/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(182);
	__webpack_require__(513);
	__webpack_require__(1);
	__webpack_require__(522);
	module.exports = __webpack_require__(102);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__ (3);
	__webpack_require__ (12);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__ (13);
	__webpack_require__ (15);
	__webpack_require__ (16);
	__webpack_require__ (17);
	__webpack_require__ (18);
	__webpack_require__ (19);
	__webpack_require__ (20);
	__webpack_require__ (21);
	__webpack_require__ (22);
	__webpack_require__ (23);
	__webpack_require__ (24);
	__webpack_require__ (25);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.1.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2016-09-22T22:30Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.1.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				resolve.call( undefined, value );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.call( undefined, value );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	function manipulationTarget( elem, content ) {
		if ( jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE <=9 only
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var val,
			valueIsBorderBox = true,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE <=11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = elem.getBoundingClientRect()[ name ];
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function raf() {
		if ( timerId ) {
			window.requestAnimationFrame( raf );
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off or if document is hidden
		if ( jQuery.fx.off || document.hidden ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.requestAnimationFrame ?
				window.requestAnimationFrame( raf ) :
				window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		if ( window.cancelAnimationFrame ) {
			window.cancelAnimationFrame( timerId );
		} else {
			window.clearInterval( timerId );
		}
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( jQuery.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win, rect, doc,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			// Make sure element is not hidden (display: none)
			if ( rect.width || rect.height ) {
				doc = elem.ownerDocument;
				win = getWindow( doc );
				docElem = doc.documentElement;
	
				return {
					top: rect.top + win.pageYOffset - docElem.clientTop,
					left: rect.left + win.pageXOffset - docElem.clientLeft
				};
			}
	
			// Return zeros for disconnected and hidden elements (gh-2310)
			return rect;
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.parseJSON = JSON.parse;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.2
	  //     https://underscorejs.org
	  //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.2';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = array && max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	var bind = __webpack_require__(31);
	var Axios = __webpack_require__(32);
	var mergeConfig = __webpack_require__(52);
	var defaults = __webpack_require__(37);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  // Factory for creating new instances
	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(50);
	axios.CancelToken = __webpack_require__(55);
	axios.isCancel = __webpack_require__(51);
	axios.VERSION = __webpack_require__(54).version;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(56);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(57);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(31);
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return Array.isArray(val);
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return toString.call(val) === '[object FormData]';
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return toString.call(val) === '[object URLSearchParams]';
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	var buildURL = __webpack_require__(33);
	var InterceptorManager = __webpack_require__(34);
	var dispatchRequest = __webpack_require__(35);
	var mergeConfig = __webpack_require__(52);
	var validator = __webpack_require__(53);
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(configOrUrl, config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof configOrUrl === 'string') {
	    config = config || {};
	    config.url = configOrUrl;
	  } else {
	    config = configOrUrl || {};
	  }
	
	  if (!config.url) {
	    throw new Error('Provided config url is not valid');
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  if (!config.url) {
	    throw new Error('Provided config url is not valid');
	  }
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	var transformData = __webpack_require__(36);
	var isCancel = __webpack_require__(51);
	var defaults = __webpack_require__(37);
	var Cancel = __webpack_require__(50);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	
	  if (config.signal && config.signal.aborted) {
	    throw new Cancel('canceled');
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	var defaults = __webpack_require__(37);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(30);
	var normalizeHeaderName = __webpack_require__(39);
	var enhanceError = __webpack_require__(40);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(41);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(41);
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  };
	  return error;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	var settle = __webpack_require__(42);
	var cookies = __webpack_require__(44);
	var buildURL = __webpack_require__(33);
	var buildFullPath = __webpack_require__(45);
	var parseHeaders = __webpack_require__(48);
	var isURLSameOrigin = __webpack_require__(49);
	var createError = __webpack_require__(43);
	var defaults = __webpack_require__(37);
	var Cancel = __webpack_require__(50);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }
	
	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || defaults.transitional;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
	        request.abort();
	        request = null;
	      };
	
	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(43);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(40);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(46);
	var combineURLs = __webpack_require__(47);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	
	  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
	  });
	
	  return config;
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VERSION = __webpack_require__(54).version;
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
	    }
	
	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}
	
	module.exports = {
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = {
	  "version": "0.25.0"
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(50);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	
	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;
	
	    var i;
	    var l = token._listeners.length;
	
	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });
	
	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);
	
	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };
	
	    return promise;
	  };
	
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Subscribe to the cancel signal
	 */
	
	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }
	
	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	
	/**
	 * Unsubscribe from the cancel signal
	 */
	
	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(30);
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return utils.isObject(payload) && (payload.isAxiosError === true);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*!
	 * validate.js 0.9.0
	 *
	 * (c) 2013-2015 Nicklas Ansman, 2013 Wrapp
	 * Validate.js may be freely distributed under the MIT license.
	 * For all details and documentation:
	 * http://validatejs.org/
	 */
	
	(function(exports, module, define) {
	  "use strict";
	
	  // The main function that calls the validators specified by the constraints.
	  // The options are the following:
	  //   - format (string) - An option that controls how the returned value is formatted
	  //     * flat - Returns a flat array of just the error messages
	  //     * grouped - Returns the messages grouped by attribute (default)
	  //     * detailed - Returns an array of the raw validation data
	  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
	  //
	  // Please note that the options are also passed to each validator.
	  var validate = function(attributes, constraints, options) {
	    options = v.extend({}, v.options, options);
	
	    var results = v.runValidations(attributes, constraints, options)
	      , attr
	      , validator;
	
	    for (attr in results) {
	      for (validator in results[attr]) {
	        if (v.isPromise(results[attr][validator])) {
	          throw new Error("Use validate.async if you want support for promises");
	        }
	      }
	    }
	    return validate.processValidationResults(results, options);
	  };
	
	  var v = validate;
	
	  // Copies over attributes from one or more sources to a single destination.
	  // Very much similar to underscore's extend.
	  // The first argument is the target object and the remaining arguments will be
	  // used as sources.
	  v.extend = function(obj) {
	    [].slice.call(arguments, 1).forEach(function(source) {
	      for (var attr in source) {
	        obj[attr] = source[attr];
	      }
	    });
	    return obj;
	  };
	
	  v.extend(validate, {
	    // This is the version of the library as a semver.
	    // The toString function will allow it to be coerced into a string
	    version: {
	      major: 0,
	      minor: 9,
	      patch: 0,
	      metadata: null,
	      toString: function() {
	        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
	        if (!v.isEmpty(v.version.metadata)) {
	          version += "+" + v.version.metadata;
	        }
	        return version;
	      }
	    },
	
	    // Below is the dependencies that are used in validate.js
	
	    // The constructor of the Promise implementation.
	    // If you are using Q.js, RSVP or any other A+ compatible implementation
	    // override this attribute to be the constructor of that promise.
	    // Since jQuery promises aren't A+ compatible they won't work.
	    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,
	
	    EMPTY_STRING_REGEXP: /^\s*$/,
	
	    // Runs the validators specified by the constraints object.
	    // Will return an array of the format:
	    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
	    runValidations: function(attributes, constraints, options) {
	      var results = []
	        , attr
	        , validatorName
	        , value
	        , validators
	        , validator
	        , validatorOptions
	        , error;
	
	      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
	        attributes = v.collectFormValues(attributes);
	      }
	
	      // Loops through each constraints, finds the correct validator and run it.
	      for (attr in constraints) {
	        value = v.getDeepObjectValue(attributes, attr);
	        // This allows the constraints for an attribute to be a function.
	        // The function will be called with the value, attribute name, the complete dict of
	        // attributes as well as the options and constraints passed in.
	        // This is useful when you want to have different
	        // validations depending on the attribute value.
	        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);
	
	        for (validatorName in validators) {
	          validator = v.validators[validatorName];
	
	          if (!validator) {
	            error = v.format("Unknown validator %{name}", {name: validatorName});
	            throw new Error(error);
	          }
	
	          validatorOptions = validators[validatorName];
	          // This allows the options to be a function. The function will be
	          // called with the value, attribute name, the complete dict of
	          // attributes as well as the options and constraints passed in.
	          // This is useful when you want to have different
	          // validations depending on the attribute value.
	          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
	          if (!validatorOptions) {
	            continue;
	          }
	          results.push({
	            attribute: attr,
	            value: value,
	            validator: validatorName,
	            globalOptions: options,
	            attributes: attributes,
	            options: validatorOptions,
	            error: validator.call(validator,
	                value,
	                validatorOptions,
	                attr,
	                attributes,
	                options)
	          });
	        }
	      }
	
	      return results;
	    },
	
	    // Takes the output from runValidations and converts it to the correct
	    // output format.
	    processValidationResults: function(errors, options) {
	      var attr;
	
	      errors = v.pruneEmptyErrors(errors, options);
	      errors = v.expandMultipleErrors(errors, options);
	      errors = v.convertErrorMessages(errors, options);
	
	      switch (options.format || "grouped") {
	        case "detailed":
	          // Do nothing more to the errors
	          break;
	
	        case "flat":
	          errors = v.flattenErrorsToArray(errors);
	          break;
	
	        case "grouped":
	          errors = v.groupErrorsByAttribute(errors);
	          for (attr in errors) {
	            errors[attr] = v.flattenErrorsToArray(errors[attr]);
	          }
	          break;
	
	        default:
	          throw new Error(v.format("Unknown format %{format}", options));
	      }
	
	      return v.isEmpty(errors) ? undefined : errors;
	    },
	
	    // Runs the validations with support for promises.
	    // This function will return a promise that is settled when all the
	    // validation promises have been completed.
	    // It can be called even if no validations returned a promise.
	    async: function(attributes, constraints, options) {
	      options = v.extend({}, v.async.options, options);
	
	      var WrapErrors = options.wrapErrors || function(errors) {
	        return errors;
	      };
	
	      // Removes unknown attributes
	      if (options.cleanAttributes !== false) {
	        attributes = v.cleanAttributes(attributes, constraints);
	      }
	
	      var results = v.runValidations(attributes, constraints, options);
	
	      return new v.Promise(function(resolve, reject) {
	        v.waitForResults(results).then(function() {
	          var errors = v.processValidationResults(results, options);
	          if (errors) {
	            reject(new WrapErrors(errors, options, attributes, constraints));
	          } else {
	            resolve(attributes);
	          }
	        }, function(err) {
	          reject(err);
	        });
	      });
	    },
	
	    single: function(value, constraints, options) {
	      options = v.extend({}, v.single.options, options, {
	        format: "flat",
	        fullMessages: false
	      });
	      return v({single: value}, {single: constraints}, options);
	    },
	
	    // Returns a promise that is resolved when all promises in the results array
	    // are settled. The promise returned from this function is always resolved,
	    // never rejected.
	    // This function modifies the input argument, it replaces the promises
	    // with the value returned from the promise.
	    waitForResults: function(results) {
	      // Create a sequence of all the results starting with a resolved promise.
	      return results.reduce(function(memo, result) {
	        // If this result isn't a promise skip it in the sequence.
	        if (!v.isPromise(result.error)) {
	          return memo;
	        }
	
	        return memo.then(function() {
	          return result.error.then(
	            function(error) {
	              result.error = error || null;
	            },
	            function(error) {
	              if (error instanceof Error) {
	                throw error;
	              }
	              v.error("Rejecting promises with the result is deprecated. Please use the resolve callback instead.");
	              result.error = error;
	            }
	          );
	        });
	      }, new v.Promise(function(r) { r(); })); // A resolved promise
	    },
	
	    // If the given argument is a call: function the and: function return the value
	    // otherwise just return the value. Additional arguments will be passed as
	    // arguments to the function.
	    // Example:
	    // ```
	    // result('foo') // 'foo'
	    // result(Math.max, 1, 2) // 2
	    // ```
	    result: function(value) {
	      var args = [].slice.call(arguments, 1);
	      if (typeof value === 'function') {
	        value = value.apply(null, args);
	      }
	      return value;
	    },
	
	    // Checks if the value is a number. This function does not consider NaN a
	    // number like many other `isNumber` functions do.
	    isNumber: function(value) {
	      return typeof value === 'number' && !isNaN(value);
	    },
	
	    // Returns false if the object is not a function
	    isFunction: function(value) {
	      return typeof value === 'function';
	    },
	
	    // A simple check to verify that the value is an integer. Uses `isNumber`
	    // and a simple modulo check.
	    isInteger: function(value) {
	      return v.isNumber(value) && value % 1 === 0;
	    },
	
	    // Uses the `Object` function to check if the given argument is an object.
	    isObject: function(obj) {
	      return obj === Object(obj);
	    },
	
	    // Simply checks if the object is an instance of a date
	    isDate: function(obj) {
	      return obj instanceof Date;
	    },
	
	    // Returns false if the object is `null` of `undefined`
	    isDefined: function(obj) {
	      return obj !== null && obj !== undefined;
	    },
	
	    // Checks if the given argument is a promise. Anything with a `then`
	    // function is considered a promise.
	    isPromise: function(p) {
	      return !!p && v.isFunction(p.then);
	    },
	
	    isJqueryElement: function(o) {
	      return o && v.isString(o.jquery);
	    },
	
	    isDomElement: function(o) {
	      if (!o) {
	        return false;
	      }
	
	      if (!v.isFunction(o.querySelectorAll) || !v.isFunction(o.querySelector)) {
	        return false;
	      }
	
	      if (v.isObject(document) && o === document) {
	        return true;
	      }
	
	      // http://stackoverflow.com/a/384380/699304
	      /* istanbul ignore else */
	      if (typeof HTMLElement === "object") {
	        return o instanceof HTMLElement;
	      } else {
	        return o &&
	          typeof o === "object" &&
	          o !== null &&
	          o.nodeType === 1 &&
	          typeof o.nodeName === "string";
	      }
	    },
	
	    isEmpty: function(value) {
	      var attr;
	
	      // Null and undefined are empty
	      if (!v.isDefined(value)) {
	        return true;
	      }
	
	      // functions are non empty
	      if (v.isFunction(value)) {
	        return false;
	      }
	
	      // Whitespace only strings are empty
	      if (v.isString(value)) {
	        return v.EMPTY_STRING_REGEXP.test(value);
	      }
	
	      // For arrays we use the length property
	      if (v.isArray(value)) {
	        return value.length === 0;
	      }
	
	      // Dates have no attributes but aren't empty
	      if (v.isDate(value)) {
	        return false;
	      }
	
	      // If we find at least one property we consider it non empty
	      if (v.isObject(value)) {
	        for (attr in value) {
	          return false;
	        }
	        return true;
	      }
	
	      return false;
	    },
	
	    // Formats the specified strings with the given values like so:
	    // ```
	    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
	    // ```
	    // If you want to write %{...} without having it replaced simply
	    // prefix it with % like this `Foo: %%{foo}` and it will be returned
	    // as `"Foo: %{foo}"`
	    format: v.extend(function(str, vals) {
	      if (!v.isString(str)) {
	        return str;
	      }
	      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
	        if (m1 === '%') {
	          return "%{" + m2 + "}";
	        } else {
	          return String(vals[m2]);
	        }
	      });
	    }, {
	      // Finds %{key} style patterns in the given string
	      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
	    }),
	
	    // "Prettifies" the given string.
	    // Prettifying means replacing [.\_-] with spaces as well as splitting
	    // camel case words.
	    prettify: function(str) {
	      if (v.isNumber(str)) {
	        // If there are more than 2 decimals round it to two
	        if ((str * 100) % 1 === 0) {
	          return "" + str;
	        } else {
	          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
	        }
	      }
	
	      if (v.isArray(str)) {
	        return str.map(function(s) { return v.prettify(s); }).join(", ");
	      }
	
	      if (v.isObject(str)) {
	        return str.toString();
	      }
	
	      // Ensure the string is actually a string
	      str = "" + str;
	
	      return str
	        // Splits keys separated by periods
	        .replace(/([^\s])\.([^\s])/g, '$1 $2')
	        // Removes backslashes
	        .replace(/\\+/g, '')
	        // Replaces - and - with space
	        .replace(/[_-]/g, ' ')
	        // Splits camel cased words
	        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
	          return "" + m1 + " " + m2.toLowerCase();
	        })
	        .toLowerCase();
	    },
	
	    stringifyValue: function(value) {
	      return v.prettify(value);
	    },
	
	    isString: function(value) {
	      return typeof value === 'string';
	    },
	
	    isArray: function(value) {
	      return {}.toString.call(value) === '[object Array]';
	    },
	
	    contains: function(obj, value) {
	      if (!v.isDefined(obj)) {
	        return false;
	      }
	      if (v.isArray(obj)) {
	        return obj.indexOf(value) !== -1;
	      }
	      return value in obj;
	    },
	
	    forEachKeyInKeypath: function(object, keypath, callback) {
	      if (!v.isString(keypath)) {
	        return undefined;
	      }
	
	      var key = ""
	        , i
	        , escape = false;
	
	      for (i = 0; i < keypath.length; ++i) {
	        switch (keypath[i]) {
	          case '.':
	            if (escape) {
	              escape = false;
	              key += '.';
	            } else {
	              object = callback(object, key, false);
	              key = "";
	            }
	            break;
	
	          case '\\':
	            if (escape) {
	              escape = false;
	              key += '\\';
	            } else {
	              escape = true;
	            }
	            break;
	
	          default:
	            escape = false;
	            key += keypath[i];
	            break;
	        }
	      }
	
	      return callback(object, key, true);
	    },
	
	    getDeepObjectValue: function(obj, keypath) {
	      if (!v.isObject(obj)) {
	        return undefined;
	      }
	
	      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
	        if (v.isObject(obj)) {
	          return obj[key];
	        }
	      });
	    },
	
	    // This returns an object with all the values of the form.
	    // It uses the input name as key and the value as value
	    // So for example this:
	    // <input type="text" name="email" value="foo@bar.com" />
	    // would return:
	    // {email: "foo@bar.com"}
	    collectFormValues: function(form, options) {
	      var values = {}
	        , i
	        , input
	        , inputs
	        , value;
	
	      if (v.isJqueryElement(form)) {
	        form = form[0];
	      }
	
	      if (!form) {
	        return values;
	      }
	
	      options = options || {};
	
	      inputs = form.querySelectorAll("input[name], textarea[name]");
	      for (i = 0; i < inputs.length; ++i) {
	        input = inputs.item(i);
	
	        if (v.isDefined(input.getAttribute("data-ignored"))) {
	          continue;
	        }
	
	        value = v.sanitizeFormValue(input.value, options);
	        if (input.type === "number") {
	          value = value ? +value : null;
	        } else if (input.type === "checkbox") {
	          if (input.attributes.value) {
	            if (!input.checked) {
	              value = values[input.name] || null;
	            }
	          } else {
	            value = input.checked;
	          }
	        } else if (input.type === "radio") {
	          if (!input.checked) {
	            value = values[input.name] || null;
	          }
	        }
	        values[input.name] = value;
	      }
	
	      inputs = form.querySelectorAll("select[name]");
	      for (i = 0; i < inputs.length; ++i) {
	        input = inputs.item(i);
	        value = v.sanitizeFormValue(input.options[input.selectedIndex].value, options);
	        values[input.name] = value;
	      }
	
	      return values;
	    },
	
	    sanitizeFormValue: function(value, options) {
	      if (options.trim && v.isString(value)) {
	        value = value.trim();
	      }
	
	      if (options.nullify !== false && value === "") {
	        return null;
	      }
	      return value;
	    },
	
	    capitalize: function(str) {
	      if (!v.isString(str)) {
	        return str;
	      }
	      return str[0].toUpperCase() + str.slice(1);
	    },
	
	    // Remove all errors who's error attribute is empty (null or undefined)
	    pruneEmptyErrors: function(errors) {
	      return errors.filter(function(error) {
	        return !v.isEmpty(error.error);
	      });
	    },
	
	    // In
	    // [{error: ["err1", "err2"], ...}]
	    // Out
	    // [{error: "err1", ...}, {error: "err2", ...}]
	    //
	    // All attributes in an error with multiple messages are duplicated
	    // when expanding the errors.
	    expandMultipleErrors: function(errors) {
	      var ret = [];
	      errors.forEach(function(error) {
	        // Removes errors without a message
	        if (v.isArray(error.error)) {
	          error.error.forEach(function(msg) {
	            ret.push(v.extend({}, error, {error: msg}));
	          });
	        } else {
	          ret.push(error);
	        }
	      });
	      return ret;
	    },
	
	    // Converts the error mesages by prepending the attribute name unless the
	    // message is prefixed by ^
	    convertErrorMessages: function(errors, options) {
	      options = options || {};
	
	      var ret = [];
	      errors.forEach(function(errorInfo) {
	        var error = v.result(errorInfo.error,
	            errorInfo.value,
	            errorInfo.attribute,
	            errorInfo.options,
	            errorInfo.attributes,
	            errorInfo.globalOptions);
	
	        if (!v.isString(error)) {
	          ret.push(errorInfo);
	          return;
	        }
	
	        if (error[0] === '^') {
	          error = error.slice(1);
	        } else if (options.fullMessages !== false) {
	          error = v.capitalize(v.prettify(errorInfo.attribute)) + " " + error;
	        }
	        error = error.replace(/\\\^/g, "^");
	        error = v.format(error, {value: v.stringifyValue(errorInfo.value)});
	        ret.push(v.extend({}, errorInfo, {error: error}));
	      });
	      return ret;
	    },
	
	    // In:
	    // [{attribute: "<attributeName>", ...}]
	    // Out:
	    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
	    groupErrorsByAttribute: function(errors) {
	      var ret = {};
	      errors.forEach(function(error) {
	        var list = ret[error.attribute];
	        if (list) {
	          list.push(error);
	        } else {
	          ret[error.attribute] = [error];
	        }
	      });
	      return ret;
	    },
	
	    // In:
	    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
	    // Out:
	    // ["<message 1>", "<message 2>"]
	    flattenErrorsToArray: function(errors) {
	      return errors.map(function(error) { return error.error; });
	    },
	
	    cleanAttributes: function(attributes, whitelist) {
	      function whitelistCreator(obj, key, last) {
	        if (v.isObject(obj[key])) {
	          return obj[key];
	        }
	        return (obj[key] = last ? true : {});
	      }
	
	      function buildObjectWhitelist(whitelist) {
	        var ow = {}
	          , lastObject
	          , attr;
	        for (attr in whitelist) {
	          if (!whitelist[attr]) {
	            continue;
	          }
	          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
	        }
	        return ow;
	      }
	
	      function cleanRecursive(attributes, whitelist) {
	        if (!v.isObject(attributes)) {
	          return attributes;
	        }
	
	        var ret = v.extend({}, attributes)
	          , w
	          , attribute;
	
	        for (attribute in attributes) {
	          w = whitelist[attribute];
	
	          if (v.isObject(w)) {
	            ret[attribute] = cleanRecursive(ret[attribute], w);
	          } else if (!w) {
	            delete ret[attribute];
	          }
	        }
	        return ret;
	      }
	
	      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
	        return {};
	      }
	
	      whitelist = buildObjectWhitelist(whitelist);
	      return cleanRecursive(attributes, whitelist);
	    },
	
	    exposeModule: function(validate, root, exports, module, define) {
	      if (exports) {
	        if (module && module.exports) {
	          exports = module.exports = validate;
	        }
	        exports.validate = validate;
	      } else {
	        root.validate = validate;
	        if (validate.isFunction(define) && define.amd) {
	          define([], function () { return validate; });
	        }
	      }
	    },
	
	    warn: function(msg) {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("[validate.js] " + msg);
	      }
	    },
	
	    error: function(msg) {
	      if (typeof console !== "undefined" && console.error) {
	        console.error("[validate.js] " + msg);
	      }
	    }
	  });
	
	  validate.validators = {
	    // Presence validates that the value isn't empty
	    presence: function(value, options) {
	      options = v.extend({}, this.options, options);
	      if (v.isEmpty(value)) {
	        return options.message || this.message || "can't be blank";
	      }
	    },
	    length: function(value, options, attribute) {
	      // Empty values are allowed
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var is = options.is
	        , maximum = options.maximum
	        , minimum = options.minimum
	        , tokenizer = options.tokenizer || function(val) { return val; }
	        , err
	        , errors = [];
	
	      value = tokenizer(value);
	      var length = value.length;
	      if(!v.isNumber(length)) {
	        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
	        return options.message || this.notValid || "has an incorrect length";
	      }
	
	      // Is checks
	      if (v.isNumber(is) && length !== is) {
	        err = options.wrongLength ||
	          this.wrongLength ||
	          "is the wrong length (should be %{count} characters)";
	        errors.push(v.format(err, {count: is}));
	      }
	
	      if (v.isNumber(minimum) && length < minimum) {
	        err = options.tooShort ||
	          this.tooShort ||
	          "is too short (minimum is %{count} characters)";
	        errors.push(v.format(err, {count: minimum}));
	      }
	
	      if (v.isNumber(maximum) && length > maximum) {
	        err = options.tooLong ||
	          this.tooLong ||
	          "is too long (maximum is %{count} characters)";
	        errors.push(v.format(err, {count: maximum}));
	      }
	
	      if (errors.length > 0) {
	        return options.message || errors;
	      }
	    },
	    numericality: function(value, options) {
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var errors = []
	        , name
	        , count
	        , checks = {
	            greaterThan:          function(v, c) { return v > c; },
	            greaterThanOrEqualTo: function(v, c) { return v >= c; },
	            equalTo:              function(v, c) { return v === c; },
	            lessThan:             function(v, c) { return v < c; },
	            lessThanOrEqualTo:    function(v, c) { return v <= c; }
	          };
	
	      // Coerce the value to a number unless we're being strict.
	      if (options.noStrings !== true && v.isString(value)) {
	        value = +value;
	      }
	
	      // If it's not a number we shouldn't continue since it will compare it.
	      if (!v.isNumber(value)) {
	        return options.message || options.notValid || this.notValid || "is not a number";
	      }
	
	      // Same logic as above, sort of. Don't bother with comparisons if this
	      // doesn't pass.
	      if (options.onlyInteger && !v.isInteger(value)) {
	        return options.message || options.notInteger || this.notInteger  || "must be an integer";
	      }
	
	      for (name in checks) {
	        count = options[name];
	        if (v.isNumber(count) && !checks[name](value, count)) {
	          // This picks the default message if specified
	          // For example the greaterThan check uses the message from
	          // this.notGreaterThan so we capitalize the name and prepend "not"
	          var key = "not" + v.capitalize(name);
	          var msg = options[key] || this[key] || "must be %{type} %{count}";
	
	          errors.push(v.format(msg, {
	            count: count,
	            type: v.prettify(name)
	          }));
	        }
	      }
	
	      if (options.odd && value % 2 !== 1) {
	        errors.push(options.notOdd || this.notOdd || "must be odd");
	      }
	      if (options.even && value % 2 !== 0) {
	        errors.push(options.notEven || this.notEven || "must be even");
	      }
	
	      if (errors.length) {
	        return options.message || errors;
	      }
	    },
	    datetime: v.extend(function(value, options) {
	      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
	        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
	      }
	
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var err
	        , errors = []
	        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
	        , latest = options.latest ? this.parse(options.latest, options) : NaN;
	
	      value = this.parse(value, options);
	
	      // 86400000 is the number of seconds in a day, this is used to remove
	      // the time from the date
	      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
	        return options.message || this.notValid || "must be a valid date";
	      }
	
	      if (!isNaN(earliest) && value < earliest) {
	        err = this.tooEarly || "must be no earlier than %{date}";
	        err = v.format(err, {date: this.format(earliest, options)});
	        errors.push(err);
	      }
	
	      if (!isNaN(latest) && value > latest) {
	        err = this.tooLate || "must be no later than %{date}";
	        err = v.format(err, {date: this.format(latest, options)});
	        errors.push(err);
	      }
	
	      if (errors.length) {
	        return options.message || errors;
	      }
	    }, {
	      parse: null,
	      format: null
	    }),
	    date: function(value, options) {
	      options = v.extend({}, options, {dateOnly: true});
	      return v.validators.datetime.call(v.validators.datetime, value, options);
	    },
	    format: function(value, options) {
	      if (v.isString(options) || (options instanceof RegExp)) {
	        options = {pattern: options};
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var message = options.message || this.message || "is invalid"
	        , pattern = options.pattern
	        , match;
	
	      // Empty values are allowed
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (!v.isString(value)) {
	        return message;
	      }
	
	      if (v.isString(pattern)) {
	        pattern = new RegExp(options.pattern, options.flags);
	      }
	      match = pattern.exec(value);
	      if (!match || match[0].length != value.length) {
	        return message;
	      }
	    },
	    inclusion: function(value, options) {
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (v.isArray(options)) {
	        options = {within: options};
	      }
	      options = v.extend({}, this.options, options);
	      if (v.contains(options.within, value)) {
	        return;
	      }
	      var message = options.message ||
	        this.message ||
	        "^%{value} is not included in the list";
	      return v.format(message, {value: value});
	    },
	    exclusion: function(value, options) {
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (v.isArray(options)) {
	        options = {within: options};
	      }
	      options = v.extend({}, this.options, options);
	      if (!v.contains(options.within, value)) {
	        return;
	      }
	      var message = options.message || this.message || "^%{value} is restricted";
	      return v.format(message, {value: value});
	    },
	    email: v.extend(function(value, options) {
	      options = v.extend({}, this.options, options);
	      var message = options.message || this.message || "is not a valid email";
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (!v.isString(value)) {
	        return message;
	      }
	      if (!this.PATTERN.exec(value)) {
	        return message;
	      }
	    }, {
	      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
	    }),
	    equality: function(value, options, attribute, attributes) {
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      if (v.isString(options)) {
	        options = {attribute: options};
	      }
	      options = v.extend({}, this.options, options);
	      var message = options.message ||
	        this.message ||
	        "is not equal to %{attribute}";
	
	      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
	        throw new Error("The attribute must be a non empty string");
	      }
	
	      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
	        , comparator = options.comparator || function(v1, v2) {
	          return v1 === v2;
	        };
	
	      if (!comparator(value, otherValue, options, attribute, attributes)) {
	        return v.format(message, {attribute: v.prettify(options.attribute)});
	      }
	    },
	
	    // A URL validator that is used to validate URLs with the ability to
	    // restrict schemes and some domains.
	    url: function(value, options) {
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var message = options.message || this.message || "is not a valid url"
	        , schemes = options.schemes || this.schemes || ['http', 'https']
	        , allowLocal = options.allowLocal || this.allowLocal || false;
	
	      if (!v.isString(value)) {
	        return message;
	      }
	
	      // https://gist.github.com/dperini/729294
	      var regex =
	        "^" +
	          // schemes
	          "(?:(?:" + schemes.join("|") + "):\\/\\/)" +
	          // credentials
	          "(?:\\S+(?::\\S*)?@)?";
	
	      regex += "(?:";
	
	      var hostname =
	          "(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)" +
	          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*" +
	          "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))";
	
	      // This ia a special case for the localhost hostname
	      if (allowLocal) {
	        hostname = "(?:localhost|" + hostname + ")";
	      } else {
	          // private & local addresses
	          regex +=
	              "(?!10(?:\\.\\d{1,3}){3})" +
	              "(?!127(?:\\.\\d{1,3}){3})" +
	              "(?!169\\.254(?:\\.\\d{1,3}){2})" +
	              "(?!192\\.168(?:\\.\\d{1,3}){2})" +
	              "(?!172" +
	                "\\.(?:1[6-9]|2\\d|3[0-1])" +
	                "(?:\\.\\d{1,3})" +
	              "{2})";
	      }
	
	      // reserved addresses
	      regex +=
	          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
	          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
	          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
	        "|" +
	          hostname +
	          // port number
	          "(?::\\d{2,5})?" +
	          // path
	          "(?:\\/[^\\s]*)?" +
	        "$";
	
	      var PATTERN = new RegExp(regex, 'i');
	      if (!PATTERN.exec(value)) {
	        return message;
	      }
	    }
	  };
	
	  validate.exposeModule(validate, this, exports, module, __webpack_require__(60));
	}).call(this,
	         true ? /* istanbul ignore next */ exports : null,
	         true ? /* istanbul ignore next */ module : null,
	        __webpack_require__(60));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module)))

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* globals CONFIG */
	
	/**
	 *
	 * @type {{
	 *     apiUrl: string;
	 *     bigCompanyThreshold: number;
	 *     defaultMaxEmployeeCount: number;
	 *     periodStartDate: number;
	 *     logLevel: string;
	 * }}
	 */
	module.exports = ({"apiUrl":"https://production-server.payrollpanda.my/api","logLevel":"warn","bigCompanyThreshold":15,"defaultMaxEmployeeCount":100,"periodStartDate":16});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = __webpack_require__(28);
	var moment = __webpack_require__(101);
	var config = __webpack_require__(61);
	
	var INVITE_TOKEN_URL = config.apiUrl + '/AppUsers/inviteToken';
	
	module.exports = function getInviteToken(token) {
	    return axios({
	        method: 'get',
	        url: INVITE_TOKEN_URL,
	        params: { token: token }
	    }).then(function (result) {
	        var expiresAt = result.data.expiresAt;
	        var isExpired = moment().isAfter(moment(expiresAt));
	        return new _bluebird2.default(function (resolve, reject) {
	            if (!isExpired && result.data.valid) {
	                resolve(result.data);
	            } else {
	                reject('Your invitation has expired. Please request ' + 'a new invitation email from your employer.');
	            }
	        });
	    });
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(64)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(65);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(66);
	var Async = __webpack_require__(67);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(72);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(73)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(74)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(75)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(76)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(77)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(78)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(79);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	
	        if (typeof fn !== "function") {
	            throw new TypeError("The last argument to .catch() " +
	                "must be a function, got " + util.toString(fn));
	        }
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	        this._dereferenceTrace();
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
	        get: function () {
	            return "Object";
	        }
	    });
	}
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(80)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(81)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(82)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(83)(Promise);
	__webpack_require__(84)(Promise);
	__webpack_require__(85)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.5";
	__webpack_require__(86)(Promise);
	__webpack_require__(87)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(88)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(89)(Promise);
	__webpack_require__(90)(Promise, INTERNAL);
	__webpack_require__(91)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(92)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(93)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(94)(Promise, PromiseArray, debug);
	__webpack_require__(95)(Promise, PromiseArray, apiRejection);
	__webpack_require__(96)(Promise, INTERNAL, debug);
	__webpack_require__(97)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(98)(Promise);
	__webpack_require__(99)(Promise, INTERNAL);
	__webpack_require__(100)(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(66);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var receiver = new FakeConstructor();
	    function ic() {
	        return typeof receiver.foo;
	    }
	    ic();
	    ic();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    typeof process.env !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? process.env[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version;
	    if (process.versions && process.versions.node) {    
	        version = process.versions.node.split(".").map(Number);
	    } else if (process.version) {
	        version = process.version.split(".").map(Number);
	    }
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38)))

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(68);
	var Queue = __webpack_require__(71);
	var util = __webpack_require__(65);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	function _drainQueue(queue) {
	    while (queue.length() > 0) {
	        _drainQueueStep(queue);
	    }
	}
	
	function _drainQueueStep(queue) {
	    var fn = queue.shift();
	    if (typeof fn !== "function") {
	        fn._settlePromises();
	    } else {
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	}
	
	Async.prototype._drainQueues = function () {
	    _drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    _drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(65);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova)) &&
	          ("classList" in document.documentElement)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38), __webpack_require__(69).setImmediate))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(70);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38)))

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(66);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(65);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(65);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(65);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(72).Warning;
	var util = __webpack_require__(65);
	var es5 = __webpack_require__(66);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var eventData = {
	                    detail: event,
	                    cancelable: true
	                };
	                es5.defineProperty(
	                    eventData, "promise", {value: event.promise});
	                es5.defineProperty(eventData, "reason", {value: event.reason});
	                var domEvent = new CustomEvent(name.toLowerCase(), eventData);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                es5.defineProperty(domEvent, "promise", {value: event.promise});
	                es5.defineProperty(domEvent, "reason", {value: event.reason});
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._dereferenceTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function longStackTracesDereferenceTrace() {
	    this._trace = undefined;
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = (firstLineError.stack || "").split("\n");
	    var lastStackLines = (lastLineError.stack || "").split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(65);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(78)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(65);
	var getKeys = __webpack_require__(66).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(65);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(72);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(66);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(65);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(65);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(65);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(65);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(72);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(65);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(65);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(65);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(65);
	var nodebackForPromise = __webpack_require__(79);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(72).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(65);
	var isObject = util.isObject;
	var es5 = __webpack_require__(66);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(65);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(65);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(65);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(65);
	var RangeError = __webpack_require__(72).RangeError;
	var AggregateError = __webpack_require__(72).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(65);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(65);
	    var TypeError = __webpack_require__(72).TypeError;
	    var inherits = __webpack_require__(65).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module)))

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/chargebee-icon.svg";

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(183);
	
	__webpack_require__(509);
	
	__webpack_require__(510);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(184);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(239);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(253);
	__webpack_require__(255);
	__webpack_require__(257);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(266);
	__webpack_require__(268);
	__webpack_require__(270);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(294);
	__webpack_require__(296);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(333);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(336);
	__webpack_require__(337);
	__webpack_require__(339);
	__webpack_require__(340);
	__webpack_require__(342);
	__webpack_require__(343);
	__webpack_require__(349);
	__webpack_require__(350);
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(358);
	__webpack_require__(359);
	__webpack_require__(360);
	__webpack_require__(361);
	__webpack_require__(362);
	__webpack_require__(364);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(370);
	__webpack_require__(372);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(376);
	__webpack_require__(378);
	__webpack_require__(380);
	__webpack_require__(382);
	__webpack_require__(383);
	__webpack_require__(384);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(390);
	__webpack_require__(392);
	__webpack_require__(402);
	__webpack_require__(406);
	__webpack_require__(407);
	__webpack_require__(409);
	__webpack_require__(410);
	__webpack_require__(414);
	__webpack_require__(415);
	__webpack_require__(417);
	__webpack_require__(418);
	__webpack_require__(419);
	__webpack_require__(420);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(423);
	__webpack_require__(424);
	__webpack_require__(425);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(432);
	__webpack_require__(433);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(437);
	__webpack_require__(438);
	__webpack_require__(439);
	__webpack_require__(440);
	__webpack_require__(441);
	__webpack_require__(443);
	__webpack_require__(444);
	__webpack_require__(445);
	__webpack_require__(447);
	__webpack_require__(448);
	__webpack_require__(449);
	__webpack_require__(450);
	__webpack_require__(451);
	__webpack_require__(452);
	__webpack_require__(453);
	__webpack_require__(454);
	__webpack_require__(456);
	__webpack_require__(457);
	__webpack_require__(459);
	__webpack_require__(460);
	__webpack_require__(461);
	__webpack_require__(462);
	__webpack_require__(465);
	__webpack_require__(466);
	__webpack_require__(468);
	__webpack_require__(469);
	__webpack_require__(470);
	__webpack_require__(471);
	__webpack_require__(473);
	__webpack_require__(474);
	__webpack_require__(475);
	__webpack_require__(476);
	__webpack_require__(477);
	__webpack_require__(478);
	__webpack_require__(479);
	__webpack_require__(480);
	__webpack_require__(481);
	__webpack_require__(482);
	__webpack_require__(484);
	__webpack_require__(485);
	__webpack_require__(486);
	__webpack_require__(487);
	__webpack_require__(488);
	__webpack_require__(489);
	__webpack_require__(490);
	__webpack_require__(491);
	__webpack_require__(492);
	__webpack_require__(493);
	__webpack_require__(494);
	__webpack_require__(496);
	__webpack_require__(497);
	__webpack_require__(498);
	__webpack_require__(499);
	__webpack_require__(500);
	__webpack_require__(501);
	__webpack_require__(502);
	__webpack_require__(503);
	__webpack_require__(504);
	__webpack_require__(505);
	__webpack_require__(506);
	__webpack_require__(507);
	__webpack_require__(508);
	module.exports = __webpack_require__(190);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(185);
	var has = __webpack_require__(186);
	var DESCRIPTORS = __webpack_require__(187);
	var $export = __webpack_require__(189);
	var redefine = __webpack_require__(199);
	var META = __webpack_require__(206).KEY;
	var $fails = __webpack_require__(188);
	var shared = __webpack_require__(202);
	var setToStringTag = __webpack_require__(207);
	var uid = __webpack_require__(200);
	var wks = __webpack_require__(208);
	var wksExt = __webpack_require__(209);
	var wksDefine = __webpack_require__(210);
	var enumKeys = __webpack_require__(211);
	var isArray = __webpack_require__(226);
	var anObject = __webpack_require__(193);
	var isObject = __webpack_require__(194);
	var toObject = __webpack_require__(227);
	var toIObject = __webpack_require__(214);
	var toPrimitive = __webpack_require__(197);
	var createDesc = __webpack_require__(198);
	var _create = __webpack_require__(228);
	var gOPNExt = __webpack_require__(231);
	var $GOPD = __webpack_require__(233);
	var $GOPS = __webpack_require__(224);
	var $DP = __webpack_require__(192);
	var $keys = __webpack_require__(212);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(232).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(225).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(203)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(191)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(188)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var core = __webpack_require__(190);
	var hide = __webpack_require__(191);
	var redefine = __webpack_require__(199);
	var ctx = __webpack_require__(204);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(192);
	var createDesc = __webpack_require__(198);
	module.exports = __webpack_require__(187) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(193);
	var IE8_DOM_DEFINE = __webpack_require__(195);
	var toPrimitive = __webpack_require__(197);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(187) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(194);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(187) && !__webpack_require__(188)(function () {
	  return Object.defineProperty(__webpack_require__(196)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(194);
	var document = __webpack_require__(185).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(194);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var hide = __webpack_require__(191);
	var has = __webpack_require__(186);
	var SRC = __webpack_require__(200)('src');
	var $toString = __webpack_require__(201);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(190).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(202)('native-function-to-string', Function.toString);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(190);
	var global = __webpack_require__(185);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(203) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(205);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(200)('meta');
	var isObject = __webpack_require__(194);
	var has = __webpack_require__(186);
	var setDesc = __webpack_require__(192).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(188)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(192).f;
	var has = __webpack_require__(186);
	var TAG = __webpack_require__(208)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(202)('wks');
	var uid = __webpack_require__(200);
	var Symbol = __webpack_require__(185).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(208);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var core = __webpack_require__(190);
	var LIBRARY = __webpack_require__(203);
	var wksExt = __webpack_require__(209);
	var defineProperty = __webpack_require__(192).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(212);
	var gOPS = __webpack_require__(224);
	var pIE = __webpack_require__(225);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(213);
	var enumBugKeys = __webpack_require__(223);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(186);
	var toIObject = __webpack_require__(214);
	var arrayIndexOf = __webpack_require__(218)(false);
	var IE_PROTO = __webpack_require__(222)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(215);
	var defined = __webpack_require__(217);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(216);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(214);
	var toLength = __webpack_require__(219);
	var toAbsoluteIndex = __webpack_require__(221);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(220);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(220);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(202)('keys');
	var uid = __webpack_require__(200);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(216);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(217);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(193);
	var dPs = __webpack_require__(229);
	var enumBugKeys = __webpack_require__(223);
	var IE_PROTO = __webpack_require__(222)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(196)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(230).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(192);
	var anObject = __webpack_require__(193);
	var getKeys = __webpack_require__(212);
	
	module.exports = __webpack_require__(187) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(185).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(214);
	var gOPN = __webpack_require__(232).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(213);
	var hiddenKeys = __webpack_require__(223).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(225);
	var createDesc = __webpack_require__(198);
	var toIObject = __webpack_require__(214);
	var toPrimitive = __webpack_require__(197);
	var has = __webpack_require__(186);
	var IE8_DOM_DEFINE = __webpack_require__(195);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(187) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(228) });


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(187), 'Object', { defineProperty: __webpack_require__(192).f });


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(187), 'Object', { defineProperties: __webpack_require__(229) });


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(214);
	var $getOwnPropertyDescriptor = __webpack_require__(233).f;
	
	__webpack_require__(238)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(189);
	var core = __webpack_require__(190);
	var fails = __webpack_require__(188);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(227);
	var $getPrototypeOf = __webpack_require__(240);
	
	__webpack_require__(238)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(186);
	var toObject = __webpack_require__(227);
	var IE_PROTO = __webpack_require__(222)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(227);
	var $keys = __webpack_require__(212);
	
	__webpack_require__(238)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(238)('getOwnPropertyNames', function () {
	  return __webpack_require__(231).f;
	});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(194);
	var meta = __webpack_require__(206).onFreeze;
	
	__webpack_require__(238)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(194);
	var meta = __webpack_require__(206).onFreeze;
	
	__webpack_require__(238)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(194);
	var meta = __webpack_require__(206).onFreeze;
	
	__webpack_require__(238)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(194);
	
	__webpack_require__(238)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(194);
	
	__webpack_require__(238)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(194);
	
	__webpack_require__(238)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(189);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(250) });


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(187);
	var getKeys = __webpack_require__(212);
	var gOPS = __webpack_require__(224);
	var pIE = __webpack_require__(225);
	var toObject = __webpack_require__(227);
	var IObject = __webpack_require__(215);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(188)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(189);
	$export($export.S, 'Object', { is: __webpack_require__(252) });


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(189);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(254).set });


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(194);
	var anObject = __webpack_require__(193);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(204)(Function.call, __webpack_require__(233).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(256);
	var test = {};
	test[__webpack_require__(208)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(199)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(216);
	var TAG = __webpack_require__(208)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(189);
	
	$export($export.P, 'Function', { bind: __webpack_require__(258) });


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(205);
	var isObject = __webpack_require__(194);
	var invoke = __webpack_require__(259);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(192).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(187) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(194);
	var getPrototypeOf = __webpack_require__(240);
	var HAS_INSTANCE = __webpack_require__(208)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(192).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var $parseInt = __webpack_require__(263);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(185).parseInt;
	var $trim = __webpack_require__(264).trim;
	var ws = __webpack_require__(265);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var defined = __webpack_require__(217);
	var fails = __webpack_require__(188);
	var spaces = __webpack_require__(265);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var $parseFloat = __webpack_require__(267);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(185).parseFloat;
	var $trim = __webpack_require__(264).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(265) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(185);
	var has = __webpack_require__(186);
	var cof = __webpack_require__(216);
	var inheritIfRequired = __webpack_require__(269);
	var toPrimitive = __webpack_require__(197);
	var fails = __webpack_require__(188);
	var gOPN = __webpack_require__(232).f;
	var gOPD = __webpack_require__(233).f;
	var dP = __webpack_require__(192).f;
	var $trim = __webpack_require__(264).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(228)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(187) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(199)(global, NUMBER, $Number);
	}


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(194);
	var setPrototypeOf = __webpack_require__(254).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toInteger = __webpack_require__(220);
	var aNumberValue = __webpack_require__(271);
	var repeat = __webpack_require__(272);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(188)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(216);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(220);
	var defined = __webpack_require__(217);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $fails = __webpack_require__(188);
	var aNumberValue = __webpack_require__(271);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(189);
	var _isFinite = __webpack_require__(185).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(277) });


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(194);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(189);
	var isInteger = __webpack_require__(277);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var $parseFloat = __webpack_require__(267);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var $parseInt = __webpack_require__(263);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(189);
	var log1p = __webpack_require__(285);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(189);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(189);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(189);
	var sign = __webpack_require__(289);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(189);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(189);
	var $expm1 = __webpack_require__(293);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { fround: __webpack_require__(295) });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(289);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(189);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(189);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(188)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(285) });


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { sign: __webpack_require__(289) });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(189);
	var expm1 = __webpack_require__(293);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(188)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(189);
	var expm1 = __webpack_require__(293);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var toAbsoluteIndex = __webpack_require__(221);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var toIObject = __webpack_require__(214);
	var toLength = __webpack_require__(219);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(264)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(309)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(310)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(220);
	var defined = __webpack_require__(217);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(203);
	var $export = __webpack_require__(189);
	var redefine = __webpack_require__(199);
	var hide = __webpack_require__(191);
	var Iterators = __webpack_require__(311);
	var $iterCreate = __webpack_require__(312);
	var setToStringTag = __webpack_require__(207);
	var getPrototypeOf = __webpack_require__(240);
	var ITERATOR = __webpack_require__(208)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(228);
	var descriptor = __webpack_require__(198);
	var setToStringTag = __webpack_require__(207);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(191)(IteratorPrototype, __webpack_require__(208)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $at = __webpack_require__(309)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(189);
	var toLength = __webpack_require__(219);
	var context = __webpack_require__(315);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(317)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(316);
	var defined = __webpack_require__(217);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(194);
	var cof = __webpack_require__(216);
	var MATCH = __webpack_require__(208)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(208)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(189);
	var context = __webpack_require__(315);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(317)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(272)
	});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(189);
	var toLength = __webpack_require__(219);
	var context = __webpack_require__(315);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(317)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(322)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var fails = __webpack_require__(188);
	var defined = __webpack_require__(217);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(322)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(322)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(322)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(322)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(322)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(322)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(322)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(322)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(322)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(322)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(322)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(322)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toObject = __webpack_require__(227);
	var toPrimitive = __webpack_require__(197);
	
	$export($export.P + $export.F * __webpack_require__(188)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(189);
	var toISOString = __webpack_require__(338);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(188);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(199)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(208)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(191)(proto, TO_PRIMITIVE, __webpack_require__(341));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(193);
	var toPrimitive = __webpack_require__(197);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(226) });


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(204);
	var $export = __webpack_require__(189);
	var toObject = __webpack_require__(227);
	var call = __webpack_require__(344);
	var isArrayIter = __webpack_require__(345);
	var toLength = __webpack_require__(219);
	var createProperty = __webpack_require__(346);
	var getIterFn = __webpack_require__(347);
	
	$export($export.S + $export.F * !__webpack_require__(348)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(193);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(311);
	var ITERATOR = __webpack_require__(208)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(192);
	var createDesc = __webpack_require__(198);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(256);
	var ITERATOR = __webpack_require__(208)('iterator');
	var Iterators = __webpack_require__(311);
	module.exports = __webpack_require__(190).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(208)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var createProperty = __webpack_require__(346);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(188)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(189);
	var toIObject = __webpack_require__(214);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(215) != Object || !__webpack_require__(351)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(188);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var html = __webpack_require__(230);
	var cof = __webpack_require__(216);
	var toAbsoluteIndex = __webpack_require__(221);
	var toLength = __webpack_require__(219);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(188)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var aFunction = __webpack_require__(205);
	var toObject = __webpack_require__(227);
	var fails = __webpack_require__(188);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(351)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $forEach = __webpack_require__(355)(0);
	var STRICT = __webpack_require__(351)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(204);
	var IObject = __webpack_require__(215);
	var toObject = __webpack_require__(227);
	var toLength = __webpack_require__(219);
	var asc = __webpack_require__(356);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(357);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(194);
	var isArray = __webpack_require__(226);
	var SPECIES = __webpack_require__(208)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $map = __webpack_require__(355)(1);
	
	$export($export.P + $export.F * !__webpack_require__(351)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $filter = __webpack_require__(355)(2);
	
	$export($export.P + $export.F * !__webpack_require__(351)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $some = __webpack_require__(355)(3);
	
	$export($export.P + $export.F * !__webpack_require__(351)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $every = __webpack_require__(355)(4);
	
	$export($export.P + $export.F * !__webpack_require__(351)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $reduce = __webpack_require__(363);
	
	$export($export.P + $export.F * !__webpack_require__(351)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(205);
	var toObject = __webpack_require__(227);
	var IObject = __webpack_require__(215);
	var toLength = __webpack_require__(219);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $reduce = __webpack_require__(363);
	
	$export($export.P + $export.F * !__webpack_require__(351)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $indexOf = __webpack_require__(218)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(351)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toIObject = __webpack_require__(214);
	var toInteger = __webpack_require__(220);
	var toLength = __webpack_require__(219);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(351)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(189);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(368) });
	
	__webpack_require__(369)('copyWithin');


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(227);
	var toAbsoluteIndex = __webpack_require__(221);
	var toLength = __webpack_require__(219);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(208)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(191)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(189);
	
	$export($export.P, 'Array', { fill: __webpack_require__(371) });
	
	__webpack_require__(369)('fill');


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(227);
	var toAbsoluteIndex = __webpack_require__(221);
	var toLength = __webpack_require__(219);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(189);
	var $find = __webpack_require__(355)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(369)(KEY);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(189);
	var $find = __webpack_require__(355)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(369)(KEY);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(375)('Array');


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(185);
	var dP = __webpack_require__(192);
	var DESCRIPTORS = __webpack_require__(187);
	var SPECIES = __webpack_require__(208)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(369);
	var step = __webpack_require__(377);
	var Iterators = __webpack_require__(311);
	var toIObject = __webpack_require__(214);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(310)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var inheritIfRequired = __webpack_require__(269);
	var dP = __webpack_require__(192).f;
	var gOPN = __webpack_require__(232).f;
	var isRegExp = __webpack_require__(316);
	var $flags = __webpack_require__(379);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(187) && (!CORRECT_NEW || __webpack_require__(188)(function () {
	  re2[__webpack_require__(208)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(199)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(375)('RegExp');


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(193);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(381);
	__webpack_require__(189)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(379);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(383);
	var anObject = __webpack_require__(193);
	var $flags = __webpack_require__(379);
	var DESCRIPTORS = __webpack_require__(187);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(199)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(188)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(187) && /./g.flags != 'g') __webpack_require__(192).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(379)
	});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(193);
	var toLength = __webpack_require__(219);
	var advanceStringIndex = __webpack_require__(385);
	var regExpExec = __webpack_require__(386);
	
	// @@match logic
	__webpack_require__(387)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(309)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(256);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(380);
	var redefine = __webpack_require__(199);
	var hide = __webpack_require__(191);
	var fails = __webpack_require__(188);
	var defined = __webpack_require__(217);
	var wks = __webpack_require__(208);
	var regexpExec = __webpack_require__(381);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(193);
	var toObject = __webpack_require__(227);
	var toLength = __webpack_require__(219);
	var toInteger = __webpack_require__(220);
	var advanceStringIndex = __webpack_require__(385);
	var regExpExec = __webpack_require__(386);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(387)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(193);
	var sameValue = __webpack_require__(252);
	var regExpExec = __webpack_require__(386);
	
	// @@search logic
	__webpack_require__(387)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(316);
	var anObject = __webpack_require__(193);
	var speciesConstructor = __webpack_require__(391);
	var advanceStringIndex = __webpack_require__(385);
	var toLength = __webpack_require__(219);
	var callRegExpExec = __webpack_require__(386);
	var regexpExec = __webpack_require__(381);
	var fails = __webpack_require__(188);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(387)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(193);
	var aFunction = __webpack_require__(205);
	var SPECIES = __webpack_require__(208)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(203);
	var global = __webpack_require__(185);
	var ctx = __webpack_require__(204);
	var classof = __webpack_require__(256);
	var $export = __webpack_require__(189);
	var isObject = __webpack_require__(194);
	var aFunction = __webpack_require__(205);
	var anInstance = __webpack_require__(393);
	var forOf = __webpack_require__(394);
	var speciesConstructor = __webpack_require__(391);
	var task = __webpack_require__(395).set;
	var microtask = __webpack_require__(396)();
	var newPromiseCapabilityModule = __webpack_require__(397);
	var perform = __webpack_require__(398);
	var userAgent = __webpack_require__(399);
	var promiseResolve = __webpack_require__(400);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(208)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(401)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(207)($Promise, PROMISE);
	__webpack_require__(375)(PROMISE);
	Wrapper = __webpack_require__(190)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(348)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(204);
	var call = __webpack_require__(344);
	var isArrayIter = __webpack_require__(345);
	var anObject = __webpack_require__(193);
	var toLength = __webpack_require__(219);
	var getIterFn = __webpack_require__(347);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(204);
	var invoke = __webpack_require__(259);
	var html = __webpack_require__(230);
	var cel = __webpack_require__(196);
	var global = __webpack_require__(185);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(216)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var macrotask = __webpack_require__(395).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(216)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(205);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(193);
	var isObject = __webpack_require__(194);
	var newPromiseCapability = __webpack_require__(397);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(199);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(403);
	var validate = __webpack_require__(404);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(405)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(192).f;
	var create = __webpack_require__(228);
	var redefineAll = __webpack_require__(401);
	var ctx = __webpack_require__(204);
	var anInstance = __webpack_require__(393);
	var forOf = __webpack_require__(394);
	var $iterDefine = __webpack_require__(310);
	var step = __webpack_require__(377);
	var setSpecies = __webpack_require__(375);
	var DESCRIPTORS = __webpack_require__(187);
	var fastKey = __webpack_require__(206).fastKey;
	var validate = __webpack_require__(404);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(194);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(185);
	var $export = __webpack_require__(189);
	var redefine = __webpack_require__(199);
	var redefineAll = __webpack_require__(401);
	var meta = __webpack_require__(206);
	var forOf = __webpack_require__(394);
	var anInstance = __webpack_require__(393);
	var isObject = __webpack_require__(194);
	var fails = __webpack_require__(188);
	var $iterDetect = __webpack_require__(348);
	var setToStringTag = __webpack_require__(207);
	var inheritIfRequired = __webpack_require__(269);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(403);
	var validate = __webpack_require__(404);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(405)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(185);
	var each = __webpack_require__(355)(0);
	var redefine = __webpack_require__(199);
	var meta = __webpack_require__(206);
	var assign = __webpack_require__(250);
	var weak = __webpack_require__(408);
	var isObject = __webpack_require__(194);
	var validate = __webpack_require__(404);
	var NATIVE_WEAK_MAP = __webpack_require__(404);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(405)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(401);
	var getWeak = __webpack_require__(206).getWeak;
	var anObject = __webpack_require__(193);
	var isObject = __webpack_require__(194);
	var anInstance = __webpack_require__(393);
	var forOf = __webpack_require__(394);
	var createArrayMethod = __webpack_require__(355);
	var $has = __webpack_require__(186);
	var validate = __webpack_require__(404);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(408);
	var validate = __webpack_require__(404);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(405)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var $typed = __webpack_require__(411);
	var buffer = __webpack_require__(412);
	var anObject = __webpack_require__(193);
	var toAbsoluteIndex = __webpack_require__(221);
	var toLength = __webpack_require__(219);
	var isObject = __webpack_require__(194);
	var ArrayBuffer = __webpack_require__(185).ArrayBuffer;
	var speciesConstructor = __webpack_require__(391);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(188)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(375)(ARRAY_BUFFER);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(185);
	var hide = __webpack_require__(191);
	var uid = __webpack_require__(200);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(185);
	var DESCRIPTORS = __webpack_require__(187);
	var LIBRARY = __webpack_require__(203);
	var $typed = __webpack_require__(411);
	var hide = __webpack_require__(191);
	var redefineAll = __webpack_require__(401);
	var fails = __webpack_require__(188);
	var anInstance = __webpack_require__(393);
	var toInteger = __webpack_require__(220);
	var toLength = __webpack_require__(219);
	var toIndex = __webpack_require__(413);
	var gOPN = __webpack_require__(232).f;
	var dP = __webpack_require__(192).f;
	var arrayFill = __webpack_require__(371);
	var setToStringTag = __webpack_require__(207);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(220);
	var toLength = __webpack_require__(219);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	$export($export.G + $export.W + $export.F * !__webpack_require__(411).ABV, {
	  DataView: __webpack_require__(412).DataView
	});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(187)) {
	  var LIBRARY = __webpack_require__(203);
	  var global = __webpack_require__(185);
	  var fails = __webpack_require__(188);
	  var $export = __webpack_require__(189);
	  var $typed = __webpack_require__(411);
	  var $buffer = __webpack_require__(412);
	  var ctx = __webpack_require__(204);
	  var anInstance = __webpack_require__(393);
	  var propertyDesc = __webpack_require__(198);
	  var hide = __webpack_require__(191);
	  var redefineAll = __webpack_require__(401);
	  var toInteger = __webpack_require__(220);
	  var toLength = __webpack_require__(219);
	  var toIndex = __webpack_require__(413);
	  var toAbsoluteIndex = __webpack_require__(221);
	  var toPrimitive = __webpack_require__(197);
	  var has = __webpack_require__(186);
	  var classof = __webpack_require__(256);
	  var isObject = __webpack_require__(194);
	  var toObject = __webpack_require__(227);
	  var isArrayIter = __webpack_require__(345);
	  var create = __webpack_require__(228);
	  var getPrototypeOf = __webpack_require__(240);
	  var gOPN = __webpack_require__(232).f;
	  var getIterFn = __webpack_require__(347);
	  var uid = __webpack_require__(200);
	  var wks = __webpack_require__(208);
	  var createArrayMethod = __webpack_require__(355);
	  var createArrayIncludes = __webpack_require__(218);
	  var speciesConstructor = __webpack_require__(391);
	  var ArrayIterators = __webpack_require__(376);
	  var Iterators = __webpack_require__(311);
	  var $iterDetect = __webpack_require__(348);
	  var setSpecies = __webpack_require__(375);
	  var arrayFill = __webpack_require__(371);
	  var arrayCopyWithin = __webpack_require__(368);
	  var $DP = __webpack_require__(192);
	  var $GOPD = __webpack_require__(233);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(189);
	var aFunction = __webpack_require__(205);
	var anObject = __webpack_require__(193);
	var rApply = (__webpack_require__(185).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(188)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(189);
	var create = __webpack_require__(228);
	var aFunction = __webpack_require__(205);
	var anObject = __webpack_require__(193);
	var isObject = __webpack_require__(194);
	var fails = __webpack_require__(188);
	var bind = __webpack_require__(258);
	var rConstruct = (__webpack_require__(185).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(192);
	var $export = __webpack_require__(189);
	var anObject = __webpack_require__(193);
	var toPrimitive = __webpack_require__(197);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(188)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(189);
	var gOPD = __webpack_require__(233).f;
	var anObject = __webpack_require__(193);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(189);
	var anObject = __webpack_require__(193);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(312)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(233);
	var getPrototypeOf = __webpack_require__(240);
	var has = __webpack_require__(186);
	var $export = __webpack_require__(189);
	var isObject = __webpack_require__(194);
	var anObject = __webpack_require__(193);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(233);
	var $export = __webpack_require__(189);
	var anObject = __webpack_require__(193);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(189);
	var getProto = __webpack_require__(240);
	var anObject = __webpack_require__(193);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(189);
	var anObject = __webpack_require__(193);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(436) });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(232);
	var gOPS = __webpack_require__(224);
	var anObject = __webpack_require__(193);
	var Reflect = __webpack_require__(185).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(189);
	var anObject = __webpack_require__(193);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(192);
	var gOPD = __webpack_require__(233);
	var getPrototypeOf = __webpack_require__(240);
	var has = __webpack_require__(186);
	var $export = __webpack_require__(189);
	var createDesc = __webpack_require__(198);
	var anObject = __webpack_require__(193);
	var isObject = __webpack_require__(194);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(189);
	var setProto = __webpack_require__(254);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(189);
	var $includes = __webpack_require__(218)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(369)('includes');


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(189);
	var flattenIntoArray = __webpack_require__(442);
	var toObject = __webpack_require__(227);
	var toLength = __webpack_require__(219);
	var aFunction = __webpack_require__(205);
	var arraySpeciesCreate = __webpack_require__(356);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(369)('flatMap');


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(226);
	var isObject = __webpack_require__(194);
	var toLength = __webpack_require__(219);
	var ctx = __webpack_require__(204);
	var IS_CONCAT_SPREADABLE = __webpack_require__(208)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(189);
	var flattenIntoArray = __webpack_require__(442);
	var toObject = __webpack_require__(227);
	var toLength = __webpack_require__(219);
	var toInteger = __webpack_require__(220);
	var arraySpeciesCreate = __webpack_require__(356);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(369)('flatten');


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(189);
	var $at = __webpack_require__(309)(true);
	var $fails = __webpack_require__(188);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(189);
	var $pad = __webpack_require__(446);
	var userAgent = __webpack_require__(399);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(219);
	var repeat = __webpack_require__(272);
	var defined = __webpack_require__(217);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(189);
	var $pad = __webpack_require__(446);
	var userAgent = __webpack_require__(399);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(264)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(264)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(189);
	var defined = __webpack_require__(217);
	var toLength = __webpack_require__(219);
	var isRegExp = __webpack_require__(316);
	var getFlags = __webpack_require__(379);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(312)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(210)('asyncIterator');


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(210)('observable');


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(189);
	var ownKeys = __webpack_require__(436);
	var toIObject = __webpack_require__(214);
	var gOPD = __webpack_require__(233);
	var createProperty = __webpack_require__(346);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(189);
	var $values = __webpack_require__(455)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(187);
	var getKeys = __webpack_require__(212);
	var toIObject = __webpack_require__(214);
	var isEnum = __webpack_require__(225).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(189);
	var $entries = __webpack_require__(455)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toObject = __webpack_require__(227);
	var aFunction = __webpack_require__(205);
	var $defineProperty = __webpack_require__(192);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(187) && $export($export.P + __webpack_require__(458), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(203) || !__webpack_require__(188)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(185)[K];
	});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toObject = __webpack_require__(227);
	var aFunction = __webpack_require__(205);
	var $defineProperty = __webpack_require__(192);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(187) && $export($export.P + __webpack_require__(458), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toObject = __webpack_require__(227);
	var toPrimitive = __webpack_require__(197);
	var getPrototypeOf = __webpack_require__(240);
	var getOwnPropertyDescriptor = __webpack_require__(233).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(187) && $export($export.P + __webpack_require__(458), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(189);
	var toObject = __webpack_require__(227);
	var toPrimitive = __webpack_require__(197);
	var getPrototypeOf = __webpack_require__(240);
	var getOwnPropertyDescriptor = __webpack_require__(233).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(187) && $export($export.P + __webpack_require__(458), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(189);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(463)('Map') });


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(256);
	var from = __webpack_require__(464);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(394);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(189);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(463)('Set') });


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(467)('Map');


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(189);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(467)('Set');


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(467)('WeakMap');


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(467)('WeakSet');


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(472)('Map');


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(189);
	var aFunction = __webpack_require__(205);
	var ctx = __webpack_require__(204);
	var forOf = __webpack_require__(394);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(472)('Set');


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(472)('WeakMap');


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(472)('WeakSet');


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(189);
	
	$export($export.G, { global: __webpack_require__(185) });


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(189);
	
	$export($export.S, 'System', { global: __webpack_require__(185) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(189);
	var cof = __webpack_require__(216);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	var scale = __webpack_require__(483);
	var fround = __webpack_require__(295);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { scale: __webpack_require__(483) });


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(189);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(189);
	var core = __webpack_require__(190);
	var global = __webpack_require__(185);
	var speciesConstructor = __webpack_require__(391);
	var promiseResolve = __webpack_require__(400);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(189);
	var newPromiseCapability = __webpack_require__(397);
	var perform = __webpack_require__(398);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(402);
	var $export = __webpack_require__(189);
	var shared = __webpack_require__(202)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(407))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var getPrototypeOf = __webpack_require__(240);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(406);
	var from = __webpack_require__(464);
	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var getPrototypeOf = __webpack_require__(240);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var getPrototypeOf = __webpack_require__(240);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(495);
	var anObject = __webpack_require__(193);
	var aFunction = __webpack_require__(205);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(189);
	var microtask = __webpack_require__(396)();
	var process = __webpack_require__(185).process;
	var isNode = __webpack_require__(216)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(189);
	var global = __webpack_require__(185);
	var core = __webpack_require__(190);
	var microtask = __webpack_require__(396)();
	var OBSERVABLE = __webpack_require__(208)('observable');
	var aFunction = __webpack_require__(205);
	var anObject = __webpack_require__(193);
	var anInstance = __webpack_require__(393);
	var redefineAll = __webpack_require__(401);
	var hide = __webpack_require__(191);
	var forOf = __webpack_require__(394);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(375)('Observable');


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(185);
	var $export = __webpack_require__(189);
	var userAgent = __webpack_require__(399);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(189);
	var $task = __webpack_require__(395);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(376);
	var getKeys = __webpack_require__(212);
	var redefine = __webpack_require__(199);
	var global = __webpack_require__(185);
	var hide = __webpack_require__(191);
	var Iterators = __webpack_require__(311);
	var wks = __webpack_require__(208);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 509 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(511);
	module.exports = __webpack_require__(190).RegExp.escape;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(189);
	var $re = __webpack_require__(512)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(514);

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _, Backbone) {'use strict';
	
	/* globals COMMIT */
	
	var _bluebird = __webpack_require__(63);
	
	var _title = __webpack_require__(524);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _Main = __webpack_require__(528);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _App = __webpack_require__(1085);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _banks = __webpack_require__(1087);
	
	var _banks2 = _interopRequireDefault(_banks);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var swal = __webpack_require__(530);
	var log = (0, _log2.default)();
	
	var Decimal = __webpack_require__(586);
	
	__webpack_require__(1089);
	__webpack_require__(101).tz.guess();
	__webpack_require__(101).locale('my', {
	    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
	    week: {
	        dow: 1,
	        doy: 4
	    }
	});
	
	__webpack_require__(1092);
	__webpack_require__(1093);
	__webpack_require__(1094);
	__webpack_require__(1095);
	__webpack_require__(1096);
	__webpack_require__(1097);
	__webpack_require__(1098);
	__webpack_require__(1099);
	__webpack_require__(1100);
	__webpack_require__(1101);
	__webpack_require__(1102);
	
	__webpack_require__(1103);
	__webpack_require__(1104);
	
	__webpack_require__(1105);
	__webpack_require__(1135);
	
	log.info('App starting...');
	
	function checkAppUpdated(force) {
	    var timestamp = new Date().getTime().toString();
	    _axios2.default.get(window.location.origin + '/build-info.json?cb=' + timestamp).then(function (res) {
	        try {
	            var commit = res.data.commit;
	            if (commit && ("6d556e02b2fb0e8fb042d01411cff8fadf054553") && commit !== ("6d556e02b2fb0e8fb042d01411cff8fadf054553") || force) {
	                swal({
	                    title: 'The app has been updated.',
	                    text: 'You should reload it now to get the latest version'
	                });
	            }
	        } catch (e) {
	            log.error('Error parsing app version');
	            log.error(e);
	        }
	    }).catch(function (e) {
	        log.error('Error fetching app version');
	        log.error(e);
	    });
	}
	
	setTimeout(checkAppUpdated, 15 * 1000);
	setInterval(checkAppUpdated, 10 * 60 * 1000); // every 10 minutes
	
	window.checkAppUpdated = checkAppUpdated;
	
	$(function () {
	    (0, _title2.default)({ base: 'PayrollPanda:' });
	
	    window.app = {
	        version: ("1.73.0"),
	        view: new _App2.default(),
	        contentView: null,
	        mainRouter: null,
	        events: _.extend({}, Backbone.Events),
	        user: new _user2.default(),
	        banks: new _banks2.default(),
	        company: null,
	        subscription: null,
	        holidays: null,
	        payrollItems: null,
	        leaveTypes: null,
	        reload: function reload() {
	            window.location.href = '/' + window.location.search;
	        },
	        refresh: function refresh() {
	            window.location.reload();
	        }
	    };
	
	    // formatiting numbers without rounding
	    Number.prototype.formatWithoutRounding = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	
	        return new Decimal(this).toDP(dp, Decimal.ROUND_DOWN).toFixed(dp);
	    };
	    // The db contains strings in several places where it should be a number
	    String.prototype.formatWithoutRounding = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	
	        var number = Number(this);
	        return isNaN(number) ? this.format() : number.formatWithoutRounding(dp);
	    };
	
	    $(window).bind('beforeunload', function () {
	        var status = { unsaved: false };
	        app.events.trigger('navigate', status);
	
	        if (status.unsaved === true) {
	            return status.msg || 'There are unsaved changes. Leaving this ' + 'page will result in the changes being discarded.';
	        }
	    });
	
	    // Load user if available
	    var accessToken = app.user.getAccessToken();
	    var onUserReady = void 0;
	    if (accessToken) {
	        log.info('Fetching user ' + accessToken.userId);
	        app.user.set({ id: accessToken.userId });
	        onUserReady = app.user.fetch().then(app.banks.fetch({ filter: { limit: 9999 } }));
	    } else {
	        onUserReady = (0, _bluebird.resolve)(true);
	    }
	
	    // load main router
	    onUserReady.then(function () {
	        app.mainRouter = new _Main2.default();
	        return true;
	    }).catch(function (err) {
	        log.error(err);
	
	        if (err.response && err.response.error && err.response.error.statusCode === 401) {
	            log.info('Removing invalid access token');
	            app.user.removeAccessToken();
	            window.location.href = '/';
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(27), __webpack_require__(523)))

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {//     Backbone.js 1.4.0
	
	//     (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(factory) {
	
	  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
	  // We use `self` instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global;
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(27), __webpack_require__(14), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore'), $;
	    try { $ = require('jquery'); } catch (e) {}
	    factory(root, exports, _, $);
	
	  // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, root.jQuery || root.Zepto || root.ender || root.$);
	  }
	
	})(function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create a local reference to a common array method we'll want to use later.
	  var slice = Array.prototype.slice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.4.0';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... this will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // a custom event channel. You may bind a callback to an event with `on` or
	  // remove with `off`; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {};
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // A private global variable to share between listeners and listenees.
	  var _listening;
	
	  // Iterates over the standard `event, callback` (as well as the fancy multiple
	  // space-separated events `"change blur", callback` and jQuery-style event
	  // maps `{event: callback}`).
	  var eventsApi = function(iteratee, events, name, callback, opts) {
	    var i = 0, names;
	    if (name && typeof name === 'object') {
	      // Handle event maps.
	      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
	      for (names = _.keys(name); i < names.length ; i++) {
	        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
	      }
	    } else if (name && eventSplitter.test(name)) {
	      // Handle space-separated event names by delegating them individually.
	      for (names = name.split(eventSplitter); i < names.length; i++) {
	        events = iteratee(events, names[i], callback, opts);
	      }
	    } else {
	      // Finally, standard events.
	      events = iteratee(events, name, callback, opts);
	    }
	    return events;
	  };
	
	  // Bind an event to a `callback` function. Passing `"all"` will bind
	  // the callback to all events fired.
	  Events.on = function(name, callback, context) {
	    this._events = eventsApi(onApi, this._events || {}, name, callback, {
	      context: context,
	      ctx: this,
	      listening: _listening
	    });
	
	    if (_listening) {
	      var listeners = this._listeners || (this._listeners = {});
	      listeners[_listening.id] = _listening;
	      // Allow the listening to use a counter, instead of tracking
	      // callbacks for library interop
	      _listening.interop = false;
	    }
	
	    return this;
	  };
	
	  // Inversion-of-control versions of `on`. Tell *this* object to listen to
	  // an event in another object... keeping track of what it's listening to
	  // for easier unbinding later.
	  Events.listenTo = function(obj, name, callback) {
	    if (!obj) return this;
	    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	    var listeningTo = this._listeningTo || (this._listeningTo = {});
	    var listening = _listening = listeningTo[id];
	
	    // This object is not listening to any other events on `obj` yet.
	    // Setup the necessary references to track the listening callbacks.
	    if (!listening) {
	      this._listenId || (this._listenId = _.uniqueId('l'));
	      listening = _listening = listeningTo[id] = new Listening(this, obj);
	    }
	
	    // Bind callbacks on obj.
	    var error = tryCatchOn(obj, name, callback, this);
	    _listening = void 0;
	
	    if (error) throw error;
	    // If the target obj is not Backbone.Events, track events manually.
	    if (listening.interop) listening.on(name, callback);
	
	    return this;
	  };
	
	  // The reducing API that adds a callback to the `events` object.
	  var onApi = function(events, name, callback, options) {
	    if (callback) {
	      var handlers = events[name] || (events[name] = []);
	      var context = options.context, ctx = options.ctx, listening = options.listening;
	      if (listening) listening.count++;
	
	      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
	    }
	    return events;
	  };
	
	  // An try-catch guarded #on function, to prevent poisoning the global
	  // `_listening` variable.
	  var tryCatchOn = function(obj, name, callback, context) {
	    try {
	      obj.on(name, callback, context);
	    } catch (e) {
	      return e;
	    }
	  };
	
	  // Remove one or many callbacks. If `context` is null, removes all
	  // callbacks with that function. If `callback` is null, removes all
	  // callbacks for the event. If `name` is null, removes all bound
	  // callbacks for all events.
	  Events.off = function(name, callback, context) {
	    if (!this._events) return this;
	    this._events = eventsApi(offApi, this._events, name, callback, {
	      context: context,
	      listeners: this._listeners
	    });
	
	    return this;
	  };
	
	  // Tell this object to stop listening to either specific events ... or
	  // to every object it's currently listening to.
	  Events.stopListening = function(obj, name, callback) {
	    var listeningTo = this._listeningTo;
	    if (!listeningTo) return this;
	
	    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
	    for (var i = 0; i < ids.length; i++) {
	      var listening = listeningTo[ids[i]];
	
	      // If listening doesn't exist, this object is not currently
	      // listening to obj. Break out early.
	      if (!listening) break;
	
	      listening.obj.off(name, callback, this);
	      if (listening.interop) listening.off(name, callback);
	    }
	    if (_.isEmpty(listeningTo)) this._listeningTo = void 0;
	
	    return this;
	  };
	
	  // The reducing API that removes a callback from the `events` object.
	  var offApi = function(events, name, callback, options) {
	    if (!events) return;
	
	    var context = options.context, listeners = options.listeners;
	    var i = 0, names;
	
	    // Delete all event listeners and "drop" events.
	    if (!name && !context && !callback) {
	      for (names = _.keys(listeners); i < names.length; i++) {
	        listeners[names[i]].cleanup();
	      }
	      return;
	    }
	
	    names = name ? [name] : _.keys(events);
	    for (; i < names.length; i++) {
	      name = names[i];
	      var handlers = events[name];
	
	      // Bail out if there are no events stored.
	      if (!handlers) break;
	
	      // Find any remaining events.
	      var remaining = [];
	      for (var j = 0; j < handlers.length; j++) {
	        var handler = handlers[j];
	        if (
	          callback && callback !== handler.callback &&
	            callback !== handler.callback._callback ||
	              context && context !== handler.context
	        ) {
	          remaining.push(handler);
	        } else {
	          var listening = handler.listening;
	          if (listening) listening.off(name, callback);
	        }
	      }
	
	      // Replace events if there are any remaining.  Otherwise, clean up.
	      if (remaining.length) {
	        events[name] = remaining;
	      } else {
	        delete events[name];
	      }
	    }
	
	    return events;
	  };
	
	  // Bind an event to only be triggered a single time. After the first time
	  // the callback is invoked, its listener will be removed. If multiple events
	  // are passed in using the space-separated syntax, the handler will fire
	  // once for each event, not once for a combination of all events.
	  Events.once = function(name, callback, context) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
	    if (typeof name === 'string' && context == null) callback = void 0;
	    return this.on(events, callback, context);
	  };
	
	  // Inversion-of-control versions of `once`.
	  Events.listenToOnce = function(obj, name, callback) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
	    return this.listenTo(obj, events);
	  };
	
	  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
	  // `offer` unbinds the `onceWrapper` after it has been called.
	  var onceMap = function(map, name, callback, offer) {
	    if (callback) {
	      var once = map[name] = _.once(function() {
	        offer(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	    }
	    return map;
	  };
	
	  // Trigger one or many events, firing all bound callbacks. Callbacks are
	  // passed the same arguments as `trigger` is, apart from the event name
	  // (unless you're listening on `"all"`, which will cause your callback to
	  // receive the true name of the event as the first argument).
	  Events.trigger = function(name) {
	    if (!this._events) return this;
	
	    var length = Math.max(0, arguments.length - 1);
	    var args = Array(length);
	    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];
	
	    eventsApi(triggerApi, this._events, name, void 0, args);
	    return this;
	  };
	
	  // Handles triggering the appropriate event callbacks.
	  var triggerApi = function(objEvents, name, callback, args) {
	    if (objEvents) {
	      var events = objEvents[name];
	      var allEvents = objEvents.all;
	      if (events && allEvents) allEvents = allEvents.slice();
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, [name].concat(args));
	    }
	    return objEvents;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	  };
	
	  // A listening class that tracks and cleans up memory bindings
	  // when all callbacks have been offed.
	  var Listening = function(listener, obj) {
	    this.id = listener._listenId;
	    this.listener = listener;
	    this.obj = obj;
	    this.interop = true;
	    this.count = 0;
	    this._events = void 0;
	  };
	
	  Listening.prototype.on = Events.on;
	
	  // Offs a callback (or several).
	  // Uses an optimized counter if the listenee uses Backbone.Events.
	  // Otherwise, falls back to manual tracking to support events
	  // library interop.
	  Listening.prototype.off = function(name, callback) {
	    var cleanup;
	    if (this.interop) {
	      this._events = eventsApi(offApi, this._events, name, callback, {
	        context: void 0,
	        listeners: void 0
	      });
	      cleanup = !this._events;
	    } else {
	      this.count--;
	      cleanup = this.count === 0;
	    }
	    if (cleanup) this.cleanup();
	  };
	
	  // Cleans up memory bindings between the listener and the listenee.
	  Listening.prototype.cleanup = function() {
	    delete this.listener._listeningTo[this.obj._listenId];
	    if (!this.interop) delete this.obj._listeners[this.id];
	  };
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.preinitialize.apply(this, arguments);
	    this.cid = _.uniqueId(this.cidPrefix);
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    var defaults = _.result(this, 'defaults');
	    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // The prefix is used to create the client id which is used to identify models locally.
	    // You may want to override this if you're experiencing name clashes with model ids.
	    cidPrefix: 'c',
	
	    // preinitialize is an empty function by default. You can override it with a function
	    // or object.  preinitialize will run before any instantiation logic is run in the Model.
	    preinitialize: function(){},
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Special-cased proxy to underscore's `_.matches` method.
	    matches: function(attrs) {
	      return !!_.iteratee(attrs, this)(this.attributes);
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      var unset      = options.unset;
	      var silent     = options.silent;
	      var changes    = [];
	      var changing   = this._changing;
	      this._changing = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	
	      var current = this.attributes;
	      var changed = this.changed;
	      var prev    = this._previousAttributes;
	
	      // For each `set` attribute, update or delete the current value.
	      for (var attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          changed[attr] = val;
	        } else {
	          delete changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Update the `id`.
	      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0; i < changes.length; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      var changed = {};
	      var hasChanged;
	      for (var attr in diff) {
	        var val = diff[attr];
	        if (_.isEqual(old[attr], val)) continue;
	        changed[attr] = val;
	        hasChanged = true;
	      }
	      return hasChanged ? changed : false;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server, merging the response with the model's
	    // local attributes. Any changed attributes will trigger a "change" event.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (!model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true, parse: true}, options);
	      var wait = options.wait;
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !wait) {
	        if (!this.set(attrs, options)) return false;
	      } else if (!this._validate(attrs, options)) {
	        return false;
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      var model = this;
	      var success = options.success;
	      var attributes = this.attributes;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
	        if (serverAttrs && !model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      // Set temporary attributes if `{wait: true}` to properly find new ids.
	      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
	
	      var method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
	      if (method === 'patch' && !options.attrs) options.attrs = attrs;
	      var xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	      var wait = options.wait;
	
	      var destroy = function() {
	        model.stopListening();
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (wait) destroy();
	        if (success) success.call(options.context, model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      var xhr = false;
	      if (this.isNew()) {
	        _.defer(options.success);
	      } else {
	        wrapError(this, options);
	        xhr = this.sync('delete', this, options);
	      }
	      if (!wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base =
	        _.result(this, 'urlRoot') ||
	        _.result(this.collection, 'url') ||
	        urlError();
	      if (this.isNew()) return base;
	      var id = this.get(this.idAttribute);
	      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend({}, options, {validate: true}));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analogous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    this.preinitialize.apply(this, arguments);
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Splices `insert` into `array` at index `at`.
	  var splice = function(array, insert, at) {
	    at = Math.min(Math.max(at, 0), array.length);
	    var tail = Array(array.length - at);
	    var length = insert.length;
	    var i;
	    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
	    for (i = 0; i < length; i++) array[i + at] = insert[i];
	    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
	  };
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	
	    // preinitialize is an empty function by default. You can override it with a function
	    // or object.  preinitialize will run before any instantiation logic is run in the Collection.
	    preinitialize: function(){},
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model) { return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set. `models` may be Backbone
	    // Models or raw JavaScript objects to be converted to Models, or any
	    // combination of the two.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      options = _.extend({}, options);
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	      var removed = this._removeModels(models, options);
	      if (!options.silent && removed.length) {
	        options.changes = {added: [], merged: [], removed: removed};
	        this.trigger('update', this, options);
	      }
	      return singular ? removed[0] : removed;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      if (models == null) return;
	
	      options = _.extend({}, setOptions, options);
	      if (options.parse && !this._isModel(models)) {
	        models = this.parse(models, options) || [];
	      }
	
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	
	      var at = options.at;
	      if (at != null) at = +at;
	      if (at > this.length) at = this.length;
	      if (at < 0) at += this.length + 1;
	
	      var set = [];
	      var toAdd = [];
	      var toMerge = [];
	      var toRemove = [];
	      var modelMap = {};
	
	      var add = options.add;
	      var merge = options.merge;
	      var remove = options.remove;
	
	      var sort = false;
	      var sortable = this.comparator && at == null && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      var model, i;
	      for (i = 0; i < models.length; i++) {
	        model = models[i];
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        var existing = this.get(model);
	        if (existing) {
	          if (merge && model !== existing) {
	            var attrs = this._isModel(model) ? model.attributes : model;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            toMerge.push(existing);
	            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
	          }
	          if (!modelMap[existing.cid]) {
	            modelMap[existing.cid] = true;
	            set.push(existing);
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(model, options);
	          if (model) {
	            toAdd.push(model);
	            this._addReference(model, options);
	            modelMap[model.cid] = true;
	            set.push(model);
	          }
	        }
	      }
	
	      // Remove stale models.
	      if (remove) {
	        for (i = 0; i < this.length; i++) {
	          model = this.models[i];
	          if (!modelMap[model.cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this._removeModels(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      var orderChanged = false;
	      var replace = !sortable && add && remove;
	      if (set.length && replace) {
	        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
	          return m !== set[index];
	        });
	        this.models.length = 0;
	        splice(this.models, set, 0);
	        this.length = this.models.length;
	      } else if (toAdd.length) {
	        if (sortable) sort = true;
	        splice(this.models, toAdd, at == null ? this.length : at);
	        this.length = this.models.length;
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort/update events.
	      if (!options.silent) {
	        for (i = 0; i < toAdd.length; i++) {
	          if (at != null) options.index = at + i;
	          model = toAdd[i];
	          model.trigger('add', model, this, options);
	        }
	        if (sort || orderChanged) this.trigger('sort', this, options);
	        if (toAdd.length || toRemove.length || toMerge.length) {
	          options.changes = {
	            added: toAdd,
	            removed: toRemove,
	            merged: toMerge
	          };
	          this.trigger('update', this, options);
	        }
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options = options ? _.clone(options) : {};
	      for (var i = 0; i < this.models.length; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      return this.remove(model, options);
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      return this.remove(model, options);
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id, cid, model object with id or cid
	    // properties, or an attributes object that is transformed through modelId.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] ||
	        this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj)] ||
	        obj.cid && this._byId[obj.cid];
	    },
	
	    // Returns `true` if the model is in the collection.
	    has: function(obj) {
	      return this.get(obj) != null;
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      if (index < 0) index += this.length;
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      return this[first ? 'find' : 'filter'](attrs);
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      var comparator = this.comparator;
	      if (!comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      var length = comparator.length;
	      if (_.isFunction(comparator)) comparator = comparator.bind(this);
	
	      // Run sort based on type of `comparator`.
	      if (length === 1 || _.isString(comparator)) {
	        this.models = this.sortBy(comparator);
	      } else {
	        this.models.sort(comparator);
	      }
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return this.map(attr + '');
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success.call(options.context, collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      var wait = options.wait;
	      model = this._prepareModel(model, options);
	      if (!model) return false;
	      if (!wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(m, resp, callbackOpts) {
	        if (wait) collection.add(m, callbackOpts);
	        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models, {
	        model: this.model,
	        comparator: this.comparator
	      });
	    },
	
	    // Define how to uniquely identify models in the collection.
	    modelId: function(attrs) {
	      return attrs[this.model.prototype.idAttribute || 'id'];
	    },
	
	    // Get an iterator of all models in this collection.
	    values: function() {
	      return new CollectionIterator(this, ITERATOR_VALUES);
	    },
	
	    // Get an iterator of all model IDs in this collection.
	    keys: function() {
	      return new CollectionIterator(this, ITERATOR_KEYS);
	    },
	
	    // Get an iterator of all [ID, model] tuples in this collection.
	    entries: function() {
	      return new CollectionIterator(this, ITERATOR_KEYSVALUES);
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (this._isModel(attrs)) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method called by both remove and set.
	    _removeModels: function(models, options) {
	      var removed = [];
	      for (var i = 0; i < models.length; i++) {
	        var model = this.get(models[i]);
	        if (!model) continue;
	
	        var index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	
	        // Remove references before triggering 'remove' event to prevent an
	        // infinite loop. #3693
	        delete this._byId[model.cid];
	        var id = this.modelId(model.attributes);
	        if (id != null) delete this._byId[id];
	
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	
	        removed.push(model);
	        this._removeReference(model, options);
	      }
	      return removed;
	    },
	
	    // Method for checking whether an object should be considered a model for
	    // the purposes of adding to the collection.
	    _isModel: function(model) {
	      return model instanceof Model;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function(model, options) {
	      this._byId[model.cid] = model;
	      var id = this.modelId(model.attributes);
	      if (id != null) this._byId[id] = model;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model, options) {
	      delete this._byId[model.cid];
	      var id = this.modelId(model.attributes);
	      if (id != null) delete this._byId[id];
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if (model) {
	        if ((event === 'add' || event === 'remove') && collection !== this) return;
	        if (event === 'destroy') this.remove(model, options);
	        if (event === 'change') {
	          var prevId = this.modelId(model.previousAttributes());
	          var id = this.modelId(model.attributes);
	          if (prevId !== id) {
	            if (prevId != null) delete this._byId[prevId];
	            if (id != null) this._byId[id] = model;
	          }
	        }
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Defining an @@iterator method implements JavaScript's Iterable protocol.
	  // In modern ES2015 browsers, this value is found at Symbol.iterator.
	  /* global Symbol */
	  var $$iterator = typeof Symbol === 'function' && Symbol.iterator;
	  if ($$iterator) {
	    Collection.prototype[$$iterator] = Collection.prototype.values;
	  }
	
	  // CollectionIterator
	  // ------------------
	
	  // A CollectionIterator implements JavaScript's Iterator protocol, allowing the
	  // use of `for of` loops in modern browsers and interoperation between
	  // Backbone.Collection and other JavaScript functions and third-party libraries
	  // which can operate on Iterables.
	  var CollectionIterator = function(collection, kind) {
	    this._collection = collection;
	    this._kind = kind;
	    this._index = 0;
	  };
	
	  // This "enum" defines the three possible kinds of values which can be emitted
	  // by a CollectionIterator that correspond to the values(), keys() and entries()
	  // methods on Collection, respectively.
	  var ITERATOR_VALUES = 1;
	  var ITERATOR_KEYS = 2;
	  var ITERATOR_KEYSVALUES = 3;
	
	  // All Iterators should themselves be Iterable.
	  if ($$iterator) {
	    CollectionIterator.prototype[$$iterator] = function() {
	      return this;
	    };
	  }
	
	  CollectionIterator.prototype.next = function() {
	    if (this._collection) {
	
	      // Only continue iterating if the iterated collection is long enough.
	      if (this._index < this._collection.length) {
	        var model = this._collection.at(this._index);
	        this._index++;
	
	        // Construct a value depending on what kind of values should be iterated.
	        var value;
	        if (this._kind === ITERATOR_VALUES) {
	          value = model;
	        } else {
	          var id = this._collection.modelId(model.attributes);
	          if (this._kind === ITERATOR_KEYS) {
	            value = id;
	          } else { // ITERATOR_KEYSVALUES
	            value = [id, model];
	          }
	        }
	        return {value: value, done: false};
	      }
	
	      // Once exhausted, remove the reference to the collection so future
	      // calls to the next method always return done.
	      this._collection = void 0;
	    }
	
	    return {value: void 0, done: true};
	  };
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    this.preinitialize.apply(this, arguments);
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be set as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // preinitialize is an empty function by default. You can override it with a function
	    // or object.  preinitialize will run before any instantiation logic is run in the View
	    preinitialize: function(){},
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this._removeElement();
	      this.stopListening();
	      return this;
	    },
	
	    // Remove this view's element from the document and all event listeners
	    // attached to it. Exposed for subclasses using an alternative DOM
	    // manipulation API.
	    _removeElement: function() {
	      this.$el.remove();
	    },
	
	    // Change the view's element (`this.el` property) and re-delegate the
	    // view's events on the new element.
	    setElement: function(element) {
	      this.undelegateEvents();
	      this._setElement(element);
	      this.delegateEvents();
	      return this;
	    },
	
	    // Creates the `this.el` and `this.$el` references for this view using the
	    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
	    // context or an element. Subclasses can override this to utilize an
	    // alternative DOM manipulation API and are only required to set the
	    // `this.el` property.
	    _setElement: function(el) {
	      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
	      this.el = this.$el[0];
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    delegateEvents: function(events) {
	      events || (events = _.result(this, 'events'));
	      if (!events) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[method];
	        if (!method) continue;
	        var match = key.match(delegateEventSplitter);
	        this.delegate(match[1], match[2], method.bind(this));
	      }
	      return this;
	    },
	
	    // Add a single event listener to the view's element (or a child element
	    // using `selector`). This only works for delegate-able events: not `focus`,
	    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
	    delegate: function(eventName, selector, listener) {
	      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view by `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // A finer-grained `undelegateEvents` for removing a single delegated event.
	    // `selector` and `listener` are both optional.
	    undelegate: function(eventName, selector, listener) {
	      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Produces a DOM element to be assigned to your view. Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _createElement: function(tagName) {
	      return document.createElement(tagName);
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        this.setElement(this._createElement(_.result(this, 'tagName')));
	        this._setAttributes(attrs);
	      } else {
	        this.setElement(_.result(this, 'el'));
	      }
	    },
	
	    // Set attributes from a hash on this view's element.  Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _setAttributes: function(attributes) {
	      this.$el.attr(attributes);
	    }
	
	  });
	
	  // Proxy Backbone class methods to Underscore functions, wrapping the model's
	  // `attributes` object or collection's `models` array behind the scenes.
	  //
	  // collection.filter(function(model) { return model.get('age') > 10 });
	  // collection.each(this.addView);
	  //
	  // `Function#apply` can be slow so we use the method's arg count, if we know it.
	  var addMethod = function(base, length, method, attribute) {
	    switch (length) {
	      case 1: return function() {
	        return base[method](this[attribute]);
	      };
	      case 2: return function(value) {
	        return base[method](this[attribute], value);
	      };
	      case 3: return function(iteratee, context) {
	        return base[method](this[attribute], cb(iteratee, this), context);
	      };
	      case 4: return function(iteratee, defaultVal, context) {
	        return base[method](this[attribute], cb(iteratee, this), defaultVal, context);
	      };
	      default: return function() {
	        var args = slice.call(arguments);
	        args.unshift(this[attribute]);
	        return base[method].apply(base, args);
	      };
	    }
	  };
	
	  var addUnderscoreMethods = function(Class, base, methods, attribute) {
	    _.each(methods, function(length, method) {
	      if (base[method]) Class.prototype[method] = addMethod(base, length, method, attribute);
	    });
	  };
	
	  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
	  var cb = function(iteratee, instance) {
	    if (_.isFunction(iteratee)) return iteratee;
	    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
	    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
	    return iteratee;
	  };
	  var modelMatcher = function(attrs) {
	    var matcher = _.matches(attrs);
	    return function(model) {
	      return matcher(model.attributes);
	    };
	  };
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
	    foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
	    select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
	    contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
	    head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
	    without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
	    isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
	    sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};
	
	
	  // Underscore methods that we want to implement on the Model, mapped to the
	  // number of arguments they take.
	  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
	    omit: 0, chain: 1, isEmpty: 1};
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	
	  _.each([
	    [Collection, collectionMethods, 'models'],
	    [Model, modelMethods, 'attributes']
	  ], function(config) {
	    var Base = config[0],
	        methods = config[1],
	        attribute = config[2];
	
	    Base.mixin = function(obj) {
	      var mappings = _.reduce(_.functions(obj), function(memo, name) {
	        memo[name] = 0;
	        return memo;
	      }, {});
	      addUnderscoreMethods(Base, obj, mappings, attribute);
	    };
	
	    addUnderscoreMethods(Base, _, methods, attribute);
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // Pass along `textStatus` and `errorThrown` from jQuery.
	    var error = options.error;
	    options.error = function(xhr, textStatus, errorThrown) {
	      options.textStatus = textStatus;
	      options.errorThrown = errorThrown;
	      if (error) error.call(options.context, xhr, textStatus, errorThrown);
	    };
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    create: 'POST',
	    update: 'PUT',
	    patch: 'PATCH',
	    delete: 'DELETE',
	    read: 'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    this.preinitialize.apply(this, arguments);
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // preinitialize is an empty function by default. You can override it with a function
	    // or object.  preinitialize will run before any instantiation logic is run in the Router.
	    preinitialize: function(){},
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        if (router.execute(callback, args, name) !== false) {
	          router.trigger.apply(router, ['route:' + name].concat(args));
	          router.trigger('route', name, args);
	          Backbone.history.trigger('route', router, name, args);
	        }
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function(callback, args, name) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	        .replace(optionalParam, '(?:$1)?')
	        .replace(namedParam, function(match, optional) {
	          return optional ? match : '([^/?]+)';
	        })
	        .replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    this.checkUrl = this.checkUrl.bind(this);
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function() {
	      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
	      return path === this.root && !this.getSearch();
	    },
	
	    // Does the pathname match the root?
	    matchRoot: function() {
	      var path = this.decodeFragment(this.location.pathname);
	      var rootPath = path.slice(0, this.root.length - 1) + '/';
	      return rootPath === this.root;
	    },
	
	    // Unicode characters in `location.pathname` are percent encoded so they're
	    // decoded for comparison. `%25` should not be decoded since it may be part
	    // of an encoded parameter.
	    decodeFragment: function(fragment) {
	      return decodeURI(fragment.replace(/%25/g, '%2525'));
	    },
	
	    // In IE6, the hash fragment and search params are incorrect if the
	    // fragment contains `?`.
	    getSearch: function() {
	      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
	      return match ? match[0] : '';
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the pathname and search params, without the root.
	    getPath: function() {
	      var path = this.decodeFragment(
	        this.location.pathname + this.getSearch()
	      ).slice(this.root.length - 1);
	      return path.charAt(0) === '/' ? path.slice(1) : path;
	    },
	
	    // Get the cross-browser normalized URL fragment from the path or hash.
	    getFragment: function(fragment) {
	      if (fragment == null) {
	        if (this._usePushState || !this._wantsHashChange) {
	          fragment = this.getPath();
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error('Backbone.history has already been started');
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
	      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.history && this.history.pushState);
	      this._usePushState    = this._wantsPushState && this._hasPushState;
	      this.fragment         = this.getFragment();
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          var rootPath = this.root.slice(0, -1) || '/';
	          this.location.replace(rootPath + '#' + this.getPath());
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	        // Or if we've started out with a hash-based route, but we're currently
	        // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot()) {
	          this.navigate(this.getHash(), {replace: true});
	        }
	
	      }
	
	      // Proxy an iframe to handle location events if the browser doesn't
	      // support the `hashchange` event, HTML5 history, or the user wants
	      // `hashChange` but not `pushState`.
	      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
	        this.iframe = document.createElement('iframe');
	        this.iframe.src = 'javascript:0';
	        this.iframe.style.display = 'none';
	        this.iframe.tabIndex = -1;
	        var body = document.body;
	        // Using `appendChild` will throw on IE < 9 if the document is not ready.
	        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
	        iWindow.document.open();
	        iWindow.document.close();
	        iWindow.location.hash = '#' + this.fragment;
	      }
	
	      // Add a cross-platform `addEventListener` shim for older browsers.
	      var addEventListener = window.addEventListener || function(eventName, listener) {
	        return attachEvent('on' + eventName, listener);
	      };
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._usePushState) {
	        addEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        addEventListener('hashchange', this.checkUrl, false);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      // Add a cross-platform `removeEventListener` shim for older browsers.
	      var removeEventListener = window.removeEventListener || function(eventName, listener) {
	        return detachEvent('on' + eventName, listener);
	      };
	
	      // Remove window listeners.
	      if (this._usePushState) {
	        removeEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        removeEventListener('hashchange', this.checkUrl, false);
	      }
	
	      // Clean up the iframe if necessary.
	      if (this.iframe) {
	        document.body.removeChild(this.iframe);
	        this.iframe = null;
	      }
	
	      // Some environments will throw when clearing an undefined interval.
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	
	      // If the user pressed the back button, the iframe's hash will have
	      // changed and we should use that for comparison.
	      if (current === this.fragment && this.iframe) {
	        current = this.getHash(this.iframe.contentWindow);
	      }
	
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragment) {
	      // If the root doesn't match, no routes can match either.
	      if (!this.matchRoot()) return false;
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.some(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: !!options};
	
	      // Normalize the fragment.
	      fragment = this.getFragment(fragment || '');
	
	      // Don't include a trailing slash on the root.
	      var rootPath = this.root;
	      if (fragment === '' || fragment.charAt(0) === '?') {
	        rootPath = rootPath.slice(0, -1) || '/';
	      }
	      var url = rootPath + fragment;
	
	      // Strip the fragment of the query and hash for matching.
	      fragment = fragment.replace(pathStripper, '');
	
	      // Decode for matching.
	      var decodedFragment = this.decodeFragment(fragment);
	
	      if (this.fragment === decodedFragment) return;
	      this.fragment = decodedFragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._usePushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
	          var iWindow = this.iframe.contentWindow;
	
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if (!options.replace) {
	            iWindow.document.open();
	            iWindow.document.close();
	          }
	
	          this._updateHash(iWindow.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function and add the prototype properties.
	    child.prototype = _.create(parent.prototype, protoProps);
	    child.prototype.constructor = child;
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function(model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error.call(options.context, model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	//
	// Short version of https://github.com/pwhisenhunt/Backbonejs-Router-Title-Helper
	//
	
	var log = __webpack_require__(525)('title-helper');
	
	function init(options) {
	    var originalRoute = Backbone.Router.prototype.route;
	    var base = options.base || '';
	
	    _.extend(Backbone.Router.prototype, {
	        _setTitle: function _setTitle(route) {
	            var title = this.titles[route];
	            var newTitle;
	
	            if (_.isUndefined(title) && _.isUndefined(this.titles.default)) {
	                log.warn('No title found. No default provided.');
	                title = '';
	            }
	
	            if (_.isString(title)) {
	                newTitle = title;
	            } else {
	                newTitle = this.titles.default;
	            }
	
	            document.title = base + ' ' + newTitle;
	
	            this.trigger('change:title', route, newTitle);
	        },
	
	        route: function route(_route, name, callback) {
	            var wrappedCallback = function wrappedCallback() {
	                if (!callback) {
	                    callback = this[name];
	                }
	
	                if (this.titles) {
	                    this._setTitle(_route);
	                }
	
	                callback.apply(this, arguments);
	            };
	
	            return originalRoute.call(this, _route, name, wrappedCallback);
	        }
	    });
	}
	
	module.exports = init;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var log = __webpack_require__(526);
	var config = __webpack_require__(527);
	var _methodFactory = log.methodFactory;
	
	// TODO consider a lib to solve platform inconsistencies the with stack trace
	// format, like https://www.stacktracejs.com/#!/docs/stacktrace-js but perhaps
	// less retarded (why does their API return promises, why would fetching an
	// mother effing stacktrace require an async API?)
	function fetchCaller() {
	    var webkitRe = /at [^(]+\((.+)\)/;
	    var firefoxRe = /[^@]*@(.+)/;
	    var stack;
	    var matches;
	
	    try {
	        throw new Error();
	    } catch (er) {
	        stack = er.stack;
	    }
	
	    if (typeof stack !== 'string') {
	        return 'unknown caller';
	    }
	
	    matches = (stack.split('\n')[3] || '').match(webkitRe) || (stack.split('\n')[2] || '').match(firefoxRe);
	
	    return matches ? matches[1] : 'unknown caller';
	}
	
	// Append logger name to identify source
	log.methodFactory = function (method, level, logger) {
	    var raw = _methodFactory(method, level, logger);
	
	    return function () {
	        var args = Array.prototype.slice.call(arguments);
	        var caller = fetchCaller();
	
	        args.unshift(caller + ' > ');
	
	        if (logger) {
	            args.unshift(logger + ' > ');
	        }
	
	        raw.apply(raw, args);
	    };
	};
	
	// Set log level from env var
	log.setLevel(config.logLevel || 'trace');
	
	// Export factory
	module.exports = function (logger) {
	    if (typeof logger !== 'string') {
	        return log;
	    }
	
	    return log.getLogger(logger);
	};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* loglevel - https://github.com/pimterry/loglevel
	*
	* Copyright (c) 2013 Tim Perry
	* Licensed under the MIT license.
	*/
	(function (root, definition) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(this, function () {
	    "use strict";
	
	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
	        /Trident\/|MSIE /.test(window.navigator.userAgent)
	    );
	
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	
	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	
	    // Trace() doesn't print the message in IE, so for that case we need to wrap it
	    function traceForIE() {
	        if (console.log) {
	            if (console.log.apply) {
	                console.log.apply(console, arguments);
	            } else {
	                // In old IE, native console methods themselves don't have apply().
	                Function.prototype.apply.apply(console.log, [console, arguments]);
	            }
	        }
	        if (console.trace) console.trace();
	    }
	
	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	
	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (methodName === 'trace' && isIE) {
	            return traceForIE;
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	
	    // These private functions always need `this` to be set properly
	
	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	
	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }
	
	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	
	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
	
	      var storageKey = "loglevel";
	      if (typeof name === "string") {
	        storageKey += ":" + name;
	      } else if (typeof name === "symbol") {
	        storageKey = undefined;
	      }
	
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	
	          if (typeof window === undefinedType || !storageKey) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	
	      function getPersistedLevel() {
	          var storedLevel;
	
	          if (typeof window === undefinedType || !storageKey) return;
	
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	
	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	
	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	
	          return storedLevel;
	      }
	
	      function clearPersistedLevel() {
	          if (typeof window === undefinedType || !storageKey) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage.removeItem(storageKey);
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	          } catch (ignore) {}
	      }
	
	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */
	
	      self.name = name;
	
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	
	      self.methodFactory = factory || defaultMethodFactory;
	
	      self.getLevel = function () {
	          return currentLevel;
	      };
	
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	
	      self.setDefaultLevel = function (level) {
	          defaultLevel = level;
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	
	      self.resetLevel = function () {
	          self.setLevel(defaultLevel, false);
	          clearPersistedLevel();
	      };
	
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	
	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	
	    /*
	     *
	     * Top-level API
	     *
	     */
	
	    var defaultLogger = new Logger();
	
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	
	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	
	        return defaultLogger;
	    };
	
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	
	    // ES6 default export, for compatibility
	    defaultLogger['default'] = defaultLogger;
	
	    return defaultLogger;
	}));


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  apiUrl: 'https://production-server.payrollpanda.my/api',
	
	  logLevel: 'warn',
	
	  bigCompanyThreshold: 15,
	
	  defaultMaxEmployeeCount: 100,
	
	  /* The date in which a 'payroll period' starts. If 15 is selected, the
	   * app would consider all payrolls after the 15th to be of that calendar
	   * month. Payrolls before ran before the 15th belong to the previous
	   * calendar month. IE running a payroll on aug 13th means it will be
	   * considered july's payroll, running it on aug 16th means it will be
	   * considered august's payroll.
	   */
	  periodStartDate: 16
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {/* global app */
	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _LogIn = __webpack_require__(531);
	
	var _LogIn2 = _interopRequireDefault(_LogIn);
	
	var _SignUp = __webpack_require__(538);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	var _ForgotPassword = __webpack_require__(617);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _ChoosePassword = __webpack_require__(619);
	
	var _ChoosePassword2 = _interopRequireDefault(_ChoosePassword);
	
	var _Notification = __webpack_require__(621);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _ErrorMobile = __webpack_require__(623);
	
	var _ErrorMobile2 = _interopRequireDefault(_ErrorMobile);
	
	var _Base = __webpack_require__(625);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _i = __webpack_require__(542);
	
	var _i2 = _interopRequireDefault(_i);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _queryString = __webpack_require__(554);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _holidays = __webpack_require__(626);
	
	var _holidays2 = _interopRequireDefault(_holidays);
	
	var _payrollItems = __webpack_require__(628);
	
	var _payrollItems2 = _interopRequireDefault(_payrollItems);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _positions = __webpack_require__(631);
	
	var _positions2 = _interopRequireDefault(_positions);
	
	var _subscription = __webpack_require__(606);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getInviteToken = __webpack_require__(62);
	
	var inflect = (0, _i2.default)();
	var log = (0, _log2.default)('main-router');
	var routers = {
	    'adminManager': __webpack_require__(632),
	    'employer': __webpack_require__(703),
	    'employee': __webpack_require__(1035),
	    'mppAdmin': __webpack_require__(1064),
	    'mppManager': __webpack_require__(1064)
	};
	
	__webpack_require__(1083);
	
	module.exports = _Base2.default.extend({
	    routes: {
	        '': 'index',
	        'login': 'login',
	        'loginWithAccessToken?:query': 'loginWithAccessToken',
	        'logout': 'logout',
	        'signup': 'signup',
	        'signup?:query': 'signup',
	        'signup-page-1': 'signup',
	        'signup-page-1-partner': 'signup',
	        'signup-page-2': 'signup',
	        'signup-page-3': 'signup',
	        'signup-page-4': 'signup',
	        'signup-page-5': 'signup',
	        'signup-page-6': 'signup',
	        'signup-page-1?:query': 'signup',
	        'signup-page-my-1': 'signup',
	        'signup-page-my-1?:query': 'signup',
	        'signup/:token': 'signupWithToken',
	        'signupMPP/:token': 'signupWithToken',
	        'forgotPassword': 'forgotPassword',
	        'choosePassword?:query': 'choosePassword',
	        'invalidLink': 'invalidLink',
	        'passwordResetSuccess?:query': 'passwordResetSuccess',
	        'errorMobile': 'errorMobile'
	    },
	
	    titles: {
	        '': 'Home',
	        'login': 'Login',
	        'loginWithAccessToken?:query': 'Login',
	        'logout': 'Logout',
	        'signup': 'Signup',
	        'signup-page-1': 'Signup',
	        'signup-page-1-partner': 'Signup',
	        'signup-page-2': 'Signup',
	        'signup-page-my-1': 'Signup',
	        'forgotPassword': 'Forgot Password',
	        'choosePassword?:query': 'Choose Password',
	        'invalidLink': 'Invalid Link',
	        'passwordResetSuccess?:query': 'Password Reset Success',
	        'errorMobile': 'Error',
	        'error404': 'Error',
	        'default': ''
	    },
	
	    guestRoutes: ['login', 'logout', 'signup', 'signup-page-1', 'signup-page-1-partner', 'signup-page-2', 'signup-page-3', 'signup-page-4', 'signup-page-5', 'signup-page-6', 'signup-page-my-1', 'forgotPassword', 'choosePassword', 'invalidLink', 'passwordResetSuccess', 'errorMobile', 'error404'],
	
	    userRouterReady: null,
	
	    initialize: function initialize() {
	        var _this = this;
	
	        log.info('Initializing main router');
	
	        _Base2.default.prototype.initialize.apply(this, [{ log: log }]);
	
	        // Save previous fragment
	        Backbone.history = _.extend(Backbone.history, {
	            loadUrl: function loadUrl(fragmentOverride) {
	                log.info('Storing ', this.fragment, 'as previousFragment');
	
	                this.previousFragment = this.fragment;
	                return Backbone.History.prototype.loadUrl.apply(this, [fragmentOverride]);
	            }
	        });
	
	        if (app.user.isLoggedIn()) {
	
	            this.userRouterReady = new _bluebird2.default(function (resolve) {
	                _this.initializeUserRouter().then(function () {
	                    return resolve(true);
	                });
	            });
	
	            return;
	        }
	
	        log.info('No user present. Skipped user routers');
	
	        log.info('Started history object');
	        Backbone.history.start();
	
	        var route = Backbone.history.getFragment().split('?')[0];
	        var isValidRoute = this.guestRoutes.indexOf(route) > -1 || !!route.match(/^signup\/[a-zA-Z0-9]+$/g);
	
	        if (!isValidRoute) {
	            log.info(route, 'requires authentication. Redirecting to login');
	            return this.navigate('login', { trigger: true });
	        }
	    },
	
	    // guaranteed that after this method run employer users can safely
	    // get reference to their company through app.company
	    initializeUserRouter: function initializeUserRouter() {
	        var _this2 = this;
	
	        var params = _queryString2.default.parse(window.location.search);
	        var promise = (0, _bluebird.resolve)(false);
	        var role = inflect.camelize(app.user.get('role'));
	        var Router = void 0;
	
	        role = role[0].toLowerCase() + role.slice(1);
	        if (app.user.get('role') === 'super_admin') {
	            role = 'adminManager';
	        }
	
	        Router = routers[role];
	
	        log.info('Initializing router for', role, 'user');
	        if (app.user.isEmployee()) {
	            log.info('Fetching employee');
	            promise = app.user.fetchEmployee().then(function (employee) {
	                app.employee = employee;
	                return employee.fetchCompany();
	            });
	        } else if (app.user.get('role') === 'employer') {
	            log.info('Fetching company');
	            promise = app.user.fetchCompany();
	        } else if (app.user.isAdmin()) {
	            if (params.company) {
	                log.info('Admin logging into company ' + params.company);
	                Router = routers.employer;
	                promise = new _company2.default({ objectId: params.company }).fetch({ validate: false });
	            } else if (params.employee) {
	                log.info('Admin logging in as employee ' + params.employee);
	                Router = routers.employee;
	                promise = new _employee2.default({ objectId: params.employee }).fetch({ validate: false }).then(function (model) {
	                    app.employee = model;
	                    return app.employee.fetchUser();
	                }).then(function (user) {
	                    app.user = user;
	                    return app.employee.fetchCompany();
	                });
	            }
	        } else if (app.user.get('role') === 'mpp_admin') {
	            if (params.company) {
	                log.info('MPP Admin logging into company ' + params.company);
	                Router = routers.employer;
	                promise = new _company2.default({ objectId: params.company }).fetch({ validate: false });
	            }
	        } else if (app.user.get('role') === 'mpp_manager') {
	            if (params.company) {
	                log.info('MPP Manager logging into company ' + params.company);
	                Router = routers.employer;
	                promise = new _company2.default({ objectId: params.company }).fetch({ validate: false });
	            }
	        }
	
	        return promise.then(function (company) {
	            if (company) {
	                log.info('Fetching payroll items, leave types, locations,                     positions, employees from server');
	
	                app.payrollItems = new _payrollItems2.default(null, { company: company });
	                app.leaveTypes = new _leaveTypes2.default(null, { company: company });
	                app.companyLocations = new _companyLocations2.default(null, { company: company });
	                app.positions = new _positions2.default(null, { company: company });
	
	                var filter = { filter: { limit: 9999 }, pagination: false };
	                return (0, _bluebird.all)([app.payrollItems.fetch(), app.leaveTypes.fetch(), app.companyLocations.fetch(), app.positions.fetch(filter)]).then(function () {
	                    return company;
	                });
	            }
	
	            app.payrollItems = new _payrollItems2.default(null, {});
	
	            if (!app.user.isAdmin()) {
	                return company;
	            }
	
	            log.info('Fetching payroll items from server');
	
	            return app.payrollItems.fetch({ filter: {
	                    where: {
	                        companyId: null,
	                        hiddenAt: null
	                    },
	                    limit: 9999
	                } }).then(function () {
	                return company;
	            });
	        }).then(function (company) {
	            log.info('Fetching holidays & employees');
	            if (app.user.get('role') !== 'employee' && company) {
	                app.holidays = new _holidays2.default(null, {
	                    all: false,
	                    enabled: true,
	                    company: company,
	                    order: '-date'
	                });
	                app.employees = new _employees2.default(null, { company: company });
	                return (0, _bluebird.all)([app.holidays.fetch(), app.employees.fetch({
	                    filter: { limit: 9999 },
	                    pagination: false
	                })]).then(function () {
	                    return company;
	                });
	            }
	
	            if (app.user.isEmployee() && app.employee) {
	                var locationPromise = app.employee.get('companyLocationId') ? app.employee.fetchCompanyLocation() : (0, _bluebird.resolve)(null);
	
	                app.employees = new _employees2.default([app.employee]);
	
	                return locationPromise.then(function (location) {
	                    app.holidays = new _holidays2.default(null, {
	                        all: false,
	                        enabled: true,
	                        company: company,
	                        location: location && location.id,
	                        order: '-date'
	                    });
	                    return app.holidays.fetch().then(function () {
	                        return company;
	                    });
	                });
	            }
	
	            return company;
	        }).then(function (company) {
	            log.info('Fetching subscription from server');
	            /* Condition to load subscription information is tricky, specially
	             * because of the impersonation feature.
	             * Basically we load the subscription if any of this conditions
	             * are met:
	             * 1. You are an admin, or a manager impersonating a company
	             * 2. You are an mpp admin looking at the dashboard
	             * 2. You are an employer not in the orbit of an mpp admin
	             */
	            var role = app.user.get('role');
	            var fetchSubscription = ['mpp_admin', 'mpp_manager', 'admin_manager', 'super_admin'].includes(role) && company && !app.employee || role === 'mpp_admin' && !company || role === 'employer' && company && !company.get('mppAdminId');
	
	            if (fetchSubscription) {
	                app.subscription = new _subscription2.default(null, {
	                    user: new _user2.default({
	                        id: !company ? app.user.id : company.get('mppAdminId') || company.get('userId')
	                    })
	                });
	
	                return app.subscription.fetch().then(function () {
	                    return company;
	                }).catch(function () {
	                    app.subscription = null;
	                    return _alerts2.default.show('error', {
	                        text: 'An error ocurred trying to fetch your  ' + 'subscription information. You will not be ' + 'able to run payrolls until the issue is ' + 'resolved. Please try to log back in, and ' + 'contact support if the problem persists.'
	                    }).then(function () {
	                        return company;
	                    });
	                });
	            }
	
	            return company;
	        }).then(function (company) {
	            log.info('Fetched company from server');
	            app.company = company;
	            app.userRouter = new Router();
	
	            log.info('Starting history object');
	            Backbone.history.start();
	        }).then(function () {
	            if (app.user.isEmployer() && app.company && app.company.get('isLocked')) {
	                return _alerts2.default.show('error', {
	                    text: 'Your account has been locked. To unlock your                     account please email to us at admin@payrollpanda.my.',
	                    confirmButtonText: 'OK'
	                }).then(function () {
	                    app.userRouter.navigate('logout', { trigger: true });
	                });
	            }
	            if (app.user.isRequirePasswordChange()) {
	                return _alerts2.default.show('warning', {
	                    text: 'We have changed our password policy to optimise                     security of PayrollPanda accounts. As a result, you are                     required to change your password before you can continue.                    Apologies for the inconvenience \u2026. it should only take a                    minute!',
	                    confirmButtonText: 'OK'
	                }).then(function () {
	                    app.userRouter.navigate('personalSettings', { trigger: true });
	                });
	            }
	        }).catch(function (err) {
	            log.error('Couldn\'t fetch company:', err);
	
	            _modal2.default.error({
	                text: 'An error ocurred trying to fetch your company ' + 'details. Please log back in, if the problem persist ' + 'contact support.',
	                callback: _this2.logout.bind(_this2)
	            });
	        });
	    },
	
	    index: function index() {
	        var params = _queryString2.default.parse(window.location.search);
	
	        if (!app.user.isLoggedIn()) {
	            return this.navigate('login', { trigger: true });
	        }
	
	        if (!this.userRouterReady) {
	            return;
	        }
	
	        this.userRouterReady.then(function () {
	            if (app.user.isRequirePasswordChange()) {
	                return;
	            }
	            var managerRoles = ['admin_manager', 'mpp_admin', 'mpp_manager', 'super_admin'];
	            var showCompanyList = managerRoles.includes(app.user.get('role')) && !params.company;
	
	            if (showCompanyList) {
	                app.userRouter.navigate('companies', { trigger: true });
	            } else {
	                app.userRouter.navigate('dashboard', { trigger: true });
	            }
	        });
	    },
	
	    login: function login() {
	        document.title = 'Login HR and Payroll Software | PayrollPanda';
	        document.getElementsByName('description')[0].content = 'Login to PayrollPanda to manage your companies Payroll and ' + 'Leave. No account yet? Sign up for free and get access to the ' + 'simplest way to manage your payroll.';
	        if (app.user.isLoggedIn()) {
	            return this.navigate('', { trigger: true });
	        }
	
	        this.view = new _LogIn2.default({ model: app.user });
	    },
	
	    loginWithAccessToken: function loginWithAccessToken(query) {
	        if (app.user.isLoggedIn()) {
	            return this.navigate('', { trigger: true });
	        }
	        try {
	            var token = JSON.parse(_queryString2.default.parse(query).token);
	            app.user.setAccessToken(token);
	            app.user.set('id', token.userId);
	            app.user.fetch().then(function () {
	                app.reload();
	            }, function (err) {
	                _modal2.default.error({
	                    text: err
	                });
	            });
	        } catch (e) {
	            _modal2.default.error({
	                text: e
	            });
	        }
	    },
	
	    signup: function signup(query) {
	        if (app.user.isLoggedIn()) {
	            return this.navigate('', { trigger: true });
	        }
	
	        var params = _queryString2.default.parse(window.location.search);
	        this.view = new _SignUp2.default({
	            query: Object.assign(params, _queryString2.default.parse(query)),
	            model: app.user
	        });
	    },
	
	    signupWithToken: function signupWithToken(token) {
	        var _this3 = this;
	
	        if (app.user.isLoggedIn()) {
	            return this.navigate('', { trigger: true });
	        }
	
	        getInviteToken(token).then(function (r) {
	            _this3.view = new _SignUp2.default({
	                record: r,
	                model: app.user
	            });
	        }).catch(function (err) {
	            return _modal2.default.error({
	                title: '',
	                text: err
	            });
	        });
	    },
	
	    forgotPassword: function forgotPassword() {
	        if (app.user.isLoggedIn()) {
	            return this.navigate('', { trigger: true });
	        }
	
	        this.view = new _ForgotPassword2.default();
	    },
	
	    choosePassword: function choosePassword(query) {
	        if (app.user.isLoggedIn()) {
	            return this.navigate('', { trigger: true });
	        }
	
	        this.view = new _ChoosePassword2.default({ query: query });
	    },
	
	    invalidLink: function invalidLink() {
	        this.view = new _Notification2.default({ text: 'Invalid Link' });
	    },
	
	    passwordResetSuccess: function passwordResetSuccess() {
	        this.view = new _Notification2.default({
	            text: 'Successfully updated your password',
	            loginLink: true
	        });
	    },
	
	    logout: function logout() {
	        var params = _queryString2.default.parse(window.location.search);
	
	        if (!app.user.isLoggedIn()) {
	            log.info('Trying to logout non existent user. Doing nothing.');
	            return;
	        }
	
	        if (params.company || params.employee) {
	            log.info('Returning to admin dashboard');
	            window.location.href = '/';
	            return;
	        }
	
	        log.info('Performing regular logout.');
	        app.user.logout().then(function () {
	            log.info('Logged out. Redirecting...');
	            window.location.href = '/';
	        });
	    },
	
	    errorMobile: function errorMobile() {
	        this.view = new _ErrorMobile2.default();
	    },
	
	    notFound: function notFound() {
	        window.location.replace('/#dashboard');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(523)))

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var log = __webpack_require__(525)('alerts');
	var swal = __webpack_require__(530);
	var noop = function noop() {};
	
	var btnSuccessColor = '#41c43a';
	var btnErrorColor = '#ed6060';
	
	function parseErrorMessage(err) {
	    if (err.message && _typeof(err.message) === 'object' && err.message.message) {
	        return err.message.message;
	    }
	
	    if (err.response && err.response.error) {
	        return err.response.error.message || JSON.stringify(err.response.error);
	    }
	
	    if (err.response && err.response.data.error) {
	        return err.response.data.error.message || JSON.stringify(err.response.data.error);
	    }
	
	    if (typeof err.message === 'string') {
	        return err.message;
	    }
	
	    return 'An unknown error occurred';
	}
	
	module.exports = {
	    btnSuccessColor: btnSuccessColor,
	    btnErrorColor: btnErrorColor,
	    show: function show(type, options) {
	        var r = void 0;
	
	        if (typeof this[type] !== 'function') {
	            log.error('Don\'t know how to show ' + type);
	            return;
	        }
	
	        options = this[type](options);
	
	        if (_typeof(options.text) === 'object' && options.type === 'error') {
	            options.text = parseErrorMessage(options.text);
	        } else if (typeof options.text !== 'string' && options.text) {
	            options.text = JSON.stringify(options.text);
	        }
	
	        if (options.loader === true) {
	            options = _.extend(options, { showLoaderOnConfirm: true });
	        }
	
	        r = swal(_.omit(options, ['callback', 'loader']));
	
	        var originalCallback = options.callback;
	        options.callback = function () {
	            if (typeof originalCallback === 'function') {
	                return originalCallback.apply(this, arguments);
	            }
	        };
	
	        var showCustomerSupportDialog = function showCustomerSupportDialog() {};
	
	        return r.then(function () {
	            showCustomerSupportDialog();
	            options.callback(true);
	        }, function (dismiss) {
	            options.callback(false, dismiss === 'cancel');
	            return (0, _bluebird.reject)(dismiss);
	        });
	    },
	
	    close: function close(options) {
	        return swal.close(options);
	    },
	
	    info: function info(options) {
	        return _.defaults(options || {}, {
	            type: 'info',
	            customClass: 'sweet-alert-success',
	            confirmButtonColor: btnSuccessColor,
	            confirmButtonText: 'OK',
	            closeOnConfirm: true,
	            callback: noop,
	            reverseButtons: true
	        });
	    },
	
	    success: function success(options) {
	        return _.defaults(options || {}, {
	            title: 'Success!',
	            text: '',
	            type: 'success',
	            customClass: 'sweet-alert-success',
	            confirmButtonColor: btnSuccessColor,
	            confirmButtonText: 'OK',
	            closeOnConfirm: true,
	            callback: noop,
	            reverseButtons: true
	        });
	    },
	
	    warning: function warning(options) {
	        return _.defaults(options || {}, {
	            title: 'Warning',
	            text: '',
	            type: 'warning',
	            customClass: 'sweet-alert-success',
	            confirmButtonColor: btnSuccessColor,
	            allowEscapeKey: true,
	            confirmButtonText: 'OK',
	            closeOnConfirm: true,
	            callback: noop,
	            reverseButtons: true
	        });
	    },
	
	    error: function error(options) {
	        return _.defaults(options || {}, {
	            title: 'Error',
	            text: 'An unknown error ocurred',
	            type: 'error',
	            customClass: 'sweet-alert-error',
	            confirmButtonColor: btnErrorColor,
	            allowEscapeKey: false,
	            confirmButtonText: 'OK',
	            callback: noop,
	            reverseButtons: true
	        });
	    },
	
	    confirm: function confirm(options) {
	        return _.defaults(options || {}, {
	            title: 'Are you sure?',
	            text: '',
	            type: 'warning',
	            customClass: 'sweet-alert-error',
	            confirmButtonColor: btnSuccessColor,
	            confirmButtonText: 'Yes, I\'m sure',
	            showCancelButton: true,
	            allowEscapeKey: false,
	            cancelButtonText: 'No',
	            callback: noop,
	            reverseButtons: true
	        });
	    },
	
	    criticalError: function criticalError(err) {
	        return this.error({
	            text: err,
	            confirmButtonText: 'Reload',
	            callback: window.location.reload.bind(window.location)
	        });
	    },
	
	    dangerConfirm: function dangerConfirm(options) {
	        return this.confirm(options);
	    },
	
	    infoConfirm: function infoConfirm(options) {
	        return this.confirm(_.extend(options, {
	            type: 'info',
	            customClass: 'sweet-alert-success'
	        }));
	    },
	
	    warningConfirm: function warningConfirm(options) {
	        return this.confirm(_.extend(options, {
	            customClass: 'sweet-alert-success'
	        }));
	    },
	
	    successConfirm: function successConfirm(options) {
	        return this.confirm(_.extend(options, {
	            type: 'success',
	            customClass: 'sweet-alert-success'
	        }));
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * sweetalert2 v5.3.8
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Sweetalert2 = factory());
	}(this, function () { 'use strict';
	
	  var swalPrefix = 'swal2-'
	
	  var prefix = function (items) {
	    var result = {}
	    for (var i in items) {
	      result[items[i]] = swalPrefix + items[i]
	    }
	    return result
	  }
	
	  var swalClasses = prefix([
	    'container',
	    'in',
	    'iosfix',
	    'modal',
	    'overlay',
	    'fade',
	    'show',
	    'hide',
	    'noanimation',
	    'close',
	    'content',
	    'spacer',
	    'confirm',
	    'cancel',
	    'icon',
	    'image',
	    'input',
	    'file',
	    'range',
	    'select',
	    'radio',
	    'checkbox',
	    'textarea',
	    'inputerror',
	    'validationerror',
	    'progresssteps',
	    'activeprogressstep',
	    'progresscircle',
	    'progressline',
	    'loading',
	    'styled'
	  ])
	
	  var iconTypes = prefix([
	    'success',
	    'warning',
	    'info',
	    'question',
	    'error'
	  ])
	
	  var defaultParams = {
	    title: '',
	    text: '',
	    html: '',
	    type: null,
	    customClass: '',
	    animation: true,
	    allowOutsideClick: true,
	    allowEscapeKey: true,
	    showConfirmButton: true,
	    showCancelButton: false,
	    preConfirm: null,
	    confirmButtonText: 'OK',
	    confirmButtonColor: '#3085d6',
	    confirmButtonClass: null,
	    cancelButtonText: 'Cancel',
	    cancelButtonColor: '#aaa',
	    cancelButtonClass: null,
	    buttonsStyling: true,
	    reverseButtons: false,
	    focusCancel: false,
	    showCloseButton: false,
	    showLoaderOnConfirm: false,
	    imageUrl: null,
	    imageWidth: null,
	    imageHeight: null,
	    imageClass: null,
	    timer: null,
	    width: 500,
	    padding: 20,
	    background: '#fff',
	    input: null,
	    inputPlaceholder: '',
	    inputValue: '',
	    inputOptions: {},
	    inputAutoTrim: true,
	    inputClass: null,
	    inputAttributes: {},
	    inputValidator: null,
	    progressSteps: [],
	    currentProgressStep: null,
	    progressStepsDistance: '40px',
	    onOpen: null,
	    onClose: null
	  }
	
	  var sweetHTML = '<div class="' + swalClasses.modal + '" style="display: none" tabIndex="-1">' +
	      '<ul class="' + swalClasses.progresssteps + '"></ul>' +
	      '<div class="' + swalClasses.icon + ' ' + iconTypes.error + '">' +
	        '<span class="x-mark"><span class="line left"></span><span class="line right"></span></span>' +
	      '</div>' +
	      '<div class="' + swalClasses.icon + ' ' + iconTypes.question + '">?</div>' +
	      '<div class="' + swalClasses.icon + ' ' + iconTypes.warning + '">!</div>' +
	      '<div class="' + swalClasses.icon + ' ' + iconTypes.info + '">i</div>' +
	      '<div class="' + swalClasses.icon + ' ' + iconTypes.success + '">' +
	        '<span class="line tip"></span> <span class="line long"></span>' +
	        '<div class="placeholder"></div> <div class="fix"></div>' +
	      '</div>' +
	      '<img class="' + swalClasses.image + '">' +
	      '<h2></h2>' +
	      '<div class="' + swalClasses.content + '"></div>' +
	      '<input class="' + swalClasses.input + '">' +
	      '<input type="file" class="' + swalClasses.file + '">' +
	      '<div class="' + swalClasses.range + '">' +
	        '<output></output>' +
	        '<input type="range">' +
	      '</div>' +
	      '<select class="' + swalClasses.select + '"></select>' +
	      '<div class="' + swalClasses.radio + '"></div>' +
	      '<label for="' + swalClasses.checkbox + '" class="' + swalClasses.checkbox + '">' +
	        '<input type="checkbox">' +
	      '</label>' +
	      '<textarea class="' + swalClasses.textarea + '"></textarea>' +
	      '<div class="' + swalClasses.validationerror + '"></div>' +
	      '<hr class="' + swalClasses.spacer + '">' +
	      '<button type="button" class="' + swalClasses.confirm + '">OK</button>' +
	      '<button type="button" class="' + swalClasses.cancel + '">Cancel</button>' +
	      '<span class="' + swalClasses.close + '">&times;</span>' +
	    '</div>'
	
	  var sweetContainer
	
	  var existingSweetContainers = document.getElementsByClassName(swalClasses.container)
	
	  if (existingSweetContainers.length) {
	    sweetContainer = existingSweetContainers[0]
	  } else {
	    sweetContainer = document.createElement('div')
	    sweetContainer.className = swalClasses.container
	    sweetContainer.innerHTML = sweetHTML
	  }
	
	  var extend = function (a, b) {
	    for (var key in b) {
	      if (b.hasOwnProperty(key)) {
	        a[key] = b[key]
	      }
	    }
	
	    return a
	  }
	
	  /*
	   * Set hover, active and focus-states for buttons (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	   */
	  var colorLuminance = function (hex, lum) {
	    // Validate hex string
	    hex = String(hex).replace(/[^0-9a-f]/gi, '')
	    if (hex.length < 6) {
	      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
	    }
	    lum = lum || 0
	
	    // Convert to decimal and change luminosity
	    var rgb = '#'
	    for (var i = 0; i < 3; i++) {
	      var c = parseInt(hex.substr(i * 2, 2), 16)
	      c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16)
	      rgb += ('00' + c).substr(c.length)
	    }
	
	    return rgb
	  }
	
	  // Remember state in cases where opening and handling a modal will fiddle with it.
	  var states = {
	    previousWindowKeyDown: null,
	    previousActiveElement: null,
	    previousBodyPadding: null
	  }
	
	  /*
	   * Add modal + overlay to DOM
	   */
	  var init = function () {
	    if (typeof document === 'undefined') {
	      console.error('SweetAlert2 requires document to initialize')
	      return
	    } else if (document.getElementsByClassName(swalClasses.container).length) {
	      return
	    }
	
	    document.body.appendChild(sweetContainer)
	
	    var modal = getModal()
	    var input = getChildByClass(modal, swalClasses.input)
	    var file = getChildByClass(modal, swalClasses.file)
	    var range = modal.querySelector('.' + swalClasses.range + ' input')
	    var select = getChildByClass(modal, swalClasses.select)
	    var checkbox = modal.querySelector('.' + swalClasses.checkbox + ' input')
	    var textarea = getChildByClass(modal, swalClasses.textarea)
	
	    input.oninput = function () {
	      sweetAlert.resetValidationError()
	    }
	
	    input.onkeydown = function (event) {
	      setTimeout(function () {
	        if (event.keyCode === 13) {
	          event.stopPropagation()
	          sweetAlert.clickConfirm()
	        }
	      }, 0)
	    }
	
	    file.onchange = function () {
	      sweetAlert.resetValidationError()
	    }
	
	    range.oninput = function () {
	      sweetAlert.resetValidationError()
	      range.previousSibling.value = range.value
	    }
	
	    range.onchange = function () {
	      sweetAlert.resetValidationError()
	      range.previousSibling.value = range.value
	    }
	
	    select.onchange = function () {
	      sweetAlert.resetValidationError()
	    }
	
	    checkbox.onchange = function () {
	      sweetAlert.resetValidationError()
	    }
	
	    textarea.oninput = function () {
	      sweetAlert.resetValidationError()
	    }
	
	    return modal
	  }
	
	  /*
	   * Manipulate DOM
	   */
	  var elementByClass = function (className) {
	    return sweetContainer.querySelector('.' + className)
	  }
	
	  var getModal = function () {
	    return document.body.querySelector('.' + swalClasses.modal) || init()
	  }
	
	  var getIcons = function () {
	    var modal = getModal()
	    return modal.querySelectorAll('.' + swalClasses.icon)
	  }
	
	  var getSpacer = function () {
	    return elementByClass(swalClasses.spacer)
	  }
	
	  var getProgressSteps = function () {
	    return elementByClass(swalClasses.progresssteps)
	  }
	
	  var getValidationError = function () {
	    return elementByClass(swalClasses.validationerror)
	  }
	
	  var getConfirmButton = function () {
	    return elementByClass(swalClasses.confirm)
	  }
	
	  var getCancelButton = function () {
	    return elementByClass(swalClasses.cancel)
	  }
	
	  var getCloseButton = function () {
	    return elementByClass(swalClasses.close)
	  }
	
	  var getFocusableElements = function (focusCancel) {
	    var buttons = [getConfirmButton(), getCancelButton()]
	    if (focusCancel) {
	      buttons.reverse()
	    }
	    return buttons.concat(Array.prototype.slice.call(
	      getModal().querySelectorAll('button:not([class^=' + swalPrefix + ']), input:not([type=hidden]), textarea, select')
	    ))
	  }
	
	  var hasClass = function (elem, className) {
	    return elem.classList.contains(className)
	  }
	
	  var focusInput = function (input) {
	    input.focus()
	
	    // place cursor at end of text in text input
	    if (input.type !== 'file') {
	      // http://stackoverflow.com/a/2345915/1331425
	      var val = input.value
	      input.value = ''
	      input.value = val
	    }
	  }
	
	  var addClass = function (elem, className) {
	    if (!elem || !className) {
	      return
	    }
	    var classes = className.split(/\s+/)
	    classes.forEach(function (className) {
	      elem.classList.add(className)
	    })
	  }
	
	  var removeClass = function (elem, className) {
	    if (!elem || !className) {
	      return
	    }
	    var classes = className.split(/\s+/)
	    classes.forEach(function (className) {
	      elem.classList.remove(className)
	    })
	  }
	
	  var getChildByClass = function (elem, className) {
	    for (var i = 0; i < elem.childNodes.length; i++) {
	      if (hasClass(elem.childNodes[i], className)) {
	        return elem.childNodes[i]
	      }
	    }
	  }
	
	  var show = function (elem, display) {
	    if (!display) {
	      display = 'block'
	    }
	    elem.style.opacity = ''
	    elem.style.display = display
	  }
	
	  var hide = function (elem) {
	    elem.style.opacity = ''
	    elem.style.display = 'none'
	  }
	
	  var empty = function (elem) {
	    while (elem.firstChild) {
	      elem.removeChild(elem.firstChild)
	    }
	  }
	
	  // borrowed from jqeury $(elem).is(':visible') implementation
	  var isVisible = function (elem) {
	    return elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length
	  }
	
	  var removeStyleProperty = function (elem, property) {
	    if (elem.style.removeProperty) {
	      elem.style.removeProperty(property)
	    } else {
	      elem.style.removeAttribute(property)
	    }
	  }
	
	  var fireClick = function (node) {
	    // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
	    // Then fixed for today's Chrome browser.
	    if (typeof MouseEvent === 'function') {
	      // Up-to-date approach
	      var mevt = new MouseEvent('click', {
	        view: window,
	        bubbles: false,
	        cancelable: true
	      })
	      node.dispatchEvent(mevt)
	    } else if (document.createEvent) {
	      // Fallback
	      var evt = document.createEvent('MouseEvents')
	      evt.initEvent('click', false, false)
	      node.dispatchEvent(evt)
	    } else if (document.createEventObject) {
	      node.fireEvent('onclick')
	    } else if (typeof node.onclick === 'function') {
	      node.onclick()
	    }
	  }
	
	  var stopEventPropagation = function (e) {
	    // In particular, make sure the space bar doesn't scroll the main window.
	    if (typeof e.stopPropagation === 'function') {
	      e.stopPropagation()
	      e.preventDefault()
	    } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
	      window.event.cancelBubble = true
	    }
	  }
	
	  var animationEndEvent = (function () {
	    var testEl = document.createElement('div')
	    var transEndEventNames = {
	      'WebkitAnimation': 'webkitAnimationEnd',
	      'OAnimation': 'oAnimationEnd oanimationend',
	      'msAnimation': 'MSAnimationEnd',
	      'animation': 'animationend'
	    }
	    for (var i in transEndEventNames) {
	      if (transEndEventNames.hasOwnProperty(i) &&
	        testEl.style[i] !== undefined) {
	        return transEndEventNames[i]
	      }
	    }
	
	    return false
	  })()
	
	  // Reset the page to its previous state
	  var resetPrevState = function () {
	    var modal = getModal()
	    window.onkeydown = states.previousWindowKeyDown
	    if (states.previousActiveElement && states.previousActiveElement.focus) {
	      states.previousActiveElement.focus()
	    }
	    clearTimeout(modal.timeout)
	  }
	
	  // Measure width of scrollbar
	  // https://github.com/twbs/bootstrap/blob/master/js/modal.js#L279-L286
	  var measureScrollbar = function () {
	    var scrollDiv = document.createElement('div')
	    scrollDiv.style.width = '50px'
	    scrollDiv.style.height = '50px'
	    scrollDiv.style.overflow = 'scroll'
	    document.body.appendChild(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    document.body.removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	  // JavaScript Debounce Function
	  // https://davidwalsh.name/javascript-debounce-function
	  var debounce = function (func, wait, immediate) {
	    var timeout
	    return function () {
	      var context = this
	      var args = arguments
	      var later = function () {
	        timeout = null
	        if (!immediate) func.apply(context, args)
	      }
	      var callNow = immediate && !timeout
	      clearTimeout(timeout)
	      timeout = setTimeout(later, wait)
	      if (callNow) func.apply(context, args)
	    }
	  }
	
	  var modalParams = extend({}, defaultParams)
	  var queue = []
	  var swal2Observer
	
	  /*
	   * Set type, text and actions on modal
	   */
	  var setParameters = function (params) {
	    var modal = getModal()
	
	    for (var param in params) {
	      if (!defaultParams.hasOwnProperty(param) && param !== 'extraParams') {
	        console.warn('SweetAlert2: Unknown parameter "' + param + '"')
	      }
	    }
	
	    // set modal width and margin-left
	    modal.style.width = (typeof params.width === 'number') ? params.width + 'px' : params.width
	
	    modal.style.padding = params.padding + 'px'
	    modal.style.background = params.background
	
	    var $title = modal.querySelector('h2')
	    var $content = modal.querySelector('.' + swalClasses.content)
	    var $confirmBtn = getConfirmButton()
	    var $cancelBtn = getCancelButton()
	    var $closeButton = modal.querySelector('.' + swalClasses.close)
	
	    // Title
	    $title.innerHTML = params.title.split('\n').join('<br>')
	
	    // Content
	    var i
	    if (params.text || params.html) {
	      if (typeof params.html === 'object') {
	        $content.innerHTML = ''
	        if (0 in params.html) {
	          for (i = 0; i in params.html; i++) {
	            $content.appendChild(params.html[i].cloneNode(true))
	          }
	        } else {
	          $content.appendChild(params.html.cloneNode(true))
	        }
	      } else {
	        $content.innerHTML = params.html || (params.text.split('\n').join('<br>'))
	      }
	      show($content)
	    } else {
	      hide($content)
	    }
	
	    // Close button
	    if (params.showCloseButton) {
	      show($closeButton)
	    } else {
	      hide($closeButton)
	    }
	
	    // Custom Class
	    modal.className = swalClasses.modal
	    if (params.customClass) {
	      addClass(modal, params.customClass)
	    }
	
	    // Progress steps
	    var progressStepsContainer = getProgressSteps()
	    var currentProgressStep = parseInt(params.currentProgressStep === null ? sweetAlert.getQueueStep() : params.currentProgressStep, 10)
	    if (params.progressSteps.length) {
	      show(progressStepsContainer)
	      empty(progressStepsContainer)
	      if (currentProgressStep >= params.progressSteps.length) {
	        console.warn(
	          'SweetAlert2: Invalid currentProgressStep parameter, it should be less than progressSteps.length ' +
	          '(currentProgressStep like JS arrays starts from 0)'
	        )
	      }
	      params.progressSteps.forEach(function (step, index) {
	        var circle = document.createElement('li')
	        addClass(circle, swalClasses.progresscircle)
	        circle.innerHTML = step
	        if (index === currentProgressStep) {
	          addClass(circle, swalClasses.activeprogressstep)
	        }
	        progressStepsContainer.appendChild(circle)
	        if (index !== params.progressSteps.length - 1) {
	          var line = document.createElement('li')
	          addClass(line, swalClasses.progressline)
	          line.style.width = params.progressStepsDistance
	          progressStepsContainer.appendChild(line)
	        }
	      })
	    } else {
	      hide(progressStepsContainer)
	    }
	
	    // Icon
	    var icons = getIcons()
	    for (i = 0; i < icons.length; i++) {
	      hide(icons[i])
	    }
	    if (params.type) {
	      var validType = false
	      for (var iconType in iconTypes) {
	        if (params.type === iconType) {
	          validType = true
	          break
	        }
	      }
	      if (!validType) {
	        console.error('SweetAlert2: Unknown alert type: ' + params.type)
	        return false
	      }
	      var $icon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes[params.type])
	      show($icon)
	
	      // Animate icon
	      switch (params.type) {
	        case 'success':
	          addClass($icon, 'animate')
	          addClass($icon.querySelector('.tip'), 'animate-success-tip')
	          addClass($icon.querySelector('.long'), 'animate-success-long')
	          break
	        case 'error':
	          addClass($icon, 'animate-error-icon')
	          addClass($icon.querySelector('.x-mark'), 'animate-x-mark')
	          break
	        case 'warning':
	          addClass($icon, 'pulse-warning')
	          break
	        default:
	          break
	      }
	    }
	
	    // Custom image
	    var $customImage = modal.querySelector('.' + swalClasses.image)
	    if (params.imageUrl) {
	      $customImage.setAttribute('src', params.imageUrl)
	      show($customImage)
	
	      if (params.imageWidth) {
	        $customImage.setAttribute('width', params.imageWidth)
	      } else {
	        $customImage.removeAttribute('width')
	      }
	
	      if (params.imageHeight) {
	        $customImage.setAttribute('height', params.imageHeight)
	      } else {
	        $customImage.removeAttribute('height')
	      }
	
	      $customImage.className = swalClasses.image
	      if (params.imageClass) {
	        addClass($customImage, params.imageClass)
	      }
	    } else {
	      hide($customImage)
	    }
	
	    // Cancel button
	    if (params.showCancelButton) {
	      $cancelBtn.style.display = 'inline-block'
	    } else {
	      hide($cancelBtn)
	    }
	
	    // Confirm button
	    if (params.showConfirmButton) {
	      removeStyleProperty($confirmBtn, 'display')
	    } else {
	      hide($confirmBtn)
	    }
	
	    // Buttons spacer
	    var spacer = getSpacer()
	    if (!params.showConfirmButton && !params.showCancelButton) {
	      hide(spacer)
	    } else {
	      show(spacer)
	    }
	
	    // Edit text on cancel and confirm buttons
	    $confirmBtn.innerHTML = params.confirmButtonText
	    $cancelBtn.innerHTML = params.cancelButtonText
	
	    // Set buttons to selected background colors
	    if (params.buttonsStyling) {
	      $confirmBtn.style.backgroundColor = params.confirmButtonColor
	      $cancelBtn.style.backgroundColor = params.cancelButtonColor
	    }
	
	    // Add buttons custom classes
	    $confirmBtn.className = swalClasses.confirm
	    addClass($confirmBtn, params.confirmButtonClass)
	    $cancelBtn.className = swalClasses.cancel
	    addClass($cancelBtn, params.cancelButtonClass)
	
	    // Buttons styling
	    if (params.buttonsStyling) {
	      addClass($confirmBtn, swalClasses.styled)
	      addClass($cancelBtn, swalClasses.styled)
	    } else {
	      removeClass($confirmBtn, swalClasses.styled)
	      removeClass($cancelBtn, swalClasses.styled)
	
	      $confirmBtn.style.backgroundColor = $confirmBtn.style.borderLeftColor = $confirmBtn.style.borderRightColor = ''
	      $cancelBtn.style.backgroundColor = $cancelBtn.style.borderLeftColor = $cancelBtn.style.borderRightColor = ''
	    }
	
	    // CSS animation
	    if (params.animation === true) {
	      removeClass(modal, swalClasses.noanimation)
	    } else {
	      addClass(modal, swalClasses.noanimation)
	    }
	  }
	
	  /*
	   * Animations
	   */
	  var openModal = function (animation, onComplete) {
	    var modal = getModal()
	    if (animation) {
	      addClass(modal, swalClasses.show)
	      addClass(sweetContainer, swalClasses.fade)
	      removeClass(modal, swalClasses.hide)
	    } else {
	      removeClass(modal, swalClasses.fade)
	    }
	    show(modal)
	
	    // scrolling is 'hidden' until animation is done, after that 'auto'
	    sweetContainer.style.overflowY = 'hidden'
	    if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
	      modal.addEventListener(animationEndEvent, function swalCloseEventFinished () {
	        modal.removeEventListener(animationEndEvent, swalCloseEventFinished)
	        sweetContainer.style.overflowY = 'auto'
	      })
	    } else {
	      sweetContainer.style.overflowY = 'auto'
	    }
	
	    addClass(sweetContainer, swalClasses.in)
	    addClass(document.body, swalClasses.in)
	    fixScrollbar()
	    iOSfix()
	    states.previousActiveElement = document.activeElement
	    if (onComplete !== null && typeof onComplete === 'function') {
	      onComplete.call(this, modal)
	    }
	  }
	
	  function fixScrollbar () {
	    // for queues, do not do this more than once
	    if (states.previousBodyPadding !== null) {
	      return
	    }
	    // if the body has overflow
	    if (document.body.scrollHeight > window.innerHeight) {
	      // add padding so the content doesn't shift after removal of scrollbar
	      states.previousBodyPadding = document.body.style.paddingRight
	      document.body.style.paddingRight = measureScrollbar() + 'px'
	    }
	  }
	
	  function undoScrollbar () {
	    if (states.previousBodyPadding !== null) {
	      document.body.style.paddingRight = states.previousBodyPadding
	      states.previousBodyPadding = null
	    }
	  }
	
	  // Fix iOS scrolling http://stackoverflow.com/q/39626302/1331425
	  function iOSfix () {
	    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
	    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
	      var offset = document.body.scrollTop
	      document.body.style.top = (offset * -1) + 'px'
	      addClass(document.body, swalClasses.iosfix)
	    }
	  }
	
	  function undoIOSfix () {
	    if (hasClass(document.body, swalClasses.iosfix)) {
	      var offset = parseInt(document.body.style.top, 10)
	      removeClass(document.body, swalClasses.iosfix)
	      document.body.scrollTop = (offset * -1)
	    }
	  }
	
	  function modalDependant () {
	    if (arguments[0] === undefined) {
	      console.error('SweetAlert2 expects at least 1 attribute!')
	      return false
	    }
	
	    var params = extend({}, modalParams)
	
	    switch (typeof arguments[0]) {
	
	      case 'string':
	        params.title = arguments[0]
	        params.text = arguments[1] || ''
	        params.type = arguments[2] || ''
	
	        break
	
	      case 'object':
	        extend(params, arguments[0])
	        params.extraParams = arguments[0].extraParams
	
	        if (params.input === 'email' && params.inputValidator === null) {
	          params.inputValidator = function (email) {
	            return new Promise(function (resolve, reject) {
	              var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
	              if (emailRegex.test(email)) {
	                resolve()
	              } else {
	                reject('Invalid email address')
	              }
	            })
	          }
	        }
	
	        break
	
	      default:
	        console.error('SweetAlert2: Unexpected type of argument! Expected "string" or "object", got ' + typeof arguments[0])
	        return false
	    }
	
	    setParameters(params)
	
	    // Modal interactions
	    var modal = getModal()
	
	    return new Promise(function (resolve, reject) {
	      // Close on timer
	      if (params.timer) {
	        modal.timeout = setTimeout(function () {
	          sweetAlert.closeModal(params.onClose)
	          reject('timer')
	        }, params.timer)
	      }
	
	      // Get input element by specified type or, if type isn't specified, by params.input
	      var getInput = function (inputType) {
	        inputType = inputType || params.input
	        switch (inputType) {
	          case 'select':
	          case 'textarea':
	          case 'file':
	            return getChildByClass(modal, swalClasses[inputType])
	          case 'checkbox':
	            return modal.querySelector('.' + swalClasses.checkbox + ' input')
	          case 'radio':
	            return modal.querySelector('.' + swalClasses.radio + ' input:checked') ||
	              modal.querySelector('.' + swalClasses.radio + ' input:first-child')
	          case 'range':
	            return modal.querySelector('.' + swalClasses.range + ' input')
	          default:
	            return getChildByClass(modal, swalClasses.input)
	        }
	      }
	
	      // Get the value of the modal input
	      var getInputValue = function () {
	        var input = getInput()
	        if (!input) {
	          return null
	        }
	        switch (params.input) {
	          case 'checkbox':
	            return input.checked ? 1 : 0
	          case 'radio':
	            return input.checked ? input.value : null
	          case 'file':
	            return input.files.length ? input.files[0] : null
	          default:
	            return params.inputAutoTrim ? input.value.trim() : input.value
	        }
	      }
	
	      // input autofocus
	      if (params.input) {
	        setTimeout(function () {
	          var input = getInput()
	          if (input) {
	            focusInput(input)
	          }
	        }, 0)
	      }
	
	      var confirm = function (value) {
	        if (params.showLoaderOnConfirm) {
	          sweetAlert.showLoading()
	        }
	
	        if (params.preConfirm) {
	          params.preConfirm(value, params.extraParams).then(
	            function (preConfirmValue) {
	              sweetAlert.closeModal(params.onClose)
	              resolve(preConfirmValue || value)
	            },
	            function (error) {
	              sweetAlert.hideLoading()
	              if (error) {
	                sweetAlert.showValidationError(error)
	              }
	            }
	          )
	        } else {
	          sweetAlert.closeModal(params.onClose)
	          resolve(value)
	        }
	      }
	
	      // Mouse interactions
	      var onButtonEvent = function (event) {
	        var e = event || window.event
	        var target = e.target || e.srcElement
	        var confirmBtn = getConfirmButton()
	        var cancelBtn = getCancelButton()
	        var targetedConfirm = confirmBtn === target || confirmBtn.contains(target)
	        var targetedCancel = cancelBtn === target || cancelBtn.contains(target)
	
	        switch (e.type) {
	          case 'mouseover':
	          case 'mouseup':
	            if (params.buttonsStyling) {
	              if (targetedConfirm) {
	                confirmBtn.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.1)
	              } else if (targetedCancel) {
	                cancelBtn.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.1)
	              }
	            }
	            break
	          case 'mouseout':
	            if (params.buttonsStyling) {
	              if (targetedConfirm) {
	                confirmBtn.style.backgroundColor = params.confirmButtonColor
	              } else if (targetedCancel) {
	                cancelBtn.style.backgroundColor = params.cancelButtonColor
	              }
	            }
	            break
	          case 'mousedown':
	            if (params.buttonsStyling) {
	              if (targetedConfirm) {
	                confirmBtn.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.2)
	              } else if (targetedCancel) {
	                cancelBtn.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.2)
	              }
	            }
	            break
	          case 'click':
	            // Clicked 'confirm'
	            if (targetedConfirm && sweetAlert.isVisible()) {
	              if (params.input) {
	                var inputValue = getInputValue()
	
	                if (params.inputValidator) {
	                  sweetAlert.disableInput()
	                  params.inputValidator(inputValue, params.extraParams).then(
	                    function () {
	                      sweetAlert.enableInput()
	                      confirm(inputValue)
	                    },
	                    function (error) {
	                      sweetAlert.enableInput()
	                      if (error) {
	                        sweetAlert.showValidationError(error)
	                      }
	                    }
	                  )
	                } else {
	                  confirm(inputValue)
	                }
	              } else {
	                confirm(true)
	              }
	
	            // Clicked 'cancel'
	            } else if (targetedCancel && sweetAlert.isVisible()) {
	              sweetAlert.closeModal(params.onClose)
	              reject('cancel')
	            }
	
	            break
	          default:
	        }
	      }
	
	      var $buttons = modal.querySelectorAll('button')
	      var i
	      for (i = 0; i < $buttons.length; i++) {
	        $buttons[i].onclick = onButtonEvent
	        $buttons[i].onmouseover = onButtonEvent
	        $buttons[i].onmouseout = onButtonEvent
	        $buttons[i].onmousedown = onButtonEvent
	      }
	
	      // Closing modal by close button
	      getCloseButton().onclick = function () {
	        sweetAlert.closeModal(params.onClose)
	        reject('close')
	      }
	
	      // Closing modal by overlay click
	      sweetContainer.onclick = function (e) {
	        if (e.target !== sweetContainer) {
	          return
	        }
	        if (params.allowOutsideClick) {
	          sweetAlert.closeModal(params.onClose)
	          reject('overlay')
	        }
	      }
	
	      var $confirmButton = getConfirmButton()
	      var $cancelButton = getCancelButton()
	
	      // Reverse buttons if neede d
	      if (params.reverseButtons) {
	        $confirmButton.parentNode.insertBefore($cancelButton, $confirmButton)
	      } else {
	        $confirmButton.parentNode.insertBefore($confirmButton, $cancelButton)
	      }
	
	      // Focus handling
	      function setFocus (index, increment) {
	        var focusableElements = getFocusableElements(params.focusCancel)
	        // search for visible elements and select the next possible match
	        for (var i = 0; i < focusableElements.length; i++) {
	          index = index + increment
	
	          // rollover to first item
	          if (index === focusableElements.length) {
	            index = 0
	
	          // go to last item
	          } else if (index === -1) {
	            index = focusableElements.length - 1
	          }
	
	          // determine if element is visible
	          var el = focusableElements[index]
	          if (isVisible(el)) {
	            return el.focus()
	          }
	        }
	      }
	
	      function handleKeyDown (event) {
	        var e = event || window.event
	        var keyCode = e.keyCode || e.which
	
	        if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
	          // Don't do work on keys we don't care about.
	          return
	        }
	
	        var $targetElement = e.target || e.srcElement
	
	        var focusableElements = getFocusableElements(params.focusCancel)
	        var btnIndex = -1 // Find the button - note, this is a nodelist, not an array.
	        for (var i = 0; i < focusableElements.length; i++) {
	          if ($targetElement === focusableElements[i]) {
	            btnIndex = i
	            break
	          }
	        }
	
	        // TAB
	        if (keyCode === 9) {
	          if (!e.shiftKey) {
	            // Cycle to the next button
	            setFocus(btnIndex, 1)
	          } else {
	            // Cycle to the prev button
	            setFocus(btnIndex, -1)
	          }
	
	          stopEventPropagation(e)
	        } else {
	          if (keyCode === 13 || keyCode === 32) {
	            if (btnIndex === -1) {
	              // ENTER/SPACE clicked outside of a button.
	              if (params.focusCancel) {
	                fireClick($cancelButton, e)
	              } else {
	                fireClick($confirmButton, e)
	              }
	            }
	          } else if (keyCode === 27 && params.allowEscapeKey === true) {
	            sweetAlert.closeModal(params.onClose)
	            reject('esc')
	          }
	        }
	      }
	
	      states.previousWindowKeyDown = window.onkeydown
	      window.onkeydown = handleKeyDown
	
	      // Loading state
	      if (params.buttonsStyling) {
	        $confirmButton.style.borderLeftColor = params.confirmButtonColor
	        $confirmButton.style.borderRightColor = params.confirmButtonColor
	      }
	
	      /**
	       * Show spinner instead of Confirm button and disable Cancel button
	       */
	      sweetAlert.showLoading = sweetAlert.enableLoading = function () {
	        show(getSpacer())
	        show($confirmButton, 'inline-block')
	        addClass($confirmButton, swalClasses.loading)
	        addClass(modal, swalClasses.loading)
	        $confirmButton.disabled = true
	        $cancelButton.disabled = true
	      }
	
	      /**
	       * Show spinner instead of Confirm button and disable Cancel button
	       */
	      sweetAlert.hideLoading = sweetAlert.disableLoading = function () {
	        if (!params.showConfirmButton) {
	          hide($confirmButton)
	          if (!params.showCancelButton) {
	            hide(getSpacer())
	          }
	        }
	        removeClass($confirmButton, swalClasses.loading)
	        removeClass(modal, swalClasses.loading)
	        $confirmButton.disabled = false
	        $cancelButton.disabled = false
	      }
	
	      sweetAlert.enableButtons = function () {
	        $confirmButton.disabled = false
	        $cancelButton.disabled = false
	      }
	
	      sweetAlert.disableButtons = function () {
	        $confirmButton.disabled = true
	        $cancelButton.disabled = true
	      }
	
	      sweetAlert.enableConfirmButton = function () {
	        $confirmButton.disabled = false
	      }
	
	      sweetAlert.disableConfirmButton = function () {
	        $confirmButton.disabled = true
	      }
	
	      sweetAlert.enableInput = function () {
	        var input = getInput()
	        if (!input) {
	          return false
	        }
	        if (input.type === 'radio') {
	          var radiosContainer = input.parentNode.parentNode
	          var radios = radiosContainer.querySelectorAll('input')
	          for (var i = 0; i < radios.length; i++) {
	            radios[i].disabled = false
	          }
	        } else {
	          input.disabled = false
	        }
	      }
	
	      sweetAlert.disableInput = function () {
	        var input = getInput()
	        if (!input) {
	          return false
	        }
	        if (input && input.type === 'radio') {
	          var radiosContainer = input.parentNode.parentNode
	          var radios = radiosContainer.querySelectorAll('input')
	          for (var i = 0; i < radios.length; i++) {
	            radios[i].disabled = true
	          }
	        } else {
	          input.disabled = true
	        }
	      }
	
	      // Set modal min-height to disable scrolling inside the modal
	      sweetAlert.recalculateHeight = debounce(function () {
	        var modal = getModal()
	        var prevState = modal.style.display
	        modal.style.minHeight = ''
	        show(modal)
	        modal.style.minHeight = (modal.scrollHeight + 1) + 'px'
	        modal.style.display = prevState
	      }, 50)
	
	      // Show block with validation error
	      sweetAlert.showValidationError = function (error) {
	        var validationError = getValidationError()
	        validationError.innerHTML = error
	        show(validationError)
	
	        var input = getInput()
	        focusInput(input)
	        addClass(input, swalClasses.inputerror)
	      }
	
	      // Hide block with validation error
	      sweetAlert.resetValidationError = function () {
	        var validationError = getValidationError()
	        hide(validationError)
	        sweetAlert.recalculateHeight()
	
	        var input = getInput()
	        if (input) {
	          removeClass(input, swalClasses.inputerror)
	        }
	      }
	
	      sweetAlert.getProgressSteps = function () {
	        return params.progressSteps
	      }
	
	      sweetAlert.setProgressSteps = function (progressSteps) {
	        params.progressSteps = progressSteps
	        setParameters(params)
	      }
	
	      sweetAlert.showProgressSteps = function () {
	        show(getProgressSteps())
	      }
	
	      sweetAlert.hideProgressSteps = function () {
	        hide(getProgressSteps())
	      }
	
	      sweetAlert.enableButtons()
	      sweetAlert.hideLoading()
	      sweetAlert.resetValidationError()
	
	      // inputs
	      var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea']
	      var input
	      for (i = 0; i < inputTypes.length; i++) {
	        var inputClass = swalClasses[inputTypes[i]]
	        var inputContainer = getChildByClass(modal, inputClass)
	        input = getInput(inputTypes[i])
	
	        // set attributes
	        if (input) {
	          for (var j in input.attributes) {
	            if (input.attributes.hasOwnProperty(j)) {
	              var attrName = input.attributes[j].name
	              if (attrName !== 'type' && attrName !== 'value') {
	                input.removeAttribute(attrName)
	              }
	            }
	          }
	          for (var attr in params.inputAttributes) {
	            input.setAttribute(attr, params.inputAttributes[attr])
	          }
	        }
	
	        // set class
	        inputContainer.className = inputClass
	        if (params.inputClass) {
	          addClass(inputContainer, params.inputClass)
	        }
	
	        hide(inputContainer)
	      }
	
	      var populateInputOptions
	      switch (params.input) {
	        case 'text':
	        case 'email':
	        case 'password':
	        case 'number':
	        case 'tel':
	          input = getChildByClass(modal, swalClasses.input)
	          input.value = params.inputValue
	          input.placeholder = params.inputPlaceholder
	          input.type = params.input
	          show(input)
	          break
	        case 'file':
	          input = getChildByClass(modal, swalClasses.file)
	          input.placeholder = params.inputPlaceholder
	          input.type = params.input
	          show(input)
	          break
	        case 'range':
	          var range = getChildByClass(modal, swalClasses.range)
	          var rangeInput = range.querySelector('input')
	          var rangeOutput = range.querySelector('output')
	          rangeInput.value = params.inputValue
	          rangeInput.type = params.input
	          rangeOutput.value = params.inputValue
	          show(range)
	          break
	        case 'select':
	          var select = getChildByClass(modal, swalClasses.select)
	          select.innerHTML = ''
	          if (params.inputPlaceholder) {
	            var placeholder = document.createElement('option')
	            placeholder.innerHTML = params.inputPlaceholder
	            placeholder.value = ''
	            placeholder.disabled = true
	            placeholder.selected = true
	            select.appendChild(placeholder)
	          }
	          populateInputOptions = function (inputOptions) {
	            for (var optionValue in inputOptions) {
	              var option = document.createElement('option')
	              option.value = optionValue
	              option.innerHTML = inputOptions[optionValue]
	              if (params.inputValue === optionValue) {
	                option.selected = true
	              }
	              select.appendChild(option)
	            }
	            show(select)
	            select.focus()
	          }
	          break
	        case 'radio':
	          var radio = getChildByClass(modal, swalClasses.radio)
	          radio.innerHTML = ''
	          populateInputOptions = function (inputOptions) {
	            for (var radioValue in inputOptions) {
	              var id = 1
	              var radioInput = document.createElement('input')
	              var radioLabel = document.createElement('label')
	              var radioLabelSpan = document.createElement('span')
	              radioInput.type = 'radio'
	              radioInput.name = swalClasses.radio
	              radioInput.value = radioValue
	              radioInput.id = swalClasses.radio + '-' + (id++)
	              if (params.inputValue === radioValue) {
	                radioInput.checked = true
	              }
	              radioLabelSpan.innerHTML = inputOptions[radioValue]
	              radioLabel.appendChild(radioInput)
	              radioLabel.appendChild(radioLabelSpan)
	              radioLabel.for = radioInput.id
	              radio.appendChild(radioLabel)
	            }
	            show(radio)
	            var radios = radio.querySelectorAll('input')
	            if (radios.length) {
	              radios[0].focus()
	            }
	          }
	          break
	        case 'checkbox':
	          var checkbox = getChildByClass(modal, swalClasses.checkbox)
	          var checkboxInput = getInput('checkbox')
	          checkboxInput.type = 'checkbox'
	          checkboxInput.value = 1
	          checkboxInput.id = swalClasses.checkbox
	          checkboxInput.checked = Boolean(params.inputValue)
	          var label = checkbox.getElementsByTagName('span')
	          if (label.length) {
	            checkbox.removeChild(label[0])
	          }
	          label = document.createElement('span')
	          label.innerHTML = params.inputPlaceholder
	          checkbox.appendChild(label)
	          show(checkbox)
	          break
	        case 'textarea':
	          var textarea = getChildByClass(modal, swalClasses.textarea)
	          textarea.value = params.inputValue
	          textarea.placeholder = params.inputPlaceholder
	          show(textarea)
	          break
	        case null:
	          break
	        default:
	          console.error('SweetAlert2: Unexpected type of input! Expected "text" or "email" or "password", "select", "checkbox", "textarea" or "file", got "' + params.input + '"')
	          break
	      }
	
	      if (params.input === 'select' || params.input === 'radio') {
	        if (params.inputOptions instanceof Promise) {
	          sweetAlert.showLoading()
	          params.inputOptions.then(function (inputOptions) {
	            sweetAlert.hideLoading()
	            populateInputOptions(inputOptions)
	          })
	        } else if (typeof params.inputOptions === 'object') {
	          populateInputOptions(params.inputOptions)
	        } else {
	          console.error('SweetAlert2: Unexpected type of inputOptions! Expected object or Promise, got ' + typeof params.inputOptions)
	        }
	      }
	
	      openModal(params.animation, params.onOpen)
	
	      // Focus the first element (input or button)
	      setFocus(-1, 1)
	
	      // fix scroll
	      sweetContainer.scrollTop = 0
	
	      // Observe changes inside the modal and adjust height
	      if (typeof MutationObserver !== 'undefined' && !swal2Observer) {
	        swal2Observer = new MutationObserver(sweetAlert.recalculateHeight)
	        swal2Observer.observe(modal, {childList: true, characterData: true, subtree: true})
	      }
	    })
	  }
	
	  // SweetAlert function
	  function sweetAlert () {
	    // Copy arguments to the local args variable
	    var args = arguments
	
	    if (sweetAlert.isVisible()) {
	      sweetAlert.close()
	    }
	
	    return modalDependant.apply(this, args)
	  }
	
	  /*
	   * Global function to determine if swal2 modal is visible
	   */
	  sweetAlert.isVisible = function () {
	    var modal = getModal()
	    return isVisible(modal)
	  }
	
	  /*
	   * Global function for chaining sweetAlert modals
	   */
	  sweetAlert.queue = function (steps) {
	    queue = steps
	    var modal = getModal()
	    var resetQueue = function () {
	      queue = []
	      modal.removeAttribute('data-queue-step')
	    }
	    var queueResult = []
	    return new Promise(function (resolve, reject) {
	      (function step (i, callback) {
	        if (i < queue.length) {
	          modal.setAttribute('data-queue-step', i)
	
	          sweetAlert(queue[i]).then(function (result) {
	            queueResult.push(result)
	            step(i + 1, callback)
	          }, function (dismiss) {
	            resetQueue()
	            reject(dismiss)
	          })
	        } else {
	          resetQueue()
	          resolve(queueResult)
	        }
	      })(0)
	    })
	  }
	
	  /*
	   * Global function for getting the index of current modal in queue
	   */
	  sweetAlert.getQueueStep = function () {
	    return getModal().getAttribute('data-queue-step')
	  }
	
	  /*
	   * Global function for inserting a modal to the queue
	   */
	  sweetAlert.insertQueueStep = function (step, index) {
	    if (index && index < queue.length) {
	      return queue.splice(index, 0, step)
	    }
	    return queue.push(step)
	  }
	
	  /*
	   * Global function for deleting a modal from the queue
	   */
	  sweetAlert.deleteQueueStep = function (index) {
	    if (typeof queue[index] !== 'undefined') {
	      queue.splice(index, 1)
	    }
	  }
	
	  /*
	   * Global function to close sweetAlert
	   */
	  sweetAlert.close = sweetAlert.closeModal = function (onComplete) {
	    var modal = getModal()
	    removeClass(modal, swalClasses.show)
	    addClass(modal, swalClasses.hide)
	
	    // Reset icon animations
	    var $successIcon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes.success)
	    removeClass($successIcon, 'animate')
	    removeClass($successIcon.querySelector('.tip'), 'animate-success-tip')
	    removeClass($successIcon.querySelector('.long'), 'animate-success-long')
	
	    var $errorIcon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes.error)
	    removeClass($errorIcon, 'animate-error-icon')
	    removeClass($errorIcon.querySelector('.x-mark'), 'animate-x-mark')
	
	    var $warningIcon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes.warning)
	    removeClass($warningIcon, 'pulse-warning')
	
	    resetPrevState()
	
	    var hideModalAndResetState = function () {
	      hide(modal)
	      modal.style.minHeight = ''
	      removeClass(sweetContainer, swalClasses.in)
	      removeClass(document.body, swalClasses.in)
	      undoScrollbar()
	      undoIOSfix()
	    }
	
	    // If animation is supported, animate
	    if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
	      modal.addEventListener(animationEndEvent, function swalCloseEventFinished () {
	        modal.removeEventListener(animationEndEvent, swalCloseEventFinished)
	        if (hasClass(modal, swalClasses.hide)) {
	          hideModalAndResetState()
	        }
	      })
	    } else {
	      // Otherwise, hide immediately
	      hideModalAndResetState()
	    }
	    if (onComplete !== null && typeof onComplete === 'function') {
	      onComplete.call(this, modal)
	    }
	  }
	
	  /*
	   * Global function to click 'Confirm' button
	   */
	  sweetAlert.clickConfirm = function () {
	    getConfirmButton().click()
	  }
	
	  /*
	   * Global function to click 'Cancel' button
	   */
	  sweetAlert.clickCancel = function () {
	    getCancelButton().click()
	  }
	
	  /**
	   * Set default params for each popup
	   * @param {Object} userParams
	   */
	  sweetAlert.setDefaults = function (userParams) {
	    if (!userParams) {
	      throw new Error('userParams is required')
	    }
	    if (typeof userParams !== 'object') {
	      throw new Error('userParams has to be a object')
	    }
	
	    extend(modalParams, userParams)
	  }
	
	  /**
	   * Reset default params for each popup
	   */
	  sweetAlert.resetDefaults = function () {
	    modalParams = extend({}, defaultParams)
	  }
	
	  sweetAlert.noop = function () { }
	
	  sweetAlert.version = '5.3.8'
	
	  if (typeof Promise === 'function') {
	    Promise.prototype.done = Promise.prototype.done || function () { // eslint-disable-line
	      return this.catch(function () {
	        // Catch promise rejections silently.
	        // https://github.com/limonte/sweetalert2/issues/177
	      })
	    }
	  } else {
	    console.warn('SweetAlert2: Please inlude Promise polyfill BEFORE including sweetalert2.js if IE10+ support needed.')
	  }
	
	  return sweetAlert;
	
	}));
	if (window.Sweetalert2) window.sweetAlert = window.swal = window.Sweetalert2;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = __webpack_require__(533);
	var loader = __webpack_require__(534);
	
	var log = (0, _log2.default)('login-view');
	
	var config = __webpack_require__(527);
	
	
	var SAVED_USERNAME_KEY = 'savedUsername';
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	
	    events: function events() {
	        return {
	            'submit .js-form': 'login',
	            'click .js-sign-in-with-xero-button': 'signInWithXero'
	        };
	    },
	    initialize: function initialize() {
	        this.render();
	        var savedUsername = window.localStorage.getItem(SAVED_USERNAME_KEY);
	        if (savedUsername) {
	            this.$('.js-email').val(savedUsername);
	        }
	        return this;
	    },
	    render: function render() {
	        this.$el.html(template());
	        $('body').addClass('gray-bg');
	        this.$('#totpToken').hide();
	    },
	    login: function login(ev) {
	        var _this = this;
	
	        ev.preventDefault();
	
	        var username = this.$('.js-email').val();
	        var password = this.$('.js-password').val();
	        var totpToken = this.$('input[name="totpToken"]').val();
	        var stopLoader = loader.startFullScreen('.js-login-button');
	        var re = new RegExp('^[a-z0-9\x7F-\uFFFF!#$%&\'*+/=?^_`{|}~-]+(?:.[a-z0-9' + '\x7F-\uFFFF!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-' + 'z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$', 'i');
	
	        if (!re.test(username)) {
	            this.$('.js-error').html('Please enter an email address.').show();
	
	            stopLoader();
	            return false;
	        }
	
	        if (!password) {
	            this.$('.js-error').html('The password cannot be empty.').show();
	
	            stopLoader();
	            return false;
	        }
	
	        var params = {
	            email: username,
	            password: password
	        };
	
	        if (totpToken) {
	            params.totpToken = totpToken;
	        }
	
	        this.model.login(params).then(function () {
	            _this.$('.js-login-button').attr('disabled', 'disabled');
	            window.localStorage.setItem(SAVED_USERNAME_KEY, username);
	            app.reload();
	        }).catch(function (err) {
	            log.error(err);
	            if (err.response && err.response.error && err.response.error.statusCode >= 400 && /totp/.test(err.response.error.message)) {
	                _this.$('#totpToken').show();
	                _this.$('.js-error').html(err.response.error.message).show();
	            } else {
	                _this.$('.js-error').html('Invalid email or password. Please try again.').show();
	                if (err.response && err.response.error && err.response.error.statusCode >= 400 && /account locked out/.test(err.response.error.message)) {
	                    _modal2.default.showError('You have already used 3 attempts to log in. Any                         further attempts will be unsuccessful unless you wait                         for 5 mins before trying again. Alternatively, you can                         reset your password by clicking on "Forgot Password".', false);
	                }
	            }
	        }).finally(function () {
	            return stopLoader();
	        });
	
	        return false;
	    },
	    signInWithXero: function signInWithXero(e) {
	        e.preventDefault();
	        _axios2.default.get(config.apiUrl + '/Integrations/xero/signinUrl').then(function (res) {
	            window.location.href = res.data;
	        });
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var swal = __webpack_require__(530);
	var btnSuccessColor = '#41c43a';
	var btnErrorColor = '#ed6060';
	
	/**
	 * @param message
	 * @param reloadPage For now undefined and truthy values cause page reload
	 */
	function showError(message, reloadPage) {
	    reloadPage = !!reloadPage || reloadPage === undefined;
	    swal({
	        title: 'Error',
	        text: parseErrorMessage(message),
	        type: 'error',
	        customClass: 'sweet-alert-error',
	        confirmButtonColor: btnErrorColor,
	        allowEscapeKey: !reloadPage,
	        confirmButtonText: reloadPage ? 'Reload page' : 'OK',
	        reverseButtons: true
	    }).then(function () {
	        if (reloadPage) {
	            window.location.reload();
	        }
	    });
	}
	
	function noop() {}
	
	function info(options) {
	    var $swal = $('.sweet-alert');
	    $swal.removeClass($swal.data('customClass'));
	
	    options = _.defaults(options || {}, {
	        title: '',
	        text: '',
	        type: 'info',
	        customClass: 'sweet-alert-success',
	        confirmButtonColor: btnSuccessColor,
	        confirmButtonText: 'OK',
	        closeOnConfirm: true,
	        callback: noop,
	        reverseButtons: true
	    });
	
	    if (!_.isString(options.text)) {
	        options.text = JSON.stringify(options.text);
	    }
	
	    /* swal1 compatibility */
	    if (options.html === true) {
	        options.html = options.text;
	    }
	
	    var callback = options.callback || noop;
	    swal(options).then(function () {
	        callback(true);
	    }, function () {
	        callback(false);
	    });
	}
	
	function success(options) {
	    var $swal = $('.sweet-alert');
	    $swal.removeClass($swal.data('customClass'));
	
	    options = _.defaults(options || {}, {
	        title: 'Success!',
	        text: '',
	        type: 'success',
	        customClass: 'sweet-alert-success',
	        confirmButtonColor: btnSuccessColor,
	        confirmButtonText: 'OK',
	        closeOnConfirm: true,
	        callback: noop,
	        reverseButtons: true
	    });
	
	    if (!_.isString(options.text)) {
	        options.text = JSON.stringify(options.text);
	    }
	
	    /* swal1 compatibility */
	    if (options.html === true) {
	        options.html = options.text;
	    }
	
	    var callback = options.callback || noop;
	    swal(options).then(function () {
	        callback(true);
	    }, function () {
	        callback(false);
	    });
	}
	
	function warning(options) {
	    var $swal = $('.sweet-alert');
	    $swal.removeClass($swal.data('customClass'));
	
	    options = _.defaults(options || {}, {
	        title: 'Warning',
	        text: '',
	        type: 'warning',
	        confirmButtonColor: btnSuccessColor,
	        allowEscapeKey: true,
	        confirmButtonText: 'OK',
	        closeOnConfirm: true,
	        callback: noop,
	        reverseButtons: true
	    });
	
	    if (!_.isString(options.text)) {
	        options.text = JSON.stringify(options.text);
	    }
	
	    /* swal1 compatibility */
	    if (options.html === true) {
	        options.html = options.text;
	    }
	
	    var callback = options.callback || noop;
	    swal(options).then(function (result) {
	        if (options.input) {
	            callback(result);
	        } else {
	            callback(true);
	        }
	    }, function () {
	        callback(false);
	    });
	}
	
	function parseErrorMessage(err) {
	    if (typeof err === 'string') {
	        return err;
	    }
	    if (err.message && _typeof(err.message) === 'object' && err.message.message) {
	        return err.message.message;
	    }
	
	    if (err.response && err.response.error) {
	        return err.response.error.message || JSON.stringify(err.response.error);
	    }
	
	    if (typeof err.message === 'string') {
	        return err.message;
	    }
	    return 'An unknown error occurred';
	}
	
	function error(options) {
	    var confirmatioBtn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var $swal = $('.sweet-alert');
	    $swal.removeClass($swal.data('customClass'));
	
	    options = _.defaults(options || {}, {
	        title: 'Error',
	        text: 'An unknown error occurred',
	        type: 'error',
	        customClass: 'sweet-alert-error',
	        showConfirmButton: confirmatioBtn,
	        confirmButtonColor: btnErrorColor,
	        allowEscapeKey: false,
	        confirmButtonText: 'Reload',
	        callback: window.location.reload.bind(window.location),
	        reverseButtons: true
	    });
	
	    if (_typeof(options.text) === 'object') {
	        options.text = parseErrorMessage(options.text);
	    }
	
	    /* swal1 compatibility */
	    if (options.html === true) {
	        options.html = options.text;
	    }
	
	    var callback = options.callback || noop;
	    swal(options).then(function () {
	        callback(true);
	    }, function () {
	        callback(false);
	    });
	}
	
	function confirm(options) {
	    var $swal = $('.sweet-alert');
	    $swal.removeClass($swal.data('customClass'));
	
	    options = _.defaults(options || {}, {
	        title: 'Are you sure?',
	        text: 'Yes, I\'m sure',
	        type: 'warning',
	        confirmButtonColor: btnSuccessColor,
	        showCancelButton: true,
	        allowEscapeKey: false,
	        confirmButtonText: 'Cancel',
	        callback: noop,
	        reverseButtons: true
	    });
	
	    if (!_.isString(options.text)) {
	        options.text = JSON.stringify(options.text);
	    }
	
	    /* swal1 compatibility */
	    if (options.html === true) {
	        options.html = options.text;
	    }
	
	    var callback = options.callback || noop;
	    swal(options).then(function () {
	        callback(true);
	    }, function () {
	        callback(false);
	    });
	}
	
	function closeAll() {
	    return swal.close();
	}
	
	/**
	 * @param text {String}
	 */
	function showAlertSuccess(text) {
	    var $el = $('<div class="global-alert-box">' + '<div class="alert alert-success global-alert">' + text + '</div>' + '</div>').hide();
	    $('body').prepend($el);
	
	    $el.fadeIn(200).delay(2000).fadeOut(300, function () {
	        $(this).remove();
	    });
	}
	
	module.exports = {
	    info: info,
	    success: success,
	    error: error,
	    warning: warning,
	    confirm: confirm,
	    closeAll: closeAll,
	    showError: showError,
	    showAlertSuccess: showAlertSuccess
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(27)))

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/LogIn.html -->\n<div class="login-container">\n    <div class="login-box-container">\n\n        <div class="row">\n            <div class="col-sm-8 col-sm-offset-2">\n\n                <div class="login-box text-center">\n                    <img src="/images/payrollpanda-logo-sm.png" alt="PayrollPanda Logo">\n\n                    <h2 class="font-bold m-t-xl m-b-none">Login</h2>\n\n                    <div class="row m-l-none m-r-none">\n                        <div class="col-sm-8 col-sm-offset-2">\n                            <form class="js-form m-t-md" role="form">\n                                <div class="js-error error" style="display:none; color:red;"></div>\n                                <div class="form-group m-b-md">\n                                    <input type="email" class="js-email form-control" placeholder="Email" required="">\n                                </div>\n                                <div class="form-group text-left">\n                                    <input type="password" class="js-password form-control m-b-sm" placeholder="Password" required="">\n                                    <a href="#forgotPassword" class="text-left forgot-password-link">\n                                        Forgot password?\n                                    </a>\n                                </div>\n                                <div id="totpToken" class="form-group m-b-md">\n                                    <input type="text" class="js-text form-control" name="totpToken" placeholder="TOTP Token">\n                                </div>\n                                <div class="form-group text-center m-t">\n                                    <button type="submit"\n                                            class="js-login-button btn btn-primary btn-large ladda-button"\n                                            data-style="swap">\n                                        Login\n                                    </button>\n                                </div>\n                            </form>\n                            <div class="form-group text-center m-b-xl">\n                                <button type="button"\n                                        class="js-sign-in-with-xero-button btn btn-secondary btn-large ladda-button"\n                                        data-style="swap">\n                                    <img src="/images/logo-xero.svg" height="24" width="24" style="width: auto;" alt="Xero logo" />\n                                    Sign In with Xero\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="login-box-footer">\n                    <a class="btn btn-outline btn-white pull-right" style="margin-top: -8px;"\n                       href="#signup">Sign Up For Free</a>\n                    <span class="hint text-muted pull-right m-r">Have no account?</span>\n                </div>\n\n            </div>\n        </div>\n\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {'use strict';
	
	var spinner = __webpack_require__(535);
	var ladda = __webpack_require__(536);
	
	/**
	 * @param {?(String|jQuery|Element)} button
	 * @return {Function}
	 */
	function startFullScreen(button) {
	    $(button).addClass('ladda-button').attr({ 'data-style': 'swap' });
	    $.blockUI({
	        message: null,
	        overlayCSS: {
	            backgroundColor: '#000',
	            opacity: 0.2,
	            cursor: null,
	            'z-index': 1000000000
	        }
	    });
	
	    var buttonEl = _.isObject($(button)) ? $(button)[0] : false;
	    if (buttonEl) {
	        var l = ladda.create(buttonEl);
	        l.start();
	
	        return function () {
	            $(button).prop('disabled', false);
	            $.unblockUI();
	            l.stop();
	        };
	    }
	    return function () {
	        $(button).prop('disabled', false);
	        $.unblockUI();
	    };
	}
	
	/**
	 * @param {?(String|jQuery|Element)} element
	 * @return {Function}
	 */
	function startFullPage(element) {
	    $.blockUI({
	        message: null,
	        overlayCSS: {
	            backgroundColor: '#000',
	            opacity: 0.2,
	            cursor: null,
	            'z-index': 1000000000
	        }
	    });
	    $(element).html('<div class="loader">' + spinner() + '</div>');
	    return function () {
	        $.unblockUI();
	    };
	}
	
	function stopLoader() {
	    return $.unblockUI();
	}
	
	module.exports = {
	    startFullScreen: startFullScreen,
	    startFullPage: startFullPage,
	    stopLoader: stopLoader
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(27)))

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/Spinner.html -->\n<div class="sk-spinner sk-spinner-circle">\n  <div class="sk-circle1 sk-circle"></div>\n  <div class="sk-circle2 sk-circle"></div>\n  <div class="sk-circle3 sk-circle"></div>\n  <div class="sk-circle4 sk-circle"></div>\n  <div class="sk-circle5 sk-circle"></div>\n  <div class="sk-circle6 sk-circle"></div>\n  <div class="sk-circle7 sk-circle"></div>\n  <div class="sk-circle8 sk-circle"></div>\n  <div class="sk-circle9 sk-circle"></div>\n  <div class="sk-circle10 sk-circle"></div>\n  <div class="sk-circle11 sk-circle"></div>\n  <div class="sk-circle12 sk-circle"></div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Ladda 1.0.6 (2018-02-04, 13:19)
	 * http://lab.hakim.se/ladda
	 * MIT licensed
	 *
	 * Copyright (C) 2017 Hakim El Hattab, http://hakim.se
	 */
	
	!function(t,e){"use strict"; true?module.exports=e(__webpack_require__(537)):"function"==typeof define&&define.amd?define(["spin"],e):t.Ladda=e(t.Spinner)}(this,function(t){"use strict";var e=[];function a(a){if(void 0!==a){if(/ladda-button/i.test(a.className)||(a.className+=" ladda-button"),a.hasAttribute("data-style")||a.setAttribute("data-style","expand-right"),!a.querySelector(".ladda-label")){var u=document.createElement("span");u.className="ladda-label",n=a,i=u,(r=document.createRange()).selectNodeContents(n),r.surroundContents(i),n.appendChild(i)}var n,i,r,d,o,s=a.querySelector(".ladda-spinner");s||((s=document.createElement("span")).className="ladda-spinner"),a.appendChild(s);var F={start:function(){return d||(d=function(e){var a,u,n=e.offsetHeight;0===n&&(n=parseFloat(window.getComputedStyle(e).height));n>32&&(n*=.8);e.hasAttribute("data-spinner-size")&&(n=parseInt(e.getAttribute("data-spinner-size"),10));e.hasAttribute("data-spinner-color")&&(a=e.getAttribute("data-spinner-color"));e.hasAttribute("data-spinner-lines")&&(u=parseInt(e.getAttribute("data-spinner-lines"),10));var i=.2*n;return new t({color:a||"#fff",lines:u||12,radius:i,length:.6*i,width:i<7?2:3,zIndex:"auto",top:"auto",left:"auto",className:""})}(a)),a.disabled=!0,a.setAttribute("data-loading",""),clearTimeout(o),d.spin(s),this.setProgress(0),this},startAfter:function(t){return clearTimeout(o),o=setTimeout(function(){F.start()},t),this},stop:function(){return F.isLoading()&&(a.disabled=!1,a.removeAttribute("data-loading")),clearTimeout(o),d&&(o=setTimeout(function(){d.stop()},1e3)),this},toggle:function(){return this.isLoading()?this.stop():this.start()},setProgress:function(t){t=Math.max(Math.min(t,1),0);var e=a.querySelector(".ladda-progress");0===t&&e&&e.parentNode?e.parentNode.removeChild(e):(e||((e=document.createElement("div")).className="ladda-progress",a.appendChild(e)),e.style.width=(t||0)*a.offsetWidth+"px")},enable:function(){return this.stop()},disable:function(){return this.stop(),a.disabled=!0,this},isLoading:function(){return a.hasAttribute("data-loading")},remove:function(){clearTimeout(o),a.disabled=!1,a.removeAttribute("data-loading"),d&&(d.stop(),d=null),e.splice(e.indexOf(F),1)}};return e.push(F),F}console.warn("Ladda button target must be defined.")}function u(t,e){if("function"==typeof t.addEventListener){var u=a(t),n=-1;t.addEventListener("click",function(){var a,i,r=!0,d=function(t,e){for(;t.parentNode&&t.tagName!==e;)t=t.parentNode;return e===t.tagName?t:void 0}(t,"FORM");if(void 0!==d&&!d.hasAttribute("novalidate"))if("function"==typeof d.checkValidity)r=d.checkValidity();else for(var o=(a=d,i=[],["input","textarea","select"].forEach(function(t){for(var e=a.getElementsByTagName(t),u=0;u<e.length;u++)e[u].hasAttribute("required")&&i.push(e[u])}),i),s=0;s<o.length;s++){var F=o[s],l=F.getAttribute("type");if(""===F.value.replace(/^\s+|\s+$/g,"")&&(r=!1),"checkbox"!==l&&"radio"!==l||F.checked||(r=!1),"email"===l&&(r=/^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i.test(F.value)),"url"===l&&(r=/^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(F.value)),!r)break}r&&(u.startAfter(1),"number"==typeof e.timeout&&(clearTimeout(n),n=setTimeout(u.stop,e.timeout)),"function"==typeof e.callback&&e.callback.apply(null,[u]))},!1)}}return{bind:function(t,e){var a;if("string"==typeof t)a=document.querySelectorAll(t);else{if("object"!=typeof t)throw new Error("target must be string or object");a=[t]}e=e||{};for(var n=0;n<a.length;n++)u(a[n],e)},create:a,stopAll:function(){for(var t=0,a=e.length;t<a;t++)e[t].stop()}}});

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 *
	 * Example:
	    var opts = {
	      lines: 12             // The number of lines to draw
	    , length: 7             // The length of each line
	    , width: 5              // The line thickness
	    , radius: 10            // The radius of the inner circle
	    , scale: 1.0            // Scales overall size of the spinner
	    , corners: 1            // Roundness (0..1)
	    , color: '#000'         // #rgb or #rrggbb
	    , opacity: 1/4          // Opacity of the lines
	    , rotate: 0             // Rotation offset
	    , direction: 1          // 1: clockwise, -1: counterclockwise
	    , speed: 1              // Rounds per second
	    , trail: 100            // Afterglow percentage
	    , fps: 20               // Frames per second when using setTimeout()
	    , zIndex: 2e9           // Use a high z-index by default
	    , className: 'spinner'  // CSS class to assign to the element
	    , top: '50%'            // center vertically
	    , left: '50%'           // center horizontally
	    , shadow: false         // Whether to render a shadow
	    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	    , position: 'absolute'  // Element positioning
	    }
	    var target = document.getElementById('foo')
	    var spinner = new Spinner(opts).spin(target)
	 */
	;(function (root, factory) {
	
	  /* CommonJS */
	  if (typeof module == 'object' && module.exports) module.exports = factory()
	
	  /* AMD module */
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	  /* Browser global */
	  else root.Spinner = factory()
	}(this, function () {
	  "use strict"
	
	  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
	    , animations = {} /* Animation rules keyed by their name */
	    , useCssAnimations /* Whether to use CSS animations or setTimeout */
	    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
	
	  /**
	   * Utility function to create elements. If no tag name is given,
	   * a DIV is created. Optionally properties can be passed.
	   */
	  function createEl (tag, prop) {
	    var el = document.createElement(tag || 'div')
	      , n
	
	    for (n in prop) el[n] = prop[n]
	    return el
	  }
	
	  /**
	   * Appends children and returns the parent.
	   */
	  function ins (parent /* child1, child2, ...*/) {
	    for (var i = 1, n = arguments.length; i < n; i++) {
	      parent.appendChild(arguments[i])
	    }
	
	    return parent
	  }
	
	  /**
	   * Creates an opacity keyframe animation rule and returns its name.
	   * Since most mobile Webkits have timing issues with animation-delay,
	   * we create separate rules for each line/segment.
	   */
	  function addAnimation (alpha, trail, i, lines) {
	    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
	      , start = 0.01 + i/lines * 100
	      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
	      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
	      , pre = prefix && '-' + prefix + '-' || ''
	
	    if (!animations[name]) {
	      sheet.insertRule(
	        '@' + pre + 'keyframes ' + name + '{' +
	        '0%{opacity:' + z + '}' +
	        start + '%{opacity:' + alpha + '}' +
	        (start+0.01) + '%{opacity:1}' +
	        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
	        '100%{opacity:' + z + '}' +
	        '}', sheet.cssRules.length)
	
	      animations[name] = 1
	    }
	
	    return name
	  }
	
	  /**
	   * Tries various vendor prefixes and returns the first supported property.
	   */
	  function vendor (el, prop) {
	    var s = el.style
	      , pp
	      , i
	
	    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
	    if (s[prop] !== undefined) return prop
	    for (i = 0; i < prefixes.length; i++) {
	      pp = prefixes[i]+prop
	      if (s[pp] !== undefined) return pp
	    }
	  }
	
	  /**
	   * Sets multiple style properties at once.
	   */
	  function css (el, prop) {
	    for (var n in prop) {
	      el.style[vendor(el, n) || n] = prop[n]
	    }
	
	    return el
	  }
	
	  /**
	   * Fills in default values.
	   */
	  function merge (obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i]
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n]
	      }
	    }
	    return obj
	  }
	
	  /**
	   * Returns the line color from the given string or array.
	   */
	  function getColor (color, idx) {
	    return typeof color == 'string' ? color : color[idx % color.length]
	  }
	
	  // Built-in defaults
	
	  var defaults = {
	    lines: 12             // The number of lines to draw
	  , length: 7             // The length of each line
	  , width: 5              // The line thickness
	  , radius: 10            // The radius of the inner circle
	  , scale: 1.0            // Scales overall size of the spinner
	  , corners: 1            // Roundness (0..1)
	  , color: '#000'         // #rgb or #rrggbb
	  , opacity: 1/4          // Opacity of the lines
	  , rotate: 0             // Rotation offset
	  , direction: 1          // 1: clockwise, -1: counterclockwise
	  , speed: 1              // Rounds per second
	  , trail: 100            // Afterglow percentage
	  , fps: 20               // Frames per second when using setTimeout()
	  , zIndex: 2e9           // Use a high z-index by default
	  , className: 'spinner'  // CSS class to assign to the element
	  , top: '50%'            // center vertically
	  , left: '50%'           // center horizontally
	  , shadow: false         // Whether to render a shadow
	  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	  , position: 'absolute'  // Element positioning
	  }
	
	  /** The constructor */
	  function Spinner (o) {
	    this.opts = merge(o || {}, Spinner.defaults, defaults)
	  }
	
	  // Global defaults that override the built-ins:
	  Spinner.defaults = {}
	
	  merge(Spinner.prototype, {
	    /**
	     * Adds the spinner to the given target element. If this instance is already
	     * spinning, it is automatically removed from its previous target b calling
	     * stop() internally.
	     */
	    spin: function (target) {
	      this.stop()
	
	      var self = this
	        , o = self.opts
	        , el = self.el = createEl(null, {className: o.className})
	
	      css(el, {
	        position: o.position
	      , width: 0
	      , zIndex: o.zIndex
	      , left: o.left
	      , top: o.top
	      })
	
	      if (target) {
	        target.insertBefore(el, target.firstChild || null)
	      }
	
	      el.setAttribute('role', 'progressbar')
	      self.lines(el, self.opts)
	
	      if (!useCssAnimations) {
	        // No CSS animation support, use setTimeout() instead
	        var i = 0
	          , start = (o.lines - 1) * (1 - o.direction) / 2
	          , alpha
	          , fps = o.fps
	          , f = fps / o.speed
	          , ostep = (1 - o.opacity) / (f * o.trail / 100)
	          , astep = f / o.lines
	
	        ;(function anim () {
	          i++
	          for (var j = 0; j < o.lines; j++) {
	            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
	
	            self.opacity(el, j * o.direction + start, alpha, o)
	          }
	          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
	        })()
	      }
	      return self
	    }
	
	    /**
	     * Stops and removes the Spinner.
	     */
	  , stop: function () {
	      var el = this.el
	      if (el) {
	        clearTimeout(this.timeout)
	        if (el.parentNode) el.parentNode.removeChild(el)
	        this.el = undefined
	      }
	      return this
	    }
	
	    /**
	     * Internal method that draws the individual lines. Will be overwritten
	     * in VML fallback mode below.
	     */
	  , lines: function (el, o) {
	      var i = 0
	        , start = (o.lines - 1) * (1 - o.direction) / 2
	        , seg
	
	      function fill (color, shadow) {
	        return css(createEl(), {
	          position: 'absolute'
	        , width: o.scale * (o.length + o.width) + 'px'
	        , height: o.scale * o.width + 'px'
	        , background: color
	        , boxShadow: shadow
	        , transformOrigin: 'left'
	        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
	        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
	        })
	      }
	
	      for (; i < o.lines; i++) {
	        seg = css(createEl(), {
	          position: 'absolute'
	        , top: 1 + ~(o.scale * o.width / 2) + 'px'
	        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
	        , opacity: o.opacity
	        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
	        })
	
	        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
	        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
	      }
	      return el
	    }
	
	    /**
	     * Internal method that adjusts the opacity of a single line.
	     * Will be overwritten in VML fallback mode below.
	     */
	  , opacity: function (el, i, val) {
	      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
	    }
	
	  })
	
	
	  function initVML () {
	
	    /* Utility function to create a VML tag */
	    function vml (tag, attr) {
	      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
	    }
	
	    // No CSS transforms but VML support, add a CSS rule for VML elements:
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
	
	    Spinner.prototype.lines = function (el, o) {
	      var r = o.scale * (o.length + o.width)
	        , s = o.scale * 2 * r
	
	      function grp () {
	        return css(
	          vml('group', {
	            coordsize: s + ' ' + s
	          , coordorigin: -r + ' ' + -r
	          })
	        , { width: s, height: s }
	        )
	      }
	
	      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
	        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
	        , i
	
	      function seg (i, dx, filter) {
	        ins(
	          g
	        , ins(
	            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
	          , ins(
	              css(
	                vml('roundrect', {arcsize: o.corners})
	              , { width: r
	                , height: o.scale * o.width
	                , left: o.scale * o.radius
	                , top: -o.scale * o.width >> 1
	                , filter: filter
	                }
	              )
	            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
	            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        )
	      }
	
	      if (o.shadow)
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
	        }
	
	      for (i = 1; i <= o.lines; i++) seg(i)
	      return ins(el, g)
	    }
	
	    Spinner.prototype.opacity = function (el, i, val, o) {
	      var c = el.firstChild
	      o = o.shadow && o.lines || 0
	      if (c && i + o < c.childNodes.length) {
	        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
	        if (c) c.opacity = val
	      }
	    }
	  }
	
	  if (typeof document !== 'undefined') {
	    sheet = (function () {
	      var el = createEl('style', {type : 'text/css'})
	      ins(document.getElementsByTagName('head')[0], el)
	      return el.sheet || el.styleSheet
	    }())
	
	    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
	
	    if (!vendor(probe, 'transform') && probe.adj) initVML()
	    else useCssAnimations = vendor(probe, 'animation')
	  }
	
	  return Spinner
	
	}));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _SignupForm = __webpack_require__(539);
	
	var _SignupForm2 = _interopRequireDefault(_SignupForm);
	
	var _PasswordRuleTable = __webpack_require__(551);
	
	var _PasswordRuleTable2 = _interopRequireDefault(_PasswordRuleTable);
	
	var _jsCookie = __webpack_require__(553);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _queryString = __webpack_require__(554);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _underscore = __webpack_require__(27);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _LogosRatings = __webpack_require__(607);
	
	var _LogosRatings2 = _interopRequireDefault(_LogosRatings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _SignupForm2.default.extend({
	    el: '.content',
	
	    passwordRuleTableView: null,
	
	    events: function events() {
	        return Object.assign(_SignupForm2.default.prototype.events.apply(this), {
	            'submit .js-signup-form': 'signUp',
	            'click .js-go-to-top': 'goToTop',
	            'keyup input[name="password"]': 'toggleRuleDisplay',
	            'click .js-sign-up-with-xero-button': 'signUpWithXero'
	        });
	    },
	    initialize: function initialize(options) {
	        this.record = options.record || null;
	        this.params = _queryString2.default.parse(window.location.search);
	
	        var pageDesc = '';
	
	        this.options = _underscore2.default.extend(options, {
	            adConversionParams: options.query || {}
	        });
	
	        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	        var coupon = this.options.adConversionParams.utm_term || this.options.adConversionParams.cpn;
	        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	        if (coupon && !_jsCookie2.default.get('couponCode')) {
	            _jsCookie2.default.set('couponCode', coupon, { expires: 30 });
	        }
	
	        // Hammer, meet balls. Balls, meet hammer.
	        var _w = window;
	        this.lang = 'en';
	        if (_w.location.hash.indexOf('#signup-page-1-partner') > -1) {
	            this.template = __webpack_require__(608);
	            document.title = 'Sign Up Online Payroll Software | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online payroll ';
	            pageDesc += 'software. Includes free leave management. ';
	            pageDesc += 'Try us now and run two payrolls FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-1') > -1) {
	            this.template = __webpack_require__(609);
	            document.title = 'Sign Up Online Payroll Software | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online payroll ';
	            pageDesc += 'software. Includes free leave management. ';
	            pageDesc += 'Try us now and and run your first payroll for FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-2') > -1) {
	            this.template = __webpack_require__(610);
	            document.title = 'Leave Management System | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online leave ';
	            pageDesc += 'system. Includes payroll software. Try us now ';
	            pageDesc += 'and run your first payroll for FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-3') > -1) {
	            this.template = __webpack_require__(611);
	            document.title = 'Sign Up Payroll System | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online ';
	            pageDesc += 'payroll system. Includes free leave management. ';
	            pageDesc += 'Try us now and run your first payroll for FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-4') > -1) {
	            this.template = __webpack_require__(612);
	            document.title = 'Free Payroll Software | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online ';
	            pageDesc += 'payroll software. Includes free leave ';
	            pageDesc += 'management. Try the payroll software for FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-5') > -1) {
	            this.template = __webpack_require__(613);
	            document.title = 'Online Payroll Service | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online ';
	            pageDesc += 'payroll service. Includes free leave management. ';
	            pageDesc += 'Try us now and run your first payroll for FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-6') > -1) {
	            this.template = __webpack_require__(614);
	            document.title = 'Online HR Management Software | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use HR ';
	            pageDesc += 'Management Software. Includes leave ';
	            pageDesc += 'management. Try us now and run your first ';
	            pageDesc += 'payroll for FREE!';
	        } else if (_w.location.hash.indexOf('#signup-page-my-1') > -1) {
	            this.lang = 'ms';
	            this.template = __webpack_require__(615);
	            document.title = 'Sign Up Online Payroll Software | PayrollPanda';
	            pageDesc = 'Sign up for affordable & easy-to-use online payroll ';
	            pageDesc += 'software. Includes free leave management. ';
	            pageDesc += 'Try us now and and run your first payroll for FREE!';
	        } else {
	            this.template = __webpack_require__(616);
	            document.title = 'Get Online Payroll System | PayrollPanda';
	            pageDesc = 'Online HR and Payroll System for Businesses ';
	            pageDesc += 'in Malaysia. Simple, Secure, Accurate and ';
	            pageDesc += 'Affordable. Includes Free Leave Management. ';
	            pageDesc += 'Try it now.';
	        }
	
	        document.getElementsByName('description')[0].content = pageDesc;
	
	        this.passwordRuleTableView = new _PasswordRuleTable2.default();
	
	        return _SignupForm2.default.prototype.initialize.apply(this);
	    },
	
	
	    toggleRuleDisplay: function toggleRuleDisplay(ev) {
	        return this.passwordRuleTableView && this.passwordRuleTableView.toggleRuleDisplay && this.passwordRuleTableView.toggleRuleDisplay(ev);
	    },
	
	    determineRole: function determineRole() {
	        if (this.record && this.record.data) {
	            if (this.record.data.role === undefined && this.record.data.employeeId) {
	                return 'employee';
	            }
	            return this.record.data.role;
	        }
	
	        return 'employer';
	    },
	
	    render: function render() {
	        var recordEmail = (this.record ? this.record.data.email : '').trim();
	        var recordName = (this.record ? this.record.data.name : '').trim();
	        var who = 'Employer';
	
	        var role = this.determineRole();
	        if (role === 'employee') {
	            who = 'Employee';
	        } else if (role === 'mpp_admin') {
	            who = 'MPP Admin';
	        } else if (role === 'mpp_manager') {
	            who = 'MPP Manager';
	        }
	        if (this.record && this.record.data) {
	            this.model.set({
	                email: (recordEmail || '').toLowerCase(),
	                name: recordName,
	                role: role,
	                isMPPCustomer: role === 'employer'
	            }, { validate: false });
	        }
	
	        this.$el.html(this.template({
	            restrictEmployerSignup: !this.record,
	            email: (recordEmail || '').toLowerCase(),
	            name: recordName,
	            who: who,
	            contactPhoneRequired: role === 'employer' && !this.record
	        }));
	
	        $('body').addClass('gray-bg');
	        this.$('[name=password]').pwstrength({
	            ui: {
	                showVerdicts: false,
	                colorClasses: ['danger', 'warning', 'warning', 'info', 'info', 'success']
	            },
	            common: { minChar: 8 }
	        });
	
	        $('#section-ratings').html((0, _LogosRatings2.default)({
	            lang: this.lang
	        }));
	
	        if (this.record) {
	            this.$('ul.nav.nav-tabs>li:first-child>a').attr('data-toggle', null).attr('href', null);
	        }
	
	        this.$('#password-rules').append(this.passwordRuleTableView.render().$el);
	    },
	
	    signUp: function signUp(ev) {
	        var _this = this;
	
	        ev.preventDefault();
	
	        if (!this.model.isValid()) {
	            this.invalid(this.model, { errors: this.model.validationError });
	            return;
	        }
	
	        var payload = {
	            name: this.model.get('name'),
	            email: this.model.get('email'),
	            password: this.model.get('password'),
	            disclosedEmployeeCount: this.model.get('disclosedEmployeeCount')
	        };
	
	        if (this.record) {
	            payload.token = this.record.token;
	        }
	        if (this.model.get('contactPhone')) {
	            payload.contactPhone = this.model.get('contactPhone');
	        }
	        return _user2.default.signUp(payload).then(function () {
	            return _this.model.login({
	                email: payload.email,
	                password: payload.password
	            });
	        }).then(function () {
	            app.reload();
	        }).catch(function (err) {
	            _alerts2.default.show('error', {
	                title: 'An error ocurred trying to sign up',
	                text: err
	            });
	        });
	    },
	
	    signUpWithXero: function signUpWithXero(e) {
	        e.preventDefault();
	        window.location.href = _config2.default.apiUrl + '/Integrations/xero/signupUrl';
	        return false;
	    },
	
	    goToTop: function goToTop() {
	        var _this2 = this;
	
	        $('html, body').animate({ scrollTop: 0 }, 500, function () {
	            _this2.$('[name="name"]').focus();
	        });
	    },
	
	    // make sure that whenever we get the email field from the UI we make it
	    // lower case
	    getInputValueOfEmail: function getInputValueOfEmail($el) {
	        return ($el.val() || '').trim().toLowerCase();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var EditView = __webpack_require__(540);
	var FormView = __webpack_require__(550);
	
	module.exports = FormView.extend({
	    bindHandlers: function bindHandlers() {
	        // we override for EditView since we don't want to validate form
	        // to be able to toggle between login and signup form at will
	        // this removes form validation when going to next route
	        // includes properties like dirty()
	        return EditView.prototype.bindHandlers.apply(this, arguments);
	    }
	});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var Alerts = __webpack_require__(529);
	var moment = __webpack_require__(101);
	var tooltip = __webpack_require__(541);
	var inflect = __webpack_require__(542)();
	var Cocktail = __webpack_require__(548);
	
	var InputValueFormatMixin = __webpack_require__(549);
	
	module.exports = Cocktail.mixin(Backbone.View.extend({
	    tainted: false,
	
	    showAlert: function showAlert(message) {
	        Alerts.show('error', {
	            text: 'You\'re trying to save an incorrect data:\n' + message + '\n Please complete the form or\n' + 'use a different value before continuing.'
	        });
	    },
	
	    events: function events() {
	        return {
	            /* js-ext class can be used by Views that extend this one
	             * to provide custom behaviour to some fields if they don't
	             * have a one to one match to a model's attribute or for whatever
	             * reason.
	             * */
	            'change input:not(.js-icheck):not(.js-ext)': 'updateModel',
	            'change textarea:not(.js-ext)': 'updateModel',
	            'change select:not(.js-ext)': 'updateModel',
	            'ifToggled input:not(.js-ext)': 'updateModel',
	            'changeDate .js-datepicker:not(.js-ext)': 'updateDate',
	            'change input,select,textarea': 'taint',
	            'ifToggled input': 'taint',
	
	            'change .js-datepicker:not(.js-ext) .js-datepicker-input': 'updateDateInput'
	        };
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            templateExtra: false,
	            template: null,
	            radioClass: 'iradio_square-blue',
	            checkboxClass: 'icheckbox_square-blue'
	        });
	
	        this.tainted = false;
	
	        if (this.model) {
	            this.bindHandlers();
	            this.render();
	        }
	
	        return this;
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.model.on('invalid error', this.invalid, this);
	        this.model.on('change', this.valid, this);
	        this.model.on('change', this.renderAttributes, this);
	        this.model.on('sync', this.render, this);
	        this.model.on('sync', this.untaint, this);
	        this.model.on('destroy', this.remove, this);
	        this.model.on('alert', this.invalidAlert, this);
	
	        return this;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        this.model.off(null, null, this);
	        return this;
	    },
	
	    setModel: function setModel(model) {
	        if (this.model) {
	            this.unbindHandlers();
	        }
	
	        this.model = model;
	        this.bindHandlers();
	        this.render();
	
	        return this;
	    },
	
	    unsetModel: function unsetModel() {
	        this.unbindHandlers();
	        this.model = undefined;
	
	        return this;
	    },
	
	    render: function render() {
	        if (!this.options.template) {
	            return this;
	        }
	
	        if (!this.model) {
	            return this;
	        }
	
	        this.$el.html(this.options.template(_.defaults({ model: this.model }, this.options.templateExtra || {})));
	
	        this.$('.js-icheck').iCheck({
	            radioClass: this.options.radioClass,
	            checkboxClass: this.options.checkboxClass
	        });
	
	        this.$('.js-datepicker').addClass('js-ignore').datepicker({
	            autoclose: true,
	            format: 'dd/mm/yyyy',
	            keyboardNavigation: false,
	            todayBtn: 'linked',
	            todayHighlight: true
	        }).removeClass('js-ignore');
	
	        this.$('.js-chosen').chosen({ width: '100%' });
	
	        tooltip.init(this);
	
	        return this;
	    },
	
	    renderAttributes: function renderAttributes(model) {
	        var _this = this;
	
	        var changes = model.changed || {};
	
	        Object.keys(changes).forEach(function (attr) {
	            var renderer = 'render' + inflect.camelize(attr);
	
	            // if there is a renderer specified, use it
	            if (typeof _this[renderer] === 'function') {
	                return _this[renderer](model);
	            }
	
	            return _this.renderAttribute(model, attr);
	        });
	    },
	
	    renderAttribute: function renderAttribute(model, attr) {
	        var $el = this.$('[name="' + attr + '"]');
	
	        /* I *HATE* iCheck */
	        if ($el.attr('type') === 'radio' && $el.parent().attr('class').indexOf(this.options.radioClass) >= 0) {
	            var value = !_.isBoolean(model.get(attr)) ? model.get(attr) : model.get(attr) === true ? '1' : '0';
	
	            this.$('[name="' + attr + '"][value="' + value + '"]').iCheck('check');
	        } else if ($el.attr('type') === 'checkbox' && $el.parent().attr('class').indexOf(this.options.checkboxClass) >= 0) {
	            this.$('[name="' + attr + '"]').iCheck(model.get(attr) ? 'check' : 'uncheck');
	        } else if ($el.hasClass('js-datepicker-input')) {
	            $el.val(_.isFunction(model.getFormatted) ? model.getFormatted(attr, 'DD/MM/YYYY') : model.get(attr));
	        } else if (!_.isObject(model.get(attr)) && attr.slice(-2) !== 'Id') {
	            this.$('[name=' + attr + ']').val(model.get(attr));
	        }
	    },
	
	    updateDateInput: function updateDateInput(ev) {
	        var $input = this.$(ev.currentTarget);
	        var $datepicker = this.$(ev.currentTarget).closest('.js-datepicker', this.el);
	        var attr = $input.attr('name');
	
	        if ($input.val() === '') {
	            this.model.set(attr, null);
	        } else {
	            $datepicker.datepicker('setDate', $input.val());
	        }
	    },
	
	    updateDate: function updateDate(ev) {
	        var _this2 = this,
	            _arguments = arguments;
	
	        var $input = this.$(ev.currentTarget).hasClass('js-datepicker-input') ? this.$(ev.currentTarget).closest('.js-datepicker', this.el) : this.$(ev.currentTarget);
	        var $realInput = $input.find('input');
	        var updateModel = function updateModel() {
	            var validDate = moment(_this2.getInputValue($input)).isSame(moment($realInput.val(), 'DD/MM/YYYY'), 'day');
	            if (validDate) {
	                _this2.updateModel.apply(_this2, _arguments);
	            }
	        };
	
	        $realInput.off('blur', updateModel);
	        if ($realInput.is(':focus')) {
	            $realInput.on('blur', updateModel);
	        } else {
	            updateModel();
	        }
	    },
	
	    updateModel: function updateModel(ev) {
	        var $input = this.$(ev.currentTarget).hasClass('js-datepicker-input') ? this.$(ev.currentTarget).closest('.js-datepicker', this.el) : this.$(ev.currentTarget);
	        var $realInput = $input.find('input');
	        var attr = $realInput.length ? $realInput.attr('name') : $input.data('attributeName') || $input.attr('name');
	
	        if ($input.hasClass('js-ignore')) {
	            return;
	        }
	
	        if ($input.closest('.js-ext', this.el).length > 0) {
	            return;
	        }
	
	        if (typeof attr === 'undefined') {
	            return;
	        }
	
	        this.toggleError(attr);
	        var value = this.getInputValue($input);
	
	        this.model.set(attr, value);
	        return this;
	    },
	
	    taint: function taint() {
	        this.tainted = true;
	    },
	
	    untaint: function untaint() {
	        this.tainted = false;
	    },
	
	    toggleError: function toggleError(attribute, message) {
	        this.$('[name=' + attribute + '], .js-attr-' + attribute).closest('.form-group', this.$el).toggleClass('has-error', message !== undefined);
	        this.$('.error-' + attribute).text(message || '');
	
	        if (!this.$('[name=' + attribute + ']').length && message) {
	            this.showAlert(message);
	        }
	    },
	
	    invalidAlert: function invalidAlert(message) {
	        this.showAlert(message);
	    },
	
	    invalid: function invalid(model) {
	        var _this3 = this;
	
	        var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var noParsedError = true;
	        if (Object.keys(error).indexOf('errors') >= 0) {
	            error = error.errors || {};
	            noParsedError = false;
	        }
	
	        if (noParsedError && error.responseJSON && error.responseJSON.error && error.responseJSON.error.details) {
	            error = error.responseJSON.error.details.messages || {};
	        }
	
	        Object.keys(error).forEach(function (attr) {
	            var message = Array.isArray(error[attr]) ? error[attr][0] : error[attr];
	            _this3.toggleError(attr, message);
	        });
	    },
	
	    valid: function valid(model) {
	        var _this4 = this;
	
	        var changes = model.changed || {};
	        Object.keys(changes).forEach(function (attr) {
	            _this4.toggleError(attr);
	        });
	    },
	
	    remove: function remove() {
	        Backbone.View.prototype.remove.apply(this, arguments);
	
	        this.undelegateEvents();
	
	        if (this.model) {
	            this.unbindHandlers();
	        }
	
	        this.$el.remove();
	    }
	}), InputValueFormatMixin);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function initBody() {
	    $('body').on('click', function () {
	        $('.tooltip.in').remove();
	    }).on('show.bs.tooltip', '[data-toggle="tooltip"]', function (e) {
	        $('[data-toggle="tooltip"]').not($(e.currentTarget)).tooltip('hide');
	    }).on('show.bs.modal', '.modal.in', function () {
	        $('.tooltip.in').remove();
	    }).on('hide.bs.modal', '.modal.in', function () {
	        $('.tooltip.in').remove();
	    });
	}
	
	function init(view) {
	    view.$('[data-toggle="tooltip"][data-delayed]').tooltip({
	        delay: { show: 1000, hide: 0 }, trigger: 'hover'
	    });
	    view.$('[data-toggle="tooltip"]').tooltip({
	        trigger: 'manual'
	    });
	
	    var timeoutId = void 0;
	    view.$('[data-toggle="tooltip"]').hover(function () {
	        view.$(this).tooltip('show');
	    }, function () {
	        var _this = this;
	
	        var delay = view.$(this).data('delay') || 4000;
	        timeoutId = setTimeout(function () {
	            view.$(_this).tooltip('hide');
	        }, delay);
	    });
	}
	
	module.exports = {
	    initBody: initBody,
	    init: init
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	// Requiring modules
	
	module.exports = function (attach) {
	  var methods = __webpack_require__(543);
	
	  if (attach) {
	    __webpack_require__(547)(methods);
	  }
	
	  return methods;
	};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	// The Inflector transforms words from singular to plural, class names to table names, modularized class names to ones without,
	// and class names to foreign keys. The default inflections for pluralization, singularization, and uncountable words are kept
	// in inflections.coffee
	//
	// If you discover an incorrect inflection and require it for your application, you'll need
	// to correct it yourself (explained below).
	
	var util = __webpack_require__(544);
	
	var inflect = module.exports;
	
	// Import [inflections](inflections.html) instance
	inflect.inflections = __webpack_require__(545);
	
	// Gives easy access to add inflections to this class
	inflect.inflect = function (fn) {
	  fn(inflect.inflections);
	};
	
	// By default, _camelize_ converts strings to UpperCamelCase. If the argument to _camelize_
	// is set to _false_ then _camelize_ produces lowerCamelCase.
	//
	// _camelize_ will also convert '/' to '.' which is useful for converting paths to namespaces.
	//
	//     "bullet_record".camelize()             // => "BulletRecord"
	//     "bullet_record".camelize(false)        // => "bulletRecord"
	//     "bullet_record/errors".camelize()      // => "BulletRecord.Errors"
	//     "bullet_record/errors".camelize(false) // => "bulletRecord.Errors"
	//
	// As a rule of thumb you can think of _camelize_ as the inverse of _underscore_,
	// though there are cases where that does not hold:
	//
	//     "SSLError".underscore.camelize // => "SslError"
	inflect.camelize = function (lower_case_and_underscored_word, first_letter_in_uppercase) {
	  var result;
	  if (first_letter_in_uppercase == null) first_letter_in_uppercase = true;
	  result = util.string.gsub(lower_case_and_underscored_word, /\/(.?)/, function ($) {
	    return '.' + util.string.upcase($[1]);
	  });
	  result = util.string.gsub(result, /(?:_)(.)/, function ($) {
	    return util.string.upcase($[1]);
	  });
	  if (first_letter_in_uppercase) {
	    return util.string.upcase(result);
	  } else {
	    return util.string.downcase(result);
	  }
	};
	
	// Makes an underscored, lowercase form from the expression in the string.
	//
	// Changes '.' to '/' to convert namespaces to paths.
	//
	//     "BulletRecord".underscore()         // => "bullet_record"
	//     "BulletRecord.Errors".underscore()  // => "bullet_record/errors"
	//
	// As a rule of thumb you can think of +underscore+ as the inverse of +camelize+,
	// though there are cases where that does not hold:
	//
	//     "SSLError".underscore().camelize() // => "SslError"
	inflect.underscore = function (camel_cased_word) {
	  var self;
	  self = util.string.gsub(camel_cased_word, /\./, '/');
	  self = util.string.gsub(self, /([A-Z])([A-Z][a-z])/, '$1_$2');
	  self = util.string.gsub(self, /([a-z\d])([A-Z])/, '$1_$2');
	  self = util.string.gsub(self, /-/, '_');
	  return self.toLowerCase();
	};
	
	// Replaces underscores with dashes in the string.
	//
	//     "puni_puni".dasherize()   // => "puni-puni"
	inflect.dasherize = function (underscored_word) {
	  return util.string.gsub(underscored_word, /_/, '-');
	};
	
	// Removes the module part from the expression in the string.
	//
	//     "BulletRecord.String.Inflections".demodulize() // => "Inflections"
	//     "Inflections".demodulize()                     // => "Inflections"
	inflect.demodulize = function (class_name_in_module) {
	  return util.string.gsub(class_name_in_module, /^.*\./, '');
	};
	
	// Creates a foreign key name from a class name.
	// _separate_class_name_and_id_with_underscore_ sets whether
	// the method should put '_' between the name and 'id'.
	//
	//     "Message".foreign_key()      // => "message_id"
	//     "Message".foreign_key(false) // => "messageid"
	//     "Admin::Post".foreign_key()  // => "post_id"
	inflect.foreign_key = function (class_name, separate_class_name_and_id_with_underscore) {
	  if (separate_class_name_and_id_with_underscore == null) {
	    separate_class_name_and_id_with_underscore = true;
	  }
	  return (
	    inflect.underscore(inflect.demodulize(class_name)) + (separate_class_name_and_id_with_underscore ? '_id' : 'id')
	  );
	};
	
	// Turns a number into an ordinal string used to denote the position in an
	// ordered sequence such as 1st, 2nd, 3rd, 4th.
	//
	//     ordinalize(1)     // => "1st"
	//     ordinalize(2)     // => "2nd"
	//     ordinalize(1002)  // => "1002nd"
	//     ordinalize(1003)  // => "1003rd"
	//     ordinalize(-11)   // => "-11th"
	//     ordinalize(-1021) // => "-1021st"
	inflect.ordinalize = function (number) {
	  var _ref;
	  number = parseInt(number);
	  if ((_ref = Math.abs(number) % 100) === 11 || _ref === 12 || _ref === 13) {
	    return '' + number + 'th';
	  } else {
	    switch (Math.abs(number) % 10) {
	      case 1:
	        return '' + number + 'st';
	      case 2:
	        return '' + number + 'nd';
	      case 3:
	        return '' + number + 'rd';
	      default:
	        return '' + number + 'th';
	    }
	  }
	};
	
	// Checks a given word for uncountability
	//
	//     "money".uncountability()     // => true
	//     "my money".uncountability()  // => true
	inflect.uncountability = function (word) {
	  return inflect.inflections.uncountables.some(function (ele, ind, arr) {
	    return word.match(new RegExp('(\\b|_)' + ele + '$', 'i')) != null;
	  });
	};
	
	// Returns the plural form of the word in the string.
	//
	//     "post".pluralize()             // => "posts"
	//     "octopus".pluralize()          // => "octopi"
	//     "sheep".pluralize()            // => "sheep"
	//     "words".pluralize()            // => "words"
	//     "CamelOctopus".pluralize()     // => "CamelOctopi"
	inflect.pluralize = function (word) {
	  var plural, result;
	  result = word;
	  if (word === '' || inflect.uncountability(word)) {
	    return result;
	  } else {
	    for (var i = 0; i < inflect.inflections.plurals.length; i++) {
	      plural = inflect.inflections.plurals[i];
	      result = util.string.gsub(result, plural[0], plural[1]);
	      if (word.match(plural[0]) != null) break;
	    }
	    return result;
	  }
	};
	
	// The reverse of _pluralize_, returns the singular form of a word in a string.
	//
	//     "posts".singularize()            // => "post"
	//     "octopi".singularize()           // => "octopus"
	//     "sheep".singularize()            // => "sheep"
	//     "word".singularize()             // => "word"
	//     "CamelOctopi".singularize()      // => "CamelOctopus"
	inflect.singularize = function (word) {
	  var result, singular;
	  result = word;
	  if (word === '' || inflect.uncountability(word)) {
	    return result;
	  } else {
	    for (var i = 0; i < inflect.inflections.singulars.length; i++) {
	      singular = inflect.inflections.singulars[i];
	      result = util.string.gsub(result, singular[0], singular[1]);
	      if (word.match(singular[0])) break;
	    }
	    return result;
	  }
	};
	
	// Capitalizes the first word and turns underscores into spaces and strips a
	// trailing "_id", if any. Like _titleize_, this is meant for creating pretty output.
	//
	//     "employee_salary".humanize()   // => "Employee salary"
	//     "author_id".humanize()         // => "Author"
	inflect.humanize = function (lower_case_and_underscored_word) {
	  var human, result;
	  result = lower_case_and_underscored_word;
	  for (var i = 0; i < inflect.inflections.humans.length; i++) {
	    human = inflect.inflections.humans[i];
	    result = util.string.gsub(result, human[0], human[1]);
	  }
	  result = util.string.gsub(result, /_id$/, '');
	  result = util.string.gsub(result, /_/, ' ');
	  return util.string.capitalize(result, true);
	};
	
	// Capitalizes all the words and replaces some characters in the string to create
	// a nicer looking title. _titleize_ is meant for creating pretty output. It is not
	// used in the Bullet internals.
	//
	//
	//     "man from the boondocks".titleize()   // => "Man From The Boondocks"
	//     "x-men: the last stand".titleize()    // => "X Men: The Last Stand"
	inflect.titleize = function (word) {
	  var self;
	  self = inflect.humanize(inflect.underscore(word));
	  return util.string.capitalize(self);
	};
	
	// Create the name of a table like Bullet does for models to table names. This method
	// uses the _pluralize_ method on the last word in the string.
	//
	//     "RawScaledScorer".tableize()   // => "raw_scaled_scorers"
	//     "egg_and_ham".tableize()       // => "egg_and_hams"
	//     "fancyCategory".tableize()     // => "fancy_categories"
	inflect.tableize = function (class_name) {
	  return inflect.pluralize(inflect.underscore(class_name));
	};
	
	// Create a class name from a plural table name like Bullet does for table names to models.
	// Note that this returns a string and not a Class.
	//
	//     "egg_and_hams".classify()   // => "EggAndHam"
	//     "posts".classify()          // => "Post"
	//
	// Singular names are not handled correctly:
	//
	//     "business".classify()       // => "Busines"
	inflect.classify = function (table_name) {
	  return inflect.camelize(inflect.singularize(util.string.gsub(table_name, /^.*\./, '')));
	};


/***/ }),
/* 544 */
/***/ (function(module, exports) {

	// Some utility functions in js
	
	var u = (module.exports = {
	  array: {
	    // Returns a copy of the array with the value removed once
	    //
	    //     [1, 2, 3, 1].del 1 #=> [2, 3, 1]
	    //     [1, 2, 3].del 4    #=> [1, 2, 3]
	    del: function (arr, val) {
	      var index = arr.indexOf(val);
	
	      if (index != -1) {
	        if (index == 0) {
	          return arr.slice(1);
	        } else {
	          return arr.slice(0, index).concat(arr.slice(index + 1));
	        }
	      } else {
	        return arr;
	      }
	    },
	
	    // Returns the first element of the array
	    //
	    //     [1, 2, 3].first() #=> 1
	    first: function (arr) {
	      return arr[0];
	    },
	
	    // Returns the last element of the array
	    //
	    //     [1, 2, 3].last()  #=> 3
	    last: function (arr) {
	      return arr[arr.length - 1];
	    },
	  },
	  string: {
	    // Returns a copy of str with all occurrences of pattern replaced with either replacement or the return value of a function.
	    // The pattern will typically be a Regexp; if it is a String then no regular expression metacharacters will be interpreted
	    // (that is /\d/ will match a digit, but ‘\d’ will match a backslash followed by a ‘d’).
	    //
	    // In the function form, the current match object is passed in as a parameter to the function, and variables such as
	    // $[1], $[2], $[3] (where $ is the match object) will be set appropriately. The value returned by the function will be
	    // substituted for the match on each call.
	    //
	    // The result inherits any tainting in the original string or any supplied replacement string.
	    //
	    //     "hello".gsub /[aeiou]/, '*'      #=> "h*ll*"
	    //     "hello".gsub /[aeiou]/, '<$1>'   #=> "h<e>ll<o>"
	    //     "hello".gsub /[aeiou]/, ($) {
	    //       "<#{$[1]}>"                    #=> "h<e>ll<o>"
	    //
	    gsub: function (str, pattern, replacement) {
	      var i, match, matchCmpr, matchCmprPrev, replacementStr, result, self;
	      if (!(pattern != null && replacement != null)) return u.string.value(str);
	      result = '';
	      self = str;
	      while (self.length > 0) {
	        if ((match = self.match(pattern))) {
	          result += self.slice(0, match.index);
	          if (typeof replacement === 'function') {
	            match[1] = match[1] || match[0];
	            result += replacement(match);
	          } else if (replacement.match(/\$[1-9]/)) {
	            matchCmprPrev = match;
	            matchCmpr = u.array.del(match, void 0);
	            while (matchCmpr !== matchCmprPrev) {
	              matchCmprPrev = matchCmpr;
	              matchCmpr = u.array.del(matchCmpr, void 0);
	            }
	            match[1] = match[1] || match[0];
	            replacementStr = replacement;
	            for (i = 1; i <= 9; i++) {
	              if (matchCmpr[i]) {
	                replacementStr = u.string.gsub(replacementStr, new RegExp('\\$' + i), matchCmpr[i]);
	              }
	            }
	            result += replacementStr;
	          } else {
	            result += replacement;
	          }
	          self = self.slice(match.index + match[0].length);
	        } else {
	          result += self;
	          self = '';
	        }
	      }
	      return result;
	    },
	
	    // Returns a copy of the String with the first letter being upper case
	    //
	    //     "hello".upcase #=> "Hello"
	    upcase: function (str) {
	      var self = u.string.gsub(str, /_([a-z])/, function ($) {
	        return '_' + $[1].toUpperCase();
	      });
	
	      self = u.string.gsub(self, /\/([a-z])/, function ($) {
	        return '/' + $[1].toUpperCase();
	      });
	
	      return self[0].toUpperCase() + self.substr(1);
	    },
	
	    // Returns a copy of capitalized string
	    //
	    //     "employee salary" #=> "Employee Salary"
	    capitalize: function (str, spaces) {
	      if (!str.length) {
	        return str;
	      }
	
	      var self = str.toLowerCase();
	
	      if (!spaces) {
	        self = u.string.gsub(self, /\s([a-z])/, function ($) {
	          return ' ' + $[1].toUpperCase();
	        });
	      }
	
	      return self[0].toUpperCase() + self.substr(1);
	    },
	
	    // Returns a copy of the String with the first letter being lower case
	    //
	    //     "HELLO".downcase #=> "hELLO"
	    downcase: function (str) {
	      var self = u.string.gsub(str, /_([A-Z])/, function ($) {
	        return '_' + $[1].toLowerCase();
	      });
	
	      self = u.string.gsub(self, /\/([A-Z])/, function ($) {
	        return '/' + $[1].toLowerCase();
	      });
	
	      return self[0].toLowerCase() + self.substr(1);
	    },
	
	    // Returns a string value for the String object
	    //
	    //     "hello".value() #=> "hello"
	    value: function (str) {
	      return str.substr(0);
	    },
	  },
	});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// A singleton instance of this class is yielded by Inflector.inflections, which can then be used to specify additional
	// inflection rules. Examples:
	//
	//     BulletSupport.Inflector.inflect ($) ->
	//       $.plural /^(ox)$/i, '$1en'
	//       $.singular /^(ox)en/i, '$1'
	//
	//       $.irregular 'octopus', 'octopi'
	//
	//       $.uncountable "equipment"
	//
	// New rules are added at the top. So in the example above, the irregular rule for octopus will now be the first of the
	// pluralization and singularization rules that is runs. This guarantees that your rules run before any of the rules that may
	// already have been loaded.
	
	var util = __webpack_require__(544);
	
	var Inflections = function () {
	  this.plurals = [];
	  this.singulars = [];
	  this.uncountables = [];
	  this.humans = [];
	  __webpack_require__(546)(this);
	  return this;
	};
	
	// Specifies a new pluralization rule and its replacement. The rule can either be a string or a regular expression.
	// The replacement should always be a string that may include references to the matched data from the rule.
	Inflections.prototype.plural = function (rule, replacement) {
	  if (typeof rule == 'string') {
	    this.uncountables = util.array.del(this.uncountables, rule);
	  }
	  this.uncountables = util.array.del(this.uncountables, replacement);
	  this.plurals.unshift([rule, replacement]);
	};
	
	// Specifies a new singularization rule and its replacement. The rule can either be a string or a regular expression.
	// The replacement should always be a string that may include references to the matched data from the rule.
	Inflections.prototype.singular = function (rule, replacement) {
	  if (typeof rule == 'string') {
	    this.uncountables = util.array.del(this.uncountables, rule);
	  }
	  this.uncountables = util.array.del(this.uncountables, replacement);
	  this.singulars.unshift([rule, replacement]);
	};
	
	// Specifies a new irregular that applies to both pluralization and singularization at the same time. This can only be used
	// for strings, not regular expressions. You simply pass the irregular in singular and plural form.
	//
	//     irregular 'octopus', 'octopi'
	//     irregular 'person', 'people'
	Inflections.prototype.irregular = function (singular, plural, fullMatchRequired) {
	  this.uncountables = util.array.del(this.uncountables, singular);
	  this.uncountables = util.array.del(this.uncountables, plural);
	  var prefix = '';
	  if (fullMatchRequired) {
	    prefix = '^';
	  }
	  if (singular[0].toUpperCase() == plural[0].toUpperCase()) {
	    this.plural(new RegExp('(' + prefix + singular[0] + ')' + singular.slice(1) + '$', 'i'), '$1' + plural.slice(1));
	    this.plural(new RegExp('(' + prefix + plural[0] + ')' + plural.slice(1) + '$', 'i'), '$1' + plural.slice(1));
	    this.singular(new RegExp('(' + prefix + plural[0] + ')' + plural.slice(1) + '$', 'i'), '$1' + singular.slice(1));
	  } else {
	    this.plural(
	      new RegExp(prefix + singular[0].toUpperCase() + singular.slice(1) + '$'),
	      plural[0].toUpperCase() + plural.slice(1)
	    );
	    this.plural(
	      new RegExp(prefix + singular[0].toLowerCase() + singular.slice(1) + '$'),
	      plural[0].toLowerCase() + plural.slice(1)
	    );
	    this.plural(
	      new RegExp(prefix + plural[0].toUpperCase() + plural.slice(1) + '$'),
	      plural[0].toUpperCase() + plural.slice(1)
	    );
	    this.plural(
	      new RegExp(prefix + plural[0].toLowerCase() + plural.slice(1) + '$'),
	      plural[0].toLowerCase() + plural.slice(1)
	    );
	    this.singular(
	      new RegExp(prefix + plural[0].toUpperCase() + plural.slice(1) + '$'),
	      singular[0].toUpperCase() + singular.slice(1)
	    );
	    this.singular(
	      new RegExp(prefix + plural[0].toLowerCase() + plural.slice(1) + '$'),
	      singular[0].toLowerCase() + singular.slice(1)
	    );
	  }
	};
	
	// Specifies a humanized form of a string by a regular expression rule or by a string mapping.
	// When using a regular expression based replacement, the normal humanize formatting is called after the replacement.
	// When a string is used, the human form should be specified as desired (example: 'The name', not 'the_name')
	//
	//     human /(.*)_cnt$/i, '$1_count'
	//     human "legacy_col_person_name", "Name"
	Inflections.prototype.human = function (rule, replacement) {
	  this.humans.unshift([rule, replacement]);
	};
	
	// Add uncountable words that shouldn't be attempted inflected.
	//
	//     uncountable "money"
	//     uncountable ["money", "information"]
	Inflections.prototype.uncountable = function (words) {
	  this.uncountables = this.uncountables.concat(words);
	};
	
	// Clears the loaded inflections within a given scope (default is _'all'_).
	// Give the scope as a symbol of the inflection type, the options are: _'plurals'_,
	// _'singulars'_, _'uncountables'_, _'humans'_.
	//
	//     clear 'all'
	//     clear 'plurals'
	Inflections.prototype.clear = function (scope) {
	  if (scope == null) scope = 'all';
	  switch (scope) {
	    case 'all':
	      this.plurals = [];
	      this.singulars = [];
	      this.uncountables = [];
	      this.humans = [];
	    default:
	      this[scope] = [];
	  }
	};
	
	// Clears the loaded inflections and initializes them to [default](../inflections.html)
	Inflections.prototype.default = function () {
	  this.plurals = [];
	  this.singulars = [];
	  this.uncountables = [];
	  this.humans = [];
	  __webpack_require__(546)(this);
	  return this;
	};
	
	module.exports = new Inflections();


/***/ }),
/* 546 */
/***/ (function(module, exports) {

	// Default inflections
	module.exports = function (inflect) {
	  inflect.plural(/$/, 's');
	  inflect.plural(/s$/i, 's');
	  inflect.plural(/(ax|test)is$/i, '$1es');
	  inflect.plural(/(octop|vir)us$/i, '$1i');
	  inflect.plural(/(octop|vir)i$/i, '$1i');
	  inflect.plural(/(alias|status)$/i, '$1es');
	  inflect.plural(/(bu)s$/i, '$1ses');
	  inflect.plural(/(buffal|tomat)o$/i, '$1oes');
	  inflect.plural(/([ti])um$/i, '$1a');
	  inflect.plural(/([ti])a$/i, '$1a');
	  inflect.plural(/sis$/i, 'ses');
	  inflect.plural(/(?:([^fa])fe|(?:(oa)f)|([lr])f)$/i, '$1ves');
	  inflect.plural(/(hive)$/i, '$1s');
	  inflect.plural(/([^aeiouy]|qu)y$/i, '$1ies');
	  inflect.plural(/(x|ch|ss|sh)$/i, '$1es');
	  inflect.plural(/(matr|vert|ind)(?:ix|ex)$/i, '$1ices');
	  inflect.plural(/([m|l])ouse$/i, '$1ice');
	  inflect.plural(/([m|l])ice$/i, '$1ice');
	  inflect.plural(/^(ox)$/i, '$1en');
	  inflect.plural(/^(oxen)$/i, '$1');
	  inflect.plural(/(quiz)$/i, '$1zes');
	
	  inflect.singular(/s$/i, '');
	  inflect.singular(/(n)ews$/i, '$1ews');
	  inflect.singular(/([ti])a$/i, '$1um');
	  inflect.singular(/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$/i, '$1sis');
	  inflect.singular(/(^analy)ses$/i, '$1sis');
	  inflect.singular(/([^f])ves$/i, '$1fe');
	  inflect.singular(/(hive)s$/i, '$1');
	  inflect.singular(/(tive)s$/i, '$1');
	  inflect.singular(/(oave)s$/i, 'oaf');
	  inflect.singular(/([lr])ves$/i, '$1f');
	  inflect.singular(/([^aeiouy]|qu)ies$/i, '$1y');
	  inflect.singular(/(s)eries$/i, '$1eries');
	  inflect.singular(/(m)ovies$/i, '$1ovie');
	  inflect.singular(/(x|ch|ss|sh)es$/i, '$1');
	  inflect.singular(/([m|l])ice$/i, '$1ouse');
	  inflect.singular(/(bus)es$/i, '$1');
	  inflect.singular(/(o)es$/i, '$1');
	  inflect.singular(/(shoe)s$/i, '$1');
	  inflect.singular(/(cris|ax|test)es$/i, '$1is');
	  inflect.singular(/(octop|vir)i$/i, '$1us');
	  inflect.singular(/(alias|status)es$/i, '$1');
	  inflect.singular(/^(ox)en/i, '$1');
	  inflect.singular(/(vert|ind)ices$/i, '$1ex');
	  inflect.singular(/(matr)ices$/i, '$1ix');
	  inflect.singular(/(quiz)zes$/i, '$1');
	  inflect.singular(/(database)s$/i, '$1');
	
	  inflect.irregular('child', 'children');
	  inflect.irregular('person', 'people');
	  inflect.irregular('man', 'men');
	  inflect.irregular('child', 'children');
	  inflect.irregular('sex', 'sexes');
	  inflect.irregular('move', 'moves');
	  inflect.irregular('cow', 'kine');
	  inflect.irregular('zombie', 'zombies');
	  inflect.irregular('oaf', 'oafs', true);
	  inflect.irregular('jefe', 'jefes');
	  inflect.irregular('save', 'saves');
	  inflect.irregular('safe', 'safes');
	  inflect.irregular('fife', 'fifes');
	
	  inflect.uncountable([
	    'equipment',
	    'information',
	    'rice',
	    'money',
	    'species',
	    'series',
	    'fish',
	    'sheep',
	    'jeans',
	    'sushi',
	  ]);
	};


/***/ }),
/* 547 */
/***/ (function(module, exports) {

	module.exports = function (obj) {
	  var addProperty = function (method, func) {
	    String.prototype.__defineGetter__(method, func);
	  };
	
	  var stringPrototypeBlacklist = [
	    '__defineGetter__',
	    '__defineSetter__',
	    '__lookupGetter__',
	    '__lookupSetter__',
	    'charAt',
	    'constructor',
	    'hasOwnProperty',
	    'isPrototypeOf',
	    'propertyIsEnumerable',
	    'toLocaleString',
	    'toString',
	    'valueOf',
	    'charCodeAt',
	    'indexOf',
	    'lastIndexof',
	    'length',
	    'localeCompare',
	    'match',
	    'replace',
	    'search',
	    'slice',
	    'split',
	    'substring',
	    'toLocaleLowerCase',
	    'toLocaleUpperCase',
	    'toLowerCase',
	    'toUpperCase',
	    'trim',
	    'trimLeft',
	    'trimRight',
	    'gsub',
	  ];
	
	  Object.keys(obj).forEach(function (key) {
	    if (key != 'inflect' && key != 'inflections') {
	      if (stringPrototypeBlacklist.indexOf(key) !== -1) {
	        console.log('warn: You should not override String.prototype.' + key);
	      } else {
	        addProperty(key, function () {
	          return obj[key](this);
	        });
	      }
	    }
	  });
	};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	//  (c) 2012 Onsi Fakhouri
	//  Cocktail.js may be freely distributed under the MIT license.
	//  http://github.com/onsi/cocktail
	(function (factory) {
	    if ("function" === 'function' && typeof module !== 'undefined' && module.exports) {
	        module.exports = factory(__webpack_require__(27));
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(27)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        this.Cocktail = factory(_);
	    }
	})(function (_) {
	
	    var Cocktail = {};
	
	    Cocktail.mixins = {};
	
	    Cocktail.mixin = function mixin(klass) {
	        var mixins = _.chain(arguments).toArray().slice(1).flatten().value();
	        // Allows mixing into the constructor's prototype or the dynamic instance
	        var obj = klass.prototype || klass;
	
	        var collisions = {};
	
	        _.each(mixins, function (mixin) {
	            if (_.isString(mixin)) {
	                mixin = Cocktail.mixins[mixin];
	            }
	            _.each(mixin, function (value, key) {
	                if (_.isFunction(value)) {
	                    // If the mixer already has that exact function reference
	                    // Note: this would occur on an accidental mixin of the same base
	                    if (obj[key] === value) return;
	
	                    if (obj[key]) {
	                        // Avoid accessing built-in properties like constructor (#39)
	                        collisions[key] = collisions.hasOwnProperty(key) ? collisions[key] : [obj[key]];
	                        collisions[key].push(value);
	                    }
	                    obj[key] = value;
	                } else if (_.isArray(value)) {
	                    obj[key] = _.union(value, obj[key] || []);
	                } else if (_.isObject(value)) {
	                    obj[key] = _.extend({}, value, obj[key] || {});
	                } else if (!(key in obj)) {
	                    obj[key] = value;
	                }
	            });
	        });
	
	        _.each(collisions, function (propertyValues, propertyName) {
	            obj[propertyName] = function () {
	                var that = this,
	                    args = arguments,
	                    returnValue;
	
	                _.each(propertyValues, function (value) {
	                    var returnedValue = _.isFunction(value) ? value.apply(that, args) : value;
	
	                    returnValue = propertyName === 'events' && _.isObject(returnedValue) ? _.extend(returnValue || {}, returnedValue) : typeof returnedValue === 'undefined' ? returnValue : returnedValue;
	                });
	
	                return returnValue;
	            };
	        });
	
	        return klass;
	    };
	
	    var originalExtend;
	
	    Cocktail.patch = function patch(Backbone) {
	        originalExtend = Backbone.Model.extend;
	
	        var extend = function extend(protoProps, classProps) {
	            var klass = originalExtend.call(this, protoProps, classProps);
	
	            var mixins = klass.prototype.mixins;
	            if (mixins && klass.prototype.hasOwnProperty('mixins')) {
	                Cocktail.mixin(klass, mixins);
	            }
	
	            return klass;
	        };
	
	        _.each([Backbone.Model, Backbone.Collection, Backbone.Router, Backbone.View], function (klass) {
	            klass.mixin = function mixin() {
	                Cocktail.mixin(this, _.toArray(arguments));
	            };
	
	            klass.extend = extend;
	        });
	    };
	
	    Cocktail.unpatch = function unpatch(Backbone) {
	        _.each([Backbone.Model, Backbone.Collection, Backbone.Router, Backbone.View], function (klass) {
	            klass.mixin = undefined;
	            klass.extend = originalExtend;
	        });
	    };
	
	    return Cocktail;
	});

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var inflect = __webpack_require__(542)();
	var moment = __webpack_require__(101);
	
	module.exports = {
	    getInputValue: function getInputValue($input) {
	        var type = $input.data('valueType');
	        var name = $input.attr('name');
	        var getValueOf = 'getInputValueOf' + inflect.camelize(name || '__');
	        var getValueAs = 'getInputValueAs' + inflect.camelize(type || '__');
	
	        if (_.isFunction(this[getValueOf])) {
	            return this[getValueOf]($input);
	        }
	
	        if (_.isFunction(this[getValueAs])) {
	            return this[getValueAs]($input);
	        }
	
	        return this.getInputValueAsRaw($input);
	    },
	
	    getInputValueAsRaw: function getInputValueAsRaw($input) {
	        if ($input.attr('type') === 'radio') {
	            return this.$('[name="' + $input.attr('name') + '"]:checked').val();
	        }
	
	        if ($input.hasClass('js-datepicker')) {
	            var m = moment($input.datepicker('getDate'));
	            return new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0));
	        }
	
	        if ($input.attr('type') === 'checkbox') {
	            return $input.is(':checked') ? $input.val() : null;
	        }
	
	        if ($input.prop('tagName') === 'SELECT' && $input.attr('multiple')) {
	            return $input.val();
	        }
	
	        return $.trim($input.val());
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var Alerts = __webpack_require__(529);
	var loader = __webpack_require__(534);
	var EditView = __webpack_require__(540);
	var log = __webpack_require__(525)('form-view');
	
	module.exports = EditView.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(EditView.prototype.events) ? EditView.prototype.events() : EditView.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-save': 'save',
	            'click .js-cancel': 'cancel',
	            'click .js-destroy': 'destroy'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            actOnSave: true,
	            actOnCancel: true,
	            actOnDestroy: true
	        });
	        this.options.templateExtra = _.defaults(this.options.templateExtra || {}, {
	            forceDestroyButton: false
	        });
	
	        return EditView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = EditView.prototype.bindHandlers.apply(this, arguments);
	
	        app.events.on('navigate', function (status) {
	            log.info('Caught navigate event...');
	            if (this.dirty()) {
	                log.info('...and we have unsaved changes');
	
	                status.unsaved = true;
	                status.msg = 'You have unsaved changes.  Exiting this ' + 'page will result in the changes being discarded.';
	            } else {
	                status.unsaved = false;
	            }
	        }, this);
	
	        app.events.on('hard-exit', this.hardExit, this);
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = EditView.prototype.unbindHandlers.apply(this, arguments);
	
	        app.events.off(null, null, this);
	
	        return r;
	    },
	
	    hardExit: function hardExit() {
	        log.info('The user decided to abandon form. Syncing model and leaving');
	
	        this.unbindHandlers();
	        this.fetch();
	    },
	
	    render: function render() {
	        var returnValue = EditView.prototype.render.apply(this, arguments);
	
	        this.markMandatoryFields();
	
	        return returnValue;
	    },
	
	    enableDestroyButton: function enableDestroyButton() {
	        this.options.templateExtra = _.extend(this.options.templateExtra, {
	            forceDestroyButton: true
	        });
	
	        return this.render();
	    },
	
	    disableDestroyButton: function disableDestroyButton() {
	        this.options.templateExtra = _.extend(this.options.templateExtra, {
	            forceDestroyButton: false
	        });
	
	        return this.render();
	    },
	
	    dirty: function dirty() {
	        return this.model.isNew() ? this.tainted : this.model.dirty();
	    },
	
	    save: function save(ev) {
	        var _this = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = loader.startFullScreen($button);
	
	        ev.preventDefault();
	
	        if ($button.closest('.js-ext', this.el).length > 0) {
	            stopLoader();
	            return;
	        }
	
	        this.trigger('save', this.model);
	
	        if (!this.model) {
	            stopLoader();
	            return;
	        }
	
	        if (this.constraints) {
	            this.model.setAdditionalConstraints(this.constraints);
	        }
	        if (this.options.actOnSave !== true) {
	            var errors = this.model.validate(this.model.attributes);
	
	            if (!_.isEmpty(errors)) {
	                log.error(errors);
	
	                this.invalid(this.model, { errors: errors });
	                stopLoader();
	                return;
	            }
	
	            this.trigger('saved', this.model);
	            stopLoader();
	
	            return;
	        }
	
	        return this.model.save(this.model.unsavedAttributes).then(function () {
	            _this.trigger('saved', _this.model);
	        }).catch(function (err) {
	            log.error(err);
	
	            if (_.isObject(err)) {
	                return;
	            }
	
	            Alerts.show('criticalError', err);
	        }).finally(function () {
	            _this.model.setAdditionalConstraints(null);
	            stopLoader();
	        });
	    },
	
	    fetch: function fetch() {
	        return this.model.fetch();
	    },
	
	    cancel: function cancel(ev) {
	        var _this2 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader;
	
	        ev.preventDefault();
	
	        if ($button.closest('.js-ext', this.el).length > 0) {
	            return;
	        }
	
	        stopLoader = loader.startFullScreen($button);
	
	        this.trigger('cancel', this.model);
	
	        if (this.options.actOnCancel !== true) {
	            this.trigger('cancelled', this.model);
	            stopLoader();
	
	            return;
	        }
	
	        return this.fetch().then(function () {
	            _this2.trigger('cancelled', _this2.model);
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	        }).finally(stopLoader);
	    },
	
	    destroy: function destroy(ev) {
	        var _this3 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = loader.startFullScreen($button);
	
	        ev.preventDefault();
	
	        if ($button.closest('.js-ext', this.el).length > 0) {
	            stopLoader();
	            return;
	        }
	
	        this.trigger('destroy', this.model);
	
	        if (this.options.actOnDestroy !== true) {
	            this.trigger('destroyed', this.model);
	            stopLoader();
	
	            return;
	        }
	
	        this.model.destroy().then(function () {
	            _this3.trigger('destroyed', _this3.model);
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	        }).finally(stopLoader);
	    },
	
	    markMandatoryFields: function markMandatoryFields(constraints) {
	        var _this4 = this;
	
	        var fields = constraints || this.model && this.model.constraints();
	
	        _(fields).each(function (item, key) {
	            var markAsMandatory = false;
	            if (item.presence) {
	                markAsMandatory = true;
	            } else if (typeof item === 'function') {
	                // Try to get whether is mandatory without failing
	                var _constraints = {};
	                try {
	                    var attr = _this4.model.attributes;
	                    _constraints = item(attr[item.name], attr);
	                } catch (e) {
	                    //
	                }
	                if (_constraints && _constraints.presence) {
	                    markAsMandatory = true;
	                }
	            }
	
	            if (markAsMandatory) {
	                /* FIXME Form markup is a bit fucked up, which makes id'ing labels
	                 * equally fucked up. So, first we need a better form markup and
	                 * then we fix this
	                 * */
	                var $label = _this4.$('[name="' + key + '"]').closest('div:not(.input-group):not(.iradio_square-blue)').prev('.control-label');
	                $label.find('.js-required').remove();
	                $label.append('<span class="js-required js-required-' + key + '">' + '*' + '</span>');
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _PasswordRuleTable = __webpack_require__(552);
	
	var _PasswordRuleTable2 = _interopRequireDefault(_PasswordRuleTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'div',
	    className: 'password-rule-table',
	
	    initialize: function initialize() {
	
	        this.render();
	        return this;
	    },
	
	    render: function render() {
	        this.$el.html((0, _PasswordRuleTable2.default)());
	
	        return this;
	    },
	
	    toggleRuleDisplay: function toggleRuleDisplay(evt) {
	        var password = evt.target.value;
	
	        this.$('#rule-8-chars').toggleClass('rule-match', password.length >= 8);
	        this.$('#rule-1-num').toggleClass('rule-match', /[0-9]+/.test(password));
	        this.$('#rule-1-alphabet').toggleClass('rule-match', /[a-zA-Z]+/.test(password));
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/PasswordRuleTable.ejs -->\n<p>\n    Your password should contain:\n</p>\n<ul class="password-rules">\n    <li id="rule-8-chars">8 characters</li>\n    <li id="rule-1-num">1 number</li>\n</ul>\n<ul class="password-rules">\n    <li id="rule-1-alphabet">1 alphabet</li>\n</ul>\n';
	}
	return __p;
	};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.3
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					return (document.cookie = [
						key, '=', value,
						attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
						attributes.path ? '; path=' + attributes.path : '',
						attributes.domain ? '; domain=' + attributes.domain : '',
						attributes.secure ? '; secure' : ''
					].join(''));
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(555);
	var objectAssign = __webpack_require__(556);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 556 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _companies = __webpack_require__(563);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _subscription = __webpack_require__(606);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _syncError = __webpack_require__(561);
	
	var _syncError2 = _interopRequireDefault(_syncError);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESET_URL = _config2.default.apiUrl + '/AppUsers/reset';
	var USER_URL = _config2.default.apiUrl + '/AppUsers';
	var INVITE_MPP_ADMIN_URL = _config2.default.apiUrl + '/AppUsers/inviteMPPAdmin';
	var INVITE_MPP_MANAGER_URL = _config2.default.apiUrl + '/AppUsers/inviteMPPManager';
	var INVITE_MPP_CUSTOMER_URL = _config2.default.apiUrl + '/AppUsers/inviteMPPCustomer';
	var INVITE_LEGACY_USER_URL = _config2.default.apiUrl + '/AppUsers/inviteLegacyUser';
	var MPP_PERMISSIONS_URL = _config2.default.apiUrl + '/AppUsers/setMppManagerPermissions';
	var log = (0, _log2.default)('model/user');
	
	var User = function (_Model) {
	    _inherits(User, _Model);
	
	    function User() {
	        _classCallCheck(this, User);
	
	        return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
	    }
	
	    _createClass(User, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/AppUsers';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                role: 'employer'
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            var loggedIn = this.isLoggedIn();
	            return {
	                name: {
	                    presence: { message: '^Name is required' },
	                    length: {
	                        minimum: 2,
	                        message: '^Name is too short'
	                    }
	                },
	                username: {
	                    presence: { message: '^Username email is required' },
	                    length: {
	                        minimum: 4,
	                        message: '^Username email must be at least 4 characters'
	                    }
	                },
	                email: {
	                    email: '^Email is required',
	                    presence: { message: '^Email is not valid' }
	                },
	                password: function password() {
	                    //If you are logged in, no need to validate password presence.
	                    if (!loggedIn) {
	                        return {
	                            presence: {
	                                message: '^Password must be at least 8 characters'
	                            },
	                            length: {
	                                minimum: 8,
	                                message: '^Password must be at least 8 characters'
	                            }
	                        };
	                    }
	                },
	                contactPhone: function contactPhone(value, attrs) {
	                    if (!loggedIn && attrs.role === 'employer' && !attrs.isMPPCustomer) {
	                        return {
	                            presence: { message: '^Contact phone is required' },
	                            format: {
	                                pattern: '[0-9\\(\\)\\+\\- ]+',
	                                message: '^The contact phone must be a valid ' + 'phone number'
	                            }
	                        };
	                    }
	
	                    return null;
	                }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            var _this2 = this;
	
	            var r = _get(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), 'initialize', this).apply(this, arguments);
	            this.companies = new _companies2.default(null, { user: this });
	            this.subscription = new _subscription2.default(null, { user: this });
	
	            this.on('change:email', this.syncEmailAndUsername('email'), this);
	            this.on('change:username', this.syncEmailAndUsername('username'), this);
	            this.on('destroy', function () {
	                return _this2.off(null, null, _this2);
	            }, this);
	
	            return r;
	        }
	    }, {
	        key: 'syncEmailAndUsername',
	        value: function syncEmailAndUsername(sourceField) {
	            var _this3 = this;
	
	            var targetField = sourceField === 'email' ? 'username' : sourceField === 'username' ? 'email' : null;
	
	            if (targetField === null) {
	                return function () {}; //noop
	            }
	            return function () {
	                _this3.set(targetField, _this3.get(sourceField), {
	                    validate: false,
	                    silent: true
	                });
	                return _this3;
	            };
	        }
	    }, {
	        key: 'login',
	        value: function login() {
	            var _this4 = this;
	
	            var credentials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { email: null, password: null };
	
	            var url = this.baseUrl() + '/login';
	            if (this.isLoggedIn()) {
	                return (0, _bluebird.reject)(new Error('User is already authenticated'));
	            }
	
	            // TODO use axios
	            return (0, _bluebird.resolve)(Backbone.$.ajax({
	                method: 'POST',
	                url: url,
	                data: credentials
	            })).then(this.setAccessToken).then(function () {
	                _this4.set('id', _this4.getAccessToken().userId);
	                return _this4.fetch();
	            }).then(function () {
	                return _this4.trigger('loggedIn');
	            }).catch(function (err) {
	                if (!(err instanceof _syncError2.default)) {
	                    return (0, _bluebird.reject)(new _syncError2.default(_this4, err.responseJSON || err.responseText));
	                }
	                return (0, _bluebird.reject)(err);
	            });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            var _this5 = this;
	
	            return (0, _axios2.default)({
	                method: 'post',
	                url: this.baseUrl() + '/logout',
	                headers: { 'Authorization': this.getAccessToken().id }
	            }).then(function () {
	                window.localStorage.removeItem('access-token');
	                _this5.trigger('loggedOut');
	            }).catch(function (err) {
	                console.error(err);
	                throw err;
	            });
	        }
	    }, {
	        key: 'setAccessToken',
	        value: function setAccessToken(token) {
	            window.localStorage.setItem('access-token', JSON.stringify(token));
	        }
	    }, {
	        key: 'getAccessToken',
	        value: function getAccessToken() {
	            return JSON.parse(window.localStorage.getItem('access-token'));
	        }
	    }, {
	        key: 'removeAccessToken',
	        value: function removeAccessToken() {
	            window.localStorage.removeItem('access-token');
	        }
	    }, {
	        key: 'isLoggedIn',
	        value: function isLoggedIn() {
	            return this.id && this.getAccessToken();
	        }
	    }, {
	        key: 'isRequirePasswordChange',
	        value: function isRequirePasswordChange() {
	            return this.isLoggedIn() && !this.get('passwordChangedAt') && (this.isEmployer() || this.isAdmin()) && /jibble\.io/.test(this.get('email'));
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(oldPassword, newPassword) {
	            var _this6 = this;
	
	            return _axios2.default.post(this.baseUrl() + '/change-password', {
	                oldPassword: oldPassword,
	                newPassword: newPassword
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this6.fetch();
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'sendCustomerSupportEmail',
	        value: function sendCustomerSupportEmail(questionSubject, desc) {
	            return _axios2.default.post(this.baseUrl() + '/customerSupport', {
	                subject: questionSubject,
	                desc: desc
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'remove',
	        value: function remove() {
	            return _axios2.default.delete(this.finalUrl(), {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            });
	        }
	    }, {
	        key: 'fetchCompany',
	        value: function fetchCompany() {
	            var _this7 = this;
	
	            return this.companies.fetch({ validate: false }).then(function () {
	                return _this7.companies.at(0).fetch();
	            }).then(function () {
	                return _this7.companies.at(0);
	            });
	        }
	    }, {
	        key: 'fetchEmployee',
	        value: function fetchEmployee() {
	            return new _employee2.default({ user: this }).fetch({ validate: false });
	        }
	    }, {
	        key: 'fetchSubscription',
	        value: function fetchSubscription() {
	            return this.subscription.fetch().catch(function (err) {
	                log.debug('Silently ignoring subscription failure:', err);
	            });
	        }
	    }, {
	        key: 'getSubscription',
	        value: function getSubscription() {
	            return this.subscription;
	        }
	    }, {
	        key: 'setRole',
	        value: function setRole(role) {
	            var _this8 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/setRole', { role: role }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this8.fetch();
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'isAdmin',
	        value: function isAdmin() {
	            return ['admin_manager', 'super_admin'].includes(this.get('role'));
	        }
	    }, {
	        key: 'isSuperAdmin',
	        value: function isSuperAdmin() {
	            return this.get('role') === 'super_admin';
	        }
	    }, {
	        key: 'isEmployee',
	        value: function isEmployee() {
	            return this.get('role') === 'employee';
	        }
	    }, {
	        key: 'isEmployer',
	        value: function isEmployer() {
	            return this.get('role') === 'employer';
	        }
	    }, {
	        key: 'removeLogo',
	        value: function removeLogo() {
	            return _axios2.default.delete(this.finalUrl() + '/logo', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            });
	        }
	    }, {
	        key: 'uploadLogo',
	        value: function uploadLogo() {
	            var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!file) {
	                return (0, _bluebird.resolve)();
	            }
	
	            // Size limit: 200 kb
	            if (file && file.size && file.size > 1024 * 200) {
	                return (0, _bluebird.reject)('The maximum allowed size is 200kb');
	            }
	
	            if (!/^image\/(png|jpeg)$/.test(file.type)) {
	                return (0, _bluebird.reject)('Only PNG or JPEG images are allowed');
	            }
	
	            var extension = file.name.split('.').pop();
	            var data = new FormData();
	            data.append('file', file, 'mpp-logo.' + extension);
	
	            return _axios2.default.post(this.finalUrl() + '/logo', data, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'getLogoUrl',
	        value: function getLogoUrl() {
	            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            var url = id ? USER_URL + '/' + id : this.finalUrl();
	            return url + '/logo?' + ('access_token=' + app.user.getAccessToken().id + '&') + ('_b=' + Math.floor(Math.random() * 1000000));
	        }
	    }], [{
	        key: 'signUp',
	        value: function signUp(_ref) {
	            var name = _ref.name,
	                email = _ref.email,
	                password = _ref.password,
	                token = _ref.token,
	                contactPhone = _ref.contactPhone,
	                disclosedEmployeeCount = _ref.disclosedEmployeeCount;
	
	            return (0, _axios2.default)({
	                method: 'post',
	                url: _config2.default.apiUrl + '/AppUsers/signup/' + (token || ''),
	                data: {
	                    name: name, email: email, password: password, contactPhone: contactPhone,
	                    disclosedEmployeeCount: disclosedEmployeeCount
	                }
	            }).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'inviteMppAdmin',
	        value: function inviteMppAdmin(name, email) {
	            return _axios2.default.post(INVITE_MPP_ADMIN_URL, {
	                name: name,
	                email: email
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'inviteMppManager',
	        value: function inviteMppManager(name, email, companies) {
	            return _axios2.default.post(INVITE_MPP_MANAGER_URL, {
	                name: name,
	                email: email,
	                companies: companies
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'inviteLegacyUser',
	        value: function inviteLegacyUser(name, email) {
	            return _axios2.default.post(INVITE_LEGACY_USER_URL, {
	                name: name,
	                email: email
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'inviteMppCustomer',
	        value: function inviteMppCustomer(name, email, mppAdminId) {
	            return _axios2.default.post(INVITE_MPP_CUSTOMER_URL, { name: name, email: email, mppAdminId: mppAdminId }, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'setMppManagerPermissions',
	        value: function setMppManagerPermissions(manager, companies) {
	            return _axios2.default.post(MPP_PERMISSIONS_URL, {
	                manager: manager,
	                companies: companies
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (result) {
	                return result.data;
	            });
	        }
	    }, {
	        key: 'resetPassword',
	        value: function resetPassword(email) {
	            return _axios2.default.post(RESET_URL, { email: email });
	        }
	    }]);
	
	    return User;
	}(_model2.default);
	
	exports.default = User;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _promisifySync = __webpack_require__(559);
	
	var _promisifySync2 = _interopRequireDefault(_promisifySync);
	
	var _validate2 = __webpack_require__(58);
	
	var _validate3 = _interopRequireDefault(_validate2);
	
	var _validators = __webpack_require__(562);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// extend validators with a set of our own
	// TODO turn into a library so we can just do
	// `import validate from 'lib/validate'` and not have to do this here.
	Object.assign(_validate3.default.validators, _validators2.default || {});
	
	var log = (0, _log2.default)('base-model');
	
	var _class = function (_PromisifySync) {
	    _inherits(_class, _PromisifySync);
	
	    function _class() {
	        var _ret;
	
	        _classCallCheck(this, _class);
	
	        // by default all models are soft deletable
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	
	        _this.softDelete = true;
	        return _ret = _this, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class, [{
	        key: 'baseUrl',
	        value: function baseUrl() {
	            return _config2.default.apiUrl + _.result(this, 'urlRoot');
	        }
	    }, {
	        key: 'finalUrl',
	        value: function finalUrl() {
	            return _config2.default.apiUrl + _.result(this, 'url');
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {};
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'initialize', this).apply(this, arguments);
	            if (this.get(this.idAttribute)) {
	                this.id = this.get(this.idAttribute);
	            }
	
	            this.unsavedAttributes = {};
	            this.on('change', this.trackChangedAttributes, this);
	            this.on('sync', this.resetChangedAttributes, this);
	            return this;
	        }
	    }, {
	        key: 'setAdditionalConstraints',
	        value: function setAdditionalConstraints(additionalConstraints) {
	            this.additionalConstraints = additionalConstraints;
	        }
	    }, {
	        key: 'validate',
	        value: function validate(attrs) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            options = Object.assign({ validateAttrs: {} }, options);
	            var pickConstraints = function pickConstraints(constraints) {
	                var keys = options.validateAttrs.include || (options.validateAttrs.exclude ? Object.keys(attrs).filter(function (attr) {
	                    return !options.validateAttrs.exclude.includes(attr);
	                }) : Object.keys(attrs));
	                var r = {};
	                keys.forEach(function (key) {
	                    return r[key] = constraints[key];
	                });
	                return r;
	            };
	            var constraints = (options.validateAttrs.include || options.validateAttrs.exclude || []).length ? pickConstraints(this.constraints()) : this.constraints();
	
	            if (this.additionalConstraints) {
	                var ret = Object.assign({}, (0, _validate3.default)(attrs, constraints), (0, _validate3.default)(attrs, this.additionalConstraints));
	                return Object.keys(ret).length === 0 ? false : ret;
	            }
	            return (0, _validate3.default)(attrs, constraints) || false;
	        }
	    }, {
	        key: 'wasValid',
	        value: function wasValid() {
	            return this.validationError === false || !Object.keys(this.validationError || {}).length;
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid(options) {
	            this.validationError = this.validate(this.attributes, options);
	            return this.validationError === false;
	        }
	    }, {
	        key: 'getFormatted',
	        value: function getFormatted(attr, format) {
	            var value = this.get(attr);
	            return (0, _moment2.default)(value).format(format);
	        }
	
	        // We used to check `this.changedAttributes()` but according to the
	        // documentation, it tracks changes after every call to set(). Because
	        // of this it was not really suiting our needs. `dirty()` now returns
	        // true only if there have been changes after `sync`.
	
	    }, {
	        key: 'trackChangedAttributes',
	        value: function trackChangedAttributes(model) {
	            this.unsavedAttributes = Object.assign(this.unsavedAttributes, model.changed);
	        }
	    }, {
	        key: 'resetChangedAttributes',
	        value: function resetChangedAttributes() {
	            this.unsavedAttributes = {};
	        }
	    }, {
	        key: 'dirty',
	        value: function dirty() {
	            var isDirty = !!Object.keys(this.unsavedAttributes).length;
	            log.debug('Checking dirtyness for ' + this.id + ':', isDirty ? 'It\'s dirty: ' : 'All clean.', Object.keys(this.unsavedAttributes).join(', '));
	            return isDirty;
	        }
	    }, {
	        key: 'dirtyKeys',
	        value: function dirtyKeys() {
	            return Object.keys(this.unsavedAttributes || {});
	        }
	    }, {
	        key: 'set',
	        value: function set(attr, value) {
	            var _this2 = this;
	
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var changes = {};
	            if (typeof attr === 'string') {
	                changes[attr] = value;
	            } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && options === false) {
	                options = value;
	            }
	
	            if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) === 'object') {
	                changes = attr;
	            }
	
	            options = Object.assign({
	                validateAttrs: { include: Object.keys(changes) },
	                validate: true
	            }, options || {});
	
	            // If the attribute has an object value backbone doesn't trigger
	            // a change event so we add it to unsavedAttributes manually
	            if (typeof attr === 'string' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	                this.unsavedAttributes = Object.assign(this.unsavedAttributes, changes);
	            }
	
	            Object.keys(changes).forEach(function (attr) {
	                if (_this2.validationError && _this2.validationError[attr]) {
	                    delete _this2.validationError[attr];
	                }
	            });
	
	            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'set', this).call(this, changes, options);
	        }
	
	        // We need to send the patch option so that backbone uses `PATCH`
	        // requests instead of `PUT` (which is currently not supported)
	
	    }, {
	        key: 'save',
	        value: function save(attrs) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            // if the model is new we send whatever came as the first argument
	            // (if we send `this.unsavedAttributes || {}` backbone does a PATCH
	            // request instead of POST for new models), else we try to send only
	            // what was modified in the client.
	            var attributes = this.isNew() ? attrs : attrs || this.unsavedAttributes || {};
	
	            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'save', this).call(this, attributes, Object.assign(options, { patch: true }));
	        }
	
	        // To all requests that go through Backbone: add access token if present,
	        // and set the URL
	
	    }, {
	        key: 'sync',
	        value: function sync(method, model, options) {
	            if (app.user) {
	                var accessToken = app.user.getAccessToken();
	                options = Object.assign({}, options || {}, { url: model.finalUrl() });
	                if (accessToken && accessToken.id) {
	                    options = Object.assign({}, options, {
	                        headers: { 'Authorization': accessToken.id }
	                    });
	                }
	            }
	
	            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'sync', this).call(this, method, model, options);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            if (this.softDelete !== true) {
	                return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'destroy', this).apply(this, arguments);
	            }
	
	            return this.save({ hiddenAt: new Date() }, { silent: true });
	        }
	    }]);
	
	    return _class;
	}((0, _promisifySync2.default)(Backbone.Model));
	
	exports.default = _class;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _errors = __webpack_require__(560);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {};
	
	exports.default = function (superclass) {
	    return function (_superclass) {
	        _inherits(_class, _superclass);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: '_successCallback',
	
	            /**
	             * _successCallback - Wrapper for the real success callback so we can
	             *  promisify it
	             *
	             * @param  {function} callback the original callback
	             * @param  {object} options A backbone style options object
	             * @param  {function} resolver A promise resolver function
	             * @return {function}
	             */
	            value: function _successCallback(callback, options, resolver) {
	                var _this2 = this;
	
	                return function (xhr, status, error) {
	                    resolver(_this2, xhr, status, error);
	                    callback.call(_this2, xhr, status, error);
	                };
	            }
	
	            /**
	             * _errorCallback - Wrapper for the real error callback so we can
	             *  promisify it
	             *
	             * @param  {function} callback the original callback
	             * @param  {object} options A backbone style options object
	             * @param  {function} rejecter A promise rejecter function
	             * @return {function}
	             */
	
	        }, {
	            key: '_errorCallback',
	            value: function _errorCallback(callback, options, rejecter) {
	                var _this3 = this;
	
	                return function (xhr, status, error) {
	                    callback.call(_this3, xhr, status, error);
	                    rejecter(new _errors2.default(_this3, xhr.responseJSON || xhr.responseText, options));
	                };
	            }
	
	            /**
	             * sync - An overriden sync method that returns a promise
	             *
	             * @param  {string} method The method used to sync agains the server
	             * @param  {external:Backbone.Model} model A model
	             * @param  {object} options A backbone style options object
	             * @return {external:Promise} A promise that will be resolved or rejected
	             *  depending on what the server replies
	             */
	
	        }, {
	            key: 'sync',
	            value: function sync(method, model, options) {
	                var _this4 = this;
	
	                var success = options.success || noop;
	                var error = options.error || noop;
	                return new _bluebird2.default(function (resolve, reject) {
	                    options.success = _this4._successCallback(success, options, resolve);
	                    options.error = _this4._errorCallback(error, options, reject);
	                    _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'sync', _this4).call(_this4, method, model, options);
	                });
	            }
	
	            /**
	             * save - An overriden save method that *always* returns a promise. The
	             * emphasis on always is because if the model validation fails, backbone
	             * returns false by default instead of calling the error callback.
	             *
	             * @return {external:Promise}
	             */
	
	        }, {
	            key: 'save',
	            value: function save() {
	                var r = _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'save', this).apply(this, arguments);
	                if (r === false) {
	                    return (0, _bluebird.reject)(this.validationError);
	                }
	                return r;
	            }
	        }]);
	
	        return _class;
	    }(superclass);
	};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _syncError = __webpack_require__(561);
	
	var _syncError2 = _interopRequireDefault(_syncError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _syncError2.default;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * SyncError - An error object for model syncronization errors
	 */
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyncError = function (_Error) {
	    _inherits(SyncError, _Error);
	
	    /**
	     * constructor
	     * @constructor
	     * @param  {external:Backbone.Model} model - The model that was being sync'd
	     * @param  {external:jqXhr} response - An XHR object
	     * @param  {object} options - A Backbone-style options object
	     * @return {SyncError}
	     */
	    function SyncError(model, response, options) {
	        var _ret;
	
	        _classCallCheck(this, SyncError);
	
	        if (typeof response === 'string') {
	            var _this = _possibleConstructorReturn(this, (SyncError.__proto__ || Object.getPrototypeOf(SyncError)).call(this, response.error));
	        } else {
	            var _this = _possibleConstructorReturn(this, (SyncError.__proto__ || Object.getPrototypeOf(SyncError)).call(this));
	        }
	
	        _this.stack = new Error().stack;
	        _this.name = _this.constructor.name;
	
	        _this.model = model;
	        _this.collection = model;
	        _this.response = response;
	        _this.options = options;
	        var error = (response || {}).error;
	        _this.status = (error ? error.status : 0) || 500;
	
	        if (response.error instanceof Array) {
	            _this.messages = response.error.map(function (err) {
	                return err.message;
	            });
	        } else {
	            _this.messages = [response.error.message || 'Unknown error'];
	        }
	
	        return _ret = _this, _possibleConstructorReturn(_this, _ret);
	    }
	
	    return SyncError;
	}(Error);
	
	exports.default = SyncError;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var moment = __webpack_require__(101);
	
	module.exports = {
	    isValidIdStr: function isValidIdStr(value, options, key, attributes) {
	        var date = void 0;
	        var idStr = (value || '').replace(/_/g, '');
	
	        if (attributes.idType !== 1) {
	            return null;
	        }
	
	        if (idStr.replace(/-/g, '').length === 0) {
	            return null;
	        }
	
	        if (idStr.length < 14) {
	            return 'is too short';
	        }
	
	        if (parseInt(value.substr(0, 2), 10) > 15) {
	            value = '19' + value;
	        } else {
	            value = '20' + value;
	        }
	
	        date = moment(value.substr(0, 8) + '+00:00', 'YYYYMMDDZ').utcOffset(0);
	        return date.isValid() ? null : ' is not valid';
	    },
	
	    batchPaymentSettings: function batchPaymentSettings(value, options, key, attributes) {
	        if (!attributes.bankAccountId) {
	            return null;
	        }
	
	        if (!attributes.isCreditingDateRequired) {
	            return null;
	        }
	
	        if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || typeof value.creditingDate === 'undefined') {
	            return 'are not valid. Missing crediting date.';
	        }
	
	        return null;
	    }
	};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Companies = function (_Collection) {
	    _inherits(Companies, _Collection);
	
	    function Companies() {
	        _classCallCheck(this, Companies);
	
	        return _possibleConstructorReturn(this, (Companies.__proto__ || Object.getPrototypeOf(Companies)).apply(this, arguments));
	    }
	
	    _createClass(Companies, [{
	        key: 'url',
	        value: function url() {
	            if (this.user && this.user.get('role') === 'employer') {
	                return this.user.url() + '/companies';
	            }
	
	            if (this.user && this.user.get('role') === 'mpp_admin') {
	                return this.user.url() + '/mppCompanies';
	            }
	
	            if (this.user && this.user.get('role') === 'mpp_manager') {
	                return this.user.url() + '/mppManagedCompanies';
	            }
	
	            return '/Companies';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$user = _ref.user,
	                user = _ref$user === undefined ? null : _ref$user,
	                _ref$mppSearchString = _ref.mppSearchString,
	                mppSearchString = _ref$mppSearchString === undefined ? '' : _ref$mppSearchString;
	
	            this.model = _company2.default;
	            _get(Companies.prototype.__proto__ || Object.getPrototypeOf(Companies.prototype), 'initialize', this).apply(this, arguments);
	
	            this.mppSearchString = mppSearchString;
	            this.mppSearchableAttributes = ['username', 'name'];
	            this.searchableAttributes = ['companyName', 'contactName', 'contactEmail', 'username'];
	            this.user = user;
	
	            return this;
	        }
	    }, {
	        key: 'getMppSearchTerm',
	        value: function getMppSearchTerm() {
	            return this.mppSearchString || '';
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var mppWhere = { or: [] };
	            if (this.mppSearchString !== '') {
	                var escapedString = this.mppSearchString.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	                this.mppSearchableAttributes.forEach(function (attr) {
	                    mppWhere.or.push(_defineProperty({}, attr, { regexp: '/^.*' + escapedString + '.*$/i' }));
	                });
	            }
	
	            if (!mppWhere.or.length) {
	                return _get(Companies.prototype.__proto__ || Object.getPrototypeOf(Companies.prototype), 'fetch', this).call(this, options);
	            }
	
	            var filter = Object.assign(options.filter || {}, { mppWhere: mppWhere });
	            return _get(Companies.prototype.__proto__ || Object.getPrototypeOf(Companies.prototype), 'fetch', this).call(this, Object.assign({}, options, { filter: filter }));
	        }
	    }]);
	
	    return Companies;
	}(_collection2.default);
	
	exports.default = Companies;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _promisifySync = __webpack_require__(559);
	
	var _promisifySync2 = _interopRequireDefault(_promisifySync);
	
	var _loopbackFetch = __webpack_require__(565);
	
	var _loopbackFetch2 = _interopRequireDefault(_loopbackFetch);
	
	var _paginatable = __webpack_require__(566);
	
	var _paginatable2 = _interopRequireDefault(_paginatable);
	
	var _searchable = __webpack_require__(567);
	
	var _searchable2 = _interopRequireDefault(_searchable);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* TODO this is awful, I very briefly experimented with the idea of making a
	 * compose function but it was throwing a weird type error so I reverted back
	 * to this "way" of composing functions. Should try again sometime.
	 * TODO Do we want to make all collections searchable and paginatable?
	 */
	var _class = function (_Searchable) {
	    _inherits(_class, _Searchable);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	        key: 'initialize',
	        value: function initialize(models, options) {
	            this.removedModels = [];
	            this.searchableAttributes = [];
	            this.searchTerm = '';
	
	            this.options = Object.assign({
	                syncRemove: false,
	                sortKey: null,
	                sortOrder: null
	            }, options || {});
	
	            if (this.options.syncRemove) {
	                this.on('remove', this.destroyLater, this);
	            }
	            this.on('reset', this.invalidateModelsAfterReset, this);
	
	            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(a, b) {
	            if (typeof this.options.sortKey !== 'string') {
	                return 0;
	            }
	
	            if (typeof (a || {}).get !== 'function' || typeof (b || {}).get !== 'function') {
	                return;
	            }
	
	            a = a.get(this.options.sortKey);
	            b = b.get(this.options.sortKey);
	
	            return this.valueComparator(a, b);
	        }
	    }, {
	        key: 'valueComparator',
	        value: function valueComparator(a, b) {
	            var order = this.options.sortOrder || 'ascending';
	
	            if (typeof a === 'string') {
	                a = a.toLowerCase();
	            }
	            if (typeof b === 'string') {
	                b = b.toLowerCase();
	            }
	
	            if (a instanceof Date) {
	                a = a.getTime();
	            }
	            if (b instanceof Date) {
	                b = b.getTime();
	            }
	
	            return order === 'ascending' ? a < b ? -1 : a > b ? 1 : 0 : a < b ? 1 : a > b ? -1 : 0;
	        }
	    }, {
	        key: 'setOptions',
	        value: function setOptions(options) {
	            this.options = Object.assign(this.options, options || {});
	        }
	    }, {
	        key: 'isNew',
	        value: function isNew() {
	            return this.reduce(function (memo, model) {
	                return memo && model.isNew();
	            }, true);
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.reduce(function (memo, model) {
	                return memo && model.isValid();
	            }, true);
	        }
	    }, {
	        key: 'getSort',
	        value: function getSort() {
	            return {
	                key: this.options.sortKey,
	                order: this.options.sortOrder
	            };
	        }
	    }, {
	        key: 'finalUrl',
	        value: function finalUrl() {
	            return _config2.default.apiUrl + _.result(this, 'url');
	        }
	    }, {
	        key: 'dirty',
	        value: function dirty() {
	            return this.reduce(function (m, model) {
	                return m || model.dirty() || model.isNew();
	            }, false) || this.removedModels.length > 0;
	        }
	    }, {
	        key: 'count',
	        value: function count() {
	            var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var url = this.finalUrl() + '/count';
	            return (0, _axios2.default)({
	                method: 'get',
	                url: url,
	                params: { where: where },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (_ref) {
	                var data = _ref.data;
	                return data.count || 0;
	            });
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var sorting = this.getSort();
	            var filter = Object.assign(this.options.filter || {}, options.filter || {});
	
	            if (sorting.key) {
	                filter.order = sorting.key + ' ' + (sorting.order === 'descending' ? 'DESC' : 'ASC');
	            }
	
	            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'fetch', this).call(this, Object.assign(options, { filter: filter }));
	        }
	    }, {
	        key: 'headers',
	        value: function headers() {
	            var r = {};
	            if (app.user) {
	                var accessToken = app.user.getAccessToken();
	                if (accessToken && accessToken.id) {
	                    r = Object.assign(r, {
	                        'Authorization': accessToken.id
	                    });
	                }
	            }
	
	            return r;
	        }
	    }, {
	        key: 'sync',
	        value: function sync(method, collection, options) {
	            options = Object.assign({}, options || {}, {
	                url: _config2.default.apiUrl + _.result(collection, 'url')
	            });
	            options.headers = Object.assign({}, options.headers || {}, this.headers());
	            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'sync', this).call(this, method, collection, options);
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this2 = this;
	
	            return (0, _bluebird.all)(this.filter(function (model) {
	                return model.dirty() || model.isNew();
	            }).map(function (model) {
	                return model.save().then(function () {
	                    return model.fetch();
	                });
	            })).then(function () {
	                if (!_this2.options.syncRemove || _this2.removedModels.length === 0) {
	                    return (0, _bluebird.resolve)();
	                }
	
	                return (0, _bluebird.join)(_this2.removedModels.map(function (model) {
	                    return model.destroy();
	                })).then(function () {
	                    return _this2.removedModels = [];
	                });
	            }).then(function () {
	                return _this2;
	            });
	        }
	    }, {
	        key: 'destroyLater',
	        value: function destroyLater(model) {
	            if (!model.id) {
	                return;
	            }
	
	            if (!this.removedModels.find(function (m) {
	                return m.id === model.id;
	            })) {
	                this.removedModels.push(model);
	            }
	            return this;
	        }
	    }, {
	        key: 'invalidateModelsAfterReset',
	        value: function invalidateModelsAfterReset(collection, options) {
	            if (options.previousModels && options.previousModels.length > 0) {
	                this.forEach(function (model) {
	                    var oldModel = options.previousModels.find(function (m) {
	                        return m.id === model.id;
	                    });
	                    if (oldModel) {
	                        var changes = {};
	                        Object.keys(model.attributes).forEach(function (attr) {
	                            if (!_.isEqual(model.attributes[attr], oldModel.attributes[attr])) {
	                                changes[attr] = model.attributes[attr];
	                            }
	                        });
	                        Object.keys(oldModel.unsavedAttributes).forEach(function (attr) {
	                            if (_.isEqual(model.attributes[attr], oldModel.unsavedAttributes[attr])) {
	                                changes[attr] = model.attributes[attr];
	                            }
	                        });
	                        model.unsavedAttributes = Object.assign(model.unsavedAttributes, changes);
	                    }
	                });
	            }
	        }
	    }]);
	
	    return _class;
	}((0, _searchable2.default)((0, _paginatable2.default)((0, _loopbackFetch2.default)((0, _promisifySync2.default)(Backbone.Collection)))));
	
	exports.default = _class;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (superclass) {
	    return function (_superclass) {
	        _inherits(_class, _superclass);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: "fetch",
	            value: function fetch() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                options.data = Backbone.$.param({
	                    filter: JSON.stringify(options.filter || {})
	                });
	
	                return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), "fetch", this).call(this, options);
	            }
	        }]);
	
	        return _class;
	    }(superclass);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (superclass) {
	    return function (_superclass) {
	        _inherits(_class, _superclass);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: 'initialize',
	            value: function initialize(models) {
	                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                if (options.pagination !== false) {
	                    this.pagination = Object.assign({
	                        page: 0,
	                        rowsPerPage: 30
	                    }, options.pagination || {});
	                }
	
	                return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'initialize', this).apply(this, arguments);
	            }
	        }, {
	            key: 'fetchPage',
	            value: function fetchPage() {
	                var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                if (n !== null) {
	                    this.pagination.page = n;
	                }
	                return this.fetch(options);
	            }
	        }, {
	            key: 'fetch',
	            value: function fetch() {
	                var _this2 = this;
	
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                if (!this.pagination) {
	                    return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'fetch', this).call(this, options);
	                }
	
	                var where = (options.filter || {}).where;
	                if (where && (typeof where === 'undefined' ? 'undefined' : _typeof(where)) === 'object') {
	                    this._where = where;
	                }
	
	                if (this.pagination.page < 0) {
	                    this.pagination.page = 0;
	                    return (0, _bluebird.resolve)(this);
	                }
	
	                return this.count(this._where).then(function (count) {
	                    _this2.pagination.count = count;
	                    _this2.pagination.pages = Math.ceil(count / _this2.pagination.rowsPerPage);
	
	                    if (_this2.pagination.page > _this2.pagination.pages - 1) {
	                        _this2.pagination.page = _this2.pagination.pages - 1;
	                        _this2.trigger('sync');
	                        return (0, _bluebird.resolve)(_this2);
	                    }
	
	                    _this2.pagination.limit = _this2.pagination.rowsPerPage;
	                    _this2.pagination.offset = _this2.pagination.page * _this2.pagination.rowsPerPage;
	
	                    var filter = Object.assign(options.filter || {}, {
	                        where: _this2._where ? _this2._where : undefined,
	                        limit: _this2.pagination.limit,
	                        offset: _this2.pagination.offset
	                    });
	                    return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'fetch', _this2).call(_this2, Object.assign({}, options, { filter: filter }));
	                });
	            }
	        }, {
	            key: 'nextPage',
	            value: function nextPage() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                return this.fetchPage(this.pagination.page + 1, options);
	            }
	        }, {
	            key: 'prevPage',
	            value: function prevPage() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                return this.fetchPage(this.pagination.page - 1, options);
	            }
	        }, {
	            key: 'getPaginationInfo',
	            value: function getPaginationInfo() {
	                return this.pagination;
	            }
	        }]);
	
	        return _class;
	    }(superclass);
	};

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (superclass) {
	    return function (_superclass) {
	        _inherits(_class, _superclass);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: 'initialize',
	            value: function initialize(models) {
	                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                this.searchString = options.searchString || '';
	                this.searchableAttributes = [];
	                return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'initialize', this).apply(this, arguments);
	            }
	        }, {
	            key: 'search',
	            value: function search() {
	                var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                this.searchString = str;
	                return this.fetch(options);
	            }
	        }, {
	            key: 'fetch',
	            value: function fetch() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                var where = { or: [] };
	                if (this.searchString !== '') {
	                    var escapedString = this.searchString.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	                    this.searchableAttributes.forEach(function (attr) {
	                        where.or.push(_defineProperty({}, attr, { regexp: '/^.*' + escapedString + '.*$/i' }));
	                    });
	                }
	
	                if (!where.or.length) {
	                    return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'fetch', this).call(this, options);
	                }
	
	                where = Object.assign(options.filter && options.filter.where || {}, where);
	                var filter = Object.assign(options.filter || {}, { where: where });
	                return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'fetch', this).call(this, Object.assign({}, options, { filter: filter }));
	            }
	        }, {
	            key: 'getSearchString',
	            value: function getSearchString() {
	                return this.searchString;
	            }
	        }, {
	            key: 'getSearchTerm',
	            value: function getSearchTerm() {
	                return this.getSearchString();
	            }
	        }]);
	
	        return _class;
	    }(superclass);
	};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _bankAccount = __webpack_require__(573);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _attachment = __webpack_require__(579);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _integrations = __webpack_require__(604);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORMS_URL = _config2.default.apiUrl + '/GovernmentForms';
	var BULKUPLOADS_URL = _config2.default.apiUrl + '/BulkUploads';
	
	var Company = function (_Model) {
	    _inherits(Company, _Model);
	
	    function Company() {
	        _classCallCheck(this, Company);
	
	        return _possibleConstructorReturn(this, (Company.__proto__ || Object.getPrototypeOf(Company)).apply(this, arguments));
	    }
	
	    _createClass(Company, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Companies';
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            var daysCalculationTypeConstraint = {
	                numericality: {
	                    onlyInteger: true,
	                    greaterThanOrEqualTo: 1,
	                    lessThanOrEqualTo: 3
	                },
	                presence: true
	            };
	            var fixedDaysConstraint = function fixedDaysConstraint(calculationType) {
	                return {
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 1,
	                        lessThanOrEqualTo: 31
	                    },
	                    presence: calculationType === 1
	                };
	            };
	            return {
	                userId: { presence: true },
	                companyName: {
	                    presence: { message: '^Company Name cannot be blank' }
	                },
	                type: { presence: true },
	                eNumber: {
	                    format: {
	                        pattern: /^\d{1,8}-\d{2}$/,
	                        message: 'Invalid E Number format (Example: 99999999-99)'
	                    },
	                    length: {
	                        is: 11,
	                        message: '^The E Number must be 10 digits long and a hyphen'
	                    }
	                },
	                socsoRegNumber: {
	                    format: {
	                        pattern: /^[a-zA-Z]([0-9]{10})[a-zA-Z]$/,
	                        message: 'Invalid SOCSO Number format (Example: B3201002997A)'
	                    }
	                },
	                contactEmail: { presence: true, email: true },
	                contactName: { presence: true },
	                employeeCount: {
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 0
	                    }
	                },
	                annualLeaveDays: { numericality: true },
	                hospitalizationLeaveDays: { numericality: true },
	                maternityLeaveDays: { numericality: true },
	                medicalLeaveDays: { numericality: true },
	                marriageLeaveDays: { numericality: true },
	                compassionateLeaveDays: { numericality: true },
	
	                // <-- days calculation type -->
	                prorateCalculationType: Object.assign({}, daysCalculationTypeConstraint),
	                prorateFixedDays: function prorateFixedDays(value, attrs) {
	                    return fixedDaysConstraint(attrs.prorateCalculationType);
	                },
	
	                overtimeCalculationType: Object.assign({}, daysCalculationTypeConstraint),
	                overtimeFixedDays: function overtimeFixedDays(value, attrs) {
	                    return fixedDaysConstraint(attrs.overtimeCalculationType);
	                },
	
	                unpaidLeaveCalculationType: function unpaidLeaveCalculationType(value, attrs) {
	                    return attrs.recordUnpaidLeaveInPayroll === true ? Object.assign({}, daysCalculationTypeConstraint) : null;
	                },
	                unpaidLeaveFixedDays: function unpaidLeaveFixedDays(value, attrs) {
	                    return fixedDaysConstraint(attrs.unpaidLeaveCalculationType);
	                },
	                // </- days calculation type -->
	
	                reminderApproveLeaveEmailDays: {
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 0
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            var r = _get(Company.prototype.__proto__ || Object.getPrototypeOf(Company.prototype), 'initialize', this).apply(this, arguments);
	
	            this.locations = new _companyLocations2.default(null, {
	                company: this,
	                pagination: false,
	                syncRemove: true
	            });
	            this.payrolls = new _payrolls2.default(null, {
	                company: this,
	                pagination: false,
	                sortKey: 'periodDate',
	                sortOrder: 'descending'
	            });
	            this.integrations = new _integrations2.default(null, {
	                company: this,
	                pagination: false
	            });
	
	            return r;
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this2 = this,
	                _arguments = arguments;
	
	            if (this.getBankAccount() && this.getBankAccount().dirty()) {
	                return this.bankAccount.save().then(function () {
	                    return _this2.set({ bankAccountId: _this2.bankAccount.id }, { validate: false });
	                }).then(function () {
	                    return _get(Company.prototype.__proto__ || Object.getPrototypeOf(Company.prototype), 'save', _this2).apply(_this2, _arguments);
	                });
	            }
	
	            return _get(Company.prototype.__proto__ || Object.getPrototypeOf(Company.prototype), 'save', this).apply(this, arguments);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            var _this3 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/destroy', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                _this3.trigger('destroy');
	                return _this3;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'isSetUp',
	        value: function isSetUp() {
	            return this.get('isSetUp') || this.isBasicInfoSetUp() && this.get('regNumber') && this.get('eNumber') && this.get('epfRegNumber') && this.get('socsoRegNumber');
	        }
	    }, {
	        key: 'isBasicInfoSetUp',
	        value: function isBasicInfoSetUp() {
	            return this.get('isSetUp') || this.primaryLocation && this.get('companyName') && this.get('type') && this.get('address');
	        }
	    }, {
	        key: 'fetchSubscription',
	        value: function fetchSubscription() {
	            var _this4 = this;
	
	            var user = new _user2.default({
	                id: this.get('mppAdminId') || this.get('userId')
	            });
	            return user.fetchSubscription().then(function (subscription) {
	                _this4.subscription = subscription;
	                return subscription;
	            });
	        }
	    }, {
	        key: 'getSubscription',
	        value: function getSubscription() {
	            return this.subscription;
	        }
	    }, {
	        key: 'fetchBankAccount',
	        value: function fetchBankAccount() {
	            var _this5 = this;
	
	            if (!this.get('bankAccountId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            this.bankAccount = new _bankAccount2.default({
	                objectId: this.get('bankAccountId')
	            }, { validate: false });
	            return this.bankAccount.fetch().then(function () {
	                return _this5.bankAccount;
	            }).catch(function () {
	                _this5.bankAccount = null;
	                return _this5.bankAccount;
	            });
	        }
	    }, {
	        key: 'getBankAccount',
	        value: function getBankAccount() {
	            return this.bankAccount;
	        }
	    }, {
	        key: 'setBankAccount',
	        value: function setBankAccount(bankAccount) {
	            this.bankAccount = bankAccount;
	            this.set({ bankAccountId: bankAccount && bankAccount.id }, { silent: true });
	        }
	    }, {
	        key: 'fetchPrimaryLocation',
	        value: function fetchPrimaryLocation() {
	            var locations = new _companyLocations2.default(null, { company: this });
	            return locations.fetch({ filter: { where: { primary: true, hiddenAt: null } } }).then(function () {
	                return locations.at(0);
	            });
	        }
	    }, {
	        key: 'fetchLocations',
	        value: function fetchLocations() {
	            var _this6 = this;
	
	            return this.locations.fetch({ filter: { where: { hiddenAt: null } } }).then(function () {
	                return _this6.locations;
	            });
	        }
	    }, {
	        key: 'fetchPayrolls',
	        value: function fetchPayrolls() {
	            var _this7 = this;
	
	            return this.payrolls.fetch({ filter: {
	                    where: { status: { neq: null } }
	                } }).then(function () {
	                return _this7.payrolls;
	            });
	        }
	    }, {
	        key: 'destroyUnsavedPayrolls',
	        value: function destroyUnsavedPayrolls() {
	            return new _payrolls2.default(null, { company: this, pagination: false }).fetch({ filter: { where: { status: null } }, validate: false }).then(function (collection) {
	                var payrolls = collection.remove(collection.models, { validate: false });
	                return (0, _bluebird.all)(payrolls.map(function (payroll) {
	                    if (payroll.id) {
	                        return payroll.destroy();
	                    }
	                    return payroll;
	                }));
	            });
	        }
	    }, {
	        key: 'fetchUnsavedPayroll',
	        value: function fetchUnsavedPayroll() {
	            return new _payrolls2.default(null, { company: this, pagination: false }).fetch({
	                filter: {
	                    where: { status: null },
	                    order: '-createdAt',
	                    limit: 1
	                },
	                validate: false
	            }).then(function (collection) {
	                return collection.at(0);
	            });
	        }
	    }, {
	        key: 'fetchCurrentPayroll',
	        value: function fetchCurrentPayroll() {
	            return new _payrolls2.default(null, { company: this, pagination: false }).fetch({ filter: {
	                    where: { status: { lte: 2 } },
	                    order: '-createdAt',
	                    limit: 1
	                } }).then(function (collection) {
	                return collection.at(0);
	            });
	        }
	    }, {
	        key: 'fetchLastSubmittedPayroll',
	        value: function fetchLastSubmittedPayroll() {
	            return new _payrolls2.default(null, { company: this, pagination: false }).fetch({ filter: {
	                    where: { status: { gte: 3 } },
	                    order: '-createdAt',
	                    limit: 1
	                } }).then(function (collection) {
	                return collection.at(0);
	            });
	        }
	    }, {
	        key: 'fetchFormEAEmployees',
	        value: function fetchFormEAEmployees() {
	            var _this8 = this;
	
	            var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _moment2.default)().year() - 1;
	
	            return _axios2.default.get(this.finalUrl() + '/employees/formEA/', {
	                params: {
	                    year: year
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (_ref) {
	                var data = _ref.data;
	                return new _employees2.default(data, { company: _this8 });
	            });
	        }
	    }, {
	        key: 'fetchPayableEmployees',
	        value: function fetchPayableEmployees(payroll) {
	            var rowsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var forPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            if (forPeriod) {
	                forPeriod = (0, _moment2.default)(forPeriod).tz('Asia/Kuala_Lumpur').endOf('month').toDate();
	            }
	            var period = forPeriod || (payroll || new _payroll2.default()).getPeriod().endOf('month').toDate();
	
	            if (payroll && payroll.get('revertedAt')) {
	                if (payroll.get('payslips') <= 0) {
	                    return new _employees2.default(null, { company: this, pagination: false });
	                }
	
	                return payroll.fetchEmployees();
	            }
	
	            var query = { filter: {
	                    where: {
	                        or: [{
	                            and: [{ commencementDate: { neq: null } }, { commencementDate: { lte: period } }],
	                            hiddenAt: null
	                        }, {
	                            and: [{ commencementDate: { neq: null } }, { commencementDate: { lte: period } }, { cessationDate: { neq: null } }, { cessationDate: {
	                                    gte: (0, _moment2.default)(period).startOf('month').toDate()
	                                } }]
	                        }]
	                    }
	                } };
	
	            var pagination = rowsPerPage ? { rowsPerPage: rowsPerPage } : false;
	
	            if (!rowsPerPage) {
	                query.filter.limit = 9999;
	            }
	
	            return new _employees2.default(null, {
	                company: this,
	                pagination: pagination
	            }).fetch(query);
	        }
	    }, {
	        key: 'fetchAttachments',
	        value: function fetchAttachments() {
	            var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var attachments = new _attachments2.default(null, { attachable: this });
	
	            return attachments.fetch({ filter: {
	                    where: {
	                        tags: { inq: tags }
	                    },
	                    limit: 20
	                } });
	        }
	    }, {
	        key: 'fetchIntegration',
	        value: function fetchIntegration() {
	            var _this9 = this;
	
	            return this.integrations.fetch({ filter: {
	                    where: {
	                        or: [{ expiresAt: { gt: new Date() } }, { renewAt: { gt: new Date() } }],
	                        hiddenAt: null
	                    },
	                    order: '-createdAt',
	                    limit: 1
	                } }).then(function () {
	                return _this9.integrations.at(0);
	            });
	        }
	    }, {
	        key: 'getIntegration',
	        value: function getIntegration() {
	            return this.integrations.at(0);
	        }
	    }, {
	        key: 'getCompanyRegNumbers',
	        value: function getCompanyRegNumbers() {
	            return {
	                eNumber: 'E Number',
	                regNumber: 'Company Registration Number',
	                epfRegNumber: 'EPF Number',
	                socsoRegNumber: 'SOCSO Number'
	            };
	        }
	    }, {
	        key: 'getMissingRegNumbers',
	        value: function getMissingRegNumbers() {
	            var _this10 = this;
	
	            var res = [];
	            Object.keys(this.getCompanyRegNumbers()).forEach(function (attr) {
	                var label = _this10.getCompanyRegNumbers()[attr];
	                if (!_this10.get(attr)) {
	                    res.push(label);
	                }
	            });
	            return res;
	        }
	    }, {
	        key: 'sendFormEA',
	        value: function sendFormEA(employeeIds) {
	            var _this11 = this;
	
	            var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)().year() - 1;
	            var ccEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/sendFormEA', { employeeIds: employeeIds, period: period, ccEmail: ccEmail }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this11;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'generateFormE',
	        value: function generateFormE() {
	            var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _moment2.default)().year() - 1;
	
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/generateFormE', { period: period }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'generateFormCp8d',
	        value: function generateFormCp8d() {
	            var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'txt';
	            var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)().year() - 1;
	
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/generateFormCp8d', { period: period, format: format }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'getLeaveDays',
	        value: function getLeaveDays(type) {
	            var days = this.get('leaveDays') || {};
	            return parseFloat(days[type.id]) || 0;
	        }
	    }, {
	        key: 'setLeaveDays',
	        value: function setLeaveDays(options) {
	            var leaveDays = this.get('leaveDays') || {};
	            var type = options.type,
	                days = options.days;
	            var typeId = options.typeId;
	
	
	            if (!typeId) {
	                typeId = type.id;
	            }
	            leaveDays[typeId] = parseFloat(days || 0);
	            this.set('leaveDays', leaveDays);
	        }
	    }, {
	        key: 'setMPPAdmin',
	        value: function setMPPAdmin(mppAdminId) {
	            var _this12 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/setMPPAdmin', { userId: mppAdminId }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this12.fetch({ validate: false });
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'unsetMPPAdmin',
	        value: function unsetMPPAdmin() {
	            var _this13 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/unsetMPPAdmin', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this13.fetch({ validate: false });
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'uploadLogo',
	        value: function uploadLogo() {
	            var _this14 = this;
	
	            var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!file) {
	                return (0, _bluebird.resolve)();
	            }
	
	            // Size limit: 200 kb
	            if (file && file.size && file.size > 1024 * 50) {
	                return (0, _bluebird.reject)({ text: 'The maximum allowed size is 50kb' });
	            }
	
	            if (!/^image\/(png|jpeg)$/.test(file.type)) {
	                return (0, _bluebird.reject)({
	                    text: 'Only PNG or JPEG images are allowed'
	                });
	            }
	
	            var extension = file.name.split('.').pop();
	            var data = new FormData();
	            data.append('file', file, 'company-logo.' + extension);
	
	            // Hack to cover `unsavedAttributes` issue
	            var pendingChanges = Object.assign({}, this.unsavedAttributes || {});
	
	            return _axios2.default.post(this.finalUrl() + '/logo', data, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this14.fetch({ validate: false });
	            }).then(function () {
	                // tracking of `unsavedAtrributes` is working incorrectly as
	                // backbone appends server sent attributes into model without reset
	                _this14.unsavedAttributes = Object.assign(_this14.unsavedAttributes || {}, pendingChanges);
	                _this14.set(pendingChanges);
	            });
	        }
	    }, {
	        key: 'unsetLogo',
	        value: function unsetLogo() {
	            return _axios2.default.delete(this.finalUrl() + '/logo', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            });
	        }
	    }, {
	        key: 'getLogoUrl',
	        value: function getLogoUrl() {
	            if (!this.get('logoUrl')) {
	                return false;
	            }
	
	            return this.finalUrl() + '/logo?' + ('access_token=' + app.user.getAccessToken().id + '&') + ('_b=' + Math.floor(Math.random() * 1000000));
	        }
	    }, {
	        key: 'payslipsTemplateDownloadUrl',
	        value: function payslipsTemplateDownloadUrl() {
	            return BULKUPLOADS_URL + '/downloadPayslipsTemplate/' + this.id + '?' + ('access_token=' + app.user.getAccessToken().id);
	        }
	    }, {
	        key: 'bulkEmployeesTemplateDownloadUrl',
	        value: function bulkEmployeesTemplateDownloadUrl() {
	            return BULKUPLOADS_URL + '/downloadBulkEmployeesTemplate/' + this.id + '?' + ('access_token=' + app.user.getAccessToken().id);
	        }
	    }, {
	        key: 'timesheetsTemplateDownloadUrl',
	        value: function timesheetsTemplateDownloadUrl() {
	            return BULKUPLOADS_URL + '/downloadTimesheetsTemplate/' + this.id + '?' + ('access_token=' + app.user.getAccessToken().id);
	        }
	    }, {
	        key: 'employeeDataUrl',
	        value: function employeeDataUrl() {
	            return this.finalUrl() + '/employee-data?' + ('access_token=' + app.user.getAccessToken().id);
	        }
	    }, {
	        key: 'generateLHDNAuditFiles',
	        value: function generateLHDNAuditFiles() {
	            var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _moment2.default)().year() - 1;
	
	            return _axios2.default.post(this.finalUrl() + '/audit-zip', { year: year }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'setMaxEmployeeCount',
	        value: function setMaxEmployeeCount() {
	            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            return _axios2.default.post(this.finalUrl() + '/maxEmployeeCount', { count: count }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'isAllowAddEmployees',
	        value: function isAllowAddEmployees() {
	            return (this.get('employeeCount') || 0) < (this.get('maxEmployeeCount') || _config2.default.defaultMaxEmployeeCount);
	        }
	    }]);
	
	    return Company;
	}(_model2.default);
	
	exports.default = Company;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.payrollStatus = undefined;
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _payslips = __webpack_require__(581);
	
	var _payslips2 = _interopRequireDefault(_payslips);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _payrollDetails = __webpack_require__(599);
	
	var _payrollDetails2 = _interopRequireDefault(_payrollDetails);
	
	var _payrollIntegrations = __webpack_require__(601);
	
	var _payrollIntegrations2 = _interopRequireDefault(_payrollIntegrations);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORMS_URL = _config2.default.apiUrl + '/GovernmentForms';
	
	var payrollStatus = exports.payrollStatus = {
	    INITIAL: 0, // step 1
	    RAN: 1, // after done with run (beginning of step 2)
	    CONFIRMED: 2, // after clicking "continue" at step 2
	    SUBMITTED: 3,
	    FINISHED: 9 // done
	};
	
	var Payroll = function (_Model) {
	    _inherits(Payroll, _Model);
	
	    _createClass(Payroll, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Payrolls';
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                companyId: { presence: true },
	                status: {
	                    presence: true,
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 0,
	                        lessOrEqualThan: 0
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                submittedDate: null,
	                chequePickupDate: null,
	                periodDate: null,
	                status: 0,
	                lastEditedEmployee: null,
	                employeeEpf: 0,
	                employeeSocso: 0,
	                employerEpf: 0,
	                employerSocso: 0,
	                mtd: 0,
	                cp38: 0,
	                zakat: 0,
	                grossPay: 0,
	                netPay: 0,
	                base: 0,
	                additions: 0,
	                deductions: 0,
	                payslips: 0
	            };
	        }
	    }]);
	
	    function Payroll() {
	        _classCallCheck(this, Payroll);
	
	        var _this = _possibleConstructorReturn(this, (Payroll.__proto__ || Object.getPrototypeOf(Payroll)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(Payroll, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            this.employees = new _employees2.default(null, {
	                company: app.company,
	                pagination: false
	            });
	            this.payslips = new _payslips2.default(null, {
	                payroll: this,
	                pagination: false
	            });
	            this.integrations = new _payrollIntegrations2.default(null, {
	                payroll: this,
	                pagination: false
	            });
	            return _get(Payroll.prototype.__proto__ || Object.getPrototypeOf(Payroll.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'fetchPayslips',
	        value: function fetchPayslips() {
	            var _this2 = this;
	
	            return this.payslips.fetch({ filter: { limit: 9999 } }).then(function () {
	                return _this2.payslips;
	            });
	        }
	    }, {
	        key: 'fetchEmployees',
	        value: function fetchEmployees() {
	            var _this3 = this;
	
	            return new _payslips2.default(null, { payroll: this, pagination: false }).fetch({ filter: { limit: 9999 } }).then(function (payslips) {
	                var ids = payslips.map(function (p) {
	                    return p.get('employeeId');
	                });
	                return _this3.employees.fetch({ filter: {
	                        where: { companyId: _this3.get('companyId') },
	                        limit: 9999
	                    } }).then(function (employees) {
	                    return employees.filter(function (emp) {
	                        return ids.includes(emp.get('objectId'));
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'fetchCompany',
	        value: function fetchCompany() {
	            if (!this.get('companyId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            this.company = new _company2.default({ objectId: this.get('companyId') });
	            return this.company.fetch();
	        }
	    }, {
	        key: 'getCompany',
	        value: function getCompany() {
	            return this.company;
	        }
	    }, {
	        key: 'setCompany',
	        value: function setCompany(company) {
	            if (this.get('companyId') === company.id) {
	                this.company = company;
	            }
	        }
	    }, {
	        key: 'fetchIntegrations',
	        value: function fetchIntegrations() {
	            var _this4 = this;
	
	            var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            return this.integrations.fetch(filter).then(function () {
	                return _this4.integrations;
	            });
	        }
	    }, {
	        key: 'getIntegrations',
	        value: function getIntegrations() {
	            return this.integrations;
	        }
	    }, {
	        key: 'samePeriodAs',
	        value: function samePeriodAs(payroll) {
	            return this.getPeriod().isSame(payroll.getPeriod(), 'month');
	        }
	    }, {
	        key: 'isCurrentPeriod',
	        value: function isCurrentPeriod() {
	            return this.getPeriod().isSame(Payroll.getPeriodFromDate(Date.now()), 'month');
	        }
	    }, {
	        key: 'getStatusLabel',
	        value: function getStatusLabel() {
	            if (this.get('status') < 3) {
	                return 'Saved';
	            } else if (this.get('status') === 9) {
	                return 'Complete';
	            } else {
	                return 'Submitted';
	            }
	        }
	    }, {
	        key: 'getPeriod',
	        value: function getPeriod() {
	            if (this.get('periodDate')) {
	                return (0, _moment2.default)(this.get('periodDate')).tz('Asia/Kuala_Lumpur');
	            }
	
	            return (0, _moment2.default)(Payroll.getPeriodFromDate(this.get('submittedDate') || Date.now())).tz('Asia/Kuala_Lumpur');
	        }
	    }, {
	        key: 'getPeriodFormatted',
	        value: function getPeriodFormatted() {
	            return this.getPeriod().format('MMMM YYYY');
	        }
	    }, {
	        key: 'isCreated',
	        value: function isCreated() {
	            return (this.get('status') || 0) === 0;
	        }
	    }, {
	        key: 'isComplete',
	        value: function isComplete() {
	            return this.get('status') === 9;
	        }
	    }, {
	        key: 'hasPendingJobs',
	        value: function hasPendingJobs() {
	            return _axios2.default.get(this.finalUrl() + '/hasPendingJobs', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'generateForms',
	        value: function generateForms() {
	            var _this5 = this;
	
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/generatePayrollForms', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this5;
	            });
	        }
	    }, {
	        key: 'setStatus',
	        value: function setStatus(status) {
	            var _this6 = this;
	
	            var chequePickupDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return _axios2.default.post(this.finalUrl() + '/setStatus', { status: status, chequePickupDate: chequePickupDate }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this6.fetch();
	            }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                throw err;
	            });
	        }
	    }, {
	        key: 'run',
	        value: function run() {
	            var _this7 = this;
	
	            var includeAllEmployees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            return _axios2.default.post(this.finalUrl() + '/run', { includeAllEmployees: includeAllEmployees }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this7.fetch();
	            }).then(function () {
	                _this7.trigger('running', _this7);
	                _this7.whenDone().then(function () {
	                    _this7.trigger('run-complete', _this7);
	                });
	                return _this7;
	            }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                throw err;
	            });
	        }
	    }, {
	        key: 'whenDone',
	        value: function whenDone() {
	            var _this8 = this;
	
	            var timeout = void 0;
	            var resolver = (0, _bluebird.defer)();
	            var pollStatus = function pollStatus() {
	                return _axios2.default.get(_this8.finalUrl() + '/jobStatus', {
	                    headers: { 'Authorization': app.user.getAccessToken().id }
	                }).then(function (res) {
	                    if (res.data.done === true) {
	                        clearTimeout(timeout);
	                        resolver.resolve(_this8);
	                        return;
	                    }
	
	                    timeout = setTimeout(pollStatus, 2000);
	                }).catch(function (err) {
	                    clearTimeout(timeout);
	                    if (err.response) {
	                        resolver.reject(err.response.data.error);
	                    } else {
	                        resolver.reject(err);
	                    }
	                });
	            };
	
	            pollStatus();
	
	            return resolver.promise;
	        }
	    }, {
	        key: 'revert',
	        value: function revert() {
	            var _this9 = this;
	
	            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            return _axios2.default.post(this.finalUrl() + '/revert', opts, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this9.fetch();
	            });
	        }
	    }, {
	        key: 'resetUnpaidLeave',
	        value: function resetUnpaidLeave() {
	            var _this10 = this;
	
	            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            return _axios2.default.post(this.finalUrl() + '/resetUnpaidLeave', opts, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this10.fetch();
	            });
	        }
	    }, {
	        key: 'resetEmployee',
	        value: function resetEmployee() {
	            var _this11 = this;
	
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee;
	
	            var employeeId = null;
	            if (employee) {
	                employeeId = employee.id;
	            }
	            return _axios2.default.post(this.finalUrl() + '/resetEmployee', { employeeId: employeeId }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                if (!employee) {
	                    return null;
	                }
	
	                var overtimeItems = app.payrollItems.filter(function (p) {
	                    return p.get('type') === 'overtime';
	                }).map(function (p) {
	                    return p.id;
	                });
	
	                var details = new _payrollDetails2.default(null, {
	                    payroll: _this11,
	                    filter: { limit: 9999 },
	                    pagination: false
	                });
	                return details.fetch({ filter: { where: {
	                            employeeId: employeeId,
	                            payrollItemId: { inq: overtimeItems }
	                        } } });
	            }).then(function (details) {
	                return _this11.fixOvertimeAfterReset(details, employee);
	            }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                throw err;
	            });
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            var _this12 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/reset', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                var overtimeItems = app.payrollItems.filter(function (p) {
	                    return p.get('type') === 'overtime';
	                }).map(function (p) {
	                    return p.id;
	                });
	
	                var details = new _payrollDetails2.default(null, {
	                    payroll: _this12,
	                    filter: { limit: 9999 },
	                    pagination: false
	                });
	
	                return details.fetch({ filter: { where: {
	                            payrollItemId: { inq: overtimeItems }
	                        } } });
	            }).then(function (details) {
	                return _this12.fixOvertimeAfterReset(details);
	            }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                throw err;
	            });
	        }
	    }, {
	        key: 'fetchAllPayrollDetails',
	        value: function fetchAllPayrollDetails() {
	            return new _payrollDetails2.default(null, { payroll: this, pagination: false }).fetch({ filter: { limit: 9999 } }).then(function (details) {
	                return details;
	            });
	        }
	    }, {
	        key: 'fixOvertimeAfterReset',
	        value: function fixOvertimeAfterReset(details) {
	            var _this13 = this;
	
	            var employee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return (0, _bluebird.all)(details.map(function (detail) {
	                return detail.createOvertimeInfo(_this13, employee).then(function (detail) {
	                    return detail.save();
	                });
	            }));
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var _this14 = this;
	
	            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (opts.chequePickupDate === null) {
	                delete opts.chequePickupDate;
	            }
	            return _axios2.default.post(this.finalUrl() + '/submit', opts, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this14.fetch();
	            }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                if (err.message === 'Network Error') {
	                    return _this14.fetch();
	                }
	                throw err;
	            });
	        }
	    }, {
	        key: 'sendPayslips',
	        value: function sendPayslips(payslips) {
	            var _this15 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/sendPayslips', { payslips: payslips }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this15;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'calculateBillableAmount',
	        value: function calculateBillableAmount() {
	            return _axios2.default.get(this.finalUrl() + '/billableAmount', { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                return r.data;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'finish',
	        value: function finish() {
	            var _this16 = this;
	
	            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            return _axios2.default.post(this.finalUrl() + '/finish', opts, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this16.fetch();
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'createArchive',
	        value: function createArchive() {
	            var _this17 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/archive', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this17;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'markAsManuallyInvoiced',
	        value: function markAsManuallyInvoiced() {
	            var _this18 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/markAsManuallyInvoiced', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this18;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'syncPayroll',
	        value: function syncPayroll() {
	            var _this19 = this;
	
	            var integration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (integration === null) {
	                throw new Error('Can\'t integrate payroll to an unknown provider');
	            }
	
	            var provider = integration.get('provider');
	            return _axios2.default.post(this.finalUrl() + '/sync', { provider: provider }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this19;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            // 20210706 PPKAN-290 make sure invoice ids are set to null
	            if (this.get('chargebeeInvoiceId') === '') {
	                this.set('chargebeeInvoiceId', null);
	            }
	            if (this.get('chargebeeAdjustmentInvoiceId') === '') {
	                this.set('chargebeeAdjustmentInvoiceId', null);
	            }
	
	            return _get(Payroll.prototype.__proto__ || Object.getPrototypeOf(Payroll.prototype), 'save', this).apply(this, arguments);
	        }
	    }], [{
	        key: 'fetchCurrent',
	        value: function fetchCurrent(company) {
	            var payrolls = new _payrolls2.default(null, {
	                company: company,
	                pagination: false
	            });
	
	            return payrolls.fetch({
	                filter: {
	                    where: {
	                        status: {
	                            lte: 2
	                        }
	                    },
	                    order: 'createdAt DESC',
	                    limit: 1
	                }
	            }).then(function () {
	                return (0, _bluebird.resolve)(payrolls.at(0));
	            });
	        }
	    }, {
	        key: 'getCurrentPeriodDate',
	        value: function getCurrentPeriodDate() {
	            return Payroll.getPeriodFromDate((0, _moment2.default)());
	        }
	    }, {
	        key: 'getPeriodFromDate',
	        value: function getPeriodFromDate(date) {
	            var m = (0, _moment2.default)(date || Date.now()).tz('Asia/Kuala_Lumpur');
	
	            if (m.date() < _config2.default.periodStartDate) {
	                m.subtract(1, 'month');
	            }
	
	            return m.toDate();
	        }
	    }]);
	
	    return Payroll;
	}(_model2.default);
	
	exports.default = Payroll;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _timeEntries = __webpack_require__(595);
	
	var _timeEntries2 = _interopRequireDefault(_timeEntries);
	
	var _defaultPayrollDetails = __webpack_require__(596);
	
	var _defaultPayrollDetails2 = _interopRequireDefault(_defaultPayrollDetails);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Employees = function (_Collection) {
	    _inherits(Employees, _Collection);
	
	    function Employees() {
	        _classCallCheck(this, Employees);
	
	        return _possibleConstructorReturn(this, (Employees.__proto__ || Object.getPrototypeOf(Employees)).apply(this, arguments));
	    }
	
	    _createClass(Employees, [{
	        key: 'url',
	        value: function url() {
	            if (this.employee) {
	                return this.employee.url() + '/managedEmployees';
	            }
	
	            if (this.company) {
	                return this.company.url() + '/Employees';
	            }
	
	            if (this.companyLocation) {
	                return this.companyLocation.url() + '/employees';
	            }
	
	            return '/Employees';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company,
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee,
	                _ref$companyLocation = _ref.companyLocation,
	                companyLocation = _ref$companyLocation === undefined ? null : _ref$companyLocation;
	
	            _get(Employees.prototype.__proto__ || Object.getPrototypeOf(Employees.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _employee2.default;
	            this.searchableAttributes = ['idStr', 'email', 'fullName'];
	            this.company = company;
	            this.employee = employee;
	            this.companyLocation = companyLocation;
	
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'canonicalFullName';
	            }
	            return this;
	        }
	    }, {
	        key: 'fetchTimeEntries',
	        value: function fetchTimeEntries(company) {
	            var _this2 = this;
	
	            var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	            // we fetch only the current months entries -/+ 6 days in case
	            // we are displaying a week that is partially in the previous or the
	            // next month
	            var monthStart = (0, _moment2.default)(date).startOf('month').add(-6, 'days');
	            var monthEnd = (0, _moment2.default)(date).endOf('month').add(6, 'days');
	            var employees = this.map(function (model) {
	                model._timeEntries = new _timeEntries2.default(null, { employee: model });
	                return model;
	            });
	            var entries = new _timeEntries2.default(null, {
	                company: company,
	                sortKey: 'payrollItemId',
	                pagination: { rowsPerPage: 5000 }
	            });
	            return entries.fetch({
	                filter: {
	                    where: {
	                        employeeId: {
	                            inq: employees.map(function (employee) {
	                                return employee.get('objectId');
	                            })
	                        },
	                        and: [{ date: { lte: monthEnd } }, { date: { gte: monthStart } }]
	                    }
	                }
	            }).then(function () {
	                entries.forEach(function (entry) {
	                    _this2.get(entry.get('employeeId'))._timeEntries.add(entry);
	                });
	            }).then(function () {
	                return (0, _bluebird.all)(_this2.map(function (employee) {
	                    // Force add recurring OT
	                    var details = new _defaultPayrollDetails2.default(null, { employee: employee });
	                    return details.fetch({ filter: { where: { hiddenAt: null } } }).then(function () {
	                        var otDetails = details.filter(function (d) {
	                            return d.getPayrollItem().get('type') === 'overtime';
	                        });
	                        var items = otDetails.map(function (d) {
	                            return d.getPayrollItem();
	                        });
	                        items.forEach(function (item) {
	                            return employee.getTimeEntry(date, item);
	                        });
	                    });
	                }));
	            }).then(function () {
	                return _this2;
	            });
	        }
	    }, {
	        key: 'saveTimeEntries',
	        value: function saveTimeEntries() {
	            var timeEntries = new _timeEntries2.default(null, {});
	            this.forEach(function (employee) {
	                timeEntries.add(employee._timeEntries.models);
	            });
	            return timeEntries.save();
	        }
	    }, {
	        key: 'dirtyTimeEntries',
	        value: function dirtyTimeEntries() {
	            var dirty = this.find(function (employee) {
	                return employee._timeEntries.dirty();
	            });
	            return !!dirty;
	        }
	    }]);
	
	    return Employees;
	}(_collection2.default);
	
	exports.default = Employees;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.consts = undefined;
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _bankAccount = __webpack_require__(573);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _companyLocation = __webpack_require__(574);
	
	var _companyLocation2 = _interopRequireDefault(_companyLocation);
	
	var _timeEntry = __webpack_require__(575);
	
	var _timeEntry2 = _interopRequireDefault(_timeEntry);
	
	var _position = __webpack_require__(576);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _employeeRemoval = __webpack_require__(577);
	
	var _employeeRemoval2 = _interopRequireDefault(_employeeRemoval);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _attachment = __webpack_require__(579);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _payslips = __webpack_require__(581);
	
	var _payslips2 = _interopRequireDefault(_payslips);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _leaveApprovals = __webpack_require__(587);
	
	var _leaveApprovals2 = _interopRequireDefault(_leaveApprovals);
	
	var _itemYearlyTotals = __webpack_require__(589);
	
	var _itemYearlyTotals2 = _interopRequireDefault(_itemYearlyTotals);
	
	var _countriesList = __webpack_require__(594);
	
	var _countriesList2 = _interopRequireDefault(_countriesList);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/employee');
	
	var FORMS_URL = _config2.default.apiUrl + '/GovernmentForms';
	
	// TODO We don't have the time to go down the rabbit hole of getting rid
	// of these "consts" and constValue, but we have to eventually.
	var constValues = function constValues(re) {
	    return _.map(_.filter(_.keys(consts), function (constName) {
	        return re.test(constName);
	    }), function (constName) {
	        return consts[constName];
	    });
	};
	var consts = exports.consts = {
	    GENDER_MALE: 1,
	    GENDER_FEMALE: 2,
	
	    MARRIED_STATUS_DEFAULT: 1,
	    MARRIED_STATUS_SINGLE: 1,
	    MARRIED_STATUS_SINGLE_WITH_CHILDREN: 2,
	    MARRIED_STATUS_DIVORCED: 3,
	    MARRIED_STATUS_SPOUSE_WORKING: 4,
	    MARRIED_STATUS_SPOUSE_NOT_WORKING: 5,
	
	    RESIDENT_SUBTYPE_NORMAL: 0,
	    RESIDENT_SUBTYPE_KNOWLEDGE_WORKER: 1,
	    RESIDENT_SUBTYPE_REP: 2,
	    RESIDENT_SUBTYPE_FREELANCER: 3,
	    RESIDENT_SUBTYPE_PART_TIME: 4,
	    RESIDENT_SUBTYPE_DEFAULT: 0,
	
	    ID_TYPE_DEFAULT: 1,
	    ID_TYPE_IC_NUMBER: 1,
	    ID_TYPE_PASSPORT: 2,
	
	    RACE_DEFAULT: 0,
	    RACE_NONE: 1,
	    RACE_MALAY: 1,
	    RACE_CHINESE: 2,
	    RACE_INDIAN: 3,
	    RACE_OTHER: 4,
	
	    EARNINGS_FREQUENCY_DEFAULT: 3,
	    EARNINGS_FREQUENCY_HOURLY: 1,
	    EARNINGS_FREQUENCY_DAILY: 2,
	    EARNINGS_FREQUENCY_MONTHLY: 3,
	
	    EPF_EMPLOYER_RATE_DEFAULT: 1,
	    EPF_EMPLOYER_RATE_GOVT_TABLE: 1,
	    EPF_EMPLOYER_RATE_5RM: 2,
	
	    SOCSO_CATEGORY_DEFAULT: 1,
	    SOCSO_CATEGORY_NONE: 0,
	    SOCSO_CATEGORY_INJURY_AND_INVALIDITY: 1,
	    SOCSO_CATEGORY_INJURY: 2,
	
	    PAYMENT_METHOD_DEFAULT: 0,
	    PAYMENT_METHOD_NONE: 0,
	    PAYMENT_METHOD_BANK_TRANSFER: 1,
	    PAYMENT_METHOD_CASH: 2,
	    PAYMENT_METHOD_CHEQUE: 3
	};
	
	var Employee = function (_Model) {
	    _inherits(Employee, _Model);
	
	    _createClass(Employee, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Employees';
	        }
	    }, {
	        key: 'url',
	        value: function url() {
	            if (this.user && !this.get(this.idAttribute)) {
	                return this.user.url() + '/employee';
	            }
	
	            return _get(Employee.prototype.__proto__ || Object.getPrototypeOf(Employee.prototype), 'url', this).call(this);
	        }
	    }]);
	
	    function Employee() {
	        _classCallCheck(this, Employee);
	
	        var _this = _possibleConstructorReturn(this, (Employee.__proto__ || Object.getPrototypeOf(Employee)).apply(this, arguments));
	
	        _this.fieldsAffectingProgress = ['fullName', 'idStr', 'dob', 'earningsAmount', 'earningsFrequency', 'commencementDate'];
	        _this.companyLocation = null;
	        _this.position = null;
	        _this.leaveApprovals = new _leaveApprovals2.default(null, {
	            requester: _this, pagination: false
	        });
	        _this.hasPrevItemYearlyTotals = false;
	        _this.isIntern = null;
	        return _this;
	    }
	
	    _createClass(Employee, [{
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                companyId: { presence: true },
	                gender: {
	                    presence: true,
	                    inclusion: constValues(/^GENDER_/)
	                },
	                fullName: {
	                    presence: { message: '^Full Name cannot be blank' }
	                },
	                email: {
	                    email: true
	                },
	                residentSubType: {
	                    presence: true,
	                    inclusion: constValues(/^RESIDENT_SUBTYPE_/)
	                },
	                idType: {
	                    presence: true,
	                    inclusion: constValues(/^ID_TYPE_/)
	                },
	                idStr: {
	                    presence: true,
	                    isValidIdStr: true
	                },
	                race: {
	                    inclusion: constValues(/^RACE_/)
	                },
	                nationality: { presence: true },
	                marriedStatus: {
	                    presence: true,
	                    inclusion: constValues(/^MARRIED_STATUS_/)
	                },
	                pcbDeductionForChildren: {
	                    numericality: {
	                        notLessThan: 0,
	                        notGreaterThan: 100
	                    }
	                },
	                dob: {
	                    presence: {
	                        message: function message(value, attribute, validatorOptions, attributes) {
	                            if (attributes.idType === 1) {
	                                return '^Date of Birth on IC number is invalid';
	                            } else {
	                                return '^Date of Birth cannot be blank';
	                            }
	                        }
	                    }
	                },
	                earningsFrequency: {
	                    inclusion: constValues(/^EARNINGS_FREQUENCY_/)
	                },
	                socsoCategory: { inclusion: constValues(/^SOCSO_CATEGORY_/) },
	                ssfwNumber: {
	                    format: {
	                        pattern: /^\d{12}$/,
	                        message: '^SSFW Number must be 12 digits long'
	                    }
	                },
	                // personalEmail: {email: true},
	                preferredPaymentMethod: {
	                    inclusion: constValues(/^PAYMENT_METHOD_/)
	                },
	                emergencyContactPhone: { format: {
	                        pattern: '[0-9\\(\\)\\+\\- ]+',
	                        message: 'Emergency contact phone must be a valid phone number'
	                    } }
	            };
	        } // eof constraints. TODO Move to a separate file?
	
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                gender: consts.GENDER_MALE,
	                isResident: true,
	                residentSubType: consts.RESIDENT_SUBTYPE_DEFAULT,
	                idType: consts.ID_TYPE_DEFAULT,
	                race: consts.RACE_DEFAULT,
	                nationality: 'MY',
	                isPermanentResident: false,
	                marriedStatus: consts.MARRIED_STATUS_DEFAULT,
	                isDisabled: false,
	                isSpouseDisabled: false,
	                earningsAmount: 0,
	                earningsFrequency: consts.EARNINGS_FREQUENCY_DEFAULT,
	                positionId: null,
	                managerId: null,
	                companyLocationId: null,
	                bankAccountId: null,
	                addressId: null,
	                children: [],
	                socsoCategory: consts.SOCSO_CATEGORY_DEFAULT,
	                ssfwNumber: null,
	                isEpf: false,
	                isEpfMemberBefore1998: false,
	                epfAdditionalRate: 0,
	                epfEmployerRate: consts.EPF_EMPLOYER_RATE_DEFAULT,
	                epfEmployerAdditionalRate: 0,
	                mtdBorneByEmployer: false,
	                isEis: true,
	                commencementDate: null,
	                preferredPaymentMethod: consts.PAYMENT_METHOD_DEFAULT,
	                isSetUp: false,
	                hasPayslips: false,
	                hasValidItemYearlyTotals: false
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(_ref) {
	            var _ref$user = _ref.user,
	                user = _ref$user === undefined ? null : _ref$user,
	                _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company,
	                _ref$address = _ref.address,
	                address = _ref$address === undefined ? null : _ref$address;
	
	            this.idAttribute = 'objectId';
	            _get(Employee.prototype.__proto__ || Object.getPrototypeOf(Employee.prototype), 'initialize', this).apply(this, arguments);
	
	            this.user = user;
	            this.company = company;
	            this.address = address;
	            this.imageChanged = false;
	            this.locationAdded = false;
	            this.on('change:earningsAmount', this.updatePositionInfo, this);
	            this.on('change:earningsFrequency', this.updatePositionInfo, this);
	            this.on('change:idType', this.onIdTypeChange, this);
	            this.on('change:isResident', this.updateEPFEmployerRate, this);
	            this.on('change:isPermanentResident', this.onUpdate, this);
	            this.on('change:nationality', this.onUpdate, this);
	            this.on('change:dob', this.onUpdate, this);
	
	            return this;
	        }
	    }, {
	        key: 'fetchCompany',
	        value: function fetchCompany() {
	            var _this2 = this;
	
	            if (this.company) {
	                return (0, _bluebird.resolve)(this.company);
	            }
	            var company = new _company2.default({ objectId: this.get('companyId') });
	            return company.fetch().then(function (model) {
	                _this2.company = model;
	                return _this2.company;
	            });
	        }
	    }, {
	        key: 'fetchUser',
	        value: function fetchUser() {
	            var _this3 = this;
	
	            if (this.user) {
	                (0, _bluebird.resolve)(this.user);
	            }
	
	            if (!this.get('userId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _user2.default({ id: this.get('userId') }).fetch().then(function (model) {
	                _this3.user = model;
	                return _this3.user;
	            });
	        }
	    }, {
	        key: 'fetchRemoval',
	        value: function fetchRemoval() {
	            var _this4 = this;
	
	            return _employeeRemoval2.default.getForEmployee(this).then(function (employeeRemoval) {
	                _this4.removal = employeeRemoval;
	                return _this4.removal;
	            });
	        }
	    }, {
	        key: 'fetchCompanyLocation',
	        value: function fetchCompanyLocation() {
	            var _this5 = this;
	
	            if (this.companyLocation) {
	                (0, _bluebird.resolve)(this.companyLocation);
	            }
	
	            if (!this.get('companyLocationId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            var companyLocation = app.companyLocations && app.companyLocations.find(function (location) {
	                return location.id === _this5.get('companyLocationId');
	            });
	            if (companyLocation) {
	                this.companyLocation = companyLocation;
	                return (0, _bluebird.resolve)(this.companyLocation);
	            }
	
	            return new _companyLocation2.default({ objectId: this.get('companyLocationId') }).fetch({ validate: false }).then(function (model) {
	                _this5.companyLocation = model;
	                return _this5.companyLocation;
	            });
	        }
	    }, {
	        key: 'getCompanyLocation',
	        value: function getCompanyLocation() {
	            return this.companyLocation;
	        }
	    }, {
	        key: 'fetchPosition',
	        value: function fetchPosition() {
	            var _this6 = this;
	
	            if (this.position) {
	                (0, _bluebird.resolve)(this.position);
	            }
	
	            if (!this.get('positionId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            var position = app.positions.find(function (p) {
	                return p.get('objectId') === _this6.get('positionId');
	            });
	
	            if (position) {
	                this.position = position;
	                return (0, _bluebird.resolve)(position);
	            }
	
	            return new _position2.default({ objectId: this.get('positionId') }, { validate: false }).fetch().then(function (model) {
	                _this6.position = model;
	                return _this6.position;
	            });
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition() {
	            return this.position;
	        }
	    }, {
	        key: 'setPosition',
	        value: function setPosition(position) {
	            if (position === null) {
	                this.set('positionId', null);
	                this.position = null;
	            } else if (position.isNew()) {
	                this.set('positionId', null);
	                this.position = position;
	            } else {
	                this.set('positionId', position.id);
	                this.position = position;
	            }
	        }
	    }, {
	        key: 'fetchAddress',
	        value: function fetchAddress() {
	            var _this7 = this;
	
	            if (this.address && !this.address.isNew() && !this.address.hasChanged()) {
	                (0, _bluebird.resolve)(this.address);
	            }
	
	            if (!this.get('addressId')) {
	                this.address = null;
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _address2.default({ objectId: this.get('addressId') }, { validate: false }).fetch().then(function (model) {
	                _this7.address = model;
	                return _this7.address;
	            });
	        }
	    }, {
	        key: 'getAddress',
	        value: function getAddress() {
	            return this.address;
	        }
	    }, {
	        key: 'setAddress',
	        value: function setAddress(address) {
	            var _this8 = this;
	
	            var old = this.getAddress();
	            if (old) {
	                old.off('sync', null, null);
	            }
	
	            this.set('addressId', address ? address.id : null);
	            this.address = address;
	
	            if (address) {
	                this.address.on('sync', function () {
	                    _this8.set('addressId', _this8.address.id);
	                }, this);
	            }
	        }
	    }, {
	        key: 'fetchBankAccount',
	        value: function fetchBankAccount() {
	            var _this9 = this;
	
	            if (this.bankAccount && !this.bankAccount.isNew() && !this.bankAccount.hasChanged()) {
	                (0, _bluebird.resolve)(this.bankAccount);
	            }
	
	            if (!this.get('bankAccountId')) {
	                this.bankAccount = null;
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _bankAccount2.default({ objectId: this.get('bankAccountId') }, { validate: false }).fetch().then(function (model) {
	                _this9.bankAccount = model;
	                return _this9.bankAccount;
	            }).catch(function () {
	                _this9.bankAccount = null;
	                return _this9.bankAccount;
	            });
	        }
	    }, {
	        key: 'getBankAccount',
	        value: function getBankAccount() {
	            return this.bankAccount;
	        }
	    }, {
	        key: 'setBankAccount',
	        value: function setBankAccount(bankAccount) {
	            var _this10 = this;
	
	            var old = this.getBankAccount();
	            if (old) {
	                old.off('sync', null, null);
	            }
	
	            this.set('bankAccountId', bankAccount ? bankAccount.id : null);
	            this.bankAccount = bankAccount;
	
	            if (bankAccount) {
	                this.bankAccount.on('sync', function () {
	                    _this10.set('bankAccountId', _this10.bankAccount.id);
	                }, this);
	            }
	        }
	    }, {
	        key: 'fetchAttachments',
	        value: function fetchAttachments() {
	            var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var attachments = new _attachments2.default(null, { attachable: this });
	
	            return attachments.fetch({ filter: {
	                    where: {
	                        tags: { inq: tags }
	                    },
	                    limit: 20
	                } });
	        }
	    }, {
	        key: 'getRemovalReason',
	        value: function getRemovalReason() {
	            if (!this.removal) {
	                return '';
	            }
	
	            var reasons = {
	                0: 'Select a reason',
	                1: 'Terminated',
	                2: 'Redundant',
	                3: 'Resigned',
	                4: 'Retired',
	                5: 'Left Malaysia',
	                6: 'Other'
	            };
	
	            return reasons[this.removal.get('reason')];
	        }
	    }, {
	        key: 'getRemovalDate',
	        value: function getRemovalDate() {
	            if (!this.removal) {
	                return '';
	            }
	
	            return (0, _moment2.default)(this.removal.get('removedAt')).format('DD.MM.YYYY');
	        }
	    }, {
	        key: 'invite',
	        value: function invite() {
	            return _axios2.default.post(this.finalUrl() + '/invite', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                throw err;
	            });
	        }
	    }, {
	        key: 'requestChanges',
	        value: function requestChanges(text) {
	            return _axios2.default.post(this.finalUrl() + '/requestChanges', { text: text }, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this11 = this,
	                _arguments = arguments;
	
	            if (this.imageChanged) {
	                this.imageChanged = false;
	            }
	            if (this.locationAdded && this.get('companyLocationId') && !this.unsavedAttributes.companyLocationId) {
	                this.unsavedAttributes = Object.assign(this.unsavedAttributes, { companyLocationId: this.get('companyLocationId') });
	                this.locationAdded = false;
	            }
	            if (this.getPosition() && this.getPosition().isNew()) {
	
	                return this.getPosition().save().then(function () {
	                    return _this11.set({ positionId: _this11.getPosition().id }, { validate: false });
	                }).then(function () {
	                    return _get(Employee.prototype.__proto__ || Object.getPrototypeOf(Employee.prototype), 'save', _this11).apply(_this11, _arguments);
	                });
	            }
	
	            return _get(Employee.prototype.__proto__ || Object.getPrototypeOf(Employee.prototype), 'save', this).apply(this, arguments);
	        }
	
	        /**
	         * Based on the earningsAmount and earningsFrequency fields we update
	         * the associated models/Position only if it is a new position object.
	         *
	         * @instance
	         * @private
	         * @returns {null|undefined} Nothing
	         */
	
	    }, {
	        key: 'updatePositionInfo',
	        value: function updatePositionInfo(model, value, options) {
	            var _this12 = this;
	
	            var attrsWhitelist = ['earningsAmount', 'earningsFrequency'];
	
	            if (this.getPosition() && this.getPosition().isNew()) {
	                _.each(_.keys(options.changes), function (attr) {
	                    if (!_.contains(attrsWhitelist, attr)) {
	                        return;
	                    }
	
	                    _this12.getPosition().set(attr, value);
	                });
	            }
	        }
	
	        /**
	         * If the ID type is not an IC disable socso category
	         * if the ID Type is IC and isResident is true force
	         * 12/13% employer contribution
	         *
	         * @instance
	         * @private
	         */
	
	    }, {
	        key: 'onIdTypeChange',
	        value: function onIdTypeChange(model, value) {
	            if (!model.dirty()) {
	                return;
	            }
	
	            if (value === consts.ID_TYPE_IC_NUMBER && model.get('isResident')) {
	                this.set('epfEmployerRate', consts.EPF_EMPLOYER_RATE_GOVT_TABLE);
	            }
	        }
	    }, {
	        key: 'updateSocsoCategory',
	        value: function updateSocsoCategory() {
	            if (this.getAgeAtEndOfPeriod() < 60 && (this.isMalaysian() || this.get('isPermanentResident'))) {
	                this.set('socsoCategory', consts.SOCSO_CATEGORY_INJURY_AND_INVALIDITY);
	            } else {
	                this.set('socsoCategory', consts.SOCSO_CATEGORY_INJURY);
	            }
	        }
	    }, {
	        key: 'updateEpfRate',
	        value: function updateEpfRate() {
	            var oldEpfRate = this.get('epfRate');
	            var rates = this.getApplicableEpfRates();
	            if (!rates.find(function (_ref2) {
	                var value = _ref2.value;
	                return value === oldEpfRate;
	            })) {
	                var newRate = rates.find(function (i) {
	                    return i.default;
	                });
	                this.set('epfRate', newRate.value);
	            }
	        }
	    }, {
	        key: 'onUpdate',
	        value: function onUpdate(model) {
	            if (!model.dirty()) {
	                return;
	            }
	            this.updateSocsoCategory();
	            this.updateEpfRate();
	        }
	    }, {
	        key: 'isAffected2025Foreigner',
	        value: function isAffected2025Foreigner() {
	            return !this.isMalaysian() && !this.get('isPermanentResident') && !this.get('isEpfMemberBefore1998') && this.get('residentSubType') !== 3 && !(this.isIntern === true && this.get('isEpf') !== true);
	        }
	    }, {
	        key: 'getApplicableEpfRates',
	        value: function getApplicableEpfRates() {
	            if (this.isAffected2025Foreigner()) {
	                return [{
	                    text: '2%',
	                    value: 2,
	                    default: true
	                }];
	            }
	
	            if (this.getAgeAtEndOfPeriod() >= 60) {
	                return this.isMalaysian() ? [{
	                    text: '0%',
	                    value: 0,
	                    default: true
	                }] : [{
	                    text: '5.5%',
	                    value: 0.055,
	                    default: true
	                }];
	            }
	
	            return [{
	                text: '9%',
	                value: 0.09
	            }, {
	                text: '11%',
	                value: 0.11,
	                default: true
	            }];
	        }
	    }, {
	        key: 'getEmployerEpfRate',
	        value: function getEmployerEpfRate() {
	            if (this.isAffected2025Foreigner()) {
	                return {
	                    label: '2%',
	                    value: consts.EPF_EMPLOYER_RATE_GOVT_TABLE
	                };
	            }
	            if (!this.isMalaysian() && !this.get('isPermanentResident') && !this.get('isEpfMemberBefore1998')) {
	                return {
	                    label: '0% (RM 5)',
	                    value: consts.EPF_EMPLOYER_RATE_5RM
	                };
	            }
	            return {
	                label: this.getAgeAtEndOfPeriod() < 60 ? '12/13%' : this.isMalaysian() ? '4%' : '6/6.5%',
	                value: consts.EPF_EMPLOYER_RATE_GOVT_TABLE
	            };
	        }
	
	        /**
	         * @instance
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isMale',
	        value: function isMale() {
	            return this.get('gender') === consts.GENDER_MALE;
	        }
	
	        /**
	         * @instance
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isFemale',
	        value: function isFemale() {
	            return this.get('gender') === consts.GENDER_FEMALE;
	        }
	
	        /**
	         * Get the employee's company location
	         *
	         * @instance
	         * @returns {string} company location
	         */
	
	    }, {
	        key: 'getCompanyLocationName',
	        value: function getCompanyLocationName() {
	            return this.companyLocation ? this.companyLocation.get('name') : '';
	        }
	
	        /**
	         * Get the employee's position
	         *
	         * @instance
	         * @returns {string} position
	         */
	
	    }, {
	        key: 'getPositionName',
	        value: function getPositionName() {
	            return this.position ? this.position.get('name') : '';
	        }
	
	        /**
	         * Get the employee's age
	         *
	         * @instance
	         * @returns {integer} age
	         */
	
	    }, {
	        key: 'getAge',
	        value: function getAge() {
	            return (0, _moment2.default)().diff(this.get('dob') || new Date(), 'years');
	        }
	
	        /**
	         * Get the employee's age at the end of the current payroll period
	         *
	         * @instance
	         * @returns {integer} age
	         */
	
	    }, {
	        key: 'getAgeAtEndOfPeriod',
	        value: function getAgeAtEndOfPeriod() {
	            return new _payroll2.default().getPeriod().endOf('month').diff(this.get('dob'), 'years');
	        }
	
	        /**
	         * Get the employee's DOB
	         *
	         * @instance
	         * @returns {string} DOB
	         */
	
	    }, {
	        key: 'getDob',
	        value: function getDob() {
	            var date = this.get('dob');
	            return date ? (0, _moment2.default)(date).format('DD/MM/YYYY') : '';
	        }
	
	        /**
	         * Get race label or string
	         *
	         * @instance
	         * @returns {string} The race name
	         */
	
	    }, {
	        key: 'getRace',
	        value: function getRace() {
	            var type = {};
	            type[consts.RACE_DEFAULT] = 'Not selected';
	            type[consts.RACE_MALAY] = 'Malay';
	            type[consts.RACE_CHINESE] = 'Chinese';
	            type[consts.RACE_INDIAN] = 'Indian';
	            type[consts.RACE_OTHER] = 'Other';
	            return type[this.get('race')];
	        }
	
	        /**
	         * Get residence type string.
	         *
	         * @instance
	         * @returns {string} The residence type
	         */
	
	    }, {
	        key: 'getResidentType',
	        value: function getResidentType() {
	            var type = {};
	            type[consts.RESIDENT_SUBTYPE_NORMAL] = 'Normal';
	            type[consts.RESIDENT_SUBTYPE_KNOWLEDGE_WORKER] = 'Iskandar Knowledge Worker';
	            type[consts.RESIDENT_SUBTYPE_REP] = 'Returning Expert Program';
	            return type[this.get('residentSubType')];
	        }
	
	        /**
	         * Get marital status string
	         *
	         * @instance
	         * @returns {string} The marital status as string
	         */
	
	    }, {
	        key: 'getMarriedStatus',
	        value: function getMarriedStatus() {
	            var type = {};
	            type[consts.MARRIED_STATUS_SINGLE] = 'Single';
	            type[consts.MARRIED_STATUS_SINGLE_WITH_CHILDREN] = 'Single with Children';
	            type[consts.MARRIED_STATUS_DIVORCED] = 'Divorced or Widowed';
	            type[consts.MARRIED_STATUS_SPOUSE_WORKING] = 'Married and spouse is working';
	            type[consts.MARRIED_STATUS_SPOUSE_NOT_WORKING] = 'Married and spouse is NOT working';
	
	            return type[this.get('marriedStatus')];
	        }
	
	        /**
	         * Get preferred payment method as string
	         *
	         * @instance
	         * @returns {string} The payment method
	         */
	
	    }, {
	        key: 'getPreferredPaymentMethod',
	        value: function getPreferredPaymentMethod() {
	            var type = {};
	            type[consts.PAYMENT_METHOD_DEFAULT] = '';
	            type[consts.PAYMENT_METHOD_BANK_TRANSFER] = 'Bank Transfer';
	            type[consts.PAYMENT_METHOD_CASH] = 'Cash';
	            type[consts.PAYMENT_METHOD_CHEQUE] = 'Cheque';
	            return type[this.get('preferredPaymentMethod')];
	        }
	
	        /**
	         * Get children as string
	         *
	         * @instance
	         * @returns {string} The children
	         */
	
	    }, {
	        key: 'getChildren',
	        value: function getChildren() {
	            var type = {
	                0: 'None of the Categories',
	                underage: 'Under 18 or In Education',
	                inEducation: 'Over 18 - In Education (Diploma level)',
	                inHigherEducation: 'Over 18 - In Education (Degree level or higher)',
	                disabled: 'Disabled',
	                disabledInEducation: 'Disabled - In Higher Education'
	            };
	            var res = [];
	            var groupedChildren = _.groupBy(this.get('children'), function (item) {
	                var category = item ? type[item.category] : type[0];
	                return category + ' (' + item.pcbDeduction + '%)';
	            });
	
	            _.each(groupedChildren, function (item, key) {
	                res.push(item.length + ' ' + key);
	            });
	
	            return res;
	        }
	
	        /**
	         * Get nationality as string. Not as country code
	         *
	         * @instance
	         * @returns {string} The nationality
	         */
	
	    }, {
	        key: 'getNationality',
	        value: function getNationality() {
	            return _.find(_countriesList2.default, { code: this.get('nationality') }).name;
	        }
	    }, {
	        key: 'isMalaysian',
	        value: function isMalaysian() {
	            return this.get('nationality') === 'MY';
	        }
	
	        /**
	         * Get how many children the employee has, regardless of type or
	         * classification
	         *
	         * @instance
	         * @returns {integer} The employee's children count
	         */
	
	    }, {
	        key: 'getChildrenCount',
	        value: function getChildrenCount() {
	            return (this.get('children') || []).length;
	        }
	
	        /**
	         * @instance
	         * @return {integer} integer in range 0...100
	         */
	
	    }, {
	        key: 'calculateProfileProgress',
	        value: function calculateProfileProgress() {
	            var _this13 = this;
	
	            var populatedFieldCount = this.fieldsAffectingProgress.reduce(function (memo, field) {
	                if (_this13.get(field)) {
	                    memo++;
	                }
	                return memo;
	            }, 0);
	            return Math.floor(populatedFieldCount / this.fieldsAffectingProgress.length * 100);
	        }
	    }, {
	        key: 'getNameAbbreviation',
	        value: function getNameAbbreviation() {
	            var name = this.get('fullName') || '';
	            var words = name.match(/(\w+)/g) || '';
	
	            if (!name) {
	                return '';
	            }
	            if (!words) {
	                return '';
	            }
	            if (words.length === 1) {
	                return words[0].substr(0, 2);
	            }
	            return words[0].charAt(0) + words.pop().charAt(0);
	        }
	    }, {
	        key: 'getTaxModifyingAttributes',
	        value: function getTaxModifyingAttributes() {
	            var r = [];
	
	            if (this.get('isDisabled')) {
	                r.push('Disabled');
	            }
	
	            if (!this.get('isResident')) {
	                r.push('Non-Resident');
	            } else {
	                r.push('Resident');
	
	                if (this.get('residentSubType') === consts.RESIDENT_SUBTYPE_KNOWLEDGE_WORKER) {
	                    r.push('Iskandar Knowledge Worker');
	                } else if (this.get('residentSubType') === consts.RESIDENT_SUBTYPE_REP) {
	                    r.push('Returning Expert Program');
	                }
	            }
	
	            switch (this.get('marriedStatus')) {
	                case consts.MARRIED_STATUS_SINGLE:
	                    r.push('Single');
	                    break;
	                case consts.MARRIED_STATUS_SPOUSE_NOT_WORKING:
	                    r.push('Married');
	                    r.push('Spouse Not Working');
	                    break;
	                case consts.MARRIED_STATUS_SPOUSE_WORKING:
	                    r.push('Married');
	                    r.push('Spouse Working');
	                    break;
	                case consts.MARRIED_STATUS_DIVORCED:
	                    r.push('Divorced');
	                    break;
	                case consts.MARRIED_STATUS_SINGLE_WITH_CHILDREN:
	                    r.push('Single W/ Children');
	                    break;
	            }
	
	            if (this.get('isSpouseDisabled')) {
	                r.push('Married');
	                r.push('Spouse Disabled');
	            }
	
	            if (this.get('marriedStatus') !== consts.MARRIED_STATUS_SINGLE) {
	                if (this.getChildrenCount() === 1) {
	                    r.push('1 Child: ' + this.getChildren().join(', '));
	                } else if (this.getChildrenCount() > 1) {
	                    r.push(this.getChildrenCount() + ' Children: ' + this.getChildren().join(', '));
	                } else {
	                    r.push('No Dependent Children');
	                }
	            }
	
	            return r;
	        }
	    }, {
	        key: 'generateFormEA',
	        value: function generateFormEA(period) {
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/generateFormEA', { period: period }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'generateFormPcb2',
	        value: function generateFormPcb2(period) {
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/generateFormPcb2', { period: period }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'generateFormExcel',
	        value: function generateFormExcel(period) {
	            return _axios2.default.post(FORMS_URL + '/' + this.id + '/generateExcel', { period: period }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return new _attachment2.default(res.data.result);
	            });
	        }
	    }, {
	        key: 'getApplicableLeavePeriodDates',
	        value: function getApplicableLeavePeriodDates(date) {
	            if (!this.company) {
	                return {
	                    start: (0, _moment2.default)(date).startOf('year'),
	                    end: (0, _moment2.default)(date).endOf('year')
	                };
	            }
	
	            var joinDate = (0, _moment2.default)(this.get('commencementDate') || date).startOf('day');
	
	            if (this.company.get('leaveRenewalPolicy') === 'joinDate') {
	                if ((0, _moment2.default)(date).isBefore(joinDate, 'day')) {
	                    return {
	                        start: (0, _moment2.default)(joinDate).subtract(1, 'year').startOf('day'),
	                        end: (0, _moment2.default)(joinDate).subtract(1, 'day').endOf('day')
	                    };
	                }
	                var years = (0, _moment2.default)(date).startOf('day').diff(joinDate, 'years');
	
	                var _start = (0, _moment2.default)(joinDate).add(years, 'years');
	
	                return {
	                    start: _start,
	                    end: (0, _moment2.default)(_start).add(1, 'year').subtract(1, 'day').endOf('day')
	                };
	            }
	
	            var start = (0, _moment2.default)(date).startOf('year');
	
	            // Change starting date to joining date for
	            // "Renews at the beginning of the year" + employee joined this year
	            if (this.company.get('leaveRenewalPolicy') === 'calendarYear' && (0, _moment2.default)(date).isSame(joinDate, 'year')) {
	                start = (0, _moment2.default)(joinDate);
	            }
	
	            return {
	                start: start,
	                end: (0, _moment2.default)(date).endOf('year')
	            };
	        }
	    }, {
	        key: 'getApplicableLeavePeriod',
	        value: function getApplicableLeavePeriod(date) {
	            return this.getApplicableLeavePeriodDates(date).start.year();
	        }
	    }, {
	        key: 'getDaysEntitled',
	        value: function getDaysEntitled(type, period) {
	            if (!period) {
	                period = this.getApplicableLeavePeriod((0, _moment2.default)());
	            }
	
	            var daysEntitled = this.get('daysEntitled') || {};
	            var daysEntitledForPeriod = daysEntitled[period] || daysEntitled[period - 1] || {};
	
	            var defaultDaysEntitled = 0;
	            if (this.company) {
	                defaultDaysEntitled = this.company.getLeaveDays(type);
	            }
	
	            return daysEntitledForPeriod[type.id] !== undefined ? parseFloat(daysEntitledForPeriod[type.id]) : defaultDaysEntitled;
	        }
	    }, {
	        key: 'dismiss',
	        value: function dismiss(_ref3) {
	            var reason = _ref3.reason,
	                isReported = _ref3.isReported,
	                removedAt = _ref3.removedAt,
	                notes = _ref3.notes,
	                prorateSalary = _ref3.prorateSalary,
	                personalEmail = _ref3.personalEmail;
	
	            return _axios2.default.post(this.finalUrl() + '/dismiss', {
	                reason: reason,
	                isReported: isReported,
	                removedAt: removedAt,
	                notes: notes,
	                prorateSalary: prorateSalary,
	                personalEmail: personalEmail
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } });
	        }
	    }, {
	        key: 'restore',
	        value: function restore() {
	            var _this14 = this;
	
	            return _axios2.default.delete(this.finalUrl() + '/dismissal', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function () {
	                return _this14.save({ hiddenAt: null }, { validate: false });
	            });
	        }
	    }, {
	        key: 'permanentDestroy',
	        value: function permanentDestroy() {
	            return _axios2.default.post(this.finalUrl() + '/permanentDestroy', {}, {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            });
	        }
	
	        // destroy user for the employee and unset userId
	
	    }, {
	        key: 'removeEmployeeUser',
	        value: function removeEmployeeUser() {
	            var _this15 = this;
	
	            var userId = this.get('userId');
	            var user = new _user2.default({ id: userId });
	
	            return user.remove().then(function () {
	                return _this15.save({ userId: null }, { validate: false });
	            });
	        }
	
	        /**
	         * period should be instanceof moment
	         */
	
	    }, {
	        key: 'getHourlyWage',
	        value: function getHourlyWage(date) {
	            var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'overtime';
	
	            return _axios2.default.get(this.finalUrl() + '/hourlyWage', {
	                //date is wrapped by moment because some parts of the app
	                //might send moment instances or date objects
	                params: {
	                    name: name,
	                    date: (0, _moment2.default)(date).toDate()
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data;
	            });
	        }
	    }, {
	        key: 'setDaysEntitled',
	        value: function setDaysEntitled(_ref4) {
	            var type = _ref4.type,
	                typeId = _ref4.typeId,
	                days = _ref4.days,
	                period = _ref4.period;
	
	            if (!typeId) {
	                typeId = type.id;
	            }
	            if (!period) {
	                period = this.getApplicableLeavePeriod((0, _moment2.default)());
	            }
	
	            var daysEntitled = this.get('daysEntitled') || _defineProperty({}, period, {});
	            if (!daysEntitled[period]) {
	                daysEntitled[period] = JSON.parse(JSON.stringify(daysEntitled[period - 1] || this.company.get('leaveDays') || {}));
	            }
	            daysEntitled[period][typeId] = parseFloat(days);
	            this.set('daysEntitled', daysEntitled);
	        }
	
	        /* there isn't a getDaysCarryForward method because it's a complex
	           calculation made in server side */
	
	    }, {
	        key: 'setDaysCarryForward',
	        value: function setDaysCarryForward(_ref6) {
	            var typeId = _ref6.typeId,
	                days = _ref6.days;
	
	            var period = this.getApplicableLeavePeriod((0, _moment2.default)());
	            var daysCarryForward = this.get('daysCarryForward') || _defineProperty({}, period, {});
	            if (!daysCarryForward[period]) {
	                daysCarryForward[period] = {};
	            }
	            daysCarryForward[period][typeId] = parseFloat(days);
	
	            this.set('daysCarryForward', daysCarryForward);
	        }
	    }, {
	        key: 'fetchLeaveApprovals',
	        value: function fetchLeaveApprovals() {
	            var _this16 = this;
	
	            return this.leaveApprovals.fetch({ filter: { limit: 9999 } }).then(function () {
	                return _this16.leaveApprovals;
	            });
	        }
	    }, {
	        key: 'isManagedBy',
	        value: function isManagedBy(manager) {
	            if (!this.leaveApprovals) {
	                return false;
	            }
	            return this.leaveApprovals.length > 0 && this.leaveApprovals.map(function (a) {
	                return a.get('approverId');
	            }).indexOf(manager.id) > -1;
	        }
	    }, {
	        key: 'getApprovalLayer',
	        value: function getApprovalLayer(manager) {
	            if (!this.leaveApprovals) {
	                return -1;
	            }
	            var appr = this.leaveApprovals.find(function (a) {
	                return a.get('approverId') === manager.id;
	            });
	            if (!appr) {
	                return -1;
	            }
	            return appr.get('layer');
	        }
	    }, {
	        key: 'createTimeEntry',
	        value: function createTimeEntry(date) {
	            var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return new _timeEntry2.default({
	                employeeId: this.get('objectId'),
	                date: date,
	                hours: 0,
	                payrollItemId: item && item.get('objectId')
	            });
	        }
	    }, {
	        key: 'getTimeEntry',
	        value: function getTimeEntry(date) {
	            var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var insert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	            if (!this._timeEntries) {
	                throw new Error('We don\'t have time entry information for this model');
	            }
	
	            var commencementDate = this.get('commencementDate') ? (0, _moment2.default)(this.get('commencementDate')).startOf('day') : (0, _moment2.default)(date);
	            var cessationDate = this.get('cessationDate') ? (0, _moment2.default)(this.get('cessationDate')).startOf('day') : null;
	            var isBeforeCommencementDate = (0, _moment2.default)(date).startOf('day').isBefore(commencementDate);
	            var isAfterCessationDate = cessationDate ? (0, _moment2.default)(date).startOf('day').isAfter(cessationDate) : false;
	
	            if (isBeforeCommencementDate || isAfterCessationDate) {
	                return false;
	            }
	
	            var entry = this._timeEntries.find(function (entry) {
	                var itemId = item && item.id;
	                var entryItemId = entry.get('payrollItemId');
	                var isNotMonthly = !entry.get('isMonthOnly');
	
	                return isNotMonthly && (0, _moment2.default)(date).isSame(new Date(entry.get('date')), 'day') && (!item && !entry.get('payrollItemId') || itemId === entryItemId);
	            });
	
	            if (entry) {
	                return entry;
	            }
	
	            if (insert) {
	                var newEntry = this.createTimeEntry(date, item);
	                this._timeEntries.add(newEntry);
	                return newEntry;
	            }
	        }
	    }, {
	        key: 'getVisiblePayrollItems',
	        value: function getVisiblePayrollItems() {
	            var _this17 = this;
	
	            return app.payrollItems.filter(function (model) {
	                return model.get('hiddenAt') === null && _this17._timeEntries.some(function (entry) {
	                    return entry.get('payrollItemId') === model.id;
	                });
	            });
	        }
	    }, {
	        key: 'getTimeEntryItems',
	        value: function getTimeEntryItems() {
	            if (app.payrollItems) {
	                return [null].concat(_toConsumableArray(this.getVisiblePayrollItems()));
	            }
	            log.warn('App hasn\'t any payroll items loaded');
	        }
	    }, {
	        key: 'getTimeEntriesDailyTotal',
	        value: function getTimeEntriesDailyTotal(date) {
	            var entries = this._timeEntries.filter(function (entry) {
	                return (0, _moment2.default)(entry.get('date')).isSame(date, 'day') && !entry.get('isMonthOnly');
	            });
	            if (entries.length === 0) {
	                entries.push(this.getTimeEntry(date));
	            }
	
	            return entries.reduce(function (m, entry) {
	                return m + (entry && entry.get('hours') || 0);
	            }, 0);
	        }
	    }, {
	        key: 'getTimeEntriesWeeklyTotal',
	        value: function getTimeEntriesWeeklyTotal(date) {
	            var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var weekStart = (0, _moment2.default)(date).startOf('week');
	            var weekEnd = (0, _moment2.default)(date).endOf('week');
	            var total = 0;
	
	            while (!weekStart.isAfter(weekEnd)) {
	                var entry = this.getTimeEntry(weekStart.toDate(), item, false);
	                total += entry ? entry.get('hours') || 0 : 0;
	                weekStart.add(1, 'day');
	            }
	            return total;
	        }
	    }, {
	        key: 'getTimeEntriesMonthlyTotal',
	        value: function getTimeEntriesMonthlyTotal(date) {
	            var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var monthStart = (0, _moment2.default)(date).startOf('month');
	            var monthEnd = (0, _moment2.default)(date).endOf('month');
	            var total = 0;
	
	            while (!monthStart.isAfter(monthEnd)) {
	                var _entry = this.getTimeEntry(monthStart.toDate(), item, false);
	                total += _entry ? _entry && _entry.get('hours') || 0 : 0;
	                monthStart.add(1, 'day');
	            }
	
	            // count monthly time entries from bulk upload
	            var entry = this._timeEntries.find(function (entry) {
	                var itemId = item && item.id;
	                var entryItemId = entry.get('payrollItemId');
	                var isMonthly = entry.get('isMonthOnly');
	
	                return isMonthly && (0, _moment2.default)(monthEnd).isSame(new Date(entry.get('date')), 'day') && (!itemId && !entry.get('payrollItemId') || itemId === entryItemId);
	            });
	
	            total += entry ? entry && entry.get('hours') || 0 : 0;
	
	            return total;
	        }
	    }, {
	        key: 'deleteTimeEntries',
	        value: function deleteTimeEntries(date) {
	            var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
	
	            if (!this._timeEntries) {
	                throw new Error('We don\'t have time entry information for this model');
	            }
	
	            var start = (0, _moment2.default)(date).startOf(scope);
	            var end = (0, _moment2.default)(date).endOf(scope);
	
	            var promises = [];
	            while (!start.isAfter(end)) {
	                var entry = this.getTimeEntry(start.toDate(), item, false);
	                if (entry) {
	                    this._timeEntries.remove(entry);
	                    promises.push(entry.destroy());
	                }
	                start.add(1, 'day');
	            }
	            if (scope === 'month') {
	                var monthEntry = this._timeEntries.find(function (i) {
	                    return i.get('isMonthOnly') && i.get('payrollItemId') === item.id;
	                });
	
	                if (monthEntry) {
	                    this._timeEntries.remove(monthEntry);
	                    promises.push(monthEntry.destroy());
	                }
	            }
	            return (0, _bluebird.all)(promises);
	        }
	    }, {
	        key: 'getFormattedDate',
	        value: function getFormattedDate(property, format) {
	            var date = this.get(property);
	            return date ? (0, _moment2.default)(date).format(format) : '';
	        }
	    }, {
	        key: 'canContributeToEis',
	        value: function canContributeToEis() {
	            var myNationality = this.get('nationality') === 'MY';
	            return myNationality || this.get('isPermanentResident');
	        }
	
	        // 20200819 this.hasPrevItemYearlyTotals: to determine whether
	        // an employee has entered YTD data. this is for warning dialog
	        // at payroll step 1 (when clicking step 2)
	
	    }, {
	        key: 'getHasPrevItemYearlyTotals',
	        value: function getHasPrevItemYearlyTotals(year) {
	            var _this18 = this;
	
	            return new _itemYearlyTotals2.default(null, {
	                employee: this, year: year || (0, _moment2.default)().year()
	            }).fetch({ filter: { limit: 999 } }).then(function (itemYearlyTotals) {
	                _this18.hasPrevItemYearlyTotals = itemYearlyTotals.some(function (ytd) {
	                    return ytd.get('amount') > 0 || ytd.get('prevEmploymentAmount') > 0;
	                });
	            });
	        }
	    }, {
	        key: 'isDestroyable',
	        value: function isDestroyable() {
	            var payslips = new _payslips2.default(null, {
	                employee: this,
	                filter: { limit: 1 },
	                pagination: false
	            });
	            return this.fetchCompany().then(function (company) {
	                return (0, _bluebird.all)([company.fetchCurrentPayroll(), payslips.fetch()]).then(function (_ref8) {
	                    var _ref9 = _slicedToArray(_ref8, 2),
	                        payroll = _ref9[0],
	                        payslip = _ref9[1];
	
	                    return !payroll && !payslip.length;
	                });
	            });
	        }
	    }, {
	        key: 'autoFillPreviousPayslipsData',
	        value: function autoFillPreviousPayslipsData(_ref10) {
	            var itemYearlyTotals = _ref10.itemYearlyTotals,
	                _ref10$current = _ref10.current,
	                current = _ref10$current === undefined ? true : _ref10$current;
	
	            if (itemYearlyTotals.length < 1) {
	                return (0, _bluebird.resolve)(itemYearlyTotals);
	            }
	            return _axios2.default.post(this.finalUrl() + '/autoFillPreviousPayslipsData', {
	                current: current,
	                itemYearlyTotals: itemYearlyTotals.models.map(function (model) {
	                    return model.toJSON();
	                })
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return itemYearlyTotals.reset(res.data.results);
	            });
	        }
	    }, {
	        key: 'uploadImage',
	        value: function uploadImage() {
	            var _this19 = this;
	
	            var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!file) {
	                return (0, _bluebird.resolve)();
	            }
	
	            // Size limit: 200 kb
	            if (file && file.size && file.size > 1024 * 200) {
	                return (0, _bluebird.reject)({ text: 'The maximum allowed size is 200kb' });
	            }
	
	            if (!/^image\/(png|jpeg)$/.test(file.type)) {
	                return (0, _bluebird.reject)({
	                    text: 'Only PNG or JPEG images are allowed'
	                });
	            }
	
	            var extension = file.name.split('.').pop();
	            var data = new FormData();
	            data.append('file', file, 'image.' + extension);
	
	            // Hack to cover `unsavedAttributes` issue
	            var pendingChanges = Object.assign({}, this.unsavedAttributes || {});
	
	            return _axios2.default.post(this.finalUrl() + '/image', data, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this19.fetch({ validate: false });
	            }).then(function () {
	                // tracking of `unsavedAtrributes` is working incorrectly as
	                // backbone appends server sent attributes into model without reset
	                _this19.unsavedAttributes = pendingChanges;
	                _this19.set(pendingChanges);
	                _this19.imageChanged = true;
	            });
	        }
	    }, {
	        key: 'getImageUrl',
	        value: function getImageUrl() {
	            if (!this.imageChanged && !this.get('imageUrl')) {
	                return false;
	            }
	            var tempParam = this.imageChanged ? '&displayTemp=1' : '';
	
	            return this.finalUrl() + '/image?' + ('access_token=' + app.user.getAccessToken().id + '&') + ('_b=' + Math.floor(Math.random() * 1000000)) + tempParam;
	        }
	    }]);
	
	    return Employee;
	}(_model2.default);
	
	exports.default = Employee;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Address = function (_Model) {
	    _inherits(Address, _Model);
	
	    _createClass(Address, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Addresses';
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            // If the address belongs to a location that is not the primary one,
	            // we only require state information
	            if (this.companyLocation && !this.companyLocation.get('primary')) {
	                return {
	                    state: { presence: { message: '^State is required' } }
	                };
	            }
	
	            return { city: {
	                    format: {
	                        pattern: /^.{0,50}$/,
	                        message: '^A city name cannot contain more than 50 characters.'
	                    }
	                },
	                streetAddress: {
	                    format: {
	                        pattern: /^.{0,150}$/,
	                        message: '^A Street Address cannot contain more than 150 characters.'
	                    }
	                },
	                postcode: {
	                    format: {
	                        pattern: /^.{0,20}$/,
	                        message: '^A Postal Code cannot contain more than 20 characters.'
	                    }
	                } };
	        }
	    }]);
	
	    function Address() {
	        _classCallCheck(this, Address);
	
	        var _this = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(Address, [{
	        key: 'initialize',
	        value: function initialize(attr) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$companyLocation = _ref.companyLocation,
	                companyLocation = _ref$companyLocation === undefined ? null : _ref$companyLocation;
	
	            this.idAttribute = 'objectId';
	            this.companyLocation = companyLocation;
	            return _get(Address.prototype.__proto__ || Object.getPrototypeOf(Address.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'getStateName',
	        value: function getStateName() {
	            return Address.getStateName(this.get('state'));
	        }
	    }, {
	        key: 'isBlank',
	        value: function isBlank() {
	            return !this.get('line1') && !this.get('city') && !this.get('state') && !this.get('postcode') && !this.get('contactPhone');
	        }
	    }], [{
	        key: 'getStatesList',
	        value: function getStatesList() {
	            return [{ code: '01', name: 'Johor' }, { code: '02', name: 'Kedah' }, { code: '03', name: 'Kelantan' }, { code: '14', name: 'Kuala Lumpur' }, { code: '15', name: 'Labuan' }, { code: '04', name: 'Malacca' }, { code: '05', name: 'Negeri Sembilan' }, { code: '06', name: 'Pahang' }, { code: '07', name: 'Penang' }, { code: '08', name: 'Perak' }, { code: '09', name: 'Perlis' }, { code: '16', name: 'Putrajaya' }, { code: '12', name: 'Sabah' }, { code: '13', name: 'Sarawak' }, { code: '10', name: 'Selangor' }, { code: '11', name: 'Terengganu' }];
	        }
	    }, {
	        key: 'getStateName',
	        value: function getStateName(code) {
	            var state = Address.getStatesList().find(function (state) {
	                return state.code === code;
	            });
	            return state && state.name;
	        }
	    }]);
	
	    return Address;
	}(_model2.default);
	
	exports.default = Address;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BankAccount = function (_Model) {
	    _inherits(BankAccount, _Model);
	
	    _createClass(BankAccount, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/BankAccounts';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                isPayer: false,
	                isPayee: true,
	                companyId: null, // TODO do we need this field?
	                employeeId: null // TODO do we need this field?
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                bankName: { presence: { message: '^Bank Name is required' } },
	                bankBnmCode: { presence: { message: '^BNM code is required' } },
	                bankSwiftCode: { presence: { message: '^SWIFT code is required' } },
	
	                holderName: function holderName(value, attrs) {
	                    var constraints = {
	                        presence: { message: '^Account\'s holder Name is required' }
	                    };
	
	                    if ((attrs.bankBnmCode || null) === '18') {
	                        constraints.length = {
	                            maximum: 40,
	                            message: '^Account Holder\'s Name ' + 'should not more than 40 Char'
	                        };
	                    }
	
	                    return constraints;
	                },
	                number: function number(value, attrs) {
	                    var constraints = {
	                        presence: { message: '^Account number is required' }
	                    };
	
	                    if ((attrs.bankBnmCode || null) === '33') {
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                        constraints.length = {
	                            is: 10,
	                            message: '^Account number must be 10 digits long'
	                        };
	                    } else if ((attrs.bankBnmCode || null) === '27') {
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                        constraints.length = {
	                            is: 12,
	                            message: '^Account number must be 12 digits long'
	                        };
	                    } else if ((attrs.bankBnmCode || null) === '24') {
	                        // HLB
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                        constraints.length = {
	                            is: 11,
	                            message: '^Account number must be 11-digit long'
	                        };
	                    } else if ((attrs.bankBnmCode || null) === '18') {
	                        // RHB
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                        constraints.length = {
	                            is: 14,
	                            message: '^Account number must be ' + '14 digit long'
	                        };
	                    } else if ((attrs.bankBnmCode || null) === '29') {
	                        // OCBC
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                        if (attrs.isPayer) {
	                            constraints.length = {
	                                is: 10,
	                                message: '^Account number must be ' + '10 digit long'
	                            };
	                        }
	                    } else if ((attrs.bankBnmCode || null) === '22') {
	                        // HSBC
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                        if (attrs.isPayer) {
	                            constraints.length = {
	                                is: 12,
	                                message: '^Account number must be 12 digit long'
	                            };
	                        }
	                    } else if ((attrs.bankBnmCode || null) === '26') {
	                        // UOB
	                        constraints.numericality = {
	                            onlyInteger: { message: '^Only numbers are allowed' }
	                        };
	                    }
	
	                    return constraints;
	                },
	
	                organizationCode: function organizationCode(value, attrs) {
	                    if (['27', '33', '35', '18'].indexOf(attrs.bankBnmCode) >= 0 && attrs.isPayer) {
	                        if (attrs.accountType === 'enterprise' || attrs.accountType === 'maybank2u') {
	                            return false;
	                        }
	                        var constraints = {
	                            presence: { message: '^Organization code is required' }
	                        };
	
	                        if (attrs.bankBnmCode === '35') {
	                            constraints.length = {
	                                is: 5,
	                                message: '^The organization code must be 5 ' + 'digits long'
	                            };
	                        } else if (attrs.bankBnmCode === '33') {
	                            constraints.length = {
	                                is: 3,
	                                message: '^The organization code must be 3 ' + 'digits long'
	                            };
	                        } else if (attrs.bankBnmCode === '18') {
	                            //RHB
	                            constraints.length = {
	                                is: 6,
	                                message: '^The Corporate ID must be 6 digits long'
	                            };
	                        } else if (attrs.bankBnmCode === '27' && attrs.accountType === 'maybank2e') {
	                            constraints.length = {
	                                maximum: 30,
	                                message: '^The Corporate ID must be at most 30 digits long'
	                            };
	                        }
	
	                        return constraints;
	                    }
	
	                    return false;
	                },
	
	                originatorId: function originatorId(value, attrs) {
	                    if (attrs.bankBnmCode === '27' && attrs.isPayer) {
	                        if (attrs.accountType === 'maybank2e') {
	                            return false;
	                        }
	                        return {
	                            presence: { message: '^Originator ID is required' },
	                            length: {
	                                is: 5,
	                                message: '^The originator ID  must be 5 digits long'
	                            },
	                            numericality: {
	                                onlyInteger: { message: '^Only numbers are allowed' }
	                            }
	                        };
	                    }
	
	                    return false;
	                },
	
	                transactionType: function transactionType(value, attrs) {
	                    if (['18', '24', '26', '33'].indexOf(attrs.bankBnmCode) >= 0 && attrs.isPayer) {
	                        var constraints = {
	                            presence: {
	                                message: '^Payment mode/transaction type is required'
	                            }
	                        };
	
	                        return constraints;
	                    }
	
	                    return false;
	                },
	
	                accountType: function accountType(value, attrs) {
	                    if (attrs.bankBnmCode !== '27' || !attrs.isPayer) {
	                        return false;
	                    }
	
	                    return {
	                        presence: {
	                            message: '^Account type is required'
	                        }
	                    };
	                },
	
	                hsbcNetPaymentSetNo: function hsbcNetPaymentSetNo(value, attrs) {
	                    if (attrs.bankBnmCode !== '22' || !attrs.isPayer) {
	                        return false;
	                    }
	
	                    return {
	                        length: {
	                            is: 3,
	                            message: '^Must be 3 characters long'
	                        }
	                    };
	                },
	
	                hsbcNetId: function hsbcNetId(value, attrs) {
	                    if (attrs.bankBnmCode !== '22' || !attrs.isPayer) {
	                        return false;
	                    }
	
	                    return {
	                        length: {
	                            minimum: 17,
	                            maximum: 18,
	                            message: '^Length must be 17-18 characters'
	                        }
	                    };
	                },
	
	                hsbcConnectId: function hsbcConnectId(value, attrs) {
	                    if (attrs.bankBnmCode !== '22' || !attrs.isPayer) {
	                        return false;
	                    }
	
	                    return {
	                        length: {
	                            is: 11,
	                            message: '^Must be 11 characters long'
	                        }
	                    };
	                },
	
	                // UOB Company ID
	                companyCode: function companyCode(value, attrs) {
	                    if (attrs.bankBnmCode !== '26' || !attrs.isPayer) {
	                        return false;
	                    }
	
	                    return {
	                        presence: {
	                            message: '^Company ID is required'
	                        }
	                    };
	                }
	            };
	        } // end of constraints
	
	    }]);
	
	    function BankAccount() {
	        _classCallCheck(this, BankAccount);
	
	        var _this = _possibleConstructorReturn(this, (BankAccount.__proto__ || Object.getPrototypeOf(BankAccount)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(BankAccount, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(BankAccount.prototype.__proto__ || Object.getPrototypeOf(BankAccount.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'getSupportedTransactionTypes',
	        value: function getSupportedTransactionTypes() {
	            if (this.get('bankBnmCode') === '18') {
	                /* RHB transaction types */
	                return {
	                    '20': 'Rentas',
	                    '30': 'IBG'
	                };
	            }
	
	            if (this.get('bankBnmCode') === '33') {
	                // Public Bank
	                var types = {
	                    'service': {
	                        'LGP': 'IBG',
	                        'LSP': 'Rentas',
	                        'LBC': 'BC/DD'
	                    },
	                    'enterprise': {
	                        'LGP': 'PBB',
	                        'LSP': 'IBG',
	                        'LBC': 'REN'
	                    }
	                };
	                var type = this.get('accountType');
	                return types[type];
	            }
	
	            if (this.get('bankBnmCode') === '24') {
	                // HLB
	                return {
	                    'RTS': 'Rentas',
	                    'IBG': 'IBG'
	                };
	            }
	
	            if (this.get('bankBnmCode') === '26') {
	                // UOB
	                return {
	                    'IBG': 'IBG',
	                    'IFT': 'IFT'
	                };
	            }
	
	            return null;
	        }
	    }]);
	
	    return BankAccount;
	}(_model2.default);
	
	exports.default = BankAccount;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyLocation = function (_Model) {
	    _inherits(CompanyLocation, _Model);
	
	    _createClass(CompanyLocation, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/CompanyLocations';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                name: 'HQ',
	                addressId: null,
	                primary: true
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                name: { presence: { message: '^Name is required' } },
	                companyId: { presence: true },
	                primary: { presence: true }
	            };
	        }
	    }]);
	
	    function CompanyLocation() {
	        _classCallCheck(this, CompanyLocation);
	
	        var _this = _possibleConstructorReturn(this, (CompanyLocation.__proto__ || Object.getPrototypeOf(CompanyLocation)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(CompanyLocation, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(CompanyLocation.prototype.__proto__ || Object.getPrototypeOf(CompanyLocation.prototype), 'initialize', this).apply(this, arguments);
	
	            if (!this.get('addressId')) {
	                this.setAddress(new _address2.default(null, {
	                    validate: false,
	                    companyLocation: this
	                }));
	            }
	            this.employees = new _employees2.default(null, {
	                companyLocation: this,
	                pagination: false
	            });
	
	            return this;
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this2 = this,
	                _arguments = arguments;
	
	            if (this.getAddress() && this.getAddress().dirty()) {
	                var options = {};
	
	                // if address is not primary, validate only state
	                if (!this.get('primary')) {
	                    options = { validateAttrs: { include: ['state'] } };
	                }
	
	                return this.getAddress().save(null, options).then(function () {
	                    return _this2.set({ addressId: _this2.getAddress().id }, { validate: false });
	                }).then(function () {
	                    return _get(CompanyLocation.prototype.__proto__ || Object.getPrototypeOf(CompanyLocation.prototype), 'save', _this2).apply(_this2, _arguments);
	                });
	            }
	
	            return _get(CompanyLocation.prototype.__proto__ || Object.getPrototypeOf(CompanyLocation.prototype), 'save', this).apply(this, arguments);
	        }
	    }, {
	        key: 'fetchAddress',
	        value: function fetchAddress() {
	            var _this3 = this;
	
	            if (!this.get('addressId')) {
	                return this.address;
	            }
	
	            return new _address2.default({ objectId: this.get('addressId') }, { validate: false, companyLocation: this }).fetch({ validate: false }).then(function (model) {
	                _this3.setAddress(model);
	                return model;
	            });
	        }
	    }, {
	        key: 'getAddress',
	        value: function getAddress() {
	            return this.address;
	        }
	    }, {
	        key: 'setAddress',
	        value: function setAddress(address) {
	            var _this4 = this;
	
	            var old = this.getAddress();
	
	            if (old) {
	                old.off('change', null, null);
	            }
	
	            this.address = address;
	            this.address.companyLocation = this;
	            this.address.on('change', function (model, options) {
	                // Some views check the changed attribute of a model to determine
	                // whether we need to toggle an error message or not.
	                // So we extend `changed` with whatever changed in the address
	                // so the views can see it
	                _this4.changed = Object.assign(_this4.changed || {}, model.changed || {});
	
	                Object.keys(model.changed).forEach(function (attr) {
	                    if (_this4.validationError && _this4.validationError[attr]) {
	                        delete _this4.validationError[attr];
	                    }
	                });
	                _this4.trigger('change', _this4, options);
	            });
	            this.address.on('invalid', function (model, error, options) {
	                _this4.validationError = Object.assign({}, _this4.validationError || {}, _this4.address.validationError || {});
	                _this4.trigger('invalid', _this4, error, options);
	            });
	        }
	    }, {
	        key: 'fetchEmployees',
	        value: function fetchEmployees() {
	            return this.employees.fetch({ filter: { limit: 9999 } });
	        }
	    }, {
	        key: 'getEmployees',
	        value: function getEmployees() {
	            return this.employees;
	        }
	    }, {
	        key: 'validate',
	        value: function validate(attrs, options) {
	            var locationResult = _get(CompanyLocation.prototype.__proto__ || Object.getPrototypeOf(CompanyLocation.prototype), 'validate', this).apply(this, arguments);
	            var address = this.getAddress();
	            var finalResult = locationResult;
	
	            if (address) {
	                var addressResult = this.getAddress().validate(this.getAddress().attributes, options);
	
	                if (addressResult) {
	                    finalResult = Object.assign({}, locationResult || {}, addressResult);
	                }
	            }
	
	            return finalResult;
	        }
	    }, {
	        key: 'dirty',
	        value: function dirty() {
	            var dirty = _get(CompanyLocation.prototype.__proto__ || Object.getPrototypeOf(CompanyLocation.prototype), 'dirty', this).call(this);
	
	            if (this.getAddress()) {
	                dirty = dirty || this.getAddress().dirty();
	            }
	
	            return dirty;
	        }
	
	        // TODO deprecate
	
	    }, {
	        key: 'getValidationError',
	        value: function getValidationError() {
	            return this.validationError;
	        }
	    }]);
	
	    return CompanyLocation;
	}(_model2.default);
	
	exports.default = CompanyLocation;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeEntry = function (_Model) {
	    _inherits(TimeEntry, _Model);
	
	    _createClass(TimeEntry, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/TimeEntries';
	        }
	    }]);
	
	    function TimeEntry() {
	        _classCallCheck(this, TimeEntry);
	
	        var _this = _possibleConstructorReturn(this, (TimeEntry.__proto__ || Object.getPrototypeOf(TimeEntry)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(TimeEntry, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(TimeEntry.prototype.__proto__ || Object.getPrototypeOf(TimeEntry.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }]);
	
	    return TimeEntry;
	}(_model2.default);
	
	exports.default = TimeEntry;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Position = function (_Model) {
	    _inherits(Position, _Model);
	
	    function Position() {
	        _classCallCheck(this, Position);
	
	        return _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).apply(this, arguments));
	    }
	
	    _createClass(Position, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Positions';
	        }
	    }, {
	        key: 'url',
	        value: function url() {
	            if (this.company && !this.get(this.idAttribute)) {
	                return this.company.url() + '/positions';
	            }
	            return _get(Position.prototype.__proto__ || Object.getPrototypeOf(Position.prototype), 'url', this).call(this);
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                hiddenAt: null
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                name: { presence: true }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(_ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.idAttribute = 'objectId';
	            _get(Position.prototype.__proto__ || Object.getPrototypeOf(Position.prototype), 'initialize', this).apply(this, arguments);
	
	            this.company = company;
	            return this;
	        }
	    }]);
	
	    return Position;
	}(_model2.default);
	
	exports.default = Position;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmployeeRemoval = function (_Model) {
	    _inherits(EmployeeRemoval, _Model);
	
	    _createClass(EmployeeRemoval, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/EmployeeRemovals';
	        }
	    }]);
	
	    function EmployeeRemoval() {
	        _classCallCheck(this, EmployeeRemoval);
	
	        var _this = _possibleConstructorReturn(this, (EmployeeRemoval.__proto__ || Object.getPrototypeOf(EmployeeRemoval)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(EmployeeRemoval, [{
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                removedAt: new Date(),
	                prorateSalary: true,
	                isReported: false,
	                notes: ''
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                employeeId: { presence: true },
	                reason: { presence: true },
	                removedAt: { presence: true },
	                personalEmail: { email: true }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(EmployeeRemoval.prototype.__proto__ || Object.getPrototypeOf(EmployeeRemoval.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'setEmployee',
	        value: function setEmployee(employee) {
	            this.employee = employee;
	            if (employee.get('personalEmail')) {
	                this.set({
	                    personalEmail: employee.get('personalEmail')
	                });
	            }
	            return this.set({
	                employeeId: employee.get('objectId')
	            });
	        }
	    }, {
	        key: 'getEmployee',
	        value: function getEmployee() {
	            return this.employee;
	        }
	    }, {
	        key: 'getFormattedDate',
	        value: function getFormattedDate(property, format) {
	            var date = this.get(property);
	            return date ? (0, _moment2.default)(date).format(format) : '';
	        }
	    }], [{
	        key: 'getForEmployee',
	        value: function getForEmployee(employee) {
	            return _axios2.default.get(employee.finalUrl() + '/dismissal', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (result) {
	                return new EmployeeRemoval(result.data);
	            }).catch(function () {
	                return null;
	            });
	        }
	    }]);
	
	    return EmployeeRemoval;
	}(_model2.default);
	
	exports.default = EmployeeRemoval;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _attachment = __webpack_require__(579);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _taggable = __webpack_require__(580);
	
	var _taggable2 = _interopRequireDefault(_taggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Attachments = function (_Taggable) {
	    _inherits(Attachments, _Taggable);
	
	    function Attachments() {
	        _classCallCheck(this, Attachments);
	
	        return _possibleConstructorReturn(this, (Attachments.__proto__ || Object.getPrototypeOf(Attachments)).apply(this, arguments));
	    }
	
	    _createClass(Attachments, [{
	        key: 'url',
	        value: function url() {
	            if (this.attachable) {
	                return this.attachable.url() + '/attachments';
	            }
	
	            return '/Attachments';
	        }
	
	        // Note that attachable can be any model. Careful on what the server
	        // supports.
	
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$attachable = _ref.attachable,
	                attachable = _ref$attachable === undefined ? null : _ref$attachable;
	
	            _get(Attachments.prototype.__proto__ || Object.getPrototypeOf(Attachments.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _attachment2.default;
	            this.attachable = attachable;
	            return this;
	        }
	    }]);
	
	    return Attachments;
	}((0, _taggable2.default)(_collection2.default));
	
	exports.default = Attachments;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Attachment = function (_Model) {
	    _inherits(Attachment, _Model);
	
	    _createClass(Attachment, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Attachments';
	        }
	    }]);
	
	    function Attachment() {
	        _classCallCheck(this, Attachment);
	
	        var _this = _possibleConstructorReturn(this, (Attachment.__proto__ || Object.getPrototypeOf(Attachment)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(Attachment, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(Attachment.prototype.__proto__ || Object.getPrototypeOf(Attachment.prototype), 'initialize', this).apply(this, arguments);
	        }
	
	        /**
	         * Get the url of the file in this attachment
	         *
	         * @instance
	         * @returns {string} An empty string if there is no file, or the url of
	         *  the file.
	         */
	
	    }, {
	        key: 'getUrl',
	        value: function getUrl() {
	            return this.downloadUrl();
	        }
	
	        /**
	         * Test the tags attribute for a specific tag
	         *
	         * @instance
	         * @param {string} tag - The tag to search for
	         * @returns {boolean} True if found, false otherwise
	         */
	
	    }, {
	        key: 'hasTag',
	        value: function hasTag(tag) {
	            return _.contains(this.get('tags'), tag);
	        }
	
	        /**
	         * Find a tag using a regular expression
	         *
	         * @instance
	         * @param {RegExp} re - The regular expression to test with
	         * @returns {string|falsy} The tag if found, a falsy value otherwise
	         */
	
	    }, {
	        key: 'findTag',
	        value: function findTag(re) {
	            return _.find(this.get('tags'), re.test.bind(re));
	        }
	    }, {
	        key: 'downloadUrl',
	        value: function downloadUrl() {
	            return this.finalUrl() + '/download?' + ('access_token=' + app.user.getAccessToken().id);
	        }
	    }]);
	
	    return Attachment;
	}(_model2.default);
	
	exports.default = Attachment;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (superclass) {
	    return function (_superclass) {
	        _inherits(Taggable, _superclass);
	
	        function Taggable() {
	            _classCallCheck(this, Taggable);
	
	            return _possibleConstructorReturn(this, (Taggable.__proto__ || Object.getPrototypeOf(Taggable)).apply(this, arguments));
	        }
	
	        _createClass(Taggable, [{
	            key: 'findByTags',
	
	            /*
	             * Return a new collection with the models that match all tags sent
	             * in the tags parameter, and/or it doesn't have any tags from the
	             * excludeTags parameter
	             */
	            value: function findByTags(tags, excludeTags) {
	                var r = this;
	
	                // for each tag we are searching...
	                tags.find(function (tag) {
	                    // ... create a new collection that contains only the models that
	                    // that match it.
	                    // jscs:disable
	
	                    r = new Taggable(
	                    //jscs:enable
	                    r.filter(function (model) {
	                        return _.contains(model.get('tags'), tag);
	                    }));
	                    // if the collection is empty there is no point in continue
	                    // searching so we exit the find() loop early by returning `true`
	                    return r.length === 0;
	                });
	
	                // if we need to exclude certain tags...
	                if (excludeTags) {
	                    // we reset the models that already matched...
	                    r.reset(r.filter(function (model) {
	                        // and keep only the ones that don't have the given tag
	                        return !_.find(excludeTags, function (tag) {
	                            return _.contains(model.get('tags'), tag);
	                        });
	                    }), { silent: true });
	                }
	
	                return r;
	            }
	        }, {
	            key: 'hasTag',
	            value: function hasTag(tag) {
	                return this.findByTags([tag]).length > 0;
	            }
	        }]);
	
	        return Taggable;
	    }(superclass);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payslip = __webpack_require__(582);
	
	var _payslip2 = _interopRequireDefault(_payslip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Payslips = function (_Collection) {
	    _inherits(Payslips, _Collection);
	
	    function Payslips() {
	        _classCallCheck(this, Payslips);
	
	        return _possibleConstructorReturn(this, (Payslips.__proto__ || Object.getPrototypeOf(Payslips)).apply(this, arguments));
	    }
	
	    _createClass(Payslips, [{
	        key: 'url',
	        value: function url() {
	            if (this.payroll) {
	                return this.payroll.url() + '/slips';
	            }
	
	            if (this.employee) {
	                return this.employee.url() + '/payslips';
	            }
	
	            return '/Payslips';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$payroll = _ref.payroll,
	                payroll = _ref$payroll === undefined ? null : _ref$payroll,
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee;
	
	            this.model = _payslip2.default;
	            this.payroll = payroll;
	            this.employee = employee;
	            _get(Payslips.prototype.__proto__ || Object.getPrototypeOf(Payslips.prototype), 'initialize', this).apply(this, arguments);
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'employeeName';
	            }
	            return this;
	        }
	    }]);
	
	    return Payslips;
	}(_collection2.default);
	
	exports.default = Payslips;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _payslipDetails = __webpack_require__(583);
	
	var _payslipDetails2 = _interopRequireDefault(_payslipDetails);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Payslip = function (_Model) {
	    _inherits(Payslip, _Model);
	
	    _createClass(Payslip, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Payslips';
	        }
	    }]);
	
	    function Payslip() {
	        _classCallCheck(this, Payslip);
	
	        var _this = _possibleConstructorReturn(this, (Payslip.__proto__ || Object.getPrototypeOf(Payslip)).apply(this, arguments));
	
	        _this.employee = null;
	        _this.company = null;
	        _this.payroll = null;
	        return _this;
	    }
	
	    _createClass(Payslip, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(Payslip.prototype.__proto__ || Object.getPrototypeOf(Payslip.prototype), 'initialize', this).apply(this, arguments);
	            this.details = new _payslipDetails2.default(null, { payslip: this });
	            this.attachments = new _attachments2.default(null, { attachable: this });
	            return this;
	        }
	    }, {
	        key: 'fetchPayroll',
	        value: function fetchPayroll() {
	            var _this2 = this;
	
	            if (this.payroll) {
	                (0, _bluebird.resolve)(this.payroll);
	            }
	
	            return new _payroll2.default({ objectId: this.get('payrollId') }).fetch().then(function (payroll) {
	                _this2.payroll = payroll;
	                return _this2.payroll;
	            });
	        }
	    }, {
	        key: 'getPayroll',
	        value: function getPayroll() {
	            return this.payroll;
	        }
	    }, {
	        key: 'setPayroll',
	        value: function setPayroll(payroll) {
	            if (this.get('payrollId') === payroll.id) {
	                this.payroll = payroll;
	            }
	        }
	    }, {
	        key: 'fetchCompany',
	        value: function fetchCompany() {
	            var _this3 = this;
	
	            if (this.company) {
	                (0, _bluebird.resolve)(this.company);
	            }
	
	            return this.fetchPayroll().then(function (payroll) {
	                return payroll.fetchCompany();
	            }).then(function (company) {
	                _this3.company = company;
	                return _this3.company;
	            });
	        }
	    }, {
	        key: 'getCompany',
	        value: function getCompany() {
	            return this.company;
	        }
	    }, {
	        key: 'setCompany',
	        value: function setCompany(company) {
	            if (this.payroll && this.payroll.get('companyId') === company.id) {
	                this.company = company;
	            }
	        }
	    }, {
	        key: 'getPeriod',
	        value: function getPeriod() {
	            var payroll = this.getPayroll() || {};
	            var m = void 0;
	
	            if (this.get('periodDate')) {
	                return (0, _moment2.default)(this.get('periodDate'));
	            }
	
	            if (typeof payroll.getPeriod === 'function') {
	                return payroll.getPeriod();
	            }
	
	            m = (0, _moment2.default)(this.get('createdAt') || Date.now());
	            if (m.date() >= _config2.default.periodStartDate) {
	                return m;
	            } else {
	                return m.subtract(1, 'month');
	            }
	        }
	    }, {
	        key: 'getPeriodFormatted',
	        value: function getPeriodFormatted() {
	            var payroll = this.getPayroll() || {};
	
	            if (typeof payroll.getPeriodFormatted === 'function') {
	                return payroll.getPeriodFormatted();
	            }
	
	            return this.getPeriod().format('MMMM YYYY');
	        }
	    }, {
	        key: 'getFormattedDate',
	        value: function getFormattedDate() {
	            return (0, _moment2.default)(this.get('createdAt')).format('MMM D, YYYY');
	        }
	    }, {
	        key: 'fetchDetails',
	        value: function fetchDetails() {
	            var _this4 = this;
	
	            var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
	            var pagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            return new _payslipDetails2.default(null, { payslip: this, filter: {
	                    limit: limit
	                },
	                pagination: pagination }).fetch().then(function (payslip) {
	                _this4.details = payslip;return _this4.details;
	            });
	        }
	    }, {
	        key: 'getDetails',
	        value: function getDetails() {
	            return this.details;
	        }
	    }, {
	        key: 'fetchEmployee',
	        value: function fetchEmployee() {
	            var _this5 = this;
	
	            if (this.employee) {
	                (0, _bluebird.resolve)(this.employee);
	            }
	
	            if (!this.get('employeeId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _employee2.default({ objectId: this.get('employeeId') }).fetch({ validate: false }).then(function (model) {
	                _this5.employee = model;
	                return _this5.employee;
	            });
	        }
	    }, {
	        key: 'getEmployee',
	        value: function getEmployee() {
	            return this.employee;
	        }
	    }, {
	        key: 'fetchAttachments',
	        value: function fetchAttachments() {
	            var _this6 = this;
	
	            return this.attachments.fetch().then(function () {
	                return _this6.attachments;
	            });
	        }
	    }, {
	        key: 'getHrdf',
	        value: function getHrdf() {
	            var hrdf = this.get('hrdf') || 0;
	            var sum = this.getDetails().filter(function (detail) {
	                return detail.getPayrollItem().get('subtype') === 'hrdf';
	            }).reduce(function (total, detail) {
	                return parseFloat((detail.get('amount') + total).toFixed(2));
	            }, hrdf);
	            return sum || 0;
	        }
	    }, {
	        key: 'getPayslipJSON',
	        value: function getPayslipJSON() {
	            return _axios2.default.get(this.finalUrl() + '/getJSON', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }]);
	
	    return Payslip;
	}(_model2.default);
	
	exports.default = Payslip;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payslipDetail = __webpack_require__(584);
	
	var _payslipDetail2 = _interopRequireDefault(_payslipDetail);
	
	var _payrollItemFilters = __webpack_require__(585);
	
	var _payrollItemFilters2 = _interopRequireDefault(_payrollItemFilters);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayslipDetails = function (_PayrollItemFilters) {
	    _inherits(PayslipDetails, _PayrollItemFilters);
	
	    function PayslipDetails() {
	        _classCallCheck(this, PayslipDetails);
	
	        return _possibleConstructorReturn(this, (PayslipDetails.__proto__ || Object.getPrototypeOf(PayslipDetails)).apply(this, arguments));
	    }
	
	    _createClass(PayslipDetails, [{
	        key: 'url',
	        value: function url() {
	            if (this.payslip) {
	                return this.payslip.url() + '/details';
	            }
	
	            return '/PayslipDetails';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$payslip = _ref.payslip,
	                payslip = _ref$payslip === undefined ? null : _ref$payslip;
	
	            this.model = _payslipDetail2.default;
	            this.payslip = payslip;
	            return _get(PayslipDetails.prototype.__proto__ || Object.getPrototypeOf(PayslipDetails.prototype), 'initialize', this).apply(this, arguments);
	        }
	
	        // TODO we need the payroll items to sort, so we need to figure out
	        // a way for them to be included when this run
	
	    }, {
	        key: 'comparator',
	        value: function comparator(a, b) {
	            // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	            var weightByType = {
	                base: 100,
	                addition: 90,
	                benefit: 80,
	                deduction: 70,
	                unpaid_leave: 65,
	                cp38: 63,
	                mtd: 60,
	                epf: 50,
	                socso: 40,
	                zakat: 30
	            };
	            // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	            var itemA = a.getPayrollItem();
	            var itemB = b.getPayrollItem();
	
	            if (a.get('isAdditional') > b.get('isAdditional')) {
	                return 1;
	            }
	
	            if (a.get('amount') < b.get('amount')) {
	                return 1;
	            }
	
	            if (!itemA || !itemB) {
	                return 1;
	            }
	
	            if (weightByType[itemA.get('type')] < weightByType[itemB.get('type')]) {
	                return 1;
	            }
	        }
	    }, {
	        key: 'setPayslip',
	        value: function setPayslip(payslip) {
	            this.payslip = payslip;
	        }
	
	        /**
	         * Get payslip details that have an amount attr larger than 0 in a brand
	         * new collection
	         *
	         * @instance
	         * @todo TODO Why is this called current?
	         * @returns {module:collections.PayslipDetails}
	         */
	
	    }, {
	        key: 'current',
	        value: function current() {
	            return new _collection2.default(_.clone(this.filter(function (model) {
	                return (model.get('amount') || 0) > 0;
	            })));
	        }
	
	        /**
	         * Get the sum of all items' amount (regardless of payroll item config)
	         *
	         * @instance
	         * @returns {Number}
	         */
	
	    }, {
	        key: 'getFullAmount',
	        value: function getFullAmount() {
	            return this.reduce(function (memo, model) {
	                return memo.plus(model.get('fullAmount') || 0);
	            }, new _decimal2.default(0)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	        }
	
	        /**
	         * Get the sum of all items that affect the net amount
	         *
	         * @instance
	         * @returns {Number}
	         */
	
	    }, {
	        key: 'getNetAmount',
	        value: function getNetAmount() {
	            return this.reduce(function (memo, detail) {
	                var payrollItem = detail.getPayrollItem();
	                if (payrollItem && payrollItem.get('isNet')) {
	                    return memo.plus(detail.getRealAmount() || 0);
	                }
	                return memo;
	            }, new _decimal2.default(0)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	        }
	
	        /**
	         * Create a new collection with all payslip details that are affected by
	         * unpaid leave
	         *
	         * @instance
	         * @returns {module:collections.PayslipDetails}
	         */
	
	    }, {
	        key: 'findAffectedByUnpaidLeave',
	        value: function findAffectedByUnpaidLeave() {
	            return new PayslipDetails(this.filter(function (model) {
	                return model.get('isUnpaidLeave') === true;
	            }), { payslip: this.payslip });
	        }
	    }]);
	
	    return PayslipDetails;
	}((0, _payrollItemFilters2.default)(_collection2.default));
	
	exports.default = PayslipDetails;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/payslip-detail');
	
	var PayslipDetail = function (_Model) {
	    _inherits(PayslipDetail, _Model);
	
	    function PayslipDetail() {
	        _classCallCheck(this, PayslipDetail);
	
	        return _possibleConstructorReturn(this, (PayslipDetail.__proto__ || Object.getPrototypeOf(PayslipDetail)).apply(this, arguments));
	    }
	
	    _createClass(PayslipDetail, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/PayslipDetails';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.payrollItem = this.getPayrollItem();
	            this.affectsItem = this.getAffectsItem();
	            this.on('change:payrollItemId', this._setPayrollItem, this);
	            this.on('change:affectsItem', this._setAffectsItem, this);
	            this.idAttribute = 'objectId';
	            return _get(PayslipDetail.prototype.__proto__ || Object.getPrototypeOf(PayslipDetail.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'getPayrollItem',
	        value: function getPayrollItem() {
	            if (this.payrollItem) {
	                return this.payrollItem;
	            }
	
	            return this._setPayrollItem(this.get('payrollItemId'));
	        }
	    }, {
	        key: '_setPayrollItem',
	        value: function _setPayrollItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                log.warn('PayslipDetail doesn\'t have a payroll item');
	                return;
	            }
	
	            this.payrollItem = app.payrollItems.find(function (model) {
	                return model.get('objectId') === id;
	            });
	
	            return this.payrollItem;
	        }
	    }, {
	        key: 'getAffectsItem',
	        value: function getAffectsItem() {
	            if (this.affectsItem) {
	                return this.affectsItem;
	            }
	
	            return this._setAffectsItem(this.get('affectsItemId'));
	        }
	    }, {
	        key: '_setAffectsItem',
	        value: function _setAffectsItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                return;
	            }
	
	            this.affectsItem = app.payrollItems.find(function (model) {
	                return model.get('objectId') === id;
	            });
	
	            return this.affectsItem;
	        }
	    }, {
	        key: 'isUnit',
	        value: function isUnit() {
	            var item = this.getPayrollItem();
	            return item.get('isUnit') === true;
	        }
	    }, {
	        key: 'isZakat',
	        value: function isZakat() {
	            var item = this.getPayrollItem();
	            return item.get('type') === 'zakat';
	        }
	    }, {
	        key: 'isAddition',
	        value: function isAddition() {
	            var item = this.getPayrollItem();
	            return item && _.contains(['addition', 'bonus', 'base'], item.get('type')) && (item.get('isGross') || item.get('isNet'));
	        }
	    }, {
	        key: 'isDeduction',
	        value: function isDeduction() {
	            var item = this.getPayrollItem();
	            return item && _.contains(['unpaid_leave', 'deduction', 'mtd', 'epf', 'socso', 'cp38'], item.get('type')) && (item.get('isGross') || item.get('isNet'));
	        }
	    }, {
	        key: 'isOther',
	        value: function isOther() {
	            var item = this.getPayrollItem();
	            return item && !item.get('isGross') && !item.get('isNet');
	        }
	    }, {
	        key: 'getRealAmount',
	        value: function getRealAmount() {
	            var item = this.getPayrollItem();
	            var multiplier = _.contains(['base', 'bonus', 'addition', 'benefit', 'overtime'], item.get('type')) ? 1 : -1;
	            return (this.get('amount') || 0) * multiplier;
	        }
	    }, {
	        key: 'getPayrollItemName',
	        value: function getPayrollItemName() {
	            var payrollItemName = (this.getPayrollItem() ? this.getPayrollItem().get('name') : '') || '';
	
	            if (this.getAffectsItem() && this.getAffectsItem().get('name')) {
	                payrollItemName += ' on ' + this.getAffectsItem().get('name');
	            }
	
	            return payrollItemName;
	        }
	    }]);
	
	    return PayslipDetail;
	}(_model2.default);
	
	exports.default = PayslipDetail;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (superclass) {
	    return function (_superclass) {
	        _inherits(_class, _superclass);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: 'findByPayrollItem',
	            value: function findByPayrollItem(payrollItem, options) {
	                var id = typeof payrollItem === 'string' ? payrollItem : payrollItem.id;
	
	                return new this.constructor(this.filter(function (model) {
	                    return model.get('payrollItemId') === id;
	                }), options);
	            }
	        }, {
	            key: 'findByType',
	            value: function findByType(type) {
	                if (typeof type !== 'string') {
	                    return new this.constructor(null, {});
	                }
	
	                return this.findByTypes([type]);
	            }
	        }, {
	            key: 'findByTypes',
	            value: function findByTypes(types) {
	                return new this.constructor(this.filter(function (model) {
	                    var payrollItem = model.getPayrollItem();
	
	                    return payrollItem && _.contains(types, payrollItem.get('type'));
	                }), {});
	            }
	        }, {
	            key: 'findAdditions',
	            value: function findAdditions() {
	                var additions = this.filter(function (model) {
	                    var payrollItem = model.getPayrollItem();
	
	                    return payrollItem && _.contains(['addition', 'bonus', 'base', 'overtime'], payrollItem.get('type')) && (payrollItem.get('isGross') || payrollItem.get('isNet'));
	                });
	                return new this.constructor(additions.sort(function (x, y) {
	                    return x.getPayrollItem().get('name') === 'Salary (Basic)' ? -1 : y.getPayrollItem().get('name') === 'Salary (Basic)' ? 1 : 0;
	                }), {});
	            }
	        }, {
	            key: 'findBenefits',
	            value: function findBenefits() {
	                return new this.constructor(this.filter(function (model) {
	                    var payrollItem = model.getPayrollItem();
	
	                    return payrollItem && payrollItem.get('type') === 'benefit' && payrollItem.get('affectsMtd') === true && !payrollItem.get('isGross') && !payrollItem.get('isNet');
	                }), {});
	            }
	        }, {
	            key: 'findBenefitsNonTaxable',
	            value: function findBenefitsNonTaxable() {
	                return new this.constructor(this.filter(function (model) {
	                    var payrollItem = model.getPayrollItem();
	
	                    return payrollItem && payrollItem.get('type') === 'benefit' && payrollItem.get('affectsMtd') === false && !payrollItem.get('isGross') && !payrollItem.get('isNet');
	                }), {});
	            }
	        }, {
	            key: 'findDeductions',
	            value: function findDeductions() {
	                return new this.constructor(this.filter(function (model) {
	                    var payrollItem = model.getPayrollItem();
	
	                    return payrollItem && (payrollItem.get('type') === 'mtd' || _.contains(['unpaid_leave', 'deduction', 'mtd', 'epf', 'socso', 'cp38', 'zakat', 'eis', 'hrdf'], payrollItem.get('type')) && (payrollItem.get('isGross') || payrollItem.get('isNet')));
	                }), {});
	            }
	        }, {
	            key: 'findTaxDeductions',
	            value: function findTaxDeductions() {
	                return new this.constructor(this.filter(function (model) {
	                    var payrollItem = model.getPayrollItem();
	
	                    return payrollItem && (payrollItem.get('type') === 'deduction' && payrollItem.get('affectsMtd') === true || payrollItem.get('type') === 'zakat') && !payrollItem.get('isGross') && !payrollItem.get('isNet');
	                }), {});
	            }
	        }]);
	
	        return _class;
	    }(superclass);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js v10.3.1
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js
	   *  Copyright (c) 2021 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The maximum exponent magnitude.
	    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
	  var EXP_LIMIT = 9e15,                      // 0 to 9e15
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	    MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	    // Base conversion alphabet.
	    NUMERALS = '0123456789abcdef',
	
	    // The natural logarithm of 10 (1025 digits).
	    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058',
	
	    // Pi (1025 digits).
	    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789',
	
	
	    // The initial configuration properties of the Decimal constructor.
	    DEFAULTS = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed at run-time using the `Decimal.config` method.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used when rounding to `precision`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The modulo mode used when calculating the modulus: a mod n.
	      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
	      // The remainder (r) is calculated as: r = a - n * q.
	      //
	      // UP         0 The remainder is positive if the dividend is negative, else is negative.
	      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
	      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
	      // HALF_EVEN  6 The IEEE 754 remainder function.
	      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
	      //
	      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
	      // division (9) are commonly used for the modulus operation. The other rounding modes can also
	      // be used, but they may not give useful results.
	      modulo: 1,                             // 0 to 9
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -EXP_LIMIT
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to EXP_LIMIT
	
	      // The minimum exponent value, beneath which underflow to zero occurs.
	      // JavaScript numbers: -324  (5e-324)
	      minE: -EXP_LIMIT,                      // -1 to -EXP_LIMIT
	
	      // The maximum exponent value, above which overflow to Infinity occurs.
	      // JavaScript numbers: 308  (1.7976931348623157e+308)
	      maxE: EXP_LIMIT,                       // 1 to EXP_LIMIT
	
	      // Whether to use cryptographically-secure random number generation, if available.
	      crypto: false                          // true/false
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    Decimal, inexact, noConflict, quadrant,
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    precisionLimitExceeded = decimalError + 'Precision limit exceeded',
	    cryptoUnavailable = decimalError + 'crypto unavailable',
	    tag = '[object Decimal]',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
	    isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
	    isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	
	    LN10_PRECISION = LN10.length - 1,
	    PI_PRECISION = PI.length - 1,
	
	    // Decimal.prototype object
	    P = { toStringTag: tag };
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue             abs
	   *  ceil
	   *  clampedTo                 clamp
	   *  comparedTo                cmp
	   *  cosine                    cos
	   *  cubeRoot                  cbrt
	   *  decimalPlaces             dp
	   *  dividedBy                 div
	   *  dividedToIntegerBy        divToInt
	   *  equals                    eq
	   *  floor
	   *  greaterThan               gt
	   *  greaterThanOrEqualTo      gte
	   *  hyperbolicCosine          cosh
	   *  hyperbolicSine            sinh
	   *  hyperbolicTangent         tanh
	   *  inverseCosine             acos
	   *  inverseHyperbolicCosine   acosh
	   *  inverseHyperbolicSine     asinh
	   *  inverseHyperbolicTangent  atanh
	   *  inverseSine               asin
	   *  inverseTangent            atan
	   *  isFinite
	   *  isInteger                 isInt
	   *  isNaN
	   *  isNegative                isNeg
	   *  isPositive                isPos
	   *  isZero
	   *  lessThan                  lt
	   *  lessThanOrEqualTo         lte
	   *  logarithm                 log
	   *  [maximum]                 [max]
	   *  [minimum]                 [min]
	   *  minus                     sub
	   *  modulo                    mod
	   *  naturalExponential        exp
	   *  naturalLogarithm          ln
	   *  negated                   neg
	   *  plus                      add
	   *  precision                 sd
	   *  round
	   *  sine                      sin
	   *  squareRoot                sqrt
	   *  tangent                   tan
	   *  times                     mul
	   *  toBinary
	   *  toDecimalPlaces           toDP
	   *  toExponential
	   *  toFixed
	   *  toFraction
	   *  toHexadecimal             toHex
	   *  toNearest
	   *  toNumber
	   *  toOctal
	   *  toPower                   pow
	   *  toPrecision
	   *  toSignificantDigits       toSD
	   *  toString
	   *  truncated                 trunc
	   *  valueOf                   toJSON
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s < 0) x.s = 1;
	    return finalise(x);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
	   * direction of positive Infinity.
	   *
	   */
	  P.ceil = function () {
	    return finalise(new this.constructor(this), this.e + 1, 2);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal clamped to the range
	   * delineated by `min` and `max`.
	   *
	   * min {number|string|Decimal}
	   * max {number|string|Decimal}
	   *
	   */
	  P.clampedTo = P.clamp = function (min, max) {
	    var k,
	      x = this,
	      Ctor = x.constructor;
	    min = new Ctor(min);
	    max = new Ctor(max);
	    if (!min.s || !max.s) return new Ctor(NaN);
	    if (min.gt(max)) throw Error(invalidArgument + max);
	    k = x.cmp(min);
	    return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value,
	   *   NaN  if the value of either Decimal is NaN.
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this,
	      xd = x.d,
	      yd = (y = new x.constructor(y)).d,
	      xs = x.s,
	      ys = y.s;
	
	    // Either NaN or ±Infinity?
	    if (!xd || !yd) {
	      return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
	    }
	
	    // Either zero?
	    if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
	
	    // Signs differ?
	    if (xs !== ys) return xs;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
	
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-1, 1]
	   *
	   * cos(0)         = 1
	   * cos(-0)        = 1
	   * cos(Infinity)  = NaN
	   * cos(-Infinity) = NaN
	   * cos(NaN)       = NaN
	   *
	   */
	  P.cosine = P.cos = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.d) return new Ctor(NaN);
	
	    // cos(0) = cos(-0) = 1
	    if (!x.d[0]) return new Ctor(1);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
	    Ctor.rounding = 1;
	
	    x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
	  };
	
	
	  /*
	   *
	   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   *  cbrt(0)  =  0
	   *  cbrt(-0) = -0
	   *  cbrt(1)  =  1
	   *  cbrt(-1) = -1
	   *  cbrt(N)  =  N
	   *  cbrt(-I) = -I
	   *  cbrt(I)  =  I
	   *
	   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
	   *
	   */
	  P.cubeRoot = P.cbrt = function () {
	    var e, m, n, r, rep, s, sd, t, t3, t3plusx,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite() || x.isZero()) return new Ctor(x);
	    external = false;
	
	    // Initial estimate.
	    s = x.s * mathpow(x.s * x, 1 / 3);
	
	     // Math.cbrt underflow/overflow?
	     // Pass x to Math.pow as integer, then adjust the exponent of the result.
	    if (!s || Math.abs(s) == 1 / 0) {
	      n = digitsToString(x.d);
	      e = x.e;
	
	      // Adjust n exponent so it is a multiple of 3 away from x exponent.
	      if (s = (e - n.length + 1) % 3) n += (s == 1 || s == -2 ? '0' : '00');
	      s = mathpow(n, 1 / 3);
	
	      // Rarely, e may be one less than the result exponent value.
	      e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
	
	      if (s == 1 / 0) {
	        n = '5e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	      r.s = x.s;
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    sd = (e = Ctor.precision) + 3;
	
	    // Halley's method.
	    // TODO? Compare Newton's method.
	    for (;;) {
	      t = r;
	      t3 = t.times(t).times(t);
	      t3plusx = t3.plus(x);
	      r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
	
	      // TODO? Replace with for-loop and checkRoundingDigits.
	      if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
	        n = n.slice(sd - 3, sd + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
	        // , i.e. approaching a rounding boundary, continue the iteration.
	        if (n == '9999' || !rep && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          if (!rep) {
	            finalise(t, e + 1, 0);
	
	            if (t.times(t).times(t).eq(x)) {
	              r = t;
	              break;
	            }
	          }
	
	          sd += 4;
	          rep = 1;
	        } else {
	
	          // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
	          // If not, then there are further digits and m will be truthy.
	          if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
	
	            // Truncate to the first rounding digit.
	            finalise(r, e + 1, 1);
	            m = !r.times(r).times(r).eq(x);
	          }
	
	          break;
	        }
	      }
	    }
	
	    external = true;
	
	    return finalise(r, e, Ctor.rounding, m);
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var w,
	      d = this.d,
	      n = NaN;
	
	    if (d) {
	      w = d.length - 1;
	      n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
	
	      // Subtract the number of trailing zeros of the last word.
	      w = d[w];
	      if (w) for (; w % 10 == 0; w /= 10) n--;
	      if (n < 0) n = 0;
	    }
	
	    return n;
	  };
	
	
	  /*
	   *  n / 0 = I
	   *  n / N = N
	   *  n / I = 0
	   *  0 / n = 0
	   *  0 / 0 = N
	   *  0 / N = N
	   *  0 / I = 0
	   *  N / n = N
	   *  N / 0 = N
	   *  N / N = N
	   *  N / I = N
	   *  I / n = I
	   *  I / 0 = I
	   *  I / N = N
	   *  I / I = N
	   *
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   */
	  P.dividedToIntegerBy = P.divToInt = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return this.cmp(y) === 0;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
	   * direction of negative Infinity.
	   *
	   */
	  P.floor = function () {
	    return finalise(new this.constructor(this), this.e + 1, 3);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    var k = this.cmp(y);
	    return k == 1 || k === 0;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [1, Infinity]
	   *
	   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
	   *
	   * cosh(0)         = 1
	   * cosh(-0)        = 1
	   * cosh(Infinity)  = Infinity
	   * cosh(-Infinity) = Infinity
	   * cosh(NaN)       = NaN
	   *
	   *  x        time taken (ms)   result
	   * 1000      9                 9.8503555700852349694e+433
	   * 10000     25                4.4034091128314607936e+4342
	   * 100000    171               1.4033316802130615897e+43429
	   * 1000000   3817              1.5166076984010437725e+434294
	   * 10000000  abandoned after 2 minute wait
	   *
	   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
	   *
	   */
	  P.hyperbolicCosine = P.cosh = function () {
	    var k, n, pr, rm, len,
	      x = this,
	      Ctor = x.constructor,
	      one = new Ctor(1);
	
	    if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
	    if (x.isZero()) return one;
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
	    Ctor.rounding = 1;
	    len = x.d.length;
	
	    // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
	    // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
	
	    // Estimate the optimum number of times to use the argument reduction.
	    // TODO? Estimation reused from cosine() and may not be optimal here.
	    if (len < 32) {
	      k = Math.ceil(len / 3);
	      n = (1 / tinyPow(4, k)).toString();
	    } else {
	      k = 16;
	      n = '2.3283064365386962890625e-10';
	    }
	
	    x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
	
	    // Reverse argument reduction
	    var cosh2_x,
	      i = k,
	      d8 = new Ctor(8);
	    for (; i--;) {
	      cosh2_x = x.times(x);
	      x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
	    }
	
	    return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-Infinity, Infinity]
	   *
	   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
	   *
	   * sinh(0)         = 0
	   * sinh(-0)        = -0
	   * sinh(Infinity)  = Infinity
	   * sinh(-Infinity) = -Infinity
	   * sinh(NaN)       = NaN
	   *
	   * x        time taken (ms)
	   * 10       2 ms
	   * 100      5 ms
	   * 1000     14 ms
	   * 10000    82 ms
	   * 100000   886 ms            1.4033316802130615897e+43429
	   * 200000   2613 ms
	   * 300000   5407 ms
	   * 400000   8824 ms
	   * 500000   13026 ms          8.7080643612718084129e+217146
	   * 1000000  48543 ms
	   *
	   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
	   *
	   */
	  P.hyperbolicSine = P.sinh = function () {
	    var k, pr, rm, len,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite() || x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
	    Ctor.rounding = 1;
	    len = x.d.length;
	
	    if (len < 3) {
	      x = taylorSeries(Ctor, 2, x, x, true);
	    } else {
	
	      // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
	      // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
	      // 3 multiplications and 1 addition
	
	      // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
	      // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
	      // 4 multiplications and 2 additions
	
	      // Estimate the optimum number of times to use the argument reduction.
	      k = 1.4 * Math.sqrt(len);
	      k = k > 16 ? 16 : k | 0;
	
	      x = x.times(1 / tinyPow(5, k));
	      x = taylorSeries(Ctor, 2, x, x, true);
	
	      // Reverse argument reduction
	      var sinh2_x,
	        d5 = new Ctor(5),
	        d16 = new Ctor(16),
	        d20 = new Ctor(20);
	      for (; k--;) {
	        sinh2_x = x.times(x);
	        x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
	      }
	    }
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(x, pr, rm, true);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-1, 1]
	   *
	   * tanh(x) = sinh(x) / cosh(x)
	   *
	   * tanh(0)         = 0
	   * tanh(-0)        = -0
	   * tanh(Infinity)  = 1
	   * tanh(-Infinity) = -1
	   * tanh(NaN)       = NaN
	   *
	   */
	  P.hyperbolicTangent = P.tanh = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(x.s);
	    if (x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + 7;
	    Ctor.rounding = 1;
	
	    return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
	   * this Decimal.
	   *
	   * Domain: [-1, 1]
	   * Range: [0, pi]
	   *
	   * acos(x) = pi/2 - asin(x)
	   *
	   * acos(0)       = pi/2
	   * acos(-0)      = pi/2
	   * acos(1)       = 0
	   * acos(-1)      = pi
	   * acos(1/2)     = pi/3
	   * acos(-1/2)    = 2*pi/3
	   * acos(|x| > 1) = NaN
	   * acos(NaN)     = NaN
	   *
	   */
	  P.inverseCosine = P.acos = function () {
	    var halfPi,
	      x = this,
	      Ctor = x.constructor,
	      k = x.abs().cmp(1),
	      pr = Ctor.precision,
	      rm = Ctor.rounding;
	
	    if (k !== -1) {
	      return k === 0
	        // |x| is 1
	        ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0)
	        // |x| > 1 or x is NaN
	        : new Ctor(NaN);
	    }
	
	    if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
	
	    // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
	
	    Ctor.precision = pr + 6;
	    Ctor.rounding = 1;
	
	    x = x.asin();
	    halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return halfPi.minus(x);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
	   * value of this Decimal.
	   *
	   * Domain: [1, Infinity]
	   * Range: [0, Infinity]
	   *
	   * acosh(x) = ln(x + sqrt(x^2 - 1))
	   *
	   * acosh(x < 1)     = NaN
	   * acosh(NaN)       = NaN
	   * acosh(Infinity)  = Infinity
	   * acosh(-Infinity) = NaN
	   * acosh(0)         = NaN
	   * acosh(-0)        = NaN
	   * acosh(1)         = 0
	   * acosh(-1)        = NaN
	   *
	   */
	  P.inverseHyperbolicCosine = P.acosh = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
	    if (!x.isFinite()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
	    Ctor.rounding = 1;
	    external = false;
	
	    x = x.times(x).minus(1).sqrt().plus(x);
	
	    external = true;
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.ln();
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
	   * of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-Infinity, Infinity]
	   *
	   * asinh(x) = ln(x + sqrt(x^2 + 1))
	   *
	   * asinh(NaN)       = NaN
	   * asinh(Infinity)  = Infinity
	   * asinh(-Infinity) = -Infinity
	   * asinh(0)         = 0
	   * asinh(-0)        = -0
	   *
	   */
	  P.inverseHyperbolicSine = P.asinh = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite() || x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
	    Ctor.rounding = 1;
	    external = false;
	
	    x = x.times(x).plus(1).sqrt().plus(x);
	
	    external = true;
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.ln();
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
	   * value of this Decimal.
	   *
	   * Domain: [-1, 1]
	   * Range: [-Infinity, Infinity]
	   *
	   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
	   *
	   * atanh(|x| > 1)   = NaN
	   * atanh(NaN)       = NaN
	   * atanh(Infinity)  = NaN
	   * atanh(-Infinity) = NaN
	   * atanh(0)         = 0
	   * atanh(-0)        = -0
	   * atanh(1)         = Infinity
	   * atanh(-1)        = -Infinity
	   *
	   */
	  P.inverseHyperbolicTangent = P.atanh = function () {
	    var pr, rm, wpr, xsd,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(NaN);
	    if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    xsd = x.sd();
	
	    if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
	
	    Ctor.precision = wpr = xsd - x.e;
	
	    x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
	
	    Ctor.precision = pr + 4;
	    Ctor.rounding = 1;
	
	    x = x.ln();
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.times(0.5);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-pi/2, pi/2]
	   *
	   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
	   *
	   * asin(0)       = 0
	   * asin(-0)      = -0
	   * asin(1/2)     = pi/6
	   * asin(-1/2)    = -pi/6
	   * asin(1)       = pi/2
	   * asin(-1)      = -pi/2
	   * asin(|x| > 1) = NaN
	   * asin(NaN)     = NaN
	   *
	   * TODO? Compare performance of Taylor series.
	   *
	   */
	  P.inverseSine = P.asin = function () {
	    var halfPi, k,
	      pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (x.isZero()) return new Ctor(x);
	
	    k = x.abs().cmp(1);
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    if (k !== -1) {
	
	      // |x| is 1
	      if (k === 0) {
	        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
	        halfPi.s = x.s;
	        return halfPi;
	      }
	
	      // |x| > 1 or x is NaN
	      return new Ctor(NaN);
	    }
	
	    // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
	
	    Ctor.precision = pr + 6;
	    Ctor.rounding = 1;
	
	    x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.times(2);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
	   * of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-pi/2, pi/2]
	   *
	   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
	   *
	   * atan(0)         = 0
	   * atan(-0)        = -0
	   * atan(1)         = pi/4
	   * atan(-1)        = -pi/4
	   * atan(Infinity)  = pi/2
	   * atan(-Infinity) = -pi/2
	   * atan(NaN)       = NaN
	   *
	   */
	  P.inverseTangent = P.atan = function () {
	    var i, j, k, n, px, t, r, wpr, x2,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      rm = Ctor.rounding;
	
	    if (!x.isFinite()) {
	      if (!x.s) return new Ctor(NaN);
	      if (pr + 4 <= PI_PRECISION) {
	        r = getPi(Ctor, pr + 4, rm).times(0.5);
	        r.s = x.s;
	        return r;
	      }
	    } else if (x.isZero()) {
	      return new Ctor(x);
	    } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
	      r = getPi(Ctor, pr + 4, rm).times(0.25);
	      r.s = x.s;
	      return r;
	    }
	
	    Ctor.precision = wpr = pr + 10;
	    Ctor.rounding = 1;
	
	    // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
	
	    // Argument reduction
	    // Ensure |x| < 0.42
	    // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
	
	    k = Math.min(28, wpr / LOG_BASE + 2 | 0);
	
	    for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));
	
	    external = false;
	
	    j = Math.ceil(wpr / LOG_BASE);
	    n = 1;
	    x2 = x.times(x);
	    r = new Ctor(x);
	    px = x;
	
	    // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
	    for (; i !== -1;) {
	      px = px.times(x2);
	      t = r.minus(px.div(n += 2));
	
	      px = px.times(x2);
	      r = t.plus(px.div(n += 2));
	
	      if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--;);
	    }
	
	    if (k) r = r.times(2 << (k - 1));
	
	    external = true;
	
	    return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is a finite number, otherwise return false.
	   *
	   */
	  P.isFinite = function () {
	    return !!this.d;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isInt = function () {
	    return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is NaN, otherwise return false.
	   *
	   */
	  P.isNaN = function () {
	    return !this.s;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isNeg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.isPos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return !!this.d && this.d[0] === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * If no base is specified, return log[10](arg).
	   *
	   * log[base](arg) = ln(arg) / ln(base)
	   *
	   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
	   * otherwise:
	   *
	   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
	   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
	   * between the result and the correctly rounded result will be one ulp (unit in the last place).
	   *
	   * log[-b](a)       = NaN
	   * log[0](a)        = NaN
	   * log[1](a)        = NaN
	   * log[NaN](a)      = NaN
	   * log[Infinity](a) = NaN
	   * log[b](0)        = -Infinity
	   * log[b](-0)       = -Infinity
	   * log[b](-a)       = NaN
	   * log[b](1)        = 0
	   * log[b](Infinity) = Infinity
	   * log[b](NaN)      = NaN
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var isBase10, d, denominator, k, inf, num, sd, r,
	      arg = this,
	      Ctor = arg.constructor,
	      pr = Ctor.precision,
	      rm = Ctor.rounding,
	      guard = 5;
	
	    // Default base is 10.
	    if (base == null) {
	      base = new Ctor(10);
	      isBase10 = true;
	    } else {
	      base = new Ctor(base);
	      d = base.d;
	
	      // Return NaN if base is negative, or non-finite, or is 0 or 1.
	      if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
	
	      isBase10 = base.eq(10);
	    }
	
	    d = arg.d;
	
	    // Is arg negative, non-finite, 0 or 1?
	    if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
	      return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
	    }
	
	    // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
	    // integer power of 10.
	    if (isBase10) {
	      if (d.length > 1) {
	        inf = true;
	      } else {
	        for (k = d[0]; k % 10 === 0;) k /= 10;
	        inf = k !== 1;
	      }
	    }
	
	    external = false;
	    sd = pr + guard;
	    num = naturalLogarithm(arg, sd);
	    denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
	
	    // The result will have 5 rounding digits.
	    r = divide(num, denominator, sd, 1);
	
	    // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
	    // calculate 10 further digits.
	    //
	    // If the result is known to have an infinite decimal expansion, repeat this until it is clear
	    // that the result is above or below the boundary. Otherwise, if after calculating the 10
	    // further digits, the last 14 are nines, round up and assume the result is exact.
	    // Also assume the result is exact if the last 14 are zero.
	    //
	    // Example of a result that will be incorrectly rounded:
	    // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
	    // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
	    // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
	    // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
	    // place is still 2.6.
	    if (checkRoundingDigits(r.d, k = pr, rm)) {
	
	      do {
	        sd += 10;
	        num = naturalLogarithm(arg, sd);
	        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
	        r = divide(num, denominator, sd, 1);
	
	        if (!inf) {
	
	          // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
	          if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
	            r = finalise(r, pr + 1, 0);
	          }
	
	          break;
	        }
	      } while (checkRoundingDigits(r.d, k += 10, rm));
	    }
	
	    external = true;
	
	    return finalise(r, pr, rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
	   *
	   * arguments {number|string|Decimal}
	   *
	  P.max = function () {
	    Array.prototype.push.call(arguments, this);
	    return maxOrMin(this.constructor, arguments, 'lt');
	  };
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
	   *
	   * arguments {number|string|Decimal}
	   *
	  P.min = function () {
	    Array.prototype.push.call(arguments, this);
	    return maxOrMin(this.constructor, arguments, 'gt');
	  };
	   */
	
	
	  /*
	   *  n - 0 = n
	   *  n - N = N
	   *  n - I = -I
	   *  0 - n = -n
	   *  0 - 0 = 0
	   *  0 - N = N
	   *  0 - I = -I
	   *  N - n = N
	   *  N - 0 = N
	   *  N - N = N
	   *  N - I = N
	   *  I - n = I
	   *  I - 0 = I
	   *  I - N = N
	   *  I - I = N
	   *
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd,
	      x = this,
	      Ctor = x.constructor;
	
	    y = new Ctor(y);
	
	    // If either is not finite...
	    if (!x.d || !y.d) {
	
	      // Return NaN if either is NaN.
	      if (!x.s || !y.s) y = new Ctor(NaN);
	
	      // Return y negated if x is finite and y is ±Infinity.
	      else if (x.d) y.s = -y.s;
	
	      // Return x if y is finite and x is ±Infinity.
	      // Return x if both are ±Infinity with different signs.
	      // Return NaN if both are ±Infinity with the same sign.
	      else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
	
	      return y;
	    }
	
	    // If signs differ...
	    if (x.s != y.s) {
	      y.s = -y.s;
	      return x.plus(y);
	    }
	
	    xd = x.d;
	    yd = y.d;
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    // If either is zero...
	    if (!xd[0] || !yd[0]) {
	
	      // Return y negated if x is zero and y is non-zero.
	      if (yd[0]) y.s = -y.s;
	
	      // Return x if y is zero and x is non-zero.
	      else if (xd[0]) y = new Ctor(x);
	
	      // Return zero if both are zero.
	      // From IEEE 754 (2008) 6.3: 0 - 0 = -0 - -0 = -0 when rounding to -Infinity.
	      else return new Ctor(rm === 3 ? -0 : 0);
	
	      return external ? finalise(y, pr, rm) : y;
	    }
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    // Calculate base 1e7 exponents.
	    e = mathfloor(y.e / LOG_BASE);
	    xe = mathfloor(x.e / LOG_BASE);
	
	    xd = xd.slice();
	    k = xe - e;
	
	    // If base 1e7 exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of
	      // zeros needing to be prepended, but this can be avoided while still ensuring correct
	      // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to `xd` if shorter.
	    // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
	
	    y.d = xd;
	    y.e = getBase10Exponent(xd, e);
	
	    return external ? finalise(y, pr, rm) : y;
	  };
	
	
	  /*
	   *   n % 0 =  N
	   *   n % N =  N
	   *   n % I =  n
	   *   0 % n =  0
	   *  -0 % n = -0
	   *   0 % 0 =  N
	   *   0 % N =  N
	   *   0 % I =  0
	   *   N % n =  N
	   *   N % 0 =  N
	   *   N % N =  N
	   *   N % I =  N
	   *   I % n =  N
	   *   I % 0 =  N
	   *   I % N =  N
	   *   I % I =  N
	   *
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * The result depends on the modulo mode.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor;
	
	    y = new Ctor(y);
	
	    // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
	    if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
	
	    // Return x if y is ±Infinity or x is ±0.
	    if (!y.d || x.d && !x.d[0]) {
	      return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
	    }
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	
	    if (Ctor.modulo == 9) {
	
	      // Euclidian division: q = sign(y) * floor(x / abs(y))
	      // result = x - q * y    where  0 <= result < abs(y)
	      q = divide(x, y.abs(), 0, 3, 1);
	      q.s *= y.s;
	    } else {
	      q = divide(x, y, 0, Ctor.modulo, 1);
	    }
	
	    q = q.times(y);
	
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return naturalExponential(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return naturalLogarithm(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s;
	    return finalise(x);
	  };
	
	
	  /*
	   *  n + 0 = n
	   *  n + N = N
	   *  n + I = I
	   *  0 + n = n
	   *  0 + 0 = 0
	   *  0 + N = N
	   *  0 + I = I
	   *  N + n = N
	   *  N + 0 = N
	   *  N + N = N
	   *  N + I = N
	   *  I + n = I
	   *  I + 0 = I
	   *  I + N = N
	   *  I + I = I
	   *
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var carry, d, e, i, k, len, pr, rm, xd, yd,
	      x = this,
	      Ctor = x.constructor;
	
	    y = new Ctor(y);
	
	    // If either is not finite...
	    if (!x.d || !y.d) {
	
	      // Return NaN if either is NaN.
	      if (!x.s || !y.s) y = new Ctor(NaN);
	
	      // Return x if y is finite and x is ±Infinity.
	      // Return x if both are ±Infinity with the same sign.
	      // Return NaN if both are ±Infinity with different signs.
	      // Return y if x is finite and y is ±Infinity.
	      else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
	
	      return y;
	    }
	
	     // If signs differ...
	    if (x.s != y.s) {
	      y.s = -y.s;
	      return x.minus(y);
	    }
	
	    xd = x.d;
	    yd = y.d;
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    // If either is zero...
	    if (!xd[0] || !yd[0]) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!yd[0]) y = new Ctor(x);
	
	      return external ? finalise(y, pr, rm) : y;
	    }
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    // Calculate base 1e7 exponents.
	    k = mathfloor(x.e / LOG_BASE);
	    e = mathfloor(y.e / LOG_BASE);
	
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = getBase10Exponent(xd, e);
	
	    return external ? finalise(y, pr, rm) : y;
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var k,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    if (x.d) {
	      k = getPrecision(x.d);
	      if (z && x.e + 1 > k) k = x.e + 1;
	    } else {
	      k = NaN;
	    }
	
	    return k;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.round = function () {
	    var x = this,
	      Ctor = x.constructor;
	
	    return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-1, 1]
	   *
	   * sin(x) = x - x^3/3! + x^5/5! - ...
	   *
	   * sin(0)         = 0
	   * sin(-0)        = -0
	   * sin(Infinity)  = NaN
	   * sin(-Infinity) = NaN
	   * sin(NaN)       = NaN
	   *
	   */
	  P.sine = P.sin = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(NaN);
	    if (x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
	    Ctor.rounding = 1;
	
	    x = sine(Ctor, toLessThanHalfPi(Ctor, x));
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   *  sqrt(-n) =  N
	   *  sqrt(N)  =  N
	   *  sqrt(-I) =  N
	   *  sqrt(I)  =  I
	   *  sqrt(0)  =  0
	   *  sqrt(-0) = -0
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var m, n, sd, r, rep, t,
	      x = this,
	      d = x.d,
	      e = x.e,
	      s = x.s,
	      Ctor = x.constructor;
	
	    // Negative/NaN/Infinity/zero?
	    if (s !== 1 || !d || !d[0]) {
	      return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
	    }
	
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(d);
	
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '5e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    sd = (e = Ctor.precision) + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
	
	      // TODO? Replace with for-loop and checkRoundingDigits.
	      if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
	        n = n.slice(sd - 3, sd + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (n == '9999' || !rep && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          if (!rep) {
	            finalise(t, e + 1, 0);
	
	            if (t.times(t).eq(x)) {
	              r = t;
	              break;
	            }
	          }
	
	          sd += 4;
	          rep = 1;
	        } else {
	
	          // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
	          // If not, then there are further digits and m will be truthy.
	          if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
	
	            // Truncate to the first rounding digit.
	            finalise(r, e + 1, 1);
	            m = !r.times(r).eq(x);
	          }
	
	          break;
	        }
	      }
	    }
	
	    external = true;
	
	    return finalise(r, e, Ctor.rounding, m);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-Infinity, Infinity]
	   *
	   * tan(0)         = 0
	   * tan(-0)        = -0
	   * tan(Infinity)  = NaN
	   * tan(-Infinity) = NaN
	   * tan(NaN)       = NaN
	   *
	   */
	  P.tangent = P.tan = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(NaN);
	    if (x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + 10;
	    Ctor.rounding = 1;
	
	    x = x.sin();
	    x.s = 1;
	    x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
	  };
	
	
	  /*
	   *  n * 0 = 0
	   *  n * N = N
	   *  n * I = I
	   *  0 * n = 0
	   *  0 * 0 = 0
	   *  0 * N = N
	   *  0 * I = N
	   *  N * n = N
	   *  N * 0 = N
	   *  N * N = N
	   *  N * I = N
	   *  I * n = I
	   *  I * 0 = N
	   *  I * N = N
	   *  I * I = I
	   *
	   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    y.s *= x.s;
	
	     // If either is NaN, ±Infinity or ±0...
	    if (!xd || !xd[0] || !yd || !yd[0]) {
	
	      return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd
	
	        // Return NaN if either is NaN.
	        // Return NaN if x is ±0 and y is ±Infinity, or y is ±0 and x is ±Infinity.
	        ? NaN
	
	        // Return ±Infinity if either is ±Infinity.
	        // Return ±0 if either is ±0.
	        : !xd || !yd ? y.s / 0 : y.s * 0);
	    }
	
	    e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = getBase10Exponent(r, e);
	
	    return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
	   * digits using rounding mode `rm`.
	   *
	   * If the optional `sd` argument is present then return binary exponential notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toBinary = function (sd, rm) {
	    return toStringBinary(this, 2, sd, rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.toDP = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return finalise(x, dp + x.e + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = finiteToString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = finalise(new Ctor(x), dp + 1, rm);
	      str = finiteToString(x, true, dp + 1);
	    }
	
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = finiteToString(x);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      y = finalise(new Ctor(x), dp + x.e + 1, rm);
	      str = finiteToString(y, false, dp + y.e + 1);
	    }
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return an array representing the value of this Decimal as a simple fraction with an integer
	   * numerator and an integer denominator.
	   *
	   * The denominator will be a positive non-zero value less than or equal to the specified maximum
	   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
	   * value necessary to represent the number exactly.
	   *
	   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
	   *
	   */
	  P.toFraction = function (maxD) {
	    var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r,
	      x = this,
	      xd = x.d,
	      Ctor = x.constructor;
	
	    if (!xd) return new Ctor(x);
	
	    n1 = d0 = new Ctor(1);
	    d1 = n0 = new Ctor(0);
	
	    d = new Ctor(d1);
	    e = d.e = getPrecision(xd) - x.e - 1;
	    k = e % LOG_BASE;
	    d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
	
	    if (maxD == null) {
	
	      // d is 10**e, the minimum max-denominator needed.
	      maxD = e > 0 ? d : n1;
	    } else {
	      n = new Ctor(maxD);
	      if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
	      maxD = n.gt(d) ? (e > 0 ? d : n1) : n;
	    }
	
	    external = false;
	    n = new Ctor(digitsToString(xd));
	    pr = Ctor.precision;
	    Ctor.precision = e = xd.length * LOG_BASE * 2;
	
	    for (;;)  {
	      q = divide(n, d, 0, 1, 1);
	      d2 = d0.plus(q.times(d1));
	      if (d2.cmp(maxD) == 1) break;
	      d0 = d1;
	      d1 = d2;
	      d2 = n1;
	      n1 = n0.plus(q.times(d2));
	      n0 = d2;
	      d2 = d;
	      d = n.minus(q.times(d2));
	      n = d2;
	    }
	
	    d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
	    n0 = n0.plus(d2.times(n1));
	    d0 = d0.plus(d2.times(d1));
	    n0.s = n1.s = x.s;
	
	    // Determine which fraction is closer to x, n0/d0 or n1/d1?
	    r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1
	        ? [n1, d1] : [n0, d0];
	
	    Ctor.precision = pr;
	    external = true;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
	   * digits using rounding mode `rm`.
	   *
	   * If the optional `sd` argument is present then return binary exponential notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toHexadecimal = P.toHex = function (sd, rm) {
	    return toStringBinary(this, 16, sd, rm);
	  };
	
	
	  /*
	   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
	   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
	   *
	   * The return value will always have the same sign as this Decimal, unless either this Decimal
	   * or `y` is NaN, in which case the return value will be also be NaN.
	   *
	   * The return value is not affected by the value of `precision`.
	   *
	   * y {number|string|Decimal} The magnitude to round to a multiple of.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * 'toNearest() rounding mode not an integer: {rm}'
	   * 'toNearest() rounding mode out of range: {rm}'
	   *
	   */
	  P.toNearest = function (y, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	
	    if (y == null) {
	
	      // If x is not finite, return x.
	      if (!x.d) return x;
	
	      y = new Ctor(1);
	      rm = Ctor.rounding;
	    } else {
	      y = new Ctor(y);
	      if (rm === void 0) {
	        rm = Ctor.rounding;
	      } else {
	        checkInt32(rm, 0, 8);
	      }
	
	      // If x is not finite, return x if y is not NaN, else NaN.
	      if (!x.d) return y.s ? x : y;
	
	      // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
	      if (!y.d) {
	        if (y.s) y.s = x.s;
	        return y;
	      }
	    }
	
	    // If y is not zero, calculate the nearest multiple of y to x.
	    if (y.d[0]) {
	      external = false;
	      x = divide(x, y, 0, rm, 1).times(y);
	      external = true;
	      finalise(x);
	
	    // If y is zero, return zero with the sign of x.
	    } else {
	      y.s = x.s;
	      x = y;
	    }
	
	    return x;
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   * Zero keeps its sign.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
	   * digits using rounding mode `rm`.
	   *
	   * If the optional `sd` argument is present then return binary exponential notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toOctal = function (sd, rm) {
	    return toStringBinary(this, 8, sd, rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
	   * to `precision` significant digits using rounding mode `rounding`.
	   *
	   * ECMAScript compliant.
	   *
	   *   pow(x, NaN)                           = NaN
	   *   pow(x, ±0)                            = 1
	
	   *   pow(NaN, non-zero)                    = NaN
	   *   pow(abs(x) > 1, +Infinity)            = +Infinity
	   *   pow(abs(x) > 1, -Infinity)            = +0
	   *   pow(abs(x) == 1, ±Infinity)           = NaN
	   *   pow(abs(x) < 1, +Infinity)            = +0
	   *   pow(abs(x) < 1, -Infinity)            = +Infinity
	   *   pow(+Infinity, y > 0)                 = +Infinity
	   *   pow(+Infinity, y < 0)                 = +0
	   *   pow(-Infinity, odd integer > 0)       = -Infinity
	   *   pow(-Infinity, even integer > 0)      = +Infinity
	   *   pow(-Infinity, odd integer < 0)       = -0
	   *   pow(-Infinity, even integer < 0)      = +0
	   *   pow(+0, y > 0)                        = +0
	   *   pow(+0, y < 0)                        = +Infinity
	   *   pow(-0, odd integer > 0)              = -0
	   *   pow(-0, even integer > 0)             = +0
	   *   pow(-0, odd integer < 0)              = -Infinity
	   *   pow(-0, even integer < 0)             = +Infinity
	   *   pow(finite x < 0, finite non-integer) = NaN
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
	   * probability of an incorrectly rounded result
	   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
	   * i.e. 1 in 250,000,000,000,000
	   *
	   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, rm, s,
	      x = this,
	      Ctor = x.constructor,
	      yn = +(y = new Ctor(y));
	
	    // Either ±Infinity, NaN or ±0?
	    if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
	
	    x = new Ctor(x);
	
	    if (x.eq(1)) return x;
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    if (y.eq(1)) return finalise(x, pr, rm);
	
	    // y exponent
	    e = mathfloor(y.e / LOG_BASE);
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = intPow(Ctor, x, k, pr);
	      return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
	    }
	
	    s = x.s;
	
	    // if x is negative
	    if (s < 0) {
	
	      // if y is not an integer
	      if (e < y.d.length - 1) return new Ctor(NaN);
	
	      // Result is positive if x is negative and the last digit of integer y is even.
	      if ((y.d[e] & 1) == 0) s = 1;
	
	      // if x.eq(-1)
	      if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
	        x.s = s;
	        return x;
	      }
	    }
	
	    // Estimate result exponent.
	    // x^y = 10^e,  where e = y * log10(x)
	    // log10(x) = log10(x_significand) + x_exponent
	    // log10(x_significand) = ln(x_significand) / ln(10)
	    k = mathpow(+x, yn);
	    e = k == 0 || !isFinite(k)
	      ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1))
	      : new Ctor(k + '').e;
	
	    // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
	
	    // Overflow/underflow?
	    if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
	
	    external = false;
	    Ctor.rounding = x.s = 1;
	
	    // Estimate the extra guard digits needed to ensure five correct rounding digits from
	    // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
	    // new Decimal(2.32456).pow('2087987436534566.46411')
	    // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
	    k = Math.min(12, (e + '').length);
	
	    // r = x^y = exp(y*ln(x))
	    r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
	
	    // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
	    if (r.d) {
	
	      // Truncate to the required precision plus five rounding digits.
	      r = finalise(r, pr + 5, 1);
	
	      // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
	      // the result.
	      if (checkRoundingDigits(r.d, pr, rm)) {
	        e = pr + 10;
	
	        // Truncate to the increased precision plus five rounding digits.
	        r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
	
	        // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
	        if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
	          r = finalise(r, pr + 1, 0);
	        }
	      }
	    }
	
	    r.s = s;
	    external = true;
	    Ctor.rounding = rm;
	
	    return finalise(r, pr, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = finalise(new Ctor(x), sd, rm);
	      str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
	    }
	
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * 'toSD() digits out of range: {sd}'
	   * 'toSD() digits not an integer: {sd}'
	   * 'toSD() rounding mode not an integer: {rm}'
	   * 'toSD() rounding mode out of range: {rm}'
	   *
	   */
	  P.toSignificantDigits = P.toSD = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return finalise(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = function () {
	    var x = this,
	      Ctor = x.constructor,
	      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
	
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
	   *
	   */
	  P.truncated = P.trunc = function () {
	    return finalise(new this.constructor(this), this.e + 1, 1);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   * Unlike `toString`, negative zero will include the minus sign.
	   *
	   */
	  P.valueOf = P.toJSON = function () {
	    var x = this,
	      Ctor = x.constructor,
	      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
	
	    return x.isNeg() ? '-' + str : str;
	  };
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
	   *                           finiteToString, naturalExponential, naturalLogarithm
	   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
	   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
	   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
	   *  convertBase              toStringBinary, parseOther
	   *  cos                      P.cos
	   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
	   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
	   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
	   *                           taylorSeries, atan2, parseOther
	   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
	   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
	   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
	   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
	   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
	   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
	   *                           naturalLogarithm, ceil, floor, round, trunc
	   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
	   *                           toStringBinary
	   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
	   *  getLn10                  P.logarithm, naturalLogarithm
	   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
	   *  getPrecision             P.precision, P.toFraction
	   *  getZeroString            digitsToString, finiteToString
	   *  intPow                   P.toPower, parseOther
	   *  isOdd                    toLessThanHalfPi
	   *  maxOrMin                 max, min
	   *  naturalExponential       P.naturalExponential, P.toPower
	   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
	   *                           P.toPower, naturalExponential
	   *  nonFiniteToString        finiteToString, toStringBinary
	   *  parseDecimal             Decimal
	   *  parseOther               Decimal
	   *  sin                      P.sin
	   *  taylorSeries             P.cosh, P.sinh, cos, sin
	   *  toLessThanHalfPi         P.cos, P.sin
	   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
	   *  truncate                 intPow
	   *
	   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
	   *                           naturalLogarithm, config, parseOther, random, Decimal
	   */
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  /*
	   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
	   * `repeating == null` if caller is `log` or `pow`,
	   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
	   */
	  function checkRoundingDigits(d, i, rm, repeating) {
	    var di, k, r, rd;
	
	    // Get the length of the first word of the array d.
	    for (k = d[0]; k >= 10; k /= 10) --i;
	
	    // Is the rounding digit in the first word of d?
	    if (--i < 0) {
	      i += LOG_BASE;
	      di = 0;
	    } else {
	      di = Math.ceil((i + 1) / LOG_BASE);
	      i %= LOG_BASE;
	    }
	
	    // i is the index (0 - 6) of the rounding digit.
	    // E.g. if within the word 3487563 the first rounding digit is 5,
	    // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
	    k = mathpow(10, LOG_BASE - i);
	    rd = d[di] % k | 0;
	
	    if (repeating == null) {
	      if (i < 3) {
	        if (i == 0) rd = rd / 100 | 0;
	        else if (i == 1) rd = rd / 10 | 0;
	        r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
	      } else {
	        r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) &&
	          (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 ||
	            (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
	      }
	    } else {
	      if (i < 4) {
	        if (i == 0) rd = rd / 1000 | 0;
	        else if (i == 1) rd = rd / 100 | 0;
	        else if (i == 2) rd = rd / 10 | 0;
	        r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
	      } else {
	        r = ((repeating || rm < 4) && rd + 1 == k ||
	        (!repeating && rm > 3) && rd + 1 == k / 2) &&
	          (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
	      }
	    }
	
	    return r;
	  }
	
	
	  // Convert string of `baseIn` to an array of numbers of `baseOut`.
	  // Eg. convertBase('255', 10, 16) returns [15, 15].
	  // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
	  function convertBase(str, baseIn, baseOut) {
	    var j,
	      arr = [0],
	      arrL,
	      i = 0,
	      strL = str.length;
	
	    for (; i < strL;) {
	      for (arrL = arr.length; arrL--;) arr[arrL] *= baseIn;
	      arr[0] += NUMERALS.indexOf(str.charAt(i++));
	      for (j = 0; j < arr.length; j++) {
	        if (arr[j] > baseOut - 1) {
	          if (arr[j + 1] === void 0) arr[j + 1] = 0;
	          arr[j + 1] += arr[j] / baseOut | 0;
	          arr[j] %= baseOut;
	        }
	      }
	    }
	
	    return arr.reverse();
	  }
	
	
	  /*
	   * cos(x) = 1 - x^2/2! + x^4/4! - ...
	   * |x| < pi/2
	   *
	   */
	  function cosine(Ctor, x) {
	    var k, len, y;
	
	    if (x.isZero()) return x;
	
	    // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
	    // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
	
	    // Estimate the optimum number of times to use the argument reduction.
	    len = x.d.length;
	    if (len < 32) {
	      k = Math.ceil(len / 3);
	      y = (1 / tinyPow(4, k)).toString();
	    } else {
	      k = 16;
	      y = '2.3283064365386962890625e-10';
	    }
	
	    Ctor.precision += k;
	
	    x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
	
	    // Reverse argument reduction
	    for (var i = k; i--;) {
	      var cos2x = x.times(x);
	      x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
	    }
	
	    Ctor.precision -= k;
	
	    return x;
	  }
	
	
	  /*
	   * Perform division in the specified base.
	   */
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k, base) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % base | 0;
	        carry = temp / base | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL, base) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * base + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, rm, dp, base) {
	      var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0,
	        yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either NaN, Infinity or 0?
	      if (!xd || !xd[0] || !yd || !yd[0]) {
	
	        return new Ctor(// Return NaN if either NaN, or both Infinity or 0.
	          !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN :
	
	          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
	          xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
	      }
	
	      if (base) {
	        logBase = 1;
	        e = x.e - y.e;
	      } else {
	        base = BASE;
	        logBase = LOG_BASE;
	        e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
	      }
	
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      // The digit array of a Decimal from toStringBinary may have trailing zeros.
	      for (i = 0; yd[i] == (xd[i] || 0); i++);
	
	      if (yd[i] > (xd[i] || 0)) e--;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	        rm = Ctor.rounding;
	      } else if (dp) {
	        sd = pr + (x.e - y.e) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) {
	        qd.push(1);
	        more = true;
	      } else {
	
	        // Convert precision in number of base 10 digits to base 1e7 digits.
	        sd = sd / logBase + 2 | 0;
	        i = 0;
	
	        // divisor < 1e7
	        if (yL == 1) {
	          k = 0;
	          yd = yd[0];
	          sd++;
	
	          // k is the carry.
	          for (; (i < xL || k) && sd--; i++) {
	            t = k * base + (xd[i] || 0);
	            qd[i] = t / yd | 0;
	            k = t % yd | 0;
	          }
	
	          more = k || i < xL;
	
	        // divisor >= 1e7
	        } else {
	
	          // Normalise xd and yd so highest order digit of yd is >= base/2
	          k = base / (yd[0] + 1) | 0;
	
	          if (k > 1) {
	            yd = multiplyInteger(yd, k, base);
	            xd = multiplyInteger(xd, k, base);
	            yL = yd.length;
	            xL = xd.length;
	          }
	
	          xi = yL;
	          rem = xd.slice(0, yL);
	          remL = rem.length;
	
	          // Add zeros to make remainder as long as divisor.
	          for (; remL < yL;) rem[remL++] = 0;
	
	          yz = yd.slice();
	          yz.unshift(0);
	          yd0 = yd[0];
	
	          if (yd[1] >= base / 2) ++yd0;
	
	          do {
	            k = 0;
	
	            // Compare divisor and remainder.
	            cmp = compare(yd, rem, yL, remL);
	
	            // If divisor < remainder.
	            if (cmp < 0) {
	
	              // Calculate trial digit, k.
	              rem0 = rem[0];
	              if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
	
	              // k will be how many times the divisor goes into the current remainder.
	              k = rem0 / yd0 | 0;
	
	              //  Algorithm:
	              //  1. product = divisor * trial digit (k)
	              //  2. if product > remainder: product -= divisor, k--
	              //  3. remainder -= product
	              //  4. if product was < remainder at 2:
	              //    5. compare new remainder and divisor
	              //    6. If remainder > divisor: remainder -= divisor, k++
	
	              if (k > 1) {
	                if (k >= base) k = base - 1;
	
	                // product = divisor * trial digit.
	                prod = multiplyInteger(yd, k, base);
	                prodL = prod.length;
	                remL = rem.length;
	
	                // Compare product and remainder.
	                cmp = compare(prod, rem, prodL, remL);
	
	                // product > remainder.
	                if (cmp == 1) {
	                  k--;
	
	                  // Subtract divisor from product.
	                  subtract(prod, yL < prodL ? yz : yd, prodL, base);
	                }
	              } else {
	
	                // cmp is -1.
	                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	                if (k == 0) cmp = k = 1;
	                prod = yd.slice();
	              }
	
	              prodL = prod.length;
	              if (prodL < remL) prod.unshift(0);
	
	              // Subtract product from remainder.
	              subtract(rem, prod, remL, base);
	
	              // If product was < previous remainder.
	              if (cmp == -1) {
	                remL = rem.length;
	
	                // Compare divisor and new remainder.
	                cmp = compare(yd, rem, yL, remL);
	
	                // If divisor < new remainder, subtract divisor from remainder.
	                if (cmp < 1) {
	                  k++;
	
	                  // Subtract divisor from remainder.
	                  subtract(rem, yL < remL ? yz : yd, remL, base);
	                }
	              }
	
	              remL = rem.length;
	            } else if (cmp === 0) {
	              k++;
	              rem = [0];
	            }    // if cmp === 1, k will be 0
	
	            // Add the next digit, k, to the result array.
	            qd[i++] = k;
	
	            // Update the remainder.
	            if (cmp && rem[0]) {
	              rem[remL++] = xd[xi] || 0;
	            } else {
	              rem = [xd[xi]];
	              remL = 1;
	            }
	
	          } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	
	          more = rem[0] !== void 0;
	        }
	
	        // Leading zero?
	        if (!qd[0]) qd.shift();
	      }
	
	      // logBase is 1 when divide is being used for base conversion.
	      if (logBase == 1) {
	        q.e = e;
	        inexact = more;
	      } else {
	
	        // To calculate q.e, first get the number of digits of qd[0].
	        for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
	        q.e = i + e * logBase - 1;
	
	        finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
	      }
	
	      return q;
	    };
	  })();
	
	
	  /*
	   * Round `x` to `sd` significant digits using rounding mode `rm`.
	   * Check for over/under-flow.
	   */
	   function finalise(x, sd, rm, isTruncated) {
	    var digits, i, j, k, rd, roundUp, w, xd, xdi,
	      Ctor = x.constructor;
	
	    // Don't round if sd is null or undefined.
	    out: if (sd != null) {
	      xd = x.d;
	
	      // Infinity/NaN.
	      if (!xd) return x;
	
	      // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	      // w: the word of xd containing rd, a base 1e7 number.
	      // xdi: the index of w within xd.
	      // digits: the number of digits of w.
	      // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	      // they had leading zeros)
	      // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	      // Get the length of the first word of the digits array xd.
	      for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
	      i = sd - digits;
	
	      // Is the rounding digit in the first word of xd?
	      if (i < 0) {
	        i += LOG_BASE;
	        j = sd;
	        w = xd[xdi = 0];
	
	        // Get the rounding digit at index j of w.
	        rd = w / mathpow(10, digits - j - 1) % 10 | 0;
	      } else {
	        xdi = Math.ceil((i + 1) / LOG_BASE);
	        k = xd.length;
	        if (xdi >= k) {
	          if (isTruncated) {
	
	            // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
	            for (; k++ <= xdi;) xd.push(0);
	            w = rd = 0;
	            digits = 1;
	            i %= LOG_BASE;
	            j = i - LOG_BASE + 1;
	          } else {
	            break out;
	          }
	        } else {
	          w = k = xd[xdi];
	
	          // Get the number of digits of w.
	          for (digits = 1; k >= 10; k /= 10) digits++;
	
	          // Get the index of rd within w.
	          i %= LOG_BASE;
	
	          // Get the index of rd within w, adjusted for leading zeros.
	          // The number of leading zeros of w is given by LOG_BASE - digits.
	          j = i - LOG_BASE + digits;
	
	          // Get the rounding digit at index j of w.
	          rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
	        }
	      }
	
	      // Are there any non-zero digits after the rounding digit?
	      isTruncated = isTruncated || sd < 0 ||
	        xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
	
	      // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
	      // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
	      // will give 714.
	
	      roundUp = rm < 4
	        ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	
	      if (sd < 1 || !xd[0]) {
	        xd.length = 0;
	        if (roundUp) {
	
	          // Convert sd to decimal places.
	          sd -= x.e + 1;
	
	          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	          xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	          x.e = -sd || 0;
	        } else {
	
	          // Zero.
	          xd[0] = x.e = 0;
	        }
	
	        return x;
	      }
	
	      // Remove excess digits.
	      if (i == 0) {
	        xd.length = xdi;
	        k = 1;
	        xdi--;
	      } else {
	        xd.length = xdi + 1;
	        k = mathpow(10, LOG_BASE - i);
	
	        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	        // j > 0 means i > number of leading zeros of w.
	        xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
	      }
	
	      if (roundUp) {
	        for (;;) {
	
	          // Is the digit to be rounded up in the first word of xd?
	          if (xdi == 0) {
	
	            // i will be the length of xd[0] before k is added.
	            for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
	            j = xd[0] += k;
	            for (k = 1; j >= 10; j /= 10) k++;
	
	            // if i != k the length has increased.
	            if (i != k) {
	              x.e++;
	              if (xd[0] == BASE) xd[0] = 1;
	            }
	
	            break;
	          } else {
	            xd[xdi] += k;
	            if (xd[xdi] != BASE) break;
	            xd[xdi--] = 0;
	            k = 1;
	          }
	        }
	      }
	
	      // Remove trailing zeros.
	      for (i = xd.length; xd[--i] === 0;) xd.pop();
	    }
	
	    if (external) {
	
	      // Overflow?
	      if (x.e > Ctor.maxE) {
	
	        // Infinity.
	        x.d = null;
	        x.e = NaN;
	
	      // Underflow?
	      } else if (x.e < Ctor.minE) {
	
	        // Zero.
	        x.e = 0;
	        x.d = [0];
	        // Ctor.underflow = true;
	      } // else Ctor.underflow = false;
	    }
	
	    return x;
	  }
	
	
	  function finiteToString(x, isExp, sd) {
	    if (!x.isFinite()) return nonFiniteToString(x);
	    var k,
	      e = x.e,
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return str;
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(digits, e) {
	    var w = digits[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for ( e *= LOG_BASE; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	    if (sd > LN10_PRECISION) {
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(precisionLimitExceeded);
	    }
	    return finalise(new Ctor(LN10), sd, 1, true);
	  }
	
	
	  function getPi(Ctor, sd, rm) {
	    if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
	    return finalise(new Ctor(PI), sd, rm, true);
	  }
	
	
	  function getPrecision(digits) {
	    var w = digits.length - 1,
	      len = w * LOG_BASE + 1;
	
	    w = digits[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) len--;
	
	      // Add the number of digits of the first word.
	      for (w = digits[0]; w >= 10; w /= 10) len++;
	    }
	
	    return len;
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
	   * integer of type number.
	   *
	   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
	   *
	   */
	  function intPow(Ctor, x, n, pr) {
	    var isTruncated,
	      r = new Ctor(1),
	
	      // Max n of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      k = Math.ceil(pr / LOG_BASE + 4);
	
	    external = false;
	
	    for (;;) {
	      if (n % 2) {
	        r = r.times(x);
	        if (truncate(r.d, k)) isTruncated = true;
	      }
	
	      n = mathfloor(n / 2);
	      if (n === 0) {
	
	        // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
	        n = r.d.length - 1;
	        if (isTruncated && r.d[n] === 0) ++r.d[n];
	        break;
	      }
	
	      x = x.times(x);
	      truncate(x.d, k);
	    }
	
	    external = true;
	
	    return r;
	  }
	
	
	  function isOdd(n) {
	    return n.d[n.d.length - 1] & 1;
	  }
	
	
	  /*
	   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
	   */
	  function maxOrMin(Ctor, args, ltgt) {
	    var y,
	      x = new Ctor(args[0]),
	      i = 0;
	
	    for (; ++i < args.length;) {
	      y = new Ctor(args[i]);
	      if (!y.s) {
	        x = y;
	        break;
	      } else if (x[ltgt](y)) {
	        x = y;
	      }
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
	   * digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
	   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(Infinity)  = Infinity
	   *  exp(-Infinity) = 0
	   *  exp(NaN)       = NaN
	   *  exp(±0)        = 1
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   *  The result will always be correctly rounded.
	   *
	   */
	  function naturalExponential(x, sd) {
	    var denominator, guard, j, pow, sum, t, wpr,
	      rep = 0,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      rm = Ctor.rounding,
	      pr = Ctor.precision;
	
	    // 0/NaN/Infinity?
	    if (!x.d || !x.d[0] || x.e > 17) {
	
	      return new Ctor(x.d
	        ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0
	        : x.s ? x.s < 0 ? 0 : x : 0 / 0);
	    }
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    // while abs(x) >= 0.1
	    while (x.e > -2) {
	
	      // x = x / 2^5
	      x = x.times(t);
	      k += 5;
	    }
	
	    // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
	    // necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(1);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = finalise(pow.times(x), wpr, 1);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr, 1));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        j = k;
	        while (j--) sum = finalise(sum.times(sum), wpr, 1);
	
	        // Check to see if the first 4 rounding digits are [49]999.
	        // If so, repeat the summation with a higher precision, otherwise
	        // e.g. with precision: 18, rounding: 1
	        // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
	        // `wpr - guard` is the index of first rounding digit.
	        if (sd == null) {
	
	          if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
	            Ctor.precision = wpr += 10;
	            denominator = pow = t = new Ctor(1);
	            i = 0;
	            rep++;
	          } else {
	            return finalise(sum, Ctor.precision = pr, rm, external = true);
	          }
	        } else {
	          Ctor.precision = pr;
	          return sum;
	        }
	      }
	
	      sum = t;
	    }
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
	   * digits.
	   *
	   *  ln(-n)        = NaN
	   *  ln(0)         = -Infinity
	   *  ln(-0)        = -Infinity
	   *  ln(1)         = 0
	   *  ln(Infinity)  = Infinity
	   *  ln(-Infinity) = NaN
	   *  ln(NaN)       = NaN
	   *
	   *  ln(n) (n != 1) is non-terminating.
	   *
	   */
	  function naturalLogarithm(y, sd) {
	    var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      rm = Ctor.rounding,
	      pr = Ctor.precision;
	
	    // Is x negative or Infinity, NaN, 0 or 1?
	    if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
	      return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
	    }
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    Ctor.precision = wpr += guard;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	
	    if (Math.abs(e = x.e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = x.e;
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	      Ctor.precision = pr;
	
	      return sd == null ? finalise(x, pr, rm, external = true) : x;
	    }
	
	    // x1 is x reduced to a value near 1.
	    x1 = x;
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
	    x2 = finalise(x.times(x), wpr, 1);
	    denominator = 3;
	
	    for (;;) {
	      numerator = finalise(numerator.times(x2), wpr, 1);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
	        // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr, 1);
	
	        // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
	        // been repeated previously) and the first 4 rounding digits 9999?
	        // If so, restart the summation with a higher precision, otherwise
	        // e.g. with precision: 12, rounding: 1
	        // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
	        // `wpr - guard` is the index of first rounding digit.
	        if (sd == null) {
	          if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
	            Ctor.precision = wpr += guard;
	            t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
	            x2 = finalise(x.times(x), wpr, 1);
	            denominator = rep = 1;
	          } else {
	            return finalise(sum, Ctor.precision = pr, rm, external = true);
	          }
	        } else {
	          Ctor.precision = pr;
	          return sum;
	        }
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  // ±Infinity, NaN.
	  function nonFiniteToString(x) {
	    // Unsigned.
	    return String(x.s * x.s / 0);
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48; i++);
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48; --len);
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      x.e = e = e - i - 1;
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external) {
	
	        // Overflow?
	        if (x.e > x.constructor.maxE) {
	
	          // Infinity.
	          x.d = null;
	          x.e = NaN;
	
	        // Underflow?
	        } else if (x.e < x.constructor.minE) {
	
	          // Zero.
	          x.e = 0;
	          x.d = [0];
	          // x.constructor.underflow = true;
	        } // else x.constructor.underflow = false;
	      }
	    } else {
	
	      // Zero.
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
	   */
	  function parseOther(x, str) {
	    var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
	
	    if (str.indexOf('_') > -1) {
	      str = str.replace(/(\d)_(?=\d)/g, '$1');
	      if (isDecimal.test(str)) return parseDecimal(x, str);
	    } else if (str === 'Infinity' || str === 'NaN') {
	      if (!+str) x.s = NaN;
	      x.e = NaN;
	      x.d = null;
	      return x;
	    }
	
	    if (isHex.test(str))  {
	      base = 16;
	      str = str.toLowerCase();
	    } else if (isBinary.test(str))  {
	      base = 2;
	    } else if (isOctal.test(str))  {
	      base = 8;
	    } else {
	      throw Error(invalidArgument + str);
	    }
	
	    // Is there a binary exponent part?
	    i = str.search(/p/i);
	
	    if (i > 0) {
	      p = +str.slice(i + 1);
	      str = str.substring(2, i);
	    } else {
	      str = str.slice(2);
	    }
	
	    // Convert `str` as an integer then divide the result by `base` raised to a power such that the
	    // fraction part will be restored.
	    i = str.indexOf('.');
	    isFloat = i >= 0;
	    Ctor = x.constructor;
	
	    if (isFloat) {
	      str = str.replace('.', '');
	      len = str.length;
	      i = len - i;
	
	      // log[10](16) = 1.2041... , log[10](88) = 1.9444....
	      divisor = intPow(Ctor, new Ctor(base), i, i * 2);
	    }
	
	    xd = convertBase(str, base, BASE);
	    xe = xd.length - 1;
	
	    // Remove trailing zeros.
	    for (i = xe; xd[i] === 0; --i) xd.pop();
	    if (i < 0) return new Ctor(x.s * 0);
	    x.e = getBase10Exponent(xd, xe);
	    x.d = xd;
	    external = false;
	
	    // At what precision to perform the division to ensure exact conversion?
	    // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
	    // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
	    // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
	    // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
	    // Therefore using 4 * the number of digits of str will always be enough.
	    if (isFloat) x = divide(x, divisor, len * 4);
	
	    // Multiply by the binary exponent part if present.
	    if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
	    external = true;
	
	    return x;
	  }
	
	
	  /*
	   * sin(x) = x - x^3/3! + x^5/5! - ...
	   * |x| < pi/2
	   *
	   */
	  function sine(Ctor, x) {
	    var k,
	      len = x.d.length;
	
	    if (len < 3) {
	      return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
	    }
	
	    // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
	    // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
	    // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
	
	    // Estimate the optimum number of times to use the argument reduction.
	    k = 1.4 * Math.sqrt(len);
	    k = k > 16 ? 16 : k | 0;
	
	    x = x.times(1 / tinyPow(5, k));
	    x = taylorSeries(Ctor, 2, x, x);
	
	    // Reverse argument reduction
	    var sin2_x,
	      d5 = new Ctor(5),
	      d16 = new Ctor(16),
	      d20 = new Ctor(20);
	    for (; k--;) {
	      sin2_x = x.times(x);
	      x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
	    }
	
	    return x;
	  }
	
	
	  // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
	  function taylorSeries(Ctor, n, x, y, isHyperbolic) {
	    var j, t, u, x2,
	      i = 1,
	      pr = Ctor.precision,
	      k = Math.ceil(pr / LOG_BASE);
	
	    external = false;
	    x2 = x.times(x);
	    u = new Ctor(y);
	
	    for (;;) {
	      t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
	      u = isHyperbolic ? y.plus(t) : y.minus(t);
	      y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
	      t = u.plus(y);
	
	      if (t.d[k] !== void 0) {
	        for (j = k; t.d[j] === u.d[j] && j--;);
	        if (j == -1) break;
	      }
	
	      j = u;
	      u = y;
	      y = t;
	      t = j;
	      i++;
	    }
	
	    external = true;
	    t.d.length = k + 1;
	
	    return t;
	  }
	
	
	  // Exponent e must be positive and non-zero.
	  function tinyPow(b, e) {
	    var n = b;
	    while (--e) n *= b;
	    return n;
	  }
	
	
	  // Return the absolute value of `x` reduced to less than or equal to half pi.
	  function toLessThanHalfPi(Ctor, x) {
	    var t,
	      isNeg = x.s < 0,
	      pi = getPi(Ctor, Ctor.precision, 1),
	      halfPi = pi.times(0.5);
	
	    x = x.abs();
	
	    if (x.lte(halfPi)) {
	      quadrant = isNeg ? 4 : 1;
	      return x;
	    }
	
	    t = x.divToInt(pi);
	
	    if (t.isZero()) {
	      quadrant = isNeg ? 3 : 2;
	    } else {
	      x = x.minus(t.times(pi));
	
	      // 0 <= x < pi
	      if (x.lte(halfPi)) {
	        quadrant = isOdd(t) ? (isNeg ? 2 : 3) : (isNeg ? 4 : 1);
	        return x;
	      }
	
	      quadrant = isOdd(t) ? (isNeg ? 1 : 4) : (isNeg ? 3 : 2);
	    }
	
	    return x.minus(pi).abs();
	  }
	
	
	  /*
	   * Return the value of Decimal `x` as a string in base `baseOut`.
	   *
	   * If the optional `sd` argument is present include a binary exponent suffix.
	   */
	  function toStringBinary(x, baseOut, sd, rm) {
	    var base, e, i, k, len, roundUp, str, xd, y,
	      Ctor = x.constructor,
	      isExp = sd !== void 0;
	
	    if (isExp) {
	      checkInt32(sd, 1, MAX_DIGITS);
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    } else {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    }
	
	    if (!x.isFinite()) {
	      str = nonFiniteToString(x);
	    } else {
	      str = finiteToString(x);
	      i = str.indexOf('.');
	
	      // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
	      // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
	      // minBinaryExponent = floor(decimalExponent * log[2](10))
	      // log[2](10) = 3.321928094887362347870319429489390175864
	
	      if (isExp) {
	        base = 2;
	        if (baseOut == 16) {
	          sd = sd * 4 - 3;
	        } else if (baseOut == 8) {
	          sd = sd * 3 - 2;
	        }
	      } else {
	        base = baseOut;
	      }
	
	      // Convert the number as an integer then divide the result by its base raised to a power such
	      // that the fraction part will be restored.
	
	      // Non-integer.
	      if (i >= 0) {
	        str = str.replace('.', '');
	        y = new Ctor(1);
	        y.e = str.length - i;
	        y.d = convertBase(finiteToString(y), 10, base);
	        y.e = y.d.length;
	      }
	
	      xd = convertBase(str, 10, base);
	      e = len = xd.length;
	
	      // Remove trailing zeros.
	      for (; xd[--len] == 0;) xd.pop();
	
	      if (!xd[0]) {
	        str = isExp ? '0p+0' : '0';
	      } else {
	        if (i < 0) {
	          e--;
	        } else {
	          x = new Ctor(x);
	          x.d = xd;
	          x.e = e;
	          x = divide(x, y, sd, rm, 0, base);
	          xd = x.d;
	          e = x.e;
	          roundUp = inexact;
	        }
	
	        // The rounding digit, i.e. the digit after the digit that may be rounded up.
	        i = xd[sd];
	        k = base / 2;
	        roundUp = roundUp || xd[sd + 1] !== void 0;
	
	        roundUp = rm < 4
	          ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2))
	          : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 ||
	            rm === (x.s < 0 ? 8 : 7));
	
	        xd.length = sd;
	
	        if (roundUp) {
	
	          // Rounding up may mean the previous digit has to be rounded up and so on.
	          for (; ++xd[--sd] > base - 1;) {
	            xd[sd] = 0;
	            if (!sd) {
	              ++e;
	              xd.unshift(1);
	            }
	          }
	        }
	
	        // Determine trailing zeros.
	        for (len = xd.length; !xd[len - 1]; --len);
	
	        // E.g. [4, 11, 15] becomes 4bf.
	        for (i = 0, str = ''; i < len; i++) str += NUMERALS.charAt(xd[i]);
	
	        // Add binary exponent suffix?
	        if (isExp) {
	          if (len > 1) {
	            if (baseOut == 16 || baseOut == 8) {
	              i = baseOut == 16 ? 4 : 3;
	              for (--len; len % i; len++) str += '0';
	              xd = convertBase(str, base, baseOut);
	              for (len = xd.length; !xd[len - 1]; --len);
	
	              // xd[0] will always be be 1
	              for (i = 1, str = '1.'; i < len; i++) str += NUMERALS.charAt(xd[i]);
	            } else {
	              str = str.charAt(0) + '.' + str.slice(1);
	            }
	          }
	
	          str =  str + (e < 0 ? 'p' : 'p+') + e;
	        } else if (e < 0) {
	          for (; ++e;) str = '0' + str;
	          str = '0.' + str;
	        } else {
	          if (++e > len) for (e -= len; e-- ;) str += '0';
	          else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
	        }
	      }
	
	      str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  abs
	   *  acos
	   *  acosh
	   *  add
	   *  asin
	   *  asinh
	   *  atan
	   *  atanh
	   *  atan2
	   *  cbrt
	   *  ceil
	   *  clamp
	   *  clone
	   *  config
	   *  cos
	   *  cosh
	   *  div
	   *  exp
	   *  floor
	   *  hypot
	   *  ln
	   *  log
	   *  log2
	   *  log10
	   *  max
	   *  min
	   *  mod
	   *  mul
	   *  pow
	   *  random
	   *  round
	   *  set
	   *  sign
	   *  sin
	   *  sinh
	   *  sqrt
	   *  sub
	   *  sum
	   *  tan
	   *  tanh
	   *  trunc
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of `x`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function abs(x) {
	    return new this(x).abs();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arccosine in radians of `x`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function acos(x) {
	    return new this(x).acos();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function acosh(x) {
	    return new this(x).acosh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function add(x, y) {
	    return new this(x).plus(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function asin(x) {
	    return new this(x).asin();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function asinh(x) {
	    return new this(x).asinh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function atan(x) {
	    return new this(x).atan();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function atanh(x) {
	    return new this(x).atanh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
	   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-pi, pi]
	   *
	   * y {number|string|Decimal} The y-coordinate.
	   * x {number|string|Decimal} The x-coordinate.
	   *
	   * atan2(±0, -0)               = ±pi
	   * atan2(±0, +0)               = ±0
	   * atan2(±0, -x)               = ±pi for x > 0
	   * atan2(±0, x)                = ±0 for x > 0
	   * atan2(-y, ±0)               = -pi/2 for y > 0
	   * atan2(y, ±0)                = pi/2 for y > 0
	   * atan2(±y, -Infinity)        = ±pi for finite y > 0
	   * atan2(±y, +Infinity)        = ±0 for finite y > 0
	   * atan2(±Infinity, x)         = ±pi/2 for finite x
	   * atan2(±Infinity, -Infinity) = ±3*pi/4
	   * atan2(±Infinity, +Infinity) = ±pi/4
	   * atan2(NaN, x) = NaN
	   * atan2(y, NaN) = NaN
	   *
	   */
	  function atan2(y, x) {
	    y = new this(y);
	    x = new this(x);
	    var r,
	      pr = this.precision,
	      rm = this.rounding,
	      wpr = pr + 4;
	
	    // Either NaN
	    if (!y.s || !x.s) {
	      r = new this(NaN);
	
	    // Both ±Infinity
	    } else if (!y.d && !x.d) {
	      r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
	      r.s = y.s;
	
	    // x is ±Infinity or y is ±0
	    } else if (!x.d || y.isZero()) {
	      r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
	      r.s = y.s;
	
	    // y is ±Infinity or x is ±0
	    } else if (!y.d || x.isZero()) {
	      r = getPi(this, wpr, 1).times(0.5);
	      r.s = y.s;
	
	    // Both non-zero and finite
	    } else if (x.s < 0) {
	      this.precision = wpr;
	      this.rounding = 1;
	      r = this.atan(divide(y, x, wpr, 1));
	      x = getPi(this, wpr, 1);
	      this.precision = pr;
	      this.rounding = rm;
	      r = y.s < 0 ? r.minus(x) : r.plus(x);
	    } else {
	      r = this.atan(divide(y, x, wpr, 1));
	    }
	
	    return r;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function cbrt(x) {
	    return new this(x).cbrt();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function ceil(x) {
	    return finalise(x = new this(x), x.e + 1, 2);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
	   *
	   * x {number|string|Decimal}
	   * min {number|string|Decimal}
	   * max {number|string|Decimal}
	   *
	   */
	  function clamp(x, min, max) {
	    return new this(x).clamp(min, max);
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *   maxE       {number}
	   *   minE       {number}
	   *   modulo     {number}
	   *   crypto     {boolean|number}
	   *   defaults   {true}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
	    var i, p, v,
	      useDefaults = obj.defaults === true,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -EXP_LIMIT, 0,
	        'toExpPos', 0, EXP_LIMIT,
	        'maxE', 0, EXP_LIMIT,
	        'minE', -EXP_LIMIT, 0,
	        'modulo', 0, 9
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
	      if ((v = obj[p]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
	    if ((v = obj[p]) !== void 0) {
	      if (v === true || v === false || v === 0 || v === 1) {
	        if (v) {
	          if (typeof crypto != 'undefined' && crypto &&
	            (crypto.getRandomValues || crypto.randomBytes)) {
	            this[p] = true;
	          } else {
	            throw Error(cryptoUnavailable);
	          }
	        } else {
	          this[p] = false;
	        }
	      } else {
	        throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    return this;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function cos(x) {
	    return new this(x).cos();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function cosh(x) {
	    return new this(x).cosh();
	  }
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * v {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(v) {
	      var e, i, t,
	        x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(v);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (isDecimalInstance(v)) {
	        x.s = v.s;
	
	        if (external) {
	          if (!v.d || v.e > Decimal.maxE) {
	
	            // Infinity.
	            x.e = NaN;
	            x.d = null;
	          } else if (v.e < Decimal.minE) {
	
	            // Zero.
	            x.e = 0;
	            x.d = [0];
	          } else {
	            x.e = v.e;
	            x.d = v.d.slice();
	          }
	        } else {
	          x.e = v.e;
	          x.d = v.d ? v.d.slice() : v.d;
	        }
	
	        return;
	      }
	
	      t = typeof v;
	
	      if (t === 'number') {
	        if (v === 0) {
	          x.s = 1 / v < 0 ? -1 : 1;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        if (v < 0) {
	          v = -v;
	          x.s = -1;
	        } else {
	          x.s = 1;
	        }
	
	        // Fast path for small integers.
	        if (v === ~~v && v < 1e7) {
	          for (e = 0, i = v; i >= 10; i /= 10) e++;
	
	          if (external) {
	            if (e > Decimal.maxE) {
	              x.e = NaN;
	              x.d = null;
	            } else if (e < Decimal.minE) {
	              x.e = 0;
	              x.d = [0];
	            } else {
	              x.e = e;
	              x.d = [v];
	            }
	          } else {
	            x.e = e;
	            x.d = [v];
	          }
	
	          return;
	
	        // Infinity, NaN.
	        } else if (v * 0 !== 0) {
	          if (!v) x.s = NaN;
	          x.e = NaN;
	          x.d = null;
	          return;
	        }
	
	        return parseDecimal(x, v.toString());
	
	      } else if (t !== 'string') {
	        throw Error(invalidArgument + v);
	      }
	
	      // Minus sign?
	      if ((i = v.charCodeAt(0)) === 45) {
	        v = v.slice(1);
	        x.s = -1;
	      } else {
	        // Plus sign?
	        if (i === 43) v = v.slice(1);
	        x.s = 1;
	      }
	
	      return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	    Decimal.EUCLID = 9;
	
	    Decimal.config = Decimal.set = config;
	    Decimal.clone = clone;
	    Decimal.isDecimal = isDecimalInstance;
	
	    Decimal.abs = abs;
	    Decimal.acos = acos;
	    Decimal.acosh = acosh;        // ES6
	    Decimal.add = add;
	    Decimal.asin = asin;
	    Decimal.asinh = asinh;        // ES6
	    Decimal.atan = atan;
	    Decimal.atanh = atanh;        // ES6
	    Decimal.atan2 = atan2;
	    Decimal.cbrt = cbrt;          // ES6
	    Decimal.ceil = ceil;
	    Decimal.clamp = clamp;
	    Decimal.cos = cos;
	    Decimal.cosh = cosh;          // ES6
	    Decimal.div = div;
	    Decimal.exp = exp;
	    Decimal.floor = floor;
	    Decimal.hypot = hypot;        // ES6
	    Decimal.ln = ln;
	    Decimal.log = log;
	    Decimal.log10 = log10;        // ES6
	    Decimal.log2 = log2;          // ES6
	    Decimal.max = max;
	    Decimal.min = min;
	    Decimal.mod = mod;
	    Decimal.mul = mul;
	    Decimal.pow = pow;
	    Decimal.random = random;
	    Decimal.round = round;
	    Decimal.sign = sign;          // ES6
	    Decimal.sin = sin;
	    Decimal.sinh = sinh;          // ES6
	    Decimal.sqrt = sqrt;
	    Decimal.sub = sub;
	    Decimal.sum = sum;
	    Decimal.tan = tan;
	    Decimal.tanh = tanh;          // ES6
	    Decimal.trunc = trunc;        // ES6
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      if (obj.defaults !== true) {
	        ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'maxE', 'minE', 'modulo', 'crypto'];
	        for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	      }
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function div(x, y) {
	    return new this(x).div(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} The power to which to raise the base of the natural log.
	   *
	   */
	  function exp(x) {
	    return new this(x).exp();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function floor(x) {
	    return finalise(x = new this(x), x.e + 1, 3);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
	   * rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
	   *
	   * arguments {number|string|Decimal}
	   *
	   */
	  function hypot() {
	    var i, n,
	      t = new this(0);
	
	    external = false;
	
	    for (i = 0; i < arguments.length;) {
	      n = new this(arguments[i++]);
	      if (!n.d) {
	        if (n.s) {
	          external = true;
	          return new this(1 / 0);
	        }
	        t = n;
	      } else if (t.d) {
	        t = t.plus(n.times(n));
	      }
	    }
	
	    external = true;
	
	    return t.sqrt();
	  }
	
	
	  /*
	   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
	   * otherwise return false.
	   *
	   */
	  function isDecimalInstance(obj) {
	    return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function ln(x) {
	    return new this(x).ln();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
	   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   * log[y](x)
	   *
	   * x {number|string|Decimal} The argument of the logarithm.
	   * y {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  function log(x, y) {
	    return new this(x).log(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function log2(x) {
	    return new this(x).log(2);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function log10(x) {
	    return new this(x).log(10);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the maximum of the arguments.
	   *
	   * arguments {number|string|Decimal}
	   *
	   */
	  function max() {
	    return maxOrMin(this, arguments, 'lt');
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the minimum of the arguments.
	   *
	   * arguments {number|string|Decimal}
	   *
	   */
	  function min() {
	    return maxOrMin(this, arguments, 'gt');
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
	   * using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function mod(x, y) {
	    return new this(x).mod(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function mul(x, y) {
	    return new this(x).mul(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} The base.
	   * y {number|string|Decimal} The exponent.
	   *
	   */
	  function pow(x, y) {
	    return new this(x).pow(y);
	  }
	
	
	  /*
	   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
	   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
	   * are produced).
	   *
	   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
	   *
	   */
	  function random(sd) {
	    var d, e, k, n,
	      i = 0,
	      r = new this(1),
	      rd = [];
	
	    if (sd === void 0) sd = this.precision;
	    else checkInt32(sd, 1, MAX_DIGITS);
	
	    k = Math.ceil(sd / LOG_BASE);
	
	    if (!this.crypto) {
	      for (; i < k;) rd[i++] = Math.random() * 1e7 | 0;
	
	    // Browsers supporting crypto.getRandomValues.
	    } else if (crypto.getRandomValues) {
	      d = crypto.getRandomValues(new Uint32Array(k));
	
	      for (; i < k;) {
	        n = d[i];
	
	        // 0 <= n < 4294967296
	        // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
	        if (n >= 4.29e9) {
	          d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
	        } else {
	
	          // 0 <= n <= 4289999999
	          // 0 <= (n % 1e7) <= 9999999
	          rd[i++] = n % 1e7;
	        }
	      }
	
	    // Node.js supporting crypto.randomBytes.
	    } else if (crypto.randomBytes) {
	
	      // buffer
	      d = crypto.randomBytes(k *= 4);
	
	      for (; i < k;) {
	
	        // 0 <= n < 2147483648
	        n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
	
	        // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
	        if (n >= 2.14e9) {
	          crypto.randomBytes(4).copy(d, i);
	        } else {
	
	          // 0 <= n <= 2139999999
	          // 0 <= (n % 1e7) <= 9999999
	          rd.push(n % 1e7);
	          i += 4;
	        }
	      }
	
	      i = k / 4;
	    } else {
	      throw Error(cryptoUnavailable);
	    }
	
	    k = rd[--i];
	    sd %= LOG_BASE;
	
	    // Convert trailing digits to zeros according to sd.
	    if (k && sd) {
	      n = mathpow(10, LOG_BASE - sd);
	      rd[i] = (k / n | 0) * n;
	    }
	
	    // Remove trailing words which are zero.
	    for (; rd[i] === 0; i--) rd.pop();
	
	    // Zero?
	    if (i < 0) {
	      e = 0;
	      rd = [0];
	    } else {
	      e = -1;
	
	      // Remove leading words which are zero and adjust exponent accordingly.
	      for (; rd[0] === 0; e -= LOG_BASE) rd.shift();
	
	      // Count the digits of the first word of rd to determine leading zeros.
	      for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;
	
	      // Adjust the exponent for leading zeros of the first word of rd.
	      if (k < LOG_BASE) e -= LOG_BASE - k;
	    }
	
	    r.e = e;
	    r.d = rd;
	
	    return r;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
	   *
	   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function round(x) {
	    return finalise(x = new this(x), x.e + 1, this.rounding);
	  }
	
	
	  /*
	   * Return
	   *   1    if x > 0,
	   *  -1    if x < 0,
	   *   0    if x is 0,
	   *  -0    if x is -0,
	   *   NaN  otherwise
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function sign(x) {
	    x = new this(x);
	    return x.d ? (x.d[0] ? x.s : 0 * x.s) : x.s || NaN;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
	   * using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function sin(x) {
	    return new this(x).sin();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function sinh(x) {
	    return new this(x).sinh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function sqrt(x) {
	    return new this(x).sqrt();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
	   * using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function sub(x, y) {
	    return new this(x).sub(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * Only the result is rounded, not the intermediate calculations.
	   *
	   * arguments {number|string|Decimal}
	   *
	   */
	  function sum() {
	    var i = 0,
	      args = arguments,
	      x = new this(args[i]);
	
	    external = false;
	    for (; x.s && ++i < args.length;) x = x.plus(args[i]);
	    external = true;
	
	    return finalise(x, this.precision, this.rounding);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function tan(x) {
	    return new this(x).tan();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function tanh(x) {
	    return new this(x).tanh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` truncated to an integer.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function trunc(x) {
	    return finalise(x = new this(x), x.e + 1, 1);
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(DEFAULTS);
	  Decimal.prototype.constructor = Decimal;
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Create the internal constants from their string values.
	  LN10 = new Decimal(LN10);
	  PI = new Decimal(PI);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
	      P[Symbol['for']('nodejs.util.inspect.custom')] = P.toString;
	      P[Symbol.toStringTag] = 'Decimal';
	    }
	
	    module.exports = Decimal;
	
	  // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self ? self : window;
	    }
	
	    noConflict = globalScope.Decimal;
	    Decimal.noConflict = function () {
	      globalScope.Decimal = noConflict;
	      return Decimal;
	    };
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _leaveApproval = __webpack_require__(588);
	
	var _leaveApproval2 = _interopRequireDefault(_leaveApproval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveApprovals = function (_Collection) {
	    _inherits(LeaveApprovals, _Collection);
	
	    function LeaveApprovals() {
	        _classCallCheck(this, LeaveApprovals);
	
	        return _possibleConstructorReturn(this, (LeaveApprovals.__proto__ || Object.getPrototypeOf(LeaveApprovals)).apply(this, arguments));
	    }
	
	    _createClass(LeaveApprovals, [{
	        key: 'url',
	        value: function url() {
	            if (this.requester) {
	                return this.requester.url() + '/leaveApprovers';
	            }
	
	            if (this.approver) {
	                return this.approver.url() + '/leaveRequesters';
	            }
	
	            return '/LeaveApprovals';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$requester = _ref.requester,
	                requester = _ref$requester === undefined ? null : _ref$requester,
	                _ref$approver = _ref.approver,
	                approver = _ref$approver === undefined ? null : _ref$approver;
	
	            this.model = _leaveApproval2.default;
	            _get(LeaveApprovals.prototype.__proto__ || Object.getPrototypeOf(LeaveApprovals.prototype), 'initialize', this).apply(this, arguments);
	            this.requester = requester;
	            this.approver = approver;
	            return this;
	        }
	    }]);
	
	    return LeaveApprovals;
	}(_collection2.default);
	
	exports.default = LeaveApprovals;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveApproval = function (_Model) {
	    _inherits(LeaveApproval, _Model);
	
	    _createClass(LeaveApproval, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/LeaveApprovals';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                layer: 1
	            };
	        }
	    }]);
	
	    function LeaveApproval() {
	        _classCallCheck(this, LeaveApproval);
	
	        var _this = _possibleConstructorReturn(this, (LeaveApproval.__proto__ || Object.getPrototypeOf(LeaveApproval)).apply(this, arguments));
	
	        _this.softDelete = false;
	        _this.requester = null;
	        _this.approver = null;
	        return _this;
	    }
	
	    _createClass(LeaveApproval, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(LeaveApproval.prototype.__proto__ || Object.getPrototypeOf(LeaveApproval.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                requesterId: { presence: true },
	                approverId: { presence: true },
	                layer: { presence: true }
	            };
	        }
	    }, {
	        key: 'fetchRequester',
	        value: function fetchRequester() {
	            var _this2 = this;
	
	            if (this.requester) {
	                (0, _bluebird.resolve)(this.requester);
	            }
	
	            var employee = app.employees.find(function (emp) {
	                return emp.get('objectId') === _this2.get('requesterId');
	            });
	            if (employee) {
	                this.requester = employee;
	                return (0, _bluebird.resolve)(employee);
	            }
	
	            return new _employee2.default({ objectId: this.get('requesterId') }).fetch({ validate: false }).then(function (model) {
	                _this2.requester = model;
	                return _this2.requester;
	            }).catch(function () {
	                return null;
	            });
	        }
	    }]);
	
	    return LeaveApproval;
	}(_model2.default);
	
	exports.default = LeaveApproval;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _itemYearlyTotal = __webpack_require__(590);
	
	var _itemYearlyTotal2 = _interopRequireDefault(_itemYearlyTotal);
	
	var _payrollItemFilters = __webpack_require__(585);
	
	var _payrollItemFilters2 = _interopRequireDefault(_payrollItemFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemYearlyTotals = function (_PayrollItemFilters) {
	    _inherits(ItemYearlyTotals, _PayrollItemFilters);
	
	    function ItemYearlyTotals() {
	        _classCallCheck(this, ItemYearlyTotals);
	
	        return _possibleConstructorReturn(this, (ItemYearlyTotals.__proto__ || Object.getPrototypeOf(ItemYearlyTotals)).apply(this, arguments));
	    }
	
	    _createClass(ItemYearlyTotals, [{
	        key: 'url',
	        value: function url() {
	            if (this.employee) {
	                return this.employee.url() + '/totals';
	            }
	
	            return '/ItemYearlyTotals';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee,
	                _ref$year = _ref.year,
	                year = _ref$year === undefined ? null : _ref$year;
	
	            _get(ItemYearlyTotals.prototype.__proto__ || Object.getPrototypeOf(ItemYearlyTotals.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _itemYearlyTotal2.default;
	            this.employee = employee;
	            this.year = year;
	
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'createdAt';
	            }
	            return this;
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(model) {
	            // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	            var weightByType = {
	                base: 100,
	                mtd: 90,
	                epf: 80,
	                socso: 70,
	                zakat: 60,
	                addition: 50,
	                benefit: 40,
	                deduction: 30
	            };
	            // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	            var item = model.getPayrollItem();
	
	            return -(weightByType[item.get('type')] || 0);
	        }
	    }, {
	        key: 'fetchForPreviousPayslips',
	        value: function fetchForPreviousPayslips() {
	            var _this2 = this;
	
	            var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            var payrollItems = app.payrollItems.filter(function (model) {
	                var type = model.get('type');
	                return ['hrdf', 'eis', 'epf', 'socso'].includes(type) && model.get('isNet') === true || ['hrdf', 'eis', 'epf', 'socso'].indexOf(type) < 0;
	            });
	            var payrollItemIds = payrollItems.map(function (i) {
	                return i.id;
	            });
	            var filter = {
	                where: {
	                    payrollItemId: { inq: payrollItemIds }
	                },
	                limit: 9999
	            };
	
	            if (year && typeof year === 'number') {
	                this.year = year;
	            }
	
	            if (this.year) {
	                filter.where.year = this.year;
	            }
	
	            return this.fetch({ filter: filter }).then(function () {
	                return _this2;
	            });
	        }
	    }, {
	        key: 'clearAmounts',
	        value: function clearAmounts() {
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref2$current = _ref2.current,
	                current = _ref2$current === undefined ? null : _ref2$current;
	
	            this.forEach(function (model) {
	                var monthly = [].concat(_toConsumableArray(Array(12).keys())).map(function () {
	                    return 0;
	                });
	
	                if (current !== false) {
	                    model.set({
	                        amount: 0,
	                        monthly: monthly
	                    });
	                }
	
	                if (current !== true) {
	                    model.set({
	                        prevEmploymentAmount: 0,
	                        prevEmploymentMonthly: monthly
	                    });
	                }
	            });
	
	            return this;
	        }
	    }]);
	
	    return ItemYearlyTotals;
	}((0, _payrollItemFilters2.default)(_collection2.default));
	
	exports.default = ItemYearlyTotals;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _payrollItem = __webpack_require__(591);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/item-yearly-total');
	
	var ItemYearlyTotal = function (_Model) {
	    _inherits(ItemYearlyTotal, _Model);
	
	    _createClass(ItemYearlyTotal, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/ItemYearlyTotals';
	        }
	    }]);
	
	    function ItemYearlyTotal() {
	        _classCallCheck(this, ItemYearlyTotal);
	
	        var _this = _possibleConstructorReturn(this, (ItemYearlyTotal.__proto__ || Object.getPrototypeOf(ItemYearlyTotal)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(ItemYearlyTotal, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(ItemYearlyTotal.prototype.__proto__ || Object.getPrototypeOf(ItemYearlyTotal.prototype), 'initialize', this).apply(this, arguments);
	            this.payrollItem = this.getPayrollItem();
	            this.on('change:payrollItemId', this._setPayrollItem, this);
	            return this;
	        }
	    }, {
	        key: 'getPayrollItem',
	        value: function getPayrollItem() {
	            if (this.payrollItem) {
	                return this.payrollItem;
	            }
	
	            return this._setPayrollItem(this.get('payrollItemId'));
	        }
	    }, {
	        key: '_setPayrollItem',
	        value: function _setPayrollItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                log.warn('ItemYearlyTotal doesn\'t have a payroll item');
	                return;
	            }
	
	            this.payrollItem = app.payrollItems.find(function (model) {
	                return model.get('objectId') === id;
	            });
	
	            return this.payrollItem;
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                year: new Date().getFullYear(),
	                prevEmploymentAmount: 0,
	                prevEmploymentMonthly: [],
	                amount: 0,
	                monthly: []
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                year: {
	                    presence: true,
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 0
	                    }
	                },
	                employeeId: { presence: true },
	                payrollItemId: { presence: true },
	                amount: {
	                    presence: true
	                },
	                prevEmploymentAmount: {
	                    presence: true
	                },
	                additionalInformation: function additionalInformation(value, attrs) {
	                    if (!attrs.payrollItemId) {
	                        return null;
	                    }
	
	                    if (!app.payrollItems) {
	                        return null;
	                    }
	
	                    var payrollItem = app.payrollItems.get(attrs.payrollItemId);
	                    if (!payrollItem || !payrollItem.get('additionalInfoClass')) {
	                        return null;
	                    }
	
	                    return { presence: true };
	                }
	            };
	        }
	    }, {
	        key: 'getPayrollItemName',
	        value: function getPayrollItemName() {
	            var item = this.getPayrollItem();
	            return item && item.get('name') || '';
	        }
	    }, {
	        key: 'getMonthlySum',
	        value: function getMonthlySum(options) {
	            var sum = 0;
	            var monthly = void 0;
	
	            options = _.defaults(options || {}, {
	                month: 11,
	                current: null
	            });
	
	            if (options.current !== true) {
	                monthly = this.get('prevEmploymentMonthly') || [];
	
	                sum = monthly.reduce(function (acc, v) {
	                    return acc.plus(v || 0);
	                }, new _decimal2.default(sum)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	            }
	
	            if (options.current !== false) {
	                monthly = this.get('monthly') || [];
	
	                sum = monthly.reduce(function (acc, v) {
	                    return acc.plus(v || 0);
	                }, new _decimal2.default(sum)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	            }
	
	            return sum;
	        }
	    }, {
	        key: 'isBase',
	        value: function isBase() {
	            var item = this.getPayrollItem();
	            return (item.get('type') || null) === _payrollItem.consts.TYPE_BASE;
	        }
	    }]);
	
	    return ItemYearlyTotal;
	}(_model2.default);
	
	exports.default = ItemYearlyTotal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.consts = undefined;
	
	var _bluebird = __webpack_require__(63);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _mtdLimits = __webpack_require__(592);
	
	var _mtdLimits2 = _interopRequireDefault(_mtdLimits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO We don't have the time to go down the rabbit hole of getting rid
	// of these "consts" and constValue, but we have to eventually.
	var constValues = function constValues(re) {
	    return _.map(_.filter(_.keys(consts), function (constName) {
	        return re.test(constName);
	    }), function (constName) {
	        return consts[constName];
	    });
	};
	var consts = exports.consts = {
	    TYPE_BASE: 'base',
	    TYPE_ADDITION: 'addition',
	    TYPE_BONUS: 'bonus',
	    TYPE_DEDUCTION: 'deduction',
	    TYPE_BENEFIT: 'benefit',
	    TYPE_CP38: 'cp38',
	    TYPE_UNPAID_LEAVE: 'unpaid_leave',
	    TYPE_MTD: 'mtd',
	    TYPE_SOCSO: 'socso',
	    TYPE_EPF: 'epf',
	    TYPE_ZAKAT: 'zakat',
	    TYPE_OVERTIME: 'overtime',
	    TYPE_EIS: 'eis',
	    TYPE_HRDF: 'hrdf',
	
	    CATEGORY_REMUNERATION: 0,
	    CATEGORY_ALLOWANCES: 1,
	    CATEGORY_BIKS: 2,
	    CATEGORY_DEDUCTIONS: 3,
	    CATEGORY_PERQUISITES: 4
	};
	
	var PayrollItem = function (_Model) {
	    _inherits(PayrollItem, _Model);
	
	    _createClass(PayrollItem, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/PayrollItems';
	        }
	    }]);
	
	    function PayrollItem() {
	        _classCallCheck(this, PayrollItem);
	
	        var _this = _possibleConstructorReturn(this, (PayrollItem.__proto__ || Object.getPrototypeOf(PayrollItem)).apply(this, arguments));
	
	        _this.categories = [{ name: 'Remuneration', text: '' }, { name: 'Allowances', text: '' }, { name: 'Benefits-in-Kind', text: '' }, { name: 'Deductions', text: '' }, { name: 'Other Perquisites', text: '' }];
	        return _this;
	    }
	
	    _createClass(PayrollItem, [{
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                name: { presence: true },
	                type: {
	                    presence: true,
	                    inclusion: constValues(/^TYPE_/)
	                },
	                category: {
	                    presence: true,
	                    inclusion: constValues(/^CATEGORY_/)
	                },
	                // We are deprecating this attribute, sometimes it might still
	                // appear so in those cases we need to validate at least that
	                // its a number.
	                mtdLimit: { numericality: { greaterThanOrEqualTo: 0 } },
	                overtimeFactor: function overtimeFactor(value, attrs) {
	                    if (attrs.type !== 'overtime') {
	                        return null;
	                    }
	
	                    return {
	                        presence: true,
	                        numericality: {
	                            greaterThanOrEqualTo: 1.0,
	                            message: '^Rate must be at least 1.0'
	                        }
	                    };
	                },
	                eaFields: function eaFields() {
	                    return {
	                        presence: { message: '^You need to select an EA field' },
	                        length: {
	                            minimum: 1,
	                            maximum: 2,
	                            message: '^Please select an EA field or ' + 'choose \'None\''
	                        }
	                    };
	                }
	            };
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                companyId: null,
	                isUnit: false,
	                isGross: false,
	                isNet: false,
	                allowRecurrency: false,
	                affectsMtd: false,
	                affectsEpf: false,
	                affectsSocso: false,
	                mtdLimit: 0,
	                additionalInfoClass: null,
	                popularity: 0,
	                hiddenAt: null,
	                overtimeFactor: 0,
	                afterWorkingHours: false,
	                nonWorkingDays: false,
	                holidays: false
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(PayrollItem.prototype.__proto__ || Object.getPrototypeOf(PayrollItem.prototype), 'initialize', this).apply(this, arguments);
	            this.mtdLimits = new _mtdLimits2.default(null, { payrollItem: this });
	            this.mtdLimit = false;
	            this.on('change:mtdLimit', this.updateMtdLimit, this);
	            return this;
	        }
	
	        // We are deprecating this attribute, sometimes it might still appear
	        // so in those cases we need to validate at least that its a number.
	
	    }, {
	        key: 'validate',
	        value: function validate(attributes) {
	            var validationError = _get(PayrollItem.prototype.__proto__ || Object.getPrototypeOf(PayrollItem.prototype), 'validate', this).apply(this, arguments);
	
	            if (this.get('mtdLimit') === 0 && attributes.mtdLimit !== this.get('mtdLimit') && validationError && validationError.eaFields) {
	                delete validationError.eaFields;
	
	                if (_.isEmpty(validationError)) {
	                    return false;
	                }
	            }
	
	            return validationError;
	        }
	    }, {
	        key: 'getCompany',
	        value: function getCompany() {
	            if (!this.get('companyId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            var company = new _company2.default({ objectId: this.get('companyId') });
	            return company.fetch();
	        }
	
	        // This three methods are UI related. If I'm not mistaken they are used
	        // in the payroll item selector to determine which item has been clicked on
	        // or not. TODO move elsewhere
	
	    }, {
	        key: 'toggleSelect',
	        value: function toggleSelect() {
	            this.selected = !this.selected;
	            this.trigger(!!this.selected ? 'select' : 'unselect', this);
	        }
	    }, {
	        key: 'isSelected',
	        value: function isSelected() {
	            return !!this.selected;
	        }
	    }, {
	        key: 'isSelectableAsDefault',
	        value: function isSelectableAsDefault() {
	            return (this.get('type') === consts.TYPE_ADDITION || this.get('type') === consts.TYPE_BONUS || this.get('type') === consts.TYPE_DEDUCTION || this.get('type') === consts.TYPE_BENEFIT || this.get('type') === consts.TYPE_ZAKAT || this.get('type') === consts.TYPE_CP38 || this.get('type') === consts.TYPE_OVERTIME) && this.get('allowRecurrency') === true;
	        }
	    }, {
	        key: 'getTaxExemptEaField',
	        value: function getTaxExemptEaField() {
	            var eaField = (this.get('eaFields') || []).find(function (eaField) {
	                return (typeof eaField === 'undefined' ? 'undefined' : _typeof(eaField)) === 'object' && eaField.limit >= 0 && !eaField.offset;
	            });
	            return eaField ? eaField.field : '';
	        }
	    }, {
	        key: 'getEaField',
	        value: function getEaField() {
	            var eaField = (this.get('eaFields') || []).find(function (eaField) {
	                return typeof eaField === 'string' || (typeof eaField === 'undefined' ? 'undefined' : _typeof(eaField)) === 'object' && eaField.offset >= 0 && !eaField.limit;
	            });
	            return eaField && eaField.field ? eaField.field : eaField;
	        }
	    }, {
	        key: 'updateMtdLimit',
	        value: function updateMtdLimit(model, value) {
	            this.mtdLimit = value;
	        }
	    }, {
	        key: 'getMtdLimit',
	        value: function getMtdLimit() {
	            return this.mtdLimit || 0;
	        }
	    }, {
	        key: 'fetchMtdLimit',
	        value: function fetchMtdLimit() {
	            var _this2 = this;
	
	            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	            // if (!this.get('companyId'))
	            //     return Promise.resolve(0);
	
	            return this.mtdLimits.fetch({ filter: {
	                    where: {
	                        or: [{
	                            validFrom: { lte: date },
	                            validTo: null
	                        }, {
	                            validFrom: { lte: date },
	                            validTo: { gte: date }
	                        }]
	                    },
	                    order: 'primary DESC'
	                } }).then(function () {
	                var primaryLimit = _this2.mtdLimits.find(function (m) {
	                    return m.get('primary');
	                });
	                if (primaryLimit) {
	                    _this2.mtdLimit = primaryLimit.get('amount');
	                }
	                return _this2.getMtdLimit();
	            });
	        }
	    }, {
	        key: 'isAddition',
	        value: function isAddition() {
	            return ['addition', 'bonus'].includes(this.get('type'));
	        }
	    }, {
	        key: 'isDeduction',
	        value: function isDeduction() {
	            return this.get('type') === 'deduction';
	        }
	    }, {
	        key: 'isCustom',
	        value: function isCustom() {
	            return this.get('companyId') !== null;
	        }
	
	        // whether an item can be included in Integration (XERO, Quickbook)
	        // ref: https://jibbletech.atlassian.net/browse/PPKAN-98
	        // a payroll item will not be an option to mapping when either:
	        //   - category: BIK,
	        //   - not subject to Gross Pay nor Net Pay
	
	    }, {
	        key: 'isIntegrationMappable',
	        value: function isIntegrationMappable() {
	            return (this.get('isNet') || this.get('isGross') || ['hrdf'].includes(this.get('subtype')) || ['hrdf', 'socso', 'eis', 'epf', 'mtd'].includes(this.get('type'))) && this.get('category') !== 2;
	        }
	    }]);
	
	    return PayrollItem;
	}(_model2.default);
	
	exports.default = PayrollItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _mtdLimit = __webpack_require__(593);
	
	var _mtdLimit2 = _interopRequireDefault(_mtdLimit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MtdLimits = function (_Collection) {
	    _inherits(MtdLimits, _Collection);
	
	    function MtdLimits() {
	        _classCallCheck(this, MtdLimits);
	
	        return _possibleConstructorReturn(this, (MtdLimits.__proto__ || Object.getPrototypeOf(MtdLimits)).apply(this, arguments));
	    }
	
	    _createClass(MtdLimits, [{
	        key: 'url',
	        value: function url() {
	            if (this.payrollItem) {
	                return this.payrollItem.url() + '/mtdLimits';
	            }
	
	            return '/MtdLimits';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$payrollItem = _ref.payrollItem,
	                payrollItem = _ref$payrollItem === undefined ? null : _ref$payrollItem;
	
	            _get(MtdLimits.prototype.__proto__ || Object.getPrototypeOf(MtdLimits.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _mtdLimit2.default;
	            this.payrollItem = payrollItem;
	            this.pagination = false;
	            return this;
	        }
	    }]);
	
	    return MtdLimits;
	}(_collection2.default);
	
	exports.default = MtdLimits;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MtdLimit = function (_Model) {
	    _inherits(MtdLimit, _Model);
	
	    function MtdLimit() {
	        _classCallCheck(this, MtdLimit);
	
	        return _possibleConstructorReturn(this, (MtdLimit.__proto__ || Object.getPrototypeOf(MtdLimit)).apply(this, arguments));
	    }
	
	    _createClass(MtdLimit, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/MtdLimits';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(MtdLimit.prototype.__proto__ || Object.getPrototypeOf(MtdLimit.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }]);
	
	    return MtdLimit;
	}(_model2.default);
	
	exports.default = MtdLimit;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	'use strict';
	
	var list = [{ code: 'AF', name: 'AFGHANISTAN' }, { code: 'AX', name: 'ÅLAND ISLANDS' }, { code: 'AL', name: 'ALBANIA' }, { code: 'DZ', name: 'ALGERIA' }, { code: 'AS', name: 'AMERICAN SAMOA' }, { code: 'AD', name: 'ANDORA' }, { code: 'AO', name: 'ANGOLA' }, { code: 'AI', name: 'ANGUILLA' }, { code: 'AQ', name: 'ANTARCTICA' }, { code: 'AG', name: 'ANTIGUA AND BARBUDA' }, { code: 'AR', name: 'ARGENTINA' }, { code: 'AM', name: 'ARMENIA' }, { code: 'AW', name: 'ARUBA' }, { code: 'AU', name: 'AUSTRALIA' }, { code: 'AT', name: 'AUSTRIA' }, { code: 'AZ', name: 'AZERBAIDJAN' }, { code: 'BS', name: 'BAHAMAS' }, { code: 'BH', name: 'BAHRAIN' }, { code: 'BD', name: 'BANGLADESH' }, { code: 'BB', name: 'BARBADOS' }, { code: 'BY', name: 'BELARUS' }, { code: 'BE', name: 'BELGIUM' }, { code: 'BZ', name: 'BELIZE' }, { code: 'BJ', name: 'BENIN' }, { code: 'BM', name: 'BERMUDA' }, { code: 'BT', name: 'BHUTAN' }, { code: 'BO', name: 'BOLIVIA' }, { code: 'BQ', name: 'BONAIRE, SINT EUSTATIUS AND SABA' }, { code: 'BA', name: 'BOSNIA HERZEGOVINA' }, { code: 'BW', name: 'BOTSWANA' }, { code: 'BV', name: 'BOUVET ISLAND' }, { code: 'BR', name: 'BRAZIL' }, { code: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY' }, { code: 'BN', name: 'BRUNEI DARUSSALAM' }, { code: 'BG', name: 'BULGARIA' }, { code: 'BF', name: 'BURKINA FASO' }, { code: 'BI', name: 'BURUNDI' }, { code: 'BY', name: 'BYELORUSSIAN' }, { code: 'KH', name: 'CAMBODIA' }, { code: 'CM', name: 'CAMEROON' }, { code: 'CA', name: 'CANADA' }, { code: 'CV', name: 'CAPE VERDE' }, { code: 'KY', name: 'CAYMAN ISLANDS' }, { code: 'CF', name: 'CENTRAL AFRICAN REPUBLIC' }, { code: 'TD', name: 'CHAD' }, { code: 'CD', name: 'CHANNEL ISLAND' }, { code: 'CL', name: 'CHILE' }, { code: 'CN', name: 'CHINA' }, { code: 'CX', name: 'CHRISTMAS ISLANDS' }, { code: 'CC', name: 'COCOS ISLAND' }, { code: 'CO', name: 'COLOMBIA' }, { code: 'KM', name: 'COMOROS' }, { code: 'CG', name: 'CONGO' }, { code: 'CK', name: 'COOK ISLANDS' }, { code: 'CR', name: 'COSTA RICA' }, { code: 'CI', name: 'COTE D\'IVOIRE' }, { code: 'CT', name: 'CROATIA' }, { code: 'CU', name: 'CUBA' }, { code: 'CW', name: 'CURACAO' }, { code: 'CY', name: 'CYPRUS' }, { code: 'CZ', name: 'CZECH REPUBLIC' }, { code: 'CS', name: 'CZECHOSLOVAKIA' }, { code: 'DK', name: 'DENMARK' }, { code: 'DJ', name: 'DJIBOUTI' }, { code: 'DM', name: 'DOMINICA' }, { code: 'DO', name: 'DOMINICAN REPUBLIC' }, { code: 'TP', name: 'EAST TIMOR' }, { code: 'EG', name: 'EGYPT' }, { code: 'SV', name: 'EL SALVADOR' }, { code: 'EC', name: 'ECUADOR' }, { code: 'GQ', name: 'EQUATORIAN GUINEA' }, { code: 'ER', name: 'ERITREA' }, { code: 'EE', name: 'ESTONIA' }, { code: 'ET', name: 'ETHIOPIA' }, { code: 'FO', name: 'FAEROE ISLANDS' }, { code: 'FK', name: 'FALKLAND ISLANDS (MALVINAS)' }, { code: 'FJ', name: 'FIJI' }, { code: 'FI', name: 'FINLAND' }, { code: 'FR', name: 'FRANCE' }, { code: 'GF', name: 'FRENCH GUIANA' }, { code: 'PF', name: 'FRENCH POLYNESIA' }, { code: 'TF', name: 'FRENCH SOUTHERN TERRITORIES' }, { code: 'GA', name: 'GABON' }, { code: 'GM', name: 'GAMBIA' }, { code: 'GE', name: 'GEORGIA' }, { code: 'DE', name: 'GERMANY' }, { code: 'GH', name: 'GHANA' }, { code: 'GI', name: 'GIBRALTAR' }, { code: 'GR', name: 'GREECE' }, { code: 'GL', name: 'GREENLAND' }, { code: 'GD', name: 'GRENADA' }, { code: 'GP', name: 'GUADELOUPE' }, { code: 'GU', name: 'GUAM' }, { code: 'GT', name: 'GUATEMALA' }, { code: 'GG', name: 'GUERNSEY' }, { code: 'GN', name: 'GUINEA' }, { code: 'GW', name: 'GUINEA-BISSAU' }, { code: 'GY', name: 'GUYANA' }, { code: 'HT', name: 'HAITI' }, { code: 'HM', name: 'HEARD AND MCDONALD ISLANDS' }, { code: 'HN', name: 'HONDURAS' }, { code: 'HK', name: 'HONG KONG' }, { code: 'HU', name: 'HUNGARY' }, { code: 'IS', name: 'ICELAND' }, { code: 'IN', name: 'INDIA' }, { code: 'ID', name: 'INDONESIA' }, { code: 'IQ', name: 'IRAQ' }, { code: 'IE', name: 'IRELAND' }, { code: 'IR', name: 'ISLAMIC REPUBLIC OF IRAN' }, { code: 'IM', name: 'ISLE OF MAN' }, { code: 'IL', name: 'ISRAEL' }, { code: 'IT', name: 'ITALY' }, { code: 'IC', name: 'IVORY COAST' }, { code: 'JM', name: 'JAMAICA' }, { code: 'JP', name: 'JAPAN' }, { code: 'JO', name: 'JORDAN' }, { code: 'KZ', name: 'KAZAKHSTAN' }, { code: 'KE', name: 'KENYA' }, { code: 'KP', name: 'KOREA (NORTH)' }, { code: 'KR', name: 'KOREA (SOUTH)' }, { code: 'KG', name: 'KYRGYZSTAN' }, { code: 'KI', name: 'KIRIBATI' }, { code: 'KW', name: 'KUWAIT' }, { code: 'LA', name: 'LAO PEOPLE\'S DEMOCRATIC REP' }, { code: 'LV', name: 'LATVIA' }, { code: 'LB', name: 'LEBANON' }, { code: 'LS', name: 'LESOTHO' }, { code: 'LR', name: 'LIBERIA' }, { code: 'LY', name: 'LIBYAN ARAB JAMAHIRIYA' }, { code: 'LI', name: 'LIECHTENSTEIN' }, { code: 'LT', name: 'LITHUANIA' }, { code: 'LU', name: 'LUXEMBOURG' }, { code: 'MO', name: 'MACAU' }, { code: 'MK', name: 'MACEDONIA (NORTH)' }, { code: 'MG', name: 'MADAGASCAR' }, { code: 'MW', name: 'MALAWI' }, { code: 'MY', name: 'MALAYSIA' }, { code: 'MV', name: 'MALDIVES' }, { code: 'ML', name: 'MALI' }, { code: 'MT', name: 'MALTA' }, { code: 'MH', name: 'MARSHALL IALANDS' }, { code: 'MQ', name: 'MARTINIQUE' }, { code: 'MR', name: 'MAURITANIA' }, { code: 'MU', name: 'MAURITIUS' }, { code: 'YT', name: 'MAYOTTE' }, { code: 'MX', name: 'MEXICO' }, { code: 'FM', name: 'MICRONESIA' }, { code: 'MD', name: 'MOLDOVA REPUBLIC OF' }, { code: 'MC', name: 'MONACO' }, { code: 'MN', name: 'MONGOLIA' }, { code: 'MS', name: 'MONTSERRAT' }, { code: 'MA', name: 'MOROCCO' }, { code: 'MZ', name: 'MOZAMBIQUE' }, { code: 'MM', name: 'MYANMAR' }, { code: 'NA', name: 'NAMIBIA' }, { code: 'NR', name: 'NAURU' }, { code: 'NP', name: 'NEPAL' }, { code: 'NL', name: 'NETHERLANDS' }, { code: 'AN', name: 'NETHERLANDS ANTILLES' }, { code: 'NT', name: 'NEUTRAL ZONE' }, { code: 'NC', name: 'NEW CALEDONIA' }, { code: 'NZ', name: 'NEW ZEALAND' }, { code: 'NI', name: 'NICARAGUA' }, { code: 'NE', name: 'NIGER' }, { code: 'NG', name: 'NIGERIA' }, { code: 'NU', name: 'NIUE' }, { code: 'NF', name: 'NORFOLK ISLAND' }, { code: 'MP', name: 'NORTHEEN MARIANA ISLANDS' }, { code: 'ND', name: 'NORTHERN IRELAND' }, { code: 'NO', name: 'NORWAY' }, { code: 'OM', name: 'OMAN' }, { code: 'PK', name: 'PAKISTAN' }, { code: 'PW', name: 'PALAU' }, { code: 'PS', name: 'PALESTINE' }, { code: 'PA', name: 'PANAMA' }, { code: 'PG', name: 'PAPUA NEW GUINEA' }, { code: 'PY', name: 'PARAGUAY' }, { code: 'PE', name: 'PERU' }, { code: 'PH', name: 'PHILIPPINES' }, { code: 'PN', name: 'PITCAIRN' }, { code: 'PL', name: 'POLAND' }, { code: 'PT', name: 'PORTUGAL' }, { code: 'PR', name: 'PUERTO RICO' }, { code: 'QA', name: 'QATAR' }, { code: 'RE', name: 'REUNION' }, { code: 'RO', name: 'ROMANIA' }, { code: 'SU', name: 'RUSSIA' }, { code: 'RW', name: 'RWANDA' }, { code: 'BL', name: 'SAINT BARTHÉLEMY' }, { code: 'SH', name: 'SAINT HELENA' }, { code: 'KN', name: 'SAINT KITTS AND NEVIS' }, { code: 'LC', name: 'SAINT LUCIA' }, { code: 'MF', name: 'SAINT MARTIN (FRENCH PART)' }, { code: 'PM', name: 'SAINT PIERRE AND MIQUELON' }, { code: 'VC', name: 'SAINT VINCENT AND GRENADINES' }, { code: 'WS', name: 'SAMOA' }, { code: 'SM', name: 'SAN MARINO' }, { code: 'ST', name: 'SAO TOME AND PRINCIPE' }, { code: 'SA', name: 'SAUDI ARABIA' }, { code: 'SF', name: 'SCOTLAND' }, { code: 'SN', name: 'SENEGAL' }, { code: 'RS', name: 'SERBIA' }, { code: 'SC', name: 'SEYCHELLES' }, { code: 'SL', name: 'SIERRA LEONE' }, { code: 'SG', name: 'SINGAPORE' }, { code: 'SX', name: 'SINT MAARTEN (DUTCH PART)' }, { code: 'SK', name: 'SLOVAKIA' }, { code: 'SI', name: 'SLOVENIA' }, { code: 'SB', name: 'SOLOMON ISLANDS' }, { code: 'SO', name: 'SOMALIA' }, { code: 'ZA', name: 'SOUTH AFRICA' }, { code: 'GS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' }, { code: 'SS', name: 'SOUTH SUDAN' }, { code: 'ES', name: 'SPAIN' }, { code: 'LK', name: 'SRI LANKA' }, { code: 'SD', name: 'SUDAN' }, { code: 'SR', name: 'SURINAME' }, { code: 'SJ', name: 'SVALBARD AND JAN MAYEN ISLANDS' }, { code: 'SZ', name: 'SWAZILAND' }, { code: 'SE', name: 'SWEDEN' }, { code: 'CH', name: 'SWITZERLAND' }, { code: 'SY', name: 'SYRIAN ARAB REPUBLIC' }, { code: 'TW', name: 'TAIWAN' }, { code: 'TJ', name: 'TAJIKISTAN' }, { code: 'TZ', name: 'TANZANIA UNITED REPUBLIC OF' }, { code: 'TH', name: 'THAILAND' }, { code: 'TL', name: 'TIMOR-LESTE' }, { code: 'TG', name: 'TOGO' }, { code: 'TK', name: 'TOKELAU' }, { code: 'TO', name: 'TONGA' }, { code: 'TT', name: 'TRINIDAD AND TOBAGO' }, { code: 'TN', name: 'TUNISIA' }, { code: 'TR', name: 'TURKEY' }, { code: 'TI', name: 'TURKMENISTAN' }, { code: 'TC', name: 'TURKS AND CAICOS ISLANDS' }, { code: 'TV', name: 'TUVALU' }, { code: 'UG', name: 'UGANDA' }, { code: 'UA', name: 'UKRAINE' }, { code: 'AE', name: 'UNITED ARAB EMIRATES' }, { code: 'GB', name: 'UNITED KINGDOM' }, { code: 'US', name: 'UNITED STATES OF AMERICA' }, { code: 'UY', name: 'URUGUAY' }, { code: 'UM', name: 'US MINOR OUTLYING ISLANDS' }, { code: 'UZ', name: 'UZBEKISTAN' }, { code: 'VU', name: 'VANUATU' }, { code: 'VA', name: 'VATICAN CITY STATE' }, { code: 'VE', name: 'VENEZUELA' }, { code: 'VN', name: 'VIETNAM' }, { code: 'VG', name: 'VIRGIN ISLANDS (BRITISH)' }, { code: 'VI', name: 'VIRGIN ISLANDS (US)' }, { code: 'WF', name: 'WALLIS AND FUTUNA ISLANDS' }, { code: 'WI', name: 'WEST INDIES' }, { code: 'EH', name: 'WESTERN SAHARA' }, { code: 'WE', name: 'WESTERN SAMOA' }, { code: 'YE', name: 'YEMEN' }, { code: 'YD', name: 'YEMEN DEMOCRATIC' }, { code: 'YU', name: 'YUGOSLAVIA' }, { code: 'ZR', name: 'ZAIRE' }, { code: 'ZM', name: 'ZAMBIA' }, { code: 'ZW', name: 'ZIMBABWE' }];
	
	module.exports = list;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _timeEntry = __webpack_require__(575);
	
	var _timeEntry2 = _interopRequireDefault(_timeEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeEntries = function (_Collection) {
	    _inherits(TimeEntries, _Collection);
	
	    function TimeEntries() {
	        _classCallCheck(this, TimeEntries);
	
	        return _possibleConstructorReturn(this, (TimeEntries.__proto__ || Object.getPrototypeOf(TimeEntries)).apply(this, arguments));
	    }
	
	    _createClass(TimeEntries, [{
	        key: 'url',
	        value: function url() {
	            if (this.employee) {
	                return this.employee.url() + '/timeEntries';
	            }
	
	            if (this.company) {
	                return this.company.url() + '/timeEntries';
	            }
	
	            return '/TimeEntries';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company,
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee;
	
	            _get(TimeEntries.prototype.__proto__ || Object.getPrototypeOf(TimeEntries.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _timeEntry2.default;
	            this.searchableAttributes = ['date'];
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'date';
	            }
	            this.company = company;
	            this.employee = employee;
	            return this;
	        }
	    }, {
	        key: 'dirty',
	        value: function dirty() {
	            return this.reduce(function (memo, model) {
	                return memo || model.dirty() && !model.isNew() || model.isNew() && model.get('hours');
	            }, false) || this.removedModels.length > 0;
	        }
	    }]);
	
	    return TimeEntries;
	}(_collection2.default);
	
	exports.default = TimeEntries;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _defaultPayrollDetail = __webpack_require__(597);
	
	var _defaultPayrollDetail2 = _interopRequireDefault(_defaultPayrollDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultPayrollDetails = function (_Collection) {
	    _inherits(DefaultPayrollDetails, _Collection);
	
	    function DefaultPayrollDetails() {
	        _classCallCheck(this, DefaultPayrollDetails);
	
	        return _possibleConstructorReturn(this, (DefaultPayrollDetails.__proto__ || Object.getPrototypeOf(DefaultPayrollDetails)).apply(this, arguments));
	    }
	
	    _createClass(DefaultPayrollDetails, [{
	        key: 'url',
	        value: function url() {
	            if (this.employee) {
	                return this.employee.url() + '/defaultPayrollDetails';
	            }
	
	            return '/DefaultPayrollDetails';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee;
	
	            _get(DefaultPayrollDetails.prototype.__proto__ || Object.getPrototypeOf(DefaultPayrollDetails.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _defaultPayrollDetail2.default;
	            this.employee = employee;
	            return this;
	        }
	    }]);
	
	    return DefaultPayrollDetails;
	}(_collection2.default);
	
	exports.default = DefaultPayrollDetails;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/default-payroll-detail');
	var excludedOvertime = ['Overtime (Wage)']; // ticket: PPKAN-340
	
	var DefaultPayrollDetail = function (_Model) {
	    _inherits(DefaultPayrollDetail, _Model);
	
	    _createClass(DefaultPayrollDetail, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/DefaultPayrollDetails';
	        }
	    }]);
	
	    function DefaultPayrollDetail() {
	        _classCallCheck(this, DefaultPayrollDetail);
	
	        var _this = _possibleConstructorReturn(this, (DefaultPayrollDetail.__proto__ || Object.getPrototypeOf(DefaultPayrollDetail)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(DefaultPayrollDetail, [{
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                companyId: null,
	                rate: 0,
	                unit: 0,
	                amount: 0,
	                isLocked: false,
	                isUnpaidLeave: true,
	                hiddenAt: null
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                payrollItemId: { presence: true },
	                employeeId: { presence: true },
	                amount: {
	                    presence: true
	                },
	                rate: function rate(value, attrs) {
	                    if (!attrs.payrollItemId) {
	                        return null;
	                    }
	
	                    if (!app.payrollItems) {
	                        return null;
	                    }
	
	                    var payrollItem = app.payrollItems.get(attrs.payrollItemId);
	                    if (!payrollItem || payrollItem.get('isUnit') !== true) {
	                        return null;
	                    }
	
	                    return {
	                        presence: true,
	                        numericality: { greaterThanOrEqualTo: 0 }
	                    };
	                },
	                unit: function unit(value, attrs) {
	                    if (!attrs.payrollItemId) {
	                        return null;
	                    }
	
	                    if (!app.payrollItems) {
	                        return null;
	                    }
	
	                    var payrollItem = app.payrollItems.get(attrs.payrollItemId);
	                    if (!payrollItem || payrollItem.get('isUnit') !== true) {
	                        return null;
	                    }
	
	                    return {
	                        presence: true,
	                        numericality: { greaterThanOrEqualTo: 0 }
	                    };
	                },
	                additionalInformation: function additionalInformation(value, attrs) {
	                    if (!attrs.payrollItemId) {
	                        return null;
	                    }
	
	                    if (!app.payrollItems) {
	                        return null;
	                    }
	
	                    var payrollItem = app.payrollItems.get(attrs.payrollItemId);
	                    if (!payrollItem || !payrollItem.get('additionalInfoClass')) {
	                        return null;
	                    }
	
	                    return { presence: true };
	                }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(DefaultPayrollDetail.prototype.__proto__ || Object.getPrototypeOf(DefaultPayrollDetail.prototype), 'initialize', this).apply(this, arguments);
	            this.payrollItem = this.getPayrollItem();
	            this.on('change:payrollItemId', this._setPayrollItem, this);
	            this.on('change:rate change:unit', this.updateAmount, this);
	            return this;
	        }
	    }, {
	        key: 'getPayrollItem',
	        value: function getPayrollItem() {
	            if (this.payrollItem) {
	                return this.payrollItem;
	            }
	
	            return this._setPayrollItem(this.get('payrollItemId'));
	        }
	    }, {
	        key: '_setPayrollItem',
	        value: function _setPayrollItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                log.warn('DefaultPayrollDetail doesn\'t have a payroll item');
	                return;
	            }
	
	            this.payrollItem = app.payrollItems.find(function (model) {
	                return model.get('objectId') === id;
	            });
	
	            return this.payrollItem;
	        }
	    }, {
	        key: 'updateAmount',
	        value: function updateAmount() {
	            if (this.isUnit()) {
	                var roundedRate = new _decimal2.default(this.get('rate')).toDP(2, _decimal2.default.ROUND_HALF_UP);
	                var roundedUnit = new _decimal2.default(this.get('unit')).toDP(2, _decimal2.default.ROUND_HALF_UP);
	
	                this.set('amount', roundedRate.times(roundedUnit).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber());
	            }
	        }
	    }, {
	        key: 'getPayrollItemName',
	        value: function getPayrollItemName() {
	            var item = this.getPayrollItem();
	            return item && item.get('name') || '';
	        }
	    }, {
	        key: 'getPayrollItemType',
	        value: function getPayrollItemType() {
	            var item = this.getPayrollItem();
	            return item && item.get('type');
	        }
	    }, {
	        key: 'isUnit',
	        value: function isUnit() {
	            var item = this.getPayrollItem();
	            return item.get('isUnit') === true;
	        }
	    }, {
	        key: 'isBase',
	        value: function isBase() {
	            var item = this.getPayrollItem();
	            return (item ? item.get('type') === 'base' : false) || false;
	        }
	    }, {
	        key: 'isOvertime',
	        value: function isOvertime() {
	            var item = this.getPayrollItem();
	            return item && item.get('type') === 'overtime' && !excludedOvertime.includes(item.get('name'));
	        }
	    }, {
	        key: 'isAllowAffectOvertime',
	        value: function isAllowAffectOvertime() {
	            var item = this.getPayrollItem();
	            return item && !this.isOvertime() && item.get('allowIsAffectOvertime') !== false;
	        }
	    }, {
	        key: 'isAllowUnpaidLeave',
	        value: function isAllowUnpaidLeave() {
	            var item = this.getPayrollItem();
	            return item && (item.isAddition() || item.isDeduction() && item.isCustom() || item.get('allowIsUnpaidLeave') === true);
	        }
	
	        //Bonus used to be a simple addition item but a change in the EPF calculator
	        //required it to be split into a separate type.
	        //For the intents and purposes of the UI, it is still very much an addition
	
	    }, {
	        key: 'isAddition',
	        value: function isAddition() {
	            var item = this.getPayrollItem();
	            return item && item.isAddition();
	        }
	    }, {
	        key: 'isZakat',
	        value: function isZakat() {
	            var item = this.getPayrollItem();
	            return item.get('type') === 'zakat';
	        }
	    }, {
	        key: 'getRealAmount',
	        value: function getRealAmount() {
	            var item = this.getPayrollItem();
	            var multiplier = _.contains(['deduction', 'zakat', 'mtd', 'epf', 'socso'], item.get('type')) ? 1 : -1;
	            return (this.get('amount') || 0) * multiplier;
	        }
	    }]);
	
	    return DefaultPayrollDetail;
	}(_model2.default);
	
	exports.default = DefaultPayrollDetail;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Payrolls = function (_Collection) {
	    _inherits(Payrolls, _Collection);
	
	    function Payrolls() {
	        _classCallCheck(this, Payrolls);
	
	        return _possibleConstructorReturn(this, (Payrolls.__proto__ || Object.getPrototypeOf(Payrolls)).apply(this, arguments));
	    }
	
	    _createClass(Payrolls, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/payrolls';
	            }
	
	            return '/Payrolls';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.model = _payroll2.default;
	            this.company = company;
	            _get(Payrolls.prototype.__proto__ || Object.getPrototypeOf(Payrolls.prototype), 'initialize', this).apply(this, arguments);
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'createdAt';
	            }
	            if (!this.options.sortOrder) {
	                this.options.sortOrder = 'descending';
	            }
	            return this;
	        }
	    }, {
	        key: 'getSavedCount',
	        value: function getSavedCount() {
	            return this.reduce(function (memo, model) {
	                return memo + (model.get('status') < 3 ? 1 : 0);
	            }, 0);
	        }
	    }, {
	        key: 'getSubmittedCount',
	        value: function getSubmittedCount() {
	            return this.reduce(function (memo, model) {
	                return memo + (model.get('status') >= 3 && model.get('status') < 9 ? 1 : 0);
	            }, 0);
	        }
	    }, {
	        key: 'getCompletedCount',
	        value: function getCompletedCount() {
	            return this.reduce(function (memo, model) {
	                return memo + (model.get('status') === 9 ? 1 : 0);
	            }, 0);
	        }
	    }]);
	
	    return Payrolls;
	}(_collection2.default);
	
	exports.default = Payrolls;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payrollDetail = __webpack_require__(600);
	
	var _payrollDetail2 = _interopRequireDefault(_payrollDetail);
	
	var _payrollItemFilters = __webpack_require__(585);
	
	var _payrollItemFilters2 = _interopRequireDefault(_payrollItemFilters);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayrollDetails = function (_PayrollItemFilters) {
	    _inherits(PayrollDetails, _PayrollItemFilters);
	
	    function PayrollDetails() {
	        _classCallCheck(this, PayrollDetails);
	
	        return _possibleConstructorReturn(this, (PayrollDetails.__proto__ || Object.getPrototypeOf(PayrollDetails)).apply(this, arguments));
	    }
	
	    _createClass(PayrollDetails, [{
	        key: 'url',
	        value: function url() {
	            if (this.payroll && this.payroll.id) {
	                return this.payroll.url() + '/details';
	            }
	
	            if (this.employee) {
	                return this.employee.url() + '/payrollDetails';
	            }
	
	            return '/PayrollDetails';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$payroll = _ref.payroll,
	                payroll = _ref$payroll === undefined ? null : _ref$payroll,
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee,
	                _ref$autoCalcZakat = _ref.autoCalcZakat,
	                autoCalcZakat = _ref$autoCalcZakat === undefined ? true : _ref$autoCalcZakat,
	                _ref$pagination = _ref.pagination,
	                pagination = _ref$pagination === undefined ? false : _ref$pagination;
	
	            // Make sure pagination is disabled for this collection
	            _get(PayrollDetails.prototype.__proto__ || Object.getPrototypeOf(PayrollDetails.prototype), 'initialize', this).call(this, models, Object.assign(arguments[1] || {}, { pagination: pagination }));
	
	            this.model = _payrollDetail2.default;
	            this.payroll = payroll;
	            this.employee = employee;
	            this.autoCalcZakat = autoCalcZakat;
	
	            if (this.autoCalcZakat === true) {
	                this.on('reset', this.updateZakats, this);
	                this.on('add remove change:amount destroy', this.updateZakat, this);
	                setTimeout(this.updateZakats.bind(this), 1);
	            }
	
	            if (this.payroll) {
	                this.payroll.on('sync', this.updatePayrollId, this);
	            }
	
	            return this;
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(a, b) {
	            // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	            var weightByType = {
	                base: 100,
	                addition: 90,
	                benefit: 80,
	                deduction: 70,
	                unpaid_leave: 65,
	                cp38: 63,
	                mtd: 60,
	                epf: 50,
	                socso: 40,
	                zakat: 30
	            };
	            // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	            var itemA = a.getPayrollItem();
	            var itemB = b.getPayrollItem();
	
	            if (a.get('isAdditional') > b.get('isAdditional')) {
	                return 1;
	            }
	
	            if (!itemA || !itemB) {
	                return 1;
	            }
	
	            if (weightByType[itemA.get('type')] < weightByType[itemB.get('type')]) {
	                return 1;
	            }
	        }
	    }, {
	        key: 'setPayroll',
	        value: function setPayroll(payroll) {
	            this.payroll = payroll;
	            this.updatePayrollId();
	        }
	    }, {
	        key: 'updatePayrollId',
	        value: function updatePayrollId() {
	            var _this2 = this;
	
	            this.each(function (model) {
	                return model.set({ payrollId: _this2.payroll.id }, {
	                    silent: true,
	                    validate: false
	                });
	            });
	        }
	    }, {
	        key: 'updateZakats',
	        value: function updateZakats() {
	            var _this3 = this;
	
	            var employeeIds = _.uniq(this.map(function (model) {
	                return model.get('employeeId');
	            }));
	            employeeIds.forEach(function (id) {
	                _this3.filterByEmployee(id).forEach(_this3.updateZakat.bind(_this3));
	            });
	        }
	    }, {
	        key: 'updateZakat',
	        value: function updateZakat(model) {
	            if (model.isZakat()) {
	                return;
	            }
	
	            var net = this.getNetAmount(model.get('employeeId'));
	            var zakats = this.filter(function (detail) {
	                return !detail.isAdditional() && detail.isZakat() && detail.get('rate') && model.get('employeeId') === detail.get('employeeId');
	            });
	
	            zakats.forEach(function (zakat) {
	                zakat.set('amount', net * (zakat.get('rate') / 100));
	            });
	        }
	    }, {
	        key: 'replace',
	        value: function replace(details, employeeId) {
	            var _this4 = this;
	
	            var models = employeeId ? this.filterByEmployee(employeeId) : this.models;
	
	            return (0, _bluebird.all)(models.map(function (detail) {
	                // clear all additional items
	                if (detail.get('isAdditional')) {
	                    _this4.remove(detail, { validate: false });
	                    if (detail.id) {
	                        return detail.destroy();
	                    }
	                }
	                return (0, _bluebird.resolve)();
	            })).then(function () {
	                details.each(function (prevDetail) {
	                    var attrs = prevDetail && _.isObject(prevDetail.attributes) ? prevDetail.attributes : prevDetail;
	                    delete attrs.objectId;
	                    delete attrs.createdAt;
	                    delete attrs.updatedAt;
	                    var currDetail = _this4.find(function (detail) {
	                        return detail.get('payrollItemId') === attrs.payrollItemId && detail.get('employeeId') === attrs.employeeId;
	                    });
	
	                    // add any new additional items
	                    if (!currDetail && attrs.isAdditional === true) {
	                        return _this4.add(attrs, { validate: false });
	                    }
	
	                    if (currDetail) {
	                        currDetail.set({ unit: attrs.unit });
	
	                        if (!currDetail.isLocked()) {
	                            currDetail.set({
	                                rate: attrs.rate,
	                                amount: attrs.amount
	                            });
	                        }
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'reassignToPayroll',
	        value: function reassignToPayroll(payrollId) {
	            this.forEach(function (detail) {
	                return detail.set({ payrollId: payrollId });
	            });
	            return this;
	        }
	
	        /**
	         * Get the sum of all items that affect the net amount
	         *
	         * @instance
	         * @returns {Number}
	         */
	
	    }, {
	        key: 'getNetAmount',
	        value: function getNetAmount(employeeId) {
	            var models = employeeId ? this.filterByEmployee(employeeId) : this.models;
	
	            return models.reduce(function (memo, detail) {
	                var payrollItem = detail.getPayrollItem();
	                if (payrollItem && payrollItem.get('isNet')) {
	                    return memo.plus(detail.getRealAmount() || 0);
	                }
	                return memo;
	            }, new _decimal2.default(0)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	        }
	
	        /**
	         * Create a new collection with all payslip details that are affected by
	         * unpaid leave
	         *
	         * @instance
	         * @returns {module:collections.PayslipDetails}
	         */
	
	    }, {
	        key: 'findAffectedByUnpaidLeave',
	        value: function findAffectedByUnpaidLeave() {
	            return new PayrollDetails(this.filter(function (model) {
	                return model.get('isUnpaidLeave') === true;
	            }));
	        }
	    }, {
	        key: 'filterByEmployee',
	        value: function filterByEmployee(employeeId) {
	            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref2$collection = _ref2.collection,
	                collection = _ref2$collection === undefined ? false : _ref2$collection;
	
	            var models = this.filter(function (model) {
	                return model.get('employeeId') === employeeId;
	            });
	
	            models.sort(function (x, y) {
	                return x.getPayrollItem().get('name') === 'Salary (Basic)' ? -1 : y.getPayrollItem().get('name') === 'Salary (Basic)' ? 1 : 0;
	            });
	
	            if (collection === true) {
	                return new PayrollDetails(models, { payroll: this.payroll });
	            }
	            return models;
	        }
	    }, {
	        key: 'filterNonContributions',
	        value: function filterNonContributions() {
	            var models = this.filter(function (model) {
	                var item = model.getPayrollItem();
	                var type = item.get('type');
	                var subtype = item.get('subtype');
	
	                return item && (['mtd', 'epf', 'socso', 'eis', 'hrdf'].indexOf(type) < 0 || type === 'mtd' && subtype === 'custom');
	            });
	
	            return new PayrollDetails(models, { payroll: this.payroll });
	        }
	    }, {
	        key: 'createOvertimeInfoAfterAdd',
	        value: function createOvertimeInfoAfterAdd(employee) {
	            var _this5 = this;
	
	            return (0, _bluebird.all)(this.map(function (detail) {
	                if (detail.isOvertime()) {
	                    var currentEmployee = employee && detail.get('employeeId') === employee.id ? employee : null;
	                    if (currentEmployee) {
	                        return detail.createOvertimeInfo(_this5.payroll, currentEmployee);
	                    }
	                    return detail;
	                }
	                return detail;
	            }));
	        }
	    }], [{
	        key: 'createDefaults',
	        value: function createDefaults(payroll, employees) {
	            if (employees.length === 0) {
	                return (0, _bluebird.resolve)();
	            }
	            var url = new PayrollDetails(null, {}).finalUrl();
	            var employeeIds = employees.map(function (employee) {
	                return employee.id;
	            });
	            return _axios2.default.post(url + '/createDefaults', {
	                companyId: app.company.id,
	                employeeIds: employeeIds,
	                period: payroll.get('periodDate') || undefined
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                var details = new PayrollDetails(r.data.map(function (detail) {
	                    if (payroll.id) {
	                        // this isn't a backbone model yet
	                        detail.payrollId = payroll.id;
	                    }
	                    return detail;
	                }), { payroll: payroll });
	
	                return (0, _bluebird.all)(details.map(function (detail) {
	                    if (detail.isOvertime()) {
	                        var employee = employees.find(function (model) {
	                            return model.id === detail.get('employeeId');
	                        });
	                        return detail.createOvertimeInfo(payroll, employee);
	                    }
	                    return detail;
	                })).then(function () {
	                    return details;
	                });
	            }).catch(function (err) {
	                if (err.response) {
	                    throw err.response.data.error;
	                }
	                throw err;
	            });
	        }
	    }]);
	
	    return PayrollDetails;
	}((0, _payrollItemFilters2.default)(_collection2.default));
	
	exports.default = PayrollDetails;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/payroll-detail');
	var excludedOvertime = ['Overtime (Wage)']; // ticket: PPKAN-340
	
	var PayrollDetail = function (_Model) {
	    _inherits(PayrollDetail, _Model);
	
	    _createClass(PayrollDetail, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/PayrollDetails';
	        }
	    }]);
	
	    function PayrollDetail() {
	        _classCallCheck(this, PayrollDetail);
	
	        var _this = _possibleConstructorReturn(this, (PayrollDetail.__proto__ || Object.getPrototypeOf(PayrollDetail)).apply(this, arguments));
	
	        _this.employee = null;
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(PayrollDetail, [{
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                amount: 0,
	                rate: 0,
	                unit: 0,
	                isAdditional: true,
	                isLocked: false
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                employeeId: { presence: true },
	                payrollItemId: { presence: true },
	                isLocked: { presence: true },
	                isAdditional: { presence: true },
	                amount: {
	                    presence: true
	                },
	                unit: {
	                    numericality: { greaterThanOrEqualTo: 0 }
	                },
	                additionalInformation: function additionalInformation(value, attrs) {
	                    if (!attrs.payrollItemId) {
	                        return null;
	                    }
	
	                    if (!app.payrollItems) {
	                        return null;
	                    }
	
	                    var payrollItem = app.payrollItems.get(attrs.payrollItemId);
	                    if (!payrollItem || !payrollItem.get('additionalInfoClass')) {
	                        return null;
	                    }
	
	                    return { presence: true };
	                }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(PayrollDetail.prototype.__proto__ || Object.getPrototypeOf(PayrollDetail.prototype), 'initialize', this).apply(this, arguments);
	            this.payrollItem = this.getPayrollItem();
	            this.affectsItem = this.getAffectsItem();
	            this.on('change:payrollItemId', this._setPayrollItem, this);
	            this.on('change:affectsItem', this._setAffectsItem, this);
	            this.on('change:rate change:unit', this.updateAmount, this);
	            return this;
	        }
	    }, {
	        key: 'getPayrollItem',
	        value: function getPayrollItem() {
	            if (this.payrollItem) {
	                return this.payrollItem;
	            }
	            return this._setPayrollItem(this.get('payrollItemId'));
	        }
	    }, {
	        key: '_setPayrollItem',
	        value: function _setPayrollItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                log.warn('PayrollDetail doesn\'t have a payroll item');
	                return;
	            }
	
	            this.payrollItem = app.payrollItems.find(function (model) {
	                return model.get('objectId') === id;
	            });
	
	            return this.payrollItem;
	        }
	    }, {
	        key: 'getAffectsItem',
	        value: function getAffectsItem() {
	            if (this.affectsItem) {
	                return this.affectsItem;
	            }
	
	            return this._setAffectsItem(this.get('affectsItemId'));
	        }
	    }, {
	        key: '_setAffectsItem',
	        value: function _setAffectsItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                return;
	            }
	
	            this.affectsItem = app.payrollItems.find(function (model) {
	                return model.get('objectId') === id;
	            });
	
	            return this.affectsItem;
	        }
	    }, {
	        key: 'fetchEmployee',
	        value: function fetchEmployee() {
	            var _this2 = this;
	
	            if (!this.get('employeeId')) {
	                return null;
	            }
	
	            var employee = app.employees.find(function (emp) {
	                return emp.id === _this2.get('employeeId');
	            });
	            if (employee) {
	                this.employee = employee;
	                return (0, _bluebird.resolve)(employee);
	            }
	
	            this.employee = new _employee2.default({ objectId: this.get('employeeId') });
	            return this.employee.fetch();
	        }
	    }, {
	        key: 'getEmployee',
	        value: function getEmployee() {
	            return this.employee;
	        }
	    }, {
	        key: 'updateAmount',
	        value: function updateAmount() {
	            if (this.isUnit() || this.isOvertime()) {
	                var roundedRate = new _decimal2.default(this.get('rate')).toDP(2, _decimal2.default.ROUND_HALF_UP);
	                var roundedUnit = new _decimal2.default(this.get('unit')).toDP(2, _decimal2.default.ROUND_HALF_UP);
	
	                this.set('amount', roundedRate.times(roundedUnit).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber());
	            }
	        }
	    }, {
	        key: 'getPayrollItemName',
	        value: function getPayrollItemName() {
	            var item = this.getPayrollItem();
	            var affects = this.getAffectsItem();
	            var payrollItemName = item && item.get('name') || '';
	
	            if (affects && affects.get('name')) {
	                payrollItemName += ' on ' + affects.get('name');
	            }
	
	            return payrollItemName;
	        }
	    }, {
	        key: 'getPayrollItemType',
	        value: function getPayrollItemType() {
	            var item = this.getPayrollItem();
	            return item && item.get('type');
	        }
	    }, {
	        key: 'isUnpaidLeave',
	        value: function isUnpaidLeave() {
	            var item = this.getPayrollItem();
	            return item && item.get('type') === 'unpaid_leave';
	        }
	    }, {
	        key: 'isUnit',
	        value: function isUnit() {
	            var item = this.getPayrollItem();
	            return item.get('isUnit') === true;
	        }
	    }, {
	        key: 'isZakat',
	        value: function isZakat() {
	            var item = this.getPayrollItem();
	            return item.get('type') === 'zakat';
	        }
	    }, {
	        key: 'isOvertime',
	        value: function isOvertime() {
	            var item = this.getPayrollItem();
	            return item && item.get('type') === 'overtime' && !excludedOvertime.includes(item.get('name'));
	        }
	    }, {
	        key: 'isLocked',
	        value: function isLocked() {
	            return this.get('isLocked') === true;
	        }
	    }, {
	        key: 'isAdditional',
	        value: function isAdditional() {
	            return this.get('isAdditional') === true;
	        }
	    }, {
	        key: 'isAddition',
	        value: function isAddition() {
	            var item = this.getPayrollItem();
	            return item && _.contains(['addition', 'bonus', 'base', 'overtime'], item.get('type')) && (item.get('isGross') || item.get('isNet'));
	        }
	    }, {
	        key: 'isDeduction',
	        value: function isDeduction() {
	            var item = this.getPayrollItem();
	            return item && _.contains(['unpaid_leave', 'deduction', 'mtd', 'epf', 'socso', 'cp38', 'zakat'], item.get('type')) && (item.get('isGross') || item.get('isNet'));
	        }
	    }, {
	        key: 'isOther',
	        value: function isOther() {
	            var item = this.getPayrollItem();
	            return item && !item.get('isGross') && !item.get('isNet') && item.get('type') !== 'unpaid_leave';
	        }
	    }, {
	        key: 'getRealAmount',
	        value: function getRealAmount() {
	            var item = this.getPayrollItem();
	            var multiplier = _.contains(['base', 'bonus', 'addition', 'benefit', 'overtime'], item.get('type')) ? 1 : -1;
	            return (this.get('amount') || 0) * multiplier;
	        }
	    }, {
	        key: 'createOvertimeInfo',
	        value: function createOvertimeInfo() {
	            var _this3 = this;
	
	            var payroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var employee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (!this.isOvertime()) {
	                return (0, _bluebird.resolve)(this);
	            }
	
	            return (employee ? (0, _bluebird.resolve)(employee) : this.fetchEmployee()).then(function (employee) {
	                if (!employee) {
	                    return 0;
	                }
	
	                var date = payroll && payroll.id === _this3.get('payrollId') ? payroll.getPeriod() : (0, _moment2.default)();
	
	                return employee.getHourlyWage(date);
	            }).then(function (hourlyWage) {
	                var overtimeFactor = _this3.getPayrollItem().get('overtimeFactor') || 1;
	                if (!excludedOvertime.includes(_this3.getPayrollItem().get('name'))) {
	                    var unit = _this3.get('unit');
	                    var rate = new _decimal2.default(hourlyWage).times(overtimeFactor).toDP(2, _decimal2.default.ROUND_HALF_UP);
	
	                    _this3.set({
	                        unit: unit,
	                        rate: rate.toNumber(),
	                        amount: new _decimal2.default(unit).times(rate).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber(),
	                        additionalInformation: {
	                            overtimeFactor: overtimeFactor,
	                            hourlyWage: hourlyWage
	                        }
	                    });
	                }
	
	                return _this3;
	            });
	        }
	    }]);
	
	    return PayrollDetail;
	}(_model2.default);
	
	exports.default = PayrollDetail;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payrollIntegration = __webpack_require__(602);
	
	var _payrollIntegration2 = _interopRequireDefault(_payrollIntegration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayrollIntegrations = function (_Collection) {
	    _inherits(PayrollIntegrations, _Collection);
	
	    function PayrollIntegrations() {
	        _classCallCheck(this, PayrollIntegrations);
	
	        return _possibleConstructorReturn(this, (PayrollIntegrations.__proto__ || Object.getPrototypeOf(PayrollIntegrations)).apply(this, arguments));
	    }
	
	    _createClass(PayrollIntegrations, [{
	        key: 'url',
	        value: function url() {
	            if (this.payroll) {
	                return this.payroll.url() + '/integrations';
	            }
	
	            if (this.integration) {
	                return this.integration.url() + '/payrollIntegrations';
	            }
	
	            return '/PayrollIntegrations';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$payroll = _ref.payroll,
	                payroll = _ref$payroll === undefined ? null : _ref$payroll,
	                _ref$integration = _ref.integration,
	                integration = _ref$integration === undefined ? null : _ref$integration;
	
	            this.model = _payrollIntegration2.default;
	            _get(PayrollIntegrations.prototype.__proto__ || Object.getPrototypeOf(PayrollIntegrations.prototype), 'initialize', this).apply(this, arguments);
	            this.payroll = payroll;
	            this.integration = integration;
	            return this;
	        }
	    }]);
	
	    return PayrollIntegrations;
	}(_collection2.default);
	
	exports.default = PayrollIntegrations;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayrollIntegration = function (_Model) {
	    _inherits(PayrollIntegration, _Model);
	
	    _createClass(PayrollIntegration, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/PayrollIntegrations';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                remoteId: null,
	                syncedAt: new Date()
	            };
	        }
	    }]);
	
	    function PayrollIntegration() {
	        _classCallCheck(this, PayrollIntegration);
	
	        var _this = _possibleConstructorReturn(this, (PayrollIntegration.__proto__ || Object.getPrototypeOf(PayrollIntegration)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(PayrollIntegration, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(PayrollIntegration.prototype.__proto__ || Object.getPrototypeOf(PayrollIntegration.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                companyId: { presence: true },
	                integrationId: { presence: true }
	            };
	        }
	    }]);
	
	    return PayrollIntegration;
	}(_model2.default);
	
	exports.default = PayrollIntegration;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _companyLocation = __webpack_require__(574);
	
	var _companyLocation2 = _interopRequireDefault(_companyLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyLocations = function (_Collection) {
	    _inherits(CompanyLocations, _Collection);
	
	    function CompanyLocations() {
	        _classCallCheck(this, CompanyLocations);
	
	        return _possibleConstructorReturn(this, (CompanyLocations.__proto__ || Object.getPrototypeOf(CompanyLocations)).apply(this, arguments));
	    }
	
	    _createClass(CompanyLocations, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/locations';
	            }
	            return '/CompanyLocations';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.model = _companyLocation2.default;
	            _get(CompanyLocations.prototype.__proto__ || Object.getPrototypeOf(CompanyLocations.prototype), 'initialize', this).apply(this, arguments);
	            this.company = company;
	            return this;
	        }
	
	        /**
	         * Get the primary location in the collection, if it exists
	         *
	         * @instance
	         * @returns {module:models.CompanyLocation}
	         */
	
	    }, {
	        key: 'getPrimary',
	        value: function getPrimary() {
	            return this.find(function (model) {
	                return model.get('primary') === true;
	            });
	        }
	    }, {
	        key: 'dirty',
	        value: function dirty() {
	            return this.reduce(function (memo, model) {
	                return memo || model.dirty() && !model.isNew() || model.isNew();
	            }, false) || this.removedModels.length > 0;
	        }
	    }, {
	        key: 'fetchAddresses',
	        value: function fetchAddresses() {
	            var _this2 = this;
	
	            return (0, _bluebird.all)(this.map(function (model) {
	                return model.fetchAddress();
	            })).then(function () {
	                return _this2;
	            });
	        }
	    }, {
	        key: 'fetchEmployees',
	        value: function fetchEmployees() {
	            var _this3 = this;
	
	            return (0, _bluebird.all)(this.map(function (model) {
	                return model.fetchEmployees();
	            })).then(function () {
	                return _this3;
	            });
	        }
	    }]);
	
	    return CompanyLocations;
	}(_collection2.default);
	
	exports.default = CompanyLocations;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _integration = __webpack_require__(605);
	
	var _integration2 = _interopRequireDefault(_integration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Integrations = function (_Collection) {
	    _inherits(Integrations, _Collection);
	
	    function Integrations() {
	        _classCallCheck(this, Integrations);
	
	        return _possibleConstructorReturn(this, (Integrations.__proto__ || Object.getPrototypeOf(Integrations)).apply(this, arguments));
	    }
	
	    _createClass(Integrations, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/integrations';
	            }
	            return '/Integrations';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.model = _integration2.default;
	            _get(Integrations.prototype.__proto__ || Object.getPrototypeOf(Integrations.prototype), 'initialize', this).apply(this, arguments);
	            this.company = company;
	            return this;
	        }
	    }]);
	
	    return Integrations;
	}(_collection2.default);
	
	exports.default = Integrations;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _integrations = __webpack_require__(604);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Integration = function (_Model) {
	    _inherits(Integration, _Model);
	
	    _createClass(Integration, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Integrations';
	        }
	    }, {
	        key: 'url',
	        value: function url() {
	            if (this.company && !this.get(this.idAttribute)) {
	                return this.company.url() + '/integrations';
	            }
	            return _get(Integration.prototype.__proto__ || Object.getPrototypeOf(Integration.prototype), 'url', this).call(this);
	        }
	    }]);
	
	    function Integration() {
	        _classCallCheck(this, Integration);
	
	        var _this = _possibleConstructorReturn(this, (Integration.__proto__ || Object.getPrototypeOf(Integration)).apply(this, arguments));
	
	        _this.softDelete = true;
	        return _this;
	    }
	
	    _createClass(Integration, [{
	        key: 'initialize',
	        value: function initialize(_ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.idAttribute = 'objectId';
	            _get(Integration.prototype.__proto__ || Object.getPrototypeOf(Integration.prototype), 'initialize', this).apply(this, arguments);
	
	            this.company = company;
	            return this;
	        }
	    }, {
	        key: 'fetchData',
	        value: function fetchData() {
	            return _axios2.default.get(this.finalUrl() + '/data', {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data.result;
	            });
	        }
	    }], [{
	        key: 'fetchIntegration',
	        value: function fetchIntegration(company) {
	            return new _integrations2.default(null, { company: company }).fetch({ filter: {
	                    where: {
	                        or: [{ expiresAt: { gt: new Date() } }, { renewAt: { gt: new Date() } }],
	                        hiddenAt: null
	                    },
	                    order: '-createdAt',
	                    limit: 1
	                } }).then(function (collections) {
	                return collections.at(0);
	            });
	        }
	    }]);
	
	    return Integration;
	}(_model2.default);
	
	exports.default = Integration;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)();
	
	var Subscription = function (_Model) {
	    _inherits(Subscription, _Model);
	
	    function Subscription() {
	        _classCallCheck(this, Subscription);
	
	        return _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).apply(this, arguments));
	    }
	
	    _createClass(Subscription, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '';
	        }
	    }, {
	        key: 'url',
	        value: function url() {
	            if (!this.id) {
	                return this.user.url() + '/subscription';
	            }
	
	            return '/Subscriptions/' + this.id;
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(attributes) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                user = _ref.user;
	
	            this.idAttribute = 'objectId';
	
	            if (!user) {
	                throw new Error('We need an user to instantiate a subscription model');
	            }
	
	            this.user = user;
	
	            this.invoices = [];
	
	            return _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                discountLimit: {
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 0,
	                        message: '^Discount limit must be integers greater than 0'
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'setPlan',
	        value: function setPlan(plan) {
	            var _this2 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/setPlan', { plan: plan }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this2.fetch();
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'setDiscount',
	        value: function setDiscount() {
	            if (this.isValid()) {
	                return _axios2.default.post(this.finalUrl() + '/setDiscount', {
	                    couponCode: this.get('couponCode'),
	                    isDiscountLimited: this.get('isDiscountLimited'),
	                    discountLimit: this.get('discountLimit')
	                }, { headers: { 'Authorization': app.user.getAccessToken().id } }).catch(function (err) {
	                    throw err.response.data.error;
	                });
	            } else {
	                return (0, _bluebird.reject)(this.validationError);
	            }
	        }
	    }, {
	        key: 'updateStatus',
	        value: function updateStatus() {
	            var _this3 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/updateStatus', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this3.fetch();
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'generateInvoices',
	        value: function generateInvoices() {
	            var _this4 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/generateInvoices', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this4;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'adjustYearlyInvoice',
	        value: function adjustYearlyInvoice() {
	            var _this5 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/adjustYearlyInvoice', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this5;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'toggleInvoicing',
	        value: function toggleInvoicing() {
	            var _this6 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/toggleInvoicing', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this6.fetch();
	            }).then(function () {
	                return _this6;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'updateDetails',
	        value: function updateDetails() {
	            var _this7 = this;
	
	            return _axios2.default.post(this.finalUrl() + '/updateDetails', {}, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                return _this7;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'listInvoices',
	        value: function listInvoices() {
	            var _this8 = this;
	
	            return _axios2.default.get(this.finalUrl() + '/invoices', { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                _this8.invoices = r.data.results || [];
	                return _this8.invoices;
	            }).catch(function (err) {
	                log.error(err.response.data.error);
	                // 20210318 return previous invoice data if failed
	                return _this8.invoices;
	            });
	        }
	    }, {
	        key: 'invoiceDownloadUrl',
	        value: function invoiceDownloadUrl(id) {
	            return this.finalUrl() + '/invoicePdf/' + id + '?' + ('access_token=' + app.user.getAccessToken().id);
	        }
	    }, {
	        key: 'onlinePayment',
	        value: function onlinePayment(invoiceId) {
	            var id = app.subscription.id;
	
	            return _axios2.default.post(this.baseUrl() + '/subscriptions/' + id + '/onlinePayment', {
	                id: id,
	                invoiceId: invoiceId
	            }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                return r.data;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this9 = this,
	                _arguments = arguments;
	
	            // 20210710 make sure custom prices are sent as numbers.
	            if (this.get('customBasePrice') !== undefined) {
	                this.set('customBasePrice', parseFloat(this.get('customBasePrice')) || 0);
	            }
	            if (this.get('customEmployeePrice') !== undefined) {
	                this.set('customEmployeePrice', parseFloat(this.get('customEmployeePrice')) || 0);
	            }
	
	            this.set({
	                isDiscountLimited: !!this.get('isDiscountLimited'),
	                discountLimit: parseInt(this.get('discountLimit'), 10)
	            });
	
	            return (app.user.isAdmin() ? this.setDiscount() : (0, _bluebird.resolve)()).then(function () {
	                return _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'save', _this9).apply(_this9, _arguments);
	            });
	        }
	    }]);
	
	    return Subscription;
	}(_model2.default);
	
	exports.default = Subscription;

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/LogosRatings.html -->\n<div class="container fluid">\n    <div class="row">\n        <div class="col-md-2 col-sm-4 col-xs-6">\n            <div class="customer-logo cl-mr-wireman"></div>\n        </div>\n        <div class="col-md-2 col-sm-4 col-xs-6">\n            <div class="customer-logo cl-petros"></div>\n        </div>\n        <div class="col-md-2 col-sm-4 col-xs-6">\n            <div class="customer-logo cl-commonground"></div>\n        </div>\n        <div class="col-md-2 col-sm-4 col-xs-6">\n            <div class="customer-logo cl-setel"></div>\n        </div>\n        <div class="col-md-2 col-sm-4 col-xs-6">\n            <div class="customer-logo cl-mint-events"></div>\n        </div>\n        <div class="col-md-2 col-sm-4 col-xs-6">\n            <div class="customer-logo cl-famacorp"></div>\n        </div>\n    </div>\n    <div class="row">\n        <h4 class="separator">\n            ';
	 if (lang === 'ms') { 
	__p+='\n                Anugerah &amp; Pengiktirafan Tinggi\n            ';
	 } else { 
	__p+='\n                Award-winning &amp; Highly-rated\n            ';
	 } 
	__p+='\n        </h4>\n    </div>\n    <div class="row">\n        <div class="col-lg-1 visible-lg"></div>\n        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6">\n            <div class="logo-ratings">\n                <div class="logo lr-g2-crowd"></div>\n                <div class="ratings">\n                    <div class="five"></div>\n                </div>\n            </div>\n        </div>\n        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6">\n            <div class="logo-ratings">\n                <div class="logo lr-capterra"></div>\n                <div class="ratings">\n                    <div class="four-half"></div>\n                </div>\n            </div>\n        </div>\n        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6">\n            <div class="logo-ratings">\n                <div class="logo lr-bitcatcha"></div>\n                <div class="ratings">\n                    <div class="five"></div>\n                </div>\n            </div>\n        </div>\n        <div class="col-md-2 col-sm-2 visible-md visible-sm"></div>\n        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6">\n            <div class="logo-ratings">\n                <div class="logo lr-getapp"></div>\n                <div class="ratings">\n                    <div class="four-half"></div>\n                </div>\n            </div>\n        </div>\n        <div class="col-xs-3 visible-xs"></div>\n        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6">\n            <div class="logo-ratings">\n                <div class="logo lr-tec"></div>\n                <div class="ratings">\n                    <div class="four-half"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Partner.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>The simplest way <br>to manage your payroll</h1>\n    <h2>Affordable and easy-to-use online payroll software <br>\n        for Malaysian businesses. <br><br>\n        Try us now and run two payrolls FREE*:</h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                    maxlength="72"\n                    class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n\n            <div class="license">\n                *Valid promo code required. Terms & conditions apply.\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>Our Main Features</h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Generate payslips, monthly reports and statutory forms with the click of a button.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-docs"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage your payroll from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Free Leave Management</h3>\n            <p>Ease the burden of HR. Staff can apply for leave and check up on their remaining leave allocation. You can also log their MC days!   </p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*\n            </p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-book-open"></span>\n            <h3>Secure</h3>\n            <p>Your sensitive information is encrypted and safely secured in the cloud.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-user-following"></span>\n            <h3>Statutory Compliant & Accurate</h3>\n            <p>Get peace of mind. All calculations and deductions for\n                the statutory bodies are according to Malaysian law.</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="features-note"><i>*50 employees or less are charged at RM 8,\n            more than 50 employees charges at RM 6. Excluding SST.</i>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n<div class="container">\n    <div class="row">\n        <h1>What Our Customers Are Saying</h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-bernadette"></div>\n            <div class="customer-name">Bernadette Lawrence</div>\n            <div class="customer-title">Office & Admin Manager MDBC</div>\n            <div class="customer-feedback">\n                For someone who has no prior HR or payroll experience,\n                this has been surprisingly easy to use.\n            </div>\n        </div>\n\n        <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-shahireen"></div>\n            <div class="customer-name">Shahireen Zulkifli</div>\n            <div class="customer-title">Director Terfaktab Media</div>\n            <div class="customer-feedback">\n                PayrollPanda is user friendly, everything is in order and simple\n                to use. The chat function is really useful too.\n            </div>\n        </div>\n\n        <div class="col-md-4 col-sm-4 customers">\n          <div class="customer-photo cp-dato"></div>\n          <div class="customer-name">Dato Jeffrey Mohamed</div>\n          <div class="customer-title">\n            Founder Smart Intelligent Parking\n          </div>\n          <div class="customer-feedback">\n            I am a happy user. The app is easy to use, user-friendly and makes\n            my life easier. Most importantly the app settings conform with the\n            government regulations.\n          </div>\n        </div>\n\n    </div>\n</div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try us now and run two payrolls FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Fb.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <img src="/images/lhdn.gif" height="25"\n        title="LHDN Certificate"><br>\n    <h1>The simplest way <br>to manage your payroll</h1>\n    <h2>Affordable and easy-to-use online payroll software <br>\n        for Malaysian businesses. <br><br>\n        Try us now and run your first payroll for FREE:</h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                    maxlength="72"\n                    class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n\n            <div class="switch-language-my">\n                <a href="#signup-page-my-1">Tukar ke Bahasa Melayu</a>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>Our Main Features</h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Generate payslips, monthly reports and statutory forms with the click of a button.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-docs"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage your payroll from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Free Leave Management</h3>\n            <p>Ease the burden of HR. Staff can apply for leave and check up on their remaining leave allocation. You can also log their MC days!   </p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*\n            </p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-book-open"></span>\n            <h3>Secure</h3>\n            <p>Your sensitive information is encrypted and safely secured in the cloud.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-user-following"></span>\n            <h3>Statutory Compliant & Accurate</h3>\n            <p>Get peace of mind. All calculations and deductions for\n                the statutory bodies are according to Malaysian law.</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="features-note"><i>*50 employees or less are charged\n            at RM 8, more than 50 employees are charged at RM 6.\n            Excluding SST.</i>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n    <div class="container">\n        <div class="row">\n            <h1>What Our Customers Are Saying</h1>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-bernadette"></div>\n                <div class="customer-name">Bernadette Lawrence</div>\n                <div class="customer-title">Office & Admin Manager MDBC</div>\n                <div class="customer-feedback">\n                    For someone who has no prior HR or payroll experience,\n                    this has been surprisingly easy to use.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-shahireen"></div>\n                <div class="customer-name">Shahireen Zulkifli</div>\n                <div class="customer-title">Director Terfaktab Media</div>\n                <div class="customer-feedback">\n                    PayrollPanda is user friendly, everything is in order and simple\n                    to use. The chat function is really useful too.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-dato"></div>\n            <div class="customer-name">Dato Jeffrey Mohamed</div>\n            <div class="customer-title">\n                Founder Smart Intelligent Parking\n            </div>\n            <div class="customer-feedback">\n                I am a happy user. The app is easy to use, user-friendly and makes\n                my life easier. Most importantly the app settings conform with the\n                government regulations.\n            </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try us now and run your first payroll for FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Leave.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>\n        The simplest way<br>to manage your leave.\n    </h1>\n    <h2>Affordable and easy-to-use payroll and leave<br>\n        management system for Malaysian SMEs.\n        <br><br>\n            Try the software for FREE:\n        </h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                    class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                    maxlength="72"\n                    class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>\n            Payroll & Leave Management System Features\n        </h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Apply and approve leave with the click of a button.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-laptop"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage the leave management system from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Leave Calendar</h3>\n            <p>Get a clear overview of leave requests and holidays.</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*</p>\n            <p>*50 employees or less are charged at RM 8, more than 50 employees are charged at RM 6. Excluding SST.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-users-group"></span>\n            <h3>Employee Self Service</h3>\n            <p>Staff can apply for leave, check their remaining leave allocation and access their payslips online.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-payroll"></span>\n            <h3>Payroll Software</h3>\n            <p>Generate Malaysian payroll with the click of a button, includes payslips, reports and statutory forms.</p>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n    <div class="container">\n        <div class="row">\n            <h1>What Our Customers Are Saying</h1>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-bernadette"></div>\n                <div class="customer-name">Bernadette Lawrence</div>\n                <div class="customer-title">Office & Admin Manager MDBC</div>\n                <div class="customer-feedback">\n                    For someone who has no prior HR or payroll experience,\n                    this has been surprisingly easy to use.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-shahireen"></div>\n                <div class="customer-name">Shahireen Zulkifli</div>\n                <div class="customer-title">Director Terfaktab Media</div>\n                <div class="customer-feedback">\n                    PayrollPanda is user friendly, everything is in order and simple\n                    to use. The chat function is really useful too.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-dato"></div>\n            <div class="customer-name">Dato Jeffrey Mohamed</div>\n            <div class="customer-title">\n                Founder Smart Intelligent Parking\n            </div>\n            <div class="customer-feedback">\n                I am a happy user. The app is easy to use, user-friendly and makes\n                my life easier. Most importantly the app settings conform with the\n                government regulations.\n            </div>\n            </div>\n\n        </div>\n    </div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try our leave management system for FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Leave-3.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>\n        Simple and accurate<br>payroll system.\n    </h1>\n    <h2>Online payroll service for Malaysian SMEs.\n        <br><br>\n            Try the payroll software for free:\n        </h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                       class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>\n            Payroll System Features\n        </h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Generate Malaysian payroll with the click of a button, includes payslips, reports and statutory forms.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-laptop"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage your payroll system from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Leave Calendar</h3>\n            <p>Ease the burden of HR. Staff can apply for leave and check up on their remaining leave allocation. You can also log their MC days!</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*</p>\n            <p>*50 employees or less are charged at RM 8, more than 50 employees are charged at RM 6. Excluding SST.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-users-group"></span>\n            <h3>Employee Self Service</h3>\n            <p>Your sensitive payroll information is encrypted and safely secured in the cloud.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-payroll"></span>\n            <h3>Payroll Software</h3>\n            <p>All payroll software calculations and deductions for the statutory bodies are according to Malaysian law.</p>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n    <div class="container">\n        <div class="row">\n            <h1>What Our Customers Are Saying</h1>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-bernadette"></div>\n                <div class="customer-name">Bernadette Lawrence</div>\n                <div class="customer-title">Office & Admin Manager MDBC</div>\n                <div class="customer-feedback">\n                    For someone who has no prior HR or payroll experience,\n                    this has been surprisingly easy to use.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-shahireen"></div>\n                <div class="customer-name">Shahireen Zulkifli</div>\n                <div class="customer-title">Director Terfaktab Media</div>\n                <div class="customer-feedback">\n                    PayrollPanda is user friendly, everything is in order and simple\n                    to use. The chat function is really useful too.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-dato"></div>\n            <div class="customer-name">Dato Jeffrey Mohamed</div>\n            <div class="customer-title">\n                Founder Smart Intelligent Parking\n            </div>\n            <div class="customer-feedback">\n                I am a happy user. The app is easy to use, user-friendly and makes\n                my life easier. Most importantly the app settings conform with the\n                government regulations.\n            </div>\n            </div>\n\n        </div>\n    </div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try us now and run your first payroll for FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Leave-4.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>\n        Payroll software for SMEs.<br>Try it FREE!\n    </h1>\n    <h2>Affordable and easy-to-use online\n        <br>payroll system for Malaysian SMEs.\n    </h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                       class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>\n            Payroll Software Features\n        </h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Generate Malaysian payroll with the click of a button. Includes several payslip formats.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-laptop"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage your payroll software from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Leave Calendar</h3>\n            <p>Ease the burden of HR. Staff can apply for leave and check up on their remaining leave allocation. You can also log their MC days!</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*</p>\n            <p>*50 employees or less are charged at RM 8, more than 50 employees are charged at RM 6. Excluding SST.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-users-group"></span>\n            <h3>Employee Self Service</h3>\n            <p>Your sensitive payroll information is encrypted and safely secured in the cloud.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-payroll"></span>\n            <h3>Payroll Software</h3>\n            <p>All payroll software calculations and deductions for the statutory bodies are according to Malaysian law.</p>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n    <div class="container">\n        <div class="row">\n            <h1>What Our Customers Are Saying</h1>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-bernadette"></div>\n                <div class="customer-name">Bernadette Lawrence</div>\n                <div class="customer-title">Office & Admin Manager MDBC</div>\n                <div class="customer-feedback">\n                    For someone who has no prior HR or payroll experience,\n                    this has been surprisingly easy to use.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-shahireen"></div>\n                <div class="customer-name">Shahireen Zulkifli</div>\n                <div class="customer-title">Director Terfaktab Media</div>\n                <div class="customer-feedback">\n                    PayrollPanda is user friendly, everything is in order and simple\n                    to use. The chat function is really useful too.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-dato"></div>\n            <div class="customer-name">Dato Jeffrey Mohamed</div>\n            <div class="customer-title">\n                Founder Smart Intelligent Parking\n            </div>\n            <div class="customer-feedback">\n                I am a happy user. The app is easy to use, user-friendly and makes\n                my life easier. Most importantly the app settings conform with the\n                government regulations.\n            </div>\n            </div>\n\n        </div>\n    </div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try the payroll software for FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Leave-5.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>\n            The simplest way to <br>manage your payroll.\n    </h1>\n    <h2>Affordable and easy-to-use online\n        <br>payroll service for Malaysian SMEs.\n        <br><br>\n        Try us now and run your first payroll for FREE:\n    </h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                       class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>\n            Payroll Service Features\n        </h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Generate payslips, monthly reports and statutory forms with the click of a button.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-laptop"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage your payroll software from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Leave Calendar</h3>\n            <p>Ease the burden of HR. Staff can apply for leave and check up on their remaining leave allocation. You can also log their MC days!</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*</p>\n            <p>*50 employees or less are charged at RM 8, more than 50 employees are charged at RM 6. Excluding SST.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-users-group"></span>\n            <h3>Employee Self Service</h3>\n            <p>Your sensitive payroll information is encrypted and safely secured in the cloud.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-payroll"></span>\n            <h3>Payroll Software</h3>\n            <p>All payroll service calculations and deductions for the statutory bodies are according to Malaysian law.</p>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n    <div class="container">\n        <div class="row">\n            <h1>What Our Customers Are Saying</h1>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-bernadette"></div>\n                <div class="customer-name">Bernadette Lawrence</div>\n                <div class="customer-title">Office & Admin Manager MDBC</div>\n                <div class="customer-feedback">\n                    For someone who has no prior HR or payroll experience,\n                    this has been surprisingly easy to use.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-shahireen"></div>\n                <div class="customer-name">Shahireen Zulkifli</div>\n                <div class="customer-title">Director Terfaktab Media</div>\n                <div class="customer-feedback">\n                    PayrollPanda is user friendly, everything is in order and simple\n                    to use. The chat function is really useful too.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-dato"></div>\n            <div class="customer-name">Dato Jeffrey Mohamed</div>\n            <div class="customer-title">\n                Founder Smart Intelligent Parking\n            </div>\n            <div class="customer-feedback">\n                I am a happy user. The app is easy to use, user-friendly and makes\n                my life easier. Most importantly the app settings conform with the\n                government regulations.\n            </div>\n            </div>\n\n        </div>\n    </div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try the payroll service for FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-Leave-6.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>\n            Simple and accurate <br> online HR software.\n    </h1>\n    <h2>Online HR management software for Malaysian SMEs.\n        <br><br>\n        Try the HR system for free:\n    </h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Full Name"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="Work Email Address"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Phone Number">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                       class="form-control" placeholder="Password">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                    and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Get Started\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>\n            HR and Payroll Software Features\n        </h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Easy to Use</h3><!-- Feature Title -->\n            <p>Generate Malaysian payroll with the click of a button, includes payslips, reports and statutory forms.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-laptop"></span>\n            <h3>Access Anywhere, Anytime</h3>\n            <p>Access and manage your HR management software from any desktop, anywhere, anytime.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Leave Calendar</h3>\n            <p>Ease the burden of HR. Staff can apply for leave and check up on their remaining leave allocation. You can also log their MC days!</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Simple Pricing</h3>\n            <p>Only get charged if you run payroll. Monthly fees are RM 38 per company + RM 8 or RM 6 per employee.*</p>\n            <p>*50 employees or less are charged at RM 8, more than 50 employees are charged at RM 6. Excluding SST.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-users-group"></span>\n            <h3>Employee Self Service</h3>\n            <p>Your sensitive HR information is encrypted and safely secured in the cloud.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-payroll"></span>\n            <h3>Payroll Software</h3>\n            <p>Get peace of mind. All calculations and deductions for the statutory bodies are according to Malaysian law.</p>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n    <div class="container">\n        <div class="row">\n            <h1>What Our Customers Are Saying</h1>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-bernadette"></div>\n                <div class="customer-name">Bernadette Lawrence</div>\n                <div class="customer-title">Office & Admin Manager MDBC</div>\n                <div class="customer-feedback">\n                    For someone who has no prior HR or payroll experience,\n                    this has been surprisingly easy to use.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n                <div class="customer-photo cp-shahireen"></div>\n                <div class="customer-name">Shahireen Zulkifli</div>\n                <div class="customer-title">Director Terfaktab Media</div>\n                <div class="customer-feedback">\n                    PayrollPanda is user friendly, everything is in order and simple\n                    to use. The chat function is really useful too.\n                </div>\n            </div>\n\n            <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-dato"></div>\n            <div class="customer-name">Dato Jeffrey Mohamed</div>\n            <div class="customer-title">\n                Founder Smart Intelligent Parking\n            </div>\n            <div class="customer-feedback">\n                I am a happy user. The app is easy to use, user-friendly and makes\n                my life easier. Most importantly the app settings conform with the\n                government regulations.\n            </div>\n            </div>\n\n        </div>\n    </div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Try the online HR software for FREE!</h1>\n            <h3>No Obligations Or Credit Card Details Required</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Get Started\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp-My-Fb.html -->\n<div id="signUpFb">\n<section id="section-header">\n<div class="section-content">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="logo"></div>\n    <h1>Sistem Pengurusan Gaji<br/>yang paling mudah</h1>\n    <h2>Perisian sistem gaji yang mesra pengguna dan mampu milik<br>\n        untuk SME di Malaysia.<br><br>\n        Penggunaan kali pertama adalah percuma</h2>\n    <div class="signup-form col-md-10">\n        <form class="m-t js-signup-form">\n            <div class="form-group">\n                <input type="text" name="name" class="form-control"\n                       placeholder="Nama penuh"\n                       value="">\n                <div class="error-name error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input name="email" class="form-control"\n                       placeholder="E-mel Kerja"\n                       value="" >\n\n                <div id="hidden-password">\n                    <input type="password">\n                </div>\n\n                <div class="error-email error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="contactPhone" name="contactPhone"\n                       class="form-control" placeholder="Nombor telefon">\n                <div class="error-contactPhone error text-left"></div>\n            </div>\n\n            <div class="form-group">\n                <input data-id="password" name="password" type="password"\n                    maxlength="72"\n                    class="form-control" placeholder="Kata laluan">\n                <div class="password-veredict"></div>\n                <div class="error-password error text-left"></div>\n                <div class="license">\n                    Dengan mendaftar, anda telah bersetuju menerima <a href="//www.payrollpanda.my/terms.html" target="_blank">syarat perkhidmatan</a>\n                    dan <a href="//www.payrollpanda.my/privacy.html" target="_blank">dasar privasi</a>.\n                </div>\n            </div>\n\n            <div class="form-group">\n                <button class="js-register-button\nbtn btn-primary btn-get-started"  data-style="swap">\n                    Mula Sekarang\n                </button>\n            </div>\n\n            <div class="form-group text-center">\n                <u><a href="#signup-page-1" class="text-white">Switch to English</a></u>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n</div>\n</div>\n</section>\n\n<section id="section-features">\n<div class="container">\n<div class="col-md-10 col-md-offset-1">\n    <div class="row">\n        <h1>Ciri-Ciri Utama</h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features"><!-- Start Feature -->\n            <span class="line-font green icon-calendar"></span>\n            <!-- Feature Icon -->\n            <h3>Mesra Pengguna</h3><!-- Feature Title -->\n            <p>Menjana slip gaji, laporan bulanan dan borang berkanun dengan satu klik butang.</p><!-- Feature Text -->\n        </div><!-- End Feature -->\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-docs"></span>\n            <h3>Di Mana Sahaja, Bila-Bila Masa</h3>\n            <p>Akses dan menguruskan slip gaji anda dari mana-mana komputer, di mana sahaja, pada bila-bila masa.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-briefcase"></span>\n            <h3>Pengurusan Cuti Percuma</h3>\n            <p>Ringankan beban HR. Kakitangan boleh memohon cuti dan memeriksa peruntukan cuti di mana mana sahaja. Anda juga boleh log hari MC mereka.</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-list"></span>\n            <h3>Harga Yang Berpatutan</h3>\n            <p>Anda hanya perlu bayar untuk penjanaan slip gaji. Bayaran bulanan adalah RM 38 + RM 8 untuk setiap bilangan pekerja. Fungsi yang lain adalah percuma.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-book-open"></span>\n            <h3>Selamat</h3>\n            <p>Maklumat sensitif anda adalah sulit dan dilindungi di atas talian.</p>\n        </div>\n        <div class="col-md-4 col-sm-4 features">\n            <span class="line-font green icon-user-following"></span>\n            <h3>Tepat dan Betul</h3>\n            <p>Dapatkan ketenangan jiwa. Semua pengiraan adalah tepat dan mengikut undang-undang Malaysia.</p>\n        </div>\n    </div>\n    <div class="row">\n        <div class="features-note"><i>*RM 8 adalah untuk 50 pekerja dan kebawah. RM 6 akan dikenakan untuk pekerja yang ke-50 dan ke atas. Tidak termasuk SST.</i>\n        </div>\n    </div>\n</div>\n</div>\n</section>\n\n<section id="section-customers">\n<div class="container">\n    <div class="row">\n        <h1>Inilah testimonial pelanggan kami</h1>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-bernadette"></div>\n            <div class="customer-name">Bernadette Lawrence</div>\n            <div class="customer-title">Pengurus Pejabat dan Tadbir MDBC</div>\n            <div class="customer-feedback">\n                Bagi seseorang yang tiada pengalaman dalam bidang pengurusan sumber manusia dan gaji,\n                applikasi ini sangat mudah digunakan.\n            </div>\n        </div>\n\n        <div class="col-md-4 col-sm-4 customers">\n            <div class="customer-photo cp-shahireen"></div>\n            <div class="customer-name">Shahireen Zulkifli</div>\n            <div class="customer-title">Pengarah Terfaktab Media</div>\n            <div class="customer-feedback">\n                PayrollPanda sangat mesra pengguna, semua teratur dan mudah digunakan.\n                Fungsi chat juga sangat membantu.\n            </div>\n        </div>\n\n        <div class="col-md-4 col-sm-4 customers">\n          <div class="customer-photo cp-dato"></div>\n          <div class="customer-name">Dato Jeffrey Mohamed</div>\n          <div class="customer-title">\n            Pengasas Smart Intelligent Parking\n          </div>\n          <div class="customer-feedback">\n            Saya sangat berpuas hati. Applikasi ini sangat mudah digunakan, mesra pengguna dan memudahkan urusan harian saya.\n            Dan yang paling penting, tetapan applikasi ini adalah selaras dengan peraturan kerajaan.\n          </div>\n        </div>\n    </div>\n</div>\n</section>\n\n<section id="section-ratings"></section>\n\n<section id="section-payroll">\n<div class="content">\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Cubalah sekarang dan mulakan penjanaan gaji pekerja anda yang pertama secara percuma</h1>\n            <h3>Tiada Komitmen Atau Butiran Kad Kredit Diperlukan</h3>\n            <a class="btn btn-primary btn-get-started js-go-to-top"\n            data-style="swap">\n                Mula Sekarang\n            </a>\n        </div>\n    </div>\n</div>\n</section>\n<section id="section-footer">\n    <div class="container">\n        <div class="col-md-10 col-md-offset-1">\n            <div class="row">\n                <!-- Footer Intro  -->\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <p>We focus on providing world class HR cloud applications. Our flagship product is PayrollPanda, an online payroll system for Malaysian SMEs.</p>\n                </div>\n\n                <div class="col-md-3">\n                    <h3>Payroll Panda Sdn Bhd</h3>\n                    <ul>\n                        <li><i class="fa fa-map-signs"></i> E 2-1-1 Commercial Unit, Bukit Utama 1, Changkat Bukit Utama PJU 6, Bandar Utama, 47800 Petaling Jaya, Selangor, Malaysia</li>\n                        <li><i class="fa fa-phone"></i> +60 3 2787 9168</li>\n                        <li><i class="fa fa-envelope-open-o"></i>\n                            <a href="mailto:admin@payrollpanda.my"> admin@payrollpanda.my</a>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Quick Links</h3>\n                    <ul>\n                        <li><i class="fa fa-angle-right"></i> <a href="/terms">Terms &amp; Conditions</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="/privacy">Privacy Policy</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://payrollpanda.youcanbook.me/">Book Demo</a></li>\n                        <li><i class="fa fa-angle-right"></i> <a href="https://www.skootjobs.com/business/5819aa7d5f458cabb14a09cb/all/jobs/jobs-at-launchpad-startups">Careers</a></li>\n                    </ul>\n                </div>\n\n                <div class="col-md-3 w-col-stack">\n                    <h3>Stay in Touch!</h3>\n                    <ul>\n                        <li>Follow us on social media!</li>\n                        <li>\n                            <div class="row">\n                                <a href="http://www.facebook.com/payrollpanda"><i class="col-md-4 center-block social social-facebook"></i></a>\n                                <a href="https://www.linkedin.com/company/payroll-panda"><i class="col-md-4 center-block social social-linkedin"></i></a>\n                                <a href="https://www.youtube.com/channel/UCgk7FYF9_C_hvM9c-OEeMfA"><i class="col-md-4 center-block social social-youtube"></i></a>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n\n<footer>\n<div class="content">\n<div class="col-md-10 col-md-offset-1">\n<div class="row">\n    <div class="col-md-6">\n        <p>Copyright &copy; '+
	((__t=( new Date().getFullYear() ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.</p>\n    </div>\n</div>\n</div>\n</div>\n</footer>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/SignUp.html -->\n<div class="signup-container">\n<div class="signup-box-container">\n<div class="row">\n<div class="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3">\n\n<div class="signup-box text-center">\n    <img src="/images/payrollpanda-logo-lg.png" alt="PayrollPanda Logo">\n    <h2 class="font-bold m-t-lg">Try us now for FREE</h2>\n    <div class="signup-header text-center">\n        No obligations or credit card required:\n    </div>\n    <div class="row m-l-none m-r-none">\n        <div class="col-sm-10 col-sm-offset-1 col-xs-10 col-xs-offset-1 col-form">\n\n            ';
	 if (who !== 'MPP Admin' && who !== 'MPP Manager') { 
	__p+='\n            <ul class="nav nav-tabs">\n                <li';
	 if (who !== 'Employee') { 
	__p+=' class="active"';
	 } 
	__p+='>\n                    <a data-toggle="tab" href="#employer">I\'m an Employer</a>\n                </li>\n                <li';
	 if (who === 'Employee') { 
	__p+=' class="active"';
	 } 
	__p+='>\n                    <a data-toggle="tab" href="#employee">I\'m an Employee</a>\n                </li>\n            </ul>\n            ';
	 } 
	__p+='\n            <div class="tab-content" style="height:auto;">\n                ';
	 if (restrictEmployerSignup) { 
	__p+='\n                <div id="employer" class="tab-pane fade in\n                    ';
	 if (who !== 'Employee') { 
	__p+='active';
	 } 
	__p+='">\n                    <div class="signup-restriction-warning-container" style="margin: 50px 20px;">\n                        New subscriptions are restricted.\n                        Consider using <a href="https://app2.payrollpanda.my" target="_blank">PayrollPanda Core</a> instead.\n                        If you need assistance please contact PayrollPanda customer support.\n                    </div>\n                </div>\n                ';
	 } else { 
	__p+='\n                <div id="employer" class="tab-pane fade in\n                    ';
	 if (who !== 'Employee') { 
	__p+='active';
	 } 
	__p+='">\n                    <div>\n                    <form class="js-signup-form" role="form">\n                        <div class="form-group">\n                            <input type="text" name="name" class="form-control"\n                                placeholder="Your Name"\n                                value="'+
	((__t=( name ))==null?'':_.escape(__t))+
	'" '+
	((__t=( name ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n                            <div class="error-name error text-left"></div>\n                        </div>\n\n                        ';
	 if (contactPhoneRequired) { 
	__p+='\n                        <div class="form-group">\n                            <input data-id="contactPhone" name="contactPhone"\n                                    class="form-control" placeholder="Your Phone Number">\n                            <div class="error-contactPhone error text-left"></div>\n                        </div>\n                        ';
	 } 
	__p+='\n\n                        <div class="form-group">\n                            <input name="email" class="form-control"\n                                placeholder="Your Work Email Address"\n                                value="'+
	((__t=( email ))==null?'':_.escape(__t))+
	'" autocomplete="new-password"\n                                '+
	((__t=( email ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n                            <div class="error-email error text-left"></div>\n                        </div>\n                        <div class="form-group">\n                            <input data-id="password" name="password" type="password"\n                                class="form-control" placeholder="Password"\n                                maxlength="72"\n                                autocomplete="new-password">\n                            <div class="password-veredict"></div>\n                            <div id="password-rules"></div>\n                            <div class="error-password error text-left" style="top: 0;"></div>\n                        </div>\n                        <div class="form-group">\n                            <select name="disclosedEmployeeCount" data-id="disclosedEmployeeCount"\n                                class="form-control">\n                                <option selected disabled value="">Number of Employees</option>\n                                <option value="1-10">1-10</option>\n                                <option value="11-25">11-25</option>\n                                <option value="26-50">26-50</option>\n                                <option value="51-100">51-100</option>\n                                <option value="+100">+100</option>\n                            </select>\n                        </div>\n\n                        <div class="license">\n                            By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                            and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                        </div>\n\n                        <button class="js-register-button btn btn-primary block full-width m-b ladda-button"\n                                data-style="swap">\n                            Sign Up\n                        </button>\n\n                        <div class="signup-restriction-warning-container">\n                            New subscriptions are restricted.\n                            Consider using <a href="https://app2.payrollpanda.my" target="_blank">PayrollPanda Core</a> instead.\n                            If you need assistance please contact PayrollPanda customer support.\n                        </div>\n\n                        <div class="section-ratings">\n                            <div class="row ratings-container">\n                                <div class="rating-items">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-g2-crowd"></div>\n                                        <div class="ratings">\n                                            <div class="five"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="rating-items">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-capterra"></div>\n                                        <div class="ratings">\n                                            <div class="four-half"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="rating-items">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-bitcatcha"></div>\n                                        <div class="ratings">\n                                            <div class="five"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="rating-items">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-getapp"></div>\n                                        <div class="ratings">\n                                            <div class="four-half"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="rating-items hidden-lg">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-capterra-best-of-use"></div>\n                                    </div>\n                                </div>\n                                <div class="rating-items">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-tec"></div>\n                                        <div class="ratings">\n                                            <div class="four-half"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="rating-items hidden-sm hidden-md hidden-xs ">\n                                    <div class="logo-ratings">\n                                        <div class="logo lr-capterra-best-of-use"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                    </div>\n                </div>\n\n                ';
	 } 
	__p+='\n                ';
	 if (who === 'Employee') { 
	__p+='\n                    <div id="employee" class="tab-pane fade in active">\n                        <form class="js-signup-form" role="form">\n                            <div class="form-group">\n                                <input type="text" name="name" class="form-control" placeholder="Your Name"\n                                    value="'+
	((__t=( name ))==null?'':_.escape(__t))+
	'" '+
	((__t=( name ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n                                <div class="error-name error text-left"></div>\n                            </div>\n\n                            <div class="form-group">\n                                <input name="email" class="form-control"\n                                        placeholder="Your Work Email Address"\n                                        value="'+
	((__t=( email ))==null?'':_.escape(__t))+
	'" autocomplete="new-password"\n                                        '+
	((__t=( email ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n                                <div class="error-email error text-left"></div>\n                            </div>\n                            <div class="form-group">\n                                <input data-id="password" name="password" type="password"\n                                    class="form-control" placeholder="Password"\n                                    autocomplete="new-password">\n                                <div class="password-veredict"></div>\n                                <div class="error-password error text-left"></div>\n                            </div>\n\n                            <div class="license">\n                                By signing up, you agree to the <a href="//www.payrollpanda.my/terms.html" target="_blank">Terms of Service</a>\n                                and <a href="//www.payrollpanda.my/privacy.html" target="_blank">Privacy Policy</a>.\n                            </div>\n\n                            <button class="js-register-button\n                                btn btn-primary block full-width m-b\n                                ladda-button"  data-style="swap">\n                                Sign Up\n                            </button>\n                        </form>\n                    </div>\n                ';
	 } else { 
	__p+='\n                    <div id="employee" class="tab-pane fade in">\n                        <img src="/images/large_panda.jpg" alt="Panda Logo" />\n                        <p>\n                            To sign up as an employee you need to be invited by your employer through the app.\n                            <br />\n                            If you need help you can contact us via the chat support.\n                        </p>\n                    </div>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="signup-box-footer">\n    <a class="btn btn-outline btn-white pull-right" style="margin-top: -8px;"\n       href="#login">Login</a>\n    <span class="hint text-muted pull-right m-r">Have an account already?</span>\n</div>\n\n</div>\n</div>\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _ForgotPassword = __webpack_require__(618);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _sweetalert = __webpack_require__(530);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'submit .js-form': 'forgotPassword'
	    },
	
	    el: '.content',
	
	    initialize: function initialize() {
	        _.bindAll(this, 'forgotPassword');
	        this.render();
	    },
	
	    forgotPassword: function forgotPassword() {
	        var self = this;
	        var email = self.$('.js-email').val();
	        var re = new RegExp('^[a-z0-9\x7F-\uFFFF!#$%&\'*+/=?^_`{|}~-]+(?:.[a-z0-9' + '\x7F-\uFFFF!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-' + 'z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$', 'i');
	        if (!re.test(email)) {
	            self.$('.js-error').text('Please enter an email address.').show();
	            return false;
	        }
	
	        var stopLoader = _loader2.default.startFullScreen('.js-send-button');
	        _user2.default.resetPassword(email).then(function () {
	            (0, _sweetalert2.default)({
	                title: 'Success!',
	                text: 'Password reset request was sent successfully. ' + 'Please check your email to reset your password. \n\n' + '<strong style="color:red;font-style:italic;font-size:14px">' + 'Note: Reset Password link will expire after 24 hours.</strong>',
	                type: 'success',
	                customClass: 'sweet-alert-success',
	                confirmButtonColor: _alerts2.default.btnSuccessColor,
	                confirmButtonText: 'OK'
	            }, function () {
	                app.mainRouter.navigate('login', { trigger: true });
	            });
	        }).catch(function (error) {
	            var message = error.message;
	            // try (and fail silently, if impossible) to get a message
	            // from the response
	            try {
	                message = error.response.data.error.message;
	            } catch (err) {}
	
	            self.$('.js-error').text(message).show();
	        }).finally(stopLoader());
	
	        return false;
	    },
	
	    render: function render() {
	        this.$el.html((0, _ForgotPassword2.default)());
	        $('body').addClass('gray-bg');
	        this.delegateEvents();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/ForgotPassword.html -->\n<div class="forgot-container">\n    <div class="forgot-box-container">\n\n        <div class="row">\n            <div class="col-sm-8 col-sm-offset-2">\n\n                <div class="forgot-box text-center">\n                    <img src="/images/payrollpanda-logo-sm.png" alt="PayrollPanda Logo">\n\n                    <h2 class="font-bold m-t-xl m-b-none">Forgot Password</h2>\n\n                    <div class="row m-l-none m-r-none">\n                        <div class="col-sm-8 col-sm-offset-2">\n                            <form class="js-form m-t-md" role="form">\n                                <div class="js-error error" style="display:none; color:red;"></div>\n                                <div class="form-group m-b-md">\n                                    <input type="email" class="js-email form-control" placeholder="Email" required="">\n                                </div>\n                                <div class="form-group text-center m-b-xl" style="margin-top: 60px;">\n                                    <button type="submit"\n                                            class="js-send-button btn btn-primary btn-large ladda-button"\n                                            data-style="swap">\n                                        Send new password\n                                    </button>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="forgot-box-footer">\n                    <a class="btn btn-outline btn-white pull-right" style="margin-top: -8px;"\n                       href="#login">Login</a>\n                    <span class="hint text-muted pull-right m-r">Have an account already?</span>\n                </div>\n\n            </div>\n        </div>\n\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(620);
	var loader = __webpack_require__(534);
	
	module.exports = Backbone.View.extend({
	
	    events: {
	        'submit .js-form': 'submit'
	    },
	
	    el: '.content',
	
	    initialize: function initialize(options) {
	        var self = this;
	        self.query = self.parseQuery(options.query);
	        this.render();
	    },
	
	    render: function render() {
	        var self = this;
	        var base = 'https://www.parse.com/apps/';
	        self.$el.html(template({
	            action: base + self.query.id + '/request_password_reset',
	            username: self.query.username,
	            token: self.query.token
	        }));
	        $('body').addClass('gray-bg');
	        self.$('.js-password').strength();
	    },
	
	    parseQuery: function parseQuery(query) {
	        // Taken from original reset password template
	        var urlParams = {};
	        var pair;
	        var tokenize = /([^&=]+)=?([^&]*)/g;
	        var reSpace = function reSpace(s) {
	            return decodeURIComponent(s.replace(/\+/g, ' '));
	        };
	        while (pair = tokenize.exec(query)) {
	            urlParams[reSpace(pair[1])] = reSpace(pair[2]);
	        }
	        return urlParams;
	    },
	
	    submit: function submit() {
	        var self = this;
	        var password = self.$('.js-password').val();
	
	        if (password.length < 8) {
	            self.$('.js-error').html('The password must be at least 8 characters.').show();
	            return false;
	        }
	        loader.startFullScreen('#change-button');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/ChoosePassword.html -->\n<div class="password-reset-container">\n    <div class="password-reset-box-container">\n\n        <div class="row">\n            <div class="col-sm-8 col-sm-offset-2">\n\n                <div class="password-reset-box text-center">\n                    <img src="/images/payrollpanda-logo-sm.png" alt="PayrollPanda Logo">\n\n                    <h2 class="font-bold m-t-xl m-b-none">Reset password</h2>\n\n                    <div class="row m-l-none m-r-none">\n                        <div class="col-sm-8 col-sm-offset-2">\n                            <p>Enter your new password.</p>\n\n                            <form class="js-form m-t-md" role="form" action="'+
	((__t=( action ))==null?'':_.escape(__t))+
	'" method="POST">\n                                <div class="js-error error" style="display:none; color:red;"></div>\n                                <div class="form-group m-b-md">\n                                    <input name="new_password" data-id="password" type="password" class="js-password form-control" placeholder="Password" required="">\n                                </div>\n\n                                <input name="utf-8" type="hidden" value="✓" />\n                                <input name="username" type="hidden" value="'+
	((__t=( username ))==null?'':_.escape(__t))+
	'" />\n                                <input name="token" type="hidden" value="'+
	((__t=( token ))==null?'':_.escape(__t))+
	'" />\n\n                                <div class="form-group text-center m-b-xl" style="margin-top: 60px;">\n                                    <button type="submit"\n                                            class="js-send-button btn btn-primary btn-large ladda-button"\n                                            data-style="swap">\n                                        Change password\n                                    </button>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="password-reset-box-footer">\n                    <a class="btn btn-outline btn-white pull-right" style="margin-top: -8px;"\n                       href="/#login">Login</a>\n                    <span class="hint text-muted pull-right m-r">Have an account already?</span>\n                </div>\n\n            </div>\n        </div>\n\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(622);
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	
	    initialize: function initialize(options) {
	        var self = this;
	        self.text = options.text;
	        self.loginLink = options.loginLink || false;
	        self.render();
	    },
	
	    render: function render() {
	        var self = this;
	        self.$el.html(template({
	            text: self.text,
	            loginLink: self.loginLink
	        }));
	        $('body').addClass('gray-bg');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/Notification.html -->\n<div class="middle-box text-center animated fadeInDown">\n    <a href="/">\n        <img src="/images/payrollpanda-logo.png" width="300">\n    </a>\n    <h3 class="font-bold"></h3>\n    <div>'+
	((__t=( text ))==null?'':_.escape(__t))+
	'</div>\n    ';
	 if (loginLink) { 
	__p+='\n        <div>Please <a href="/#login">Login</a></div>\n    ';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(624);
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	
	    initialize: function initialize() {
	        this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template());
	        $('body').addClass('gray-bg');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/ErrorMobile.html -->\n<div class="middle-box text-center animated fadeInDown">\n    <img src="/images/payrollpanda-logo.png" width="300">\n    <h3 class="font-bold"></h3>\n    <div class="error-desc">\n        <p>Sorry but this version of the PayrollPanda application is currently only\n        available for use with a desktop computer. Check your email for your login details and sign in via a desktop computer.</p>\n        <p>Learn how PayrollPanda can help you save time in this 1-minute video:</p>\n        <iframe width="100%" src="https://www.youtube.com/embed/vsCENM-S6Fo" frameborder="0" allowfullscreen></iframe>\n        <p>If you have any questions you can reach us at admin@payrollpanda.my.</p>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var Alerts = __webpack_require__(529);
	var log = __webpack_require__(525)('common-base-router');
	
	module.exports = Backbone.Router.extend({
	    view: null,
	    layout: null,
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            log: function log() {}
	        });
	
	        this.on('route', this.logRouteChange, this);
	    },
	
	    route: function route(_route, name, _callback) {
	        var f;
	
	        if (!_callback) {
	            _callback = this[name];
	        }
	
	        f = function f() {
	            var _this = this;
	
	            var args = arguments;
	            var status = { unsaved: false };
	
	            log.info('Triggering navigate event');
	            app.events.trigger('navigate', status);
	
	            if (status.unsaved === true) {
	                log.info('A view claimed unsaved changes');
	
	                Alerts.show('confirm', {
	                    title: 'Unsaved changes',
	
	                    text: status.msg || 'There are unsaved changes. Exiting ' + 'this page will result in the changes being discarded.',
	                    confirmButtonText: 'Exit',
	                    cancelButtonText: 'Stay',
	                    callback: function callback(confirm) {
	                        if (confirm) {
	                            app.events.trigger('hard-exit');
	
	                            _this.hidePopups();
	                            _this.undelegateEvents();
	                            app.events.trigger('before:route', {
	                                previousFragment: Backbone.history.previousFragment
	                            });
	                            _callback.apply(_this, args);
	                            return;
	                        }
	
	                        app.mainRouter.navigate(Backbone.history.previousFragment, { trigger: false, replace: true });
	                    }
	                });
	
	                return;
	            }
	
	            this.hidePopups();
	            this.undelegateEvents();
	            app.events.trigger('before:route', {
	                previousFragment: Backbone.history.previousFragment
	            });
	            _callback.apply(this, arguments);
	        };
	
	        return Backbone.Router.prototype.route.apply(this, [_route, name, f]);
	    },
	
	    undelegateEvents: function undelegateEvents() {
	        if (this.view && _.isFunction(this.view.undelegateEvents)) {
	            this.view.undelegateEvents();
	        }
	
	        if (!_.isNull(this.layout) && _.isFunction(this.layout.undelegateEvents)) {
	            this.layout.undelegateEvents();
	        }
	
	        if (app.contentView && typeof app.contentView.undelegateEvents === 'function') {
	            app.contentView.undelegateEvents();
	        }
	    },
	
	    hidePopups: function hidePopups() {
	        if (Backbone.history.previousFragment === Backbone.history.getFragment()) {
	            return;
	        }
	
	        if ($('.modal-backdrop.in')[0]) {
	            $('.modal').off().modal('hide');
	        }
	
	        Alerts.close();
	    },
	
	    logRouteChange: function logRouteChange(route, params) {
	        var args = ['Route matched <', route, '>'];
	
	        if (params && params.length > 0 && params[0] !== null) {
	            args.push('with params', params);
	        } else {
	            args.push('with no parameters');
	        }
	
	        this.options.log.info.apply(this.options.log, args);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _holiday = __webpack_require__(627);
	
	var _holiday2 = _interopRequireDefault(_holiday);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Holidays = function (_Collection) {
	    _inherits(Holidays, _Collection);
	
	    function Holidays() {
	        _classCallCheck(this, Holidays);
	
	        return _possibleConstructorReturn(this, (Holidays.__proto__ || Object.getPrototypeOf(Holidays)).apply(this, arguments));
	    }
	
	    _createClass(Holidays, [{
	        key: 'url',
	        value: function url() {
	            return '/Holidays';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, options) {
	            this.model = _holiday2.default;
	            _get(Holidays.prototype.__proto__ || Object.getPrototypeOf(Holidays.prototype), 'initialize', this).apply(this, arguments);
	
	            this.options = _.defaults(options || {}, {
	                all: true,
	                enabled: true,
	                company: app.company,
	                location: options.location,
	                dateStart: (0, _moment2.default)().startOf('year').toDate(),
	                dateEnd: null,
	                forceFetch: false
	            });
	
	            return this;
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(a, b) {
	            return (0, _moment2.default)(a.get('date')).isBefore(b.get('date')) ? -1 : 1;
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var _this2 = this;
	
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref$force = _ref.force,
	                force = _ref$force === undefined ? false : _ref$force;
	
	            var models = [];
	            var enabledHolidays = (0, _bluebird.resolve)([]);
	            var disabledHolidays = (0, _bluebird.resolve)([]);
	
	            if (!this.options.company) {
	                throw new Error('Can\'t fetch holidays for no company');
	            }
	
	            if (this.options.all || this.options.enabled) {
	                enabledHolidays = _axios2.default.get(this.finalUrl() + '/enabled', {
	                    params: {
	                        companyId: this.options.company.id,
	                        locationId: this.options.location,
	                        dateStart: this.options.dateStart,
	                        dateEnd: this.options.dateEnd,
	                        force: force || this.options.forceFetch
	                    },
	                    headers: { 'Authorization': app.user.getAccessToken().id }
	                }).then(function (r) {
	                    return r.data.results;
	                });
	            }
	
	            if (this.options.all || !this.options.enabled) {
	                disabledHolidays = _axios2.default.get(this.finalUrl() + '/disabled', {
	                    params: {
	                        companyId: this.options.company.id,
	                        locationId: this.options.location,
	                        dateStart: this.options.dateStart,
	                        dateEnd: this.options.dateEnd,
	                        force: force || this.options.forceFetch
	                    },
	                    headers: { 'Authorization': app.user.getAccessToken().id }
	                }).then(function (r) {
	                    return r.data.results;
	                });
	            }
	
	            return (0, _bluebird.all)([enabledHolidays, disabledHolidays]).then(function (_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2),
	                    enabled = _ref3[0],
	                    disabled = _ref3[1];
	
	                disabled = disabled.map(function (holiday) {
	                    holiday.enabled = false;
	                    return holiday;
	                });
	                models.push.apply(models, _toConsumableArray(enabled).concat(_toConsumableArray(disabled)));
	                // If we are not silent the collection might flag models as
	                // dirty if they have changed.
	                _this2.reset(models, { silent: true });
	                _this2.trigger('sync');
	                return _this2;
	            });
	        }
	    }]);
	
	    return Holidays;
	}(_collection2.default);
	
	exports.default = Holidays;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Holiday = function (_Model) {
	    _inherits(Holiday, _Model);
	
	    _createClass(Holiday, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Holidays';
	        }
	    }]);
	
	    function Holiday() {
	        _classCallCheck(this, Holiday);
	
	        var _this = _possibleConstructorReturn(this, (Holiday.__proto__ || Object.getPrototypeOf(Holiday)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(Holiday, [{
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                title: { presence: { message: '^Title is required' } },
	                date: { presence: { message: '^Date is required' } }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(Holiday.prototype.__proto__ || Object.getPrototypeOf(Holiday.prototype), 'initialize', this).apply(this, arguments);
	            this._enabled = typeof this.get('enabled') !== 'undefined' ? this.get('enabled') : true;
	            this._toggle = typeof this.get('enabled') !== 'undefined' ? this.get('enabled') : true;
	            this._location = null;
	            return this;
	        }
	    }, {
	        key: 'toggle',
	        value: function toggle(value, location) {
	            var _this2 = this;
	
	            if (value !== this._enabled) {
	                return _axios2.default.post(this.finalUrl() + '/toggle', {
	                    companyId: app.company.id,
	                    locationId: location && location.id,
	                    holidayId: this.id,
	                    enabled: value
	                }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function () {
	                    _this2._enabled = value;
	                    _this2._toggle = value;
	
	                    return true;
	                }).catch(function () {
	                    return false;
	                });
	            }
	
	            return (0, _bluebird.resolve)(false);
	        }
	    }, {
	        key: 'dirty',
	        value: function dirty() {
	            var dirty = _get(Holiday.prototype.__proto__ || Object.getPrototypeOf(Holiday.prototype), 'dirty', this).apply(this, arguments);
	            if (arguments.length) {
	                return dirty;
	            }
	            return dirty || this._enabled !== this._toggle;
	        }
	    }, {
	        key: 'isEnabled',
	        value: function isEnabled() {
	            return this._toggle === true;
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            if (this.get('companyId')) {
	                return _get(Holiday.prototype.__proto__ || Object.getPrototypeOf(Holiday.prototype), 'save', this).apply(this, arguments);
	            }
	
	            return (0, _bluebird.resolve)();
	        }
	    }]);
	
	    return Holiday;
	}(_model2.default);
	
	exports.default = Holiday;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payrollItem = __webpack_require__(591);
	
	var _payrollItem2 = _interopRequireDefault(_payrollItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayrollItems = function (_Collection) {
	    _inherits(PayrollItems, _Collection);
	
	    function PayrollItems() {
	        _classCallCheck(this, PayrollItems);
	
	        return _possibleConstructorReturn(this, (PayrollItems.__proto__ || Object.getPrototypeOf(PayrollItems)).apply(this, arguments));
	    }
	
	    _createClass(PayrollItems, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return '/PayrollItems/getForCompany/' + this.company.get('objectId');
	            }
	            return '/PayrollItems';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company,
	                _ref$unsyncable = _ref.unsyncable,
	                unsyncable = _ref$unsyncable === undefined ? false : _ref$unsyncable;
	
	            _get(PayrollItems.prototype.__proto__ || Object.getPrototypeOf(PayrollItems.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _payrollItem2.default;
	            this.company = company;
	            this.unsyncable = unsyncable;
	            this.searchableAttributes = ['name'];
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'name';
	            }
	            this.pagination = false;
	            return this;
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            return _get(PayrollItems.prototype.__proto__ || Object.getPrototypeOf(PayrollItems.prototype), 'fetch', this).apply(this, arguments);
	        }
	
	        // The reason sync is overriden is so that we can transparently use
	        // fetch() to get the payroll items for a given company. Dunno if it's the
	        // right call tho.
	
	    }, {
	        key: 'sync',
	        value: function sync(method, collection, options) {
	            if (this.unsyncable) {
	                return this.map(function (model) {
	                    return model.attributes;
	                });
	            }
	
	            if (!this.company || method !== 'read') {
	                return _get(PayrollItems.prototype.__proto__ || Object.getPrototypeOf(PayrollItems.prototype), 'sync', this).apply(this, arguments);
	            }
	
	            options.url = this.finalUrl();
	            options.headers = { 'Authorization': app.user.getAccessToken().id };
	            return _get(PayrollItems.prototype.__proto__ || Object.getPrototypeOf(PayrollItems.prototype), 'sync', this).call(this, method, collection, options);
	        }
	    }, {
	        key: 'popular',
	        value: function popular() {
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref2$limit = _ref2.limit,
	                limit = _ref2$limit === undefined ? 12 : _ref2$limit,
	                _ref2$threshold = _ref2.threshold,
	                threshold = _ref2$threshold === undefined ? 0 : _ref2$threshold;
	
	            var models = _(this.filter(function (model) {
	                return (model.get('popularity') || -1) >= threshold;
	            })).sortBy(function (model) {
	                return (model.get('popularity') || 0) * -1;
	            });
	
	            return _(models).first(limit);
	        }
	    }, {
	        key: 'getByCategory',
	        value: function getByCategory(category) {
	            return this.filter(function (model) {
	                return model.get('category') === category;
	            });
	        }
	    }, {
	        key: 'getSelected',
	        value: function getSelected() {
	            return this.filter(function (model) {
	                return model.isSelected();
	            });
	        }
	    }, {
	        key: 'getSelectedByCategory',
	        value: function getSelectedByCategory(category) {
	            return this.filter(function (model) {
	                return model.get('category') === category && model.isSelected();
	            });
	        }
	    }, {
	        key: 'clearSelection',
	        value: function clearSelection() {
	            this.getSelected().forEach(function (model) {
	                return model.toggleSelect();
	            });
	            return this;
	        }
	    }, {
	        key: 'clearSelectionForCategory',
	        value: function clearSelectionForCategory(category) {
	            this.getSelectedByCategory(category).forEach(function (model) {
	                model.toggleSelect();
	            });
	            return this;
	        }
	    }, {
	        key: 'getSelectableAdditionals',
	        value: function getSelectableAdditionals() {
	            var types = [_payrollItem.consts.TYPE_ADDITION, _payrollItem.consts.TYPE_BONUS, _payrollItem.consts.TYPE_DEDUCTION, _payrollItem.consts.TYPE_CP38, _payrollItem.consts.TYPE_ZAKAT, _payrollItem.consts.TYPE_OVERTIME, _payrollItem.consts.TYPE_BENEFIT, _payrollItem.consts.TYPE_UNPAID_LEAVE];
	
	            return new PayrollItems(this.filter(function (model) {
	                // TODO: Revise after backend is ported to PP2
	                var includeItem = function includeItem(item) {
	                    return item.get('type') !== _payrollItem.consts.TYPE_UNPAID_LEAVE || item.get('type') === _payrollItem.consts.TYPE_UNPAID_LEAVE && item.get('category') !== 0;
	                };
	
	                return model.get('hiddenAt') === null && (types.includes(model.get('type')) && includeItem(model) || model.get('type') === _payrollItem.consts.TYPE_MTD && model.get('subtype') === 'custom');
	            }), { unsyncable: true });
	        }
	    }, {
	        key: 'getSelectablePreviousPayslips',
	        value: function getSelectablePreviousPayslips() {
	            var nonNetTypes = [_payrollItem.consts.TYPE_ADDITION, _payrollItem.consts.TYPE_BONUS, _payrollItem.consts.TYPE_DEDUCTION, _payrollItem.consts.TYPE_CP38, _payrollItem.consts.TYPE_MTD, _payrollItem.consts.TYPE_ZAKAT, _payrollItem.consts.TYPE_BENEFIT, _payrollItem.consts.TYPE_BASE, _payrollItem.consts.TYPE_OVERTIME];
	            var netTypes = [_payrollItem.consts.TYPE_HRDF, _payrollItem.consts.TYPE_EIS, _payrollItem.consts.TYPE_SOCSO, _payrollItem.consts.TYPE_EPF, _payrollItem.consts.TYPE_UNPAID_LEAVE];
	
	            return new PayrollItems(this.filter(function (model) {
	                return model.get('hiddenAt') === null && (nonNetTypes.indexOf(model.get('type')) >= 0 || netTypes.indexOf(model.get('type')) >= 0 && model.get('isUnit') === false && model.get('isNet') === true);
	            }), { unsyncable: true });
	        }
	    }, {
	        key: 'getSelectableDefaults',
	        value: function getSelectableDefaults() {
	            var types = [_payrollItem.consts.TYPE_ADDITION, _payrollItem.consts.TYPE_BONUS, _payrollItem.consts.TYPE_DEDUCTION, _payrollItem.consts.TYPE_ZAKAT, _payrollItem.consts.TYPE_BENEFIT, _payrollItem.consts.TYPE_CP38, _payrollItem.consts.TYPE_OVERTIME];
	
	            return new PayrollItems(this.filter(function (model) {
	                return model.get('hiddenAt') === null && model.get('allowRecurrency') === true && types.indexOf(model.get('type')) >= 0;
	            }), { unsyncable: true });
	        }
	    }, {
	        key: 'getMappable',
	        value: function getMappable() {
	            return new PayrollItems(this.filter(function (model) {
	                return model.get('hiddenAt') === null && model.isIntegrationMappable();
	            }), { unsyncable: true });
	        }
	    }, {
	        key: 'getMappableDefaults',
	        value: function getMappableDefaults() {
	            var types = [_payrollItem.consts.TYPE_SOCSO, _payrollItem.consts.TYPE_BASE, _payrollItem.consts.TYPE_MTD, _payrollItem.consts.TYPE_EPF, _payrollItem.consts.TYPE_EIS, _payrollItem.consts.TYPE_HRDF, _payrollItem.consts.TYPE_ZAKAT];
	
	            return new PayrollItems(this.filter(function (model) {
	                return types.indexOf(model.get('type')) >= 0 && model.get('subtype') !== 'custom' && model.get('isUnit') === false;
	            }), { unsyncable: true });
	        }
	    }]);
	
	    return PayrollItems;
	}(_collection2.default);
	
	exports.default = PayrollItems;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _leaveType = __webpack_require__(630);
	
	var _leaveType2 = _interopRequireDefault(_leaveType);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveTypes = function (_Collection) {
	    _inherits(LeaveTypes, _Collection);
	
	    function LeaveTypes() {
	        _classCallCheck(this, LeaveTypes);
	
	        return _possibleConstructorReturn(this, (LeaveTypes.__proto__ || Object.getPrototypeOf(LeaveTypes)).apply(this, arguments));
	    }
	
	    _createClass(LeaveTypes, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return '/LeaveTypes/getForCompany/' + this.company.get('objectId');
	            }
	            return '/LeaveTypes';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            _get(LeaveTypes.prototype.__proto__ || Object.getPrototypeOf(LeaveTypes.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _leaveType2.default;
	            this.company = company;
	            this.pagination = false;
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'createdAt';
	            }
	            if (!this.options.sortOrder) {
	                this.options.sortOrder = 'descending';
	            }
	            return this;
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(a, b) {
	            if (a.get('annual')) {
	                return -1;
	            }
	
	            if (b.get('annual')) {
	                return 1;
	            }
	
	            if (!a.get('paid')) {
	                return 1;
	            }
	
	            if (!a.get('companyId')) {
	                return -1;
	            }
	
	            if (!a.get('optional')) {
	                return -1;
	            }
	
	            return a.get('name') > b.get('name') ? 1 : -1;
	        }
	    }, {
	        key: 'getActiveTypes',
	        value: function getActiveTypes() {
	            return new LeaveTypes(this.filter(function (model) {
	                return !model.get('hiddenAt');
	            }), { company: this.company });
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            // TODO support filters in getForCompany
	            if (this.company) {
	                return _get(LeaveTypes.prototype.__proto__ || Object.getPrototypeOf(LeaveTypes.prototype), 'fetch', this).call(this);
	            }
	
	            return _get(LeaveTypes.prototype.__proto__ || Object.getPrototypeOf(LeaveTypes.prototype), 'fetch', this).apply(this, arguments);
	        }
	
	        // The reason sync is overriden is so that we can transparently use
	        // fetch() to get the leave types for a given company. Dunno if it's the
	        // right call tho.
	
	    }, {
	        key: 'sync',
	        value: function sync(method, collection, options) {
	            if (!this.company || method !== 'read') {
	                return _get(LeaveTypes.prototype.__proto__ || Object.getPrototypeOf(LeaveTypes.prototype), 'sync', this).apply(this, arguments);
	            }
	
	            options.url = this.finalUrl();
	            options.headers = { 'Authorization': app.user.getAccessToken().id };
	            return _get(LeaveTypes.prototype.__proto__ || Object.getPrototypeOf(LeaveTypes.prototype), 'sync', this).call(this, method, collection, options);
	        }
	    }, {
	        key: 'fetchBalances',
	        value: function fetchBalances(employee) {
	            var _this2 = this;
	
	            var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	            return (typeof employee === 'string' ? new _employee2.default({ objectId: employee }).fetch() : (0, _bluebird.resolve)(employee)).then(function (employee) {
	                return _this2.fetchBalancesMap(employee, date);
	            }).then(function (data) {
	                try {
	                    console.log('Annual leave values - current entitled: ' + data.entitledNoCf['8A3RuXfS5w'] + ' taken: ' + data.taken['8A3RuXfS5w'] + ' cf: ' + (data.entitled['8A3RuXfS5w'] - data.entitledNoCf['8A3RuXfS5w']) + ' balance: ' + (data.entitled['8A3RuXfS5w'] - data.taken['8A3RuXfS5w']));
	                } catch (e) {
	                    // ignore
	                }
	
	                Object.keys(data.taken).forEach(function (id) {
	                    var model = _this2.get(id);
	                    if (model) {
	                        model.setTaken(data.taken[id]);
	                    }
	                });
	
	                Object.keys(data.defaultEntitled).forEach(function (id) {
	                    var model = _this2.get(id);
	                    if (model) {
	                        model.setDefaultEntitled(data.defaultEntitled[id]);
	                    }
	                });
	
	                Object.keys(data.entitled).forEach(function (id) {
	                    var model = _this2.get(id);
	                    if (model) {
	                        model.setEntitled(data.entitled[id]);
	                    }
	                });
	
	                Object.keys(data.cf || {}).forEach(function (id) {
	                    var model = _this2.get(id);
	                    if (model) {
	                        model.setCarriedFoward(data.cf[id]);
	                    }
	                });
	
	                return _this2;
	            }).catch(function (err) {
	                throw err;
	            });
	        }
	    }, {
	        key: 'fetchBalancesMap',
	        value: function fetchBalancesMap(employee) {
	            var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	            var isEndAtDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            //we want the url without any company prefixes
	            var url = new LeaveTypes(null, {}).finalUrl();
	
	            return _axios2.default.get(url + '/fetchBalances/' + employee.get('objectId'), {
	                params: {
	                    typeIds: this.map(function (model) {
	                        return model.get('objectId');
	                    }),
	                    date: date,
	                    isEndAtDate: isEndAtDate
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data.result;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }], [{
	        key: 'fetchCarryForwardDays',
	        value: function fetchCarryForwardDays(employee) {
	            var url = new LeaveTypes(null, {}).finalUrl();
	            return _axios2.default.get(url + '/fetchCarryForwardDays/' + employee.get('objectId'), { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                return r.data.result;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }]);
	
	    return LeaveTypes;
	}(_collection2.default);
	
	exports.default = LeaveTypes;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveType = function (_Model) {
	    _inherits(LeaveType, _Model);
	
	    function LeaveType() {
	        _classCallCheck(this, LeaveType);
	
	        return _possibleConstructorReturn(this, (LeaveType.__proto__ || Object.getPrototypeOf(LeaveType)).apply(this, arguments));
	    }
	
	    _createClass(LeaveType, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/LeaveTypes';
	        }
	    }, {
	        key: 'url',
	        value: function url() {
	            if (this.company && !this.get(this.idAttribute)) {
	                return this.company.url() + '/leaveTypes';
	            }
	            return _get(LeaveType.prototype.__proto__ || Object.getPrototypeOf(LeaveType.prototype), 'url', this).call(this);
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                name: { presence: { message: '^Name is required' } }
	            };
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                accruable: false,
	                paid: true,
	                carriable: false
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(_ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.idAttribute = 'objectId';
	            _get(LeaveType.prototype.__proto__ || Object.getPrototypeOf(LeaveType.prototype), 'initialize', this).apply(this, arguments);
	
	            this.company = company;
	            this.taken = 0;
	            this.defaultEntitled = 0;
	            this.entitled = 0;
	            this.cf = 0;
	
	            return this;
	        }
	    }, {
	        key: 'setTaken',
	        value: function setTaken() {
	            var taken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            this.taken = taken;
	        }
	    }, {
	        key: 'getTaken',
	        value: function getTaken() {
	            return new _decimal2.default(this.taken).toDP(3, _decimal2.default.ROUND_DOWN).toNumber();
	        }
	    }, {
	        key: 'setDefaultEntitled',
	        value: function setDefaultEntitled() {
	            var defaultEntitled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            this.defaultEntitled = defaultEntitled;
	        }
	    }, {
	        key: 'getDefaultEntitled',
	        value: function getDefaultEntitled() {
	            return new _decimal2.default(this.defaultEntitled).toNumber();
	        }
	    }, {
	        key: 'setEntitled',
	        value: function setEntitled() {
	            var entitled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            this.entitled = entitled;
	        }
	    }, {
	        key: 'getEntitled',
	        value: function getEntitled() {
	            return new _decimal2.default(this.entitled).toDP(3, _decimal2.default.ROUND_DOWN).toNumber();
	        }
	    }, {
	        key: 'setCarriedFoward',
	        value: function setCarriedFoward() {
	            var cf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            this.cf = cf;
	        }
	    }, {
	        key: 'getCarriedFoward',
	        value: function getCarriedFoward() {
	            return new _decimal2.default(this.cf).toDP(3, _decimal2.default.ROUND_DOWN).toNumber();
	        }
	    }, {
	        key: 'hasDaysEntitled',
	        value: function hasDaysEntitled() {
	            return this.get('paid');
	        }
	    }]);
	
	    return LeaveType;
	}(_model2.default);
	
	exports.default = LeaveType;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _position = __webpack_require__(576);
	
	var _position2 = _interopRequireDefault(_position);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Positions = function (_Collection) {
	    _inherits(Positions, _Collection);
	
	    function Positions() {
	        _classCallCheck(this, Positions);
	
	        return _possibleConstructorReturn(this, (Positions.__proto__ || Object.getPrototypeOf(Positions)).apply(this, arguments));
	    }
	
	    _createClass(Positions, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/positions';
	            }
	
	            return '/Positions';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            _get(Positions.prototype.__proto__ || Object.getPrototypeOf(Positions.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _position2.default;
	            this.company = company;
	            return this;
	        }
	    }]);
	
	    return Positions;
	}(_collection2.default);
	
	exports.default = Positions;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Main = __webpack_require__(633);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _coupon = __webpack_require__(639);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _companies = __webpack_require__(563);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _changeLogs = __webpack_require__(640);
	
	var _changeLogs2 = _interopRequireDefault(_changeLogs);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _users = __webpack_require__(642);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _coupons = __webpack_require__(643);
	
	var _coupons2 = _interopRequireDefault(_coupons);
	
	var _positions = __webpack_require__(631);
	
	var _positions2 = _interopRequireDefault(_positions);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alerts = __webpack_require__(529);
	
	var MainView = __webpack_require__(644);
	var PayrollSubmissionsView = __webpack_require__(647);
	var CompaniesView = __webpack_require__(654);
	var ReportsView = __webpack_require__(658);
	var PayrollsView = __webpack_require__(660);
	var ChangeLogsView = __webpack_require__(667);
	var EmployeesView = __webpack_require__(672);
	var MPPAccountsView = __webpack_require__(676);
	var PersonalSettingsView = __webpack_require__(681);
	var CouponsView = __webpack_require__(683);
	var BaseRouter = __webpack_require__(625);
	var loader = __webpack_require__(534);
	var SettingsRouter = __webpack_require__(691);
	
	
	module.exports = BaseRouter.extend({
	    routes: {
	        'payrollSubmissions': 'payrollSubmissions',
	        'reports': 'reports',
	        'personalSettings': 'personalSettings',
	        'users': 'users',
	        'users/:sort/:order': 'users',
	        'users/:sort/:order/:search': 'users',
	        'companies': 'companies',
	        'companies/:sort/:order': 'companies',
	        'companies/:sort/:order/:searchTerm': 'companies',
	        'companies/:sort/:order/:searchTerm/:mppSearchTerm': 'companies',
	        'payrolls/:companyId': 'payrolls',
	        'logs/:companyId': 'changeLogs',
	        'employees/:companyId': 'employees',
	        'employees/:companyId/:searchTerm': 'employees',
	        'mppAccounts': 'mppAccounts',
	        'coupons': 'coupons'
	    },
	
	    titles: {
	        'payrollSubmissions': 'Payroll Submissions',
	        'reports': 'Reports',
	        'personalSettings': 'Personal Settings',
	        'users': 'Users',
	        'companies': 'Companies',
	        'companies/:sort/:order': 'Companies',
	        'companies/:sort/:order/:searchTerm': 'Companies',
	        'companies/:sort/:order/:searchTerm/:mppSearchTerm': 'Companies',
	        'payrolls/:companyId': 'Payrolls',
	        'logs/:companyId': 'Logs',
	        'employees/:companyId': 'Employees',
	        'employees/:companyId/:searchTerm': 'Employees',
	        'mppAccounts': 'MPP Accounts'
	    },
	
	    childEl: '#main-area',
	
	    // The initialization of this router is way to complex because the
	    // MainView is the container for all the others and it requires async
	    // info. TODO Fix MainView
	    initialize: function initialize() {
	        this.mainView = new MainView({});
	
	        this.subRouters = [new SettingsRouter({ el: this.childEl })];
	
	        Backbone.history.on('route', function () {
	            this.mainView.setActiveLink(Backbone.history.getFragment());
	            window.scrollTo(0, 0);
	        }.bind(this));
	    },
	
	    companies: function companies(sortKey, sortOrder, searchStr, mppSearchStr) {
	        var _this = this;
	
	        var options = {
	            sortKey: 'companyName',
	            sortOrder: 'ascending',
	            pagination: { limit: 25 }
	        };
	
	        if (sortKey) {
	            options.sortKey = sortKey;
	        }
	        if (sortOrder) {
	            options.sortOrder = sortOrder;
	        }
	        if (searchStr && searchStr !== '__all') {
	            options.searchString = searchStr;
	        }
	        if (mppSearchStr && mppSearchStr !== '__all') {
	            options.mppSearchString = mppSearchStr;
	        }
	
	        this.undelegateEvents();
	        return (0, _bluebird.all)([new _users2.default(undefined, { pagination: false }).fetch({ filter: {
	                where: { role: 'mpp_admin' },
	                limit: 9999
	            } }), _coupon2.default.getDiscountCodes()]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                mppAdmins = _ref2[0],
	                discountCodes = _ref2[1];
	
	            _this.view = new CompaniesView({
	                el: _this.mainView.childEl,
	                collection: new _companies2.default(null, options),
	                mppAdmins: mppAdmins,
	                discountCodes: discountCodes
	            });
	        });
	    },
	
	    payrollSubmissions: function payrollSubmissions() {
	        var _this2 = this;
	
	        var stopLoader = loader.startFullPage(this.mainView.childEl);
	
	        var payrolls = new _payrolls2.default(null, { pagination: false });
	
	        payrolls.fetch({
	            filter: {
	                where: {
	                    and: [{
	                        status: {
	                            gte: 3
	                        }
	                    }, {
	                        status: {
	                            lt: 9
	                        }
	                    }]
	                },
	                limit: 9999
	            }
	        }).then(function () {
	            var payrollAttachments = payrolls.map(function (p) {
	                var atmts = new _attachments2.default(null, { attachable: p });
	
	                return atmts.fetch().then(function () {
	                    return [p.id, atmts];
	                });
	            });
	
	            var payrollCompanies = payrolls.map(function (p) {
	                return p.fetchCompany();
	            });
	
	            return (0, _bluebird.all)(payrollAttachments, payrollCompanies);
	        }).then(function (payrollAttachments) {
	            app.payrolls = payrolls;
	
	            _this2.undelegateEvents();
	            _this2.view = new PayrollSubmissionsView({
	                el: _this2.mainView.childEl,
	                collection: payrolls,
	                attachments: _.object(payrollAttachments)
	            });
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	        }).finally(stopLoader);
	    },
	
	    reports: function reports() {
	        this.undelegateEvents();
	        this.view = new ReportsView({
	            el: this.mainView.childEl
	        });
	    },
	
	    personalSettings: function personalSettings() {
	        this.undelegateEvents();
	        this.view = new PersonalSettingsView({
	            el: this.mainView.childEl,
	            model: app.user
	        });
	    },
	
	    users: function users(sortKey, sortOrder, searchStr) {
	        var options = {
	            sortKey: 'username',
	            sortOrder: 'ascending',
	            pagination: { limit: 25 }
	        };
	
	        if (sortKey) {
	            options.sortKey = sortKey;
	        }
	        if (sortOrder) {
	            options.sortOrder = sortOrder;
	        }
	        if (searchStr && searchStr !== '__all') {
	            options.searchString = searchStr;
	        }
	
	        this.undelegateEvents();
	        this.view = new _Main2.default({
	            el: this.mainView.childEl,
	            collection: new _users2.default(null, options)
	        });
	    },
	
	    payrolls: function payrolls(companyId) {
	        var _this3 = this;
	
	        this.undelegateEvents();
	        var stopLoader = loader.startFullPage(this.mainView.childEl);
	        var company = new _company2.default({ objectId: companyId });
	        var attachments = {};
	
	        function getAttachments(payroll) {
	            return new _attachments2.default(null, {
	                attachable: payroll,
	                pagination: false
	            }).fetch({ filter: { limit: 9999 } }).then(function (collection) {
	                return attachments[payroll.id] = collection;
	            });
	        }
	
	        company.fetch().then(function () {
	            return (0, _bluebird.all)([company.fetchPayrolls(), company.fetchSubscription()]);
	        }).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 1),
	                payrolls = _ref4[0];
	
	            return (0, _bluebird.all)(payrolls.map(function (payroll) {
	                return getAttachments(payroll);
	            })).then(function () {
	                return payrolls;
	            });
	        }).then(function (payrolls) {
	            _this3.view = new PayrollsView({
	                el: _this3.mainView.childEl,
	                collection: payrolls,
	                company: company,
	                attachments: attachments
	            }).render();
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    changeLogs: function changeLogs(companyId) {
	        var _this4 = this;
	
	        this.undelegateEvents();
	        var stopLoader = loader.startFullPage(this.mainView.childEl);
	        var company = new _company2.default({ objectId: companyId });
	        var positions = new _positions2.default(null, {
	            company: company,
	            pagination: false
	        });
	        var locations = new _companyLocations2.default(null, {
	            company: company,
	            pagination: false
	        });
	        var leaveTypes = new _leaveTypes2.default(null, {
	            company: company,
	            pagination: false
	        });
	        return company.fetch().then(function () {
	            return (0, _bluebird.all)([positions.fetch({ filter: {
	                    where: { hiddenAt: null },
	                    limit: 9999
	                } }), locations.fetch({ filter: {
	                    where: { hiddenAt: null },
	                    limit: 9999
	                } }), leaveTypes.fetch({ filter: {
	                    limit: 9999
	                } })]);
	        }).then(function () {
	            _this4.view = new ChangeLogsView({
	                el: _this4.mainView.childEl,
	                collection: new _changeLogs2.default(null, {
	                    company: company,
	                    pagination: { limit: 25 },
	                    filter: {}
	                }),
	                company: company,
	                positions: positions,
	                locations: locations,
	                leaveTypes: leaveTypes
	            }).render();
	        }).finally(stopLoader);
	    },
	
	    mppAccounts: function mppAccounts() {
	        var _this5 = this;
	
	        this.undelegateEvents();
	        var stopLoader = loader.startFullPage(this.mainView.childEl);
	        return (0, _bluebird.all)([new _users2.default(null, { pagination: false }).fetch({ filter: { where: { role: 'mpp_admin' } } }), _coupon2.default.getDiscountCodes()]).then(function (_ref5) {
	            var _ref6 = _slicedToArray(_ref5, 2),
	                collection = _ref6[0],
	                discountCodes = _ref6[1];
	
	            _this5.view = new MPPAccountsView({
	                el: _this5.mainView.childEl,
	                collection: collection,
	                discountCodes: discountCodes
	            }).render();
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    employees: function employees(companyId, searchStr) {
	        var _this6 = this;
	
	        this.undelegateEvents();
	        var options = {
	            sortKey: 'fullName',
	            sortOrder: 'ascending',
	            pagination: { limit: 25 },
	            filter: {}
	        };
	        if (searchStr) {
	            options.searchString = searchStr;
	        }
	
	        if (!companyId || companyId === 'all') {
	            this.view = new EmployeesView({
	                el: this.mainView.childEl,
	                collection: new _employees2.default(null, options)
	            });
	            return;
	        }
	
	        options.filter.where = {
	            companyId: companyId,
	            hiddenAt: null
	        };
	
	        var stopLoader = loader.startFullPage(this.mainView.childEl);
	        new _company2.default({ objectId: companyId }).fetch().then(function (company) {
	            _this6.view = new EmployeesView({
	                el: _this6.mainView.childEl,
	                collection: new _employees2.default(null, options),
	                company: company
	            }).render();
	        }).finally(stopLoader);
	    },
	
	    coupons: function coupons() {
	        var _this7 = this;
	
	        this.undelegateEvents();
	        var stopLoader = loader.startFullPage(this.mainView.childEl);
	        new _coupons2.default(null, { pagination: false }).fetch({
	            filter: {
	                limit: 9999
	            }
	        }).then(function (coupons) {
	            _this7.view = new CouponsView({
	                el: _this7.mainView.childEl,
	                collection: coupons
	            }).render();
	        }).finally(stopLoader);
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _Main = __webpack_require__(634);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _InviteLegacy = __webpack_require__(635);
	
	var _InviteLegacy2 = _interopRequireDefault(_InviteLegacy);
	
	var _User = __webpack_require__(636);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _loader3 = __webpack_require__(534);
	
	var _loader4 = _interopRequireDefault(_loader3);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginatedList2.default.extend({
	    events: function events() {
	        return Object.assign({
	            'click .js-invite-legacy-user': 'inviteLegacyUser'
	        }, _PaginatedList2.default.prototype.events.apply(this));
	    },
	
	    views: [],
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {});
	
	        this.views = [];
	
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	
	        return this;
	    },
	
	    inviteLegacyUser: function inviteLegacyUser(ev) {
	        var _this = this;
	
	        var stopLoader = _loader4.default.startFullScreen(ev.currentTarget);
	        var email = this.$('.js-email').val();
	        var name = this.$('.js-name').val();
	
	        _user2.default.inviteLegacyUser(name, email).then(function () {
	            stopLoader();
	            _this.$('#invite-modal').modal('hide');
	            return _alerts2.default.show('success', {
	                title: 'Legacy User Invitation',
	                text: 'Invitation successfully sent!'
	            });
	        }).catch(function (err) {
	            stopLoader();
	            _this.$('#invite-modal').modal('hide');
	            return _alerts2.default.show('error', {
	                title: 'Legacy User Invitation not sent',
	                text: err
	            });
	        });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var sortClass = this.collection.getSort().order === 'ascending' ? 'footable-sorted-desc' : 'footable-sorted';
	
	        this.$el.html((0, _Main2.default)({
	            searchTerm: this.collection.getSearchTerm(),
	            total: this.collection.length,
	            pagination: this.collection.getPaginationInfo(),
	            sort: this.collection.getSort(),
	            inviteModal: (0, _InviteLegacy2.default)()
	        }));
	
	        this.collection.forEach(function (model) {
	            _this2.views.push(new _User2.default({ model: model }));
	            _this2.$('.js-users').append(_(_this2.views).last().$el);
	        });
	
	        this.$('.footable-sortable').removeClass('footable-sorted-desc').removeClass('footable-sorted');
	
	        this.$('[data-sort="' + this.collection.getSort().key + '"]').addClass(sortClass);
	
	        this.stopLoader();
	        return this;
	    },
	
	    // TODO the brainchild of Artem, wouldn't it be nicer to use a qs?
	    navigate: function navigate() {
	        app.mainRouter.navigate('users' + '/' + this.collection.getSort().key + '/' + this.collection.getSort().order + '/' + (this.collection.getSearchTerm() || '__all'), { trigger: true });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/users/Main.ejs -->\n<div class="wrapper wrapper-content users">\n    <div class="row">\n        <div class="col-md-9">\n            <span>Invite Legacy User</span>\n            <a href=""\n               data-toggle="modal"\n               data-target="#invite-modal"\n               title="Invite legacy user">\n                <i class="fa fa-2x fa-plus-circle"></i>\n            </a>\n        </div>\n        <div class="col-md-3">\n            <div class="searchbox">\n                <input type="text" name="search" placeholder="Users search"\n                    class="form-control js-searchbox" value="'+
	((__t=( searchTerm ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-search"></i>\n            </div>\n        </div>\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Users</h5>\n                <div class="ibox-tools">\n                    <h5>&nbsp;Total Users: '+
	((__t=( pagination.count ))==null?'':_.escape(__t))+
	'</h5>\n                </div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable footable-ellipsis table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th class="footable-sortable" data-sort="id">\n                                ID <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="name">\n                                Name <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="username">\n                                Username/Email <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="role">\n                                Role <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="createdAt">\n                                Sign Up Date <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:250px;">\n                                Actions\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-users"></tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n\n'+
	((__t=( inviteModal ))==null?'':__t)+
	'\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/users/InviteLegacy.ejs -->\n<!-- Modal -->\n<div class="modal fade" id="invite-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\n    <div class="modal-dialog" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="myModalLabel">Invite Legacy User</h4>\n            </div>\n            <div class="modal-body">\n                <div class="form-horizontal">\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Name\n                        </label>\n                        <div class="col-sm-9">\n                            <input name="name" class="js-name form-control" type="text"\n                                   placeholder="Name"\n                                   data-value-type="string">\n                            <span class="error-name error"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Email\n                        </label>\n                        <div class="col-sm-9">\n                            <input name="email" class="js-email form-control" type="text"\n                                   placeholder="Enter Email"\n                                   data-value-type="string">\n                            <span class="error-email error"></span>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">\n                    Close\n                </button>\n                <button type="button" class="btn btn-primary js-invite-legacy-user">\n                    Send invitation\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _User = __webpack_require__(637);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        return {
	            'click .js-grant-admin': 'grantAdmin',
	            'click .js-revoke-admin': 'revokeAdmin'
	        };
	    },
	    initialize: function initialize() {
	        this.model.on('sync', this.render, this);
	        return this.render();
	    },
	    render: function render() {
	        this.$el.html((0, _User2.default)({ model: this.model }));
	        return this;
	    },
	    grantAdmin: function grantAdmin() {
	        this.model.setRole('admin_manager');
	    },
	    revokeAdmin: function revokeAdmin() {
	        this.model.setRole('employer');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/users/User.ejs -->\n<td>'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('username') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('role') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('createdAt') ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    ';
	 if (model.get('role') === 'employer') { 
	__p+='\n        <button class="js-grant-admin btn btn-default float-right">\n            Make Admin\n        </button>\n    ';
	 } else if (model.get('role') === 'admin_manager') { 
	__p+='\n        <button class="js-revoke-admin btn btn-default float-right">\n            Revoke Admin Access\n        </button>\n    ';
	 } 
	__p+='\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {'use strict';
	
	var tooltip = __webpack_require__(541);
	var loader = __webpack_require__(534);
	
	module.exports = Backbone.View.extend({
	    events: function events() {
	        return {
	            'click .js-pagination-next': 'loadNextPage',
	            'click .js-pagination-prev': 'loadPrevPage',
	            'click .js-pagination-page': 'loadPage',
	            'click [data-sort]': 'actionSort',
	            'change .js-searchbox': 'search',
	            'keyup .js-searchbox': 'autoSubmitSearch'
	        };
	    },
	
	    render: function render() {
	        tooltip.init(this);
	        return this;
	    },
	
	    loadNextPage: function loadNextPage(ev) {
	        var _this = this;
	
	        var $button = void 0;
	        var stopLoader = void 0;
	        var load = function load() {
	            stopLoader = loader.startFullScreen($button);
	            _this.collection.nextPage({ validate: false }).finally(stopLoader);
	        };
	
	        if (ev) {
	            ev.preventDefault();
	            $button = this.$(ev.currentTarget);
	        }
	
	        if (typeof this.beforePageChange === 'function') {
	            this.beforePageChange().then(load, function () {/* ignore */});
	            return this;
	        }
	        load();
	        return this;
	    },
	
	    loadPrevPage: function loadPrevPage(ev) {
	        var _this2 = this;
	
	        var $button = void 0;
	        var stopLoader = void 0;
	        var load = function load() {
	            stopLoader = loader.startFullScreen($button);
	            _this2.collection.prevPage({ validate: false }).finally(stopLoader);
	        };
	
	        if (ev) {
	            ev.preventDefault();
	            $button = this.$(ev.currentTarget);
	        }
	        if (typeof this.beforePageChange === 'function') {
	            this.beforePageChange().then(load, function () {/* ignore */});
	            return this;
	        }
	        load();
	
	        return this;
	    },
	
	    loadPage: function loadPage(ev) {
	        var _this3 = this;
	
	        var $button = void 0;
	        var stopLoader = void 0;
	        var page = void 0;
	        var load = function load() {
	            stopLoader = loader.startFullScreen($button);
	            _this3.collection.fetchPage(page, { validate: false }).finally(stopLoader);
	        };
	
	        if (!ev) {
	            return;
	        }
	
	        $button = this.$(ev.currentTarget);
	        page = $button.data('page');
	
	        if (typeof this.beforePageChange === 'function') {
	            this.beforePageChange().then(load, function () {/* ignore */});
	            return this;
	        }
	        load();
	
	        return this;
	    },
	
	    actionSort: function actionSort(ev) {
	        var sortKey = $(ev.currentTarget).attr('data-sort');
	        var sortOrder = this.collection.getSort().order === 'ascending' ? 'descending' : 'ascending';
	
	        this.collection.setOptions({ sortKey: sortKey, sortOrder: sortOrder });
	
	        this.navigate();
	        return false;
	    },
	
	    autoSubmitSearch: function autoSubmitSearch(ev) {
	        var _this4 = this;
	
	        var val = (this.$(ev.currentTarget).val() || '').trim();
	
	        if (!_.isUndefined(this.searchboxTimeout)) {
	            clearTimeout(this.searchboxTimeout);
	        }
	
	        if (this.collection.getSearchTerm() && val !== this.collection.getSearchTerm() && val.length >= 3) {
	            this.searchboxTimeout = setTimeout(function () {
	                _this4.$(ev.currentTarget).trigger('change');
	            }, 1500);
	        }
	    },
	
	    search: function search(ev) {
	        var $el = this.$(ev.currentTarget);
	        var value = encodeURIComponent($el.val() || '').trim();
	
	        if (!_.isUndefined(this.searchboxTimeout)) {
	            clearTimeout(this.searchboxTimeout);
	        }
	
	        $el.prop({ 'disabled': true });
	        this.collection.searchString = value;
	        this.navigate();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14), __webpack_require__(27)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Coupon = function (_Model) {
	    _inherits(Coupon, _Model);
	
	    _createClass(Coupon, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Coupons';
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                code: { presence: { message: '^Coupon code is required' } },
	                uses: {
	                    presence: { message: '^Number of uses is required' },
	                    numericality: { message: '^Coupon uses must be a number' }
	                }
	            };
	        }
	    }]);
	
	    function Coupon() {
	        _classCallCheck(this, Coupon);
	
	        var _this = _possibleConstructorReturn(this, (Coupon.__proto__ || Object.getPrototypeOf(Coupon)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(Coupon, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(Coupon.prototype.__proto__ || Object.getPrototypeOf(Coupon.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }], [{
	        key: 'getDiscountCodes',
	        value: function getDiscountCodes() {
	            return (0, _axios2.default)({
	                method: 'get',
	                url: new Coupon().baseUrl() + '/discountCodes',
	                headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (res) {
	                return res.data;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }]);
	
	    return Coupon;
	}(_model2.default);
	
	exports.default = Coupon;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _changeLog = __webpack_require__(641);
	
	var _changeLog2 = _interopRequireDefault(_changeLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChangeLogs = function (_Collection) {
	    _inherits(ChangeLogs, _Collection);
	
	    function ChangeLogs() {
	        _classCallCheck(this, ChangeLogs);
	
	        return _possibleConstructorReturn(this, (ChangeLogs.__proto__ || Object.getPrototypeOf(ChangeLogs)).apply(this, arguments));
	    }
	
	    _createClass(ChangeLogs, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/changeLogs';
	            }
	
	            return '/ChangeLogs';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.model = _changeLog2.default;
	            this.company = company;
	            _get(ChangeLogs.prototype.__proto__ || Object.getPrototypeOf(ChangeLogs.prototype), 'initialize', this).apply(this, arguments);
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'createdAt';
	            }
	            if (!this.options.sortOrder) {
	                this.options.sortOrder = 'descending';
	            }
	            return this;
	        }
	    }]);
	
	    return ChangeLogs;
	}(_collection2.default);
	
	exports.default = ChangeLogs;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.consts = undefined;
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _company = __webpack_require__(568);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var consts = exports.consts = {
	    OPERATION_CREATE: 0,
	    OPERATION_UPDATE: 1,
	    OPERATION_DELETE: 2
	};
	
	var ChangeLog = function (_Model) {
	    _inherits(ChangeLog, _Model);
	
	    function ChangeLog() {
	        _classCallCheck(this, ChangeLog);
	
	        return _possibleConstructorReturn(this, (ChangeLog.__proto__ || Object.getPrototypeOf(ChangeLog)).apply(this, arguments));
	    }
	
	    _createClass(ChangeLog, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/ChangeLogs';
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                companyId: { presence: true },
	                userName: { presence: true },
	                changeTime: { presence: true }
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            _get(ChangeLog.prototype.__proto__ || Object.getPrototypeOf(ChangeLog.prototype), 'initialize', this).apply(this, arguments);
	            this.user = null;
	            this.employee = null;
	            this.payroll = null;
	            return this;
	        }
	    }, {
	        key: 'fetchCompany',
	        value: function fetchCompany() {
	            var company = new _company2.default({ objectId: this.get('companyId') });
	            return company.fetch();
	        }
	    }, {
	        key: 'fetchUser',
	        value: function fetchUser() {
	            var _this2 = this;
	
	            if (this.user) {
	                (0, _bluebird.resolve)(this.user);
	            }
	
	            if (!this.get('userId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _user2.default({ id: this.get('userId') }).fetch().then(function (model) {
	                _this2.user = model;
	                return _this2.user;
	            }).catch(function () {
	                return null;
	            });
	        }
	    }, {
	        key: 'fetchPayroll',
	        value: function fetchPayroll() {
	            var _this3 = this;
	
	            if (this.payroll) {
	                (0, _bluebird.resolve)(this.payroll);
	            }
	
	            if (!this.get('payrollId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _payroll2.default({ objectId: this.get('payrollId') }).fetch().then(function (model) {
	                _this3.payroll = model;
	                return _this3.payroll;
	            }).catch(function () {
	                return null;
	            });
	        }
	    }]);
	
	    return ChangeLog;
	}(_model2.default);
	
	exports.default = ChangeLog;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Users = function (_Collection) {
	    _inherits(Users, _Collection);
	
	    function Users() {
	        _classCallCheck(this, Users);
	
	        return _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).apply(this, arguments));
	    }
	
	    _createClass(Users, [{
	        key: 'url',
	        value: function url() {
	            if (this.user && this.user.get('role') === 'mpp_admin') {
	                return this.user.url() + '/mppManagers';
	            }
	
	            return '/AppUsers';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$user = _ref.user,
	                user = _ref$user === undefined ? null : _ref$user;
	
	            this.model = _user2.default;
	            _get(Users.prototype.__proto__ || Object.getPrototypeOf(Users.prototype), 'initialize', this).apply(this, arguments);
	            this.searchableAttributes = ['name', 'username', 'role'];
	            this.user = user;
	            return this;
	        }
	    }]);
	
	    return Users;
	}(_collection2.default);
	
	exports.default = Users;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _coupon = __webpack_require__(639);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Coupons = function (_Collection) {
	    _inherits(Coupons, _Collection);
	
	    function Coupons() {
	        _classCallCheck(this, Coupons);
	
	        return _possibleConstructorReturn(this, (Coupons.__proto__ || Object.getPrototypeOf(Coupons)).apply(this, arguments));
	    }
	
	    _createClass(Coupons, [{
	        key: 'url',
	        value: function url() {
	            return '/Coupons';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.model = _coupon2.default;
	            _get(Coupons.prototype.__proto__ || Object.getPrototypeOf(Coupons.prototype), 'initialize', this).apply(this, arguments);
	
	            return this;
	        }
	    }]);
	
	    return Coupons;
	}(_collection2.default);
	
	exports.default = Coupons;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(645);
	var navMenuTpl = __webpack_require__(646);
	var tooltip = __webpack_require__(541);
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	    childEl: '#main-area',
	
	    initialize: function initialize() {
	        this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            navMenu: navMenuTpl({ userName: app.user.get('name') }),
	            headerMenu: null,
	            version: app.version,
	            whitelabel: false,
	            logoUrl: ''
	        }));
	
	        $('body').removeClass('gray-bg');
	
	        tooltip.initBody();
	    },
	
	    setActiveLink: function setActiveLink(route) {
	        this.$el.find('#side-menu li').removeClass('active');
	
	        this.$el.find('#side-menu a[href="#' + route + '"]').parent().addClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/Main.ejs -->\n<div id="wrapper">\n    <nav class="navbar-default navbar-static-side" role="navigation">\n        <div class="sidebar-collapse">\n            '+
	((__t=( app.user.isRequirePasswordChange() ? '' : navMenu ))==null?'':__t)+
	'\n        </div>\n    </nav>\n\n    <div id="page-wrapper" class="gray-bg">\n        <div class="row border-bottom">\n            <nav class="navbar navbar-static-top" role="navigation"\n                style="margin-bottom: 0">\n                ';
	 if (whitelabel) { 
	__p+='\n                    <div class="navbar-header logo hidden">\n                        <img src="'+
	((__t=( logoUrl ))==null?'':_.escape(__t))+
	'" width="150">\n                    </div>\n                ';
	 } else { 
	__p+='\n                    <div class="navbar-header logo">\n                        <img src="/images/payrollpanda-logo.png" width="150">\n                    </div>\n                ';
	 } 
	__p+='\n                <div class="navbar-header navbar-short-buttons navbar-right pull-right">\n                    '+
	((__t=( headerMenu ))==null?'':__t)+
	'\n                </div>\n            </nav>\n        </div>\n\n        <div class="js-alerts"></div>\n        <div id="leaves-migrated-notification" class="update-restricted-notification">\n            Leaves have been migrated to Jibble. Log in at <a href="https://web.jibble.io/login" target="_blank">web.jibble.io</a>\n            to access your new Jibble account\n        </div>\n        <div id="update-restricted-notification" class="update-restricted-notification">\n            Company has migrated to new PayrollPanda version. Update operations are restricted.<br>\n            Learn more by reading this <a href="https://www.payrollpanda.my/help/migrate-to-new-payrollpanda-version/" target="_blank">help article</a>.\n        </div>\n        <div id="mpp-ops-restricted-notification" class="update-restricted-notification">\n            Managed companies have been migrated to new PayrollPanda version. MPP operations are restricted.<br>\n            Learn more by reading this <a href="https://www.payrollpanda.my/help/migrate-to-new-payrollpanda-version/" target="_blank">help article</a>.\n        </div>\n        <div id="help-notification" class="update-restricted-notification">\n            Do you have any questions or require assistance?\n            Log in to your new PayrollPanda account at <a href="https://app2.payrollpanda.my/login" target="_blank">https://app2.payrollpanda.my/login</a>\n            or email us at <a href="mailto:support@payrollpanda.my" target="_blank">support@payrollpanda.my</a>\n        </div>\n        <div id="main-area"></div>\n        <div class="footer">\n            <div class="row text-center">\n                ';
	 var year = new Date().getFullYear(); 
	__p+='\n                <div class="col-lg-7">\n                    <div class="row">\n                        <div class="col-lg-9">\n                            Copyright &copy; '+
	((__t=( year ))==null?'':_.escape(__t))+
	' Payroll Panda Sdn Bhd. All Rights Reserved.\n                            <span class="app-version">('+
	((__t=( version ))==null?'':_.escape(__t))+
	')</span>\n                        </div>\n                        <div class="col-lg-3">\n                            <img src="/images/lhdn.gif" height="25"\n                                title="LHDN Certificate">\n                        </div>\n                    </div>\n                </div>\n                <div class="col-lg-5">\n                    <div class="row">\n                        <div class="col-lg-6">\n                            <span class="footer-phone">\n                                <strong>Phone</strong> +603 2787 9168\n                            </span>\n                        </div>\n                        <div class="col-lg-6">\n                            <span>\n                                <strong>Email</strong> admin@payrollpanda.my\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/NavMenu.ejs -->\n<ul class="nav metismenu" id="side-menu">\n    <li class="nav-header">\n        <div class="dropdown profile-element">\n            <a data-toggle="dropdown" class="dropdown-toggle" href="#">\n                <span class="clear">\n                    <span class="block m-t-xs">\n                        <strong class="font-bold">[Admin]</strong>\n                    </span>\n                    <span class="text-muted text-xs block">\n                        '+
	((__t=( userName ))==null?'':_.escape(__t))+
	'\n                        <b class="caret"></b>\n                    </span>\n                </span>\n            </a>\n            <ul class="dropdown-menu animated fadeInRight m-t-xs">\n                <li><a href="#personalSettings">Personal Settings</a></li>\n                <li><a href="#logout">Logout</a></li>\n            </ul>\n        </div>\n        <div class="logo-element">\n            IN+\n        </div>\n    </li>\n    <li id="li-lnk-companies-view" class="active">\n        <a id="lnk-companies-view" href="#companies">\n            <i class="fa fa-building"></i>\n            <span class="nav-label">Companies</span>\n        </a>\n    </li>\n    <li id="li-lnk-companies-view" class="active">\n        <a id="lnk-companies-view" href="#employees/all">\n            <i class="fa fa-building"></i>\n            <span class="nav-label">Employees</span>\n        </a>\n    </li>\n    <li id="li-lnk-run-payroll-view">\n        <a id="lnk-run-payroll-view" href="#payrollSubmissions">\n            <i class="fa fa-pencil-square-o"></i>\n            <span class="nav-label">Payroll Submissions</span>\n        </a>\n    </li>\n    <li>\n        <a href="#reports"><i class="fa fa-copy"></i>\n            <span class="nav-label">Reports</span></a>\n    </li>\n    <li>\n        <a href="#users"><i class="fa fa-users"></i>\n            <span class="nav-label">Users</span></a>\n    </li>\n    <li>\n        <a href="#mppAccounts"><i class="fa fa-users"></i>\n            <span class="nav-label">MPP Users</span></a>\n    </li>\n    <li>\n        <a href="#coupons"><i class="fa fa-ticket"></i>\n            <span class="nav-label">Coupons</span></a>\n    </li>\n    <li>\n        <a href="#settings"><i class="fa fa-cog"></i>\n            <span class="nav-label">Settings</span></a>\n    </li>\n</ul>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(648);
	var SubmissionView = __webpack_require__(649);
	
	module.exports = Backbone.View.extend({
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            attachments: null
	        });
	
	        return this.render();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        this.$el.html(template({ total: this.collection.length }));
	
	        this.collection.each(function (payroll) {
	            var submissionView = new SubmissionView({
	                model: payroll,
	                attachments: _this.options.attachments[payroll.id]
	            });
	
	            _this.$('#submissions').append(submissionView.el);
	        });
	
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/payrollSubmissions/Main.html -->\n<div class="wrapper wrapper-content payroll-submission">\n\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Payroll submissions</h5>\n                <div class="ibox-tools"><h5>Total Submissions: '+
	((__t=( total ))==null?'':_.escape(__t))+
	'</h5></div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable footable-ellipsis table table-stripped footable-payroll-submissions" data-striping="false">\n                    <thead>\n                    <tr>\n                        <th style="width: 25%">Company Name</th>\n                        <th style="width: 25%">Payroll State</th>\n                        <th style="width: 50%">Action</th>\n                    </tr>\n                    </thead>\n                    <tbody id="submissions"></tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $, Parse) {'use strict';
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Submission = __webpack_require__(653);
	
	var _Submission2 = _interopRequireDefault(_Submission);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	
	    events: {
	        'click .js-confirm-pickup': 'confirmPickup',
	        'click .js-received-payment': 'receivedPayment',
	        'click .js-generate-forms': 'generateForms',
	        'click .js-awaiting-signatures': 'awaitingSignatures',
	        'click .js-awaiting-submission': 'awaitingSubmission',
	        'click .js-submitted-to-govt': 'submittedToGovernment',
	        'click .js-notify-company': 'notifyCompany',
	        'change .js-upload-file': 'uploadFiles',
	        'click .js-cancel': 'cancel',
	        'click .js-revert': 'revert'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            attachments: null
	        });
	
	        this.model.on('sync', this.render, this);
	
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html((0, _Submission2.default)({
	            model: this.model,
	            statusText: this.getStatusText(this.model.get('status') || 0)
	        }));
	
	        this.$pickDate = this.$('.pickup-date');
	        this.$pickDate.datepicker({
	            weekStart: 1,
	            autoclose: true,
	            todayHighlight: true
	        }).datepicker('setDate', this.model.get('chequePickupDate'));
	
	        this.renderAttachments();
	
	        return this;
	    },
	
	    renderAttachments: function renderAttachments() {
	        this.$('.js-attachments').html('');
	
	        if (!_.contains([5, 8], this.model.get('status'))) {
	            return;
	        }
	
	        this.options.attachments.findByTags(this.model.get('status') === 5 ? ['payroll', 'form'] : ['payroll', 'upload']).each(this.renderAttachment.bind(this));
	
	        return this;
	    },
	
	    renderAttachment: function renderAttachment(attachment) {
	        var $attachments = this.$('.js-attachments');
	
	        var $link = $('<a>').attr({
	            href: attachment.downloadUrl(),
	            target: '_blank'
	        }).text(attachment.get('name'));
	        var $delete = $('<i class="fa fa-times"></i>');
	
	        var $attachment = $('<div class="item">').append($delete).append($link).append(' (' + (attachment.get('description') || 'unknown') + ')');
	
	        $delete.on('click', function () {
	            this.promptDeleteFile(attachment, $attachment);
	        }.bind(this));
	
	        $attachments.append($attachment);
	    },
	
	    getStatusText: function getStatusText(status) {
	        switch (status) {
	            case 3:
	                return 'Submitted. Awaiting pick up date confirmation';
	            case 4:
	                return 'Pickup date confirmed';
	            case 5:
	                return 'Payments received';
	            case 6:
	                return 'Forms awaiting signatures';
	            case 7:
	                return 'Forms awaiting submission';
	            case 8:
	                return 'Forms submitted to government';
	            case 9:
	                return 'Employer notified';
	            default:
	                return 'Unknown status';
	        }
	    },
	
	    saveStatus: function saveStatus($button, status, chequePickupDate) {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        this.model.setStatus(status, chequePickupDate).then(function (payroll) {
	            _this.model = payroll.model;
	            _this.render();
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(stopLoader);
	    },
	
	    confirmPickup: function confirmPickup(ev) {
	        var chequePickupDate = this.$pickDate.datepicker('getDate');
	        this.saveStatus(this.$(ev.currentTarget), 4, chequePickupDate);
	    },
	
	    receivedPayment: function receivedPayment(ev) {
	        this.saveStatus(this.$(ev.currentTarget), 5);
	    },
	
	    awaitingSignatures: function awaitingSignatures(ev) {
	        this.saveStatus(this.$(ev.currentTarget), 6);
	    },
	
	    awaitingSubmission: function awaitingSubmission(ev) {
	        this.saveStatus(this.$(ev.currentTarget), 7);
	    },
	
	    submittedToGovernment: function submittedToGovernment(ev) {
	        this.saveStatus(this.$(ev.currentTarget), 8);
	    },
	
	    notifyCompany: function notifyCompany(ev) {
	        this.saveStatus(this.$(ev.currentTarget), 9);
	    },
	
	    uploadFiles: function uploadFiles(ev) {
	        var $button = this.$('.js-upload-files').find('.dropdown-toggle');
	        var description = this.$(ev.currentTarget).data('description');
	        var tags = this.$(ev.currentTarget).data('tags').split(' ');
	        var files = this.$(ev.currentTarget)[0].files;
	        var stopLoader = _loader2.default.startFullScreen($button);
	        var promises;
	
	        if (files.length === 0) {
	            stopLoader();
	            return false;
	        }
	
	        tags.push('payroll', 'upload', 'payroll-archive');
	
	        promises = _.map(files, function (file) {
	            var originalName = file.name;
	            var ext = file.name.split('.').pop();
	            return new Parse.File('file.' + ext, file).save().then(function (file) {
	                return Parse.Cloud.run('createAttachment', {
	                    file: file,
	                    name: originalName,
	                    tags: tags,
	                    description: description,
	
	                    attachmentStore: this.model.get('attachmentStore').id
	                });
	            }.bind(this));
	        }.bind(this));
	
	        Parse.Promise.when(promises).then(function (attachments) {
	            this.options.attachments.add(attachments);
	            this.renderAttachments();
	        }.bind(this), function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).always(stopLoader);
	    },
	
	    promptDeleteFile: function promptDeleteFile(attachment, $el) {
	        var _this2 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to delete file?',
	            confirmButtonText: 'Yes, Delete',
	
	            callback: function callback(isConfirm) {
	                if (isConfirm) {
	                    _this2.deleteFile(attachment, $el);
	                }
	            }
	        });
	    },
	
	    deleteFile: function deleteFile(attachment, $el) {
	        var _this3 = this;
	
	        var stopLoader = _loader2.default.startFullScreen();
	
	        $el.addClass('disabled');
	
	        attachment.destroy().then(function () {
	            _this3.options.attachments.remove(attachment.id);
	            $el.remove();
	        }).catch(function (err) {
	            $el.removeClass('disabled');
	            _alerts2.default.show('criticalError', err);
	        }).finally(stopLoader);
	    },
	
	    generateForms: function generateForms(ev) {
	        var _this4 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        this.model.generateForms().then(function () {
	            var attachments = new _attachments2.default(null, { attachable: _this4.model });
	            attachments.fetch().then(function () {
	                _this4.options.attachments.add(attachments.models);
	                _this4.render();
	            });
	        }).finally(stopLoader);
	    },
	
	    cancel: function cancel() {
	        var _this5 = this;
	
	        var warnTextByStatus = {
	            5: 'You have already recevied payment for this payroll. ',
	            6: 'Government forms have already been signed. ',
	            7: 'Forms have already been submitted to the government. ',
	            8: 'Forms have been processed. '
	        };
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to cancel this payroll?',
	            text: (warnTextByStatus[this.model.get('status')] || '') + 'You will lose any generated or uploaded forms and receipts',
	            confirmButtonText: 'Yes, Cancel',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this5.model.destroy().then(function () {
	                    return _this5.remove();
	                }, function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    revert: function revert() {
	        var _this6 = this;
	
	        var lastPayrollReady = _payroll2.default.fetchCurrent(this.model.get('company'));
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to revert this payroll?',
	            text: 'You will lose all generated and uploaded files, ' + 'including any emailed payslips and signed forms.',
	            confirmButtonText: 'Yes, Revert'
	        }).then(function () {
	            return lastPayrollReady.then(function (payroll) {
	                if (!payroll) {
	                    return;
	                }
	                if (payroll.samePeriodAs(_this6.model)) {
	                    return _alerts2.default.show('dangerConfirm', {
	                        title: 'Already saved payroll found',
	                        text: 'The user already has a saved payroll for the ' + 'current month. What do you wish to do with this ' + 'payroll?',
	                        confirmButtonText: 'Revert and discard',
	                        cancelButtonText: 'Revert and keep'
	                    }).then(function () {
	                        // Discard
	                        return 'discard';
	                    }, function () {
	                        // Keep
	                        return 'keep';
	                    });
	                }
	            }).then(function (action) {
	                _this6.model.revert({
	                    savedPayrollAction: action
	                }).then(function () {
	                    return _this6.remove();
	                }).catch(function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14), __webpack_require__(650)))

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Pace = __webpack_require__(651);
	var ParseLatest = __webpack_require__(652);
	
	// load pace before parse since it modifies xmlhttprequest
	Pace.start({
	    document: true,
	    ajax: {
	        trackMethods: ['GET', 'POST']
	    }
	});
	
	module.exports = ParseLatest.Parse;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
	  var AjaxMonitor, Bar, DocumentMonitor, ElementMonitor, ElementTracker, EventLagMonitor, Evented, Events, NoTargetError, Pace, RequestIntercept, SOURCE_KEYS, Scaler, SocketRequestTracker, XHRRequestTracker, animation, avgAmplitude, bar, cancelAnimation, cancelAnimationFrame, defaultOptions, extend, extendNative, getFromDOM, getIntercept, handlePushState, ignoreStack, init, now, options, requestAnimationFrame, result, runAnimation, scalers, shouldIgnoreURL, shouldTrack, source, sources, uniScaler, _WebSocket, _XDomainRequest, _XMLHttpRequest, _i, _intercept, _len, _pushState, _ref, _ref1, _replaceState,
	    __slice = [].slice,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  defaultOptions = {
	    catchupTime: 100,
	    initialRate: .03,
	    minTime: 250,
	    ghostTime: 100,
	    maxProgressPerFrame: 20,
	    easeFactor: 1.25,
	    startOnPageLoad: true,
	    restartOnPushState: true,
	    restartOnRequestAfter: 500,
	    target: 'body',
	    elements: {
	      checkInterval: 100,
	      selectors: ['body']
	    },
	    eventLag: {
	      minSamples: 10,
	      sampleCount: 3,
	      lagThreshold: 3
	    },
	    ajax: {
	      trackMethods: ['GET'],
	      trackWebSockets: true,
	      ignoreURLs: []
	    }
	  };
	
	  now = function() {
	    var _ref;
	    return (_ref = typeof performance !== "undefined" && performance !== null ? typeof performance.now === "function" ? performance.now() : void 0 : void 0) != null ? _ref : +(new Date);
	  };
	
	  requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
	
	  cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
	
	  if (requestAnimationFrame == null) {
	    requestAnimationFrame = function(fn) {
	      return setTimeout(fn, 50);
	    };
	    cancelAnimationFrame = function(id) {
	      return clearTimeout(id);
	    };
	  }
	
	  runAnimation = function(fn) {
	    var last, tick;
	    last = now();
	    tick = function() {
	      var diff;
	      diff = now() - last;
	      if (diff >= 33) {
	        last = now();
	        return fn(diff, function() {
	          return requestAnimationFrame(tick);
	        });
	      } else {
	        return setTimeout(tick, 33 - diff);
	      }
	    };
	    return tick();
	  };
	
	  result = function() {
	    var args, key, obj;
	    obj = arguments[0], key = arguments[1], args = 3 <= arguments.length ? __slice.call(arguments, 2) : [];
	    if (typeof obj[key] === 'function') {
	      return obj[key].apply(obj, args);
	    } else {
	      return obj[key];
	    }
	  };
	
	  extend = function() {
	    var key, out, source, sources, val, _i, _len;
	    out = arguments[0], sources = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    for (_i = 0, _len = sources.length; _i < _len; _i++) {
	      source = sources[_i];
	      if (source) {
	        for (key in source) {
	          if (!__hasProp.call(source, key)) continue;
	          val = source[key];
	          if ((out[key] != null) && typeof out[key] === 'object' && (val != null) && typeof val === 'object') {
	            extend(out[key], val);
	          } else {
	            out[key] = val;
	          }
	        }
	      }
	    }
	    return out;
	  };
	
	  avgAmplitude = function(arr) {
	    var count, sum, v, _i, _len;
	    sum = count = 0;
	    for (_i = 0, _len = arr.length; _i < _len; _i++) {
	      v = arr[_i];
	      sum += Math.abs(v);
	      count++;
	    }
	    return sum / count;
	  };
	
	  getFromDOM = function(key, json) {
	    var data, e, el;
	    if (key == null) {
	      key = 'options';
	    }
	    if (json == null) {
	      json = true;
	    }
	    el = document.querySelector("[data-pace-" + key + "]");
	    if (!el) {
	      return;
	    }
	    data = el.getAttribute("data-pace-" + key);
	    if (!json) {
	      return data;
	    }
	    try {
	      return JSON.parse(data);
	    } catch (_error) {
	      e = _error;
	      return typeof console !== "undefined" && console !== null ? console.error("Error parsing inline pace options", e) : void 0;
	    }
	  };
	
	  Evented = (function() {
	    function Evented() {}
	
	    Evented.prototype.on = function(event, handler, ctx, once) {
	      var _base;
	      if (once == null) {
	        once = false;
	      }
	      if (this.bindings == null) {
	        this.bindings = {};
	      }
	      if ((_base = this.bindings)[event] == null) {
	        _base[event] = [];
	      }
	      return this.bindings[event].push({
	        handler: handler,
	        ctx: ctx,
	        once: once
	      });
	    };
	
	    Evented.prototype.once = function(event, handler, ctx) {
	      return this.on(event, handler, ctx, true);
	    };
	
	    Evented.prototype.off = function(event, handler) {
	      var i, _ref, _results;
	      if (((_ref = this.bindings) != null ? _ref[event] : void 0) == null) {
	        return;
	      }
	      if (handler == null) {
	        return delete this.bindings[event];
	      } else {
	        i = 0;
	        _results = [];
	        while (i < this.bindings[event].length) {
	          if (this.bindings[event][i].handler === handler) {
	            _results.push(this.bindings[event].splice(i, 1));
	          } else {
	            _results.push(i++);
	          }
	        }
	        return _results;
	      }
	    };
	
	    Evented.prototype.trigger = function() {
	      var args, ctx, event, handler, i, once, _ref, _ref1, _results;
	      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      if ((_ref = this.bindings) != null ? _ref[event] : void 0) {
	        i = 0;
	        _results = [];
	        while (i < this.bindings[event].length) {
	          _ref1 = this.bindings[event][i], handler = _ref1.handler, ctx = _ref1.ctx, once = _ref1.once;
	          handler.apply(ctx != null ? ctx : this, args);
	          if (once) {
	            _results.push(this.bindings[event].splice(i, 1));
	          } else {
	            _results.push(i++);
	          }
	        }
	        return _results;
	      }
	    };
	
	    return Evented;
	
	  })();
	
	  Pace = window.Pace || {};
	
	  window.Pace = Pace;
	
	  extend(Pace, Evented.prototype);
	
	  options = Pace.options = extend({}, defaultOptions, window.paceOptions, getFromDOM());
	
	  _ref = ['ajax', 'document', 'eventLag', 'elements'];
	  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	    source = _ref[_i];
	    if (options[source] === true) {
	      options[source] = defaultOptions[source];
	    }
	  }
	
	  NoTargetError = (function(_super) {
	    __extends(NoTargetError, _super);
	
	    function NoTargetError() {
	      _ref1 = NoTargetError.__super__.constructor.apply(this, arguments);
	      return _ref1;
	    }
	
	    return NoTargetError;
	
	  })(Error);
	
	  Bar = (function() {
	    function Bar() {
	      this.progress = 0;
	    }
	
	    Bar.prototype.getElement = function() {
	      var targetElement;
	      if (this.el == null) {
	        targetElement = document.querySelector(options.target);
	        if (!targetElement) {
	          throw new NoTargetError;
	        }
	        this.el = document.createElement('div');
	        this.el.className = "pace pace-active";
	        document.body.className = document.body.className.replace(/pace-done/g, '');
	        document.body.className += ' pace-running';
	        this.el.innerHTML = '<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>';
	        if (targetElement.firstChild != null) {
	          targetElement.insertBefore(this.el, targetElement.firstChild);
	        } else {
	          targetElement.appendChild(this.el);
	        }
	      }
	      return this.el;
	    };
	
	    Bar.prototype.finish = function() {
	      var el;
	      el = this.getElement();
	      el.className = el.className.replace('pace-active', '');
	      el.className += ' pace-inactive';
	      document.body.className = document.body.className.replace('pace-running', '');
	      return document.body.className += ' pace-done';
	    };
	
	    Bar.prototype.update = function(prog) {
	      this.progress = prog;
	      return this.render();
	    };
	
	    Bar.prototype.destroy = function() {
	      try {
	        this.getElement().parentNode.removeChild(this.getElement());
	      } catch (_error) {
	        NoTargetError = _error;
	      }
	      return this.el = void 0;
	    };
	
	    Bar.prototype.render = function() {
	      var el, key, progressStr, transform, _j, _len1, _ref2;
	      if (document.querySelector(options.target) == null) {
	        return false;
	      }
	      el = this.getElement();
	      transform = "translate3d(" + this.progress + "%, 0, 0)";
	      _ref2 = ['webkitTransform', 'msTransform', 'transform'];
	      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	        key = _ref2[_j];
	        el.children[0].style[key] = transform;
	      }
	      if (!this.lastRenderedProgress || this.lastRenderedProgress | 0 !== this.progress | 0) {
	        el.children[0].setAttribute('data-progress-text', "" + (this.progress | 0) + "%");
	        if (this.progress >= 100) {
	          progressStr = '99';
	        } else {
	          progressStr = this.progress < 10 ? "0" : "";
	          progressStr += this.progress | 0;
	        }
	        el.children[0].setAttribute('data-progress', "" + progressStr);
	      }
	      return this.lastRenderedProgress = this.progress;
	    };
	
	    Bar.prototype.done = function() {
	      return this.progress >= 100;
	    };
	
	    return Bar;
	
	  })();
	
	  Events = (function() {
	    function Events() {
	      this.bindings = {};
	    }
	
	    Events.prototype.trigger = function(name, val) {
	      var binding, _j, _len1, _ref2, _results;
	      if (this.bindings[name] != null) {
	        _ref2 = this.bindings[name];
	        _results = [];
	        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	          binding = _ref2[_j];
	          _results.push(binding.call(this, val));
	        }
	        return _results;
	      }
	    };
	
	    Events.prototype.on = function(name, fn) {
	      var _base;
	      if ((_base = this.bindings)[name] == null) {
	        _base[name] = [];
	      }
	      return this.bindings[name].push(fn);
	    };
	
	    return Events;
	
	  })();
	
	  _XMLHttpRequest = window.XMLHttpRequest;
	
	  _XDomainRequest = window.XDomainRequest;
	
	  _WebSocket = window.WebSocket;
	
	  extendNative = function(to, from) {
	    var e, key, _results;
	    _results = [];
	    for (key in from.prototype) {
	      try {
	        if ((to[key] == null) && typeof from[key] !== 'function') {
	          if (typeof Object.defineProperty === 'function') {
	            _results.push(Object.defineProperty(to, key, {
	              get: function() {
	                return from.prototype[key];
	              },
	              configurable: true,
	              enumerable: true
	            }));
	          } else {
	            _results.push(to[key] = from.prototype[key]);
	          }
	        } else {
	          _results.push(void 0);
	        }
	      } catch (_error) {
	        e = _error;
	      }
	    }
	    return _results;
	  };
	
	  ignoreStack = [];
	
	  Pace.ignore = function() {
	    var args, fn, ret;
	    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    ignoreStack.unshift('ignore');
	    ret = fn.apply(null, args);
	    ignoreStack.shift();
	    return ret;
	  };
	
	  Pace.track = function() {
	    var args, fn, ret;
	    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    ignoreStack.unshift('track');
	    ret = fn.apply(null, args);
	    ignoreStack.shift();
	    return ret;
	  };
	
	  shouldTrack = function(method) {
	    var _ref2;
	    if (method == null) {
	      method = 'GET';
	    }
	    if (ignoreStack[0] === 'track') {
	      return 'force';
	    }
	    if (!ignoreStack.length && options.ajax) {
	      if (method === 'socket' && options.ajax.trackWebSockets) {
	        return true;
	      } else if (_ref2 = method.toUpperCase(), __indexOf.call(options.ajax.trackMethods, _ref2) >= 0) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  RequestIntercept = (function(_super) {
	    __extends(RequestIntercept, _super);
	
	    function RequestIntercept() {
	      var monitorXHR,
	        _this = this;
	      RequestIntercept.__super__.constructor.apply(this, arguments);
	      monitorXHR = function(req) {
	        var _open;
	        _open = req.open;
	        return req.open = function(type, url, async) {
	          if (shouldTrack(type)) {
	            _this.trigger('request', {
	              type: type,
	              url: url,
	              request: req
	            });
	          }
	          return _open.apply(req, arguments);
	        };
	      };
	      window.XMLHttpRequest = function(flags) {
	        var req;
	        req = new _XMLHttpRequest(flags);
	        monitorXHR(req);
	        return req;
	      };
	      try {
	        extendNative(window.XMLHttpRequest, _XMLHttpRequest);
	      } catch (_error) {}
	      if (_XDomainRequest != null) {
	        window.XDomainRequest = function() {
	          var req;
	          req = new _XDomainRequest;
	          monitorXHR(req);
	          return req;
	        };
	        try {
	          extendNative(window.XDomainRequest, _XDomainRequest);
	        } catch (_error) {}
	      }
	      if ((_WebSocket != null) && options.ajax.trackWebSockets) {
	        window.WebSocket = function(url, protocols) {
	          var req;
	          if (protocols != null) {
	            req = new _WebSocket(url, protocols);
	          } else {
	            req = new _WebSocket(url);
	          }
	          if (shouldTrack('socket')) {
	            _this.trigger('request', {
	              type: 'socket',
	              url: url,
	              protocols: protocols,
	              request: req
	            });
	          }
	          return req;
	        };
	        try {
	          extendNative(window.WebSocket, _WebSocket);
	        } catch (_error) {}
	      }
	    }
	
	    return RequestIntercept;
	
	  })(Events);
	
	  _intercept = null;
	
	  getIntercept = function() {
	    if (_intercept == null) {
	      _intercept = new RequestIntercept;
	    }
	    return _intercept;
	  };
	
	  shouldIgnoreURL = function(url) {
	    var pattern, _j, _len1, _ref2;
	    _ref2 = options.ajax.ignoreURLs;
	    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	      pattern = _ref2[_j];
	      if (typeof pattern === 'string') {
	        if (url.indexOf(pattern) !== -1) {
	          return true;
	        }
	      } else {
	        if (pattern.test(url)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  getIntercept().on('request', function(_arg) {
	    var after, args, request, type, url;
	    type = _arg.type, request = _arg.request, url = _arg.url;
	    if (shouldIgnoreURL(url)) {
	      return;
	    }
	    if (!Pace.running && (options.restartOnRequestAfter !== false || shouldTrack(type) === 'force')) {
	      args = arguments;
	      after = options.restartOnRequestAfter || 0;
	      if (typeof after === 'boolean') {
	        after = 0;
	      }
	      return setTimeout(function() {
	        var stillActive, _j, _len1, _ref2, _ref3, _results;
	        if (type === 'socket') {
	          stillActive = request.readyState < 2;
	        } else {
	          stillActive = (0 < (_ref2 = request.readyState) && _ref2 < 4);
	        }
	        if (stillActive) {
	          Pace.restart();
	          _ref3 = Pace.sources;
	          _results = [];
	          for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
	            source = _ref3[_j];
	            if (source instanceof AjaxMonitor) {
	              source.watch.apply(source, args);
	              break;
	            } else {
	              _results.push(void 0);
	            }
	          }
	          return _results;
	        }
	      }, after);
	    }
	  });
	
	  AjaxMonitor = (function() {
	    function AjaxMonitor() {
	      var _this = this;
	      this.elements = [];
	      getIntercept().on('request', function() {
	        return _this.watch.apply(_this, arguments);
	      });
	    }
	
	    AjaxMonitor.prototype.watch = function(_arg) {
	      var request, tracker, type, url;
	      type = _arg.type, request = _arg.request, url = _arg.url;
	      if (shouldIgnoreURL(url)) {
	        return;
	      }
	      if (type === 'socket') {
	        tracker = new SocketRequestTracker(request);
	      } else {
	        tracker = new XHRRequestTracker(request);
	      }
	      return this.elements.push(tracker);
	    };
	
	    return AjaxMonitor;
	
	  })();
	
	  XHRRequestTracker = (function() {
	    function XHRRequestTracker(request) {
	      var event, size, _j, _len1, _onreadystatechange, _ref2,
	        _this = this;
	      this.progress = 0;
	      if (window.ProgressEvent != null) {
	        size = null;
	        request.addEventListener('progress', function(evt) {
	          if (evt.lengthComputable) {
	            return _this.progress = 100 * evt.loaded / evt.total;
	          } else {
	            return _this.progress = _this.progress + (100 - _this.progress) / 2;
	          }
	        }, false);
	        _ref2 = ['load', 'abort', 'timeout', 'error'];
	        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	          event = _ref2[_j];
	          request.addEventListener(event, function() {
	            return _this.progress = 100;
	          }, false);
	        }
	      } else {
	        _onreadystatechange = request.onreadystatechange;
	        request.onreadystatechange = function() {
	          var _ref3;
	          if ((_ref3 = request.readyState) === 0 || _ref3 === 4) {
	            _this.progress = 100;
	          } else if (request.readyState === 3) {
	            _this.progress = 50;
	          }
	          return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
	        };
	      }
	    }
	
	    return XHRRequestTracker;
	
	  })();
	
	  SocketRequestTracker = (function() {
	    function SocketRequestTracker(request) {
	      var event, _j, _len1, _ref2,
	        _this = this;
	      this.progress = 0;
	      _ref2 = ['error', 'open'];
	      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	        event = _ref2[_j];
	        request.addEventListener(event, function() {
	          return _this.progress = 100;
	        }, false);
	      }
	    }
	
	    return SocketRequestTracker;
	
	  })();
	
	  ElementMonitor = (function() {
	    function ElementMonitor(options) {
	      var selector, _j, _len1, _ref2;
	      if (options == null) {
	        options = {};
	      }
	      this.elements = [];
	      if (options.selectors == null) {
	        options.selectors = [];
	      }
	      _ref2 = options.selectors;
	      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	        selector = _ref2[_j];
	        this.elements.push(new ElementTracker(selector));
	      }
	    }
	
	    return ElementMonitor;
	
	  })();
	
	  ElementTracker = (function() {
	    function ElementTracker(selector) {
	      this.selector = selector;
	      this.progress = 0;
	      this.check();
	    }
	
	    ElementTracker.prototype.check = function() {
	      var _this = this;
	      if (document.querySelector(this.selector)) {
	        return this.done();
	      } else {
	        return setTimeout((function() {
	          return _this.check();
	        }), options.elements.checkInterval);
	      }
	    };
	
	    ElementTracker.prototype.done = function() {
	      return this.progress = 100;
	    };
	
	    return ElementTracker;
	
	  })();
	
	  DocumentMonitor = (function() {
	    DocumentMonitor.prototype.states = {
	      loading: 0,
	      interactive: 50,
	      complete: 100
	    };
	
	    function DocumentMonitor() {
	      var _onreadystatechange, _ref2,
	        _this = this;
	      this.progress = (_ref2 = this.states[document.readyState]) != null ? _ref2 : 100;
	      _onreadystatechange = document.onreadystatechange;
	      document.onreadystatechange = function() {
	        if (_this.states[document.readyState] != null) {
	          _this.progress = _this.states[document.readyState];
	        }
	        return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
	      };
	    }
	
	    return DocumentMonitor;
	
	  })();
	
	  EventLagMonitor = (function() {
	    function EventLagMonitor() {
	      var avg, interval, last, points, samples,
	        _this = this;
	      this.progress = 0;
	      avg = 0;
	      samples = [];
	      points = 0;
	      last = now();
	      interval = setInterval(function() {
	        var diff;
	        diff = now() - last - 50;
	        last = now();
	        samples.push(diff);
	        if (samples.length > options.eventLag.sampleCount) {
	          samples.shift();
	        }
	        avg = avgAmplitude(samples);
	        if (++points >= options.eventLag.minSamples && avg < options.eventLag.lagThreshold) {
	          _this.progress = 100;
	          return clearInterval(interval);
	        } else {
	          return _this.progress = 100 * (3 / (avg + 3));
	        }
	      }, 50);
	    }
	
	    return EventLagMonitor;
	
	  })();
	
	  Scaler = (function() {
	    function Scaler(source) {
	      this.source = source;
	      this.last = this.sinceLastUpdate = 0;
	      this.rate = options.initialRate;
	      this.catchup = 0;
	      this.progress = this.lastProgress = 0;
	      if (this.source != null) {
	        this.progress = result(this.source, 'progress');
	      }
	    }
	
	    Scaler.prototype.tick = function(frameTime, val) {
	      var scaling;
	      if (val == null) {
	        val = result(this.source, 'progress');
	      }
	      if (val >= 100) {
	        this.done = true;
	      }
	      if (val === this.last) {
	        this.sinceLastUpdate += frameTime;
	      } else {
	        if (this.sinceLastUpdate) {
	          this.rate = (val - this.last) / this.sinceLastUpdate;
	        }
	        this.catchup = (val - this.progress) / options.catchupTime;
	        this.sinceLastUpdate = 0;
	        this.last = val;
	      }
	      if (val > this.progress) {
	        this.progress += this.catchup * frameTime;
	      }
	      scaling = 1 - Math.pow(this.progress / 100, options.easeFactor);
	      this.progress += scaling * this.rate * frameTime;
	      this.progress = Math.min(this.lastProgress + options.maxProgressPerFrame, this.progress);
	      this.progress = Math.max(0, this.progress);
	      this.progress = Math.min(100, this.progress);
	      this.lastProgress = this.progress;
	      return this.progress;
	    };
	
	    return Scaler;
	
	  })();
	
	  sources = null;
	
	  scalers = null;
	
	  bar = null;
	
	  uniScaler = null;
	
	  animation = null;
	
	  cancelAnimation = null;
	
	  Pace.running = false;
	
	  handlePushState = function() {
	    if (options.restartOnPushState) {
	      return Pace.restart();
	    }
	  };
	
	  if (window.history.pushState != null) {
	    _pushState = window.history.pushState;
	    window.history.pushState = function() {
	      handlePushState();
	      return _pushState.apply(window.history, arguments);
	    };
	  }
	
	  if (window.history.replaceState != null) {
	    _replaceState = window.history.replaceState;
	    window.history.replaceState = function() {
	      handlePushState();
	      return _replaceState.apply(window.history, arguments);
	    };
	  }
	
	  SOURCE_KEYS = {
	    ajax: AjaxMonitor,
	    elements: ElementMonitor,
	    document: DocumentMonitor,
	    eventLag: EventLagMonitor
	  };
	
	  (init = function() {
	    var type, _j, _k, _len1, _len2, _ref2, _ref3, _ref4;
	    Pace.sources = sources = [];
	    _ref2 = ['ajax', 'elements', 'document', 'eventLag'];
	    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	      type = _ref2[_j];
	      if (options[type] !== false) {
	        sources.push(new SOURCE_KEYS[type](options[type]));
	      }
	    }
	    _ref4 = (_ref3 = options.extraSources) != null ? _ref3 : [];
	    for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
	      source = _ref4[_k];
	      sources.push(new source(options));
	    }
	    Pace.bar = bar = new Bar;
	    scalers = [];
	    return uniScaler = new Scaler;
	  })();
	
	  Pace.stop = function() {
	    Pace.trigger('stop');
	    Pace.running = false;
	    bar.destroy();
	    cancelAnimation = true;
	    if (animation != null) {
	      if (typeof cancelAnimationFrame === "function") {
	        cancelAnimationFrame(animation);
	      }
	      animation = null;
	    }
	    return init();
	  };
	
	  Pace.restart = function() {
	    Pace.trigger('restart');
	    Pace.stop();
	    return Pace.start();
	  };
	
	  Pace.go = function() {
	    var start;
	    Pace.running = true;
	    bar.render();
	    start = now();
	    cancelAnimation = false;
	    return animation = runAnimation(function(frameTime, enqueueNextFrame) {
	      var avg, count, done, element, elements, i, j, remaining, scaler, scalerList, sum, _j, _k, _len1, _len2, _ref2;
	      remaining = 100 - bar.progress;
	      count = sum = 0;
	      done = true;
	      for (i = _j = 0, _len1 = sources.length; _j < _len1; i = ++_j) {
	        source = sources[i];
	        scalerList = scalers[i] != null ? scalers[i] : scalers[i] = [];
	        elements = (_ref2 = source.elements) != null ? _ref2 : [source];
	        for (j = _k = 0, _len2 = elements.length; _k < _len2; j = ++_k) {
	          element = elements[j];
	          scaler = scalerList[j] != null ? scalerList[j] : scalerList[j] = new Scaler(element);
	          done &= scaler.done;
	          if (scaler.done) {
	            continue;
	          }
	          count++;
	          sum += scaler.tick(frameTime);
	        }
	      }
	      avg = sum / count;
	      bar.update(uniScaler.tick(frameTime, avg));
	      if (bar.done() || done || cancelAnimation) {
	        bar.update(100);
	        Pace.trigger('done');
	        return setTimeout(function() {
	          bar.finish();
	          Pace.running = false;
	          return Pace.trigger('hide');
	        }, Math.max(options.ghostTime, Math.max(options.minTime - (now() - start), 0)));
	      } else {
	        return enqueueNextFrame();
	      }
	    });
	  };
	
	  Pace.start = function(_options) {
	    extend(options, _options);
	    Pace.running = true;
	    try {
	      bar.render();
	    } catch (_error) {
	      NoTargetError = _error;
	    }
	    if (!document.querySelector('.pace')) {
	      return setTimeout(Pace.start, 50);
	    } else {
	      Pace.trigger('start');
	      return Pace.go();
	    }
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(651)], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return Pace;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = Pace;
	  } else {
	    if (options.startOnPageLoad) {
	      Pace.start();
	    }
	  }
	
	}).call(this);


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(_, $, process) {/*!
	 * Parse JavaScript SDK
	 * Version: 1.5.0
	 * Built: Fri Jul 10 2015 17:05:46
	 * http://parse.com
	 *
	 * Copyright 2015 Parse, LLC
	 *
	 * Includes: Underscore.js
	 * Copyright 2009-2012 Jeremy Ashkenas, DocumentCloud Inc.
	 * Released under the MIT license.
	 */
	(function(root) {
	  root.Parse = root.Parse || {};
	  root.Parse.VERSION = "js1.5.0";
	}(this));
	//     Underscore.js 1.4.4
	//     http://underscorejs.org
	//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push             = ArrayProto.push,
	      slice            = ArrayProto.slice,
	      concat           = ArrayProto.concat,
	      toString         = ObjProto.toString,
	      hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.4.4';
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, l = obj.length; i < l; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      for (var key in obj) {
	        if (_.has(obj, key)) {
	          if (iterator.call(context, obj[key], key, obj) === breaker) return;
	        }
	      }
	    }
	  };
	
	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results[results.length] = iterator.call(context, value, index, list);
	    });
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, iterator, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
	    each(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) results[results.length] = value;
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, iterator, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !iterator.call(context, value, index, list);
	    }, context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, function(value){ return value[key]; });
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs, first) {
	    if (_.isEmpty(attrs)) return first ? null : [];
	    return _[first ? 'find' : 'filter'](obj, function(value) {
	      for (var key in attrs) {
	        if (attrs[key] !== value[key]) return false;
	      }
	      return true;
	    });
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.where(obj, attrs, true);
	  };
	
	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See: https://bugs.webkit.org/show_bug.cgi?id=80797
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return -Infinity;
	    var result = {computed : -Infinity, value: -Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed >= result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return Infinity;
	    var result = {computed : Infinity, value: Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed < result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Shuffle an array.
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };
	
	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	  };
	
	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, value, context) {
	    var iterator = lookupIterator(value);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value : value,
	        index : index,
	        criteria : iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index < right.index ? -1 : 1;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(obj, value, context, behavior) {
	    var result = {};
	    var iterator = lookupIterator(value || _.identity);
	    each(obj, function(value, index) {
	      var key = iterator.call(context, value, index, obj);
	      behavior(result, key, value);
	    });
	    return result;
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key, value) {
	      (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
	    });
	  };
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key) {
	      if (!_.has(result, key)) result[key] = 0;
	      result[key]++;
	    });
	  };
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };
	
	  // Safely convert anything iterable into a real, live array.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    return (n != null) && !guard ? slice.call(array, 0, n) : array[0];
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n != null) && !guard) {
	      return slice.call(array, Math.max(array.length - n, 0));
	    } else {
	      return array[array.length - 1];
	    }
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    each(input, function(value) {
	      if (_.isArray(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };
	
	  // Return a completely flattened version of an array.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(concat.apply(ArrayProto, arguments));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.indexOf(other, item) >= 0;
	      });
	    });
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var args = slice.call(arguments);
	    var length = _.max(_.pluck(args, 'length'));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(args, "" + i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, l = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, l + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < l; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;
	
	    var len = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(len);
	
	    while(idx < len) {
	      range[idx++] = start;
	      start += step;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (func.bind === nativeBind && nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    var args = slice.call(arguments, 2);
	    return function() {
	      return func.apply(context, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context.
	  _.partial = function(func) {
	    var args = slice.call(arguments, 1);
	    return function() {
	      return func.apply(this, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Bind all of an object's methods to that object. Useful for ensuring that
	  // all callbacks defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) funcs = _.functions(obj);
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time.
	  _.throttle = function(func, wait) {
	    var context, args, timeout, result;
	    var previous = 0;
	    var later = function() {
	      previous = new Date;
	      timeout = null;
	      result = func.apply(context, args);
	    };
	    return function() {
	      var now = new Date;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, result;
	    return function() {
	      var context = this, args = arguments;
	      var later = function() {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	      };
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) result = func.apply(context, args);
	      return result;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return function() {
	      var args = [func];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    if (times <= 0) return func();
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = nativeKeys || function(obj) {
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys[keys.length] = key;
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var values = [];
	    for (var key in obj) if (_.has(obj, key)) values.push(obj[key]);
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var pairs = [];
	    for (var key in obj) if (_.has(obj, key)) pairs.push([key, obj[key]]);
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    for (var key in obj) if (_.has(obj, key)) result[obj[key]] = key;
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] == null) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the Harmony `egal` proposal: http://wiki.ecmascript.org/doku.php?id=harmony:egal.
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Objects with different constructors are not equivalent, but `Object`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                               _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
	        return false;
	      }
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }
	
	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(n);
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;',
	      '/': '&#x2F;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);
	
	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });
	
	  // If the value of the named property is a function then invoke it;
	  // otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return null;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name){
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";
	
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  _.extend(_.prototype, {
	
	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },
	
	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }
	
	  });
	
	}).call(this);
	
	/*global _: false, $: false, localStorage: false, process: true,
	  XMLHttpRequest: false, XDomainRequest: false, exports: false,
	  require: false, setTimeout: true */
	(function(root) {
	  root.Parse = root.Parse || {};
	  /**
	   * Contains all Parse API classes and functions.
	   * @name Parse
	   * @namespace
	   *
	   * Contains all Parse API classes and functions.
	   */
	  var Parse = root.Parse;
	
	  var req = typeof(require) === 'function' ? require : null;
	  // Load references to other dependencies
	  if (typeof(XMLHttpRequest) !== 'undefined') {
	    Parse.XMLHttpRequest = XMLHttpRequest;
	  } else if (false) {
	    Parse.XMLHttpRequest = req('xmlhttprequest').XMLHttpRequest;
	  }
	  // Import Parse's local copy of underscore.
	  if (typeof(exports) !== 'undefined' && exports._) {
	    // We're running in a CommonJS environment
	    Parse._ = exports._.noConflict();
	    exports.Parse = Parse;
	  } else {
	    Parse._ = _.noConflict();
	  }
	
	  // If jQuery or Zepto has been included, grab a reference to it.
	  if (typeof($) !== "undefined") {
	    Parse.$ = $;
	  }
	
	  // Helpers
	  // -------
	
	  // Shared empty constructor function to aid in prototype-chain creation.
	  var EmptyConstructor = function() {};
	
	  // TODO: fix this so that ParseObjects aren't all called "child" in debugger.
	  // Helper function to correctly set up the prototype chain, for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var inherits = function(parent, protoProps, staticProps) {
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent's constructor.
	    if (protoProps && protoProps.hasOwnProperty('constructor')) {
	      child = protoProps.constructor;
	    } else {
	      /** @ignore */
	      child = function(){ parent.apply(this, arguments); };
	    }
	
	    // Inherit class (static) properties from parent.
	    Parse._.extend(child, parent);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function.
	    EmptyConstructor.prototype = parent.prototype;
	    child.prototype = new EmptyConstructor();
	
	    // Add prototype properties (instance properties) to the subclass,
	    // if supplied.
	    if (protoProps) {
	      Parse._.extend(child.prototype, protoProps);
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    if (staticProps) {
	      Parse._.extend(child, staticProps);
	    }
	
	    // Correctly set child's `prototype.constructor`.
	    child.prototype.constructor = child;
	
	    // Set a convenience property in case the parent's prototype is
	    // needed later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set the server for Parse to talk to.
	  Parse.serverURL = "https://api.parse.com";
	
	  // Check whether we are running in Node.js.
	  if (typeof(process) !== "undefined" &&
	      process.versions &&
	      process.versions.node) {
	    Parse._isNode = true;
	  }
	
	  /**
	   * Call this method first to set up your authentication tokens for Parse.
	   * You can get your keys from the Data Browser on parse.com.
	   * @param {String} applicationId Your Parse Application ID.
	   * @param {String} javaScriptKey Your Parse JavaScript Key.
	   * @param {String} masterKey (optional) Your Parse Master Key. (Node.js only!)
	   */
	  Parse.initialize = function(applicationId, javaScriptKey, masterKey) {
	    if (masterKey) {
	      throw "Parse.initialize() was passed a Master Key, which is only " +
	        "allowed from within Node.js.";
	    }
	    Parse._initialize(applicationId, javaScriptKey);
	  };
	
	  /**
	   * Call this method first to set up master authentication tokens for Parse.
	   * This method is for Parse's own private use.
	   * @param {String} applicationId Your Parse Application ID.
	   * @param {String} javaScriptKey Your Parse JavaScript Key.
	   * @param {String} masterKey Your Parse Master Key.
	   */
	  Parse._initialize = function(applicationId, javaScriptKey, masterKey) {
	    Parse.applicationId = applicationId;
	    Parse.javaScriptKey = javaScriptKey;
	    Parse.masterKey = masterKey;
	    Parse._useMasterKey = false;
	  };
	
	  // If we're running in node.js, allow using the master key.
	  if (Parse._isNode) {
	    Parse.initialize = Parse._initialize;
	
	    Parse.Cloud = Parse.Cloud || {};
	    /**
	     * Switches the Parse SDK to using the Master key.  The Master key grants
	     * priveleged access to the data in Parse and can be used to bypass ACLs and
	     * other restrictions that are applied to the client SDKs.
	     * <p><strong><em>Available in Cloud Code and Node.js only.</em></strong>
	     * </p>
	     */
	    Parse.Cloud.useMasterKey = function() {
	      Parse._useMasterKey = true;
	    };
	  }
	
	  /**
	   * Returns prefix for Storage keys used by this instance of Parse.
	   * @param {String} path The relative suffix to append to it.
	   *     null or undefined is treated as the empty string.
	   * @return {String} The full key name.
	   */
	  Parse._getParsePath = function(path) {
	    if (!Parse.applicationId) {
	      throw "You need to call Parse.initialize before using Parse.";
	    }
	    if (!path) {
	      path = "";
	    }
	    if (!Parse._.isString(path)) {
	      throw "Tried to get a Storage path that wasn't a String.";
	    }
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    return "Parse/" + Parse.applicationId + "/" + path;
	  };
	
	  /**
	   * Returns a Promise that is resolved with the unique string for this app on
	   * this machine.
	   * Gets reset when Storage is cleared.
	   */
	  Parse._installationId = null;
	  Parse._getInstallationId = function() {
	    // See if it's cached in RAM.
	    if (Parse._installationId) {
	      return Parse.Promise.as(Parse._installationId);
	    }
	
	    // Try to get it from Storage.
	    var path = Parse._getParsePath("installationId");
	    return (Parse.Storage.getItemAsync(path)
	      .then(function(value) {
	        Parse._installationId = value;
	
	        if (!Parse._installationId || Parse._installationId === "") {
	          // It wasn't in Storage, so create a new one.
	          var hexOctet = function() {
	            return (
	              Math.floor((1+Math.random())*0x10000).toString(16).substring(1)
	            );
	          };
	          Parse._installationId = (
	            hexOctet() + hexOctet() + "-" +
	            hexOctet() + "-" +
	            hexOctet() + "-" +
	            hexOctet() + "-" +
	            hexOctet() + hexOctet() + hexOctet());
	          return Parse.Storage.setItemAsync(path, Parse._installationId);
	        }
	
	        return Parse.Promise.as(Parse._installationId);
	      })
	    );
	  };
	
	  Parse._parseDate = function(iso8601) {
	    var regexp = new RegExp(
	      "^([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})" + "T" +
	      "([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})" +
	      "(.([0-9]+))?" + "Z$");
	    var match = regexp.exec(iso8601);
	    if (!match) {
	      return null;
	    }
	
	    var year = match[1] || 0;
	    var month = (match[2] || 1) - 1;
	    var day = match[3] || 0;
	    var hour = match[4] || 0;
	    var minute = match[5] || 0;
	    var second = match[6] || 0;
	    var milli = match[8] || 0;
	
	    return new Date(Date.UTC(year, month, day, hour, minute, second, milli));
	  };
	
	  Parse._ajaxIE8 = function(method, url, data) {
	    var promise = new Parse.Promise();
	    var xdr = new XDomainRequest();
	    xdr.onload = function() {
	      var response;
	      try {
	        response = JSON.parse(xdr.responseText);
	      } catch (e) {
	        promise.reject(e);
	      }
	      if (response) {
	        promise.resolve(response);
	      }
	    };
	    xdr.onerror = xdr.ontimeout = function() {
	      // Let's fake a real error message.
	      var fakeResponse = {
	        responseText: JSON.stringify({
	          code: Parse.Error.X_DOMAIN_REQUEST,
	          error: "IE's XDomainRequest does not supply error info."
	        })
	      };
	      promise.reject(fakeResponse);
	    };
	    xdr.onprogress = function() {};
	    xdr.open(method, url);
	    xdr.send(data);
	    return promise;
	  };
	
	  Parse._useXDomainRequest = function() {
	    if (typeof(XDomainRequest) !== "undefined") {
	      // We're in IE 8+.
	      if ('withCredentials' in new XMLHttpRequest()) {
	        // We're in IE 10+.
	        return false;
	      }
	      return true;
	    }
	    return false;
	  };
	
	  // TODO(klimt): Get rid of success/error usage in website.
	  Parse._ajax = function(method, url, data, success, error) {
	    var options = {
	      success: success,
	      error: error
	    };
	
	    if (Parse._useXDomainRequest()) {
	      return Parse._ajaxIE8(method, url, data)._thenRunCallbacks(options);
	    }
	
	    var promise = new Parse.Promise();
	    var attempts = 0;
	
	    var dispatch = function() {
	      var handled = false;
	      var xhr = new Parse.XMLHttpRequest();
	
	      xhr.onreadystatechange = function() {
	        if (xhr.readyState === 4) {
	          if (handled) {
	            return;
	          }
	          handled = true;
	
	          if (xhr.status >= 200 && xhr.status < 300) {
	            var response;
	            try {
	              response = JSON.parse(xhr.responseText);
	            } catch (e) {
	              promise.reject(e);
	            }
	            if (response) {
	              promise.resolve(response, xhr.status, xhr);
	            }
	          } else if (xhr.status >= 500) { // Retry on 5XX
	            if (++attempts < 5) {
	              // Exponentially-growing delay
	              var delay = Math.round(
	                Math.random() * 125 * Math.pow(2, attempts)
	              );
	              setTimeout(dispatch, delay);
	            } else {
	              // After 5 retries, fail
	              promise.reject(xhr);
	            }
	          } else {
	            promise.reject(xhr);
	          }
	        }
	      };
	
	      xhr.open(method, url, true);
	      xhr.setRequestHeader('Content-Type', 'text/plain');  // avoid pre-flight.
	      if (Parse._isNode) {
	        // Add a special user agent just for request from node.js.
	        xhr.setRequestHeader("User-Agent",
	                             "Parse/" + Parse.VERSION +
	                             " (NodeJS " + process.versions.node + ")");
	      }
	      xhr.send(data);
	    };
	
	    dispatch();
	    return promise._thenRunCallbacks(options); 
	  };
	
	  // A self-propagating extend function.
	  Parse._extend = function(protoProps, classProps) {
	    var child = inherits(this, protoProps, classProps);
	    child.extend = this.extend;
	    return child;
	  };
	
	  /**
	   * Options:
	   *   route: is classes, users, login, etc.
	   *   objectId: null if there is no associated objectId.
	   *   method: the http method for the REST API.
	   *   dataObject: the payload as an object, or null if there is none.
	   *   useMasterKey: overrides whether to use the master key if set.
	   * @ignore
	   */
	  Parse._request = function(options) {
	    var route = options.route;
	    var className = options.className;
	    var objectId = options.objectId;
	    var method = options.method;
	    var useMasterKey = options.useMasterKey;
	    var sessionToken = options.sessionToken;
	    var dataObject = options.data;
	
	    if (!Parse.applicationId) {
	      throw "You must specify your applicationId using Parse.initialize.";
	    }
	
	    if (!Parse.javaScriptKey && !Parse.masterKey) {
	      throw "You must specify a key using Parse.initialize.";
	    }
	
	    // TODO: We can remove this check later, but it's useful for development.
	    if (route !== "batch" &&
	        route !== "classes" &&
	        route !== "events" &&
	        route !== "files" &&
	        route !== "functions" &&
	        route !== "login" &&
	        route !== "logout" &&
	        route !== "push" &&
	        route !== "requestPasswordReset" &&
	        route !== "rest_verify_analytics" &&
	        route !== "users" &&
	        route !== "jobs" &&
	        route !== "config" &&
	        route !== "sessions" &&
	        route !== "upgradeToRevocableSession") {
	      throw "Bad route: '" + route + "'.";
	    }
	
	    var url = Parse.serverURL;
	    if (url.charAt(url.length - 1) !== "/") {
	      url += "/";
	    }
	    url += "1/" + route;
	    if (className) {
	      url += "/" + className;
	    }
	    if (objectId) {
	      url += "/" + objectId;
	    }
	
	    dataObject = Parse._.clone(dataObject || {});
	    if (method !== "POST") {
	      dataObject._method = method;
	      method = "POST";
	    }
	
	    if (Parse._.isUndefined(useMasterKey)) {
	      useMasterKey = Parse._useMasterKey;
	    }
	
	    dataObject._ApplicationId = Parse.applicationId;
	    if (!useMasterKey) {
	      dataObject._JavaScriptKey = Parse.javaScriptKey;
	    } else if (!Parse.masterKey) {
	      throw new Error('Cannot use the Master Key, it has not been provided.');
	    } else {
	      dataObject._MasterKey = Parse.masterKey;
	    }
	
	    dataObject._ClientVersion = Parse.VERSION;
	
	    return Parse._getInstallationId().then(function(iid) {
	      dataObject._InstallationId = iid;
	
	      if (sessionToken) {
	        return Parse.Promise.as({ _sessionToken: sessionToken });
	      }
	      if (!Parse.User._canUseCurrentUser()) {
	        return Parse.Promise.as(null);
	      }
	
	      return Parse.User._currentAsync();
	    }).then(function(currentUser) {
	      if (currentUser && currentUser._sessionToken) {
	        dataObject._SessionToken = currentUser._sessionToken;
	      }
	
	      if (Parse.User._isRevocableSessionEnabled) {
	        dataObject._RevocableSession = '1';
	      }
	
	      var data = JSON.stringify(dataObject);
	
	      return Parse._ajax(method, url, data);
	    }).then(null, function(response) {
	      // Transform the error into an instance of Parse.Error by trying to parse
	      // the error string as JSON.
	      var error;
	      if (response && response.responseText) {
	        try {
	          var errorJSON = JSON.parse(response.responseText);
	          error = new Parse.Error(errorJSON.code, errorJSON.error);
	        } catch (e) {
	          // If we fail to parse the error text, that's okay.
	          error = new Parse.Error(
	              Parse.Error.INVALID_JSON,
	              "Received an error with invalid JSON from Parse: " +
	                  response.responseText);
	        }
	      } else {
	        error = new Parse.Error(
	            Parse.Error.CONNECTION_FAILED,
	            "XMLHttpRequest failed: " + JSON.stringify(response));
	      }
	      // By explicitly returning a rejected Promise, this will work with
	      // either jQuery or Promises/A semantics.
	      return Parse.Promise.error(error);
	    });
	  };
	
	  // Helper function to get a value from a Backbone object as a property
	  // or as a function.
	  Parse._getValue = function(object, prop) {
	    if (!(object && object[prop])) {
	      return null;
	    }
	    return Parse._.isFunction(object[prop]) ? object[prop]() : object[prop];
	  };
	
	  /**
	   * Converts a value in a Parse Object into the appropriate representation.
	   * This is the JS equivalent of Java's Parse.maybeReferenceAndEncode(Object)
	   * if seenObjects is falsey. Otherwise any Parse.Objects not in
	   * seenObjects will be fully embedded rather than encoded
	   * as a pointer.  This array will be used to prevent going into an infinite
	   * loop because we have circular references.  If seenObjects
	   * is set, then none of the Parse Objects that are serialized can be dirty.
	   */
	  Parse._encode = function(value, seenObjects, disallowObjects) {
	    var _ = Parse._;
	    if (value instanceof Parse.Object) {
	      if (disallowObjects) {
	        throw "Parse.Objects not allowed here";
	      }
	      if (!seenObjects || _.include(seenObjects, value) || !value._hasData) {
	        return value._toPointer();
	      }
	      if (!value.dirty()) {
	        seenObjects = seenObjects.concat(value);
	        return Parse._encode(value._toFullJSON(seenObjects),
	                             seenObjects,
	                             disallowObjects);
	      }
	      throw "Tried to save an object with a pointer to a new, unsaved object.";
	    }
	    if (value instanceof Parse.ACL) {
	      return value.toJSON();
	    }
	    if (_.isDate(value)) {
	      if (isNaN(value)) {
	        throw new Error('Cannot encode invalid Date');
	      }
	      return { "__type": "Date", "iso": value.toJSON() };
	    }
	    if (value instanceof Parse.GeoPoint) {
	      return value.toJSON();
	    }
	    if (_.isArray(value)) {
	      return _.map(value, function(x) {
	        return Parse._encode(x, seenObjects, disallowObjects);
	      });
	    }
	    if (_.isRegExp(value)) {
	      return value.source;
	    }
	    if (value instanceof Parse.Relation) {
	      return value.toJSON();
	    }
	    if (value instanceof Parse.Op) {
	      return value.toJSON();
	    }
	    if (value instanceof Parse.File) {
	      if (!value.url()) {
	        throw "Tried to save an object containing an unsaved file.";
	      }
	      return {
	        __type: "File",
	        name: value.name(),
	        url: value.url()
	      };
	    }
	    if (_.isObject(value)) {
	      var output = {};
	      Parse._objectEach(value, function(v, k) {
	        output[k] = Parse._encode(v, seenObjects, disallowObjects);
	      });
	      return output;
	    }
	    return value;
	  };
	
	  /**
	   * The inverse function of Parse._encode.
	   * TODO: make decode not mutate value.
	   */
	  Parse._decode = function(key, value) {
	    var _ = Parse._;
	    if (!_.isObject(value)) {
	      return value;
	    }
	    if (_.isArray(value)) {
	      Parse._arrayEach(value, function(v, k) {
	        value[k] = Parse._decode(k, v);
	      });
	      return value;
	    }
	    if (value instanceof Parse.Object) {
	      return value;
	    }
	    if (value instanceof Parse.File) {
	      return value;
	    }
	    if (value instanceof Parse.Op) {
	      return value;
	    }
	    if (value.__op) {
	      return Parse.Op._decode(value);
	    }
	    if (value.__type === "Pointer" && value.className) {
	      var pointer = Parse.Object._create(value.className);
	      pointer._finishFetch({ objectId: value.objectId }, false);
	      return pointer;
	    }
	    if (value.__type === "Object" && value.className) {
	      // It's an Object included in a query result.
	      var className = value.className;
	      delete value.__type;
	      delete value.className;
	      var object = Parse.Object._create(className);
	      object._finishFetch(value, true);
	      return object;
	    }
	    if (value.__type === "Date") {
	      return Parse._parseDate(value.iso);
	    }
	    if (value.__type === "GeoPoint") {
	      return new Parse.GeoPoint({
	        latitude: value.latitude,
	        longitude: value.longitude
	      });
	    }
	    if (key === "ACL") {
	      if (value instanceof Parse.ACL) {
	        return value;
	      }
	      return new Parse.ACL(value);
	    }
	    if (value.__type === "Relation") {
	      var relation = new Parse.Relation(null, key);
	      relation.targetClassName = value.className;
	      return relation;
	    }
	    if (value.__type === "File") {
	      var file = new Parse.File(value.name);
	      file._url = value.url;
	      return file;
	    }
	    Parse._objectEach(value, function(v, k) {
	      value[k] = Parse._decode(k, v);
	    });
	    return value;
	  };
	
	  Parse._arrayEach = Parse._.each;
	
	  /**
	   * Does a deep traversal of every item in object, calling func on every one.
	   * @param {Object} object The object or array to traverse deeply.
	   * @param {Function} func The function to call for every item. It will
	   *     be passed the item as an argument. If it returns a truthy value, that
	   *     value will replace the item in its parent container.
	   * @returns {} the result of calling func on the top-level object itself.
	   */
	  Parse._traverse = function(object, func, seen) {
	    if (object instanceof Parse.Object) {
	      seen = seen || [];
	      if (Parse._.indexOf(seen, object) >= 0) {
	        // We've already visited this object in this call.
	        return;
	      }
	      seen.push(object);
	      Parse._traverse(object.attributes, func, seen);
	      return func(object);
	    }
	    if (object instanceof Parse.Relation || object instanceof Parse.File) {
	      // Nothing needs to be done, but we don't want to recurse into the
	      // object's parent infinitely, so we catch this case.
	      return func(object);
	    }
	    if (Parse._.isArray(object)) {
	      Parse._.each(object, function(child, index) {
	        var newChild = Parse._traverse(child, func, seen);
	        if (newChild) {
	          object[index] = newChild;
	        }
	      });
	      return func(object);
	    }
	    if (Parse._.isObject(object)) {
	      Parse._each(object, function(child, key) {
	        var newChild = Parse._traverse(child, func, seen);
	        if (newChild) {
	          object[key] = newChild;
	        }
	      });
	      return func(object);
	    }
	    return func(object);
	  };
	
	  /**
	   * This is like _.each, except:
	   * * it doesn't work for so-called array-like objects,
	   * * it does work for dictionaries with a "length" attribute.
	   */
	  Parse._objectEach = Parse._each = function(obj, callback) {
	    var _ = Parse._;
	    if (_.isObject(obj)) {
	      _.each(_.keys(obj), function(key) {
	        callback(obj[key], key);
	      });
	    } else {
	      _.each(obj, callback);
	    }
	  };
	
	  // Helper function to check null or undefined.
	  Parse._isNullOrUndefined = function(x) {
	    return Parse._.isNull(x) || Parse._.isUndefined(x);
	  };
	}(this));
	
	/* global require: false, localStorage: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  
	  var Storage = {
	    async: false,
	  };
	
	  var hasLocalStorage = (typeof localStorage !== 'undefined');
	  if (hasLocalStorage) {
	    try {
	      localStorage.setItem('supported', true);
	      localStorage.removeItem('supported');
	    } catch(e) {
	      hasLocalStorage = false;
	    }
	  }
	  if (hasLocalStorage) {
	    Storage.getItem = function(path) {
	      return localStorage.getItem(path);
	    };
	
	    Storage.setItem = function(path, value) {
	      return localStorage.setItem(path, value);
	    };
	
	    Storage.removeItem = function(path) {
	      return localStorage.removeItem(path);
	    };
	
	    Storage.clear = function() {
	      return localStorage.clear();
	    };
	  } else if (true) {
	    var AsyncStorage;
	    try {
	      AsyncStorage = eval("require('AsyncStorage')"); // jshint ignore:line
	
	      Storage.async = true;
	
	      Storage.getItemAsync = function(path) {
	        var p = new Parse.Promise();
	        AsyncStorage.getItem(path, function(err, value) {
	          if (err) {
	            p.reject(err);
	          } else {
	            p.resolve(value);
	          }
	        });
	        return p;
	      };
	
	      Storage.setItemAsync = function(path, value) {
	        var p = new Parse.Promise();
	        AsyncStorage.setItem(path, value, function(err) {
	          if (err) {
	            p.reject(err);
	          } else {
	            p.resolve(value);
	          }
	        });
	        return p;
	      };
	
	      Storage.removeItemAsync = function(path) {
	        var p = new Parse.Promise();
	        AsyncStorage.removeItem(path, function(err) {
	          if (err) {
	            p.reject(err);
	          } else {
	            p.resolve();
	          }
	        });
	        return p;
	      };
	
	      Storage.clear = function() {
	        AsyncStorage.clear();
	      };
	    } catch (e) { }
	  }
	  if (!Storage.async && !Storage.getItem) {
	    var memMap = Storage.inMemoryMap = {};
	    Storage.getItem = function(path) {
	      if (memMap.hasOwnProperty(path)) {
	        return memMap[path];
	      }
	      return null;
	    };
	
	    Storage.setItem = function(path, value) {
	      memMap[path] = String(value);
	    };
	
	    Storage.removeItem = function(path) {
	      delete memMap[path];
	    };
	
	    Storage.clear = function() {
	      for (var key in memMap) {
	        if (memMap.hasOwnProperty(key)) {
	          delete memMap[key];
	        }
	      }
	    };
	  }
	
	  // We can use synchronous methods from async scenarios, but not vice-versa
	  if (!Storage.async) {
	    Storage.getItemAsync = function(path) {
	      return Parse.Promise.as(
	        Storage.getItem(path)
	      );
	    };
	
	    Storage.setItemAsync = function(path, value) {
	      Storage.setItem(path, value);
	      return Parse.Promise.as(value);
	    };
	
	    Storage.removeItemAsync = function(path) {
	      return Parse.Promise.as(
	        Storage.removeItem(path)
	      );
	    };
	  }
	
	  Parse.Storage = Storage;
	
	})(this);
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * @namespace Provides an interface to Parse's logging and analytics backend.
	   */
	  Parse.Analytics = Parse.Analytics || {};
	
	  _.extend(Parse.Analytics, /** @lends Parse.Analytics */ {
	    /**
	     * Tracks the occurrence of a custom event with additional dimensions.
	     * Parse will store a data point at the time of invocation with the given
	     * event name.
	     *
	     * Dimensions will allow segmentation of the occurrences of this custom
	     * event. Keys and values should be {@code String}s, and will throw
	     * otherwise.
	     *
	     * To track a user signup along with additional metadata, consider the
	     * following:
	     * <pre>
	     * var dimensions = {
	     *  gender: 'm',
	     *  source: 'web',
	     *  dayType: 'weekend'
	     * };
	     * Parse.Analytics.track('signup', dimensions);
	     * </pre>
	     *
	     * There is a default limit of 8 dimensions per event tracked.
	     *
	     * @param {String} name The name of the custom event to report to Parse as
	     * having happened.
	     * @param {Object} dimensions The dictionary of information by which to
	     * segment this event.
	     * @param {Object} options A Backbone-style callback object.
	     * @return {Parse.Promise} A promise that is resolved when the round-trip
	     * to the server completes.
	     */
	    track: function(name, dimensions, options) {
	      name = name || '';
	      name = name.replace(/^\s*/, '');
	      name = name.replace(/\s*$/, '');
	      if (name.length === 0) {
	        throw 'A name for the custom event must be provided';
	      }
	
	      _.each(dimensions, function(val, key) {
	        if (!_.isString(key) || !_.isString(val)) {
	          throw 'track() dimensions expects keys and values of type "string".';
	        }
	      });
	
	      options = options || {};
	      return Parse._request({
	        route: 'events',
	        className: name,
	        method: 'POST',
	        data: { dimensions: dimensions }
	      })._thenRunCallbacks(options);
	    }
	  });
	}(this));
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * @class Parse.Config is a local representation of configuration data that
	   * can be set from the Parse dashboard.
	   */
	  Parse.Config = function() {
	    this.attributes = {};
	    this._escapedAttributes = {};
	  };
	
	  /**
	   * Retrieves the most recently-fetched configuration object, either from
	   * memory or from local storage if necessary.
	   *
	   * @return {Parse.Config} The most recently-fetched Parse.Config if it
	   *     exists, else an empty Parse.Config.
	   */
	  Parse.Config.current = function() {
	    if (Parse.Config._currentConfig) {
	      return Parse.Config._currentConfig;
	    }
	
	    var config = new Parse.Config();
	
	    if (Parse.Storage.async) {
	      return config;
	    }
	
	    var configData = Parse.Storage.getItem(Parse._getParsePath(
	          Parse.Config._CURRENT_CONFIG_KEY));
	
	    if (configData) {  
	      config._finishFetch(JSON.parse(configData));
	      Parse.Config._currentConfig = config;
	    }
	    return config;
	  };
	
	  /**
	   * Gets a new configuration object from the server.
	   * @param {Object} options A Backbone-style options object.
	   * Valid options are:<ul>
	   *   <li>success: Function to call when the get completes successfully.
	   *   <li>error: Function to call when the get fails.
	   * </ul>
	   * @return {Parse.Promise} A promise that is resolved with a newly-created
	   *     configuration object when the get completes.
	   */
	  Parse.Config.get = function(options) {
	    options = options || {};
	
	    var request = Parse._request({
	      route: "config",
	      method: "GET",
	    });
	
	    return request.then(function(response) {
	      if (!response || !response.params) {
	        var errorObject = new Parse.Error(
	          Parse.Error.INVALID_JSON,
	          "Config JSON response invalid.");
	        return Parse.Promise.error(errorObject);
	      }
	
	      var config = new Parse.Config();
	      config._finishFetch(response);
	      Parse.Config._currentConfig = config;
	      return config;
	    })._thenRunCallbacks(options);
	  };
	
	  Parse.Config.prototype = {
	
	    /**
	     * Gets the HTML-escaped value of an attribute.
	     */
	    escape: function(attr) {
	      var html = this._escapedAttributes[attr];
	      if (html) {
	        return html;
	      }
	      var val = this.attributes[attr];
	      var escaped;
	      if (Parse._isNullOrUndefined(val)) {
	        escaped = '';
	      } else {
	        escaped = _.escape(val.toString());
	      }
	      this._escapedAttributes[attr] = escaped;
	      return escaped;
	    },
	
	    /**
	     * Gets the value of an attribute.
	     * @param {String} attr The name of an attribute.
	     */
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    _finishFetch: function(serverData) {
	      this.attributes = Parse._decode(null, _.clone(serverData.params));
	      if (!Parse.Storage.async) {
	        // We only provide local caching of config with synchronous Storage
	        Parse.Storage.setItem(
	            Parse._getParsePath(Parse.Config._CURRENT_CONFIG_KEY),
	            JSON.stringify(serverData));
	      }
	    }
	  };
	
	  Parse.Config._currentConfig = null;
	
	  Parse.Config._CURRENT_CONFIG_KEY = "currentConfig";
	
	}(this));
	
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Constructs a new Parse.Error object with the given code and message.
	   * @param {Number} code An error code constant from <code>Parse.Error</code>.
	   * @param {String} message A detailed description of the error.
	   * @class
	   *
	   * <p>Class used for all objects passed to error callbacks.</p>
	   */
	  Parse.Error = function(code, message) {
	    this.code = code;
	    this.message = message;
	  };
	
	  _.extend(Parse.Error, /** @lends Parse.Error */ {
	    /**
	     * Error code indicating some error other than those enumerated here.
	     * @constant
	     */
	    OTHER_CAUSE: -1,
	
	    /**
	     * Error code indicating that something has gone wrong with the server.
	     * If you get this error code, it is Parse's fault. Contact us at 
	     * https://parse.com/help
	     * @constant
	     */
	    INTERNAL_SERVER_ERROR: 1,
	
	    /**
	     * Error code indicating the connection to the Parse servers failed.
	     * @constant
	     */
	    CONNECTION_FAILED: 100,
	
	    /**
	     * Error code indicating the specified object doesn't exist.
	     * @constant
	     */
	    OBJECT_NOT_FOUND: 101,
	
	    /**
	     * Error code indicating you tried to query with a datatype that doesn't
	     * support it, like exact matching an array or object.
	     * @constant
	     */
	    INVALID_QUERY: 102,
	
	    /**
	     * Error code indicating a missing or invalid classname. Classnames are
	     * case-sensitive. They must start with a letter, and a-zA-Z0-9_ are the
	     * only valid characters.
	     * @constant
	     */
	    INVALID_CLASS_NAME: 103,
	
	    /**
	     * Error code indicating an unspecified object id.
	     * @constant
	     */
	    MISSING_OBJECT_ID: 104,
	
	    /**
	     * Error code indicating an invalid key name. Keys are case-sensitive. They
	     * must start with a letter, and a-zA-Z0-9_ are the only valid characters.
	     * @constant
	     */
	    INVALID_KEY_NAME: 105,
	
	    /**
	     * Error code indicating a malformed pointer. You should not see this unless
	     * you have been mucking about changing internal Parse code.
	     * @constant
	     */
	    INVALID_POINTER: 106,
	
	    /**
	     * Error code indicating that badly formed JSON was received upstream. This
	     * either indicates you have done something unusual with modifying how
	     * things encode to JSON, or the network is failing badly.
	     * @constant
	     */
	    INVALID_JSON: 107,
	
	    /**
	     * Error code indicating that the feature you tried to access is only
	     * available internally for testing purposes.
	     * @constant
	     */
	    COMMAND_UNAVAILABLE: 108,
	
	    /**
	     * You must call Parse.initialize before using the Parse library.
	     * @constant
	     */
	    NOT_INITIALIZED: 109,
	
	    /**
	     * Error code indicating that a field was set to an inconsistent type.
	     * @constant
	     */
	    INCORRECT_TYPE: 111,
	
	    /**
	     * Error code indicating an invalid channel name. A channel name is either
	     * an empty string (the broadcast channel) or contains only a-zA-Z0-9_
	     * characters and starts with a letter.
	     * @constant
	     */
	    INVALID_CHANNEL_NAME: 112,
	
	    /**
	     * Error code indicating that push is misconfigured.
	     * @constant
	     */
	    PUSH_MISCONFIGURED: 115,
	
	    /**
	     * Error code indicating that the object is too large.
	     * @constant
	     */
	    OBJECT_TOO_LARGE: 116,
	
	    /**
	     * Error code indicating that the operation isn't allowed for clients.
	     * @constant
	     */
	    OPERATION_FORBIDDEN: 119,
	
	    /**
	     * Error code indicating the result was not found in the cache.
	     * @constant
	     */
	    CACHE_MISS: 120,
	
	    /**
	     * Error code indicating that an invalid key was used in a nested
	     * JSONObject.
	     * @constant
	     */
	    INVALID_NESTED_KEY: 121,
	
	    /**
	     * Error code indicating that an invalid filename was used for ParseFile.
	     * A valid file name contains only a-zA-Z0-9_. characters and is between 1
	     * and 128 characters.
	     * @constant
	     */
	    INVALID_FILE_NAME: 122,
	
	    /**
	     * Error code indicating an invalid ACL was provided.
	     * @constant
	     */
	    INVALID_ACL: 123,
	
	    /**
	     * Error code indicating that the request timed out on the server. Typically
	     * this indicates that the request is too expensive to run.
	     * @constant
	     */
	    TIMEOUT: 124,
	
	    /**
	     * Error code indicating that the email address was invalid.
	     * @constant
	     */
	    INVALID_EMAIL_ADDRESS: 125,
	
	    /**
	     * Error code indicating a missing content type.
	     * @constant
	     */
	    MISSING_CONTENT_TYPE: 126,
	
	    /**
	     * Error code indicating a missing content length.
	     * @constant
	     */
	    MISSING_CONTENT_LENGTH: 127,
	
	    /**
	     * Error code indicating an invalid content length.
	     * @constant
	     */
	    INVALID_CONTENT_LENGTH: 128,
	
	    /**
	     * Error code indicating a file that was too large.
	     * @constant
	     */
	    FILE_TOO_LARGE: 129,
	
	    /**
	     * Error code indicating an error saving a file.
	     * @constant
	     */
	    FILE_SAVE_ERROR: 130,
	
	    /**
	     * Error code indicating that a unique field was given a value that is
	     * already taken.
	     * @constant
	     */
	    DUPLICATE_VALUE: 137,
	
	    /**
	     * Error code indicating that a role's name is invalid.
	     * @constant
	     */
	    INVALID_ROLE_NAME: 139,
	
	    /**
	     * Error code indicating that an application quota was exceeded.  Upgrade to
	     * resolve.
	     * @constant
	     */
	    EXCEEDED_QUOTA: 140,
	
	    /**
	     * Error code indicating that a Cloud Code script failed.
	     * @constant
	     */
	    SCRIPT_FAILED: 141,
	
	    /**
	     * Error code indicating that a Cloud Code validation failed.
	     * @constant
	     */
	    VALIDATION_ERROR: 142,
	
	    /**
	     * Error code indicating that invalid image data was provided.
	     * @constant
	     */
	    INVALID_IMAGE_DATA: 150,
	
	    /**
	     * Error code indicating an unsaved file.
	     * @constant
	     */
	    UNSAVED_FILE_ERROR: 151,
	
	    /**
	     * Error code indicating an invalid push time.
	     */
	    INVALID_PUSH_TIME_ERROR: 152,
	
	    /**
	     * Error code indicating an error deleting a file.
	     * @constant
	     */
	    FILE_DELETE_ERROR: 153,
	
	    /**
	     * Error code indicating that the application has exceeded its request
	     * limit.
	     * @constant
	     */
	    REQUEST_LIMIT_EXCEEDED: 155,
	
	    /**
	     * Error code indicating an invalid event name.
	     */
	    INVALID_EVENT_NAME: 160,
	
	    /**
	     * Error code indicating that the username is missing or empty.
	     * @constant
	     */
	    USERNAME_MISSING: 200,
	
	    /**
	     * Error code indicating that the password is missing or empty.
	     * @constant
	     */
	    PASSWORD_MISSING: 201,
	
	    /**
	     * Error code indicating that the username has already been taken.
	     * @constant
	     */
	    USERNAME_TAKEN: 202,
	
	    /**
	     * Error code indicating that the email has already been taken.
	     * @constant
	     */
	    EMAIL_TAKEN: 203,
	
	    /**
	     * Error code indicating that the email is missing, but must be specified.
	     * @constant
	     */
	    EMAIL_MISSING: 204,
	
	    /**
	     * Error code indicating that a user with the specified email was not found.
	     * @constant
	     */
	    EMAIL_NOT_FOUND: 205,
	
	    /**
	     * Error code indicating that a user object without a valid session could
	     * not be altered.
	     * @constant
	     */
	    SESSION_MISSING: 206,
	
	    /**
	     * Error code indicating that a user can only be created through signup.
	     * @constant
	     */
	    MUST_CREATE_USER_THROUGH_SIGNUP: 207,
	
	    /**
	     * Error code indicating that an an account being linked is already linked
	     * to another user.
	     * @constant
	     */
	    ACCOUNT_ALREADY_LINKED: 208,
	
	    /**
	     * Error code indicating that the current session token is invalid.
	     * @constant
	     */
	    INVALID_SESSION_TOKEN: 209,
	
	    /**
	     * Error code indicating that a user cannot be linked to an account because
	     * that account's id could not be found.
	     * @constant
	     */
	    LINKED_ID_MISSING: 250,
	
	    /**
	     * Error code indicating that a user with a linked (e.g. Facebook) account
	     * has an invalid session.
	     * @constant
	     */
	    INVALID_LINKED_SESSION: 251,
	
	    /**
	     * Error code indicating that a service being linked (e.g. Facebook or
	     * Twitter) is unsupported.
	     * @constant
	     */
	    UNSUPPORTED_SERVICE: 252,
	
	    /**
	     * Error code indicating that there were multiple errors. Aggregate errors
	     * have an "errors" property, which is an array of error objects with more
	     * detail about each error that occurred.
	     * @constant
	     */
	    AGGREGATE_ERROR: 600,
	
	    /**
	     * Error code indicating the client was unable to read an input file.
	     * @constant
	     */
	    FILE_READ_ERROR: 601,
	
	    /**
	     * Error code indicating a real error code is unavailable because
	     * we had to use an XDomainRequest object to allow CORS requests in
	     * Internet Explorer, which strips the body from HTTP responses that have
	     * a non-2XX status code.
	     * @constant
	     */
	    X_DOMAIN_REQUEST: 602
	  });
	
	}(this));
	
	/*global _: false */
	(function() {
	  var root = this;
	  var Parse = (root.Parse || (root.Parse = {}));
	  var eventSplitter = /\s+/;
	  var slice = Array.prototype.slice;
	
	  /**
	   * @class
	   *
	   * <p>Parse.Events is a fork of Backbone's Events module, provided for your
	   * convenience.</p>
	   *
	   * <p>A module that can be mixed in to any object in order to provide
	   * it with custom events. You may bind callback functions to an event
	   * with `on`, or remove these functions with `off`.
	   * Triggering an event fires all callbacks in the order that `on` was
	   * called.
	   *
	   * <pre>
	   *     var object = {};
	   *     _.extend(object, Parse.Events);
	   *     object.on('expand', function(){ alert('expanded'); });
	   *     object.trigger('expand');</pre></p>
	   *
	   * <p>For more information, see the
	   * <a href="http://documentcloud.github.com/backbone/#Events">Backbone
	   * documentation</a>.</p>
	   */
	  Parse.Events = {
	    /**
	     * Bind one or more space separated events, `events`, to a `callback`
	     * function. Passing `"all"` will bind the callback to all events fired.
	     */
	    on: function(events, callback, context) {
	
	      var calls, event, node, tail, list;
	      if (!callback) {
	        return this;
	      }
	      events = events.split(eventSplitter);
	      calls = this._callbacks || (this._callbacks = {});
	
	      // Create an immutable callback list, allowing traversal during
	      // modification.  The tail is an empty object that will always be used
	      // as the next node.
	      event = events.shift();
	      while (event) {
	        list = calls[event];
	        node = list ? list.tail : {};
	        node.next = tail = {};
	        node.context = context;
	        node.callback = callback;
	        calls[event] = {tail: tail, next: list ? list.next : node};
	        event = events.shift();
	      }
	
	      return this;
	    },
	
	    /**
	     * Remove one or many callbacks. If `context` is null, removes all callbacks
	     * with that function. If `callback` is null, removes all callbacks for the
	     * event. If `events` is null, removes all bound callbacks for all events.
	     */
	    off: function(events, callback, context) {
	      var event, calls, node, tail, cb, ctx;
	
	      // No events, or removing *all* events.
	      if (!(calls = this._callbacks)) {
	        return;
	      }
	      if (!(events || callback || context)) {
	        delete this._callbacks;
	        return this;
	      }
	
	      // Loop through the listed events and contexts, splicing them out of the
	      // linked list of callbacks if appropriate.
	      events = events ? events.split(eventSplitter) : Object.keys(calls);
	      event = events.shift();
	      while (event) {
	        node = calls[event];
	        delete calls[event];
	        if (!node || !(callback || context)) {
	          event = events.shift();
	          continue;
	        }
	        // Create a new list, omitting the indicated callbacks.
	        tail = node.tail;
	        node = node.next;
	        while (node !== tail) {
	          cb = node.callback;
	          ctx = node.context;
	          if ((callback && cb !== callback) || (context && ctx !== context)) {
	            this.on(event, cb, ctx);
	          }
	          node = node.next;
	        }
	        event = events.shift();
	      }
	
	      return this;
	    },
	
	    /**
	     * Trigger one or many events, firing all bound callbacks. Callbacks are
	     * passed the same arguments as `trigger` is, apart from the event name
	     * (unless you're listening on `"all"`, which will cause your callback to
	     * receive the true name of the event as the first argument).
	     */
	    trigger: function(events) {
	      var event, node, calls, tail, args, all, rest;
	      if (!(calls = this._callbacks)) {
	        return this;
	      }
	      all = calls.all;
	      events = events.split(eventSplitter);
	      rest = slice.call(arguments, 1);
	
	      // For each event, walk through the linked list of callbacks twice,
	      // first to trigger the event, then to trigger any `"all"` callbacks.
	      event = events.shift();
	      while (event) {
	        node = calls[event];
	        if (node) {
	          tail = node.tail;
	          while ((node = node.next) !== tail) {
	            node.callback.apply(node.context || this, rest);
	          }
	        }
	        node = all;
	        if (node) {
	          tail = node.tail;
	          args = [event].concat(rest);
	          while ((node = node.next) !== tail) {
	            node.callback.apply(node.context || this, args);
	          }
	        }
	        event = events.shift();
	      }
	
	      return this;
	    }
	  };  
	
	  /**
	   * @function
	   */
	  Parse.Events.bind = Parse.Events.on;
	
	  /**
	   * @function
	   */
	  Parse.Events.unbind = Parse.Events.off;
	}.call(this));
	
	
	/*global navigator: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Creates a new GeoPoint with any of the following forms:<br>
	   *   <pre>
	   *   new GeoPoint(otherGeoPoint)
	   *   new GeoPoint(30, 30)
	   *   new GeoPoint([30, 30])
	   *   new GeoPoint({latitude: 30, longitude: 30})
	   *   new GeoPoint()  // defaults to (0, 0)
	   *   </pre>
	   * @class
	   *
	   * <p>Represents a latitude / longitude point that may be associated
	   * with a key in a ParseObject or used as a reference point for geo queries.
	   * This allows proximity-based queries on the key.</p>
	   *
	   * <p>Only one key in a class may contain a GeoPoint.</p>
	   *
	   * <p>Example:<pre>
	   *   var point = new Parse.GeoPoint(30.0, -20.0);
	   *   var object = new Parse.Object("PlaceObject");
	   *   object.set("location", point);
	   *   object.save();</pre></p>
	   */
	  Parse.GeoPoint = function(arg1, arg2) {
	    if (_.isArray(arg1)) {
	      Parse.GeoPoint._validate(arg1[0], arg1[1]);
	      this.latitude = arg1[0];
	      this.longitude = arg1[1];
	    } else if (_.isObject(arg1)) {
	      Parse.GeoPoint._validate(arg1.latitude, arg1.longitude);
	      this.latitude = arg1.latitude;
	      this.longitude = arg1.longitude;
	    } else if (_.isNumber(arg1) && _.isNumber(arg2)) {
	      Parse.GeoPoint._validate(arg1, arg2);
	      this.latitude = arg1;
	      this.longitude = arg2;
	    } else {
	      this.latitude = 0;
	      this.longitude = 0;
	    }
	
	    // Add properties so that anyone using Webkit or Mozilla will get an error
	    // if they try to set values that are out of bounds.
	    var self = this;
	    if (this.__defineGetter__ && this.__defineSetter__) {
	      // Use _latitude and _longitude to actually store the values, and add
	      // getters and setters for latitude and longitude.
	      this._latitude = this.latitude;
	      this._longitude = this.longitude;
	      this.__defineGetter__("latitude", function() {
	        return self._latitude;
	      });
	      this.__defineGetter__("longitude", function() {
	        return self._longitude;
	      });
	      this.__defineSetter__("latitude", function(val) {
	        Parse.GeoPoint._validate(val, self.longitude);
	        self._latitude = val;
	      });
	      this.__defineSetter__("longitude", function(val) {
	        Parse.GeoPoint._validate(self.latitude, val);
	        self._longitude = val;
	      });
	    }
	  };
	
	  /**
	   * @lends Parse.GeoPoint.prototype
	   * @property {float} latitude North-south portion of the coordinate, in range
	   *   [-90, 90].  Throws an exception if set out of range in a modern browser.
	   * @property {float} longitude East-west portion of the coordinate, in range
	   *   [-180, 180].  Throws if set out of range in a modern browser.
	   */
	
	  /**
	   * Throws an exception if the given lat-long is out of bounds.
	   */
	  Parse.GeoPoint._validate = function(latitude, longitude) {
	    if (latitude < -90.0) {
	      throw "Parse.GeoPoint latitude " + latitude + " < -90.0.";
	    }
	    if (latitude > 90.0) {
	      throw "Parse.GeoPoint latitude " + latitude + " > 90.0.";
	    }
	    if (longitude < -180.0) {
	      throw "Parse.GeoPoint longitude " + longitude + " < -180.0.";
	    }
	    if (longitude > 180.0) {
	      throw "Parse.GeoPoint longitude " + longitude + " > 180.0.";
	    }
	  };
	
	  /**
	   * Creates a GeoPoint with the user's current location, if available.
	   * Calls options.success with a new GeoPoint instance or calls options.error.
	   * @param {Object} options An object with success and error callbacks.
	   */
	  Parse.GeoPoint.current = function(options) {
	    var promise = new Parse.Promise();
	    navigator.geolocation.getCurrentPosition(function(location) {
	      promise.resolve(new Parse.GeoPoint({
	        latitude: location.coords.latitude,
	        longitude: location.coords.longitude
	      }));
	
	    }, function(error) {
	      promise.reject(error);
	    });
	
	    return promise._thenRunCallbacks(options);
	  };
	
	  Parse.GeoPoint.prototype = {
	    /**
	     * Returns a JSON representation of the GeoPoint, suitable for Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      Parse.GeoPoint._validate(this.latitude, this.longitude);
	      return {
	        "__type": "GeoPoint",
	        latitude: this.latitude,
	        longitude: this.longitude
	      };
	    },
	
	    /**
	     * Returns the distance from this GeoPoint to another in radians.
	     * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
	     * @return {Number}
	     */
	    radiansTo: function(point) {
	      var d2r = Math.PI / 180.0;
	      var lat1rad = this.latitude * d2r;
	      var long1rad = this.longitude * d2r;
	      var lat2rad = point.latitude * d2r;
	      var long2rad = point.longitude * d2r;
	      var deltaLat = lat1rad - lat2rad;
	      var deltaLong = long1rad - long2rad;
	      var sinDeltaLatDiv2 = Math.sin(deltaLat / 2);
	      var sinDeltaLongDiv2 = Math.sin(deltaLong / 2);
	      // Square of half the straight line chord distance between both points.
	      var a = ((sinDeltaLatDiv2 * sinDeltaLatDiv2) +
	               (Math.cos(lat1rad) * Math.cos(lat2rad) *
	                sinDeltaLongDiv2 * sinDeltaLongDiv2));
	      a = Math.min(1.0, a);
	      return 2 * Math.asin(Math.sqrt(a));
	    },
	
	    /**
	     * Returns the distance from this GeoPoint to another in kilometers.
	     * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
	     * @return {Number}
	     */
	    kilometersTo: function(point) {
	      return this.radiansTo(point) * 6371.0;
	    },
	
	    /**
	     * Returns the distance from this GeoPoint to another in miles.
	     * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
	     * @return {Number}
	     */
	    milesTo: function(point) {
	      return this.radiansTo(point) * 3958.8;
	    }
	  };
	}(this));
	
	/*global navigator: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  var PUBLIC_KEY = "*";
	
	  /**
	   * Creates a new ACL.
	   * If no argument is given, the ACL has no permissions for anyone.
	   * If the argument is a Parse.User, the ACL will have read and write
	   *   permission for only that user.
	   * If the argument is any other JSON object, that object will be interpretted
	   *   as a serialized ACL created with toJSON().
	   * @see Parse.Object#setACL
	   * @class
	   *
	   * <p>An ACL, or Access Control List can be added to any
	   * <code>Parse.Object</code> to restrict access to only a subset of users
	   * of your application.</p>
	   */
	  Parse.ACL = function(arg1) {
	    var self = this;
	    self.permissionsById = {};
	    if (_.isObject(arg1)) {
	      if (arg1 instanceof Parse.User) {
	        self.setReadAccess(arg1, true);
	        self.setWriteAccess(arg1, true);
	      } else {
	        if (_.isFunction(arg1)) {
	          throw "Parse.ACL() called with a function.  Did you forget ()?";
	        }
	        Parse._objectEach(arg1, function(accessList, userId) {
	          if (!_.isString(userId)) {
	            throw "Tried to create an ACL with an invalid userId.";
	          }
	          self.permissionsById[userId] = {};
	          Parse._objectEach(accessList, function(allowed, permission) {
	            if (permission !== "read" && permission !== "write") {
	              throw "Tried to create an ACL with an invalid permission type.";
	            }
	            if (!_.isBoolean(allowed)) {
	              throw "Tried to create an ACL with an invalid permission value.";
	            }
	            self.permissionsById[userId][permission] = allowed;
	          });
	        });
	      }
	    }
	  };
	
	  /**
	   * Returns a JSON-encoded version of the ACL.
	   * @return {Object}
	   */
	  Parse.ACL.prototype.toJSON = function() {
	    return _.clone(this.permissionsById);
	  };
	
	  Parse.ACL.prototype._setAccess = function(accessType, userId, allowed) {
	    if (userId instanceof Parse.User) {
	      userId = userId.id;
	    } else if (userId instanceof Parse.Role) {
	      userId = "role:" + userId.getName();
	    }
	    if (!_.isString(userId)) {
	      throw "userId must be a string.";
	    }
	    if (!_.isBoolean(allowed)) {
	      throw "allowed must be either true or false.";
	    }
	    var permissions = this.permissionsById[userId];
	    if (!permissions) {
	      if (!allowed) {
	        // The user already doesn't have this permission, so no action needed.
	        return;
	      } else {
	        permissions = {};
	        this.permissionsById[userId] = permissions;
	      }
	    }
	
	    if (allowed) {
	      this.permissionsById[userId][accessType] = true;
	    } else {
	      delete permissions[accessType];
	      if (_.isEmpty(permissions)) {
	        delete permissions[userId];
	      }
	    }
	  };
	
	  Parse.ACL.prototype._getAccess = function(accessType, userId) {
	    if (userId instanceof Parse.User) {
	      userId = userId.id;
	    } else if (userId instanceof Parse.Role) {
	      userId = "role:" + userId.getName();
	    }
	    var permissions = this.permissionsById[userId];
	    if (!permissions) {
	      return false;
	    }
	    return permissions[accessType] ? true : false;
	  };
	
	  /**
	   * Set whether the given user is allowed to read this object.
	   * @param userId An instance of Parse.User or its objectId.
	   * @param {Boolean} allowed Whether that user should have read access.
	   */
	  Parse.ACL.prototype.setReadAccess = function(userId, allowed) {
	    this._setAccess("read", userId, allowed);
	  };
	
	  /**
	   * Get whether the given user id is *explicitly* allowed to read this object.
	   * Even if this returns false, the user may still be able to access it if
	   * getPublicReadAccess returns true or a role that the user belongs to has
	   * write access.
	   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
	   * @return {Boolean}
	   */
	  Parse.ACL.prototype.getReadAccess = function(userId) {
	    return this._getAccess("read", userId);
	  };
	
	  /**
	   * Set whether the given user id is allowed to write this object.
	   * @param userId An instance of Parse.User or its objectId, or a Parse.Role..
	   * @param {Boolean} allowed Whether that user should have write access.
	   */
	  Parse.ACL.prototype.setWriteAccess = function(userId, allowed) {
	    this._setAccess("write", userId, allowed);
	  };
	
	  /**
	   * Get whether the given user id is *explicitly* allowed to write this object.
	   * Even if this returns false, the user may still be able to write it if
	   * getPublicWriteAccess returns true or a role that the user belongs to has
	   * write access.
	   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
	   * @return {Boolean}
	   */
	  Parse.ACL.prototype.getWriteAccess = function(userId) {
	    return this._getAccess("write", userId);
	  };
	
	  /**
	   * Set whether the public is allowed to read this object.
	   * @param {Boolean} allowed
	   */
	  Parse.ACL.prototype.setPublicReadAccess = function(allowed) {
	    this.setReadAccess(PUBLIC_KEY, allowed);
	  };
	
	  /**
	   * Get whether the public is allowed to read this object.
	   * @return {Boolean}
	   */
	  Parse.ACL.prototype.getPublicReadAccess = function() {
	    return this.getReadAccess(PUBLIC_KEY);
	  };
	
	  /**
	   * Set whether the public is allowed to write this object.
	   * @param {Boolean} allowed
	   */
	  Parse.ACL.prototype.setPublicWriteAccess = function(allowed) {
	    this.setWriteAccess(PUBLIC_KEY, allowed);
	  };
	
	  /**
	   * Get whether the public is allowed to write this object.
	   * @return {Boolean}
	   */
	  Parse.ACL.prototype.getPublicWriteAccess = function() {
	    return this.getWriteAccess(PUBLIC_KEY);
	  };
	  
	  /**
	   * Get whether users belonging to the given role are allowed
	   * to read this object. Even if this returns false, the role may
	   * still be able to write it if a parent role has read access.
	   * 
	   * @param role The name of the role, or a Parse.Role object.
	   * @return {Boolean} true if the role has read access. false otherwise.
	   * @throws {String} If role is neither a Parse.Role nor a String.
	   */
	  Parse.ACL.prototype.getRoleReadAccess = function(role) {
	    if (role instanceof Parse.Role) {
	      // Normalize to the String name
	      role = role.getName();
	    }
	    if (_.isString(role)) {
	      return this.getReadAccess("role:" + role);
	    }
	    throw "role must be a Parse.Role or a String";
	  };
	  
	  /**
	   * Get whether users belonging to the given role are allowed
	   * to write this object. Even if this returns false, the role may
	   * still be able to write it if a parent role has write access.
	   * 
	   * @param role The name of the role, or a Parse.Role object.
	   * @return {Boolean} true if the role has write access. false otherwise.
	   * @throws {String} If role is neither a Parse.Role nor a String.
	   */
	  Parse.ACL.prototype.getRoleWriteAccess = function(role) {
	    if (role instanceof Parse.Role) {
	      // Normalize to the String name
	      role = role.getName();
	    }
	    if (_.isString(role)) {
	      return this.getWriteAccess("role:" + role);
	    }
	    throw "role must be a Parse.Role or a String";
	  };
	  
	  /**
	   * Set whether users belonging to the given role are allowed
	   * to read this object.
	   * 
	   * @param role The name of the role, or a Parse.Role object.
	   * @param {Boolean} allowed Whether the given role can read this object.
	   * @throws {String} If role is neither a Parse.Role nor a String.
	   */
	  Parse.ACL.prototype.setRoleReadAccess = function(role, allowed) {
	    if (role instanceof Parse.Role) {
	      // Normalize to the String name
	      role = role.getName();
	    }
	    if (_.isString(role)) {
	      this.setReadAccess("role:" + role, allowed);
	      return;
	    }
	    throw "role must be a Parse.Role or a String";
	  };
	  
	  /**
	   * Set whether users belonging to the given role are allowed
	   * to write this object.
	   * 
	   * @param role The name of the role, or a Parse.Role object.
	   * @param {Boolean} allowed Whether the given role can write this object.
	   * @throws {String} If role is neither a Parse.Role nor a String.
	   */
	  Parse.ACL.prototype.setRoleWriteAccess = function(role, allowed) {
	    if (role instanceof Parse.Role) {
	      // Normalize to the String name
	      role = role.getName();
	    }
	    if (_.isString(role)) {
	      this.setWriteAccess("role:" + role, allowed);
	      return;
	    }
	    throw "role must be a Parse.Role or a String";
	  };
	
	}(this));
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * @class
	   * A Parse.Op is an atomic operation that can be applied to a field in a
	   * Parse.Object. For example, calling <code>object.set("foo", "bar")</code>
	   * is an example of a Parse.Op.Set. Calling <code>object.unset("foo")</code>
	   * is a Parse.Op.Unset. These operations are stored in a Parse.Object and
	   * sent to the server as part of <code>object.save()</code> operations.
	   * Instances of Parse.Op should be immutable.
	   *
	   * You should not create subclasses of Parse.Op or instantiate Parse.Op
	   * directly.
	   */
	  Parse.Op = function() {
	    this._initialize.apply(this, arguments);
	  };
	
	  Parse.Op.prototype = {
	    _initialize: function() {}
	  };
	
	  _.extend(Parse.Op, {
	    /**
	     * To create a new Op, call Parse.Op._extend();
	     */
	    _extend: Parse._extend,
	
	    // A map of __op string to decoder function.
	    _opDecoderMap: {},
	
	    /**
	     * Registers a function to convert a json object with an __op field into an
	     * instance of a subclass of Parse.Op.
	     */
	    _registerDecoder: function(opName, decoder) {
	      Parse.Op._opDecoderMap[opName] = decoder;
	    },
	
	    /**
	     * Converts a json object into an instance of a subclass of Parse.Op.
	     */
	    _decode: function(json) {
	      var decoder = Parse.Op._opDecoderMap[json.__op];
	      if (decoder) {
	        return decoder(json);
	      } else {
	        return undefined;
	      }
	    }
	  });
	
	  /*
	   * Add a handler for Batch ops.
	   */
	  Parse.Op._registerDecoder("Batch", function(json) {
	    var op = null;
	    Parse._arrayEach(json.ops, function(nextOp) {
	      nextOp = Parse.Op._decode(nextOp);
	      op = nextOp._mergeWithPrevious(op);
	    });
	    return op;
	  });
	
	  /**
	   * @class
	   * A Set operation indicates that either the field was changed using
	   * Parse.Object.set, or it is a mutable container that was detected as being
	   * changed.
	   */
	  Parse.Op.Set = Parse.Op._extend(/** @lends Parse.Op.Set.prototype */ {
	    _initialize: function(value) {
	      this._value = value;
	    },
	
	    /**
	     * Returns the new value of this field after the set.
	     */
	    value: function() {
	      return this._value;
	    },
	
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return Parse._encode(this.value());
	    },
	
	    _mergeWithPrevious: function(previous) {
	      return this;
	    },
	
	    _estimate: function(oldValue) {
	      return this.value();
	    }
	  });
	
	  /**
	   * A sentinel value that is returned by Parse.Op.Unset._estimate to
	   * indicate the field should be deleted. Basically, if you find _UNSET as a
	   * value in your object, you should remove that key.
	   */
	  Parse.Op._UNSET = {};
	
	  /**
	   * @class
	   * An Unset operation indicates that this field has been deleted from the
	   * object.
	   */
	  Parse.Op.Unset = Parse.Op._extend(/** @lends Parse.Op.Unset.prototype */ {
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return { __op: "Delete" };
	    },
	
	    _mergeWithPrevious: function(previous) {
	      return this;
	    },
	
	    _estimate: function(oldValue) {
	      return Parse.Op._UNSET;
	    }
	  });
	
	  Parse.Op._registerDecoder("Delete", function(json) {
	    return new Parse.Op.Unset();
	  });
	
	  /**
	   * @class
	   * An Increment is an atomic operation where the numeric value for the field
	   * will be increased by a given amount.
	   */
	  Parse.Op.Increment = Parse.Op._extend(
	      /** @lends Parse.Op.Increment.prototype */ {
	
	    _initialize: function(amount) {
	      this._amount = amount;
	    },
	
	    /**
	     * Returns the amount to increment by.
	     * @return {Number} the amount to increment by.
	     */
	    amount: function() {
	      return this._amount;
	    },
	
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return { __op: "Increment", amount: this._amount };
	    },
	
	    _mergeWithPrevious: function(previous) {
	      if (!previous) {
	        return this;
	      } else if (previous instanceof Parse.Op.Unset) {
	        return new Parse.Op.Set(this.amount());
	      } else if (previous instanceof Parse.Op.Set) {
	        return new Parse.Op.Set(previous.value() + this.amount());
	      } else if (previous instanceof Parse.Op.Increment) {
	        return new Parse.Op.Increment(this.amount() + previous.amount());
	      } else {
	        throw "Op is invalid after previous op.";
	      }
	    },
	
	    _estimate: function(oldValue) {
	      if (!oldValue) {
	        return this.amount();
	      }
	      return oldValue + this.amount();
	    }
	  });
	
	  Parse.Op._registerDecoder("Increment", function(json) {
	    return new Parse.Op.Increment(json.amount);
	  });
	
	  /**
	   * @class
	   * Add is an atomic operation where the given objects will be appended to the
	   * array that is stored in this field.
	   */
	  Parse.Op.Add = Parse.Op._extend(/** @lends Parse.Op.Add.prototype */ {
	    _initialize: function(objects) {
	      this._objects = objects;
	    },
	
	    /**
	     * Returns the objects to be added to the array.
	     * @return {Array} The objects to be added to the array.
	     */
	    objects: function() {
	      return this._objects;
	    },
	
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return { __op: "Add", objects: Parse._encode(this.objects()) };
	    },
	
	    _mergeWithPrevious: function(previous) {
	      if (!previous) {
	        return this;
	      } else if (previous instanceof Parse.Op.Unset) {
	        return new Parse.Op.Set(this.objects());
	      } else if (previous instanceof Parse.Op.Set) {
	        return new Parse.Op.Set(this._estimate(previous.value()));
	      } else if (previous instanceof Parse.Op.Add) {
	        return new Parse.Op.Add(previous.objects().concat(this.objects()));
	      } else {
	        throw "Op is invalid after previous op.";
	      }
	    },
	
	    _estimate: function(oldValue) {
	      if (!oldValue) {
	        return _.clone(this.objects());
	      } else {
	        return oldValue.concat(this.objects());
	      }
	    }
	  });
	
	  Parse.Op._registerDecoder("Add", function(json) {
	    return new Parse.Op.Add(Parse._decode(undefined, json.objects));
	  });
	
	  /**
	   * @class
	   * AddUnique is an atomic operation where the given items will be appended to
	   * the array that is stored in this field only if they were not already
	   * present in the array.
	   */
	  Parse.Op.AddUnique = Parse.Op._extend(
	      /** @lends Parse.Op.AddUnique.prototype */ {
	
	    _initialize: function(objects) {
	      this._objects = _.uniq(objects);
	    },
	
	    /**
	     * Returns the objects to be added to the array.
	     * @return {Array} The objects to be added to the array.
	     */
	    objects: function() {
	      return this._objects;
	    },
	
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return { __op: "AddUnique", objects: Parse._encode(this.objects()) };
	    },
	
	    _mergeWithPrevious: function(previous) {
	      if (!previous) {
	        return this;
	      } else if (previous instanceof Parse.Op.Unset) {
	        return new Parse.Op.Set(this.objects());
	      } else if (previous instanceof Parse.Op.Set) {
	        return new Parse.Op.Set(this._estimate(previous.value()));
	      } else if (previous instanceof Parse.Op.AddUnique) {
	        return new Parse.Op.AddUnique(this._estimate(previous.objects()));
	      } else {
	        throw "Op is invalid after previous op.";
	      }
	    },
	
	    _estimate: function(oldValue) {
	      if (!oldValue) {
	        return _.clone(this.objects());
	      } else {
	        // We can't just take the _.uniq(_.union(...)) of oldValue and
	        // this.objects, because the uniqueness may not apply to oldValue
	        // (especially if the oldValue was set via .set())
	        var newValue = _.clone(oldValue);
	        Parse._arrayEach(this.objects(), function(obj) {
	          if (obj instanceof Parse.Object && obj.id) {
	            var matchingObj = _.find(newValue, function(anObj) {
	              return (anObj instanceof Parse.Object) && (anObj.id === obj.id);
	            });
	            if (!matchingObj) {
	              newValue.push(obj);
	            } else {
	              var index = _.indexOf(newValue, matchingObj);
	              newValue[index] = obj;
	            }
	          } else if (!_.contains(newValue, obj)) {
	            newValue.push(obj);
	          }
	        });
	        return newValue;
	      }
	    }
	  });
	
	  Parse.Op._registerDecoder("AddUnique", function(json) {
	    return new Parse.Op.AddUnique(Parse._decode(undefined, json.objects));
	  });
	
	  /**
	   * @class
	   * Remove is an atomic operation where the given objects will be removed from
	   * the array that is stored in this field.
	   */
	  Parse.Op.Remove = Parse.Op._extend(/** @lends Parse.Op.Remove.prototype */ {
	    _initialize: function(objects) {
	      this._objects = _.uniq(objects);
	    },
	
	    /**
	     * Returns the objects to be removed from the array.
	     * @return {Array} The objects to be removed from the array.
	     */
	    objects: function() {
	      return this._objects;
	    },
	
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return { __op: "Remove", objects: Parse._encode(this.objects()) };
	    },
	
	    _mergeWithPrevious: function(previous) {
	      if (!previous) {
	        return this;
	      } else if (previous instanceof Parse.Op.Unset) {
	        return previous;
	      } else if (previous instanceof Parse.Op.Set) {
	        return new Parse.Op.Set(this._estimate(previous.value()));
	      } else if (previous instanceof Parse.Op.Remove) {
	        return new Parse.Op.Remove(_.union(previous.objects(), this.objects()));
	      } else {
	        throw "Op is invalid after previous op.";
	      }
	    },
	
	    _estimate: function(oldValue) {
	      if (!oldValue) {
	        return [];
	      } else {
	        var newValue = _.difference(oldValue, this.objects());
	        // If there are saved Parse Objects being removed, also remove them.
	        Parse._arrayEach(this.objects(), function(obj) {
	          if (obj instanceof Parse.Object && obj.id) {
	            newValue = _.reject(newValue, function(other) {
	              return (other instanceof Parse.Object) && (other.id === obj.id);
	            });
	          }
	        });
	        return newValue;
	      }
	    }
	  });
	
	  Parse.Op._registerDecoder("Remove", function(json) {
	    return new Parse.Op.Remove(Parse._decode(undefined, json.objects));
	  });
	
	  /**
	   * @class
	   * A Relation operation indicates that the field is an instance of
	   * Parse.Relation, and objects are being added to, or removed from, that
	   * relation.
	   */
	  Parse.Op.Relation = Parse.Op._extend(
	      /** @lends Parse.Op.Relation.prototype */ {
	
	    _initialize: function(adds, removes) {
	      this._targetClassName = null;
	
	      var self = this;
	
	      var pointerToId = function(object) {
	        if (object instanceof Parse.Object) {
	          if (!object.id) {
	            throw "You can't add an unsaved Parse.Object to a relation.";
	          }
	          if (!self._targetClassName) {
	            self._targetClassName = object.className;
	          }
	          if (self._targetClassName !== object.className) {
	            throw "Tried to create a Parse.Relation with 2 different types: " +
	                  self._targetClassName + " and " + object.className + ".";
	          }
	          return object.id;
	        }
	        return object;
	      };
	
	      this.relationsToAdd = _.uniq(_.map(adds, pointerToId));
	      this.relationsToRemove = _.uniq(_.map(removes, pointerToId));
	    },
	
	    /**
	     * Returns an array of unfetched Parse.Object that are being added to the
	     * relation.
	     * @return {Array}
	     */
	    added: function() {
	      var self = this;
	      return _.map(this.relationsToAdd, function(objectId) {
	        var object = Parse.Object._create(self._targetClassName);
	        object.id = objectId;
	        return object;
	      });
	    },
	
	    /**
	     * Returns an array of unfetched Parse.Object that are being removed from
	     * the relation.
	     * @return {Array}
	     */
	    removed: function() {
	      var self = this;
	      return _.map(this.relationsToRemove, function(objectId) {
	        var object = Parse.Object._create(self._targetClassName);
	        object.id = objectId;
	        return object;
	      });
	    },
	
	    /**
	     * Returns a JSON version of the operation suitable for sending to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      var adds = null;
	      var removes = null;
	      var self = this;
	      var idToPointer = function(id) {
	        return { __type: 'Pointer',
	                 className: self._targetClassName,
	                 objectId: id };
	      };
	      var pointers = null;
	      if (this.relationsToAdd.length > 0) {
	        pointers = _.map(this.relationsToAdd, idToPointer);
	        adds = { "__op": "AddRelation", "objects": pointers };
	      }
	
	      if (this.relationsToRemove.length > 0) {
	        pointers = _.map(this.relationsToRemove, idToPointer);
	        removes = { "__op": "RemoveRelation", "objects": pointers };
	      }
	
	      if (adds && removes) {
	        return { "__op": "Batch", "ops": [adds, removes]};
	      }
	
	      return adds || removes || {};
	    },
	
	    _mergeWithPrevious: function(previous) {
	      if (!previous) {
	        return this;
	      } else if (previous instanceof Parse.Op.Unset) {
	        throw "You can't modify a relation after deleting it.";
	      } else if (previous instanceof Parse.Op.Relation) {
	        if (previous._targetClassName &&
	            previous._targetClassName !== this._targetClassName) {
	          throw "Related object must be of class " + previous._targetClassName +
	              ", but " + this._targetClassName + " was passed in.";
	        }
	        var newAdd = _.union(_.difference(previous.relationsToAdd,
	                                          this.relationsToRemove),
	                             this.relationsToAdd);
	        var newRemove = _.union(_.difference(previous.relationsToRemove,
	                                             this.relationsToAdd),
	                                this.relationsToRemove);
	
	        var newRelation = new Parse.Op.Relation(newAdd, newRemove);
	        newRelation._targetClassName = this._targetClassName;
	        return newRelation;
	      } else {
	        throw "Op is invalid after previous op.";
	      }
	    },
	
	    _estimate: function(oldValue, object, key) {
	      if (!oldValue) {
	        var relation = new Parse.Relation(object, key);
	        relation.targetClassName = this._targetClassName;
	      } else if (oldValue instanceof Parse.Relation) {
	        if (this._targetClassName) {
	          if (oldValue.targetClassName) {
	            if (oldValue.targetClassName !== this._targetClassName) {
	              throw "Related object must be a " + oldValue.targetClassName +
	                  ", but a " + this._targetClassName + " was passed in.";
	            }
	          } else {
	            oldValue.targetClassName = this._targetClassName;
	          }
	        }
	        return oldValue;
	      } else {
	        throw "Op is invalid after previous op.";
	      }
	    }
	  });
	
	  Parse.Op._registerDecoder("AddRelation", function(json) {
	    return new Parse.Op.Relation(Parse._decode(undefined, json.objects), []);
	  });
	  Parse.Op._registerDecoder("RemoveRelation", function(json) {
	    return new Parse.Op.Relation([], Parse._decode(undefined, json.objects));
	  });
	
	}(this));
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Creates a new Relation for the given parent object and key. This
	   * constructor should rarely be used directly, but rather created by
	   * Parse.Object.relation.
	   * @param {Parse.Object} parent The parent of this relation.
	   * @param {String} key The key for this relation on the parent.
	   * @see Parse.Object#relation
	   * @class
	   *
	   * <p>
	   * A class that is used to access all of the children of a many-to-many
	   * relationship.  Each instance of Parse.Relation is associated with a
	   * particular parent object and key.
	   * </p>
	   */
	  Parse.Relation = function(parent, key) {
	    this.parent = parent;
	    this.key = key;
	    this.targetClassName = null;
	  };
	
	  Parse.Relation.prototype = {
	    /**
	     * Makes sure that this relation has the right parent and key.
	     */
	    _ensureParentAndKey: function(parent, key) {
	      this.parent = this.parent || parent;
	      this.key = this.key || key;
	      if (this.parent !== parent) {
	        throw "Internal Error. Relation retrieved from two different Objects.";
	      }
	      if (this.key !== key) {
	        throw "Internal Error. Relation retrieved from two different keys.";
	      }
	    },
	
	    /**
	     * Adds a Parse.Object or an array of Parse.Objects to the relation.
	     * @param {} objects The item or items to add.
	     */
	    add: function(objects) {
	      if (!_.isArray(objects)) {
	        objects = [objects];
	      }
	
	      var change = new Parse.Op.Relation(objects, []);
	      this.parent.set(this.key, change);
	      this.targetClassName = change._targetClassName;
	    },
	
	    /**
	     * Removes a Parse.Object or an array of Parse.Objects from this relation.
	     * @param {} objects The item or items to remove.
	     */
	    remove: function(objects) {
	      if (!_.isArray(objects)) {
	        objects = [objects];
	      }
	
	      var change = new Parse.Op.Relation([], objects);
	      this.parent.set(this.key, change);
	      this.targetClassName = change._targetClassName;
	    },
	
	    /**
	     * Returns a JSON version of the object suitable for saving to disk.
	     * @return {Object}
	     */
	    toJSON: function() {
	      return { "__type": "Relation", "className": this.targetClassName };
	    },
	
	    /**
	     * Returns a Parse.Query that is limited to objects in this
	     * relation.
	     * @return {Parse.Query}
	     */
	    query: function() {
	      var targetClass;
	      var query;
	      if (!this.targetClassName) {
	        targetClass = Parse.Object._getSubclass(this.parent.className);
	        query = new Parse.Query(targetClass);
	        query._extraOptions.redirectClassNameForKey = this.key;
	      } else {
	        targetClass = Parse.Object._getSubclass(this.targetClassName);
	        query = new Parse.Query(targetClass);
	      }
	      query._addCondition("$relatedTo", "object", this.parent._toPointer());
	      query._addCondition("$relatedTo", "key", this.key);
	
	      return query;
	    }
	  };
	}(this));
	
	/*global window: false, process: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * A Promise is returned by async methods as a hook to provide callbacks to be
	   * called when the async task is fulfilled.
	   *
	   * <p>Typical usage would be like:<pre>
	   *    query.find().then(function(results) {
	   *      results[0].set("foo", "bar");
	   *      return results[0].saveAsync();
	   *    }).then(function(result) {
	   *      console.log("Updated " + result.id);
	   *    });
	   * </pre></p>
	   *
	   * @see Parse.Promise.prototype.then
	   * @class
	   */
	  Parse.Promise = function() {
	    this._resolved = false;
	    this._rejected = false;
	    this._resolvedCallbacks = [];
	    this._rejectedCallbacks = [];
	  };
	
	  _.extend(Parse.Promise, /** @lends Parse.Promise */ {
	
	    _isPromisesAPlusCompliant: false,
	
	    /**
	     * Returns true iff the given object fulfils the Promise interface.
	     * @return {Boolean}
	     */
	    is: function(promise) {
	      return promise && promise.then && _.isFunction(promise.then);
	    },
	
	    /**
	     * Returns a new promise that is resolved with a given value.
	     * @return {Parse.Promise} the new promise.
	     */
	    as: function() {
	      var promise = new Parse.Promise();
	      promise.resolve.apply(promise, arguments);
	      return promise;
	    },
	
	    /**
	     * Returns a new promise that is rejected with a given error.
	     * @return {Parse.Promise} the new promise.
	     */
	    error: function() {
	      var promise = new Parse.Promise();
	      promise.reject.apply(promise, arguments);
	      return promise;
	    },
	
	    /**
	     * Returns a new promise that is fulfilled when all of the input promises
	     * are resolved. If any promise in the list fails, then the returned promise
	     * will fail with the last error. If they all succeed, then the returned
	     * promise will succeed, with the results being the results of all the input
	     * promises. For example: <pre>
	     *   var p1 = Parse.Promise.as(1);
	     *   var p2 = Parse.Promise.as(2);
	     *   var p3 = Parse.Promise.as(3);
	     *
	     *   Parse.Promise.when(p1, p2, p3).then(function(r1, r2, r3) {
	     *     console.log(r1);  // prints 1
	     *     console.log(r2);  // prints 2
	     *     console.log(r3);  // prints 3
	     *   });</pre>
	     *
	     * The input promises can also be specified as an array: <pre>
	     *   var promises = [p1, p2, p3];
	     *   Parse.Promise.when(promises).then(function(r1, r2, r3) {
	     *     console.log(r1);  // prints 1
	     *     console.log(r2);  // prints 2
	     *     console.log(r3);  // prints 3
	     *   });
	     * </pre>
	     * @param {Array} promises a list of promises to wait for.
	     * @return {Parse.Promise} the new promise.
	     */
	    when: function(promises) {
	      // Allow passing in Promises as separate arguments instead of an Array.
	      var objects;
	      if (promises && Parse._isNullOrUndefined(promises.length)) {
	        objects = arguments;
	      } else {
	        objects = promises;
	      }
	
	      var total = objects.length;
	      var hadError = false;
	      var results = [];
	      var errors = [];
	      results.length = objects.length;
	      errors.length = objects.length;
	
	      if (total === 0) {
	        return Parse.Promise.as.apply(this, results);
	      }
	
	      var promise = new Parse.Promise();
	
	      var resolveOne = function() {
	        total = total - 1;
	        if (total === 0) {
	          if (hadError) {
	            promise.reject(errors);
	          } else {
	            promise.resolve.apply(promise, results);
	          }
	        }
	      };
	
	      Parse._arrayEach(objects, function(object, i) {
	        if (Parse.Promise.is(object)) {
	          object.then(function(result) {
	            results[i] = result;
	            resolveOne();
	          }, function(error) {
	            errors[i] = error;
	            hadError = true;
	            resolveOne();
	          });
	        } else {
	          results[i] = object;
	          resolveOne();
	        }
	      });
	
	      return promise;
	    },
	
	    /**
	     * Runs the given asyncFunction repeatedly, as long as the predicate
	     * function returns a truthy value. Stops repeating if asyncFunction returns
	     * a rejected promise.
	     * @param {Function} predicate should return false when ready to stop.
	     * @param {Function} asyncFunction should return a Promise.
	     */
	    _continueWhile: function(predicate, asyncFunction) {
	      if (predicate()) {
	        return asyncFunction().then(function() {
	          return Parse.Promise._continueWhile(predicate, asyncFunction);
	        });
	      }
	      return Parse.Promise.as();
	    }
	  });
	
	  _.extend(Parse.Promise.prototype, /** @lends Parse.Promise.prototype */ {
	
	    /**
	     * Marks this promise as fulfilled, firing any callbacks waiting on it.
	     * @param {Object} result the result to pass to the callbacks.
	     */
	    resolve: function(result) {
	      if (this._resolved || this._rejected) {
	        throw "A promise was resolved even though it had already been " +
	          (this._resolved ? "resolved" : "rejected") + ".";
	      }
	      this._resolved = true;
	      this._result = arguments;
	      var results = arguments;
	      Parse._arrayEach(this._resolvedCallbacks, function(resolvedCallback) {
	        resolvedCallback.apply(this, results);
	      });
	      this._resolvedCallbacks = [];
	      this._rejectedCallbacks = [];
	    },
	
	    /**
	     * Marks this promise as fulfilled, firing any callbacks waiting on it.
	     * @param {Object} error the error to pass to the callbacks.
	     */
	    reject: function(error) {
	      if (this._resolved || this._rejected) {
	        throw "A promise was rejected even though it had already been " +
	          (this._resolved ? "resolved" : "rejected") + ".";
	      }
	      this._rejected = true;
	      this._error = error;
	      Parse._arrayEach(this._rejectedCallbacks, function(rejectedCallback) {
	        rejectedCallback(error);
	      });
	      this._resolvedCallbacks = [];
	      this._rejectedCallbacks = [];
	    },
	
	    /**
	     * Adds callbacks to be called when this promise is fulfilled. Returns a new
	     * Promise that will be fulfilled when the callback is complete. It allows
	     * chaining. If the callback itself returns a Promise, then the one returned
	     * by "then" will not be fulfilled until that one returned by the callback
	     * is fulfilled.
	     * @param {Function} resolvedCallback Function that is called when this
	     * Promise is resolved. Once the callback is complete, then the Promise
	     * returned by "then" will also be fulfilled.
	     * @param {Function} rejectedCallback Function that is called when this
	     * Promise is rejected with an error. Once the callback is complete, then
	     * the promise returned by "then" with be resolved successfully. If
	     * rejectedCallback is null, or it returns a rejected Promise, then the
	     * Promise returned by "then" will be rejected with that error.
	     * @return {Parse.Promise} A new Promise that will be fulfilled after this
	     * Promise is fulfilled and either callback has completed. If the callback
	     * returned a Promise, then this Promise will not be fulfilled until that
	     * one is.
	     */
	    then: function(resolvedCallback, rejectedCallback) {
	      var promise = new Parse.Promise();
	
	      var wrappedResolvedCallback = function() {
	        var result = arguments;
	        if (resolvedCallback) {
	          if (Parse.Promise._isPromisesAPlusCompliant) {
	            try {
	              result = [resolvedCallback.apply(this, result)];
	            } catch (e) {
	              result = [Parse.Promise.error(e)];
	            }
	          } else {
	            result = [resolvedCallback.apply(this, result)];
	          }
	        }
	        if (result.length === 1 && Parse.Promise.is(result[0])) {
	          result[0].then(function() {
	            promise.resolve.apply(promise, arguments);
	          }, function(error) {
	            promise.reject(error);
	          });
	        } else {
	          promise.resolve.apply(promise, result);
	        }
	      };
	
	      var wrappedRejectedCallback = function(error) {
	        var result = [];
	        if (rejectedCallback) {
	          if (Parse.Promise._isPromisesAPlusCompliant) {
	            try {
	              result = [rejectedCallback(error)];
	            } catch (e) {
	              result = [Parse.Promise.error(e)];
	            }
	          } else {
	            result = [rejectedCallback(error)];
	          }
	          if (result.length === 1 && Parse.Promise.is(result[0])) {
	            result[0].then(function() {
	              promise.resolve.apply(promise, arguments);
	            }, function(error) {
	              promise.reject(error);
	            });
	          } else {
	            if (Parse.Promise._isPromisesAPlusCompliant) {
	              promise.resolve.apply(promise, result);
	            } else {
	              promise.reject(result[0]);
	            }
	          }
	        } else {
	          promise.reject(error);
	        }
	      };
	
	      var runLater = function(func) {
	        func.call();
	      };
	      if (Parse.Promise._isPromisesAPlusCompliant) {
	        if (typeof(window) !== 'undefined' && window.setTimeout) {
	          runLater = function(func) {
	            window.setTimeout(func, 0);
	          };
	        } else if (typeof(process) !== 'undefined' && process.nextTick) {
	          runLater = function(func) {
	            process.nextTick(func);
	          };
	        }
	      }
	
	      var self = this;
	      if (this._resolved) {
	        runLater(function() {
	          wrappedResolvedCallback.apply(self, self._result);
	        });
	      } else if (this._rejected) {
	        runLater(function() {
	          wrappedRejectedCallback(self._error);
	        });
	      } else {
	        this._resolvedCallbacks.push(wrappedResolvedCallback);
	        this._rejectedCallbacks.push(wrappedRejectedCallback);
	      }
	
	      return promise;
	    },
	
	    /**
	     * Add handlers to be called when the promise 
	     * is either resolved or rejected
	     */
	    always: function(callback) {
	      return this.then(callback, callback);
	    },
	
	    /**
	     * Add handlers to be called when the Promise object is resolved
	     */
	    done: function(callback) {
	      return this.then(callback);
	    },
	
	    /**
	     * Add handlers to be called when the Promise object is rejected
	     */
	    fail: function(callback) {
	      return this.then(null, callback);
	    },
	
	    /**
	     * Run the given callbacks after this promise is fulfilled.
	     * @param optionsOrCallback {} A Backbone-style options callback, or a
	     * callback function. If this is an options object and contains a "model"
	     * attributes, that will be passed to error callbacks as the first argument.
	     * @param model {} If truthy, this will be passed as the first result of
	     * error callbacks. This is for Backbone-compatability.
	     * @return {Parse.Promise} A promise that will be resolved after the
	     * callbacks are run, with the same result as this.
	     */
	    _thenRunCallbacks: function(optionsOrCallback, model) {
	      var options;
	      if (_.isFunction(optionsOrCallback)) {
	        var callback = optionsOrCallback;
	        options = {
	          success: function(result) {
	            callback(result, null);
	          },
	          error: function(error) {
	            callback(null, error);
	          }
	        };
	      } else {
	        options = _.clone(optionsOrCallback);
	      }
	      options = options || {};
	
	      return this.then(function(result) {
	        if (options.success) {
	          options.success.apply(this, arguments);
	        } else if (model) {
	          // When there's no callback, a sync event should be triggered.
	          model.trigger('sync', model, result, options);
	        }
	        return Parse.Promise.as.apply(Parse.Promise, arguments);
	      }, function(error) {
	        if (options.error) {
	          if (!_.isUndefined(model)) {
	            options.error(model, error);
	          } else {
	            options.error(error);
	          }
	        } else if (model) {
	          // When there's no error callback, an error event should be triggered.
	          model.trigger('error', model, error, options);
	        }
	        // By explicitly returning a rejected Promise, this will work with
	        // either jQuery or Promises/A semantics.
	        return Parse.Promise.error(error);
	      });
	    },
	
	    /**
	     * Adds a callback function that should be called regardless of whether
	     * this promise failed or succeeded. The callback will be given either the
	     * array of results for its first argument, or the error as its second,
	     * depending on whether this Promise was rejected or resolved. Returns a
	     * new Promise, like "then" would.
	     * @param {Function} continuation the callback.
	     */
	    _continueWith: function(continuation) {
	      return this.then(function() {
	        return continuation(arguments, null);
	      }, function(error) {
	        return continuation(null, error);
	      });
	    }
	
	  });
	
	}(this));
	
	/*jshint bitwise:false *//*global FileReader: true, File: true */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  var b64Digit = function(number) {
	    if (number < 26) {
	      return String.fromCharCode(65 + number);
	    }
	    if (number < 52) {
	      return String.fromCharCode(97 + (number - 26));
	    }
	    if (number < 62) {
	      return String.fromCharCode(48 + (number - 52));
	    }
	    if (number === 62) {
	      return "+";
	    }
	    if (number === 63) {
	      return "/";
	    }
	    throw "Tried to encode large digit " + number + " in base64.";
	  };
	
	  var encodeBase64 = function(array) {
	    var chunks = [];
	    chunks.length = Math.ceil(array.length / 3);
	    _.times(chunks.length, function(i) {
	      var b1 = array[i * 3];
	      var b2 = array[i * 3 + 1] || 0;
	      var b3 = array[i * 3 + 2] || 0;
	
	      var has2 = (i * 3 + 1) < array.length;
	      var has3 = (i * 3 + 2) < array.length;
	
	      chunks[i] = [
	        b64Digit((b1 >> 2) & 0x3F),
	        b64Digit(((b1 << 4) & 0x30) | ((b2 >> 4) & 0x0F)),
	        has2 ? b64Digit(((b2 << 2) & 0x3C) | ((b3 >> 6) & 0x03)) : "=",
	        has3 ? b64Digit(b3 & 0x3F) : "="
	      ].join("");
	    });
	    return chunks.join("");
	  };
	
	  /**
	   * Reads a File using a FileReader.
	   * @param file {File} the File to read.
	   * @param type {String} (optional) the mimetype to override with.
	   * @return {Parse.Promise} A Promise that will be fulfilled with a
	   *     base64-encoded string of the data and its mime type.
	   */
	  var readAsync = function(file, type) {
	    var promise = new Parse.Promise();
	
	    if (typeof(FileReader) === "undefined") {
	      return Parse.Promise.error(new Parse.Error(
	          Parse.Error.FILE_READ_ERROR,
	          "Attempted to use a FileReader on an unsupported browser."));
	    }
	
	    var reader = new FileReader();
	    reader.onloadend = function() {
	      if (reader.readyState !== 2) {
	        promise.reject(new Parse.Error(
	            Parse.Error.FILE_READ_ERROR,
	            "Error reading file."));
	        return;
	      }
	
	      var dataURL = reader.result;
	      var matches = /^data:([^;]*);base64,(.*)$/.exec(dataURL);
	      if (!matches) {
	        promise.reject(new Parse.Error(
	            Parse.Error.FILE_READ_ERROR,
	            "Unable to interpret data URL: " + dataURL));
	        return;
	      }
	
	      promise.resolve(matches[2], type || matches[1]);
	    };
	    reader.readAsDataURL(file);
	    return promise;
	  };
	
	  /**
	   * A Parse.File is a local representation of a file that is saved to the Parse
	   * cloud.
	   * @class
	   * @param name {String} The file's name. This will be prefixed by a unique
	   *     value once the file has finished saving. The file name must begin with
	   *     an alphanumeric character, and consist of alphanumeric characters,
	   *     periods, spaces, underscores, or dashes.
	   * @param data {Array} The data for the file, as either:
	   *     1. an Array of byte value Numbers, or
	   *     2. an Object like { base64: "..." } with a base64-encoded String.
	   *     3. a File object selected with a file upload control. (3) only works
	   *        in Firefox 3.6+, Safari 6.0.2+, Chrome 7+, and IE 10+.
	   *        For example:<pre>
	   * var fileUploadControl = $("#profilePhotoFileUpload")[0];
	   * if (fileUploadControl.files.length > 0) {
	   *   var file = fileUploadControl.files[0];
	   *   var name = "photo.jpg";
	   *   var parseFile = new Parse.File(name, file);
	   *   parseFile.save().then(function() {
	   *     // The file has been saved to Parse.
	   *   }, function(error) {
	   *     // The file either could not be read, or could not be saved to Parse.
	   *   });
	   * }</pre>
	   * @param type {String} Optional Content-Type header to use for the file. If
	   *     this is omitted, the content type will be inferred from the name's
	   *     extension.
	   */
	  Parse.File = function(name, data, type) {
	    this._name = name;
	
	    // Guess the content type from the extension if we need to.
	    var extension = /\.([^.]*)$/.exec(name);
	    if (extension) {
	      extension = extension[1].toLowerCase();
	    }
	    var specifiedType = type || '';
	
	    if (_.isArray(data)) {
	      this._source = Parse.Promise.as(encodeBase64(data), specifiedType);
	    } else if (data && data.base64) {
	      // if it contains data uri, extract based64 and the type out of it.
	      /*jslint maxlen: 1000*/
	      var dataUriRegexp = /^data:([a-zA-Z]*\/[a-zA-Z+.-]*);(charset=[a-zA-Z0-9\-\/\s]*,)?base64,(\S+)/;
	      /*jslint maxlen: 80*/
	
	      var matches = dataUriRegexp.exec(data.base64);
	      if (matches && matches.length > 0) {
	        // if data URI with charset, there will have 4 matches.
	        this._source = Parse.Promise.as(
	          (matches.length === 4 ? matches[3] : matches[2]), matches[1]
	        );
	      } else {
	        this._source = Parse.Promise.as(data.base64, specifiedType);
	      }
	    } else if (typeof(File) !== "undefined" && data instanceof File) {
	      this._source = readAsync(data, type);
	    } else if (_.isString(data)) {
	      throw "Creating a Parse.File from a String is not yet supported.";
	    }
	  };
	
	  Parse.File.prototype = {
	
	    /**
	     * Gets the name of the file. Before save is called, this is the filename
	     * given by the user. After save is called, that name gets prefixed with a
	     * unique identifier.
	     */
	    name: function() {
	      return this._name;
	    },
	
	    /**
	     * Gets the url of the file. It is only available after you save the file or
	     * after you get the file from a Parse.Object.
	     * @return {String}
	     */
	    url: function() {
	      return this._url;
	    },
	
	    /**
	     * Saves the file to the Parse cloud.
	     * @param {Object} options A Backbone-style options object.
	     * @return {Parse.Promise} Promise that is resolved when the save finishes.
	     */
	    save: function(options) {
	      options= options || {};
	
	      var self = this;
	      if (!self._previousSave) {
	        self._previousSave = self._source.then(function(base64, type) {
	          var data = {
	            base64: base64,
	            _ContentType: type
	          };
	          return Parse._request({
	            route: "files",
	            className: self._name,
	            method: 'POST',
	            data: data,
	            useMasterKey: options.useMasterKey
	          });
	
	        }).then(function(response) {
	          self._name = response.name;
	          self._url = response.url;
	          return self;
	        });
	      }
	      return self._previousSave._thenRunCallbacks(options);
	    }
	  };
	
	}(this));
	
	// Parse.Object is analogous to the Java ParseObject.
	// It also implements the same interface as a Backbone model.
	// TODO: multiple dispatch for callbacks
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Creates a new model with defined attributes. A client id (cid) is
	   * automatically generated and assigned for you.
	   *
	   * <p>You won't normally call this method directly.  It is recommended that
	   * you use a subclass of <code>Parse.Object</code> instead, created by calling
	   * <code>extend</code>.</p>
	   *
	   * <p>However, if you don't want to use a subclass, or aren't sure which
	   * subclass is appropriate, you can use this form:<pre>
	   *     var object = new Parse.Object("ClassName");
	   * </pre>
	   * That is basically equivalent to:<pre>
	   *     var MyClass = Parse.Object.extend("ClassName");
	   *     var object = new MyClass();
	   * </pre></p>
	   *
	   * @param {Object} attributes The initial set of data to store in the object.
	   * @param {Object} options A set of Backbone-like options for creating the
	   *     object.  The only option currently supported is "collection".
	   * @see Parse.Object.extend
	   *
	   * @class
	   *
	   * <p>The fundamental unit of Parse data, which implements the Backbone Model
	   * interface.</p>
	   */
	  Parse.Object = function(attributes, options) {
	    // Allow new Parse.Object("ClassName") as a shortcut to _create.
	    if (_.isString(attributes)) {
	      return Parse.Object._create.apply(this, arguments);
	    }
	
	    attributes = attributes || {};
	    if (options && options.parse) {
	      attributes = this.parse(attributes);
	    }
	    var defaults = Parse._getValue(this, 'defaults');
	    if (defaults) {
	      attributes = _.extend({}, defaults, attributes);
	    }
	    if (options && options.collection) {
	      this.collection = options.collection;
	    }
	
	    this._serverData = {};  // The last known data for this object from cloud.
	    this._opSetQueue = [{}];  // List of sets of changes to the data.
	    this.attributes = {};  // The best estimate of this's current data.
	
	    this._hashedJSON = {};  // Hash of values of containers at last save.
	    this._escapedAttributes = {};
	    this.cid = _.uniqueId('c');
	    this.changed = {};
	    this._silent = {};
	    this._pending = {};
	    if (!this.set(attributes, {silent: true})) {
	      throw new Error("Can't create an invalid Parse.Object");
	    }
	    this.changed = {};
	    this._silent = {};
	    this._pending = {};
	    this._hasData = true;
	    this._previousAttributes = _.clone(this.attributes);
	    this.initialize.apply(this, arguments);
	  };
	
	  /**
	   * The ID of this object, unique within its class.
	   * @name id
	   * @type String
	   * @field
	   * @memberOf Parse.Object.prototype
	   */
	
	  /**
	   * The first time this object was saved on the server.
	   * @name createdAt
	   * @type Date
	   * @field
	   * @memberOf Parse.Object.prototype
	   */
	
	  /**
	   * The last time this object was updated on the server.
	   * @name updatedAt
	   * @type Date
	   * @field
	   * @memberOf Parse.Object.prototype
	   */
	
	  /**
	   * Saves the given list of Parse.Object.
	   * If any error is encountered, stops and calls the error handler.
	   *
	   * <pre>
	   *   Parse.Object.saveAll([object1, object2, ...], {
	   *     success: function(list) {
	   *       // All the objects were saved.
	   *     },
	   *     error: function(error) {
	   *       // An error occurred while saving one of the objects.
	   *     },
	   *   });
	   * </pre>
	   *
	   * @param {Array} list A list of <code>Parse.Object</code>.
	   * @param {Object} options A Backbone-style callback object.
	   * Valid options are:<ul>
	   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	   *     be used for this request.
	   *   <li>sessionToken: A valid session token, used for making a request on
	   *       behalf of a specific user.
	   * </ul>
	   */
	  Parse.Object.saveAll = function(list, options) {
	    options = options || {};
	    return Parse.Object._deepSaveAsync(list, {
	      useMasterKey: options.useMasterKey,
	      sessionToken: options.sessionToken
	    })._thenRunCallbacks(options);
	  };
	
	  /**
	   * Destroy the given list of models on the server if it was already persisted.
	   * Optimistically removes each model from its collection, if it has one.
	   * If `wait: true` is passed, waits for the server to respond before removal.
	   *
	   * <p>Unlike saveAll, if an error occurs while deleting an individual model,
	   * this method will continue trying to delete the rest of the models if
	   * possible, except in the case of a fatal error like a connection error.
	   *
	   * <p>In particular, the Parse.Error object returned in the case of error may
	   * be one of two types:
	   *
	   * <ul>
	   *   <li>A Parse.Error.AGGREGATE_ERROR. This object's "errors" property is an
	   *       array of other Parse.Error objects. Each error object in this array
	   *       has an "object" property that references the object that could not be
	   *       deleted (for instance, because that object could not be found).</li>
	   *   <li>A non-aggregate Parse.Error. This indicates a serious error that
	   *       caused the delete operation to be aborted partway through (for
	   *       instance, a connection failure in the middle of the delete).</li>
	   * </ul>
	   *
	   * <pre>
	   *   Parse.Object.destroyAll([object1, object2, ...], {
	   *     success: function() {
	   *       // All the objects were deleted.
	   *     },
	   *     error: function(error) {
	   *       // An error occurred while deleting one or more of the objects.
	   *       // If this is an aggregate error, then we can inspect each error
	   *       // object individually to determine the reason why a particular
	   *       // object was not deleted.
	   *       if (error.code == Parse.Error.AGGREGATE_ERROR) {
	   *         for (var i = 0; i < error.errors.length; i++) {
	   *           console.log("Couldn't delete " + error.errors[i].object.id +
	   *             "due to " + error.errors[i].message);
	   *         }
	   *       } else {
	   *         console.log("Delete aborted because of " + error.message);
	   *       }
	   *     },
	   *   });
	   * </pre>
	   *
	   * @param {Array} list A list of <code>Parse.Object</code>.
	   * @param {Object} options A Backbone-style callback object.
	   * Valid options are:<ul>
	   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	   *     be used for this request.
	   *   <li>sessionToken: A valid session token, used for making a request on
	   *       behalf of a specific user.
	   * </ul>
	   * @return {Parse.Promise} A promise that is fulfilled when the destroyAll
	   *     completes.
	   */
	  Parse.Object.destroyAll = function(list, options) {
	    options = options || {};
	
	    var triggerDestroy = function(object) {
	      object.trigger('destroy', object, object.collection, options);
	    };
	
	    var errors = [];
	    var destroyBatch = function(batch) {
	      var promise = Parse.Promise.as();
	
	      if (batch.length > 0) {
	        promise = promise.then(function() {
	          return Parse._request({
	            route: "batch",
	            method: "POST",
	            useMasterKey: options.useMasterKey,
	            sessionToken: options.sessionToken,
	            data: {
	              requests: _.map(batch, function(object) {
	                return {
	                  method: "DELETE",
	                  path: "/1/classes/" + object.className + "/" + object.id
	                };
	              })
	            }
	          });
	        }).then(function(responses, status, xhr) {
	          Parse._arrayEach(batch, function(object, i) {
	            if (responses[i].success && options.wait) {
	              triggerDestroy(object);
	            } else if (responses[i].error) {
	              var error = new Parse.Error(responses[i].error.code,
	                                          responses[i].error.error);
	              error.object = object;
	
	              errors.push(error);
	            }
	          });
	        });
	      }
	
	      return promise;
	    };
	
	    var promise = Parse.Promise.as();
	    var batch = [];
	    Parse._arrayEach(list, function(object, i) {
	      if (!object.id || !options.wait) {
	        triggerDestroy(object);
	      }
	
	      if (object.id) {
	        batch.push(object);
	      }
	
	      if (batch.length === 20 || i+1 === list.length) {
	        var thisBatch = batch;
	        batch = [];
	
	        promise = promise.then(function() {
	          return destroyBatch(thisBatch);
	        });
	      }
	    });
	
	    return promise.then(function() {
	      if (errors.length === 0) {
	        return true;
	      } else {
	        var error = new Parse.Error(Parse.Error.AGGREGATE_ERROR,
	                                    "Error deleting an object in destroyAll");
	        error.errors = errors;
	
	        return Parse.Promise.error(error);
	      }
	    })._thenRunCallbacks(options);
	  };
	
	  /**
	   * Fetches the given list of Parse.Object.
	   * If any error is encountered, stops and calls the error handler.
	   *
	   * <pre>
	   *   Parse.Object.fetchAll([object1, object2, ...], {
	   *     success: function(list) {
	   *       // All the objects were fetched.
	   *     },
	   *     error: function(error) {
	   *       // An error occurred while fetching one of the objects.
	   *     },
	   *   });
	   * </pre>
	   *
	   * @param {Array} list A list of <code>Parse.Object</code>.
	   * @param {Object} options A Backbone-style callback object.
	   * Valid options are:<ul>
	   *   <li>success: A Backbone-style success callback.
	   *   <li>error: An Backbone-style error callback.
	   * </ul>
	   */
	  Parse.Object.fetchAll = function(list, options) {
	    return Parse.Object._fetchAll(
	      list,
	      true
	    )._thenRunCallbacks(options);
	  };
	
	  /**
	   * Fetches the given list of Parse.Object if needed.
	   * If any error is encountered, stops and calls the error handler.
	   *
	   * <pre>
	   *   Parse.Object.fetchAllIfNeeded([object1, ...], {
	   *     success: function(list) {
	   *       // Objects were fetched and updated.
	   *     },
	   *     error: function(error) {
	   *       // An error occurred while fetching one of the objects.
	   *     },
	   *   });
	   * </pre>
	   *
	   * @param {Array} list A list of <code>Parse.Object</code>.
	   * @param {Object} options A Backbone-style callback object.
	   * Valid options are:<ul>
	   *   <li>success: A Backbone-style success callback.
	   *   <li>error: An Backbone-style error callback.
	   * </ul>
	   */
	  Parse.Object.fetchAllIfNeeded = function(list, options) {
	    return Parse.Object._fetchAll(
	      list,
	      false
	    )._thenRunCallbacks(options);
	  };
	
	  // Attach all inheritable methods to the Parse.Object prototype.
	  _.extend(Parse.Object.prototype, Parse.Events,
	           /** @lends Parse.Object.prototype */ {
	    _existed: false,
	
	    /**
	     * Initialize is an empty function by default. Override it with your own
	     * initialization logic.
	     */
	    initialize: function(){},
	
	    /**
	     * Returns a JSON version of the object suitable for saving to Parse.
	     * @return {Object}
	     */
	    toJSON: function() {
	      var json = this._toFullJSON();
	      Parse._arrayEach(["__type", "className"],
	                       function(key) { delete json[key]; });
	      return json;
	    },
	
	    _toFullJSON: function(seenObjects) {
	      var json = _.clone(this.attributes);
	      Parse._objectEach(json, function(val, key) {
	        json[key] = Parse._encode(val, seenObjects);
	      });
	      Parse._objectEach(this._operations, function(val, key) {
	        json[key] = val;
	      });
	
	      if (_.has(this, "id")) {
	        json.objectId = this.id;
	      }
	      if (_.has(this, "createdAt")) {
	        if (_.isDate(this.createdAt)) {
	          json.createdAt = this.createdAt.toJSON();
	        } else {
	          json.createdAt = this.createdAt;
	        }
	      }
	
	      if (_.has(this, "updatedAt")) {
	        if (_.isDate(this.updatedAt)) {
	          json.updatedAt = this.updatedAt.toJSON();
	        } else {
	          json.updatedAt = this.updatedAt;
	        }
	      }
	      json.__type = "Object";
	      json.className = this.className;
	      return json;
	    },
	
	    /**
	     * Updates _hashedJSON to reflect the current state of this object.
	     * Adds any changed hash values to the set of pending changes.
	     */
	    _refreshCache: function() {
	      var self = this;
	      if (self._refreshingCache) {
	        return;
	      }
	      self._refreshingCache = true;
	      Parse._objectEach(this.attributes, function(value, key) {
	        if (value instanceof Parse.Object) {
	          value._refreshCache();
	        } else if (_.isObject(value)) {
	          var objectArray = false;
	          if (_.isArray(value)) {
	            // We don't cache arrays of Parse.Objects
	            _.each(value, function(arrVal) {
	              if (arrVal instanceof Parse.Object) {
	                objectArray = true;
	                arrVal._refreshCache();
	              }
	            });
	          }
	          if (!objectArray && self._resetCacheForKey(key)) {
	            self.set(key, new Parse.Op.Set(value), { silent: true });
	          }
	        }
	      });
	      delete self._refreshingCache;
	    },
	
	    /**
	     * Returns true if this object has been modified since its last
	     * save/refresh.  If an attribute is specified, it returns true only if that
	     * particular attribute has been modified since the last save/refresh.
	     * @param {String} attr An attribute name (optional).
	     * @return {Boolean}
	     */
	    dirty: function(attr) {
	      this._refreshCache();
	
	      var currentChanges = _.last(this._opSetQueue);
	
	      if (attr) {
	        return (currentChanges[attr] ? true : false);
	      }
	      if (!this.id) {
	        return true;
	      }
	      if (_.keys(currentChanges).length > 0) {
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Returns an array of keys that have been modified since last save/refresh
	     * @return {Array of string}
	     */
	    dirtyKeys: function() {
	      return _.keys(_.last(this._opSetQueue));
	    },
	
	    /**
	     * Gets a Pointer referencing this Object.
	     */
	    _toPointer: function() {
	      if (!this.id) {
	        throw new Error("Can't serialize an unsaved Parse.Object");
	      }
	      return { __type: "Pointer",
	               className: this.className,
	               objectId: this.id };
	    },
	
	    /**
	     * Gets the value of an attribute.
	     * @param {String} attr The string name of an attribute.
	     */
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    /**
	     * Gets a relation on the given class for the attribute.
	     * @param String attr The attribute to get the relation for.
	     */
	    relation: function(attr) {
	      var value = this.get(attr);
	      if (value) {
	        if (!(value instanceof Parse.Relation)) {
	          throw "Called relation() on non-relation field " + attr;
	        }
	        value._ensureParentAndKey(this, attr);
	        return value;
	      } else {
	        return new Parse.Relation(this, attr);
	      }
	    },
	
	    /**
	     * Gets the HTML-escaped value of an attribute.
	     */
	    escape: function(attr) {
	      var html = this._escapedAttributes[attr];
	      if (html) {
	        return html;
	      }
	      var val = this.attributes[attr];
	      var escaped;
	      if (Parse._isNullOrUndefined(val)) {
	        escaped = '';
	      } else {
	        escaped = _.escape(val.toString());
	      }
	      this._escapedAttributes[attr] = escaped;
	      return escaped;
	    },
	
	    /**
	     * Returns <code>true</code> if the attribute contains a value that is not
	     * null or undefined.
	     * @param {String} attr The string name of the attribute.
	     * @return {Boolean}
	     */
	    has: function(attr) {
	      return !Parse._isNullOrUndefined(this.attributes[attr]);
	    },
	
	    /**
	     * Pulls "special" fields like objectId, createdAt, etc. out of attrs
	     * and puts them on "this" directly.  Removes them from attrs.
	     * @param attrs - A dictionary with the data for this Parse.Object.
	     */
	    _mergeMagicFields: function(attrs) {
	      // Check for changes of magic fields.
	      var model = this;
	      var specialFields = ["id", "objectId", "createdAt", "updatedAt"];
	      Parse._arrayEach(specialFields, function(attr) {
	        if (attrs[attr]) {
	          if (attr === "objectId") {
	            model.id = attrs[attr];
	          } else if ((attr === "createdAt" || attr === "updatedAt") &&
	                     !_.isDate(attrs[attr])) {
	            model[attr] = Parse._parseDate(attrs[attr]);
	          } else {
	            model[attr] = attrs[attr];
	          }
	          delete attrs[attr];
	        }
	      });
	    },
	
	    /**
	     * Copies the given serverData to "this", refreshes attributes, and
	     * clears pending changes;
	     */
	    _copyServerData: function(serverData) {
	      // Copy server data
	      var tempServerData = {};
	      Parse._objectEach(serverData, function(value, key) {
	        tempServerData[key] = Parse._decode(key, value);
	      });
	      this._serverData = tempServerData;
	
	      // Refresh the attributes.
	      this._rebuildAllEstimatedData();
	
	      // TODO (bklimt): Revisit clearing operations, perhaps move to revert.
	      // Clear out any changes the user might have made previously.
	      this._refreshCache();
	      this._opSetQueue = [{}];
	
	      // Refresh the attributes again.
	      this._rebuildAllEstimatedData();
	    },
	
	    /**
	     * Merges another object's attributes into this object.
	     */
	    _mergeFromObject: function(other) {
	      if (!other) {
	        return;
	      }
	
	      // This does the inverse of _mergeMagicFields.
	      this.id = other.id;
	      this.createdAt = other.createdAt;
	      this.updatedAt = other.updatedAt;
	
	      this._copyServerData(other._serverData);
	
	      this._hasData = true;
	    },
	
	    /**
	     * Returns the json to be sent to the server.
	     */
	    _startSave: function() {
	      this._opSetQueue.push({});
	    },
	
	    /**
	     * Called when a save fails because of an error. Any changes that were part
	     * of the save need to be merged with changes made after the save. This
	     * might throw an exception is you do conflicting operations. For example,
	     * if you do:
	     *   object.set("foo", "bar");
	     *   object.set("invalid field name", "baz");
	     *   object.save();
	     *   object.increment("foo");
	     * then this will throw when the save fails and the client tries to merge
	     * "bar" with the +1.
	     */
	    _cancelSave: function() {
	      var self = this;
	      var failedChanges = _.first(this._opSetQueue);
	      this._opSetQueue = _.rest(this._opSetQueue);
	      var nextChanges = _.first(this._opSetQueue);
	      Parse._objectEach(failedChanges, function(op, key) {
	        var op1 = failedChanges[key];
	        var op2 = nextChanges[key];
	        if (op1 && op2) {
	          nextChanges[key] = op2._mergeWithPrevious(op1);
	        } else if (op1) {
	          nextChanges[key] = op1;
	        }
	      });
	      this._saving = this._saving - 1;
	    },
	
	    /**
	     * Called when a save completes successfully. This merges the changes that
	     * were saved into the known server data, and overrides it with any data
	     * sent directly from the server.
	     */
	    _finishSave: function(serverData) {
	      // Grab a copy of any object referenced by this object. These instances
	      // may have already been fetched, and we don't want to lose their data.
	      // Note that doing it like this means we will unify separate copies of the
	      // same object, but that's a risk we have to take.
	      var fetchedObjects = {};
	      Parse._traverse(this.attributes, function(object) {
	        if (object instanceof Parse.Object && object.id && object._hasData) {
	          fetchedObjects[object.id] = object;
	        }
	      });
	
	      var savedChanges = _.first(this._opSetQueue);
	      this._opSetQueue = _.rest(this._opSetQueue);
	      this._applyOpSet(savedChanges, this._serverData);
	      this._mergeMagicFields(serverData);
	      var self = this;
	      Parse._objectEach(serverData, function(value, key) {
	        self._serverData[key] = Parse._decode(key, value);
	
	        // Look for any objects that might have become unfetched and fix them
	        // by replacing their values with the previously observed values.
	        var fetched = Parse._traverse(self._serverData[key], function(object) {
	          if (object instanceof Parse.Object && fetchedObjects[object.id]) {
	            return fetchedObjects[object.id];
	          }
	        });
	        if (fetched) {
	          self._serverData[key] = fetched;
	        }
	      });
	      this._rebuildAllEstimatedData();
	      this._saving = this._saving - 1;
	    },
	
	    /**
	     * Called when a fetch or login is complete to set the known server data to
	     * the given object.
	     */
	    _finishFetch: function(serverData, hasData) {
	      // TODO (bklimt): Revisit clearing operations, perhaps move to revert.
	      this._opSetQueue = [{}];
	
	      // Bring in all the new server data.
	      this._mergeMagicFields(serverData);
	      this._copyServerData(serverData);
	
	      this._hasData = hasData;
	    },
	
	    /**
	     * Applies the set of Parse.Op in opSet to the object target.
	     */
	    _applyOpSet: function(opSet, target) {
	      var self = this;
	      Parse._objectEach(opSet, function(change, key) {
	        target[key] = change._estimate(target[key], self, key);
	        if (target[key] === Parse.Op._UNSET) {
	          delete target[key];
	        }
	      });
	    },
	
	    /**
	     * Replaces the cached value for key with the current value.
	     * Returns true if the new value is different than the old value.
	     */
	    _resetCacheForKey: function(key) {
	      var value = this.attributes[key];
	      if (_.isObject(value) &&
	          !(value instanceof Parse.Object) &&
	          !(value instanceof Parse.File)) {
	        value = value.toJSON ? value.toJSON() : value;
	        var json = JSON.stringify(value);
	        if (this._hashedJSON[key] !== json) {
	          var wasSet = !!this._hashedJSON[key];
	          this._hashedJSON[key] = json;
	          return wasSet;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Populates attributes[key] by starting with the last known data from the
	     * server, and applying all of the local changes that have been made to that
	     * key since then.
	     */
	    _rebuildEstimatedDataForKey: function(key) {
	      var self = this;
	      delete this.attributes[key];
	      if (this._serverData[key]) {
	        this.attributes[key] = this._serverData[key];
	      }
	      Parse._arrayEach(this._opSetQueue, function(opSet) {
	        var op = opSet[key];
	        if (op) {
	          self.attributes[key] = op._estimate(self.attributes[key], self, key);
	          if (self.attributes[key] === Parse.Op._UNSET) {
	            delete self.attributes[key];
	          } else {
	            self._resetCacheForKey(key);
	          }
	        }
	      });
	    },
	
	    /**
	     * Populates attributes by starting with the last known data from the
	     * server, and applying all of the local changes that have been made since
	     * then.
	     */
	    _rebuildAllEstimatedData: function() {
	      var self = this;
	
	      var previousAttributes = _.clone(this.attributes);
	
	      this.attributes = _.clone(this._serverData);
	      Parse._arrayEach(this._opSetQueue, function(opSet) {
	        self._applyOpSet(opSet, self.attributes);
	        Parse._objectEach(opSet, function(op, key) {
	          self._resetCacheForKey(key);
	        });
	      });
	
	      // Trigger change events for anything that changed because of the fetch.
	      Parse._objectEach(previousAttributes, function(oldValue, key) {
	        if (self.attributes[key] !== oldValue) {
	          self.trigger('change:' + key, self, self.attributes[key], {});
	        }
	      });
	      Parse._objectEach(this.attributes, function(newValue, key) {
	        if (!_.has(previousAttributes, key)) {
	          self.trigger('change:' + key, self, newValue, {});
	        }
	      });
	    },
	
	    /**
	     * Sets a hash of model attributes on the object, firing
	     * <code>"change"</code> unless you choose to silence it.
	     *
	     * <p>You can call it with an object containing keys and values, or with one
	     * key and value.  For example:<pre>
	     *   gameTurn.set({
	     *     player: player1,
	     *     diceRoll: 2
	     *   }, {
	     *     error: function(gameTurnAgain, error) {
	     *       // The set failed validation.
	     *     }
	     *   });
	     *
	     *   game.set("currentPlayer", player2, {
	     *     error: function(gameTurnAgain, error) {
	     *       // The set failed validation.
	     *     }
	     *   });
	     *
	     *   game.set("finished", true);</pre></p>
	     *
	     * @param {String} key The key to set.
	     * @param {} value The value to give it.
	     * @param {Object} options A set of Backbone-like options for the set.
	     *     The only supported options are <code>silent</code>,
	     *     <code>error</code>, and <code>promise</code>.
	     * @return {Boolean} true if the set succeeded.
	     * @see Parse.Object#validate
	     * @see Parse.Error
	     */
	    set: function(key, value, options) {
	      var attrs, attr;
	      if (_.isObject(key) || Parse._isNullOrUndefined(key)) {
	        attrs = key;
	        Parse._objectEach(attrs, function(v, k) {
	          attrs[k] = Parse._decode(k, v);
	        });
	        options = value;
	      } else {
	        attrs = {};
	        attrs[key] = Parse._decode(key, value);
	      }
	
	      // Extract attributes and options.
	      options = options || {};
	      if (!attrs) {
	        return this;
	      }
	      if (attrs instanceof Parse.Object) {
	        attrs = attrs.attributes;
	      }
	
	      var self = this;
	      Parse._objectEach(attrs, function(unused_value, key) {
	        if (self.constructor.readOnlyAttributes &&
	          self.constructor.readOnlyAttributes[key]) {
	          throw new Error('Cannot modify readonly key: ' + key);
	        }
	      });
	
	      // If the unset option is used, every attribute should be a Unset.
	      if (options.unset) {
	        Parse._objectEach(attrs, function(unused_value, key) {
	          attrs[key] = new Parse.Op.Unset();
	        });
	      }
	
	      // Apply all the attributes to get the estimated values.
	      var dataToValidate = _.clone(attrs);
	      Parse._objectEach(dataToValidate, function(value, key) {
	        if (value instanceof Parse.Op) {
	          dataToValidate[key] = value._estimate(self.attributes[key],
	                                                self, key);
	          if (dataToValidate[key] === Parse.Op._UNSET) {
	            delete dataToValidate[key];
	          }
	        }
	      });
	
	      // Run validation.
	      if (!this._validate(attrs, options)) {
	        return false;
	      }
	
	      this._mergeMagicFields(attrs);
	
	      options.changes = {};
	      var escaped = this._escapedAttributes;
	      var prev = this._previousAttributes || {};
	
	      // Update attributes.
	      Parse._arrayEach(_.keys(attrs), function(attr) {
	        var val = attrs[attr];
	
	        // If this is a relation object we need to set the parent correctly,
	        // since the location where it was parsed does not have access to
	        // this object.
	        if (val instanceof Parse.Relation) {
	          val.parent = self;
	        }
	
	        if (!(val instanceof Parse.Op)) {
	          val = new Parse.Op.Set(val);
	        }
	
	        // See if this change will actually have any effect.
	        var isRealChange = true;
	        if (val instanceof Parse.Op.Set &&
	            _.isEqual(self.attributes[attr], val.value)) {
	          isRealChange = false;
	        }
	
	        if (isRealChange) {
	          delete escaped[attr];
	          if (options.silent) {
	            self._silent[attr] = true;
	          } else {
	            options.changes[attr] = true;
	          }
	        }
	
	        var currentChanges = _.last(self._opSetQueue);
	        currentChanges[attr] = val._mergeWithPrevious(currentChanges[attr]);
	        self._rebuildEstimatedDataForKey(attr);
	
	        if (isRealChange) {
	          self.changed[attr] = self.attributes[attr];
	          if (!options.silent) {
	            self._pending[attr] = true;
	          }
	        } else {
	          delete self.changed[attr];
	          delete self._pending[attr];
	        }
	      });
	
	      if (!options.silent) {
	        this.change(options);
	      }
	      return this;
	    },
	
	    /**
	     * Remove an attribute from the model, firing <code>"change"</code> unless
	     * you choose to silence it. This is a noop if the attribute doesn't
	     * exist.
	     */
	    unset: function(attr, options) {
	      options = options || {};
	      options.unset = true;
	      return this.set(attr, null, options);
	    },
	
	    /**
	     * Atomically increments the value of the given attribute the next time the
	     * object is saved. If no amount is specified, 1 is used by default.
	     *
	     * @param attr {String} The key.
	     * @param amount {Number} The amount to increment by.
	     */
	    increment: function(attr, amount) {
	      if (_.isUndefined(amount) || _.isNull(amount)) {
	        amount = 1;
	      }
	      return this.set(attr, new Parse.Op.Increment(amount));
	    },
	
	    /**
	     * Atomically add an object to the end of the array associated with a given
	     * key.
	     * @param attr {String} The key.
	     * @param item {} The item to add.
	     */
	    add: function(attr, item) {
	      return this.set(attr, new Parse.Op.Add([item]));
	    },
	
	    /**
	     * Atomically add an object to the array associated with a given key, only
	     * if it is not already present in the array. The position of the insert is
	     * not guaranteed.
	     *
	     * @param attr {String} The key.
	     * @param item {} The object to add.
	     */
	    addUnique: function(attr, item) {
	      return this.set(attr, new Parse.Op.AddUnique([item]));
	    },
	
	    /**
	     * Atomically remove all instances of an object from the array associated
	     * with a given key.
	     *
	     * @param attr {String} The key.
	     * @param item {} The object to remove.
	     */
	    remove: function(attr, item) {
	      return this.set(attr, new Parse.Op.Remove([item]));
	    },
	
	    /**
	     * Returns an instance of a subclass of Parse.Op describing what kind of
	     * modification has been performed on this field since the last time it was
	     * saved. For example, after calling object.increment("x"), calling
	     * object.op("x") would return an instance of Parse.Op.Increment.
	     *
	     * @param attr {String} The key.
	     * @returns {Parse.Op} The operation, or undefined if none.
	     */
	    op: function(attr) {
	      return _.last(this._opSetQueue)[attr];
	    },
	
	    /**
	     * Clear all attributes on the model, firing <code>"change"</code> unless
	     * you choose to silence it.
	     */
	    clear: function(options) {
	      options = options || {};
	      options.unset = true;
	      var keysToClear = _.extend(this.attributes, this._operations);
	      return this.set(keysToClear, options);
	    },
	
	    /**
	     * Returns a JSON-encoded set of operations to be sent with the next save
	     * request.
	     */
	    _getSaveJSON: function() {
	      var json = _.clone(_.first(this._opSetQueue));
	      Parse._objectEach(json, function(op, key) {
	        json[key] = op.toJSON();
	      });
	      return json;
	    },
	
	    /**
	     * Returns true if this object can be serialized for saving.
	     */
	    _canBeSerialized: function() {
	      return Parse.Object._canBeSerializedAsValue(this.attributes);
	    },
	
	    /**
	     * Fetch the model from the server. If the server's representation of the
	     * model differs from its current attributes, they will be overriden,
	     * triggering a <code>"change"</code> event.
	     *
	     * @param {Object} options A Backbone-style callback object.
	     * Valid options are:<ul>
	     *   <li>success: A Backbone-style success callback.
	     *   <li>error: An Backbone-style error callback.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     * @return {Parse.Promise} A promise that is fulfilled when the fetch
	     *     completes.
	     */
	    fetch: function(options) {
	      var self = this;
	      options = options || {};
	      var request = Parse._request({
	        method: 'GET',
	        route: "classes",
	        className: this.className,
	        objectId: this.id,
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken
	      });
	      return request.then(function(response, status, xhr) {
	        self._finishFetch(self.parse(response, status, xhr), true);
	        return self;
	      })._thenRunCallbacks(options, this);
	    },
	
	    /**
	     * Set a hash of model attributes, and save the model to the server.
	     * updatedAt will be updated when the request returns.
	     * You can either call it as:<pre>
	     *   object.save();</pre>
	     * or<pre>
	     *   object.save(null, options);</pre>
	     * or<pre>
	     *   object.save(attrs, options);</pre>
	     * or<pre>
	     *   object.save(key, value, options);</pre>
	     *
	     * For example, <pre>
	     *   gameTurn.save({
	     *     player: "Jake Cutter",
	     *     diceRoll: 2
	     *   }, {
	     *     success: function(gameTurnAgain) {
	     *       // The save was successful.
	     *     },
	     *     error: function(gameTurnAgain, error) {
	     *       // The save failed.  Error is an instance of Parse.Error.
	     *     }
	     *   });</pre>
	     * or with promises:<pre>
	     *   gameTurn.save({
	     *     player: "Jake Cutter",
	     *     diceRoll: 2
	     *   }).then(function(gameTurnAgain) {
	     *     // The save was successful.
	     *   }, function(error) {
	     *     // The save failed.  Error is an instance of Parse.Error.
	     *   });</pre>
	     *
	     * @param {Object} options A Backbone-style callback object.
	     * Valid options are:<ul>
	     *   <li>wait: Set to true to wait for the server to confirm a successful
	     *   save before modifying the attributes on the object.
	     *   <li>silent: Set to true to avoid firing the `set` event.
	     *   <li>success: A Backbone-style success callback.
	     *   <li>error: An Backbone-style error callback.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     * @return {Parse.Promise} A promise that is fulfilled when the save
	     *     completes.
	     * @see Parse.Error
	     */
	    save: function(arg1, arg2, arg3) {
	      var i, attrs, current, options, saved;
	      if (_.isObject(arg1) || Parse._isNullOrUndefined(arg1)) {
	        attrs = arg1;
	        options = arg2;
	      } else {
	        attrs = {};
	        attrs[arg1] = arg2;
	        options = arg3;
	      }
	
	      // Make save({ success: function() {} }) work.
	      if (!options && attrs) {
	        var extra_keys = _.reject(attrs, function(value, key) {
	          return _.include(["success", "error", "wait"], key);
	        });
	        if (extra_keys.length === 0) {
	          var all_functions = true;
	          if (_.has(attrs, "success") && !_.isFunction(attrs.success)) {
	            all_functions = false;
	          }
	          if (_.has(attrs, "error") && !_.isFunction(attrs.error)) {
	            all_functions = false;
	          }
	          if (all_functions) {
	            // This attrs object looks like it's really an options object,
	            // and there's no other options object, so let's just use it.
	            return this.save(null, attrs);
	          }
	        }
	      }
	
	      options = _.clone(options) || {};
	      if (options.wait) {
	        current = _.clone(this.attributes);
	      }
	
	      var setOptions = _.clone(options) || {};
	      if (setOptions.wait) {
	        setOptions.silent = true;
	      }
	      var setError;
	      setOptions.error = function(model, error) {
	        setError = error;
	      };
	      if (attrs && !this.set(attrs, setOptions)) {
	        return Parse.Promise.error(setError)._thenRunCallbacks(options, this);
	      }
	
	      var model = this;
	
	      // If there is any unsaved child, save it first.
	      model._refreshCache();
	
	      // TODO(klimt): Refactor this so that the save starts now, not later.
	
	      var unsavedChildren = [];
	      var unsavedFiles = [];
	      Parse.Object._findUnsavedChildren(model.attributes,
	                                        unsavedChildren,
	                                        unsavedFiles);
	      if (unsavedChildren.length + unsavedFiles.length > 0) {
	        return Parse.Object._deepSaveAsync(this.attributes, {
	          useMasterKey: options.useMasterKey,
	          sessionToken: options.sessionToken
	        }).then(function() {
	          return model.save(null, options);
	        }, function(error) {
	          return Parse.Promise.error(error)._thenRunCallbacks(options, model);
	        });
	      }
	
	      this._startSave();
	      this._saving = (this._saving || 0) + 1;
	
	      this._allPreviousSaves = this._allPreviousSaves || Parse.Promise.as();
	      this._allPreviousSaves = this._allPreviousSaves._continueWith(function() {
	        var method = model.id ? 'PUT' : 'POST';
	
	        var json = model._getSaveJSON();
	
	        var route = "classes";
	        var className = model.className;
	        if (model.className === "_User" && !model.id) {
	          // Special-case user sign-up.
	          route = "users";
	          className = null;
	        }
	        var request = Parse._request({
	          route: route,
	          className: className,
	          objectId: model.id,
	          method: method,
	          useMasterKey: options.useMasterKey,
	          sessionToken: options.sessionToken,
	          data: json
	        });
	
	        request = request.then(function(resp, status, xhr) {
	          var serverAttrs = model.parse(resp, status, xhr);
	          if (options.wait) {
	            serverAttrs = _.extend(attrs || {}, serverAttrs);
	          }
	          model._finishSave(serverAttrs);
	          if (options.wait) {
	            model.set(current, setOptions);
	          }
	          return model;
	
	        }, function(error) {
	          model._cancelSave();
	          return Parse.Promise.error(error);
	
	        })._thenRunCallbacks(options, model);
	
	        return request;
	      });
	      return this._allPreviousSaves;
	    },
	
	    /**
	     * Destroy this model on the server if it was already persisted.
	     * Optimistically removes the model from its collection, if it has one.
	     * If `wait: true` is passed, waits for the server to respond
	     * before removal.
	     *
	     * @param {Object} options A Backbone-style callback object.
	     * Valid options are:<ul>
	     *   <li>wait: Set to true to wait for the server to confirm successful
	     *   deletion of the object before triggering the `destroy` event.
	     *   <li>success: A Backbone-style success callback
	     *   <li>error: An Backbone-style error callback.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     * @return {Parse.Promise} A promise that is fulfilled when the destroy
	     *     completes.
	     */
	    destroy: function(options) {
	      options = options || {};
	      var model = this;
	
	      var triggerDestroy = function() {
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      if (!this.id) {
	        return triggerDestroy();
	      }
	
	      if (!options.wait) {
	        triggerDestroy();
	      }
	
	      var request = Parse._request({
	        route: "classes",
	        className: this.className,
	        objectId: this.id,
	        method: 'DELETE',
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken
	      });
	      return request.then(function() {
	        if (options.wait) {
	          triggerDestroy();
	        }
	        return model;
	      })._thenRunCallbacks(options, this);
	    },
	
	    /**
	     * Converts a response into the hash of attributes to be set on the model.
	     * @ignore
	     */
	    parse: function(resp, status, xhr) {
	      var output = _.clone(resp);
	      _(["createdAt", "updatedAt"]).each(function(key) {
	        if (output[key]) {
	          output[key] = Parse._parseDate(output[key]);
	        }
	      });
	      if (!output.updatedAt) {
	        output.updatedAt = output.createdAt;
	      }
	      if (status) {
	        this._existed = (status !== 201);
	      }
	      return output;
	    },
	
	    /**
	     * Creates a new model with identical attributes to this one.
	     * @return {Parse.Object}
	     */
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    /**
	     * Returns true if this object has never been saved to Parse.
	     * @return {Boolean}
	     */
	    isNew: function() {
	      return !this.id;
	    },
	
	    /**
	     * Call this method to manually fire a `"change"` event for this model and
	     * a `"change:attribute"` event for each changed attribute.
	     * Calling this will cause all objects observing the model to update.
	     */
	    change: function(options) {
	      options = options || {};
	      var changing = this._changing;
	      this._changing = true;
	
	      // Silent changes become pending changes.
	      var self = this;
	      Parse._objectEach(this._silent, function(attr) {
	        self._pending[attr] = true;
	      });
	
	      // Silent changes are triggered.
	      var changes = _.extend({}, options.changes, this._silent);
	      this._silent = {};
	      Parse._objectEach(changes, function(unused_value, attr) {
	        self.trigger('change:' + attr, self, self.get(attr), options);
	      });
	      if (changing) {
	        return this;
	      }
	
	      // This is to get around lint not letting us make a function in a loop.
	      var deleteChanged = function(value, attr) {
	        if (!self._pending[attr] && !self._silent[attr]) {
	          delete self.changed[attr];
	        }
	      };
	
	      // Continue firing `"change"` events while there are pending changes.
	      while (!_.isEmpty(this._pending)) {
	        this._pending = {};
	        this.trigger('change', this, options);
	        // Pending and silent changes still remain.
	        Parse._objectEach(this.changed, deleteChanged);
	        self._previousAttributes = _.clone(this.attributes);
	      }
	
	      this._changing = false;
	      return this;
	    },
	
	    /**
	     * Returns true if this object was created by the Parse server when the
	     * object might have already been there (e.g. in the case of a Facebook
	     * login)
	     */
	    existed: function() {
	      return this._existed;
	    },
	
	    /**
	     * Determine if the model has changed since the last <code>"change"</code>
	     * event.  If you specify an attribute name, determine if that attribute
	     * has changed.
	     * @param {String} attr Optional attribute name
	     * @return {Boolean}
	     */
	    hasChanged: function(attr) {
	      if (!arguments.length) {
	        return !_.isEmpty(this.changed);
	      }
	      return this.changed && _.has(this.changed, attr);
	    },
	
	    /**
	     * Returns an object containing all the attributes that have changed, or
	     * false if there are no changed attributes. Useful for determining what
	     * parts of a view need to be updated and/or what attributes need to be
	     * persisted to the server. Unset attributes will be set to undefined.
	     * You can also pass an attributes object to diff against the model,
	     * determining if there *would be* a change.
	     */
	    changedAttributes: function(diff) {
	      if (!diff) {
	        return this.hasChanged() ? _.clone(this.changed) : false;
	      }
	      var changed = {};
	      var old = this._previousAttributes;
	      Parse._objectEach(diff, function(diffVal, attr) {
	        if (!_.isEqual(old[attr], diffVal)) {
	          changed[attr] = diffVal;
	        }
	      });
	      return changed;
	    },
	
	    /**
	     * Gets the previous value of an attribute, recorded at the time the last
	     * <code>"change"</code> event was fired.
	     * @param {String} attr Name of the attribute to get.
	     */
	    previous: function(attr) {
	      if (!arguments.length || !this._previousAttributes) {
	        return null;
	      }
	      return this._previousAttributes[attr];
	    },
	
	    /**
	     * Gets all of the attributes of the model at the time of the previous
	     * <code>"change"</code> event.
	     * @return {Object}
	     */
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    /**
	     * Checks if the model is currently in a valid state. It's only possible to
	     * get into an *invalid* state if you're using silent changes.
	     * @return {Boolean}
	     */
	    isValid: function() {
	      return !this.validate(this.attributes);
	    },
	
	    /**
	     * You should not call this function directly unless you subclass
	     * <code>Parse.Object</code>, in which case you can override this method
	     * to provide additional validation on <code>set</code> and
	     * <code>save</code>.  Your implementation should return
	     *
	     * @param {Object} attrs The current data to validate.
	     * @param {Object} options A Backbone-like options object.
	     * @return {} False if the data is valid.  An error object otherwise.
	     * @see Parse.Object#set
	     */
	    validate: function(attrs, options) {
	      if (_.has(attrs, "ACL") && !(attrs.ACL instanceof Parse.ACL)) {
	        return new Parse.Error(Parse.Error.OTHER_CAUSE,
	                               "ACL must be a Parse.ACL.");
	      }
	      var correct = true;
	      Parse._objectEach(attrs, function(unused_value, key) {
	        if (!(/^[A-Za-z][0-9A-Za-z_]*$/).test(key)) {
	          correct = false;
	        }
	      });
	      if (!correct) {
	        return new Parse.Error(Parse.Error.INVALID_KEY_NAME);
	      }
	      return false;
	    },
	
	    /**
	     * Run validation against a set of incoming attributes, returning `true`
	     * if all is well. If a specific `error` callback has been passed,
	     * call that instead of firing the general `"error"` event.
	     */
	    _validate: function(attrs, options) {
	      if (options.silent || !this.validate) {
	        return true;
	      }
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validate(attrs, options);
	      if (!error) {
	        return true;
	      }
	      if (options && options.error) {
	        options.error(this, error, options);
	      } else {
	        this.trigger('error', this, error, options);
	      }
	      return false;
	    },
	
	    /**
	     * Returns the ACL for this object.
	     * @returns {Parse.ACL} An instance of Parse.ACL.
	     * @see Parse.Object#get
	     */
	    getACL: function() {
	      return this.get("ACL");
	    },
	
	    /**
	     * Sets the ACL to be used for this object.
	     * @param {Parse.ACL} acl An instance of Parse.ACL.
	     * @param {Object} options Optional Backbone-like options object to be
	     *     passed in to set.
	     * @return {Boolean} Whether the set passed validation.
	     * @see Parse.Object#set
	     */
	    setACL: function(acl, options) {
	      return this.set("ACL", acl, options);
	    }
	
	  });
	
	  /**
	   * Returns the appropriate subclass for making new instances of the given
	   * className string.
	   */
	  Parse.Object._getSubclass = function(className) {
	    if (!_.isString(className)) {
	      throw "Parse.Object._getSubclass requires a string argument.";
	    }
	    var ObjectClass = Parse.Object._classMap[className];
	    if (!ObjectClass) {
	      ObjectClass = Parse.Object.extend(className);
	      Parse.Object._classMap[className] = ObjectClass;
	    }
	    return ObjectClass;
	  };
	
	  /**
	   * Creates an instance of a subclass of Parse.Object for the given classname.
	   */
	  Parse.Object._create = function(className, attributes, options) {
	    var ObjectClass = Parse.Object._getSubclass(className);
	    return new ObjectClass(attributes, options);
	  };
	
	  /**
	   * Returns a list of object ids given a list of objects.
	   */
	  Parse.Object._toObjectIdArray = function(list, omitObjectsWithData) {
	    if (list.length === 0) {
	      return Parse.Promise.as(list);
	    }
	
	    var error;
	    var className = list[0].className;
	    var objectIds = [];
	    for (var i = 0; i < list.length; i++) {
	      var object = list[i];
	      if (className !== object.className) {
	        error = new Parse.Error(Parse.Error.INVALID_CLASS_NAME,
	                                "All objects should be of the same class");
	        return Parse.Promise.error(error);
	      } else if (!object.id) {
	        error = new Parse.Error(Parse.Error.MISSING_OBJECT_ID,
	                                "All objects must have an ID");
	        return Parse.Promise.error(error);
	      } else if (omitObjectsWithData && object._hasData) {
	        continue;
	      }
	      objectIds.push(object.id);
	    }
	
	    return Parse.Promise.as(objectIds);
	  };
	
	  /**
	   * Updates a list of objects with fetched results.
	   */
	  Parse.Object._updateWithFetchedResults = function(list, fetched, forceFetch) {
	    var fetchedObjectsById = {};
	    Parse._arrayEach(fetched, function(object, i) {
	      fetchedObjectsById[object.id] = object;
	    });
	
	    for (var i = 0; i < list.length; i++) {
	      var object = list[i];
	      var fetchedObject = fetchedObjectsById[object.id];
	      if (!fetchedObject && forceFetch) {
	        var error = new Parse.Error(Parse.Error.OBJECT_NOT_FOUND,
	                                "All objects must exist on the server");
	        return Parse.Promise.error(error);
	      }
	
	      object._mergeFromObject(fetchedObject);
	    }
	
	    return Parse.Promise.as(list);
	  };
	
	  /**
	   * Fetches the objects given in list.  The forceFetch option will fetch all
	   * objects if true and ignore objects with data if false.
	   */
	  Parse.Object._fetchAll = function(list, forceFetch) {
	    if (list.length === 0) {
	      return Parse.Promise.as(list);
	    }
	
	    var omitObjectsWithData = !forceFetch;
	    return Parse.Object._toObjectIdArray(
	      list,
	      omitObjectsWithData
	    ).then(function(objectIds) {
	      var className = list[0].className;
	      var query = new Parse.Query(className);
	      query.containedIn("objectId", objectIds);
	      query.limit = objectIds.length;
	      return query.find();
	    }).then(function(results) {
	      return Parse.Object._updateWithFetchedResults(
	        list,
	        results,
	        forceFetch
	      );
	    });
	  };
	
	  // Set up a map of className to class so that we can create new instances of
	  // Parse Objects from JSON automatically.
	  Parse.Object._classMap = {};
	
	  Parse.Object._extend = Parse._extend;
	
	  /**
	   * Creates a new subclass of Parse.Object for the given Parse class name.
	   *
	   * <p>Every extension of a Parse class will inherit from the most recent
	   * previous extension of that class. When a Parse.Object is automatically
	   * created by parsing JSON, it will use the most recent extension of that
	   * class.</p>
	   *
	   * <p>You should call either:<pre>
	   *     var MyClass = Parse.Object.extend("MyClass", {
	   *         <i>Instance methods</i>,
	   *         initialize: function(attrs, options) {
	   *             this.someInstanceProperty = [],
	   *             <i>Other instance properties</i>
	   *         }
	   *     }, {
	   *         <i>Class properties</i>
	   *     });</pre>
	   * or, for Backbone compatibility:<pre>
	   *     var MyClass = Parse.Object.extend({
	   *         className: "MyClass",
	   *         <i>Instance methods</i>,
	   *         initialize: function(attrs, options) {
	   *             this.someInstanceProperty = [],
	   *             <i>Other instance properties</i>
	   *         }
	   *     }, {
	   *         <i>Class properties</i>
	   *     });</pre></p>
	   *
	   * @param {String} className The name of the Parse class backing this model.
	   * @param {Object} protoProps Instance properties to add to instances of the
	   *     class returned from this method.
	   * @param {Object} classProps Class properties to add the class returned from
	   *     this method.
	   * @return {Class} A new subclass of Parse.Object.
	   */
	  Parse.Object.extend = function(className, protoProps, classProps) {
	    // Handle the case with only two args.
	    if (!_.isString(className)) {
	      if (className && _.has(className, "className")) {
	        return Parse.Object.extend(className.className, className, protoProps);
	      } else {
	        throw new Error(
	            "Parse.Object.extend's first argument should be the className.");
	      }
	    }
	
	    // If someone tries to subclass "User", coerce it to the right type.
	    if (className === "User" && Parse.User._performUserRewrite) {
	      className = "_User";
	    }
	    protoProps = protoProps || {};
	    protoProps.className = className;
	
	    var NewClassObject = null;
	    if (_.has(Parse.Object._classMap, className)) {
	      var OldClassObject = Parse.Object._classMap[className];
	      // This new subclass has been told to extend both from "this" and from
	      // OldClassObject. This is multiple inheritance, which isn't supported.
	      // For now, let's just pick one.
	      NewClassObject = OldClassObject._extend(protoProps, classProps);
	    } else {
	      NewClassObject = this._extend(protoProps, classProps);
	    }
	    // Extending a subclass should reuse the classname automatically.
	    NewClassObject.extend = function(arg0) {
	      if (_.isString(arg0) || (arg0 && _.has(arg0, "className"))) {
	        return Parse.Object.extend.apply(NewClassObject, arguments);
	      }
	      var newArguments = [className].concat(Parse._.toArray(arguments));
	      return Parse.Object.extend.apply(NewClassObject, newArguments);
	    };
	
	    /**
	     * Creates a reference to a subclass of Parse.Object with the given id. This
	     * does not exist on Parse.Object, only on subclasses.
	     *
	     * <p>A shortcut for: <pre>
	     *  var Foo = Parse.Object.extend("Foo");
	     *  var pointerToFoo = new Foo();
	     *  pointerToFoo.id = "myObjectId";
	     * </pre>
	     *
	     * @name createWithoutData
	     * @param {String} id The ID of the object to create a reference to.
	     * @return {Parse.Object} A Parse.Object reference.
	     * @function
	     * @memberOf Parse.Object
	     */
	    NewClassObject.createWithoutData = function(id) {
	      var obj = new NewClassObject();
	      obj.id = id;
	      return obj;
	    };
	
	    Parse.Object._classMap[className] = NewClassObject;
	    return NewClassObject;
	  };
	
	  Parse.Object._findUnsavedChildren = function(object, children, files) {
	    Parse._traverse(object, function(object) {
	      if (object instanceof Parse.Object) {
	        object._refreshCache();
	        if (object.dirty()) {
	          children.push(object);
	        }
	        return;
	      }
	
	      if (object instanceof Parse.File) {
	        if (!object.url()) {
	          files.push(object);
	        }
	        return;
	      }
	    });
	  };
	
	  Parse.Object._canBeSerializedAsValue = function(object) {
	    // TODO(klimt): We should rewrite _traverse so that it can be used here.
	    if (object instanceof Parse.Object) {
	      return !!object.id;
	    }
	    if (object instanceof Parse.File) {
	      // Don't recurse indefinitely into files.
	      return true;
	    }
	
	    var canBeSerializedAsValue = true;
	
	    if (_.isArray(object)) {
	      Parse._arrayEach(object, function(child) {
	        if (!Parse.Object._canBeSerializedAsValue(child)) {
	          canBeSerializedAsValue = false;
	        }
	      });
	    } else if (_.isObject(object)) {
	      Parse._objectEach(object, function(child) {
	        if (!Parse.Object._canBeSerializedAsValue(child)) {
	          canBeSerializedAsValue = false;
	        }
	      });
	    }
	    return canBeSerializedAsValue;
	  };
	
	  /**
	   * @param {Object} object The root object.
	   * @param {Object} options: The only valid option is useMasterKey.
	   */
	  Parse.Object._deepSaveAsync = function(object, options) {
	    var unsavedChildren = [];
	    var unsavedFiles = [];
	    Parse.Object._findUnsavedChildren(object, unsavedChildren, unsavedFiles);
	
	    var promise = Parse.Promise.as();
	    _.each(unsavedFiles, function(file) {
	      promise = promise.then(function() {
	        return file.save(options);
	      });
	    });
	
	    var objects = _.uniq(unsavedChildren);
	    var remaining = _.uniq(objects);
	
	    return promise.then(function() {
	      return Parse.Promise._continueWhile(function() {
	        return remaining.length > 0;
	      }, function() {
	
	        // Gather up all the objects that can be saved in this batch.
	        var batch = [];
	        var newRemaining = [];
	        Parse._arrayEach(remaining, function(object) {
	          // Limit batches to 20 objects.
	          if (batch.length > 20) {
	            newRemaining.push(object);
	            return;
	          }
	
	          if (object._canBeSerialized()) {
	            batch.push(object);
	          } else {
	            newRemaining.push(object);
	          }
	        });
	        remaining = newRemaining;
	
	        // If we can't save any objects, there must be a circular reference.
	        if (batch.length === 0) {
	          return Parse.Promise.error(
	            new Parse.Error(Parse.Error.OTHER_CAUSE,
	                            "Tried to save a batch with a cycle."));
	        }
	
	        // Reserve a spot in every object's save queue.
	        var readyToStart = Parse.Promise.when(_.map(batch, function(object) {
	          return object._allPreviousSaves || Parse.Promise.as();
	        }));
	        var batchFinished = new Parse.Promise();
	        Parse._arrayEach(batch, function(object) {
	          object._allPreviousSaves = batchFinished;
	        });
	
	        // Save a single batch, whether previous saves succeeded or failed.
	        return readyToStart._continueWith(function() {
	          return Parse._request({
	            route: "batch",
	            method: "POST",
	            useMasterKey: options.useMasterKey,
	            sessionToken: options.sessionToken,
	            data: {
	              requests: _.map(batch, function(object) {
	                var json = object._getSaveJSON();
	                var method = "POST";
	
	                var path = "/1/classes/" + object.className;
	                if (object.id) {
	                  path = path + "/" + object.id;
	                  method = "PUT";
	                }
	
	                object._startSave();
	
	                return {
	                  method: method,
	                  path: path,
	                  body: json
	                };
	              })
	            }
	          }).then(function(response, status, xhr) {
	            var error;
	            Parse._arrayEach(batch, function(object, i) {
	              if (response[i].success) {
	                object._finishSave(
	                  object.parse(response[i].success, status, xhr));
	              } else {
	                error = error || response[i].error;
	                object._cancelSave();
	              }
	            });
	            if (error) {
	              return Parse.Promise.error(
	                new Parse.Error(error.code, error.error));
	            }
	
	          }).then(function(results) {
	            batchFinished.resolve(results);
	            return results;
	          }, function(error) {
	            batchFinished.reject(error);
	            return Parse.Promise.error(error);
	          });
	        });
	      });
	    }).then(function() {
	      return object;
	    });
	  };
	
	}(this));
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Represents a Role on the Parse server. Roles represent groupings of
	   * Users for the purposes of granting permissions (e.g. specifying an ACL
	   * for an Object). Roles are specified by their sets of child users and
	   * child roles, all of which are granted any permissions that the parent
	   * role has.
	   *
	   * <p>Roles must have a name (which cannot be changed after creation of the
	   * role), and must specify an ACL.</p>
	   * @class
	   * A Parse.Role is a local representation of a role persisted to the Parse
	   * cloud.
	   */
	  Parse.Role = Parse.Object.extend("_Role", /** @lends Parse.Role.prototype */ {
	    // Instance Methods
	    
	    /**
	     * Constructs a new ParseRole with the given name and ACL.
	     * 
	     * @param {String} name The name of the Role to create.
	     * @param {Parse.ACL} acl The ACL for this role. Roles must have an ACL.
	     */
	    constructor: function(name, acl) {
	      if (_.isString(name) && (acl instanceof Parse.ACL)) {
	        Parse.Object.prototype.constructor.call(this, null, null);
	        this.setName(name);
	        this.setACL(acl);
	      } else {
	        Parse.Object.prototype.constructor.call(this, name, acl);
	      }
	    },
	    
	    /**
	     * Gets the name of the role.  You can alternatively call role.get("name")
	     * 
	     * @return {String} the name of the role.
	     */
	    getName: function() {
	      return this.get("name");
	    },
	    
	    /**
	     * Sets the name for a role. This value must be set before the role has
	     * been saved to the server, and cannot be set once the role has been
	     * saved.
	     * 
	     * <p>
	     *   A role's name can only contain alphanumeric characters, _, -, and
	     *   spaces.
	     * </p>
	     *
	     * <p>This is equivalent to calling role.set("name", name)</p>
	     * 
	     * @param {String} name The name of the role.
	     * @param {Object} options Standard options object with success and error
	     *     callbacks.
	     */
	    setName: function(name, options) {
	      return this.set("name", name, options);
	    },
	    
	    /**
	     * Gets the Parse.Relation for the Parse.Users that are direct
	     * children of this role. These users are granted any privileges that this
	     * role has been granted (e.g. read or write access through ACLs). You can
	     * add or remove users from the role through this relation.
	     * 
	     * <p>This is equivalent to calling role.relation("users")</p>
	     * 
	     * @return {Parse.Relation} the relation for the users belonging to this
	     *     role.
	     */
	    getUsers: function() {
	      return this.relation("users");
	    },
	    
	    /**
	     * Gets the Parse.Relation for the Parse.Roles that are direct
	     * children of this role. These roles' users are granted any privileges that
	     * this role has been granted (e.g. read or write access through ACLs). You
	     * can add or remove child roles from this role through this relation.
	     * 
	     * <p>This is equivalent to calling role.relation("roles")</p>
	     * 
	     * @return {Parse.Relation} the relation for the roles belonging to this
	     *     role.
	     */
	    getRoles: function() {
	      return this.relation("roles");
	    },
	    
	    /**
	     * @ignore
	     */
	    validate: function(attrs, options) {
	      if ("name" in attrs && attrs.name !== this.getName()) {
	        var newName = attrs.name;
	        if (this.id && this.id !== attrs.objectId) {
	          // Check to see if the objectId being set matches this.id.
	          // This happens during a fetch -- the id is set before calling fetch.
	          // Let the name be set in this case.
	          return new Parse.Error(Parse.Error.OTHER_CAUSE,
	              "A role's name can only be set before it has been saved.");
	        }
	        if (!_.isString(newName)) {
	          return new Parse.Error(Parse.Error.OTHER_CAUSE,
	              "A role's name must be a String.");
	        }
	        if (!(/^[0-9a-zA-Z\-_ ]+$/).test(newName)) {
	          return new Parse.Error(Parse.Error.OTHER_CAUSE,
	              "A role's name can only contain alphanumeric characters, _," +
	              " -, and spaces.");
	        }
	      }
	      if (Parse.Object.prototype.validate) {
	        return Parse.Object.prototype.validate.call(this, attrs, options);
	      }
	      return false;
	    }
	  });
	}(this));
	
	
	/*global _: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Creates a new instance with the given models and options.  Typically, you
	   * will not call this method directly, but will instead make a subclass using
	   * <code>Parse.Collection.extend</code>.
	   *
	   * @param {Array} models An array of instances of <code>Parse.Object</code>.
	   *
	   * @param {Object} options An optional object with Backbone-style options.
	   * Valid options are:<ul>
	   *   <li>model: The Parse.Object subclass that this collection contains.
	   *   <li>query: An instance of Parse.Query to use when fetching items.
	   *   <li>comparator: A string property name or function to sort by.
	   * </ul>
	   *
	   * @see Parse.Collection.extend
	   *
	   * @class
	   *
	   * <p>Provides a standard collection class for our sets of models, ordered
	   * or unordered.  For more information, see the
	   * <a href="http://documentcloud.github.com/backbone/#Collection">Backbone
	   * documentation</a>.</p>
	   */
	  Parse.Collection = function(models, options) {
	    options = options || {};
	    if (options.comparator) {
	      this.comparator = options.comparator;
	    }
	    if (options.model) {
	      this.model = options.model;
	    }
	    if (options.query) {
	      this.query = options.query;
	    }
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) {
	      this.reset(models, {silent: true, parse: options.parse});
	    }
	  };
	
	  // Define the Collection's inheritable methods.
	  _.extend(Parse.Collection.prototype, Parse.Events,
	      /** @lends Parse.Collection.prototype */ {
	
	    // The default model for a collection is just a Parse.Object.
	    // This should be overridden in most cases.
	    // TODO: think harder. this is likely to be weird.
	    model: Parse.Object,
	
	    /**
	     * Initialize is an empty function by default. Override it with your own
	     * initialization logic.
	     */
	    initialize: function(){},
	
	    /**
	     * The JSON representation of a Collection is an array of the
	     * models' attributes.
	     */
	    toJSON: function() {
	      return this.map(function(model){ return model.toJSON(); });
	    },
	
	    /**
	     * Add a model, or list of models to the set. Pass **silent** to avoid
	     * firing the `add` event for every new model.
	     *
	     * @param {Array} models An array of instances of <code>Parse.Object</code>.
	     *
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are:<ul>
	     *   <li>at: The index at which to add the models.
	     *   <li>silent: Set to true to avoid firing the `add` event for every new
	     *   model.
	     * </ul>
	     */
	    add: function(models, options) {
	      var i, index, length, model, cid, id, cids = {}, ids = {};
	      options = options || {};
	      models = _.isArray(models) ? models.slice() : [models];
	
	      // Begin by turning bare objects into model references, and preventing
	      // invalid models or duplicate models from being added.
	      for (i = 0, length = models.length; i < length; i++) {
	        models[i] = this._prepareModel(models[i], options);
	        model = models[i];
	        if (!model) {
	          throw new Error("Can't add an invalid model to a collection");
	        }
	        cid = model.cid;
	        if (cids[cid] || this._byCid[cid]) {
	          throw new Error("Duplicate cid: can't add the same model " +
	                          "to a collection twice");
	        }
	        id = model.id;
	        if (!Parse._isNullOrUndefined(id) && (ids[id] || this._byId[id])) {
	          throw new Error("Duplicate id: can't add the same model " +
	                          "to a collection twice");
	        }
	        ids[id] = model;
	        cids[cid] = model;
	      }
	
	      // Listen to added models' events, and index models for lookup by
	      // `id` and by `cid`.
	      for (i = 0; i < length; i++) {
	        (model = models[i]).on('all', this._onModelEvent, this);
	        this._byCid[model.cid] = model;
	        if (model.id) {
	          this._byId[model.id] = model;
	        }
	      }
	
	      // Insert models into the collection, re-sorting if needed, and triggering
	      // `add` events unless silenced.
	      this.length += length;
	      index = Parse._isNullOrUndefined(options.at) ? 
	          this.models.length : options.at;
	      this.models.splice.apply(this.models, [index, 0].concat(models));
	      if (this.comparator) {
	        this.sort({silent: true});
	      }
	      if (options.silent) {
	        return this;
	      }
	      for (i = 0, length = this.models.length; i < length; i++) {
	        model = this.models[i];
	        if (cids[model.cid]) {
	          options.index = i;
	          model.trigger('add', model, this, options);
	        }
	      }
	      return this;
	    },
	
	    /**
	     * Remove a model, or a list of models from the set. Pass silent to avoid
	     * firing the <code>remove</code> event for every model removed.
	     *
	     * @param {Array} models The model or list of models to remove from the
	     *   collection.
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are: <ul>
	     *   <li>silent: Set to true to avoid firing the `remove` event.
	     * </ul>
	     */
	    remove: function(models, options) {
	      var i, l, index, model;
	      options = options || {};
	      models = _.isArray(models) ? models.slice() : [models];
	      for (i = 0, l = models.length; i < l; i++) {
	        model = this.getByCid(models[i]) || this.get(models[i]);
	        if (!model) {
	          continue;
	        }
	        delete this._byId[model.id];
	        delete this._byCid[model.cid];
	        index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	        this._removeReference(model);
	      }
	      return this;
	    },
	
	    /**
	     * Gets a model from the set by id.
	     * @param {String} id The Parse objectId identifying the Parse.Object to
	     * fetch from this collection.
	     */
	    get: function(id) {
	      return id && this._byId[id.id || id];
	    },
	
	    /**
	     * Gets a model from the set by client id.
	     * @param {} cid The Backbone collection id identifying the Parse.Object to
	     * fetch from this collection.
	     */
	    getByCid: function(cid) {
	      return cid && this._byCid[cid.cid || cid];
	    },
	
	    /**
	     * Gets the model at the given index.
	     *
	     * @param {Number} index The index of the model to return.
	     */
	    at: function(index) {
	      return this.models[index];
	    },
	
	    /**
	     * Forces the collection to re-sort itself. You don't need to call this
	     * under normal circumstances, as the set will maintain sort order as each
	     * item is added.
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are: <ul>
	     *   <li>silent: Set to true to avoid firing the `reset` event.
	     * </ul>
	     */
	    sort: function(options) {
	      options = options || {};
	      if (!this.comparator) {
	        throw new Error('Cannot sort a set without a comparator');
	      }
	      var boundComparator = _.bind(this.comparator, this);
	      if (this.comparator.length === 1) {
	        this.models = this.sortBy(boundComparator);
	      } else {
	        this.models.sort(boundComparator);
	      }
	      if (!options.silent) {
	        this.trigger('reset', this, options);
	      }
	      return this;
	    },
	
	    /**
	     * Plucks an attribute from each model in the collection.
	     * @param {String} attr The attribute to return from each model in the
	     * collection.
	     */
	    pluck: function(attr) {
	      return _.map(this.models, function(model){ return model.get(attr); });
	    },
	
	    /**
	     * When you have more items than you want to add or remove individually,
	     * you can reset the entire set with a new list of models, without firing
	     * any `add` or `remove` events. Fires `reset` when finished.
	     *
	     * @param {Array} models The model or list of models to remove from the
	     *   collection.
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are: <ul>
	     *   <li>silent: Set to true to avoid firing the `reset` event.
	     * </ul>
	     */
	    reset: function(models, options) {
	      var self = this;
	      models = models || [];
	      options = options || {};
	      Parse._arrayEach(this.models, function(model) {
	        self._removeReference(model);
	      });
	      this._reset();
	      this.add(models, {silent: true, parse: options.parse});
	      if (!options.silent) {
	        this.trigger('reset', this, options);
	      }
	      return this;
	    },
	
	    /**
	     * Fetches the default set of models for this collection, resetting the
	     * collection when they arrive. If `add: true` is passed, appends the
	     * models to the collection instead of resetting.
	     *
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are:<ul>
	     *   <li>silent: Set to true to avoid firing `add` or `reset` events for
	     *   models fetched by this fetch.
	     *   <li>success: A Backbone-style success callback.
	     *   <li>error: An Backbone-style error callback.
	     *   <li>useMasterKey: In Cloud Code and Node only, uses the Master Key for
	     *       this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     */
	    fetch: function(options) {
	      options = _.clone(options) || {};
	      if (options.parse === undefined) {
	        options.parse = true;
	      }
	      var collection = this;
	      var query = this.query || new Parse.Query(this.model);
	      return query.find({
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken
	      }).then(function(results) {
	        if (options.add) {
	          collection.add(results, options);
	        } else {
	          collection.reset(results, options);
	        }
	        return collection;
	      })._thenRunCallbacks(options, this);
	    },
	
	    /**
	     * Creates a new instance of a model in this collection. Add the model to
	     * the collection immediately, unless `wait: true` is passed, in which case
	     * we wait for the server to agree.
	     *
	     * @param {Parse.Object} model The new model to create and add to the
	     *   collection.
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are:<ul>
	     *   <li>wait: Set to true to wait for the server to confirm creation of the
	     *       model before adding it to the collection.
	     *   <li>silent: Set to true to avoid firing an `add` event.
	     *   <li>success: A Backbone-style success callback.
	     *   <li>error: An Backbone-style error callback.
	     *   <li>useMasterKey: In Cloud Code and Node only, uses the Master Key for
	     *       this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     */
	    create: function(model, options) {
	      var coll = this;
	      options = options ? _.clone(options) : {};
	      model = this._prepareModel(model, options);
	      if (!model) {
	        return false;
	      }
	      if (!options.wait) {
	        coll.add(model, options);
	      }
	      var success = options.success;
	      options.success = function(nextModel, resp, xhr) {
	        if (options.wait) {
	          coll.add(nextModel, options);
	        }
	        if (success) {
	          success(nextModel, resp);
	        } else {
	          nextModel.trigger('sync', model, resp, options);
	        }
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    /**
	     * Converts a response into a list of models to be added to the collection.
	     * The default implementation is just to pass it through.
	     * @ignore
	     */
	    parse: function(resp, xhr) {
	      return resp;
	    },
	
	    /**
	     * Proxy to _'s chain. Can't be proxied the same way the rest of the
	     * underscore methods are proxied because it relies on the underscore
	     * constructor.
	     */
	    chain: function() {
	      return _(this.models).chain();
	    },
	
	    /**
	     * Reset all internal state. Called when the collection is reset.
	     */
	    _reset: function(options) {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	      this._byCid = {};
	    },
	
	    /**
	     * Prepare a model or hash of attributes to be added to this collection.
	     */
	    _prepareModel: function(model, options) {
	      if (!(model instanceof Parse.Object)) {
	        var attrs = model;
	        options.collection = this;
	        model = new this.model(attrs, options);
	        if (!model._validate(model.attributes, options)) {
	          model = false;
	        }
	      } else if (!model.collection) {
	        model.collection = this;
	      }
	      return model;
	    },
	
	    /**
	     * Internal method to remove a model's ties to a collection.
	     */
	    _removeReference: function(model) {
	      if (this === model.collection) {
	        delete model.collection;
	      }
	      model.off('all', this._onModelEvent, this);
	    },
	
	    /**
	     * Internal method called every time a model in the set fires an event.
	     * Sets need to update their indexes when models change ids. All other
	     * events simply proxy through. "add" and "remove" events that originate
	     * in other collections are ignored.
	     */
	    _onModelEvent: function(ev, model, collection, options) {
	      if ((ev === 'add' || ev === 'remove') && collection !== this) {
	        return;
	      }
	      if (ev === 'destroy') {
	        this.remove(model, options);
	      }
	      if (model && ev === 'change:objectId') {
	        delete this._byId[model.previous("objectId")];
	        this._byId[model.id] = model;
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  var methods = ['forEach', 'each', 'map', 'reduce', 'reduceRight', 'find',
	    'detect', 'filter', 'select', 'reject', 'every', 'all', 'some', 'any',
	    'include', 'contains', 'invoke', 'max', 'min', 'sortBy', 'sortedIndex',
	    'toArray', 'size', 'first', 'initial', 'rest', 'last', 'without', 'indexOf',
	    'shuffle', 'lastIndexOf', 'isEmpty', 'groupBy'];
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  Parse._arrayEach(methods, function(method) {
	    Parse.Collection.prototype[method] = function() {
	      return _[method].apply(_, [this.models].concat(_.toArray(arguments)));
	    };
	  });
	
	  /**
	   * Creates a new subclass of <code>Parse.Collection</code>.  For example,<pre>
	   *   var MyCollection = Parse.Collection.extend({
	   *     // Instance properties
	   *
	   *     model: MyClass,
	   *     query: MyQuery,
	   *
	   *     getFirst: function() {
	   *       return this.at(0);
	   *     }
	   *   }, {
	   *     // Class properties
	   *
	   *     makeOne: function() {
	   *       return new MyCollection();
	   *     }
	   *   });
	   *
	   *   var collection = new MyCollection();
	   * </pre>
	   *
	   * @function
	   * @param {Object} instanceProps Instance properties for the collection.
	   * @param {Object} classProps Class properies for the collection.
	   * @return {Class} A new subclass of <code>Parse.Collection</code>.
	   */
	  Parse.Collection.extend = Parse._extend;
	
	}(this));
	
	/*global _: false, document: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Creating a Parse.View creates its initial element outside of the DOM,
	   * if an existing element is not provided...
	   * @class
	   *
	   * <p>A fork of Backbone.View, provided for your convenience.  If you use this
	   * class, you must also include jQuery, or another library that provides a
	   * jQuery-compatible $ function.  For more information, see the
	   * <a href="http://documentcloud.github.com/backbone/#View">Backbone
	   * documentation</a>.</p>
	   * <p><strong><em>Available in the client SDK only.</em></strong></p>
	   */
	  Parse.View = function(options) {
	    this.cid = _.uniqueId('view');
	    this._configure(options || {});
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	    this.delegateEvents();
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var eventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be merged as properties.
	  // TODO: include objectId, createdAt, updatedAt?
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes',
	                     'className', 'tagName'];
	
	  // Set up all inheritable **Parse.View** properties and methods.
	  _.extend(Parse.View.prototype, Parse.Events,
	           /** @lends Parse.View.prototype */ {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    /**
	     * jQuery delegate for element lookup, scoped to DOM elements within the
	     * current view. This should be prefered to global lookups where possible.
	     */
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    /**
	     * Initialize is an empty function by default. Override it with your own
	     * initialization logic.
	     */
	    initialize: function(){},
	
	    /**
	     * The core function that your view should override, in order
	     * to populate its element (`this.el`), with the appropriate HTML. The
	     * convention is for **render** to always return `this`.
	     */
	    render: function() {
	      return this;
	    },
	
	    /**
	     * Remove this view from the DOM. Note that the view isn't present in the
	     * DOM by default, so calling this method may be a no-op.
	     */
	    remove: function() {
	      this.$el.remove();
	      return this;
	    },
	
	    /**
	     * For small amounts of DOM Elements, where a full-blown template isn't
	     * needed, use **make** to manufacture elements, one at a time.
	     * <pre>
	     *     var el = this.make('li', {'class': 'row'},
	     *                        this.model.escape('title'));</pre>
	     */
	    make: function(tagName, attributes, content) {
	      var el = document.createElement(tagName);
	      if (attributes) {
	        Parse.$(el).attr(attributes);
	      }
	      if (content) {
	        Parse.$(el).html(content);
	      }
	      return el;
	    },
	
	    /**
	     * Changes the view's element (`this.el` property), including event
	     * re-delegation.
	     */
	    setElement: function(element, delegate) {
	      this.$el = Parse.$(element);
	      this.el = this.$el[0];
	      if (delegate !== false) {
	        this.delegateEvents();
	      }
	      return this;
	    },
	
	    /**
	     * Set callbacks.  <code>this.events</code> is a hash of
	     * <pre>
	     * *{"event selector": "callback"}*
	     *
	     *     {
	     *       'mousedown .title':  'edit',
	     *       'click .button':     'save'
	     *       'click .open':       function(e) { ... }
	     *     }
	     * </pre>
	     * pairs. Callbacks will be bound to the view, with `this` set properly.
	     * Uses event delegation for efficiency.
	     * Omitting the selector binds the event to `this.el`.
	     * This only works for delegate-able events: not `focus`, `blur`, and
	     * not `change`, `submit`, and `reset` in Internet Explorer.
	     */
	    delegateEvents: function(events) {
	      events = events || Parse._getValue(this, 'events');
	      if (!events) {
	        return;
	      }
	      this.undelegateEvents();
	      var self = this;
	      Parse._objectEach(events, function(method, key) {
	        if (!_.isFunction(method)) {
	          method = self[events[key]];
	        }
	        if (!method) {
	          throw new Error('Event "' + events[key] + '" does not exist');
	        }
	        var match = key.match(eventSplitter);
	        var eventName = match[1], selector = match[2];
	        method = _.bind(method, self);
	        eventName += '.delegateEvents' + self.cid;
	        if (selector === '') {
	          self.$el.bind(eventName, method);
	        } else {
	          self.$el.delegate(selector, eventName, method);
	        }
	      });
	    },
	
	    /**
	     * Clears all callbacks previously bound to the view with `delegateEvents`.
	     * You usually don't need to use this, but may wish to if you have multiple
	     * Backbone views attached to the same DOM element.
	     */
	    undelegateEvents: function() {
	      this.$el.unbind('.delegateEvents' + this.cid);
	    },
	
	    /**
	     * Performs the initial configuration of a View with a set of options.
	     * Keys with special meaning *(model, collection, id, className)*, are
	     * attached directly to the view.
	     */
	    _configure: function(options) {
	      if (this.options) {
	        options = _.extend({}, this.options, options);
	      }
	      var self = this;
	      _.each(viewOptions, function(attr) {
	        if (options[attr]) {
	          self[attr] = options[attr];
	        }
	      });
	      this.options = options;
	    },
	
	    /**
	     * Ensure that the View has a DOM element to render into.
	     * If `this.el` is a string, pass it through `$()`, take the first
	     * matching element, and re-assign it to `el`. Otherwise, create
	     * an element from the `id`, `className` and `tagName` properties.
	     */
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = Parse._getValue(this, 'attributes') || {};
	        if (this.id) {
	          attrs.id = this.id;
	        }
	        if (this.className) {
	          attrs['class'] = this.className;
	        }
	        this.setElement(this.make(this.tagName, attrs), false);
	      } else {
	        this.setElement(this.el, false);
	      }
	    }
	
	  });
	
	  /**
	   * @function
	   * @param {Object} instanceProps Instance properties for the view.
	   * @param {Object} classProps Class properies for the view.
	   * @return {Class} A new subclass of <code>Parse.View</code>.
	   */
	  Parse.View.extend = Parse._extend;
	
	}(this));
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * @class
	   *
	   * <p>A Parse.User object is a local representation of a user persisted to the
	   * Parse cloud. This class is a subclass of a Parse.Object, and retains the
	   * same functionality of a Parse.Object, but also extends it with various
	   * user specific methods, like authentication, signing up, and validation of
	   * uniqueness.</p>
	   */
	  Parse.User = Parse.Object.extend("_User", /** @lends Parse.User.prototype */ {
	    // Instance Variables
	    _isCurrentUser: false,
	
	
	    // Instance Methods
	    
	    /**
	     * Merges another object's attributes into this object.
	     */
	    _mergeFromObject: function(other) {
	      if (other.getSessionToken()) {
	        this._sessionToken = other.getSessionToken();      
	      }    
	      Parse.User.__super__._mergeFromObject.call(this, other);
	    },    
	
	    /**
	     * Internal method to handle special fields in a _User response.
	     */
	    _mergeMagicFields: function(attrs) {
	      if (attrs.sessionToken) {
	        this._sessionToken = attrs.sessionToken;
	        delete attrs.sessionToken;
	      }
	      Parse.User.__super__._mergeMagicFields.call(this, attrs);
	    },
	
	    /**
	     * Removes null values from authData (which exist temporarily for
	     * unlinking)
	     */
	    _cleanupAuthData: function() {
	      if (!this.isCurrent()) {
	        return;
	      }
	      var authData = this.get('authData');
	      if (!authData) {
	        return;
	      }
	      Parse._objectEach(this.get('authData'), function(value, key) {
	        if (!authData[key]) {
	          delete authData[key];
	        }
	      });
	    },
	
	    /**
	     * Synchronizes authData for all providers.
	     */
	    _synchronizeAllAuthData: function() {
	      var authData = this.get('authData');
	      if (!authData) {
	        return;
	      }
	
	      var self = this;
	      Parse._objectEach(this.get('authData'), function(value, key) {
	        self._synchronizeAuthData(key);
	      });
	    },
	
	    /**
	     * Synchronizes auth data for a provider (e.g. puts the access token in the
	     * right place to be used by the Facebook SDK).
	     */
	    _synchronizeAuthData: function(provider) {
	      if (!this.isCurrent()) {
	        return;
	      }
	      var authType;
	      if (_.isString(provider)) {
	        authType = provider;
	        provider = Parse.User._authProviders[authType];
	      } else {
	        authType = provider.getAuthType();
	      }
	      var authData = this.get('authData');
	      if (!authData || !provider) {
	        return;
	      }
	      var success = provider.restoreAuthentication(authData[authType]);
	      if (!success) {
	        this._unlinkFrom(provider);
	      }
	    },
	
	    _handleSaveResult: function(makeCurrent) {
	      // Clean up and synchronize the authData object, removing any unset values
	      if (makeCurrent) {
	        this._isCurrentUser = true;
	      }
	      this._cleanupAuthData();
	      this._synchronizeAllAuthData();
	      // Don't keep the password around.
	      delete this._serverData.password;
	      this._rebuildEstimatedDataForKey("password");
	      this._refreshCache();
	      if (makeCurrent || this.isCurrent()) {
	        Parse.User._saveCurrentUser(this);
	      }
	    },
	
	    /**
	     * Unlike in the Android/iOS SDKs, logInWith is unnecessary, since you can
	     * call linkWith on the user (even if it doesn't exist yet on the server).
	     */
	    _linkWith: function(provider, options) {
	      var authType;
	      if (_.isString(provider)) {
	        authType = provider;
	        provider = Parse.User._authProviders[provider];
	      } else {
	        authType = provider.getAuthType();
	      }
	      if (_.has(options, 'authData')) {
	        var authData = this.get('authData') || {};
	        authData[authType] = options.authData;
	        this.set('authData', authData);
	
	        // Overridden so that the user can be made the current user.
	        var newOptions = _.clone(options) || {};
	        newOptions.success = function(model) {
	          model._handleSaveResult(true);
	          if (options.success) {
	            options.success.apply(this, arguments);
	          }
	        };
	        return this.save({'authData': authData}, newOptions);
	      } else {
	        var self = this;
	        var promise = new Parse.Promise();
	        provider.authenticate({
	          success: function(provider, result) {
	            self._linkWith(provider, {
	              authData: result,
	              success: options.success,
	              error: options.error
	            }).then(function() {
	              promise.resolve(self);
	            });
	          },
	          error: function(provider, error) {
	            if (options.error) {
	              options.error(self, error);
	            }
	            promise.reject(error);
	          }
	        });
	        return promise;
	      }
	    },
	
	    /**
	     * Unlinks a user from a service.
	     */
	    _unlinkFrom: function(provider, options) {
	      var authType;
	      if (_.isString(provider)) {
	        authType = provider;
	        provider = Parse.User._authProviders[provider];
	      } else {
	        authType = provider.getAuthType();
	      }
	      var newOptions = _.clone(options);
	      var self = this;
	      newOptions.authData = null;
	      newOptions.success = function(model) {
	        self._synchronizeAuthData(provider);
	        if (options.success) {
	          options.success.apply(this, arguments);
	        }
	      };
	      return this._linkWith(provider, newOptions);
	    },
	
	    /**
	     * Checks whether a user is linked to a service.
	     */
	    _isLinked: function(provider) {
	      var authType;
	      if (_.isString(provider)) {
	        authType = provider;
	      } else {
	        authType = provider.getAuthType();
	      }
	      var authData = this.get('authData') || {};
	      return !!authData[authType];
	    },
	
	    /**
	     * Deauthenticates all providers.
	     */
	    _logOutWithAll: function() {
	      var authData = this.get('authData');
	      if (!authData) {
	        return;
	      }
	      var self = this;
	      Parse._objectEach(this.get('authData'), function(value, key) {
	        self._logOutWith(key);
	      });
	    },
	
	    /**
	     * Deauthenticates a single provider (e.g. removing access tokens from the
	     * Facebook SDK).
	     */
	    _logOutWith: function(provider) {
	      if (!this.isCurrent()) {
	        return;
	      }
	      if (_.isString(provider)) {
	        provider = Parse.User._authProviders[provider];
	      }
	      if (provider && provider.deauthenticate) {
	        provider.deauthenticate();
	      }
	    },
	
	    /**
	     * Signs up a new user. You should call this instead of save for
	     * new Parse.Users. This will create a new Parse.User on the server, and
	     * also persist the session on disk so that you can access the user using
	     * <code>current</code>.
	     *
	     * <p>A username and password must be set before calling signUp.</p>
	     *
	     * <p>Calls options.success or options.error on completion.</p>
	     *
	     * @param {Object} attrs Extra fields to set on the new user, or null.
	     * @param {Object} options A Backbone-style options object.
	     * @return {Parse.Promise} A promise that is fulfilled when the signup
	     *     finishes.
	     * @see Parse.User.signUp
	     */
	    signUp: function(attrs, options) {
	      var error;
	      options = options || {};
	
	      var username = (attrs && attrs.username) || this.get("username");
	      if (!username || (username === "")) {
	        error = new Parse.Error(
	            Parse.Error.OTHER_CAUSE,
	            "Cannot sign up user with an empty name.");
	        if (options && options.error) {
	          options.error(this, error);
	        }
	        return Parse.Promise.error(error);
	      }
	
	      var password = (attrs && attrs.password) || this.get("password");
	      if (!password || (password === "")) {
	        error = new Parse.Error(
	            Parse.Error.OTHER_CAUSE,
	            "Cannot sign up user with an empty password.");
	        if (options && options.error) {
	          options.error(this, error);
	        }
	        return Parse.Promise.error(error);
	      }
	
	      // Overridden so that the user can be made the current user.
	      var newOptions = _.clone(options);
	      newOptions.success = function(model) {
	        model._handleSaveResult(Parse.User._canUseCurrentUser());
	        if (options.success) {
	          options.success.apply(this, arguments);
	        }
	      };
	      return this.save(attrs, newOptions);
	    },
	
	    /**
	     * Logs in a Parse.User. On success, this saves the session to localStorage,
	     * so you can retrieve the currently logged in user using
	     * <code>current</code>.
	     *
	     * <p>A username and password must be set before calling logIn.</p>
	     *
	     * <p>Calls options.success or options.error on completion.</p>
	     *
	     * @param {Object} options A Backbone-style options object.
	     * @see Parse.User.logIn
	     * @return {Parse.Promise} A promise that is fulfilled with the user when
	     *     the login is complete.
	     */
	    logIn: function(options) {
	      if (!Parse.User._canUseCurrentUser()) {
	        throw new Error(
	          'It is not possible to log in on a server environment.'
	        );
	      }
	      var model = this;
	      options = options || {};
	      var request = Parse._request({
	        route: "login",
	        method: "GET",
	        useMasterKey: options.useMasterKey,
	        data: this.toJSON()
	      });
	      return request.then(function(resp, status, xhr) {
	        var serverAttrs = model.parse(resp, status, xhr);
	        model._finishFetch(serverAttrs);
	        model._handleSaveResult(true);
	        return model;
	      })._thenRunCallbacks(options, this);
	    },
	
	    /**
	     * @see Parse.Object#save
	     */
	    save: function(arg1, arg2, arg3) {
	      var i, attrs, current, options, saved;
	      if (_.isObject(arg1) || _.isNull(arg1) || _.isUndefined(arg1)) {
	        attrs = arg1;
	        options = arg2;
	      } else {
	        attrs = {};
	        attrs[arg1] = arg2;
	        options = arg3;
	      }
	      options = options || {};
	
	      var newOptions = _.clone(options);
	      newOptions.success = function(model) {
	        model._handleSaveResult(false);
	        if (options.success) {
	          options.success.apply(this, arguments);
	        }
	      };
	      return Parse.Object.prototype.save.call(this, attrs, newOptions);
	    },
	
	    /**
	     * @see Parse.Object#fetch
	     */
	    fetch: function(options) {
	      var newOptions = options ? _.clone(options) : {};
	      newOptions.success = function(model) {
	        model._handleSaveResult(false);
	        if (options && options.success) {
	          options.success.apply(this, arguments);
	        }
	      };
	      return Parse.Object.prototype.fetch.call(this, newOptions);
	    },
	
	    /**
	     * Returns true if <code>current</code> would return this user.
	     * @see Parse.User#current
	     */
	    isCurrent: function() {
	      return this._isCurrentUser;
	    },
	
	    /**
	     * Returns get("username").
	     * @return {String}
	     * @see Parse.Object#get
	     */
	    getUsername: function() {
	      return this.get("username");
	    },
	
	    /**
	     * Calls set("username", username, options) and returns the result.
	     * @param {String} username
	     * @param {Object} options A Backbone-style options object.
	     * @return {Boolean}
	     * @see Parse.Object.set
	     */
	    setUsername: function(username, options) {
	      return this.set("username", username, options);
	    },
	
	    /**
	     * Calls set("password", password, options) and returns the result.
	     * @param {String} password
	     * @param {Object} options A Backbone-style options object.
	     * @return {Boolean}
	     * @see Parse.Object.set
	     */
	    setPassword: function(password, options) {
	      return this.set("password", password, options);
	    },
	
	    /**
	     * Returns get("email").
	     * @return {String}
	     * @see Parse.Object#get
	     */
	    getEmail: function() {
	      return this.get("email");
	    },
	
	    /**
	     * Calls set("email", email, options) and returns the result.
	     * @param {String} email
	     * @param {Object} options A Backbone-style options object.
	     * @return {Boolean}
	     * @see Parse.Object.set
	     */
	    setEmail: function(email, options) {
	      return this.set("email", email, options);
	    },
	
	    /**
	     * Checks whether this user is the current user and has been authenticated.
	     * @return (Boolean) whether this user is the current user and is logged in.
	     */
	    authenticated: function() {
	      return !!this._sessionToken &&
	          (Parse.User.current() && Parse.User.current().id === this.id);
	    },
	
	    /**
	     * Returns the session token for this user, if the user has been logged in,
	     * or if it is the result of a query with the master key. Otherwise, returns
	     * undefined.
	     * @return {String} the session token, or undefined
	     */
	    getSessionToken: function() {
	      return this._sessionToken;
	    },
	
	    /**
	     * Request a revocable session token to replace the older style of token.
	     * @param {Object} options A Backbone-style options object.
	     *
	     * @return {Parse.Promise} A promise that is resolved when the replacement
	     *   token has been fetched.
	     */
	    _upgradeToRevocableSession: function(options) {
	      options = options || {};
	      if (!Parse.User.current()) {
	        return Parse.Promise.as()._thenRunCallbacks(options);
	      }
	      var currentSession = Parse.User.current().getSessionToken();
	      if (Parse.Session._isRevocable(currentSession)) {
	        return Parse.Promise.as()._thenRunCallbacks(options);
	      }
	      return Parse._request({
	        route: 'upgradeToRevocableSession',
	        method: 'POST',
	        useMasterKey: options.useMasterKey,
	        sessionToken: currentSession
	      }).then(function(result) {
	        var session = new Parse.Session();
	        session._finishFetch(result);
	        var currentUser = Parse.User.current();
	        currentUser._sessionToken = session.getSessionToken();
	        Parse.User._saveCurrentUser(currentUser);
	      })._thenRunCallbacks(options);
	    },
	
	  }, /** @lends Parse.User */ {
	    // Class Variables
	
	    // The currently logged-in user.
	    _currentUser: null,
	
	    // Whether currentUser is known to match the serialized version on disk.
	    // This is useful for saving a localstorage check if you try to load
	    // _currentUser frequently while there is none stored.
	    _currentUserMatchesDisk: false,
	
	    // The localStorage key suffix that the current user is stored under.
	    _CURRENT_USER_KEY: "currentUser",
	
	    // The mapping of auth provider names to actual providers
	    _authProviders: {},
	
	    // Whether to rewrite className User to _User
	    _performUserRewrite: true,
	
	    // Whether to send a Revocable Session header
	    _isRevocableSessionEnabled: false,
	
	    // Whether to enable a memory-unsafe current user in node.js
	    _enableUnsafeCurrentUser: false,
	
	
	    // Class Methods
	
	    /**
	     * Signs up a new user with a username (or email) and password.
	     * This will create a new Parse.User on the server, and also persist the
	     * session in localStorage so that you can access the user using
	     * {@link #current}.
	     *
	     * <p>Calls options.success or options.error on completion.</p>
	     *
	     * @param {String} username The username (or email) to sign up with.
	     * @param {String} password The password to sign up with.
	     * @param {Object} attrs Extra fields to set on the new user.
	     * @param {Object} options A Backbone-style options object.
	     * @return {Parse.Promise} A promise that is fulfilled with the user when
	     *     the signup completes.
	     * @see Parse.User#signUp
	     */
	    signUp: function(username, password, attrs, options) {
	      attrs = attrs || {};
	      attrs.username = username;
	      attrs.password = password;
	      var user = Parse.Object._create("_User");
	      return user.signUp(attrs, options);
	    },
	
	    /**
	     * Logs in a user with a username (or email) and password. On success, this
	     * saves the session to disk, so you can retrieve the currently logged in
	     * user using <code>current</code>.
	     *
	     * <p>Calls options.success or options.error on completion.</p>
	     *
	     * @param {String} username The username (or email) to log in with.
	     * @param {String} password The password to log in with.
	     * @param {Object} options A Backbone-style options object.
	     * @return {Parse.Promise} A promise that is fulfilled with the user when
	     *     the login completes.
	     * @see Parse.User#logIn
	     */
	    logIn: function(username, password, options) {
	      var user = Parse.Object._create("_User");
	      user._finishFetch({ username: username, password: password });
	      return user.logIn(options);
	    },
	
	    /**
	     * Logs in a user with a session token. On success, this saves the session
	     * to disk, so you can retrieve the currently logged in user using
	     * <code>current</code>.
	     *
	     * <p>Calls options.success or options.error on completion.</p>
	     *
	     * @param {String} sessionToken The sessionToken to log in with.
	     * @param {Object} options A Backbone-style options object.
	     * @return {Parse.Promise} A promise that is fulfilled with the user when
	     *     the login completes.
	     */
	    become: function(sessionToken, options) {
	      if (!Parse.User._canUseCurrentUser()) {
	        throw new Error(
	          'It is not secure to become a user on a node.js server environment.'
	        );
	      }
	      options = options || {};
	
	      var user = Parse.Object._create("_User");
	      return Parse._request({
	        route: "users",
	        className: "me",
	        method: "GET",
	        useMasterKey: options.useMasterKey,
	        sessionToken: sessionToken
	      }).then(function(resp, status, xhr) {
	        var serverAttrs = user.parse(resp, status, xhr);
	        user._finishFetch(serverAttrs);
	        user._handleSaveResult(true);
	        return user;
	
	      })._thenRunCallbacks(options, user);
	    },
	
	    /**
	     * Logs out the currently logged in user session. This will remove the
	     * session from disk, log out of linked services, and future calls to
	     * <code>current</code> will return <code>null</code>.
	     * @return {Parse.Promise} A promise that is resolved when the session is
	     *   destroyed on the server.
	     */
	    logOut: function() {
	      if (!Parse.User._canUseCurrentUser()) {
	        throw new Error(
	          'There is no current user user on a node.js server environment.'
	        );
	      }
	      return Parse.User._currentAsync().then(function(currentUser) {
	        var promise = Parse.Storage.removeItemAsync(
	          Parse._getParsePath(Parse.User._CURRENT_USER_KEY));
	
	        if (currentUser !== null) {
	          var currentSession = currentUser.getSessionToken();
	          if (Parse.Session._isRevocable(currentSession)) {
	            promise.then(function() {
	              return Parse._request({
	                route: 'logout',
	                method: 'POST',
	                sessionToken: currentSession
	              });
	            });
	          }
	          currentUser._logOutWithAll();
	          currentUser._isCurrentUser = false;
	        }
	        Parse.User._currentUserMatchesDisk = true;
	        Parse.User._currentUser = null;
	
	        return promise;
	      });
	    },
	
	    /**
	     * Requests a password reset email to be sent to the specified email address
	     * associated with the user account. This email allows the user to securely
	     * reset their password on the Parse site.
	     *
	     * <p>Calls options.success or options.error on completion.</p>
	     *
	     * @param {String} email The email address associated with the user that
	     *     forgot their password.
	     * @param {Object} options A Backbone-style options object.
	     */
	    requestPasswordReset: function(email, options) {
	      options = options || {};
	      var request = Parse._request({
	        route: "requestPasswordReset",
	        method: "POST",
	        useMasterKey: options.useMasterKey,
	        data: { email: email }
	      });
	      return request._thenRunCallbacks(options);
	    },
	
	    /**
	     * Retrieves the currently logged in ParseUser with a valid session,
	     * either from memory or localStorage, if necessary.
	     * @return {Parse.Object} The currently logged in Parse.User.
	     */
	    current: function() {
	      if (!Parse.User._canUseCurrentUser()) {
	        throw new Error(
	          'There is no current user user on a node.js server environment.'
	        );
	      }
	      if (Parse.Storage.async) {
	        // We can't return the current user synchronously
	        Parse.User._currentAsync();
	        return Parse.User._currentUser;
	      }
	      
	      if (Parse.User._currentUser) {
	        return Parse.User._currentUser;
	      }
	
	      if (Parse.User._currentUserMatchesDisk) {
	        // TODO: Lazily log in anonymous user.
	        return Parse.User._currentUser;
	      }
	
	      // Load the user from local storage.
	      Parse.User._currentUserMatchesDisk = true;
	
	      var userData = Parse.Storage.getItem(Parse._getParsePath(
	          Parse.User._CURRENT_USER_KEY));
	      if (!userData) {
	        // TODO: Lazily log in anonymous user.
	        return null;
	      }
	      Parse.User._currentUser = Parse.Object._create("_User");
	      Parse.User._currentUser._isCurrentUser = true;
	
	      var json = JSON.parse(userData);
	      Parse.User._currentUser.id = json._id;
	      delete json._id;
	      Parse.User._currentUser._sessionToken = json._sessionToken;
	      delete json._sessionToken;
	      Parse.User._currentUser._finishFetch(json);
	
	      Parse.User._currentUser._synchronizeAllAuthData();
	      Parse.User._currentUser._refreshCache();
	      Parse.User._currentUser._opSetQueue = [{}];
	      return Parse.User._currentUser;
	    },
	
	    /**
	     * Retrieves the currently logged in ParseUser from asynchronous Storage.
	     * @return {Parse.Promise} A Promise that is resolved with the currently
	     *   logged in Parse User
	     */
	    _currentAsync: function() {
	      if (Parse.User._currentUser) {
	        return Parse.Promise.as(Parse.User._currentUser);
	      }
	
	      if (Parse.User._currentUserMatchesDisk) {
	        return Parse.Promise.as(Parse.User._currentUser);
	      }
	
	      // Load the user from Storage
	      return Parse.Storage.getItemAsync(Parse._getParsePath(
	        Parse.User._CURRENT_USER_KEY)).then(function(userData) {
	        if (!userData) {
	          return null;
	        }
	        Parse.User._currentUser = Parse.Object._create("_User");
	        Parse.User._currentUser._isCurrentUser = true;
	
	        var json = JSON.parse(userData);
	        Parse.User._currentUser.id = json._id;
	        delete json._id;
	        Parse.User._currentUser._sessionToken = json._sessionToken;
	        delete json._sessionToken;
	        Parse.User._currentUser._finishFetch(json);
	
	        Parse.User._currentUser._synchronizeAllAuthData();
	        Parse.User._currentUser._refreshCache();
	        Parse.User._currentUser._opSetQueue = [{}];
	        return Parse.User._currentUser;
	      });
	    },
	
	    /**
	     * Allow someone to define a custom User class without className
	     * being rewritten to _User. The default behavior is to rewrite
	     * User to _User for legacy reasons. This allows developers to
	     * override that behavior.
	     *
	     * @param {Boolean} isAllowed Whether or not to allow custom User class
	     */
	    allowCustomUserClass: function(isAllowed) {
	      this._performUserRewrite = !isAllowed;
	    },
	
	    /**
	     * Allow a legacy application to start using revocable sessions. If the
	     * current session token is not revocable, a request will be made for a new,
	     * revocable session.
	     * It is not necessary to call this method from cloud code unless you are
	     * handling user signup or login from the server side. In a cloud code call,
	     * this function will not attempt to upgrade the current token.
	     * @param {Object} options A Backbone-style options object.
	     *
	     * @return {Parse.Promise} A promise that is resolved when the process has
	     *   completed. If a replacement session token is requested, the promise
	     *   will be resolved after a new token has been fetched.
	     */
	    enableRevocableSession: function(options) {
	      options = options || {};
	      Parse.User._isRevocableSessionEnabled = true;
	      if (Parse.User._canUseCurrentUser() && Parse.User.current()) {
	        return Parse.User.current()._upgradeToRevocableSession(options);
	      }
	      return Parse.Promise.as()._thenRunCallbacks(options);
	    },
	
	    /**
	     *
	     */
	    enableUnsafeCurrentUser: function() {
	      Parse.User._enableUnsafeCurrentUser = true;
	    },
	
	    _canUseCurrentUser: function() {
	      return !Parse._isNode || Parse.User._enableUnsafeCurrentUser;
	    },
	
	    /**
	     * Persists a user as currentUser to localStorage, and into the singleton.
	     */
	    _saveCurrentUser: function(user) {
	      if (Parse.User._currentUser !== null &&
	          Parse.User._currentUser !== user) {
	        Parse.User.logOut();
	      }
	      user._isCurrentUser = true;
	      Parse.User._currentUser = user;
	      Parse.User._currentUserMatchesDisk = true;
	
	      var json = user.toJSON();
	      json._id = user.id;
	      json._sessionToken = user._sessionToken;
	      if (Parse.Storage.async) {
	        Parse.Storage.setItemAsync(
	          Parse._getParsePath(Parse.User._CURRENT_USER_KEY),
	          JSON.stringify(json));
	      } else {
	        Parse.Storage.setItem(
	          Parse._getParsePath(Parse.User._CURRENT_USER_KEY),
	          JSON.stringify(json));
	      }
	    },
	
	    _registerAuthenticationProvider: function(provider) {
	      Parse.User._authProviders[provider.getAuthType()] = provider;
	      // Synchronize the current user with the auth provider.
	      if (Parse.User.current()) {
	        Parse.User.current()._synchronizeAuthData(provider.getAuthType());
	      }
	    },
	
	    _logInWith: function(provider, options) {
	      var user = Parse.Object._create("_User");
	      return user._linkWith(provider, options);
	    }
	
	  });
	}(this));
	
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	
	  /**
	   * @class
	   *
	   * <p>A Parse.Session object is a local representation of a revocable session.
	   * This class is a subclass of a Parse.Object, and retains the same
	   * functionality of a Parse.Object.</p>
	   */
	  Parse.Session = Parse.Object.extend('_Session',
	  /** @lends Parse.Session.prototype */
	  {
	    /**
	     * Returns the session token string.
	     * @return {String}
	     */
	    getSessionToken: function() {
	      return this._sessionToken;
	    },
	
	    /**
	     * Internal method to handle special fields in a _Session response.
	     */
	    _mergeMagicFields: function(attrs) {
	      if (attrs.sessionToken) {
	        this._sessionToken = attrs.sessionToken;
	        delete attrs.sessionToken;
	      }
	      Parse.Session.__super__._mergeMagicFields.call(this, attrs);
	    },
	  }, /** @lends Parse.Session */ {
	
	    // Throw an error when modifying these read-only fields
	    readOnlyAttributes: {
	      createdWith: true,
	      expiresAt: true,
	      installationId: true,
	      restricted: true,
	      sessionToken: true,
	      user: true
	    },
	
	    /**
	     * Retrieves the Session object for the currently logged in session.
	     * @return {Parse.Promise} A promise that is resolved with the Parse.Session
	     *   object after it has been fetched.
	     */
	    current: function(options) {
	      options = options || {};
	
	      var session = Parse.Object._create('_Session');
	      var currentToken = Parse.User.current().getSessionToken();
	      return Parse._request({
	        route: 'sessions',
	        className: 'me',
	        method: 'GET',
	        useMasterKey: options.useMasterKey,
	        sessionToken: currentToken
	      }).then(function(resp, status, xhr) {
	        var serverAttrs = session.parse(resp, status, xhr);
	        session._finishFetch(serverAttrs);
	        return session;
	      })._thenRunCallbacks(options, session);
	    },
	
	    /**
	     * Determines whether a session token is revocable.
	     * @return {Boolean}
	     */
	    _isRevocable: function(token) {
	      return token.indexOf('r:') > -1;
	    },
	
	    /**
	     * Determines whether the current session token is revocable.
	     * This method is useful for migrating Express.js or Node.js web apps to
	     * use revocable sessions. If you are migrating an app that uses the Parse
	     * SDK in the browser only, please use Parse.User.enableRevocableSession()
	     * instead, so that sessions can be automatically upgraded.
	     * @return {Boolean}
	     */
	    isCurrentSessionRevocable: function() {
	      if (Parse.User.current() !== null) {
	        return Parse.Session._isRevocable(
	          Parse.User.current().getSessionToken()
	        );
	      }
	    }
	  });
	})(this);
	
	// Parse.Query is a way to create a list of Parse.Objects.
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Creates a new parse Parse.Query for the given Parse.Object subclass.
	   * @param objectClass -
	   *   An instance of a subclass of Parse.Object, or a Parse className string.
	   * @class
	   *
	   * <p>Parse.Query defines a query that is used to fetch Parse.Objects. The
	   * most common use case is finding all objects that match a query through the
	   * <code>find</code> method. For example, this sample code fetches all objects
	   * of class <code>MyClass</code>. It calls a different function depending on
	   * whether the fetch succeeded or not.
	   * 
	   * <pre>
	   * var query = new Parse.Query(MyClass);
	   * query.find({
	   *   success: function(results) {
	   *     // results is an array of Parse.Object.
	   *   },
	   *
	   *   error: function(error) {
	   *     // error is an instance of Parse.Error.
	   *   }
	   * });</pre></p>
	   * 
	   * <p>A Parse.Query can also be used to retrieve a single object whose id is
	   * known, through the get method. For example, this sample code fetches an
	   * object of class <code>MyClass</code> and id <code>myId</code>. It calls a
	   * different function depending on whether the fetch succeeded or not.
	   * 
	   * <pre>
	   * var query = new Parse.Query(MyClass);
	   * query.get(myId, {
	   *   success: function(object) {
	   *     // object is an instance of Parse.Object.
	   *   },
	   *
	   *   error: function(object, error) {
	   *     // error is an instance of Parse.Error.
	   *   }
	   * });</pre></p>
	   * 
	   * <p>A Parse.Query can also be used to count the number of objects that match
	   * the query without retrieving all of those objects. For example, this
	   * sample code counts the number of objects of the class <code>MyClass</code>
	   * <pre>
	   * var query = new Parse.Query(MyClass);
	   * query.count({
	   *   success: function(number) {
	   *     // There are number instances of MyClass.
	   *   },
	   *
	   *   error: function(error) {
	   *     // error is an instance of Parse.Error.
	   *   }
	   * });</pre></p>
	   */
	  Parse.Query = function(objectClass) {
	    if (_.isString(objectClass)) {
	      objectClass = Parse.Object._getSubclass(objectClass);
	    }
	
	    this.objectClass = objectClass;
	
	    this.className = objectClass.prototype.className;
	
	    this._where = {};
	    this._include = [];
	    this._limit = -1; // negative limit means, do not send a limit
	    this._skip = 0;
	    this._extraOptions = {};
	  };
	
	  /**
	   * Constructs a Parse.Query that is the OR of the passed in queries.  For
	   * example:
	   * <pre>var compoundQuery = Parse.Query.or(query1, query2, query3);</pre>
	   *
	   * will create a compoundQuery that is an or of the query1, query2, and
	   * query3.
	   * @param {...Parse.Query} var_args The list of queries to OR.
	   * @return {Parse.Query} The query that is the OR of the passed in queries.
	   */
	  Parse.Query.or = function() {
	    var queries = _.toArray(arguments);
	    var className = null;
	    Parse._arrayEach(queries, function(q) {
	      if (_.isNull(className)) {
	        className = q.className;
	      }
	
	      if (className !== q.className) {
	        throw "All queries must be for the same class";
	      }
	    });
	    var query = new Parse.Query(className);
	    query._orQuery(queries);
	    return query;
	  };
	
	  Parse.Query.prototype = {
	    /**
	     * Constructs a Parse.Object whose id is already known by fetching data from
	     * the server.  Either options.success or options.error is called when the
	     * find completes.
	     *
	     * @param {String} objectId The id of the object to be fetched.
	     * @param {Object} options A Backbone-style options object.
	     * Valid options are:<ul>
	     *   <li>success: A Backbone-style success callback
	     *   <li>error: An Backbone-style error callback.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     */
	    get: function(objectId, options) {
	      var self = this;
	      self.equalTo('objectId', objectId);
	
	      var firstOptions = {};
	      if (options && _.has(options, 'useMasterKey')) {
	        firstOptions = { useMasterKey: options.useMasterKey };
	      }
	      if (options && _.has(options, 'sessionToken')) {
	        firstOptions.sessionToken = options.sessionToken;
	      }
	
	      return self.first(firstOptions).then(function(response) {
	        if (response) {
	          return response;
	        }
	
	        var errorObject = new Parse.Error(Parse.Error.OBJECT_NOT_FOUND,
	                                          "Object not found.");
	        return Parse.Promise.error(errorObject);
	
	      })._thenRunCallbacks(options, null);
	    },
	
	    /**
	     * Returns a JSON representation of this query.
	     * @return {Object} The JSON representation of the query.
	     */
	    toJSON: function() {
	      var params = {
	        where: this._where
	      };
	
	      if (this._include.length > 0) {
	        params.include = this._include.join(",");
	      }
	      if (this._select) {
	        params.keys = this._select.join(",");
	      }
	      if (this._limit >= 0) {
	        params.limit = this._limit;
	      }
	      if (this._skip > 0) {
	        params.skip = this._skip;
	      }
	      if (this._order !== undefined) {
	        params.order = this._order.join(",");
	      }
	
	      Parse._objectEach(this._extraOptions, function(v, k) {
	        params[k] = v;
	      });
	
	      return params;
	    },
	
	    /**
	     * Retrieves a list of ParseObjects that satisfy this query.
	     * Either options.success or options.error is called when the find
	     * completes.
	     *
	     * @param {Object} options A Backbone-style options object. Valid options
	     * are:<ul>
	     *   <li>success: Function to call when the find completes successfully.
	     *   <li>error: Function to call when the find fails.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     *
	     * @return {Parse.Promise} A promise that is resolved with the results when
	     * the query completes.
	     */
	    find: function(options) {
	      var self = this;
	      options = options || {};
	
	      var request = Parse._request({
	        route: "classes",
	        className: this.className,
	        method: "GET",
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken,
	        data: this.toJSON()
	      });
	
	      return request.then(function(response) {
	        return _.map(response.results, function(json) {
	          var obj;
	          if (response.className) {
	            obj = new Parse.Object(response.className);
	          } else {
	            obj = new self.objectClass();
	          }
	          obj._finishFetch(json, true);
	          return obj;
	        });
	      })._thenRunCallbacks(options);
	    },
	
	    /**
	     * Counts the number of objects that match this query.
	     * Either options.success or options.error is called when the count
	     * completes.
	     *
	     * @param {Object} options A Backbone-style options object. Valid options
	     * are:<ul>
	     *   <li>success: Function to call when the count completes successfully.
	     *   <li>error: Function to call when the find fails.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     *
	     * @return {Parse.Promise} A promise that is resolved with the count when
	     * the query completes.
	     */
	    count: function(options) {
	      var self = this;
	      options = options || {};
	
	      var params = this.toJSON();
	      params.limit = 0;
	      params.count = 1;
	      var request = Parse._request({
	        route: "classes",
	        className: self.className, 
	        method: "GET",
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken,
	        data: params
	      });
	
	      return request.then(function(response) {
	        return response.count;
	      })._thenRunCallbacks(options);
	    },
	
	    /**
	     * Retrieves at most one Parse.Object that satisfies this query.
	     *
	     * Either options.success or options.error is called when it completes.
	     * success is passed the object if there is one. otherwise, undefined.
	     *
	     * @param {Object} options A Backbone-style options object. Valid options
	     * are:<ul>
	     *   <li>success: Function to call when the find completes successfully.
	     *   <li>error: Function to call when the find fails.
	     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
	     *     be used for this request.
	     *   <li>sessionToken: A valid session token, used for making a request on
	     *       behalf of a specific user.
	     * </ul>
	     *
	     * @return {Parse.Promise} A promise that is resolved with the object when
	     * the query completes.
	     */
	    first: function(options) {
	      var self = this;
	      options = options || {};
	
	      var params = this.toJSON();
	      params.limit = 1;
	      var request = Parse._request({
	        route: "classes",
	        className: this.className, 
	        method: "GET",
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken,
	        data: params
	      });
	
	      return request.then(function(response) {
	        return _.map(response.results, function(json) {
	          var obj;
	          if (response.className) {
	            obj = new Parse.Object(response.className);
	          } else {
	            obj = new self.objectClass();
	          }
	          obj._finishFetch(json, true);
	          return obj;
	        })[0];
	      })._thenRunCallbacks(options);
	    },
	
	    /**
	     * Returns a new instance of Parse.Collection backed by this query.
	     * @param {Array} items An array of instances of <code>Parse.Object</code>
	     *     with which to start this Collection.
	     * @param {Object} options An optional object with Backbone-style options.
	     * Valid options are:<ul>
	     *   <li>model: The Parse.Object subclass that this collection contains.
	     *   <li>query: An instance of Parse.Query to use when fetching items.
	     *   <li>comparator: A string property name or function to sort by.
	     * </ul>
	     * @return {Parse.Collection}
	     */
	    collection: function(items, options) {
	      options = options || {};
	      return new Parse.Collection(items, _.extend(options, {
	        model: this.objectClass,
	        query: this
	      }));
	    },
	
	    /**
	     * Sets the number of results to skip before returning any results.
	     * This is useful for pagination.
	     * Default is to skip zero results.
	     * @param {Number} n the number of results to skip.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    skip: function(n) {
	      this._skip = n;
	      return this;
	    },
	
	    /**
	     * Sets the limit of the number of results to return. The default limit is
	     * 100, with a maximum of 1000 results being returned at a time.
	     * @param {Number} n the number of results to limit to.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    limit: function(n) {
	      this._limit = n;
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be equal to the provided value.
	     * @param {String} key The key to check.
	     * @param value The value that the Parse.Object must contain.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    equalTo: function(key, value) {
	      if (_.isUndefined(value)) {
	        return this.doesNotExist(key);
	      } 
	
	      this._where[key] = Parse._encode(value);
	      return this;
	    },
	
	    /**
	     * Helper for condition queries
	     */
	    _addCondition: function(key, condition, value) {
	      // Check if we already have a condition
	      if (!this._where[key]) {
	        this._where[key] = {};
	      }
	      this._where[key][condition] = Parse._encode(value);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be not equal to the provided value.
	     * @param {String} key The key to check.
	     * @param value The value that must not be equalled.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    notEqualTo: function(key, value) {
	      this._addCondition(key, "$ne", value);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be less than the provided value.
	     * @param {String} key The key to check.
	     * @param value The value that provides an upper bound.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    lessThan: function(key, value) {
	      this._addCondition(key, "$lt", value);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be greater than the provided value.
	     * @param {String} key The key to check.
	     * @param value The value that provides an lower bound.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    greaterThan: function(key, value) {
	      this._addCondition(key, "$gt", value);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be less than or equal to the provided value.
	     * @param {String} key The key to check.
	     * @param value The value that provides an upper bound.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    lessThanOrEqualTo: function(key, value) {
	      this._addCondition(key, "$lte", value);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be greater than or equal to the provided value.
	     * @param {String} key The key to check.
	     * @param value The value that provides an lower bound.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    greaterThanOrEqualTo: function(key, value) {
	      this._addCondition(key, "$gte", value);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * be contained in the provided list of values.
	     * @param {String} key The key to check.
	     * @param {Array} values The values that will match.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    containedIn: function(key, values) {
	      this._addCondition(key, "$in", values);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * not be contained in the provided list of values.
	     * @param {String} key The key to check.
	     * @param {Array} values The values that will not match.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    notContainedIn: function(key, values) {
	      this._addCondition(key, "$nin", values);
	      return this;
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's value to
	     * contain each one of the provided list of values.
	     * @param {String} key The key to check.  This key's value must be an array.
	     * @param {Array} values The values that will match.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    containsAll: function(key, values) {
	      this._addCondition(key, "$all", values);
	      return this;
	    },
	
	
	    /**
	     * Add a constraint for finding objects that contain the given key.
	     * @param {String} key The key that should exist.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    exists: function(key) {
	      this._addCondition(key, "$exists", true);
	      return this;
	    },
	
	    /**
	     * Add a constraint for finding objects that do not contain a given key.
	     * @param {String} key The key that should not exist
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    doesNotExist: function(key) {
	      this._addCondition(key, "$exists", false);
	      return this;
	    },
	
	    /**
	     * Add a regular expression constraint for finding string values that match
	     * the provided regular expression.
	     * This may be slow for large datasets.
	     * @param {String} key The key that the string to match is stored in.
	     * @param {RegExp} regex The regular expression pattern to match.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    matches: function(key, regex, modifiers) {
	      this._addCondition(key, "$regex", regex);
	      if (!modifiers) { modifiers = ""; }
	      // Javascript regex options support mig as inline options but store them 
	      // as properties of the object. We support mi & should migrate them to
	      // modifiers
	      if (regex.ignoreCase) { modifiers += 'i'; }
	      if (regex.multiline) { modifiers += 'm'; }
	
	      if (modifiers && modifiers.length) {
	        this._addCondition(key, "$options", modifiers);
	      }
	      return this;
	    },
	
	    /**
	     * Add a constraint that requires that a key's value matches a Parse.Query
	     * constraint.
	     * @param {String} key The key that the contains the object to match the
	     *                     query.
	     * @param {Parse.Query} query The query that should match.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    matchesQuery: function(key, query) {
	      var queryJSON = query.toJSON();
	      queryJSON.className = query.className;
	      this._addCondition(key, "$inQuery", queryJSON);
	      return this;
	    },
	
	   /**
	     * Add a constraint that requires that a key's value not matches a
	     * Parse.Query constraint.
	     * @param {String} key The key that the contains the object to match the
	     *                     query.
	     * @param {Parse.Query} query The query that should not match.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    doesNotMatchQuery: function(key, query) {
	      var queryJSON = query.toJSON();
	      queryJSON.className = query.className;
	      this._addCondition(key, "$notInQuery", queryJSON);
	      return this;
	    },
	
	
	    /**
	     * Add a constraint that requires that a key's value matches a value in
	     * an object returned by a different Parse.Query.
	     * @param {String} key The key that contains the value that is being
	     *                     matched.
	     * @param {String} queryKey The key in the objects returned by the query to
	     *                          match against.
	     * @param {Parse.Query} query The query to run.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    matchesKeyInQuery: function(key, queryKey, query) {
	      var queryJSON = query.toJSON();
	      queryJSON.className = query.className;
	      this._addCondition(key, "$select",
	                         { key: queryKey, query: queryJSON });
	      return this;
	    },
	
	    /**
	     * Add a constraint that requires that a key's value not match a value in
	     * an object returned by a different Parse.Query.
	     * @param {String} key The key that contains the value that is being
	     *                     excluded.
	     * @param {String} queryKey The key in the objects returned by the query to
	     *                          match against.
	     * @param {Parse.Query} query The query to run.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    doesNotMatchKeyInQuery: function(key, queryKey, query) {
	      var queryJSON = query.toJSON();
	      queryJSON.className = query.className;
	      this._addCondition(key, "$dontSelect",
	                         { key: queryKey, query: queryJSON });
	      return this;
	    },
	
	    /**
	     * Add constraint that at least one of the passed in queries matches.
	     * @param {Array} queries
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    _orQuery: function(queries) {
	      var queryJSON = _.map(queries, function(q) {
	        return q.toJSON().where;
	      });
	
	      this._where.$or = queryJSON;
	      return this;
	    },
	
	    /**
	     * Converts a string into a regex that matches it.
	     * Surrounding with \Q .. \E does this, we just need to escape \E's in
	     * the text separately.
	     */
	    _quote: function(s) {
	      return "\\Q" + s.replace("\\E", "\\E\\\\E\\Q") + "\\E";
	    },
	
	    /**
	     * Add a constraint for finding string values that contain a provided
	     * string.  This may be slow for large datasets.
	     * @param {String} key The key that the string to match is stored in.
	     * @param {String} substring The substring that the value must contain.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    contains: function(key, value) {
	      this._addCondition(key, "$regex", this._quote(value));
	      return this;
	    },
	
	    /**
	     * Add a constraint for finding string values that start with a provided
	     * string.  This query will use the backend index, so it will be fast even
	     * for large datasets.
	     * @param {String} key The key that the string to match is stored in.
	     * @param {String} prefix The substring that the value must start with.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    startsWith: function(key, value) {
	      this._addCondition(key, "$regex", "^" + this._quote(value));
	      return this;
	    },
	
	    /**
	     * Add a constraint for finding string values that end with a provided
	     * string.  This will be slow for large datasets.
	     * @param {String} key The key that the string to match is stored in.
	     * @param {String} suffix The substring that the value must end with.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    endsWith: function(key, value) {
	      this._addCondition(key, "$regex", this._quote(value) + "$");
	      return this;
	    },
	
	    /**
	     * Sorts the results in ascending order by the given key.
	     * 
	     * @param {(String|String[]|...String} key The key to order by, which is a 
	     * string of comma separated values, or an Array of keys, or multiple keys.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    ascending: function() {
	      this._order = [];
	      return this.addAscending.apply(this, arguments);
	    },
	
	    /**
	     * Sorts the results in ascending order by the given key, 
	     * but can also add secondary sort descriptors without overwriting _order.
	     * 
	     * @param {(String|String[]|...String} key The key to order by, which is a
	     * string of comma separated values, or an Array of keys, or multiple keys.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    addAscending: function(key) {
	      var self = this; 
	      if (!this._order) {
	        this._order = [];
	      }
	      Parse._arrayEach(arguments, function(key) {
	        if (Array.isArray(key)) {
	          key = key.join();
	        }
	        self._order = self._order.concat(key.replace(/\s/g, "").split(","));
	      });
	      return this;
	    },
	
	    /**
	     * Sorts the results in descending order by the given key.
	     * 
	     * @param {(String|String[]|...String} key The key to order by, which is a
	     * string of comma separated values, or an Array of keys, or multiple keys.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    descending: function(key) {
	      this._order = [];
	      return this.addDescending.apply(this, arguments);
	    },
	
	    /**
	     * Sorts the results in descending order by the given key,
	     * but can also add secondary sort descriptors without overwriting _order.
	     * 
	     * @param {(String|String[]|...String} key The key to order by, which is a
	     * string of comma separated values, or an Array of keys, or multiple keys.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    addDescending: function(key) {
	      var self = this; 
	      if (!this._order) {
	        this._order = [];
	      }
	      Parse._arrayEach(arguments, function(key) {
	        if (Array.isArray(key)) {
	          key = key.join();
	        }
	        self._order = self._order.concat(
	          _.map(key.replace(/\s/g, "").split(","), 
	            function(k) { return "-" + k; }));
	      });
	      return this;
	    },
	
	    /**
	     * Add a proximity based constraint for finding objects with key point
	     * values near the point given.
	     * @param {String} key The key that the Parse.GeoPoint is stored in.
	     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    near: function(key, point) {
	      if (!(point instanceof Parse.GeoPoint)) {
	        // Try to cast it to a GeoPoint, so that near("loc", [20,30]) works.
	        point = new Parse.GeoPoint(point);
	      }
	      this._addCondition(key, "$nearSphere", point);
	      return this;
	    },
	
	    /**
	     * Add a proximity based constraint for finding objects with key point
	     * values near the point given and within the maximum distance given.
	     * @param {String} key The key that the Parse.GeoPoint is stored in.
	     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
	     * @param {Number} maxDistance Maximum distance (in radians) of results to
	     *   return.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    withinRadians: function(key, point, distance) {
	      this.near(key, point);
	      this._addCondition(key, "$maxDistance", distance);
	      return this;
	    },
	
	    /**
	     * Add a proximity based constraint for finding objects with key point
	     * values near the point given and within the maximum distance given.
	     * Radius of earth used is 3958.8 miles.
	     * @param {String} key The key that the Parse.GeoPoint is stored in.
	     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
	     * @param {Number} maxDistance Maximum distance (in miles) of results to
	     *     return.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    withinMiles: function(key, point, distance) {
	      return this.withinRadians(key, point, distance / 3958.8);
	    },
	
	    /**
	     * Add a proximity based constraint for finding objects with key point
	     * values near the point given and within the maximum distance given.
	     * Radius of earth used is 6371.0 kilometers.
	     * @param {String} key The key that the Parse.GeoPoint is stored in.
	     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
	     * @param {Number} maxDistance Maximum distance (in kilometers) of results
	     *     to return.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    withinKilometers: function(key, point, distance) {
	      return this.withinRadians(key, point, distance / 6371.0);
	    },
	
	    /**
	     * Add a constraint to the query that requires a particular key's
	     * coordinates be contained within a given rectangular geographic bounding
	     * box.
	     * @param {String} key The key to be constrained.
	     * @param {Parse.GeoPoint} southwest
	     *     The lower-left inclusive corner of the box.
	     * @param {Parse.GeoPoint} northeast
	     *     The upper-right inclusive corner of the box.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    withinGeoBox: function(key, southwest, northeast) {
	      if (!(southwest instanceof Parse.GeoPoint)) {
	        southwest = new Parse.GeoPoint(southwest);
	      }
	      if (!(northeast instanceof Parse.GeoPoint)) {
	        northeast = new Parse.GeoPoint(northeast);
	      }
	      this._addCondition(key, '$within', { '$box': [southwest, northeast] });
	      return this;
	    },
	
	    /**
	     * Include nested Parse.Objects for the provided key.  You can use dot
	     * notation to specify which fields in the included object are also fetched.
	     * @param {String} key The name of the key to include.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    include: function() {
	      var self = this;
	      Parse._arrayEach(arguments, function(key) {
	        if (_.isArray(key)) {
	          self._include = self._include.concat(key);
	        } else {
	          self._include.push(key);
	        }
	      });
	      return this;
	    },
	
	    /**
	     * Restrict the fields of the returned Parse.Objects to include only the
	     * provided keys.  If this is called multiple times, then all of the keys
	     * specified in each of the calls will be included.
	     * @param {Array} keys The names of the keys to include.
	     * @return {Parse.Query} Returns the query, so you can chain this call.
	     */
	    select: function() {
	      var self = this;
	      this._select = this._select || [];
	      Parse._arrayEach(arguments, function(key) {
	        if (_.isArray(key)) {
	          self._select = self._select.concat(key);
	        } else {
	          self._select.push(key);
	        }
	      });
	      return this;
	    },
	
	    /**
	     * Iterates over each result of a query, calling a callback for each one. If
	     * the callback returns a promise, the iteration will not continue until
	     * that promise has been fulfilled. If the callback returns a rejected
	     * promise, then iteration will stop with that error. The items are
	     * processed in an unspecified order. The query may not have any sort order,
	     * and may not use limit or skip.
	     * @param {Function} callback Callback that will be called with each result
	     *     of the query.
	     * @param {Object} options An optional Backbone-like options object with
	     *     success and error callbacks that will be invoked once the iteration
	     *     has finished.
	     * @return {Parse.Promise} A promise that will be fulfilled once the
	     *     iteration has completed.
	     */
	    each: function(callback, options) {
	      options = options || {};
	
	      if (this._order || this._skip || (this._limit >= 0)) {
	        var error =
	          "Cannot iterate on a query with sort, skip, or limit.";
	        return Parse.Promise.error(error)._thenRunCallbacks(options);
	      }
	
	      var promise = new Parse.Promise();
	
	      var query = new Parse.Query(this.objectClass);
	      // We can override the batch size from the options.
	      // This is undocumented, but useful for testing.
	      query._limit = options.batchSize || 100;
	      query._where = _.clone(this._where);
	      query._include = _.clone(this._include);
	      if (this._select) {
	        query._select = _.clone(this._select);
	      }
	
	      query.ascending('objectId');
	
	      var findOptions = {};
	      if (_.has(options, "useMasterKey")) {
	        findOptions.useMasterKey = options.useMasterKey;
	      }
	      if (_.has(options, 'sessionToken')) {
	        findOptions.sessionToken = options.sessionToken;
	      }
	
	      var finished = false;
	      return Parse.Promise._continueWhile(function() {
	        return !finished;
	
	      }, function() {
	        return query.find(findOptions).then(function(results) {
	          var callbacksDone = Parse.Promise.as();
	          Parse._.each(results, function(result) {
	            callbacksDone = callbacksDone.then(function() {
	              return callback(result);
	            });
	          });
	
	          return callbacksDone.then(function() {
	            if (results.length >= query._limit) {
	              query.greaterThan("objectId", results[results.length - 1].id);
	            } else {
	              finished = true;
	            }
	          });
	        });
	      })._thenRunCallbacks(options);
	    }
	  };
	
	}(this));
	
	/*global FB: false , console: false*/
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  var PUBLIC_KEY = "*";
	
	  var initialized = false;
	  var requestedPermissions;
	  var initOptions;
	  var provider = {
	    authenticate: function(options) {
	      var self = this;
	      FB.login(function(response) {
	        if (response.authResponse) {
	          if (options.success) {
	            options.success(self, {
	              id: response.authResponse.userID,
	              access_token: response.authResponse.accessToken,
	              expiration_date: new Date(response.authResponse.expiresIn * 1000 +
	                  (new Date()).getTime()).toJSON()
	            });
	          }
	        } else {
	          if (options.error) {
	            options.error(self, response);
	          }
	        }
	      }, {
	        scope: requestedPermissions
	      });
	    },
	    restoreAuthentication: function(authData) {
	      if (authData) {
	        var authResponse = {
	          userID: authData.id,
	          accessToken: authData.access_token,
	          expiresIn: (Parse._parseDate(authData.expiration_date).getTime() -
	              (new Date()).getTime()) / 1000
	        };
	        var newOptions = _.clone(initOptions);
	        newOptions.authResponse = authResponse;
	
	        // Suppress checks for login status from the browser.
	        newOptions.status = false;
	
	        // If the user doesn't match the one known by the FB SDK, log out.
	        // Most of the time, the users will match -- it's only in cases where
	        // the FB SDK knows of a different user than the one being restored
	        // from a Parse User that logged in with username/password.
	        var existingResponse = FB.getAuthResponse();
	        if (existingResponse &&
	            existingResponse.userID !== authResponse.userID) {
	          FB.logout();
	        }
	
	        FB.init(newOptions);
	      }
	      return true;
	    },
	    getAuthType: function() {
	      return "facebook";
	    },
	    deauthenticate: function() {
	      this.restoreAuthentication(null);
	    }
	  };
	
	  /**
	   * Provides a set of utilities for using Parse with Facebook.
	   * @namespace
	   * Provides a set of utilities for using Parse with Facebook.
	   */
	  Parse.FacebookUtils = {
	    /**
	     * Initializes Parse Facebook integration.  Call this function after you
	     * have loaded the Facebook Javascript SDK with the same parameters
	     * as you would pass to<code>
	     * <a href=
	     * "https://developers.facebook.com/docs/reference/javascript/FB.init/">
	     * FB.init()</a></code>.  Parse.FacebookUtils will invoke FB.init() for you
	     * with these arguments.
	     *
	     * @param {Object} options Facebook options argument as described here:
	     *   <a href=
	     *   "https://developers.facebook.com/docs/reference/javascript/FB.init/">
	     *   FB.init()</a>. The status flag will be coerced to 'false' because it
	     *   interferes with Parse Facebook integration. Call FB.getLoginStatus()
	     *   explicitly if this behavior is required by your application.
	     */
	    init: function(options) {
	      if (typeof(FB) === 'undefined') {
	        throw "The Facebook JavaScript SDK must be loaded before calling init.";
	      } 
	      initOptions = _.clone(options) || {};
	      if (initOptions.status && typeof(console) !== "undefined") {
	        var warn = console.warn || console.log || function() {};
	        warn.call(console, "The 'status' flag passed into" +
	          " FB.init, when set to true, can interfere with Parse Facebook" +
	          " integration, so it has been suppressed. Please call" +
	          " FB.getLoginStatus() explicitly if you require this behavior.");
	      }
	      initOptions.status = false;
	      FB.init(initOptions);
	      Parse.User._registerAuthenticationProvider(provider);
	      initialized = true;
	    },
	
	    /**
	     * Gets whether the user has their account linked to Facebook.
	     * 
	     * @param {Parse.User} user User to check for a facebook link.
	     *     The user must be logged in on this device.
	     * @return {Boolean} <code>true</code> if the user has their account
	     *     linked to Facebook.
	     */
	    isLinked: function(user) {
	      return user._isLinked("facebook");
	    },
	
	    /**
	     * Logs in a user using Facebook. This method delegates to the Facebook
	     * SDK to authenticate the user, and then automatically logs in (or
	     * creates, in the case where it is a new user) a Parse.User.
	     * 
	     * @param {String, Object} permissions The permissions required for Facebook
	     *    log in.  This is a comma-separated string of permissions.
	     *    Alternatively, supply a Facebook authData object as described in our
	     *    REST API docs if you want to handle getting facebook auth tokens
	     *    yourself.
	     * @param {Object} options Standard options object with success and error
	     *    callbacks.
	     */
	    logIn: function(permissions, options) {
	      if (!permissions || _.isString(permissions)) {
	        if (!initialized) {
	          throw "You must initialize FacebookUtils before calling logIn.";
	        }
	        requestedPermissions = permissions;
	        return Parse.User._logInWith("facebook", options);
	      } else {
	        var newOptions = _.clone(options) || {};
	        newOptions.authData = permissions;
	        return Parse.User._logInWith("facebook", newOptions);
	      }
	    },
	
	    /**
	     * Links Facebook to an existing PFUser. This method delegates to the
	     * Facebook SDK to authenticate the user, and then automatically links
	     * the account to the Parse.User.
	     *
	     * @param {Parse.User} user User to link to Facebook. This must be the
	     *     current user.
	     * @param {String, Object} permissions The permissions required for Facebook
	     *    log in.  This is a comma-separated string of permissions. 
	     *    Alternatively, supply a Facebook authData object as described in our
	     *    REST API docs if you want to handle getting facebook auth tokens
	     *    yourself.
	     * @param {Object} options Standard options object with success and error
	     *    callbacks.
	     */
	    link: function(user, permissions, options) {
	      if (!permissions || _.isString(permissions)) {
	        if (!initialized) {
	          throw "You must initialize FacebookUtils before calling link.";
	        }
	        requestedPermissions = permissions;
	        return user._linkWith("facebook", options);
	      } else {
	        var newOptions = _.clone(options) || {};
	        newOptions.authData = permissions;
	        return user._linkWith("facebook", newOptions);
	      }
	    },
	
	    /**
	     * Unlinks the Parse.User from a Facebook account. 
	     * 
	     * @param {Parse.User} user User to unlink from Facebook. This must be the
	     *     current user.
	     * @param {Object} options Standard options object with success and error
	     *    callbacks.
	     */
	    unlink: function(user, options) {
	      if (!initialized) {
	        throw "You must initialize FacebookUtils before calling unlink.";
	      }
	      return user._unlinkFrom("facebook", options);
	    }
	  };
	  
	}(this));
	
	/*global _: false, document: false, window: false, navigator: false */
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * History serves as a global router (per frame) to handle hashchange
	   * events or pushState, match the appropriate route, and trigger
	   * callbacks. You shouldn't ever have to create one of these yourself
	   * — you should use the reference to <code>Parse.history</code>
	   * that will be created for you automatically if you make use of 
	   * Routers with routes.
	   * @class
	   *   
	   * <p>A fork of Backbone.History, provided for your convenience.  If you 
	   * use this class, you must also include jQuery, or another library 
	   * that provides a jQuery-compatible $ function.  For more information,
	   * see the <a href="http://documentcloud.github.com/backbone/#History">
	   * Backbone documentation</a>.</p>
	   * <p><strong><em>Available in the client SDK only.</em></strong></p>
	   */
	  Parse.History = function() {
	    this.handlers = [];
	    _.bindAll(this, 'checkUrl');
	  };
	
	  // Cached regex for cleaning leading hashes and slashes .
	  var routeStripper = /^[#\/]/;
	
	  // Cached regex for detecting MSIE.
	  var isExplorer = /msie [\w.]+/;
	
	  // Has the history handling already been started?
	  Parse.History.started = false;
	
	  // Set up all inheritable **Parse.History** properties and methods.
	  _.extend(Parse.History.prototype, Parse.Events,
	           /** @lends Parse.History.prototype */ {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(windowOverride) {
	      var loc = windowOverride ? windowOverride.location : window.location;
	      var match = loc.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the cross-browser normalized URL fragment, either from the URL,
	    // the hash, or the override.
	    getFragment: function(fragment, forcePushState) {
	      if (Parse._isNullOrUndefined(fragment)) {
	        if (this._hasPushState || forcePushState) {
	          fragment = window.location.pathname;
	          var search = window.location.search;
	          if (search) {
	            fragment += search;
	          }
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      if (!fragment.indexOf(this.options.root)) {
	        fragment = fragment.substr(this.options.root.length);
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    /**
	     * Start the hash change handling, returning `true` if the current
	     * URL matches an existing route, and `false` otherwise.
	     */
	    start: function(options) {
	      if (Parse.History.started) {
	        throw new Error("Parse.history has already been started");
	      }
	      Parse.History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options = _.extend({}, {root: '/'}, this.options, options);
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._wantsPushState = !!this.options.pushState;
	      this._hasPushState = !!(this.options.pushState && 
	                              window.history &&
	                              window.history.pushState);
	      var fragment = this.getFragment();
	      var docMode = document.documentMode;
	      var oldIE = (isExplorer.exec(navigator.userAgent.toLowerCase()) &&
	                   (!docMode || docMode <= 7));
	
	      if (oldIE) {
	        this.iframe = Parse.$('<iframe src="javascript:0" tabindex="-1" />')
	                      .hide().appendTo('body')[0].contentWindow;
	        this.navigate(fragment);
	      }
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._hasPushState) {
	        Parse.$(window).bind('popstate', this.checkUrl);
	      } else if (this._wantsHashChange &&
	                 ('onhashchange' in window) &&
	                 !oldIE) {
	        Parse.$(window).bind('hashchange', this.checkUrl);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = window.setInterval(this.checkUrl,
	                                                    this.interval);
	      }
	
	      // Determine if we need to change the base url, for a pushState link
	      // opened by a non-pushState browser.
	      this.fragment = fragment;
	      var loc = window.location;
	      var atRoot  = loc.pathname === this.options.root;
	
	      // If we've started off with a route from a `pushState`-enabled browser,
	      // but we're currently in a browser that doesn't support it...
	      if (this._wantsHashChange && 
	          this._wantsPushState && 
	          !this._hasPushState &&
	          !atRoot) {
	        this.fragment = this.getFragment(null, true);
	        window.location.replace(this.options.root + '#' + this.fragment);
	        // Return immediately as browser will do redirect to new url
	        return true;
	
	      // Or if we've started out with a hash-based route, but we're currently
	      // in a browser where it could be `pushState`-based instead...
	      } else if (this._wantsPushState &&
	                 this._hasPushState && 
	                 atRoot &&
	                 loc.hash) {
	        this.fragment = this.getHash().replace(routeStripper, '');
	        window.history.replaceState({}, document.title,
	            loc.protocol + '//' + loc.host + this.options.root + this.fragment);
	      }
	
	      if (!this.options.silent) {
	        return this.loadUrl();
	      }
	    },
	
	    // Disable Parse.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      Parse.$(window).unbind('popstate', this.checkUrl)
	                     .unbind('hashchange', this.checkUrl);
	      window.clearInterval(this._checkUrlInterval);
	      Parse.History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	      if (current === this.fragment && this.iframe) {
	        current = this.getFragment(this.getHash(this.iframe));
	      }
	      if (current === this.fragment) {
	        return false;
	      }
	      if (this.iframe) {
	        this.navigate(current);
	      }
	      if (!this.loadUrl()) {
	        this.loadUrl(this.getHash());
	      }
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragmentOverride) {
	      var fragment = this.fragment = this.getFragment(fragmentOverride);
	      var matched = _.any(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	      return matched;
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the
	    // history.
	    navigate: function(fragment, options) {
	      if (!Parse.History.started) {
	        return false;
	      }
	      if (!options || options === true) {
	        options = {trigger: options};
	      }
	      var frag = (fragment || '').replace(routeStripper, '');
	      if (this.fragment === frag) {
	        return;
	      }
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._hasPushState) {
	        if (frag.indexOf(this.options.root) !== 0) {
	          frag = this.options.root + frag;
	        }
	        this.fragment = frag;
	        var replaceOrPush = options.replace ? 'replaceState' : 'pushState';
	        window.history[replaceOrPush]({}, document.title, frag);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this.fragment = frag;
	        this._updateHash(window.location, frag, options.replace);
	        if (this.iframe &&
	            (frag !== this.getFragment(this.getHash(this.iframe)))) {
	          // Opening and closing the iframe tricks IE7 and earlier
	          // to push a history entry on hash-tag change.
	          // When replace is true, we don't want this.
	          if (!options.replace) {
	            this.iframe.document.open().close();
	          }
	          this._updateHash(this.iframe.location, frag, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        window.location.assign(this.options.root + fragment);
	      }
	      if (options.trigger) {
	        this.loadUrl(fragment);
	      }
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var s = location.toString().replace(/(javascript:|#).*$/, '');
	        location.replace(s + '#' + fragment);
	      } else {
	        location.hash = fragment;
	      }
	    }
	  });
	}(this));
	
	/*global _: false*/
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * Routers map faux-URLs to actions, and fire events when routes are
	   * matched. Creating a new one sets its `routes` hash, if not set statically.
	   * @class
	   *
	   * <p>A fork of Backbone.Router, provided for your convenience.
	   * For more information, see the
	   * <a href="http://documentcloud.github.com/backbone/#Router">Backbone
	   * documentation</a>.</p>
	   * <p><strong><em>Available in the client SDK only.</em></strong></p>
	   */
	  Parse.Router = function(options) {
	    options = options || {};
	    if (options.routes) {
	      this.routes = options.routes;
	    }
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var namedParam    = /:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-\[\]{}()+?.,\\\^\$\|#\s]/g;
	
	  // Set up all inheritable **Parse.Router** properties and methods.
	  _.extend(Parse.Router.prototype, Parse.Events,
	           /** @lends Parse.Router.prototype */ {
	
	    /**
	     * Initialize is an empty function by default. Override it with your own
	     * initialization logic.
	     */
	    initialize: function(){},
	
	    /**
	     * Manually bind a single named route to a callback. For example:
	     *
	     * <pre>this.route('search/:query/p:num', 'search', function(query, num) {
	     *       ...
	     *     });</pre>
	     */
	    route: function(route, name, callback) {
	      Parse.history = Parse.history || new Parse.History();
	      if (!_.isRegExp(route)) {
	        route = this._routeToRegExp(route);
	      } 
	      if (!callback) {
	        callback = this[name];
	      }
	      Parse.history.route(route, _.bind(function(fragment) {
	        var args = this._extractParameters(route, fragment);
	        if (callback) {
	          callback.apply(this, args);
	        }
	        this.trigger.apply(this, ['route:' + name].concat(args));
	        Parse.history.trigger('route', this, name, args);
	      }, this));
	      return this;
	    },
	
	    /**
	     * Whenever you reach a point in your application that you'd
	     * like to save as a URL, call navigate in order to update the
	     * URL. If you wish to also call the route function, set the 
	     * trigger option to true. To update the URL without creating
	     * an entry in the browser's history, set the replace option
	     * to true.
	     */
	    navigate: function(fragment, options) {
	      Parse.history.navigate(fragment, options);
	    },
	
	    // Bind all defined routes to `Parse.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) { 
	        return;
	      }
	      var routes = [];
	      for (var route in this.routes) {
	        if (this.routes.hasOwnProperty(route)) {
	          routes.unshift([route, this.routes[route]]);
	        }
	      }
	      for (var i = 0, l = routes.length; i < l; i++) {
	        this.route(routes[i][0], routes[i][1], this[routes[i][1]]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(namedParam, '([^\/]+)')
	                   .replace(splatParam, '(.*?)');
	      return new RegExp('^' + route + '$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted parameters.
	    _extractParameters: function(route, fragment) {
	      return route.exec(fragment).slice(1);
	    }
	  });
	
	  /**
	   * @function
	   * @param {Object} instanceProps Instance properties for the router.
	   * @param {Object} classProps Class properies for the router.
	   * @return {Class} A new subclass of <code>Parse.Router</code>.
	   */
	  Parse.Router.extend = Parse._extend;
	}(this));
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	  var _ = Parse._;
	
	  /**
	   * @namespace Contains functions for calling and declaring
	   * <a href="/docs/cloud_code_guide#functions">cloud functions</a>.
	   * <p><strong><em>
	   *   Some functions are only available from Cloud Code.
	   * </em></strong></p>
	   */
	  Parse.Cloud = Parse.Cloud || {};
	
	  _.extend(Parse.Cloud, /** @lends Parse.Cloud */ {
	    /**
	     * Makes a call to a cloud function.
	     * @param {String} name The function name.
	     * @param {Object} data The parameters to send to the cloud function.
	     * @param {Object} options A Backbone-style options object
	     * options.success, if set, should be a function to handle a successful
	     * call to a cloud function.  options.error should be a function that
	     * handles an error running the cloud function.  Both functions are
	     * optional.  Both functions take a single argument.
	     * @return {Parse.Promise} A promise that will be resolved with the result
	     * of the function.
	     */
	    run: function(name, data, options) {
	      options = options || {};
	
	      var request = Parse._request({
	        route: "functions",
	        className: name,
	        method: 'POST',
	        useMasterKey: options.useMasterKey,
	        sessionToken: options.sessionToken,
	        data: Parse._encode(data, null, true)
	      });
	
	      return request.then(function(resp) {
	        return Parse._decode(null, resp).result;
	      })._thenRunCallbacks(options);
	    }
	  });
	}(this));
	
	(function(root) {
	  root.Parse = root.Parse || {};
	  var Parse = root.Parse;
	
	  Parse.Installation = Parse.Object.extend("_Installation");
	
	  /**
	   * Contains functions to deal with Push in Parse
	   * @name Parse.Push
	   * @namespace
	   */
	  Parse.Push = Parse.Push || {};
	
	  /**
	   * Sends a push notification.
	   * @param {Object} data -  The data of the push notification.  Valid fields
	   * are:
	   *   <ol>
	   *     <li>channels - An Array of channels to push to.</li>
	   *     <li>push_time - A Date object for when to send the push.</li>
	   *     <li>expiration_time -  A Date object for when to expire
	   *         the push.</li>
	   *     <li>expiration_interval - The seconds from now to expire the push.</li>
	   *     <li>where - A Parse.Query over Parse.Installation that is used to match
	   *         a set of installations to push to.</li>
	   *     <li>data - The data to send as part of the push</li>
	   *   <ol>
	   * @param {Object} options An object that has an optional success function,
	   * that takes no arguments and will be called on a successful push, and
	   * an error function that takes a Parse.Error and will be called if the push
	   * failed.
	   * @return {Parse.Promise} A promise that is fulfilled when the push request
	   *     completes.
	   */
	  Parse.Push.send = function(data, options) {
	    options = options || {};
	
	    if (data.where) {
	      data.where = data.where.toJSON().where;
	    }
	
	    if (data.push_time) {
	      data.push_time = data.push_time.toJSON();
	    }
	
	    if (data.expiration_time) {
	      data.expiration_time = data.expiration_time.toJSON();
	    }
	
	    if (data.expiration_time && data.expiration_interval) {
	      throw "Both expiration_time and expiration_interval can't be set";
	    }
	
	    var request = Parse._request({
	      route: 'push',
	      method: 'POST',
	      data: data,
	      useMasterKey: options.useMasterKey
	    });
	    return request._thenRunCallbacks(options);
	  };
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14), __webpack_require__(38)))

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/payrollSubmissions/Submission.ejs -->\n<td>'+
	((__t=( model.getCompany().get('companyName') ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    <div>\n        '+
	((__t=( statusText ))==null?'':_.escape(__t))+
	'\n    </div>\n    <div class="progress">\n        ';
	 payrollProgress = (((model.get('status') - 2) * 100) / 7).toFixed(0) 
	__p+='\n        <div class="js-payroll-progress progress-bar\n            '+
	((__t=(
	                model.get('status') <= 3 ? 'progress-bar-danger' :
	                model.get('status') <= 5 ? 'progress-bar-warning' :
	                model.get('status') <= 8 ? 'progress-bar-info' :
	                    'progress-bar-primary'
	            ))==null?'':_.escape(__t))+
	'" role="progressbar" style="width:'+
	((__t=( payrollProgress ))==null?'':_.escape(__t))+
	'%">\n            <span>'+
	((__t=( payrollProgress ))==null?'':_.escape(__t))+
	'%</span>\n        </div>\n    </div>\n</td>\n<td class="td-action">\n    ';
	 /* We don't show the cancel button for statuses 1 and 2 because they
	        * have a special markup due to a datepicker and for status 8 because
	        * it means the payroll is completed. FIXME we need to fix the template
	        * to avoid this suckiness
	        */ 
	__p+='\n    ';
	 if (!_.contains([3, 9], model.get('status'))) { 
	__p+='\n        <button type="button" class="btn btn-danger js-cancel pull-right">\n            Cancel\n        </button>\n    ';
	 } 
	__p+='\n\n    ';
	 if (model.get('status') === 9) { 
	__p+='\n        <button type="button" class="btn btn-danger btn-outline js-revert\n            pull-right">\n            Revert\n        </button>\n    ';
	 } 
	__p+='\n\n    ';
	 if (model.get('status') === 3) { 
	__p+='\n        <div class="row">\n            <div class="col-md-9 col-lg-8">\n                <div class="form-group form-group-date"\n                    style="display:inline-block;">\n                    <label class="font-noraml">Cheque Pickup Date:</label>\n                    <div class="pickup-date input-group date"\n                        data-date-format="dd/mm/yyyy"\n                        style="max-width:200px">\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-white">\n                                <i class="fa fa-calendar"></i>\n                            </button>\n                        </span>\n                        <input type="text" class="form-control" value="">\n                    </div>\n                </div>\n                <button type="button" class="btn btn-success\n                    js-confirm-pickup" style="position:relative; top: 31px;">\n                    Confirm Pick Up\n                </button>\n            </div>\n            <div class="col-md-3 col-lg-4">\n                <button type="button" class="btn btn-danger js-cancel\n                    btn-confirm-pickup pull-right">\n                    Cancel\n                </button>\n            </div>\n        </div>\n\n    ';
	 } else if (model.get('status') === 4) { 
	__p+='\n        <button type="button" class="btn btn-success js-received-payment">\n            Received Payment\n        </button>\n\n    ';
	 } else if (model.get('status') === 5) { 
	__p+='\n        <button class="btn btn-success js-generate-forms">\n            Generate Forms\n        </button>\n\n        <button type="button" class="btn btn-success js-awaiting-signatures">\n            Forms - Awaiting Signatures\n        </button>\n\n        <div class="files-list js-attachments"></div>\n    ';
	 } else if (model.get('status') === 6) { 
	__p+='\n        <button type="button" class="btn btn-success js-awaiting-submission">\n            Forms - Awaiting Submission to Government\n        </button>\n\n    ';
	 } else if (model.get('status') === 7) { 
	__p+='\n        <button type="button" class="btn btn-success js-submitted-to-govt">\n            Forms - Submitted to Government\n        </button>\n\n    ';
	 } else if (model.get('status') === 8) { 
	__p+='\n        <div class="btn-group js-upload-files">\n            <button class="btn btn-success dropdown-toggle"\n                data-toggle="dropdown">\n                Upload Files\n                <span class="caret"></span>\n            </button>\n            <ul class="dropdown-menu">\n                ';
	 files = {
	                    'pcb tax-receipt':      'PCB Receipt',
	                    'socso tax-receipt':    'SOCSO Receipt',
	                    'form socso pdf final': '8A SOCSO Form (Final)',
	                    'form mtd pdf final':   'CP39 PCB Form (Final)'
	                } 
	__p+='\n                ';
	 _.each(_.keys(files), function(tags) { 
	__p+='\n                    <li>\n                        <label>\n                            <input class="hide js-upload-file"\n                                data-tags="'+
	((__t=( tags ))==null?'':_.escape(__t))+
	'"\n                                data-description="'+
	((__t=( files[tags] ))==null?'':_.escape(__t))+
	'"\n                                type="file" name="file">\n                                '+
	((__t=( files[tags] ))==null?'':_.escape(__t))+
	'\n                        </label>\n                    </li>\n                ';
	 }) 
	__p+='\n            </ul>\n        </div>\n\n        <button type="button" class="btn btn-success js-notify-company">\n            Forms - Uploaded - Notify Company\n        </button>\n\n        <div class="files-list js-attachments"></div>\n    ';
	 } 
	__p+='\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(655);
	var CompanyView = __webpack_require__(656);
	var PaginatedList = __webpack_require__(638);
	var loader = __webpack_require__(534);
	
	module.exports = PaginatedList.extend({
	    views: [],
	
	    events: function events() {
	        return Object.assign({
	            'change .js-searchbox-mpp': 'searchMpp',
	            'keyup .js-searchbox-mpp': 'autoSubmitMppSearch'
	        }, PaginatedList.prototype.events.apply(this));
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            discountCodes: []
	        });
	
	        this.views = [];
	
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.stopLoader = loader.startFullPage(this.$('table'));
	
	        return this;
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var sortClass = this.collection.getSort().order === 'ascending' ? 'footable-sorted-desc' : 'footable-sorted';
	
	        this.$el.html(template({
	            searchTerm: this.collection.getSearchTerm(),
	            mppSearchTerm: this.collection.getMppSearchTerm(),
	            total: this.collection.length,
	            pagination: this.collection.getPaginationInfo(),
	            sort: this.collection.getSort()
	        }));
	
	        this.collection.forEach(function (company) {
	            _this.views.push(new CompanyView({
	                model: company,
	                mppAdmins: _this.options.mppAdmins,
	                discountCodes: _this.options.discountCodes
	            }));
	
	            _this.$('.js-companies').append(_(_this.views).last().$el);
	        });
	
	        this.$('.footable-sortable').removeClass('footable-sorted-desc').removeClass('footable-sorted');
	
	        this.$('[data-sort="' + this.collection.getSort().key + '"]').addClass(sortClass);
	
	        this.stopLoader();
	        return this;
	    },
	
	    autoSubmitMppSearch: function autoSubmitMppSearch(ev) {
	        var _this2 = this;
	
	        var val = (this.$(ev.currentTarget).val() || '').trim();
	
	        if (!_.isUndefined(this.mppSearchboxTimeout)) {
	            clearTimeout(this.mppSearchboxTimeout);
	        }
	
	        if (this.collection.getMppSearchTerm() && val !== this.collection.getMppSearchTerm() && val.length >= 3) {
	            this.mppSearchboxTimeout = setTimeout(function () {
	                _this2.$(ev.currentTarget).trigger('change');
	            }, 1500);
	        }
	    },
	    searchMpp: function searchMpp(ev) {
	        var $el = this.$(ev.currentTarget);
	        var value = encodeURIComponent($el.val() || '').trim();
	
	        if (!_.isUndefined(this.mppSearchboxTimeout)) {
	            clearTimeout(this.mppSearchboxTimeout);
	        }
	
	        $el.prop({ 'disabled': true });
	        this.collection.mppSearchString = value;
	        this.navigate();
	    },
	
	
	    // TODO the brainchild of Artem, wouldn't it be nicer to use a qs?
	    navigate: function navigate() {
	        app.mainRouter.navigate('companies' + '/' + this.collection.getSort().key + '/' + this.collection.getSort().order + '/' + (this.collection.getSearchTerm() || '__all') + '/' + (this.collection.getMppSearchTerm() || '__all'), { trigger: true });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/companies/Main.html -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="col-md-3 col-md-offset-6">\n            <div class="searchbox">\n                <input type="text" name="search-mpp" placeholder="MPP search"\n                    class="form-control js-searchbox-mpp" value="'+
	((__t=( mppSearchTerm ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-search"></i>\n            </div>\n        </div>\n        <div class="col-md-3">\n            <div class="searchbox">\n                <input type="text" name="search" placeholder="Companies search"\n                    class="form-control js-searchbox" value="'+
	((__t=( searchTerm ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-search"></i>\n            </div>\n        </div>\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Companies</h5>\n                <div class="ibox-tools">\n                    <h5>&nbsp;Total Companies: '+
	((__t=( pagination.count ))==null?'':_.escape(__t))+
	'</h5>\n                </div>\n\n            </div>\n            <div class="ibox-content" style="overflow:scroll;">\n                <table class="footable footable-ellipsis table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th style="width:200px;" class="footable-sortable" data-sort="companyName">\n                                Company name <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:150px;"  class="footable-sortable" data-sort="contactName">\n                                Name <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:150px;" class="footable-sortable" data-sort="contactEmail">\n                                Email <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:120px;" class="footable-sortable" data-sort="lastActiveTime">\n                                Last Active Date<span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:100px;" class="footable-sortable" data-sort="createdAt">\n                                Sign Up Date <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:270px;">\n                                Discount\n                            </th>\n                            <th style="width:290px;">\n                                Actions\n                            </th>\n                            <th style="width: 200px;">MPP Admin</th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-companies"></tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _Company = __webpack_require__(657);
	
	var _Company2 = _interopRequireDefault(_Company);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    events: {
	        'click .js-login-to-company': 'loginToCompany',
	        'click .js-discount-save': 'updateDiscount',
	        'click .js-update-subs': 'forceSubsUpdate',
	        'click .js-generate-invoices': 'generateInvoices',
	        'click .js-toggle-invoicing': 'toggleInvoicing',
	        'click .js-update-details': 'updateDetails',
	        'click .js-remove-company': 'removeCompany',
	        'click .js-yearly-adjust': 'yearlyAdjust',
	        'change .js-ext-mppAdmin': 'updateMPP'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.options = _.defaults(options || {}, {
	            attachments: null,
	            discountCodes: []
	        });
	        this.model.on('sync', this.render, this);
	
	        this.model.fetchSubscription().then(function () {
	            return _this.render();
	        });
	
	        return this;
	    },
	
	    render: function render() {
	        this.$el.html((0, _Company2.default)({
	            model: this.model,
	            subscription: this.model.getSubscription(),
	            mppAdmins: this.options.mppAdmins,
	            discountCodes: this.options.discountCodes
	        }));
	
	        return this;
	    },
	
	    updateDiscount: function updateDiscount(ev) {
	        var _this2 = this;
	
	        ev.preventDefault();
	        var discountName = this.$('input[name="discount"]').val();
	        var isDiscountLimited = this.$('input[name="isDiscountLimited"]').prop('checked');
	        var discountLimit = this.$('input[name="discountLimit"]').val();
	        var stopLoader = _loader2.default.startFullScreen();
	        var subscription = this.model.getSubscription();
	
	        if (!discountName) {
	            subscription.set({
	                couponCode: ''
	            });
	        } else {
	            var discountCode = this.options.discountCodes.find(function (code) {
	                return [
	                // jscs:disable
	                code.invoice_name, code.name].includes(discountName);
	            });
	
	            if (!discountCode) {
	                _modal2.default.warning({
	                    text: 'Invalid discount specified. Please choose                     from the dropdown list'
	                });
	                return stopLoader();
	            }
	
	            subscription.set({
	                couponCode: discountCode.id
	            });
	        }
	
	        subscription.set({
	            isDiscountLimited: isDiscountLimited,
	            discountLimit: parseInt(discountLimit, 10) || 0
	        });
	        subscription.save().then(function () {
	            return _this2.render();
	        }).then(function () {
	            _modal2.default.showAlertSuccess('The discount has been updated');
	        }).catch(function (err) {
	            return _modal2.default.showError(JSON.stringify(err));
	        }).finally(stopLoader);
	    },
	
	
	    updateMPP: function updateMPP(ev) {
	        var $el = this.$(ev.currentTarget);
	        var mppAdmin = this.options.mppAdmins.find(function (u) {
	            return u.id == $el.val();
	        }) || null;
	        var promise = (0, _bluebird.resolve)();
	
	        if (mppAdmin) {
	            promise = this.model.setMPPAdmin(mppAdmin.id);
	        } else {
	            promise = this.model.unsetMPPAdmin();
	        }
	
	        this.$('.discount-inputs').toggleClass('discount-inputs', !!mppAdmin);
	
	        promise.then(function () {
	            _modal2.default.showAlertSuccess('Settings for MPP Admin have been saved');
	        }).catch(function (err) {
	            _alerts2.default.show('error', { text: JSON.stringify(err) });
	        });
	    },
	
	    loginToCompany: function loginToCompany() {
	        window.open('/?company=' + this.model.get('objectId'), '_blank');
	        return false;
	    },
	
	    forceSubsUpdate: function forceSubsUpdate(ev) {
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.getSubscription().updateStatus().then(function () {
	            return stopLoader();
	        }).catch(function (err) {
	            stopLoader();
	            _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	        });
	    },
	
	    generateInvoices: function generateInvoices(ev) {
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.getSubscription().generateInvoices().then(function () {
	            return stopLoader();
	        }).catch(function (err) {
	            stopLoader();
	            _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	        });
	    },
	
	    toggleInvoicing: function toggleInvoicing(ev) {
	        var _this3 = this;
	
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.getSubscription().toggleInvoicing().then(stopLoader).then(function () {
	            return _this3.render();
	        }).catch(function (err) {
	            stopLoader();
	            _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	        });
	    },
	
	    updateDetails: function updateDetails(ev) {
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.getSubscription().updateDetails().then(stopLoader).catch(function (err) {
	            stopLoader();
	            _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	        });
	    },
	
	    removeCompany: function removeCompany(ev) {
	        var _this4 = this;
	
	        ev.preventDefault();
	
	        var $button = this.$(ev.currentTarget);
	        _alerts2.default.show('confirm', {
	            title: 'Remove company',
	            text: 'Are you sure you want to remove ' + ('"' + (this.model.get('companyName') || this.model.get('contactName')) + '"?')
	        }).then(function () {
	            var stopLoader = _loader2.default.startFullScreen($button);
	            _this4.model.destroy().then(function () {
	                return window.location.reload();
	            }).catch(function (err) {
	                _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	            }).finally(function () {
	                return stopLoader();
	            });
	        });
	    },
	
	    yearlyAdjust: function yearlyAdjust(ev) {
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.getSubscription().adjustYearlyInvoice().then(function () {
	            return stopLoader();
	        }).catch(function (err) {
	            stopLoader();
	            _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/companies/Company.ejs -->\n';
	 var moment = __webpack_require__(101) 
	__p+='\n<td>\n    ';
	 if (model.get('isLocked')) { 
	__p+='\n        <i class="fa fa-exclamation-triangle"\n            data-toggle="tooltip"\n            data-placement="top" data-container="body"\n            data-title="this company has been locked due to payment overdue"\n        ></i>\n    ';
	 } 
	__p+='\n    '+
	((__t=( model.get('companyName') ))==null?'':_.escape(__t))+
	'\n</td>\n<td>'+
	((__t=( model.get('contactName') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('contactEmail') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('lastActiveTime') ? moment(model.get('lastActiveTime'))
	            .format('DD.MM.YYYY HH:mm') : '' ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( moment(model.get('createdAt')).format('DD.MM.YYYY') ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    ';
	
	       if (subscription) {
	           var matchingCoupon = discountCodes.find(
	               function (code) { return code.id === subscription.get('couponCode'); }
	            );
	    
	__p+='\n    <div class="discount-inputs '+
	((__t=( model.get('mppAdminId') ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n        <input name="discount"\n            list="couponCode" style="width:120px"\n            value="'+
	((__t=( matchingCoupon ? matchingCoupon.invoice_name || matchingCoupon.name : '' ))==null?'':_.escape(__t))+
	'"\n        >\n        <datalist id="couponCode">\n        ';
	 discountCodes.forEach(function (discountCode) { 
	__p+='\n            <option value="'+
	((__t=( discountCode.invoice_name || discountCode.name ))==null?'':_.escape(__t))+
	'">\n        ';
	 }); 
	__p+='\n        </datalist>\n        &nbsp;\n        <input name="isDiscountLimited" type="checkbox"\n            '+
	((__t=( subscription.get('isDiscountLimited') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n        > Limit\n        <input name="discountLimit" type="number" class="steps"\n            style="width:50px"\n            placeholder="Number of free invoices entitled to"\n            value="'+
	((__t=( subscription.get('discountLimit') || 0 ))==null?'':_.escape(__t))+
	'"\n            max="100" min="0" step="1"\n        >\n        <a class="js-discount-save" href="#">\n            <i class="fa fa-save"></i>\n        </a>\n    </div>\n    ';
	 } 
	__p+='\n</td>\n<td class="flex-container-row" style="overflow: visible;">\n    <a href="" class="spaced-child js-login-to-company" title="Login to Company">\n        <i class="fa fa-2x fa-sign-in"></i>\n    </a>\n    <a class="spaced-child" href="/#payrolls/'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'" title="Payrolls">\n        <i class="fa fa-2x fa-info"></i>\n    </a>\n    <a class="spaced-child" href="/#logs/'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'" title="Log">\n        <i class="fa fa-2x fa-list-alt"></i>\n    </a>\n    <a class="spaced-child" href="/#employees/'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'" title="Employees">\n        <i class="fa fa-2x fa-users"></i>\n    </a>\n    <a href="" title="Remove account" class="spaced-child js-remove-company">\n        <i class="fa fa-2x fa-trash"></i>\n    </a>\n    ';
	 if (subscription) {  
	__p+='\n    <div class="btn-group spaced-child" style="overflow: visible;">\n        <button type="button" class="btn btn-default dropdown-toggle"\n                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n            Subscription<span class="caret"></span>\n        </button>\n        <ul class="dropdown-menu">\n            <li><a href="#"\n                   title="Update subscription status according to invoices from\n                          Chargebee"\n                   class="js-update-subs">Update Subscription Status</a></li>\n            <li><a href="#"\n                   title="Update customer details"\n                   class="js-update-details">Update Customer Details</a>\n            </li>\n            <li><a href="#"\n                   title="Adjust yearly subscription"\n                   class="js-yearly-adjust">Adjust Yearly Subscription</a>\n            </li>\n        </ul>\n    </div>\n    ';
	 } 
	__p+='\n</td>\n<td>\n    <select class="form-control js-ext js-ext-mppAdmin" name="mppAdmin">\n        <option value=""></option>\n        ';
	 mppAdmins.forEach(function(user) { 
	__p+='\n            <option value="'+
	((__t=( user.id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( (model.get('mppAdminId') === user.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( user.get('name') ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var template = __webpack_require__(659);
	
	module.exports = Backbone.View.extend({
	
	    initialize: function initialize() {
	        this.render();
	    },
	
	    render: function render() {
	        var self = this;
	        self.$el.html(template());
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/Reports.html -->\n<div class="wrapper wrapper-content">\n    No Reports Yet\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _Main = __webpack_require__(661);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Payroll = __webpack_require__(662);
	
	var _Payroll2 = _interopRequireDefault(_Payroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-back': 'back'
	    },
	
	    initialize: function initialize(options) {
	        this.options = {
	            company: options.company
	        };
	        var payrolls = this.collection.map(function (payroll) {
	            var archive = options.attachments[payroll.id].findByTags(['payroll', 'archive', 'ready']).first();
	            var calculations = options.attachments[payroll.id].findByTags(['payroll', 'calculations', 'pdf']).first();
	            return new _Payroll2.default({
	                model: payroll,
	                archive: archive,
	                calculations: calculations
	            });
	        });
	        this.options.payrolls = payrolls;
	
	        return this;
	    },
	
	    render: function render() {
	        this.$el.html((0, _Main2.default)({
	            payrolls: this.options.payrolls,
	            company: this.options.company
	        }));
	
	        var $container = this.$('.js-payrolls');
	        this.options.payrolls.forEach(function (payroll) {
	            $container.append(payroll.render().$el);
	        });
	
	        return this;
	    },
	
	    back: function back() {
	        history.go(-1);
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/payrolls/Main.ejs -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <div class="flex-container-row">\n                    <a href="" class="js-back" title="Return to companies list">\n                        <i class="fa fa-2x fa-arrow-left"></i>\n                    </a>\n                    &nbsp;\n                    <h3>\n                        Payrolls for company:\n                        '+
	((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
	'\n                    </h3>\n                </div>\n                <div class="ibox-tools">\n                    <h5>&nbsp;Total payrolls: '+
	((__t=( payrolls.length ))==null?'':_.escape(__t))+
	'</h5>\n                </div>\n            </div>\n            <div class="ibox-content">\n            ';
	 if (company.subscription && company.subscription.get('type') === 'yearly') {
	__p+='\n                <h3>Current yearly subscription invoice: '+
	((__t=( (company.subscription.get('yearlyInvoice') || {}).id || 'N/A' ))==null?'':_.escape(__t))+
	'</h3>\n            ';
	 } 
	__p+='\n                <table class="footable table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th>Payroll period</th>\n                            <th>Status</th>\n                            <th>Employee<br/>Count</th>\n                            <th>Gross</th>\n                            <th>Total PCB</th>\n                            <th>Total EPF</th>\n                            <th>Total SOCSO</th>\n                            <th>Last updated</th>\n                            <th>Zip file</th>\n                            <th>Calculations file</th>\n                            <th>Actions</th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-payrolls">\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _Payroll = __webpack_require__(663);
	
	var _Payroll2 = _interopRequireDefault(_Payroll);
	
	var _PayrollEditModal = __webpack_require__(664);
	
	var _PayrollEditModal2 = _interopRequireDefault(_PayrollEditModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _downloadjs = __webpack_require__(666);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _payroll = __webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    events: {
	        'click .js-cancel': 'cancel',
	        'click .js-revert': 'revert',
	        'click .js-create-archive': 'createArchive',
	        'click .js-download': 'download',
	        'click .js-makeArchiveDownloadable:not(disabled)': 'makeArchiveDownloadable',
	        'click .js-markAsManuallyInvoiced:not(disabled)': 'markAsManuallyInvoiced',
	        'click .js-unlock': 'unlock',
	        'click .js-edit': 'togglEditModal'
	    },
	
	    editModal: null,
	
	    initialize: function initialize(options) {
	        this.options = {
	            archive: options.archive,
	            calculations: options.calculations
	        };
	        this.editModal = new _ModalForm2.default({
	            template: _PayrollEditModal2.default,
	            model: this.model
	        });
	        this.editModal.on('saved', this.render, this);
	    },
	
	    render: function render() {
	        this.$el.html((0, _Payroll2.default)({
	            model: this.model,
	            archive: this.options.archive,
	            calculations: this.options.calculations,
	            moment: _moment2.default
	        }));
	        return this;
	    },
	
	    download: function download(ev) {
	        var $button = this.$(ev.currentTarget);
	        var attachment = this.options[$button.data('file')];
	
	        if (attachment) {
	            /* jQuery ajax cannot be used here because messes up the response */
	            var xhr = new XMLHttpRequest();
	            xhr.open('GET', attachment.downloadUrl(), true);
	            xhr.responseType = 'blob';
	            xhr.onload = function () {
	                // TODO: handle errors
	                if (this.status == 200) {
	                    // get binary data as a response
	                    var blob = this.response;
	                    (0, _downloadjs2.default)(blob, attachment.get('name'), 'application/zip');
	                }
	            };
	            xhr.send();
	        } else {
	            _alerts2.default.show('warning', {
	                text: 'The file is being processed and should be ready ' + 'shortly. It usually takes a few seconds or a minute at ' + 'busy periods. Close this popup and refresh the page ' + 'to see if it is ready',
	                customClass: 'sweet-alert-error'
	            });
	        }
	    },
	
	    makeArchiveDownloadable: function makeArchiveDownloadable() {
	        var _this = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Warning!',
	            text: 'Before performing this action make sure you waited a ' + 'reasonable amount of time. After performing this action ' + 'review the file to make sure all contents are present.',
	            confirmButtonText: 'Continue',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this.model.makeArchiveDownloadable().then(function () {
	                    return window.location.reload();
	                }).fail(function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    markAsManuallyInvoiced: function markAsManuallyInvoiced() {
	        var _this2 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'This operation is not reversible!',
	            text: 'If you go ahead with this, your username will be logged. ' + 'This operation is not reversible so you have to make sure ' + 'a manual invoice for this payroll is created in chargebee',
	            confirmButtonText: 'Continue',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this2.model.markAsManuallyInvoiced().then(function () {
	                    return window.location.reload();
	                }).fail(function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    cancel: function cancel() {
	        var _this3 = this;
	
	        var warnTextByStatus = {
	            5: 'You have already recevied payment for this payroll. ',
	            6: 'Government forms have already been signed. ',
	            7: 'Forms have already been submitted to the government. ',
	            8: 'Forms have been processed. '
	        };
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to cancel this payroll?',
	            text: (warnTextByStatus[this.model.get('status')] || '') + 'You will lose any generated or uploaded forms and receipts',
	            confirmButtonText: 'Yes, Cancel',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this3.model.destroy().then(function () {
	                    return _this3.remove();
	                }, function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    revert: function revert() {
	        var _this4 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to revert this payroll?',
	            text: 'You will lose all generated and uploaded files, ' + 'including any emailed payslips and signed forms.',
	            confirmButtonText: 'Yes, Revert',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this4.model.revert().then(function () {
	                    return _this4.model.fetch();
	                }).then(function () {
	                    return _this4.render();
	                }).catch(function (err) {
	                    _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    createArchive: function createArchive() {
	        var _this5 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to recreate ' + 'archive file for this payroll?',
	            confirmButtonText: 'Yes',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this5.model.createArchive().then(function () {}, function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    unlock: function unlock() {
	        var _this6 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Warning!',
	            text: 'Before performing this action make sure you waited a ' + 'reasonable amount of time. After performing this action ' + 'review the payroll to make sure it\'s displaying all content' + 'correctly',
	            confirmButtonText: 'Continue',
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this6.model.save({ running: false }).then(function () {
	                    return _this6.model.setStatus(_payroll.payrollStatus.INITIAL);
	                }).then(function () {
	                    return _this6.model.fetch();
	                }).then(function () {
	                    return _this6.render();
	                }).fail(function (err) {
	                    return _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    togglEditModal: function togglEditModal() {
	        this.editModal.show();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/payrolls/Payroll.ejs -->\n<td>'+
	((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    '+
	((__t=( model.getStatusLabel() ))==null?'':_.escape(__t))+
	'\n    '+
	((__t=( model.get('revertedAt') ? '(Reverted)' : '' ))==null?'':_.escape(__t))+
	'\n</td>\n<td>'+
	((__t=( model.get('payslips') || 'N/A' ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    '+
	((__t=( (model.get('mtd') + model.get('cp38'))
	        .formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n</td>\n<td>\n    '+
	((__t=( (model.get('employeeEpf')
	        + model.get('employerEpf'))
	        .formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n</td>\n<td>\n    '+
	((__t=( (model.get('employeeSocso')
	        + model.get('employerSocso'))
	        .formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n</td>\n<td>\n    '+
	((__t=( moment(model.get('updatedAt'))
	        .format('DD/MM/YYYY HH:mm') ))==null?'':_.escape(__t))+
	'\n</td>\n<td>\n    ';
	 if (model.get('status') === 9) { 
	__p+='\n    <a class="btn btn-outine btn-primary\n        js-download" data-file="archive">\n        <i class="fa fa-download"></i>\n        '+
	((__t=( archive ? '' : 'Not ready' ))==null?'':_.escape(__t))+
	'\n    </a>\n    ';
	 } 
	__p+='\n</td>\n<td>\n    ';
	 if (model.get('status') === 9) { 
	__p+='\n    <a class="btn btn-outine btn-primary\n        js-download" data-file="calculations">\n        <i class="fa fa-download"></i>\n        '+
	((__t=( calculations ? '' : 'Not ready' ))==null?'':_.escape(__t))+
	'\n    </a>\n    ';
	 } 
	__p+='\n</td>\n<td>\n    ';
	 if (model.get('running')) { 
	__p+='\n    <button type="button"\n        data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n        class="btn btn-danger js-unlock">\n        Unlock\n    </button>\n    ';
	 } 
	__p+='\n\n    ';
	 if (!_.contains([3, 9], model.get('status'))) { 
	__p+='\n    <button type="button"\n        data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n        class="btn btn-danger js-cancel">\n        Cancel\n    </button>\n    ';
	 } 
	__p+='\n\n    ';
	 if (model.get('status') === 9) { 
	__p+='\n        <button type="button"\n            data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n            class="btn btn-danger btn-outline js-revert">\n            Revert\n        </button>\n        <button type="button"\n            data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n            class="btn btn-danger btn-outline js-create-archive">\n            Create Archive\n        </button>\n        <button class="btn btn-outline js-edit">\n            <i class="fa fa-pencil-square-o"></i>\n            Edit Invoice Info\n        </button>\n        ';
	 if (
	            !model.get('chargebeeInvoiceId') || (
	                model.get('chargebeeInvoiceId').substr(0, 2) !== 'MI' &&
	                model.get('chargebeeInvoiceId') !== 'free'
	            )
	        ) { 
	__p+='\n            ';
	 if (model.get('chargebeeInvoiceId')) { 
	__p+='\n                <button \n                    class="btn btn-outline btn-warning js-edit"\n                    data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n                >\n                    INVOICE: '+
	((__t=( model.get('chargebeeInvoiceId') ))==null?'':_.escape(__t))+
	'\n                </button>\n            ';
	 } 
	__p+='\n            ';
	 if (model.get('chargebeeAdjustmentInvoiceId')) { 
	__p+='\n                <button class="btn btn-outline btn-warning js-edit">\n                    ADJUSTMENT INVOICE: '+
	((__t=( model.get('chargebeeAdjustmentInvoiceId') ))==null?'':_.escape(__t))+
	'\n                </button>\n            ';
	 } 
	__p+='\n            <button class="btn btn-outline js-markAsManuallyInvoiced btn-primary"\n                data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'">\n                Mark as Manually Invoiced\n            </button>\n        ';
	 } else if (model.get('chargebeeInvoiceId') === 'free') { 
	__p+='\n            <button class="btn btn-outline btn-warning disabled" disabled>\n                Free Payroll\n            </button>\n        ';
	 } else if (model.get('chargebeeInvoiceId').substr(0, 2) === 'MI') { 
	__p+='\n            <button class="btn btn-outline btn-warning disabled" disabled>\n                Manually Invoiced by '+
	((__t=( model.get('chargebeeInvoiceId').split('-')[1] ))==null?'':_.escape(__t))+
	'\n            </button>\n        ';
	 } 
	__p+='\n        ';
	 if (model.get('chargebeeInvoiceNote')) { 
	__p+='\n            <button class="btn btn-outline btn-warning disabled" disabled>\n                '+
	((__t=( model.get('chargebeeInvoiceNote') ))==null?'':_.escape(__t))+
	'\n            </button>\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n    ';
	 disabled = (model.get('status') === 9 && archive) || model.get('status') < 9; 
	__p+='\n    <button class="btn btn-outline js-makeArchiveDownloadable\n        '+
	((__t=( disabled ? '' : 'btn-primary' ))==null?'':_.escape(__t))+
	'"\n        data-id="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n        '+
	((__t=( disabled ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n        Make File Downloadable\n    </button>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/payrolls/PayrollEditModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            <h3>Edit Payroll</h3>\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Invoice ID\n                        </label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="chargebeeInvoiceId"\n                                value="'+
	((__t=( model.get('chargebeeInvoiceId') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-chargebeeInvoiceId"></span>\n                        </div>\n                    </div>\n\n                    <!-- city -->\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Adjustment Invoice ID\n                        </label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="chargebeeAdjustmentInvoiceId"\n                                value="'+
	((__t=( model.get('chargebeeAdjustmentInvoiceId') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-chargebeeAdjustmentInvoiceId"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var FormView = __webpack_require__(550);
	
	module.exports = FormView.extend({
	    tagName: 'div',
	    className: 'modal inmodal',
	
	    events: function events() {
	        var parentEvents = _.isFunction(FormView.prototype.events) ? FormView.prototype.events() : FormView.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'hide.bs.modal': 'render',
	            'show.bs.modal': 'render',
	
	            /* If we don't stop this datepicker events they bubble up and
	             * cause render to loop infinitely
	             * */
	            'hide .js-datepicker': 'stopEvent',
	            'show .js-datepicker': 'stopEvent',
	
	            'hidden.bs.modal': 'hidden',
	            'shown.bs.modal': 'shown'
	        });
	    },
	
	    initialize: function initialize() {
	        this.on('saved cancelled destroyed', this.hide, this);
	        return FormView.prototype.initialize.apply(this, arguments);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = FormView.prototype.bindHandlers.apply(this, arguments);
	
	        app.events.off(null, null, this);
	
	        return r;
	    },
	
	    stopEvent: function stopEvent(ev) {
	        ev.preventDefault();
	        ev.stopImmediatePropagation();
	    },
	
	    show: function show() {
	        this.trigger('show');
	        this.$el.modal('show');
	    },
	
	    shown: function shown() {
	        this.trigger('shown');
	    },
	
	    hide: function hide() {
	        this.trigger('hide');
	        this.$el.modal('hide');
	    },
	
	    hidden: function hidden() {
	        this.trigger('hidden');
	    },
	
	    isVisible: function isVisible() {
	        return this.$el.hasClass('in');
	    },
	
	    dirty: function dirty() {
	        return this.isVisible() && FormView.prototype.dirty.apply(this, arguments);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
	// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
	// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
	// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
	// v4 adds AMD/UMD, commonJS, and plain browser support
	// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
	// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
	// https://github.com/rndme/download
	
	(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.download = factory();
	  }
	}(this, function () {
	
		return function download(data, strFileName, strMimeType) {
	
			var self = window, // this script is only for browsers anyway...
				defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
				mimeType = strMimeType || defaultMime,
				payload = data,
				url = !strFileName && !strMimeType && payload,
				anchor = document.createElement("a"),
				toString = function(a){return String(a);},
				myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
				fileName = strFileName || "download",
				blob,
				reader;
				myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
		  
			if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
				payload=[payload, mimeType];
				mimeType=payload[0];
				payload=payload[1];
			}
	
	
			if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
				fileName = url.split("/").pop().split("?")[0];
				anchor.href = url; // assign href prop to temp anchor
			  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
	        		var ajax=new XMLHttpRequest();
	        		ajax.open( "GET", url, true);
	        		ajax.responseType = 'blob';
	        		ajax.onload= function(e){ 
					  download(e.target.response, fileName, defaultMime);
					};
	        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
				    return ajax;
				} // end if valid url?
			} // end if url?
	
	
			//go ahead and download dataURLs right away
			if(/^data\:[\w+\-]+\/[\w+\-\.]+[,;]/.test(payload)){
			
				if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
					payload=dataUrlToBlob(payload);
					mimeType=payload.type || defaultMime;
				}else{			
					return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
						navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
						saver(payload) ; // everyone else can save dataURLs un-processed
				}
				
			}else{//not data url, is it a string with special needs?
				if(/([\x80-\xff])/.test(payload)){			  
					var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
					for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
				 	payload=new myBlob([tempUiArr], {type: mimeType});
				}		  
			}
			blob = payload instanceof myBlob ?
				payload :
				new myBlob([payload], {type: mimeType}) ;
	
	
			function dataUrlToBlob(strUrl) {
				var parts= strUrl.split(/[:;,]/),
				type= parts[1],
				decoder= parts[2] == "base64" ? atob : decodeURIComponent,
				binData= decoder( parts.pop() ),
				mx= binData.length,
				i= 0,
				uiArr= new Uint8Array(mx);
	
				for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);
	
				return new myBlob([uiArr], {type: type});
			 }
	
			function saver(url, winMode){
	
				if ('download' in anchor) { //html5 A[download]
					anchor.href = url;
					anchor.setAttribute("download", fileName);
					anchor.className = "download-js-link";
					anchor.innerHTML = "downloading...";
					anchor.style.display = "none";
					document.body.appendChild(anchor);
					setTimeout(function() {
						anchor.click();
						document.body.removeChild(anchor);
						if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
					}, 66);
					return true;
				}
	
				// handle non-a[download] safari as best we can:
				if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
					if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
					if(!window.open(url)){ // popup blocked, offer direct download:
						if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
					}
					return true;
				}
	
				//do iframe dataURL download (old ch+FF):
				var f = document.createElement("iframe");
				document.body.appendChild(f);
	
				if(!winMode && /^data:/.test(url)){ // force a mime that will download:
					url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				}
				f.src=url;
				setTimeout(function(){ document.body.removeChild(f); }, 333);
	
			}//end saver
	
	
	
	
			if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
				return navigator.msSaveBlob(blob, fileName);
			}
	
			if(self.URL){ // simple fast and modern way using Blob and URL:
				saver(self.URL.createObjectURL(blob), true);
			}else{
				// handle non-Blob()+non-URL browsers:
				if(typeof blob === "string" || blob.constructor===toString ){
					try{
						return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
					}catch(y){
						return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
					}
				}
	
				// Blob but not URL support:
				reader=new FileReader();
				reader.onload=function(e){
					saver(this.result);
				};
				reader.readAsDataURL(blob);
			}
			return true;
		}; /* end download() */
	}));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _Main = __webpack_require__(668);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _ChangeLog = __webpack_require__(670);
	
	var _ChangeLog2 = _interopRequireDefault(_ChangeLog);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginatedList2.default.extend({
	    views: [],
	    events: function events() {
	        var parentEvents = _.isFunction(_PaginatedList2.default.prototype.events) ? _PaginatedList2.default.prototype.events() : _PaginatedList2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-back': 'back'
	        });
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            company: null
	        });
	
	        this.views = [];
	
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	
	        return this;
	    },
	    render: function render() {
	        var _this = this;
	
	        this.$el.html((0, _Main2.default)({
	            company: this.options.company,
	            total: this.collection.length,
	            pagination: this.collection.getPaginationInfo(),
	            sort: this.collection.getSort()
	        }));
	
	        this.collection.forEach(function (changeLog) {
	            _this.views.push(new _ChangeLog2.default({
	                model: changeLog,
	                positions: _this.options.positions,
	                locations: _this.options.locations,
	                leaveTypes: _this.options.leaveTypes
	            }));
	
	            _this.$('.js-logs').append(_(_this.views).last().$el);
	        });
	
	        this.stopLoader();
	        return this;
	    },
	    back: function back() {
	        if (!this.options.company) {
	            return;
	        }
	
	        history.go(-1);
	    },
	    navigate: function navigate() {
	        app.mainRouter.navigate('logs/' + this.options.company.id, { trigger: true });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/changeLogs/Main.ejs -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                ';
	 if (company) { 
	__p+='\n                    <div class="flex-container-row">\n                        <a href="" class="js-back" title="Return to companies list">\n                            <i class="fa fa-2x fa-arrow-left"></i>\n                        </a>\n                        &nbsp;\n                        <h3>\n                            Logs for company:\n                            '+
	((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
	'\n                        </h3>\n                    </div>\n                ';
	 } 
	__p+='\n                <div class="ibox-tools">\n                    <h5>&nbsp;Total logs: '+
	((__t=( total ))==null?'':_.escape(__t))+
	'</h5>\n                </div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th>Time</th>\n                            <th>Description</th>\n                            <th>Person</th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-logs">\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        '+
	((__t=( __webpack_require__(669)({
	            pagination: pagination, items: 'logs'
	        }) ))==null?'':__t)+
	'\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/Paginator.ejs -->\n';
	 if (pagination.count > pagination.limit) { 
	__p+='\n<ul class="pagination pull-right">\n    <li class="page-item '+
	((__t=( pagination.page <= 0 ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'">\n        <a aria-label="Previous" class="js-pagination-prev">\n            <span aria-hidden="true">Previous</span>\n        </a>\n    </li>\n    ';
	 _.times(pagination.pages, function(i) { 
	__p+='\n    <li class="page-item '+
	((__t=( pagination.page == i ? 'active' : '' ))==null?'':_.escape(__t))+
	'">\n        <a aria-label="Page '+
	((__t=( i + 1 ))==null?'':_.escape(__t))+
	'" data-page="'+
	((__t=( i ))==null?'':_.escape(__t))+
	'"\n           class="js-pagination-page">\n            <span aria-hidden="true">'+
	((__t=( i + 1 ))==null?'':_.escape(__t))+
	'</span>\n        </a>\n    </li>\n    ';
	 }) 
	__p+='\n    <li class="page-item\n                    '+
	((__t=( pagination.page >= (pagination.pages - 1) ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'">\n        <a aria-label="Next" class="js-pagination-next">\n            <span aria-hidden="true">Next</span>\n        </a>\n    </li>\n</ul>\n\n<span class="pull-right pagination-info">\n                Showing\n    '+
	((__t=( pagination.offset + 1 ))==null?'':_.escape(__t))+
	' to\n    '+
	((__t=( Math.min(pagination.count, pagination.offset + pagination.limit) ))==null?'':_.escape(__t))+
	'\n    of '+
	((__t=( pagination.count ))==null?'':_.escape(__t))+
	'\n    '+
	((__t=( (items) ? items : 'items'  ))==null?'':_.escape(__t))+
	'\n            </span>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _ChangeLog = __webpack_require__(671);
	
	var _ChangeLog2 = _interopRequireDefault(_ChangeLog);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _changeLog = __webpack_require__(641);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    events: {},
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.options = {
	            positions: options.positions,
	            locations: options.locations,
	            leaveTypes: options.leaveTypes
	        };
	        return this.model.fetchUser().then(function (u) {
	            _this.user = u;
	            return _this.model.fetchCompany();
	        }).then(function (c) {
	            _this.company = c;
	            return _this.render();
	        });
	    },
	    convertCompanyType: function convertCompanyType(type) {
	        if (!type) {
	            return type;
	        }
	        switch (type) {
	            case '01':
	                {
	                    return 'Individual – Resident who does not carry on business';
	                }
	            case '02':
	                {
	                    return 'Self-employed or Business';
	                }
	            case '03':
	                {
	                    return 'Partnership';
	                }
	            case '04':
	                {
	                    return 'Private Company (Sdn Bhd)';
	                }
	            case '05':
	                {
	                    return 'Hindu Joint Family';
	                }
	            case '06':
	                {
	                    return 'Association';
	                }
	            case '07':
	                {
	                    return 'Deceased Person\'s Estate';
	                }
	            case '08':
	                {
	                    return 'Trust Body';
	                }
	            case '09':
	                {
	                    return 'Unit/Real Property Trust';
	                }
	            case '10':
	                {
	                    return 'Co-Operative Society';
	                }
	            case '11':
	                {
	                    return 'Real Estate Investment Trust / Property Trust Fund';
	                }
	            case '12':
	                {
	                    return 'Limited Liability Partnership';
	                }
	            case '13':
	                {
	                    return 'Business Trust';
	                }
	            case '14':
	                {
	                    return 'Labuan Entity';
	                }
	            default:
	                {
	                    return type;
	                }
	        }
	    },
	    convertBankTransactionType: function convertBankTransactionType(type) {
	        if (!type) {
	            return type;
	        }
	        switch (type) {
	            case '20':
	                {
	                    return 'Rentas';
	                }
	            case '30':
	                {
	                    return 'IBG';
	                }
	            default:
	                {
	                    return type;
	                }
	        }
	    },
	    convertCompanyLeavePolicy: function convertCompanyLeavePolicy(policy) {
	        if (!policy) {
	            return policy;
	        }
	        switch (policy) {
	            case '0':
	                {
	                    return 'Earned all at once' + ' (renews at the beginning of the year)';
	                }
	            case '1':
	                {
	                    return 'Earned all at once' + ' (renews on employee\'s join date)';
	                }
	            case '2':
	                {
	                    return 'Earned throughout the year' + ' (renews at the beginning of the year)';
	                }
	            case '3':
	                {
	                    return 'Earned throughout the year' + ' (renews on employee\'s join date)';
	                }
	            default:
	                {
	                    return policy;
	                }
	        }
	    },
	    convertCalculationType: function convertCalculationType(type) {
	        if (!type) {
	            return type;
	        }
	        switch (type) {
	            case '1':
	                {
	                    return 'Fixed Number of Days';
	                }
	            case '2':
	                {
	                    return 'All Days in Current Calendar Month';
	                }
	            case '3':
	                {
	                    return 'Working Days in Current Calendar Month';
	                }
	            default:
	                {
	                    return type;
	                }
	        }
	    },
	    convertWorkingDays: function convertWorkingDays(days) {
	        if (!days) {
	            return days;
	        }
	        var daysArray = JSON.parse(days);
	        return 'Sunday: ' + daysArray[0] + ', Monday: ' + daysArray[1] + ',' + (' Tuesday: ' + daysArray[2] + ', Wednesday: ' + daysArray[3] + ',') + (' Thursday: ' + daysArray[4] + ', Friday: ' + daysArray[5] + ',') + (' Saturday: ' + daysArray[6]);
	    },
	    getDescription: function getDescription() {
	        switch (this.model.get('type')) {
	            case 'company':
	                {
	                    var oldValue = this.model.get('oldValue');
	                    var newValue = this.model.get('newValue');
	                    if (this.model.get('fieldName') === 'type') {
	                        oldValue = this.convertCompanyType(this.model.get('oldValue'));
	                        newValue = this.convertCompanyType(this.model.get('newValue'));
	                    } else if (this.model.get('fieldName') === 'annualLeavePolicy') {
	                        oldValue = this.convertCompanyLeavePolicy(this.model.get('oldValue'));
	                        newValue = this.convertCompanyLeavePolicy(this.model.get('newValue'));
	                    } else if (['prorateCalculationType', 'overtimeCalculationType', 'unpaidLeaveCalculationType'].includes(this.model.get('fieldName'))) {
	                        oldValue = this.convertCalculationType(this.model.get('oldValue'));
	                        newValue = this.convertCalculationType(this.model.get('newValue'));
	                    } else if (this.model.get('fieldName') === 'workingDays') {
	                        oldValue = this.convertWorkingDays(this.model.get('oldValue'));
	                        newValue = this.convertWorkingDays(this.model.get('newValue'));
	                    }
	                    switch (this.model.get('operation')) {
	                        case _changeLog.consts.OPERATION_CREATE:
	                            {
	                                return 'Company ' + this.company.get('companyName') + ' was created';
	                            }
	                        case _changeLog.consts.OPERATION_UPDATE:
	                            {
	                                return 'Company ' + this.company.get('companyName') + (' ' + this.model.get('fieldName') + ' changed from') + (' ' + (oldValue || '-') + ' to') + (' ' + (newValue || '-'));
	                            }
	                    }
	                    break;
	                }
	            case 'employee':
	                switch (this.model.get('operation')) {
	                    case _changeLog.consts.OPERATION_CREATE:
	                        {
	                            return 'Employee ' + this.model.get('newValue') + ' was created';
	                        }
	                    case _changeLog.consts.OPERATION_UPDATE:
	                        {
	                            if (this.model.get('fieldName') === 'hiddenAt') {
	                                if (JSON.parse(this.model.get('newValue')) === '') {
	                                    var time = (0, _moment2.default)(this.model.get('changeTime')).format('ddd MMM DD YYYY HH:mm:ss');
	                                    return '' + this.model.get('employeeName') + (' was unarchived at ' + time);
	                                } else {
	                                    return '' + this.model.get('employeeName') + ' was archived at' + (' ' + this.model.get('newValue'));
	                                }
	                            } else {
	                                var _oldValue = this.model.get('oldValue');
	                                var _newValue = this.model.get('newValue');
	                                var fieldName = this.model.get('fieldName');
	                                if (this.model.get('fieldName') === 'positionId') {
	                                    if (_oldValue) {
	                                        fieldName = 'position';
	                                        var position = this.options.positions.models.find(function (model) {
	                                            return model.get('objectId') === JSON.parse(_oldValue);
	                                        });
	                                        _oldValue = position.get('name');
	                                    }
	                                    if (_newValue) {
	                                        fieldName = 'position';
	                                        var _position = this.options.positions.models.find(function (model) {
	                                            return model.get('objectId') === JSON.parse(_newValue);
	                                        });
	                                        _newValue = _position.get('name');
	                                    }
	                                } else if (this.model.get('fieldName') === 'companyLocationId') {
	                                    if (_oldValue) {
	                                        fieldName = 'company location';
	                                        var location = this.options.locations.models.find(function (model) {
	                                            return model.get('objectId') === JSON.parse(_oldValue);
	                                        });
	                                        _oldValue = location.get('name');
	                                    }
	                                    if (_newValue) {
	                                        fieldName = 'company location';
	                                        var _location = this.options.locations.models.find(function (model) {
	                                            return model.get('objectId') === JSON.parse(_newValue);
	                                        });
	                                        _newValue = _location.get('name');
	                                    }
	                                } else if (this.model.get('fieldName') === 'daysEntitled' && this.model.get('descriptions')) {
	                                    return this.model.get('descriptions');
	                                }
	                                return '' + this.model.get('employeeName') + (' ' + fieldName + ' changed from') + (' ' + (_oldValue || '-') + ' to') + (' ' + (_newValue || '-'));
	                            }
	                        }
	                    case _changeLog.consts.OPERATION_DELETE:
	                        {
	                            return 'Employee ' + this.model.get('oldValue') + ' was deleted';
	                        }
	                }
	                break;
	            case 'bank account':
	                {
	                    var _oldValue2 = this.model.get('oldValue');
	                    var _newValue2 = this.model.get('newValue');
	                    if (this.model.get('fieldName') === 'transactionType') {
	                        _oldValue2 = this.convertBankTransactionType(this.model.get('oldValue'));
	                        _newValue2 = this.convertBankTransactionType(this.model.get('newValue'));
	                    }
	                    switch (this.model.get('operation')) {
	                        case _changeLog.consts.OPERATION_UPDATE:
	                            {
	                                if (!this.model.get('employeeName')) {
	                                    return 'Company bank account ' + this.model.get('fieldName') + ' changed from ' + (_oldValue2 || '-') + ' to ' + (_newValue2 || '-');
	                                } else {
	                                    return this.model.get('employeeName') + ' bank account ' + this.model.get('fieldName') + ' changed from  ' + (_oldValue2 || '-') + ' to ' + (_newValue2 || '-');
	                                }
	                            }
	                    }
	                    break;
	                }
	            case 'address':
	                switch (this.model.get('operation')) {
	                    case _changeLog.consts.OPERATION_UPDATE:
	                        {
	                            if (!this.model.get('employeeName')) {
	                                return 'Company address' + (' ' + this.model.get('fieldName') + ' changed from') + (' ' + (this.model.get('oldValue') || '-') + ' to') + (' ' + (this.model.get('newValue') || '-'));
	                            } else {
	                                return this.model.get('employeeName') + ' address' + (' ' + this.model.get('fieldName') + ' changed from') + (' ' + (this.model.get('oldValue') || '-') + ' to') + (' ' + (this.model.get('newValue') || '-'));
	                            }
	                        }
	                }
	                break;
	            case 'ytd':
	                var itemName = this.model.get('fieldName');
	                var employeeName = this.model.get('employeeName') || this.model.get('employeeId');
	
	                var description = 'YTD item "' + itemName + '" for employee                     ' + employeeName;
	                if (this.model.get('oldValue')) {
	                    var _oldValue3 = this.model.get('oldValue');
	
	                    description += '| old values: ' + _oldValue3;
	                }
	                description += '| new values: ' + this.model.get('newValue');
	                return description;
	            case 'payroll':
	                {
	                    if (this.model.get('fieldName') === 'revertedAt') {
	                        return 'Payroll for' + (' ' + this.model.get('oldValue')) + (' was reverted at ' + this.model.get('newValue'));
	                    }
	                    if (this.model.get('descriptions')) {
	                        return this.model.get('descriptions');
	                    }
	                    break;
	                }
	            default:
	                {
	                    if (this.model.get('descriptions')) {
	                        return this.model.get('descriptions');
	                    }
	                    return this.model.get('type') + ':                     ' + (this.model.get('fieldName') || '') + '\n                    ' + (this.model.get('oldValue') ? this.model.get('oldValue') + '=>' : '') + '\n                    ' + this.model.get('newValue');
	                }
	        }
	    },
	    render: function render() {
	        this.$el.html((0, _ChangeLog2.default)({
	            model: this.model,
	            description: this.getDescription(),
	            company: this.company,
	            moment: _moment2.default
	        }));
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/changeLogs/ChangeLog.ejs -->\n<td>'+
	((__t=( moment(model.get('changeTime')).format('DD-MM-YYYY HH:mm') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( description ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('userName') ))==null?'':_.escape(__t))+
	'</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _Main = __webpack_require__(673);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Employee = __webpack_require__(674);
	
	var _Employee2 = _interopRequireDefault(_Employee);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginatedList2.default.extend({
	    views: [],
	    events: function events() {
	        var parentEvents = _.isFunction(_PaginatedList2.default.prototype.events) ? _PaginatedList2.default.prototype.events() : _PaginatedList2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-back': 'back'
	        });
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            company: null
	        });
	
	        this.views = [];
	
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	
	        return this;
	    },
	    render: function render() {
	        var _this = this;
	
	        this.$el.html((0, _Main2.default)({
	            company: this.options.company,
	            searchTerm: this.collection.getSearchTerm(),
	            total: this.collection.length,
	            pagination: this.collection.getPaginationInfo(),
	            sort: this.collection.getSort()
	        }));
	
	        this.collection.forEach(function (employee) {
	            _this.views.push(new _Employee2.default({ model: employee }));
	
	            _this.$('.js-employees').append(_(_this.views).last().$el);
	        });
	
	        this.stopLoader();
	        return this;
	    },
	    back: function back() {
	        if (!this.options.company) {
	            return;
	        }
	
	        history.go(-1);
	    },
	    navigate: function navigate() {
	        app.mainRouter.navigate('employees/' + (this.options.company ? this.options.company.id : 'all') + (this.collection.getSearchTerm() ? '/' + this.collection.getSearchTerm() : ''), { trigger: true });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/employees/Main.ejs -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="col-md-3 col-md-offset-9">\n            <div class="searchbox">\n                <input type="text" name="search" placeholder="Search"\n                    class="form-control js-searchbox" value="'+
	((__t=( searchTerm ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-search"></i>\n            </div>\n        </div>\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                ';
	 if (company) { 
	__p+='\n                    <div class="flex-container-row">\n                        <a href="" class="js-back" title="Return to companies list">\n                            <i class="fa fa-2x fa-arrow-left"></i>\n                        </a>\n                        &nbsp;\n                        <h3>\n                            Employees for company:\n                            '+
	((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
	'\n                        </h3>\n                    </div>\n                ';
	 } 
	__p+='\n                <div class="ibox-tools">\n                    <h5>&nbsp;Total employees: '+
	((__t=( total ))==null?'':_.escape(__t))+
	'</h5>\n                </div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th>Name</th>\n                            <th>Email</th>\n                            <th>Company</th>\n                            <th>Sign up date</th>\n                            <th>Actions</th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-employees">\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _Employee = __webpack_require__(675);
	
	var _Employee2 = _interopRequireDefault(_Employee);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    events: {
	        'click .js-login': 'loginAsEmployee'
	    },
	
	    initialize: function initialize() {
	        var _this = this;
	
	        this.model.fetchUser().then(function (u) {
	            return _this.user = u;
	        }).then(function () {
	            return _this.model.fetchCompany();
	        }).then(function (c) {
	            return _this.company = c;
	        }).then(function () {
	            return _this.render();
	        });
	    },
	    render: function render() {
	        var displayLogin = this.user ? true : false;
	        this.$el.html((0, _Employee2.default)({
	            model: this.model,
	            user: this.user,
	            company: this.company,
	            displayLogin: displayLogin,
	            moment: _moment2.default
	        }));
	        return this;
	    },
	    loginAsEmployee: function loginAsEmployee(ev) {
	        window.open('/?employee=' + this.model.get('objectId'), '_blank');
	        ev.preventDefault();
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/employees/Employee.ejs -->\n<td>'+
	((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('email') ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    '+
	((__t=( company ? company.get('companyName') : '-' ))==null?'':_.escape(__t))+
	'\n</td>\n<td>'+
	((__t=( user ? moment(user.get('createdAt')).format('DD/MM/YYYY') : '-' ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    ';
	 if (displayLogin) { 
	__p+='\n        <a href="" class="js-login" title="Login as Employee">\n            <i class="fa fa-2x fa-sign-in"></i>\n        </a>\n    ';
	 } 
	__p+='\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _Main = __webpack_require__(677);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Add = __webpack_require__(678);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _Account = __webpack_require__(679);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-save': 'save',
	        'input .js-email': 'onEmailChange'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            discountCodes: []
	        });
	        return this;
	    },
	
	    save: function save(ev) {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullScreen(ev.currentTarget);
	        var email = this.$('.js-email').val();
	        var name = this.$('.js-name').val();
	
	        _user2.default.inviteMppAdmin(name, email).then(function () {
	            stopLoader();
	            _this.$('#add-modal').modal('hide');
	            return _alerts2.default.show('success', {
	                title: 'MPP Invitation',
	                text: 'Invitation successfully sent!'
	            });
	        }).catch(function (err) {
	            stopLoader();
	            _this.$('#add-modal').modal('hide');
	            return _alerts2.default.show('error', {
	                title: 'MPP Invitation not sent',
	                text: err
	            });
	        });
	    },
	
	    onEmailChange: function onEmailChange() {
	        if (this.$('.js-email').val()) {
	            this.$('.js-save').prop('disabled', false);
	        } else {
	            this.$('.js-save').prop('disabled', true);
	        }
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        this.$el.html((0, _Main2.default)({
	            collection: this.collection,
	            addModal: (0, _Add2.default)()
	        }));
	
	        var $container = this.$('.js-accounts');
	        this.collection.forEach(function (mppAccount) {
	            var view = new _Account2.default({
	                model: mppAccount,
	                discountCodes: _this2.options.discountCodes
	            });
	            $container.append(view.$el);
	        });
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/mppAccounts/Main.ejs -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <div class="flex-container-row">\n                    <h3>\n                        MPP Accounts\n                    </h3>\n                    <!--\n                    <a href=""\n                       class="js-add-user"\n                       data-toggle="modal"\n                       data-target="#add-modal"\n                       title="Add new user">\n                        <i class="fa fa-2x fa-plus-circle"></i>\n                    </a>\n                    -->\n                </div>\n            </div>\n            <div class="ibox-content" style="overflow:scroll;">\n                <table class="footable table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th>Name</th>\n                            <th>Email</th>\n                            <th style="max-width: 200px;">Logo</th>\n                            <th style="min-width: 90px;">Plan</th>\n                            <th>Discount Override</th>\n                            <th></th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-accounts">\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n'+
	((__t=( addModal ))==null?'':__t)+
	'\n';
	}
	return __p;
	};


/***/ }),
/* 678 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/mppAccounts/Add.ejs -->\n<!-- Modal -->\n<div class="modal fade" id="add-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\n  <div class="modal-dialog" role="document">\n    <div class="modal-content">\n      <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n        <h4 class="modal-title" id="myModalLabel">Add new MPP Admin</h4>\n      </div>\n      <div class="modal-body">\n          <div class="form-horizontal">\n              <div class="form-group">\n                  <label class="col-sm-3 control-label">\n                      Name\n                  </label>\n                  <div class="col-sm-9">\n                      <input name="name" class="js-name form-control" type="text"\n                             placeholder="Name"\n                             data-value-type="string">\n                      <span class="error-name error"></span>\n                  </div>\n              </div>\n\n              <div class="form-group">\n                  <label class="col-sm-3 control-label">\n                      Email\n                  </label>\n                  <div class="col-sm-9">\n                      <input name="email" class="js-email form-control" type="text"\n                             placeholder="Enter Email"\n                             data-value-type="string">\n                      <span class="error-email error"></span>\n                  </div>\n              </div>\n          </div>\n\n      </div>\n      <div class="modal-footer">\n          <button type="button" class="btn btn-default" data-dismiss="modal">\n              Close\n          </button>\n          <button type="button"\n                  class="btn btn-primary js-save"\n                  disabled="disabled"\n                  >\n              Send invitation\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _Account = __webpack_require__(680);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    events: {
	        'click .js-invoice': 'invoice',
	        'click .js-change-mpp-logo': 'onChangeLogo',
	        'click .js-remove-mpp-logo': 'onRemoveLogo',
	        'change .js-change-mpp-logo-input': 'uploadLogo',
	        'change select[name=mppPlan]': 'updatePlan',
	        'change input[name=discount]': 'updateDiscount'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.options = _.defaults(options || {}, {
	            discountCodes: []
	        });
	
	        this.model.on('sync', this.render, this);
	        this.model.fetchSubscription().then(function () {
	            return _this.render();
	        });
	        return this;
	    },
	    render: function render() {
	        var _this2 = this;
	
	        this.$el.html((0, _Account2.default)({
	            model: this.model,
	            subscription: this.model.getSubscription(),
	            mppPlans: [{ id: 'mpp', name: 'Regular' }, { id: 'bronze', name: 'Bronze' }, { id: 'silver', name: 'Silver' }, { id: 'gold', name: 'Gold' }, { id: 'platinum', name: 'Platinum' }],
	            discountCodes: this.options.discountCodes
	        }));
	
	        this.$el.find('.company-logo').on('load', function (e) {
	            $(e.target.parentElement).removeClass('hidden');
	            _this2.$('.js-remove-mpp-logo').removeClass('hidden');
	            _this2.$('.js-change-mpp-logo').text('Change Logo');
	        });
	
	        return this;
	    },
	    invoice: function invoice(ev) {
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.getSubscription().generateInvoices().then(stopLoader).catch(function (err) {
	            stopLoader();
	            _modal2.default.showError('Error: ' + JSON.stringify(err), false);
	        });
	    },
	    updatePlan: function updatePlan(ev) {
	        var _this3 = this;
	
	        ev.preventDefault();
	        var $input = this.$(ev.currentTarget);
	        var plan = $input.val();
	        var stopLoader = _loader2.default.startFullScreen();
	        this.model.getSubscription().setPlan(plan).then(function () {
	            return _this3.render();
	        }).then(function () {
	            _modal2.default.showAlertSuccess('The plan has been updated');
	            _this3.$('[name="discount"]').prop('disabled', plan !== 'mpp');
	        }).catch(function (err) {
	            return _modal2.default.showError(JSON.stringify(err));
	        }).finally(stopLoader);
	    },
	    updateDiscount: function updateDiscount(ev) {
	        var _this4 = this;
	
	        ev.preventDefault();
	        var $input = this.$(ev.currentTarget);
	        var discountName = $input.val();
	        var stopLoader = _loader2.default.startFullScreen();
	        var subscription = this.model.getSubscription();
	
	        if (!discountName) {
	            subscription.set({
	                couponCode: ''
	            });
	        } else {
	            var discountCode = this.options.discountCodes.find(function (code) {
	                return [
	                // jscs:disable
	                code.invoice_name, code.name].includes(discountName);
	            });
	
	            if (!discountCode) {
	                _modal2.default.warning({
	                    text: 'Invalid discount specified. Please choose                     from the dropdown list'
	                });
	                return stopLoader();
	            }
	
	            subscription.set({
	                couponCode: discountCode.id
	            });
	        }
	
	        return subscription.save().then(function () {
	            return _this4.render();
	        }).then(function () {
	            _modal2.default.showAlertSuccess('The discount has been updated');
	        }).catch(function (err) {
	            return _modal2.default.showError(JSON.stringify(err));
	        }).finally(stopLoader);
	    },
	
	
	    onChangeLogo: function onChangeLogo() {
	        this.$('.js-change-mpp-logo-input').click();
	    },
	
	    onRemoveLogo: function onRemoveLogo(ev) {
	        var _this5 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.removeLogo().then(function () {
	            return _this5.render();
	        }).catch(function (err) {
	            return _modal2.default.showError(JSON.stringify(err), false);
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    uploadLogo: function uploadLogo(ev) {
	        var _this6 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        var selectedFile = this.$(ev.currentTarget)[0].files[0];
	        this.model.uploadLogo(selectedFile).then(function () {
	            return _this6.render();
	        }).catch(function (err) {
	            return _modal2.default.showError(JSON.stringify(err), false);
	        }).finally(function () {
	            return stopLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/mppAccounts/Account.ejs -->\n<td>'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('username') ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    <input class="hide js-change-mpp-logo-input"\n        type="file" accept="image/*"\n        value="'+
	((__t=( model.getLogoUrl() || '' ))==null?'':_.escape(__t))+
	'" >\n    <p class="form-control-static hidden">\n        <img class="company-logo"\n            src="'+
	((__t=( model.getLogoUrl() || '' ))==null?'':_.escape(__t))+
	'" />\n    </p>\n    <div class="change-image-wrapper">\n        <span class="js-change-mpp-logo btn btn-default">\n            Add Logo\n        </span>\n        <span class="js-remove-mpp-logo btn btn-default hidden">\n            Remove Logo\n        </span>\n    </div>\n    <span class="error error-logo"></span>\n</td>\n<td>\n    <select name="mppPlan" class="form-control">\n        ';
	 mppPlans.forEach(function(plan) { 
	__p+='\n            <option value="'+
	((__t=( plan.id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( subscription.get('plan') === plan.id ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( plan.name ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n<td>\n    ';
	
	    var matchingCoupon = discountCodes.find(function (code) { return code.id === subscription.get('couponCode'); });
	    
	__p+='\n    <input name="discount"\n        list="couponCode"\n        value="'+
	((__t=( matchingCoupon ? matchingCoupon.invoice_name || matchingCoupon.name : '' ))==null?'':_.escape(__t))+
	'"\n    >\n    <datalist id="couponCode">\n    ';
	 discountCodes.forEach(function (discountCode) { 
	__p+='\n        <option value="'+
	((__t=( discountCode.invoice_name || discountCode.name ))==null?'':_.escape(__t))+
	'">\n    ';
	 }) 
	__p+='\n    </datalist>\n</td>\n<td>\n    <button\n        title="Force the creation of an invoice for all currently unpaid\n            payrolls"\n        class="js-invoice btn btn-default float-right">\n        <i class="fa fa-file-text-o"></i>\n        Invoice\n    </button>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _PersonalSettings = __webpack_require__(682);
	
	var _PersonalSettings2 = _interopRequireDefault(_PersonalSettings);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _PasswordRuleTable = __webpack_require__(551);
	
	var _PasswordRuleTable2 = _interopRequireDefault(_PasswordRuleTable);
	
	var _validate = __webpack_require__(58);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Form2.default.extend({
	
	    subViews: null,
	    passwordRuleTableView: null,
	
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events(), {
	            'keyup input.js-ext-pwd': 'hidePasswordError',
	            'click .js-pwd-toggle': 'togglePasswordVisibility',
	            'keyup input[name="newPassword"]': 'toggleRuleDisplay'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.events = Object.assign({}, _Form2.default.prototype.events || {}, this.events);
	
	        this.options = Object.assign({
	            subViews: [],
	            template: _PersonalSettings2.default,
	            templateExtra: {}
	        }, options || {});
	
	        this.subViews = this.options.subViews || [];
	
	        this.passwordRuleTableView = new _PasswordRuleTable2.default();
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    toggleRuleDisplay: function toggleRuleDisplay(ev) {
	        return this.passwordRuleTableView && this.passwordRuleTableView.toggleRuleDisplay && this.passwordRuleTableView.toggleRuleDisplay(ev);
	    },
	
	    validatePasswords: function validatePasswords() {
	        var $current = this.$('input[name = currentPassword]');
	        var $new = this.$('input[name = newPassword]');
	        var passwordConfirm = this.$('input[name = passwordConfirm]').val();
	        var errs = (0, _validate2.default)({
	            currentPassword: $current.val(),
	            newPassword: $new.val(),
	            passwordConfirm: passwordConfirm
	        }, {
	            currentPassword: { presence: '^Current password can\'t be blank' },
	            newPassword: {
	                presence: true,
	                length: {
	                    minimum: 8,
	                    message: '^Minimum password length is 8'
	                },
	                equality: {
	                    attribute: 'currentPassword',
	                    message: 'Cannot be the same password',
	                    comparator: function comparator(a, b) {
	                        return a !== b;
	                    }
	                }
	            },
	            passwordConfirm: {
	                presence: true,
	                equality: {
	                    attribute: 'newPassword',
	                    message: 'New password doesn\'t match'
	                }
	            }
	        });
	
	        return _.isEmpty(errs) ? false : { errors: errs };
	    },
	
	    render: function render() {
	        var _this = this;
	
	        _Form2.default.prototype.render.apply(this, arguments);
	
	        this.$('input[name=newPassword]').pwstrength({
	            ui: {
	                showVerdicts: false,
	                colorClasses: ['danger', 'warning', 'warning', 'info', 'info', 'success']
	            },
	            common: { minChar: 8 }
	        });
	
	        if (!app.user.isRequirePasswordChange()) {
	            this.subViews.forEach(function (view) {
	                _this.$('.js-ext-container').append(view.render().$el);
	
	                /* Redelegate events for subviews becasue their parent dom element
	                 * changed. */
	                view.undelegateEvents();
	                view.delegateEvents();
	            });
	        }
	
	        this.$('#password-rules').append(this.passwordRuleTableView.render().$el);
	
	        return this;
	    },
	
	    togglePasswordVisibility: function togglePasswordVisibility(ev) {
	        var $button = this.$(ev.currentTarget);
	        var $input = $button.closest('.input-group', this.el).find('input.js-ext-pwd');
	        var visible = $input.prop('type') === 'text';
	
	        $input.prop('type', visible ? 'password' : 'text');
	        $button.html(visible ? 'Show' : 'Hide');
	
	        return this;
	    },
	
	    hidePasswordError: function hidePasswordError(ev) {
	        this.$(ev.currentTarget).closest('.has-error').removeClass('has-error').find('.error').text('');
	
	        return this;
	    },
	
	    showPasswordErrors: function showPasswordErrors(errors) {
	        if (!_.isEmpty(errors)) {
	            this.invalid(null, errors);
	        }
	    },
	
	    save: function save(ev) {
	        var _this2 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader;
	
	        ev.preventDefault();
	
	        if ($button.closest('.js-ext', this.el).length > 0) {
	            return;
	        }
	
	        stopLoader = _loader2.default.startFullScreen($button);
	
	        this.trigger('save');
	
	        this.savePassword().then(function () {
	            return stopLoader();
	        }).then(function () {
	            return _this2.saved();
	        }).then(function () {
	            return _this2.render();
	        }).catch(function (err) {
	            return _this2.showPasswordErrors(err);
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    savePassword: function savePassword() {
	        var currentPwd = this.$('input[name=currentPassword]').val();
	        var newPwd = this.$('input[name=newPassword]').val();
	        var validationError = this.validatePasswords();
	
	        if (!_.isEmpty(validationError)) {
	            return (0, _bluebird.reject)(validationError);
	        }
	
	        return this.model.changePassword(currentPwd, newPwd).catch(function () {
	            return (0, _bluebird.reject)({ errors: {
	                    currentPassword: ['Invalid password. Please try again']
	                } });
	        });
	    },
	
	    saved: function saved() {
	        this.trigger('saved');
	
	        return _alerts2.default.show('success', {
	            title: 'Password set!',
	            text: 'Your new password has been set.',
	            callback: function callback() {
	                app.userRouter.navigate('logout', { trigger: true });
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/PersonalSettings.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Personal Settings</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content personal-settings">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="js-ext js-ext-container"></div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>Change Password</h5>\n                </div>\n                <form class="js-form-change-password form-horizontal">\n                    <div class="ibox-content">\n                        <div class="form-group">\n                            <label class="col-sm-3 control-label">\n                                Current Password\n                            </label>\n                            <div class="col-sm-9">\n                                <input name="currentPassword"\n                                    class="js-ext form-control js-ext-pwd"\n                                    type="password"\n                                    placeholder="Enter Current Password" value="">\n                                <span class="error error-currentPassword"></span>\n                            </div>\n                        </div>\n\n                        <div class="form-group">\n                            <label class="col-sm-3 control-label">\n                                New Password\n                            </label>\n                            <div class="col-sm-9">\n                                <div class="input-group">\n                                    <input name="newPassword"\n                                        data-id="newPassword"\n                                        class="js-ext form-control js-ext-pwd"\n                                        type="password"\n                                        placeholder="Enter New Password" value="">\n                                    <span class="input-group-btn">\n                                        <button type="button"\n                                            class="btn btn-white js-pwd-toggle">\n                                            Show\n                                        </button>\n                                    </span>\n                                </div>\n                                <span class="error error-newPassword"></span>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-sm-3 control-label">\n                                Confirm Password\n                            </label>\n                            <div class="col-sm-9">\n                                <div class="input-group">\n                                    <input name="passwordConfirm"\n                                        class="js-ext form-control js-ext-pwd"\n                                        type="password"\n                                        placeholder="Re-Enter New Password" value="">\n                                    <span class="input-group-btn">\n                                        <button type="button"\n                                            class="btn btn-white js-pwd-toggle">\n                                            Show\n                                        </button>\n                                    </span>\n                                </div>\n                                <span class="error error-confirmPassword"></span>\n                            </div>\n                        </div>\n                        <div id="password-rules" class="col-sm-offset-2"></div>\n                    </div>\n\n                    <div class="ibox-footer text-right">\n                        <button type="button"\n                                class="js-cancel btn btn-w-m btn-warning"\n                                data-toggle="tooltip"\n                                data-title="No changes will be saved"\n                                data-placement="top" data-delayed>\n                            <i class="fa fa-exclamation-triangle"></i> Cancel\n                        </button>\n                        <button type="submit"\n                                class="js-save btn btn-w-m btn-primary m-l-xs">\n                            <i class="fa fa-check"></i> Change Password\n                        </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _Main = __webpack_require__(685);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Modal = __webpack_require__(686);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Row = __webpack_require__(688);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _coupon = __webpack_require__(639);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ListEditables2.default.extend({
	    itemViews: [],
	    modalView: null,
	
	    events: function events() {
	        var parentEvents = _.isFunction(_ListEditables2.default.prototype.events) ? _ListEditables2.default.prototype.events() : _ListEditables2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {});
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _Main2.default,
	            Model: _coupon2.default,
	            ModalEditView: _Modal2.default,
	            ModelView: _Row2.default
	        });
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loader = __webpack_require__(534);
	var tooltip = __webpack_require__(541);
	var modal = __webpack_require__(532);
	
	var log = (0, _log2.default)('list-editables');
	
	module.exports = Backbone.View.extend({
	    events: function events() {
	        return {
	            'click .js-save': 'save',
	            'click .js-cancel': 'cancel',
	            'click .js-add': 'add'
	        };
	    },
	
	    modelViews: [],
	
	    modalEditView: null,
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: null,
	            templateExtra: false,
	            Model: null,
	            ModelView: null,
	            ModalEditView: null
	        });
	
	        if (!_.isNull(this.options.ModalEditView)) {
	            this.modalEditView = new this.options.ModalEditView({
	                actOnSave: false,
	                actOnCancel: false,
	                actOnDestroy: false
	            });
	        }
	
	        if (this.collection) {
	            this.bindHandlers();
	            this.render();
	        }
	
	        return this;
	    },
	
	    bindHandlers: function bindHandlers() {
	        var _this = this;
	
	        this.collection.on('reset', this.render, this);
	        this.collection.on('add remove destroy', this.toggleEmptyMessage, this);
	        this.collection.on('add', this.renderModel, this);
	
	        if (this.modalEditView) {
	            this.modalEditView.on('saved', function (model) {
	                _this._original = null;
	                try {
	                    _this.collection.add(model);
	                } catch (e) {
	                    // ignore, the model is already in the collection
	                }
	            }, this);
	            this.modalEditView.on('cancelled', function (model) {
	                if (_this._original) {
	                    model.set(_this._original, { silent: true });
	                    _this._original = null;
	                    _this.renderModels();
	                }
	            }, this);
	        }
	
	        return this;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        this.collection.off(null, null, this);
	        if (this.modalEditView) {
	            this.modalEditView.off(null, null, this.collection);
	        }
	        return this;
	    },
	
	    render: function render() {
	        if (!this.options.template) {
	            log.info('No template present');
	            return this;
	        }
	
	        if (!this.collection) {
	            log.info('No collection present');
	            return this;
	        }
	
	        this.$el.html(this.options.template(_.defaults({
	            collection: this.collection
	        }, this.options.templateExtra || {})));
	
	        this.renderModels();
	
	        this.toggleEmptyMessage();
	
	        tooltip.init(this);
	
	        return this;
	    },
	
	    renderModels: function renderModels() {
	        var _this2 = this;
	
	        if (!this.options.ModelView) {
	            return this;
	        }
	
	        if (!this.collection) {
	            return this;
	        }
	
	        this.removeModelViews();
	        this.collection.each(function (model) {
	            if (!_this2.options.filter || _this2.options.filter && _this2.options.filter(model)) {
	                _this2.renderModel(model);
	            }
	        });
	
	        return this;
	    },
	
	    renderModel: function renderModel(model) {
	        // TODO i think listeditables are not flexible enough
	        var view = new this.options.ModelView({
	            model: model,
	            additional: this.options
	        });
	
	        this.$('.js-model-views').append(view.$el);
	        this.modelViews.push(view);
	
	        view.on('edit', this.showEditModal, this);
	
	        return this;
	    },
	
	    showEditModal: function showEditModal(model) {
	        this._original = Object.assign({}, model.attributes);
	        this.modalEditView.setModel(model).show();
	    },
	
	    toggleEmptyMessage: function toggleEmptyMessage() {
	        this.$('.js-empty').toggleClass('hidden', _.isObject(this.collection) && this.collection.length > 0);
	
	        return this;
	    },
	
	    add: function add(ev) {
	        var model = this.createModel();
	        ev.preventDefault();
	
	        if (!this.modalEditView) {
	            log.info('No modal edit view present');
	            return this;
	        }
	
	        if (!model) {
	            log.info('No model could be created');
	            return this;
	        }
	
	        this.modalEditView.setModel(model).show();
	
	        return this;
	    },
	
	    createModel: function createModel() {
	        if (!this.options.Model) {
	            log.info('Mising model constructor');
	            return false;
	        }
	
	        return new this.options.Model();
	    },
	
	    removeModelViews: function removeModelViews() {
	        _.each(this.modelViews, function (view) {
	            view.off(null, null, this);
	            view.remove();
	            view = null;
	        });
	        this.modelViews = [];
	
	        return this;
	    },
	
	    remove: function remove() {
	        Backbone.View.prototype.remove.apply(this, arguments);
	
	        this.undelegateEvents();
	
	        if (this.collection) {
	            this.unbindHandlers();
	        }
	
	        if (this.modalEditView) {
	            this.modalEditView.remove();
	        }
	
	        this.removeModelViews();
	
	        this.$el.remove();
	    },
	
	    save: function save(ev) {
	        var _this3 = this;
	
	        var stopLoader = function stopLoader() {};
	        if (ev) {
	            stopLoader = loader.startFullScreen(this.$(ev.currentTarget));
	        }
	
	        this.trigger('save', this.collection);
	        return this.collection.save().then(function () {
	            _this3.trigger('saved', _this3.collection);
	            modal.showAlertSuccess('Your changes have been saved');
	        }).finally(stopLoader);
	    },
	
	    cancel: function cancel(ev) {
	        var stopLoader = function stopLoader() {};
	        if (ev) {
	            stopLoader = loader.startFullScreen(this.$(ev.currentTarget));
	        }
	        this.collection.fetch({ reset: true }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/coupons/Main.ejs -->\n<table class="table table-striped table-settings">\n    <thead>\n        <tr>\n            <th>Code</th>\n            <th width="12%"># Uses</th>\n            <th width="12%">New Customers Only</th>\n            <th width="12%">Created At</th>\n        </tr>\n    </thead>\n    <tbody class="list-empty js-empty">\n        <tr><td colspan="3">\n            <h2 class="text-center">\n                You don\'t have any coupons yet.\n            </h2>\n        </td></tr>\n    </tbody>\n    <tbody class="js-model-views"></tbody>\n    <tfoot>\n        <tr><td colspan="10">\n            <button class="btn btn-outline pull-right btn-primary js-add"\n                data-loading-text="Adding..."\n                data-complete-text="+ Add Coupon">\n                + Add Coupon\n            </button>\n        </td></tr>\n    </tfoot>\n</table>\n<div class="clearfix" style="padding-bottom: 75px">\n    <div class="pull-right">\n        <button class="js-cancel btn btn-warning btn-w-m btn-cancel"\n            data-toggle="tooltip" data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i>\n            Cancel\n        </button>\n        <button class="js-save btn btn-primary m-l-xs">\n            <i class="fa fa-check"></i>\n            Save changes\n        </button>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(687);
	var ModalFormView = __webpack_require__(665);
	
	module.exports = ModalFormView.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(ModalFormView.prototype.events) ? ModalFormView.prototype.events() : ModalFormView.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {});
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { template: template });
	        return ModalFormView.prototype.initialize.apply(this, [this.options]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/coupons/Modal.ejs -->\n<div class="modal-dialog" style="width: 540px;">\n    <form class="modal-content animated sweet form-horizontal" role="form">\n        <div class="modal-header" style="border-bottom: none;">\n            <h1 class="modal-title">Add Coupon</h1>\n        </div>\n\n        <div class="modal-body" style="background: #ffffff; padding: 0 50px\n            40px 50px;">\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">Code</label>\n                <div class="col-sm-8">\n                    <input name="code" class="form-control" type="text"\n                        value="">\n                    <span class="error error-code"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label"># Uses</label>\n                <div class="col-sm-8">\n                    <input name="uses" class="form-control" type="text"\n                        value="0">\n                    <span class="error error-uses"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">New Customers Only</label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="newCustomers"\n                            checked data-value-type="boolean">\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="newCustomers"\n                            data-value-type="boolean">\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-newCustomers"></span>\n                </div>\n            </div>\n        </div>\n\n        <div class="modal-footer" style="border-top: none; text-align:\n            center;">\n            <button type="reset" class="btn btn-warning btn-w-m js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit" class="btn btn-primary btn-w-m btn-save\n                js-save m-l-md">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n\n';
	}
	return __p;
	};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(689);
	var RowEditView = __webpack_require__(690);
	
	module.exports = RowEditView.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        var parentEvents = _.isFunction(RowEditView.prototype.events) ? RowEditView.prototype.events() : RowEditView.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {});
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: template,
	            deletable: true
	        });
	        return RowEditView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    render: function render() {
	        var r = RowEditView.prototype.render.apply(this, arguments);
	        setTimeout(this.initializeControls.bind(this), 1);
	        return r;
	    },
	
	    initializeControls: function initializeControls() {
	        // The UI design has a weird placement for the delete button
	        this.$('.form-control-with-delete').each(function (i, control) {
	            var $control = this.$(control);
	            var $value = $control.find('.form-control-value');
	            var $input = $control.find('.form-control');
	
	            $value.css({
	                display: 'inline-block',
	                maxWidth: $input.width() - $control.find('.btn-delete').outerWidth(true) - 5 + 'px'
	            }).text($input.val());
	
	            $value.on('click', function () {
	                $control.addClass('focus');
	                $input.focus();
	            });
	
	            $input.on('keyup', function (ev) {
	                var val = this.$(ev.target).val();
	                $value.html(val);
	            }.bind(this)).on('focus', function () {
	                $control.addClass('focus');
	            }).on('blur', function () {
	                $control.removeClass('focus');
	            });
	        }.bind(this));
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/coupons/Row.ejs -->\n<td class="td-nowrap">\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="code"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
	((__t=( model.get('code') ))==null?'':_.escape(__t))+
	'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n\n    <div class="error error-code error-uses error-newCustomers"></div>\n    <div class="error error-code error-uses error-newCustomers\n        error-placeholder"></div>\n</td>\n\n<td class="form-group">\n    <input type="text" name="uses"\n        class="form-control form-control-invisible"\n        value="'+
	((__t=( model.get('uses') ))==null?'':_.escape(__t))+
	'">\n</td>\n\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="newCustomers"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('newCustomers') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n\n<td>'+
	((__t=( model.get('createdAt') ))==null?'':_.escape(__t))+
	'</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alerts = __webpack_require__(529);
	var EditView = __webpack_require__(540);
	var log = (0, _log2.default)('row-edit');
	
	module.exports = EditView.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(EditView.prototype.events) ? EditView.prototype.events() : EditView.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-destroy': 'destroyModel',
	            'click .js-edit': 'triggerEditView'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { deletable: false });
	
	        return EditView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    render: function render() {
	        var r = EditView.prototype.render.apply(this, arguments);
	
	        this.toggleTainted();
	
	        return r;
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.model.on('change', this.toggleTainted, this);
	        this.model.on('sync', this.toggleTainted, this);
	
	        return EditView.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    toggleError: function toggleError(attribute, message) {
	        this.$('[name=' + attribute + '], .js-attr-' + attribute).closest('.form-group').toggleClass('has-error', !_.isUndefined(message));
	        this.$('.error-' + attribute).text(message || '');
	
	        this.$el.toggleClass('has-error', !_.isUndefined(message));
	        this.$el.toggleClass('invalid', !_.isUndefined(message));
	
	        return this;
	    },
	
	    toggleTainted: function toggleTainted() {
	        this.$el.toggleClass('tainted', this.model.isNew() || this.model.dirty());
	
	        return this;
	    },
	
	    triggerEditView: function triggerEditView(ev) {
	        ev.preventDefault();
	        this.trigger('edit', this.model);
	    },
	
	    destroyModel: function destroyModel() {
	        var _this = this;
	
	        if (this.options.deletable !== true) {
	            log.info('Model is not deletable');
	            return this;
	        }
	
	        Alerts.show('dangerConfirm', {
	            confirmButtonText: 'Yes, Remove',
	            callback: function callback(confirm) {
	                if (!confirm) {
	                    return;
	                }
	
	                log.info('Deleting ' + _this.model.id);
	                _this.model.destroy().then(function () {
	                    if (_this.model.collection) {
	                        _this.model.collection.remove(_this.model);
	                    }
	
	                    _this.remove();
	                }, function (err) {
	                    Alerts.show('criticalError', err);
	                });
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _Base = __webpack_require__(625);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _SettingsLayout = __webpack_require__(692);
	
	var _SettingsLayout2 = _interopRequireDefault(_SettingsLayout);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('admin-manager/settings-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'settings': 'settings',
	        'settings/defaultPayrollItems': 'defaultPayrollItems'
	    },
	
	    titles: {
	        'settings': 'Settings',
	        'settings/defaultPayrollItems': 'Default Payroll Items'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    settings: function settings() {
	        this.navigate('settings/defaultPayrollItems', {
	            trigger: true,
	            replace: true
	        });
	    },
	
	    defaultPayrollItems: function defaultPayrollItems() {
	        this.layout = new _SettingsLayout2.default({
	            tab: 'defaultPayrollItems',
	            el: this.options.el
	        });
	        this.layout.renderContent({ collection: app.payrollItems });
	        this.layout.hideLoader();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(693);
	var tooltip = __webpack_require__(541);
	var PayrollItemsView = __webpack_require__(694);
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize(options) {
	        //FIXME NEVER extend this with options
	        _.extend(this, options);
	        this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({ tab: this.tab }));
	
	        return this;
	    },
	
	    renderContent: function renderContent(options) {
	        options.defaultPayrollItems = true;
	        options.showReliefOptions = true;
	        options.templateExtra = { hideActionButtons: !app.user.isSuperAdmin() };
	
	        if (this.tab === 'defaultPayrollItems') {
	            new PayrollItemsView(_.extend({ el: this.$('.js-defaultPayrollItems') }, options));
	            this.$('.js-defaultPayrollItems-tab').addClass('active');
	        }
	
	        this.$('input[type="checkbox"]').iCheck({
	            checkboxClass: 'icheckbox_square-blue'
	        });
	        tooltip.init(this);
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-loading-tab').removeClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/adminManager/templates/settings/SettingsLayout.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Settings</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content wrapper-tabs wrapper-settings">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="tabs-container">\n                <div class="tab-content">\n                    <div class="js-defaultPayrollItems-tab tab-pane">\n                        <div class="js-defaultPayrollItems panel-body"></div>\n                    </div>\n                    <div class="js-loading-tab tab-pane active">\n                        <div class="panel-body">\n                            <div class="loader-wrapper">\n                                <div class="loader">\n                                    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                                </div>\n                                <div class="clearfix"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _PayrollItem = __webpack_require__(695);
	
	var _PayrollItem2 = _interopRequireDefault(_PayrollItem);
	
	var _PayrollItemModal = __webpack_require__(699);
	
	var _PayrollItemModal2 = _interopRequireDefault(_PayrollItemModal);
	
	var _PayrollItems = __webpack_require__(702);
	
	var _PayrollItems2 = _interopRequireDefault(_PayrollItems);
	
	var _payrollItem = __webpack_require__(591);
	
	var _payrollItem2 = _interopRequireDefault(_payrollItem);
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ListEditables2.default.extend({
	    itemViews: [],
	    modalView: null,
	
	    events: function events() {
	        var parentEvents = _.isFunction(_ListEditables2.default.prototype.events) ? _ListEditables2.default.prototype.events() : _ListEditables2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-add-addition': 'addAddition',
	            'click .js-add-deduction': 'addDeduction',
	            'click .js-add-overtime': 'addOvertime'
	        });
	    },
	
	    initialize: function initialize(options) {
	        var filter = void 0;
	
	        if (options.defaultPayrollItems) {
	            filter = function filter(model) {
	                return model.get('hiddenAt') === null;
	            };
	        } else {
	            filter = function filter(model) {
	                return model.get('hiddenAt') === null && model.get('companyId') !== null;
	            };
	        }
	
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItems2.default,
	            Model: _payrollItem2.default,
	            ModalEditView: _PayrollItemModal2.default,
	            ModelView: _PayrollItem2.default,
	            unsubmittedPayroll: null,
	            unsubmittedPayrollDetails: null,
	            filter: filter
	        });
	
	        this.firstTime = true;
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    renderModel: function renderModel(model) {
	        var view = new this.options.ModelView({
	            model: model,
	            showReliefOptions: this.options.showReliefOptions,
	            unsubmittedPayroll: this.options.unsubmittedPayroll,
	            unsubmittedPayrollDetails: this.options.unsubmittedPayrollDetails
	        });
	
	        var type = 'addition';
	
	        // This hacky thing here is because they don't want to update the UI
	        // properly so we have to cram items wheverever we can.
	        // We now consider items that 'add' as additions
	        // and items that subtract as deductions, regardless of type.
	        if (['deduction', 'zakat', 'mtd', 'epf', 'socso', 'unpaid_leave', 'cp38', 'eis', 'hrdf'].indexOf(model.get('type')) >= 0) {
	            type = 'deduction';
	        } else if (model.get('type') === 'overtime') {
	            type = 'overtime';
	        }
	
	        //However, the hacky thing mentioned earlier should only be implemented
	        //for admin managers
	        if (!app.user.isAdmin()) {
	            type = model.get('type');
	        }
	
	        this.modelViews.push(view);
	
	        this.$('.js-model-' + type + '-views').append(view.$el);
	
	        view.on('edit', this.showEditModal, this);
	
	        return this;
	    },
	
	    toggleEmptyMessage: function toggleEmptyMessage() {
	        _.each(['addition', 'deduction', 'overtime'], function (type) {
	            var count = this.collection.filter(function (m) {
	                if (app.user.isAdmin()) {
	                    var types = ['deduction', 'zakat', 'mtd', 'epf', 'socso', 'unpaid_leave', 'cp38'];
	                    if (type === 'deduction') {
	                        return types.indexOf(m.get('type')) >= 0;
	                    } else if (type === 'addition') {
	                        return types.indexOf(m.get('type')) < 0 && m.get('type') !== 'overtime';
	                    }
	                }
	
	                return m.get('type') === type;
	            }).length;
	            this.$('.js-empty-' + type).toggleClass('hidden', count > 0);
	        }.bind(this));
	
	        return this;
	    },
	
	    addAddition: function addAddition(ev) {
	        ev.preventDefault();
	        this.add('addition');
	    },
	
	    addDeduction: function addDeduction(ev) {
	        ev.preventDefault();
	        this.add('deduction');
	    },
	
	    addOvertime: function addOvertime(ev) {
	        ev.preventDefault();
	        return this.add('overtime');
	    },
	
	    add: function add(type) {
	        if (!this.modalEditView) {
	            return this;
	        }
	
	        var attr = {
	            type: type,
	            companyId: app.company.id,
	            allowRecurrency: true
	        };
	
	        if (type === 'overtime') {
	            Object.assign(attr, {
	                isUnit: true,
	                isNet: true,
	                isGross: true,
	                overtimeFactor: 1.5,
	                category: 0,
	                affectsMtd: true,
	                affectsEpf: false,
	                affectsSocso: true,
	                affectsEis: true,
	                eaFields: ['grossSalary']
	            });
	        }
	
	        var model = new _payrollItem2.default(attr);
	        this.modalEditView.setModel(model).show();
	        return this;
	    },
	
	    save: function save(ev) {
	        _ListEditables2.default.prototype.save.apply(this, [ev]).then(function () {
	            _modal2.default.showAlertSuccess('Settings have been saved');
	        });
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _eaFields = __webpack_require__(696);
	
	var _eaFields2 = _interopRequireDefault(_eaFields);
	
	var _PayrollItem = __webpack_require__(697);
	
	var _PayrollItem2 = _interopRequireDefault(_PayrollItem);
	
	var _OvertimePayrollItem = __webpack_require__(698);
	
	var _OvertimePayrollItem2 = _interopRequireDefault(_OvertimePayrollItem);
	
	var _RowEdit = __webpack_require__(690);
	
	var _RowEdit2 = _interopRequireDefault(_RowEdit);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	module.exports = _RowEdit2.default.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        var parentEvents = _.isFunction(_RowEdit2.default.prototype.events) ? _RowEdit2.default.prototype.events() : _RowEdit2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'change .js-ext.js-ext-eaField': 'updateEaField'
	        });
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItem2.default,
	            deletable: true,
	            unsubmittedPayroll: null,
	            showReliefOptions: false
	        });
	        var applicableEaFields = Object.keys(_eaFields2.default).reduce(function (rs, field) {
	            if (_this.options.showReliefOptions || !['relief', 'zakatRelief'].includes(field)) {
	                return Object.assign(rs, _defineProperty({}, field, _eaFields2.default[field]));
	            }
	            return rs;
	        }, {});
	        this.options.templateExtra = {
	            eaFields: applicableEaFields,
	            showType: app.user.isAdmin()
	        };
	
	        if (this.model.get('type') === 'overtime') {
	            this.options.template = _OvertimePayrollItem2.default;
	        }
	
	        if (!this.model.isNew()) {
	            this.model.fetchMtdLimit().then(function () {
	                return _RowEdit2.default.prototype.initialize.apply(_this, [_this.options]);
	            });
	        } else {
	            _RowEdit2.default.prototype.initialize.apply(this, [this.options]);
	        }
	
	        return this;
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = _RowEdit2.default.prototype.bindHandlers.apply(this, arguments);
	        this.model.on('change:affectsMtd', this.toggleMtdLimit, this);
	        this.model.on('change:affectsMtd', this.toggleEaField, this);
	        this.model.on('change:mtdLimit', this.toggleEaField, this);
	        this.model.on('change:afterWorkingHours', this.checkOvertimeDuplicates, this);
	        this.model.on('change:nonWorkingDays', this.checkOvertimeDuplicates, this);
	        this.model.on('change:holidays', this.checkOvertimeDuplicates, this);
	        return r;
	    },
	
	    render: function render() {
	        var r = _RowEdit2.default.prototype.render.apply(this, arguments);
	        setTimeout(this.initializeControls.bind(this), 1);
	        return r;
	    },
	
	    toggleEaField: function toggleEaField() {
	        var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var disabled = !(this.model.get('affectsMtd') && this.model.get('mtdLimit') > 0);
	        this.$('[name=taxExemptEaField]').prop('disabled', disabled).attr('disabled', disabled);
	
	        if (update) {
	            this.updateEaField();
	        }
	    },
	
	    toggleMtdLimit: function toggleMtdLimit() {
	        this.$('[name=mtdLimit]').removeAttr('disabled').prop({ disabled: !this.model.get('affectsMtd') }).focus().select();
	
	        if (!this.model.get('affectsMtd')) {
	            this.$('[name=mtdLimit]').val('0.00').trigger('change');
	        }
	
	        return this;
	    },
	
	    updateEaField: function updateEaField() {
	        var eaFields = [];
	        var eaField = this.$('[name=eaField]').val();
	        var taxExemptEaField = this.$('[name=taxExemptEaField]').val();
	        var limit = void 0;
	        var offset = void 0;
	
	        limit = offset = this.model.get('mtdLimit') || 0;
	        if (eaField) {
	            eaFields.push({ field: eaField, offset: offset });
	        }
	        if (taxExemptEaField) {
	            eaFields.push({ field: taxExemptEaField, limit: limit });
	        }
	        this.model.set('eaFields', eaFields);
	    },
	
	    initializeControls: function initializeControls() {
	        if (!app.user.isSuperAdmin() && !this.model.get('companyId')) {
	            this.$('input, select').prop({ 'disabled': true });
	        }
	
	        if (!app.user.isSuperAdmin()) {
	            var pcbChecked = this.model.get('affectsMtd') === true;
	            this.$('select[name="taxExemptEaField"]').prop('disabled', !pcbChecked || !this.model.get('mtdLimit'));
	        } else {
	            this.toggleEaField(false);
	        }
	
	        // The UI design has a weird placement for the delete button
	        this.$('.form-control-with-delete').each(function (i, control) {
	            var $control = this.$(control);
	            var $value = $control.find('.form-control-value');
	            var $input = $control.find('.form-control');
	
	            $value.css({
	                display: 'inline-block',
	                maxWidth: $input.width() - $control.find('.btn-delete').outerWidth(true) - 5 + 'px'
	            }).text($input.val());
	
	            $value.on('click', function () {
	                $control.addClass('focus');
	                $input.focus();
	            });
	
	            $input.on('keyup', function (ev) {
	                var val = this.$(ev.target).val();
	                $value.text(val);
	            }.bind(this)).on('focus', function () {
	                $control.addClass('focus');
	            }).on('blur', function () {
	                $control.removeClass('focus');
	            });
	        }.bind(this));
	    },
	
	    checkOvertimeDuplicates: function checkOvertimeDuplicates(model, value, options) {
	        //not necessary to check if a flag was disabled
	        if (value === false) {
	            return;
	        }
	        var attr = Object.keys(options.changes).pop();
	        var collection = this.model.collection;
	        var duplicate = collection.find(function (m) {
	            return m.get(attr) === value && m !== model;
	        });
	
	        if (duplicate) {
	            _alerts2.default.show('warning', {
	                title: 'Duplicate Overtime Items',
	                text: 'The settings you have configured overlap with another ' + 'overtime item. This means that any automated function ' + 'will utilize the last item you modified.'
	            });
	        }
	    },
	
	    destroyConfirmationMessage: function destroyConfirmationMessage() {
	        if (!this.model.isNew() && this.options.unsubmittedPayroll) {
	            return {
	                title: 'Your saved payroll will be erased!',
	                text: 'You have an unsubmitted payroll saved. If you ' + 'continue, the payroll will be reset and all unsubmitted ' + 'data will be erased.'
	            };
	        } else {
	            return {};
	        }
	    },
	
	    destroyModel: function destroyModel() {
	        var _this2 = this;
	
	        _modal2.default.confirm(_.extend(this.destroyConfirmationMessage(), {
	            customClass: 'sweet-alert-error',
	            confirmButtonText: 'Yes, Remove Item',
	            callback: function callback(confirm) {
	                var wasNew = _this2.model.isNew();
	
	                if (!confirm) {
	                    return;
	                }
	
	                _this2.model.destroy().then(function () {
	                    if (_this2.model.collection) {
	                        _this2.model.collection.remove(_this2.model);
	                    }
	
	                    if (_this2.options.unsubmittedPayroll && !wasNew) {
	                        return _this2.options.unsubmittedPayroll.destroy();
	                    }
	
	                    return (0, _bluebird.resolve)(true);
	                }).then(function () {
	                    if (!wasNew) {
	                        _this2.options.unsubmittedPayroll = null;
	                    }
	
	                    return (0, _bluebird.resolve)(true);
	                }).then(function () {
	                    return _this2.remove();
	                }).catch(function (err) {
	                    if (err.response) {
	                        _alerts2.default.show('warning', {
	                            title: 'Important note!',
	                            text: 'Please note that this custom item cannot be                                deleted as it has already been included in a                                payroll.'
	                        });
	                    } else {
	                        _alerts2.default.show('criticalError', err);
	                    }
	                });
	            }
	        }));
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    'grossSalary': 'B.1 (a) - Gross salary, wages or leave pay (incl. overtime)',
	    'feesCommissionsBonuses': 'B.1 (b) - Fees (incl. director fees), commissions or bonuses',
	    'allowances': 'B.1 (c) - Gross tips, perquisites, awards/rewards or other allowances',
	    'employerMtd': 'B.1 (d) - Income tax borne by employer in respect of his employee',
	    'shareOption': 'B.1 (e) - Employee Share Option Scheme (ESOS) benefit',
	    'gratuity': 'B.1 (f) - Gratuity',
	    'benefits': 'B.3 - Benefits in kind',
	    'livingAccommodation': 'B.4 - Value of living accomodations',
	    'unapprovedPension': 'B.5 - Refund from unapproved pension',
	    'compensation': 'B.6 - Compensation for loss of employment',
	    'pensions': 'C.1 - Pension',
	    'annuities': 'C.2 - Annuities or other periodical payments',
	    'relief': 'D.5 (a) - Relief claim by employee via Form TP1',
	    'zakatRelief': 'D.5 (b) - Zakat relief claim by employee via Form TP1',
	    'taxExemptAmount': 'F - Tax Exempt Allowances / Perquisites / Gifts / Benefits'
	};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PayrollItem.ejs -->\n<td class="td-nowrap">\n    <input type="hidden" name="eaFields" disabled>\n\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="name"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n    ';
	 if (showType) { 
	__p+='\n        <div class="m-l-sm">(type: '+
	((__t=( model.get('type') ))==null?'':_.escape(__t))+
	')</div>\n    ';
	 } 
	__p+='\n\n    <div class="error error-name error-isUnit error-isGross error-isNet\n        error-allowRecurrency error-affectsMtd error-affectsEpf\n        error-eaFields error-affectsSocso error-affectsEis">\n    </div>\n    <div class="error error-name error-isUnit error-isGross error-isNet\n        error-allowRecurrency error-affectsMtd error-affectsEpf\n        error-affectsSocso error-eaFields error-affectsEis error-placeholder">\n    </div>\n</td>\n\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="isUnit"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('isUnit') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="isGross"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('isGross') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="isNet"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('isNet') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsMtd"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsEpf"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsSocso"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsEis"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <input type="text" name="mtdLimit"\n    class="form-control form-control-invisible"\n        value="'+
	((__t=( model.getMtdLimit().toFixed(2) ))==null?'':_.escape(__t))+
	'"\n        data-value-type="float"\n        '+
	((__t=( !model.get('affectsMtd') ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n</td>\n<td>\n    <select name="taxExemptEaField"\n        class="form-control js-ext js-ext-eaField js-attr-eaFields">\n        <option disabled '+
	((__t=( !model.getTaxExemptEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
	'\n            value="">\n            Select an option\n        </option>\n        <option value="none">None</option>\n        ';
	 Object.keys(eaFields).forEach(function(field) { 
	__p+='\n            <option value="'+
	((__t=( field ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.getTaxExemptEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( eaFields[field] ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n<td>\n    <select name="eaField" class="form-control js-ext js-ext-eaField js-attr-eaFields">\n        <option disabled '+
	((__t=( !model.getEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
	'\n            value="">\n            Select an option\n        </option>\n        <option value="none">None</option>\n        ';
	 Object.keys(eaFields).forEach(function(field) { 
	__p+='\n            <option value="'+
	((__t=( field ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.getEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( eaFields[field] ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n';
	 /*
	<td>
	    <a href="" title="Edit" class="js-edit">
	        <i class="fa fa-pencil fa-2x"></i>
	    </a>
	</td> */ 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/OvertimePayrollItem.ejs -->\n<td class="td-nowrap">\n    <input type="hidden" name="eaFields" disabled>\n\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="name"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n    ';
	 if (showType) { 
	__p+='\n        <div class="m-l-sm">(type: '+
	((__t=( model.get('type') ))==null?'':_.escape(__t))+
	')</div>\n    ';
	 } 
	__p+='\n\n    <div class="error error-name error-isUnit error-isGross error-isNet\n        error-allowRecurrency error-affectsMtd error-affectsEpf\n        error-affectsSocso error-overtimeFactor error-affectsEis\n        error-eaFields">\n    </div>\n    <div class="error error-name error-isUnit error-isGross error-isNet\n        error-allowRecurrency error-affectsMtd error-affectsEpf\n        error-affectsSocso error-overtimeFactor error-eaFields error-affectsEis\n        error-placeholder">\n    </div>\n</td>\n\n<td class="form-group">\n    <input type="text" name="overtimeFactor"\n        class="form-control form-control-invisible"\n        value="'+
	((__t=( (model.get('overtimeFactor') || 0).toFixed(2) ))==null?'':_.escape(__t))+
	'"\n        data-value-type="float">\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsMtd"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsEpf"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsSocso"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsEis"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="afterWorkingHours"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('afterWorkingHours') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="nonWorkingDays"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('nonWorkingDays') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="holidays"\n            data-value-type="boolean" class="js-icheck"\n            '+
	((__t=( model.get('holidays') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <select name="eaField" class="form-control js-ext js-ext-eaField js-attr-eaFields">\n        <option disabled '+
	((__t=( !model.getEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n            Select an option\n        </option>\n        <option value="none">None</option>\n        ';
	 _(Object.keys(eaFields)).forEach(function(field) { 
	__p+='\n            <option value="'+
	((__t=( field ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.getEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( eaFields[field] ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _eaFields = __webpack_require__(696);
	
	var _eaFields2 = _interopRequireDefault(_eaFields);
	
	var _PayrollItemModal = __webpack_require__(700);
	
	var _PayrollItemModal2 = _interopRequireDefault(_PayrollItemModal);
	
	var _OvertimePayrollItemModal = __webpack_require__(701);
	
	var _OvertimePayrollItemModal2 = _interopRequireDefault(_OvertimePayrollItemModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	module.exports = _ModalForm2.default.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(_ModalForm2.default.prototype.events) ? _ModalForm2.default.prototype.events() : _ModalForm2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'change .js-ext.js-ext-eaField': 'updateEaField'
	        });
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItemModal2.default,
	            showReliefOptions: false
	        });
	        var applicableEaFields = Object.keys(_eaFields2.default).reduce(function (rs, field) {
	            if (_this.options.showReliefOptions || !['relief', 'zakatRelief'].includes(field)) {
	                return Object.assign(rs, _defineProperty({}, field, _eaFields2.default[field]));
	            }
	            return rs;
	        }, {});
	        this.options.templateExtra = { eaFields: applicableEaFields };
	
	        return _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = _ModalForm2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.model.on('change:affectsMtd', this.toggleMtdLimit, this);
	        this.model.on('change:affectsMtd', this.toggleEaField, this);
	        this.model.on('change:mtdLimit', this.toggleEaField, this);
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = _ModalForm2.default.prototype.bindHandlers.apply(this, arguments);
	        this.model.off(null, null, this);
	        return r;
	    },
	
	    toggleMtdLimit: function toggleMtdLimit() {
	        this.$('[name=mtdLimit]').removeAttr('disabled').prop({ disabled: !this.model.get('affectsMtd') }).focus().select();
	
	        if (!this.model.get('affectsMtd')) {
	            this.model.set('mtdLimit', 0);
	        }
	
	        return this;
	    },
	
	    toggleEaField: function toggleEaField() {
	        this.$('[name=taxExemptEaField]').closest('.form-group').toggleClass('hidden', !(this.model.get('affectsMtd') && this.model.get('mtdLimit') > 0));
	        this.$('.form-group:not(.hidden) [name=taxExemptEaField]').prop('disabled', false).attr('disabled', false);
	        this.$('.form-group.hidden [name=taxExemptEaField]').prop('disabled', true).attr('disabled', true);
	        this.updateEaField();
	    },
	
	    updateEaField: function updateEaField() {
	        var eaFields = [];
	        var eaField = this.$('[name=eaField]').val();
	        var taxExemptEaField = this.$('[name=taxExemptEaField]').val();
	        var limit = void 0;
	        var offset = void 0;
	
	        if (!this.model.get('affectsMtd') || this.model.get('mtdLimit') <= 0) {
	            if (eaField) {
	                this.model.set('eaFields', [eaField]);
	            } else {
	                this.model.set('eaFields', null);
	            }
	            return;
	        }
	
	        limit = offset = this.model.get('mtdLimit');
	        if (eaField) {
	            eaFields.push({ field: eaField, offset: offset });
	        }
	        if (taxExemptEaField) {
	            eaFields.push({ field: taxExemptEaField, limit: limit });
	        }
	        this.model.set('eaFields', eaFields);
	    },
	
	    render: function render() {
	        if (this.model.get('type') === 'overtime') {
	            this.options.template = _OvertimePayrollItemModal2.default;
	        } else {
	            this.options.template = _PayrollItemModal2.default;
	        }
	
	        var returnValue = _ModalForm2.default.prototype.render.apply(this, arguments);
	        if (this.model.get('category')) {
	            this.$('[name="category"]').val(this.model.get('category'));
	        }
	        return returnValue;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PayrollItemModal.ejs -->\n<div class="modal-dialog" style="width: 540px;">\n    <form class="modal-content animated sweet form-horizontal" role="form">\n        <input type="hidden" name="eaFields" class="js-ext">\n        <div class="modal-header" style="border-bottom: none;">\n            <h1 class="modal-title">\n                Add\n                '+
	((__t=( (model.get('type') === 'addition') ?
	                    'Addition' : 'Deduction' ))==null?'':_.escape(__t))+
	'\n            </h1>\n        </div>\n\n        <div class="modal-body" style="background: #ffffff; padding: 0 50px\n            40px 50px;">\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Name\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Choose the name you would like to\n                            identify this payroll item by"></i>\n                </label>\n                <div class="col-sm-8">\n                    <input name="name" class="form-control" type="text"\n                        placeholder="Enter the name of the item"\n                        value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'">\n                    <span class="error error-name"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">Category</label>\n                <div class="col-sm-8">\n                    <select name="category" class="form-control"\n                        data-value-type="integer">\n                        <option disabled selected>Select a category...</option>\n\n                        ';
	 if (model.get('type') === 'addition') { 
	__p+='\n                            <option value="0"\n                                '+
	((__t=( model.get('category') === 0 ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                Remuneration\n                            </option>\n                            <option value="4"\n                                '+
	((__t=( model.get('category') === 4 ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                Other Perquisite\n                            </option>\n                            <option value="1"\n                                '+
	((__t=( model.get('category') === 1 ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                Allowance\n                            </option>\n                            <option value="2"\n                                '+
	((__t=( model.get('category') === 2 ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                Benefit-in-Kind\n                            </option>\n                        ';
	 } 
	__p+='\n\n                        ';
	 if (model.get('type') === 'deduction') { 
	__p+='\n                            <option value="3"\n                                '+
	((__t=( model.get('category') === 3 ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                Deduction\n                            </option>\n                        ';
	 } 
	__p+='\n                    </select>\n                    <span class="error error-category"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Per unit?\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Choose whether the payroll item is\n                            a fixed amount or has units attached to it\n                            like hours or days. See help for more info"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="isUnit"\n                            '+
	((__t=( !model.get('isUnit') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="isUnit"\n                            '+
	((__t=( model.get('isUnit') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-isUnit"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Is Gross?\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in gross income?"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="isGross"\n                            '+
	((__t=( !model.get('isGross') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="isGross"\n                            '+
	((__t=( model.get('isGross') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-isGross"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Is Net?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in net income?"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="isNet"\n                            '+
	((__t=( !model.get('isNet') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="isNet"\n                            '+
	((__t=( model.get('isNet') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-isNet"></span>\n                </div>\n            </div>            \n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects PCB?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in PCB calculations?">\n                    </i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsMtd"\n                            '+
	((__t=( !model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsMtd"\n                            '+
	((__t=( model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                            data-value-type="boolean">\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsMtd"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    PCB Exempt Limit\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="The value this item can reach\n                        before it will be taxed (0.00 means any amount will be\n                        taxed)"></i>\n                </label>\n                <div class="col-sm-8">\n                    <div class="input-group">\n                        <input type="text" name="mtdLimit" class="form-control"\n                            data-value-type="float" type="text"\n                            ';
	 if (model.get('affectsMtd')) { 
	__p+='\n                                value="'+
	((__t=( model.get('mtdLimit') ))==null?'':_.escape(__t))+
	'"\n                            ';
	 } else { 
	__p+='\n                                disabled\n                            ';
	 } 
	__p+='>\n                    </div>\n                    <span class="error error-mtdLimit"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects EPF?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in EPF calculations?">\n                    </i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsEpf"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsEpf"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsEpf"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects SOCSO?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in SOCSO\n                        calculations?"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsSocso"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsSocso"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsSocso"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects EIS?\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in EIS\n                        calculations?"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsEis"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsEis"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsEis"></span>\n                </div>\n            </div>\n\n            <div class="form-group row\n                '+
	((__t=( model.get('affectsMtd') && model.get('mtdLimit') > 0 ? '': 'hidden' ))==null?'':_.escape(__t))+
	'">\n                <label class="col-sm-4 control-label">\n                    EA Form Field (Tax Exempt Amount)\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Where should the tax exempt\n                            amount amount appear in the yearly EA form?"></i>\n                    <span class="js-required js-required-eaFields">*</span>\n                </label>\n                <div class="col-sm-8">\n                    <div class="input-group">\n                        <select name="taxExemptEaField"\n                            '+
	((__t=(
	                            model.get('affectsMtd') && model.get('mtdLimit') > 0 ?
	                                '': 'disabled'  ))==null?'':_.escape(__t))+
	'\n                            class="form-control js-ext js-ext-eaField js-attr-eaFields">\n                            <option disabled '+
	((__t=( !model.getTaxExemptEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                Please select an option\n                            </option>\n                            <option value="none">None</option>\n                            ';
	 _(Object.keys(eaFields)).forEach(function(field) { 
	__p+='\n                                <option value="'+
	((__t=( field ))==null?'':_.escape(__t))+
	'"\n                                    '+
	((__t=( model.getTaxExemptEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                    '+
	((__t=( eaFields[field] ))==null?'':_.escape(__t))+
	'\n                                </option>\n                            ';
	 }) 
	__p+='\n                        </select>\n                    </div>\n                    <span class="error error-eaFields"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    EA Form Field\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Where should the\n                            amount appear in the yearly EA form?">\n                    </i>\n                    <span class="js-required js-required-eaFields">*</span>\n                </label>\n                <div class="col-sm-8">\n                    <div class="input-group">\n                        <select name="eaField"\n                            class="form-control js-ext js-ext-eaField js-attr-eaFields">\n                            <option disabled '+
	((__t=( !model.getEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                Please select an option\n                            </option>\n                            <option value="none">None</option>\n                            ';
	 _(Object.keys(eaFields)).forEach(function(field) { 
	__p+='\n                                <option value="'+
	((__t=( field ))==null?'':_.escape(__t))+
	'"\n                                    '+
	((__t=( model.getEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                    '+
	((__t=( eaFields[field] ))==null?'':_.escape(__t))+
	'\n                                </option>\n                            ';
	 }) 
	__p+='\n                        </select>\n                        <span class="error error-eaFields"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="modal-footer" style="border-top: none; text-align:\n            center;">\n            <button type="reset" class="btn btn-warning btn-w-m js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit" class="btn btn-primary btn-w-m btn-save\n                js-save m-l-md">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/OvertimePayrollItemModal.ejs -->\n<div class="modal-dialog" style="width: 540px;">\n    <form class="modal-content animated sweet form-horizontal" role="form">\n        <input type="hidden" name="eaFields" disabled>\n        <div class="modal-header" style="border-bottom: none;">\n            <h1 class="modal-title">\n                Add Custom Overtime\n            </h1>\n        </div>\n\n        <div class="modal-body" style="background: #ffffff; padding: 0 50px\n            40px 50px;">\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Name\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Choose the name you would like to\n                            identify the overtime"></i>\n                </label>\n                <div class="col-sm-8">\n                    <input name="name" class="form-control" type="text"\n                        placeholder="Enter the name of the item"\n                        value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'">\n                    <span class="error error-name"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Rate\n                </label>\n                <div class="col-sm-8">\n                    <div class="input-group">\n                        <input type="text" name="overtimeFactor"\n                            class="form-control"\n                            type="text"\n                            value="'+
	((__t=( model.get('overtimeFactor') ))==null?'':_.escape(__t))+
	'"\n                            data-value-type="float">\n                    </div>\n                    <span class="error error-overtimeFactor"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    After Working Hours?\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="afterWorkingHours"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('afterWorkingHours') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="afterWorkingHours"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('afterWorkingHours') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-afterWorkingHours"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Non-Working Days?\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="nonWorkingDays"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('nonWorkingDays') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="nonWorkingDays"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('nonWorkingDays') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-nonWorkingDays"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Holidays?\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="holidays"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('holidays') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="holidays"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('holidays') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-holidays"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects PCB?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in PCB calculations?">\n                    </i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsMtd"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsMtd"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsMtd"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects EPF?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in EPF calculations?">\n                    </i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsEpf"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsEpf"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsEpf"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects SOCSO?\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in SOCSO\n                        calculations?"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsSocso"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsSocso"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsSocso"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Affects EIS?\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Is included in EIS\n                        calculations?"></i>\n                </label>\n                <div class="col-sm-8">\n                    <label class="js-icheck" style="margin-right: 32px;">\n                        <input type="radio" value="0" name="affectsEis"\n                            data-value-type="boolean"\n                            '+
	((__t=( !model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>No</span>\n                    </label>\n                    <label class="js-icheck">\n                        <input type="radio" value="1" name="affectsEis"\n                            data-value-type="boolean"\n                            '+
	((__t=( model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span>Yes</span>\n                    </label>\n                    <span class="error error-affectsEis"></span>\n                </div>\n            </div>\n\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    EA Form Field\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Where should the\n                            amount appear in the yearly EA form?">\n                    </i>\n                </label>\n                <div class="col-sm-8">\n                    <div class="input-group">\n                        <select name="eaField"\n                            class="form-control js-ext js-ext-eaField js-attr-eaFields">\n                            <option disabled '+
	((__t=( !model.getEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                Please select an option\n                            </option>\n                            <option value="none">None</option>\n                            ';
	 _(Object.keys(eaFields)).forEach(function(field) { 
	__p+='\n                                <option value="'+
	((__t=( field ))==null?'':_.escape(__t))+
	'"\n                                    '+
	((__t=( model.getEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                    '+
	((__t=( eaFields[field] ))==null?'':_.escape(__t))+
	'\n                                </option>\n                            ';
	 }) 
	__p+='\n                        </select>\n                    </div>\n                    <span class="error error-eaFields"></span>\n                </div>\n            </div>\n        </div>\n        ';
	 /* Having an input for these attributes prevents
	         any possible error from poping up as a modal */ 
	__p+='\n        <input type="hidden" name="mtdLimit">\n        <input type="hidden" name="allowRecurrency">\n        <input type="hidden" name="category">\n        <input type="hidden" name="isUnit">\n        <input type="hidden" name="isGross">\n        <input type="hidden" name="isNet">\n\n        <div class="modal-footer" style="border-top: none; text-align:\n            center;">\n            <button type="reset" class="btn btn-warning btn-w-m js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit" class="btn btn-primary btn-w-m btn-save\n                js-save m-l-md">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PayrollItems.ejs -->\n';
	 labels = {
	    addition: {
	        plural: 'Additions',
	        singular: 'Addition'
	    },
	    overtime: {
	        plural: 'Custom Overtime',
	        singular: 'Custom Overtime'
	    },
	    deduction: {
	        plural: 'Deductions',
	        singular: 'Deduction'
	    }
	} 
	__p+='\n';
	 _.each(['addition', 'overtime', 'deduction'], function(type) { 
	__p+='\n    ';
	 colspan = (type === 'overtime') ? 10 : 12 
	__p+='\n    <table class="table table-striped table-settings table-settings-'+
	((__t=( type ))==null?'':_.escape(__t))+
	'">\n        <thead>\n            <tr>\n                <th>'+
	((__t=( labels[type].plural ))==null?'':_.escape(__t))+
	'</th>\n                ';
	 if (type === 'overtime') { 
	__p+='\n                    <th width="10%">Rate</th>\n                    <th width="6%">PCB</th>\n                    <th width="6%">EPF</th>\n                    <th width="6%">SOCSO</th>\n                    <th width="6%">EIS</th>\n                    <th width="8%">After Working Hours</th>\n                    <th width="8%">Non Working Days</th>\n                    <th width="8%">Holidays</th>\n                    <th width="12%">EA Field</th>\n                ';
	 } else { 
	__p+='\n                    <th width="6%">Per Unit</th>\n                    <th width="6%">Gross</th>\n                    <th width="6%">Net</th>\n                    <th width="6%">PCB</th>\n                    <th width="6%">EPF</th>\n                    <th width="6%">SOCSO</th>\n                    <th width="6%">EIS</th>\n                    <th width="9.5%">PCB Exempt Limit</th>\n                    <th width="12%">EA Field (Exempt)</th>\n                    <th width="12%">EA Field</th>\n                ';
	 } 
	__p+='\n            </tr>\n        </thead>\n        <tbody class="list-'+
	((__t=( type ))==null?'':_.escape(__t))+
	'-empty js-empty-'+
	((__t=( type ))==null?'':_.escape(__t))+
	'">\n            <tr><td colspan="'+
	((__t=( colspan ))==null?'':_.escape(__t))+
	'">\n                <h2 class="text-center">\n                    You don\'t have any '+
	((__t=( labels[type].plural.toLowerCase() ))==null?'':_.escape(__t))+
	'\n                </h2>\n            </td></tr>\n        </tbody>\n        <tbody class="list-'+
	((__t=( type ))==null?'':_.escape(__t))+
	' js-model-'+
	((__t=( type ))==null?'':_.escape(__t))+
	'-views"></tbody>\n        ';
	 if (typeof hideActionButtons === 'undefined' || !hideActionButtons) { 
	__p+='\n        <tfoot>\n            <tr><td colspan="'+
	((__t=( colspan ))==null?'':_.escape(__t))+
	'">\n                <button class="btn btn-outline pull-right\n                    btn-'+
	((__t=( type === 'deduction' ? 'danger' : 'primary' ))==null?'':_.escape(__t))+
	'\n                    js-add-'+
	((__t=( type ))==null?'':_.escape(__t))+
	'\n                    data-loading-text="Adding..."\n                    data-complete-text="+ Add '+
	((__t=( labels[type].singular ))==null?'':_.escape(__t))+
	'">\n                    + Add '+
	((__t=( labels[type].singular ))==null?'':_.escape(__t))+
	'\n                </button>\n            </td></tr>\n        </tfoot>\n        ';
	 } 
	__p+='\n    </table>\n';
	 }); 
	__p+='\n';
	 if (typeof hideActionButtons === 'undefined' || !hideActionButtons) { 
	__p+='\n<div class="clearfix">\n    <div class="pull-right">\n        <button class="js-cancel btn btn-warning btn-w-m btn-cancel"\n            data-toggle="tooltip" data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i>\n            Cancel\n        </button>\n        <button class="js-save btn btn-primary m-l-xs">\n            <i class="fa fa-check"></i>\n            Save changes\n        </button>\n    </div>\n</div>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var MainView = __webpack_require__(704);
	var CommonPersonalSettingsView = __webpack_require__(681);
	var RolePersonalSettingsView = __webpack_require__(708);
	
	var BaseRouter = __webpack_require__(625);
	var PayrollRouter = __webpack_require__(711);
	var EmployeeRouter = __webpack_require__(771);
	var ReportRouter = __webpack_require__(820);
	var SettingsRouter = __webpack_require__(835);
	var CalendarRouter = __webpack_require__(890);
	var GovernmentFormsRouter = __webpack_require__(913);
	var DashboardRouter = __webpack_require__(1010);
	var TimesheetRouter = __webpack_require__(1024);
	var moment = __webpack_require__(101);
	
	module.exports = BaseRouter.extend({
	    routes: {
	        'personalSettings': 'personalSettings'
	    },
	
	    titles: {
	        'personalSettings': 'Personal Settings'
	    },
	
	    initialize: function initialize() {
	        var _this = this;
	
	        this.mainView = new MainView({ model: app.company });
	
	        this.subRouters = [new PayrollRouter({ el: this.mainView.childEl }), new EmployeeRouter({ el: this.mainView.childEl })];
	
	        /* MPP Managers only have access to Payroll and Employees */
	        if (app.user.get('role') !== 'mpp_manager') {
	            this.subRouters = this.subRouters.concat([new ReportRouter({ el: this.mainView.childEl }), new SettingsRouter({ el: this.mainView.childEl }), new GovernmentFormsRouter({ el: this.mainView.childEl }), new DashboardRouter({ el: this.mainView.childEl }), new CalendarRouter({ el: this.mainView.childEl }), new TimesheetRouter({ el: this.mainView.childEl })]);
	        }
	
	        // TODO This is view logic, it does not belong in the router and should
	        // be moved out
	        Backbone.history.on('route', function () {
	            this.mainView.setActiveLink(Backbone.history.getFragment());
	            window.scrollTo(0, 0);
	        }.bind(this));
	
	        app.events.on('before:route', function (opts) {
	            var fragment = opts.previousFragment || false;
	            var activeRouter = _this.subRouters.find(function (router) {
	                var routes = Object.keys(router.routes);
	                return routes.indexOf(fragment) >= 0;
	            });
	            if (activeRouter && activeRouter.view) {
	                if (activeRouter.view.remove) {
	                    activeRouter.view.remove();
	                }
	            }
	        });
	
	        var impersonating = app.user.isAdmin();
	        if (!impersonating) {
	            app.company.save({ 'lastActiveTime': moment.now() }, { validate: false });
	        }
	        if (app.company.get('updateRestricted')) {
	            $('#update-restricted-notification').css({ display: 'block' });
	        }
	        if (app.company.get('leaveRequestsMigrated')) {
	            $('#leaves-migrated-notification').css({ display: 'block' });
	        }
	        $('#help-notification').css({ display: 'block' });
	    },
	
	    toggleFreeAccountSetup: function toggleFreeAccountSetup(show) {
	        var button = $('.js-free-account-setup');
	        if (show) {
	            button.show();
	        } else {
	            button.hide();
	        }
	    },
	
	    personalSettings: function personalSettings() {
	        this.undelegateEvents();
	
	        // just hotfix for solve events mess
	        // TODO: refactor events binding
	        var el = $('<div></div>');
	        $(this.mainView.childEl).html(el);
	
	        this.view = new CommonPersonalSettingsView({
	            el: el,
	            model: app.user,
	            subViews: app.user.get('role') === 'employer' ? [new RolePersonalSettingsView({
	                model: app.user,
	                company: app.company
	            })] : []
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Main = __webpack_require__(645);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _NavMenu = __webpack_require__(705);
	
	var _NavMenu2 = _interopRequireDefault(_NavMenu);
	
	var _HeaderMenu = __webpack_require__(706);
	
	var _HeaderMenu2 = _interopRequireDefault(_HeaderMenu);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _FreeAccountSetup = __webpack_require__(707);
	
	var _FreeAccountSetup2 = _interopRequireDefault(_FreeAccountSetup);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _employee = __webpack_require__(571);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	    childEl: '#main-area',
	
	    events: {
	        'click .js-free-account-setup': 'freeAccountSetup',
	        'click .snooze-button': 'hideAlert',
	        'click .alert-link': 'exitLink'
	    },
	
	    initialize: function initialize() {
	        this.model.on('sync change', this.renderCompanyName, this);
	        this.model.on('sync change', this.renderContactName, this);
	        this.model.on('change:logoUrl', this.renderLogo, this);
	        return this.render();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var id = app.company.get('mppAdminId');
	        var logoUrl = app.user.getLogoUrl(id);
	        var altRole = '';
	        if (app.user.get('role').match(/(admin|mpp)/)) {
	            altRole = app.user.get('role');
	        }
	
	        this.$el.html((0, _Main2.default)({
	            navMenu: (0, _NavMenu2.default)({
	                model: this.model,
	                altRole: altRole
	            }),
	            headerMenu: (0, _HeaderMenu2.default)({}),
	            version: app.version,
	            whitelabel: app.company.get('mppAdminId') || app.subscription && app.subscription.get('plan') !== 'client',
	            logoUrl: logoUrl
	        }));
	
	        // update EIS/SOCSO once a month
	        var prevLoginPayrollPeriodDate = _payroll2.default.getPeriodFromDate(this.lastActive());
	        if ((0, _moment2.default)(_payroll2.default.getCurrentPeriodDate()).isAfter(prevLoginPayrollPeriodDate, 'month')) {
	            var employees = new _employees2.default(null, {
	                company: app.company,
	                pagination: false
	            });
	            employees.fetch({
	                filter: {
	                    where: {
	                        hiddenAt: null
	                    },
	                    limit: 9999
	                }
	            }).then(function () {
	                return _this.updateSatutoryFor18(employees);
	            }).then(function () {
	                return _this.updateSatutoryFor60(employees);
	            });
	        }
	
	        $('body').removeClass('gray-bg');
	
	        this.$('#side-menu').metisMenu({
	            toggle: false,
	            activeClass: 'active-group'
	        });
	
	        this.$el.find('.logo img').on('load', function (e) {
	            $(e.target.parentElement).removeClass('hidden');
	        }).on('error', function (e) {
	            e.target.src = '';
	        });
	
	        _tooltip2.default.initBody();
	
	        this.trigger('render');
	
	        return this;
	    },
	
	    lastActive: function lastActive() {
	        return (0, _moment2.default)(app.company.get('lastActiveTime'));
	    },
	
	    renderCompanyName: function renderCompanyName() {
	        this.$('.js-company-name').text(this.model.get('companyName'));
	    },
	
	    renderContactName: function renderContactName() {
	        this.$('.js-contact-name').text(this.model.get('contactName'));
	    },
	
	    renderLogo: function renderLogo() {
	        var hasLogo = !!this.model.get('logoUrl');
	        var url = this.model.getLogoUrl();
	        var $img = this.$('.js-nav-company-logo');
	
	        if (hasLogo) {
	            $img.removeClass('hidden').attr('src', url);
	        } else {
	            $img.addClass('hidden').attr('src', '');
	        }
	    },
	
	    freeAccountSetup: function freeAccountSetup() {
	        var _this2 = this;
	
	        return _FreeAccountSetup2.default.freeAccountSetupRequest().then(function () {
	            return _this2.$('.js-free-account-setup').hide();
	        }).catch(function () {});
	    },
	
	    setActiveLink: function setActiveLink(route) {
	        // for all 3 payroll steps
	        if (route.indexOf('payroll/step') === 0) {
	            route = 'payroll';
	        }
	
	        if (route.indexOf('settings') === 0) {
	            route = 'settings';
	        }
	
	        var $parent = this.$el.find('#side-menu a[href="#' + route + '"]').parent();
	        var $sub = $parent.parent();
	
	        this.$('#side-menu li').removeClass('active');
	
	        $parent.addClass('active');
	
	        if ($parent.parent().hasClass('nav-second-level')) {
	            // show second level menu
	            $sub.collapse('show');
	            $sub.parent().addClass('active-group');
	        }
	    },
	
	    hideAlert: function hideAlert(ev) {
	        this.$(ev.target).closest('.display-alert').addClass('hidden');
	    },
	
	    exitLink: function exitLink(ev) {
	        ev.preventDefault();
	        var isMppManager = app.user.get('role') === 'mpp_manager';
	        if (isMppManager) {
	            _modal2.default.warning({
	                text: 'Currently, there are outstanding invoices to be paid.                    <br>Please refer to MPP Admin for payment information.',
	                html: true
	            });
	        } else {
	            window.location.href = ev.target.href;
	        }
	    },
	
	    getEmployeeNameString: function getEmployeeNameString(employees) {
	        var getEmpName = function getEmpName(employee) {
	            return employee.get('fullName');
	        };
	        if (employees.length > 1) {
	            var empNames = employees.map(getEmpName);
	            return 'employees ' + empNames.slice(0, -1).join(', ') + (', and ' + empNames.slice(-1) + ' have');
	        }
	        return 'employee ' + getEmpName(employees[0]) + ' has';
	    },
	
	    updateSatutoryFor18: function updateSatutoryFor18(employees) {
	        var _this3 = this;
	
	        // compare age last active and age now. if same, don't change anything
	        var employeesToUpdate = employees.filter(function (employee) {
	            var ageThisPayroll = employee.getAgeAtEndOfPeriod();
	            var payrollMonth = new _payroll2.default().getPeriod().month();
	            var birthMonth = (0, _moment2.default)(employee.get('dob')).month();
	            return ageThisPayroll === 18 && payrollMonth === birthMonth && !employee.get('isEis') && employee.canContributeToEis();
	        });
	
	        if (employeesToUpdate.length > 0) {
	            return (0, _bluebird.all)(employeesToUpdate.map(function (employee) {
	                employee.set('isEis', true);
	                return employee.save();
	            })).then(function () {
	                return new _bluebird2.default(function (resolve) {
	                    return _alerts2.default.show('info', {
	                        title: 'Update of Employees\' Statutory Requirements',
	                        text: 'Your ' + _this3.getEmployeeNameString(employeesToUpdate) + ' ' + 'reached the age of 18. Therefore, the EIS contribution ' + 'has been automatically enabled since they are now ' + 'eligible to contribute to the Employment Insurance ' + 'Scheme. If you wish to disable EIS, please proceed to ' + 'the Statutory Requirements tab in the employee\u2019s ' + 'profile. <br />',
	                        callback: function callback() {
	                            return resolve();
	                        }
	                    });
	                });
	            });
	        }
	    },
	
	    updateSatutoryFor60: function updateSatutoryFor60(employees) {
	        var _this4 = this;
	
	        // compare age last active and age now. if same, don't change anything
	        var employeesToUpdate = employees.filter(function (employee) {
	            var ageThisPayroll = employee.getAgeAtEndOfPeriod();
	            var payrollMonth = new _payroll2.default().getPeriod().month();
	            var birthMonth = (0, _moment2.default)(employee.get('dob')).month();
	            return ageThisPayroll === 60 && payrollMonth === birthMonth && (![_employee.consts.SOCSO_CATEGORY_NONE, _employee.consts.SOCSO_CATEGORY_INJURY].includes(employee.get('socsoCategory')) || employee.get('isEis'));
	        });
	
	        if (employeesToUpdate.length > 0) {
	            return (0, _bluebird.all)(employeesToUpdate.map(function (employee) {
	                employee.set('socsoCategory', _employee.consts.SOCSO_CATEGORY_INJURY);
	                employee.set('isEis', false);
	                return employee.save();
	            })).then(function () {
	                return new _bluebird2.default(function (resolve) {
	                    return _alerts2.default.show('info', {
	                        title: 'Update of Employees\' Statutory Requirements',
	                        text: 'Your ' + _this4.getEmployeeNameString(employeesToUpdate) + ' reached the age of 60. Therefore, the SOCSO ' + 'contribution category has automatically been changed ' + 'to \u2018Employment Injury Scheme\u2019 and EIS has been ' + 'disabled. If you wish to change the SOCSO category or ' + 'enable the EIS contribution,  please proceed to the ' + 'Statutory Requirements tab in the employee\u2019s profile. ' + '<br />' +
	                        // jscs:disable
	                        'For more information, please ' +
	                        // jscs:disable
	                        'read <a target="_blank" href="https://help.payrollpa' + 'nda.my/perkeso/what-are-' + 'the-differences-between-the-two-socso-categories">' + 'What are the differences between the two SOCSO categori' + 'es?</a> and <a target="_blank" href="https://help.payro' + 'llpanda.my/perkeso/294777-what-is-the-employment-insuran' + 'ce-system-eis">What is the Employment Insurance System ' + '(EIS)?</a>',
	                        callback: function callback() {
	                            return resolve();
	                        }
	                    });
	                });
	            });
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/NavMenu.ejs -->\n<ul class="nav metismenu" id="side-menu">\n    <li class="nav-header">\n        <div class="dropdown profile-element">\n            <div class="nav-company-logo">\n                <img class="js-nav-company-logo '+
	((__t=( model.getLogoUrl() ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'"\n                    src="'+
	((__t=( model.getLogoUrl() || '' ))==null?'':_.escape(__t))+
	'" />\n            </div>\n            <a data-toggle="dropdown" class="dropdown-toggle">\n                <span class="clear">\n                    <span class="block m-t-xs">\n                        <strong class="font-bold">\n                            <span class="js-company-name">\n                                '+
	((__t=( model.get('companyName') || '' ))==null?'':_.escape(__t))+
	'\n                            </span>\n                            ';
	 if (altRole) { 
	__p+='\n                                <br>['+
	((__t=( altRole ))==null?'':_.escape(__t))+
	']\n                            ';
	 } 
	__p+='\n                        </strong>\n                    </span>\n                    <span class="text-muted text-xs block">\n                        <span class="js-contact-name">\n                            '+
	((__t=( model.get('contactName') || '' ))==null?'':_.escape(__t))+
	'\n                        </span>\n                        <b class="caret"></b>\n                    </span>\n                </span>\n            </a>\n            <ul class="dropdown-menu animated fadeInDown m-t-xs">\n                <li>\n                    <a href="#personalSettings">\n                        Personal Settings\n                    </a>\n                </li>\n                <li><a href="#logout">Logout</a></li>\n            </ul>\n        </div>\n        <div class="dropdown mini-navbar-profile-element">\n            <a data-toggle="dropdown" class="dropdown-toggle">\n                <i class="fa fa-user"></i>\n                <b class="caret"></b>\n            </a>\n            <ul class="dropdown-menu animated fadeInDown m-t-xs">\n                <li>\n                    <a href="#personalSettings">\n                        Personal Settings\n                    </a>\n                </li>\n                <li><a href="#logout">Logout</a></li>\n            </ul>\n        </div>\n    </li>\n    <!-- TODO: this role checking logic should be in the view -->\n    ';
	 if (app.user.get('role') !== 'mpp_manager') { 
	__p+='\n    <li class="active">\n        <a href="#dashboard">\n            <i class="fa fa-tachometer"></i>\n            <span class="nav-label">Dashboard</span>\n        </a>\n    </li>\n    ';
	 } 
	__p+='\n    <li>\n        <a>\n            <i class="fa fa-pencil-square-o"></i>\n            <span class="nav-label">Payroll</span>\n            <span class="fa arrow"></span>\n        </a>\n        <ul class="nav nav-second-level">\n            ';
	 if (!app.user.get('isMPPCustomer')) { 
	__p+='\n                <li><a href="#payroll">Run Payroll</a></li>\n            ';
	 } 
	__p+='\n            <li><a href="#payroll/history">Payroll History</a></li>\n        </ul>\n    </li>\n    ';
	 if (app.user.get('role') !== 'mpp_manager') { 
	__p+='\n    <li>\n        <a href="#calendar">\n            <i class="fa fa-calendar"></i>\n            <span class="nav-label">Leave</span>\n        </a>\n    </li>\n    <li>\n        <a href="#timesheet">\n            <i class="fa fa-clock-o"></i>\n            <span class="nav-label">Timesheet</span>\n        </a>\n    </li>\n    ';
	 } 
	__p+='\n    <li>\n        <a href="#employees">\n            <i class="fa fa-users"></i>\n            <span class="nav-label">Employees</span>\n        </a>\n    </li>\n    ';
	 if (app.user.get('role') !== 'mpp_manager') { 
	__p+='\n    <li>\n        <a>\n            <i class="fa fa-files-o"></i>\n            <span class="nav-label">Reports</span>\n            <span class="fa arrow"></span>\n        </a>\n            <ul class="nav nav-second-level">\n            <li><a href="#reports/leave">Leave</a></li>\n            <li><a href="#reports/totals">Totals</a></li>\n            <li><a href="#reports/variance">Variance</a></li>\n            <li><a href="#governmentForms/lhdn">LHDN Audit Files</a></li>\n        </ul>\n\n    </li>\n    <li>\n        <a>\n            <i class="fa fa-university"></i>\n            <span class="nav-label">Yearly Forms</span>\n            <span class="fa arrow"></span>\n        </a>\n        <ul class="nav nav-second-level">\n            <li><a href="#governmentForms/e">Form E</a></li>\n            <li><a href="#governmentForms/ea">Form EA</a></li>\n            <li><a href="#governmentForms/pcb2">Form PCB 2(II)</a></li>\n        </ul>\n    </li>\n    <li>\n        <a href="#settings">\n            <i class="fa fa-cog"></i>\n            <span class="nav-label">Settings</span>\n        </a>\n    </li>\n    ';
	 } 
	__p+='\n</ul>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/HeaderMenu.ejs -->\n<button data-toggle="dropdown"\n        class="btn btn-success btn-bitbucket dropdown-toggle"\n        aria-expanded="false">\n    <i class="fa fa-plus"></i>\n</button>\n';
	}
	return __p;
	};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var freeAccountSetupRequest = function freeAccountSetupRequest() {
	    var request = function request() {
	        return _alerts2.default.show('success', {
	            title: '',
	            text: 'Get payroll assistance with account setup and full ' + 'onboarding by calling +603 2787 9168.',
	            confirmButtonText: 'OK'
	        });
	    };
	
	    return request().then(function () {
	        return app.company.fetch({ validate: false });
	    });
	};
	
	var shouldShowFreeSetup = function shouldShowFreeSetup() {
	    return (0, _bluebird.all)([app.company.fetch(), new _payrolls2.default(null, { company: app.company }).count()]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            company = _ref2[0],
	            count = _ref2[1];
	
	        var role = app.user.get('role');
	        var isMpp = ['mpp_admin', 'mpp_manager'].includes(role);
	        var lessThanOnePayroll = count <= 1;
	        var show = lessThanOnePayroll && !isMpp;
	        return show;
	    });
	};
	
	module.exports = {
	    freeAccountSetupRequest: freeAccountSetupRequest,
	    shouldShowFreeSetup: shouldShowFreeSetup
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(709);
	var PanelView = __webpack_require__(710);
	
	module.exports = PanelView.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { template: template });
	        return PanelView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var _this = this;
	
	        var r = PanelView.prototype.bindHandlers.apply(this, arguments);
	
	        this.on('save', function () {
	            return app.company.save({
	                officerDesignation: _this.$('#officerDesignation').val() || ''
	            });
	        }, this);
	
	        this.on('saved', function () {
	            return app.company.fetch({ validate: false });
	        }, this);
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = PanelView.prototype.bindHandlers.apply(this, arguments);
	        this.off('saved', null, this);
	        return r;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/PersonalSettings.ejs -->\n<div class="ibox-title">\n    <h5>Contact Information</h5>\n</div>\n<form class="js-form-settings form-horizontal">\n    <div class="ibox-content">\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Email\n            </label>\n            <div class="col-sm-9">\n                <input type="text" name="username" class="form-control"\n                       placeholder="Enter email"\n                       value="'+
	((__t=( model.get('username') ))==null?'':_.escape(__t))+
	'"/>\n                <span class="error error-username"></span>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Name\n            </label>\n            <div class="col-sm-9">\n                <input type="text" name="name" class="form-control"\n                    placeholder="Enter name" value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'">\n                <span class="error error-name"></span>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Designation\n            </label>\n            <div class="col-sm-9">\n                <input type="text" id="officerDesignation" class="form-control"\n                    placeholder="Officer’s designation for the EA form" value="'+
	((__t=( app.company.get('officerDesignation') ))==null?'':_.escape(__t))+
	'">\n                <span class="error error-name"></span>\n            </div>\n        </div>\n    </div>\n\n    <div class="ibox-footer text-right">\n        <button type="button"\n            class="js-cancel btn btn-w-m btn-warning"\n            data-toggle="tooltip"\n            data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i>\n            Cancel\n        </button>\n        <button type="submit"\n            class="js-save btn btn-w-m btn-primary m-l-xs">\n            <i class="fa fa-check"></i> Save\n        </button>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var FormView = __webpack_require__(550);
	var modal = __webpack_require__(532);
	
	module.exports = FormView.extend({
	    className: 'ibox m-b-lg',
	
	    bindHandlers: function bindHandlers() {
	        var r = FormView.prototype.bindHandlers.apply(this, arguments);
	
	        this.on('saved', this.showSavedToast, this);
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = FormView.prototype.bindHandlers.apply(this, arguments);
	
	        this.off('saved', this.showSavedToast, this);
	
	        return r;
	    },
	
	    showSavedToast: function showSavedToast() {
	        var thing = this.options.thing || 'personal settings';
	
	        modal.showAlertSuccess('Your ' + thing + ' have been saved');
	    }
	});

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Layout = __webpack_require__(713);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _PayrollHistory = __webpack_require__(760);
	
	var _PayrollHistory2 = _interopRequireDefault(_PayrollHistory);
	
	var _PayrollView = __webpack_require__(768);
	
	var _PayrollView2 = _interopRequireDefault(_PayrollView);
	
	var _payrollDetails = __webpack_require__(599);
	
	var _payrollDetails2 = _interopRequireDefault(_payrollDetails);
	
	var _payslips = __webpack_require__(581);
	
	var _payslips2 = _interopRequireDefault(_payslips);
	
	var _payslipDetails = __webpack_require__(583);
	
	var _payslipDetails2 = _interopRequireDefault(_payslipDetails);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _payrollSummary = __webpack_require__(770);
	
	var _payrollSummary2 = _interopRequireDefault(_payrollSummary);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/payroll-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'payroll': 'payroll',
	        'payroll/step/:step': 'payrollStep',
	        'payroll/history': 'history',
	        'payroll/view/:id/:tab': 'payrollView'
	    },
	
	    titles: {
	        'payroll': 'Run Payroll',
	        'payroll/step/:step': 'Run Payroll',
	        'payroll/history': 'Payroll History',
	        'payroll/view/:id/:tab': 'Payroll'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    payroll: function payroll() {
	        var _this = this;
	
	        if (app.user.get('isMPPCustomer')) {
	            return;
	        }
	
	        app.contentView = this.layout = new _Layout2.default({ el: this.el });
	        this.layout.showLoader();
	
	        return (0, _bluebird.all)([app.company.fetchCurrentPayroll(), app.company.destroyUnsavedPayrolls()]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                payroll = _ref2[0];
	
	            if (payroll) {
	                return (0, _bluebird.all)([(0, _bluebird.resolve)(payroll), payroll.hasPendingJobs()]);
	            }
	            return [false, false];
	        }).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                payroll = _ref4[0],
	                hasPendingJobs = _ref4[1];
	
	            if (!payroll || payroll.get('status') < 1) {
	                _this.navigate('payroll/step/1', { trigger: true, replace: true });
	                return;
	            }
	
	            _this._payroll = payroll;
	            _this._pendingJobs = hasPendingJobs;
	            _this.navigate('payroll/step/' + (payroll.get('status') + 1), { trigger: true, replace: true });
	        });
	    },
	
	    loadPayrollForStep: function loadPayrollForStep(step) {
	        var promise = void 0;
	
	        if (this._payroll && step > 1) {
	            promise = (0, _bluebird.all)([(0, _bluebird.resolve)(this._payroll), (0, _bluebird.resolve)(this._pendingJobs)]);
	            this._payroll = null;
	            this._pendingJobs = null;
	        } else {
	            promise = (0, _bluebird.all)([app.company.fetchCurrentPayroll(), app.company.fetchUnsavedPayroll()]).then(function (_ref5) {
	                var _ref6 = _slicedToArray(_ref5, 2),
	                    payroll = _ref6[0],
	                    unsavedPayroll = _ref6[1];
	
	                if (!payroll && unsavedPayroll && step === 2) {
	                    payroll = unsavedPayroll;
	                }
	                if (payroll) {
	                    return (0, _bluebird.all)([(0, _bluebird.resolve)(payroll), payroll.hasPendingJobs()]);
	                }
	
	                if (!payroll && step === 1) {
	                    payroll = new _payroll2.default({
	                        companyId: app.company.id,
	                        periodDate: _payroll2.default.getCurrentPeriodDate()
	                    });
	                }
	                return (0, _bluebird.all)([(0, _bluebird.resolve)(payroll), (0, _bluebird.resolve)(false)]);
	            });
	        }
	        return promise;
	    },
	
	    // TODO I got rid of the crappy
	    // step[One|Two|Three] but some of the crapiness in them I placed here
	    // to be reviewed later.
	    loadStepViewData: function loadStepViewData(payroll, pendingJobs, step) {
	        var loaders = [function (payroll, pendingJobs) {
	            //step 1
	            var date = payroll.getPeriod().toDate();
	            if (payroll.isNew()) {
	                payroll.set('periodDate', date);
	            }
	            return (0, _bluebird.all)([app.company.fetchLastSubmittedPayroll(), app.company.fetchPayableEmployees(null, 10, date), app.company.fetchPayableEmployees(null, null, date), app.company.fetch()]).then(function (_ref7) {
	                var _ref8 = _slicedToArray(_ref7, 3),
	                    lastPayroll = _ref8[0],
	                    employees = _ref8[1],
	                    allEmployees = _ref8[2];
	
	                if (lastPayroll && !lastPayroll.isComplete()) {
	                    throw new Error('Unfinished Payroll Present');
	                }
	
	                if (employees.length === 0) {
	                    throw new Error('No Payable Employee');
	                }
	
	                var payrollItems = app.payrollItems.getSelectableAdditionals();
	
	                var details = new _payrollDetails2.default(null, {
	                    payroll: payroll,
	                    filter: { limit: 9999 },
	                    pagination: false
	                });
	                var lastPayrollDetails = new _payrollDetails2.default(null, {
	                    payroll: lastPayroll,
	                    filter: {
	                        where: { amount: { gt: 0 } },
	                        limit: 9999
	                    },
	                    pagination: false
	                });
	
	                return (0, _bluebird.all)([payroll.isNew() ? _payrollDetails2.default.createDefaults(payroll, employees.slice(0, 10)) : details.fetch().then(function () {
	                    return details.filterNonContributions();
	                }), lastPayroll ? lastPayrollDetails.fetch().then(function () {
	                    return lastPayrollDetails.filterNonContributions();
	                }) : (0, _bluebird.resolve)(lastPayrollDetails)]).then(function (_ref9) {
	                    var _ref10 = _slicedToArray(_ref9, 2),
	                        details = _ref10[0],
	                        lastDetails = _ref10[1];
	
	                    return (0, _bluebird.resolve)({
	                        model: payroll,
	                        pendingJobs: pendingJobs,
	                        payrollDetails: details,
	                        lastPayroll: lastPayroll,
	                        lastPayrollDetails: lastDetails,
	                        employees: employees,
	                        allEmployees: allEmployees,
	                        payrollItems: payrollItems
	                    });
	                });
	            });
	        }, function (payroll) {
	            //step 2
	            // There is a combobox widget in step 2 that requires all
	            // payslips. Until it can be ajaxified, this will have to do
	            return payroll.fetchPayslips().then(function (payslips) {
	                if (!payslips.length) {
	                    return _alerts2.default.show('warning', {
	                        text: 'The payroll you created has no                                         payslips. <a href="https://help.                                        payrollpanda.my/18570-app-faq170577-                                        how-can-i-send-the-payslips-to-my-                                        employees" target="_blank">Learn more                                        </a> if you want to send payslips.',
	                        confirmButtonText: 'Back To Step 1'
	                    }).then(function () {
	                        return payroll.setStatus(0);
	                    }).then(function () {
	                        return app.mainRouter.navigate('payroll/step/1', { trigger: true });
	                    });
	                }
	
	                payroll.setCompany(app.company);
	                return (0, _bluebird.all)(payslips.map(function (payslip) {
	                    payslip.setPayroll(payroll);
	                    payslip.setCompany(app.company);
	                    return payslip.fetchEmployee().then(function (emp) {
	                        return emp.fetchPosition();
	                    });
	                })).then(function () {
	                    return payslips;
	                });
	            }).then(function (payslips) {
	                var attachments = new _attachments2.default(null, {
	                    attachable: payroll,
	                    pagination: false
	                });
	                return (0, _bluebird.all)([payslips, app.company.fetchPrimaryLocation().then(function (location) {
	                    return location.fetchAddress().then(function () {
	                        return location;
	                    });
	                }), attachments.fetch()]);
	            }).then(function (_ref11) {
	                var _ref12 = _slicedToArray(_ref11, 3),
	                    payslips = _ref12[0],
	                    location = _ref12[1],
	                    attachments = _ref12[2];
	
	                return (0, _bluebird.resolve)({
	                    model: payroll,
	                    payslips: payslips,
	                    payslipDetails: new _payslipDetails2.default(null, {}),
	                    payrollSummary: new _payrollSummary2.default(null, {
	                        payroll: payroll,
	                        filter: {
	                            limit: 10
	                        },
	                        pagination: { rowsPerPage: 10 }
	                    }),
	                    companyLocation: location,
	                    attachments: attachments,
	                    tab: 'summary'
	                });
	            });
	        }, function (payroll) {
	            //step 3
	            var payslips = new _payslips2.default(null, {
	                payroll: payroll,
	                pagination: false,
	                sortKey: 'employeeName',
	                sortOrder: 'ascending'
	            });
	            payroll.setCompany(app.company);
	            return (0, _bluebird.all)([app.company.fetchCurrentPayroll(), app.company.fetchBankAccount(), payslips.fetch({
	                filter: { limit: 9999 }
	            })]).then(function () {
	                var isFree = !app.company.get('isBillable');
	                if (isFree) {
	                    return 0;
	                }
	
	                return payroll.calculateBillableAmount();
	            }).then(function (amount) {
	                payroll.set('billableAmount', amount);
	                return (0, _bluebird.all)(payslips.map(function (payslip) {
	                    return payslip.fetchEmployee().then(function (employee) {
	                        return employee.fetchPosition();
	                    });
	                }));
	            }).then(function () {
	                return {
	                    payslips: payslips,
	                    model: payroll
	                };
	            });
	        }];
	
	        return loaders[step - 1](payroll, pendingJobs);
	    },
	
	    payrollStep: function payrollStep(step) {
	        var _this2 = this;
	
	        // 20200827 disable payroll runs between 2-5am,
	        // during which fix-YTD is running
	        if ((0, _moment2.default)().hour() >= 2 && (0, _moment2.default)().hour() < 5) {
	            return _alerts2.default.show('warning', {
	                text: 'Please note maintenance is in progress.                     Please check back after 5 am to run payroll.',
	                confirmButtonText: 'OK',
	                callback: function callback() {
	                    return app.mainRouter.navigate('dashboard', { trigger: true });
	                }
	            });
	        }
	
	        if (app.user.get('isMPPCustomer')) {
	            return;
	        }
	
	        app.contentView = this.layout = new _Layout2.default({ el: this.el });
	
	        step = parseInt(step, 10);
	        if (step < 1 || step > 3) {
	            step = 1;
	        }
	
	        this.layout.step = step;
	        this.layout.render();
	
	        this.loadPayrollForStep(step).then(function (_ref13) {
	            var _ref14 = _slicedToArray(_ref13, 2),
	                payroll = _ref14[0],
	                pendingJobs = _ref14[1];
	
	            if (!payroll || payroll.get('status') !== step - 1) {
	                return app.mainRouter.navigate('payroll', { trigger: true, replace: true });
	            }
	
	            _this2.layout.model = payroll;
	            _this2.layout.render();
	
	            return _this2.loadStepViewData(payroll, pendingJobs, step).then(function (viewData) {
	                _this2.layout.renderContent(viewData);
	            });
	        }).catch(function (err) {
	            if (err.message === 'Unfinished Payroll Present') {
	                return _alerts2.default.show('warning', {
	                    text: 'You have an unfinished payroll. Please submit                             it before starting the next payroll.',
	                    confirmButtonText: 'View Payroll History',
	                    callback: function callback() {
	                        return app.mainRouter.navigate('payroll/history', { trigger: true });
	                    }
	                });
	            } else if (err.message === 'No Payable Employee') {
	                return _alerts2.default.show('warning', {
	                    text: 'You need to add at least one employee before ' + 'you can Run Payroll.',
	                    confirmButtonText: 'Add Employee',
	                    callback: function callback() {
	                        return app.mainRouter.navigate('employee/add', { trigger: true });
	                    }
	                });
	            }
	            log.error(err);
	            _alerts2.default.show('criticalError', err);
	        });
	    },
	
	    history: function history() {
	        var _this3 = this;
	
	        var attachments = {};
	        var integration = null;
	        var payrollIntegrations = {};
	        var payrolls = void 0;
	
	        this.view = new _PayrollHistory2.default({ el: this.el });
	
	        return app.company.fetchPayrolls().then(function () {
	            return payrolls = app.company.payrolls;
	        }).then(function () {
	            return app.company.fetchIntegration();
	        }).then(function () {
	            return integration = app.company.getIntegration();
	        }).then(function () {
	            var payrollAttachments = payrolls.map(function (p) {
	                var atmts = new _attachments2.default(null, {
	                    attachable: p,
	                    pagination: false
	                });
	
	                return atmts.fetch({ filter: { limit: 10000 } }).then(function () {
	                    return [p.id, atmts];
	                });
	            });
	
	            return (0, _bluebird.all)(payrollAttachments);
	        }).then(function (payrollAttachments) {
	            attachments = _.object(payrollAttachments);
	
	            _this3.view.setCollection({
	                collection: payrolls,
	                attachments: attachments,
	                integration: integration,
	                payrollIntegrations: payrollIntegrations
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        });
	    },
	
	    payrollView: function payrollView(id, tab) {
	        var _this4 = this;
	
	        app.contentView = this.layout = new _PayrollView2.default({ el: this.el });
	
	        return new _payroll2.default({ objectId: id }).fetch().then(function (payroll) {
	            if (!payroll) {
	                throw new Error('Payroll not found');
	            }
	
	            payroll.setCompany(app.company);
	
	            _this4.layout.period = payroll.getPeriodFormatted();
	            _this4.layout.render();
	
	            // make sure payslips include employee data
	            var fetchPayslips = function fetchPayslips() {
	                return payroll.fetchPayslips().then(function (payslips) {
	                    return (0, _bluebird.all)(payslips.map(function (payslip) {
	                        payslip.setPayroll(payroll);
	                        payslip.setCompany(app.company);
	                        return payslip.fetchEmployee();
	                    })).then(function (employees) {
	                        return (0, _bluebird.all)(employees.map(function (employee) {
	                            return employee.fetchPosition();
	                        }));
	                    }).then(function () {
	                        return payslips;
	                    });
	                });
	            };
	
	            // make sure address is included
	            var fetchLocation = function fetchLocation() {
	                return app.company.fetchPrimaryLocation().then(function (location) {
	                    return location.fetchAddress().then(function () {
	                        return location;
	                    });
	                });
	            };
	
	            return (0, _bluebird.all)([fetchPayslips(), fetchLocation()]).then(function (_ref15) {
	                var _ref16 = _slicedToArray(_ref15, 2),
	                    payslips = _ref16[0],
	                    location = _ref16[1];
	
	                _this4.layout.renderContent({
	                    model: payroll,
	                    payslips: payslips,
	                    payslipDetails: new _payslipDetails2.default(null, {}),
	                    payrollSummary: new _payrollSummary2.default(null, {
	                        filter: {
	                            where: { payrollId: id },
	                            limit: 10
	                        },
	                        pagination: { rowsPerPage: 10 },
	                        payroll: payroll
	                    }),
	                    companyLocation: location,
	                    tab: tab
	                });
	            }).catch(function (err) {
	                _alerts2.default.show('criticalError', err);
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseRouter = __webpack_require__(625);
	
	module.exports = BaseRouter.extend({
	    noSetupRequiredRoutes: ['dashboard', 'settings', 'settings/company', 'personalSettings'],
	
	    initialize: function initialize(options) {
	        options = _.defaults(options || {}, {
	            el: null
	        });
	
	        this.el = options.el;
	
	        BaseRouter.prototype.initialize.apply(this, arguments);
	    },
	
	    route: function route(_route, name, callback) {
	        var f;
	
	        if (!callback) {
	            callback = this[name];
	        }
	
	        f = function f() {
	            if (typeof callback === 'function') {
	                callback.apply(this, arguments);
	            }
	        };
	
	        return BaseRouter.prototype.route.apply(this, [_route, name, f]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _payrollDetails = __webpack_require__(599);
	
	var _payrollDetails2 = _interopRequireDefault(_payrollDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = __webpack_require__(714);
	var PayrollView = __webpack_require__(715);
	var StepTwoView = __webpack_require__(742);
	var StepThreeView = __webpack_require__(754);
	
	
	module.exports = Backbone.View.extend({
	    contentView: null,
	    loaderMessages: ['Tabulating some serious data... Don\'t leave us yet!', 'Most companies run payroll around the 25-30th of each month. But you         can run payroll as early as the 16th of each month with our app.', 'Small businesses spend up to ten hours processing payroll a month.         Thank goodness you\'ve got PayrollPanda!', 'If you\'re looking for ways to go green, cut costs, and maintain the         security of your data \u2013 go paperless!<br>Paperless payroll will save         you time too!', 'Facing any issue? The fastest way to reach customer support is via         the live chat at the bottom right corner of the app.', 'Employees have 24/7 access to their payslips and leave management if         they\'re on the app. Get them on board now if you haven\'t already!', 'Did you know that Directors\' Fees are exempt from EPF, SOCSO and EIS?', 'Don\'t forget to enter your employees\' previous payslips information         for accurate PCB calculations!', 'Keep records of travel for 7 years and your employees can claim full         tax exemption for their travel allowance.'],
	
	    events: {
	        'click .js-fullscreen-toggle': 'fullscreenToggle',
	        'changeDate .js-datepicker-periodDate': 'updatePeriodDate'
	    },
	
	    initialize: function initialize(options) {
	        //FIXME NEVER extend this with options!!!!
	        _.extend(this, options);
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            period: this.model ? this.model.getPeriodFormatted() : '',
	            periodDate: this.model ? this.model.getPeriod().format('MM/YYYY') : '',
	            editablePeriodDate: this.step === 1 && app.user.isAdmin()
	        }));
	
	        this.$('.js-datepicker').datepicker({
	            autoclose: true,
	            format: 'mm/yyyy',
	            keyboardNavigation: false,
	            todayBtn: 'linked',
	            todayHighlight: true,
	            minViewMode: 'months',
	            monthsstartView: 'months'
	        });
	
	        this.setStep();
	
	        return this;
	    },
	
	    renderContent: function renderContent(options) {
	        this.render();
	
	        if (this.contentView !== null) {
	            this.contentView.remove();
	            this.contentView = null;
	        }
	
	        options = _.extend(options || {}, {
	            layoutView: this
	        });
	
	        if (this.step == 1) {
	            this.contentView = new PayrollView(options);
	        } else if (this.step == 2) {
	            this.contentView = new StepTwoView(options);
	        } else if (this.step == 3) {
	            this.contentView = new StepThreeView(options);
	        }
	
	        this.$('#content').html('').append(this.contentView.$el);
	        this.$('#loader').hide();
	    },
	
	    updatePeriodDate: function updatePeriodDate(ev) {
	        var _this = this;
	
	        var $datepicker = this.$(ev.currentTarget);
	        var options = void 0;
	        if (this.contentView) {
	            options = this.contentView.options;
	        }
	        var date = (0, _moment2.default)($datepicker.datepicker('getDate')).startOf('month').add(1, 'day').toDate();
	        this.model.set('periodDate', date);
	        if (options) {
	            return (0, _bluebird.all)([app.company.fetchPayableEmployees(null, 10, date), app.company.fetchPayableEmployees(null, null, date), this.model.destroy()]).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    employees = _ref2[0],
	                    allEmployees = _ref2[1];
	
	                _this.model = new _payroll2.default({
	                    companyId: app.company.id,
	                    periodDate: date
	                });
	                options.employees = employees;
	                options.allEmployees = allEmployees;
	                return _payrollDetails2.default.createDefaults(_this.model, options.employees.slice(0, 10));
	            }).then(function (details) {
	                options.payrollDetails = details;
	                options.model = _this.model;
	                _this.showLoader();
	                _this.contentView.remove();
	                _this.contentView = null;
	                _this.contentView = new PayrollView(options);
	                _this.$('#content').html('').append(_this.contentView.$el);
	                _this.hideLoader();
	            });
	        }
	    },
	
	    fullscreenToggle: function fullscreenToggle(e) {
	        if ($('nav.navbar-default').is(':visible') && e) {
	            $('.js-fullscreen-toggle').addClass('btn-success');
	            $('.js-fullscreen-toggle').removeClass('btn-white');
	            $('nav.navbar-default').hide();
	            $('#page-wrapper').css('margin-left', '0px');
	        } else {
	            $('.js-fullscreen-toggle').removeClass('btn-success');
	            $('.js-fullscreen-toggle').addClass('btn-white');
	            $('#page-wrapper').css('margin-left', '');
	            setTimeout(function () {
	                $('nav.navbar-default').show();
	            }, 350);
	        }
	    },
	
	    setStep: function setStep() {
	        var $tabs = this.$('li[role="tab"]');
	        $tabs.removeClass('current');
	        $tabs.slice(0, this.step - 1).addClass('done');
	        $tabs.eq(this.step - 1).addClass('current');
	
	        if (this.step != 2) {
	            $('.js-fullscreen-toggle').hide();
	            this.fullscreenToggle();
	        } else {
	            $('.js-fullscreen-toggle').show();
	        }
	    },
	
	    showLoader: function showLoader(withMessages) {
	        this.$('.js-loader-message').html('');
	
	        this.$('#content').hide();
	        this.$('#loader').show();
	
	        if (withMessages === true) {
	            this.$('.js-loader-message').html(this.loaderMessages[0]);
	
	            this.loaderMessagesTimer = setInterval(function () {
	                this.$('.js-loader-message').html(_.sample(this.loaderMessages));
	            }.bind(this), 5000);
	        }
	    },
	
	    hideLoader: function hideLoader() {
	        if (this.loaderMessagesTimer) {
	            clearTimeout(this.loaderMessagesTimer);
	        }
	
	        this.$('#content').show();
	        this.$('#loader').hide();
	    },
	
	    undelegateEvents: function undelegateEvents() {
	        Backbone.View.prototype.undelegateEvents.apply(this, arguments);
	
	        if (this.contentView) {
	            this.contentView.remove();
	            this.contentView = null;
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/Layout.html -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div id="payrolls-restricted-notification" class="update-restricted-notification">\n        Company has migrated to new PayrollPanda version. Running payrolls is restricted.<br>\n        Learn more by reading this <a href="https://www.payrollpanda.my/help/migrate-to-new-payrollpanda-version/" target="_blank">help article</a>.\n    </div>\n    <div class="col-xs-12">\n        <h2>\n            ';
	 if (editablePeriodDate === true) { 
	__p+='\n                Run Payroll for\n                <div class="datepicker-wrapper">\n                    <div class="input-group date js-datepicker\n                        js-datepicker-periodDate"\n                        data-attribute-name="periodDate"\n                        data-date-format="mm/yyyy">\n                        <span class="input-group-addon">\n                            <span class="glyphicon glyphicon-calendar"></span>\n                        </span>\n                        <input type="text"\n                            class="form-control js-datepicker-input"\n                            name="periodDate"\n                            value="'+
	((__t=( periodDate ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n            ';
	 } else { 
	__p+='\n                Run Payroll for '+
	((__t=( period ))==null?'':_.escape(__t))+
	'\n            ';
	 } 
	__p+='\n            <a class="js-fullscreen-toggle btn btn-sm btn-white pull-right">\n                <i class="fa fa-arrows-alt" aria-hidden="true"></i>\n            </a>\n        </h2>\n\n        <div class="wizard wizard-payroll clearfix">\n            <div class="steps clearfix">\n                <ul role="tablist">\n                    <li role="tab" class="disabled first current"\n                        aria-disabled="false" aria-selected="true">\n                        <a href="">\n                            <span class="number">1.</span>\n                            Adjustments\n                        </a>\n                    </li>\n                    <li role="tab" class="disabled" aria-disabled="true">\n                        <a href="">\n                            <span class="number">2.</span>\n                            Payroll Summary & Payslips\n                        </a>\n                    </li>\n                    <li role="tab" class="disabled last" aria-disabled="true">\n                        <a href="">\n                            <span class="number">3.</span>\n                            Payments & Submission\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<div id="loader" class="loader loader-payroll">\n    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n    <div class="row">\n        <div class="col-md-offset-1 col-md-10">\n            <h2 class="js-loader-message text-center"></h2>\n        </div>\n    </div>\n</div>\n<div id="content" class="wrapper wrapper-content">\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _Payroll = __webpack_require__(716);
	
	var _Payroll2 = _interopRequireDefault(_Payroll);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _EmployeeList = __webpack_require__(717);
	
	var _EmployeeList2 = _interopRequireDefault(_EmployeeList);
	
	var _EmployeeSlides = __webpack_require__(739);
	
	var _EmployeeSlides2 = _interopRequireDefault(_EmployeeSlides);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _payroll = __webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('payroll-step-one');
	
	module.exports = Backbone.View.extend({
	    activeTab: null,
	
	    events: {
	        'click .js-cancel-button': 'cancel',
	        'click .js-save-draft-button': 'saveDraft',
	        'click .js-save-button': 'save',
	        'click .show-warning': 'showMultiplePayrollError',
	        'shown.bs.tab .payroll-toggle-view a[data-toggle="tab"]': 'switchTab'
	    },
	
	    initialize: function initialize(options) {
	        if ((0, _moment2.default)().year() >= 2026 || app.company.get('payrolls2025Restricted') && (0, _moment2.default)().year() >= 2025) {
	            $('#payrolls-restricted-notification').css({ display: 'block' });
	        }
	
	        this.tabViews = [];
	        this.activeTab = null;
	        this.tainted = false;
	        this.options = _.defaults(options || {}, {
	            tab: null,
	            employees: null,
	            allEmployees: null,
	            payrollDetails: null,
	            payroll: null,
	            payrollItems: null,
	            lastPayroll: null,
	            lastPayrollDetails: null,
	            pendingJobs: false
	        });
	
	        this.options.payrollDetails.on('sync', this.renderTitle, this);
	        this.model.on('running', this.showLayoutLoader, this);
	        this.model.on('run-complete', this.runComplete, this);
	
	        app.events.on('navigate', this.handleUnsavedChanges, this);
	        app.events.on('hard-exit', this.hardExit, this);
	
	        this.options.payrollDetails.on('change add remove', this.taint, this);
	
	        this.render();
	    },
	
	    // FIXME this methods are almost exact copies of the ones found in
	    // commons/Form because I needed to change as little as possible as this
	    // is a hotfix. We need to merge these methods into a separate class or
	    // mixin.
	    handleUnsavedChanges: function handleUnsavedChanges(status) {
	        log.info('Caught navigate event...');
	        if (this.dirty()) {
	            log.info('...and we have unsaved changes');
	
	            status.unsaved = true;
	            status.msg = 'You have unsaved changes. Exiting this page will                 result in the changes being discarded.';
	        } else {
	            status.unsaved = false;
	        }
	    },
	
	    dirty: function dirty() {
	        return this.options.payrollDetails.isNew() ? this.tainted : this.options.payrollDetails.dirty();
	    },
	
	    taint: function taint() {
	        this.tainted = true;
	    },
	
	    hardExit: function hardExit() {
	        app.events.off(null, null, this);
	    },
	
	    render: function render() {
	        this.$el.html((0, _Payroll2.default)({
	            tab: _localStorageUtil2.default.getItem('payrollStepOneTab'),
	            disableTabSwitch: this.options.allEmployees.length === 0,
	            showButtons: this.options.allEmployees.length > 0 && !this.model.get('running') && !this.options.pendingJobs,
	            isRunPayrollDisabled: this.isRunPayrollDisabled()
	        }));
	
	        if (this.options.allEmployees.length > 0) {
	            this.tabViews.push(new _EmployeeSlides2.default({
	                el: this.$('.js-payroll-slide-view'),
	                employees: this.options.allEmployees,
	                payroll: this.model,
	                payrollDetails: this.options.payrollDetails,
	                lastPayroll: this.options.lastPayroll,
	                lastPayrollDetails: this.options.lastPayrollDetails,
	                pendingJobs: this.options.pendingJobs,
	                payrollItems: this.options.payrollItems
	            }));
	        }
	
	        this.tabViews.push(new _EmployeeList2.default({
	            el: this.$('.js-payroll-list-view'),
	            employees: this.options.employees,
	            lastPayroll: this.options.lastPayroll,
	            payroll: this.model,
	            pendingJobs: this.options.pendingJobs,
	            payrollDetails: this.options.payrollDetails,
	            payrollItems: this.options.payrollItems,
	            lastPayrollDetails: this.options.lastPayrollDetails,
	            layoutView: this.options.layoutView
	        }));
	
	        _tooltip2.default.init(this);
	        this.renderTitle();
	
	        setTimeout(function () {
	            this.activeTab = _.find(this.tabViews, function (view) {
	                return view.$el.hasClass('active');
	            });
	
	            this.activeTab.activate();
	        }.bind(this), 1);
	
	        this.renderPendingJobMsg(this.options.pendingJobs || this.model.get('running'));
	    },
	
	    renderPendingJobMsg: function renderPendingJobMsg(hasPendingJobs) {
	        this.$('.js-payroll-in-progress').toggleClass('hidden', !hasPendingJobs);
	    },
	
	    showLayoutLoader: function showLayoutLoader() {
	        this.options.layoutView.showLoader(true);
	    },
	
	    runComplete: function runComplete() {
	        this.options.layoutView.hideLoader();
	        app.mainRouter.navigate('payroll/step/2', { trigger: true });
	    },
	
	    switchTab: function switchTab(ev) {
	        var $tabButton = $(ev.currentTarget);
	
	        this.activeTab = _.find(this.tabViews, function (view) {
	            return view.$el.hasClass('active');
	        });
	
	        this.$('a[data-toggle="tab"].btn-success').toggleClass('btn-success').toggleClass('btn-white');
	        $tabButton.toggleClass('btn-success').toggleClass('btn-white');
	
	        this.activeTab.activate();
	
	        _localStorageUtil2.default.setItem('payrollStepOneTab', this.activeTab.$el.data('tab-name'));
	    },
	
	    renderTitle: function renderTitle() {
	        var count = this.options.allEmployees.length;
	        var text = 'Running Payroll for ' + count + ' ' + (count === 1 ? 'Employee' : 'Employees');
	        this.$('.js-payroll-title').text(text);
	    },
	
	    cancel: function cancel() {
	        var _this = this;
	
	        var self = this;
	        var cancelled = function cancelled() {
	            self.options.payrollDetails.reset([]);
	
	            _alerts2.default.show('success', {
	                title: 'Payroll Reset!',
	                text: 'Your Payroll has been reset.'
	            });
	            app.mainRouter.navigate('payroll', { trigger: true });
	        };
	
	        _alerts2.default.show('dangerConfirm', {
	            text: 'You will not be able to recover this payroll',
	            confirmButtonText: 'Yes, Restart',
	            loader: true,
	            callback: function callback(confirmed) {
	                if (!confirmed) {
	                    return;
	                }
	                return (_this.model.isNew() ? (0, _bluebird.resolve)() : _this.model.destroy()).then(function () {
	                    return cancelled();
	                }).catch(function (err) {
	                    _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    saveDraft: function saveDraft(ev) {
	        var _this2 = this;
	
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        (this.model.isNew() ? this.model.save() : this.model.fetch()).then(function () {
	            if (_this2.model.get('running') || _this2.options.pendingJobs || _this2.model.get('status') !== _payroll.payrollStatus.INITIAL) {
	                if (_this2.model.get('running') || _this2.model.get('status') === _payroll.payrollStatus.RAN) {
	                    _alerts2.default.show('warning', {
	                        title: 'Warning',
	                        text: 'Note :This payroll is already at step 2. Please go to                                 Payroll History and click on Continue Payroll.',
	                        allowEscapeKey: false,
	                        callback: function callback() {
	                            app.mainRouter.navigate('payroll/history', { trigger: true });
	                        }
	                    });
	                }
	                _alerts2.default.show('warning', {
	                    title: 'Warning',
	                    text: 'Please note that your payroll has been                             modified. To view accurate calculations,                             please reload the page.',
	                    allowEscapeKey: false,
	                    callback: function callback() {
	                        return window.location.reload();
	                    }
	                });
	                return;
	            }
	
	            return _this2.model.fetchAllPayrollDetails().then(function (res) {
	                if (res) {
	                    if (_this2.checkDuplicate(res)) {
	                        _alerts2.default.show('warning', {
	                            title: 'Error',
	                            text: 'Adding same payroll item twice is not allowed.\n                                       Reload page to see updates.',
	                            allowEscapeKey: false
	                        });
	                    } else {
	                        _this2.options.payrollDetails.setPayroll(_this2.model);
	                        return _this2.options.payrollDetails.save();
	                    }
	                }
	            });
	        }).then(function () {
	            return _this2.activeTab.save ? _this2.activeTab.save() : (0, _bluebird.resolve)();
	        }).then(function () {
	            return Backbone.history.loadUrl();
	        }).catch(function (err) {
	            stopLoader();
	            _alerts2.default.show('error', err, {
	                callback: function callback() {
	                    app.mainRouter.navigate('payroll/history', { trigger: true });
	                }
	            });
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    checkDuplicate: function checkDuplicate(savedPayrollItems) {
	        var payrollDetails = this.options.payrollDetails;
	        var duplicatePayrollDetails = payrollDetails.filter(function (x) {
	            return savedPayrollItems.some(function (y) {
	                return x.getPayrollItem().id === y.getPayrollItem().id && x.isNew() && y.get("employeeId") === x.get("employeeId") && x.get('affectsItemId') === y.get('affectsItemId');
	            });
	        });
	        return duplicatePayrollDetails.length > 0;
	    },
	
	    displayBillingNotice: function displayBillingNotice() {
	        app.company.set('billingNoticeGiven', true);
	        return app.company.save();
	    },
	
	    displayPreviousPayslipDataWarning: function displayPreviousPayslipDataWarning(employees) {
	        if (employees.length === 0) {
	            return (0, _bluebird.resolve)();
	        }
	
	        // 20200819 for the employees to show up in the warning dialog,
	        // the employee must 1. has no payslips 2. has 0 amount in YTD
	        // amount/prev employment
	        return (0, _bluebird.all)(employees.map(function (employee) {
	            return employee.getHasPrevItemYearlyTotals((0, _moment2.default)().year());
	        })).then(function () {
	            var employeesToShow = employees.filter(function (emp) {
	                return !emp.hasPrevItemYearlyTotals;
	            });
	
	            if (employeesToShow.length === 0) {
	                return (0, _bluebird.resolve)();
	            }
	
	            // jscs:disable
	            var names = employeesToShow.map(function (employee) {
	                return employee.get('fullName');
	            }).sort().join(', ').replace(/(, )(?=[^,]*$)/, ' and ');
	
	            return new _bluebird2.default(function (resolve, reject) {
	                _alerts2.default.show('warningConfirm', {
	                    title: 'Important note!',
	                    text: '<p>You might be missing previous payslip data                         for the following employees that have joined your                         company this year:<br>' + names + '.</p><p>Not entering                         this data will affect their monthly PCB calculations                         and EA forms.</p>',
	                    showCloseButton: true,
	                    cancelButtonText: 'No, Continue',
	                    confirmButtonText: 'Yes, Edit Now'
	                }).then(function () {
	                    app.mainRouter.navigate('employee/' + _(employees).first().id + '/previousPayslips', { trigger: true });
	                    reject();
	                }, function () {
	                    return resolve();
	                });
	            });
	        });
	    },
	
	    save: function save(ev) {
	        var _this3 = this;
	
	        ev.preventDefault();
	
	        if (this.model.get('running') || this.options.pendingJobs) {
	            return;
	        }
	
	        var stopLoader = function stopLoader() {};
	        var $button = this.$(ev.currentTarget);
	        $button.prop('disabled', true);
	        return this.checkMultiplePayrollRun().then(function () {
	            return _this3.checkFirstTimeEmployees();
	        }).then(function () {
	            return _this3.checkBillingNotice();
	        }).then(function () {
	            return _this3.activeTab.confirmMissingEmployees();
	        }).then(function (includeAll) {
	            stopLoader = _loader2.default.startFullScreen($button);
	            return (_this3.model.isNew() ? _this3.model.save() : _this3.model.fetch()).then(function () {
	                if (_this3.model.get('running') || _this3.model.get('status') !== _payroll.payrollStatus.INITIAL) {
	                    throw new Error('Note :This payroll is already at step 2. Please go to Payroll History and click on Continue Payroll.');
	                }
	                _this3.options.payrollDetails.setPayroll(_this3.model);
	                return _this3.options.payrollDetails.save();
	            }).then(function () {
	                return _this3.activeTab.save ? _this3.activeTab.save() : (0, _bluebird.resolve)();
	            }).then(function () {
	                return _this3.model.run(includeAll);
	            }).catch(function (err) {
	                if (/duplicated payroll run detected/.test(err.message)) {
	                    _alerts2.default.show('criticalError', 'You can only run 1 payroll for the same month.');
	                } else if (/Payroll Item already exist for payroll/.test(err.message)) {
	                    _alerts2.default.show('warning', {
	                        text: err.message,
	                        customClass: 'sweet-alert-error'
	                    });
	                } else if (/This payroll is already at step 2/.test(err.message)) {
	                    _alerts2.default.show('warning', err.message, {
	                        callback: function callback() {
	                            app.mainRouter.navigate('payroll/history', { trigger: true });
	                        }
	                    });
	                } else if (err.messages && err.messages.length && /Company has migrated to new PayrollPanda version/.test(err.messages[0])) {
	                    _alerts2.default.show('criticalError', err.messages[0]);
	                } else {
	                    _alerts2.default.show('warning', {
	                        title: 'Warning',
	                        text: 'Please note that your payroll has been                                     modified. To view accurate calculations,                                     please reload the page.',
	                        allowEscapeKey: false,
	                        callback: function callback() {
	                            return window.location.reload();
	                        }
	                    });
	                }
	            });
	        }).finally(function () {
	            stopLoader();
	            $button.prop('disabled', false);
	        });
	    },
	
	    isRunPayrollDisabled: function isRunPayrollDisabled() {
	        return this.options.lastPayroll && ((0, _moment2.default)(this.options.lastPayroll.get('submittedDate')).tz('Asia/Kuala_Lumpur').isSame(Date.now(), 'day') || this.options.lastPayroll.isCurrentPeriod()) && !app.user.isAdmin();
	    },
	    checkMultiplePayrollRun: function checkMultiplePayrollRun() {
	        var _this4 = this;
	
	        if (app.user.isAdmin()) {
	            return (0, _bluebird.resolve)();
	        }
	
	        if (this.isRunPayrollDisabled()) {
	            this.showMultiplePayrollError();
	            return (0, _bluebird.reject)();
	        }
	
	        return app.company.fetchCurrentPayroll().then(function (unsubmittedPayroll) {
	            if (unsubmittedPayroll && (_this4.model.isNew() || unsubmittedPayroll.get('objectId') !== _this4.model.get('objectId'))) {
	                _this4.showMultiplePayrollError();
	                return (0, _bluebird.reject)();
	            }
	            return (0, _bluebird.resolve)();
	        });
	    },
	    checkFirstTimeEmployees: function checkFirstTimeEmployees() {
	        var firstTimeEmployees = this.options.allEmployees.filter(function (employee) {
	            return !employee.get('hasPayslips');
	        });
	
	        if (firstTimeEmployees.length) {
	            return this.displayPreviousPayslipDataWarning(firstTimeEmployees);
	        }
	
	        return (0, _bluebird.resolve)(true);
	    },
	    checkBillingNotice: function checkBillingNotice() {
	        var displayBillingNotice = app.company.get('isBillable') && !app.company.get('billingNoticeGiven') && !app.company.get('mppAdminId') && !app.subscription.get('skipInvoicing');
	
	        if (displayBillingNotice) {
	            return this.displayBillingNotice();
	        }
	
	        return (0, _bluebird.resolve)(true);
	    },
	
	
	    remove: function remove() {
	        this.options.payrollDetails.on(null, null, this);
	        this.model.off(null, null, this);
	
	        this.undelegateEvents();
	        _.each(this.tabViews, function (view, i) {
	            view.remove();
	            delete this.tabViews[i];
	        }.bind(this));
	        this.tabViews = [];
	    },
	
	    showMultiplePayrollError: function showMultiplePayrollError() {
	        var text = this.options.lastPayroll.isCurrentPeriod() ? '<p>You have already completed a payroll for the current             month. You cannot run a new one until the 16th of the month.             </p><p>If you would like to delete your last submitted             payroll, and run it again, please email us at             <a href="mailto:admin@payrollpanda.my" target="_blank">            admin@payrollpanda.my</a>.</p><p>Alternatively, use the chat             window at the bottom right corner of the app and we will             assist you.</p>' : '<p>Please note that you already completed a payroll today and            cannot move to step 2 until tomorrow. For assistance, please            contact us via the live chat window.';
	        return _modal2.default.warning({
	            title: 'Cannot run payroll yet!',
	            html: text,
	            confirmButtonText: 'View Payroll Status',
	            customClass: 'sweet-alert-success',
	            callback: function callback(isConfirm) {
	                if (isConfirm) {
	                    app.mainRouter.navigate('payroll/history', { trigger: true });
	                }
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14), __webpack_require__(27)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepOne/Payroll.html -->\n';
	 idSuffix = Math.floor(Math.random() * 10000000) 
	__p+='\n<div class="row wrapper payroll-in-progress js-payroll-in-progress\n    hidden animated fadeInDown">\n    <div class="col-xs-12">\n        <img src="/images/processed.png" class="pull-left">\n        <h2>\n            Hang in there! We\'re still working on this payroll. You can review the details but you won\'t be able to edit until this payroll is complete.\n        </h2>\n    </div>\n</div>\n\n<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5 class="js-payroll-title"></h5>\n                ';
	 if (!disableTabSwitch) { 
	__p+='\n                    <div class="payroll-toggle-view btn-group pull-right">\n                        <a data-tab="list" data-toggle="tab"\n                            href="#list-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                            class="btn btn-sm btn-list\n                                '+
	((__t=( (!tab || (tab === 'list')) ?
	                                    'btn-success' : 'btn-white' ))==null?'':_.escape(__t))+
	'">\n                            <i class="fa fa-list"></i>\n                        </a>\n                        <a data-tab="slide" data-toggle="tab"\n                            href="#slides-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                            class="btn btn-sm btn-slide\n                                '+
	((__t=( (tab && tab === 'slide') ?
	                                    'btn-success' : 'btn-white' ))==null?'':_.escape(__t))+
	'">\n                            <i class="fa fa-ellipsis-h"></i>\n                        </a>\n                    </div>\n                ';
	 } 
	__p+='\n            </div>\n\n            <div class="tab-content">\n                <div id="list-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                    class="ibox-content js-payroll-list-view payroll-list-view\n                        tab-pane\n                        '+
	((__t=( (!tab || (tab === 'list')) ? 'active' : '' ))==null?'':_.escape(__t))+
	'"\n                    data-tab-name="list">\n                </div>\n                <div id="slides-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                    class="ibox-content js-payroll-slide-view\n                        payroll-slide-view tab-pane\n                        '+
	((__t=( (tab && tab === 'slide') ? 'active' : '' ))==null?'':_.escape(__t))+
	'"\n                    data-tab-name="slide">\n                </div>\n            </div>\n\n            ';
	 if (showButtons) { 
	__p+='\n                <div class="wizard-footer text-right">\n                    <button type="button"\n                        class="btn btn-w-m btn-warning\n                            js-cancel-button"\n                        data-toggle="tooltip"\n                        data-title="No changes will be saved and current\n                            payroll cannot be recovered"\n                        data-placement="top" data-delayed>\n\n                        <i class="fa fa-exclamation-triangle"></i>\n\n                        Cancel &amp; Restart\n                    </button>\n                    <button type="button"\n                        class="btn btn-w-m btn-success ladda-button js-save-draft-button"\n                        data-style="swap"\n                        data-toggle="tooltip"\n                        data-title="Save current data but run payroll at a\n                            later time"\n                        data-placement="top" data-delayed>\n\n                        <i class="fa fa-clipboard"></i>\n\n                        Save for later\n                    </button>\n\n                    <button  type="button"\n                        class="btn btn-w-m btn-primary ladda-button js-save-button"\n                        data-style="swap"\n                    >\n                        <i class="fa fa-check"></i>\n                        Save &amp; Go To Step 2\n                    </button>\n                    ';
	 if (isRunPayrollDisabled) { 
	__p+='\n                        <i class="fa fa-question-circle" data-toggle="tooltip"\n                            data-placement="top" data-container="body"\n                            data-html="true"\n                            data-original-title="Please note you cannot proceed \n                                to step 2 if you already submitted another payroll today. \n                                You can proceed tomorrow or contact customer support via \n                                the live chat to move your payroll to step 2.">\n                        </i>\n                    ';
	 } 
	__p+='\n                </div>\n            ';
	 } 
	__p+='\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _EmployeeList = __webpack_require__(718);
	
	var _EmployeeList2 = _interopRequireDefault(_EmployeeList);
	
	var _Employee = __webpack_require__(719);
	
	var _Employee2 = _interopRequireDefault(_Employee);
	
	var _payrollDetails = __webpack_require__(599);
	
	var _payrollDetails2 = _interopRequireDefault(_payrollDetails);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginatedList2.default.extend({
	
	    events: function events() {
	        var myEvents = {
	            'click .js-payroll-toggle': 'payrollToggle'
	        };
	        return Object.assign(myEvents, _PaginatedList2.default.prototype.events.apply(this));
	    },
	
	    initialize: function initialize(options) {
	        this.detailViews = [];
	
	        this.options = _.defaults(options || {}, {
	            employees: null,
	            payroll: null,
	            payrollDetails: null,
	            lastPayrollDetails: null,
	            lastPayroll: null,
	            payrollItems: null,
	            layoutView: null
	        });
	
	        this.collection = this.options.employees;
	        this.collection.on('sync', this.render, this);
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var pagination = this.collection.pagination;
	        this.$el.html((0, _EmployeeList2.default)({ pagination: pagination }));
	
	        this.$('.js-empty-list').toggleClass('hidden', this.collection.length > 0);
	
	        this.options.layoutView.showLoader();
	        return this.fetchDetails(this.collection).then(function () {
	            return (0, _bluebird.each)(_this.collection.models, function (employee) {
	                var detailView = new _Employee2.default({
	                    model: employee,
	                    payroll: _this.options.payroll,
	                    payrollDetails: _this.options.payrollDetails,
	                    payrollItems: _this.options.payrollItems,
	                    lastPayrollDetails: _this.options.lastPayrollDetails,
	                    className: 'employee footable-employee ' + 'toggle-arrow-tiny'
	                });
	
	                _this.detailViews.push(detailView);
	                _this.$('.js-payroll-details').append(detailView.el);
	            });
	        }).finally(function () {
	            _this.show();
	            _this.options.layoutView.hideLoader();
	        });
	    },
	
	    payrollToggle: function payrollToggle(e) {
	        e.preventDefault();
	
	        if (this.collapsed) {
	            this.$('.footable').trigger('footable_expand_all');
	            this.collapsed = false;
	        } else {
	            this.$('.footable').trigger('footable_collapse_all');
	            this.collapsed = true;
	        }
	    },
	
	    show: function show() {
	        _.each(this.detailViews, function (view) {
	            view.$el.trigger('show');
	        });
	    },
	
	    activate: function activate() {
	        if (this.detailViews.length !== 0) {
	            return;
	        }
	        this.render();
	    },
	
	    remove: function remove() {
	        Backbone.View.prototype.remove.apply(this, arguments);
	
	        this.undelegateEvents();
	        _.each(this.detailViews, function (view, i) {
	            view.remove();
	            delete this.detailViews[i];
	        }.bind(this));
	    },
	
	    confirmMissingEmployees: function confirmMissingEmployees() {
	        // By default include all employees to the payroll
	        return (0, _bluebird.resolve)(true);
	    },
	
	    fetchDetails: function fetchDetails(employees) {
	        var _this2 = this;
	
	        var payroll = this.options.payroll;
	        var lastPayroll = this.options.lastPayroll;
	        var detailsPromise = void 0;
	        var lastDetailsPromise = void 0;
	
	        if (!employees.length) {
	            return;
	        }
	
	        var fetchDetailsForPayroll = function fetchDetailsForPayroll(payroll, employees) {
	            return new _payrollDetails2.default(null, { payroll: payroll }).fetch({
	                filter: {
	                    limit: 9999,
	                    where: {
	                        employeeId: {
	                            inq: employees.map(function (employee) {
	                                return employee.get('objectId');
	                            })
	                        }
	                    }
	                }
	            }).then(function (collection) {
	                return collection.filterNonContributions();
	            });
	        };
	
	        var employeesWithoutDetails = employees.filter(function (employee) {
	            return _this2.options.payrollDetails.filterByEmployee(employee.id).length === 0;
	        });
	        var employeesWithoutLastDetails = employees.filter(function (employee) {
	            return _this2.options.lastPayrollDetails.filterByEmployee(employee.id).length === 0;
	        });
	
	        if (employeesWithoutDetails.length === 0) {
	            detailsPromise = (0, _bluebird.resolve)([]);
	        } else {
	            if (payroll.isNew()) {
	                detailsPromise = _payrollDetails2.default.createDefaults(payroll, employeesWithoutDetails);
	            } else {
	                detailsPromise = fetchDetailsForPayroll(payroll, employees).then(function (collection) {
	                    collection.models.forEach(function (detail) {
	                        _this2.options.payrollDetails.add(detail);
	                    });
	                    var employeesWithDetails = collection.map(function (details) {
	                        return details.get('employeeId');
	                    });
	
	                    employeesWithoutDetails = employees.filter(function (emp) {
	                        return !employeesWithDetails.includes(emp.id);
	                    });
	
	                    if (employeesWithoutDetails.length === 0) {
	                        return (0, _bluebird.resolve)([]);
	                    } else {
	                        return _payrollDetails2.default.createDefaults(payroll, employeesWithoutDetails);
	                    }
	                });
	            }
	        }
	
	        if (employeesWithoutLastDetails.length === 0 || !lastPayroll) {
	            lastDetailsPromise = (0, _bluebird.resolve)([]);
	        } else {
	            lastDetailsPromise = fetchDetailsForPayroll(lastPayroll, employeesWithoutLastDetails);
	        }
	
	        return (0, _bluebird.all)([detailsPromise.then(function (collection) {
	            if (collection.length > 0) {
	                collection.models.forEach(function (detail) {
	                    _this2.options.payrollDetails.add(detail);
	                });
	            }
	        }), lastDetailsPromise.then(function (collection) {
	            if (collection.length > 0) {
	                collection.models.forEach(function (detail) {
	                    if (detail.get('amount') > 0) {
	                        _this2.options.lastPayrollDetails.add(detail);
	                    }
	                });
	            }
	        })]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(523)))

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepOne/EmployeeList.html -->\n<table class="footable footable-payroll table table-striped toggle-arrow-tiny"\n    data-striping="false">\n    <thead>\n        <tr>\n            <th data-toggle="true" class="footable-sortable js-payroll-toggle">\n                Employee <span class="footable-sort-indicator"></span>\n            </th>\n            <th class="amount">RM</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr><td colspan="3" class="js-payroll-details"></td></tr>\n    </tbody>\n    <tbody class="js-empty-list empty-list hidden">\n        <tr>\n            <td colspan="3" style="border-top: none;">\n                <h2 class="text-center col-sm-12 col-lg-6 col-lg-offset-3 m-t-lg">\n                    None of your employees can be included in the payroll for\n                    the current month because of their join date.\n                </h3>\n            </td>\n        </tr>\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan="3">\n                '+
	((__t=( __webpack_require__(669)({ pagination: pagination, items: 'employees' }) ))==null?'':__t)+
	'\n            </td>\n        </tr>\n    </tfoot>\n</table>\n';
	}
	return __p;
	};


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _PayrollDetail = __webpack_require__(720);
	
	var _PayrollDetail2 = _interopRequireDefault(_PayrollDetail);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _PayrollItemSelectionModal = __webpack_require__(722);
	
	var _PayrollItemSelectionModal2 = _interopRequireDefault(_PayrollItemSelectionModal);
	
	var _Employee = __webpack_require__(738);
	
	var _Employee2 = _interopRequireDefault(_Employee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'table',
	    availablePayrollItems: null,
	    payrollItemsModal: null,
	    detailViews: null,
	
	    events: function events() {
	        return {
	            'click .js-add-item-button': 'showSelectModal',
	            'click .js-use-last-payroll-button': 'reuseLastPayroll',
	            'show': 'onShow'
	        };
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            payroll: null,
	            pendingJobs: false,
	            payrollDetails: null,
	            payrollItems: null,
	            lastPayroll: null,
	            lastPayrollDetails: null
	        });
	
	        this.detailViews = [];
	
	        this.availablePayrollItems = this.options.payrollItems.clone();
	        this.updateItemAvailability();
	
	        this.payrollItemsModal = new _PayrollItemSelectionModal2.default({
	            collection: this.availablePayrollItems
	        });
	
	        this.bindHandlers();
	
	        this.render();
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.payrollItemsModal.on('select', this.addItems, this);
	
	        this.options.payrollDetails.on('add', this.renderDetail, this);
	        this.options.payrollDetails.on('reset', this.renderDetails, this);
	        this.options.payrollDetails.on('destroy remove', this.hideEmpty, this);
	        this.options.payrollDetails.on('add remove reset change:amount', this.renderNetAmount, this);
	        this.options.payrollDetails.on('add remove reset', this.updateItemAvailability, this);
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        this.payrollItemsModal.off(null, null, this);
	        this.options.payrollDetails.off(null, null, this);
	    },
	
	    render: function render() {
	        this.$el.addClass('invisible').html((0, _Employee2.default)({
	            model: this.model,
	            payroll: this.options.payroll,
	            payrollDetails: this.options.payrollDetails,
	            lastPayrollDetails: this.options.lastPayrollDetails ? this.options.lastPayrollDetails.filterByEmployee(this.model.id, { collection: true }) : null,
	            isCard: this.$el.hasClass('js-is-card'),
	            showButtons: !this.options.payroll.get('running') && !this.options.pendingJobs
	        }));
	
	        this.renderDetails();
	
	        this.renderNetAmount();
	
	        _tooltip2.default.init(this);
	    },
	
	    onShow: function onShow() {
	        setTimeout(function () {
	            this.$el.footable({
	                sort: false,
	                addRowToggle: !this.$el.hasClass('js-is-card')
	            }).trigger('footable_expand_all').removeClass('invisible');
	
	            this.$('.footable-last-payroll-details').footable({
	                sort: false,
	                addRowToggle: true
	            }).removeClass('invisible');
	
	            this.$el.trigger('footable_expand_all');
	        }.bind(this), 1);
	    },
	
	    renderDetail: function renderDetail(model) {
	        if (model.get('employeeId') !== this.model.id) {
	            return;
	        }
	
	        var view = new _PayrollDetail2.default({ model: model });
	        var $el = model.isAddition() ? this.$('.js-payroll-details-additions') : model.isDeduction() ? this.$('.js-payroll-details-deductions') : model.isOther() ? this.$('.js-payroll-details-others') : null;
	
	        if ($el) {
	            this.detailViews.push(view);
	            $el.append(view.$el).removeClass('hidden');
	        }
	    },
	
	    renderDetails: function renderDetails() {
	        _.each(this.detailViews, function (view, i) {
	            view.remove();
	            delete this.detailViews[i];
	        }.bind(this));
	        this.detailViews = [];
	
	        this.options.payrollDetails.filterByEmployee(this.model.id, {
	            collection: true
	        }).forEach(this.renderDetail.bind(this));
	    },
	
	    renderNetAmount: function renderNetAmount(model) {
	        if (model && _.isObject(model.attributes) && model.get('employeeId') !== this.model.id) {
	            return true;
	        }
	
	        this.$('.js-net-amount').val((this.options.payrollDetails.getNetAmount(this.model.id) || 0).formatWithoutRounding());
	    },
	
	    addItems: function addItems(payrollItems, additionalInfo) {
	        var _this = this;
	
	        if (this.options.payroll.get('running') || this.options.pendingJobs) {
	            return;
	        }
	
	        return (0, _bluebird.all)(payrollItems.map(function (payrollItem) {
	            var info = _.isObject(additionalInfo) ? additionalInfo[payrollItem.id] || null : null;
	
	            _this.options.payrollDetails.add({
	                employeeId: _this.model.id,
	                payrollId: _this.options.payroll.id,
	                payrollItemId: payrollItem.id,
	                isAdditional: true,
	                rate: payrollItem.get('isUnit') ? 1 : null,
	                unit: payrollItem.get('isUnit') ? 1 : null,
	                additionalInformation: info
	            }, { validate: false });
	
	            return _this.options.payrollDetails.createOvertimeInfoAfterAdd(_this.model);
	        }));
	    },
	
	    hideEmpty: function hideEmpty() {
	        this.$('.js-payroll-details-additions').toggleClass('hidden', !this.$('.js-payroll-details-additions tr:not(.title)').length);
	        this.$('.js-payroll-details-deductions').toggleClass('hidden', !this.$('.js-payroll-details-deductions tr:not(.title)').length);
	    },
	
	    reuseLastPayroll: function reuseLastPayroll(ev) {
	        var _this2 = this;
	
	        ev.preventDefault();
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        var lastDetails = this.options.lastPayrollDetails.filterByEmployee(this.model.id, { collection: true });
	
	        if (this.options.payroll.get('running') || this.options.pendingJobs) {
	            stopLoader();
	            return;
	        }
	
	        if (lastDetails.length > 0) {
	            this.options.payrollDetails.replace(lastDetails.reassignToPayroll(this.options.payroll.id), this.model.id).then(function () {
	                return _this2.options.payrollDetails.createOvertimeInfoAfterAdd(_this2.model);
	            }).finally(stopLoader);
	        } else {
	            stopLoader();
	            _alerts2.default.show('warning', {
	                title: '',
	                text: 'There is no previous payroll for this employee'
	            });
	        }
	    },
	
	    showSelectModal: function showSelectModal(ev) {
	        ev.preventDefault();
	
	        if (this.options.payroll.get('running') || this.options.pendingJobs) {
	            return;
	        }
	
	        this.payrollItemsModal.show();
	    },
	
	    updateItemAvailability: function updateItemAvailability() {
	        var employeeDetails = this.options.payrollDetails.filterByEmployee(this.model.id);
	
	        this.availablePayrollItems.reset(this.options.payrollItems.clone().filter(function (model) {
	            return employeeDetails.every(function (detail) {
	                var payrollItem = detail.getPayrollItem();
	                return payrollItem && payrollItem.id !== model.id || !_.isEmpty(detail.get('affectsItemId'));
	            });
	        }));
	    },
	
	    remove: function remove() {
	        Backbone.View.prototype.remove.apply(this, arguments);
	
	        this.unbindHandlers();
	        this.undelegateEvents();
	        this.payrollItemsModal.remove();
	
	        _.each(this.detailViews, function (view) {
	            view.remove();
	            view = null;
	        });
	    },
	
	    lock: function lock() {
	        this.unbindHandlers();
	        this.undelegateEvents();
	    },
	
	    unlock: function unlock() {
	        // make sure it's locked first, to avoid duplicate handlers
	        this.lock();
	
	        this.bindHandlers();
	        this.delegateEvents();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var Alerts = __webpack_require__(529);
	var template = __webpack_require__(721);
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    className: 'tr-md payroll-detail',
	
	    events: {
	        'change input': 'updateModel',
	        'focus input': 'onFocus',
	        'click .js-remove-button': 'destroyModel'
	    },
	
	    initialize: function initialize() {
	        this.$el.toggleClass('is-default', !this.model.isAdditional());
	        this.$el.toggleClass('is-locked', this.model.isLocked());
	        this.model.on('change', this.render, this);
	        this.model.on('destroy remove', this.remove, this);
	
	        this.render();
	
	        return this;
	    },
	
	    render: function render() {
	        this.$el.html(template({ model: this.model }));
	
	        return this;
	    },
	
	    onFocus: function onFocus(ev) {
	        this.$(ev.currentTarget).select();
	    },
	
	    updateModel: function updateModel(ev) {
	        ev.preventDefault();
	
	        var $el = this.$(ev.currentTarget);
	        var attr = $el.attr('name');
	        var val = $el.val() || 0;
	
	        if (['unit', 'rate', 'amount'].indexOf(attr) >= 0) {
	            val = parseFloat(val);
	        }
	
	        this.model.set(attr, val);
	        this.model.set('isManuallyAdjusted', true);
	    },
	
	    destroyModel: function destroyModel(ev) {
	        ev.preventDefault();
	
	        if (!this.model.get('isAdditional')) {
	            Alerts.show('error', {
	                text: 'This item is part of the employee\'s employment ' + 'contract, it can\'t be deleted'
	            });
	
	            return;
	        }
	
	        this.model.destroy();
	    },
	
	    remove: function remove() {
	        Backbone.View.prototype.remove.apply(this, arguments);
	
	        this.model.off(null, null, this);
	        this.undelegateEvents();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepOne/PayrollDetail.html -->\n<td class="title">\n    <strong>\n        '+
	((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n        <small>\n            ';
	 if (
	                model.getPayrollItemType() !== 'unpaid_leave' &&
	                model.getPayrollItemType() !== 'overtime' &&
	                model.get('additionalInformation')
	            ) { 
	__p+='\n                ';
	 info = model.get('additionalInformation'); 
	__p+='\n                (\n                    ';
	 last = _.last(_.keys(info)); 
	__p+='\n                    ';
	 _.each(_.keys(info), function(attr, i) { 
	__p+='\n                        '+
	((__t=( info[attr] + (attr !== last ? ', ' : '') ))==null?'':_.escape(__t))+
	'\n                    ';
	 }); 
	__p+='\n                )\n            ';
	 } 
	__p+='\n\n            ';
	 if (
	                model.isOvertime() &&
	                model.get('additionalInformation')
	            ) { 
	__p+='\n                ';
	 info = model.get('additionalInformation'); 
	__p+='\n                (\n                    Hourly wage: '+
	((__t=( info.hourlyWage ))==null?'':_.escape(__t))+
	',\n                    Rate: '+
	((__t=( info.overtimeFactor ))==null?'':_.escape(__t))+
	'x\n                )\n            ';
	 } 
	__p+='\n        </small>\n    </strong>\n    ';
	 if (model.isAdditional()) { 
	__p+='\n        <a href="" class="js-remove-button" tabindex="-1">\n            <i class="fa fa-times"></i>\n        </a>\n    ';
	 } 
	__p+='\n</td>\n\n';
	 if (model.isUnit()) { 
	__p+='\n    <td>\n        <span>RM:</span>\n        <input name="rate" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
	((__t=( (model.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n            ';
	 if (model.isOvertime()) { 
	__p+='\n                readonly\n            ';
	 } 
	__p+='\n            ';
	 if (model.isLocked()) { 
	__p+='\n                readonly data-toggle="tooltip" data-placement="left"\n                title="To change this value you need to edit the employee\'s\n                    employment details"\n            ';
	 } 
	__p+='\n            >\n    </td>\n    <td>\n        <span>'+
	((__t=( model.isOvertime() ? 'Hours' : 'Units' ))==null?'':_.escape(__t))+
	':</span>\n        <input name="unit" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
	((__t=( (model.get('unit') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'">\n    </td>\n';
	 } else { 
	__p+='\n    <td></td>\n    <td></td>\n';
	 } 
	__p+='\n\n<td>\n    <input name="amount" class="form-control text-right form-control-invisible"\n        type="text" autocomplete="off"\n        value="'+
	((__t=( (model.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n        '+
	((__t=( (model.isLocked() || model.isUnit()) ? 'readonly' : '' ))==null?'':_.escape(__t))+
	'\n        ';
	 if (model.isLocked()) { 
	__p+='\n            data-toggle="tooltip" data-placement="left"\n\n            ';
	 if (model.isUnpaidLeave()) { 
	__p+='\n                title="Unpaid leave is calculated automatically. To manually calculate unpaid leave, please turn off the \'Record Unpaid Leave In Payroll\' in Payment Settings."\n            ';
	 } else if (model.isUnit()) { 
	__p+='\n                title="To change this value, you need to change the amount of units billed by the employee"\n            ';
	 } else { 
	__p+='\n                title="To change this value, you need to edit the employee\'s employment details"\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _PayrollItemSelectionModal = __webpack_require__(723);
	
	var _PayrollItemSelectionModal2 = _interopRequireDefault(_PayrollItemSelectionModal);
	
	var _PayrollItemSelectionButton = __webpack_require__(724);
	
	var _PayrollItemSelectionButton2 = _interopRequireDefault(_PayrollItemSelectionButton);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _vehicle = __webpack_require__(726);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	var _furnishing = __webpack_require__(727);
	
	var _furnishing2 = _interopRequireDefault(_furnishing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdditionalInfoClasses = { Address: _address2.default, Vehicle: _vehicle2.default, Furnishing: _furnishing2.default };
	var AdditionalInfoModals = {
	    Address: __webpack_require__(728),
	    Vehicle: __webpack_require__(730),
	    Furnishing: __webpack_require__(735)
	};
	
	module.exports = Backbone.View.extend({
	    tagName: 'div',
	    itemViews: [],
	
	    events: {
	        'hide.bs.modal': 'render',
	        'show.bs.modal': 'render',
	        'hidden.bs.modal': 'onHidden',
	        'shown.bs.modal': 'onShown',
	
	        'click .js-category-button': 'toggleCategory',
	        'click .js-back-button': 'showCategoryNav',
	        'click .js-add-selected-button': 'select',
	        'click .js-clear-selection-button': 'clearCategorySelection',
	
	        'afterChange .js-slider': 'fixOpacity'
	    },
	
	    initialize: function initialize(options) {
	        this.additionalForms = {};
	        this.additionalInfo = {};
	
	        this.options = _.defaults(options || {}, { type: 'addition' });
	
	        if (this.collection) {
	            this.bindHandlers();
	        }
	
	        this.render();
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.collection.on('select unselect', this.updateSelectCounters, this);
	        this.collection.on('select', this.showAdditionalForm, this);
	    },
	
	    setCollection: function setCollection(collection) {
	        this.collection = collection;
	
	        this.render();
	        this.bindHandlers();
	    },
	
	    render: function render() {
	        this.$el.addClass('modal inmodal').html((0, _PayrollItemSelectionModal2.default)({
	            title: this.options.title || 'Add Payroll Item',
	            text: this.options.text || false,
	            collection: this.collection || null
	        }));
	        this.$el.attr('data-backdrop', 'static');
	        this.$el.attr('data-keyboard', 'false');
	
	        this.$('.js-slider').css({ opacity: 0 }).slick({
	            slidesToShow: 1,
	            arrows: false,
	            draggable: false,
	            infinite: false,
	            swipe: false,
	            touchMove: false
	        }).slick('slickGoTo', 0);
	
	        _.each(this.collection.getSelected(), function (model) {
	            this.updateSelectCounters(model);
	        }.bind(this));
	    },
	
	    fixOpacity: function fixOpacity() {
	        this.$('.js-slider').css({ opacity: '' });
	    },
	
	    updateSelectCounters: function updateSelectCounters(model) {
	        var category = model.get('category');
	        var $counter = this.$('[data-toggle-category=' + category + '].js-category-button .counter');
	        var $categoryButton = $counter.closest('.js-category-button');
	
	        var $clearButton = $categoryButton.find('.js-clear-selection-button');
	
	        var count = this.collection.getSelectedByCategory(category).length;
	        var total = this.collection.getByCategory(category).length;
	
	        $counter.toggleClass('hidden', count <= 0);
	        $clearButton.toggleClass('hidden', count <= 0);
	        $categoryButton.toggleClass('selected', count > 0);
	
	        $counter.find('.count').text(count);
	        $counter.find('.total').text(total);
	    },
	
	    showCategoryNav: function showCategoryNav(ev) {
	        ev.preventDefault();
	        this.$('.js-slider').slick('slickGoTo', 0);
	    },
	
	    showAdditionalForm: function showAdditionalForm(model) {
	        var formClass = model.get('additionalInfoClass');
	
	        if (!formClass) {
	            return;
	        }
	
	        if (!_.isFunction(AdditionalInfoModals[formClass])) {
	            _modal2.default.showError('An application error ocurred. Contact support.');
	            return;
	        }
	
	        if (!this.$el.hasClass('in')) {
	            /* don't act if the modal is in a hidden state */
	            return;
	        }
	
	        if (!_.isObject(this.additionalForms[formClass])) {
	            this.additionalForms[formClass] = new AdditionalInfoModals[formClass]({
	                actOnSave: false,
	                actOnCancel: false,
	                actOnDestroy: false,
	                templateExtra: {
	                    title: 'Additional Information for \'' + model.get('name') + '\''
	                }
	            });
	
	            this.additionalForms[formClass].on('save', function (additional) {
	                this.additionalInfo[model.id] = additional.toJSON({
	                    asAdditionalInformation: true
	                });
	            }, this);
	            this.additionalForms[formClass].on('cancel', function () {
	                this.additionalInfo[model.id] = undefined;
	            }, this);
	        }
	
	        var additionalInfoModel = new AdditionalInfoClasses[formClass]();
	        this.additionalForms[formClass].setModel(additionalInfoModel);
	        this.additionalForms[formClass].$el.attr('data-backdrop', 'static');
	        this.additionalForms[formClass].$el.attr('data-keyboard', 'false');
	        this.additionalForms[formClass].show();
	    },
	
	    toggleCategory: function toggleCategory(ev) {
	        var $button = this.$(ev.currentTarget);
	        var category = parseInt($button.data('toggleCategory'), 10);
	        var categoryModels = this.collection.getByCategory(category);
	
	        ev.preventDefault();
	
	        _.each(this.itemViews, function (view) {
	            view.remove();
	        });
	        this.itemViews = [];
	
	        _.each(categoryModels, this.renderItem.bind(this));
	
	        this.$('.js-slider').slick('slickGoTo', 1);
	        this.$('.js-category-name').text(category === 0 ? 'Remuneration' : category === 1 ? 'Allowances' : category === 2 ? 'Benefits-in-Kind' : category === 3 ? 'Deductions' : category === 4 ? 'Other Perquisites' : '');
	    },
	
	    renderItem: function renderItem(model) {
	        var itemView = new _PayrollItemSelectionButton2.default({
	            model: model,
	            additionalInfo: this.additionalInfo[model.id]
	        });
	
	        this.itemViews.push(itemView);
	        this.$('.items').append(itemView.$el);
	    },
	
	    removeItemView: function removeItemView(model) {
	        this.itemViews = _.reject(this.itemViews, function (view) {
	            return view.model === model;
	        });
	    },
	
	    select: function select(ev) {
	        ev.preventDefault();
	
	        var id = this.$('[name=id]').val();
	        var model = this.collection.get(id);
	
	        if (model) {
	            this.trigger('select', [model], this.additionalInfo);
	        }
	
	        this.trigger('select', this.collection.getSelected(), this.additionalInfo);
	        this.hide();
	    },
	
	    clearCategorySelection: function clearCategorySelection(ev) {
	        ev.preventDefault();
	        ev.stopPropagation();
	
	        var $button = this.$(ev.currentTarget);
	
	        this.collection.clearSelectionForCategory($button.data('category'));
	    },
	
	    onHidden: function onHidden() {
	        this.trigger('hide');
	        this.$('.modal-body').addClass('hidden');
	    },
	
	    onShown: function onShown() {
	        this.trigger('show');
	
	        if (this.keepState === true) {
	            this.keepState = false;
	            return;
	        }
	
	        this.collection.clearSelection();
	    },
	
	    hide: function hide(options) {
	        options = _.defaults(options || {}, { keepState: false });
	
	        if (options.keepState === true) {
	            this.keepState = true;
	        }
	
	        this.$el.modal('hide');
	    },
	
	    show: function show() {
	        this.$el.modal('show');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/PayrollItemSelectionModal.html -->\n<div class="modal-dialog payroll-item-selection">\n    <div class="modal-content animated sweet">\n        <div class="modal-header" style="border-bottom: none;">\n            <h1 class="modal-title">\n                '+
	((__t=( title ))==null?'':_.escape(__t))+
	'\n            </h1>\n\n            ';
	 if (text) { 
	__p+='\n                <p class="m-t-lg">'+
	((__t=( text ))==null?'':__t)+
	'</p>\n            ';
	 } 
	__p+='\n        </div>\n\n        <div class="modal-body js-slider" style="background: #ffffff; padding: 0 50px 40px 50px;">\n            <div class="category-nav container js-category-nav">\n                <div>\n                    <h4>Select from the most popular items:</h4>\n                    <div class="form-group">\n                        <div class="col-sm-12 input-group">\n                            <select name="id" class="form-control">\n                                <option disabled selected>--</option>\n                                ';
	 _.each(collection.popular(), function (model) { 
	__p+='\n                                    <option value="'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'">\n                                        '+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }); 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="divider"><span class="text">or</span></div>\n\n                <div class="categories">\n                    <h4>Select from these categories:</h4>\n\n                    <div class="btn btn-outline btn-default btn-category js-category-button"\n                        data-toggle-category="1">\n                        <div class="row">\n                            <div class="btn-category-left btn-category-icon text-success">\n                                <i class="fa fa-rocket"></i>\n                            </div>\n                            <div class="btn-category-label">\n                                <h5>\n                                    Allowances\n\n                                    <span class="counter hidden">\n                                        Selected <span class="count"></span>\n                                        of <span class="total"></span>\n                                    </span>\n\n                                    <a class="hidden js-clear-selection-button"\n                                        data-category="1">\n                                        Clear all\n                                    </a>\n                                </h5>\n                            </div>\n                            <div class="btn-category-right btn-category-icon">\n                                <i class="fa fa-angle-right"></i>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="btn btn-outline btn-default btn-category js-category-button"\n                        data-toggle-category="4">\n                        <div class="row">\n                            <div class="btn-category-left btn-category-icon text-success">\n                                <i class="fa fa-gift"></i>\n                            </div>\n                            <div class="btn-category-label">\n                                <h5>\n                                    Other Perquisites\n\n                                    <span class="counter hidden">\n                                        Selected <span class="count"></span>\n                                        of <span class="total"></span>\n                                    </span>\n\n                                    <a class="hidden js-clear-selection-button"\n                                        data-category="4">\n                                        Clear all\n                                    </a>\n                                </h5>\n                            </div>\n                            <div class="btn-category-right btn-category-icon">\n                                <i class="fa fa-angle-right"></i>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="btn btn-outline btn-default btn-category js-category-button"\n                        data-toggle-category="0">\n                        <div class="row">\n                            <div class="btn-category-left btn-category-icon text-info">\n                                <i class="fa fa-money"></i>\n                            </div>\n                            <div class="btn-category-label">\n                                <h5>\n                                    Remuneration\n\n                                    <span class="counter hidden">\n                                        Selected <span class="count"></span>\n                                        of <span class="total"></span>\n                                    </span>\n\n                                    <a class="hidden js-clear-selection-button"\n                                        data-category="0">\n                                        Clear all\n                                    </a>\n                                </h5>\n                            </div>\n                            <div class="btn-category-right btn-category-icon">\n                                <i class="fa fa-angle-right"></i>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="btn btn-outline btn-default btn-category js-category-button"\n                        data-toggle-category="3">\n                        <div class="row">\n                            <div class="btn-category-left btn-category-icon text-warning">\n                                <i class="fa fa-minus-circle"></i>\n                            </div>\n                            <div class="btn-category-label">\n                                <h5>\n                                    Deductions\n\n                                    <span class="counter hidden">\n                                        Selected <span class="count"></span>\n                                        of <span class="total"></span>\n                                    </span>\n\n                                    <a class="hidden js-clear-selection-button"\n                                        data-category="3">\n                                        Clear all\n                                    </a>\n                                </h5>\n                            </div>\n                            <div class="btn-category-right btn-category-icon">\n                                <i class="fa fa-angle-right"></i>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="btn btn-outline btn-default btn-category js-category-button"\n                        data-toggle-category="2">\n                        <div class="row">\n                            <div class="btn-category-icon btn-category-left text-navy">\n                                <i class="fa fa-briefcase"></i>\n                            </div>\n                            <div class="btn-category-label">\n                                <h5>\n                                    Benefits-in-Kind\n\n                                    <span class="counter hidden">\n                                        Selected <span class="count"></span>\n                                        of <span class="total"></span>\n                                    </span>\n\n                                    <a class="hidden js-clear-selection-button"\n                                        data-category="2">\n                                        Clear all\n                                    </a>\n                                </h5>\n                            </div>\n                            <div class="btn-category-right btn-category-icon">\n                                <i class="fa fa-angle-right"></i>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div> <!-- /start -->\n\n            <div class="item-nav container">\n                <a class="js-back-button">\n                    <i class="fa fa-angle-left"></i>\n                    Back to categories\n                </a>\n\n                <h4>\n                    Select item in category\n                    <span class="js-category-name"></span>\n                    :\n                </h4>\n\n                <div class="items js-items"></div>\n            </div> <!-- /category -->\n        </div>\n        <div class="modal-footer" style="border-top: none; text-align: center;">\n            <button type="reset" class="btn btn-warning btn-w-m"\n                    data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="button"\n                    class="btn btn-primary btn-w-m btn-save ladda-button js-add-selected-button"\n                    style="margin-left: 27px;"\n                    data-style="swap">\n                Add Selected\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(725);
	
	module.exports = Backbone.View.extend({
	    tagName: 'div',
	
	    events: {
	        'click': 'toggleSelect'
	    },
	
	    initialize: function initialize(options) {
	        var self = this;
	
	        self.options = _.defaults(options || {}, {
	            additionalInfo: null
	        });
	
	        self.model.on('change', self.render, self);
	        self.render();
	    },
	
	    render: function render() {
	        var self = this;
	
	        self.$el.addClass('btn btn-outline btn-default btn-item').html(template({
	            model: self.model,
	            additionalInfo: self.options.additionalInfo
	        }));
	        self.$el.toggleClass('selected js-selected', self.model.isSelected());
	    },
	
	    remove: function remove() {
	        var self = this;
	        if (_.isFunction(Backbone.View.prototype.remove)) {
	            Backbone.View.prototype.remove.apply(self, arguments);
	        }
	
	        self.model.off('change', self.render);
	        self.undelegateEvents();
	    },
	
	    toggleSelect: function toggleSelect(ev) {
	        ev.preventDefault();
	
	        var self = this;
	
	        self.model.toggleSelect();
	        self.$el.toggleClass('selected js-selected', self.model.isSelected());
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/PayrollItemSelectionButton.html -->\n<div class="row">\n    <div class="btn-item-left btn-item-icon">\n        ';
	 if (model.get('category') === 1) {
	__p+='\n            <i class="fa fa-rocket text-success"></i>\n        ';
	}
	__p+='\n        ';
	 if (model.get('category') === 4) {
	__p+='\n            <i class="fa fa-gift text-success"></i>\n        ';
	}
	__p+='\n        ';
	 if (model.get('category') === 0) {
	__p+='\n            <i class="fa fa-money text-info"></i>\n        ';
	}
	__p+='\n        ';
	 if (model.get('category') === 3) {
	__p+='\n            <i class="fa fa-minus-circle text-warning"></i>\n        ';
	}
	__p+='\n        ';
	 if (model.get('category') === 2) {
	__p+='\n            <i class="fa fa-briefcase text-navy"></i>\n        ';
	}
	__p+='\n    </div>\n    <div class="btn-item-label">\n        <h5>\n            '+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'\n            <small>\n                ';
	 if (additionalInfo) { 
	__p+='\n                    (\n                        ';
	 last = _.last(_.keys(additionalInfo)); 
	__p+='\n                        ';
	 _.each(_.keys(additionalInfo), function(attr, i) { 
	__p+='\n                            '+
	((__t=( additionalInfo[attr] + (
	                                attr !== last ? ', ' : ''
	                            ) ))==null?'':_.escape(__t))+
	'\n                        ';
	 }); 
	__p+='\n                    )\n                ';
	 } 
	__p+='\n            </small>\n        </h5>\n        ';
	 if (model.get('description')) { 
	__p+='\n            <p>'+
	((__t=( model.get('description') ))==null?'':_.escape(__t))+
	'</p>\n        ';
	 } 
	__p+='\n    </div>\n    <div class="btn-item-right btn-item-icon">\n        <i class="fa fa-check icon"></i>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('models/vehicle');
	
	var Vehicle = function (_Model) {
	    _inherits(Vehicle, _Model);
	
	    function Vehicle() {
	        _classCallCheck(this, Vehicle);
	
	        return _possibleConstructorReturn(this, (Vehicle.__proto__ || Object.getPrototypeOf(Vehicle)).apply(this, arguments));
	    }
	
	    _createClass(Vehicle, [{
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                type: '',
	                year: new Date().getFullYear(),
	                model: ''
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                type: { presence: true },
	                year: {
	                    presence: true,
	                    numericality: {
	                        onlyIntegers: true,
	                        lessThanOrEqualTo: new Date().getFullYear()
	                    }
	                },
	                model: { presence: true }
	            };
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            log.warn('Vehicle Model is not meant to be persisted.');
	            return (0, _bluebird.resolve)(this);
	        }
	    }]);
	
	    return Vehicle;
	}(_model2.default);
	
	exports.default = Vehicle;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('models/furnishing');
	
	var Furnishing = function (_Model) {
	    _inherits(Furnishing, _Model);
	
	    function Furnishing() {
	        _classCallCheck(this, Furnishing);
	
	        return _possibleConstructorReturn(this, (Furnishing.__proto__ || Object.getPrototypeOf(Furnishing)).apply(this, arguments));
	    }
	
	    _createClass(Furnishing, [{
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                furniture: false,
	                airConditioners: false,
	                carpets: false,
	                curtains: false
	            };
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            log.warn('Vehicle Model is not meant to be persisted.');
	            return (0, _bluebird.resolve)(this);
	        }
	    }, {
	        key: 'toJSON',
	        value: function toJSON(options) {
	            var r = _get(Furnishing.prototype.__proto__ || Object.getPrototypeOf(Furnishing.prototype), 'toJSON', this).call(this, arguments);
	
	            options = Object.assign({ asAdditionalInformation: false }, options || {});
	
	            if (options.asAdditionalInformation === true) {
	                Object.keys(r).forEach(function (attr) {
	                    if (r[attr] === false) {
	                        delete r[attr];
	                        return;
	                    }
	
	                    switch (attr) {
	                        case 'furniture':
	                            r[attr] = 'Furniture';
	                            break;
	                        case 'airConditioners':
	                            r[attr] = 'Air Conditioners';
	                            break;
	                        case 'carpets':
	                            r[attr] = 'Carpets';
	                            break;
	                        case 'curtains':
	                            r[attr] = 'Curtains';
	                            break;
	                    }
	                });
	            }
	
	            return r;
	        }
	    }]);
	
	    return Furnishing;
	}(_model2.default);
	
	exports.default = Furnishing;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(729);
	var ModalFormView = __webpack_require__(665);
	
	module.exports = ModalFormView.extend({
	    initialize: function initialize(options) {
	        ModalFormView.prototype.initialize.apply(this, [_.extend(options, {
	            template: template
	        })]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/AddressModal.html -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            <h3>\n                ';
	 if (title) { 
	__p+='\n                    '+
	((__t=( title ))==null?'':_.escape(__t))+
	'\n                ';
	 } else { 
	__p+='\n                    '+
	((__t=( model.isNew() ? 'Add' : 'Edit' ))==null?'':_.escape(__t))+
	' Address\n                ';
	 } 
	__p+='\n            </h3>\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Street Address\n                        </label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="line1"\n                                value="'+
	((__t=( model.get('line1') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-line1"></span>\n                        </div>\n                    </div>\n\n                    <!-- city -->\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">City</label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="city"\n                                value="'+
	((__t=( model.get('city') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-city"></span>\n                        </div>\n                    </div>\n\n                    <!-- state -->\n                    ';
	 states = model.constructor.getStatesList() 
	__p+='\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">State</label>\n                        <div class="col-sm-9">\n                            <select name="state" class="form-control">\n                                <option value=""></option>\n                                ';
	 _.each(states, function(s) { 
	__p+='\n                                    <option value="'+
	((__t=( s.code ))==null?'':_.escape(__t))+
	'">\n                                        '+
	((__t=( s.name ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }); 
	__p+='\n                            </select>\n                            <span class="error error-state"></span>\n                        </div>\n                    </div>\n\n                    <!-- post code and phone -->\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">Post Code</label>\n                        <div class="col-sm-2">\n                            <input name="postcode" type="text"\n                                class="form-control"\n                                value="'+
	((__t=( model.get('postcode') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-postcode"></span>\n                        </div>\n\n                        <label class="col-sm-3 control-label">\n                            Contact Phone\n                        </label>\n                        <div class="col-sm-4">\n                            <input name="contactPhone" type="text"\n                                class="form-control"\n                                value="'+
	((__t=( model.get('contactPhone') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-contactPhone"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            ';
	 if (!model.isNew()) { 
	__p+='\n                <button type="button"\n                    class="js-remove btn btn-w-m btn-danger m-l-xs float-left">\n                    <i class="fa fa-trash"></i> Remove\n                </button>\n            ';
	 } 
	__p+='\n            <button type="button"\n                class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(731);
	var ModalFormView = __webpack_require__(665);
	
	__webpack_require__(732);
	
	module.exports = ModalFormView.extend({
	    initialize: function initialize(options) {
	        ModalFormView.prototype.initialize.apply(this, [_.extend(options, {
	            template: template
	        })]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/VehicleModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            <h3>\n                ';
	 if (title) { 
	__p+='\n                    '+
	((__t=( title ))==null?'':_.escape(__t))+
	'\n                ';
	 } else { 
	__p+='\n                    '+
	((__t=( model.isNew() ? 'Add' : 'Edit' ))==null?'':_.escape(__t))+
	' Vehicle\n                ';
	 } 
	__p+='\n            </h3>\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Type\n                        </label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="type"\n                                value="'+
	((__t=( model.get('type') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-type"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">Year</label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="year"\n                                value="'+
	((__t=( model.get('year') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-year"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">Model</label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="model"\n                                value="'+
	((__t=( model.get('model') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-model"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            ';
	 if (!model.isNew()) { 
	__p+='\n                <button type="button"\n                    class="js-remove btn btn-w-m btn-danger m-l-xs float-left">\n                    <i class="fa fa-trash"></i> Remove\n                </button>\n            ';
	 } 
	__p+='\n            <button type="button" class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var BaseModel = __webpack_require__(733);
	var log = __webpack_require__(525)('vehicle-model');
	var Model;
	
	module.exports = Model = BaseModel.extend('Vehicle', {
	    softDelete: false,
	
	    defaults: {
	        type: '',
	        year: new Date().getFullYear(),
	        model: ''
	    },
	
	    constraints: {
	        type: { presence: true },
	        year: {
	            presence: true,
	            numericality: {
	                onlyIntegers: true,
	                lessThanOrEqualTo: new Date().getFullYear()
	            }
	        },
	        model: { presence: true }
	    },
	
	    save: function save() {
	        log.warn('Vehicle Model is not meant to be persisted.');
	    }
	}, {});

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Parse) {/** @module models */
	'use strict';
	
	var moment = __webpack_require__(101);
	var _validate = __webpack_require__(58);
	var validators = __webpack_require__(562);
	var parseUtil = __webpack_require__(734);
	var log = __webpack_require__(525)('base-model');
	var _proto = _.clone(Parse.Object.prototype);
	
	_.extend(_validate.validators, validators);
	
	/**
	 * @name module:models.BaseModel
	 * @constructor
	 * @augments external:Parse.Object
	 */
	_.extend(Parse.Object.prototype,
	/** @lends module:models.BaseModel */
	{
	    /**
	     * Determines the deletion strategy to use for the inheriting model
	     *
	     * @type {boolean}
	     * @default
	     * @protected
	     */
	    softDelete: true,
	
	    /**
	     * Set of rules used to validate the model's attributes
	     *
	     * @type {object}
	     * @default
	     * @protected
	     */
	    constraints: {},
	
	    /**
	     * We have some use cases in which, on top of the constraints we
	     * want to perform validation to some other attributes. So this would
	     * be a subset of validation rules, used optionally
	     *
	     * @type {object}
	     * @default
	     * @protected
	     */
	    groupedConstraints: {},
	
	    /**
	     * Setter methods for attributes, their definition is optional.
	     *
	     * @type {object}
	     * @default
	     * @protected
	     */
	    setters: {},
	
	    /**
	     * Strips 'presence' constraints from the constraints object
	     *
	     * @instance
	     * @private
	     * @param {object} constraints - The object from where to strip the
	     *  'presence' constraints
	     * @param {object} attributes - The attributes for which we wish to
	     *  strip 'presence' constraints.
	     * @returns {object} A constraints object without any 'presence' rules.
	     */
	    _stripPresenceConstraints: function _stripPresenceConstraints(constraints, attributes) {
	        constraints = _.pick(constraints, _.keys(attributes));
	
	        _.each(_.keys(constraints), function (attr) {
	            var valids;
	
	            if (typeof constraints[attr] === 'function') {
	                constraints[attr] = constraints[attr](attributes[attr], attributes);
	            }
	
	            valids = _.reject(_.keys(constraints[attr]), function (constraint) {
	                return constraint === 'presence';
	            });
	
	            constraints[attr] = _.pick(constraints[attr], valids);
	        });
	
	        return constraints;
	    },
	
	    /**
	     * Whether or not the model is valid
	     *
	     * @instance
	     * @param {object} options - A backbone style options object.
	     * @returns {boolean} True if model is valid, false if not.
	     */
	    isValid: function isValid(options) {
	        return !this.validate(this.attributes, options);
	    },
	
	    /**
	     * Whether or not the model was invalid. We check if validationError has
	     * data in it.
	     *
	     * @instance
	     * @returns {boolean} True if it was deemed valid, false if not.
	     */
	    wasValid: function wasValid() {
	        return this.validationError === false || _.isEmpty(this.validationError);
	    },
	
	    /**
	     * Validate a set of attributes against a defined set of constraints
	     *
	     * @instance
	     * @param {object} attributes - The attributes to validate
	     * @param {object} options - A backbone style options object
	     * @returns {mixed} An error object or false if we encountered no errors
	     */
	    validate: function validate(attributes, options) {
	        var self = this;
	        var constraints = _.clone(self.constraints);
	        var groupedConstraints;
	
	        options = _.defaults(options || {}, {
	            _set: false,
	            _save: false,
	            groupedConstraints: null,
	            forcePresenceValidation: false,
	            include: []
	        });
	
	        self.validationError = false;
	
	        if (_.isObject(self.groupedConstraints[options.groupedConstraints])) {
	            groupedConstraints = _.clone(self.groupedConstraints[options.groupedConstraints]);
	        }
	
	        if (_.isUndefined(attributes) || _.isDate(attributes.hiddenAt)) {
	            return self.validationError;
	        }
	
	        if (options._save !== true && options._set === true && options.forcePresenceValidation === false) {
	            constraints = self._stripPresenceConstraints(constraints, attributes);
	
	            if (_.isObject(groupedConstraints)) {
	                groupedConstraints = self._stripPresenceConstraints(groupedConstraints, attributes);
	            }
	        }
	
	        self.validationError = _.extend({}, _validate(attributes, constraints || {}), _validate(attributes, groupedConstraints || {}));
	
	        _.each(options.include || [], function (include) {
	            var obj = attributes[include];
	
	            if (_.isObject(obj) && _.isFunction(obj.validate)) {
	                obj.validate(obj.attributes, options);
	
	                self.validationError = _.extend(self.validationError || {}, obj.validationError || {});
	            }
	        });
	
	        return _.isEmpty(self.validationError) ? false : {
	            code: 1100,
	            error: 'Validation error',
	            errors: self.validationError
	        };
	    },
	
	    /**
	     * Saves the model
	     * This is essentially the same as Parse.Object.save() but we
	     * perform a validation on all attributes before saving to the server.
	     *
	     * @instance
	     * @param {mixed} attr - Either an attribute name or an attributes object
	     *  with key-value pairs.
	     * @param {mixed} val - Either the value of the previous parameter or
	     *  an options object.
	     * @param {object} options - A backbone style options object
	     * @returns {promise} A promise, resolved if the model was succesfully saved
	     *  or reject if it wasn't
	     */
	    save: function save(attr, val, options) {
	        var self = this;
	        var attrs = {};
	
	        if (_.isNull(attr) || _.isUndefined(attr) || _.isObject(attr)) {
	            attrs = attr;
	            options = val;
	        } else {
	            attrs[attr] = val;
	        }
	
	        options = _.defaults(options || {}, { _save: true });
	
	        if (!self._validate(self.attributes, options) && !options.skipValidation) {
	            return Parse.Promise.error(self.validate(self.attributes, options));
	        }
	
	        return _proto.save.apply(self, [attrs, options]);
	    },
	
	    /**
	     * Destroy the model
	     *
	     * @instance
	     * @returns {promise} A resolved promise on a succesful delete, rejected
	     *  otherwise
	     */
	    destroy: function destroy() {
	        var self = this;
	
	        if (self.softDelete === true) {
	            return self.save({
	                hiddenAt: new Date()
	            }, {
	                silent: true,
	                success: function success() {}
	            }).then(function (model) {
	                return Parse.Promise.as(model);
	            });
	        } else {
	            return _proto.destroy.apply(self, arguments);
	        }
	    },
	
	    /**
	     * Smarter fetch method. Don't do a xhr request for new methods, just
	     * rebuild default values
	     *
	     * @instance
	     * @returns {promise} The promise of a synced model
	     */
	    fetch: function fetch(options) {
	        var self = this;
	        var Constructor = self.constructor;
	        var defaults = new Constructor().attributes;
	
	        if (!self.isNew()) {
	            return _proto.fetch.apply(self, arguments);
	        }
	
	        self._finishFetch(defaults, 200);
	
	        return Parse.Promise.as(self)._thenRunCallbacks(options, self);
	    },
	
	    /**
	     * Set a new value for an attribute. For any attributes with a setter
	     * defined, we run the proposed value through the setter function first and
	     * save whatever said function returns.
	     *
	     * @instance
	     * @param {mixed} attribute - Either an attribute name or an object of
	     *  key value pairs.
	     * @param {mixed} value - Either an attribute value or an backbone-style
	     *  options object
	     * @param {object} object - If not undefined, a backbone-style options
	     *  object.
	     * @returns {models/BaseModel}
	     */
	    set: function set(attribute, value, options) {
	        var self = this;
	        var changes = {};
	
	        if (_.isString(attribute)) {
	            changes[attribute] = value;
	        } else if (_.isObject(value) && _.isUndefined(options)) {
	            options = value;
	        }
	
	        if (_.isObject(attribute)) {
	            changes = attribute;
	        }
	
	        options = _.defaults(options || {}, {
	            _set: true
	        });
	
	        if (options._save === true) {
	            options.silent = true;
	        }
	
	        _.each(_.keys(changes), function (attribute) {
	            if (self.setters && _.isFunction(self.setters[attribute])) {
	                log.debug('Setters should be deprecated for', self.className, '.', attribute);
	
	                changes[attribute] = self.setters[attribute](changes[attribute]);
	            }
	        });
	
	        return _proto.set.apply(self, [changes, options]);
	    },
	
	    /**
	     * Returns the models' attributes in JSON format
	     *
	     * @instance
	     * @param {object} options - A backbone-style options object
	     * @returns {object} A JSON of the models' attributes
	     */
	    toJSON: function toJSON(options) {
	        var self = this;
	
	        options = _.defaults(options || {}, {
	            deep: false
	        });
	
	        if (options.deep !== true) {
	            return _proto.toJSON.apply(self);
	        } else {
	            return parseUtil.toJSON(self);
	        }
	    },
	
	    /**
	     * Returns a simple pointer object. Useful for specifying queries using
	     * object literals
	     *
	     * @instance
	     * @returns {object} A simple pointer object, with class name and id
	     */
	    toPointerObj: function toPointerObj() {
	        if (this.isNew() && !this.id) {
	            throw new Error('Can\'t create pointer objects for new models');
	        }
	
	        return {
	            __type: 'Pointer',
	            className: this.className,
	            objectId: this.id
	        };
	    },
	
	    /**
	     * Get dates in whatever specified format
	     *
	     * @instance
	     * @param {string} attr - The attribute to format
	     * @param {string} format - Format to use. Must be something momentjs
	     *  understands
	     * @returns {string} Formatted date
	     */
	    getFormatted: function getFormatted(attr, format) {
	        var value = this.get(attr);
	        if (_.isDate(value)) {
	            return moment(value).format(format);
	        }
	        return value;
	    }
	});
	
	Parse.Object.setters = {
	    boolean: function boolean(value) {
	        if (_.isBoolean(value)) {
	            return value;
	        }
	
	        if (_.isString(value) && _.contains(['true', 'false'], value)) {
	            return value === 'true';
	        }
	
	        if (_.isString(value) && _.contains(['0', '1'], value)) {
	            return value === '1';
	        }
	
	        if (_.isNumber(value)) {
	            return !!value;
	        }
	
	        return false;
	    },
	
	    string: function string(value) {
	        return value && !_.isString(value) && _.isFunction(value.toString) ? value.toString() : value;
	    },
	
	    integer: function integer(value) {
	        return !_.isNaN(parseInt(value, 10)) ? parseInt(value, 10) : value;
	    },
	
	    float: function float(value) {
	        value = typeof value === 'string' ? value.replace(',', '') : value;
	        return !_.isNaN(parseFloat(value)) ? parseFloat(value) : value;
	    },
	
	    date: function date(value) {
	        if (_.isDate(value)) {
	            return value;
	        }
	        var m;
	        if (_.isString(value)) {
	            m = moment(value);
	        }
	        if (_.isObject(value)) {
	            m = moment(value.string, moment.format);
	        }
	        return m && m.isValid() ? m.toDate() : null;
	    }
	};
	
	module.exports = Parse.Object;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(650)))

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Parse, _) {'use strict';
	
	// Additional Parse functions
	
	/**
	 * Object to JSON with nested attributes
	 *
	 * @param {Object} object
	 * @returns {*}
	 */
	function toJSON(object) {
	    var json = _toFullJSON(object);
	    Parse._arrayEach(['__type', 'className'], function (key) {
	        delete json[key];
	    });
	    return json;
	}
	
	function _toFullJSON(object) {
	    var json = _.clone(object.attributes);
	    Parse._objectEach(json, function (val, key) {
	        json[key] = Parse._encode(val, []);
	    });
	    Parse._objectEach(object._operations, function (val, key) {
	        json[key] = val;
	    });
	
	    if (_.has(object, 'id')) {
	        json.objectId = object.id;
	    }
	    if (_.has(object, 'createdAt')) {
	        if (_.isDate(object.createdAt)) {
	            json.createdAt = object.createdAt.toJSON();
	        } else {
	            json.createdAt = object.createdAt;
	        }
	    }
	
	    if (_.has(object, 'updatedAt')) {
	        if (_.isDate(object.updatedAt)) {
	            json.updatedAt = object.updatedAt.toJSON();
	        } else {
	            json.updatedAt = object.updatedAt;
	        }
	    }
	    json.__type = 'Object';
	    json.className = object.className;
	    return json;
	}
	
	module.exports = {
	    toJSON: toJSON
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(650), __webpack_require__(27)))

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(736);
	var ModalFormView = __webpack_require__(665);
	
	__webpack_require__(737);
	
	module.exports = ModalFormView.extend({
	    initialize: function initialize(options) {
	        ModalFormView.prototype.initialize.apply(this, [_.extend(options, {
	            template: template
	        })]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/FurnishingModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            <h3>\n                ';
	 if (title) { 
	__p+='\n                    '+
	((__t=( title ))==null?'':_.escape(__t))+
	'\n                ';
	 } else { 
	__p+='\n                    '+
	((__t=( model.isNew() ? 'Add' : 'Edit' ))==null?'':_.escape(__t))+
	' Furnishing\n                ';
	 } 
	__p+='\n            </h3>\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <div class="form-group row">\n                            <label class="col-sm-4 control-label">\n                                Furniture\n                            </label>\n                            <div class="col-sm-8">\n                                <label class="js-icheck ichecks"\n                                    style="margin-right: 32px;">\n                                    <input type="radio" value="0"\n                                        name="furniture" checked>\n                                    <span>No</span>\n                                </label>\n                                <label class="js-icheck ichecks">\n                                    <input type="radio" value="1"\n                                        name="furniture">\n                                    <span>Yes</span>\n                                </label>\n                                <span class="error error-furniture"></span>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <label class="col-sm-4 control-label">\n                                Air-Conditioners\n                            </label>\n                            <div class="col-sm-8">\n                                <label class="js-icheck ichecks"\n                                    style="margin-right: 32px;">\n                                    <input type="radio" value="0"\n                                        name="airConditioners" checked>\n                                    <span>No</span>\n                                </label>\n                                <label class="js-icheck ichecks">\n                                    <input type="radio" value="1"\n                                        name="airConditioners">\n                                    <span>Yes</span>\n                                </label>\n                                <span class="error error-airConditioners">\n                                </span>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <label class="col-sm-4 control-label">\n                                Curtains\n                            </label>\n                            <div class="col-sm-8">\n                                <label class="js-icheck ichecks"\n                                    style="margin-right: 32px;">\n                                    <input type="radio" value="0"\n                                        name="curtains" checked>\n                                    <span>No</span>\n                                </label>\n                                <label class="js-icheck ichecks">\n                                    <input type="radio" value="1"\n                                        name="curtains">\n                                    <span>Yes</span>\n                                </label>\n                                <span class="error error-curtains"></span>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <label class="col-sm-4 control-label">\n                                Carpets\n                            </label>\n                            <div class="col-sm-8">\n                                <label class="js-icheck ichecks"\n                                    style="margin-right: 32px;">\n                                    <input type="radio" value="0"\n                                        name="carpets" checked>\n                                    <span>No</span>\n                                </label>\n                                <label class="js-icheck ichecks">\n                                    <input type="radio" value="1"\n                                        name="carpets">\n                                    <span>Yes</span>\n                                </label>\n                                <span class="error error-carpets"></span>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            ';
	 if (!model.isNew()) { 
	__p+='\n                <button type="button"\n                    class="js-remove btn btn-w-m btn-danger m-l-xs float-left">\n                    <i class="fa fa-trash"></i> Remove\n                </button>\n            ';
	 } 
	__p+='\n            <button type="button" class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseModel = __webpack_require__(733);
	var log = __webpack_require__(525)('furnishing-model');
	var Model;
	
	module.exports = Model = BaseModel.extend('Furnishing', {
	    softDelete: false,
	
	    defaults: {
	        furniture: false,
	        airConditioners: false,
	        carpets: false,
	        curtains: false
	    },
	
	    constraints: {},
	
	    save: function save() {
	        log.warn('Furnishing model is not meant to be persisted');
	    },
	
	    toJSON: function toJSON(options) {
	        var self = this;
	        var r = BaseModel.prototype.toJSON.apply(self, arguments);
	
	        options = _.defaults(options || {}, {
	            asAdditionalInformation: false
	        });
	
	        if (options.asAdditionalInformation === true) {
	            _.each(_.keys(r), function (attr) {
	                if (r[attr] === false) {
	                    delete r[attr];
	                    return;
	                }
	
	                switch (attr) {
	                    case 'furniture':
	                        r[attr] = 'Furniture';
	                        break;
	                    case 'airConditioners':
	                        r[attr] = 'Air Conditioners';
	                        break;
	                    case 'carpets':
	                        r[attr] = 'Carpets';
	                        break;
	                    case 'curtains':
	                        r[attr] = 'Curtains';
	                        break;
	                }
	            });
	        }
	
	        return r;
	    }
	}, {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepOne/Employee.html -->\n<thead>\n    <th></th>\n    <th class="amount"></th>\n    <th data-hide="all"></th>\n</thead>\n<tbody><tr class="tr-lg">\n    <td class="name">\n        <strong>'+
	((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
	'</strong>\n        <span>'+
	((__t=( model.getPositionName() ))==null?'':_.escape(__t))+
	'</span>\n    </td>\n    <td>\n        <input name="net" type="text"\n            class="form-control text-right form-control-invisible\n                js-net-amount"\n            autocomplete="off" data-toggle="popover" readonly\n            value="'+
	((__t=( payrollDetails.getNetAmount(model.id).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'">\n    </td>\n    <td>\n        <table class="footable table"\n            data-striping="false">\n            <thead>\n                <tr>\n                    <th></th>\n                    <th class="rate"></th>\n                    <th class="units"></th>\n                    <th class="amount"></th>\n                </tr>\n            </thead>\n\n            <tbody class="footable-body footable-body-additions\n                js-payroll-details-additions hidden">\n            </tbody>\n\n            <tbody class="footable-body footable-body-deductions\n                js-payroll-details-deductions hidden">\n            </tbody>\n\n            <tbody class="footable-body footable-body-others\n                js-payroll-details-others hidden">\n            </tbody>\n        </table>\n\n        <div class="text-right">\n            ';
	 if (showButtons) { 
	__p+='\n                <button class="btn btn-outline btn-primary js-add-item-button"\n                    type="button">\n                    + Additional Payroll Item\n                </button>\n\n                ';
	 if (!isCard) { 
	__p+='\n                    <button type="button"\n                        class="btn btn-outline btn-warning\n                            js-use-last-payroll-button\n                            ';
	 if (!lastPayrollDetails) { 
	__p+=' disabled ';
	 } 
	__p+='"\n                        data-tooltip="tooltip"\n                        data-title="Payroll incl. all additions and deductions will\n                            be as per previous month"\n                        data-container="body" data-placement="top" data-delayed>\n                        Use Same As Last Payroll\n                    </button>\n                ';
	 } 
	__p+='\n            ';
	 } 
	__p+='\n        </div>\n\n        ';
	 if (lastPayrollDetails && isCard) { 
	__p+='\n            <table class="footable table toggle-arrow no-paging\n                footable-last-payroll-details">\n                <thead>\n                    <tr>\n                        <th></th>\n                        <th class="amount"></th>\n                        <th data-hide="all"></th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <td><strong>Last Payroll Details</strong></td>\n                        <td class="text-right">\n                            <strong>\n                                RM: &nbsp;\n                                '+
	((__t=( lastPayrollDetails.getNetAmount().formatWithoutRounding()))==null?'':_.escape(__t))+
	'\n                            </strong>\n                        </td>\n                        <td>\n                            <table class="footable table table-striped">\n                                <thead>\n                                    <th></th>\n                                    <th class="rate"></th>\n                                    <th class="units"></th>\n                                    <th class="amount"></th>\n                                </thead>\n                                <tbody>\n                                    ';
	 lastPayrollDetails.forEach(function(model) { 
	__p+='\n                                        <tr>\n                                            <td>\n                                                '+
	((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                                            </td>\n\n                                            ';
	 if (model.isUnit()) { 
	__p+='\n                                                <td class="text-right">\n                                                    <span>RM:</span>\n                                                    <span>\n                                                        '+
	((__t=( (model.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                                                    </span>\n                                                </td>\n                                                <td class="text-right">\n                                                    <span>Units:</span>\n                                                    <span>\n                                                        '+
	((__t=( (model.get('unit') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                                                    </span>\n                                                </td>\n                                            ';
	 } else { 
	__p+='\n                                                <td colspan="2"></td>\n                                            ';
	 } 
	__p+='\n\n                                            <td class="text-right">\n                                                '+
	((__t=( model.get('amount').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                                            </td>\n                                        </tr>\n                                    ';
	 }) 
	__p+='\n                                </tbody>\n                            </table>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        ';
	 } 
	__p+='\n        ';
	 if (isCard && showButtons) { 
	__p+='\n            <div class="text-right">\n                <button type="button"\n                    class="btn btn-outline btn-warning\n                        js-use-last-payroll-button\n                        ';
	 if (!lastPayrollDetails) { 
	__p+=' disabled ';
	 } 
	__p+='"\n                    data-tooltip="tooltip"\n                    data-title="Payroll incl. all additions and deductions will\n                        be as per previous month"\n                    data-container="body" data-placement="top" data-delayed>\n                    Use Same As Last Payroll\n                </button>\n            </div>\n        ';
	 } 
	__p+='\n    </td>\n</tr></tbody>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _EmployeeSlides = __webpack_require__(740);
	
	var _EmployeeSlides2 = _interopRequireDefault(_EmployeeSlides);
	
	var _Employee = __webpack_require__(719);
	
	var _Employee2 = _interopRequireDefault(_Employee);
	
	var _payrollDetails = __webpack_require__(599);
	
	var _payrollDetails2 = _interopRequireDefault(_payrollDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'change .js-employee-select': 'selectEmployee',
	        'beforeChange .js-employee-slides': 'beforeChangeSlide',
	        'afterChange .js-employee-slides': 'afterChangeSlide',
	        'click .js-prev-slide': 'prevSlide',
	        'click .js-next-slide': 'nextSlide'
	    },
	
	    initialize: function initialize(options) {
	        this.activeSlideView = null;
	        this.nextSlideView = null;
	        this.$slides = null;
	        this.$prevSlide = null;
	        this.$nextSlide = null;
	        this.viewedSlides = [];
	
	        this.options = _.defaults(options || {}, {
	            employees: null,
	            payroll: null,
	            payrollDetails: null,
	            lastPayrollDetails: null,
	            lastPayroll: null,
	            pendingJobs: false,
	            payrollItems: null
	        });
	        this.currentEmployee = this.options.employees.first();
	
	        this.render();
	    },
	
	    fetchDetails: function fetchDetails() {
	        var _this = this;
	
	        var employee = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	        var payroll = this.options.payroll;
	        var lastPayroll = this.options.lastPayroll;
	        var detailsPromise = void 0;
	        var lastDetailsPromise = void 0;
	
	        if (!employee) {
	            employee = this.currentEmployee;
	        }
	
	        if (!employee) {
	            return;
	        }
	
	        function detailsForEmployee(details, employee) {
	            return details.filterByEmployee(employee.id).length !== 0;
	        }
	
	        var cachedDetails = detailsForEmployee(this.options.payrollDetails, employee);
	
	        var cachedLastDetails = detailsForEmployee(this.options.lastPayrollDetails, employee);
	
	        function fetchDetailsForPayroll(payroll, employee) {
	            return new _payrollDetails2.default(null, { payroll: payroll }).fetch({
	                filter: {
	                    limit: 9999,
	                    where: { employeeId: employee.id }
	                }
	            }).then(function (collection) {
	                return collection.filterNonContributions();
	            });
	        }
	
	        if (cachedDetails) {
	            detailsPromise = (0, _bluebird.resolve)([]);
	        } else {
	            detailsPromise = payroll.isNew() ? _payrollDetails2.default.createDefaults(payroll, [employee]) : fetchDetailsForPayroll(payroll, employee);
	        }
	
	        if (cachedLastDetails || !lastPayroll) {
	            lastDetailsPromise = (0, _bluebird.resolve)([]);
	        } else {
	            lastDetailsPromise = fetchDetailsForPayroll(lastPayroll, employee);
	        }
	
	        return (0, _bluebird.all)([detailsPromise.then(function (details) {
	            if (details && details.length) {
	                return details;
	            }
	            if (!cachedDetails) {
	                return _payrollDetails2.default.createDefaults(payroll, [employee]);
	            }
	            return [];
	        }).then(function (collection) {
	            // Do not append if already cached
	            if (!cachedDetails && collection.length > 0) {
	                collection.models.forEach(function (detail) {
	                    _this.options.payrollDetails.add(detail);
	                });
	            }
	        }), lastDetailsPromise.then(function (collection) {
	            // Do not append if already cached
	            if (!cachedLastDetails && collection.length > 0) {
	                collection.models.forEach(function (detail) {
	                    _this.options.lastPayrollDetails.add(detail);
	                });
	            }
	        })]);
	    },
	
	    render: function render() {
	        this.$el.html((0, _EmployeeSlides2.default)({
	            currentEmployee: this.currentEmployee,
	            employees: this.options.employees
	        }));
	
	        this.$slides = this.$('.js-employee-slides');
	        this.$prevSlide = this.$('.js-prev-slide');
	        this.$nextSlide = this.$('.js-next-slide');
	        this.$employeeSelect = this.$('.js-employee-select');
	
	        this.$slides.slick({
	            slidesToShow: 1,
	            swipe: false,
	            infinite: false,
	            arrows: false,
	            draggable: false,
	            touchMove: false,
	            accesibility: false
	        });
	
	        _tooltip2.default.init(this);
	    },
	
	    renderSlide: function renderSlide(employee) {
	        var view = new _Employee2.default({
	            model: employee,
	            payroll: this.options.payroll,
	            pendingJobs: this.options.pendingJobs,
	            payrollDetails: this.options.payrollDetails,
	            lastPayrollDetails: this.options.lastPayrollDetails,
	            payrollItems: this.options.payrollItems,
	            className: 'employee footable-employee js-is-card'
	        });
	        this.$('.js-slide-' + employee.id).append(view.$el);
	        return view;
	    },
	
	    renderCount: function renderCount(current) {
	        var total = this.options.employees.length;
	        var progress = Math.round(100 * (current / total));
	        var text = ' of ' + total + ' ';
	        text += total === 1 ? 'Employee' : 'Employees';
	        this.$('.js-employee-counter').text('').append($('<strong>').text(current)).append(text);
	        this.$('.js-progress-bar').css('width', progress + '%');
	    },
	
	    prevSlide: function prevSlide() {
	        var _this2 = this;
	
	        this.$prevSlide.tooltip('hide').addClass('loading');
	        this.activeSlideView.lock();
	        this.save().then(function () {
	            var employee = _this2.options.employees.at(Math.max(0, _this2.$slides.slick('slickCurrentSlide') - 1));
	            return _this2.fetchDetails(employee);
	        }).then(function () {
	            return _this2.$slides.slick('slickPrev');
	        }).finally(function () {
	            return _this2.$prevSlide.removeClass('loading');
	        });
	    },
	
	    nextSlide: function nextSlide() {
	        var _this3 = this;
	
	        this.$nextSlide.tooltip('hide').addClass('loading');
	        this.activeSlideView.lock();
	        this.save().then(function () {
	            var employee = _this3.options.employees.at(Math.max(0, _this3.$slides.slick('slickCurrentSlide') + 1));
	            return _this3.fetchDetails(employee);
	        }).then(function () {
	            return _this3.$slides.slick('slickNext');
	        }).finally(function () {
	            return _this3.$nextSlide.removeClass('loading');
	        });
	    },
	
	    selectEmployee: function selectEmployee(ev) {
	        var _this4 = this;
	
	        var $input = $(ev.currentTarget);
	
	        ev.preventDefault();
	
	        var search = $input.val();
	        var matchingEmployee = this.options.employees.find(function (emp) {
	            return emp.get('employeeId') && emp.get('employeeId') === search || emp.get('fullName') === search;
	        });
	        if (!matchingEmployee) {
	            return;
	        }
	        var matchingIndex = this.options.employees.findIndex(function (emp) {
	            return emp.get('objectId') === matchingEmployee.get('objectId');
	        });
	        this.currentEmployee = matchingEmployee;
	
	        var currentSlide = this.$slides.slick('slickCurrentSlide');
	        var $button = currentSlide < matchingIndex ? this.$nextSlide : this.$prevSlide;
	
	        $button.addClass('loading');
	        this.activeSlideView.lock();
	
	        $input.val('');
	
	        this.save().then(function () {
	            return _this4.fetchDetails(_this4.currentEmployee);
	        }).then(function () {
	            return _this4.$slides.slick('slickGoTo', matchingIndex);
	        }).finally(function () {
	            $button.removeClass('loading');
	        });
	    },
	
	    save: function save($el) {
	        var _this5 = this;
	
	        if ($el) {
	            $el.addClass('loading');
	        }
	
	        this.$prevSlide.addClass('slick-disabled');
	        this.$nextSlide.addClass('slick-disabled');
	        this.$employeeSelect.prop({ disabled: true }).attr({ disabled: true }).trigger('chosen:updated');
	
	        var save = !this.options.payroll.get('running') && !this.options.pendingJobs;
	        var promise = save ? this.options.payroll.save(null, { validate: false }) : (0, _bluebird.resolve)();
	
	        return promise.then(function () {
	            return save ? _this5.options.payrollDetails.save() : (0, _bluebird.resolve)();
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            if ($el) {
	                $el.removeClass('loading');
	            }
	
	            _this5.$prevSlide.addClass('slick-disabled');
	            _this5.$nextSlide.addClass('slick-disabled');
	            _this5.$employeeSelect.prop({ disabled: false }).attr({ disabled: false }).trigger('chosen:updated');
	        });
	    },
	
	    beforeChangeSlide: function beforeChangeSlide(event, slick, currentSlide, nextSlide) {
	        this.nextSlideView = this.renderSlide(this.options.employees.at(nextSlide));
	        this.nextSlideView.$el.removeClass('invisible').trigger('show');
	
	        this.toggleSlideButtons(nextSlide + 1);
	        this.renderCount(nextSlide + 1);
	    },
	
	    afterChangeSlide: function afterChangeSlide() {
	        var prevSlideView = this.activeSlideView;
	
	        this.viewedSlides = _.uniq(this.viewedSlides.concat([this.$slides.slick('slickCurrentSlide')]));
	
	        this.activeSlideView = this.nextSlideView;
	
	        prevSlideView.remove();
	    },
	
	    toggleSlideButtons: function toggleSlideButtons(slide) {
	        this.$prevSlide.toggleClass('slick-disabled', slide === 1);
	        this.$nextSlide.toggleClass('slick-disabled', slide === this.options.employees.length);
	    },
	
	    activate: function activate() {
	        var _this6 = this;
	
	        if (this.activeSlideView !== null) {
	            return;
	        }
	
	        var employee = this.currentEmployee || this.options.employees.first();
	        this.fetchDetails(employee).then(function () {
	            _this6.activeSlideView = _this6.renderSlide(employee);
	            _this6.activeSlideView.$el.removeClass('invisible').trigger('show');
	
	            _this6.viewedSlides.push(0);
	            _this6.toggleSlideButtons(1);
	            _this6.renderCount(1);
	
	            setTimeout(function () {
	                _this6.$slides.slick('setPosition').removeClass('invisible');
	            }, 1);
	        });
	    },
	
	    remove: function remove() {
	        Backbone.View.prototype.remove.apply(this, arguments);
	
	        this.undelegateEvents();
	        if (this.activeSlideView) {
	            this.activeSlideView.remove();
	        }
	
	        if (this.nextSlideView) {
	            this.nextSlideView.remove();
	        }
	    },
	
	    confirmMissingEmployees: function confirmMissingEmployees() {
	        // By default include all employees to the payroll
	        return (0, _bluebird.resolve)(true);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepOne/EmployeeSlides.ejs -->\n<div class="row m-b-md">\n    <div class="col-sm-4">\n        <div class="employee-counter js-employee-counter"></div>\n        <div class="progress progress-mini">\n            <div style="width: 0;"\n                class="progress-bar progress-bar-success js-progress-bar">\n            </div>\n        </div>\n    </div>\n\n    <div class="col-sm-8">\n        <div class="row">\n            <label class="col-sm-3 employee-label text-right">\n                Employee\n            </label>\n            <div class="col-sm-9">\n                <input name="employee-select"\n                    class="chosen-select js-employee-select"\n                    placeholder="Search and select employees"\n                    list="employeeList" style="width:80%"\n                >\n                <datalist id="employeeList">\n                    ';
	 employees.forEach(function (employee) { 
	__p+='\n                        <option value="'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'">\n                            '+
	((__t=( employee.get('employeeId') || '' ))==null?'':_.escape(__t))+
	'\n                        </option>\n                    ';
	 }) 
	__p+='\n                </datalist>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="row">\n    <div class="col-xs-12">\n        <div class="slick-wrapper">\n            <div class="slick-prev js-prev-slide"\n                data-toggle="tooltip" data-placement="top"\n                data-container="body" data-html="true"\n                data-original-title="Save and view <br>the previous employee"\n                data-delayed>\n                '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n            </div>\n\n            <div class="slick-next js-next-slide"\n                data-toggle="tooltip" data-placement="top"\n                data-container="body" data-html="true"\n                data-original-title="Save and view <br>the next employee"\n                data-delayed>\n                '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n            </div>\n\n            <div  class="invisible js-employee-slides">\n                ';
	 employees.forEach(function(employee) { 
	__p+='\n                    <div class="js-slide js-slide-'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	' employee-card"></div>\n                ';
	 }) 
	__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	'use strict';
	
	function _key(key) {
	    return (app.company.id || '') + ':' + key;
	}
	
	function getItem(key) {
	    return window.localStorage.getItem(_key(key));
	}
	
	function setItem(key, data) {
	    return window.localStorage.setItem(_key(key), data);
	}
	
	function removeItem(key) {
	    return window.localStorage.removeItem(_key(key));
	}
	
	module.exports = {
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem
	};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Main = __webpack_require__(743);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Summary = __webpack_require__(744);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _Payslips = __webpack_require__(747);
	
	var _Payslips2 = _interopRequireDefault(_Payslips);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _payroll = __webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-back-button': 'back',
	        'click .js-cancel-button': 'cancel',
	        'click .js-save-button': 'save',
	        'shown.bs.tab a[data-toggle="tab"]': 'switchTab'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            payslips: null,
	            payslipDetails: null,
	            payrollSummary: null,
	            companyLocation: null
	        });
	
	        this.render();
	    },
	
	    render: function render() {
	        var summaryPdf = this.options.attachments ? this.options.attachments.findByTags(['payroll', 'summary', 'pdf']).first() : null;
	
	        this.$el.html((0, _Main2.default)({
	            model: this.model,
	            viewMode: this.options.viewMode,
	            tab: this.options.tab,
	            summaryPdf: summaryPdf
	        }));
	
	        this.tabViews = [new _Summary2.default({
	            el: this.$('.js-summary-view'),
	            model: this.model,
	            collection: this.options.payrollSummary,
	            attachments: this.options.attachments
	        }), new _Payslips2.default({
	            el: this.$('.js-payslips-view'),
	            model: this.model,
	            payslips: this.options.payslips,
	            payslipDetails: this.options.payslipDetails,
	            companyLocation: this.options.companyLocation
	        })];
	
	        if (this.options.tab) {
	            this.$('.js-' + this.options.tab + '-button').tab('show');
	        }
	
	        _tooltip2.default.init(this);
	
	        return this;
	    },
	
	    switchTab: function switchTab() {
	        var activeTab = _.find(this.tabViews, function (view) {
	            return view.$el.hasClass('active');
	        });
	
	        if (this.options.viewMode) {
	            var tab = activeTab.$el.attr('data-name');
	            app.mainRouter.navigate('payroll/view/' + this.model.id + '/' + tab, { trigger: false });
	        }
	
	        activeTab.show();
	    },
	
	    back: function back() {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullPage();
	
	        return this.model.fetch().then(function () {
	            if (_this.model.get('status') !== _payroll.payrollStatus.RAN) {
	                var err = new Error('invalid status');
	                err.statusCode = 400;
	                throw err;
	            }
	            return _this.model.setStatus(_payroll.payrollStatus.INITIAL).then(function () {
	                app.mainRouter.navigate('payroll/step/1', { trigger: true });
	            });
	        }).catch(function (err) {
	            if (err.statusCode === 400 || err.response && err.response.error && err.response.error.statusCode === 400) {
	                _alerts2.default.show('warning', {
	                    title: 'Warning',
	                    text: 'Please note that your payroll has been                             modified. To view accurate calculations,                             please reload the page.',
	                    allowEscapeKey: false,
	                    callback: window.location.reload.bind(window.location)
	                });
	            } else {
	                _alerts2.default.show('criticalError', err);
	            }
	        }).finally(stopLoader);
	    },
	
	    cancel: function cancel() {
	        var _this2 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            text: 'You will not be able to recover this payroll',
	            confirmButtonText: 'Yes, Restart',
	            loader: true,
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this2.model.destroy().then(function () {
	                    _this2.options.payslips.reset([]);
	                    _this2.options.payslipDetails.reset([]);
	
	                    app.mainRouter.navigate('payroll/step/1', { trigger: true });
	
	                    _this2.cancelSuccess();
	                }).catch(function (err) {
	                    _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    cancelSuccess: function cancelSuccess() {
	        _alerts2.default.show('success', {
	            title: 'Payroll Reset!',
	            text: 'Your Payroll has been reset.'
	        });
	    },
	
	    save: function save(ev) {
	        var $el = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullPage($el);
	
	        return this.model.setStatus(_payroll.payrollStatus.CONFIRMED).then(function () {
	            app.mainRouter.navigate('payroll/step/3', { trigger: true });
	        }).catch(function (err) {
	            if (err.statusCode === 400 || err.response && err.response.error && err.response.error.statusCode === 400) {
	                _alerts2.default.show('warning', {
	                    title: 'Warning',
	                    text: 'Please note that your payroll has been                             modified. To view accurate calculations,                             please reload the page.',
	                    allowEscapeKey: false,
	                    callback: window.location.reload.bind(window.location)
	                });
	            } else {
	                _alerts2.default.show('criticalError', err);
	            }
	        }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/Main.html -->\n';
	 idSuffix = Math.floor(Math.random() * 10000000) 
	__p+='\n\n<div class="row">\n<div class="col-xs-12">\n<div class="ibox float-e-margins">\n    <div class="tabs-container">\n        <ul class="nav nav-tabs">\n            <li class="'+
	((__t=( (!tab || tab === 'summary') ? 'active' : '' ))==null?'':_.escape(__t))+
	'">\n                <a data-toggle="tab"\n                href="#tab-summary-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                    class="js-summary-button ">\n                    Summary\n                </a>\n            </li>\n            <li class="'+
	((__t=( (tab === 'payslips') ? 'active' : '' ))==null?'':_.escape(__t))+
	'">\n                <a data-toggle="tab" href="#tab-payslips-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                    class="js-payslips-button">\n                    Payslips\n                </a>\n            </li>\n        </ul>\n        <div class="tab-content">\n            <div id="tab-summary-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'" data-name="summary"\n                class="tab-pane js-summary-view payroll-summary-wrapper\n                    '+
	((__t=( (!tab || tab === 'summary') ? 'active' : '' ))==null?'':_.escape(__t))+
	'">\n\n                <div id="loader" class="loader loader-payroll">\n                    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                </div>\n            </div>\n            <div id="tab-payslips-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'" data-name="payslips"\n                class="tab-pane js-payslips-view\n                    '+
	((__t=( (tab === 'payslips') ? 'active' : '' ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n    </div>\n    <div class="wizard-footer">\n    ';
	 if (viewMode) { 
	__p+='\n        <div class="text-right">\n            <a href="#payroll/history" type="button"\n            class="btn btn-w-m btn-white btn-transparent"\n            data-toggle="tooltip"\n            data-title="Back to Payroll History"\n            data-placement="top" data-delayed>\n                <i class="fa fa-arrow-left"></i>\n                Back to Payroll History\n            </a>\n        </div>\n    ';
	 } else { 
	__p+='\n        <a type="button"\n            class="btn btn-w-m btn-primary"\n            data-toggle="tooltip"\n            data-title="Download sample to check payroll summary"\n            data-placement="top" data-delayed\n            target="_blank"\n            href="'+
	((__t=( summaryPdf ? summaryPdf.downloadUrl() : '' ))==null?'':_.escape(__t))+
	'">\n\n            <i class="fa fa-download"></i>\n            '+
	((__t=( summaryPdf ? 'Download' : 'Not Ready' ))==null?'':_.escape(__t))+
	'\n        </a>\n\n        <div class="float-right">\n            <button type="button"\n            class="btn btn-w-m btn-white btn-transparent js-back-button"\n            data-toggle="tooltip"\n            data-title="Make changes to the employees"\n            data-placement="top" data-delayed>\n                <i class="fa fa-arrow-left"></i>\n                Back to Adjustments\n            </button>\n            <button type="button"\n                    class="btn btn-w-m btn-warning js-cancel-button"\n                    data-toggle="tooltip"\n                    data-title="No changes will be saved"\n                    data-placement="top" data-delayed>\n                <i class="fa fa-exclamation-triangle"></i>\n                Cancel &amp; Restart\n            </button>\n            <button type="button" data-loading-text="Saving..."\n                    class="btn btn-w-m btn-primary js-save-button">\n                <i class="fa fa-check"></i>\n                Save &amp; Continue\n            </button>\n        </div>\n    ';
	 } 
	__p+='\n    </div>\n</div>\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var template = __webpack_require__(745);
	var PaginatedList = __webpack_require__(638);
	var Decimal = __webpack_require__(586);
	
	module.exports = PaginatedList.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {});
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        return this;
	    },
	
	    render: function render() {
	        var _this = this,
	            _arguments = arguments;
	
	        return (0, _bluebird.all)(this.collection.map(function (payslip) {
	            return payslip.fetchDetails(999, false).then(function () {
	                return payslip.fetchEmployee();
	            }).then(function (employee) {
	                return employee.fetchPosition();
	            });
	        })).then(function () {
	            _this.$el.html(template({
	                payroll: _this.model,
	                totals: {
	                    mtd: new Decimal(_this.model.get('mtd') || 0).plus(_this.model.get('cp38') || 0).toDP(2, Decimal.ROUND_HALF_UP).toNumber(),
	                    epf: new Decimal(_this.model.get('employerEpf') || 0).plus(_this.model.get('employeeEpf') || 0).toDP(2, Decimal.ROUND_HALF_UP).toNumber(),
	                    socso: new Decimal(_this.model.get('employerSocso') || 0).plus(_this.model.get('employeeSocso') || 0).toDP(2, Decimal.ROUND_HALF_UP).toNumber(),
	                    eis: new Decimal(_this.model.get('employerEis') || 0).plus(_this.model.get('employeeEis') || 0).toDP(2, Decimal.ROUND_HALF_UP).toNumber()
	                },
	                company: _this.model.getCompany(),
	                payslips: _this.collection,
	                pagination: _this.collection.getPaginationInfo(),
	                pageTotals: _this.collection.getTotals(),
	                // The hack here is to enable the MTD tooltip for the hidden
	                // payrollpanda company. Needed to get that done in less than
	                // a couple of hours so I hardcoded the ID. Sorry!
	                mtdTooltip: app.user.isAdmin() || ['KoPWwKrGwV', 'LEvydMX0ZJ', '0e59RwHVjb', 'AsJarFrvEQ', 'zJT6Mg83es', 'MKlfhlqFCT'].indexOf((app.company || {}).id) >= 0
	            }));
	
	            return PaginatedList.prototype.render.apply(_this, _arguments);
	        });
	    },
	
	    show: function show() {}
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/Summary.ejs -->\n';
	 zakatColEnabled = payroll.get('zakat') > 0 
	__p+='\n\n<div class="panel-body payroll-summary">\n    <div>\n        <strong>'+
	((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
	'</strong>\n        ';
	 if (company.get('regNumber')) { 
	__p+='\n            <small>('+
	((__t=( company.get('regNumber') ))==null?'':_.escape(__t))+
	')</small>\n        ';
	 } 
	__p+='\n    </div>\n\n    <h3>Payroll Summary For: End of '+
	((__t=( payroll.getPeriodFormatted() ))==null?'':_.escape(__t))+
	'</h3>\n\n    <table class="footable footable-summary footable-ellipsis table\n        table-stripped" data-striping="false">\n        <thead>\n            <tr class="first-header">\n                <th style=""></th>\n                <th style="width: 6%;"></th>\n                <th style="width: 13%;"></th>\n                <th style="width: 13%;"></th>\n                <th style="width: 6%;"></th>\n                ';
	 if (zakatColEnabled) { 
	__p+='\n                    <th style="width: 6%;"></th>\n                ';
	 } 
	__p+='\n                <th style="width: 19%;" class="employee contributions"\n                    colspan="4">\n                    Employee Contributions\n                </th>\n                <th style="width: 19%;" class="employer contributions"\n                    colspan="4">\n                    Employer Contributions\n                </th>\n                <th style="width: 6%;"></th>\n            </tr>\n            <tr class="second-header">\n                <th>Employee</th>\n                <th>Basic</th>\n                <th>Additions</th>\n                <th>Deductions</th>\n                <th>Gross</th>\n                ';
	 if (zakatColEnabled) { 
	__p+='\n                    <th class="">Zakat</th>\n                ';
	 } 
	__p+='\n                <th class="employee">PCB</th>\n                <th class="employee">EPF</th>\n                <th class="employee">SOCSO</th>\n                <th class="employee">EIS</th>\n                <th class="employer">EPF</th>\n                <th class="employer">SOCSO</th>\n                <th class="employer">EIS</th>\n                <th class="employer">HRDF</th>\n                <th>Net Pay</th>\n            </tr>\n        </thead>\n        <tbody>\n        ';
	 payslips.forEach(function(payslip) { 
	__p+='\n            ';
	 employee = payslip.getEmployee() 
	__p+='\n            ';
	 details = payslip.getDetails() 
	__p+='\n            ';
	 additions = details.findByTypes(['addition', 'bonus', 'overtime']) 
	__p+='\n            ';
	 deductions = details.findByTypes(['unpaid_leave', 'deduction']) 
	__p+='\n            <tr>\n                <td data-column="employeeName">\n                    <strong>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</strong>\n                    <div>'+
	((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
	'</div>\n                </td>\n                <td data-column="base">\n                    '+
	((__t=( payslip.get('base').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td data-column="additions">\n                    '+
	((__t=( payslip.get('additions').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    <div class="additions">\n                        ';
	 additions.forEach(function(addition) { 
	__p+='\n                            ';
	 if (!addition.get('amount')) return; 
	__p+='\n\n                            <div data-toggle="tooltip"\n                                data-placement="top" data-container="body"\n                                data-original-title="'+
	((__t=( addition.getPayrollItemName() ))==null?'':_.escape(__t))+
	'">\n                                ';
	 /* formatted like this to avoid space before the colon */ 
	__p+='\n                                '+
	((__t=( addition.get('amount').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'';
	 if (addition.isUnit()) { 
	__p+='\n                                    (\n                                        '+
	((__t=( (addition.get('unit') || 0) ))==null?'':_.escape(__t))+
	' @\n                                        '+
	((__t=( (addition.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                                    )\n                                ';
	 } 
	__p+=': '+
	((__t=( addition.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                            </div>\n                        ';
	 }) 
	__p+='\n                    </div>\n                </td>\n                <td data-column="deductions">\n                    '+
	((__t=( payslip.get('deductions').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n\n                    <div class="deductions">\n                        ';
	 deductions.forEach(function(deduction) { 
	__p+='\n                            ';
	 if (
	                                !deduction.get('amount') ||
	                                !deduction.getPayrollItem().get('isNet')
	                            ) return; 
	__p+='\n\n                            <div data-toggle="tooltip"\n                                data-placement="top" data-container="body"\n                                data-original-title="'+
	((__t=( deduction.getPayrollItemName() ))==null?'':_.escape(__t))+
	'">\n                                ';
	 /* formatted like this to avoid space before the colon */ 
	__p+='\n                                - '+
	((__t=( deduction.get('amount').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'';
	 if (deduction.isUnit()) { 
	__p+='\n                                    (\n                                        '+
	((__t=( (deduction.get('unit') || 0) ))==null?'':_.escape(__t))+
	' @\n                                        '+
	((__t=( (deduction.get('rate') || 0) ))==null?'':_.escape(__t))+
	'\n                                    )\n                                ';
	 } 
	__p+=': '+
	((__t=( deduction.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                            </div>\n                        ';
	 }) 
	__p+='\n                    </div>\n\n                </td>\n                <td data-column="grossPay">\n                    <strong>\n                        '+
	((__t=( payslip.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </strong>\n                </td>\n                ';
	 if (zakatColEnabled) { 
	__p+='\n                    <td data-column="zakat">\n                        '+
	((__t=( payslip.get('zakat').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </td>\n                ';
	 } 
	__p+='\n                <td class="employee" data-column="mtd">\n                    ';
	 mtdDetail = details.findByType('mtd').find(function (d) {
	                        return d.getPayrollItem().get('subtype') !==
	                            'custom';
	                    }) 
	__p+='\n                    ';
	 if (
	                        mtdTooltip &&
	                        mtdDetail &&
	                        mtdDetail.get('additionalInformation')
	                    ) { 
	__p+='\n                        <div data-toggle="tooltip"\n                            data-placement="right" data-container="body"\n                            data-html="true"\n                            data-delay="10000"\n                            data-original-title="\n                                '+
	((__t=( __webpack_require__(746)({
	                                    data: mtdDetail.get('additionalInformation')
	                                }) ))==null?'':__t)+
	'">\n                            '+
	((__t=( payslip.get('mtd').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </div>\n                    ';
	 } else { 
	__p+='\n                        '+
	((__t=( payslip.get('mtd').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    ';
	 } 
	__p+='\n\n                    ';
	 if ((payslip.get('cp38') || 0) > 0) { 
	__p+='\n                        <div data-toggle="tooltip"\n                            data-placement="right" data-container="body"\n                            data-original-title="CP38">\n                            '+
	((__t=( payslip.get('cp38').formatWithoutRounding() ))==null?'':_.escape(__t))+
	': CP38\n                        </div>\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="employee" data-column="employeeEpf">\n                    '+
	((__t=( payslip.get('employeeEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="employee" data-column="employeeSocso">\n                    '+
	((__t=( payslip.get('employeeSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="employee" data-column="employeeEis">\n                    '+
	((__t=( (payslip.get('employeeEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="employer" data-column="employeeEpf">\n                    '+
	((__t=( payslip.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="employer" data-column="employerSocso">\n                    '+
	((__t=( payslip.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="employer" data-column="employerEis">\n                    '+
	((__t=( (payslip.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="employer" data-column="hrdf">\n                    '+
	((__t=( (payslip.get('totalHrdf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td data-column="netPay">\n                    <strong>'+
	((__t=( payslip.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</strong>\n                </td>\n            </tr>\n        ';
	 }) 
	__p+='\n        ';
	 if (pagination && pagination.pages > 1) { 
	__p+='\n            <tr>\n                <td>\n                    <strong>Page Total:</strong>\n                </td>\n                <td data-column="page-base">'+
	((__t=( pageTotals.base.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td data-column="page-additions">'+
	((__t=( pageTotals.additions.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td data-column="page-deductions">'+
	((__t=( pageTotals.deductions.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td data-column="page-grossPay"><strong>'+
	((__t=( pageTotals.grossPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</strong></td>\n                ';
	 if (zakatColEnabled) { 
	__p+='\n                    <td data-column="page-zakat">'+
	((__t=( pageTotals.zakat.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                ';
	 } 
	__p+='\n                <td class="employee" data-column="page-mtd">'+
	((__t=( (pageTotals.mtd + pageTotals.cp38).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employee" data-column="page-employeeEpf">'+
	((__t=( pageTotals.employeeEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employee" data-column="page-employeeSocso">'+
	((__t=( pageTotals.employeeSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employee" data-column="page-employeeEis">'+
	((__t=( pageTotals.employeeEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employer" data-column="page-employerEpf">'+
	((__t=( pageTotals.employerEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employer" data-column="page-employerSocso">'+
	((__t=( pageTotals.employerSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employer" data-column="page-employerEis">'+
	((__t=( pageTotals.employerEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="employer" data-column="page-hrdf">'+
	((__t=( (pageTotals.hrdf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td data-column="page-netPay"><strong>'+
	((__t=( pageTotals.netPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</strong</td>\n            </tr>\n        ';
	 } 
	__p+='\n        <tr>\n            <td>\n                <strong>Grand Total:</strong>\n            </td>\n            <td data-column="total-base">'+
	((__t=( payroll.get('base').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td data-column="total-additions">'+
	((__t=( (payroll.get('additions') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td data-column="total-deductions">'+
	((__t=( payroll.get('deductions').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td data-column="total-grossPay"><strong>'+
	((__t=( payroll.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</strong></td>\n            ';
	 if (zakatColEnabled) { 
	__p+='\n                <td data-column="zakat">'+
	((__t=( payroll.get('zakat').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            ';
	 } 
	__p+='\n            <td class="employee" data-column="total-mtd">'+
	((__t=( (totals.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employee" data-column="total-employeeEpf">'+
	((__t=( payroll.get('employeeEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employee" data-column="total-employeeSocso">'+
	((__t=( payroll.get('employeeSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employee" data-column="total-employeeEis">'+
	((__t=( (payroll.get('employeeEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employer" data-column="total-employerEpf">'+
	((__t=( payroll.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employer" data-column="total-employerSocso">'+
	((__t=( payroll.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employer" data-column="total-employerEis">'+
	((__t=( (payroll.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td class="employer" data-column="total-hrdf">'+
	((__t=( (payroll.get('employerHRDF') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            <td data-column="total-netPay"><strong>'+
	((__t=( payroll.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</strong</td>\n        </tr>\n        </tbody>\n    </table>\n\n    ';
	 if (pagination && pagination.pages > 1) { 
	__p+='\n        <div class="container-fluid">\n            <ul class="pagination pull-right clearfix">\n                <li class="page-item '+
	((__t=( pagination.page <= 0 ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'">\n                    <a aria-label="Previous" class="js-pagination-prev">\n                        <span aria-hidden="true">Previous</span>\n                    </a>\n                </li>\n                ';
	 _.times(pagination.pages, function(i) { 
	__p+='\n                    <li class="page-item '+
	((__t=( pagination.page == i ? 'active' : '' ))==null?'':_.escape(__t))+
	'">\n                        <a aria-label="Page '+
	((__t=( i + 1 ))==null?'':_.escape(__t))+
	'" data-page="'+
	((__t=( i ))==null?'':_.escape(__t))+
	'"\n                           class="js-pagination-page">\n                            <span aria-hidden="true">'+
	((__t=( i + 1 ))==null?'':_.escape(__t))+
	'</span>\n                        </a>\n                    </li>\n                ';
	 }) 
	__p+='\n                <li class="page-item '+
	((__t=( pagination.page >= (pagination.pages - 1) ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'">\n                    <a aria-label="Next" class="js-pagination-next">\n                        <span aria-hidden="true">Next</span>\n                    </a>\n                </li>\n            </ul>\n            <span class="pull-right pagination-info">\n                Showing\n                '+
	((__t=( pagination.offset + 1 ))==null?'':_.escape(__t))+
	' to\n                '+
	((__t=( Math.min(pagination.count, pagination.offset + pagination.limit) ))==null?'':_.escape(__t))+
	'\n                of '+
	((__t=( pagination.count ))==null?'':_.escape(__t))+
	' employees\n            </span>\n        </div>\n    ';
	 } 
	__p+='\n\n    <div class="row total">\n        <div class="col-lg-8 col-md-12">\n            <div class="col-md-6 col-sm-12">\n                <div class="total-row">\n                    Number of Employees:\n                    <span class="pull-right">'+
	((__t=( pagination.count ))==null?'':_.escape(__t))+
	'</span>\n                </div>\n                <div class="total-row">\n                    Total Employee Net Pay:\n                    <span class="pull-right">\n                        '+
	((__t=( payroll.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </span>\n                </div>\n            </div>\n            <div class="col-sm-6">\n                <div class="total-row">\n                    Total PCB payment:\n                    <span class="pull-right">\n                        '+
	((__t=( (totals.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </span>\n                </div>\n                <div class="total-row">\n                    Total EPF payment:\n                    <span class="pull-right">\n                        '+
	((__t=( (totals.epf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </span>\n                </div>\n                <div class="total-row">\n                    Total SOCSO payment:\n                    <span class="pull-right">\n                        '+
	((__t=( (totals.socso || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </span>\n                </div>\n                <div class="total-row">\n                    Total EIS payment:\n                    <span class="pull-right">\n                        '+
	((__t=( (totals.eis).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </span>\n                </div>\n\n                <div class="total-row">\n                    Total HRDF payment:\n                    <span class="pull-right">\n                        '+
	((__t=( (payroll.get('employerHRDF') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </span>\n                </div>\n\n                ';
	 if (payroll.get('zakat')) { 
	__p+='\n                    <div class="total-row">\n                        Total Zakat payment:\n                        <span class="pull-right">\n                            '+
	((__t=( (payroll.get('zakat') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </span>\n                    </div>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/MTDTooltip.ejs -->\n';
	 /*
	This template sucks ass and I'm aware. It was originally a Quick&Dirty proof
	of concept that admins liked and requested changes to it to be deployed ASAP.
	
	This content shouldn't even be a tooltip to begin with.
	*/ 
	__p+='\n';
	 var Decimal = __webpack_require__(586); 
	__p+='\n<h4>Calculation Parameters:</h4>\n\n';
	 if (data && data.regularIncome) { 
	__p+='\n    <h5>Regular Income:</h5>\n\n    <pre>\nChargeable Income (P) =\n(('+
	((__t=( (data.taxableYtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.ytdEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') +\n('+
	((__t=( (data.taxableRegular || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.regularEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') +\n('+
	((__t=( (data.taxableEstimate || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.estimateEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	')) -\n'+
	((__t=( (data.totalTaxDeduction || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n\nChargeable Income (P) = '+
	((__t=( data.regularIncome.chargeable ))==null?'':_.escape(__t))+
	'\n    </pre>\n\n    <pre>\nAnnual Tax = (('+
	((__t=( (data.regularIncome.chargeable || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.regularIncome.firstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') *\n'+
	((__t=( (data.regularIncome.taxRate || 0).format('0,0.000') ))==null?'':_.escape(__t))+
	') + ('+
	((__t=( (data.regularIncome.taxesOnFirstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	')\n\nAnnual Tax = '+
	((__t=( (data.regularIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n    </pre>\n';
	 } 
	__p+='\n\n';
	 if (data && data.additionalIncome) { 
	__p+='\n    <h5>Additional Income:</h5>\n\n    <pre>\nChargeable Income (P\') = (('+
	((__t=( (data.taxableYtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.ytdEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') +\n('+
	((__t=( (data.taxableAdditional || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.epf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') +\n('+
	((__t=( (data.taxableEstimate || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.estimateEpfAdditional || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	')) -\n'+
	((__t=( (data.totalTaxDeduction || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n\nChargeable Income (P\') = '+
	((__t=( data.additionalIncome.chargeable ))==null?'':_.escape(__t))+
	'\n    </pre>\n\n    <pre>\nMTD\'(PCB\') = (('+
	((__t=( (data.additionalIncome.chargeable || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.additionalIncome.firstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') *\n'+
	((__t=( (data.additionalIncome.taxRate || 0).format('0,0.000') ))==null?'':_.escape(__t))+
	') + ('+
	((__t=( (data.additionalIncome.taxesOnFirstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	')\nMTD\'(PCB\') = '+
	((__t=( (data.additionalIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n\nMTD\'\'(PCB\'\') = (('+
	((__t=( (data.regularIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.ytdMtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' -\n'+
	((__t=( (data.ytdZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') / (13 - '+
	((__t=( (data.month || 0) ))==null?'':_.escape(__t))+
	')) - '+
	((__t=( (data.totalZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\nMTD\'\'(PCB\'\') = '+
	((__t=( (data.regularIncome.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' (0 if number was less than 10)\n\nMTD(PCB) = MTD\'\'(PCB\'\') + '+
	((__t=( (data.additionalIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'  -\n('+
	((__t=( (data.ytdMtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' + ('+
	((__t=( (data.regularIncome.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' * (13 - '+
	((__t=( (data.month || 0) ))==null?'':_.escape(__t))+
	'))\n\nMTD(PCB) = '+
	((__t=( (data.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' (Number rounded to spec)\n    </pre>\n\n';
	 } else if (data.regularIncome) { 
	__p+='\n    <pre>\nMTD(PCB) = (('+
	((__t=( (data.regularIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( (data.ytdMtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' -\n'+
	((__t=( (data.ytdZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	') / (13 - '+
	((__t=( (data.month || 0) ))==null?'':_.escape(__t))+
	')) - '+
	((__t=( (data.totalZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n\nMTD(PCB) = '+
	((__t=( (data.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	' (Number rounded to spec)\n    </pre>\n';
	 } 
	__p+='\n\n';
	 if (data && data.totalTaxDeduction) { 
	__p+='\n    <h4>Deductions applied:</h4>\n    <pre>\nTotal: '+
	((__t=( (data.totalTaxDeduction || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n    </pre>\n';
	 } 
	__p+='\n\n';
	 if (data && data.compulsoryDeductions) { 
	__p+='\n    <h5>Compulsory</h5>\n    <ul>\n        <li>Individual: RM '+
	((__t=( data.compulsoryDeductions.individual ))==null?'':_.escape(__t))+
	'</li>\n        <li>Disability: RM '+
	((__t=( data.compulsoryDeductions.isDisabled ))==null?'':_.escape(__t))+
	'</li>\n        <li>Spouse: RM '+
	((__t=( data.compulsoryDeductions.spouse ))==null?'':_.escape(__t))+
	'</li>\n        <li>Spouse disability: RM '+
	((__t=( data.compulsoryDeductions.spouseIsDisabled ))==null?'':_.escape(__t))+
	'</li>\n        <li>\n            Children:\n            <ul>\n                <li>Underage: RM '+
	((__t=( data.compulsoryDeductions.child.underage ))==null?'':_.escape(__t))+
	'</li>\n                <li>Disabled: RM '+
	((__t=( data.compulsoryDeductions.child.disabled ))==null?'':_.escape(__t))+
	'</li>\n                <li>In education: RM '+
	((__t=( data.compulsoryDeductions.child.inEducation ))==null?'':_.escape(__t))+
	'</li>\n                <li>In education+: RM '+
	((__t=( data.compulsoryDeductions.child.inHigherEducation ))==null?'':_.escape(__t))+
	'</li>\n                <li>In education++: RM '+
	((__t=( data.compulsoryDeductions.child.disabledInEducation ))==null?'':_.escape(__t))+
	'</li>\n            </ul>\n        </li>\n    </ul>\n';
	 } 
	__p+='\n\n';
	 if (data && data.taxDeductions) { 
	__p+='\n    <h5>Others</h5>\n    <ul>\n        ';
	 if (data.taxDeductions.length === 0) { 
	__p+='\n            <li>No additional tax deductions</li>\n        ';
	 } else { 
	__p+='\n            ';
	 data.taxDeductions.forEach(function (deduction) { 
	__p+='\n                <li>\n                    '+
	((__t=( deduction.name ))==null?'':_.escape(__t))+
	':\n                    RM '+
	((__t=( new Decimal(deduction.amount).minus(deduction.ytd || 0).toDP(2, Decimal.ROUND_HALF_UP).toNumber() ))==null?'':_.escape(__t))+
	'\n                    (Y: RM '+
	((__t=( deduction.ytd ))==null?'':_.escape(__t))+
	')\n                </li>\n            ';
	 }) 
	__p+='\n        ';
	 } 
	__p+='\n    </ul>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Payslips = __webpack_require__(748);
	
	var _Payslips2 = _interopRequireDefault(_Payslips);
	
	var _Payslip = __webpack_require__(749);
	
	var _Payslip2 = _interopRequireDefault(_Payslip);
	
	var _leaveRequests = __webpack_require__(752);
	
	var _leaveRequests2 = _interopRequireDefault(_leaveRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('payslips-slides');
	
	module.exports = Backbone.View.extend({
	    events: {
	        'change .js-employee-select': 'selectEmployee',
	        'beforeChange .js-slides': 'beforeChangeSlide',
	        'afterChange .js-slides': 'afterChangeSlide',
	        'click .js-prev-slide:not(.js-disabled)': 'prevSlide',
	        'click .js-next-slide:not(.js-disabled)': 'nextSlide'
	    },
	
	    activeSlideView: null,
	    nextSlideView: null,
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            payslips: null,
	            payslipDetails: null,
	            companyLocation: null
	        });
	
	        this.render();
	    },
	
	    // TODO it is a big and multiplied method, refactor it later
	    fetchBalance: function fetchBalance(payslip) {
	        var _this = this;
	
	        var fetchYearlyBalances = function fetchYearlyBalances() {
	            return app.leaveTypes.fetchBalances(payslip.getEmployee(), payslip.getPayroll().getPeriod().endOf('month').toDate());
	        };
	
	        var transformYearly = function transformYearly(leaveTypes) {
	            return leaveTypes.map(function (leaveType) {
	                var name = leaveType.get('name');
	                var id = leaveType.id;
	                var entitled = leaveType.getEntitled() || 0;
	                var taken = leaveType.getTaken() || 0;
	                var remaining = Math.max(0, entitled - taken);
	                return {
	                    id: id,
	                    name: name,
	                    entitled: entitled,
	                    remaining: remaining,
	                    taken: taken
	                };
	            });
	        };
	
	        var mergeBalances = function mergeBalances(yearly, monthly) {
	            var obligated = _.filter(yearly, function (balance) {
	                return ['Medical Leave', 'Annual Leave', 'Unpaid Leave'].includes(balance.name);
	            });
	            var yearlyHasInMontly = _.filter(yearly, function (balance) {
	                return _.map(monthly, function (t) {
	                    return t.id;
	                }).includes(balance.id) && balance.taken > 0;
	            }).concat(obligated);
	
	            var mergeBalances = _.map(yearlyHasInMontly, function (balance) {
	                var sameMonthlyBalance = monthly.find(function (t) {
	                    return t.id === balance.id;
	                });
	                if (balance.taken > 0) {
	                    var newTaken = sameMonthlyBalance ? sameMonthlyBalance.taken : 0;
	                    balance.taken = newTaken;
	                }
	                return balance;
	            });
	            return mergeBalances;
	        };
	
	        var fetchMonthlyBalance = function fetchMonthlyBalance(types, reference) {
	            var end = (0, _moment2.default)(reference).endOf('month').toDate();
	            var start = (0, _moment2.default)(reference).startOf('month').toDate();
	            return _leaveRequests2.default.fetchForBalances({
	                employee: payslip.getEmployee(),
	                typeIds: types.map(function (t) {
	                    return t.id;
	                }),
	                start: start,
	                end: end
	            }).then(function (requests) {
	                var simplified = requests.map(function (request) {
	                    var id = request.get('typeId');
	                    var taken = request.get('daysRequired');
	                    return {
	                        id: id,
	                        taken: taken
	                    };
	                }) || [];
	                var groupedById = _.groupBy(simplified, 'id');
	                var summedById = _.map(groupedById, function (requests) {
	                    var taken = _.reduce(requests, function (sum, request) {
	                        return sum + request.taken;
	                    }, 0);
	                    return {
	                        id: requests[0].id,
	                        taken: taken
	                    };
	                });
	
	                return summedById;
	            });
	        };
	
	        return fetchYearlyBalances().then(function (yearlyBalances) {
	            return (0, _bluebird.all)([transformYearly(yearlyBalances), fetchMonthlyBalance(yearlyBalances, payslip.getPayroll().get('periodDate'))]);
	        }).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                yearly = _ref2[0],
	                monthly = _ref2[1];
	
	            return mergeBalances(yearly, monthly);
	        }).then(function (balances) {
	            _this.options.payslipDetails.balances = balances;
	        });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        this.$el.html((0, _Payslips2.default)({ payslips: this.options.payslips }));
	
	        this.$('.js-employee-select').chosen({ width: '100%' });
	
	        this.options.payslipDetails.setPayslip(this.options.payslips.first());
	        this.options.payslipDetails.fetch().then(function () {
	            return _this2.fetchBalance(_this2.options.payslips.first());
	        }).then(function () {
	            if (_this2.activeSlideView) {
	                _this2.activeSlideView.remove();
	            }
	
	            _this2.activeSlideView = _this2.renderPayslip(_this2.options.payslips.first(), _this2.options.payslipDetails, _this2.options.balances);
	
	            _this2.toggleSlideButtons(1);
	            _this2.$('.js-slides').removeClass('invisible');
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        });
	
	        this.$('.js-slides').slick({
	            slidesToShow: 1,
	            swipe: false,
	            infinite: false,
	            arrows: false,
	            draggable: false,
	            touchMove: false,
	            accesibility: false
	        });
	
	        return this;
	    },
	
	    renderPayslip: function renderPayslip(payslip, details) {
	        var view = new _Payslip2.default({
	            model: payslip,
	            payslipDetails: details,
	            companyLocation: this.options.companyLocation
	        });
	
	        this.$('.js-slide-' + payslip.id).append(view.$el);
	
	        return view;
	    },
	
	    show: function show() {
	        this.$('.js-slides').slick('setPosition');
	        return this;
	    },
	
	    selectEmployee: function selectEmployee(ev) {
	        var _this3 = this;
	
	        var $select = $(ev.currentTarget);
	        var payslip = this.options.payslips.at($select.val());
	        this.options.payslipDetails.setPayslip(payslip);
	        this.options.payslipDetails.fetch().then(function () {
	            return _this3.fetchBalance(payslip);
	        }).then(function () {
	            return _this3.$('.js-slides').slick('slickGoTo', $select.val());
	        });
	    },
	
	    beforeChangeSlide: function beforeChangeSlide(ev, slick, currentSlide, nextSlide) {
	        if (currentSlide !== nextSlide) {
	            this.$('.js-employee-select').val(nextSlide).trigger('chosen:updated');
	        }
	
	        this.nextSlideView = this.renderPayslip(this.options.payslips.at(nextSlide), this.options.payslipDetails);
	
	        this.toggleSlideButtons(nextSlide + 1);
	    },
	
	    afterChangeSlide: function afterChangeSlide() {
	        var prevSlideView = this.activeSlideView;
	        this.activeSlideView = this.nextSlideView;
	
	        if (prevSlideView && typeof prevSlideView.remove === 'function') {
	            prevSlideView.remove();
	        } else {
	            log.error('Inconsistent state. Missing previous slide view.');
	        }
	    },
	
	    prevSlide: function prevSlide() {
	        var _this4 = this;
	
	        var payslip = this.options.payslips.at(Math.max(0, this.$('.js-slides').slick('slickCurrentSlide') - 1));
	        this.options.payslipDetails.setPayslip(payslip);
	        this.options.payslipDetails.fetch().then(function () {
	            return _this4.fetchBalance(payslip);
	        }).then(function () {
	            return _this4.$('.js-slides').slick('slickPrev');
	        });
	    },
	
	    nextSlide: function nextSlide() {
	        var _this5 = this;
	
	        var payslip = this.options.payslips.at(Math.min(this.options.payslips.length, this.$('.js-slides').slick('slickCurrentSlide') + 1));
	        this.options.payslipDetails.setPayslip(payslip);
	        this.options.payslipDetails.fetch().then(function () {
	            return _this5.fetchBalance(payslip);
	        }).then(function () {
	            _this5.$('.js-slides').slick('slickNext');
	        });
	    },
	
	    toggleSlideButtons: function toggleSlideButtons(slide) {
	        this.$('.js-prev-slide').toggleClass('slick-disabled', slide === 1).toggleClass('js-disabled', slide === 1);
	        this.$('.js-next-slide').toggleClass('slick-disabled', slide === this.options.payslips.length).toggleClass('js-disabled', slide === this.options.payslips.length);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/Payslips.ejs -->\n<div class="panel-body payroll-payslips">\n    <div class="row">\n        <div class="col-xs-6"></div>\n        <div class="col-xs-6 col-employee">\n            <div class="row">\n                <label class="col-xs-2 control-label employee text-right">\n                    Employee\n                </label>\n                <div class="col-xs-10">\n                    <select class="js-employee-select">\n                        ';
	 payslips.forEach(function(payslip, key) { 
	__p+='\n                            <option value="'+
	((__t=( key ))==null?'':_.escape(__t))+
	'">\n                                '+
	((__t=( payslip.getEmployee().get('fullName') ))==null?'':_.escape(__t))+
	'\n                            </option>\n                        ';
	 }) 
	__p+='\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="slick-wrapper">\n        <div class="payslip-slick-prev js-prev-slide">\n            <i class="fa fa-angle-left"></i>\n        </div>\n        <div class="payslip-slick-next js-next-slide">\n            <i class="fa fa-angle-right"></i>\n        </div>\n        <div class="js-slides invisible">\n            ';
	 payslips.forEach(function(payslip) { 
	__p+='\n                <div class="js-slide js-slide-'+
	((__t=( payslip.id ))==null?'':_.escape(__t))+
	'"></div>\n            ';
	 }) 
	__p+='\n        </div>\n    </div>\n\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _payslipDetail = __webpack_require__(584);
	
	var _payslipDetail2 = _interopRequireDefault(_payslipDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'div',
	    className: 'payslip',
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.template = app.company.get('payslipSize') === 'A5' ? __webpack_require__(750) : __webpack_require__(751);
	        this.options = _.defaults(options || {}, {
	            payslipDetails: null,
	            companyLocation: null
	        });
	
	        this.options.payslipDetails.reset(_.sortBy(this.options.payslipDetails.models, function (item) {
	            return -item.get('amount');
	        }), { silent: true });
	
	        this.json = {};
	
	        return this.options.model.getPayslipJSON().then(function (data) {
	            _this.json = data;
	            _this.render();
	        });
	    },
	
	    render: function render() {
	        var additions = this.options.payslipDetails.findAdditions();
	        var deductions = this.options.payslipDetails.findDeductions();
	
	        // 20200417 handling the "double EPF", which is caused by "additional"
	        // EPF that is needed to create separate payroll detail for PCB
	        // calculation. we need some hack right here to merge these items.
	        var epfDeductions = deductions.findByType('epf');
	        if (epfDeductions.length > 1) {
	            var firstEpf = (epfDeductions.at(0) || new _payslipDetail2.default({ amount: 0 })).clone();
	
	            var epfAmount = epfDeductions.reduce(function (sum, model) {
	                return sum + model.get('amount');
	            }, 0);
	            firstEpf.set('amount', epfAmount);
	            epfDeductions.forEach(function (model) {
	                return deductions.remove(model);
	            });
	            deductions.add(firstEpf);
	        }
	        var taxDeductions = this.options.payslipDetails.findTaxDeductions();
	        var benefits = this.options.payslipDetails.findBenefits();
	        var nonTaxables = this.options.payslipDetails.findBenefitsNonTaxable();
	        this.$el.html(this.template(Object.assign(this.json, {
	            model: this.model,
	            payslipDetails: this.options.payslipDetails,
	            companyLocation: this.options.companyLocation,
	            formattedSubmitDate: this.getFormattedSubmitDate(this.json.payroll),
	
	            /* helping attributes */
	            company: app.company,
	            employee: this.model.getEmployee(),
	            address: this.options.companyLocation.getAddress(),
	            payroll: this.model.getPayroll(),
	
	            period: this.model.getPeriod().month(),
	
	            additions: additions,
	            deductions: deductions,
	            taxDeductions: taxDeductions.current(),
	            benefits: benefits.current(),
	            nonTaxables: nonTaxables.current(),
	
	            employerEpfYtd: this.getEmployerYtdByType('epf'),
	            employerSocsoYtd: this.getEmployerYtdByType('socso'),
	
	            unpaidLeaveFootnote: this.getUnpaidLeaveFootnote(),
	            mtdFootnote: this.getMtdFootnote(),
	            epfFootnote: this.getEpfFootnote(),
	            ytdFootnote: {
	                startMonth: new Date(this.model.getEmployee().get('commencementDate')).getFullYear() < this.model.getPeriod().year() ? 'January' : (0, _moment2.default)(new Date(this.model.getEmployee().get('commencementDate'))).format('MMMM'),
	                endMonth: this.model.getPeriod().format('MMMM'),
	                year: this.model.getPeriod().year()
	            },
	            overtimeFootnote: this.getOvertimeFootnote()
	        })));
	
	        return this;
	    },
	
	    getFormattedSubmitDate: function getFormattedSubmitDate(payroll) {
	        if (payroll && payroll.submittedDate && this.model.get('status') === 'done') {
	            return (0, _moment2.default)(payroll.submittedDate.iso).format('MMM D, YYYY');
	        }
	        return this.model.getFormattedDate();
	    },
	
	    getEmployerYtdByType: function getEmployerYtdByType(type) {
	        return this.options.payslipDetails.findByType(type).reduce(function (memo, model) {
	            if (model.getPayrollItem().get('isNet')) {
	                return memo;
	            }
	
	            return memo + (model.get('ytd') || 0);
	        }, 0) || 0;
	    },
	
	    getMtdFootnote: function getMtdFootnote() {
	        var mtd = this.options.payslipDetails.findByType('mtd').find(function (d) {
	            return d.getPayrollItem().get('subtype') !== 'custom';
	        });
	        var data = mtd ? mtd.get('additionalInformation') : false;
	        var footnote = {
	            employer: false,
	            employeeAttributes: []
	        };
	
	        if (!mtd) {
	            return false;
	        }
	
	        footnote.employer = mtd.getPayrollItem().get('isNet') === false;
	
	        if (!data || !data.employeeInfo) {
	            footnote.employeeAttributes = this.model.getEmployee().getTaxModifyingAttributes().join(', ');
	
	            return footnote;
	        }
	        var subType = data.employeeInfo.residentSubType;
	
	        if (data.employeeInfo.isDisabled) {
	            footnote.employeeAttributes.push('Disabled');
	        }
	
	        if (data.employeeInfo.isResident) {
	            footnote.employeeAttributes.push('Resident');
	            if (subType === 1) {
	                //knowledge worker
	                footnote.employeeAttributes.push('Iskandar Knowledge Worker');
	            } else if (subType === 2) {
	                //ret exp program
	                footnote.employeeAttributes.push('Returning Expert Program');
	            }
	        } else {
	            footnote.employeeAttributes.push('Non-Resident');
	        }
	        if (subType === 3) {
	            footnote.employeeAttributes.push('Freelancer');
	        }
	
	        switch (data.employeeInfo.marriedStatus) {
	            case 1:
	            case 2:
	                footnote.employeeAttributes.push('Single');
	                break;
	            case 3:
	                footnote.employeeAttributes.push('Divorced or Widowed');
	                break;
	            case 4:
	                footnote.employeeAttributes.push('Married');
	                footnote.employeeAttributes.push('Spouse Working');
	                break;
	            case 5:
	                footnote.employeeAttributes.push('Married');
	                footnote.employeeAttributes.push('Spouse Not Working');
	                break;
	            case 6:
	                footnote.employeeAttributes.push('Married');
	                footnote.employeeAttributes.push('Spouse Disabled');
	                break;
	        }
	
	        if (data.employeeInfo.marriedStatus > 1) {
	            if (!data.employeeInfo.children || !data.employeeInfo.children.length) {
	                footnote.employeeAttributes.push('No Dependent Children');
	            } else if (data.employeeInfo.children.length === 1) {
	                footnote.employeeAttributes.push('1 Child: ' + this.getChildrenFootnote(data.employeeInfo.children).join(', '));
	            } else if (data.employeeInfo.children.length > 1) {
	                footnote.employeeAttributes.push(data.employeeInfo.children.length + ' Children: ' + this.getChildrenFootnote(data.employeeInfo.children).join(', '));
	            }
	        }
	
	        footnote.employeeAttributes = footnote.employeeAttributes.join(', ');
	        return footnote;
	    },
	
	    getChildrenFootnote: function getChildrenFootnote(children) {
	        var type = {
	            0: 'None of the Categories',
	            underage: 'Under 18 or In Education',
	            inEducation: 'Over 18 - In Education (Diploma level)',
	            inHigherEducation: 'Over 18 - In Education (Degree level or higher)',
	            disabled: 'Disabled',
	            disabledInEducation: 'Disabled - In Higher Education'
	        };
	        var res = [];
	        var groupedChildren = _.groupBy(children, function (item) {
	            var category = item ? type[item.category] : type[0];
	            return category + ' (' + item.pcbDeduction + '%)';
	        });
	
	        _.each(groupedChildren, function (item, key) {
	            res.push(item.length + ' ' + key);
	        });
	
	        return res;
	    },
	
	    getEpfFootnote: function getEpfFootnote() {
	        var footnote = {
	            employeeRate: 0,
	            employerRate: 0,
	            employerContrib: 0,
	            nonResident: !this.model.getEmployee().get('isResident'),
	            employeeExtraDeduction: 0,
	            employerExtraDeduction: 0
	        };
	
	        var epfDetails = this.options.payslipDetails.findByType('epf').filter(function (detail) {
	            return detail.get('amount') >= 0;
	        });
	
	        if (epfDetails.length === 0) {
	            return null;
	        }
	
	        var employeeEpf = _(epfDetails).find(function (detail) {
	            return detail.getPayrollItem().get('isNet');
	        });
	        var employerEpf = _(epfDetails).find(function (detail) {
	            return !detail.getPayrollItem().get('isNet');
	        });
	
	        if (employeeEpf) {
	            var info = employeeEpf.get('additionalInformation') || {};
	            footnote.employeeRate = ((info.rate || 0) * 100).toFixed(2);
	            var employeeExtraDeductionAmount = (info.extraDeductions || {}).employee || 0;
	            if (employeeExtraDeductionAmount > 0) {
	                footnote.employeeExtraDeduction = employeeExtraDeductionAmount.toFixed(2);
	            }
	        }
	
	        if (employerEpf) {
	            var _info = employerEpf.get('additionalInformation') || {};
	            if (_info.rate) {
	                footnote.employerRate = (_info.rate * 100).toFixed(2);
	            } else {
	                footnote.employerContrib = employerEpf.get('amount').toFixed(2);
	            }
	            var employerExtraDeductionAmount = (_info.extraDeductions || {}).employer || 0;
	            if (employerExtraDeductionAmount > 0) {
	                footnote.employerExtraDeduction = employerExtraDeductionAmount.toFixed(2);
	            }
	        }
	
	        return footnote;
	    },
	
	    getUnpaidLeaveFootnote: function getUnpaidLeaveFootnote() {
	        var _this2 = this;
	
	        var unpaidLeave = this.options.payslipDetails.findByType('unpaid_leave').filter(function (detail) {
	            return detail.getPayrollItem().get('isGross') && !detail.get('isAdditional') && Object.keys(detail.get('additionalInformation') || {}).length;
	        });
	
	        if (!unpaidLeave.length) {
	            return false;
	        }
	
	        // this block is used to render old style unpaid leaves
	        if (unpaidLeave.length === 1 && !unpaidLeave[0].getAffectsItem()) {
	            var leave = unpaidLeave.shift();
	            var affectedDetails = this.options.payslipDetails.findAffectedByUnpaidLeave();
	
	            return _.defaults(leave.get('additionalInformation') || {}, {
	                method: '',
	                daysTaken: 0,
	                monthDays: 0,
	                details: affectedDetails
	            });
	        }
	
	        return unpaidLeave.map(function (leave) {
	            var amount = _this2.options.payslipDetails.findByPayrollItem(leave.getAffectsItem()).findAffectedByUnpaidLeave().getFullAmount();
	
	            return _.defaults(leave.get('additionalInformation') || {}, {
	                method: '',
	                daysTaken: 0,
	                monthDays: 0,
	                itemName: leave.getAffectsItem().get('name'),
	                amount: amount || 0
	            });
	        });
	    },
	
	    getOvertimeFootnote: function getOvertimeFootnote() {
	        var overtime = this.options.payslipDetails.findByType('overtime');
	
	        if (!overtime.length) {
	            return false;
	        }
	
	        return overtime.map(function (detail) {
	            return {
	                name: detail.getPayrollItem().get('name'),
	                hourlyWage: detail.get('additionalInformation').hourlyWage,
	                factor: detail.get('additionalInformation').overtimeFactor
	            };
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/NewPayslip.ejs -->\n<!-- header -->\n<div style="display: flex; flex-direction: row; justify-content: space-between">\n    ';
	 if (company.getLogoUrl()) { 
	__p+='\n        <div>\n            <img\n                style="padding: 10px 32px;\n                    border-style: none;\n                    border-width: 2px;\n                    border-color: #ffffff"\n                class="company-logo"\n                src="'+
	((__t=( company.getLogoUrl() ))==null?'':_.escape(__t))+
	'" />\n        </div>\n    ';
	 } 
	__p+='\n    <div>\n        <div class="title">Payslip</div>\n        <strong>'+
	((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
	'</strong>\n        <div>Issue Date: '+
	((__t=( formattedSubmitDate ))==null?'':_.escape(__t))+
	'</div>\n    </div>\n    <div>\n        <div class="title">Company</div>\n        <strong>'+
	((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
	'</strong>\n\n        <div>'+
	((__t=( address.get('line1') ))==null?'':_.escape(__t))+
	'</div>\n        <div>'+
	((__t=( address.get('postcode') ))==null?'':_.escape(__t))+
	' '+
	((__t=( address.get('city') ))==null?'':_.escape(__t))+
	'</div>\n        <div>'+
	((__t=( address.getStateName() ))==null?'':_.escape(__t))+
	'</div>\n    </div>\n    <div>\n        <div class="title">Employee</div>\n        <strong>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</strong>\n        <div>'+
	((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
	'</div>\n        <div>IC/Passport: '+
	((__t=( employee.get('idStr') ))==null?'':_.escape(__t))+
	'</div>\n        <div>EPF Number: '+
	((__t=( employee.get('epfNumber') ))==null?'':_.escape(__t))+
	'</div>\n        <div>PCB Number: '+
	((__t=( employee.get('taxNumber') ))==null?'':_.escape(__t))+
	'</div>\n    </div>\n</div>\n\n<!-- earnings -->\n<div style="display: flex; flex-direction: row">\n    <table class="footable footable-payslip earnings\n        footable-ellipsis table table-stripped\n        payslip-container-left"\n        data-striping="false">\n        <thead>\n            <tr class="tr-md">\n                <th class="colored">Earnings</th>\n                <th class="text-left payslip-rate">Rate</th>\n                <th class="text-right payslip-amount">Current Period (RM)</th>\n            </tr>\n        </thead>\n        <tbody>\n            ';
	 additions.forEach(function(detail) { 
	__p+='\n                ';
	 payrollItem = detail.getPayrollItem() 
	__p+='\n                <tr class="tr-md">\n                    <td class="name">\n                        '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                        ';
	 if (
	                            payrollItem.get('type') === 'overtime' &&
	                            overtimeFootnote
	                        ) { 
	__p+='\n                            <small class="footnote">5</small>\n                        ';
	 } 
	__p+='\n                    </td>\n                    <td class="text-left">\n                        ';
	 if (detail.get('amount') && detail.isUnit()) { 
	__p+='\n                            '+
	((__t=( detail.get('unit') ))==null?'':_.escape(__t))+
	' @ RM\n                            '+
	((__t=( (detail.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        ';
	 } 
	__p+='\n                    </td>\n                    <td class="text-right">\n                        '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </td>\n                </tr>\n            ';
	 }) 
	__p+='\n            <tr class="tr-md">\n                <td><strong>Total Earnings</strong></td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    <strong class="colored">\n                        '+
	((__t=( Number(additions.getNetAmount()).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </strong>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n\n    <!-- deductions -->\n    <table class="footable footable-payslip deductions\n        footable-ellipsis table table-stripped payslip-container-right"\n        data-striping="false">\n        <thead>\n            <tr class="tr-md">\n                <th class="colored">Deductions</th>\n                <th class="payslip-rate"></th>\n                <th class="payslip-amount"></th>\n            </tr>\n        </thead>\n        <tbody>\n            ';
	 deductions.forEach(function(detail) { 
	__p+='\n            ';
	 payrollItem = detail.getPayrollItem() 
	__p+='\n\n                <tr class="tr-md">\n                    <td class="name">\n                        ';
	 if (detail.getPayrollItemName() === 'EIS') { 
	__p+='\n                            Employee EIS\n                        ';
	 } else { 
	__p+='\n                            '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                        ';
	 } 
	__p+='\n                        ';
	 if (
	                            payrollItem.get('type') === 'mtd' &&
	                            payrollItem.get('subtype') !== 'custom' &&
	                            mtdFootnote
	                        ) { 
	__p+='\n                            <small class="footnote">1</small>\n                        ';
	 } 
	__p+='\n                        ';
	 if (
	                            payrollItem.get('type') === 'unpaid_leave' &&
	                            unpaidLeaveFootnote && !detail.get('isAdditional')
	                        ) { 
	__p+='\n                            <small class="footnote">2</small>\n                        ';
	 } 
	__p+='\n                        ';
	 if (
	                            payrollItem.get('type') === 'epf' &&
	                            epfFootnote.employeeRate > 0
	                        ) { 
	__p+='\n                            <small class="footnote">3</small>\n                        ';
	 } 
	__p+='\n                    </td>\n                    <td class="text-left">\n                        ';
	 if (detail.get('amount') && detail.isUnit()) { 
	__p+='\n                            '+
	((__t=( detail.get('unit') ))==null?'':_.escape(__t))+
	' @\n                            '+
	((__t=( (detail.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        ';
	 } 
	__p+='\n                    </td>\n                    <td class="text-right">\n                        '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </td>\n                </tr>\n            ';
	 }) 
	__p+='\n\n            <tr class="tr-md">\n                <td><strong>Total Deductions</strong></td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    <strong class="colored">\n                        '+
	((__t=( Math.abs(deductions.getNetAmount()).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </strong>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n\n<!-- net income -->\n<div style="display: flex; flex-direction: row-reverse">\n    <table class="footable footable-payslip net-income\n        footable-ellipsis table table-stripped payslip-container-right"\n        data-striping="false">\n        <thead>\n            <tr class="tr-md">\n                <th></th>\n                <th class="payslip-rate"></th>\n                <th class="payslip-amount"></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr class="tr-md net">\n                <td><strong>Net Income</strong></td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    <strong>\n                        '+
	((__t=( model.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </strong>\n                </td>\n            </tr>\n            <tr class="tr-md">\n                <td class="name">\n                    Taxable Income\n                    ';
	 if (benefits.length > 0) { 
	__p+='\n                        <small class="footnote">4</small>\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    '+
	((__t=( model.get('taxable').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n\n<!-- contributions -->\n<div style="display: flex; flex-direction: row">\n    <table class="footable footable-payslip footable-ellipsis\n        payslip-container-left table table-stripped m-b-xl"\n        data-striping="false">\n        <thead>\n            <tr class="tr-md">\n                <th colspan="6">Employer Contributions</th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr class="tr-md">\n                <td class="name">\n                    EPF\n                    ';
	 if (epfFootnote && epfFootnote.employeeRate > 0) { 
	__p+='\n                        <small class="footnote">3</small>\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    '+
	((__t=( model.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="name">Socso</td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    '+
	((__t=( model.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n            </tr>\n            <tr class="tr-md">\n                <td class="name">EIS</td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    '+
	((__t=( (model.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td class="name">HRDF</td>\n                <td class="text-right"></td>\n                <td class="text-right">\n                    '+
	((__t=( (model.get('totalHrdf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    <table class="footable footable-payslip footable-ellipsis\n        payslip-container-right table table-stripped m-b-xl"\n        data-striping="false">\n        <thead>\n            <tr class="tr-md">\n                <th colspan="4">Leave Balance</th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr class="tr-md">\n                <td class="name">Unpaid Leave</td>\n                <td class="text-right">'+
	((__t=( (unpaidBalance.taken || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="name"></td>\n                <td class="text-right"></td>\n            </tr>\n            <tr class="tr-md">\n                <td class="name">Annual Leave</td>\n                <td class="text-right">'+
	((__t=( (annualBalance.taken || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="name">Balance</td>\n                <td class="text-right">'+
	((__t=( (annualBalance.remaining || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n            </tr>\n            <tr class="tr-md">\n                <td class="name">Medical Leave</td>\n                <td class="text-right">'+
	((__t=( (medicalBalance.taken || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                <td class="name">Balance</td>\n                <td class="text-right">'+
	((__t=( (medicalBalance.remaining || 0).formatWithoutRounding()))==null?'':_.escape(__t))+
	'</td>\n            </tr>\n            ';
	 otherBalances.forEach(function(leave) { 
	__p+='\n                <tr class="tr-md">\n                    <td class="name">'+
	((__t=(leave.name))==null?'':_.escape(__t))+
	'</td>\n                    <td class="text-right">'+
	((__t=( (leave.taken || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                    <td class="name">Balance</td>\n                    <td class="text-right">'+
	((__t=( (leave.remaining || 0).formatWithoutRounding()))==null?'':_.escape(__t))+
	'</td>\n                </tr>\n            ';
	 })
	__p+='\n        </tbody>\n    </table>\n</div>\n<div class="line-break"><hr class="m-b-sm"></div>\n\n<div>\n    ';
	 if (mtdFootnote) { 
	__p+='\n        <small class="footnote">1</small>\n        Tax calculations are based on Employee attributes:\n        '+
	((__t=( mtdFootnote.employeeAttributes ))==null?'':_.escape(__t))+
	'\n        ';
	 if (taxDeductions.length > 0) { 
	__p+='\n            <br>\n            List of deductible Items that do not affect\n            Gross/Net Income:\n            <ul>\n                ';
	 taxDeductions.forEach(function(detail) { 
	__p+='\n                    <li>\n                        '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	' :\n                        RM '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </li>\n                ';
	 }) 
	__p+='\n            </ul>\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (unpaidLeaveFootnote) { 
	__p+='\n        ';
	 methods = [
	            false,
	            'Fixed number of days',
	            'All days in current calendar month',
	            'Working days in current calendar month'
	        ] 
	__p+='\n\n        <small class="footnote">2</small>\n        Unpaid leave is calculated based on the method of\n        ';
	 if (unpaidLeaveFootnote instanceof Array) { 
	__p+='\n            <i>'+
	((__t=( methods[_.first(unpaidLeaveFootnote).method] || 'Unknown' ))==null?'':_.escape(__t))+
	'</i>:\n            <ul>\n                ';
	 unpaidLeaveFootnote.forEach(function (footnote) { 
	__p+='\n                    <li>\n                        '+
	((__t=( footnote.itemName ))==null?'':_.escape(__t))+
	': ('+
	((__t=( footnote.amount.formatWithoutRounding() ))==null?'':_.escape(__t))+
	' *\n                        '+
	((__t=( footnote.daysTaken ))==null?'':_.escape(__t))+
	' unpaid days taken) /\n                        '+
	((__t=( footnote.monthDays ))==null?'':_.escape(__t))+
	' days\n                    </li>\n                ';
	 }) 
	__p+='\n            </ul>\n        ';
	 } else { 
	__p+='\n            <i>'+
	((__t=( methods[unpaidLeaveFootnote.method] || 'Unknown' ))==null?'':_.escape(__t))+
	'</i>:\n            (('+
	((__t=( unpaidLeaveFootnote.details.map(function (detail) {
	                return (
	                    detail.getPayrollItemName() + ': ' +
	                    detail.get('amount').formatWithoutRounding()
	                );
	            }).join(' + ') ))==null?'':_.escape(__t))+
	') * '+
	((__t=( unpaidLeaveFootnote.daysTaken ))==null?'':_.escape(__t))+
	' unpaid\n            leave days taken) / '+
	((__t=( unpaidLeaveFootnote.monthDays ))==null?'':_.escape(__t))+
	' days\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (epfFootnote && epfFootnote.employeeRate > 0) { 
	__p+='\n        <small class="footnote">3</small>\n        Contributions for EPF are calculated based on\n        '+
	((__t=( epfFootnote.employeeRate || 0 ))==null?'':_.escape(__t))+
	'% employee rate\n        ';
	 if (epfFootnote.employerRate) { 
	__p+='\n            and '+
	((__t=( epfFootnote.employerRate || 0 ))==null?'':_.escape(__t))+
	'% employer rate\n        ';
	 } else if (epfFootnote.employerContrib) { 
	__p+='\n            and a fixed employer contribution of RM\n            '+
	((__t=( epfFootnote.employerContrib || 0 ))==null?'':_.escape(__t))+
	'\n\n            ';
	 if (epfFootnote.nonResident) { 
	__p+='\n                for non-resident\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n        ';
	 if (epfFootnote.employeeExtraDeduction || epfFootnote.employerExtraDeduction) { 
	__p+='\n          <br>\n        ';
	 } 
	__p+='\n        ';
	 if (epfFootnote.employeeExtraDeduction) { 
	__p+='\n            EPF employee contribution manually reduced by RM\n            '+
	((__t=( epfFootnote.employeeExtraDeduction ))==null?'':_.escape(__t))+
	'\n        ';
	 } 
	__p+='\n        ';
	 if (epfFootnote.employerExtraDeduction) { 
	__p+='\n            '+
	((__t=( epfFootnote.employeeExtraDeduction ? 'and' : '' ))==null?'':_.escape(__t))+
	'\n            EPF employer contribution manually reduced by RM\n            '+
	((__t=( epfFootnote.employerExtraDeduction ))==null?'':_.escape(__t))+
	'\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (benefits.length > 0) { 
	__p+='\n        <small class="footnote">4</small>\n        Taxable Income includes Perquisites/Benefits-in-Kind:\n        <ul>\n            ';
	 benefits.forEach(function(detail) { 
	__p+='\n                <li>\n                    '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	' :\n                    RM '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </li>\n            ';
	 }) 
	__p+='\n        </ul>\n    ';
	 } 
	__p+='\n    ';
	 if (nonTaxables.length > 0) { 
	__p+='\n        <small class="footnote">5</small>\n        Benefits-in-kind not affecting taxable income:\n        <ul>\n            ';
	 nonTaxables.forEach(function(detail) { 
	__p+='\n                <li>\n                    '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	' :\n                    RM '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </li>\n            ';
	 }) 
	__p+='\n        </ul>\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (overtimeFootnote) { 
	__p+='\n        <small class="footnote">5</small>\n        Overtime was calculated using the following parameters:\n        <ul>\n            ';
	 overtimeFootnote.forEach(function(detail) { 
	__p+='\n                <li>\n                    '+
	((__t=( detail.name ))==null?'':_.escape(__t))+
	' :\n                        Hourly wage: '+
	((__t=( detail.hourlyWage ))==null?'':_.escape(__t))+
	',\n                        Rate: '+
	((__t=( detail.factor ))==null?'':_.escape(__t))+
	'x\n                </li>\n            ';
	 }) 
	__p+='\n        </ul>\n    ';
	 } 
	__p+='\n</div>\n<div>\n    Working days '+
	((__t=( workingDays ))==null?'':_.escape(__t))+
	'; Public holidays '+
	((__t=( holidays ))==null?'':_.escape(__t))+
	'.\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/Payslip.ejs -->\n<!-- header -->\n<div class="row row-header">\n    ';
	 if (company.getLogoUrl()) { 
	__p+='\n        <div class="col-xs-12">\n            <img class="company-logo"\n                src="'+
	((__t=( company.getLogoUrl() ))==null?'':_.escape(__t))+
	'" />\n        </div>\n    ';
	 } 
	__p+='\n    <div class="col-sm-4 m-b-md">\n        <div class="title">Payslip</div>\n        <strong>'+
	((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
	'</strong>\n        <div>Issue Date: '+
	((__t=( formattedSubmitDate ))==null?'':_.escape(__t))+
	'</div>\n    </div>\n    <div class="col-sm-4 m-b-md">\n        <div class="title">Company</div>\n        <strong>'+
	((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
	'</strong>\n        <div>'+
	((__t=( address.get('line1') ))==null?'':_.escape(__t))+
	'</div>\n        <div>'+
	((__t=( address.get('postcode') ))==null?'':_.escape(__t))+
	' '+
	((__t=( address.get('city') ))==null?'':_.escape(__t))+
	'</div>\n        <div>'+
	((__t=( address.getStateName() ))==null?'':_.escape(__t))+
	'</div>\n    </div>\n    <div class="col-sm-4 m-b-md">\n        <div class="title">Employee</div>\n        <strong>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</strong>\n        <div>'+
	((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
	'</div>\n        <div>IC/Passport: '+
	((__t=( employee.get('idStr') ))==null?'':_.escape(__t))+
	'</div>\n        <div>EPF Number: '+
	((__t=( employee.get('epfNumber') ))==null?'':_.escape(__t))+
	'</div>\n        <div>PCB Number: '+
	((__t=( employee.get('taxNumber') ))==null?'':_.escape(__t))+
	'</div>\n    </div>\n</div>\n\n<!-- earnings -->\n<table class="footable footable-payslip earnings\n    footable-ellipsis table table-stripped"\n    data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th class="colored">Earnings</th>\n            <th class="text-left payslip-rate hidden-xs">Rate</th>\n            <th class="text-right payslip-amount">Current Period (RM)</th>\n        </tr>\n    </thead>\n    <tbody>\n        ';
	 additions.forEach(function(detail) { 
	__p+='\n            ';
	 payrollItem = detail.getPayrollItem() 
	__p+='\n            <tr class="tr-md">\n                <td class="name">\n                    '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                    ';
	 if (
	                        payrollItem.get('type') === 'overtime' &&
	                        overtimeFootnote
	                    ) { 
	__p+='\n                        <small class="footnote">5</small>\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="text-left hidden-xs">\n                    ';
	 if (detail.get('amount') && detail.isUnit()) { 
	__p+='\n                        '+
	((__t=( detail.get('unit') ))==null?'':_.escape(__t))+
	' @ RM\n                        '+
	((__t=( (detail.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="text-right">\n                    '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n            </tr>\n        ';
	 }) 
	__p+='\n        <tr class="tr-md">\n            <td><strong>Total Earnings</strong></td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                <strong class="colored">\n                    '+
	((__t=( Number(additions.getNetAmount()).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </strong>\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<!-- deductions -->\n<table class="footable footable-payslip deductions\n    footable-ellipsis table table-stripped" data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th class="colored">Deductions</th>\n            <th class="payslip-rate hidden-xs"></th>\n            <th class="payslip-amount"></th>\n        </tr>\n    </thead>\n    <tbody>\n        ';
	 deductions.forEach(function(detail) { 
	__p+='\n            ';
	 payrollItem = detail.getPayrollItem() 
	__p+='\n\n            <tr class="tr-md">\n                <td class="name">\n                    ';
	 if (detail.getPayrollItemName() === 'EIS') { 
	__p+='\n                        Employee EIS\n                    ';
	 } else { 
	__p+='\n                        '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                    ';
	 } 
	__p+='\n                    ';
	 if (
	                        payrollItem.get('type') === 'mtd' &&
	                        payrollItem.get('subtype') !== 'custom' &&
	                        mtdFootnote
	                    ) { 
	__p+='\n                        <small class="footnote">1</small>\n                    ';
	 } 
	__p+='\n                    ';
	 if (
	                        payrollItem.get('type') === 'unpaid_leave' &&
	                        unpaidLeaveFootnote &&
	                        !detail.get('isAdditional')
	                    ) { 
	__p+='\n                        <small class="footnote">2</small>\n                    ';
	 } 
	__p+='\n                    ';
	 if (
	                        payrollItem.get('type') === 'epf' &&
	                        epfFootnote.employeeRate > 0
	                    ) { 
	__p+='\n                        <small class="footnote">3</small>\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="text-left hidden-xs">\n                    ';
	 if (detail.get('amount') && detail.isUnit()) { 
	__p+='\n                        '+
	((__t=( detail.get('unit') ))==null?'':_.escape(__t))+
	' @\n                        '+
	((__t=( (detail.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    ';
	 } 
	__p+='\n                </td>\n                <td class="text-right">\n                    '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </td>\n            </tr>\n        ';
	 }) 
	__p+='\n\n        <tr class="tr-md">\n            <td><strong>Total Deductions</strong></td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                <strong class="colored">\n                    '+
	((__t=( Math.abs(deductions.getNetAmount()).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </strong>\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<!-- net income -->\n<table class="footable footable-payslip net-income\n    footable-ellipsis table table-stripped" data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th></th>\n            <th class="payslip-rate hidden-xs"></th>\n            <th class="payslip-amount"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr class="tr-md net">\n            <td><strong>Net Income</strong></td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                <strong>\n                    '+
	((__t=( model.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </strong>\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">\n                Taxable Income\n                ';
	 if (benefits.length > 0) { 
	__p+='\n                    <small class="footnote">4</small>\n                ';
	 } 
	__p+='\n            </td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
	((__t=( model.get('taxable').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<!-- contributions -->\n<table class="footable footable-payslip footable-ellipsis\n    table table-stripped m-b-xl" data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th>Employer Contributions</th>\n            <th class="payslip-rate hidden-xs"></th>\n            <th class="payslip-amount"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr class="tr-md">\n            <td class="name">\n                EPF\n                ';
	 if (epfFootnote && epfFootnote.employeeRate > 0) { 
	__p+='\n                    <small class="footnote">3</small>\n                ';
	 } 
	__p+='\n            </td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
	((__t=( model.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">Socso</td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
	((__t=( model.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">EIS</td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
	((__t=( (model.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">HRDF</td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
	((__t=( (model.get('totalHrdf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<div class="line-break"><hr class="m-b-sm"></div>\n\n<div>\n    ';
	 if (mtdFootnote) { 
	__p+='\n        <small class="footnote">1</small>\n        Tax calculations are based on Employee attributes:\n        '+
	((__t=( mtdFootnote.employeeAttributes ))==null?'':_.escape(__t))+
	'\n        ';
	 if (taxDeductions.length > 0) { 
	__p+='\n            <br>\n            List of deductible Items that do not affect\n            Gross/Net Income:\n            <ul>\n                ';
	 taxDeductions.forEach(function(detail) { 
	__p+='\n                    <li>\n                        '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	' :\n                        RM '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </li>\n                ';
	 }) 
	__p+='\n            </ul>\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (unpaidLeaveFootnote) { 
	__p+='\n        ';
	 methods = [
	            false,
	            'Fixed number of days',
	            'All days in current calendar month',
	            'Working days in current calendar month'
	        ] 
	__p+='\n\n        <small class="footnote">2</small>\n        Unpaid leave is calculated based on the method of\n        ';
	 if (unpaidLeaveFootnote instanceof Array) { 
	__p+='\n            <i>'+
	((__t=( methods[_.first(unpaidLeaveFootnote).method] || 'Unknown' ))==null?'':_.escape(__t))+
	'</i>:\n            <ul>\n                ';
	 unpaidLeaveFootnote.forEach(function (footnote) { 
	__p+='\n                    <li>\n                        '+
	((__t=( footnote.itemName ))==null?'':_.escape(__t))+
	': ('+
	((__t=( footnote.amount.formatWithoutRounding() ))==null?'':_.escape(__t))+
	' *\n                        '+
	((__t=( footnote.daysTaken ))==null?'':_.escape(__t))+
	' unpaid days taken) /\n                        '+
	((__t=( footnote.monthDays ))==null?'':_.escape(__t))+
	' days\n                    </li>\n                ';
	 }) 
	__p+='\n            </ul>\n        ';
	 } else { 
	__p+='\n            <i>'+
	((__t=( methods[unpaidLeaveFootnote.method] || 'Unknown' ))==null?'':_.escape(__t))+
	'</i>:\n            (('+
	((__t=( unpaidLeaveFootnote.details.map(function (detail) {
	                return (
	                    detail.getPayrollItemName() + ': ' +
	                    detail.get('amount').formatWithoutRounding()
	                );
	            }).join(' + ') ))==null?'':_.escape(__t))+
	') * '+
	((__t=( unpaidLeaveFootnote.daysTaken ))==null?'':_.escape(__t))+
	' unpaid\n            leave days taken) / '+
	((__t=( unpaidLeaveFootnote.monthDays ))==null?'':_.escape(__t))+
	' days\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (epfFootnote && epfFootnote.employeeRate > 0) { 
	__p+='\n        <small class="footnote">3</small>\n        Contributions for EPF are calculated based on\n        '+
	((__t=( epfFootnote.employeeRate || 0 ))==null?'':_.escape(__t))+
	'% employee rate\n        ';
	 if (epfFootnote.employerRate) { 
	__p+='\n            and '+
	((__t=( epfFootnote.employerRate || 0 ))==null?'':_.escape(__t))+
	'% employer rate\n        ';
	 } else if (epfFootnote.employerContrib) { 
	__p+='\n            and a fixed employer contribution of RM\n            '+
	((__t=( epfFootnote.employerContrib || 0 ))==null?'':_.escape(__t))+
	'\n\n            ';
	 if (epfFootnote.nonResident) { 
	__p+='\n                for non-resident\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n        ';
	 if (epfFootnote.employeeExtraDeduction || epfFootnote.employerExtraDeduction) { 
	__p+='\n          <br>\n        ';
	 } 
	__p+='\n        ';
	 if (epfFootnote.employeeExtraDeduction) { 
	__p+='\n            EPF employee contribution manually reduced by RM\n            '+
	((__t=( epfFootnote.employeeExtraDeduction ))==null?'':_.escape(__t))+
	'\n        ';
	 } 
	__p+='\n        ';
	 if (epfFootnote.employerExtraDeduction) { 
	__p+='\n            '+
	((__t=( epfFootnote.employeeExtraDeduction ? 'and' : '' ))==null?'':_.escape(__t))+
	'\n            EPF employer contribution manually reduced by RM\n            '+
	((__t=( epfFootnote.employerExtraDeduction ))==null?'':_.escape(__t))+
	'\n        ';
	 } 
	__p+='\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (benefits.length > 0) { 
	__p+='\n        <small class="footnote">4</small>\n        Taxable Income includes Perquisites/Benefits-in-Kind:\n        <ul>\n            ';
	 benefits.forEach(function(detail) { 
	__p+='\n                <li>\n                    '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	' :\n                    RM '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </li>\n            ';
	 }) 
	__p+='\n        </ul>\n    ';
	 } 
	__p+='\n    ';
	 if (nonTaxables.length > 0) { 
	__p+='\n        <small class="footnote">5</small>\n        Benefits-in-kind not affecting taxable income:\n        <ul>\n            ';
	 nonTaxables.forEach(function(detail) { 
	__p+='\n                <li>\n                    '+
	((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
	' :\n                    RM '+
	((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </li>\n            ';
	 }) 
	__p+='\n        </ul>\n    ';
	 } 
	__p+='\n</div>\n<div>\n    ';
	 if (overtimeFootnote) { 
	__p+='\n        <small class="footnote">5</small>\n        Overtime was calculated using the following parameters:\n        <ul>\n            ';
	 overtimeFootnote.forEach(function(detail) { 
	__p+='\n                <li>\n                    '+
	((__t=( detail.name ))==null?'':_.escape(__t))+
	' :\n                        Hourly wage: '+
	((__t=( detail.hourlyWage ))==null?'':_.escape(__t))+
	',\n                        Rate: '+
	((__t=( detail.factor ))==null?'':_.escape(__t))+
	'x\n                </li>\n            ';
	 }) 
	__p+='\n        </ul>\n    ';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _leaveRequest2 = _interopRequireDefault(_leaveRequest);
	
	var _leaveApprovals = __webpack_require__(587);
	
	var _leaveApprovals2 = _interopRequireDefault(_leaveApprovals);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveRequests = function (_Collection) {
	    _inherits(LeaveRequests, _Collection);
	
	    function LeaveRequests() {
	        _classCallCheck(this, LeaveRequests);
	
	        return _possibleConstructorReturn(this, (LeaveRequests.__proto__ || Object.getPrototypeOf(LeaveRequests)).apply(this, arguments));
	    }
	
	    _createClass(LeaveRequests, [{
	        key: 'url',
	        value: function url() {
	            if (this.employee) {
	                return this.employee.url() + '/leaveRequests';
	            }
	
	            if (this.company) {
	                return this.company.url() + '/leaveRequests';
	            }
	
	            return '/LeaveRequests';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company,
	                _ref$employee = _ref.employee,
	                employee = _ref$employee === undefined ? null : _ref$employee;
	
	            _get(LeaveRequests.prototype.__proto__ || Object.getPrototypeOf(LeaveRequests.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _leaveRequest2.default;
	            this.company = company;
	            this.employee = employee;
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(a, b) {
	            var typeA = a.getType();
	            var typeB = b.getType();
	
	            if (!typeA || !typeB) {
	                return a.id > b.id ? 1 : -1;
	            }
	
	            if (typeA.get('annual')) {
	                return -1;
	            }
	
	            if (typeB.get('annual')) {
	                return 1;
	            }
	
	            if (!typeA.get('company')) {
	                return -1;
	            }
	
	            if (!typeA.get('optional')) {
	                return -1;
	            }
	
	            return typeA.get('name') > typeB.get('name') ? 1 : -1;
	        }
	    }, {
	        key: 'asCalendarEvents',
	        value: function asCalendarEvents() {
	            return this.map(function (model) {
	                return model.asCalendarEvent();
	            });
	        }
	    }, {
	        key: 'getRequestedDays',
	        value: function getRequestedDays() {
	            return this.reduce(function (memo, model) {
	                return memo + model.getRequestedDays();
	            }, 0);
	        }
	    }], [{
	        key: 'fetchForBalances',
	        value: function fetchForBalances(_ref2) {
	            var _ref2$employee = _ref2.employee,
	                employee = _ref2$employee === undefined ? null : _ref2$employee,
	                _ref2$typeIds = _ref2.typeIds,
	                typeIds = _ref2$typeIds === undefined ? [] : _ref2$typeIds,
	                _ref2$start = _ref2.start,
	                start = _ref2$start === undefined ? new Date() : _ref2$start,
	                _ref2$end = _ref2.end,
	                end = _ref2$end === undefined ? new Date() : _ref2$end;
	
	            return new LeaveRequests(null, { employee: employee, pagination: false }).fetch({ filter: { where: {
	                        typeId: { inq: typeIds },
	                        status: 2,
	                        or: [{
	                            dateTo: { gte: start },
	                            dateFrom: { lte: end }
	                        }, {
	                            and: [{ dateFrom: { gte: start } }, { dateFrom: { lte: end } }],
	                            dateTo: null
	                        }]
	                    } } });
	        }
	    }, {
	        key: 'fetchForTypes',
	        value: function fetchForTypes(_ref3) {
	            var _ref3$typeIds = _ref3.typeIds,
	                typeIds = _ref3$typeIds === undefined ? null : _ref3$typeIds,
	                _ref3$employeeIds = _ref3.employeeIds,
	                employeeIds = _ref3$employeeIds === undefined ? null : _ref3$employeeIds;
	
	            var url = new LeaveRequests(null, { company: app.company }).finalUrl();
	            return _axios2.default.post('' + url, { filter: {
	                    where: {
	                        employeeId: { inq: employeeIds },
	                        typeId: { inq: typeIds },
	                        status: 2
	                    },
	                    limit: 9999
	                } }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                return new LeaveRequests(r.data, { company: app.company });
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }, {
	        key: 'fetchForCalendar',
	        value: function fetchForCalendar(_ref4) {
	            var _ref4$employees = _ref4.employees,
	                employees = _ref4$employees === undefined ? null : _ref4$employees,
	                _ref4$start = _ref4.start,
	                start = _ref4$start === undefined ? new Date() : _ref4$start,
	                _ref4$end = _ref4.end,
	                end = _ref4$end === undefined ? new Date() : _ref4$end,
	                _ref4$status = _ref4.status,
	                status = _ref4$status === undefined ? null : _ref4$status,
	                _ref4$location = _ref4.location,
	                location = _ref4$location === undefined ? null : _ref4$location;
	
	            var filterJSON = {
	                filter: {
	                    where: {
	                        or: [{
	                            dateFrom: { gte: start },
	                            dateTo: { lte: end }
	                        }, {
	                            dateTo: { gte: start },
	                            dateFrom: { lte: end }
	                        }, {
	                            and: [{ dateFrom: { gte: start } }, { dateFrom: { lte: end } }],
	                            dateTo: null
	                        }]
	                    },
	                    limit: 9999
	                }
	            };
	            if (status) {
	                filterJSON.filter.where.status = status;
	            }
	
	            if (employees.length === 1) {
	                // if it's a single employee, fetch leave requests through
	                // his/her relation
	                var employee = employees.at(0);
	                return new LeaveRequests(null, { employee: employee, pagination: false }).fetch(filterJSON).then(function (leaves) {
	                    // if it's the user employee's own leaves
	                    if (!app.employee || employee.id === app.employee.id) {
	                        leaves.each(function (leave) {
	                            leave.employee = employee;
	                        });
	                        return leaves;
	                    }
	                    var approvals = new _leaveApprovals2.default(null, {
	                        approver: app.employee
	                    });
	                    return approvals.fetch({
	                        filter: { where: { requesterId: employee.id } }
	                    }).then(function () {
	                        var layer = approvals.length ? approvals.at(0).get('layer') : -1;
	                        var filteredLeaves = new LeaveRequests(leaves.filter(function (model) {
	                            if (!model.isAwaiting()) {
	                                return true;
	                            }
	                            var approvalStatus = model.get('approvalStatus') || 0;
	                            return layer <= approvalStatus + 1;
	                        }), { employee: employee });
	                        filteredLeaves.each(function (leave) {
	                            leave.employee = employee;
	                        });
	                        return filteredLeaves;
	                    });
	                });
	            } else {
	                // if it's multiple employees, fetch leave requests through the
	                // company relation. We assume app.company because the calendar
	                // is not built to load data from multiple companies
	                filterJSON.filter.where.employeeId = {
	                    inq: employees.map(function (employee) {
	                        return employee.id;
	                    })
	                };
	                var url = new LeaveRequests(null, { company: app.company }).finalUrl();
	                return _axios2.default.post('' + url, filterJSON, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                    var leaves = new LeaveRequests(r.data, { company: app.company });
	                    leaves.each(function (leave) {
	                        leave.employee = employees.find(function (employee) {
	                            return leave.get('employeeId') === employee.id;
	                        });
	                    });
	
	                    if (location && leaves.length > 0) {
	                        var leaveByLocation = leaves.filter(function (leave) {
	                            return leave.employee.get('companyLocationId') === location;
	                        });
	
	                        return new LeaveRequests(leaveByLocation, { company: app.company });
	                    }
	
	                    return leaves;
	                }).catch(function (err) {
	                    throw err.response.data.error;
	                });
	            }
	        }
	    }]);
	
	    return LeaveRequests;
	}(_collection2.default);
	
	exports.default = LeaveRequests;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.consts = exports.statuses = undefined;
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _leaveType = __webpack_require__(630);
	
	var _leaveType2 = _interopRequireDefault(_leaveType);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _attachment = __webpack_require__(579);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/leave-request');
	
	var statuses = exports.statuses = {
	    1: 'Awaiting approval',
	    2: 'Approved',
	    3: 'Rejected',
	    4: 'Cancelled'
	};
	
	var consts = exports.consts = {
	    DATE_TYPE_FULL_DAY: 1,
	    DATE_TYPE_MORNING: 2,
	    DATE_TYPE_AFTERNOON: 3,
	    STATUS_AWAITING: 1,
	    STATUS_APPROVED: 2,
	    STATUS_REJECTED: 3,
	    STATUS_CANCELLED: 4
	};
	
	var LeaveRequest = function (_Model) {
	    _inherits(LeaveRequest, _Model);
	
	    _createClass(LeaveRequest, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/LeaveRequests';
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                typeId: {
	                    presence: {
	                        message: '^Please choose a Leave Type'
	                    }
	                },
	                dateFrom: {
	                    presence: {
	                        message: '^Please choose a date'
	                    }
	                },
	                employeeId: {
	                    presence: {
	                        message: '^Please choose an employee'
	                    }
	                }
	            };
	        }
	    }]);
	
	    function LeaveRequest() {
	        _classCallCheck(this, LeaveRequest);
	
	        var _this = _possibleConstructorReturn(this, (LeaveRequest.__proto__ || Object.getPrototypeOf(LeaveRequest)).apply(this, arguments));
	
	        _this.type = null;
	        return _this;
	    }
	
	    _createClass(LeaveRequest, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            this.on('change:typeId', this._setType, this);
	            return _get(LeaveRequest.prototype.__proto__ || Object.getPrototypeOf(LeaveRequest.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'getType',
	        value: function getType() {
	            if (this.type) {
	                return this.type;
	            }
	            return this._setType(this.get('typeId'));
	        }
	    }, {
	        key: '_setType',
	        value: function _setType(id) {
	            if (!app.leaveTypes) {
	                log.warn('App hasn\'t any leave types loaded');
	                this.type = null;
	                return;
	            }
	
	            if (!id) {
	                log.warn('Leave request doesn\'t have a leave type');
	                this.type = null;
	                return;
	            }
	
	            this.type = app.leaveTypes.find(function (model) {
	                return model.id === id;
	            });
	            return this.type;
	        }
	    }, {
	        key: 'fetchType',
	        value: function fetchType() {
	            var _this2 = this;
	
	            if (this.type && this.type.id === this.get('typeId')) {
	                return (0, _bluebird.resolve)(this.type);
	            }
	
	            var type = app.leaveTypes.find(function (t) {
	                return t.id === _this2.get('typeId');
	            });
	            if (type) {
	                this.type = type;
	                return (0, _bluebird.resolve)(type);
	            }
	
	            return new _leaveType2.default({ objectId: this.get('typeId') }).fetch().then(function (model) {
	                _this2.type = model;
	                return _this2.type;
	            });
	        }
	    }, {
	        key: 'setEmployee',
	        value: function setEmployee(employee) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            this.employee = employee;
	            return this.set({ employeeId: employee.get('objectId') }, options);
	        }
	    }, {
	        key: 'getEmployee',
	        value: function getEmployee() {
	            return this.employee;
	        }
	    }, {
	        key: 'fetchEmployee',
	        value: function fetchEmployee() {
	            var _this3 = this;
	
	            if (this.employee && this.employee.id === this.get('employeeId')) {
	                return (0, _bluebird.resolve)(this.employee);
	            }
	
	            var employee = app.employees.find(function (emp) {
	                return emp.id === _this3.get('employeeId');
	            });
	            if (employee) {
	                this.employee = employee;
	                return (0, _bluebird.resolve)(employee);
	            }
	
	            return new _employee2.default({ objectId: this.get('employeeId') }).fetch().then(function (model) {
	                _this3.employee = model;
	                return _this3.employee;
	            });
	        }
	    }, {
	        key: 'asCalendarEvent',
	        value: function asCalendarEvent() {
	            return {
	                start: _moment2.default.utc(this.get('dateFrom')),
	                allDay: !this.get('dateTo'),
	                end: this.get('dateTo') ? _moment2.default.utc(this.get('dateTo')) : _moment2.default.utc(this.get('dateFrom')),
	                model: this
	            };
	        }
	    }, {
	        key: 'getStatusText',
	        value: function getStatusText() {
	            var status = this.get('status');
	            return statuses[status] || '';
	        }
	    }, {
	        key: 'getStatusColor',
	        value: function getStatusColor() {
	            var status = this.get('status');
	            var leaveRequestMap = {
	                1: 'text-warning',
	                2: 'text-success',
	                3: 'text-danger'
	            };
	            return leaveRequestMap[status] || '';
	        }
	    }, {
	        key: 'isAwaiting',
	        value: function isAwaiting() {
	            return this.get('status') === consts.STATUS_AWAITING;
	        }
	    }, {
	        key: 'isApproved',
	        value: function isApproved() {
	            return this.get('status') === consts.STATUS_APPROVED;
	        }
	    }, {
	        key: 'isRejected',
	        value: function isRejected() {
	            return this.get('status') === consts.STATUS_REJECTED;
	        }
	    }, {
	        key: 'isCancelled',
	        value: function isCancelled() {
	            return this.get('status') === consts.STATUS_CANCELLED;
	        }
	    }, {
	        key: 'hasApprovals',
	        value: function hasApprovals() {
	            return this.get('approvalStatus') > 0;
	        }
	    }, {
	        key: 'dateFromIsMorning',
	        value: function dateFromIsMorning() {
	            return this.get('dateFromType') === consts.DATE_TYPE_MORNING;
	        }
	    }, {
	        key: 'dateFromIsAfternoon',
	        value: function dateFromIsAfternoon() {
	            return this.get('dateFromType') === consts.DATE_TYPE_AFTERNOON;
	        }
	    }, {
	        key: 'dateToIsMorning',
	        value: function dateToIsMorning() {
	            return this.get('dateToType') === consts.DATE_TYPE_MORNING;
	        }
	    }, {
	        key: 'getRequestedDays',
	        value: function getRequestedDays() {
	            return this.get('daysRequired');
	        }
	    }, {
	        key: 'getFormattedDateFrom',
	        value: function getFormattedDateFrom() {
	            return _moment2.default.utc(this.get('dateFrom')).format('D MMM YYYY');
	        }
	    }, {
	        key: 'getFormattedDateTo',
	        value: function getFormattedDateTo() {
	            return this.get('dateTo') ? _moment2.default.utc(this.get('dateTo')).format('D MMM YYYY') : this.getFormattedDateFrom();
	        }
	    }, {
	        key: 'approve',
	        value: function approve() {
	            var _this4 = this;
	
	            var url = this.finalUrl() + '/approve';
	            return _axios2.default.post(url, {}, {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function () {
	                return _this4.fetch();
	            });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            return this.save({ status: consts.STATUS_CANCELLED });
	        }
	    }, {
	        key: 'canBeAdded',
	        value: function canBeAdded() {
	            var url = this.baseUrl() + '/canBeAdded';
	            return _axios2.default.get(url, {
	                params: {
	                    employeeId: this.get('employeeId'),
	                    leaveTypeId: this.get('typeId'),
	                    dateFrom: this.get('dateFrom'),
	                    dateFromType: this.get('dateFromType'),
	                    dateTo: this.get('dateTo'),
	                    dateToType: this.get('dateToType')
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data.result;
	            });
	        }
	    }, {
	        key: 'canBeCancelled',
	        value: function canBeCancelled() {
	            var url = this.finalUrl() + '/isCancellable';
	            return _axios2.default.get(url, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                return r.data.result;
	            });
	        }
	    }, {
	        key: 'fetchDaysAllowed',
	        value: function fetchDaysAllowed() {
	            var _this5 = this;
	
	            var employeeId = this.get('employeeId');
	            var type = this.getType();
	
	            if (!employeeId || !type) {
	                return (0, _bluebird.resolve)(0);
	            }
	
	            return (this.getEmployee() ? (0, _bluebird.resolve)(this.getEmployee()) : this.fetchEmployee()).then(function (employee) {
	                return new _leaveTypes2.default([type], { company: null }).fetchBalances(employee, _this5.get('dateFrom'));
	            }).then(function () {
	                var daysAllowed = new _decimal2.default(type.getEntitled()).minus(type.getTaken()).toDP(1, _decimal2.default.ROUND_DOWN).toNumber();
	                return (0, _bluebird.resolve)(daysAllowed);
	            });
	        }
	    }, {
	        key: 'createAttachment',
	        value: function createAttachment(_ref) {
	            var file = _ref.file,
	                name = _ref.name,
	                description = _ref.description;
	
	            var attachment = new _attachment2.default({
	                name: name,
	                description: description,
	                file: {
	                    name: name,
	                    content: file
	                },
	                tags: ['leaveRequest'],
	                attachableId: this.id,
	                attachableType: 'LeaveRequest'
	            });
	
	            return attachment.save();
	        }
	    }, {
	        key: 'getLink',
	        value: function getLink() {
	            return '#calendar/' + this.id + '/view';
	        }
	    }]);
	
	    return LeaveRequest;
	}(_model2.default);
	
	exports.default = LeaveRequest;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _BatchPaymentConfig = __webpack_require__(755);
	
	var _BatchPaymentConfig2 = _interopRequireDefault(_BatchPaymentConfig);
	
	var _batchPaymentConfig = __webpack_require__(757);
	
	var _batchPaymentConfig2 = _interopRequireDefault(_batchPaymentConfig);
	
	var _FreeAccountSetup = __webpack_require__(707);
	
	var _FreeAccountSetup2 = _interopRequireDefault(_FreeAccountSetup);
	
	var _Main = __webpack_require__(758);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	var _payroll = __webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showedRentasAlert = false;
	
	module.exports = Backbone.View.extend({
	    batchPaymentConfig: null,
	    batchPaymentConfigView: null,
	
	    events: {
	        'click .js-back': 'back',
	        'click .js-save': 'save',
	        'click .js-cancel': 'cancel',
	        'ifChecked input[name=paymentType]': 'toggleChequePickup'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        /* FIXME NEVER extend this with options like in the following line of
	         * code, it can have unexpected consequences. The Backbone way is to
	         * use a this.options object.
	         * */
	        _.extend(this, options);
	        this.employees = _.sortBy(this.payslips.map(function (p) {
	            return p.getEmployee();
	        }), function (employee) {
	            return employee.get('fullName');
	        });
	
	        var promise = (0, _bluebird.resolve)(false);
	        // NOTE there are some companies that erronously refer to
	        // a deleted bank account id
	        if (app.company.getBankAccount()) {
	            promise = _batchPaymentConfig2.default.isBankSupported(app.company.get('bankAccountId'));
	        }
	        return promise.then(function (supported) {
	            _this.batchPaymentConfig = new _batchPaymentConfig2.default({
	                payrollId: _this.model.id,
	                bankAccountId: app.company.get('bankAccountId')
	            }, { bankAccount: app.company.getBankAccount() });
	
	            _this.batchPaymentConfigView = new _BatchPaymentConfig2.default({
	                model: _this.batchPaymentConfig,
	                supported: supported
	            });
	
	            _this.render();
	        });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        // use employees to save same order in table
	        this.employees.forEach(function (employee) {
	            employee.payslip = _this2.payslips.find(function (payslip) {
	                return payslip.get('employeeId') === employee.id;
	            });
	        });
	
	        var payrollPrice = this.model.get('billableAmount') / 100;
	        var total = _.reduce(this.employees, function (memo, employee) {
	            return memo + (employee.payslip.get('mtd') || 0) + (employee.payslip.get('cp38') || 0) + (employee.payslip.get('employeeEpf') || 0) + (employee.payslip.get('employerEpf') || 0) + (employee.payslip.get('employeeSocso') || 0) + (employee.payslip.get('employerSocso') || 0) + (employee.payslip.get('employeeEis') || 0) + (employee.payslip.get('employerEis') || 0) + (payrollPrice || 0);
	        }, 0);
	        this.$el.html((0, _Main2.default)({
	            employees: this.employees,
	            payrollPrice: payrollPrice || 'FREE',
	            pcb: new _decimal2.default(this.model.get('mtd') || 0).plus(this.model.get('cp38') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber(),
	            epf: new _decimal2.default(this.model.get('employeeEpf') || 0).plus(this.model.get('employerEpf') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber(),
	            socso: new _decimal2.default(this.model.get('employeeSocso') || 0).plus(this.model.get('employerSocso') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber(),
	            eis: new _decimal2.default(this.model.get('employeeEis') || 0).plus(this.model.get('employerEis') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber(),
	            zakat: this.model.get('zakat') || 0,
	            hrdf: this.model.get('hrdf') || 0,
	            total: total,
	            company: app.company,
	            employerZakat: this.model.get('employerZakat'),
	
	            showPaymentMethods: this.model.getCompany().get('isManaged') !== false,
	            summaryPdf: this.model.has('summaryPdf') ? this.model.get('summaryPdf').url() : null,
	            summaryXls: this.model.has('summaryXls') ? this.model.get('summaryXls').url() : null
	        }));
	
	        this.$pickDate = this.$('.js-pickup-date');
	        this.toggleChequePickup();
	
	        this.$paymentType = this.$('.js-payment-methods input[type="radio"]');
	        this.$paymentType.iCheck({ radioClass: 'iradio_square-blue' });
	
	        this.$('.js-crediting-date').datepicker({
	            autoclose: true,
	            todayHighlight: true
	        });
	
	        this.$('.js-enable-batch-payments').iCheck({
	            checkboxClass: 'icheckbox_square-blue'
	        });
	
	        this.$('.js-batch-payment-config').html('').append(this.batchPaymentConfigView.$el);
	
	        _tooltip2.default.init(this);
	        return this;
	    },
	
	    toggleFreeAccountSetup: function toggleFreeAccountSetup() {
	        var button = $('.js-free-account-setup');
	        _FreeAccountSetup2.default.shouldShowFreeSetup().then(function (show) {
	            if (!show) {
	                button.hide();
	            }
	        });
	    },
	
	    toggleChequePickup: function toggleChequePickup(ev) {
	        var $el = ev ? this.$(ev.currentTarget) : false;
	
	        if (!$el || $el.attr('value') === '2') {
	            this.$pickDate.datepicker({
	                startDate: (0, _moment2.default)().add(35, 'hours').toDate(),
	                weekStart: 1,
	                daysOfWeekDisabled: [0, 6],
	                autoclose: true,
	                todayHighlight: true
	            });
	        } else {
	            this.$pickDate.datepicker('remove');
	        }
	
	        this.$pickDate.find('input').prop('disabled', $el && $el.attr('value') !== '2');
	    },
	
	    save: function save() {
	        var _this3 = this;
	
	        var submit = function submit() {
	            var date = _this3.$pickDate.length ? _this3.$pickDate.datepicker('getDate') : null;
	            var paymentType = _this3.$paymentType.filter(':checked').val();
	
	            if (paymentType === '2' && !date) {
	                _alerts2.default.show('error', {
	                    title: 'Missing pickup date',
	                    text: 'Please provide a date you would like us to                         pickup your cheques',
	                    callback: function callback() {
	                        return _this3.$('.js-pickup-date i').click();
	                    }
	                });
	                return;
	            }
	
	            _this3.batchPaymentConfigView.save().then(function () {
	                return _this3.submitRequest({
	                    date: date,
	                    payroll: _this3.model,
	                    paymentType: paymentType
	                });
	            });
	            _this3.toggleFreeAccountSetup();
	        };
	
	        if (this.shouldShowRentasAlert() && !showedRentasAlert) {
	            this.showRentasAlert();
	            showedRentasAlert = true;
	        } else {
	            submit();
	        }
	    },
	
	    shouldShowRentasAlert: function shouldShowRentasAlert() {
	        var account = app.company.bankAccount;
	
	        if (!account) {
	            return false;
	        }
	
	        var eligibleForPayrollFile = function eligibleForPayrollFile(payslip) {
	            var employee = payslip.employee;
	            var hasNetPay = payslip.get('netPay') > 0;
	            var hasAccount = employee.get('bankAccountId');
	            return hasNetPay && hasAccount;
	        };
	
	        var allHaveEnough = function allHaveEnough(has, payslip) {
	            var net = parseFloat(payslip.get('netPay'));
	            var lessThan = net < 10000;
	            return has || lessThan;
	        };
	
	        var isRhbBank = account.get('bankBnmCode') === '18';
	
	        var isRentas = account.get('transactionType') === '20';
	
	        var hasAnyNetLesserThanAllowed = this.payslips.filter(eligibleForPayrollFile).reduce(allHaveEnough, false);
	
	        return isRhbBank && isRentas && hasAnyNetLesserThanAllowed;
	    },
	
	    showRentasAlert: function showRentasAlert() {
	        _alerts2.default.show('warning', {
	            title: 'Important Note',
	            text: 'For RHB Bank: if the Payment Transaction type is Rentas,                 The Employee Net Salary should be equal or more than RM10,000.'
	        });
	    },
	
	    submitRequest: function submitRequest(data) {
	        var stopLoader = _loader2.default.startFullScreen(this.$('.js-save'));
	
	        return this.model.submit({
	            chequePickupDate: data.date,
	            paymentType: data.paymentType
	        }).then(function () {
	            _localStorageUtil2.default.removeItem('unsavedPayroll');
	
	            _alerts2.default.show('successConfirm', {
	                title: 'Submitted!',
	                text: 'Your payroll has been submitted.',
	                cancelButtonText: 'Later',
	                confirmButtonText: 'View Payroll Status',
	                callback: function callback(isConfirm) {
	                    if (isConfirm) {
	                        app.mainRouter.navigate('payroll/history', { trigger: true });
	                        return;
	                    }
	
	                    app.mainRouter.navigate('dashboard', { trigger: true });
	                }
	            });
	        }).catch(function (err) {
	            if (err.statusCode === 400) {
	                _alerts2.default.show('warning', {
	                    title: 'Warning',
	                    text: 'Please note that your payroll has been                             modified. To view accurate calculations,                             please reload the page.',
	                    allowEscapeKey: false,
	                    callback: window.location.reload.bind(window.location)
	                });
	            } else {
	                _alerts2.default.show('criticalError', err);
	            }
	        }).finally(stopLoader);
	    },
	
	    back: function back() {
	        var _this4 = this;
	
	        var stopLoader = _loader2.default.startFullPage();
	
	        this.model.fetch().then(function () {
	            if (_this4.model.get('status') !== _payroll.payrollStatus.CONFIRMED) {
	                var err = new Error('invalid status');
	                err.statusCode = 400;
	                throw err;
	            }
	
	            _this4.model.setStatus(_payroll.payrollStatus.RAN).then(function () {
	                app.mainRouter.navigate('payroll/step/2', { trigger: true });
	            });
	        }).catch(function (err) {
	            if (err.statusCode === 400 || err.response && err.response.error && err.response.error.statusCode === 400) {
	                _alerts2.default.show('warning', {
	                    title: 'Warning',
	                    text: 'Please note that your payroll has been                             modified. To view accurate calculations,                             please reload the page.',
	                    allowEscapeKey: false,
	                    callback: window.location.reload.bind(window.location)
	                });
	            } else {
	                _alerts2.default.show('criticalError', err);
	            }
	        }).finally(stopLoader);
	    },
	
	    cancel: function cancel() {
	        var _this5 = this;
	
	        _alerts2.default.show('dangerConfirm', {
	            text: 'You will not be able to recover this payroll',
	            confirmButtonText: 'Yes, Restart',
	            loader: true,
	            callback: function callback(confirmed) {
	                if (!confirmed) {
	                    return;
	                }
	                _this5.model.destroy().then(function () {
	                    _localStorageUtil2.default.removeItem('unsavedPayroll');
	                    app.mainRouter.navigate('payroll/step/1', { trigger: true });
	                    _this5.cancelSuccess();
	                }, function (err) {
	                    _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    cancelSuccess: function cancelSuccess() {
	        _alerts2.default.show('success', {
	            title: 'Payroll Reset!',
	            text: 'Your Payroll has been reset.'
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _BatchPaymentConfig = __webpack_require__(756);
	
	var _BatchPaymentConfig2 = _interopRequireDefault(_BatchPaymentConfig);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('batch-payment-config-view');
	
	module.exports = _Form2.default.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(_Form2.default.prototype.events) ? _Form2.default.prototype.events() : _Form2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'ifToggled .js-ext-enable': 'toggleFormFields'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { template: _BatchPaymentConfig2.default });
	        this.options.templateExtra = _.defaults(this.options.templateExtra || {}, {
	            supported: this.options.supported
	        });
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    toggleFormFields: function toggleFormFields(ev) {
	        var _this = this;
	
	        var $toggle = this.$(ev.currentTarget);
	
	        if (!$toggle.is(':checked')) {
	            this.$('form input').each(function (i, el) {
	                if (el !== $toggle[0]) {
	                    _this.$(el).prop('disabled', true);
	                }
	            });
	        } else {
	            this.$('form input').prop('disabled', false);
	        }
	
	        this.toggleError();
	    },
	
	    dirty: function dirty() {
	        return false;
	    },
	
	    save: function save() {
	        if (!this.getInputValue(this.$('.js-ext-enable'))) {
	            log.debug('Not saving batch payment config. Disabled by user');
	            return (0, _bluebird.resolve)();
	        }
	
	        if (!this.options.supported) {
	            log.debug('Not saving batch payment config. Not supported by bank');
	            return (0, _bluebird.resolve)();
	        }
	
	        return this.model.save();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepThree/BatchPaymentConfig.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>\n            Bank Payment File Options\n            <i class="fa fa-question-circle m-l-xs" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                data-original-title="Some banks have optional requirements.\n                    The bank payment files will be included in your payroll\n                    zip once payroll has been submitted.">\n            </i>\n        </h5>\n    </div>\n    <form class="form-horizontal ibox-content" name="batchPaymentSettings">\n        ';
	 if (!model.get('bankAccountId')) { 
	__p+='\n            <div>\n                <h4 class="text-center m-t-sm">\n                    If you want to generate bulk payment files for your\n                    bank account make sure you add it in your company settings.\n                </h4>\n                <h4 class="text-center m-t-md">\n                    <a href="#settings/company">Click here</a> to setup a\n                    bank account\n                </h4>\n            </div>\n        ';
	 } else if (!supported) { 
	__p+='\n            <div>\n                <h4 class="text-center m-t-sm">\n                    We are currently unable to create payment files for\n                    your bank, but we are working on it. Sorry!\n                </h4>\n            </div>\n        ';
	 } else { 
	__p+='\n            <div class="form-group">\n                <label class="col-sm-3 control-label">\n                    Enable\n                </label>\n                <div class="col-sm-9">\n                    <input type="checkbox" name="enable"\n                        data-value-type="boolean"\n                        class="js-icheck js-ext js-ext-enable" checked>\n                </div>\n            </div>\n            ';
	 if (model.isCreditingDateRequired()) { 
	__p+='\n                <div class="form-group">\n                    <label class="col-sm-3 control-label">\n                        Crediting Date\n                        <i class="fa fa-question-circle m-l-xs" data-toggle="tooltip"\n                            data-placement="top" data-container="body"\n                            data-html="true"\n                            data-original-title="Bank files can\'t be submitted\n                                with a past crediting date. Kindly submit your\n                                files before crediting date"></i>\n                    </label>\n                    <div class="col-sm-9">\n                        <div class="input-group date js-datepicker\n                            js-attr-creditingDate">\n                            <span class="input-group-addon">\n                                <i class="fa fa-calendar"></i>\n                            </span>\n                            <input data-provide="datepicker" type="text" name="creditingDate"\n                                data-date-format="dd/mm/yyyy"\n                                data-date-start-date="+0d"\n                                class="form-control js-datapicker-input" value="">\n                        </div>\n                        <span class="error error-creditingDate"></span>\n                    </div>\n                </div>\n            ';
	 } 
	__p+='\n\n            ';
	 /* This form is made of fields that are saved into the settings
	             attribute of the model. The following markup is so that the view
	             instance knows were to put the error if the settings object turns
	             out to be invalid */ 
	__p+='\n             <div class="form-group">\n                <div class="col-sm-offset-3 col-sm-9">\n                    <input type="hidden" name="settings">\n                    <span class="error error-settings"></span>\n                </div>\n            </div>\n\n        ';
	 } 
	__p+='\n    </form>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _validate2 = __webpack_require__(58);
	
	var _validate3 = _interopRequireDefault(_validate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchPaymentConfig = function (_Model) {
	    _inherits(BatchPaymentConfig, _Model);
	
	    _createClass(BatchPaymentConfig, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/BatchPaymentConfigs';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                isCreditingDateRequired: false,
	                settings: {}
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                payrollId: { presence: { message: '^Payroll is required' } },
	                // todo validate that the bank account supports bulk payments
	                bankAccountId: { presence: { message: '^Bank account is required' } },
	                settings: { batchPaymentSettings: true },
	                isCreditingDateRequired: { presence: true }
	            };
	        }
	    }, {
	        key: 'settingsConstraints',
	        value: function settingsConstraints() {
	            return {
	                creditingDate: { presence: { message: '^Crediting date is required' } }
	            };
	        }
	    }]);
	
	    function BatchPaymentConfig() {
	        _classCallCheck(this, BatchPaymentConfig);
	
	        var _this = _possibleConstructorReturn(this, (BatchPaymentConfig.__proto__ || Object.getPrototypeOf(BatchPaymentConfig)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(BatchPaymentConfig, [{
	        key: 'initialize',
	        value: function initialize(attrs) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$bankAccount = _ref.bankAccount,
	                bankAccount = _ref$bankAccount === undefined ? null : _ref$bankAccount;
	
	            this.idAttribute = 'objectId';
	            _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'initialize', this).apply(this, arguments);
	            this.bankAccount = bankAccount;
	            return this;
	        }
	    }, {
	        key: 'set',
	        value: function set(attr, value) {
	            var _this2 = this;
	
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var changes = {};
	            var settings = this.get('settings') || {};
	
	            if (typeof attr === 'string') {
	                changes[attr] = value;
	            }
	
	            if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) === 'object' && attr) {
	                changes = attr;
	                options = value || {};
	            }
	
	            if (options && options.force === true) {
	                return _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'set', this).apply(this, arguments);
	            }
	
	            Object.keys(changes).forEach(function (key) {
	                if (typeof _this2.constraints()[key] === 'undefined') {
	                    settings[key] = changes[key];
	                    delete changes[key];
	                }
	            });
	            changes.settings = settings;
	
	            return _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'set', this).call(this, changes, options);
	        }
	    }, {
	        key: 'get',
	        value: function get(attr, options) {
	            var settings = _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'get', this).call(this, 'settings') || {};
	
	            if (options && options.force === true) {
	                return _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'get', this).apply(this, arguments);
	            }
	
	            if (typeof this.attributes[attr] !== 'undefined') {
	                return _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'get', this).apply(this, arguments);
	            }
	
	            if (typeof settings[attr] !== 'undefined') {
	                return settings[attr];
	            }
	
	            return _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'get', this).apply(this, arguments);
	        }
	    }, {
	        key: 'validate',
	        value: function validate(attributes) {
	            var r = _get(BatchPaymentConfig.prototype.__proto__ || Object.getPrototypeOf(BatchPaymentConfig.prototype), 'validate', this).apply(this, arguments);
	            if (r !== false) {
	                // if not valid
	                return r;
	            }
	
	            var accountId = attributes.bankAccountId;
	            if (!accountId) {
	                return r;
	            }
	
	            var constraints = this.isCreditingDateRequired() ? this.settingsConstraints() : null;
	            if (!constraints) {
	                return r;
	            }
	
	            return (0, _validate3.default)(attributes.settings, constraints);
	        }
	    }, {
	        key: 'getBankAccount',
	        value: function getBankAccount() {
	            return this.bankAccount;
	        }
	    }, {
	        key: 'isCreditingDateRequired',
	        value: function isCreditingDateRequired() {
	            // can't tell without a bankAccount, we default to false
	            if (!this.bankAccount) {
	                return false;
	            }
	
	            return ['08', '18', '22', '26', '27', '29', '33', '35'].includes(this.bankAccount.get('bankBnmCode'));
	        }
	    }], [{
	        key: 'isBankSupported',
	        value: function isBankSupported(bankAccountId) {
	            var baseUrl = new BatchPaymentConfig({}).baseUrl();
	            return _axios2.default.get(baseUrl + '/isBankSupported/' + bankAccountId, {
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data;
	            }).catch(function (err) {
	                throw err.response.data.error;
	            });
	        }
	    }]);
	
	    return BatchPaymentConfig;
	}(_model2.default);
	
	exports.default = BatchPaymentConfig;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepThree/Main.ejs -->\n<div class="row">\n    <div class="col-md-12 col-lg-12 wizard-payroll-content payroll-third-step">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Pay Employees</h5>\n                <i class="fa fa-question-circle m-l-xs" data-toggle="tooltip"\n                    data-placement="top" data-container="body"\n                    data-original-title="You can now refer to the list below\n                        for all net payments due to your employees">\n                </i>\n            </div>\n            <div class="ibox-content">\n                <table data-striping="false" class="footable\n                    footable-pay-employee footable-ellipsis\n                    table table-stripped">\n                    <thead>\n                        <tr class="tr-md">\n                            <th style="width: auto;">Employee</th>\n                            <th style="width: 140px;" class="text-right">\n                                Net Pay\n                            </th>\n                            <th style="width: 60px;"></th>\n                        </tr>\n                    </thead>\n                    <tbody>\n\n                    ';
	 _.each(employees, function(employee) { 
	__p+='\n                        <tr class="tr-md">\n                            <td>\n                                <span>\n                                    '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n                                </span>\n                                <small>\n                                    '+
	((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
	'\n                                </small>\n                            </td>\n                            <td class="text-right">\n                                '+
	((__t=( employee.payslip.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                            </td>\n                            <td></td>\n                        </tr>\n                    ';
	 }); 
	__p+='\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Other Payments</h5>\n            </div>\n            <div class="ibox-content">\n                <table data-striping="false"\n                    class="footable footable-check-collection\n                        footable-ellipsis table table-stripped">\n                    <thead>\n                    <tr class="tr-md">\n                        <th style="width: auto;">Payment</th>\n                        <th style="width: 160px;" class="text-right">Amount</th>\n                        <th style="width: 60px;"></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n\n                    <tr class="tr-md">\n                        <td>\n                            <span>Lembaga Hasil Dalam Negeri</span>\n                            <small>PCB</small>\n                        </td>\n                        <td class="text-right">\n                            '+
	((__t=( (pcb || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </td>\n                        <td></td>\n                    </tr>\n                    <tr class="tr-md">\n                        <td>\n                            <span>Kumpulan Wang Simpanan Pekerja</span>\n                            <small>EPF</small>\n                        </td>\n                        <td class="text-right">\n                            '+
	((__t=( (epf|| 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </td>\n                        <td></td>\n                    </tr>\n                    <tr class="tr-md">\n                        <td>\n                            <span>Pertubuhan Keselamatan Sosial</span>\n                            <small>SOCSO</small>\n                        </td>\n                        <td class="text-right">\n                            '+
	((__t=( (socso || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </td>\n                        <td></td>\n                    </tr>\n                    <tr class="tr-md">\n                        <td>\n                            <span>Pertubuhan Keselamatan Sosial</span>\n                            <small>EIS</small>\n                        </td>\n                        <td class="text-right">\n                            '+
	((__t=( (eis || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </td>\n                        <td></td>\n                    </tr>\n                    <tr class="tr-md">\n                        <td>\n                            <span>Pembangunan Sumber Manusia Berhad</span>\n                            <small>HRDF</small>\n                        </td>\n                        <td class="text-right">\n                            '+
	((__t=( (hrdf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </td>\n                        <td></td>\n                    </tr>\n                    ';
	 if (employerZakat) { 
	__p+='\n                        <tr class="tr-md">\n                            <td>\n                                <span>Zakat</span>\n                                <small></small>\n                            </td>\n                            <td class="text-right">\n                                '+
	((__t=( employerZakat.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                            </td>\n                            <td></td>\n                        </tr>\n                    ';
	 } 
	__p+='\n                    <tr class="tr-md">\n                        <td>\n                            <span>Payroll Panda Sdn Bhd</span>\n                            <small>(Excluding SST)</small>\n                        </td>\n                        <td class="text-right">\n                            '+
	((__t=( payrollPrice.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                        </td>\n                        <td></td>\n                    </tr>\n                    </tbody>\n                </table>\n\n                ';
	 if (showPaymentMethods) { 
	__p+='\n                    <div class="hr-line-dashed"></div>\n                    ' + __webpack_require__(759).apply(null,arguments) + '\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n\n        <div class="js-batch-payment-config"></div>\n\n        <div class="ibox float-e-margins">\n            <div class="wizard-footer text-right">\n                <button type="button"\n                    class="btn btn-w-m btn-white btn-transparent js-back">\n                    <i class="fa fa-arrow-left"></i>\n                    Back to Summary &amp; Payslips\n                </a>\n                <button type="button" class="btn btn-w-m btn-warning js-cancel"\n                    data-toggle="tooltip"\n                    data-title="No changes will be saved" data-placement="top"\n                    data-delayed>\n                    <i class="fa fa-exclamation-triangle"></i>\n                    Cancel &amp; Restart\n                </button>\n                <button type="button" class="btn btn-w-m btn-primary js-save">\n                    <i class="fa fa-check"></i>\n                    Submit Payroll\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/stepThree/PaymentMethods.ejs -->\n<div class="container-fluid payment-methods js-payment-methods">\n    <h4> Payment Methods </h4>\n    <ul class="list-unstyled">\n        <li class="row">\n            <label class="col-sm-6 col-md-5 col-lg-4">\n                <input type="radio" name="paymentType"\n                    value="1">\n                <span>Send Other Payments via Bank</span>\n            </label>\n            <div class="col-sm-6 col-md-4">\n                <small>\n                    Total Amount: '+
	((__t=( total.formatWithoutRounding() ))==null?'':_.escape(__t))+
	' [Bank account]\n                </small>\n            </div>\n        </li>\n\n        <li class="row">\n            <label class="col-sm-6 col-md-5 col-lg-4">\n                <input type="radio" name="paymentType"\n                    value="2" checked>\n                <span>\n                    Choose date for cheque\n                    pickups\n                    <i class="fa fa-question-circle m-l-xs"\n                        data-toggle="tooltip"\n                        data-placement="bottom"\n                        date-container="body"\n                        data-original-title="Please select a\n                            date you would like us to pick up\n                            the cheques for the statutory\n                            bodies. We cannot pickup the next\n                            day if you submit after 1pm">\n                    </i>\n                </span>\n            </label>\n            <div class="col-sm-6 col-md-4 col-lg-3">\n                <div class="input-group date js-pickup-date"\n                    data-date-format="dd/mm/yyyy">\n\n                    <span class="input-group-addon">\n                        <i class="fa fa-calendar"></i>\n                    </span>\n                    <input type="text"\n                        class="form-control"\n                        value="">\n                </div>\n            </div>\n        </li>\n\n        <li class="row">\n            <label class="col-sm-6 col-md-5 col-lg-4">\n                <input type="radio" name="paymentType"\n                    value="3">\n                <span>\n                    Send cheques via your own courier service\n                </span>\n        </li>\n    <ul>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(761);
	var ItemView = __webpack_require__(762);
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            attachments: null,
	            integration: null,
	            payrollIntegrations: {}
	        });
	
	        this.itemViews = [];
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({ collection: this.collection }));
	        this.toggleEmptyLabel();
	
	        if (this.collection) {
	            this.collection.each(this.renderPayroll.bind(this));
	            this.$('.sk-spinner').hide();
	        }
	
	        return this;
	    },
	
	    setCollection: function setCollection(options) {
	        this.collection = options.collection || null;
	        this.options.attachments = options.attachments || null;
	        this.options.integration = options.integration || null;
	        this.options.payrollIntegrations = options.payrollIntegrations || null;
	
	        return this.render();
	    },
	
	    renderPayroll: function renderPayroll(model, index) {
	        var view = new ItemView({
	            model: model,
	            attachments: this.options.attachments[model.id],
	            integration: this.options.integration,
	            payrollIntegration: this.options.payrollIntegrations[model.id]
	        });
	
	        this.itemViews.push(view);
	        this.$('.payroll-history-items').append(view.$el);
	
	        if (index % 2 === 1) {
	            this.$('.payroll-history-items').append('<div class="col-xs-12"></div>');
	        }
	    },
	
	    toggleEmptyLabel: function toggleEmptyLabel() {
	        this.$('.empty-list').toggleClass('hidden', !_.isNull(this.collection) || this.collection.length > 0);
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/PayrollHistory.html -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="payroll-history-title">\n            ';
	 if (!collection) { 
	__p+='\n                Loading payrolls\n            ';
	 } else if (collection && collection.length <= 0) { 
	__p+='\n                No payrolls available\n            ';
	 } else { 
	__p+='\n                Viewing '+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' Payrolls:\n\n                ';
	 if (collection.getSavedCount()) { 
	__p+='\n                    <div class="label label-default">\n                        '+
	((__t=( collection.getSavedCount() ))==null?'':_.escape(__t))+
	' Saved\n                    </div>\n                ';
	 } 
	__p+='\n                ';
	 if (collection.getSubmittedCount()) { 
	__p+='\n                    <div class="label label-warning">\n                        '+
	((__t=( collection.getSubmittedCount() ))==null?'':_.escape(__t))+
	' Submitted\n                    </div>\n                ';
	 } 
	__p+='\n                ';
	 if (collection.getCompletedCount()) { 
	__p+='\n                    <div class="label label-primary">\n                        '+
	((__t=( collection.getCompletedCount() ))==null?'':_.escape(__t))+
	' Completed\n                    </div>\n                ';
	 } 
	__p+='\n            ';
	 } 
	__p+='\n        </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n<div class="row">\n<div class="col-md-12 col-lg-12">\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>Payroll History</h5>\n    </div>\n\n    <div class="ibox-content">\n        <div class="row payroll-history-items">\n            <div class="col-xs-12">\n                '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n\n                <div class="empty-list text-center">\n                    <h1>\n                        You currently have no saved, submitted or\n                        completed payrolls.\n                    </h1>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n</div>\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _Item = __webpack_require__(763);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _PickupDateModal = __webpack_require__(764);
	
	var _PickupDateModal2 = _interopRequireDefault(_PickupDateModal);
	
	var _SendPayslipsModal = __webpack_require__(766);
	
	var _SendPayslipsModal2 = _interopRequireDefault(_SendPayslipsModal);
	
	var _downloadjs = __webpack_require__(666);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    className: 'col-lg-6',
	
	    events: {
	        'click .js-cancel-payroll': 'cancel',
	        'click .js-set-date': 'setDate',
	        'click .js-download-payroll': 'download',
	        'click .js-send-payslips': 'sendPayslips',
	        'click .js-finish-payroll': 'finish',
	        'click .js-sync': 'sync'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.options = Object.assign({ attachments: null, integration: null }, options || {});
	
	        if (this.model.get('paymentType') === '2') {
	            this.pickupDateModal = new _PickupDateModal2.default();
	        }
	        this.sendPayslipsModal = new _SendPayslipsModal2.default();
	
	        this.model.on('change', this.render, this);
	
	        if (!this.options.integration) {
	            return this.render();
	        }
	
	        this.model.fetchIntegrations({ filter: {
	                where: { integrationId: this.options.integration.id },
	                limit: 1
	            } }).then(function () {
	            return _this.render();
	        });
	        return this;
	    },
	
	    render: function render() {
	        var archive = this.options.attachments.findByTags(['payroll', 'archive', 'ready']).first();
	
	        this.$el.html((0, _Item2.default)({
	            company: app.company,
	            model: this.model,
	            summaryPdf: this.options.attachments.findByTags(['payroll', 'pdf'], ['form', 'receipt', 'upload']).first(),
	            summaryXls: this.options.attachments.findByTags(['payroll', 'xls'], ['form', 'receipt', 'upload']).first(),
	            archive: archive,
	            payslipsPdf: this.options.attachments.findByTags(['payslip', 'list', 'pdf']).first(),
	            receipts: this.options.attachments.findByTags(['tax-receipt', 'upload']),
	            showFinishButton: this.model.get('status') === 3 && app.company.get('mppAdminId'),
	            showSyncButton: this.options.integration && this.model.get('status') === 9,
	            integrationProvider: this.options.integration && this.options.integration.get('provider') === 'xero' ? 'Xero' : 'Quickbooks',
	            lastSyncAt: this.model.getIntegrations().length ? (0, _moment2.default)(this.model.getIntegrations().first().get('syncedAt')).format('DD/MM/YYYY') : '',
	            pcb: new _decimal2.default(this.model.get('mtd') || 0).plus(this.model.get('cp38') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toFixed(2),
	            epf: new _decimal2.default(this.model.get('employerEpf') || 0).plus(this.model.get('employeeEpf') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toFixed(2),
	            socso: new _decimal2.default(this.model.get('employerSocso') || 0).plus(this.model.get('employeeSocso') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toFixed(2),
	            eis: new _decimal2.default(this.model.get('employerEis') || 0).plus(this.model.get('employeeEis') || 0).toDP(2, _decimal2.default.ROUND_HALF_UP).toFixed(2)
	
	        }));
	
	        _tooltip2.default.init(this);
	
	        return this;
	    },
	
	    cancel: function cancel() {
	        var _this2 = this;
	
	        _modal2.default.confirm({
	            text: 'You will not be able to recover this payroll',
	            confirmButtonText: 'Yes, Cancel Payroll',
	            customClass: 'sweet-alert-error',
	            closeOnConfirm: false,
	            showLoaderOnConfirm: true,
	            callback: function callback(confirm) {
	                if (!confirm) {
	                    return;
	                }
	
	                _this2.model.destroy().then(function () {
	                    _localStorageUtil2.default.removeItem('unsavedPayroll');
	                    _this2.trigger('deleted');
	                    _this2.undelegateEvents();
	                    _this2.remove();
	                    _this2.cancelSuccess();
	                }, function (err) {
	                    return _modal2.default.error({ text: err });
	                });
	            }
	        });
	    },
	
	    cancelSuccess: function cancelSuccess() {
	        _modal2.default.success({
	            title: 'Payroll Cancelled!',
	            text: 'Your Payroll has been cancelled.'
	        });
	    },
	
	    setDate: function setDate() {
	        this.pickupDateModal.setModel(this.model);
	        this.pickupDateModal.render();
	        this.pickupDateModal.show();
	        return false;
	    },
	
	    download: function download() {
	        var archive = this.options.attachments.findByTags(['payroll', 'archive', 'ready']).first();
	
	        if (archive) {
	            /* jQuery ajax cannot be used here because messes up the response */
	            var xhr = new XMLHttpRequest();
	            xhr.open('GET', archive.getUrl(), true);
	            xhr.responseType = 'blob';
	            xhr.onload = function () {
	                // TODO: handle errors
	                // Alternatively we could use the whatwg-fetch polyfill
	                if (this.status == 200) {
	                    // get binary data as a response
	                    var blob = this.response;
	                    (0, _downloadjs2.default)(blob, archive.get('name'), 'application/zip');
	                }
	            };
	            xhr.send();
	        } else {
	            _alerts2.default.show('infoConfirm', {
	                title: 'File nearly ready!',
	                html: 'Your Payroll zip that contains all your ' + 'payroll files is being processed and should be ready ' + 'shortly. It usually takes a few seconds or a minute at busy ' + 'periods. Close this popup and refresh the page to see if ' + 'it is ready',
	                confirmButtonText: 'OK',
	                showCancelButton: false
	            });
	        }
	    },
	
	    sendPayslips: function sendPayslips() {
	        var _this3 = this;
	
	        return this.model.fetchPayslips().then(function (payslips) {
	            return (0, _bluebird.all)(payslips.map(function (payslip) {
	                return payslip.fetchEmployee();
	            })).then(function () {
	                return payslips;
	            });
	        }).then(function (payslips) {
	            _this3.sendPayslipsModal.setModel(_this3.model);
	            _this3.sendPayslipsModal.setCollection(payslips);
	            _this3.sendPayslipsModal.render();
	            _this3.sendPayslipsModal.show();
	            return false;
	        });
	    },
	
	    finish: function finish(ev) {
	        var stopLoader = _loader2.default.startFullScreen(ev.currentTarget);
	
	        return this.model.finish().then(function () {
	            _alerts2.default.show('infoConfirm', {
	                title: 'Payroll Being Processed',
	                html: 'Your Payroll is being processed. You will receive ' + 'an email when it\'s ready.',
	                confirmButtonText: 'OK',
	                showCancelButton: false
	            });
	        }).catch(function () {
	            _alerts2.default.show('infoConfirm', {
	                title: 'Error while finishing payroll!',
	                confirmButtonText: 'OK',
	                showCancelButton: false
	            });
	        }).finally(stopLoader);
	    },
	
	    sync: function sync(ev) {
	        var _this4 = this;
	
	        var stopLoader = _loader2.default.startFullScreen(ev.currentTarget);
	
	        this.model.syncPayroll(this.options.integration).then(function () {
	            return _this4.model.fetchIntegrations({ filter: {
	                    where: { integrationId: _this4.options.integration.id },
	                    limit: 1
	                } });
	        }).then(function () {
	            _alerts2.default.show('infoConfirm', {
	                title: 'Payroll Synced',
	                html: 'Your Payroll has been successfully synced!',
	                confirmButtonText: 'OK',
	                showCancelButton: false
	            });
	
	            _this4.render();
	        }).catch(function (err) {
	            err || (err = {});
	            var title = 'Unknown synchronization error';
	            var msg = 'Please try again shortly';
	
	            var errorMsg = typeof err.message === 'string' ? JSON.parse(err.message) : err.message || {};
	
	            if (_this4.options.integration.get('provider') === 'quickbooks') {
	                title = 'QuickBooks error';
	                if (_typeof(errorMsg.error) === 'object' && typeof errorMsg.error.Fault !== 'undefined' && typeof errorMsg.error.Fault.Error !== 'undefined') {
	                    msg = '<ul class="text-left">';
	                    msg += errorMsg.error.Fault.Error.map(function (qbErr) {
	                        return '<li>' + qbErr.Detail + '</li>';
	                    }).join('');
	                    msg += '</ul>';
	                    msg += '<br>Possible causes are erroneous mappings to                            the chart of accounts.\n                            Please review your settings before trying to sync                            again.                             If the error persists, don\u2019t hesitate to contact                            our support team via chat or email.';
	                } else {
	                    msg = errorMsg;
	                }
	            }
	
	            // added xero errors
	            // TODO change all this!
	            if (_this4.options.integration.get('provider') === 'xero') {
	                if (_typeof(errorMsg.error) && errorMsg.error.length > 0) {
	
	                    title = 'Xero mapping error';
	                    msg = 'Missing items: <br /><br />';
	                    msg += errorMsg.error.join('<br />');
	                } else if (typeof errorMsg.error === 'string') {
	                    title = 'Xero authentication error';
	                    msg = errorMsg.error;
	                }
	            }
	
	            _alerts2.default.show('error', { title: title, html: msg });
	        }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payrollHistory/Item.ejs -->\n<div class="ibox float-e-margins payroll-history-item\n    payroll-status-'+
	((__t=( model.get('status') ))==null?'':_.escape(__t))+
	'">\n    <div class="ibox-title">\n        '+
	((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
	'\n        <span class="label pull-right\n            '+
	((__t=(
	                model.get('status') < 3 ? 'label-default' :
	                model.get('status') === 9 ? 'label-primary' :
	                    'label-warning'
	            ))==null?'':_.escape(__t))+
	'">\n            '+
	((__t=(
	                model.getStatusLabel()
	            ))==null?'':_.escape(__t))+
	'\n        </span>\n    </div>\n    <div class="ibox-content">\n        <div class="row">\n            <div class="col-xs-5 total">\n                <h2>\n                    '+
	((__t=( model.get('payslips') ))==null?'':_.escape(__t))+
	'\n                </h2>\n                Employees\n            </div>\n            <div class="col-xs-7 total">\n                <h2>\n                    RM '+
	((__t=( model.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                </h2>\n                Gross\n            </div>\n        </div>\n    </div>\n    <div class="ibox-content summary">\n        <div class="row">\n            <div class="col-xs-3 tax-total">\n                <h3>Total PCB</h3>\n                <h3>'+
	((__t=( pcb ))==null?'':_.escape(__t))+
	'</h3>\n            </div>\n            <div class="col-xs-3 tax-total">\n                <h3>Total EPF</h3>\n                <h3>'+
	((__t=( epf ))==null?'':_.escape(__t))+
	'</h3>\n            </div>\n            <div class="col-xs-3 tax-total">\n                <h3>Total SOCSO</h3>\n                <h3>'+
	((__t=( socso ))==null?'':_.escape(__t))+
	'</h3>\n            </div>\n            <div class="col-xs-3 tax-total">\n                <h3>Total EIS</h3>\n                <h3>\n                    '+
	((__t=( eis ))==null?'':_.escape(__t))+
	'\n                </h3>\n            </div>\n        </div>\n\n        <div class="m-t">\n            ';
	  if (model.get('status') > 0) {  
	__p+='\n                <h3>\n                    <a href="#payroll/view/'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'/summary">\n                        <i class="fa fa-table" aria-hidden="true"></i>\n                        Payroll Summary Report\n                    </a>\n                </h3>\n                <h3 class="m-t-xs">\n                    <a href="#payroll/view/'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'/payslips">\n                        <i class="fa fa-th-list" aria-hidden="true"></i>\n                        Payslips\n                    </a>\n                </h3>\n            ';
	  } else { 
	__p+='\n                <h3><i class="fa fa-table" aria-hidden="true"></i>\n                    <span class="disabled">Payroll Summary Report</span>\n                </h3>\n                <h3 class="m-t-xs">\n                    <i class="fa fa-th-list" aria-hidden="true"></i>\n                    <span class="disabled">Payslips</span>\n                </h3>\n            ';
	  } 
	__p+='\n        </div>\n    </div>\n    <div class="ibox-content receipts">\n        <div class="row clearfix">\n            <div class="pull-left">\n                ';
	 if (!(company.get('isManaged') === false
	                    && model.get('status') <= 3)) {  
	__p+='\n                <i class="fa icon\n                    '+
	((__t=( model.get('status') <= 1
	                        && model.get('paymentType') === '2'?
	                            'fa-calendar' :
	                        model.get('status') <= 3 ?
	                            'fa-bicycle' :
	                        model.get('status') <= 7 ?
	                            'fa-university' :
	                            'fa-check-square-o'
	                    ))==null?'':_.escape(__t))+
	'">\n                </i>\n                ';
	 }  
	__p+='\n            </div>\n            <div class="">\n                <div class="status status-unsubmitted status-submitted">\n                    ';
	 if (model.get('status') < 9
	                        && model.get('paymentType') === '2') { 
	__p+='\n                        <h3>Picking Up Cheques On:</h3>\n                        <h4>\n                            '+
	((__t=( model.getFormatted(
	                                'chequePickupDate', 'dddd, D MMMM'
	                            ) || ' - ' ))==null?'':_.escape(__t))+
	'\n                        </h4>\n                    ';
	 } else if (model.get('status') > 8) { 
	__p+='\n                        <h3>Payroll Submitted On:</h3>\n                        <h4>\n                            '+
	((__t=( model.getFormatted(
	                                'submittedDate', 'dddd, D MMMM'
	                            ) || ' - ' ))==null?'':_.escape(__t))+
	'\n                        </h4>\n                    ';
	 } 
	__p+='\n                </div>\n            </div>\n        </div>\n\n        ';
	 if (company.get('isManaged') !== false && receipts.length > 0) {  
	__p+='\n        <div class="receipt-links\n            '+
	((__t=( model.get('status') < 9 ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'">\n            <h3>Receipts:</h3>\n            <div class="row">\n                <ul>\n                    ';
	 receipts.forEach(function(attachment) { 
	__p+='\n                    <li>\n                        <a href="'+
	((__t=( attachment.getUrl() ))==null?'':_.escape(__t))+
	'" target="_blank">\n                            '+
	((__t=( attachment.get('description') ))==null?'':_.escape(__t))+
	'\n                            <span class="small">\n                                ('+
	((__t=( attachment.get('name') ))==null?'':_.escape(__t))+
	')\n                            </span>\n                        </a>\n                    </li>\n                    ';
	 }) 
	__p+='\n                </ul>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n\n        <div class="row m-t-lg text-right">\n            <div class="col-xs-12">\n                ';
	 if (showFinishButton) { 
	__p+='\n                    <button class="btn btn-outline btn-success\n                        btn-continue-payroll js-finish-payroll"\n                            data-loading-text="Submitting...">\n                        <i class="fa fa-arrow-circle-left"></i>\n                        Finish Payroll\n                    </button>\n                ';
	 } 
	__p+='\n\n\n                ';
	 if (model.get('status') === 3) { 
	__p+='\n                    <button class="btn btn-outline btn-warning\n                        btn-cancel-payroll js-cancel-payroll"\n                        data-loading-text="Cancelling...">\n                        <i class="fa fa-exclamation-triangle"></i>\n                        Cancel Payroll\n                    </button>\n                ';
	 } 
	__p+='\n\n                ';
	 if (model.get('status') < 3) { 
	__p+='\n                    <a href="#payroll"\n                        class="btn btn-outline btn-success\n                            btn-continue-payroll"\n                        data-toggle="tooltip"\n                        data-title="Proceed running payroll for current month"\n                        data-placement="top" data-delayed>\n                        <i class="fa fa-arrow-circle-left"></i>\n                        Continue Payroll\n                    </a>\n                ';
	 } 
	__p+='\n\n                ';
	 if (
	                    model.get('status') === 3 &&
	                    model.get('paymentType') === '2' &&
	                    !model.get('chequePickupDate')
	                ) { 
	__p+='\n                    <button\n                        class="btn btn-outline btn-success js-set-date">\n                        <i class="fa fa-calendar"></i>\n                        Set Date\n                    </button>\n                ';
	 } 
	__p+='\n\n                ';
	 if (showSyncButton) { 
	__p+='\n                    <button class="btn btn-outline btn-success js-sync">\n                        <i class="fa fa-refresh"></i>\n                        Sync with '+
	((__t=( integrationProvider ))==null?'':_.escape(__t))+
	'\n                    </button>\n                ';
	 } 
	__p+='\n                ';
	 if (lastSyncAt) { 
	__p+='\n                    Last Sync at: '+
	((__t=( lastSyncAt ))==null?'':_.escape(__t))+
	'\n                ';
	 } 
	__p+='\n\n                ';
	 if (model.get('status') === 9) { 
	__p+='\n                    ';
	 if (archive) { 
	__p+='\n                        <button class="btn btn-outline btn-success js-send-payslips">\n                            <i class="fa fa-envelope-o"></i>\n                            Send Payslips\n                        </button>\n                    ';
	 } else { 
	__p+='\n                        <button class="btn btn-outline btn-success">\n                            <i class="fa fa-envelope-o"></i>\n                            Not ready\n                        </button>\n                    ';
	 } 
	__p+='\n                    <a class="btn btn-outine btn-primary js-download-payroll">\n                        <i class="fa fa-download"></i>\n                        '+
	((__t=( archive ?
	                            'Download' : 'Not ready' ))==null?'':_.escape(__t))+
	'\n                    </a>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var template = __webpack_require__(765);
	var ModalForm = __webpack_require__(665);
	var loader = __webpack_require__(534);
	var moment = __webpack_require__(101);
	
	module.exports = ModalForm.extend({
	
	    events: {
	        'click .js-cancel': 'cancel',
	        'click .js-save': 'save'
	    },
	
	    setModel: function setModel(model) {
	        var self = this;
	        self.model = model;
	    },
	
	    render: function render() {
	        var self = this;
	        self.$el.html(template());
	        self.$pickDate = self.$('.js-pickup-date');
	        self.$pickDate.datepicker({
	            startDate: moment.tz('Asia/Kuala_Lumpur').add(24 + 11, 'hours').toDate(),
	            weekStart: 1,
	            daysOfWeekDisabled: [0, 6],
	            autoclose: true,
	            todayHighlight: true
	        });
	        return self;
	    },
	
	    save: function save() {
	        var self = this;
	        self.model.set({
	            chequePickupDate: self.$pickDate.datepicker('getDate')
	        });
	        if (self.model.isValid()) {
	            var stopLoader = loader.startFullScreen(self.$('.js-save'));
	            self.model.save().then(function () {
	                self.trigger('save', self.model);
	                self.hide();
	                stopLoader();
	            });
	        }
	    }
	});

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payrollHistory/PickupDateModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            <h3>Set Pickup Date</h3>\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <!-- name -->\n                    <div class="form-group">\n                        <label class="col-sm-5 control-label">\n                            Choose date for cheque\n                            pickups\n                            <i class="fa fa-question-circle m-l-xs"\n                               data-toggle="tooltip"\n                               data-placement="top"\n                               date-container="body"\n                               data-original-title="Please select a\n                                    date you would like us to pick up\n                                    the cheques for the statutory\n                                    bodies. We cannot pickup the next\n                                    day if you submit after 1pm">\n                            </i>\n                        </label>\n                        <div class="col-sm-5">\n                            <div class="input-group date js-pickup-date"\n                                 data-date-format="dd/mm/yyyy">\n\n                                    <span class="input-group-addon">\n                                        <i class="fa fa-calendar"></i>\n                                    </span>\n                                <input type="text"\n                                       class="form-control"\n                                       value="">\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body" \n                data-title="No changes will be saved" data-placement="top" \n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Alerts = __webpack_require__(529);
	
	var template = __webpack_require__(767);
	var ModalForm = __webpack_require__(665);
	var loader = __webpack_require__(534);
	var moment = __webpack_require__(101);
	
	module.exports = ModalForm.extend({
	
	    events: {
	        'click .js-cancel': 'cancel',
	        'click .js-send': 'send',
	        'click .js-reSend': 'reSend'
	    },
	
	    setModel: function setModel(model) {
	        this.model = model;
	    },
	
	    setCollection: function setCollection(collection) {
	        this.collection = collection;
	    },
	
	    render: function render() {
	        var list = [];
	        var wereSent = [];
	
	        this.collection.each(function (payslip) {
	            var item = {
	                id: payslip.id,
	                name: payslip.getEmployee().get('fullName'),
	                email: payslip.getEmployee().get('email')
	            };
	            if (payslip.get('payslipSent')) {
	                item.sentTime = moment(payslip.get('payslipSent')).format('DD-MMM-YYYY');
	                wereSent.push(item);
	            }
	            list.push(item);
	        });
	
	        var $tpl = template({
	            payslips: this.collection,
	            payroll: this.model,
	            wereSent: wereSent,
	            list: list
	        });
	
	        this.$el.html($tpl);
	        this.$('#send-people').chosen({ width: '95%' });
	        this.$('.js-reSend, .js-reSend-box').toggle(wereSent.length > 0);
	        this.$('.js-send, .js-send-box').toggle(wereSent.length === 0);
	        return this;
	    },
	
	    reSend: function reSend() {
	        this.$('.js-reSend, .js-reSend-box').toggle();
	        this.$('.js-send, .js-send-box').toggle();
	    },
	
	    send: function send(ev) {
	        var _this = this;
	
	        var stopLoader = loader.startFullScreen(this.$(ev.currentTarget));
	        var payslips = this.$('.js-people').val();
	
	        return this.model.sendPayslips(payslips).then(function () {
	            Alerts.show('success', {
	                title: '',
	                text: 'The payslips will be sent shortly to the ' + 'selected employees with emails',
	                callback: function callback() {
	                    // Seriously?? SERIOUSLY??
	                    app.mainRouter.navigate('payroll/h', {
	                        trigger: true,
	                        replace: true
	                    });
	                    app.mainRouter.navigate('payroll/history', {
	                        trigger: true,
	                        replace: true
	                    });
	                }
	            });
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	        }).finally(function () {
	            stopLoader();
	            _this.hide();
	        });
	    }
	});

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payrollHistory/SendPayslipsModal.ejs -->\n<div class="modal-dialog">\n<div class="modal-content animated sweet">\n    <div class="modal-header">\n        <h2>Send Payslips</h2>\n    </div>\n    <div class="modal-body">\n        <div class="row">\n            <form class="form-horizontal" role="form">\n                <!-- name -->\n                <div class="form-group js-send-box">\n                    <div class="col-sm-offset-2 col-sm-8">\n                        <h3>Send payslips for\n                            '+
	((__t=( payroll.getPeriod().format('MMMM') ))==null?'':_.escape(__t))+
	'\n                            payroll to:\n                        </h3>\n                    </div>\n                    <div class="col-sm-offset-2 col-sm-8">\n                        <select data-placeholder="All people" multiple\n                                class="js-people form-control m-b"\n                                name="people" id="send-people">\n                            ';
	 _.each(list, function(item){ 
	__p+='\n                                <option value="'+
	((__t=(item.id))==null?'':_.escape(__t))+
	'">\n                                    '+
	((__t=(item.name))==null?'':_.escape(__t))+
	'\n                                </option>\'\n                            ';
	 }) 
	__p+='\n                        </select>\n                    </div>\n                </div>\n                <div class="form-group js-reSend-box">\n                    <div class="col-sm-offset-2 col-sm-8">\n                        <h3>Payslips for\n                            '+
	((__t=( payroll.getPeriod().format('MMMM') ))==null?'':_.escape(__t))+
	'\n                            payroll were sent to '+
	((__t=( wereSent.length ))==null?'':_.escape(__t))+
	'\n                            people:\n                        </h3>\n                    </div>\n                    <div class="col-sm-offset-2 col-sm-8">\n                        <select data-placeholder="All people" multiple\n                                class="js-people form-control m-b"\n                                name="people" id="wereSent-people">\n                            ';
	 _.each(wereSent, function(item) { 
	__p+='\n                            <option value="'+
	((__t=(item.id))==null?'':_.escape(__t))+
	'">\n                                '+
	((__t=(  item.sentTime ))==null?'':_.escape(__t))+
	':\n                                '+
	((__t=( item.name ))==null?'':_.escape(__t))+
	'\n                            </option>\'\n                            ';
	 }) 
	__p+='\n                        </select>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="js-cancel btn btn-w-m btn-warning">\n            Cancel\n        </button>\n\n        <button type="button" class="js-send btn btn-w-m btn-primary m-l-xs">\n            '+
	((__t=( (wereSent.length > 0) ? 'Re-send' : 'Confirm Send' ))==null?'':_.escape(__t))+
	'\n        </button>\n\n        <button type="button" class="js-reSend btn btn-w-m btn-primary m-l-xs">\n            Re-send\n        </button>\n    </div>\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var template = __webpack_require__(769);
	var StepTwoView = __webpack_require__(742);
	
	module.exports = Backbone.View.extend({
	    contentView: null,
	
	    initialize: function initialize(options) {
	        this.options = options;
	
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({ period: this.period }));
	
	        return this;
	    },
	
	    renderContent: function renderContent(options) {
	        if (this.contentView !== null) {
	            this.contentView.remove();
	            this.contentView = null;
	        }
	
	        options.viewMode = true;
	        options.period = this.period;
	        options.el = this.$('#content');
	        this.contentView = new StepTwoView(options);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/payroll/PayrollView.html -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Payroll for '+
	((__t=( period ))==null?'':_.escape(__t))+
	'</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content" id="payroll-view">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>\n                        <a href="#payroll/history">\n                            Payroll History</a> / '+
	((__t=( period ))==null?'':_.escape(__t))+
	'\n                    </h5>\n                </div>\n                <div class="ibox-content">\n                    <div class="row">\n                        <div class="col-xs-12">\n                            <div id="content" class="wrapper wrapper-content">\n                                <div id="loader" class="loader loader-payroll">\n                                    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payslip = __webpack_require__(582);
	
	var _payslip2 = _interopRequireDefault(_payslip);
	
	var _decimal = __webpack_require__(586);
	
	var _decimal2 = _interopRequireDefault(_decimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayrollSummary = function (_Collection) {
	    _inherits(PayrollSummary, _Collection);
	
	    function PayrollSummary() {
	        _classCallCheck(this, PayrollSummary);
	
	        return _possibleConstructorReturn(this, (PayrollSummary.__proto__ || Object.getPrototypeOf(PayrollSummary)).apply(this, arguments));
	    }
	
	    _createClass(PayrollSummary, [{
	        key: 'url',
	        value: function url() {
	            if (this.payroll) {
	                return this.payroll.url() + '/slips';
	            }
	
	            return '/Payslips';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$payroll = _ref.payroll,
	                payroll = _ref$payroll === undefined ? null : _ref$payroll;
	
	            this.model = _payslip2.default;
	            this.payroll = payroll;
	            if (models && models.length > 0) {
	                throw new Error('Can\'t initialize model for this report');
	            }
	            _get(PayrollSummary.prototype.__proto__ || Object.getPrototypeOf(PayrollSummary.prototype), 'initialize', this).apply(this, arguments);
	            if (!this.options.sortKey) {
	                this.options.sortKey = 'employeeName';
	            }
	            this.totals = null;
	            this.pageTotals = [];
	            return this;
	        }
	
	        /**
	         * Get the summary totals of all the models currently present in the
	         * collection
	         *
	         * @instance
	         * @returns {Object} totals
	         * @todo define type for totals
	         */
	
	    }, {
	        key: 'getTotals',
	        value: function getTotals() {
	            var _this2 = this;
	
	            var result = {};
	
	            ['base', 'netPay', 'grossPay', 'mtd', 'employeeEpf', 'employerEpf', 'employeeSocso', 'employerSocso', 'employeeEis', 'employerEis', 'additions', 'deductions', 'zakat', 'cp38'].forEach(function (key) {
	                result[key] = _this2.reduce(function (m, obj) {
	                    return m.plus(obj.get(key) || 0);
	                }, new _decimal2.default(0)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	            });
	
	            result.hrdf = this.models.reduce(function (a, m) {
	                return a.plus(m.getHrdf());
	            }, new _decimal2.default(0)).toDP(2, _decimal2.default.ROUND_HALF_UP).toNumber();
	
	            return result;
	        }
	
	        /**
	         * Override save because this is a readonly collection
	         *
	         * @instance
	         */
	
	    }, {
	        key: 'save',
	        value: function save() {
	            throw new Error('Can\'t save a report');
	        }
	    }]);
	
	    return PayrollSummary;
	}(_collection2.default);
	
	exports.default = PayrollSummary;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _EmployeesManage = __webpack_require__(772);
	
	var _EmployeesManage2 = _interopRequireDefault(_EmployeesManage);
	
	var _Layout = __webpack_require__(774);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Payslip = __webpack_require__(808);
	
	var _Payslip2 = _interopRequireDefault(_Payslip);
	
	var _EmployeesBulkUpload = __webpack_require__(810);
	
	var _EmployeesBulkUpload2 = _interopRequireDefault(_EmployeesBulkUpload);
	
	var _EmployeesPayslipsBulkUpload = __webpack_require__(814);
	
	var _EmployeesPayslipsBulkUpload2 = _interopRequireDefault(_EmployeesPayslipsBulkUpload);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _payslip = __webpack_require__(582);
	
	var _payslip2 = _interopRequireDefault(_payslip);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _positions = __webpack_require__(631);
	
	var _positions2 = _interopRequireDefault(_positions);
	
	var _defaultPayrollDetails = __webpack_require__(596);
	
	var _defaultPayrollDetails2 = _interopRequireDefault(_defaultPayrollDetails);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _payslips = __webpack_require__(581);
	
	var _payslips2 = _interopRequireDefault(_payslips);
	
	var _itemYearlyTotals = __webpack_require__(589);
	
	var _itemYearlyTotals2 = _interopRequireDefault(_itemYearlyTotals);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _payslipDetails = __webpack_require__(583);
	
	var _payslipDetails2 = _interopRequireDefault(_payslipDetails);
	
	var _actionLogs = __webpack_require__(817);
	
	var _actionLogs2 = _interopRequireDefault(_actionLogs);
	
	var _bulkUploads = __webpack_require__(819);
	
	var _bulkUploads2 = _interopRequireDefault(_bulkUploads);
	
	var _leaveRequests = __webpack_require__(752);
	
	var _leaveRequests2 = _interopRequireDefault(_leaveRequests);
	
	var _leaveApprovals = __webpack_require__(587);
	
	var _leaveApprovals2 = _interopRequireDefault(_leaveApprovals);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/employee-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'employees': 'list',
	        'employees/bulk-upload': 'bulkUpload',
	        'employees/bulk-upload-payslips': 'bulkUploadPayslips',
	        'employees/:status': 'list',
	        'employees/:status/:sort/:order': 'list',
	        'employees/:status/:sort/:order/:searchTerm': 'list',
	        'employee': 'add',
	        'employee/add': 'add',
	        'employee/:id': 'personalInfo',
	        'employee/:id/edit': 'personalInfo',
	        'employee/:id/personalInfo': 'personalInfo',
	        'employee/:id/personalInfo/:isNew': 'personalInfoNew',
	        'employee/:id/employmentDetails': 'employmentDetails',
	        'employee/:id/employmentDetails/:isNew': 'employmentDetails',
	        'employee/:id/statutoryRequirements': 'statutoryRequirements',
	        'employee/:id/statutoryRequirements/:isNew': 'statutoryRequirements',
	        'employee/:id/previousPayslips': 'previousPayslips',
	        'employee/:id/previousPayslips/:isNew': 'previousPayslips',
	        'employee/:id/actionLog': 'actionLog',
	        'employee/:id/actionLog/:isNew': 'actionLog',
	        'employee/:id/payslip/:payslipId': 'payslip'
	    },
	
	    titles: {
	        'employees': 'Manage Employees',
	        'employees/bulk-upload': 'Employees bulk upload',
	        'employees/:status': 'Manage Employees',
	        'employees/:status/:sort/:order': 'Manage Employees',
	        'employees/:status/:sort/:order/:searchTerm': 'Manage Employees',
	        'employee': 'Add Employee',
	        'employee/add': 'Add Employee',
	        'employee/:id': 'Edit Personal Info',
	        'employee/:id/edit': 'Edit Personal Info',
	        'employee/:id/personalInfo': 'Edit Personal Info',
	        'employee/:id/personalInfo/:isNew': 'Edit Personal Info',
	        'employee/:id/employmentDetails': 'Edit Employment Details',
	        'employee/:id/employmentDetails/:isNew': 'Edit Employment Details',
	        'employee/:id/statutoryRequirements': 'Edit Statutory ' + 'Requirements',
	        'employee/:id/statutoryRequirements/:isNew': 'Edit Statutory ' + 'Requirements',
	        'employee/:id/previousPayslips': 'Edit Previous Payslips',
	        'employee/:id/previousPayslips/:isNew': 'Edit Previous Payslips',
	        'employee/:id/actionLog': 'Action Log',
	        'employee/:id/actionLog/:isNew': 'Action Log',
	        'employee/:id/payslip/:payslipId': 'Payslip'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.call(this, this.options);
	
	        this.layout = new _Layout2.default({
	            el: this.el
	        });
	    },
	
	    list: function list(status, sortKey, sortOrder, searchTerm) {
	        var employees = new _employees2.default(null, {
	            company: app.company,
	            sortKey: sortKey || 'canonicalFullName',
	            sortOrder: sortOrder || 'ascending',
	            pagination: { rowsPerPage: 25 },
	            searchString: searchTerm || '',
	            filter: {
	                where: {
	                    hiddenAt: (status || 'active') === 'active' ? null : { neq: null }
	                }
	            }
	        });
	
	        this.view = app.contentView = new _EmployeesManage2.default({
	            collection: employees,
	            el: this.el,
	            archived: status === 'archived'
	        });
	    },
	
	    add: function add() {
	        var _this = this;
	
	        return app.company.fetch().then(function () {
	            if (app.company.isAllowAddEmployees()) {
	                _localStorageUtil2.default.removeItem('ytdYear');
	                _this.layout.renderTab('personalInfo');
	                _this.layout.renderContent({
	                    isNew: true,
	                    model: new _employee2.default({
	                        companyId: app.company.id,
	                        company: app.company,
	                        address: new _address2.default()
	                    })
	                });
	                _this.layout.hideLoader();
	            } else {
	                _alerts2.default.show('warning', {
	                    text: 'You have reached your maximum number of active                             employees. Please reach out to our customer                             support if you would like to add more employee(s)',
	                    confirmButtonText: 'OK',
	                    callback: function callback() {
	                        window.history.back();
	                    }
	                });
	            }
	        });
	    },
	
	    fetchEmployeeById: function fetchEmployeeById(id) {
	        return new _employee2.default({ objectId: id }).fetch({ validate: false }).catch(function (err) {
	            if (_.isObject(err) && err.response.error.statusCode === 401) {
	                _alerts2.default.show('error', {
	                    text: 'Employee not found.',
	                    callback: function callback() {
	                        return app.mainRouter.navigate('employees', { trigger: true });
	                    }
	                });
	
	                return (0, _bluebird.resolve)(false);
	            }
	        });
	    },
	
	    personalInfo: function personalInfo(id, isNew) {
	        var _this2 = this;
	
	        this.layout.renderTab('personalInfo');
	
	        return this.fetchEmployeeById(id).then(function (employee) {
	            if (!employee) {
	                return;
	            }
	
	            return (0, _bluebird.all)([employee.fetchAddress(), employee.fetchBankAccount()]).then(function () {
	                return (0, _bluebird.resolve)(employee);
	            });
	        }).then(function (employee) {
	            return app.company.fetchCurrentPayroll().then(function (payroll) {
	                _this2.layout.renderContent({
	                    model: employee,
	                    unsubmittedPayroll: payroll,
	                    isNew: !!isNew
	                });
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this2.layout.hideLoader();
	        });
	    },
	
	    employmentDetails: function employmentDetails(id, isNew) {
	        var _this3 = this;
	
	        this.layout.renderTab('employmentDetails');
	
	        var positions = new _positions2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        var approverEmployees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        var locations = new _companyLocations2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        var leaveTypes = new _leaveTypes2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        return this.fetchEmployeeById(id).then(function (employee) {
	            if (employee) {
	                var defaultPayrollDetails = new _defaultPayrollDetails2.default(null, {
	                    employee: employee, syncRemove: true, pagination: false
	                });
	                var leaveApprovals = new _leaveApprovals2.default(null, {
	                    requester: employee, syncRemove: true, pagination: false
	                });
	
	                employee.company = app.company;
	
	                return (0, _bluebird.all)([(0, _bluebird.resolve)(employee), app.company.fetchCurrentPayroll(), _leaveTypes2.default.fetchCarryForwardDays(employee), defaultPayrollDetails.fetch({
	                    filter: {
	                        where: { hiddenAt: null },
	                        limit: 9999
	                    }
	                }).then(function () {
	                    return defaultPayrollDetails;
	                }), leaveApprovals.fetch({
	                    filter: {
	                        limit: 9999
	                    }
	                }).then(function () {
	                    return leaveApprovals;
	                }), positions.fetch({ filter: {
	                        limit: 9999,
	                        where: { hiddenAt: null }
	                    } }), approverEmployees.fetch({ filter: {
	                        where: {
	                            hiddenAt: null,
	                            userId: { neq: null }
	                        },
	                        limit: 9999
	                    }, validate: false }), locations.fetch({ filter: {
	                        where: { hiddenAt: null },
	                        limit: 9999
	                    } }), leaveTypes.fetch({ filter: {
	                        limit: 9999
	                    } }).then(function () {
	                    var typeIds = leaveTypes.map(function (type) {
	                        return type.id;
	                    });
	                    return _leaveRequests2.default.fetchForTypes({
	                        typeIds: typeIds,
	                        employeeIds: [employee.id]
	                    }).then(function (employeeRequests) {
	                        var requestedType = employeeRequests.map(function (req) {
	                            return req.get('typeId');
	                        });
	                        var enabledType = leaveTypes.filter(function (type) {
	                            return !type.get('hiddenAt');
	                        }).map(function (type) {
	                            return type.id;
	                        });
	                        return leaveTypes.filter(function (type) {
	                            return requestedType.includes(type.id) || enabledType.includes(type.id);
	                        });
	                    }).then(function () {
	                        return leaveTypes.fetchBalances(employee, (0, _moment2.default)().tz('Asia/Kuala_Lumpur').endOf('day').toDate());
	                    });
	                }), employee.fetchPosition()]);
	            } else {
	                return false;
	            }
	        }).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 5),
	                employee = _ref2[0],
	                unsubmittedPayroll = _ref2[1],
	                carryForwardDays = _ref2[2],
	                defaultPayrollDetails = _ref2[3],
	                leaveApprovals = _ref2[4];
	
	            if (!employee) {
	                return;
	            }
	
	            var payrollItems = app.payrollItems.getSelectableDefaults();
	            if (!employee.get('companyLocationId')) {
	                employee.set({ companyLocationId: locations.getPrimary().id }, { silent: true });
	                employee.locationAdded = true;
	            }
	
	            var typeIds = leaveTypes.map(function (type) {
	                return type.id;
	            });
	            return _leaveRequests2.default.fetchForTypes({ typeIds: typeIds, employeeIds: [employee.id] }).then(function (employeeRequests) {
	                var requestedType = employeeRequests.map(function (req) {
	                    return req.get('typeId');
	                });
	                var enabledType = leaveTypes.filter(function (type) {
	                    return !type.get('hiddenAt');
	                }).map(function (type) {
	                    return type.id;
	                });
	                var types = new _leaveTypes2.default(leaveTypes.filter(function (type) {
	                    return requestedType.includes(type.id) || enabledType.includes(type.id);
	                }), { company: app.company, pagination: false });
	
	                return _this3.layout.renderContent({
	                    isNew: !!isNew,
	                    model: employee,
	                    positions: positions,
	                    approverEmployees: approverEmployees,
	                    locations: locations,
	                    payrollItems: payrollItems,
	                    payrollDetails: defaultPayrollDetails,
	                    unsubmittedPayroll: unsubmittedPayroll,
	                    leaveTypes: types,
	                    carryForwardDays: carryForwardDays,
	                    leaveApprovals: leaveApprovals
	                });
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this3.layout.hideLoader();
	        });
	    },
	
	    statutoryRequirements: function statutoryRequirements(id, isNew) {
	        var _this4 = this;
	
	        this.layout.renderTab('statutoryRequirements');
	
	        this.fetchEmployeeById(id).then(function (employee) {
	            if (!employee) {
	                return;
	            }
	
	            var defaultPayrollDetails = new _defaultPayrollDetails2.default(null, {
	                employee: employee, syncRemove: true, pagination: false
	            });
	
	            return (0, _bluebird.all)([app.company.fetchCurrentPayroll(), defaultPayrollDetails.fetch({
	                filter: {
	                    where: { hiddenAt: null },
	                    limit: 9999
	                }
	            }).then(function () {
	                return defaultPayrollDetails;
	            })]).then(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    unsubmittedPayroll = _ref4[0],
	                    defaultPayrollDetails = _ref4[1];
	
	                _this4.layout.renderContent({
	                    isNew: !!isNew,
	                    model: employee,
	                    unsubmittedPayroll: unsubmittedPayroll,
	                    defaultPayrollDetails: defaultPayrollDetails
	                });
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this4.layout.hideLoader();
	        });
	    },
	
	    previousPayslips: function previousPayslips(id, isNew) {
	        var _this5 = this;
	
	        this.layout.renderTab('previousPayslips');
	        var ytdYear = parseInt(_localStorageUtil2.default.getItem('ytdYear')) || _payroll2.default.getCurrentPeriodDate().getFullYear();
	
	        return this.fetchEmployeeById(id).then(function (employee) {
	            if (!employee) {
	                return false;
	            }
	
	            var payslips = new _payslips2.default(null, {
	                employee: employee,
	                sortKey: 'createdAt',
	                sortOrder: 'descending',
	                pagination: false
	            });
	            return (0, _bluebird.all)([(0, _bluebird.resolve)(employee), employee.get('hasPayslips') ? payslips.fetch({ filter: {
	                    where: {
	                        status: 'done'
	                    },
	                    limit: 9999
	                } }).then(function () {
	                return payslips;
	            }) : (0, _bluebird.resolve)([]), new _itemYearlyTotals2.default(null, {
	                sortKey: 'createdAt',
	                pagination: false,
	                employee: employee,
	                year: ytdYear
	            }).fetchForPreviousPayslips(), app.company.fetchCurrentPayroll()]);
	        }).then(function (_ref5) {
	            var _ref6 = _slicedToArray(_ref5, 4),
	                employee = _ref6[0],
	                payslips = _ref6[1],
	                yearlyTotals = _ref6[2],
	                unsubmittedPayroll = _ref6[3];
	
	            var payrollItems = app.payrollItems.getSelectablePreviousPayslips();
	            var attachments = {};
	
	            if (!employee) {
	                return;
	            }
	
	            return (0, _bluebird.all)(payslips.map(function (payslip) {
	                return new _attachments2.default(null, {
	                    attachable: payslip,
	                    pagination: false
	                }).fetch({ filter: { limit: 9999 } }).then(function (r) {
	                    return attachments[payslip.id] = r;
	                });
	            })).then(function () {
	                _this5.layout.renderContent({
	                    isNew: !!isNew,
	                    model: employee,
	                    payrollItems: payrollItems,
	                    yearlyTotals: yearlyTotals,
	                    payslips: payslips,
	                    payslipAttachments: attachments,
	                    year: ytdYear,
	                    unsubmittedPayroll: unsubmittedPayroll
	                });
	            });
	        }).catch(function (err) {
	            log.error(err);
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this5.layout.hideLoader();
	        });
	    },
	
	    actionLog: function actionLog(id) {
	        var _this6 = this;
	
	        this.layout.renderTab('actionLog');
	
	        return this.fetchEmployeeById(id).then(function (employee) {
	            if (!employee) {
	                return false;
	            }
	
	            return (0, _bluebird.all)([(0, _bluebird.resolve)(employee), new _actionLogs2.default().fetchForEmployee(employee)]);
	        }).then(function (_ref7) {
	            var _ref8 = _slicedToArray(_ref7, 2),
	                employee = _ref8[0],
	                actionLogs = _ref8[1];
	
	            _this6.layout.renderContent({
	                model: employee,
	                collection: actionLogs,
	                fetchMore: function fetchMore(options) {
	                    return new _actionLogs2.default().fetchForEmployee(employee, options);
	                }
	            });
	        }).finally(function () {
	            return _this6.layout.hideLoader();
	        });
	    },
	
	    // TODO it is a big and multiplied method, refactor it later
	    fetchBalance: function fetchBalance(payslip) {
	        var fetchYearlyBalances = function fetchYearlyBalances() {
	            return app.leaveTypes.fetchBalances(payslip.getEmployee(), payslip.getPayroll().getPeriod().endOf('month').toDate());
	        };
	
	        var transformYearly = function transformYearly(leaveTypes) {
	            return leaveTypes.map(function (leaveType) {
	                var name = leaveType.get('name');
	                var id = leaveType.id;
	                var entitled = leaveType.getEntitled() || 0;
	                var taken = leaveType.getTaken() || 0;
	                var remaining = Math.max(0, entitled - taken);
	                return {
	                    id: id,
	                    name: name,
	                    entitled: entitled,
	                    remaining: remaining,
	                    taken: taken
	                };
	            });
	        };
	
	        var mergeBalances = function mergeBalances(yearly, monthly) {
	            var obligated = _.filter(yearly, function (balance) {
	                return ['Medical Leave', 'Annual Leave', 'Unpaid Leave'].includes(balance.name);
	            });
	            var yearlyHasInMontly = _.filter(yearly, function (balance) {
	                return _.map(monthly, function (t) {
	                    return t.id;
	                }).includes(balance.id) && balance.taken > 0;
	            }).concat(obligated);
	
	            var mergeBalances = _.map(yearlyHasInMontly, function (balance) {
	                var sameMonthlyBalance = monthly.find(function (t) {
	                    return t.id === balance.id;
	                });
	                if (balance.taken > 0) {
	                    var newTaken = sameMonthlyBalance ? sameMonthlyBalance.taken : 0;
	                    balance.taken = newTaken;
	                }
	                return balance;
	            });
	            return mergeBalances;
	        };
	
	        var fetchMonthlyBalance = function fetchMonthlyBalance(types, reference) {
	            var end = (0, _moment2.default)(reference).endOf('month').toDate();
	            var start = (0, _moment2.default)(reference).startOf('month').toDate();
	            return _leaveRequests2.default.fetchForBalances({
	                employee: payslip.getEmployee(),
	                typeIds: types.map(function (t) {
	                    return t.id;
	                }),
	                start: start,
	                end: end
	            }).then(function (requests) {
	                var simplified = requests.map(function (request) {
	                    var id = request.get('typeId');
	                    var taken = request.get('daysRequired');
	                    return {
	                        id: id,
	                        taken: taken
	                    };
	                }) || [];
	                var groupedById = _.groupBy(simplified, 'id');
	                var summedById = _.map(groupedById, function (requests) {
	                    var taken = _.reduce(requests, function (sum, request) {
	                        return sum + request.taken;
	                    }, 0);
	                    return {
	                        id: requests[0].id,
	                        taken: taken
	                    };
	                });
	
	                return summedById;
	            });
	        };
	        return fetchYearlyBalances().then(function (yearlyBalances) {
	            return (0, _bluebird.all)([transformYearly(yearlyBalances), fetchMonthlyBalance(yearlyBalances, payslip.getPayroll().get('periodDate'))]);
	        }).then(function (_ref9) {
	            var _ref10 = _slicedToArray(_ref9, 2),
	                yearly = _ref10[0],
	                monthly = _ref10[1];
	
	            return mergeBalances(yearly, monthly);
	        });
	    },
	
	    payslip: function payslip(id, payslipId) {
	        var _this7 = this;
	
	        this.undelegateEvents();
	
	        return new _payslip2.default({ objectId: payslipId }).fetch({ validate: false }).then(function (payslip) {
	            if (!payslip) {
	                _alerts2.default.show('error', {
	                    text: 'Payslip not found.',
	                    callback: function callback() {
	                        return app.mainRouter.navigate('employee/' + id + '/previousPayslips', { trigger: true });
	                    }
	                });
	
	                return (0, _bluebird.resolve)(false);
	            }
	            var details = new _payslipDetails2.default(null, {
	                payslip: payslip,
	                pagination: false
	            });
	            return (0, _bluebird.all)([(0, _bluebird.resolve)(payslip), details.fetch({ filter: { limit: 9999 } }).then(function () {
	                return details;
	            }), payslip.fetchCompany().then(function (company) {
	                return company.fetchPrimaryLocation();
	            }).then(function (companyLocation) {
	                return companyLocation.fetchAddress().then(function () {
	                    return companyLocation;
	                });
	            }), payslip.fetchEmployee().then(function () {
	                return payslip.fetchPayroll();
	            }).then(function () {
	                return _this7.fetchBalance(payslip);
	            })]);
	        }).then(function (_ref11) {
	            var _ref12 = _slicedToArray(_ref11, 4),
	                payslip = _ref12[0],
	                details = _ref12[1],
	                companyLocation = _ref12[2],
	                balances = _ref12[3];
	
	            details.balances = balances;
	            _this7.payslipView = new _Payslip2.default({
	                model: payslip,
	                payslipDetails: details,
	                companyLocation: companyLocation
	            });
	
	            $(_this7.el).html('').append(_this7.payslipView.el);
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        });
	    },
	
	    bulkUpload: function bulkUpload() {
	        var _this8 = this;
	
	        return app.company.fetch().then(function () {
	            if (app.company.isAllowAddEmployees()) {
	                _this8.layout.$('.js-loading-tab').addClass('active');
	                return new _bulkUploads2.default(null, { company: app.company }).fetch({ where: { status: { neq: 'done' } } }).then(function (pendingUploads) {
	                    var view = new _EmployeesBulkUpload2.default({
	                        model: pendingUploads.at(0)
	                    });
	                    $(_this8.el).html(view.render().el);
	                }).catch(log.error).finally(function () {
	                    return _this8.layout.hideLoader();
	                });
	            } else {
	                _alerts2.default.show('warning', {
	                    text: 'You have reached your maximum number of active                             employees. Please reach out to our customer                             support if you would like to add more employee(s)',
	                    confirmButtonText: 'OK',
	                    callback: function callback() {
	                        window.history.back();
	                    }
	                });
	            }
	        });
	    },
	
	    bulkUploadPayslips: function bulkUploadPayslips() {
	        var _this9 = this;
	
	        this.layout.$('.js-loading-tab').addClass('active');
	        return new _bulkUploads2.default(null, { company: app.company }).fetch({ where: { status: { neq: 'done' } } }).then(function (pendingUploads) {
	            var view = new _EmployeesPayslipsBulkUpload2.default({
	                model: pendingUploads.at(0)
	            });
	            $(_this9.el).html(view.render().el);
	        }).catch(log.error).finally(function () {
	            return _this9.layout.hideLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _EmployeesManage = __webpack_require__(773);
	
	var _EmployeesManage2 = _interopRequireDefault(_EmployeesManage);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginatedList2.default.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(_PaginatedList2.default.prototype.events) ? _PaginatedList2.default.prototype.events() : _PaginatedList2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'shown.bs.tab a[data-toggle="tab"]': 'switchTab',
	            'click .employee-tile': 'selectEmployee',
	            'click .js-employee-row': 'onSelectEmployee'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {});
	
	        this.views = [];
	
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	        return this;
	    },
	
	    selectEmployee: function selectEmployee(ev) {
	        _localStorageUtil2.default.removeItem('ytdYear');
	        var employeeId = $(ev.currentTarget).attr('data-employee-id');
	        app.mainRouter.navigate('employee/' + employeeId, { trigger: true });
	    },
	
	    onSelectEmployee: function onSelectEmployee() {
	        _localStorageUtil2.default.removeItem('ytdYear');
	    },
	
	    switchTab: function switchTab(ev) {
	        var self = this;
	        var $tabBtn = $(ev.currentTarget);
	
	        self.$('a[data-toggle="tab"].btn-selected').toggleClass('btn-selected').toggleClass('btn-white');
	        $tabBtn.toggleClass('btn-selected').toggleClass('btn-white');
	
	        _localStorageUtil2.default.setItem('peopleManageTab', $tabBtn.attr('data-tab'));
	
	        setTimeout(this.$('.footable').footable, 1);
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var fetchDependencies = this.collection.map(function (employee) {
	            return employee.fetchPosition().then(function () {
	                if (_this.options.archived) {
	                    return employee.fetchRemoval();
	                }
	
	                return (0, _bluebird.resolve)();
	            });
	        });
	        (0, _bluebird.all)(fetchDependencies).then(function () {
	            var sortClass = _this.collection.getSort().order === 'ascending' ? 'footable-sorted-desc' : 'footable-sorted';
	
	            var tab = _localStorageUtil2.default.getItem('peopleManageTab');
	            _this.$el.html((0, _EmployeesManage2.default)({
	                tab: tab !== 'list' && tab !== 'tiles' ? 'list' : tab,
	                collection: _this.collection,
	                archived: _this.options.archived,
	                idSuffix: Math.floor(Math.random() * 99999),
	
	                searchTerm: _this.collection.getSearchTerm(),
	                total: _this.collection.length,
	                pagination: _this.collection.getPaginationInfo(),
	                sort: _this.collection.getSort(),
	                employeeDataUrl: app.company.employeeDataUrl()
	            }));
	
	            _this.$('.footable-sortable').removeClass('footable-sorted-desc').removeClass('footable-sorted');
	
	            _this.$('[data-sort="' + _this.collection.getSort().key + '"]').addClass(sortClass);
	
	            _this.hideLoader();
	            _tooltip2.default.init(_this);
	        });
	    },
	
	    hideLoader: function hideLoader() {
	        this.stopLoader();
	    },
	
	    navigate: function navigate() {
	        var status = this.options.archived ? 'archived' : 'active';
	        var searchTerm = this.collection.getSearchTerm() ? '/' + this.collection.getSearchTerm() : '';
	        app.mainRouter.navigate('employees/' + status + '/' + (this.collection.getSort().key + '/') + ('' + this.collection.getSort().order) + ('' + searchTerm), { trigger: true });
	    },
	
	    remove: function remove() {
	        this.collection.off(null, null, this);
	        this.undelegateEvents();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/EmployeesManage.html -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Manage Employees</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n<div class="row">\n    <div class="col-md-3 col-md-offset-9">\n        <div class="searchbox">\n            <input type="text" name="search" placeholder="Search"\n                   class="form-control js-searchbox" value="'+
	((__t=( searchTerm ))==null?'':_.escape(__t))+
	'">\n            <i class="fa fa-search"></i>\n        </div>\n    </div>\n<div class="col-md-12 col-lg-12">\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        ';
	 if (archived === true) { 
	__p+='\n        <h5><a href="#employees" class="active-employees-link">Active Employees</a> / Archived Employees</h5>\n        ';
	 } else { 
	__p+='\n        <h5>Active Employees</h5>\n        ';
	 } 
	__p+='\n        <div class="tab-toggle-controls btn-group pull-right">\n            <a data-tab="tiles" data-toggle="tab"\n               href="#tiles-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n               class="btn btn-sm btn-tiles\n                '+
	((__t=( tab === 'tiles' ? 'btn-selected' : 'btn-white' ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-ellipsis-h"></i>\n            </a>\n            <a data-tab="list" data-toggle="tab"\n               href="#list-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n               class="btn btn-sm btn-list\n                '+
	((__t=( !tab || tab === 'list' ? 'btn-selected' : 'btn-white' ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-list"></i>\n            </a>\n        </div>\n    </div>\n    <div class="ibox-content  tab-content">\n        <div id="list-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'" class="tab-pane\n            '+
	((__t=( (!tab || tab === 'list') ? 'active' : '' ))==null?'':_.escape(__t))+
	'"\n             data-tab-name="list">\n        <table class="footable table table-stripped toggle-arrow-tiny" data-page-size="8">\n            <thead>\n            <tr>\n                <th class="footable-sortable" data-sort="idStr">\n                    ID\n                    <span class="footable-sort-indicator"></span>\n                </th>\n                <th class="footable-sortable" data-sort="fullName">\n                    Full Name\n                    <span class="footable-sort-indicator"></span>\n                </th>\n                <th class="footable-sortable" data-sort="email">\n                    Email\n                    <span class="footable-sort-indicator"></span>\n                </th>\n                <th>\n                    '+
	((__t=((archived === true) ? 'Reason' : 'Position'))==null?'':_.escape(__t))+
	'\n                </th>\n                ';
	 if (archived === true) { 
	__p+='\n                    <th>\n                        Archived Date\n                        <i class="fa fa-question-circle" data-toggle="tooltip"\n                            data-placement="top" data-container="body"\n                            data-original-title="Note: this is employee\'s last working day in the company">\n                        </i>\n                    </th>\n                ';
	 } 
	__p+='\n            </tr>\n            </thead>\n            <tbody>\n            ';
	 collection.each(function(employee) { 
	__p+='\n            <tr>\n                <td><a href="#employee/'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'" class="js-employee-row">\n                    '+
	((__t=( employee.get('idStr') ))==null?'':_.escape(__t))+
	'</a>\n                </td>\n                <td><a href="#employee/'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'" class="js-employee-row">\n                    '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</a>\n                </td>\n                <td><a href="#employee/'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'" class="js-employee-row">\n                    '+
	((__t=( employee.get('email') ))==null?'':_.escape(__t))+
	'</a>\n                </td>\n                <td><a href="#employee/'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'" class="js-employee-row">\n                    '+
	((__t=( (archived !== true) ?
	                        employee.getPositionName() :
	                        employee.getRemovalReason() ))==null?'':_.escape(__t))+
	'\n                    </a>\n                </td>\n                ';
	 if (archived === true) { 
	__p+='\n                    <td>\n                        '+
	((__t=( employee.getRemovalDate() ))==null?'':_.escape(__t))+
	'\n                    </td>\n                ';
	 } 
	__p+='\n            </tr>\n            ';
	 }); 
	__p+='\n            </tbody>\n        </table>\n        </div>\n        <div id="tiles-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'" class="tab-pane\n            '+
	((__t=( (tab === 'tiles') ? 'active' : '' ))==null?'':_.escape(__t))+
	'"\n             data-tab-name="tiles">\n            <div class="row row-eq-height">\n                ';
	 collection.each(function(employee, index) { 
	__p+='\n                <div class="col-md-4">\n                    <div class="employee-tile" data-employee-id="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'">\n                        <div class="employee-tile-image text-nowrap">\n                            <div class="user-image-lg"\n                                 style="background-image: url('+
	((__t=( employee.getImageUrl() || '' ))==null?'':_.escape(__t))+
	');">\n                                <abbr>'+
	((__t=( (employee.get('imageUrl') ? '' : employee.getNameAbbreviation()) ))==null?'':_.escape(__t))+
	'</abbr>\n                            </div>\n                            '+
	((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
	'\n                        </div>\n                        <div class="employee-tile-info m-t">\n                            <span class="font-bold">'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</span>\n                            <br><br>\n                            <div class="m-t-sm">\n                                '+
	((__t=( employee.get('idStr') ))==null?'':_.escape(__t))+
	'\n                            </div>\n                        </div>\n                        <br style="clear: both;"/>\n                    </div>\n                </div>\n                ';
	 if (index % 3 === 2) { 
	__p+='\n                <div class="clearfix"></div>\n                ';
	 } 
	__p+='\n                ';
	 }); 
	__p+='\n            </div>\n        </div>\n    </div>\n    <div class="ibox-footer clearfix">\n        ';
	 if (archived !== true) { 
	__p+='\n        <div class="pull-left">\n            <a id="lnkadd-employee" class="btn btn-primary" href="#employee/add"\n               data-toggle="tooltip" data-title="Add more employees to the payroll" data-placement="top" data-delayed>\n                Add Employee\n            </a>\n\n            <a class="btn btn-primary btn-outline" href="#employees/bulk-upload"\n               data-toggle="tooltip" data-title="Add more employees to the payroll" data-placement="top" data-delayed>\n                Add Multiple Employees\n            </a>\n\n            <a class="btn btn-primary btn-outline" href="#employees/bulk-upload-payslips"\n               data-toggle="tooltip" data-title="Add multiple employee payslips at once" data-placement="top" data-delayed>\n                Add Multiple Previous Payslip Info\n            </a>\n        </div>\n\n        <div class="pull-right">\n            <a id="export-employee-data-btn" class="btn btn-primary btn-primary btn-outline" href="'+
	((__t=( employeeDataUrl ))==null?'':_.escape(__t))+
	'"\n                target="_blank" data-toggle="tooltip" data-title="Download employees data" data-placement="top" data-delayed="">\n                Export Employee Data\n            </a>\n            <a class="btn btn-primary btn-primary btn-outline" href="#employees/archived" data-toggle="tooltip" data-title="View archived employees" data-placement="top" data-delayed="">\n                <i class="fa fa-archive"></i> Archived Employees\n            </a>\n        </div>\n        ';
	 }
	__p+='\n\n        '+
	((__t=( __webpack_require__(669)({ pagination: pagination, items: 'employees' }) ))==null?'':__t)+
	'\n    </div>\n</div>\n</div>\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _Layout = __webpack_require__(775);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _LayoutHeader = __webpack_require__(776);
	
	var _LayoutHeader2 = _interopRequireDefault(_LayoutHeader);
	
	var _LayoutContent = __webpack_require__(779);
	
	var _LayoutContent2 = _interopRequireDefault(_LayoutContent);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	
	    initialize: function initialize(options) {
	        Object.assign(this, options);
	        this.headerView = new _LayoutHeader2.default({
	            employees: []
	        });
	
	        this.contentView = new _LayoutContent2.default();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var employees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        employees.fetch({
	            filter: {
	                where: {
	                    hiddenAt: null
	                },
	                limit: 9999
	            }
	        }).then(function () {
	            _this.headerView.setCollection(employees);
	        });
	
	        this.$el.html((0, _Layout2.default)());
	
	        this.headerView.setElement(this.$('.employee-edit-header'));
	        this.headerView.render();
	
	        this.contentView.setElement(this.$('.employee-edit-content'));
	        this.contentView.render();
	
	        return this;
	    },
	
	    // this is only to provide immediate feedback so user quickly sees selected tab
	    renderTab: function renderTab(tab) {
	        this.headerView.setModel(null);
	        this.headerView.tab = tab;
	        this.contentView.tab = tab;
	        this.render();
	    },
	
	    // options must provide model property
	    renderContent: function renderContent(options) {
	        this.headerView.setModel(options.model);
	        this.contentView.renderContent(options);
	        if (options.employees) {
	            this.headerView.setCollection(options.employees);
	        }
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-loading-tab').removeClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/Layout.ejs -->\n<div class="row wrapper page-heading employee-edit-header">\n\n</div>\n\n<div class="wrapper wrapper-content wrapper-tabs employee-edit-content">\n\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alerts = __webpack_require__(529);
	var template = __webpack_require__(777);
	var loader = __webpack_require__(534);
	var InviteMessage = __webpack_require__(778);
	
	module.exports = Backbone.View.extend({
	
	    events: {
	        'click .js-send-welcome-email': 'onSendEmail',
	        'click .js-change-image-link': 'onChangeImage',
	        'click .js-change-employee': 'onChangeEmployee',
	        'change .js-change-image-input': 'uploadImage'
	    },
	
	    onSendEmail: function onSendEmail() {
	        var stopLoader = loader.startFullScreen('.btn-invite-employee');
	        this.model.invite().then(function () {
	            Alerts.show('success', {
	                text: InviteMessage()
	            });
	        }).catch(function (payload) {
	            if (payload.message && payload.message.error) {
	                Alerts.show('error', {
	                    text: payload.message.error.message
	                });
	            } else {
	                Alerts.show('error', { text: payload });
	            }
	        }).finally(stopLoader);
	    },
	
	    onChangeImage: function onChangeImage() {
	        this.$('.js-change-image-input').click();
	    },
	
	    uploadImage: function uploadImage(e) {
	        var selectedFile = this.$(e.currentTarget)[0].files[0];
	
	        var self = this;
	        var stopLoader = loader.startFullScreen();
	
	        return self.model.uploadImage(selectedFile).then(function () {
	            self.render();
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	        }).finally(stopLoader);
	    },
	
	    render: function render() {
	        var options = {
	            imageUrl: '',
	            fullName: '',
	            nameAbbreviation: '',
	            email: '',
	            profileProgress: 0,
	            sendButton: false,
	            tab: this.tab
	        };
	
	        if (this.model) {
	            options.imageUrl = this.model.getImageUrl() || '';
	            options.fullName = this.model.get('fullName');
	            options.nameAbbreviation = this.model.has('imageUrl') || this.model.has('tempImageUrl') ? '' : this.model.getNameAbbreviation();
	            options.email = this.model.get('email');
	            options.profileProgress = this.model.calculateProfileProgress();
	            options.sendButton = this.model.get('email') && !_.contains(this.model.dirtyKeys(), 'email');
	        }
	
	        if (this.model && this.collection && !this.model.isNew()) {
	            var ids = _.pluck(this.collection.models, 'id');
	            var index = ids.indexOf(this.model.id);
	            options.next = ids[index + 1];
	            options.prev = ids[index - 1];
	        } else {
	            options.next = false;
	            options.prev = false;
	        }
	
	        this.$el.html(template(options));
	    },
	
	    setModel: function setModel(model) {
	        if (this.model) {
	            this.model.off('change sync', this.render, this);
	        }
	        this.model = model;
	        if (this.model) {
	            this.model.on('change sync', this.render, this);
	            this.render();
	        }
	    },
	
	    setCollection: function setCollection(collection) {
	        this.collection = collection;
	        if (this.collection) {
	            this.render();
	        }
	    },
	
	    onChangeEmployee: function onChangeEmployee() {
	        _localStorageUtil2.default.removeItem('ytdYear');
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/LayoutHeader.ejs -->\n<div class="col-xs-12">\n    <div class="inline-block-element m-r">\n        <div class="user-image"\n             style="background-image: url('+
	((__t=( imageUrl ))==null?'':_.escape(__t))+
	');">\n            <abbr>\n                '+
	((__t=( nameAbbreviation ))==null?'':_.escape(__t))+
	'\n            </abbr>\n        </div>\n        <a class="js-change-image-link">Change photo</a>\n        <input class="hide js-change-image-input" type="file" accept="image/*">\n    </div>\n    ';
	 if (fullName || email) { 
	__p+='\n    <div class="inline-block-element m-r-xl" style="vertical-align: top;">\n        <form class="form-inline">\n            <p class="employee-full-name">'+
	((__t=( fullName ))==null?'':_.escape(__t))+
	'</p>\n            <p class="employee-email">'+
	((__t=( email ))==null?'':_.escape(__t))+
	'</p>\n        </form>\n        ';
	 if (sendButton) { 
	__p+='\n        <button class="btn btn-outline btn-teal js-send-welcome-email">\n            Send welcome email\n        </button>\n        ';
	 } 
	__p+='\n    </div>\n\n    <div class="inline-block-element progress-container">\n        <div>\n            <span>Mandatory Fields Complete: '+
	((__t=( profileProgress ))==null?'':_.escape(__t))+
	'%</span>\n        </div>\n        <div class="progress">\n            <div class="progress-bar" role="progressbar"\n                 style="width:'+
	((__t=( profileProgress ))==null?'':_.escape(__t))+
	'%; background-color: '+
	((__t=( profileProgress < 100 ? '#F7AF61' : '#41C43A' ))==null?'':_.escape(__t))+
	';">\n            </div>\n        </div>\n    </div>\n    ';
	 } 
	__p+='\n\n    ';
	 if (fullName || email) { 
	__p+='\n    <div class="employee-nav">\n        <span class="employee-nav-box">\n            ';
	 if (prev) { 
	__p+='\n            <a href="#employee/'+
	((__t=( prev ))==null?'':_.escape(__t))+
	'/'+
	((__t=( tab ))==null?'':_.escape(__t))+
	'" class="js-change-employee">\n                <i class="fa fa-angle-left" aria-hidden="true"></i>\n                Previous\n            </a>\n            ';
	 } else { 
	__p+='\n            <a disabled class="disabled">\n                <i class="fa fa-angle-left" aria-hidden="true"></i>\n                Previous\n            </a>\n            ';
	 } 
	__p+='\n        </span>\n\n        <span class="employee-nav-box">\n            ';
	 if (next) { 
	__p+='\n            <a href="#employee/'+
	((__t=( next ))==null?'':_.escape(__t))+
	'/'+
	((__t=( tab ))==null?'':_.escape(__t))+
	'" class="js-change-employee">Next\n                <i class="fa fa-angle-right" aria-hidden="true"></i>\n            </a>\n            ';
	 } else { 
	__p+='\n            <a disabled class="disabled">Next\n                <i class="fa fa-angle-right" aria-hidden="true"></i>\n            </a>\n            ';
	 } 
	__p+='\n        </span>\n    </div>\n    ';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/InviteMessage.ejs -->\nInvitation email to employee will be sent shortly\n<strong class="modal-message">Note: token will expire after 48 hours</strong>';
	}
	return __p;
	};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var template = __webpack_require__(780);
	
	var PersonalInfoView = __webpack_require__(781);
	var EmploymentDetailsView = __webpack_require__(790);
	var StatutoryRequirementsView = __webpack_require__(795);
	var PreviousPayslipsView = __webpack_require__(797);
	var ActionLogView = __webpack_require__(804);
	
	module.exports = Backbone.View.extend({
	
	    contentView: null,
	
	    events: {
	        'click .js-employment-details-tab': 'trackEmploymentDetails'
	    },
	
	    // TODO: favor convention over configuration
	    tabConfigs: {
	        personalInfo: {
	            tabClass: '.js-personal-info-tab',
	            tabContentClass: '.js-personal-info-tab-content'
	        },
	        employmentDetails: {
	            tabClass: '.js-employment-details-tab',
	            tabContentClass: '.js-employment-details-tab-content'
	        },
	        statutoryRequirements: {
	            tabClass: '.js-statutory-requirements-tab',
	            tabContentClass: '.js-statutory-requirements-tab-content'
	        },
	        previousPayslips: {
	            tabClass: '.js-previous-payslips-tab',
	            tabContentClass: '.js-previous-payslips-tab-content'
	        },
	        actionLog: {
	            tabClass: '.js-action-log-tab',
	            tabContentClass: '.js-action-log-tab-content'
	        }
	    },
	
	    render: function render() {
	        var self = this;
	
	        self.$el.html(template({
	            employeeId: self.model && !self.model.isNew() ? self.model.id : '',
	            isNew: self.isNew
	        }));
	
	        if (self.model && self.model.isNew()) {
	            self.$('.js-nav-tabs li').addClass('disabled');
	        }
	
	        var tabConfig = self.tabConfigs[self.tab];
	        self.$(tabConfig.tabClass).addClass('active').removeClass('disabled');
	    },
	
	    renderContent: function renderContent(options) {
	        var self = this;
	        self.model = options.model;
	        self.isNew = options.isNew;
	
	        self.render();
	
	        var tabConfig = self.tabConfigs[self.tab];
	        self.$(tabConfig.tabContentClass).addClass('active');
	
	        if (this.contentView) {
	            this.contentView.remove();
	        }
	
	        if (self.tab === 'personalInfo') {
	            this.contentView = new PersonalInfoView(options);
	            this.$('.js-personal-info').html('').append(this.contentView.$el);
	        } else if (self.tab === 'employmentDetails' && options.leaveTypes) {
	            this.contentView = new EmploymentDetailsView(options);
	            this.$('.js-employment-details').html('').append(this.contentView.$el);
	        } else if (self.tab === 'statutoryRequirements') {
	            this.contentView = new StatutoryRequirementsView(options);
	            this.$('.js-statutory-requirements').html('').append(this.contentView.$el);
	        } else if (self.tab === 'previousPayslips' && options.yearlyTotals) {
	            this.contentView = new PreviousPayslipsView(options);
	            this.$('.js-previous-payslips').html('').append(this.contentView.$el);
	        } else if (self.tab === 'actionLog' && options.collection) {
	            this.contentView = new ActionLogView(options).render();
	            this.$('.js-action-log').html('').append(this.contentView.$el);
	        }
	    },
	
	    trackEmploymentDetails: function trackEmploymentDetails() {}
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/LayoutContent.ejs -->\n<div class="row">\n<div class="col-md-12 col-lg-12">\n<div class="tabs-container ">\n<div class="tabs-left">\n    <ul class="js-nav-tabs nav nav-tabs">\n        <li class="js-personal-info-tab">\n            <a href="#employee/'+
	((__t=( employeeId ))==null?'':_.escape(__t))+
	'/personalInfo">\n                Personal Info\n            </a>\n        </li>\n        <!--<li class="js-employment-details-tab disabled">-->\n        <li class="js-employment-details-tab">\n            <a href="#employee/'+
	((__t=( employeeId ))==null?'':_.escape(__t))+
	'/employmentDetails'+
	((__t=( isNew ? '/isNew' : '' ))==null?'':_.escape(__t))+
	'">\n                Employment Details\n            </a>\n        </li>\n        <li class="js-statutory-requirements-tab">\n            <a href="#employee/'+
	((__t=( employeeId ))==null?'':_.escape(__t))+
	'/statutoryRequirements';
	 isNew ? '/isNew' : '' 
	__p+='">\n                Statutory Requirements\n            </a>\n        </li>\n        <li class="js-previous-payslips-tab">\n            <a href="#employee/'+
	((__t=( employeeId ))==null?'':_.escape(__t))+
	'/previousPayslips';
	 isNew ? '/isNew' : '' 
	__p+='">\n                Previous Payslips\n            </a>\n        </li>\n        <li class="js-action-log-tab">\n            <a href="#employee/'+
	((__t=( employeeId ))==null?'':_.escape(__t))+
	'/actionLog';
	 isNew ? '/isNew' : '' 
	__p+='">\n                Action Log\n            </a>\n        </li>\n    </ul>\n    <div class="tab-content">\n        <div class="tab-pane js-personal-info-tab-content">\n            <div class="js-personal-info panel-body"></div>\n        </div>\n        <div class="tab-pane js-employment-details-tab-content">\n            <div class="js-employment-details panel-body"></div>\n        </div>\n        <div class="tab-pane js-statutory-requirements-tab-content">\n            <div class="js-statutory-requirements panel-body"></div>\n        </div>\n        <div class="tab-pane js-previous-payslips-tab-content">\n            <div class="js-previous-payslips panel-body"></div>\n        </div>\n        <div class="tab-pane js-action-log-tab-content">\n            <div class="js-action-log panel-body"></div>\n        </div>\n        <div class="tab-pane js-loading-tab active">\n            <div class="panel-body">\n                <div class="loader-wrapper">\n                    <div class="loader">\n                        '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                    </div>\n                    <div class="clearfix"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n</div>\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Cocktail = __webpack_require__(548);
	
	var _Cocktail2 = _interopRequireDefault(_Cocktail);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _BankAccount = __webpack_require__(782);
	
	var _BankAccount2 = _interopRequireDefault(_BankAccount);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _RemovalModal = __webpack_require__(786);
	
	var _RemovalModal2 = _interopRequireDefault(_RemovalModal);
	
	var _PersonalInfo = __webpack_require__(788);
	
	var _PersonalInfo2 = _interopRequireDefault(_PersonalInfo);
	
	var _Children = __webpack_require__(789);
	
	var _Children2 = _interopRequireDefault(_Children);
	
	var _countriesList = __webpack_require__(594);
	
	var _countriesList2 = _interopRequireDefault(_countriesList);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _employee = __webpack_require__(571);
	
	var _payroll = __webpack_require__(569);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Mixins are listed at the bottom
	module.exports = _Cocktail2.default.mixin(_Form2.default.extend({
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events(), {
	            'click .js-id-type-dropdown-menu a': 'updateIdType',
	            'click .js-remove': 'destroy',
	            'click .js-remove-permanent': 'destroyPermanent',
	            'click .js-restore': 'restore',
	            'click .js-remove-employee-user': 'removeEmployeeUser',
	            'keyup input.js-ext-address': 'updateAddress',
	            'change input.js-ext-address': 'updateAddress',
	            'change select.js-ext-address': 'updateAddress',
	            'change input.js-ext-idStr': 'updateIdStr',
	            'change [name="childType"]': 'updateChildren',
	            'change [name="pcbDeduction"]': 'updateChildren',
	            'change select.js-ext-childrenAmount': 'toggleChildrenTypeSelect'
	        });
	    },
	
	    initialize: function initialize(options) {
	        /* THIS PIECE OF CODE SHOULD NEVER RUN */
	        if (this.model.get('marriedStatus') === 1 && this.model.getChildrenCount()) {
	            this.model.set('childrenAmount', '0');
	            this.model.set('children', []);
	        }
	        /* END */
	
	        this.options = Object.assign({
	            template: _PersonalInfo2.default
	        }, options || {});
	        this.options.templateExtra = Object.assign({
	            isNew: this.options.isNew,
	            model: this.model,
	            countriesList: _countriesList2.default,
	            Address: _address2.default
	        }, this.options.templateExtra || {});
	        this.options.bankAccountOverrides = { companyId: app.company.id };
	
	        this.removalModal = new _RemovalModal2.default({
	            unsubmittedPayroll: this.options.unsubmittedPayroll,
	            employee: this.model
	        });
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var _this = this;
	
	        var r = _Form2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.model.on('change:isResident', this.toggleResidentSubType, this);
	        this.model.on('change:isResident', this.togglePermanentResident, this);
	        this.model.on('change:nationality', this.togglePermanentResident, this);
	        this.model.on('change:idType', this.toggleIdMask, this);
	        this.model.on('change:idType', this.toggleDob, this);
	        this.model.on('change:idType', this.updateDobFromId, this);
	        this.model.on('change:idType', this.updateGender, this);
	        this.model.on('change:idStr', this.updateDobFromId, this);
	        this.model.on('change:residentSubType', this.onResidentSubTypeChange, this);
	        // the delay is to prevent quick tabbing into the next field from
	        // messing with updateGender()
	        this.model.on('change:idStr', function () {
	            return setTimeout(_this.updateGender.bind(_this), 100);
	        }, this);
	        this.model.on('change:marriedStatus', this.toggleChildren, this);
	        this.model.on('change:marriedStatus', this.toggleIsSpouseDisabled, this);
	
	        this.on('cancelled', this.scrollTop, this);
	
	        if (this.removalModal) {
	            this.removalModal.on('destroy', this.redirectToEmployeeList, this);
	        }
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = _Form2.default.prototype.unbindHandlers.apply(this, arguments);
	
	        this.model.off(null, null, this);
	        this.off(null, null, this);
	
	        if (this.removalModal) {
	            this.removalModal.off(null, null, this);
	        }
	
	        return r;
	    },
	
	    toggleResidentSubType: function toggleResidentSubType(model) {
	        this.$('[name=residentSubType]').iCheck(model.get('isResident') === true ? 'enable' : 'disable');
	    },
	
	    togglePermanentResident: function togglePermanentResident(model) {
	        this.$('[name=isPermanentResident]').iCheck(model.get('nationality') !== 'MY' ? 'enable' : 'disable');
	    },
	
	    // 20210207 hide isSpouseDisabled input for all marital statuses
	    // except "Married and spouse is NOT working"
	    // ticket: https://jibbletech.atlassian.net/browse/PPKAN-53
	    toggleIsSpouseDisabled: function toggleIsSpouseDisabled(model) {
	        // show only for Married and spouse is NOT working
	        if (model.get('marriedStatus') === 5) {
	            this.$('[name=isSpouseDisabled]').iCheck('enable');
	            this.$('#is-spouse-disabled-input').show();
	        } else {
	            this.$('[name=isSpouseDisabled]').iCheck('disable');
	            this.$('#is-spouse-disabled-input').hide();
	        }
	    },
	
	    toggleIdMask: function toggleIdMask(model, value) {
	        var isIcNumber = (value || this.model.get('idType')) === _employee.consts.ID_TYPE_IC_NUMBER;
	
	        if (isIcNumber) {
	            this.$('[name=idStr]').inputmask('999999-99-9999').attr('placeholder', 'Enter IC Number').val(!value ? this.model.get('idStr') : '');
	            this.$('.js-idType-label').text('IC Number');
	        } else {
	            this.$('[name=idStr]').inputmask('*{*}').attr('placeholder', 'Enter Passport').val(!value ? this.model.get('idStr') : '');
	            this.$('.js-idType-label').text('Passport');
	        }
	    },
	
	    toggleDob: function toggleDob(model, value) {
	        var isIcNumber = (value || this.model.get('idType')) === _employee.consts.ID_TYPE_IC_NUMBER;
	
	        this.$('input[name=dob]').prop('disabled', isIcNumber)
	        // the datepicker shows even if the field is disabled. I hide
	        // the calendar button for that reason.
	        .closest('.js-datepicker', this.el).toggleClass('input-group', !isIcNumber).find('.input-group-addon').toggleClass('hidden', isIcNumber);
	    },
	
	    updateDobFromId: function updateDobFromId(model) {
	        // extracting dob from malaysian ic number, format:
	        // https://en.wikipedia.org/wiki/National_Registration_Identity_Card_Number_(Malaysia)
	        //
	
	        var icNumber = model.get('idStr');
	        var date = void 0;
	
	        if (model.get('idType') !== _employee.consts.ID_TYPE_IC_NUMBER) {
	            return;
	        }
	
	        if (/^\d{6,}/g.test(icNumber)) {
	            if (parseInt(icNumber.substr(0, 2), 10) > 15) {
	                icNumber = '19' + icNumber;
	            } else {
	                icNumber = '20' + icNumber;
	            }
	
	            date = (0, _moment2.default)(icNumber.substr(0, 8) + '+00:00', 'YYYYMMDDZ').utcOffset(0);
	            this.$('.js-datepicker').datepicker('setDate', date._d);
	            this.$('.js-datepicker .js-datepicker-input').trigger('change');
	        } else {
	            this.$('.js-datepicker .js-datepicker-input').val('').trigger('change');
	        }
	    },
	
	    updateGender: function updateGender() {
	        var idType = this.model.get('idType') || '';
	        var isICNumber = idType !== _employee.consts.ID_TYPE_IC_NUMBER;
	        var idStr = this.model.get('idStr') || '';
	        var lastDigit = parseFloat(idStr.substr(-1));
	        var isNotValidNumber = isNaN(lastDigit);
	
	        if (isICNumber || isNotValidNumber) {
	            return;
	        }
	
	        var isMale = lastDigit % 2 === 1;
	
	        this.$('[name=gender][value="' + (isMale ? 1 : 2) + '"]').iCheck('check');
	    },
	
	    /**
	     * If residentSubType equals to 3(freelancer) ot 4(intern),
	     * set EPF, EIS, SOCSO contribution to none as default
	     */
	    onResidentSubTypeChange: function onResidentSubTypeChange(model, value) {
	        if (value === _employee.consts.RESIDENT_SUBTYPE_FREELANCER) {
	            this.model.set('isEpf', false);
	            this.model.set('isEis', false);
	            this.model.set('socsoCategory', _employee.consts.SOCSO_CATEGORY_NONE);
	        }
	    },
	
	    toggleChildren: function toggleChildren(model) {
	        var canHaveChildren = model.get('marriedStatus') !== _employee.consts.MARRIED_STATUS_SINGLE;
	        var hasChildren = (model.get('children') || []).length > 0;
	
	        this.$('.js-ext-childrenAmount').closest('.form-group').toggleClass('hidden', !canHaveChildren);
	
	        this.$('.js-ext-childType-container').closest('.form-group').toggleClass('hidden', !canHaveChildren || !hasChildren);
	
	        if (!canHaveChildren) {
	            this.$('.js-ext-childrenAmount').val(0).trigger('change');
	        }
	    },
	
	    toggleChildrenTypeSelect: function toggleChildrenTypeSelect(ev) {
	        var $el = this.$(ev.currentTarget);
	        var childrenAmount = parseInt($el.val(), 10) || 0;
	        var children = this.model.get('children') || [];
	        for (var i = children.length; i < childrenAmount; i++) {
	            children.push({
	                category: 'underage',
	                pcbDeduction: 100
	            });
	        }
	        if (children.length > childrenAmount) {
	            children = children.slice(0, childrenAmount);
	        }
	        this.model.set('children', children);
	        this.$('.js-ext-childType-container').html((0, _Children2.default)({
	            model: this.model
	        }));
	
	        this.$('.js-ext-childType-container').parent('.form-group').toggleClass('hidden', children.length === 0);
	    },
	
	    updateAddress: function updateAddress(ev) {
	        var $el = this.$(ev.currentTarget);
	        var attr = $el.attr('name');
	        var value = this.getInputValue($el);
	
	        if (!this.model.getAddress()) {
	            this.model.setAddress(new _address2.default());
	        }
	
	        this.toggleError(attr);
	        this.model.getAddress().set(attr, value);
	    },
	
	    updateIdStr: function updateIdStr(ev) {
	        var $el = this.$(ev.currentTarget);
	        var attr = $el.attr('name');
	        var value = this.getInputValue($el);
	
	        // anyway update the value so we could prevent object save with old data
	        if (!this.model.set({ 'idStr': value })) {
	            this.model.attributes.idStr = value;
	            this.toggleError(attr, this.model.validationError.idStr[0]);
	        }
	    },
	
	    updateChildren: function updateChildren() {
	        this.model.set('children', _.map(this.$('.js-ext-child'), function (child) {
	            return {
	                category: this.getInputValue($(child).find('[name="childType"]')),
	                pcbDeduction: this.getInputValue($(child).find('[name="pcbDeduction"]'))
	            };
	        }.bind(this)));
	    },
	
	    updateIdType: function updateIdType(ev) {
	        var $el = this.$(ev.currentTarget);
	        ev.preventDefault();
	
	        this.model.set('idType', $el.data('value'));
	    },
	
	    render: function render() {
	        var r = _Form2.default.prototype.render.apply(this, arguments);
	
	        this.toggleIdMask();
	        this.toggleIsSpouseDisabled(this.model);
	
	        return r;
	    },
	
	    cancel: function cancel(ev) {
	        var _this2 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        ev.preventDefault();
	
	        this.model.setBankAccount(null);
	        this.model.fetch().then(function () {
	            return _this2.model.fetchBankAccount();
	        }).then(function () {
	            return _this2.model.fetchAddress();
	        }).then(function () {
	            return _this2.model.trigger('sync');
	        }).then(function () {
	            return _this2.render;
	        }).finally(stopLoader);
	    },
	
	    dirty: function dirty() {
	        var tainted = this.tainted;
	
	        if (!this.model.isNew()) {
	            tainted = this.model.dirty() || this.model.getBankAccount() && this.model.getBankAccount().dirty() || this.model.getAddress() && this.model.getAddress().dirty();
	        }
	
	        return tainted;
	    },
	
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        var _this3 = this;
	
	        return new _bluebird2.default(function (resolve, reject) {
	            if (!_.isObject(_this3.options.unsubmittedPayroll)) {
	                return resolve(true);
	            }
	
	            _alerts2.default.show('infoConfirm', {
	                title: 'Your saved payroll will be modified!',
	                text: 'You have an unsubmitted payroll saved.                     If you continue, the payroll details of this employee                     will be updated based on the modifications you are about                     to save. Also, any unsaved payroll details will be lost.',
	                confirmButtonText: 'Yes, Save Employee Information'
	            }).then(function () {
	                return resolve();
	            }, function (err) {
	                return reject(err);
	            });
	        });
	    },
	
	    save: function save(ev) {
	        var _this4 = this;
	
	        var $el = this.$(ev.currentTarget);
	        var stopLoader = function stopLoader() {};
	
	        if (!this.model.isValid()) {
	            this.invalid(this.model, { errors: this.model.validationError });
	            return;
	        }
	
	        this.resetPayrollConfirm().then(function () {
	            stopLoader = _loader2.default.startFullScreen($el);
	
	            var saveBankAccount = _this4.model.getBankAccount() ? _this4.model.getBankAccount().save() : (0, _bluebird.resolve)();
	
	            return saveBankAccount.then(function () {
	                var address = _this4.model.getAddress();
	                if (address) {
	                    if (address.isBlank()) {
	                        _this4.model.setAddress(null);
	                        return address.destroy();
	                    }
	                    return _this4.model.getAddress().save();
	                }
	                return (0, _bluebird.resolve)();
	            }).then(function () {
	                var bankAccountId = _this4.model.getBankAccount() ? _this4.model.getBankAccount().id : null;
	                var addressId = _this4.model.getAddress() ? _this4.model.getAddress().id : null;
	
	                _this4.model.set('bankAccountId', bankAccountId);
	                _this4.model.set('addressId', addressId);
	                return _this4.model.save();
	            }).then(function () {
	                return _this4.options.isNew ? app.company.fetch() : (0, _bluebird.resolve)();
	            });
	        }, function () {
	            return (0, _bluebird.reject)({ _cancelled: true });
	        }).then(function () {
	            if (_this4.options.unsubmittedPayroll) {
	                return _this4.options.unsubmittedPayroll.resetEmployee({ employee: _this4.model });
	            }
	
	            return (0, _bluebird.resolve)(true);
	        }).then(function () {
	            _this4.model.trigger('sync');
	
	            if (_this4.options.isNew) {
	                var nextStep = 'employee/' + _this4.model.id + '                    /employmentDetails/isNew';
	
	                // Show message if first employee successfully saved
	                if (app.company.get('employeeCount') === 1) {
	                    _alerts2.default.show('success', {
	                        text: 'Employee\'s Personal Info has been saved,                             proceed to Employment Details now',
	                        callback: function callback() {
	                            return app.mainRouter.navigate(nextStep, {
	                                trigger: true,
	                                replace: true
	                            });
	                        }
	                    });
	                }
	
	                app.mainRouter.navigate(nextStep, {
	                    trigger: true,
	                    replace: true
	                });
	            } else {
	                _modal2.default.showAlertSuccess('Employee\'s personal info has been saved');
	            }
	        }).catch(function (err) {
	            if ((err || {})._cancelled === true) {
	                return;
	            }
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    destroy: function destroy() {
	        this.removalModal.show();
	    },
	
	    destroyPermanent: function destroyPermanent() {
	        var _this5 = this;
	
	        return this.model.isDestroyable().then(function (isDestroyable) {
	            if (!isDestroyable) {
	                _alerts2.default.show('error', {
	                    title: 'Can\'t delete this employee.',
	                    text: 'You can\'t delete this employee as he/she is part                             of a payroll.'
	                });
	                return;
	            } else {
	                _alerts2.default.show('dangerConfirm', {
	                    title: 'Are you sure you want to permanently delete the employee?',
	                    confirmButtonText: 'Yes, Delete',
	                    callback: function callback(isConfirm) {
	                        if (!isConfirm) {
	                            return;
	                        }
	
	                        _this5.model.permanentDestroy().then(function () {
	                            return app.company.fetchCurrentPayroll();
	                        }).then(function (payroll) {
	                            if (!payroll) {
	                                return false;
	                            }
	                            return payroll.setStatus(_payroll.payrollStatus.INITIAL);
	                        }).then(function () {
	                            _alerts2.default.show('success', {
	                                title: 'Employee is successfully deleted'
	                            });
	
	                            app.mainRouter.navigate('employees/archived', { trigger: true });
	                        }).catch(function (err) {
	                            _alerts2.default.show('criticalError', err);
	                        });
	                    }
	                });
	            }
	        });
	    },
	
	    removeEmployeeUser: function removeEmployeeUser() {
	        var _this6 = this;
	
	        var onRemove = function onRemove() {
	            return _this6.model.removeEmployeeUser().then(function () {
	                _alerts2.default.show('success', {
	                    title: 'Employee User Removed!'
	                });
	
	                var $remove = _this6.$('.js-remove-employee-user');
	                $remove.hide();
	            }).catch(function (err) {
	                _alerts2.default.show('error', {
	                    title: 'Error Removing EmployeeUser',
	                    text: err && err.message
	                });
	            });
	        };
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Remove Employee Access',
	            text: 'You\'re about to remove this employee\'s access.<br>                Please note this action is permanent.',
	            confirmButtonText: 'Yes, Remove',
	            callback: function callback(isConfirm) {
	                if (isConfirm) {
	                    return onRemove();
	                }
	            }
	        });
	    },
	
	    restore: function restore(e) {
	        var _this7 = this;
	
	        return this.resetPayrollConfirm().then(function () {
	            var stopLoader = _loader2.default.startFullScreen(e.target);
	            return _this7.model.restore().then(function (employee) {
	                if (_this7.options.unsubmittedPayroll) {
	                    return _this7.options.unsubmittedPayroll.resetEmployee({ employee: employee }).then(function () {
	                        return employee;
	                    });
	                }
	
	                return employee;
	            }).then(function (employee) {
	                app.company.fetch();
	                return employee;
	            }).catch(function (err) {
	                _alerts2.default.show('criticalError', err);
	            }).finally(stopLoader);
	        });
	    },
	
	    redirectToEmployeeList: function redirectToEmployeeList() {
	        this.remove();
	        app.mainRouter.navigate('employees', { trigger: true });
	    },
	
	    toggleError: function toggleError(attribute, message) {
	        //FIXME custom messages can be set in the model, extending a view
	        //method is not the place for this
	
	        if (attribute === 'idStr' && message) {
	            var type = this.model.get('idType') === 1;
	            message = type ? message.replace('Id str', 'IC Number') : message.replace('Id str', 'Passport');
	        }
	
	        _Form2.default.prototype.toggleError.apply(this, [attribute, message]);
	    },
	
	    remove: function remove() {
	        _Form2.default.prototype.remove.apply(this, arguments);
	
	        if (this.removalModal) {
	            this.removalModal.remove();
	            this.removalModal = undefined;
	        }
	
	        if (this.bankAccountModal) {
	            this.bankAccountModal.remove();
	            this.bankAccountModal = undefined;
	        }
	    },
	
	    scrollTop: function scrollTop() {
	        window.scrollTo(0, 0);
	    },
	
	    // make sure that whenever we get the email field from the UI we make it
	    // lower case
	    getInputValueOfEmail: function getInputValueOfEmail($el) {
	        return ($el.val() || '').trim().toLowerCase();
	    }
	}), _BankAccount2.default);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bankAccount = __webpack_require__(573);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _BankAccountModal = __webpack_require__(783);
	
	var _BankAccountModal2 = _interopRequireDefault(_BankAccountModal);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    events: function events() {
	        return {
	            'click .js-add-bank-account': 'addBankAccount',
	            'click .js-edit-bank-account': 'editBankAccount'
	        };
	    },
	
	    initialize: function initialize() {
	        this.bankAccountModal = new _BankAccountModal2.default({
	            actOnSave: false,
	            actOnCancel: false,
	            actOnDestroy: false
	        });
	        this.bindBankAccountModalHandlers();
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.bindBankAccountModalHandlers();
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        this.unbindBankAccountModalHandlers();
	    },
	
	    bindBankAccountModalHandlers: function bindBankAccountModalHandlers() {
	        if (this.bankAccountModal) {
	            this.bankAccountModal.on('saved', this.renderBankAccount, this);
	            this.bankAccountModal.on('cancelled', this.resetBankAccount, this);
	            this.bankAccountModal.on('destroyed', this.destroyBankAccount, this);
	            this.bankAccountModal.on('saved cancelled destroyed', this.toggleButtons, this);
	        }
	    },
	
	    unbindBankAccountModalHandlers: function unbindBankAccountModalHandlers() {
	        if (this.bankAccountModal) {
	            this.bankAccountModal.off(null, null, this);
	        }
	    },
	
	    destroyBankAccount: function destroyBankAccount(bankAccount) {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullScreen();
	
	        this.bankAccountModal.unsetModel();
	
	        if (bankAccount.isNew()) {
	            stopLoader();
	            return this.renderBankAccount(null);
	        }
	
	        return bankAccount.destroy().then(function () {
	            _this.model.setBankAccount(null);
	        }).then(function () {
	            return _this.model.save({ bankAccountId: null });
	        }).then(function () {
	            return _this.renderBankAccount(null);
	        }).finally(function () {
	            return stopLoader;
	        });
	    },
	
	    resetBankAccount: function resetBankAccount(bankAccount) {
	        var _this2 = this;
	
	        var stopLoader = _loader2.default.startFullScreen();
	
	        if (!bankAccount.isNew()) {
	            bankAccount.fetch().then(function () {
	                return _this2.renderBankAccount(bankAccount);
	            }).finally(function () {
	                return stopLoader();
	            });
	        }
	    },
	
	    renderBankAccount: function renderBankAccount(bankAccount) {
	        if (!bankAccount || !this.model.getBankAccount() || this.model.getBankAccount().id !== bankAccount.id) {
	            this.model.setBankAccount(bankAccount);
	        }
	
	        if (!_.isNull(bankAccount)) {
	            this.bankAccountModal.enableDestroyButton();
	        } else {
	            this.bankAccountModal.disableDestroyButton();
	        }
	
	        return this.render();
	    },
	
	    addBankAccount: function addBankAccount() {
	        this.showEditBankAccountModal(new _bankAccount2.default(this.options.bankAccountOverrides || {}));
	    },
	
	    editBankAccount: function editBankAccount() {
	        this.showEditBankAccountModal(this.model.getBankAccount());
	    },
	
	    showEditBankAccountModal: function showEditBankAccountModal(bankAccount) {
	        this.bankAccountModal.setModel(bankAccount).render().show();
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _BankAccountModal = __webpack_require__(784);
	
	var _BankAccountModal2 = _interopRequireDefault(_BankAccountModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _BankAccountTxTypes = __webpack_require__(785);
	
	var _BankAccountTxTypes2 = _interopRequireDefault(_BankAccountTxTypes);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global*/
	
	var accountTypes = {
	    '27': [{ id: 'maybank2u', name: 'Maybank2U' }, { id: 'maybank2e', name: 'Maybank2E' }],
	    '33': [{ id: 'service', name: 'PB ECP Service (www.pbebank.com)' }, { id: 'enterprise', name: 'PB Enterprise (www.pbenterprise.com)' }]
	};
	
	module.exports = _ModalForm2.default.extend({
	    events: function events() {
	        return Object.assign({}, _ModalForm2.default.prototype.events(), {
	            'change .js-ext-bank': 'selectBank'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            template: _BankAccountModal2.default,
	            templateExtra: {}
	        }, options || {});
	
	        this.options.templateExtra = Object.assign(this.options.templateExtra, {
	            banks: app.banks,
	            accountTypes: accountTypes
	        });
	
	        return _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var _this = this;
	
	        var r = _ModalForm2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.model.on('change:bankBnmCode', this.toggleOrganizationCodeVisibility, this);
	        this.model.on('change:bankBnmCode', this.toggleHSBCFieldsVisibility, this);
	        this.model.on('change:bankBnmCode', this.toggleAccountTypeVisibility, this);
	        this.model.on('change:bankBnmCode', this.toggleAccountType, this);
	        this.model.on('change:bankBnmCode', function () {
	            return _this.markMandatoryFields();
	        }, this);
	        this.model.on('change:bankBnmCode', this.toggleAccountTypeSelected, this);
	        this.model.on('change:accountType', this.toggleAccountTypeSelected, this);
	        this.model.on('change:bankBnmCode', this.toggleOriginatorIDVisibility, this);
	        this.model.on('change:accountType', this.toggleOriginatorIDVisibility, this);
	        this.model.on('change:bankBnmCode', this.toggleCompanyCodeVisibility, this);
	        return r;
	    },
	
	    selectBank: function selectBank(ev) {
	        var $el = this.$(ev.currentTarget);
	        var $option = $el.find('option:selected');
	        var bnmCode = ($option.data('bnm') || '') + ''; //turn to string
	        var swiftCode = $option.data('swift') || '';
	        var name = $option.data('name') || '';
	
	        this.model.set({
	            bankName: name,
	            bankBnmCode: bnmCode,
	            bankSwiftCode: swiftCode
	        });
	
	        this.toggleTxTypes();
	        this.updateOrganizationCodeLabel();
	        this.toggleDefaultTxTypes();
	        this.markMandatoryFields();
	    },
	
	    toggleDefaultTxTypes: function toggleDefaultTxTypes() {
	        var bankCode = this.model.get('bankBnmCode');
	        var supportedTxTypes = this.model.getSupportedTransactionTypes();
	
	        var defaultTxType = '';
	        if (bankCode === '18') {
	            defaultTxType = '30';
	        } else if (supportedTxTypes) {
	            defaultTxType = Object.keys(supportedTxTypes)[0];
	        }
	
	        this.model.set('transactionType', defaultTxType);
	        this.$('[name=transactionType]').val(defaultTxType).change();
	    },
	
	    toggleAccountTypeSelected: function toggleAccountTypeSelected() {
	        if (!this.model) {
	            return;
	        }
	        var selected = this.model.get('accountType');
	        var bankCode = this.model.get('bankBnmCode');
	        if (bankCode === '33') {
	            var showOrganizationCode = selected === 'service';
	            this.$('[name=organizationCode]').closest('.form-group').toggleClass('hidden', !showOrganizationCode);
	            this.toggleTxTypes();
	            this.markMandatoryFields();
	        }
	
	        if (bankCode === '27') {
	            var _showOrganizationCode = selected === 'maybank2e';
	            this.$('[name=organizationCode]').closest('.form-group').toggleClass('hidden', !_showOrganizationCode);
	            this.toggleTxTypes();
	            this.markMandatoryFields();
	        }
	    },
	
	    toggleTxTypes: function toggleTxTypes() {
	        this.$('.js-tx-types').html('');
	
	        if (!this.model) {
	            return;
	        }
	
	        /* Not as simple as hiding an input like organizationCode, therefore we
	         just render the tx types partial when required */
	        /* In retrospect, toggling inputs like organizationCode would have been
	         * easier, being that not all banks that support TxTypes require the
	         * exact same information */
	        // TODO Get rid of the partial and toggle fields instead
	        var txTypes = this.model.getSupportedTransactionTypes();
	
	        if (this.model.get('isPayer') && txTypes) {
	            txTypes = Object.keys(txTypes).map(function (k) {
	                return {
	                    type: k,
	                    desc: txTypes[k]
	                };
	            });
	            var txTypesRender = (0, _BankAccountTxTypes2.default)({
	                organizationCode: this.model.get('organizationCode'),
	                transactionType: this.model.get('transactionType'),
	                rentasTxCode: this.model.get('rentasTxCode'),
	                txTypes: txTypes
	            });
	            this.$('.js-tx-types').html(txTypesRender);
	            _tooltip2.default.init(this);
	        }
	
	        this.delegateEvents();
	    },
	
	    render: function render() {
	        var r = _ModalForm2.default.prototype.render.apply(this, arguments);
	        this.toggleTxTypes();
	        this.toggleOrganizationCodeVisibility();
	        this.toggleHSBCFieldsVisibility();
	        this.toggleOriginatorIDVisibility();
	        this.toggleAccountTypeVisibility();
	        this.toggleCompanyCodeVisibility();
	        this.updateOrganizationCodeLabel();
	        this.markMandatoryFields();
	        this.toggleAccountTypeSelected();
	
	        return r;
	    },
	
	    updateOrganizationCodeLabel: function updateOrganizationCodeLabel() {
	        if (!this.model) {
	            return;
	        }
	
	        var bankCode = this.model.get('bankBnmCode');
	        var $label = this.$('.js-organization-code-label');
	        if (bankCode === '18') {
	            $label.text('Corporate ID');
	        } else {
	            $label.text('Organization Code');
	        }
	    },
	
	    toggleOrganizationCodeVisibility: function toggleOrganizationCodeVisibility() {
	        if (!this.model) {
	            return;
	        }
	        var usingOrganizationCode = ['33', '35', '18'];
	        var bankCode = this.model.get('bankBnmCode');
	
	        this.$('[name=organizationCode]').closest('.form-group').toggleClass('hidden', !usingOrganizationCode.includes(bankCode) || !this.model.get('isPayer'));
	    },
	
	    toggleOriginatorIDVisibility: function toggleOriginatorIDVisibility() {
	        if (!this.model) {
	            return;
	        }
	        var bankCode = this.model.get('bankBnmCode');
	        var accountType = this.model.get('accountType');
	
	        this.$('[name=originatorId]').closest('.form-group').toggleClass('hidden', !(bankCode === '27' && accountType === 'maybank2u'));
	        this.markMandatoryFields();
	    },
	
	    toggleCompanyCodeVisibility: function toggleCompanyCodeVisibility() {
	        if (!this.model) {
	            return;
	        }
	        var bankCode = this.model.get('bankBnmCode');
	
	        this.$('[name=companyCode]').closest('.form-group').toggleClass('hidden', !(bankCode === '26' && this.model.get('isPayer')));
	        this.markMandatoryFields();
	    },
	
	    toggleHSBCFieldsVisibility: function toggleHSBCFieldsVisibility() {
	        if (!this.model) {
	            return;
	        }
	        var bankCode = this.model.get('bankBnmCode');
	
	        this.$('.hsbc-fields').toggleClass('hidden', !(bankCode === '22' && this.model.get('isPayer')));
	    },
	
	    toggleAccountTypeVisibility: function toggleAccountTypeVisibility() {
	        if (!this.model) {
	            return;
	        }
	        var bankCode = this.model.get('bankBnmCode');
	        this.$('.js-ext-account-type-container').toggleClass('hidden', accountTypes[bankCode] === undefined || !this.model.get('isPayer'));
	        this.$('.js-ext-account-type-opt').addClass('hidden');
	        this.$('.js-ext-account-type-opt-' + bankCode).removeClass('hidden');
	    },
	
	    toggleAccountType: function toggleAccountType() {
	        var _this2 = this;
	
	        var types = accountTypes[this.model.get('bankBnmCode')] || [];
	        var type = _.find(types, function (type) {
	            return type.id === _this2.model.get('accountType');
	        });
	        if (!type) {
	            this.model.set('accountType', '', { validate: false });
	            this.renderAttribute(this.model, 'accountType');
	            return;
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/BankAccountModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            '+
	((__t=( model.isNew() ? 'Add' : 'Edit' ))==null?'':_.escape(__t))+
	' Bank Account\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <label class="col-sm-4 control-label">\n                            Bank\n                        </label>\n                        <div class="col-sm-8">\n                            <input type="hidden" name="bankName" class="js-ext" />\n                            <input type="hidden" name="bankSwiftCode" class="js-ext" />\n                            <input type="hidden" name="bankBnmCode" class="js-ext" />\n\n                            <select name="bank" class="form-control\n                                js-ext js-ext-bank js-chosen">\n                                <option value="" disabled\n                                    '+
	((__t=( !model.get('bankName') ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Please select a bank\n                                </option>\n                                ';
	 banks.each(function(bank) { 
	__p+='\n                                    <option value="'+
	((__t=( bank.id ))==null?'':_.escape(__t))+
	'"\n                                        data-bnm="'+
	((__t=( bank.get('bnmCode') ))==null?'':_.escape(__t))+
	'"\n                                        data-swift="'+
	((__t=( bank.get('swiftCode') ))==null?'':_.escape(__t))+
	'"\n                                        data-name="'+
	((__t=( bank.get('name') ))==null?'':_.escape(__t))+
	'"\n                                        '+
	((__t=( (
	                                            model.get('bankName') == bank.get('name')
	                                        ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                        '+
	((__t=( bank.get('name') ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                            <span class="error error-bankName error-bankBnmCode\n                                error-bankSwiftCode"></span>\n                        </div>\n                    </div>\n                    <div class="form-group js-ext-account-type-container\n                        '+
	((__t=( (
	                            !model.get('bankBnmCode') ||
	                            !accountTypes[model.get('bankBnmCode')]
	                        ) ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n                        <label class="col-sm-4 control-label">\n                            Account Type\n                        </label>\n                        <div class="col-sm-8">\n                            <select name="accountType" class="form-control">\n                                <option value="" disabled\n                                    '+
	((__t=( !model.get('accountType') ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Please select an account type\n                                </option>\n                                ';
	 Object.keys(accountTypes).forEach(function(bnm) { 
	__p+='\n                                    ';
	 accountTypes[bnm].forEach(function(type) { 
	__p+='\n                                        <option value="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                            class="js-ext-account-type-opt\n                                                js-ext-account-type-opt-'+
	((__t=( bnm ))==null?'':_.escape(__t))+
	'\n                                                '+
	((__t=( (
	                                                    model.get('bankBnmCode') &&
	                                                    model.get('bankBnmCode') === bnm
	                                                ) ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'"\n                                            '+
	((__t=( (
	                                                model.get('accountType') === type.id
	                                            ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                            '+
	((__t=( type.name ))==null?'':_.escape(__t))+
	'\n                                        </option>\n                                    ';
	 }) 
	__p+='\n                                ';
	 }) 
	__p+='\n                            </select>\n                            <span class="error error-accountType"></span>\n                        </div>\n                    </div>\n                    <div class="form-group hidden">\n                        <label class="col-sm-4 control-label">\n                            <span class="js-organization-code-label">\n                                Organization Code\n                            </span>\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip"\n                                data-placement="top"\n                                data-container="body"\n                                title="This code is provided to you by your\n                                    bank and is required to generate\n                                    bulk payment files"></i>\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="organizationCode"\n                                value="'+
	((__t=( model.get('organizationCode') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-organizationCode"></span>\n                        </div>\n                    </div>\n                    <div class="form-group hidden">\n                        <label class="col-sm-4 control-label">\n                            <span class="js-originator-id-label">\n                                Originator ID\n                            </span>\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="originatorId"\n                                value="'+
	((__t=( model.get('originatorId') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-originatorId"></span>\n                        </div>\n                    </div>\n                    <div class="form-group hidden">\n                        <label class="col-sm-4 control-label">\n                            <span class="js-company-id-label">\n                                Company ID\n                            </span>\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="companyCode"\n                                value="'+
	((__t=( model.get('companyCode') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-companyCode"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group hsbc-fields hidden">\n                        <label class="col-sm-4 control-label">\n                            <span class="">\n                                HSBCnet Payment Set No\n                            </span>\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="hsbcNetPaymentSetNo"\n                                value="'+
	((__t=( model.get('hsbcNetPaymentSetNo') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-hsbcNetPaymentSetNo"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group hsbc-fields hidden">\n                        <label class="col-sm-4 control-label">\n                            <span class="">\n                                HSBCnet Customer ID\n                            </span>\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="hsbcNetId"\n                                value="'+
	((__t=( model.get('hsbcNetId') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-hsbcNetId"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group hsbc-fields hidden">\n                        <label class="col-sm-4 control-label">\n                            <span class="">\n                                HSBC Connect Customer ID\n                            </span>\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="hsbcConnectId"\n                                value="'+
	((__t=( model.get('hsbcConnectId') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-hsbcConnectId"></span>\n                        </div>\n                    </div>\n                    \n\n                    <div class="form-group">\n                        <label class="col-sm-4 control-label">\n                            Account Holder\'s Name\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="holderName"\n                                value="'+
	((__t=( model.get('holderName') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-holderName" ></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-4 control-label">\n                            Account Number\n                        </label>\n                        <div class="col-sm-8">\n                            <input class="form-control" type="text"\n                                name="number"\n                                value="'+
	((__t=( model.get('number') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-number"></span>\n                        </div>\n                    </div>\n                    <div class="js-tx-types">\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            ';
	 if (!model.isNew() || forceDestroyButton) { 
	__p+='\n                <button type="button"\n                    class="js-destroy btn btn-w-m btn-danger m-l-xs float-left">\n                    <i class="fa fa-trash"></i> Remove\n                </button>\n            ';
	 } 
	__p+='\n            <button type="button"\n                    class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/BankAccountTxTypes.ejs -->\n<div class="form-group">\n    <label class="col-sm-4 control-label">\n        Payment/Transaction Type\n        <i class="fa fa-question-circle"\n            data-toggle="tooltip"\n            data-placement="top"\n            data-container="body"\n            title="Select the payment mode/transaction type to be used when\n                issuing files for bulk payments"></i>\n    </label>\n    <div class="col-sm-8">\n        <select name="transactionType" class="form-control">\n            <option value="" disabled\n                    '+
	((__t=( !transactionType ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Please select one\n            </option>\n            ';
	 _.each(txTypes, function(tx, i) { 
	__p+='\n                <option value="'+
	((__t=( tx.type ))==null?'':_.escape(__t))+
	'"\n                    '+
	((__t=( transactionType == tx.type ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( tx.desc ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n        <span class="error error-transactionType"></span>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _RemovalModal = __webpack_require__(787);
	
	var _RemovalModal2 = _interopRequireDefault(_RemovalModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _employeeRemoval = __webpack_require__(577);
	
	var _employeeRemoval2 = _interopRequireDefault(_employeeRemoval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ModalForm2.default.extend({
	    initialize: function initialize(options) {
	        this.model = new _employeeRemoval2.default();
	        this.model.setEmployee(options.employee);
	
	        this.options = Object.assign(options, {
	            template: _RemovalModal2.default,
	            actOnCancel: false
	        });
	
	        return _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        _ModalForm2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.model.on('change:reason', this.toggleIsReported, this);
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        _ModalForm2.default.prototype.unbindHandlers.apply(this, arguments);
	
	        this.model.off('change:reason', this.toggleIsReported);
	    },
	
	    toggleIsReported: function toggleIsReported(model) {
	        this.$('.js-isReported').toggleClass('hidden', model.get('reason') !== 5);
	    },
	
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        var _this = this;
	
	        return new _bluebird2.default(function (resolve, reject) {
	            if (!_.isObject(_this.options.unsubmittedPayroll)) {
	                return resolve(true);
	            }
	
	            _alerts2.default.show('infoConfirm', {
	                title: 'Your saved payroll will be modified!',
	                text: 'You have an unsubmitted payroll saved. ' + 'If you continue, the payroll details of this employee ' + 'will be updated based on the modifications you are ' + 'about to save. Also, any unsaved payroll details will ' + 'be lost.',
	                confirmButtonText: 'Yes, Archive Employee'
	            }).then(function () {
	                return resolve();
	            }, function (err) {
	                return reject(err);
	            });
	        });
	    },
	
	    save: function save(ev) {
	        var _this2 = this;
	
	        if (!this.model.isValid()) {
	            this.invalid(this.model, { errors: this.model.validationError });
	            return;
	        }
	
	        var $el = this.$(ev.currentTarget);
	
	        this.resetPayrollConfirm().then(function () {
	            var stopLoader = _loader2.default.startFullScreen($el);
	            return _this2.options.employee.dismiss(_this2.model.attributes).then(function () {
	                if (_this2.options.unsubmittedPayroll) {
	                    return _this2.options.unsubmittedPayroll.resetEmployee({
	                        employee: _this2.model.getEmployee()
	                    });
	                }
	            }).then(function () {
	                _this2.hide();
	                _this2.trigger('destroy');
	            }).catch(function (err) {
	                _alerts2.default.show('criticalError', err);
	            }).finally(stopLoader);
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/RemovalModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content">\n        <div class="modal-header">\n            <h3>Archive Employee</h3>\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Reason\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip" data-placement="top"\n                                data-container="body"\n                                data-original-title="If you are sure you want\n                                    to archive the employee, select a reason">\n                            </i>\n                        </label>\n                        <div class="col-sm-9">\n                            <select class="form-control" name="reason"\n                                data-value-type="integer">\n                                <option disabled\n                                    '+
	((__t=( !model.get('reason') ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Select a reason\n                                </option>\n                                <option value="1"\n                                    '+
	((__t=( model.get('reason') === 1 ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Terminated\n                                </option>\n                                <option value="2"\n                                    '+
	((__t=( model.get('reason') === 2 ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Redundant\n                                </option>\n                                <option value="3"\n                                    '+
	((__t=( model.get('reason') === 3 ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Resigned\n                                </option>\n                                <option value="4"\n                                    '+
	((__t=( model.get('reason') === 4 ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Retired\n                                </option>\n                                <option value="5"\n                                    '+
	((__t=( model.get('reason') === 5 ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Left Malaysia\n                                    </option>\n                                <option value="6"\n                                    '+
	((__t=( model.get('reason') === 6 ?
	                                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Other\n                                </option>\n                            </select>\n                            <span class="error error-reason"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group hidden js-isReported">\n                        <label class="col-sm-3 control-label">\n                            Reported to the LHDNM ?\n                        </label>\n                        <div class="col-sm-9">\n                            <label class="js-icheck ichecks"\n                                style="margin-right: 32px;">\n                                <input type="radio" name="isReported"\n                                    value="0" checked data-value-type="boolean">\n                                <span>No</span>\n                            </label>\n                            <label class="js-icheck ichecks">\n                                <input type="radio" name="isReported"\n                                    value="1" data-value-type="boolean">\n                                <span>Yes</span>\n                            </label>\n                        </div>\n                        <span class="error error-isReported"></span>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Last Day\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip" data-placement="top"\n                                data-container="body"\n                                data-original-title="Last day in which\n                                    this employee ceased to be part of\n                                    company">\n                            </i>\n                        </label>\n                        <div class="col-sm-9">\n                            <div class="input-group date js-datepicker"\n                                data-attribute-name="removedAt"\n                                data-date-format="dd/mm/yyyy">\n                                <span class="input-group-addon">\n                                    <span class="glyphicon glyphicon-calendar">\n                                    </span>\n                                </span>\n                                <input type="text"\n                                    class="form-control js-ext js-ext-removedAt\n                                        js-datepicker-input"\n                                    name="removedAt"\n                                    value="'+
	((__t=( model.getFormattedDate(
	                                        'removedAt', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'">\n                            </div>\n                            <span class="error error-removedAt"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Personal Email\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip" data-placement="top"\n                                data-container="body"\n                                data-original-title="The employee\'s\n                                personal email, as specified in the Personal\n                                Info form">\n                            </i>\n                        </label>\n                        <div class="col-sm-9">\n                            <input name="personalEmail"\n                                class="form-control" type="text"\n                                value="'+
	((__t=(
	                                    model.getEmployee() ?
	                                        model.getEmployee()
	                                            .get('personalEmail') :
	                                        '' ))==null?'':_.escape(__t))+
	'">\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Additional Notes\n                        </label>\n                        <div class="col-sm-9">\n                            <textarea class="form-control" rows="3"\n                                name="notes"></textarea>\n                            <span class="error error-notes"></span>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Prorate Salary\n                        </label>\n                        <div class="col-sm-9">\n                            <label class="js-icheck ichecks"\n                                style="margin-right: 32px;">\n                                <input type="radio" name="prorateSalary"\n                                    value="0" data-value-type="boolean">\n                                <span>No</span>\n                            </label>\n                            <label class="js-icheck ichecks">\n                                <input type="radio" name="prorateSalary"\n                                    value="1" checked data-value-type="boolean">\n                                <span>Yes</span>\n                            </label>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button"\n                    class="js-cancel btn btn-w-m btn-warning"\n                    data-toggle="tooltip">\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                    class="js-save btn btn-w-m btn-danger m-l-xs">\n                <i class="fa fa-trash"></i> Yes, Archive\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/PersonalInfo.ejs -->\n<div class="form-horizontal">\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Full Name\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="Important: Employee\'s name has to be\n               identical with the name written on their IC/Passport (as\n               required for EPF Payments)">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="fullName" class="form-control" type="text"\n                placeholder="Full name must match name on IC"\n                value="'+
	((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error-fullName error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Email\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="Required if payslips are to be sent\n                automatically">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="email" class="form-control" type="text"\n                placeholder="Enter Email"\n                value="'+
	((__t=( model.get('email') ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error-email error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">ID Type &amp; Number </label>\n        <div class="col-sm-9">\n            <div class="input-group">\n                <div class="input-group-btn">\n                    <button data-toggle="dropdown" type="button"\n                        class="btn btn-white dropdown-toggle">\n                        <span class="js-idType-label">\n                            '+
	((__t=( (model.get('idType') === 1) ? 'IC Number' : '' ))==null?'':_.escape(__t))+
	'\n                            '+
	((__t=( (model.get('idType') === 2) ? 'Passport' : '' ))==null?'':_.escape(__t))+
	'\n                        </span>\n                        <span class="caret"></span>\n                    </button>\n                    <ul class="js-id-type-dropdown-menu\n                        dropdown-menu pull-right">\n                        <li><a data-value="1">IC Number</a></li>\n                        <li><a data-value="2">Passport</a></li>\n                    </ul>\n                </div>\n                <input name="idStr" class="form-control js-ext js-ext-idStr"\n                       type="text"\n                    placeholder="'+
	((__t=( model.get('idType') === 1 ?
	                        'Enter IC Number' : 'Enter Passport' ))==null?'':_.escape(__t))+
	'"\n                    value="'+
	((__t=( model.get('idStr') ))==null?'':_.escape(__t))+
	'"\n                    data-value-type="string">\n            </div>\n            <span class="error-idStr error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Gender\n        </label>\n        <div class="col-sm-9">\n            <label style="margin-right: 32px;">\n                <input type="radio" value="1" name="gender"\n                    '+
	((__t=( (model.get('gender') === 1) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                    class="js-icheck"\n                    data-value-type="integer">\n                <span>Male</span>\n            </label>\n            <label style="margin-right: 32px;">\n                <input type="radio" value="2" name="gender"\n                    '+
	((__t=( (model.get('gender') === 2) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                    class="js-icheck"\n                    data-value-type="integer">\n                <span>Female</span>\n            </label>\n            <span class="error error-gender"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Date of Birth </label>\n        <div class="col-sm-9">\n            <span class="date js-datepicker\n                '+
	((__t=( (model.get('idType') !== 1) ? 'input-group' : '' ))==null?'':_.escape(__t))+
	'"\n                data-date-format="dd/mm/yyyy">\n                <span class="input-group-addon\n                    '+
	((__t=( (model.get('idType') === 1) ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n                    <span class="glyphicon glyphicon-calendar"></span>\n                </span>\n                <input type="text" class="form-control js-datepicker-input\n                    js-ext"\n                    name="dob"\n                    value="'+
	((__t=( model.getDob() ))==null?'':_.escape(__t))+
	'"\n                    '+
	((__t=( (model.get('idType') === 1) ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n            </span>\n            <span class="error-dob error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Residence Status\n        </label>\n        <div class="col-sm-9">\n            <label style="margin-right: 25px;">\n                <input type="radio" value="1" name="isResident"\n                    '+
	((__t=( (model.get('isResident')) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                       class="js-icheck" data-value-type="boolean">\n                <span>Resident</span>\n            </label>\n            <label style="margin-right: 32px;">\n                <input type="radio" value="0" name="isResident"\n                    '+
	((__t=( (!model.get('isResident')) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                       class="js-icheck" data-value-type="boolean">\n                <span>Non-Resident</span>\n            </label>\n            <span class="error-isResident error"></span>\n        </div>\n    </div>\n\n    <!-- resident subtype -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Worker Status\n        </label>\n        <div class="col-sm-9">\n            <select class="form-control" name="residentSubType"\n                data-value-type="integer">\n                <option value="0"\n                    '+
	((__t=( (model.get('residentSubType') === 0) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Normal\n                </option>\n                <option value="1"\n                    '+
	((__t=( (model.get('residentSubType') === 1) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Iskandar Knowledge Worker\n                </option>\n                <option value="2"\n                    '+
	((__t=( (model.get('residentSubType') === 2) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Returning Expert Program\n                </option>\n                <option value="3"\n                    '+
	((__t=( (model.get('residentSubType') === 3) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Freelancer\n                </option>\n                <option value="4"\n                '+
	((__t=( (model.get('residentSubType') === 4) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Part Time\n                </option>\n            </select>\n            <span class="error error-residentSubType"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Nationality </label>\n        <div class="col-sm-4">\n            <select class="form-control" name="nationality"\n                data-value-type="string">\n                <option value="" disabled\n                    '+
	((__t=( !model.get('nationality') ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Select a nationality\n                </option>\n                ';
	 _.each(countriesList, function(country) { 
	__p+='\n                    <option value="'+
	((__t=( country.code ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (model.get('nationality') === country.code) ?
	                            'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( country.name ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }); 
	__p+='\n            </select>\n            <span class="error error-nationality"></span>\n        </div>\n\n        <label class="col-sm-5">\n            <input type="checkbox" name="isPermanentResident" class="js-icheck"\n                data-value-type="boolean"\n                '+
	((__t=( model.get('isPermanentResident') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                '+
	((__t=( (
	                        model.get('nationality') === 'MY'
	                    ) ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n            <span>Permanent Resident of Malaysia</span>\n        </label>\n        <span class="error error-isPermanentResident"></span>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Marital Status\n        </label>\n        <div class="col-sm-9">\n            <select class="form-control" name="marriedStatus"\n                data-value-type="integer">\n                <option value="1"\n                    '+
	((__t=( (model.get('marriedStatus') === 1) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Single\n                </option>\n                <option value="2"\n                    '+
	((__t=( (model.get('marriedStatus') === 2) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Single with Children\n                </option>\n                <option value="3"\n                    '+
	((__t=( (model.get('marriedStatus') === 3) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Divorced or Widowed\n                </option>\n                <option value="4"\n                    '+
	((__t=( (model.get('marriedStatus') === 4) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Married and spouse is working\n                </option>\n                <option value="5"\n                    '+
	((__t=( (model.get('marriedStatus') === 5) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Married and spouse is NOT working\n                </option>\n            </select>\n            <span class="error error-marriedStatus"></span>\n        </div>\n    </div>\n\n    <div class="form-group\n        '+
	((__t=( model.get('marriedStatus') !== 1 ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'">\n        <label class="col-sm-3 control-label">Dependent Children</label>\n        <div class="col-sm-9">\n            <select class="form-control js-ext-childrenAmount"\n                    name="childrenAmount">\n                ';
	 _.times(13, function(i) { 
	__p+='\n                <option value="'+
	((__t=( i ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( model.getChildrenCount() === i ?
	                                'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( i ))==null?'':_.escape(__t))+
	'\n                </option>\n                ';
	 }) 
	__p+='\n            </select>\n            <span class="error error-children"></span>\n        </div>\n    </div>\n\n    <div class="form-group\n        '+
	((__t=( (
	            model.get('marriedStatus') !== 1 &&
	            model.getChildrenCount()
	    ) ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'">\n        <div class="col-sm-9 col-sm-offset-3 m-b-sm">\n            Provide details about the children\n            and PCB Deduction for Dependent Children\n        </div>\n\n        <div class="js-ext-childType-container">\n            '+
	((__t=( __webpack_require__(789)({model: model}) ))==null?'':__t)+
	'\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Disability Status</label>\n        <div class="col-sm-9">\n            <label style="margin-right: 32px;">\n                <input type="radio" value="0" name="isDisabled"\n                    '+
	((__t=( !model.get('isDisabled') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                    class="js-icheck" data-value-type="boolean">\n                <span>Not Disabled</span>\n            </label>\n            <label>\n                <input type="radio" value="1" name="isDisabled"\n                    '+
	((__t=( model.get('isDisabled') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                    class="js-icheck" data-value-type="boolean">\n                <span>Disabled</span>\n            </label>\n\n\n            <span class="error error-isDisabled"></span>\n        </div>\n    </div>\n\n    <div class="form-group" id="is-spouse-disabled-input">\n        <label class="col-sm-3 control-label">Disability Status (Spouse)</label>\n        <div class="col-sm-9">\n            <label style="margin-right: 32px;">\n                <input type="radio" value="0" name="isSpouseDisabled"\n                    '+
	((__t=( !model.get('isSpouseDisabled') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                    class="js-icheck" data-value-type="boolean">\n                <span>Not Disabled</span>\n            </label>\n            <label>\n                <input type="radio" value="1" name="isSpouseDisabled"\n                    '+
	((__t=( model.get('isSpouseDisabled') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                    class="js-icheck" data-value-type="boolean">\n                <span>Disabled</span>\n            </label>\n\n            <span class="error error-isSpouseDisabled"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Race\n            <!-- Tooltip -->\n        </label>\n        <div class="col-sm-9">\n            <select class="form-control" name="race"\n                data-value-type="integer">\n                <option>\n                    Select your race\n                </option>\n                <option value="1"\n                    '+
	((__t=( (model.get('race') === 1) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Malay\n                </option>\n                <option value="2"\n                    '+
	((__t=( (model.get('race') === 2) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Chinese\n                </option>\n                <option value="3"\n                    '+
	((__t=( (model.get('race') === 3) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Indian\n                </option>\n                <option value="4"\n                    '+
	((__t=( (model.get('race') === 4) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Other\n                </option>\n            </select>\n            <span class="error error-race"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Street Address</label>\n        <div class="col-sm-9">\n            <input name="line1" type="text"\n                class="form-control js-ext js-ext-address"\n                value="'+
	((__t=( model.getAddress() ?
	                    model.getAddress().get('line1') : '' ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error error-line1"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">City</label>\n        <div class="col-sm-9">\n            <input name="city" type="text"\n                class="form-control js-ext js-ext-address"\n                value="'+
	((__t=( model.getAddress() ?
	                    model.getAddress().get('city') : '' ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error error-city"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">State</label>\n        <div class="col-sm-9">\n            <select name="state"\n                class="form-control js-ext js-ext-address"\n                data-value-type="string">\n                <option value=""\n                    '+
	((__t=( (
	                        !model.getAddress() ||
	                        !model.getAddress().get('state')
	                    ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Select a state\n                </option>\n                ';
	 _.each(Address.getStatesList(), function(state) { 
	__p+='\n                    <option value="'+
	((__t=( state.code ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (
	                            model.getAddress() &&
	                            model.getAddress().get('state') ===
	                                state.code
	                            ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( state.name ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }); 
	__p+='\n            </select>\n            <span class="error error-state"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Post Code</label>\n        <div class="col-sm-2">\n            <input name="postcode" type="text"\n                class="form-control js-ext js-ext-address"\n                value="'+
	((__t=( model.getAddress() ?
	                    model.getAddress().get('postcode') : '' ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error error-postcode"></span>\n        </div>\n        <label class="col-sm-3 control-label">Mobile Phone</label>\n        <div class="col-sm-4">\n            <input name="contactPhone" type="text"\n                class="form-control js-ext js-ext-address"\n                value="'+
	((__t=( model.getAddress() ?
	                    model.getAddress().get('contactPhone') : '' ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error error-contactPhone"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Personal Email\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="Allow employee to access their payslips on\n                PayrollPanda even after leaving company">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="personalEmail" class="form-control" type="text"\n                placeholder="Enter Email"\n                value="'+
	((__t=( model.get('personalEmail') ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error-personalEmail error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Emergency Contact Name\n        </label>\n        <div class="col-sm-9">\n            <input name="emergencyContactName" class="form-control" type="text"\n                placeholder="Enter Contact Name"\n                value="'+
	((__t=( model.get('emergencyContactName') ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error error-emergencyContactName"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Emergency Contact Phone\n        </label>\n        <div class="col-sm-9">\n            <input name="emergencyContactPhone" class="form-control" type="text"\n                placeholder="Enter Phone Number"\n                value="'+
	((__t=( model.get('emergencyContactPhone') ))==null?'':_.escape(__t))+
	'"\n                data-value-type="string">\n            <span class="error error-emergencyContactPhone"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Preferred Method of Payment\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body" data-html="true"\n                data-original-title="Select the preferred payment method, note that bank transfer needs to be selected in case you use the batch payment files to make salary payments.">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <select class="form-control" name="preferredPaymentMethod"\n                data-value-type="integer">\n                <option value="0"\n                    '+
	((__t=( (model.get('preferredPaymentMethod') === 0) ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                </option>\n                <option value="1"\n                    '+
	((__t=( (model.get('preferredPaymentMethod') === 1) ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Bank Transfer\n                </option>\n                <option value="2"\n                    '+
	((__t=( (model.get('preferredPaymentMethod') === 2) ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Cash\n                </option>\n                <option value="3"\n                    '+
	((__t=( (model.get('preferredPaymentMethod') === 3) ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Cheque\n                </option>\n            </select>\n            <span class="error error-preferredPaymentMethod"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Bank Details\n        </label>\n        <div class="col-sm-9">\n            ';
	 if (model.getBankAccount()) { 
	__p+='\n                <div>\n                    <p class="form-control-static">\n                        '+
	((__t=( model.getBankAccount().get('bankName') ))==null?'':_.escape(__t))+
	',\n                        '+
	((__t=( model.getBankAccount().get('number') ))==null?'':_.escape(__t))+
	' (\n                            '+
	((__t=( model.getBankAccount().get('holderName') ))==null?'':_.escape(__t))+
	'\n                        )\n                    </p>\n                    <button type="button"\n                        class="js-edit-bank-account btn btn-white">\n                        Edit\n                    </button>\n                </div>\n            ';
	 } else { 
	__p+='\n                <button type="button" class="js-add-bank-account btn btn-white">\n                    Add Bank Account\n                </button>\n            ';
	 } 
	__p+='\n        </div>\n    </div>\n</div>\n\n';
	 if (model.get('hiddenAt')) { 
	__p+='\n    <div class="row">\n        <div class="col-sm-9 m-l-sm m-b-md">\n            <i>\n                This person has been archived. You can restore the person or\n                delete them permanently.\n            </i>\n        </div>\n    </div>\n';
	 } 
	__p+='\n\n<div class="text-right">\n    <button class="js-cancel btn btn-warning btn-w-m"\n        data-toggle="tooltip" data-title="No changes will be saved"\n        data-placement="top" data-delayed>\n        <i class="fa fa-exclamation-triangle"></i>\n        Cancel\n    </button>\n    ';
	 if (!isNew) { 
	__p+='\n        ';
	 if (!model.get('hiddenAt')) { 
	__p+='\n            <button type="button"\n                    class="js-remove btn btn-w-m btn-danger m-l-xs float-left">\n                <i class="fa fa-trash"></i>\n                Archive\n            </button>\n        ';
	 } else { 
	__p+='\n            <button type="button"\n                    class="js-restore btn btn-w-m btn-danger m-l-xs float-left">\n                <i class="fa fa-share-square"></i>\n                Unarchive\n            </button>\n\n            <button type="button"\n                    class="js-remove-permanent btn btn-w-m btn-danger m-l-xs float-left">\n                <i class="fa fa-trash"></i>\n                Remove Permanently\n            </button>\n            ';
	 if (model.get('userId')) { 
	__p+='\n                <button type="button"\n                    class="js-remove-employee-user btn btn-w-m btn-danger m-l-xs float-left">\n                    <i class="fa fa-eraser"></i>\n                    Remove access\n                </button>\n            ';
	 } 
	__p+='\n        ';
	 }
	__p+='\n    ';
	 } 
	__p+='\n    <button class="js-save btn btn-primary m-l-xs" data-style="swap">\n        <i class="fa fa-check"></i>\n        Save changes\n    </button>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/Children.ejs -->\n<div >\n';
	 _.each(model.get('children'), function(child, index){ 
	__p+='\n<div class="js-ext-child">\n    <label class="col-sm-1 col-sm-offset-3 control-label">\n        '+
	((__t=( index + 1 ))==null?'':_.escape(__t))+
	'\n    </label>\n    <div class="col-sm-6">\n        <select class="form-control m-b js-ext" name="childType">\n            <option value=""\n                '+
	((__t=( !child.category ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                None of the Categories Below\n            </option>\n            <option value="underage"\n                '+
	((__t=( (child.category === 'underage') ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Under 18 or In Education\n            </option>\n            <option value="inEducation"\n                '+
	((__t=( (child.category === 'inEducation') ?
	                    'selected' : ''  ))==null?'':_.escape(__t))+
	'>\n                Over 18 - In Education (Diploma level)\n            </option>\n            <option value="inHigherEducation"\n                '+
	((__t=( (child.category === 'inHigherEducation') ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Over 18 - In Education (Degree level or higher)\n            </option>\n            <option value="disabled"\n                '+
	((__t=( (child.category === "disabled") ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Disabled\n            </option>\n            <option value="disabledInEducation"\n                '+
	((__t=( (child.category === "disabledInEducation") ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Disabled - In Higher Education\n            </option>\n        </select>\n    </div>\n    <div class="col-sm-2">\n        <select class="form-control js-ext" name="pcbDeduction"\n                data-value-type="integer">\n            <option value="0" '+
	((__t=( (child.pcbDeduction == 0) ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                0%\n            </option>\n            <option value="50" '+
	((__t=( (child.pcbDeduction == 50) ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                50%\n            </option>\n            <option value="100" '+
	((__t=( (child.pcbDeduction == 100) ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                100%\n            </option>\n        </select>\n        <span class="error error-pcbDeduction"></span>\n    </div>\n</div>\n';
	 }) 
	__p+='\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _escapeStringRegexp = __webpack_require__(791);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _DefaultPayrollDetail = __webpack_require__(792);
	
	var _DefaultPayrollDetail2 = _interopRequireDefault(_DefaultPayrollDetail);
	
	var _position = __webpack_require__(576);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _PayrollItemSelectionModal = __webpack_require__(722);
	
	var _PayrollItemSelectionModal2 = _interopRequireDefault(_PayrollItemSelectionModal);
	
	var _EmploymentDetails = __webpack_require__(794);
	
	var _EmploymentDetails2 = _interopRequireDefault(_EmploymentDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	module.exports = _Form2.default.extend({
	    availablePayrollItems: null,
	    payrollItemsModal: null,
	    payrollDetailViews: null,
	
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events(), {
	            'typeahead:change .js-ext-position': 'updatePosition',
	            'typeahead:select .js-ext-position': 'updatePosition',
	            'keyup .js-ext-position': 'updatePosition',
	            'change .js-ext-companyLocation': 'updateCompanyLocation',
	            'click .js-add-payroll-items': 'showPayrollItemsModal',
	            'change .js-ext-days': 'updateDays',
	            'change .js-ext-managers': 'selectManagers',
	            'change .js-ext-managers-l2': 'selectManagersL2',
	            'change .js-ext-managers-l3': 'selectManagersL3',
	            'change .js-ext-carryForward': 'updateCarryForward',
	            'click .js-add-second-layer': 'showSecondApprovalLayer',
	            'click .js-add-third-layer': 'showThirdApprovalLayer'
	        });
	    },
	
	    initialize: function initialize(options) {
	        //Ideally we should add attribute in Item model to be filtered by gender
	        var byGender = function byGender(employee) {
	            return function (type) {
	                return !type.get('gender') || type.get('gender') === employee.get('gender');
	            };
	        };
	
	        this.options = Object.assign({
	            payrollDetails: null,
	            positions: null,
	            approverEmployees: null,
	            leaveApprovals: null,
	            locations: null,
	            payrollItems: null,
	            unsubmittedPayroll: null,
	            leaveTypes: null,
	            carryForwardDays: { original: {} },
	            isNew: false,
	            template: _EmploymentDetails2.default
	        }, options || {});
	
	        this.selectedManagers = this.options.leaveApprovals.filter(function (a) {
	            return a.get('layer') === 1;
	        }).map(function (a) {
	            return a.get('approverId');
	        });
	        this.selectedManagersL2 = this.options.leaveApprovals.filter(function (a) {
	            return a.get('layer') === 2;
	        }).map(function (a) {
	            return a.get('approverId');
	        });
	        this.selectedManagersL3 = this.options.leaveApprovals.filter(function (a) {
	            return a.get('layer') === 3;
	        }).map(function (a) {
	            return a.get('approverId');
	        });
	        this.options.templateExtra = {
	            canCarryForwardDays: app.company && app.company.get('allowLeaveCarryForward'),
	            locations: this.options.locations,
	            approverEmployees: this.options.approverEmployees,
	            selectedManagers: this.selectedManagers,
	            selectedManagersL2: this.selectedManagersL2,
	            selectedManagersL3: this.selectedManagersL3,
	            leaveTypes: this.options.leaveTypes.filter(byGender(this.model)),
	            carryForwardDays: this.options.carryForwardDays,
	            isNew: this.options.isNew,
	            forceAllowJoinDateEdit: app.user.isAdmin()
	        };
	
	        this.availablePayrollItems = this.options.payrollItems.clone();
	        this.payrollItemsModal = new _PayrollItemSelectionModal2.default({
	            title: 'Add Monthly Payroll Item',
	            text: '<strong>IMPORTANT</strong> Only add payroll items ' + 'that are paid monthly as this will affect calculations!<br>',
	            collection: this.availablePayrollItems
	        });
	        this.updateAvailablePayrollItems();
	
	        this.payrollDetailViews = [];
	
	        this.constraints = {
	            commencementDate: {
	                presence: { message: '^Join Date cannot be blank' }
	            },
	            positionId: { presence: { message: '^Position cannot be blank' } },
	
	            /* NOTE that there already exists a constraint on earningsFrequency
	             * on the constraints object. This one doesn't override the other,
	             * both constraints are run.
	             * */
	            earningsFrequency: { presence: true },
	            earningsAmount: {
	                presence: { message: '^Earnings cannot be blank' },
	                numericality: {
	                    greaterThanOrEqualTo: 0,
	                    message: '^Earnings must be a positive number'
	                }
	            }
	        };
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = _Form2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.options.payrollDetails.on('add remove sync', this.updateAvailablePayrollItems, this);
	        this.options.payrollDetails.on('add remove sync', this.renderPayrollDetails, this);
	
	        this.payrollItemsModal.on('select', this.addPayrollDetails, this);
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = _Form2.default.prototype.unbindHandlers.apply(this, arguments);
	
	        this.options.payrollDetails.off(null, null, this);
	        this.payrollItemsModal.off(null, null, this);
	
	        return r;
	    },
	
	    render: function render() {
	        var r;
	
	        this.options.templateExtra.leaveTakenPeriod = this.getLeaveTakenPeriod();
	        this.options.templateExtra.selectedManagers = this.selectedManagers;
	        this.options.templateExtra.selectedManagersL2 = this.selectedManagersL2;
	        this.options.templateExtra.selectedManagersL3 = this.selectedManagersL3;
	
	        r = _Form2.default.prototype.render.apply(this, arguments);
	
	        this.initManagerSelectors();
	        if (this.selectedManagersL2.length > 0) {
	            this.showSecondApprovalLayer();
	        }
	        if (this.selectedManagersL3.length > 0) {
	            this.showThirdApprovalLayer();
	        }
	        this.initPositionInput();
	        this.renderPayrollDetails();
	
	        this.model.setAdditionalConstraints(null);
	        this.markMandatoryFields(this.constraints);
	
	        return r;
	    },
	
	    getLeaveTakenPeriod: function getLeaveTakenPeriod() {
	        var renewalPolicy = app.company.get('leaveRenewalPolicy') || 'year';
	        var dateFormat = 'MMM DD, YYYY';
	        if (renewalPolicy === 'joinDate') {
	            var joinDate = (0, _moment2.default)(this.model.get('commencementDate') || Date.now());
	            if (joinDate.day() === 1 && joinDate.month() === 0) {
	                dateFormat = 'MMM DD, YYYY';
	            } else {
	                dateFormat = 'MMM YYYY';
	            }
	            joinDate.year((0, _moment2.default)().year());
	            if (joinDate.isAfter((0, _moment2.default)())) {
	                joinDate.year((0, _moment2.default)().year() - 1);
	            }
	            return {
	                start: joinDate.format(dateFormat),
	                end: joinDate.add(1, 'year').format(dateFormat)
	            };
	        }
	        return {
	            start: (0, _moment2.default)().startOf('year').format(dateFormat),
	            end: (0, _moment2.default)().endOf('year').format(dateFormat)
	        };
	    },
	
	    initPositionInput: function initPositionInput() {
	        this.$('.js-ext-position').typeahead({
	            hint: true,
	            highlight: true,
	            minLength: 0
	        }, {
	            name: 'positions',
	            display: function display(position) {
	                return position.get('name');
	            },
	            source: function (q, callback) {
	                var matches = [];
	                var regex = new RegExp((0, _escapeStringRegexp2.default)(q), 'i');
	
	                this.options.positions.each(function (position) {
	                    if (regex.test(position.get('name'))) {
	                        matches.push(position);
	                    }
	                });
	
	                callback(matches);
	            }.bind(this)
	        });
	    },
	
	    renderPayrollDetails: function renderPayrollDetails() {
	        var sortByName = function sortByName(detail) {
	            return detail.getPayrollItem().get('name');
	        };
	        var $el = this.$('.js-payroll-details-list').html('');
	        var renderableDetails = _.sortBy(this.options.payrollDetails.filter(function (model) {
	            return model.getPayrollItem().isSelectableAsDefault();
	        }), sortByName);
	
	        var isEmptyList = renderableDetails.length === 0;
	
	        this.payrollDetailViews.forEach(function (view) {
	            view.remove();
	        });
	        this.payrollDetailViews = [];
	
	        renderableDetails.forEach(function (model) {
	            var view = new _DefaultPayrollDetail2.default({ model: model });
	            $el.append(view.$el).removeClass('hidden');
	            this.payrollDetailViews.push(view);
	        }.bind(this));
	
	        this.$('.js-payroll-details-list').toggleClass('hidden', isEmptyList);
	        this.$('.js-payroll-details-empty').toggleClass('hidden', !isEmptyList);
	    },
	
	    updatePosition: function updatePosition(ev) {
	        var q = this.$(ev.currentTarget).val();
	
	        /* Ensure an empty string is not entered */
	        if (!q) {
	            this.model.setPosition(null);
	            return;
	        }
	        var regex = new RegExp('^' + (0, _escapeStringRegexp2.default)(q) + '$', 'i');
	        var position = this.options.positions.find(function (position) {
	            return regex.test(position.get('name') || '');
	        });
	
	        if (!position) {
	            position = new _position2.default({
	                companyId: this.model.get('companyId'),
	                name: q
	            });
	        }
	        this.model.setPosition(position);
	    },
	
	    updateCompanyLocation: function updateCompanyLocation(ev) {
	        var $el = this.$(ev.currentTarget);
	        var companyLocation = this.options.locations.get($el.val());
	
	        this.model.set('companyLocationId', companyLocation.id);
	    },
	
	    initManagerSelectors: function initManagerSelectors() {
	        var _this = this;
	
	        this.selectedManagers.forEach(function (id) {
	            if (_this.$('.js-ext-managers-l2 option[value=\'' + id + '\']')) {
	                _this.$('.js-ext-managers-l2 option[value=\'' + id + '\']').hide();
	            }
	            if (_this.$('.js-ext-managers-l3 option[value=\'' + id + '\']')) {
	                _this.$('.js-ext-managers-l3 option[value=\'' + id + '\']').hide();
	            }
	        });
	        this.selectedManagersL2.forEach(function (id) {
	            if (_this.$('.js-ext-managers option[value=\'' + id + '\']')) {
	                _this.$('.js-ext-managers option[value=\'' + id + '\']').hide();
	            }
	            if (_this.$('.js-ext-managers-l3 option[value=\'' + id + '\']')) {
	                _this.$('.js-ext-managers-l3 option[value=\'' + id + '\']').hide();
	            }
	        });
	        this.selectedManagersL3.forEach(function (id) {
	            if (_this.$('.js-ext-managers option[value=\'' + id + '\']')) {
	                _this.$('.js-ext-managers option[value=\'' + id + '\']').hide();
	            }
	            if (_this.$('.js-ext-managers-l2 option[value=\'' + id + '\']')) {
	                _this.$('.js-ext-managers-l2 option[value=\'' + id + '\']').hide();
	            }
	        });
	        this.$('.js-ext-managers').trigger('chosen:updated');
	        this.$('.js-ext-managers-l2').trigger('chosen:updated');
	        this.$('.js-ext-managers-l3').trigger('chosen:updated');
	    },
	
	    selectManagers: function selectManagers(ev) {
	        var _this2 = this;
	
	        var $select = this.$(ev.currentTarget);
	        var selected = $select.val();
	        if (selected.length > 0) {
	            if (this.$('.js-second-layer').prop('style').display === 'none') {
	                this.$('.js-add-second-layer').show();
	            } else {
	                this.$('.js-ext-managers-l2').prop('disabled', false).trigger('chosen:updated');
	            }
	        } else {
	            if (this.$('.js-second-layer').prop('style').display === 'none') {
	                this.$('.js-add-second-layer').hide();
	            } else {
	                this.$('.js-ext-managers-l2').prop('disabled', true).trigger('chosen:updated');
	            }
	        }
	
	        var toRemove = this.selectedManagers.find(function (m) {
	            return selected.indexOf(m) < 0;
	        });
	        if (toRemove) {
	            var removeModel = this.options.leaveApprovals.models.find(function (a) {
	                return toRemove === a.get('approverId');
	            });
	            this.options.leaveApprovals.remove(removeModel);
	            if (this.$('.js-ext-managers-l2 option[value=\'' + toRemove + '\']')) {
	                this.$('.js-ext-managers-l2 option[value=\'' + toRemove + '\']').show();
	                this.$('.js-ext-managers-l2').trigger('chosen:updated');
	            }
	            if (this.$('.js-ext-managers-l3 option[value=\'' + toRemove + '\']')) {
	                this.$('.js-ext-managers-l3 option[value=\'' + toRemove + '\']').show();
	                this.$('.js-ext-managers-l3').trigger('chosen:updated');
	            }
	        } else {
	            var toAdd = selected.find(function (m) {
	                return _this2.selectedManagers.indexOf(m) < 0;
	            });
	            this.options.leaveApprovals.add({
	                requesterId: this.model.id,
	                approverId: toAdd,
	                layer: 1
	            }, { validate: false });
	            if (this.$('.js-ext-managers-l2 option[value=\'' + toAdd + '\']')) {
	                this.$('.js-ext-managers-l2 option[value=\'' + toAdd + '\']').hide();
	                this.$('.js-ext-managers-l2').trigger('chosen:updated');
	            }
	            if (this.$('.js-ext-managers-l3 option[value=\'' + toAdd + '\']')) {
	                this.$('.js-ext-managers-l3 option[value=\'' + toAdd + '\']').hide();
	                this.$('.js-ext-managers-l3').trigger('chosen:updated');
	            }
	        }
	        this.selectedManagers = selected;
	    },
	
	    showSecondApprovalLayer: function showSecondApprovalLayer() {
	        this.$('.js-second-layer').show();
	        this.$('.js-add-second-layer').hide();
	    },
	
	    selectManagersL2: function selectManagersL2(ev) {
	        var _this3 = this;
	
	        var $select = this.$(ev.currentTarget);
	        var selected = $select.val();
	        if (selected.length > 0) {
	            if (this.$('.js-third-layer').prop('style').display === 'none') {
	                this.$('.js-add-third-layer').show();
	            } else {
	                this.$('.js-ext-managers-l3').prop('disabled', false).trigger('chosen:updated');
	            }
	        } else {
	            if (this.$('.js-third-layer').prop('style').display === 'none') {
	                this.$('.js-add-third-layer').hide();
	            } else {
	                this.$('.js-ext-managers-l3').prop('disabled', true).trigger('chosen:updated');
	            }
	        }
	
	        var toRemove = this.selectedManagersL2.find(function (m) {
	            return selected.indexOf(m) < 0;
	        });
	        if (toRemove) {
	            var removeModel = this.options.leaveApprovals.models.find(function (a) {
	                return toRemove === a.get('approverId');
	            });
	            this.options.leaveApprovals.remove(removeModel);
	            if (this.$('.js-ext-managers-l3 option[value=\'' + toRemove + '\']')) {
	                this.$('.js-ext-managers-l3 option[value=\'' + toRemove + '\']').show();
	                this.$('.js-ext-managers-l3').trigger('chosen:updated');
	            }
	            if (this.$('.js-ext-managers option[value=\'' + toRemove + '\']')) {
	                this.$('.js-ext-managers option[value=\'' + toRemove + '\']').show();
	                this.$('.js-ext-managers').trigger('chosen:updated');
	            }
	        } else {
	            var toAdd = selected.find(function (m) {
	                return _this3.selectedManagersL2.indexOf(m) < 0;
	            });
	            this.options.leaveApprovals.add({
	                requesterId: this.model.id,
	                approverId: toAdd,
	                layer: 2
	            }, { validate: false });
	            if (this.$('.js-ext-managers option[value=\'' + toAdd + '\']')) {
	                this.$('.js-ext-managers option[value=\'' + toAdd + '\']').hide();
	                this.$('.js-ext-managers').trigger('chosen:updated');
	            }
	            if (this.$('.js-ext-managers-l3 option[value=\'' + toAdd + '\']')) {
	                this.$('.js-ext-managers-l3 option[value=\'' + toAdd + '\']').hide();
	                this.$('.js-ext-managers-l3').trigger('chosen:updated');
	            }
	        }
	        this.selectedManagersL2 = selected;
	    },
	
	    showThirdApprovalLayer: function showThirdApprovalLayer() {
	        this.$('.js-third-layer').show();
	        this.$('.js-add-third-layer').hide();
	    },
	
	    selectManagersL3: function selectManagersL3(ev) {
	        var _this4 = this;
	
	        var $select = this.$(ev.currentTarget);
	        var selected = $select.val();
	
	        var toRemove = this.selectedManagersL3.find(function (m) {
	            return selected.indexOf(m) < 0;
	        });
	        if (toRemove) {
	            var removeModel = this.options.leaveApprovals.models.find(function (a) {
	                return toRemove === a.get('approverId');
	            });
	            this.options.leaveApprovals.remove(removeModel);
	            if (this.$('.js-ext-managers option[value=\'' + toRemove + '\']')) {
	                this.$('.js-ext-managers option[value=\'' + toRemove + '\']').show();
	                this.$('.js-ext-managers').trigger('chosen:updated');
	            }
	            if (this.$('.js-ext-managers-l2 option[value=\'' + toRemove + '\']')) {
	                this.$('.js-ext-managers-l2 option[value=\'' + toRemove + '\']').show();
	                this.$('.js-ext-managers-l2').trigger('chosen:updated');
	            }
	        } else {
	            var toAdd = selected.find(function (m) {
	                return _this4.selectedManagersL3.indexOf(m) < 0;
	            });
	            this.options.leaveApprovals.add({
	                requesterId: this.model.id,
	                approverId: toAdd,
	                layer: 3
	            }, { validate: false });
	            if (this.$('.js-ext-managers option[value=\'' + toAdd + '\']')) {
	                this.$('.js-ext-managers option[value=\'' + toAdd + '\']').hide();
	                this.$('.js-ext-managers').trigger('chosen:updated');
	            }
	            if (this.$('.js-ext-managers-l2 option[value=\'' + toAdd + '\']')) {
	                this.$('.js-ext-managers-l2 option[value=\'' + toAdd + '\']').hide();
	                this.$('.js-ext-managers-l2').trigger('chosen:updated');
	            }
	        }
	        this.selectedManagersL3 = selected;
	    },
	
	    validateApprovals: function validateApprovals() {
	        var noDuplicatesList = [].concat(_toConsumableArray(new Set(this.options.leaveApprovals.models)));
	        if (this.options.leaveApprovals.length > noDuplicatesList) {
	            throw new Error('Note: The same manager cannot be assigned twice.');
	        }
	        var layer1 = this.options.leaveApprovals.filter(function (approval) {
	            return approval.get('layer') === 1;
	        });
	        var layer2 = this.options.leaveApprovals.filter(function (approval) {
	            return approval.get('layer') === 2;
	        });
	        var layer3 = this.options.leaveApprovals.filter(function (approval) {
	            return approval.get('layer') === 3;
	        });
	        if (layer3.length > 0 && (layer2.length === 0 || layer1.length === 0) || layer2.length > 0 && layer1.length === 0) {
	            throw new Error('Note: A lower approval layer cannot be empty when a ' + 'higher layer is already populated.');
	        }
	    },
	
	    showPayrollItemsModal: function showPayrollItemsModal(e) {
	        e.preventDefault();
	        this.payrollItemsModal.show();
	    },
	
	    updateAvailablePayrollItems: function updateAvailablePayrollItems() {
	        var _this5 = this;
	
	        this.availablePayrollItems.reset(this.options.payrollItems.clone().filter(function (model) {
	            return !_this5.options.payrollDetails.find(function (detail) {
	                var payrollItem = detail.getPayrollItem();
	                return payrollItem && payrollItem.id === model.id;
	            });
	        }));
	    },
	
	    addPayrollDetails: function addPayrollDetails(payrollItems, additionalInfo) {
	        var _this6 = this;
	
	        payrollItems.forEach(function (payrollItem) {
	            var info = _.isObject(additionalInfo) ? additionalInfo[payrollItem.id] || null : null;
	
	            _this6.options.payrollDetails.add({
	                employeeId: _this6.model.id,
	                payrollItemId: payrollItem.id,
	                companyId: app.company.id,
	                rate: payrollItem.get('isUnit') ? 1 : null,
	                unit: payrollItem.get('isUnit') ? 0 : null,
	                additionalInformation: info,
	                isAffectOvertime: payrollItem.get('defaultIsAffectOvertime') || false
	            });
	        });
	    },
	
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        var resolver = (0, _bluebird.defer)();
	
	        if (!_.isObject(this.options.unsubmittedPayroll)) {
	            return (0, _bluebird.resolve)(true);
	        }
	
	        _alerts2.default.show('infoConfirm', {
	            title: 'Your saved payroll will be modified!',
	            text: 'You have an unsubmitted payroll saved. ' + 'If you continue, the payroll details of this employee will ' + 'be updated based on the modifications you are about to ' + 'save. Also, any unsaved payroll details will be lost.',
	            confirmButtonText: 'Yes, Save Employment Details',
	            callback: function callback(confirm) {
	                if (confirm) {
	                    resolver.resolve(true);
	                } else {
	                    resolver.reject();
	                }
	            }
	        });
	
	        return resolver.promise;
	    },
	
	    dirty: function dirty() {
	        return this.model.dirty() || this.options.payrollDetails.dirty() || this.options.leaveApprovals.dirty() || this.model.getPosition() && this.model.getPosition().dirty() || this.model.getCompanyLocation() && this.model.getCompanyLocation().dirty();
	    },
	
	    save: function save(ev) {
	        var _this7 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = function stopLoader() {};
	
	        return this.resetPayrollConfirm().then(function () {
	            _this7.model.setAdditionalConstraints(_this7.constraints);
	            stopLoader = _loader2.default.startFullScreen($button);
	            _this7.validateApprovals();
	
	            return _this7.model.save().catch(function (err) {
	                if (_this7.model.wasValid()) {
	                    // the error is not a validation error
	                    throw err;
	                }
	                throw new Error('validationError');
	            });
	        }).then(function () {
	            return (0, _bluebird.all)([_this7.options.payrollDetails.save(), _this7.options.leaveApprovals.save(), _this7.options.leaveTypes.fetchBalances(_this7.model, // employee
	            (0, _moment2.default)().tz('Asia/Kuala_Lumpur').endOf('day').toDate())]);
	        }).then(function () {
	            return _this7.options.unsubmittedPayroll ? _this7.options.unsubmittedPayroll.resetEmployee({ employee: _this7.model }) : (0, _bluebird.resolve)();
	        }).then(function () {
	            if (!_this7.options.isNew) {
	                _this7.render();
	                _modal2.default.showAlertSuccess('Employment details have been saved');
	                return (0, _bluebird.resolve)(true);
	            }
	
	            if (app.company.get('employeeCount') === 1 && _this7.options.isNew) {
	                _alerts2.default.show('success', {
	                    text: 'Employment details have been saved, proceed ' + 'to statutory requirements.',
	                    callback: function callback() {
	                        return app.mainRouter.navigate('employee/' + _this7.model.id + '/statutoryRequirements/isNew', { trigger: true, replace: true });
	                    }
	                });
	            } else if (_this7.options.isNew) {
	                app.mainRouter.navigate('employee/' + _this7.model.id + '/statutoryRequirements/isNew', { trigger: true, replace: true });
	            }
	        }).catch(function (err) {
	            if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object' && err.message && err.message.startsWith('Note:')) {
	                _alerts2.default.show('error', {
	                    title: 'Incorrect approval setup.',
	                    text: err.message
	                });
	            } else if (/Payroll Item already exist for payroll/.test(err.message)) {
	                _alerts2.default.show('warning', {
	                    text: 'You can\'t submit same employee details more than once at the same time.',
	                    customClass: 'sweet-alert-error'
	                });
	            } else if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object' && err.message !== 'validationError') {
	                _alerts2.default.show('criticalError', err);
	            }
	        }).finally(function () {
	            _this7.model.setAdditionalConstraints(null);
	            stopLoader();
	        });
	    },
	
	    fetch: function fetch() {
	        var _this8 = this;
	
	        /* Fetch carry forward days before model is updated as that will
	           trigger a screen refresh */
	        return _leaveTypes2.default.fetchCarryForwardDays(this.model).then(function (carryForwardDays) {
	            _this8.options.carryForwardDays = carryForwardDays;
	            _this8.options.templateExtra.carryForwardDays = carryForwardDays;
	            return (0, _bluebird.all)([_this8.model.fetch(), _this8.options.payrollDetails.fetch()]);
	        });
	    },
	
	    updateDays: function updateDays($ev) {
	        var typeId = this.$($ev.currentTarget).data('type-id');
	        var days = this.getInputValue(this.$($ev.currentTarget));
	        this.model.setDaysEntitled({
	            typeId: typeId,
	            days: days
	        });
	    },
	
	    updateCarryForward: function updateCarryForward($ev) {
	        var typeId = this.$($ev.currentTarget).data('type-id');
	        var days = this.getInputValue(this.$($ev.currentTarget));
	        if (days < 0) {
	            this.$($ev.currentTarget).val(0);
	            return;
	        }
	        this.model.setDaysCarryForward({
	            typeId: typeId,
	            days: days
	        });
	        this.options.carryForwardDays[typeId] = days;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(793);
	
	var RowEditView = __webpack_require__(690);
	
	module.exports = RowEditView.extend({
	    tagName: 'tr',
	    className: 'tr-md payroll-detail',
	
	    events: function events() {
	        var parentEvents = _.isFunction(RowEditView.prototype.events) ? RowEditView.prototype.events() : RowEditView.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'focus input': 'onFocus'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.extend(options || {}, {
	            template: template,
	            deletable: true
	        });
	
	        return RowEditView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = RowEditView.prototype.bindHandlers.apply(this, arguments);
	
	        this.model.on('change:rate change:unit', this.renderAmount, this);
	        this.model.on('change:additionalInformation', this.render, this);
	
	        if (this.model.isZakat()) {
	            this.model.on('change:rate change:amount', this.toggleZakatMode, this);
	        }
	
	        return r;
	    },
	
	    onFocus: function onFocus(ev) {
	        this.$(ev.currentTarget).select();
	        return this;
	    },
	
	    renderAmount: function renderAmount() {
	        this.$('input[name=amount]').val((this.model.get('amount') || 0).formatWithoutRounding());
	        return this;
	    },
	
	    renderRate: function renderRate() {
	        this.$('input[name=rate]').val((this.model.get('rate') || 0).formatWithoutRounding());
	        return this;
	    },
	
	    toggleZakatMode: function toggleZakatMode(model, value, options) {
	        var changes = options.changes || {};
	        if (value === 0) {
	            return;
	        }
	
	        if (changes.amount) {
	            this.model.set({ rate: null }, { silent: true });
	        } else if (changes.rate) {
	            this.model.set({ amount: null }, { silent: true });
	        }
	        this.renderAmount();
	        this.renderRate();
	    },
	
	    destroyModel: function destroyModel(ev) {
	        ev.preventDefault();
	
	        this.model.collection.remove(this.model);
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/DefaultPayrollDetail.ejs -->\n<td class="title td-nowrap">\n    <strong>\n        '+
	((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n        <small>\n            ';
	 if (
	                model.getPayrollItemType() !== 'unpaid_leave' &&
	                model.getPayrollItemType() !== 'overtime' &&
	                model.get('additionalInformation')
	            ) { 
	__p+='\n                ';
	 info = model.get('additionalInformation'); 
	__p+='\n                (\n                    ';
	 last = _.last(_.keys(info)); 
	__p+='\n                    ';
	 _.each(_.keys(info), function(attr, i) { 
	__p+='\n                        '+
	((__t=( info[attr] + (attr !== last ? ', ' : '') ))==null?'':_.escape(__t))+
	'\n                    ';
	 }); 
	__p+='\n                )\n            ';
	 } 
	__p+='\n            ';
	 if (
	                model.isOvertime() &&
	                model.get('additionalInformation')
	            ) { 
	__p+='\n                ';
	 info = model.get('additionalInformation'); 
	__p+='\n                (\n                    Hourly wage: '+
	((__t=( info.hourlyWage ))==null?'':_.escape(__t))+
	',\n                    Rate: '+
	((__t=( info.overtimeFactor ))==null?'':_.escape(__t))+
	'x\n                )\n            ';
	 } 
	__p+='\n        </small>\n    </strong>\n    <a href="" class="js-destroy" tabindex="-1">\n        <i class="fa fa-times"></i>\n    </a>\n    <span class="error error-rate error-unit error-amount"></span>\n    <span class="error error-rate error-unit error-amount\n        error-placeholder"></span>\n</td>\n\n';
	 if (model.isUnit()) { 
	__p+='\n    <td class="form-group">\n        <span>'+
	((__t=( model.isOvertime() ? 'Rate' : 'RM' ))==null?'':_.escape(__t))+
	':</span>\n        <input name="rate" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
	((__t=( (model.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n            data-value-type="float"\n            '+
	((__t=( model.isOvertime() ? 'readonly' : '' ))==null?'':_.escape(__t))+
	'\n            >\n    </td>\n    <td class="form-group">\n        <span>'+
	((__t=( model.isOvertime() ? 'Hours' : 'Units' ))==null?'':_.escape(__t))+
	':</span>\n        <input name="unit" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
	((__t=( (model.get('unit') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n            data-value-type="float">\n    </td>\n';
	 } else { 
	__p+='\n    <td></td>\n    <td></td>\n';
	 } 
	__p+='\n\n<td class="form-group">\n    <input name="amount"\n        class="form-control text-right form-control-invisible"\n        type="text" autocomplete="off"\n        '+
	((__t=( (model.isUnit()) ? 'readonly' : '' ))==null?'':_.escape(__t))+
	'\n        value="'+
	((__t=( (model.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n        data-value-type="float">\n</td>\n\n';
	 if (model.isAllowUnpaidLeave()) { 
	__p+='\n    <td class="form-group text-center">\n        <input name="isUnpaidLeave" class="form-control js-icheck"\n            type="checkbox" autocomplete="off"\n            data-value-type="boolean"\n            '+
	((__t=( (model.get('isUnpaidLeave') || false) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n    </td>\n';
	 } else { 
	__p+='\n    <td></td>\n';
	 } 
	__p+='\n\n';
	 if (model.isAllowAffectOvertime()) { 
	__p+='\n    <td class="form-group text-center">\n        <input name="isAffectOvertime" class="form-control js-icheck"\n               type="checkbox" autocomplete="off"\n               data-value-type="boolean"\n               '+
	((__t=( (model.get('isAffectOvertime') || false) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n    </td>\n';
	 } else { 
	__p+='\n    <td></td>\n';
	 } 
	__p+='\n\n<td class="form-group text-center">\n    <input name="isProratable" class="form-control js-icheck"\n           type="checkbox" autocomplete="off"\n           data-value-type="boolean"\n           '+
	((__t=( (model.get('isProratable') || false) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/EmploymentDetails.ejs -->\n<div class="form-horizontal">\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Join Date\n            <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" data-container="body" data-html="true" title=""\n                data-original-title="The date when employee joined the company, i.e. first working day."\n            ></i>\n        </label>\n        <div class="col-sm-9">\n            ';
	 if (!model.get('hasPayslips') || forceAllowJoinDateEdit) { 
	__p+='\n                <div class="input-group date js-datepicker"\n                    data-date-format="dd/mm/yyyy">\n                    <span class="input-group-addon">\n                        <span class="glyphicon glyphicon-calendar"></span>\n                    </span>\n                    <input type="text" class="form-control js-ext\n                        js-datepicker-input"\n                        name="commencementDate"\n                        value="'+
	((__t=( model.getFormattedDate(
	                            'commencementDate', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'">\n                </div>\n            ';
	 } else { 
	__p+='\n                <div class="input-group">\n                    <input type="text" class="form-control readonly"\n                        name="commencementDate"\n                        value="'+
	((__t=( model.getFormattedDate(
	                            'commencementDate', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'"\n                        readonly>\n                </div>\n            ';
	 } 
	__p+='\n            <span class="error-commencementDate error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Employee ID</label>\n        <div class="col-sm-9">\n            <input name="employeeId" class="form-control"\n                type="text" placeholder="Employee ID"\n                value="'+
	((__t=( model.get('employeeId') ))==null?'':_.escape(__t))+
	'">\n            <span class="error-employeeId error"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Position\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="Employee\'s job title as per employment\n                contract">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="positionId" class="js-ext js-ext-position form-control"\n                type="text" placeholder="Enter the Employee\'s Position"\n                value="'+
	((__t=( model.getPositionName() ))==null?'':_.escape(__t))+
	'"\n                data-id="'+
	((__t=( model.get('positionId') ))==null?'':_.escape(__t))+
	'">\n            <span class="error-positionId error"></span>\n        </div>\n    </div>\n\n     <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Salary/Wages Frequency\n        </label>\n        <div class="col-sm-9">\n            <select class="form-control" name="earningsFrequency"\n                data-value-type="integer">\n                <option value="1"\n                    '+
	((__t=( model.get('earningsFrequency') === 1 ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Hourly\n                </option>\n                <option value="2"\n                    '+
	((__t=( model.get('earningsFrequency') === 2 ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Daily\n                </option>\n                <option value="3"\n                    '+
	((__t=( model.get('earningsFrequency') === 3 ?
	                        'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Monthly\n                </option>\n            </select>\n            <span class="error error-earningsFrequency"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Salary/Wages Amount\n        </label>\n        <div class="col-sm-9">\n            <input class="form-control" name="earningsAmount" type="text"\n                placeholder=\n                "Enter the employee\'s basic monthly salary or wages amount"\n                value="'+
	((__t=( model.get('earningsAmount') ))==null?'':_.escape(__t))+
	'"\n                data-value-type="float">\n            <span class="error error-earningsAmount"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Managers for Leave Approval\n            <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" data-container="body" data-html="true" title=""\n                data-original-title=\'Add a manager to approve and reject leave requests.\'\n            ></i>\n        </label>\n        <div class="col-sm-7">\n            <select class="form-control js-ext js-ext-managers js-chosen"\n                    name="managers" multiple data-placeholder="No manager">\n                ';
	 approverEmployees.each(function (emp) {
	                    if (emp.id !== model.id) { 
	__p+='\n                    <option value="'+
	((__t=( emp.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (selectedManagers.indexOf(emp.id) > -1) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( emp.get('fullName') ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }}) 
	__p+='\n            </select>\n            <span class="error error-managers"></span>\n        </div>\n        <div class="col-sm-2">\n            <button class="btn btn-outline\n                btn-primary\n                js-add-second-layer"\n                data-loading-text="Adding..."\n                data-complete-text="+ Add 2nd Layer"\n                '+
	((__t=( (selectedManagers.length === 0) ? 'style=display:none' : '' ))==null?'':_.escape(__t))+
	'>\n                + Add 2nd Layer\n            </button>\n        </div>\n    </div>\n\n    <div class="form-group js-second-layer" style="display: none">\n        <label class="col-sm-3 control-label">\n        </label>\n        <div class="col-sm-7">\n            <select class="form-control js-ext js-ext-managers-l2 js-chosen"\n                    name="managersL2" multiple data-placeholder="No manager">\n                ';
	 approverEmployees.each(function (emp) {
	                    if (emp.id !== model.id) { 
	__p+='\n                    <option value="'+
	((__t=( emp.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (selectedManagersL2.indexOf(emp.id) > -1) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( emp.get('fullName') ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }}) 
	__p+='\n            </select>\n            <span class="error error-managers-l2"></span>\n        </div>\n        <div class="col-sm-2">\n            <button class="btn btn-outline\n                btn-primary\n                js-add-third-layer"\n                data-loading-text="Adding..."\n                data-complete-text="+ Add 3rd Layer"\n                '+
	((__t=( (selectedManagersL2.length === 0) ? 'style=display:none' : '' ))==null?'':_.escape(__t))+
	'>\n                + Add 3rd Layer\n            </button>\n        </div>\n    </div>\n\n    <div class="form-group js-third-layer" style="display: none">\n        <label class="col-sm-3 control-label">\n        </label>\n        <div class="col-sm-7">\n            <select class="form-control js-ext js-ext-managers-l3 js-chosen"\n                    name="managersL3" multiple data-placeholder="No manager">\n                ';
	 approverEmployees.each(function (emp) {
	                    if (emp.id !== model.id) { 
	__p+='\n                    <option value="'+
	((__t=( emp.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (selectedManagersL3.indexOf(emp.id) > -1) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( emp.get('fullName') ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }}) 
	__p+='\n            </select>\n            <span class="error error-managers-l3"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Location\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body" data-html="true"\n                data-title=\'Adding a location allows you to to set different working days and holidays for that location.\'>\n            </i>\n        </label>\n        <div class="col-sm-9">\n            ';
	 if (locations.length <= 1) { 
	__p+='\n                ';
	 loc = locations.at(0);  
	__p+='\n                <input type="hidden" class="js-ext js-ext-companyLocation"\n                    value="'+
	((__t=( loc ? loc.id || '' : '' ))==null?'':_.escape(__t))+
	'">\n                <input type="text" class="form-control disabled" disabled\n                    value="'+
	((__t=( loc ? loc.get('name') || '' : '' ))==null?'':_.escape(__t))+
	'">\n            ';
	 } else { 
	__p+='\n                <select class="form-control js-ext js-ext-companyLocation"\n                    name="companyLocationId">\n                    <option value="" disabled\n                        '+
	((__t=( !model.get('companyLocationId') ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        Please select a location\n                    </option>\n                    ';
	 locations.each(function(loc) { 
	__p+='\n                        <option value="'+
	((__t=( loc.id ))==null?'':_.escape(__t))+
	'"\n                            '+
	((__t=( (model.get('companyLocationId') === loc.id) ?
	                                'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                            '+
	((__t=( loc.get('name') ))==null?'':_.escape(__t))+
	'\n                        </option>\n                    ';
	 }); 
	__p+='\n                </select>\n            ';
	 } 
	__p+='\n            <span class="error error-location"></span>\n        </div>\n    </div>\n\n    <div class="divider"></div>\n\n    <div class="form-group">\n        <div class="col-sm-12">\n            <table class="footable table footable-payroll-details"\n                data-striping="false">\n                <thead>\n                    <tr>\n                        <th class="name">\n                            Monthly Recurring Payroll Item\n                            <i class="fa fa-question-circle"\n                               data-toggle="tooltip"\n                               data-placement="top" data-container="body"\n                               data-html="true"\n                               data-original-title="Add monthly allowances\n                                    and any other recurring payments like overtime\n                                    or commission paid on a monthly basis. It is\n                                    important to add monthly recurring items here\n                                    as the PCB may be underpaid if wrongly added as\n                                    additional items while running payroll instead\n                                    of being added here.">\n                            </i>\n                        </th>\n                        <th class="rate">Rate</th>\n                        <th class="units">Unit</th>\n                        <th class="amount">Amount (RM)</th>\n                        <th class="check-box-fields">\n                            Apply Unpaid Leave?\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip"\n                                data-html="true"\n                                data-placement="top" data-container="body"\n                                data-original-title="Unpaid leave recorded in\n                                    the leave calendar for this employee will\n                                    apply to these payroll items as well as\n                                    salary.<br>\n                                    Note: Hourly/Daily wages are not affected\n                                    by Unpaid Leave">\n                            </i>\n                        </th>\n                        <th class="check-box-fields">\n                            Apply Overtime?\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip"\n                                data-html="true"\n                                data-placement="top" data-container="body"\n                                data-original-title="These payroll items will\n                                    be included in the calculation of Overtime\n                                    (Normal), Overtime (Rest-day) and Overtime\n                                    (Public)">\n                            </i>\n                        </th>\n                        <th class="check-box-fields">\n                            Apply Prorate?\n                            <i class="fa fa-question-circle"\n                                data-toggle="tooltip"\n                                data-html="true"\n                                data-placement="top" data-container="body"\n                                data-original-title="Prorate amount based on\n                                                     join date">\n                            </i>\n                        </th>\n                    </tr>\n                </thead>\n\n                <tbody class="footable-body js-payroll-details-empty">\n                    <tr>\n                        <td colspan="4">\n                            <h4>No monthly recurring payroll items</h4>\n                        </td>\n                    </tr>\n                </tbody>\n\n                <tbody class="footable-body\n                    js-payroll-details-list hidden js-ext">\n                </tbody>\n                <tfoot>\n                    <tr>\n                        <td colspan="7">\n                            <button type="button" class="js-add-payroll-items\n                                btn btn-white pull-right">\n                                <i class="fa fa-plus" aria-hidden="true"></i>\n                                Monthly Recurring Payroll Item\n                            </button>\n                        </td>\n                    <tr>\n                </tfoot>\n            </table>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <div class="col-sm-12">\n            <table class="footable table footable-leave-policies"\n                data-striping="false">\n                <thead>\n                    <tr>\n                        <th class="name">\n                            Leave Policies\n                            <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" data-container="body" data-html="true" title=""\n                                data-original-title=\'View or edit leave entitlements.\'\n                            ></i>\n                        </th>\n                        <th class="taken">\n                            Total Days Entitled\n\n                            ';
	 if (!isNew) { 
	__p+='\n                                <i class="fa fa-question-circle"\n                                    data-toggle="tooltip"\n                                    data-html="true"\n                                    data-placement="top" data-container="body"\n                                    data-original-title="Total days entitled since '+
	((__t=( leaveTakenPeriod.start ))==null?'':_.escape(__t))+
	' up to '+
	((__t=( leaveTakenPeriod.end ))==null?'':_.escape(__t))+
	'">\n                                </i>\n                            ';
	 } 
	__p+='\n                        </th>\n                        <th class="taken">\n                            Days Carried Forward\n                        </th>\n                        <th class="taken">\n                            Days Taken\n                            ';
	 if (!isNew) { 
	__p+='\n                                <i class="fa fa-question-circle"\n                                    data-toggle="tooltip"\n                                    data-html="true"\n                                    data-placement="top" data-container="body"\n                                    data-original-title="Days Taken since '+
	((__t=( leaveTakenPeriod.start ))==null?'':_.escape(__t))+
	' up to '+
	((__t=( leaveTakenPeriod.end ))==null?'':_.escape(__t))+
	'"></i>\n                            ';
	 } 
	__p+='\n                        </th>\n                        <th class="taken">\n                            Days Remaining\n                            ';
	 if (!isNew) { 
	__p+='\n                                <i class="fa fa-question-circle"\n                                    data-toggle="tooltip"\n                                    data-html="true"\n                                    data-placement="top" data-container="body"\n                                    data-original-title="Days Remaining until '+
	((__t=( leaveTakenPeriod.end ))==null?'':_.escape(__t))+
	'"></i>\n                            ';
	 } 
	__p+='\n                        </th>\n                    </tr>\n                </thead>\n\n                ';
	 if (leaveTypes.length === 0) { 
	__p+='\n                    <tbody class="footable-body">\n                        <tr>\n                            <td colspan="4">\n                                <h4>No leave types found</h4>\n                            </td>\n                        </tr>\n                    </tbody>\n                ';
	 } else { 
	__p+='\n                    <tbody id="leaveTypes" class="footable-body">\n                        ';
	 leaveTypes.forEach(function(type) { 
	__p+='\n                            <tr>\n                                <td class="title td-nowrap">\n                                    <div class="flex-container-row">\n                                        '+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'\n                                    </div>\n                                </td>\n                                <td class="taken">\n                                    <div class="flex-container-row">\n                                        ';
	 if (type.hasDaysEntitled()) { 
	__p+='\n                                            <input name="days"\n                                                   type="number"\n                                                   max="999"\n                                                   class="form-control\n                                                          form-control-invisible\n                                                          input-days\n                                                          text-right js-ext-days js-ext"\n                                                   autocomplete="off" type="text"\n                                                   value="'+
	((__t=( type.getDefaultEntitled().formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n                                                   data-value-type="float"\n                                                   data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'">\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                </td>\n                                <td class="taken">\n                                    <div class="flex-container-row">\n                                        ';
	 if (!canCarryForwardDays) { 
	__p+='\n                                            <input name="carryForwardDays"\n                                                   type="number"\n                                                   class="form-control\n                                                          form-control-invisible\n                                                          input-days\n                                                          text-right"\n                                                   autocomplete="off" type="text"\n                                                   value="'+
	((__t=( type.get('carriable') ? 0 : '' ))==null?'':_.escape(__t))+
	'"\n                                                   data-value-type="float"\n                                                   data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                                   disabled>\n                                        ';
	 } else { 
	__p+='\n                                            <input name="carryForwardDays"\n                                                   type="number"\n                                                   class="form-control\n                                                          form-control-invisible\n                                                          input-days\n                                                          text-right js-ext-carryForward js-ext"\n                                                   autocomplete="off" type="text"\n                                                   value="'+
	((__t=( type.get('carriable') ? (carryForwardDays[type.id] || 0).formatWithoutRounding() : '' ))==null?'':_.escape(__t))+
	'"\n                                                   data-value-type="float"\n                                                   data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                                   '+
	((__t=( !type.get('carriable') ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                </td>\n                                <td class="taken">\n                                    <div class="flex-container-row">\n                                        <span>'+
	((__t=( type.getTaken().formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</span>\n                                    </div>\n                                </td>\n                                <td class="taken">\n                                    <div class="flex-container-row">\n                                        <span>\n                                            ';
	 if (type.hasDaysEntitled()) { 
	__p+='\n                                                '+
	((__t=( (
	                                                    type.getEntitled() -
	                                                    type.getTaken()
	                                                ).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                                            ';
	 } 
	__p+='\n                                        </span>\n                                    </div>\n                                </td>\n                            </tr>\n                        ';
	 }) 
	__p+='\n                    </tbody>\n                ';
	 } 
	__p+='\n            </table>\n        </div>\n    </div>\n</div>\n\n<div class="text-right">\n    <button class="js-cancel btn btn-warning btn-w-m"\n        data-loading-text="Cancelling..." data-complete-text="Cancel"\n        data-toggle="tooltip" data-title="No changes will be saved"\n        data-placement="top" data-delayed>\n        <i class="fa fa-exclamation-triangle"></i>\n        Cancel\n    </button>\n    <button class="js-save btn btn-primary m-l-xs">\n        <i class="fa fa-check"></i>\n        Save changes\n    </button>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _employee = __webpack_require__(571);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _StatutoryRequirements = __webpack_require__(796);
	
	var _StatutoryRequirements2 = _interopRequireDefault(_StatutoryRequirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Form2.default.extend({
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events(), {
	            'click .js-is-epf-dropdown-menu a': 'updateIsEpf',
	            'change .js-socso-category': 'updateSsfwNumber',
	            'ifToggled [name="isEpfMemberBefore1998"]': 'toggleIsEpfMemberBefore1998'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            isNew: false,
	            unsubmittedPayroll: null,
	            template: _StatutoryRequirements2.default
	        }, options || {});
	
	        this.options.templateExtra = {
	            isNew: this.options.isNew,
	            baseRates: this.model.getApplicableEpfRates(),
	            employerBaseRate: this.model.getEmployerEpfRate(),
	            consts: _employee.consts
	        };
	
	        this.constraints = {
	            mtdBorneByEmployer: { presence: true },
	            isEis: { presence: true },
	            isEpf: function isEpf(value, attrs) {
	                var age = (0, _moment2.default)().diff(attrs.dob || new Date(), 'years');
	
	                if (age < 75) {
	                    return null;
	                }
	
	                return { inclusion: {
	                        within: [false],
	                        message: '^This employee is too old to contribute to EPF'
	                    } };
	            },
	            isEpfMemberBefore1998: { presence: true },
	            epfNumber: function epfNumber(value, attrs) {
	                var age = (0, _moment2.default)().diff(attrs.dob || new Date(), 'years');
	                if (!attrs.isEpf || age > 75) {
	                    return null;
	                }
	                return {
	                    format: {
	                        pattern: /^\d{1,8}$/,
	                        message: '^Invalid EPF Number format (Example: ' + '00000000)'
	                    },
	                    length: {
	                        is: 8,
	                        message: '^The EPF Number must be 8 digits long'
	                    }
	                };
	            },
	            epfRate: function epfRate(value, attrs) {
	                if (!attrs.isEpf) {
	                    return null;
	                }
	
	                return {
	                    presence: { message: '^EPF Rate cannot be blank' },
	                    numericality: {
	                        greaterThanOrEqualTo: 0,
	                        message: '^You need to specify a contribution rate'
	                    }
	                };
	            },
	
	            epfAdditionalRate: function epfAdditionalRate(value, attrs) {
	                if (!attrs.isEpf) {
	                    return null;
	                }
	
	                return {
	                    numericality: {
	                        greaterThanOrEqualTo: 0,
	                        message: '^The additional contribution rate must ' + 'be a positive number'
	                    }
	                };
	            },
	
	            epfEmployerRate: function epfEmployerRate(value, attrs) {
	                if (!attrs.isEpf) {
	                    return null;
	                }
	
	                return {
	                    presence: {
	                        message: '^EPF Rate cannot be blank'
	                    },
	                    inclusion: {
	                        within: [_employee.consts.EPF_EMPLOYER_RATE_GOVT_TABLE, _employee.consts.EPF_EMPLOYER_RATE_5RM],
	                        message: '^The employer EPF contribution rate is ' + 'not a valid value'
	                    }
	                };
	            },
	
	            epfEmployerAdditionalRate: function epfEmployerAdditionalRate(value, attrs) {
	                if (!attrs.isEpf) {
	                    return null;
	                }
	
	                return {
	                    numericality: {
	                        greaterThanOrEqualTo: 0,
	                        message: '^The additional contribution rate must be ' + 'a positive number'
	                    }
	                };
	            }
	        };
	
	        this.model.isIntern = !!this.options.defaultPayrollDetails.models.find(function (d) {
	            return d.getPayrollItem().id === 'cmyvIzZAyP';
	        });
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    resetPayrollConfirm: function resetPayrollConfirm() {
	
	        if (!this.options.unsubmittedPayroll || this.options.unsubmittedPayroll.isCreated()) {
	            return (0, _bluebird.resolve)();
	        }
	
	        return (0, _bluebird.resolve)(_alerts2.default.show('infoConfirm', {
	            title: 'Your saved payroll will be modified!',
	            text: 'You have an unsubmitted payroll saved. ' + 'If you continue, taxes calculated for this employee will ' + 'be rendered invalid and will have to be recalculated.',
	            confirmButtonText: 'Yes, Save Requirements'
	        }));
	    },
	
	    _confirmMissingEPF: function _confirmMissingEPF() {
	        var isICHolder = this.model.get('idType') === _employee.consts.ID_TYPE_IC_NUMBER;
	        var missingEpf = isICHolder && !this.model.get('isEpf');
	        if (missingEpf) {
	            this.toggleError('epfNumber', 'An EPF Number should be entered');
	            return (0, _bluebird.resolve)(_alerts2.default.show('confirm', {
	                text: 'Malaysians must contribute EPF. If the employee ' + 'is a first time contributor and does not have an EPF ' + 'number ' + 'yet, you may set the \'Contribute EPF\' field to Yes ' + 'and add 00000000 as a temporary EPF Number. You can ' + 'update to the new EPF number later. Existing EPF ' + 'numbers ' + 'can be enquired from KWSP at 03 - 8922 6000.',
	                confirmButtonText: 'Yes, Save'
	            }));
	        }
	    },
	
	    _confirmMissingSOCSO: function _confirmMissingSOCSO() {
	        var isICHolder = this.model.get('idType') === _employee.consts.ID_TYPE_IC_NUMBER;
	        var missingSocso = isICHolder && !this.model.get('socsoCategory');
	        if (missingSocso) {
	            this.toggleError('socsoCategory', 'A SOCSO category should be chosen');
	            return (0, _bluebird.resolve)(_alerts2.default.show('confirm', {
	                html: 'Effective 1 June 2016, the Employees\' Social Security\nAct, 1969 states that ALL employees who are under employment must contribute to\nSOCSO.',
	                confirmButtonText: 'Yes, Save'
	            }));
	        }
	    },
	
	    save: function save(ev) {
	        var _this = this;
	
	        return (0, _bluebird.resolve)().then(function () {
	            return _this._confirmMissingEPF();
	        }).then(function () {
	            return _this._confirmMissingSOCSO();
	        }).then(function () {
	            // Actual save
	            var $button = _this.$(ev.currentTarget);
	            var stopLoader;
	            return _this.resetPayrollConfirm().then(function () {
	                stopLoader = _loader2.default.startFullScreen($button);
	                _this.model.setAdditionalConstraints(_this.constraints);
	                return _this.model.save().catch(function (err) {
	                    if (_this.model.wasValid()) {
	                        // the error is not a validation error
	                        throw err;
	                    }
	                    throw new Error('validationError');
	                });
	            }).then(function () {
	                if (_this.options.unsubmittedPayroll) {
	                    return _this.options.unsubmittedPayroll.resetEmployee({ employee: _this.model });
	                }
	
	                return true;
	            }).then(function () {
	                if (!_this.options.isNew) {
	                    _this.render();
	                    _modal2.default.showAlertSuccess('Statutory Requirements have been saved');
	
	                    return (0, _bluebird.resolve)();
	                }
	
	                var goToPayslips = app.company.get('employeeCount') === 1 && _this.options.isNew;
	                if (goToPayslips) {
	                    _alerts2.default.show('success', {
	                        text: 'Statutory requirements have been saved, ' + 'proceed to Previous Payslips now',
	                        callback: function callback() {
	                            return app.mainRouter.navigate('employee/' + _this.model.id + '/previousPayslips/isNew', { trigger: true, replace: true });
	                        }
	                    });
	                } else if (_this.options.isNew) {
	                    app.mainRouter.navigate('employee/' + _this.model.id + '/previousPayslips/isNew', { trigger: true, replace: true });
	                }
	
	                return null;
	            }).catch(function (err) {
	                if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object' && err.message !== 'validationError') {
	                    _alerts2.default.show('criticalError', err);
	                }
	            }).finally(function () {
	                _this.model.setAdditionalConstraints(null);
	                if (typeof stopLoader === 'function') {
	                    stopLoader();
	                }
	            });
	        });
	    },
	
	    updateIsEpf: function updateIsEpf(ev) {
	        ev.preventDefault();
	        var $employeeRateInput = this.$('[name="epfRate"]:checked');
	        var employeeRate = this.getInputValue($employeeRateInput) || 0;
	        var $employerRateInput = this.$('[name="epfEmployerRate"]:checked');
	        var employerRate = this.getInputValue($employerRateInput) || 0;
	
	        this.model.set({
	            isEpf: this.$(ev.currentTarget).data('value'),
	            epfRate: this.$(ev.currentTarget).data('value') === false ? 0 : employeeRate,
	            epfEmployerRate: this.$(ev.currentTarget).data('value') === false ? 0 : employerRate
	        });
	
	        this.renderAttribute(this.model, 'epfRate');
	        this.renderAttribute(this.model, 'epfEmployerRate');
	
	        if (this.model.get('isEpf')) {
	            this.$('[name="isEpfMemberBefore1998"]').iCheck('uncheck');
	        }
	
	        return this;
	    },
	
	    updateSsfwNumber: function updateSsfwNumber(ev) {
	        ev.preventDefault();
	
	        this.model.set({
	            socsoCategory: parseInt(this.$(ev.target).find('option:selected').val(), 10)
	        });
	
	        this.$('[name=ssfwNumber]').prop('disabled', this.model.get('socsoCategory') === 0);
	
	        return this;
	    },
	
	    toggleIsEpfMemberBefore1998: function toggleIsEpfMemberBefore1998(ev) {
	        var $toggle = this.$(ev.currentTarget);
	        var isEpfMemberBefore1998 = $toggle.is(':checked');
	
	        this.model.set({
	            isEpfMemberBefore1998: isEpfMemberBefore1998,
	            epfEmployerRate: isEpfMemberBefore1998 ? _employee.consts.EPF_EMPLOYER_RATE_GOVT_TABLE : _employee.consts.EPF_EMPLOYER_RATE_5RM
	        });
	
	        this.options.templateExtra.employerBaseRate = this.model.getEmployerEpfRate();
	
	        this.options.templateExtra.baseRates = this.model.getApplicableEpfRates();
	
	        this.render();
	        return this;
	    },
	
	    render: function render() {
	        _Form2.default.prototype.render.apply(this, arguments);
	
	        this.model.setAdditionalConstraints(null);
	        this.markMandatoryFields(this.constraints);
	        this.markMandatoryFields({
	            epfRate: { presence: true },
	            epfEmployerRate: { presence: true }
	        });
	        this.$('[name=taxNumber]').inputmask('AA 99999999-999');
	        this.$('[name=epfNumber]').inputmask('99999999');
	        return this;
	    }
	});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/StatutoryRequirements.ejs -->\n<div class="form-horizontal">\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Contributing EPF\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                data-original-title="Malaysians must contribute EPF. If you\n                    don\'t have an EPF number at the moment you may set the\n                    \'Contribute EPF\' field to Yes and add 00000000 as the EPF\n                    number.">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <div class="input-group">\n                <div class="input-group-btn">\n                    <button data-toggle="dropdown" type="button"\n                        class="btn btn-white dropdown-toggle\n                            js-attr-isEpf">\n                        <span class="js-isEpf-label">\n                            '+
	((__t=( model.get('isEpf') ? 'Yes' : 'No' ))==null?'':_.escape(__t))+
	'\n                        </span>\n                        <span class="caret"></span>\n                    </button>\n                    <ul class="js-is-epf-dropdown-menu\n                        dropdown-menu pull-right">\n                        <li><a href="" data-value="true">Yes</a></li>\n                        <li><a href="" data-value="false">No</a></li>\n                    </ul>\n                </div>\n                <input name="epfNumber" class="form-control" type="text"\n                    placeholder="Enter EPF Number"\n                    '+
	((__t=( !model.get('isEpf') ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'\n                    value="'+
	((__t=( model.get('epfNumber') ))==null?'':_.escape(__t))+
	'">\n            </div>\n            <span class="error error-isEpf"></span>\n            <span class="error error-epfNumber"></span>\n        </div>\n    </div>\n\n    ';
	 if (!model.isMalaysian() && !model.get('isPermanentResident')) { 
	__p+='\n        <div class="form-group js-epf-rate '+
	((__t=( model.get('isEpf') ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'">\n            <label class="col-sm-3 control-label is-paddingless-top">\n                EPF member before 1st August 1998?\n            </label>\n            <div class="col-sm-9">\n                <input name="isEpfMemberBefore1998" class="js-icheck"\n                    type="checkbox" data-value-type="boolean"\n                    '+
	((__t=( model.get('isEpfMemberBefore1998') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                <span class="error error-isEpfMemberBefore1998"></span>\n            </div>\n        </div>\n    ';
	 } 
	__p+='\n\n    <div class="form-group js-epf-rate '+
	((__t=( model.get('isEpf') ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'">\n        <label class="col-sm-3 control-label">\n            Employee EPF Rate\n        </label>\n        <div class="col-sm-4">\n            <p>\n                ';
	 baseRates.map(function (rate) {
	__p+='\n                <label>\n                    <input type="radio" name="epfRate"\n                        value="'+
	((__t=( rate.value ))==null?'':_.escape(__t))+
	'"\n                        class="js-icheck" data-value-type="float"\n                        '+
	((__t=(
	                            (isNew && rate.default) ||
	                            rate.value === model.get('epfRate') ||
	                            baseRates.length === 1 ?
	                            'checked' : ''
	                        ))==null?'':_.escape(__t))+
	'\n                        >\n                    <span>'+
	((__t=( rate.text ))==null?'':_.escape(__t))+
	'</span>\n                </label>\n                ';
	 }) 
	__p+='\n            </p>\n            <p class="error error-epfRate"></p>\n        </div>\n        <label class="col-sm-3 control-label">\n            Additional Rate\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                data-original-title="This is the voluntary rate to be added on\n                    top of the employee\'s normal EPF.  For example if the\n                    normal rate was 11% and 5% was selected then the total\n                    rate would be 16%.  But before you can add this additional\n                    rate you must first apply to KWSP via the employee form:\n                    Form <a href=\'http://www.kwsp.gov.my/portal/en/web/kwsp/member/all-epf-form\' target=\'_blank\'>\n                        KWSP 17A (AHL)\n                    </a>"></i>\n        </label>\n        <div class="col-sm-2">\n            <select class="form-control" name="epfAdditionalRate"\n                data-value-type="float">\n                ';
	 _.times(41, function(i) { 
	__p+='\n                    <option value="'+
	((__t=( (i/2) / 100 ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (
	                            model.get('epfAdditionalRate') &&
	                            model.get('epfAdditionalRate').toFixed(3) ===
	                                ((i/2) / 100).toFixed(3)
	                        ) ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( (i / 2).toFixed(1) ))==null?'':_.escape(__t))+
	'%\n                    </option>\n                ';
	 }) 
	__p+='\n            </select>\n            <span class="error error-epfAdditionalRate"></span>\n        </div>\n    </div>\n\n    <div class="form-group js-epf-rate '+
	((__t=( model.get('isEpf') ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'">\n        <label class="col-sm-3 control-label">\n            Employer EPF Rate\n            ';
	 if (
	                !model.get('isResident') || (
	                    model.get('isResident')
	                    && model.get('idType') === 2
	                )
	            ) { 
	__p+='\n                <i class="fa fa-question-circle" data-toggle="tooltip"\n                    data-placement="top" data-container="body"\n                    data-html="true"\n                    data-original-title="Note: 5RM rate can only be chosen for foreign employees.">\n                </i>\n            ';
	 } 
	__p+='\n        </label>\n        <div class="col-sm-4">\n            <p>\n                <label>\n                    <input type="radio" name="epfEmployerRate"\n                        class="js-icheck" data-value-type="float"\n                        value="'+
	((__t=( employerBaseRate.value ))==null?'':_.escape(__t))+
	'" checked>\n                    <span data-name="epfEmployerRate">'+
	((__t=( employerBaseRate.label ))==null?'':_.escape(__t))+
	'</span>\n                </label>\n            </p>\n            <p class="error error-epfEmployerRate"></p>\n        </div>\n        <label class="col-sm-3 control-label">\n            Additional Rate\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                data-original-title="This is the voluntary rate to be added\n                    on top of the employer\'s normal EPF contribution. For\n                    example if the normal rate was 12% and 3% was selected\n                    then the total rate would be 15%. But before you can add\n                    this additional rate you must first apply to KWSP via\n                    the employer form:\n                    Form <a href=\'http://www.kwsp.gov.my/portal/en/web/kwsp/member/all-epf-form\' target=\'_blank\'>\n                        KWSP 17 (MAJ)\n                    </a>"></i>\n        </label>\n        <div class="col-sm-2">\n            <select class="form-control" name="epfEmployerAdditionalRate"\n                data-value-type="float">\n                ';
	 _.times(41, function(i) { 
	__p+='\n                    <option value="'+
	((__t=( (i/2) / 100 ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( (
	                            model.get('epfEmployerAdditionalRate') &&
	                            model.get('epfEmployerAdditionalRate').toFixed(3) ===
	                                (i / 2 / 100).toFixed(3)
	                        ) ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( (i /2).toFixed(1) ))==null?'':_.escape(__t))+
	'%\n                    </option>\n                ';
	 }) 
	__p+='\n            </select>\n            <span class="error error-epfEmployerAdditionalRate"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            PCB Number\n\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                data-original-title="The PCB will be automatically calculated if\n                    the employee’s chargeable income is above the PCB threshold.\n                    The tax number will help LHDN allocate the PCB payment to the employee. Remember to submit form CP22\n                    to LHDN for any new employee subject to PCB within 30 days of their join date."\n            >\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="taxNumber" class="form-control" type="text"\n               placeholder="Enter the Employee\'s Tax Number"\n               value="'+
	((__t=( model.get('taxNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxNumber"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            PCB Borne By Employer\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                data-original-title="When PCB is borne by the employer, the\n                    employee will have no PCB deducted from their gross pay.\n                    PCB borne by the employer is a taxable perquisite to the\n                    employee.">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="mtdBorneByEmployer" class="js-icheck"\n                type="checkbox" data-value-type="boolean"\n                '+
	((__t=( model.get('mtdBorneByEmployer') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-mtdBorneByEmployer"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            SOCSO Category\n        </label>\n        <div class="col-sm-9">\n            <select class="js-socso-category form-control" name="socsoCategory"\n                data-value-type="integer">\n                <option value="0"\n                    '+
	((__t=( model.get('socsoCategory') === consts.SOCSO_CATEGORY_NONE ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Not Applicable\n                </option>\n\n                <option value="1"\n                    '+
	((__t=( model.get('socsoCategory') === consts.SOCSO_CATEGORY_INJURY_AND_INVALIDITY ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Employment Injury Scheme and Invalidity Scheme\n                </option>\n\n                <option value="2"\n                    '+
	((__t=( model.get('socsoCategory') === consts.SOCSO_CATEGORY_INJURY ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Employment Injury Scheme\n                </option>\n            </select>\n            <span class="error error-socsoCategory"></span>\n        </div>\n    </div>\n\n    <!-- ssfw number -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            SSFW Number\n        </label>\n        <div class="col-sm-9">\n            <input name="ssfwNumber" type="text"\n               class="form-control" value="'+
	((__t=( model.get('ssfwNumber') ))==null?'':_.escape(__t))+
	'" '+
	((__t=( model.get('socsoCategory') === 0 ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-ssfwNumber"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            EIS\n        </label>\n        <div class="col-sm-9">\n            <input name="isEis" class="js-icheck"\n                type="checkbox" data-value-type="boolean"\n                '+
	((__t=( model.get('isEis') && model.canContributeToEis() ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                '+
	((__t=( !model.canContributeToEis() ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-isEis"></span>\n        </div>\n    </div>\n\n</div>\n\n<div class="text-right m-b-sm">\n    <button class="js-cancel btn btn-warning btn-w-m"\n        data-loading-text="Cancelling..."\n        data-complete-text="Cancel"\n        data-toggle="tooltip" data-title="No changes will be saved"\n        data-placement="top" data-delayed>\n        <i class="fa fa-exclamation-triangle"></i>\n        Cancel\n    </button>\n    <button class="js-save btn btn-primary m-l-xs">\n        <i class="fa fa-check"></i>\n        Save changes\n    </button>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _YearlyTotalsModal = __webpack_require__(798);
	
	var _YearlyTotalsModal2 = _interopRequireDefault(_YearlyTotalsModal);
	
	var _PreviousPayslips = __webpack_require__(802);
	
	var _PreviousPayslips2 = _interopRequireDefault(_PreviousPayslips);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _localStorageUtil = __webpack_require__(741);
	
	var _localStorageUtil2 = _interopRequireDefault(_localStorageUtil);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    previousEmploymentModal: null,
	    currentEmploymentModal: null,
	
	    events: function events() {
	        return {
	            'click .js-previous-employment': 'showPreviousEmploymentModal',
	            'click .js-current-employment': 'showCurrentEmploymentModal',
	            'change .js-ytd-year': 'changeYtdYear'
	        };
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            payrollItems: null,
	            yearlyTotals: null,
	            payslips: null,
	            payslipAttachments: null,
	            isNew: null,
	            year: new Date().getFullYear()
	        });
	
	        this.options.yearlyTotals.reset(_.sortBy(this.options.yearlyTotals.models, function (item) {
	            return -item.get('amount');
	        }), { silent: true });
	
	        this.previousEmploymentModal = new _YearlyTotalsModal2.default({
	            current: false,
	            collection: this.options.yearlyTotals,
	            payrollItems: this.options.payrollItems,
	            model: this.model,
	            year: this.options.year,
	            unsubmittedPayroll: this.options.unsubmittedPayroll
	        });
	
	        this.currentEmploymentModal = new _YearlyTotalsModal2.default({
	            current: true,
	            collection: this.options.yearlyTotals,
	            payrollItems: this.options.payrollItems,
	            model: this.model,
	            year: this.options.year,
	            unsubmittedPayroll: this.options.unsubmittedPayroll
	        });
	
	        this.options.yearlyTotals.on('all', this.render, this);
	
	        this.render();
	
	        return this;
	    },
	
	    render: function render() {
	        var periodStart = (0, _moment2.default)(_payroll2.default.getCurrentPeriodDate());
	        var yearStart = (0, _moment2.default)(periodStart).date(1).month(0);
	        var joinDate = new Date(this.model.get('commencementDate'));
	
	        this.$el.html((0, _PreviousPayslips2.default)({
	            model: this.model,
	            selectedYear: this.options.year,
	            ytdYears: _.times(Math.max(1, (0, _moment2.default)().year() - Math.max(2016, joinDate.getFullYear()) + 1), function (i) {
	                return (0, _moment2.default)().year() - i;
	            }),
	            isNew: this.options.isNew,
	            itemYearlyTotals: this.options.yearlyTotals,
	            payslips: this.options.payslips,
	            payslipAttachments: this.options.payslipAttachments,
	
	            showPreviousEmployment: joinDate && (0, _moment2.default)(joinDate).isSame(periodStart, 'year') && yearStart.isBefore(joinDate),
	            showCurrentEmployment: joinDate && (0, _moment2.default)(joinDate).isSameOrBefore(periodStart, 'month')
	        }));
	
	        _tooltip2.default.init(this);
	
	        return this;
	    },
	
	    showPreviousEmploymentModal: function showPreviousEmploymentModal(ev) {
	        ev.preventDefault();
	        this.previousEmploymentModal.show();
	    },
	
	    showCurrentEmploymentModal: function showCurrentEmploymentModal(ev) {
	        ev.preventDefault();
	        this.currentEmploymentModal.show();
	    },
	
	    changeYtdYear: function changeYtdYear(ev) {
	        ev.preventDefault();
	        _localStorageUtil2.default.setItem('ytdYear', ev.target.value);
	        Backbone.history.loadUrl(Backbone.history.fragment);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _PayrollItemSelectionModal = __webpack_require__(722);
	
	var _PayrollItemSelectionModal2 = _interopRequireDefault(_PayrollItemSelectionModal);
	
	var _YearlyTotalsModal = __webpack_require__(799);
	
	var _YearlyTotalsModal2 = _interopRequireDefault(_YearlyTotalsModal);
	
	var _YearlyTotalRow = __webpack_require__(800);
	
	var _YearlyTotalRow2 = _interopRequireDefault(_YearlyTotalRow);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'div',
	
	    itemViews: [],
	
	    availablePayrollItems: null,
	
	    events: {
	        'click .js-save': 'save',
	        'click .js-cancel': 'cancel',
	        'click .js-reset': 'reset',
	        'click .js-autofill': 'autoFill',
	        'click .js-add-item': 'showSelectModal',
	
	        'shown.bs.modal': 'focusFirstInput'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            current: true,
	            payrollItems: null,
	            year: null
	        });
	
	        this.availablePayrollItems = this.options.payrollItems.clone();
	
	        if (this.collection) {
	            this.bindHandlers();
	            this.updateItemAvailability();
	        }
	
	        this.payrollItemSelectionModal = new _PayrollItemSelectionModal2.default({
	            collection: this.availablePayrollItems
	        });
	        this.payrollItemSelectionModal.on('select', this.addItems, this);
	
	        this.render();
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.collection.on('add', this.renderItem, this);
	        this.collection.on('sync reset', this.renderItems, this);
	        this.collection.on('remove', this.removeItemView, this);
	        this.collection.on('add remove sync', this.updateItemsTabIndex, this);
	        this.collection.on('add remove sync', this.updateItemAvailability, this);
	
	        return this;
	    },
	
	    setCollection: function setCollection(collection) {
	        this.collection = collection;
	
	        this.bindHandlers();
	
	        this.render();
	        this.renderItems();
	
	        this.updateItemAvailability();
	    },
	
	    getUserMonthLabels: function getUserMonthLabels() {
	        var now = (0, _moment2.default)();
	        var joinDate = (0, _moment2.default)(this.model.get('commencementDate') || now);
	        var periodStart = (0, _moment2.default)(_payroll2.default.getCurrentPeriodDate());
	        var yearStart = (0, _moment2.default)(periodStart).utc().date(1).month(0);
	        var range = void 0;
	
	        if (yearStart.isAfter(joinDate)) {
	            joinDate = (0, _moment2.default)(new Date(yearStart.year(), 0, 1, 12));
	        }
	
	        if (this.options.current) {
	            range = _.range(Math.min(joinDate.month(), periodStart.month()), periodStart.month());
	        } else if (joinDate.month() > periodStart.month() && joinDate.month() >= now.month()) {
	            range = _.range(periodStart.month() + 1);
	        } else {
	            var month = Math.min(joinDate.month(), periodStart.month());
	            //increase month by 1 if employee started mid month
	            month = Math.min(12, month + (joinDate.date() > 1));
	            range = _.range(month);
	        }
	
	        return _(range).map(function (month) {
	            return Object.create({
	                index: month,
	                label: _moment2.default.monthsShort()[month]
	            });
	        });
	    },
	
	    /**
	     * Get an array of months to display in the modal based on the join
	     * date of the employee and whether this modal is displaying current or
	     * previous employment data.
	     *
	     * For current employment, we show the months starting from the join date
	     * up to the current period (not including it). If the employee joined
	     * sometime in april and today is 1st of october, then we show
	     * april - august (as september is the current period until the 15th of oct)
	     *
	     * For previous employment we show the months starting from january up to
	     * the join date, including or excluding it depending on whether it is
	     * larger than the current period or calendar month. Assuming today is 14th
	     * of october and the employee joins the 1st of october, we show january to
	     * september (september is the currently active payroll, but because the
	     * employee joined at the start of calendar october it will be excluded from
	     * it, hence we show the column)
	     *
	     * @returns {Object[]} An array of objects with index and label attributes
	     *  representing the index of the month (zero based) and its label
	     */
	    getMonthLabels: function getMonthLabels() {
	
	        return _.range(12).map(function (month) {
	            return Object.create({
	                index: month,
	                label: _moment2.default.monthsShort()[month]
	            });
	        });
	    },
	
	    render: function render() {
	        this.$el.addClass('modal inmodal').html((0, _YearlyTotalsModal2.default)({
	            current: this.options.current,
	            employee: this.model,
	            months: this.getMonthLabels()
	        }));
	
	        this.$el.attr('data-backdrop', 'static');
	        this.$el.attr('keyboard', 'false');
	
	        if (this.collection) {
	            this.renderItems();
	        }
	
	        return this;
	    },
	
	    renderItems: function renderItems() {
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	        this.itemViews = [];
	
	        this.$('.items').toggleClass('hidden', !this.collection.length);
	        this.$('.js-empty').toggleClass('hidden', !!this.collection.length);
	        this.$('.js-button-bar').toggleClass('hidden', !this.collection.length);
	
	        this.collection.forEach(this.renderItem.bind(this));
	        this.updateItemsTabIndex();
	    },
	
	    renderItem: function renderItem(model) {
	        var lastMonth = this.getUserMonthLabels()[this.getUserMonthLabels().length - 1];
	
	        var itemView = new _YearlyTotalRow2.default({
	            current: this.options.current,
	            model: model,
	            months: this.getMonthLabels(),
	            stop: lastMonth
	        });
	
	        this.itemViews.push(itemView);
	        this.$('.items').append(itemView.$el);
	    },
	
	    removeItemView: function removeItemView(model) {
	        this.itemViews = _.reject(this.itemViews, function (view) {
	            return view.model === model;
	        });
	    },
	
	    showSelectModal: function showSelectModal() {
	        var restoreSelf = function () {
	            this.show();
	            this.payrollItemSelectionModal.off('hide', restoreSelf);
	        }.bind(this);
	
	        this.hide();
	        this.payrollItemSelectionModal.on('hide', restoreSelf);
	        this.payrollItemSelectionModal.show();
	    },
	
	    addItems: function addItems(payrollItems, additionalInfo) {
	        if (!this.collection) {
	            return;
	        }
	
	        payrollItems.forEach(function (payrollItem) {
	            var info = _.isObject(additionalInfo) ? additionalInfo[payrollItem.id] || null : null;
	
	            this.collection.add({
	                employeeId: this.model.id,
	                payrollItemId: payrollItem.id,
	                amount: 0,
	                monthly: [],
	                additionalInformation: info,
	                year: this.options.year
	            });
	        }.bind(this));
	    },
	
	    updateItemAvailability: function updateItemAvailability() {
	        var _this = this;
	
	        this.availablePayrollItems.reset(this.options.payrollItems.clone().filter(function (model) {
	            return !_this.collection.find(function (itemYearlyTotal) {
	                return itemYearlyTotal.get('payrollItemId') === model.id;
	            });
	        }), { silent: true });
	    },
	
	    updateItemsTabIndex: function updateItemsTabIndex() {
	        var _this2 = this;
	
	        this.itemViews.forEach(function (view, idx) {
	            view.setTabIndex(idx + 1, _this2.collection.length);
	        });
	    },
	
	    focusFirstInput: function focusFirstInput() {
	        this.$('input').first().focus();
	    },
	
	    hide: function hide() {
	        this.$el.modal('hide');
	        this.trigger('hide');
	    },
	
	    show: function show() {
	        this.$el.modal('show');
	        this.trigger('show');
	    },
	
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        var _this3 = this;
	
	        return new _bluebird2.default(function (resolve, reject) {
	            if (!_.isObject(_this3.options.unsubmittedPayroll)) {
	                return resolve(true);
	            }
	
	            _alerts2.default.show('infoConfirm', {
	                title: 'Your saved payroll will be modified!',
	                text: 'You have an unsubmitted payroll saved.                     If you continue, the payroll will be sent to                     Step 1 and updated based on the modifications                     you are about to save. Please note that any                     unsaved payroll adjustments will be lost.',
	                confirmButtonText: 'Yes, Save Changes'
	            }).then(function () {
	                return resolve();
	            }, function (err) {
	                return reject(err);
	            });
	        });
	    },
	
	    save: function save(ev) {
	        var _this4 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = function stopLoader() {};
	
	        ev.preventDefault();
	
	        if (!this.collection.isValid()) {
	            return _alerts2.default.show('error', {
	                title: 'Can\'t save a form with errors.',
	                text: 'Please review the form and fix the highlighted ' + 'errors before saving.'
	            });
	        }
	
	        return this.resetPayrollConfirm().then(function () {
	            stopLoader = _loader2.default.startFullScreen($button);
	
	            _this4.hide();
	
	            return _this4.collection.save().then(function () {
	                _modal2.default.showAlertSuccess('Your changes have been saved');
	            });
	        }, function () {
	            return { cancel: true };
	        }).then(function () {
	            if (_this4.options.unsubmittedPayroll) {
	                return _this4.options.unsubmittedPayroll.resetEmployee({ employee: _this4.model });
	            }
	
	            return (0, _bluebird.resolve)(true);
	        }).catch(function (err) {
	            stopLoader();
	            if ((err || {}).cancel) {
	                return;
	            }
	            return _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    cancel: function cancel(ev) {
	        var _this5 = this;
	
	        var $button = this.$(ev.currentTarget);
	
	        _alerts2.default.show('infoConfirm', {
	            title: 'Unsaved Changes',
	            text: 'You have unsaved changes. Exiting this page                 will result in the changes being discarded.',
	            confirmButtonText: 'Exit',
	            cancelButtonText: 'Stay'
	        }).then(function () {
	            var stopLoader = _loader2.default.startFullScreen($button);
	            if (_this5.collection.isNew()) {
	                _this5.collection.clearAmounts({
	                    current: _this5.options.current
	                });
	                stopLoader();
	            } else {
	                _this5.collection.fetchForPreviousPayslips().finally(stopLoader);
	            }
	        });
	    },
	
	    reset: function reset() {
	        var _this6 = this;
	
	        this.hide();
	
	        _alerts2.default.show('dangerConfirm', {
	            title: 'Are you sure you want to clear the form?',
	            confirmButtonText: 'Yes, Clear',
	            callback: function callback(isConfirm) {
	                _this6.show();
	
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this6.collection.clearAmounts({
	                    current: _this6.options.current
	                });
	            }
	        });
	    },
	
	    autoFill: function autoFill() {
	        var _this7 = this;
	
	        var salary = this.collection.find(function (model) {
	            return model.isBase();
	        });
	
	        if (this.options.current) {
	            _alerts2.default.show('error', {
	                title: 'Can\'t Auto-Fill Current Employment Details',
	                text: 'The auto-fill feature creates estimates. You can use ' + 'to fill in previous employment information if you don\'t ' + 'have that data available to improve tax calculations. ' + 'For current employment you should always use real data.'
	            });
	            return;
	        }
	
	        if (salary.get('prevEmploymentAmount') === 0 && _.compact(salary.get('prevEmploymentMonthly')).length === 0) {
	            _alerts2.default.show('error', {
	                title: 'Missing Values',
	                text: 'You need to specify salaries to run the auto-fill ' + 'function.'
	            });
	
	            return;
	        }
	
	        _alerts2.default.show('infoConfirm', {
	            html: 'Estimated PCB, EPF or SOCSO values will be calculated ' + 'for you, and any values you entered will be overwritten ' + 'but are editable. <br><br><strong>This function should only ' + 'be used to improve monthly tax calculations if accurate ' + 'previous employment data is not available</strong>',
	            confirmButtonText: 'Yes, Auto-Fill'
	        }).then(function () {
	            return _this7.model.autoFillPreviousPayslipsData({
	                itemYearlyTotals: _this7.collection,
	                current: false
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/YearlyTotalsModal.ejs -->\n<div class="modal-dialog modal-xl previous-payslips-data">\n    <form class="modal-content animated sweet position form-horizontal" role="form">\n        <div class="modal-header">\n            <button class="close js-cancel-button js-cancel" data-dismiss="modal"\n                type="button">\n                <span aria-hidden="true"><i class="fa fa-times"></i></span>\n                <span class="sr-only">Close</span>\n            </button>\n            <h1 class="modal-title">\n                ';
	 if (current) { 
	__p+='\n                    Data of Current Employment for\n                ';
	 } else { 
	__p+='\n                    Data of Previous Employment for\n                ';
	 } 
	__p+='\n                '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n            </h1>\n        </div>\n            <div class="table-container">\n                <table class="table table-striped table-settings modal-body">\n                    <thead>\n                    <tr>\n                        <th width="12%">Payroll Item</th>\n                        ';
	 _.each(months, function(month) { 
	__p+='\n                            <th>'+
	((__t=( month.label ))==null?'':_.escape(__t))+
	'</th>\n                        ';
	 }) 
	__p+='\n                        <th>Total</th>\n                    </tr>\n                    </thead>\n                    <tbody class="items"></tbody>\n                    <tbody class="js-empty hidden">\n                        <td colspan="'+
	((__t=( months.length + 2 ))==null?'':_.escape(__t))+
	'" class="text-center">\n                            <h2 class="m-t-lg m-b-lg">\n                                We are working hard setting everything up but\n                                regrettably this form is not ready yet. Please\n                                try again shortly.\n                            </h2>\n                        </td>\n                    </tbody>\n                </table>\n            </div>\n\n\n        <div class="modal-footer js-button-bar">\n            <button type="button"\n                class="btn btn-outline btn-default btn-add js-add-item\n                    pull-left"\n                data-loading-text="Adding..." data-complete-text="+ Add Item"\n                data-toggle="tooltip" data-title="Add another item the employee\n                    claimed in his or her previous employment"\n                data-placement="top" data-delayed>\n                + Add Item\n            </button>\n\n            <button type="reset" class="btn btn-outline btn-warning js-reset">\n                Clear\n            </button>\n            ';
	 if (!current) { 
	__p+='\n                <button type="button" class="btn btn-outline btn-success\n                    js-autofill">\n                    Auto-Fill\n                </button>\n            ';
	 } 
	__p+='\n            <button type="reset" class="btn btn-danger js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit" data-style="swap" class="btn btn-primary\n                btn-save ladda-button js-save">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var Alerts = __webpack_require__(529);
	
	var RowEditView = __webpack_require__(690);
	var template = __webpack_require__(801);
	var log = __webpack_require__(525)('yearly-total-row-view');
	
	module.exports = RowEditView.extend({
	    tagName: 'tr',
	    className: 'item',
	
	    events: function events() {
	        return Object.assign({}, RowEditView.prototype.events() || {}, {
	            'focus input': 'selectInputContent',
	            'change input.js-ext-monthly': 'updateMonthlyAmount',
	            'change input.js-ext-amount': 'updateAmount'
	        });
	    },
	
	    initialize: function initialize(options) {
	        var item = this.model.getPayrollItem();
	
	        this.options = _.defaults(options || {}, {
	            current: true,
	            template: template,
	            tabIndexOffset: 0,
	            tabIndexStepping: 1,
	            months: [],
	            templateExtra: {},
	            stop: 0
	        });
	        this.options.templateExtra = _.defaults(this.options.templateExtra, {
	            months: this.options.months,
	            current: this.options.current,
	            deletable: !['base', 'mtd', 'epf', 'socso'].includes(item.get('type')) || item.get('subtype') === 'custom' || item.get('isUnit')
	        });
	
	        return RowEditView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        if (this.options.current) {
	            // this.model.on('change:monthly', this.propagateMonthly, this);
	            this.model.on('change:monthly', this.updateAmountFromMonthly, this);
	            this.model.on('change:monthly', this.renderMonthly, this);
	        } else {
	            /*
	            this.model.on(
	                'change:prevEmploymentMonthly',
	                this.propagateMonthly,
	                this
	            );*/
	            this.model.on('change:prevEmploymentMonthly', this.updateAmountFromMonthly, this);
	            this.model.on('change:prevEmploymentMonthly', this.renderMonthly, this);
	        }
	
	        return RowEditView.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    render: function render() {
	        RowEditView.prototype.render.apply(this, arguments);
	
	        this.setTabIndex(this.options.tabIndexOffset, this.options.tabIndexStepping);
	    },
	
	    selectInputContent: function selectInputContent(ev) {
	        this.$(ev.currentTarget).select();
	    },
	
	    updateMonthlyAmount: function updateMonthlyAmount(ev) {
	        var $input = this.$(ev.currentTarget);
	        var attr = this.options.current ? 'monthly' : 'prevEmploymentMonthly';
	        var month = parseInt($input.attr('name').replace('monthly-', ''), 10);
	        var monthly = _.clone(this.model.get(attr)) || [];
	        var value = this.getInputValue($input);
	        if (_.isNaN(parseFloat(value))) {
	            value = 0;
	        }
	        monthly[month] = value;
	
	        log.info('Updating', attr, 'with', monthly);
	
	        this.model.set(attr, monthly);
	
	        return this;
	    },
	
	    updateAmount: function updateAmount(ev) {
	        var $input = this.$(ev.currentTarget);
	        var attr = this.options.current ? 'amount' : 'prevEmploymentAmount';
	        var value = this.getInputValue($input);
	        if (_.isNaN(parseFloat(value))) {
	            value = 0;
	        }
	        log.info('Updating', attr, 'with', value);
	
	        this.model.set(attr, value);
	
	        return this;
	    },
	
	    updateAmountFromMonthly: function updateAmountFromMonthly(model) {
	        if (model.changed.monthly) {
	            this.model.set({
	                amount: this.model.getMonthlySum({ current: true })
	            });
	
	            this.renderAmount(this.model);
	        }
	
	        if (model.changed.prevEmploymentMonthly) {
	            this.model.set({
	                prevEmploymentAmount: this.model.getMonthlySum({ current: false })
	            });
	
	            this.renderAmount(this.model);
	        }
	    },
	
	    renderAmount: function renderAmount(model) {
	        var attr = this.options.current ? 'amount' : 'prevEmploymentAmount';
	        this.$('[name="amount"]').val((model.get(attr) || 0).toFixed(2));
	    },
	
	    renderMonthly: function renderMonthly(model) {
	        var _this = this;
	
	        var attr = this.options.current ? 'monthly' : 'prevEmploymentMonthly';
	        var monthly = model.get(attr) || [];
	
	        monthly.forEach(function (amount, idx) {
	            _this.$('[name="monthly-' + idx + '"].js-ext-monthly').val((amount || 0).toFixed(2));
	        });
	    },
	
	    /**
	     * 20200604 disable automatic propogating YTD values.
	     * ticket: https://jibbletech.atlassian.net/browse/PPD-1002
	    propagateMonthly: function(model, value) {
	        var attr = this.options.current ? 'monthly' : 'prevEmploymentMonthly';
	         var previous = model.previous(attr) || [];
	        var months   = this.options.months || [];
	        var first    = (_.first(months) || {}).index;
	        var month    = first;
	        var amounts  = _.filter(value, function(amount, i) {
	            if (i < month) {
	                return false;
	            }
	             if (month === first && amount !== previous[i]) {
	                month = i + 1;
	            }
	             return (amount !== previous[i]);
	        });
	        var amount   = _.first(amounts);
	        var itemType = model.getPayrollItem().get('type');
	        var stop = this.options.stop.index;
	         log.info('Propagating changes in monthly value in', attr);
	         if (this.options.current && !model.changed.monthly) {
	            log.info('Ignoring changes to prevEmploymentMonthly');
	            return;
	        }
	        if (!this.options.current && !model.changed.prevEmploymentMonthly) {
	            log.info('Ignoring changes to monthly');
	            return;
	        }
	        if (!_.contains(['base', 'epf', 'socso', 'mtd'], itemType)) {
	            log.info('Wrong item type. Stop propagation.');
	            return;
	        }
	        if (_.compact(amounts).length > 1) {
	            log.info('Too many changes. Stop propagation.');
	            return;
	        }
	        if (!amount) {
	            log.info('Only falsy values. Stop propagation.');
	            return;
	        }
	        if (month > _.last(months).index) {
	            log.info('Dont propagate last value. Stop propagation.');
	            return;
	        }
	        if (_.compact(value).length > month) {
	            log.info('There are other values. Stop propagation.');
	            return;
	        }
	         _.each(months, function(m) {
	            if (m.index < month || m.index > stop) {
	                return;
	            }
	             value[m.index] = amount;
	        });
	         log.info('Storing propagated values', attr, month, value);
	        this.model.set(attr, value);
	    },
	    */
	
	    destroyModel: function destroyModel() {
	        var _this2 = this;
	
	        var text = 'You will be able to add this item back, but all amounts ' + 'will be lost';
	
	        if (!this.options.current && this.model.get('amount')) {
	            text = 'You also have current employment data on this item and ' + 'deleting it will clear everything.';
	        }
	
	        if (this.options.current && this.model.get('prevEmploymentAmount')) {
	            text = 'You also have previous employment data on this item and ' + 'deleting it will clear everything.';
	        }
	
	        Alerts.show('dangerConfirm', { text: text }).then(function () {
	            _this2.model.destroy().then(function () {
	                return _this2.remove();
	            }, function (err) {
	                return Alerts.show('criticalError', err);
	            });
	        });
	    },
	
	    setTabIndex: function setTabIndex(offset, stepping) {
	        var $inputs = this.$('input.js-ext-monthly');
	
	        this.options.tabIndexOffset = offset;
	        this.options.tabIndexStepping = stepping;
	
	        $inputs.each(function (i, input) {
	            var $input = $(input);
	
	            $input.attr('tabIndex', offset + i * stepping);
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/YearlyTotalRow.ejs -->\n<td class="td-nowrap">\n    <span class="name">\n        ';
	 if (model.getPayrollItem().get('name') === 'EIS') { 
	__p+='\n            Employee EIS\n        ';
	 } else if (model.getPayrollItem().get('name') === 'Salary (Gross)') { 
	__p+='\n            Salary (Basic)\n        ';
	 } else { 
	__p+='\n            '+
	((__t=( model.getPayrollItem().get('name') ))==null?'':_.escape(__t))+
	'\n        ';
	 } 
	__p+='\n    </span>\n    ';
	 if (deletable) { 
	__p+='\n        <a class="js-destroy"><i class="fa fa-times"></i></a>\n    ';
	 } 
	__p+='\n\n    <div class="error error-monthly error-amount\n        error-prevEmploymentMonthly error-prevEmploymentAmount"></div>\n    <div class="error error-monthly error-amount error-prevEmploymentMonthly\n        error-prevEmploymentAmount error-placeholder"></div>\n</td>\n';
	 monthly = model.get(current ? 'monthly': 'prevEmploymentMonthly') || [] 
	__p+='\n';
	 _.each(months, function(month) { 
	__p+='\n    ';
	 value = monthly[month.index] || 0; 
	__p+='\n    <td class="js-col">\n        <div class="form-group">\n            <input class="form-control form-control-invisible js-ext\n                    js-ext-monthly"\n                data-value-type="float"\n                name="monthly-'+
	((__t=( month.index ))==null?'':_.escape(__t))+
	'"\n                value="'+
	((__t=( value.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n                type="text">\n\n        </div>\n    </td>\n';
	 }) 
	__p+='\n<td>\n    <div class="form-group">\n        <input class="form-control form-control-invisible js-ext js-ext-amount"\n            name="amount" data-value-type="float"\n            value="'+
	((__t=(
	                (model.get(current ? 'amount': 'prevEmploymentAmount') || 0)
	                    .formatWithoutRounding() ))==null?'':_.escape(__t))+
	'"\n            type="text" disabled>\n    </div>\n</td>\n\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/PreviousPayslips.ejs -->\n<div class="container-fluid employee-previous-payslips">\n    <div class="row">\n        ';
	 if (
	            payslips.length === 0 ||
	            app.user.isAdmin() ||
	            app.user.get("emailVerified")
	        ) { 
	__p+='\n            <div class="col-lg-8 col-md-9 col-lg-offset-2 col-md-offset-1">\n                <h4>Previous Payslip Data Entry</h4>\n\n                <p class="m-t-sm">\n                    In order to generate accurate payroll calculations for this\n                    employee you should enter the year-to-date or monthly\n                    amounts for previous payslips.\n                </p>\n\n                ';
	 if (!model.get('commencementDate')) { 
	__p+='\n                    <p class="m-t-lg">\n                        <h5>\n                            To edit this information you first need\n                            to specify a date in which this employee joined\n                            his current employment. You can do so in the\n                            Employment Details tab located to the left.\n                        </h5>\n                    </p>\n                ';
	 } else { 
	__p+='\n                    <p class="m-t-lg">\n                        <h5>\n                            Based on the employee join date you have provided:\n                            <span style="font-size: larger;">\n                                '+
	((__t=( model.getFormatted(
	                                    'commencementDate', 'DD MMMM YYYY'
	                                ) ))==null?'':_.escape(__t))+
	'\n                            </span>\n\n                            <i class="fa fa-question-circle" data-toggle="tooltip"\n                                data-placement="right" data-container="body"\n                                data-original-title="To change this date please go\n                                    to the Employment Details tab located to the\n                                    left."></i>\n                        </h5>\n                    </p>\n\n                    ';
	 if (showPreviousEmployment) { 
	__p+='\n                        <p class="m-t-md">\n                            Did the employee work at a previous company this\n                            year? Following LHDN requirements, please obtain\n                            form TP3 from the employee and enter the previous\n                            employment data provided before running your first\n                            payroll for this employee:\n\n                            <div class="text-center m-t-sm">\n                                <button type="button" class="btn btn-outline btn-default\n                                    js-previous-employment">\n                                    Previous Employment Payslip Information Form\n                                </button>\n                            </div>\n                        </p>\n                        ';
	 } 
	__p+='\n\n                    ';
	 if (showCurrentEmployment) { 
	__p+='\n                        <p class="m-t-md">\n                            Enter the previous payslip information that you have\n                            for the employee whilst at their current employment:\n\n                            <div class="text-center m-t-sm">\n                                <button type="button" class="btn btn-outline btn-default\n                                    js-current-employment">\n                                    Current Employment Payslip Information Form\n                                </button>\n                            </div>\n                        </p>\n                    ';
	 } 
	__p+='\n\n                    ';
	 if (!showPreviousEmployment && !showCurrentEmployment) { 
	__p+='\n                        <p class="m-t-md">\n                            Your employee could not have had a previous employment\n                            and started the year employed in this company. You\n                            can safely include him in your next payroll without\n                            providing further information.\n                        </p>\n                    ';
	 } 
	__p+='\n                ';
	 } 
	__p+='\n\n            </div>\n        ';
	 } 
	__p+='\n        ';
	 if (payslips.length > 0) { 
	__p+='\n            ';
	 payslips.forEach(function(payslip) { 
	__p+='\n                ';
	 payslipPdf = (
	                    payslipAttachments[payslip.id] ?
	                        payslipAttachments[payslip.id]
	                            .findByTags(['payslip', 'pdf'])
	                            .first() :
	                        null
	                ) 
	__p+='\n\n                <div class="col-lg-6 col-md-6 col-sm-12">\n                    '+
	((__t=( __webpack_require__(803)({
	                        payslip:    payslip,
	                        payslipPdf: payslipPdf,
	                        viewUrl:    '#employee/' + payslip.get('employeeId') + '/payslip/' + payslip.id
	                    }) ))==null?'':__t)+
	'\n                </div>\n            ';
	 }) 
	__p+='\n        ';
	 } 
	__p+='\n    </div>\n\n    <div class="divider"></div>\n\n    <h4>\n        Year-to-Date Totals for\n        <select class="js-ytd-year">\n            ';
	 ytdYears.forEach(function (year) { 
	__p+='\n                <option value="'+
	((__t=( year ))==null?'':_.escape(__t))+
	'" '+
	((__t=( selectedYear == year ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( year ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n        <i class="fa fa-question-circle" data-toggle="tooltip"\n            data-placement="right" data-container="body"\n            data-original-title="These are the year-to-date totals of\n                all the payslips created for this employee during the course\n                of the current year. If he or she was employed elsewhere and\n                information regarding his previous payslips was provided, they\n                are included as well."></i>\n    </h4>\n\n    <div class="ytd-tabs tabs-container">\n        <ul class="nav nav-tabs">\n            <li>\n                <a data-toggle="tab" href="#prev-employment-tab"\n                    data-tab="prev-employment">\n                    Previous Employment\n                </a>\n            </li>\n            <li class="active">\n                <a data-toggle="tab" href="#curr-employment-tab"\n                    data-tab="curr-employment">\n                    Current Employment\n                </a>\n            </li>\n        </ul>\n        <div class="tab-content">\n            <div id="prev-employment-tab" data-tab-name="prev-employment"\n                class="tab-pane">\n                <table class="footable table table-stripped">\n                    <thead>\n                        <tr>\n                            <th>Item</th>\n                            <th style="width: 10%; max-width: 100px;">RM</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        ';
	 rows = itemYearlyTotals 
	__p+='\n                        ';
	 if (rows.length === 0) { 
	__p+='\n                            <tr>\n                                <td colspan="2" class="text-center">\n                                    <h5>There\'s no previous employment data.</h5>\n                                </td>\n                            </tr>\n                        ';
	 } else { 
	__p+='\n                            ';
	 rows.forEach(function(model) { 
	__p+='\n                                <tr class="'+
	((__t=( (model.dirty() || model.isNew()) ?
	                                    'tainted' : '' ))==null?'':_.escape(__t))+
	'">\n                                    <td>\n                                        ';
	 if (model.getPayrollItemName() === 'Salary (Gross)') { 
	__p+='\n                                            Salary (Basic)\n                                        ';
	 } else { 
	__p+='\n                                            '+
	((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                                        ';
	 } 
	__p+='\n                                    </td>\n                                    <td>'+
	((__t=( model.get('prevEmploymentAmount').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                </tr>\n                            ';
	 }); 
	__p+='\n                        ';
	 } 
	__p+='\n                    <tbody>\n                </table>\n            </div>\n            <div id="curr-employment-tab" data-tab-name="curr-employment"\n                class="active tab-pane">\n                <table class="footable table table-stripped">\n                    <thead>\n                        <tr>\n                            <th>Item</th>\n                            <th style="width: 10%; max-width: 100px;">RM</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        ';
	 rows = itemYearlyTotals 
	__p+='\n                        ';
	 if (rows.length === 0) { 
	__p+='\n                            <tr>\n                                <td colspan="2" class="text-center">\n                                    <h5>There\'s no current employment data.</h5>\n                                </td>\n                            </tr>\n                        ';
	 } else { 
	__p+='\n                            ';
	 rows.forEach(function(model) { 
	__p+='\n                                <tr class="'+
	((__t=( (model.dirty() || model.isNew()) ?
	                                    'tainted' : '' ))==null?'':_.escape(__t))+
	'">\n                                    <td>\n                                        ';
	 if (model.getPayrollItemName() === 'Salary (Gross)') { 
	__p+='\n                                            Salary (Basic)\n                                        ';
	 } else { 
	__p+='\n                                            '+
	((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
	'\n                                        ';
	 } 
	__p+='\n                                    </td>\n                                    <td>'+
	((__t=( model.get('amount').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                </tr>\n                            ';
	 }); 
	__p+='\n                        ';
	 } 
	__p+='\n                    <tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/PayslipCard.ejs -->\n<div class="panel panel-default panel-payslip-card">\n    <div class="panel-heading">\n        '+
	((__t=( payslip.getPeriodFormatted() ))==null?'':_.escape(__t))+
	'\n    </div>\n    <div class="panel-body">\n        <div class="income">\n            RM '+
	((__t=( payslip.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n        </div>\n        <div>Net Income</div>\n    </div>\n    <ul class="list-group">\n        <li class="list-group-item">\n            <div class="row">\n                <div class="col-xs-4 col-sm-4">\n                    <div class="tax-label">PCB</div>\n                    <div class="tax-amount">\n                        '+
	((__t=( (payslip.get('mtd') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </div>\n                </div>\n                <div class="col-xs-4 col-sm-4">\n                    <div class="tax-label">EPF</div>\n                    <div class="tax-amount">\n                        '+
	((__t=( (payslip.get('employeeEpf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </div>\n                </div>\n                <div class="col-xs-4 col-sm-4">\n                    <div class="tax-label">SOCSO</div>\n                    <div class="tax-amount">\n                        '+
	((__t=( (payslip.get('employeeSocso') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
	'\n                    </div>\n                </div>\n            </div>\n        </li>\n        <li class="list-group-item text-right">\n            <a href="'+
	((__t=( viewUrl || ('#view/' + payslip.id) ))==null?'':_.escape(__t))+
	'" type="button"\n                class="btn btn-outline btn-success">\n                <i class="fa fa-eye"></i>\n                View\n            </a>\n            <a href="'+
	((__t=( payslipPdf ? payslipPdf.downloadUrl() : '' ))==null?'':_.escape(__t))+
	'"\n                target="_blank"\n                class="btn btn-outline btn-primary\n                    '+
	((__t=( payslipPdf ? '' : 'disabled' ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-file-pdf-o"></i>\n                Download\n            </a>\n        </li>\n    </ul>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var template = __webpack_require__(805);
	var RowTpl = __webpack_require__(806);
	var ShowMoreBtnTpl = __webpack_require__(807);
	var loader = __webpack_require__(534);
	
	module.exports = Backbone.View.extend({
	    tabName: 'div',
	
	    initialize: function initialize(options) {
	        this.limit = (this.collection.pagination || {}).limit || 10;
	        this.skip = 0;
	        this.fetchMore = options.fetchMore;
	        this.layerMap = options.layerMap;
	    },
	
	    events: {
	        'click .js-show-more-btn': 'showMore'
	    },
	
	    render: function render() {
	        var showMoreBtn = ShowMoreBtnTpl();
	        this.$el.html(template({
	            collection: this.collection,
	            RowTpl: RowTpl,
	            showMoreBtn: showMoreBtn,
	            limit: (this.collection.pagination || {}).limit || this.limit
	        }));
	        this.appendActionLogs(this.collection);
	        return this;
	    },
	
	    showMore: function showMore(e) {
	        var skip = this.skip + this.limit;
	        var stopLoader = loader.startFullScreen(e.currentTarget);
	
	        this.fetchMore({
	            skip: skip,
	            limit: this.limit
	        }).then(function (actionLogs) {
	            this.skip += this.limit;
	            this.appendActionLogs(actionLogs);
	        }.bind(this)).finally(stopLoader);
	    },
	
	    appendActionLogs: function appendActionLogs(actionLogs) {
	        var _this = this;
	
	        if (!actionLogs.length) {
	            this.$('.js-show-more-btn').hide();
	        }
	
	        (0, _bluebird.each)(actionLogs, function (actionLog) {
	            var _ref = actionLog.get('metadata') || {},
	                leaveTypeName = _ref.leaveTypeName;
	
	            return actionLog.fetchEmployee().then(function () {
	                return leaveTypeName ? (0, _bluebird.resolve)() : actionLog.fetchLeaveType();
	            }).then(function () {
	                _this.$('tbody').append(RowTpl({
	                    actionLog: actionLog,
	                    employee: actionLog.getEmployee(),
	                    leaveTypeName: leaveTypeName || actionLog.getLeaveType().get('name'),
	                    layer: _this.layerMap && _this.layerMap[actionLog.get('employeeId')] || 0
	                }));
	                return (0, _bluebird.resolve)(true);
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/ActionLogContent.ejs -->\n<div class="action-log">\n    <table class="footable table table-striped">\n        <tbody>\n            ';
	 if (collection.length === 0) { 
	__p+='\n                <tr class="table-no-entries">\n                    <td>\n                        <h2>There are currently no entries</h2>\n                    </td>\n                </tr>\n            ';
	 } 
	__p+='\n        </tbody>\n    </table>\n\n    ';
	 if (collection.length >= limit) { 
	__p+='\n        '+
	((__t=( showMoreBtn ))==null?'':__t)+
	'\n    ';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/ActionLogRow.ejs -->\n';
	
	    var subType = actionLog.get('subType');
	    var isEmployeeUser = ['request', 'cancel'].indexOf(subType) > -1;
	    var imageUrl = employee.getImageUrl() || ''
	
	__p+='\n<tr>\n    <td class="min-percent-width v-align-middle">\n        <div class="user-image"\n             style="background-image: url('+
	((__t=( imageUrl ))==null?'':_.escape(__t))+
	');">\n            <abbr>\n                '+
	((__t=( employee.has('imageUrl') ? '' :
	                    employee.getNameAbbreviation() ))==null?'':_.escape(__t))+
	'\n            </abbr>\n        </div>\n    </td>\n    <td class="max-width-none v-align-middle"\n        data-name="'+
	((__t=( isEmployeeUser ? employee.get('fullName') : actionLog.get('userName') ))==null?'':_.escape(__t))+
	'"\n        data-leaveType="'+
	((__t=( leaveTypeName ))==null?'':_.escape(__t))+
	'"\n        data-leaveDateFrom="'+
	((__t=( (actionLog.get('metadata') || {}).dateFrom ))==null?'':_.escape(__t))+
	'"\n        data-leaveDateTo="'+
	((__t=( (actionLog.get('metadata') || {}).dateTo ))==null?'':_.escape(__t))+
	'"\n        data-approveStatus="'+
	((__t=( subType ))==null?'':_.escape(__t))+
	'"\n    >\n        '+
	((__t=( isEmployeeUser ? employee.get('fullName') : actionLog.get('userName') ))==null?'':_.escape(__t))+
	'\n        <br>\n        <span class="font-bold">\n            '+
	((__t=( actionLog.getMetadata() ))==null?'':_.escape(__t))+
	' - '+
	((__t=( leaveTypeName ))==null?'':_.escape(__t))+
	'\n        </span>\n        <br>\n        '+
	((__t=( actionLog.getCreatedTime() ))==null?'':_.escape(__t))+
	'\n        '+
	((__t=( actionLog.getCreatedAt() ))==null?'':_.escape(__t))+
	'\n    </td>\n    <td class="text-nowrap min-percent-width v-align-middle text-right hidden-xs">\n        ';
	 if (actionLog.getLink(layer)) { 
	__p+='\n            <b><a href="'+
	((__t=( actionLog.getLink() ))==null?'':_.escape(__t))+
	'" class="'+
	((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
	'">'+
	((__t=( actionLog.getApprovalType() ))==null?'':_.escape(__t))+
	'</a></b>\n        ';
	 } else { 
	__p+='\n            <b class="'+
	((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
	'"></b>'+
	((__t=( actionLog.getApprovalType() ))==null?'':_.escape(__t))+
	'</b>\n        ';
	 } 
	__p+='\n    </td>\n    <td class="min-percent-width v-align-middle '+
	((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
	'">\n        ';
	 if (actionLog.getLink(layer)) { 
	__p+='\n            <a href="'+
	((__t=( actionLog.getLink() ))==null?'':_.escape(__t))+
	'" class="'+
	((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-'+
	((__t=( actionLog.getIconClass() ))==null?'':_.escape(__t))+
	' fa-lg"></i>\n            </a>\n        ';
	 } else { 
	__p+='\n            <i class="fa fa-'+
	((__t=( actionLog.getIconClass() ))==null?'':_.escape(__t))+
	' fa-lg"></i>\n        ';
	 } 
	__p+='\n    </td>\n</tr>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/ActionLogShowMoreBtn.ejs -->\n<div class="margin-bottom-large display-inline-block">\n    <button class="js-show-more-btn btn btn-primary btn-large ladda-button"\n            data-style="swap">\n        <i class="fa fa-arrow-down"></i> Show More\n    </button>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var PayslipView = __webpack_require__(749);
	var template = __webpack_require__(809);
	
	module.exports = Backbone.View.extend({
	    tabName: 'div',
	    className: 'ibox-content',
	
	    events: {
	        'click .js-back-link': 'back'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            payslip: null,
	            itemYearlyTotals: null,
	            payslipDetails: null,
	            companyLocation: null
	        });
	
	        return this.render();
	    },
	
	    back: function back() {
	        window.history.back();
	        return this;
	    },
	
	    render: function render() {
	        this.$el.html(template({}));
	
	        this.view = new PayslipView(this.options);
	
	        this.$el.append(this.view.el);
	
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/employee/Payslip.ejs -->\n<a class="previous-link js-back-link">\n    <i class="fa fa-angle-left"></i> \n    Back to Previous Payslip\n</a> \n    \n<br/>\n\n<div class="js-payslip-wrapper"></div>\n';
	}
	return __p;
	};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {/* global Backbone */
	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Main = __webpack_require__(811);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _JobStatus = __webpack_require__(812);
	
	var _JobStatus2 = _interopRequireDefault(_JobStatus);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _bulkUpload = __webpack_require__(813);
	
	var _bulkUpload2 = _interopRequireDefault(_bulkUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var log = (0, _log2.default)('employees/bulk-upload');
	
	module.exports = Backbone.View.extend({
	    events: {
	        'change input[type="file"]': 'selectFile',
	        'click .js-action-1': 'uploadFile'
	    },
	
	    render: function render() {
	        this.$el.html((0, _Main2.default)({
	            model: this.model || false
	        }));
	        this.$('.js-action-1').prop('disabled', true);
	
	        if (this.model && this.model.get('state') !== 'done') {
	            this.renderJobStatus();
	        }
	        return this;
	    },
	
	    selectFile: function selectFile(e) {
	        var _this = this;
	
	        var files = [].concat(_toConsumableArray(this.$(e.currentTarget)[0].files));
	
	        if (files.length === 0) {
	            return;
	        }
	
	        var file = files.shift();
	        var ext = file.name.split('.').pop();
	
	        if (!ext.match(/^(xls|xlsx)$/i)) {
	            return _alerts2.default.show('error', {
	                title: 'Wrong file type',
	                text: 'Please choose an Excel file'
	            });
	        }
	
	        this.$('.js-action-1').prop('disabled', false);
	        this._file = file;
	        this.$('.js-file-name').text(this._file.name);
	        if (this.$result) {
	            this.$result.fadeOut(50, function () {
	                _this.$('.js-result').html('');
	            });
	        }
	    },
	
	    uploadFile: function uploadFile() {
	        var _this2 = this;
	
	        this.$('.js-file-btn').prop('disabled', true);
	
	        var stopLoader = _loader2.default.startFullScreen(this.$('.js-action-1'));
	        var file = this._file;
	        var originalName = file.name;
	        var ext = originalName.split('.').pop();
	
	        return new _bluebird2.default(function (resolve, reject) {
	            var reader = new FileReader();
	            reader.onload = function (ev) {
	                var base64 = ev.target.result.split(',')[1];
	                _this2.model = new _bulkUpload2.default({
	                    file: {
	                        name: 'spreadsheet.' + ext,
	                        content: base64
	                    },
	                    companyId: app.company.id
	                });
	                return resolve(true);
	            };
	            reader.onerror = function (err) {
	                return reject(err);
	            };
	            reader.readAsDataURL(file);
	        }).then(function () {
	            return _this2.model.save();
	        }).then(function () {
	            _this2.render();
	        }).finally(stopLoader);
	    },
	
	    renderJobStatus: function renderJobStatus() {
	        var _this3 = this;
	
	        if (!this.model) {
	            this.$('.js-status').html('');
	            return;
	        }
	
	        this.renderJobStatusTemplate();
	
	        var refresh = function refresh() {
	            if (!_this3.model || _this3.model.get('state') === 'done') {
	                return app.company.fetch().catch(log.error).finally(function () {
	                    _this3.render();
	                    _this3.renderJobStatusTemplate();
	                });
	            }
	
	            setTimeout(function () {
	                return _this3.model.fetch().then(function () {
	                    _this3.renderJobStatusTemplate();
	                    refresh();
	                });
	            }, 2000);
	        };
	        refresh();
	    },
	
	    renderJobStatusTemplate: function renderJobStatusTemplate() {
	        this.$('.js-status').html((0, _JobStatus2.default)({ model: this.model }));
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/bulkUpload/Main.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Employee Bulk Upload</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="ibox float-e-margins\n        '+
	((__t=( model && model.get('state') !== 'done' ? 'hidden': '' ))==null?'':_.escape(__t))+
	'">\n        <div class="ibox-title">\n            <h5>Choose a file and click \'Continue\'</h5>\n        </div>\n        <div class="ibox-content tab-content">\n            <div class="flex-container-row">\n                <label class="js-file-btn btn btn-w-m btn-success ladda-button"\n                data-style="swap">\n                    Select File\n                    <input type="file" class="js-file-input hide">\n                </label>\n                <span class="js-file-name m-l-md">\n                    No file chosen\n                </span>\n            </div>\n            <div class="row m-t-md m-l-sm">                \n                <a href="'+
	((__t=( app.company.bulkEmployeesTemplateDownloadUrl() ))==null?'':_.escape(__t))+
	'">\n                    Download template\n                </a>\n            </div>\n\n            <div class="row">\n                <div class="col-md-2 col-md-offset-10">\n                    <button type="button" class="btn btn-primary js-action-1">\n                        Continue\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="js-status"></div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/bulkUpload/JobStatus.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        ';
	 if (model.get('state') === 'pending') { 
	__p+='\n            <h5>File uploaded. Process about to start...</h5>\n        ';
	 } else if (model.get('state') === 'processing') { 
	__p+='\n            <h5>Creating employees...</h5>\n        ';
	 } else { 
	__p+='\n            <h5>Bulk upload complete.</h5>\n        ';
	 } 
	__p+='\n    </div>\n    <div class="ibox-content tab-content">\n        ';
	 if (model.get('state') !== 'done') { 
	__p+='\n            <div>\n                <i class="fa fa-clock-o"></i>\n                <label>Awaiting results...</label>\n            </div>\n        ';
	 } else { 
	__p+='\n            ';
	 if (model.get('successes').length) { 
	__p+='\n                <div>\n                    <i class="fa fa-check green" aria-hidden="true"></i>\n                    <label>\n                        Successfully imported\n                        '+
	((__t=( model.get('successes').length ))==null?'':_.escape(__t))+
	' employees\n                    </label>\n                </div>\n            ';
	 } 
	__p+='\n\n            ';
	 if (model.get('successes').length && model.get('uploadErrors').length) { 
	__p+='\n                <hr/>\n            ';
	 } 
	__p+='\n\n            ';
	 if (model.get('uploadErrors').length) { 
	__p+='\n                <div>\n                    <label>\n                        There were some errors when trying to import the\n                        following employees:\n                    </label>\n                </div>\n                <div>\n                    ';
	 model.get('uploadErrors').forEach(function (e) { 
	__p+='\n                        <div>\n                            <i class="fa fa-times red" aria-hidden="true"></i>\n                            <span>'+
	((__t=( e.name ))==null?'':_.escape(__t))+
	'</span>\n                            <ul>\n                                ';
	 e.errors.forEach(function (error) { 
	__p+='\n                                    <li>'+
	((__t=( error ))==null?'':_.escape(__t))+
	'</li>\n                                ';
	 }); 
	__p+='\n                            </ul>\n                        </div>\n                    ';
	 }); 
	__p+='\n                </div>\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BulkUpload = function (_Model) {
	    _inherits(BulkUpload, _Model);
	
	    _createClass(BulkUpload, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/BulkUploads';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                companyId: app.company && app.company.id,
	                state: 'pending',
	                itemCount: 0,
	                successes: [],
	                uploadErrors: []
	            };
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                file: { presence: {
	                        message: '^A file is required to do a bulk upload'
	                    } },
	                companyId: { presence: true },
	                state: { presence: true }
	            };
	        } // end of constraints
	
	    }]);
	
	    function BulkUpload() {
	        _classCallCheck(this, BulkUpload);
	
	        var _this = _possibleConstructorReturn(this, (BulkUpload.__proto__ || Object.getPrototypeOf(BulkUpload)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(BulkUpload, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(BulkUpload.prototype.__proto__ || Object.getPrototypeOf(BulkUpload.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }]);
	
	    return BulkUpload;
	}(_model2.default);
	
	exports.default = BulkUpload;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {/* global Backbone */
	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _Main = __webpack_require__(815);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _JobStatus = __webpack_require__(816);
	
	var _JobStatus2 = _interopRequireDefault(_JobStatus);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _bulkUpload = __webpack_require__(813);
	
	var _bulkUpload2 = _interopRequireDefault(_bulkUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'change input[type="file"]': 'selectFile',
	        'click .js-action-1': 'uploadFile'
	    },
	
	    render: function render() {
	        this.$el.html((0, _Main2.default)({
	            model: this.model || false
	        }));
	
	        this.$('.js-action-1').prop('disabled', true);
	
	        _tooltip2.default.init(this);
	
	        if (this.model && this.model.get('state') !== 'done') {
	            this.renderJobStatus();
	        }
	        return this;
	    },
	
	    selectFile: function selectFile(e) {
	        var _this = this;
	
	        var files = [].concat(_toConsumableArray(this.$(e.currentTarget)[0].files));
	
	        if (files.length === 0) {
	            return;
	        }
	
	        var file = files.shift();
	        var ext = file.name.split('.').pop();
	
	        if (!ext.match(/^(xls|xlsx)$/i)) {
	            return _alerts2.default.show('error', {
	                title: 'Wrong file type',
	                text: 'Please choose an Excel file'
	            });
	        }
	
	        this.$('.js-action-1').prop('disabled', false);
	        this._file = file;
	        this.$('.js-file-name').text(this._file.name);
	        if (this.$result) {
	            this.$result.fadeOut(50, function () {
	                _this.$('.js-result').html('');
	            });
	        }
	    },
	
	    uploadFile: function uploadFile() {
	        var _this2 = this;
	
	        this.$('.js-file-btn').prop('disabled', true);
	
	        var stopLoader = _loader2.default.startFullScreen(this.$('.js-action-1'));
	        var file = this._file;
	        var originalName = file.name;
	        var ext = originalName.split('.').pop();
	
	        return new _bluebird2.default(function (resolve, reject) {
	            var reader = new FileReader();
	            reader.onload = function (ev) {
	                var base64 = ev.target.result.split(',')[1];
	                _this2.model = new _bulkUpload2.default({
	                    type: 'payslip',
	                    file: {
	                        name: 'spreadsheet.' + ext,
	                        content: base64
	                    },
	                    companyId: app.company.id
	                });
	                return resolve(true);
	            };
	            reader.onerror = function (err) {
	                return reject(err);
	            };
	            reader.readAsDataURL(file);
	        }).then(function () {
	            return _this2.model.save();
	        }).then(function () {
	            _this2.render();
	        }).finally(stopLoader);
	    },
	
	    renderJobStatus: function renderJobStatus() {
	        var _this3 = this;
	
	        if (!this.model) {
	            this.$('.js-status').html('');
	            return;
	        }
	
	        this.$('.js-status').html((0, _JobStatus2.default)({
	            model: this.model
	        }));
	
	        var refresh = function refresh() {
	            if (!_this3.model || _this3.model.get('state') === 'done') {
	                _this3.render();
	                _this3.$('.js-status').html((0, _JobStatus2.default)({
	                    model: _this3.model
	                }));
	                return;
	            }
	
	            setTimeout(function () {
	                _this3.model.fetch().then(function () {
	                    _this3.$('.js-status').html((0, _JobStatus2.default)({
	                        model: _this3.model
	                    }));
	                    refresh();
	                });
	            }, 2000);
	        };
	        refresh();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/bulkUploadPayslips/Main.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Upload Previous Payslip Information for Current Employment</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="ibox float-e-margins\n        '+
	((__t=( model && model.get('state') !== 'done' ? 'hidden': '' ))==null?'':_.escape(__t))+
	'">\n        <div class="ibox-title">\n            <h5>Choose a file and click \'Continue\'</h5>\n        </div>\n        <div class="ibox-content tab-content">\n            <div class="flex-container-row">\n                <label class="js-file-btn btn btn-w-m btn-success ladda-button"\n                data-style="swap">\n                    Select File\n                    <input type="file" class="js-file-input hide">\n                </label>\n                <span class="js-file-name m-l-md">\n                    No file chosen\n                </span>\n            </div>\n            <div class="row m-t-md m-l-sm">\n                <a href="'+
	((__t=( app.company.payslipsTemplateDownloadUrl() ))==null?'':_.escape(__t))+
	'">\n                    Download template\n                </a>\n            </div>\n\n            <div class="row m-t-md">\n                <div class="col-md-10">\n                    Note:\n                    Include only previous salary from current employment.\n                    If there are payroll items which you would like to add but\n                    they are not in the template, you have to add them from the\n                    app under Employee > Select Employee > Previous Payslips.\n                </div>\n\n                <div class="col-md-2">\n                    <button type="button" class="btn btn-primary js-action-1">\n                        Continue\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="js-status"></div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/bulkUploadPayslips/JobStatus.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        ';
	 if (model.get('state') === 'pending') { 
	__p+='\n            <h5>File uploaded. Process about to start...</h5>\n        ';
	 } else if (model.get('state') === 'processing') { 
	__p+='\n            <h5>Creating payslips...</h5>\n        ';
	 } else { 
	__p+='\n            <h5>Bulk upload complete.</h5>\n        ';
	 } 
	__p+='\n    </div>\n    <div class="ibox-content tab-content">\n        ';
	 if (model.get('state') !== 'done') { 
	__p+='\n            <div>\n                <i class="fa fa-clock-o"></i>\n                <label>Awaiting results...</label>\n            </div>\n        ';
	 } else { 
	__p+='\n            ';
	 if (model.get('itemCount')) { 
	__p+='\n                <div>\n                    <i class="fa fa-check green" aria-hidden="true"></i>\n                    <label>\n                        Successfully imported\n                        '+
	((__t=( model.get('itemCount') ))==null?'':_.escape(__t))+
	' payslips\n                    </label>\n                </div>\n            ';
	 } else { 
	__p+='\n                <div>\n                    <i class="fa fa-times red" aria-hidden="true"></i>\n                    <label>\n                        No data imported.\n                        ';
	 if (model.get('uploadErrors').length === 0) { 
	__p+='\n                            This is probably because employees already have previous payslips.\n                        ';
	 } 
	__p+='\n                    </label>\n                </div>\n            ';
	 } 
	__p+='\n\n            ';
	 if (model.get('itemCount') && model.get('uploadErrors').length) { 
	__p+='\n                <hr/>\n            ';
	 } 
	__p+='\n\n            ';
	 if (model.get('uploadErrors').length) { 
	__p+='\n                <div>\n                    <label>\n                        There were some errors when trying to import payslips:\n                    </label>\n                </div>\n                <div>\n                    ';
	 model.get('uploadErrors').forEach(function (e) { 
	__p+='\n                        <div>\n                            <i class="fa fa-times red" aria-hidden="true"></i>\n                            <span>'+
	((__t=( e.name ))==null?'':_.escape(__t))+
	'</span>\n                            <ul>\n                                ';
	 e.errors.forEach(function (error) { 
	__p+='\n                                    <li>'+
	((__t=( error ))==null?'':_.escape(__t))+
	'</li>\n                                ';
	 }); 
	__p+='\n                            </ul>\n                        </div>\n                    ';
	 }); 
	__p+='\n                </div>\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _actionLog = __webpack_require__(818);
	
	var _actionLog2 = _interopRequireDefault(_actionLog);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionLogs = function (_Collection) {
	    _inherits(ActionLogs, _Collection);
	
	    function ActionLogs() {
	        _classCallCheck(this, ActionLogs);
	
	        return _possibleConstructorReturn(this, (ActionLogs.__proto__ || Object.getPrototypeOf(ActionLogs)).apply(this, arguments));
	    }
	
	    _createClass(ActionLogs, [{
	        key: 'url',
	        value: function url() {
	            return '/ActionLogs';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.model = _actionLog2.default;
	            _get(ActionLogs.prototype.__proto__ || Object.getPrototypeOf(ActionLogs.prototype), 'initialize', this).apply(this, arguments);
	
	            this.pagination.offset = 0;
	            this.pagination.limit = 10;
	            this.pagination.page = 0;
	            this.pagination.pages = 0;
	            this.pagination.count = 0;
	
	            this.options.sortKey = 'createdAt';
	            this.options.sortOrder = 'descending';
	            return this;
	        }
	    }, {
	        key: 'fetchForEmployee',
	        value: function fetchForEmployee(employee) {
	            var _this2 = this;
	
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { limit: undefined, skip: undefined };
	
	            return _axios2.default.get(this.finalUrl() + '/getOwnAndManaged/' + employee.id, {
	                params: {
	                    limit: options.limit || 10,
	                    skip: options.skip
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data.results;
	            }).then(function (results) {
	                _this2.reset(results, { silent: true });
	
	                // save some requests by setting information we already know
	                // about (employee and user) whenever possible
	                _this2.forEach(function (model) {
	                    if (model.get('employeeId') === employee.id) {
	                        model.employee = employee;
	                    }
	                    if (model.get('userId') === app.user.id) {
	                        model.user = app.user;
	                    }
	                });
	                _this2.trigger('sync');
	                return _this2;
	            });
	        }
	    }, {
	        key: 'fetchForCompany',
	        value: function fetchForCompany(company) {
	            var _this3 = this;
	
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { limit: undefined, skip: undefined };
	
	            return _axios2.default.get(this.finalUrl() + '/getForCompany/' + company.id, {
	                params: {
	                    limit: options.limit || 10,
	                    skip: options.skip
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id }
	            }).then(function (r) {
	                return r.data.results;
	            }).then(function (results) {
	                _this3.reset(results, { silent: true });
	                // save some requests by setting information we already know
	                // about (user) whenever possible
	                _this3.forEach(function (model) {
	                    if (model.get('userId') === app.user.id) {
	                        model.user = app.user;
	                    }
	                });
	                _this3.trigger('sync');
	                return _this3;
	            });
	        }
	    }]);
	
	    return ActionLogs;
	}(_collection2.default);
	
	exports.default = ActionLogs;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bluebird = __webpack_require__(63);
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _employee = __webpack_require__(571);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _leaveRequest2 = _interopRequireDefault(_leaveRequest);
	
	var _leaveType = __webpack_require__(630);
	
	var _leaveType2 = _interopRequireDefault(_leaveType);
	
	var _leaveRequest3 = __webpack_require__(753);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionLog = function (_Model) {
	    _inherits(ActionLog, _Model);
	
	    _createClass(ActionLog, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/ActionLogs';
	        }
	    }]);
	
	    function ActionLog() {
	        _classCallCheck(this, ActionLog);
	
	        var _this = _possibleConstructorReturn(this, (ActionLog.__proto__ || Object.getPrototypeOf(ActionLog)).apply(this, arguments));
	
	        _this.employee = null;
	        _this.user = null;
	        _this.approvedBy = null;
	        _this.leaveType = null;
	        return _this;
	    }
	
	    _createClass(ActionLog, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(ActionLog.prototype.__proto__ || Object.getPrototypeOf(ActionLog.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }, {
	        key: 'fetchUser',
	        value: function fetchUser() {
	            var _this2 = this;
	
	            if (this.user) {
	                return (0, _bluebird.resolve)(this.user);
	            }
	
	            return new _user2.default({ id: this.get('userId') }).fetch().then(function (model) {
	                _this2.user = model;
	                return _this2.user;
	            });
	        }
	    }, {
	        key: 'getEmployee',
	        value: function getEmployee() {
	            return this.employee;
	        }
	    }, {
	        key: 'fetchEmployee',
	        value: function fetchEmployee() {
	            var _this3 = this;
	
	            if (this.employee) {
	                return (0, _bluebird.resolve)(this.employee);
	            }
	
	            if (!this.get('employeeId')) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            var employee = app.employees.find(function (emp) {
	                return emp.get('objectId') === _this3.get('employeeId');
	            });
	            if (employee) {
	                this.employee = employee;
	                return (0, _bluebird.resolve)(employee);
	            }
	
	            return new _employee2.default({ objectId: this.get('employeeId') }).fetch().then(function (model) {
	                _this3.employee = model;
	                return _this3.employee;
	            });
	        }
	    }, {
	        key: 'getCreatedAt',
	        value: function getCreatedAt() {
	            return (0, _moment2.default)(this.get('createdAt')).fromNow();
	        }
	    }, {
	        key: 'getCreatedTime',
	        value: function getCreatedTime() {
	            return (0, _moment2.default)(this.get('createdAt')).format('hh:mm a');
	        }
	    }, {
	        key: 'getLeaveType',
	        value: function getLeaveType() {
	            return this.leaveType;
	        }
	    }, {
	        key: 'fetchLeaveType',
	        value: function fetchLeaveType() {
	            var _this4 = this;
	
	            if (!this.get('metadata').leaveRequestId) {
	                return (0, _bluebird.resolve)(null);
	            }
	
	            return new _leaveRequest2.default({
	                objectId: this.get('metadata').leaveRequestId
	            }).fetch().then(function (model) {
	                var leaveType = app.leaveTypes.find(function (type) {
	                    return type.get('objectId') === model.get('typeId');
	                });
	                if (leaveType) {
	                    _this4.leaveType = leaveType;
	                    return _this4.leaveType;
	                }
	                return new _leaveType2.default({
	                    objectId: model.get('typeId')
	                }).fetch().then(function (model) {
	                    _this4.leaveType = model;
	                    return _this4.leaveType;
	                });
	            });
	        }
	    }, {
	        key: 'getApprovalType',
	        value: function getApprovalType() {
	            var type = this.get('type');
	            if (type !== 'leave-request') {
	                return null;
	            }
	            var subType = this.get('subType');
	            var leaveRequestMap = {
	                request: 'Requested',
	                approve: 'Approved',
	                cancel: 'Cancelled',
	                reject: 'Rejected'
	            };
	            return leaveRequestMap[subType] || 'Leave';
	        }
	    }, {
	        key: 'getMetadata',
	        value: function getMetadata() {
	            var type = this.get('type');
	            var metadata = this.get('metadata');
	            if (type === 'leave-request') {
	                var dateFrom = (0, _moment2.default)(metadata.dateFrom);
	                if (!metadata.dateTo) {
	                    return dateFrom.format('D MMM');
	                }
	                var dateTo = (0, _moment2.default)(metadata.dateTo);
	                return dateFrom.format('D MMM') + ' to ' + dateTo.format('D MMM');
	            }
	        }
	    }, {
	        key: 'getIconClass',
	        value: function getIconClass() {
	            var type = this.get('type');
	            if (type !== 'leave-request') {
	                return null;
	            }
	            var subType = this.get('subType');
	            var leaveRequestMap = {
	                request: 'calendar-plus-o',
	                approve: 'calendar-check-o',
	                cancel: 'calendar-times-o',
	                reject: 'remove'
	            };
	            return leaveRequestMap[subType];
	        }
	    }, {
	        key: 'getTextColor',
	        value: function getTextColor() {
	            var type = this.get('type');
	            if (type !== 'leave-request') {
	                return null;
	            }
	            var subType = this.get('subType');
	            var leaveRequestMap = {
	                request: 'text-success',
	                approve: 'text-navy',
	                cancel: 'text-danger',
	                reject: 'text-danger'
	            };
	            return leaveRequestMap[subType];
	        }
	    }, {
	        key: 'getLink',
	        value: function getLink() {
	            var layer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (this.get('type') === 'leave-request') {
	                var metadata = this.get('metadata');
	                if (metadata.status === _leaveRequest3.consts.STATUS_AWAITING && layer > (metadata.approvalStatus || 0) + 1) {
	                    return false;
	                }
	
	                return '#calendar/' + metadata.leaveRequestId + '/view';
	            }
	
	            return false;
	        }
	    }]);
	
	    return ActionLog;
	}(_model2.default);
	
	exports.default = ActionLog;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _bulkUpload = __webpack_require__(813);
	
	var _bulkUpload2 = _interopRequireDefault(_bulkUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BulkUploads = function (_Collection) {
	    _inherits(BulkUploads, _Collection);
	
	    function BulkUploads() {
	        _classCallCheck(this, BulkUploads);
	
	        return _possibleConstructorReturn(this, (BulkUploads.__proto__ || Object.getPrototypeOf(BulkUploads)).apply(this, arguments));
	    }
	
	    _createClass(BulkUploads, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/bulkUploads';
	            }
	
	            return '/BulkUploads';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models) {
	            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            _get(BulkUploads.prototype.__proto__ || Object.getPrototypeOf(BulkUploads.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _bulkUpload2.default;
	            this.company = company;
	            this.pagination = false;
	            return this;
	        }
	    }]);
	
	    return BulkUploads;
	}(_collection2.default);
	
	exports.default = BulkUploads;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _EmployeeTotals = __webpack_require__(821);
	
	var _EmployeeTotals2 = _interopRequireDefault(_EmployeeTotals);
	
	var _EmployeeLeave = __webpack_require__(825);
	
	var _EmployeeLeave2 = _interopRequireDefault(_EmployeeLeave);
	
	var _Variance = __webpack_require__(831);
	
	var _Variance2 = _interopRequireDefault(_Variance);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _leaveRequests = __webpack_require__(752);
	
	var _leaveRequests2 = _interopRequireDefault(_leaveRequests);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _report = __webpack_require__(822);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _queryString = __webpack_require__(554);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/report-router');
	var view = null; // backbone view
	module.exports = _Base2.default.extend({
	    routes: {
	        'reports/leave': 'leave',
	        'reports/leave?*filtersQueryString': 'leave',
	        'reports/totals': 'totals',
	        'reports/totals?*filtersQueryString': 'totals',
	        'reports/variance': 'variance'
	    },
	
	    titles: {
	        'reports/leave': 'Leave report',
	        'reports/totals': 'Totals report',
	        'reports/variance': 'Variance report'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    leave: function leave(filtersQueryString) {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	        var company = app.company;
	
	        var filters = _.defaults(_queryString2.default.parse(filtersQueryString) || {}, {
	            'period': 'current',
	            'leaveType': '',
	            'employee[]': []
	        });
	
	        if (_typeof(filters['employee[]']) !== 'object') {
	            filters['employee[]'] = [filters['employee[]']];
	        }
	
	        var employeeIds = filters['employee[]'];
	        var balanceMap = {};
	
	        var employees = new _employees2.default(null, {
	            company: company,
	            pagination: false
	        });
	
	        var employeeFetchOptions = {
	            filter: {
	                limit: 9999,
	                where: { cessationDate: null }
	            }
	        };
	        return employees.fetch(employeeFetchOptions).then(function () {
	            employees.forEach(function (emp) {
	                return emp.company = company;
	            });
	
	            var leaveTypeIds = app.leaveTypes.map(function (t) {
	                return t.id;
	            });
	            var requestLeaveType = function requestLeaveType(employeeRequests) {
	                return employeeRequests.map(function (req) {
	                    return req.get('typeId');
	                });
	            };
	
	            var requestLeaveTypeByEmployee = function requestLeaveTypeByEmployee(typeId, employeeId, employeeRequests) {
	                return employeeRequests.filter(function (req) {
	                    return req.get('employeeId') === employeeId && req.get('typeId') === typeId;
	                }).length;
	            };
	
	            var enabledType = app.leaveTypes.filter(function (type) {
	                return !type.get('hiddenAt');
	            }).map(function (type) {
	                return type.id;
	            });
	
	            var defaultLeaveTypes = app.leaveTypes.filter(function (type) {
	                return !type.get('companyId');
	            }).map(function (type) {
	                return type.id;
	            });
	
	            return _leaveRequests2.default.fetchForTypes({
	                typeIds: leaveTypeIds,
	                employeeIds: employees.map(function (e) {
	                    return e.id;
	                })
	            }).then(function (employeeRequests) {
	                var leaveTypes = new _leaveTypes2.default(app.leaveTypes.filter(function (type) {
	                    return requestLeaveType(employeeRequests).includes(type.id) || enabledType.includes(type.id) || defaultLeaveTypes.includes(type.id);
	                }));
	                return _bluebird2.default.all([employeeRequests, leaveTypes]);
	            }).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    employeeRequests = _ref2[0],
	                    leaveTypes = _ref2[1];
	
	                if (!filters.leaveType) {
	                    filters.leaveType = leaveTypeIds[0];
	                } // set initial leaveType
	                if (view) {
	                    //el: this.el in constructor is denying view
	                    // reference to be collected after change route
	                    // so, keep it in a broader variable and clean it up manually
	                    view.remove();
	                }
	                view = new _EmployeeLeave2.default({
	                    el: _this.el,
	                    filters: filters,
	                    employees: employees,
	                    leaveTypes: leaveTypes // filter's leave type
	                });
	
	                var currentLeaveType = leaveTypes.find(function (type) {
	                    return type.id === filters.leaveType;
	                });
	
	                var filteredEmployees = (employeeIds.length ? new _employees2.default(employees.filter(function (e) {
	                    return employeeIds.includes(e.id);
	                })) : employees.clone()).filter(function (employee) {
	                    return !currentLeaveType.get('gender') || currentLeaveType.get('gender') === employee.get('gender');
	                });
	
	                return _bluebird2.default.each(filteredEmployees, function (employee) {
	                    var _employee$getApplicab = employee.getApplicableLeavePeriodDates((0, _moment2.default)()),
	                        start = _employee$getApplicab.start;
	
	                    var periodStartDate = start.toDate();
	                    var periodEndDate = (0, _moment2.default)().toDate();
	                    var includeFutureLeaveTaken = false;
	                    switch (filters.period) {
	                        case 'previous':
	                            var prevPeriod = employee.getApplicableLeavePeriodDates((0, _moment2.default)().subtract(1, 'year').endOf('day'));
	                            periodStartDate = prevPeriod.start.toDate();
	                            periodEndDate = prevPeriod.end.toDate();
	                            includeFutureLeaveTaken = true;
	                            break;
	                        case 'custom':
	                            periodEndDate = filters.date ? (0, _moment2.default)(filters.date, 'YYYY/MM/DD').endOf('day').toDate() : (0, _moment2.default)().toDate();
	                            includeFutureLeaveTaken = false;
	                            periodStartDate = employee.getApplicableLeavePeriodDates(periodEndDate).start.toDate();
	                            break;
	                        case 'current':
	                            includeFutureLeaveTaken = true;
	                            break;
	                        default:
	                            break;
	                    }
	                    return leaveTypes.fetchBalancesMap(employee, periodEndDate, !includeFutureLeaveTaken).then(function (balance) {
	                        balanceMap[employee.id] = balance;
	                        balanceMap[employee.id].employee = employee;
	                        balanceMap[employee.id].types = leaveTypes.filter(function (type) {
	                            return (!type.get('gender') || type.get('gender') === employee.get('gender')) && (requestLeaveTypeByEmployee(type.id, employee.id, employeeRequests) || enabledType.includes(type.id) || defaultLeaveTypes.includes(type.id));
	                        });
	                    });
	                }).then(function () {
	                    view.render(balanceMap);
	                });
	            });
	        }).finally(stopLoader);
	    },
	
	    totals: function totals(filtersQueryString) {
	        var _this2 = this;
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	        var filters = Object.assign({
	            'dateRange': 'current_year',
	            'from': (0, _moment2.default)().startOf('year').toDate(),
	            'to': (0, _moment2.default)().startOf('day').toDate(),
	            'group[]': ''
	        }, _queryString2.default.parse(filtersQueryString) || {});
	
	        var employees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	
	        var locations = new _companyLocations2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	
	        var payrolls = new _payrolls2.default(null, {
	            company: app.company,
	            pagination: false,
	            sortKey: 'periodDate',
	            sortOrder: 'descending'
	        });
	
	        filters.from = filters.from !== '' ? (0, _moment2.default)(filters.from).hour(12).toDate() : '', filters.to = filters.to !== '' ? (0, _moment2.default)(filters.to).hour(12).toDate() : '';
	
	        if (_typeof(filters['group[]']) !== 'object') {
	            filters['group[]'] = [filters['group[]']];
	        }
	
	        var employeesFilter = filters['group[]'];
	        var locationsFilter = filters['group[]'];
	        if (filters.groupBy === 'location') {
	            employeesFilter = null;
	        } else {
	            locationsFilter = null;
	        }
	
	        _bluebird2.default.join(locations.fetch({ filter: { limit: 9999 } }), employees.fetch({
	            filter: {
	                where: {
	                    hasPayslips: true
	                },
	                limit: 9999
	            }
	        }), _report2.default.totals({
	            companyId: app.company.id,
	            employees: employeesFilter,
	            locations: locationsFilter,
	            fromDate: filters.from,
	            toDate: filters.to
	        }), payrolls.fetch({
	            filter: {
	                where: { status: 9 },
	                limit: 9999
	            }
	        })).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 4),
	                a = _ref4[0],
	                b = _ref4[1],
	                totals = _ref4[2],
	                payrolls = _ref4[3];
	
	            var fromPeriod = payrolls.length ? (0, _moment2.default)(payrolls.last().get('periodDate')) : (0, _moment2.default)();
	            var toPeriod = payrolls.length ? (0, _moment2.default)(payrolls.first().get('periodDate')) : (0, _moment2.default)();
	            _this2.view = new _EmployeeTotals2.default({
	                el: _this2.el,
	                employees: employees,
	                locations: locations,
	                filters: filters,
	                totals: totals.totals,
	                grandTotal: totals.grandTotals,
	                fromPeriod: fromPeriod,
	                toPeriod: toPeriod
	            });
	        }).catch(function (error) {
	            log.error(error);
	            _alerts2.default.show('error', {
	                text: 'Failed fetching the data. ' + 'Might\'ve been due to the oversized data. ' + 'Please try filtering your data by shorter period/ less ' + 'employees.',
	                callback: function callback() {
	                    return app.mainRouter.navigate('reports/totals');
	                }
	            });
	        }).finally(stopLoader);
	    },
	
	    variance: function variance() {
	        var _this3 = this;
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	        var payrolls = new _payrolls2.default(null, {
	            company: app.company,
	            pagination: false,
	            sortKey: 'periodDate',
	            sortOrder: 'descending'
	        });
	
	        return payrolls.fetch({
	            filter: {
	                where: { status: 9 },
	                limit: 2
	            }
	        }).then(function () {
	            _this3.view = new _Variance2.default({
	                el: _this3.el,
	                collection: payrolls
	            }).render();
	        }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _report = __webpack_require__(822);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = __webpack_require__(823);
	var moment = __webpack_require__(101);
	
	
	module.exports = Backbone.View.extend({
	    events: {
	        'submit form.filters': 'filter',
	        'changeDate .js-datepicker-range': 'taint',
	        'change input, select': 'taint',
	        'change .js-date-range': 'updateDatepickers',
	        'change .js-group-by': 'updateGroupBy',
	        'change .js-type': 'updateType',
	        'change .js-datepicker-from': 'updateFromDate',
	        'change .js-datepicker-to': 'updateToDate'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            employees: [],
	            locations: [],
	            filters: {
	                'dateRange': null,
	                'from': null,
	                'to': null,
	                'group[]': null,
	                'groupBy': null,
	                'type': null
	            },
	            totals: [],
	            grandTotal: null,
	            fromPeriod: '',
	            toPeriod: ''
	        });
	
	        this.getGroupBy();
	
	        if (this.options.filters.dateRange === this.options.filters.from && this.options.filters.dateRange === this.options.filters.to) {
	            this.options.filters.dateRange = 'everything';
	            this.options.filters.from = this.options.fromPeriod;
	            this.options.filters.to = this.options.toPeriod;
	        }
	
	        return this.render();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        _.each(['from', 'to'], function (key) {
	            if (this.options.filters[key] instanceof Date) {
	                this.options.filters[key + 'Formatted'] = moment(this.options.filters[key]).format('MMMM, YYYY');
	            }
	        }.bind(this));
	
	        this.$el.html(template({
	            group: this.group,
	            dateRanges: this.getDateRanges(),
	            filters: this.options.filters,
	            rows: this.options.totals,
	            rowCount: this.options.totals.length || 0,
	            types: ['Total', 'PCB', 'EPF', 'SOCSO', 'EIS', 'HRDF', 'Zakat', 'Additions', 'Deductions'],
	            groupBy: ['Employee', 'Location'],
	            grandTotal: this.options.grandTotal
	        }));
	
	        this.$('.js-datepicker-range').datepicker({
	            keyboardNavigation: false,
	            forceParse: false,
	            autoclose: true,
	            todayBtn: 'linked',
	            format: 'MM, yyyy',
	            viewMode: 'months',
	            minViewMode: 'months'
	        });
	        this.$('.chosen-select').chosen({ width: '275px' });
	        this.$('.footable').footable();
	        var type = (this.options.filters.type || 'total').toLowerCase();
	        //very crazy logic to hide columns in report,
	        //should be easier if we use HTML 5 at least if divs and flex/grid css
	        if (type !== 'total') {
	            var half = { width: '50%' };
	            this.$('.js-rows td').not('[name=' + type + ']').hide();
	            this.$('.js-rows td[name=fullname]').show();
	            this.$('.js-rows td[name=' + type + ']').css(half);
	
	            this.$('.second-header th').not('[name=' + type + ']').hide();
	            this.$('.second-header th[name=fullname]').show();
	            this.$('.second-header th[name=' + type + ']').css(half);
	
	            this.$('.first-header th').not('[name=' + type + ']').hide();
	            this.$('.first-header th[name=fullname]').show();
	            this.$('.first-header th[name=' + type + ']').css(half);
	
	            this.$('.employee-total td').not('[name=' + type + ']').hide();
	            this.$('.employee-total td[name=fullname]').show();
	            this.$('.employee-total td[name=' + type + ']').css(half);
	        }
	        this.$('.js-rows [name=fullname]').on('click', function (ev) {
	            _this.$(ev.currentTarget).parent().find('.details').toggleClass('hidden');
	        });
	
	        if (this.options.filters.dateRange === 'everything') {
	            var $from = this.$('.js-datepicker-from');
	            var $to = this.$('.js-datepicker-to');
	            $from.datepicker('setDate', this.options.fromPeriod.toDate());
	            $to.datepicker('setDate', this.options.toPeriod.toDate());
	        }
	
	        this.updateDownloadLink();
	    },
	
	    momentStartOf: function momentStartOf(what) {
	        return moment().startOf(what).add(1, 'days');
	    },
	
	    momentEndOf: function momentEndOf(what) {
	        return moment().endOf(what);
	    },
	
	    getDateRanges: function getDateRanges() {
	        return {
	            'current_month': {
	                label: 'Current Month',
	                from: this.momentStartOf('month'),
	                to: this.momentEndOf('month')
	            },
	            'last_month': {
	                label: 'Last Month',
	                from: this.momentStartOf('month').subtract(1, 'month'),
	                to: this.momentStartOf('month').subtract(1, 'month').endOf('month')
	            },
	            'current_quarter': {
	                label: 'Current Quarter',
	                from: this.momentStartOf('quarter'),
	                to: this.momentEndOf('quarter')
	            },
	            'last_quarter': {
	                label: 'Last Quarter',
	                from: this.momentStartOf('quarter').subtract(1, 'quarter'),
	                to: this.momentStartOf('quarter').subtract(1, 'quarter').endOf('quarter')
	            },
	            'current_year': {
	                label: 'Current Year',
	                from: this.momentStartOf('year'),
	                to: this.momentEndOf('year')
	            },
	            'last_year': {
	                label: 'Last Year',
	                from: this.momentStartOf('year').subtract(1, 'year'),
	                to: this.momentStartOf('year').subtract(1, 'year').endOf('year')
	            },
	            'sign_up': {
	                label: 'Since Signing Up',
	                from: moment(app.company.get('createdAt')),
	                to: moment(app.company.get('createdAt')).add(1, 'year')
	            }
	        };
	    },
	
	    updateDatepickers: function updateDatepickers(ev) {
	        var $select = this.$(ev.currentTarget);
	        var $option = $select.find(':selected');
	        var $from = this.$('.js-datepicker-from');
	        var $to = this.$('.js-datepicker-to');
	        var from = moment($option.data('from')).toDate();
	        var to = moment($option.data('to')).toDate();
	
	        $from.prop('disabled', $option.data('from') !== undefined);
	        $to.prop('disabled', $option.data('to') !== undefined);
	
	        if ($option.data('from') !== undefined) {
	            $from.datepicker('setDate', from);
	        }
	
	        if ($option.data('to') !== undefined) {
	            $to.datepicker('setDate', to);
	        }
	
	        this.options.filters.dateRange = this.$('[name=dateRange]').val();
	    },
	
	    updateFromDate: function updateFromDate() {
	        var fromDate = this.$('.js-datepicker-from').datepicker('getDate');
	        var toDate = this.options.filters.to;
	        if (fromDate instanceof Date) {
	            this.options.filters.from = moment(fromDate).hour(12).toDate();
	            // 20200521 for custom date to have range of 1 year only
	            if (toDate instanceof Date && moment(toDate).diff(fromDate, 'months') > 12 && !this.$('[name=dateRange]').val() // custom date
	            ) {
	                    var newToDate = moment(fromDate).add(1, 'year').hour(12).toDate();
	                    this.$('.js-datepicker-to').datepicker('setDate', newToDate);
	                    this.$('.js-datepicker-to').val(moment(newToDate).format('MMMM, YYYY'));
	                    this.options.filters.to = newToDate;
	                }
	        } else {
	            this.options.filters.from = this.options.fromPeriod;
	            this.options.filters.fromFormatted = moment(this.options.fromPeriod).format('MMMM, YYYY');
	        }
	    },
	
	    updateToDate: function updateToDate() {
	        var fromDate = this.$('.js-datepicker-from').datepicker('getDate');
	        var toDate = this.$('.js-datepicker-to').datepicker('getDate');
	        if (toDate instanceof Date) {
	            this.options.filters.to = moment(toDate).hour(12).toDate();
	            // 20200521 for custom date to have range of 1 year only
	            if (fromDate instanceof Date && moment(toDate).diff(fromDate, 'months') > 12 && !this.$('[name=dateRange]').val() // custom date
	            ) {
	                    var newFromDate = moment(toDate).subtract(1, 'year').hour(12).toDate();
	                    this.$('.js-datepicker-from').datepicker('setDate', newFromDate);
	                    this.$('.js-datepicker-from').val(moment(newFromDate).format('MMMM, YYYY'));
	                    this.options.filters.from = newFromDate;
	                }
	        } else {
	            this.options.filters.to = this.options.toPeriod;
	            this.options.filters.toFormatted = moment(this.options.toPeriod).format('MMMM, YYYY');
	        }
	    },
	
	    updateGroupBy: function updateGroupBy(ev) {
	        var $el = this.$(ev.currentTarget);
	        this.options.filters.groupBy = $el.val();
	        this.getGroupBy();
	        this.render();
	    },
	
	    getGroupBy: function getGroupBy() {
	        if (this.options.filters.groupBy === 'location') {
	            this.group = this.options.locations.map(function (location) {
	                return {
	                    id: location.get('objectId'),
	                    title: location.get('name')
	                };
	            });
	        } else {
	            this.group = this.options.employees.map(function (employee) {
	                return {
	                    id: employee.get('objectId'),
	                    title: employee.get('fullName')
	                };
	            });
	        }
	    },
	
	    updateType: function updateType(ev) {
	        var $el = this.$(ev.currentTarget);
	        this.options.filters.type = $el.val();
	    },
	
	    taint: function taint() {
	        this.$('form.filters').addClass('tainted');
	    },
	
	    filterIsTainted: function filterIsTainted() {
	        return this.$('form.filters').hasClass('tainted');
	    },
	
	    filter: function filter(ev) {
	        /* Because the stupid datepicker plugin doesn't understand
	         * the readonly property as it should I have to use disabled which
	         * in turns breaks $.serialize(). Hence, this hacky piece of code
	         */
	        var fromDate = this.$('.js-datepicker-from').datepicker('getDate');
	        var toDate = this.$('.js-datepicker-to').datepicker('getDate');
	
	        var filters = {
	            dateRange: this.$('[name=dateRange]').val(),
	            group: this.$('[name=group]').val(),
	
	            from: fromDate ? moment(fromDate).startOf('month').format('YYYY-MM-DD') : null,
	            to: toDate ? moment(toDate).endOf('month').format('YYYY-MM-DD') : null,
	            groupBy: this.$('.js-group-by').val(),
	            type: this.$('.js-type').val()
	        };
	
	        ev.preventDefault();
	
	        if (this.filterIsTainted()) {
	            this.$('.js-datepicker-range .form-control').datepicker('hide');
	            app.mainRouter.navigate('reports/totals?' + $.param(filters), {
	                trigger: true
	            });
	        }
	        this.updateDownloadLink();
	    },
	
	    updateDownloadLink: function updateDownloadLink() {
	        var filters = Object.assign({}, this.options.filters);
	
	        filters.from = filters.from ? moment(filters.from).startOf('month').format('YYYY-MM-DD') : null;
	        filters.to = filters.to ? moment(filters.to).endOf('month').format('YYYY-MM-DD') : null;
	
	        var employeesFilter = filters['group[]'];
	        var locationsFilter = filters['group[]'];
	        if (filters.groupBy === 'location') {
	            employeesFilter = null;
	        } else {
	            locationsFilter = null;
	        }
	
	        var downloadLink = this.$('#download-link');
	        downloadLink.prop('href', _report2.default.downloadUrl({
	            companyId: app.company.id,
	            employees: employeesFilter,
	            locations: locationsFilter,
	            fromDate: filters.from,
	            toDate: filters.to
	        }));
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _queryString = __webpack_require__(554);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/report');
	
	var ENDPOINT_URL = _config2.default.apiUrl + '/Reports';
	
	var Report = function (_Model) {
	    _inherits(Report, _Model);
	
	    function Report() {
	        _classCallCheck(this, Report);
	
	        var _this = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this));
	
	        throw new Error('Reports are not instantiable');return _this;
	    }
	
	    _createClass(Report, [{
	        key: 'save',
	        value: function save() {
	            log.warn('Reports cannot be saved');
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            log.warn('Reports cannot be fetched');
	        }
	    }, {
	        key: 'set',
	        value: function set() {
	            log.warn('Reports don\'t have attributes');
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            log.warn('Reports are not validatable');
	        }
	    }], [{
	        key: 'totals',
	        value: function totals(_ref) {
	            var companyId = _ref.companyId,
	                employees = _ref.employees,
	                locations = _ref.locations,
	                fromDate = _ref.fromDate,
	                toDate = _ref.toDate;
	
	            return _axios2.default.get(ENDPOINT_URL + '/totals', {
	                params: {
	                    companyId: companyId,
	                    employees: employees,
	                    locations: locations,
	                    fromDate: fromDate,
	                    toDate: toDate
	                },
	                headers: { 'Authorization': app.user.getAccessToken().id },
	                responseType: 'json'
	            }).then(function (r) {
	                return r.data;
	            });
	        }
	    }, {
	        key: 'downloadUrl',
	        value: function downloadUrl(_ref2) {
	            var companyId = _ref2.companyId,
	                employees = _ref2.employees,
	                locations = _ref2.locations,
	                fromDate = _ref2.fromDate,
	                toDate = _ref2.toDate;
	
	            return ENDPOINT_URL + '/download?' + _queryString2.default.stringify({
	                companyId: companyId,
	                employees: employees || [],
	                locations: locations || [],
	                fromDate: fromDate,
	                toDate: toDate,
	                'access_token': app.user.getAccessToken().id
	            });
	        }
	    }, {
	        key: 'sendLeaveReport',
	        value: function sendLeaveReport(_ref3) {
	            var companyId = _ref3.companyId,
	                date = _ref3.date,
	                isEndAtDate = _ref3.isEndAtDate;
	
	            return _axios2.default.post(ENDPOINT_URL + '/sendLeaveReport', { companyId: companyId, date: date, isEndAtDate: isEndAtDate }, { headers: { 'Authorization': app.user.getAccessToken().id } }).then(function (r) {
	                return r.data;
	            });
	        }
	    }]);
	
	    return Report;
	}(_model2.default);
	
	exports.default = Report;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/EmployeeTotals.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2> Reports </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n\n                <div class="ibox-title">\n                    <h3>Employee totals since using PayrollPanda</h3>\n                </div>\n\n                <div class="ibox-content">\n                    ' + __webpack_require__(824).apply(null,arguments) + '\n\n                    <table id="summary" class="footable footable-summary table table-stripped"\n                        data-page-size="25" data-sorting="false">\n                        <thead>\n                            <tr class="first-header">\n                                <th name="fullname"></th>\n                                <th style="width: 6%" name="base"></th>\n                                <th style="width: 14%" name="additions"></th>\n                                <th style="width: 14%" name="deductions"></th>\n                                <th style="width: 6%" name="gross"></th>\n                                <th style="width: 4%" name="zakat"></th>\n                                <th style="width: 16%" class="employee contributions" colspan="4">\n                                    Employee Contributions\n                                </th>\n                                <th style="width: 16%" class="employer contributions" colspan="4">\n                                    Employer Contributions\n                                </th>\n                                <th style="width: 8%" name="net"></th>\n                            </tr>\n                            <tr class="second-header">\n                                <th name="fullname" data-sort-initial="true">Employee</th>\n                                <th style="width: 6%" name="base" data-type="numeric" class="employee">Basic</th>\n                                <th style="width: 14%" name="additions" data-type="numeric" class="employee">Additions</th>\n                                <th style="width: 14%" name="deductions" data-type="numeric" class="employee">Deductions</th>\n                                <th style="width: 6%" name="gross" data-type="numeric" class="employee">Gross</th>\n                                <th style="width: 4%" name="zakat" data-type="numeric" class="employee">Zakat</th>\n                                <th style="width: 4%" name="pcb" data-type="numeric" class="employee">PCB</th>\n                                <th style="width: 4%" name="epf" data-type="numeric" class="employee">EPF</th>\n                                <th style="width: 4%" name="socso" data-type="numeric" class="employee">SOCSO</th>\n                                <th style="width: 4%" name="eis" data-type="numeric" class="employee">EIS</th>\n                                <th style="width: 4%" name="epf" data-type="numeric" class="employer">EPF</th>\n                                <th style="width: 4%" name="socso" data-type="numeric" class="employer">SOCSO</th>\n                                <th style="width: 4%" name="eis" data-type="numeric" class="employer">EIS</th>\n                                <th style="width: 4%" name="hrdf" data-type="numeric" class="employer">HRDF</th>\n                                <th style="width: 8%" name="net" data-type="numeric">Net Pay</th>\n                            </tr>\n                        </thead>\n                        ';
	 if (rowCount <= 0) { 
	__p+='\n                            <tbody class="js-empty-msg">\n                                <tr>\n                                    <td colspan="7">\n                                        <h1 class="text-center">\n                                            There are no submitted\n                                            or completed payrolls to report on\n                                            for the specified date range.\n                                        </h1>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        ';
	 } else { 
	__p+='\n                            <tbody class="js-rows">\n                                ';
	 _.each(rows, function(row) { 
	__p+='\n                                    <tr class="employee-row">\n                                        <td name="fullname"><a>'+
	((__t=( row.fullName  ))==null?'':_.escape(__t))+
	'</a></td>\n                                        <td style="width: 6%" name="base">'+
	((__t=( row.base.format() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 14%" name="additions">\n                                            '+
	((__t=( row.additions.format() ))==null?'':_.escape(__t))+
	'\n                                            ';
	 _.each(row.additionDetails, function(detail) { 
	__p+='\n                                                <div class="details hidden">\n                                                    '+
	((__t=( detail.amount.format() ))==null?'':_.escape(__t))+
	'';
	 if (detail.isUnit) { 
	__p+='\n                                                        (\n                                                            '+
	((__t=( (detail.unit || 0) ))==null?'':_.escape(__t))+
	' @\n                                                            '+
	((__t=( (detail.rate || 0).format() ))==null?'':_.escape(__t))+
	'\n                                                        )\n                                                    ';
	 } 
	__p+=': '+
	((__t=( detail.name ))==null?'':_.escape(__t))+
	'\n                                                </div>\n                                            ';
	 }); 
	__p+='\n                                        </td>\n                                        <td style="width: 14%" name="deductions">\n                                            '+
	((__t=( row.deductions.format() ))==null?'':_.escape(__t))+
	'\n                                            ';
	 _.each(row.deductionDetails, function(detail) { 
	__p+='\n                                                <div class="details hidden">\n                                                    '+
	((__t=( detail.amount.format() ))==null?'':_.escape(__t))+
	'';
	 if (detail.isUnit) { 
	__p+='\n                                                        (\n                                                            '+
	((__t=( (detail.unit || 0) ))==null?'':_.escape(__t))+
	' @\n                                                            '+
	((__t=( (detail.rate || 0).format() ))==null?'':_.escape(__t))+
	'\n                                                        )\n                                                    ';
	 } 
	__p+=': '+
	((__t=( detail.name ))==null?'':_.escape(__t))+
	'\n                                                </div>\n                                            ';
	 }); 
	__p+='\n                                        </td>\n                                        <td style="width: 6%" name="gross">'+
	((__t=( row.grossPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="zakat">'+
	((__t=( row.zakat.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="pcb">\n                                            '+
	((__t=( row.mtd.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'<br>\n                                            ';
	 if ((row.cp38 || 0) > 0) { 
	__p+='\n                                                '+
	((__t=( row.cp38.formatWithoutRounding() ))==null?'':_.escape(__t))+
	': CP38\n                                            ';
	 } 
	__p+='\n                                        </td>\n                                        <td style="width: 4%" name="epf">'+
	((__t=( row.employeeEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="socso">'+
	((__t=( row.employeeSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="eis">'+
	((__t=( row.employeeEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="epf">'+
	((__t=( row.employerEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="socso">'+
	((__t=( row.employerSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="eis">'+
	((__t=( row.employerEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 4%" name="hrdf">'+
	((__t=( row.totalHrdf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                        <td style="width: 8%" name="net">'+
	((__t=( row.netPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    </tr>\n                                ';
	 }); 
	__p+='\n                            </tbody>\n                        ';
	 } 
	__p+='\n                        <tfoot>\n                            <tr data-sorted="false" class="employee-total '+
	((__t=( rowCount % 2 ? 'zebra' : ''))==null?'':_.escape(__t))+
	'">\n                                    <td name="fullname">Total</td>\n                                    <td name="base">'+
	((__t=( grandTotal.base.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="additions">'+
	((__t=( grandTotal.additions.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="deductions">'+
	((__t=( grandTotal.deductions.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="gross">'+
	((__t=( grandTotal.grossPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="zakat">'+
	((__t=( grandTotal.zakat.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="pcb">'+
	((__t=( grandTotal.mtdcp38.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="epf">'+
	((__t=( grandTotal.employeeEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="socso">'+
	((__t=( grandTotal.employeeSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="eis">'+
	((__t=( grandTotal.employeeEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="epf">'+
	((__t=( grandTotal.employerEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="socso">'+
	((__t=( grandTotal.employerSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="eis">'+
	((__t=( grandTotal.employerEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="hrdf">'+
	((__t=( grandTotal.totalHrdf.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                                    <td name="net">'+
	((__t=( grandTotal.netPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
	'</td>\n                            </tr>\n                            <tr>\n                                <td colspan="15">\n                                    <ul class="pagination pull-right"></ul>\n\n                                    <a id="download-link"\n                                        href="#" target="_blank"\n                                        class="btn btn-primary pull-right\n                                        btn-outline js-download m-r-lg m-t-xs">\n                                        <i class="fa fa-file-excel-o m-r-sm"></i>\n                                        Download\n                                    </a>\n                                </td>\n                            </tr>\n                        </tfoot>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/Filters.ejs -->\n<form class="filters row form-inline m-t-md m-b-md">\n    <div class="form-group m-t-sm m-l-md">\n        <label class="m-r-sm">Date Range</label>\n        <select class="form-control js-date-range" name="dateRange">\n            <option value="" '+
	((__t=( !filters.dateRange ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Custom Date\n            </option>\n            ';
	 _.each(dateRanges, function(range, key) { 
	__p+='\n            <option value="'+
	((__t=( key ))==null?'':_.escape(__t))+
	'"\n                data-from="'+
	((__t=( range.from ))==null?'':_.escape(__t))+
	'"\n                data-to="'+
	((__t=( range.to ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( filters.dateRange === key ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( range.label ))==null?'':_.escape(__t))+
	'\n            </option>\n            ';
	 }) 
	__p+='\n        </select>\n        <div class="input-daterange input-group js-datepicker-range">\n            <input class="form-control js-datepicker-from" name="from"\n                value="'+
	((__t=( filters.fromFormatted ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( filters.dateRange ? 'disabled': '' ))==null?'':_.escape(__t))+
	'>\n            <span class="input-group-addon">to</span>\n            <input class="form-control js-datepicker-to" name="to"\n                value="'+
	((__t=( filters.toFormatted ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( filters.dateRange ? 'disabled': '' ))==null?'':_.escape(__t))+
	'>\n        </div>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md">\n        <label class="m-r-sm">Group By</label>\n        <select class="form-control js-group-by">\n            ';
	 groupBy.forEach(function(element) { 
	__p+='\n                <option value="'+
	((__t=( element.toLowerCase() ))==null?'':_.escape(__t))+
	'"\n                    '+
	((__t=( filters.groupBy === element.toLowerCase() ? 'selected': ''))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( element ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n        <div class="form-group">\n            <select name="group" class="form-control chosen-select"\n                multiple data-placeholder="All">\n                ';
	 group.forEach(function(element) { 
	__p+='\n                    <option value="'+
	((__t=( element.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( _.contains(filters['group[]'], element.id) ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( element.title ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }) 
	__p+='\n            </select>\n        </div>\n    </div>\n    <div class="form-group m-t-sm m-l-md">\n        <label class="m-r-sm">Type of Report</label>\n        <select class="form-control js-type">\n            ';
	 types.forEach(function(type) { 
	__p+='\n                <option value="'+
	((__t=( type ))==null?'':_.escape(__t))+
	'"\n                    '+
	((__t=( filters.type === type ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( type ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n        <div class="form-group m-l-lg">\n            <button type="submit" class="btn btn-primary">\n                <i class="fa fa-refresh"></i>\n            </button>\n        </div>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _DetailsModalView = __webpack_require__(826);
	
	var _DetailsModalView2 = _interopRequireDefault(_DetailsModalView);
	
	var _Main = __webpack_require__(828);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Table = __webpack_require__(830);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _report = __webpack_require__(822);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-filter-clear': 'resetFilter',
	        'click .js-filter-apply': 'applyFilter',
	        'submit form.filters': 'filter',
	        'change input, select': 'taint',
	        'click .js-details': 'viewDetails',
	        'change .js-datepicker-input': 'updateCustomEndDate',
	        'change [name=period]': 'toggleCustomEndDate',
	        'click .js-send-leave-report': 'sendLeaveReport'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            employees: null,
	            leaveTypes: null,
	            filters: {
	                'employee[]': null,
	                'leaveType': null,
	                'date': null
	            }
	        });
	
	        this.renderFilters();
	    },
	
	    renderFilters: function renderFilters() {
	        if (this.options.filters.date) {
	            this.options.filters.customEndDateFormatted = (0, _moment2.default)(this.options.filters.date).format('MMMM, YYYY');
	        } else {
	            this.options.filters.customEndDateFormatted = null;
	        }
	
	        this.$el.html((0, _Main2.default)({
	            filters: this.options.filters,
	            employees: this.options.employees,
	            leaveTypes: this.options.leaveTypes
	        }));
	
	        this.$('.js-datepicker').datepicker({
	            keyboardNavigation: false,
	            forceParse: false,
	            autoclose: true,
	            todayBtn: 'linked',
	            format: 'MM, yyyy',
	            viewMode: 'months',
	            minViewMode: 'months'
	        });
	
	        this.$('.chosen-select').chosen({
	            width: '175px'
	        });
	    },
	
	    render: function render() {
	        var balance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        this.options.balance = balance;
	
	        var periodType = this.options.filters.period;
	        var leaveTypeId = this.options.filters.leaveType;
	        var customEndDate = this.options.filters.date ? (0, _moment2.default)(this.options.filters.date, 'YYYY/MM/DD') : (0, _moment2.default)();
	
	        var leaveTableRows = Object.values(balance).map(function (employeeBalance) {
	            var employee = employeeBalance.employee,
	                entitled = employeeBalance.entitled,
	                taken = employeeBalance.taken,
	                defaultEntitled = employeeBalance.defaultEntitled,
	                cf = employeeBalance.cf;
	
	
	            var leavePeriodYear = void 0;
	
	            switch (periodType) {
	                case 'current':
	                    leavePeriodYear = employee.getApplicableLeavePeriod((0, _moment2.default)());
	                    break;
	                case 'previous':
	                    leavePeriodYear = employee.getApplicableLeavePeriod((0, _moment2.default)().subtract(1, 'year'));
	                    break;
	                case 'custom':
	                    leavePeriodYear = employee.getApplicableLeavePeriod(customEndDate);
	                    break;
	                default:
	                    break;
	            }
	
	            return {
	                fullName: employee.get('fullName') || '',
	                employeeId: employee.id,
	                daysEntitled: defaultEntitled[leaveTypeId].formatWithoutRounding(1),
	                daysAllowed: entitled[leaveTypeId].formatWithoutRounding(1),
	                daysTaken: taken[leaveTypeId].formatWithoutRounding(1),
	                daysCarryForward: cf[leaveTypeId].formatWithoutRounding(1),
	                daysRemaining: (entitled[leaveTypeId] - taken[leaveTypeId]).formatWithoutRounding(1)
	            };
	        });
	
	        this.$('.leave-table-container').html((0, _Table2.default)({
	            leaveTableRows: leaveTableRows,
	            isFinished: true
	        }));
	
	        this.$('.js-loader').remove();
	
	        _modal2.default.showAlertSuccess('Employee leave balances loaded!');
	
	        this.$('.leave-table').footable();
	    },
	
	    taint: function taint() {
	        this.$('form.filters').addClass('tainted');
	    },
	
	    filterIsTainted: function filterIsTainted() {
	        return this.$('form.filters').hasClass('tainted');
	    },
	
	    resetFilter: function resetFilter(e) {
	        var _this = this;
	
	        e.preventDefault();
	
	        var filters = {
	            period: 'current',
	            employee: []
	        };
	
	        app.mainRouter.navigate('reports/leave?' + $.param(filters), {
	            trigger: true
	        });
	
	        app.mainRouter.execute(function () {
	            //clear old events, before redirect
	            _this.undelegateEvents();
	        });
	    },
	
	    applyFilter: function applyFilter(e) {
	        var _this2 = this;
	
	        e.preventDefault();
	
	        if (!this.filterIsTainted()) {
	            return false;
	        }
	
	        // period is translated from presets
	        // current:     this year
	        // previous:    previous year
	        // custom:      custom date (month)
	        var period = this.$('[name=period]').val();
	
	        var leaveType = this.$('[name=leave-type]').val() === '' ? '' : this.$('[name=leave-type]').val();
	
	        var customEndDate = period === 'custom' && this.options.filters.date ? this.options.filters.date : null;
	
	        var filters = {
	            period: period,
	            leaveType: leaveType,
	            employee: this.$('[name=employee]').val(),
	            date: customEndDate
	        };
	
	        app.mainRouter.navigate('reports/leave?' + $.param(filters), {
	            trigger: true
	        });
	
	        app.mainRouter.execute(function () {
	            //clear old events, before redirect
	            _this2.undelegateEvents();
	        });
	    },
	
	    viewDetails: function viewDetails(event) {
	        event.preventDefault();
	
	        var employeeId = event.target.dataset.employeeId;
	        var data = this.options.balance[employeeId];
	
	        // prepare modal view for employee leave details
	        // similar to employment details
	        this.detailsView = new _DetailsModalView2.default(data);
	        this.$el.append(this.detailsView.$el);
	        this.detailsView.show();
	    },
	
	
	    remove: function remove() {
	        this.undelegateEvents();
	    },
	
	    updateCustomEndDate: function updateCustomEndDate() {
	        var customEndDate = this.$('input[name=customEndDate]').val();
	        if (customEndDate) {
	            this.options.filters.date = (0, _moment2.default)(customEndDate, 'MMMM, YYYY').endOf('month').format('YYYY/MM/DD');
	        }
	    },
	
	    toggleCustomEndDate: function toggleCustomEndDate(event) {
	        var isHidingCustomDateSelect = $(event.target).val() !== 'custom';
	        this.$('input[name=customEndDate]').prop('disabled', isHidingCustomDateSelect);
	    },
	
	    sendLeaveReport: function sendLeaveReport() {
	        var date = null;
	        switch (this.options.filters.period) {
	            case 'custom':
	                date = (0, _moment2.default)(this.options.filters.date || (0, _moment2.default)()).endOf('day').toDate();
	                break;
	            case 'previous':
	                date = (0, _moment2.default)().subtract(1, 'year').endOf('day').toDate();
	                break;
	            case 'current':
	                date = (0, _moment2.default)().endOf('day').toDate();
	                break;
	            default:
	                break;
	        }
	
	        return _report2.default.sendLeaveReport({
	            companyId: app.company.id,
	            date: date,
	            isEndAtDate: this.options.filters.period === 'custom'
	        }).then(function () {
	            _modal2.default.showAlertSuccess('Employee leave report will be sent to your email shortly.');
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _DetailsModal = __webpack_require__(827);
	
	var _DetailsModal2 = _interopRequireDefault(_DetailsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            types: null,
	            employee: null,
	            entitled: null,
	            taken: null,
	            cf: null
	        });
	
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html((0, _DetailsModal2.default)({
	            employee: this.options.employee,
	            types: this.options.types,
	            entitled: this.options.entitled,
	            taken: this.options.taken,
	            cf: this.options.cf
	        }));
	    },
	
	    show: function show() {
	        this.$('.modal').modal('show');
	    },
	
	    hide: function hide() {
	        this.$('.modal').modal('hide');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/leave/DetailsModal.ejs -->\n<div class="modal" tabindex="-1" aria-hidden="true" role="dialog">\n    this is the modal\n    <div class="modal-dialog modal-xl">\n        <div class="modal-content animated sweet">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal">\n                    <span aria-hidden="true">×</span><span class="sr-only">Close</span>\n                </button>\n                <div class="modal-title"><h3>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</h3></div>\n            </div>\n            <div class="modal-body">\n                <div class="row">\n                    <table class="footable table footable-leave-policies"\n                        data-striping="false">\n                        <thead>\n                            <tr>\n                                <th class="name">\n                                    Leave Policies\n                                </th>\n                                <th class="taken">\n                                    Total Days Entitled\n                                </th>\n                                <th class="taken">\n                                    Days Carried Forward\n                                </th>\n                                <th class="taken">\n                                    Days Taken\n                                </th>\n                                <th class="taken">\n                                    Days Remaining\n                                </th>\n                            </tr>\n                        </thead>\n\n                        ';
	 if (types.length === 0) { 
	__p+='\n                            <tbody class="footable-body">\n                                <tr>\n                                    <td colspan="4">\n                                        <h4>No leave types found</h4>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        ';
	 } else { 
	__p+='\n                            <tbody class="footable-body">\n                                ';
	 types.forEach(function (type) { 
	__p+='\n                                    <tr>\n                                        <td class="title td-nowrap">\n                                            <div class="flex-container-row">\n                                                '+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'\n                                            </div>\n                                        </td>\n                                        <td class="taken">\n                                            <div class="flex-container-row">\n                                                '+
	((__t=( entitled[type.id].formatWithoutRounding(1) ))==null?'':_.escape(__t))+
	'\n                                            </div>\n                                        </td>\n                                        <td class="taken">\n                                            <div class="flex-container-row">\n                                                '+
	((__t=( cf[type.id].formatWithoutRounding(1) ))==null?'':_.escape(__t))+
	'\n                                            </div>\n                                        </td>\n                                        <td class="taken">\n                                            <div class="flex-container-row">\n                                                '+
	((__t=( taken[type.id].formatWithoutRounding(1) ))==null?'':_.escape(__t))+
	'\n                                            </div>\n                                        </td>\n                                        <td class="taken">\n                                            <div class="flex-container-row">\n                                                '+
	((__t=( (entitled[type.id] - taken[type.id]).formatWithoutRounding(1) ))==null?'':_.escape(__t))+
	'\n                                            </div>\n                                        </td>\n                                    </tr>\n                                ';
	 }) 
	__p+='\n                            </tbody>\n                        ';
	 } 
	__p+='\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/leave/Main.ejs -->\n<div class="leave-report-page">\n    <div class="row wrapper border-bottom white-bg page-heading">\n        <div class="col-xs-12">\n            <h2>Leave Report</h2>\n        </div>\n    </div>\n\n    <div class="wrapper wrapper-content">\n        <div class="row">\n            <div class="col-md-12 col-lg-12">\n                <div class="ibox float-e-margins">\n\n                    <div class="ibox-title">\n                        <h3>Employee Leave Balance</h3>\n                    </div>\n\n                    <div class="ibox-content">\n                        ' + __webpack_require__(829).apply(null,arguments) + '\n\n                        <div class="leave-table-container"></div>\n                    </div>\n\n                    <div class="js-loader ibox-content loader-container">\n                        <div class="loader">\n                            '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/leave/Filters.ejs -->\n<form class="filters form-inline m-t-md m-b-md">\n    <div class="form-group m-t-sm m-l-md">\n        <label class="form-label m-r-sm">Date Range</label>\n        <select name="period" class="js-period form-control">\n            <option value="current" '+
	((__t=( filters.period === 'current' ? 'selected' : ''))==null?'':_.escape(__t))+
	'>\n                Current Balance\n            </option>\n            <option value="previous" '+
	((__t=( filters.period === 'previous' ? 'selected' : ''))==null?'':_.escape(__t))+
	'>\n                Previous Balance\n            </option>\n            <option value="custom" '+
	((__t=( filters.period === 'custom' ? 'selected' : ''))==null?'':_.escape(__t))+
	'>\n                Custom Date\n            </option>\n        </select>\n        <div class="date input-group js-datepicker">\n            <span class="input-group-addon">\n                <span class="glyphicon glyphicon-calendar"></span>\n            </span>\n            <input class="form-control js-datepicker-input" name="customEndDate"\n                value="'+
	((__t=( filters.customEndDateFormatted ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( filters.period === 'custom' ? '': 'disabled' ))==null?'':_.escape(__t))+
	'>\n        </div>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md">\n        <label class="form-label m-r-sm">Leave Type</label>\n        <select name="leave-type" class="js-type form-control">\n            ';
	 leaveTypes.forEach(function (type) { 
	__p+='\n                <option value="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( filters['leaveType'] === type.id ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md">\n        <label class="form-label m-r-sm">Group By</label>\n        <select class="form-control js-group-by">\n            <option value="employee">Employee</option>\n        </select>\n\n        <div class="form-group">\n            <select name="employee" class="form-control js-employee chosen-select"\n                multiple data-placeholder="All employees">\n                ';
	 employees.forEach(function(employee) { 
	__p+='\n                    <option value="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( _.contains(filters['employee[]'], employee.id) ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n\n                        '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }) 
	__p+='\n            </select>\n        </div>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md pull-right">\n        <div class="btn-group">\n            <button type="button" class="btn btn-default js-filter-clear">\n                <i class="fa fa-undo"></i>\n                CLEAR\n            </button>\n\n            <button type="button" class="btn btn-primary js-filter-apply">\n                <i class="fa fa-refresh"></i>\n                FILTER\n            </button>\n        </div>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/leave/Table.ejs -->\n';
	  if (!isFinished) { 
	__p+='\n    <h3>\n        Loading employee leave balances...\n    </h3>\n';
	 } else if (isFinished && (leaveTableRows.length || 0) === 0) { 
	__p+='\n    <h3>\n        No records available.\n    </h3>\n';
	 } else { 
	__p+='\n    <table class="leave-table table table-striped"\n        data-paging="true" data-page-size="25" data-sorting="false">\n\n        <thead>\n            <tr class="first-header">\n                <th style="width: 25%;">Employee</th>\n                <th data-type="numeric">Days Entitled</th>\n                <th data-type="numeric">Days Allowed</th>\n                <th data-type="numeric">Days Taken</th>\n                <th data-type="numeric">Days Carried Forward</th>\n                <th data-type="numeric">Days Remaining</th>\n            </tr>\n        </thead>\n\n        <tbody class="js-rows">\n            ';
	 leaveTableRows.forEach(function (row) { 
	__p+='\n                <tr>\n                    <td>'+
	((__t=( row.fullName ))==null?'':_.escape(__t))+
	'</td>\n                    <td>'+
	((__t=( row.daysEntitled ))==null?'':_.escape(__t))+
	'</td>\n                    <td>'+
	((__t=( row.daysAllowed ))==null?'':_.escape(__t))+
	'</td>\n                    <td>'+
	((__t=( row.daysTaken ))==null?'':_.escape(__t))+
	'</td>\n                    <td>'+
	((__t=( row.daysCarryForward ))==null?'':_.escape(__t))+
	'</td>\n                    <td>'+
	((__t=( row.daysRemaining ))==null?'':_.escape(__t))+
	'</td>\n                    <td>\n                        <a href="#" style="color: #00b800"\n                            class="js-details" data-employee-id="'+
	((__t=( row.employeeId ))==null?'':_.escape(__t))+
	'">\n\n                            <i class="fa fa-bar-chart"></i> View Details\n                        </a>\n                    </td>\n                </tr>\n            ';
	 }); 
	__p+='\n        </tbody>\n\n        <tfoot>\n            <tr>\n                <td colspan="7">\n                    <ul class="pagination pull-right"></ul>\n                    <<button class="btn btn-outline pull-right btn-success js-send-leave-report">\n                        <i class="fa fa-envelope-o"></i>\n                        Send Leave Report\n                    </button>\n                </td>\n            </tr>\n        </tfoot>\n    </table>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _Variance = __webpack_require__(832);
	
	var _Variance2 = _interopRequireDefault(_Variance);
	
	var _VarianceTable = __webpack_require__(833);
	
	var _VarianceTable2 = _interopRequireDefault(_VarianceTable);
	
	var _VarianceEmpty = __webpack_require__(834);
	
	var _VarianceEmpty2 = _interopRequireDefault(_VarianceEmpty);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    render: function render() {
	        var lastPayroll = this.collection.at(0);
	        var prevPayroll = this.collection.at(1);
	        if (!lastPayroll || !prevPayroll) {
	            this.$el.html((0, _Variance2.default)({
	                data: (0, _VarianceEmpty2.default)()
	            }));
	            return this;
	        }
	
	        var last = this.getItemsForPayroll(lastPayroll);
	        var prev = this.getItemsForPayroll(prevPayroll);
	        var diff = this.getDiff(prevPayroll, lastPayroll);
	        this.$el.html((0, _Variance2.default)({
	            data: (0, _VarianceTable2.default)({
	                last: last,
	                prev: prev,
	                diff: diff
	            })
	        }));
	        return this;
	    },
	
	    getDiff: function getDiff(prev, last) {
	        return {
	            base: (last.get('base') - prev.get('base')).formatWithoutRounding(),
	            additions: (last.get('additions') - prev.get('additions')).formatWithoutRounding(),
	            deductions: (last.get('deductions') - prev.get('deductions')).formatWithoutRounding(),
	            grossPay: (last.get('grossPay') - prev.get('grossPay')).formatWithoutRounding(),
	            mtd: (last.get('mtd') - prev.get('mtd')).formatWithoutRounding(),
	            employeeEpf: (last.get('employeeEpf') - prev.get('employeeEpf')).formatWithoutRounding(),
	            employerEpf: (last.get('employerEpf') - prev.get('employerEpf')).formatWithoutRounding(),
	            employeeSocso: (last.get('employeeSocso') - prev.get('employeeSocso')).formatWithoutRounding(),
	            employerSocso: (last.get('employerSocso') - prev.get('employerSocso')).formatWithoutRounding(),
	            netPay: (last.get('netPay') - prev.get('netPay')).formatWithoutRounding()
	        };
	    },
	
	    getItemsForPayroll: function getItemsForPayroll(payroll) {
	        var items = {
	            period: (0, _moment2.default)(payroll.get('periodDate')).format('MMMM YYYY'),
	            base: payroll.get('base').formatWithoutRounding(),
	            additions: payroll.get('additions').formatWithoutRounding(),
	            deductions: payroll.get('deductions').formatWithoutRounding(),
	            grossPay: payroll.get('grossPay').formatWithoutRounding(),
	            mtd: payroll.get('mtd').formatWithoutRounding(),
	            employeeEpf: payroll.get('employeeEpf').formatWithoutRounding(),
	            employerEpf: payroll.get('employerEpf').formatWithoutRounding(),
	            employeeSocso: payroll.get('employeeSocso').formatWithoutRounding(),
	            employerSocso: payroll.get('employerSocso').formatWithoutRounding(),
	            netPay: payroll.get('netPay').formatWithoutRounding()
	        };
	        return items;
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/Variance.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2> Reports </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n\n                <div class="ibox-title">\n                    <h3>Variance</h3>\n                </div>\n\n                <div class="ibox-content">\n                    '+
	((__t=( data ))==null?'':__t)+
	'\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/Variance-table.ejs -->\n<table class="footable footable-summary table table-stripped"\n       data-page-size="25" data-sorting="false">\n    <thead>\n        <tr>\n            <th>&nbsp;</th>\n            <th>Prev Payroll ('+
	((__t=( prev.period ))==null?'':_.escape(__t))+
	')</th>\n            <th>Last Payroll ('+
	((__t=( last.period ))==null?'':_.escape(__t))+
	')</th>\n            <th>Difference</th>\n        </tr>\n    </thead>\n    <tbody class="js-rows">\n        <tr>\n            <td>Base</td>\n            <td>'+
	((__t=( prev.base ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.base ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.base ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Additions</td>\n            <td>'+
	((__t=( prev.additions ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.additions ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.additions ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Deductions</td>\n            <td>'+
	((__t=( prev.deductions ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.deductions ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.deductions ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Gross Pay</td>\n            <td>'+
	((__t=( prev.grossPay ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.grossPay ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.grossPay ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>PCB</td>\n            <td>'+
	((__t=( prev.mtd ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.mtd ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.mtd ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Employee EPF</td>\n            <td>'+
	((__t=( prev.employeeEpf ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.employeeEpf ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.employeeEpf ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Employee SOCSO</td>\n            <td>'+
	((__t=( prev.employeeSocso ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.employeeSocso ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.employeeSocso ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Employer EPF</td>\n            <td>'+
	((__t=( prev.employerEpf ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.employerEpf ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.employerEpf ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Employer SOCSO</td>\n            <td>'+
	((__t=( prev.employerSocso ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.employerSocso ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.employerSocso ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n        <tr>\n            <td>Net Pay</td>\n            <td>'+
	((__t=( prev.netPay ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( last.netPay ))==null?'':_.escape(__t))+
	'</td>\n            <td>'+
	((__t=( diff.netPay ))==null?'':_.escape(__t))+
	'</td>\n        </tr>\n\n\n    </tbody>\n    <tfoot>\n    </tfoot>\n</table>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/reports/Variance-empty.ejs -->\n<h1 class="text-center">\n    There are no submitted\n    or completed payrolls to report on\n</h1>\n';
	}
	return __p;
	};


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Layout = __webpack_require__(836);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _positions = __webpack_require__(631);
	
	var _positions2 = _interopRequireDefault(_positions);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _payroll = __webpack_require__(569);
	
	var _payroll2 = _interopRequireDefault(_payroll);
	
	var _integration = __webpack_require__(605);
	
	var _integration2 = _interopRequireDefault(_integration);
	
	var _payrollItemIntegrations = __webpack_require__(889);
	
	var _payrollItemIntegrations2 = _interopRequireDefault(_payrollItemIntegrations);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _coupon = __webpack_require__(639);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/settings-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'settings': 'settings',
	        'settings/company': 'company',
	        'settings/tax': 'tax',
	        'settings/positions': 'positions',
	        'settings/payrollItems': 'payrollItems',
	        'settings/leave': 'leave',
	        'settings/payment': 'payment',
	        'settings/notifications': 'notifications',
	        'settings/subscription': 'subscription',
	        'settings/integrations': 'integrations'
	    },
	
	    titles: {
	        'settings': 'Settings',
	        'settings/company': 'Settings > Company Details',
	        'settings/tax': 'Settings > Tax Settings',
	        'settings/positions': 'Settings > Positions',
	        'settings/payrollItems': 'Settings > Payroll Items',
	        'settings/leave': 'Settings > Leave',
	        'settings/payment': 'Settings > Payment',
	        'settings/notifications': 'Settings > Notifications',
	        'settings/subscription': 'Settings > Subscription',
	        'settings/integrations': 'Settings > Integrations'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	
	        this.layout = new _Layout2.default({
	            el: this.el
	        });
	    },
	
	    settings: function settings() {
	        this.navigate('settings/company', { trigger: true, replace: true });
	    },
	
	    company: function company() {
	        var _this = this;
	
	        this.layout.renderTab('company');
	        app.company.fetchBankAccount().then(function () {
	            return app.company.fetchLocations();
	        }).then(function (locations) {
	            return locations.fetchAddresses();
	        }).then(function (locations) {
	            return locations.fetchEmployees();
	        }).then(function (locations) {
	            _this.layout.renderContent({
	                model: app.company,
	                locations: locations
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this.layout.hideLoader();
	        });
	    },
	
	    tax: function tax() {
	        var _this2 = this;
	
	        this.layout.renderTab('tax');
	        app.user.fetch().then(function (model) {
	            _this2.layout.renderContent({
	                model: model
	            });
	            _this2.layout.hideLoader();
	        });
	    },
	
	    positions: function positions() {
	        var _this3 = this;
	
	        this.layout.renderTab('positions');
	
	        var positions = new _positions2.default(null, {
	            company: app.company,
	            pagination: false,
	            filter: {
	                where: { hiddenAt: null },
	                limit: 9999
	            }
	        });
	
	        positions.fetch().then(function () {
	            _this3.layout.renderContent({
	                collection: positions,
	                company: app.company
	            });
	        }).catch(function (err) {
	            return _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this3.layout.hideLoader();
	        });
	    },
	
	    payrollItems: function payrollItems() {
	        var _this4 = this;
	
	        this.layout.renderTab('payrollItems');
	
	        return _payroll2.default.fetchCurrent(app.company).then(function (unsubmittedPayroll) {
	            return _this4.layout.renderContent({
	                collection: app.payrollItems,
	                unsubmittedPayroll: unsubmittedPayroll
	            });
	        }).catch(function (err) {
	            return _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this4.layout.hideLoader();
	        });
	    },
	
	    leave: function leave() {
	        var _this5 = this;
	
	        this.layout.renderTab('leave');
	
	        var leaveTypes = new _leaveTypes2.default(null, { company: app.company });
	
	        return (0, _bluebird.all)([_payroll2.default.fetchCurrent(app.company), leaveTypes.fetch()]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                unsubmittedPayroll = _ref2[0];
	
	            _this5.layout.renderContent({
	                model: app.company,
	                unsubmittedPayroll: unsubmittedPayroll,
	                leaveTypes: leaveTypes.getActiveTypes()
	            });
	        }).catch(function (err) {
	            return _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this5.layout.hideLoader();
	        });
	    },
	
	    payment: function payment() {
	        var _this6 = this;
	
	        this.layout.renderTab('payment');
	
	        var locations = new _companyLocations2.default(null, {
	            company: app.company,
	            pagination: false,
	            syncRemove: true
	        });
	
	        return (0, _bluebird.all)([app.company.fetchCurrentPayroll(), locations.fetch()]).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                unsubmittedPayroll = _ref4[0],
	                locations = _ref4[1];
	
	            _this6.layout.renderContent({
	                model: app.company,
	                unsubmittedPayroll: unsubmittedPayroll,
	                locations: locations
	            });
	        }).catch(function (err) {
	            return _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            return _this6.layout.hideLoader();
	        });
	    },
	
	    notifications: function notifications() {
	        this.layout.renderTab('notifications');
	        this.layout.renderContent({ model: app.company });
	        this.layout.hideLoader();
	    },
	
	    subscription: function subscription() {
	        var _this7 = this;
	
	        this.layout.renderTab('subscription');
	        if (!app.subscription || app.company && app.company.get('mppAdminId')) {
	            this.layout.renderContent({
	                model: null,
	                templateExtra: {
	                    mppCustomer: !!app.company.get('mppAdminId'),
	                    invoices: []
	                }
	            });
	            this.layout.hideLoader();
	            return;
	        }
	
	        var fetchYearlyStartDate = function fetchYearlyStartDate() {
	            var payrolls = new _payrolls2.default(null, {
	                company: app.company,
	                pagination: false,
	                sortKey: 'periodDate',
	                sortOrder: 'ascending'
	            });
	            return payrolls.fetch({
	                filter: {
	                    where: {
	                        status: {
	                            eq: 9
	                        },
	                        chargebeeInvoiceId: (app.subscription.get('yearlyInvoice') || {}).id || null
	                    },
	                    limit: 1
	                }
	            }).then(function () {
	                var firstPayroll = payrolls.at(0);
	                // yearlyStartDate
	                return firstPayroll ? firstPayroll.get('periodDate') : null;
	            });
	        };
	
	        return (0, _bluebird.all)([app.subscription.listInvoices(), (app.subscription.get('yearlyInvoice') || {}).id ? fetchYearlyStartDate() : null]).then(function (_ref5) {
	            var _ref6 = _slicedToArray(_ref5, 2),
	                data = _ref6[0],
	                yearlyStartDate = _ref6[1];
	
	            var invoices = (data || []).map(function (i) {
	                var description = '-';
	                var status = i.status.replace(/_/, ' ');
	                status = status[0].toUpperCase() + status.slice(1);
	                /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers*/
	                if (i.line_items && i.line_items.length) {
	                    /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers*/
	                    description = i.line_items[0].description;
	                }
	                return {
	                    id: i._id,
	                    date: _moment2.default.unix(i.date).format('DD/MM/YYYY'),
	                    description: description,
	                    amount: (i.total / 100).formatWithoutRounding(),
	                    status: status,
	                    paymentDate: i.paid_at ? _moment2.default.unix(i.paid_at).format('DD/MM/YYYY') : '',
	                    voidedDate: i.voided_at ? _moment2.default.unix(i.voided_at).format('DD/MM/YYYY') : ''
	                };
	            });
	            var hasVoidInvoice = app.subscription.get('plan') === 'client' && data.some(function (d) {
	                return d.status === 'voided';
	            });
	            var updateStatusPromise = hasVoidInvoice ? app.subscription.updateStatus() : (0, _bluebird.resolve)(null);
	            return (0, _bluebird.all)([(0, _bluebird.resolve)(invoices), yearlyStartDate, app.user.isAdmin() ? _coupon2.default.getDiscountCodes() : [], updateStatusPromise]);
	        }).then(function (_ref7) {
	            var _ref8 = _slicedToArray(_ref7, 3),
	                invoices = _ref8[0],
	                yearlyStartDate = _ref8[1],
	                discountCodes = _ref8[2];
	
	            _this7.layout.renderContent({
	                model: app.subscription,
	                templateExtra: {
	                    invoices: invoices,
	                    yearlyStartDate: yearlyStartDate || null,
	                    discountCodes: discountCodes
	                }
	            });
	        }).finally(function () {
	            return _this7.layout.hideLoader();
	        });
	    },
	
	    integrations: function integrations() {
	        var _this8 = this;
	
	        this.layout.renderTab('integrations');
	
	        return _integration2.default.fetchIntegration(app.company).then(function (integration) {
	            var provider = integration.get('provider');
	
	            if (provider === 'quickbooks') {
	                return (0, _bluebird.all)([_payrollItemIntegrations2.default.fetchPaymentAccountsForCompany(app.company, integration), _payrollItemIntegrations2.default.fetchForCompany(app.company, integration), integration.fetchData()]).then(function (_ref9) {
	                    var _ref10 = _slicedToArray(_ref9, 3),
	                        paymentAccounts = _ref10[0],
	                        mapped = _ref10[1],
	                        qbAccounts = _ref10[2];
	
	                    var mappables = app.payrollItems.getMappable();
	                    var defaults = app.payrollItems.getMappableDefaults();
	
	                    if (mapped.length === 0) {
	                        mapped.add(defaults.map(function (item) {
	                            return {
	                                payrollItemId: item.id,
	                                companyId: app.company.id,
	                                integrationId: integration.id,
	                                remoteId: null,
	                                syncedAt: null
	                            };
	                        }));
	                    }
	
	                    _this8.layout.renderContent({
	                        model: integration,
	                        mappedItems: mapped,
	                        mappableItems: mappables,
	                        provider: provider,
	                        paymentAccounts: paymentAccounts,
	                        defaults: defaults,
	                        qbAccounts: qbAccounts
	                    });
	                });
	            } else if (provider === 'xero') {
	                return (0, _bluebird.all)([_payrollItemIntegrations2.default.fetchForCompany(app.company, integration, true), integration.fetchData()]).then(function (_ref11) {
	                    var _ref12 = _slicedToArray(_ref11, 2),
	                        items = _ref12[0],
	                        formData = _ref12[1];
	
	                    var mappableItems = app.payrollItems.getMappable();
	
	                    var mappingTypes = [{ id: 'net', label: 'Net salary' }, { id: 'base', label: 'Basic salary' }, { id: 'gross', label: 'Gross salary' }];
	
	                    _this8.layout.renderContent({
	                        provider: provider,
	                        model: integration,
	                        mappingTypes: mappingTypes,
	                        items: items,
	                        mappableItems: mappableItems,
	                        organisations: formData.organisations,
	                        contacts: formData.contacts,
	                        debitAccounts: formData.debitAccounts,
	                        creditAccounts: formData.creditAccounts
	                    });
	                }).catch(function () {
	                    _this8.layout.renderContent({ model: null });
	
	                    var title = 'Xero connection error';
	                    var message = 'Could not access Xero API, ' + 'please reconnect or contact your system administrator.';
	                    _alerts2.default.show('error', {
	                        title: title,
	                        html: message
	                    });
	                });
	            } else {
	                _this8.layout.renderContent({
	                    provider: 'unknown',
	                    model: null
	                });
	            }
	        }).catch(function () {
	            _this8.layout.renderContent({ model: null });
	        }).finally(function () {
	            return _this8.layout.hideLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _Layout = __webpack_require__(837);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _CompanySetup = __webpack_require__(838);
	
	var _CompanySetup2 = _interopRequireDefault(_CompanySetup);
	
	var _TaxSettings = __webpack_require__(843);
	
	var _TaxSettings2 = _interopRequireDefault(_TaxSettings);
	
	var _Position = __webpack_require__(845);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _PayrollItems = __webpack_require__(694);
	
	var _PayrollItems2 = _interopRequireDefault(_PayrollItems);
	
	var _PaymentLayout = __webpack_require__(851);
	
	var _PaymentLayout2 = _interopRequireDefault(_PaymentLayout);
	
	var _Leave = __webpack_require__(863);
	
	var _Leave2 = _interopRequireDefault(_Leave);
	
	var _Notifications = __webpack_require__(867);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _Subscription = __webpack_require__(869);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _Integrations = __webpack_require__(871);
	
	var _Integrations2 = _interopRequireDefault(_Integrations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    contentView: null,
	
	    initialize: function initialize(options) {
	        //FIXME NEVER extend this with options
	        _.extend(this, options);
	    },
	
	    render: function render() {
	        this.$el.html((0, _Layout2.default)({ tab: this.tab }));
	
	        return this;
	    },
	
	    // this is only to provide immediate feedback so user quickly sees selected
	    // tab
	    renderTab: function renderTab(tab) {
	        this.tab = tab;
	        this.render();
	    },
	
	    renderContent: function renderContent(options) {
	        this.render();
	        if (this.contentView) {
	            this.contentView.remove();
	        }
	
	        if (this.tab === 'company') {
	            this.contentView = new _CompanySetup2.default(_.extend({ el: this.$('.js-company-setup') }, options));
	            this.$('.js-company-setup-tab').addClass('active');
	        } else if (this.tab === 'tax') {
	            this.contentView = new _TaxSettings2.default(_.extend({ el: this.$('.js-tax') }, options));
	            this.$('.js-tax-tab').addClass('active');
	        } else if (this.tab === 'positions') {
	            this.contentView = new _Position2.default(_.extend({ el: this.$('.js-position') }, options));
	            this.$('.js-position-tab').addClass('active');
	        } else if (this.tab === 'payrollItems') {
	            this.contentView = new _PayrollItems2.default(_.extend({ el: this.$('.js-payroll-items') }, options));
	            this.$('.js-payroll-items-tab').addClass('active');
	        } else if (this.tab === 'leave') {
	            this.contentView = new _Leave2.default(_.extend({ el: this.$('.js-leave') }, options));
	            this.$('.js-leave-tab').addClass('active');
	        } else if (this.tab === 'payment') {
	            this.contentView = new _PaymentLayout2.default(_.extend({ el: this.$('.js-payment') }, options));
	            this.$('.js-payment-tab').addClass('active');
	        } else if (this.tab === 'notifications') {
	            this.contentView = new _Notifications2.default(_.extend({ el: this.$('.js-notifications') }, options));
	            this.$('.js-notifications-tab').addClass('active');
	        } else if (this.tab === 'subscription') {
	            this.contentView = new _Subscription2.default(_.extend({ el: this.$('.js-subscription') }, options));
	            this.$('.js-subscription-tab').addClass('active');
	        } else if (this.tab === 'integrations') {
	            this.contentView = new _Integrations2.default(_.extend({ el: this.$('.js-integrations') }, options));
	            this.$('.js-integrations-tab').addClass('active');
	        }
	
	        this.$('input[type="checkbox"]').iCheck({
	            checkboxClass: 'icheckbox_square-blue'
	        });
	        _tooltip2.default.init(this);
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-loading-tab').removeClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Layout.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Settings</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content wrapper-tabs wrapper-settings">\n<div class="row">\n<div class="col-md-12 col-lg-12">\n<div class="tabs-container">\n    <div class="tabs-left">\n        <ul class="nav nav-tabs">\n            <li class="';
	 if (tab === 'company') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/company">Company Details</a>\n            </li>\n            ';
	 if (!app.company.get('mppAdminId')) { 
	__p+='\n            <li class="';
	 if (tab === 'tax') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/tax">Tax Settings</a>\n            </li>\n            ';
	 } 
	__p+='\n            <li class="';
	 if (tab === 'leave') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/leave">Leave Settings</a>\n            </li>\n            <li class="';
	 if (tab === 'payment') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/payment">Payment Settings</a>\n            </li>\n            <li class="';
	 if (tab === 'positions') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/positions">Positions</a>\n            </li>\n            <li class="';
	 if (tab === 'payrollItems') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/payrollItems">Payroll Items</a>\n            </li>\n            <li class="';
	 if (tab === 'notifications') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/notifications">Notifications</a>\n            </li>\n            ';
	 if (!app.user.get('isMPPCustomer')) { 
	__p+='\n            <li class="';
	 if (tab === 'subscription') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/subscription">Subscription</a>\n            </li>\n            ';
	 } 
	__p+='\n            <li class="';
	 if (tab === 'integrations') { 
	__p+=' active ';
	 } 
	__p+='">\n                <a href="#settings/integrations">Integrations</a>\n            </li>\n        </ul>\n        <div class="tab-content">\n            <div class="js-company-setup-tab tab-pane">\n                <div class="js-company-setup panel-body"></div>\n            </div>\n            <div class="js-tax-tab tab-pane">\n                <div class="js-tax panel-body"></div>\n            </div>\n            <div class="js-leave-tab tab-pane">\n                <div class="js-leave panel-body"></div>\n            </div>\n            <div class="js-payment-tab tab-pane">\n                <div class="js-payment panel-body"></div>\n            </div>\n            <div class="js-position-tab tab-pane">\n                <div class="js-position panel-body"></div>\n            </div>\n            <div class="js-payroll-items-tab tab-pane">\n                <div class="js-payroll-items panel-body"></div>\n            </div>\n            <div class="js-notifications-tab tab-pane">\n                <div class="js-notifications panel-body"></div>\n            </div>\n            <div class="js-subscription-tab tab-pane">\n                <div class="js-subscription panel-body"></div>\n            </div>\n            <div class="js-integrations-tab tab-pane">\n                <div class="js-integrations panel-body"></div>\n            </div>\n            <div class="js-loading-tab tab-pane active">\n                <div class="panel-body">\n                    <div class="loader-wrapper">\n                        <div class="loader">\n                            '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                        </div>\n                        <div class="clearfix"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n</div>\n</div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _Cocktail = __webpack_require__(548);
	
	var _Cocktail2 = _interopRequireDefault(_Cocktail);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _CompanySetup = __webpack_require__(839);
	
	var _CompanySetup2 = _interopRequireDefault(_CompanySetup);
	
	var _LocationModal = __webpack_require__(840);
	
	var _LocationModal2 = _interopRequireDefault(_LocationModal);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _BankAccount = __webpack_require__(782);
	
	var _BankAccount2 = _interopRequireDefault(_BankAccount);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CompanyTypes = __webpack_require__(842);
	
	var _CompanyTypes2 = _interopRequireDefault(_CompanyTypes);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _companyLocation = __webpack_require__(574);
	
	var _companyLocation2 = _interopRequireDefault(_companyLocation);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function showAddEmployeesPrompt() {
	    _modal2.default.confirm({
	        title: 'Success!',
	        type: 'success',
	        customClass: 'sweet-alert-success',
	        cancelButtonText: 'Add Later',
	        confirmButtonText: 'Add Now',
	        text: 'Would you like to add employees?',
	
	        callback: function callback(isConfirm) {
	            return app.mainRouter.navigate(isConfirm ? 'employee/add' : 'settings/company', { trigger: true });
	        }
	    });
	}
	
	function showAddEmployeesPromptIfNotAdded() {
	    new _employees2.default(null, { company: app.company }).count().then(function (count) {
	        if (count === 0) {
	            showAddEmployeesPrompt();
	            return;
	        }
	    });
	}
	
	module.exports = _Cocktail2.default.mixin(_Form2.default.extend({
	    locationModal: null,
	    bankAccountModal: null,
	
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events(), {
	            'change input.js-ext-primary-location': 'updatePrimaryLocation',
	            'change select.js-ext-primary-location': 'updatePrimaryLocation',
	            'click .js-iakaun-btn': 'iakaunToggle',
	            'click .js-add-location': 'newLocation',
	            'click .js-change-company-logo': 'onChangeLogo',
	            'click .js-remove-company-logo': 'onRemoveLogo',
	            'change .js-change-company-logo-input': 'uploadLogo'
	        });
	    },
	
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        this.options = Object.assign({
	            template: _CompanySetup2.default,
	            locations: [],
	            bankAccountOverrides: {
	                isPayer: true,
	                isPayee: false
	            },
	            templateExtra: {
	                companyTypes: _CompanyTypes2.default
	            }
	        }, options);
	
	        if (!this.options.locations.getPrimary()) {
	            this.options.locations.add({
	                name: 'HQ',
	                primary: true,
	                companyId: this.model.id
	            }, { silent: true });
	        }
	
	        this.options.templateExtra = Object.assign({
	            primaryLocation: this.options.locations.getPrimary(),
	            locations: this.options.locations,
	            states: _address2.default.getStatesList()
	        }, this.options.templateExtra || {});
	
	        this.options.bankAccountOverrides = Object.assign(this.options.bankAccountOverrides || {}, {
	            companyId: this.model.id
	        });
	
	        this.locationModal = new _LocationModal2.default();
	
	        // Clear validation errors that could have been produced by just
	        // fetching the model. This view has weird validation checking on save
	        // and if we don't do this the first time the user hits save some
	        // errors might be missing in the UI
	        this.model.validationError = false;
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        _Form2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.options.locations.on('add remove change', this.renderLocations, this);
	        this.options.locations.on('error', this.invalidLocation, this);
	        this.options.locations.on('change', this.validLocation, this);
	
	        this.locationModal.on('save', this.addLocation, this);
	        this.locationModal.on('remove', this.removeLocation, this);
	
	        return this;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        _Form2.default.prototype.unbindHandlers.apply(this, arguments);
	
	        this.options.locations.off(null, null, this);
	        this.locationModal.off(null, null, this);
	
	        return this;
	    },
	
	    render: function render() {
	        _Form2.default.prototype.render.apply(this, arguments);
	
	        this.renderLocations();
	        this.markMandatoryFields(new _address2.default().constraints());
	
	        this.$('[name=eNumber]').inputmask('99999999-99');
	
	        return this;
	    },
	
	    cancel: function cancel(ev) {
	        var _this = this;
	
	        ev.preventDefault();
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.fetch().then(function () {
	            return _this.model.fetchBankAccount();
	        }).then(function () {
	            return _this.options.locations.fetch();
	        }).then(function () {
	            return _this.options.locations.fetchAddresses();
	        }).then(function () {
	            return _this.options.locations.fetchEmployees();
	        }).then(function () {
	            return _this.render();
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    dirty: function dirty() {
	        return this.model.dirty() || this.options.locations.dirty() || this.model.getBankAccount() && this.model.getBankAccount().dirty();
	    },
	
	    warnMissingNumbers: function warnMissingNumbers() {
	        var _this2 = this;
	
	        return new _bluebird2.default(function (resolve) {
	            var missing = _this2.model.getMissingRegNumbers();
	
	            if (missing.length === 0) {
	                return resolve(true);
	            }
	
	            _modal2.default.warning({
	                title: '',
	                text: 'The following fields are required in ' + 'order to generate fully complete forms and documents ' + 'for your payroll: </br>' + missing.join(', </br>'),
	                html: true,
	                callback: function callback() {
	                    return resolve(true);
	                }
	            });
	        });
	    },
	
	    save: function save(ev) {
	        var _this3 = this;
	
	        ev.preventDefault();
	
	        var $button = this.$(ev.currentTarget);
	        var primaryLoc = this.options.locations.getPrimary();
	        var stopLoader = function stopLoader() {};
	
	        /* We could rely on error events, but since the form requires values
	         * from two different models, we have to manually check both for
	         * errors
	         */
	        var validationFailed = false;
	        if (!primaryLoc.wasValid() || !primaryLoc.isValid()) {
	            this.invalid(this.model, primaryLoc.validationError);
	            validationFailed = true;
	        }
	        if (!this.model.wasValid() || !this.model.isValid()) {
	            this.invalid(this.model, this.model.validationError);
	            validationFailed = true;
	        }
	        if (validationFailed) {
	            /* If either of the required models failed validation, bail out
	             */
	            return;
	        }
	
	        /* The locations are saved first because the company beforeSave
	         * trigger will check them in order to determine if the company
	         * is setup
	         */
	        this.warnMissingNumbers().then(function () {
	            stopLoader = _loader2.default.startFullScreen($button);
	        }).then(function () {
	            if (_this3.options.locations.dirty()) {
	                return _this3.options.locations.save();
	            }
	        }).then(function () {
	            // if logo was removed, persist that through the
	            // specific endpoint for the action
	            if (_this3.model.dirtyKeys().includes('logoUrl') && !_this3.model.get('logoUrl')) {
	                return _this3.model.unsetLogo();
	            }
	        }).then(function () {
	            if (app.user.isAdmin() && _this3.model.dirtyKeys().includes('maxEmployeeCount')) {
	                return _this3.model.setMaxEmployeeCount(_this3.model.get('maxEmployeeCount'));
	            }
	        }).then(function () {
	            return _this3.model.save();
	        })
	        // fetch again as changes in location can trigger changes in the
	        // backend
	        .then(function () {
	            return _this3.model.fetch();
	        }).then(function () {
	            //resetting the model binds handlers again and renders
	            _this3.setModel(_this3.model);
	
	            showAddEmployeesPromptIfNotAdded();
	
	            _modal2.default.showAlertSuccess('Your changes have been saved');
	        }).catch(function (err) {
	            _modal2.default.error({ text: err });
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    renderLocations: function renderLocations() {
	        var _this4 = this;
	
	        var nonPrimary = this.options.locations.filter(function (location) {
	            return location.get('primary') === false;
	        });
	
	        this.$('.js-location-list').html('');
	
	        nonPrimary.forEach(function (location) {
	            var address = location.getAddress();
	            var $edit = $('<a href= "">').text('Edit');
	            var stateName = address.getStateName();
	            var addressString = [address.get('line1'), address.get('city'), stateName, address.get('postcode'), address.get('contactPhone')].filter(function (s) {
	                return !!s;
	            }).join(', ');
	            var $location = $('<li>').append($('<strong>').text(location.get('name')), ' ' + addressString, $edit);
	            $edit.on('click', function (ev) {
	                ev.preventDefault();
	
	                _this4.locationModal.setModel(location);
	                _this4.locationModal.render();
	                _this4.locationModal.show();
	            });
	
	            _this4.$('.js-location-list').append($location);
	        });
	
	        if (nonPrimary.length) {
	            this.$('.js-location-list').show();
	            this.$('.js-location-list-none').hide();
	        } else {
	            this.$('.js-location-list').hide();
	            this.$('.js-location-list-none').show();
	        }
	    },
	
	    invalidLocation: function invalidLocation(model, errors) {
	        if (model.get('primary') === true) {
	            this.invalid(model, errors);
	        }
	    },
	
	    validLocation: function validLocation(model, errors) {
	        if (model.get('primary') === true) {
	            this.valid(model, errors);
	        }
	    },
	
	    updatePrimaryLocation: function updatePrimaryLocation(ev) {
	        var $el = this.$(ev.currentTarget);
	        var attr = $el.attr('name');
	        var value = $el.val();
	        var primaryLocation = this.options.locations.getPrimary();
	
	        if (!primaryLocation.getAddress()) {
	            return;
	        }
	
	        this.toggleError(attr);
	        if (primaryLocation.validationError && primaryLocation.validationError[attr]) {
	            delete primaryLocation.validationError[attr];
	        }
	
	        primaryLocation.getAddress().set(_defineProperty({}, attr, value));
	        if (!primaryLocation.wasValid()) {
	            this.invalid(this.model, primaryLocation.validationError || {});
	        }
	    },
	
	    newLocation: function newLocation() {
	        var locationName = (this.model.get('companyName') || 'Location') + ' ' + (this.options.locations.length + 1);
	
	        if (this.options.locations.length > 1) {
	            var lastLocation = this.options.locations.last();
	            var regex = /[0-9]+$/g;
	            var m = regex.exec(lastLocation.get('name'));
	            if (m && m.length > 0) {
	                var newInt = parseInt(m[0]) + 1;
	                locationName = (this.model.get('companyName') || 'Location') + ' ' + newInt;
	            }
	        }
	
	        var newCompanyLocation = new _companyLocation2.default({
	            companyId: this.model.id,
	            name: locationName,
	            primary: false
	        });
	        newCompanyLocation.locations = this.options.locations;
	
	        this.locationModal.setModel(newCompanyLocation);
	        this.locationModal.render({ addMode: true });
	        this.locationModal.show();
	    },
	
	    addLocation: function addLocation(location) {
	        if (location.isNew() && !this.options.locations.contains(location)) {
	            this.options.locations.add(location);
	        }
	    },
	
	    removeLocation: function removeLocation(location) {
	        if (this.options.locations.contains(location)) {
	            this.options.locations.destroyLater(location);
	            this.options.locations.remove(location);
	        }
	    },
	
	    iakaunToggle: function iakaunToggle(e) {
	        var $iakaun = this.$('.js-iakaun');
	
	        if ($iakaun.attr('type') === 'password') {
	            $iakaun.attr('type', 'text');
	            $(e.currentTarget).button('hide');
	        } else {
	            $iakaun.attr('type', 'password');
	            $(e.currentTarget).button('reset');
	        }
	    },
	
	    onChangeLogo: function onChangeLogo() {
	        this.$('.js-change-company-logo-input').click();
	    },
	
	    onRemoveLogo: function onRemoveLogo() {
	        this.model.set('logoUrl', null);
	        this.render();
	    },
	
	    uploadLogo: function uploadLogo(e) {
	        var _this5 = this;
	
	        var stopLoader = _loader2.default.startFullScreen();
	        var selectedFile = this.$(e.currentTarget)[0].files[0];
	        this.model.uploadLogo(selectedFile).then(function () {
	            return _this5.render();
	        }).catch(function (err) {
	            _alerts2.default.show('error', err);
	        }).finally(function () {
	            return stopLoader();
	        });
	    }
	}), _BankAccount2.default);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/CompanySetup.ejs -->\n<form id="form-company-setup" role="form" class="form-horizontal">\n    <!-- prevent save password & autofill  -->\n    <input type="text" style="height: 1px; width: 1px; opacity: 0.01"/>\n    <input type="password" style="height: 1px; width: 1px; opacity: 0.01"/>\n    <!-- prevent save password & autofill  -->\n\n    <!-- name -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Company Name\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="bottom" data-container="body"\n                data-html="true"\n                title="Can be found on: <ul>\n                    <li>Borang A</li>\n                    <li>Borang 8A</li>\n                    <li>CP 39</li>\n                    <li>Form E</li>\n                    <li>Form EA</li>\n                </ul>">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="companyName" type="text"\n                class="form-control"\n                value="'+
	((__t=( model.get('companyName') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-companyName"></span>\n        </div>\n    </div>\n\n    ';
	 if(app.user.isAdmin()){ 
	__p+='\n    <!-- isLocked -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Locked?\n        </label>\n        <div class="col-sm-9">\n            <input name="isLocked" type="checkbox"\n                class="form-control"\n                data-value-type="boolean"\n                '+
	((__t=( model.get('isLocked') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n            >\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Maximum Employee Number\n        </label>\n        <div class="col-sm-9">\n            <input name="maxEmployeeCount" type="text"\n                class="form-control"\n                data-value-type="integer"\n                value="'+
	((__t=( model.get('maxEmployeeCount') ))==null?'':_.escape(__t))+
	'"\n            >\n        </div>\n    </div>\n    ';
	 } 
	__p+='\n\n    <!-- type -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Company Type</label>\n        <div class="col-sm-9">\n            <select name="type" class="form-control">\n                ';
	 if(!model.get('type')){ 
	__p+='\n                    <option value=""></option>\n                ';
	 } 
	__p+='\n                ';
	 companyTypes.forEach(function (type) {
	__p+='\n                    <option value="'+
	((__t=( type.value ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( model.get('type') === type.value ? 'selected' : '' ))==null?'':_.escape(__t))+
	'\n                    >\n                        '+
	((__t=( type.label ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	});
	__p+='\n            </select>\n            <span class="error error-type"></span>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <!-- contactEmail -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Company Email\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="Enter email, which you prefer\n                to appear on Form E"></i>\n        </label>\n        <div class="col-sm-9">\n            <input name="contactEmail" type="text"\n                class="form-control"\n                value="'+
	((__t=( model.get('contactEmail') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-contactEmail"></span>\n        </div>\n    </div>\n\n    ';
	 address = primaryLocation ? primaryLocation.getAddress() : false; 
	__p+='\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Contact Phone</label>\n        <div class="col-sm-3">\n            <input name="contactPhone" type="text"\n                class="form-control js-ext js-ext-primary-location"\n                value="'+
	((__t=( address ? address.get('contactPhone') : '' ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-contactPhone"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Street Address</label>\n        <div class="col-sm-9">\n            <input name="line1" type="text"\n                class="form-control js-ext js-ext-primary-location"\n                value="'+
	((__t=( address ? address.get('line1') : '' ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-line1"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">City</label>\n        <div class="col-sm-9">\n            <input name="city" type="text"\n                class="form-control js-ext js-ext-primary-location"\n                value="'+
	((__t=( address ? address.get('city') : '' ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-city"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">State</label>\n        <div class="col-sm-9">\n            <select name="state"\n                class="form-control js-ext js-ext-primary-location">\n                <option value =""></option>\n                ';
	 _.each(states, function(state) { 
	__p+='\n                    ';
	 code = state.code 
	__p+='\n                    ';
	 addrState = address ?
	                        (address.get('state') || '') : '' 
	__p+='\n                    <option value="'+
	((__t=( code ))==null?'':_.escape(__t))+
	'"\n                        ';
	 if (addrState == code) { 
	__p+='selected';
	  } 
	__p+='>\n                        '+
	((__t=( state.name ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }); 
	__p+='\n            </select>\n            <span class="error error-state"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Post Code</label>\n        <div class="col-sm-5">\n            <input name="postcode" type="text"\n                   class="form-control js-ext js-ext-primary-location"\n                   value="'+
	((__t=( address ? address.get('postcode') : '' ))==null?'':_.escape(__t))+
	'"\n                   maxlength="5" />\n\n            <span class="error error-postcode"></span>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <!-- logo -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Company Logo\n        </label>\n        <div class="col-sm-9">\n            <input class="hide js-change-company-logo-input"\n                type="file" accept="image/*"\n                value="'+
	((__t=( model.getLogoUrl() ))==null?'':_.escape(__t))+
	'" >\n            <p class="form-control-static">\n                ';
	 if (!model.getLogoUrl()) { 
	__p+='\n                        No Logo Added\n                ';
	 } else { 
	__p+='\n                        <img class="company-logo"\n                            src="'+
	((__t=( model.getLogoUrl() ))==null?'':_.escape(__t))+
	'" />\n                ';
	 } 
	__p+='\n            </p>\n            <div class="change-image-wrapper">\n                <span class="js-change-company-logo btn btn-default">\n                    Change Logo\n                </span>\n                ';
	 if (model.get('logoUrl')) { 
	__p+='\n                    <span class="js-remove-company-logo btn btn-default">\n                        Remove Logo\n                    </span>\n                ';
	 } 
	__p+='\n            </div>\n            <span class="error error-logo"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Other Locations\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"  data-html="true"\n                data-original-title="\n                <p>You can set different locations and assign employees to\n                each one. Once new locations were added you\n                can modify their Payment settings under each location.</p>">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <p class="js-location-list-none form-control-static">\n                No Other Locations\n            </p>\n            <ol class="js-location-list company-location-list"\n                style="display: none;"></ol>\n            <button type="button" class="js-add-location btn btn-white">\n                Add Location\n            </button>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Bank Details\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body" data-html="true"\n                data-original-title="If you want to generate bank files to make\n                    bulk payments to your employees then you need to add your bank\n                    details here.">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            ';
	 if (model.getBankAccount()) { 
	__p+='\n                <div>\n                    <p class="form-control-static">\n                        '+
	((__t=( model.getBankAccount().get('bankName') ))==null?'':_.escape(__t))+
	',\n                        '+
	((__t=( model.getBankAccount().get('number') ))==null?'':_.escape(__t))+
	' (\n                            '+
	((__t=( model.getBankAccount().get('holderName') ))==null?'':_.escape(__t))+
	'\n                        )\n                    </p>\n                    <button type="button"\n                        class="js-edit-bank-account btn btn-white"\n                        tabindex="30">\n                        Edit\n                    </button>\n                </div>\n            ';
	 } else { 
	__p+='\n                <button type="button" class="js-add-bank-account btn btn-white"\n                    tabindex="30">\n                    Add Bank Account\n                </button>\n            ';
	 } 
	__p+='\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Company Registration &numero;\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-html="true"\n                title="Can be found on: <ul>\n                    <li>SSM forms 9, 24, 49 (No. Syarikat/MyCoID)</li>\n                    <li>Form E (Field 7)</li>\n                    <li>CP39 (No. Pendaftaran Perniagaan)</li>\n                </ul>">\n            </i>\n\n        </label>\n        <div class="col-sm-9">\n            <input name="regNumber" type="text"\n                class="form-control" value="'+
	((__t=( model.get('regNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-regNumber"></span>\n        </div>\n    </div>\n\n    <!-- e number -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            E Number\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body" data-html="true"\n                data-original-title="\n<p>Please complete with 10 digits without the letter E </br>\n                Example 1 : E 908915-10 has to be filled as 0090891510</br>\n                Example 2 : E 6918546-05 has to be filled as 0691854605</br>\n                Example 3 : E 90002135-00 has to be filled as 9000213500</br>\n                </p>\n                Can be found on: <ul>\n                    <li>Form CP39 (No. Rujukan Majikan E)</li>\n                    <li>Form E (Field 2)</li>\n                    <li>Form EA (Employer\'s E-number)</li>\n                    </ul>">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="eNumber" type="text"\n                class="form-control" value="'+
	((__t=( model.get('eNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-eNumber"></span>\n        </div>\n    </div>\n\n    <!-- tax reg number -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            C Number\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"  data-html="true"\n                data-original-title="\n                    <p>Can be found on: Form E (Field 5)\n                    <p>The C Number is only required for generating end of year Form E</p>">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="taxRegNumber" type="text"\n                class="form-control" value="'+
	((__t=( model.get('taxRegNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxRegNumber"></span>\n        </div>\n    </div>\n\n    <!-- epf reg number -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            EPF &numero;\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"  data-html="true"\n                data-original-title="<p>Can be found on: Borang A (No. Rujukan\n                Majikan)</p>">\n            </i>\n        </label>\n        <div class="col-sm-3">\n            <input name="epfRegNumber" autocomplete="new-password" type="text"\n               class="form-control" value="'+
	((__t=( model.get('epfRegNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-epfRegNumber"></span>\n        </div>\n        <label class="col-sm-2 control-label">\n            I-Akaun password\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="You may enter your I-Akaun password for reference only"></i>\n        </label>\n        <div class="col-sm-4">\n            <div class="input-group">\n                <input type="password"\n                    name="iakaunPassword" class="js-iakaun form-control"\n                    value="'+
	((__t=( model.get('iakaunPassword') ))==null?'':_.escape(__t))+
	'">\n                <span class="input-group-btn">\n                    <button type="button" data-hide-text="Hide"\n                        class="js-iakaun-btn btn btn-white"\n                        tabindex="-1">\n                        Show\n                    </button>\n                </span>\n            </div>\n            <span class="error error-iakaunPassword"></span>\n        </div>\n    </div>\n\n    <!-- socso reg number -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            SOCSO &numero;\n            <!-- Tooltip -->\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"  data-html="true"\n                data-original-title="\n                <p>Can be found on: Perkeso Borang 8A (No. Kod Majikan) </p>">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input name="socsoRegNumber" type="text"\n               class="form-control" value="'+
	((__t=( model.get('socsoRegNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-socsoRegNumber"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Zakat &numero;</label>\n        <div class="col-sm-9">\n            <input name="zakatRefNumber" type="text"\n               class="form-control" value="'+
	((__t=( model.get('zakatRefNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-zakatRefNumber"></span>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <div class="text-right">\n        <button type="button"\n            class="js-cancel btn btn-w-m btn-warning"\n            data-toggle="tooltip" data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i> Cancel\n        </button>\n        <button type="submit" class="js-save btn btn-w-m btn-primary m-l-xs">\n            <i class="fa fa-check"></i> Save\n        </button>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {'use strict';
	
	var _LocationModal = __webpack_require__(841);
	
	var _LocationModal2 = _interopRequireDefault(_LocationModal);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	module.exports = Backbone.View.extend({
	
	    className: 'modal inmodal',
	
	    events: {
	        'click .js-cancel': 'cancel',
	        'click .js-remove': 'remove',
	        'click .js-save': 'save',
	        'change input:not(.js-address)': 'updateModel',
	        'change select:not(.js-address)': 'updateModel',
	        'change input.js-address': 'updateModelAddress',
	        'change select.js-address': 'updateModelAddress'
	    },
	
	    initialize: function initialize() {
	        if (this.model) {
	            this.bindHandlers();
	            this.render();
	        }
	
	        return this;
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.model.on('invalid', this.invalid, this);
	        this.model.on('change', this.valid, this);
	    },
	
	    setModel: function setModel(model) {
	        this.model = model;
	        this.bindHandlers();
	    },
	
	    render: function render(addMode) {
	        this.$el.html((0, _LocationModal2.default)({
	            model: this.model,
	            addMode: !!addMode,
	            states: _address2.default.getStatesList()
	        }));
	        _tooltip2.default.init(this);
	        return this;
	    },
	
	    updateModel: function updateModel(ev) {
	        var $el = $(ev.currentTarget);
	        var attr = $el.attr('name');
	
	        this.model.set(_defineProperty({}, attr, $el.val()), { validateAttrs: { include: [attr] } });
	    },
	
	    updateModelAddress: function updateModelAddress(ev) {
	        var $el = $(ev.currentTarget);
	        var attr = $el.attr('name');
	
	        if (!this.model.getAddress()) {
	            return;
	        }
	
	        this.model.getAddress().set(_defineProperty({}, attr, $el.val()), { validateAttrs: { include: [attr] } });
	    },
	
	    toggleError: function toggleError(attribute, message) {
	        this.$('[name=' + attribute + ']').closest('.form-group').toggleClass('has-error', !_.isUndefined(message));
	        this.$('.error-' + attribute).text(message);
	
	        var hasError = this.$('[name=' + attribute + ']').closest('.form-group').hasClass('has-error');
	        if (!hasError) {
	            this.$('span.error-' + attribute).hide();
	        } else {
	
	            this.$('span.error-' + attribute).show();
	        }
	    },
	
	    invalid: function invalid(model, error) {
	        var _this = this;
	
	        Object.keys(error || {}).forEach(function (attribute) {
	            _this.toggleError(attribute, error[attribute][0]);
	        });
	    },
	
	    valid: function valid(model) {
	        var _this2 = this;
	
	        var address = model.getAddress();
	
	        if (address) {
	            Object.keys(address.changed || {}).forEach(function (attr) {
	                _this2.toggleError(attr);
	            });
	        }
	
	        Object.keys(model.changed || {}).forEach(function (attr) {
	            _this2.toggleError(attr);
	        });
	    },
	
	    save: function save() {
	        //Whenever you try to put a invalid value into model it rises a error and
	        //DO NOT PUT such value into the model, so the UI and MODEL get OUT OF SYNC
	        //So we must validate UI for valid values too, before save it.
	        var nameValue = this.$('[name="name"]').val();
	        var hasNameErrors = this.model.validate({ name: nameValue }).name;
	
	        if (this.model.isValid() && !hasNameErrors) {
	            this.trigger('save', this.model);
	            this.hide();
	            if (this.model.locations) {
	                this.model.locations.add(this.model);
	            }
	        } else {
	            var state = this.model.getAddress().get('state');
	            if (!state) {
	                this.toggleError('state', 'State is required');
	            }
	
	            if (hasNameErrors) {
	                this.toggleError('name', 'Name is required');
	            }
	
	            // TODO this block of code seems to serve no purpose. Looks safe to
	            // delete but not sure
	            if (this.model.validationError) {
	                var errors = this.model.validationError.name;
	                if (errors) {
	                    var nameError = errors.find(function (error) {
	                        return error.includes('Name');
	                    });
	                    this.toggleError('name', nameError);
	                }
	            }
	        }
	    },
	
	    show: function show() {
	        this.$el.modal('show');
	    },
	
	    hide: function hide() {
	        this.$el.modal('hide');
	    },
	
	    cancel: function cancel() {
	        this.hide();
	    },
	
	    remove: function remove() {
	        var _this3 = this;
	
	        var employees = this.model.getEmployees();
	        if (employees.length > 0) {
	            var employeeNames = employees.map(function (employee) {
	                return employee.get('fullName');
	            }).join(', ');
	
	            _alerts2.default.show('confirm', {
	                title: 'Important note!',
	                text: 'Note: employee(s) (' + employeeNames + ') are ' + 'assigned to this location. If you choose to ' + 'remove Location, employee(s) will be ' + 'assigned to HQ location.',
	                confirmButtonText: 'Delete',
	                cancelButtonText: 'Cancel',
	                callback: function callback(confirm) {
	                    if (confirm) {
	                        _this3.trigger('remove', _this3.model);
	                        _this3.hide();
	                    }
	                }
	            });
	        } else {
	            this.trigger('remove', this.model);
	            this.hide();
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14), __webpack_require__(27)))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/LocationModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            ';
	 if (addMode) { 
	__p+='\n                <h3>Add Location</h3>\n            ';
	 } else { 
	__p+='\n                <h3>Edit Location</h3>\n            ';
	 } 
	__p+='\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <!-- name -->\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">Name*</label>\n                        <div class="col-sm-9">\n                            <input class="form-control" type="text" name="name"\n                                value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'" required>\n                            <label class="error" style="display: none;"></label>\n                            <span class="error error-name"></span>\n                        </div>\n                    </div>\n\n                    ';
	 address = model.getAddress(); 
	__p+='\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Street Address\n                        </label>\n                        <div class="col-sm-9">\n                            <input class="form-control js-address" type="text"\n                                name="line1"\n                                value="'+
	((__t=( address && address.get('line1') ))==null?'':_.escape(__t))+
	'">\n                            <label class="error" style="display: none;"></label>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">City</label>\n                        <div class="col-sm-9">\n                            <input class="form-control js-address" type="text"\n                                name="city" value="'+
	((__t=( address && address.get('city') ))==null?'':_.escape(__t))+
	'">\n                            <label class="error" style="display: none;"></label>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">State*</label>\n                        <div class="col-sm-9">\n                            <select name="state"\n                                class="form-control js-address" required>\n                                <option></option>\n                                ';
	 _.each(states || [], function(state) { 
	__p+='\n                                    <option value="'+
	((__t=( state.code ))==null?'':_.escape(__t))+
	'"\n                                        '+
	((__t=( address && (address.get('state') === state.code) ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                                        '+
	((__t=( state.name ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }); 
	__p+='\n                            </select>\n                            <span class="error error-state"></span>\n                        </div>\n                    </div>\n\n                    <!-- post code and phone -->\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">Post Code</label>\n                        <div class="col-sm-2">\n                            <input name="postcode" type="text"\n                                class="form-control js-address"\n                                value="'+
	((__t=( address && address.get('postcode') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-postcode" style="display: none;"></span>\n                        </div>\n                        <label class="col-sm-3 control-label">\n                            Contact Phone\n                        </label>\n                        <div class="col-sm-4">\n                            <input name="contactPhone" type="text"\n                                class="form-control js-address"\n                                value="'+
	((__t=( address && address.get('contactPhone') ))==null?'':_.escape(__t))+
	'">\n                            <span class="error error-contactPhone" style="display: none;"></span>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            ';
	 if (!addMode) { 
	__p+='\n                <button type="button"\n                    class="js-remove btn btn-w-m btn-danger m-l-xs float-left">\n                    <i class="fa fa-trash"></i> Remove\n                </button>\n            ';
	 } 
	__p+='\n            <button type="button"\n                class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i>\n                ';
	 if (addMode) { 
	__p+='\n                    Add\n                ';
	 } else { 
	__p+='\n                    Save\n                ';
	 } 
	__p+='\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = [{
	    value: '01',
	    label: 'Individual – Resident who does not carry on business'
	}, {
	    value: '02',
	    label: 'Self-employed or Business'
	}, {
	    value: '03',
	    label: 'Partnership'
	}, {
	    value: '04',
	    label: 'Private Company (Sdn Bhd)'
	}, {
	    value: '05',
	    label: 'Hindu Joint Family'
	}, {
	    value: '06',
	    label: 'Association'
	}, {
	    value: '07',
	    label: 'Deceased Person\'s Estate'
	}, {
	    value: '08',
	    label: 'Trust Body'
	}, {
	    value: '09',
	    label: 'Unit/Real Property Trust'
	}, {
	    value: '10',
	    label: 'Co-Operative Society'
	}, {
	    value: '11',
	    label: 'Real Estate Investment Trust / Property Trust Fund'
	}, {
	    value: '12',
	    label: 'Limited Liability Partnership'
	}, {
	    value: '13',
	    label: 'Business Trust'
	}, {
	    value: '14',
	    label: 'Labuan Entity'
	}];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _TaxSettings = __webpack_require__(844);
	
	var _TaxSettings2 = _interopRequireDefault(_TaxSettings);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _address = __webpack_require__(572);
	
	var _address2 = _interopRequireDefault(_address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Form2.default.extend({
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events());
	    },
	
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        this.options = Object.assign({ template: _TaxSettings2.default }, options);
	
	        this.options.templateExtra = Object.assign({
	            states: _address2.default.getStatesList(),
	            idTypes: [{ code: 'BRN', name: 'Business Registration Number' }, { code: 'NRIC', name: 'MyKad' }, { code: 'PASSPORT', name: 'Passport' }]
	        }, this.options.templateExtra || {});
	
	        this.model.validationError = false;
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        _Form2.default.prototype.bindHandlers.apply(this, arguments);
	        return this;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        _Form2.default.prototype.unbindHandlers.apply(this, arguments);
	        return this;
	    },
	
	    render: function render() {
	        _Form2.default.prototype.render.apply(this, arguments);
	        this.markMandatoryFields(new _address2.default().constraints());
	        return this;
	    },
	
	    cancel: function cancel(ev) {
	        var _this = this;
	
	        ev.preventDefault();
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        this.model.fetch().then(function () {
	            return _this.render();
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    dirty: function dirty() {
	        return this.model.dirty();
	    },
	
	    isConsentGiven: function isConsentGiven() {
	        return this.model.isConsentGiven();
	    },
	
	    save: function save(ev) {
	        var _this2 = this;
	
	        ev.preventDefault();
	
	        if (!this.model.isValid()) {
	            this.invalid(this.model, { errors: this.model.validationError });
	            return;
	        }
	
	        if (!$('.js-taxSettingsConsent').is(':checked')) {
	            _modal2.default.warning({ text: 'Please confirm that provided tax information is correct' });
	            return;
	        }
	
	        var $button = this.$(ev.currentTarget);
	
	        var validationFailed = false;
	        if (!this.model.wasValid() || !this.model.isValid()) {
	            this.invalid(this.model, this.model.validationError);
	            validationFailed = true;
	        }
	        if (validationFailed) {
	            /* If either of the required models failed validation, bail out
	             */
	            return;
	        }
	
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        this.model.save().then(function () {
	            return _this2.model.fetch();
	        }).then(function () {
	            _this2.setModel(_this2.model);
	            _modal2.default.showAlertSuccess('Your changes have been saved');
	        }).catch(function (err) {
	            return _modal2.default.error({ text: err, confirmButtonText: 'OK', callback: function callback() {} });
	        }).finally(function () {
	            return stopLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/TaxSettings.ejs -->\n<form id="form-company-setup" role="form" class="form-horizontal">\n    <!-- prevent save password & autofill  -->\n    <input type="text" style="height: 1px; width: 1px; opacity: 0.01"/>\n    <input type="password" style="height: 1px; width: 1px; opacity: 0.01"/>\n    <!-- prevent save password & autofill  -->\n\n    <!-- Business name -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Business Name *</label>\n        <div class="col-sm-9">\n            <input name="taxInfoBusinessName" type="text"\n                   class="form-control"\n                   value="'+
	((__t=( model.get('taxInfoBusinessName') || '' ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoBusinessName"></span>\n        </div>\n    </div>\n\n    <!-- Reg no -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">ID Type *</label>\n        <div class="col-sm-9">\n            <select name="taxInfoIdType" class="form-control">\n                <option value =""></option>\n                ';
	 _.each(idTypes, function(idType) { 
	__p+='\n                    <option value="'+
	((__t=( idType.code ))==null?'':_.escape(__t))+
	'"\n                            ';
	 if (idType.code === model.get('taxInfoIdType')) { 
	__p+='selected';
	  } 
	__p+='>\n                        '+
	((__t=( idType.name ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }); 
	__p+='\n            </select>\n            <span class="error error-taxInfoIdType"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            ID Number *\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="Accepted format: max 20 characters/numbers"></i>\n        </label>\n        <div class="col-sm-9">\n            <input name="taxInfoIdNumber" type="text"\n                   class="form-control"\n                   value="'+
	((__t=( model.get('taxInfoIdNumber') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoIdNumber"></span>\n        </div>\n    </div>\n\n    <!-- TIN -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Tax Identification Number (TIN) *\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="Please remove the starting zero after the 2 letter prefixes if present. If you are a business, please add a zero at the end of your TIN (if it does not already ends in zero). Accepted format: X111111111111 or X1111111111111 or XX111111111111"></i>\n        </label>\n        <div class="col-sm-9">\n            <input name="taxInfoTIN" type="text"\n                   class="form-control"\n                   value="'+
	((__t=( model.get('taxInfoTIN') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoTIN"></span>\n        </div>\n    </div>\n\n    <!-- SST -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Sales and Service Tax Number (SST)\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="All customer with a valid SST number are required to provide SST number. Accepted format: X1-1111-11111111 or X11-1111-11111111 or X1X-1111-11111111"></i>\n        </label>\n        <div class="col-sm-9">\n            <input name="taxInfoSST" type="text"\n                   class="form-control"\n                   value="'+
	((__t=( model.get('taxInfoSST') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoSST"></span>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <!-- Address -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Street Address *</label>\n        <div class="col-sm-9">\n            <input name="taxInfoAddressLine1" type="text"\n                class="form-control"\n                value="'+
	((__t=( model.get('taxInfoAddressLine1') || '' ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoAddressLine1"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">City *</label>\n        <div class="col-sm-9">\n            <input name="taxInfoCity" type="text"\n                class="form-control"\n                value="'+
	((__t=( model.get('taxInfoCity') || '' ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoCity"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">State *</label>\n        <div class="col-sm-9">\n            <select name="taxInfoState"\n                class="form-control">\n                <option value =""></option>\n                ';
	 _.each(states, function(state) { 
	__p+='\n                    <option value="'+
	((__t=( state.code ))==null?'':_.escape(__t))+
	'"\n                            ';
	 if (state.code === model.get('taxInfoState')) { 
	__p+='selected';
	  } 
	__p+='>\n                        '+
	((__t=( state.name ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }); 
	__p+='\n            </select>\n            <span class="error error-taxInfoState"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">Post Code</label>\n        <div class="col-sm-5">\n            <input name="taxInfoPostCode" type="text"\n                   class="form-control"\n                   value="'+
	((__t=( model.get('taxInfoPostCode') || '' ))==null?'':_.escape(__t))+
	'"\n                   maxlength="10" />\n            <span class="error error-taxInfoPostCode"></span>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <!-- Phone -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="Accepted format: +1111111111111, i.e. only numbers starting with + sign"></i>\n            Phone Number *\n        </label>\n        <div class="col-sm-9">\n            <input name="taxInfoContactPhone" type="text"\n                   class="form-control"\n                   value="'+
	((__t=( model.get('taxInfoContactPhone') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-taxInfoContactPhone"></span>\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Validation Status\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="Validation status is updated asynchronously. Please reload the page to see updated status"></i>\n        </label>\n        <div class="col-sm-9 font-bold" style="padding-top: 7px;">\n            ';
	 if (!model.get('taxInfoValidationStatus') || model.get('taxInfoValidationStatus') === 0) { 
	__p+='Not Validated';
	  } 
	__p+='\n            ';
	 if (model.get('taxInfoValidationStatus') === 1) { 
	__p+='<span class="green">Valid</span>';
	 } 
	__p+='\n            ';
	 if (model.get('taxInfoValidationStatus') === 2) { 
	__p+='<span class="red">Invalid</span>';
	  } 
	__p+='\n        </div>\n    </div>\n\n    <div class="hr-line-dashed"></div>\n\n    <div class="form-group">\n        <label class="col-sm-9 control-label">\n            I confirm that the billing details provided above are correct *\n        </label>\n        <div class="col-sm-3">\n            <input class="js-icheck js-taxSettingsConsent" type="checkbox" data-value-type="boolean">\n        </div>\n    </div>\n\n    <div class="text-right">\n        <button type="button"\n            class="js-cancel btn btn-w-m btn-warning"\n            data-toggle="tooltip" data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i> Cancel\n        </button>\n        <button type="submit" class="js-save btn btn-w-m btn-primary m-l-xs">\n            <i class="fa fa-check"></i> Save\n        </button>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _position = __webpack_require__(576);
	
	var _position2 = _interopRequireDefault(_position);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = __webpack_require__(846);
	var ItemView = __webpack_require__(847);
	var ModalView = __webpack_require__(849);
	var ListEditablesView = __webpack_require__(684);
	var modal = __webpack_require__(532);
	
	module.exports = ListEditablesView.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: template,
	            Model: _position2.default,
	            ModalEditView: ModalView,
	            ModelView: ItemView
	        });
	
	        return ListEditablesView.prototype.initialize.apply(this, [this.options]);
	    },
	
	    createModel: function createModel() {
	        return new _position2.default({ company: app.company });
	    },
	
	    save: function save(ev) {
	        ListEditablesView.prototype.save.apply(this, [ev]).then(function () {
	            modal.showAlertSuccess('Settings have been saved');
	        });
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Position.ejs -->\n<table class="table table-striped table-settings">\n    <thead>\n        <tr>\n            <th>Position</th>\n        </tr>\n    </thead>\n    <tbody class="js-model-views positions">\n        <tr class="empty-table-msg js-empty">\n            <td>\n                <h2>No positions have been added yet</h2>\n            </td>\n        </tr>\n    </tbody>\n    <tfoot>\n        <tr>\n            <td>\n                <button class="btn btn-outline btn-primary btn-add js-add pull-right"\n                    data-loading-text="Adding..." \n                    data-complete-text="+ Add Position"\n                    data-toggle="tooltip" \n                    data-title="Choose to add another position"\n                    data-placement="top" data-delayed>\n                    + Add Position\n                </button>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n\n<div class="clearfix">\n    <div class="pull-right">\n        <button class="js-cancel btn btn-warning btn-w-m"\n            data-toggle="tooltip" data-title="No changes will be saved" \n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i>\n            Cancel\n        </button>\n        <button class="js-save btn btn-primary m-l-xs">\n            <i class="fa fa-check"></i>\n            Save changes\n        </button>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(848);
	var RowEditView = __webpack_require__(690);
	
	module.exports = RowEditView.extend({
	    tagName: 'tr',
	    className: 'item',
	
	    initialize: function initialize(options) {
	        var self = this;
	
	        self.options = _.defaults(options || {}, {
	            template: template,
	            deletable: true
	        });
	
	        return RowEditView.prototype.initialize.apply(self, [self.options]);
	    },
	
	    render: function render() {
	        var self = this;
	        var r = RowEditView.prototype.render.apply(self, arguments);
	
	        setTimeout(self.initializeControls.bind(self), 1);
	
	        return r;
	    },
	
	    initializeControls: function initializeControls() {
	        var self = this;
	
	        // The UI design has a weird placement for the delete button
	        self.$('.form-control-with-delete').each(function (i, control) {
	            var $control = self.$(control);
	            var $value = $control.find('.form-control-value');
	            var $input = $control.find('.form-control');
	
	            $value.css({
	                display: 'inline-block',
	                maxWidth: $input.width() - $control.find('.btn-delete').outerWidth(true) - 5 + 'px'
	            }).text($input.val());
	
	            $value.on('click', function () {
	                $control.addClass('focus');
	                $input.focus();
	            });
	
	            $input.on('keyup', function (ev) {
	                var val = self.$(ev.target).val();
	                $value.text(val);
	            }).on('focus', function () {
	                $control.addClass('focus');
	            }).on('blur', function () {
	                $control.removeClass('focus');
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PositionItem.ejs -->\n<td class="td-nowrap">\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="name"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n    <div class="error error-name"></div>\n    <div class="error error-name error-placeholder"></div>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(850);
	var ModalFormView = __webpack_require__(665);
	
	module.exports = ModalFormView.extend({
	    initialize: function initialize(options) {
	        var self = this;
	
	        self.options = _.defaults(options || {}, {
	            template: template
	        });
	
	        return ModalFormView.prototype.initialize.apply(self, [self.options]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PositionItemModal.html -->\n<div class="modal-dialog">\n    <form class="modal-content animated sweet position form-horizontal" \n        role="form">\n        <div class="modal-header">\n            <h1 class="modal-title">Add Position</h1>\n        </div>\n\n        <div class="modal-body">\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Name\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="A position is identified by its \n                            name given here.  Positions are assigned to \n                            employees from each employee profile."></i>\n                </label>\n                <div class="col-sm-8">\n                    <input name="name" class="form-control" type="text"\n                        placeholder="Enter the name of the position"\n                        value="">\n                    <span class="error error-name"></span>\n                </div>\n            </div>\n        </div>\n\n        <div class="modal-footer">\n            <button type="reset" class="btn btn-danger js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit"\n                class="btn btn-primary btn-save js-save">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _, Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _PaymentLayout = __webpack_require__(852);
	
	var _PaymentLayout2 = _interopRequireDefault(_PaymentLayout);
	
	var _Payment = __webpack_require__(853);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _PaymentDaysCalculationType = __webpack_require__(855);
	
	var _PaymentDaysCalculationType2 = _interopRequireDefault(_PaymentDaysCalculationType);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _HolidaysModal = __webpack_require__(856);
	
	var _HolidaysModal2 = _interopRequireDefault(_HolidaysModal);
	
	var _holidays = __webpack_require__(626);
	
	var _holidays2 = _interopRequireDefault(_holidays);
	
	var _WorkingDaysModal = __webpack_require__(861);
	
	var _WorkingDaysModal2 = _interopRequireDefault(_WorkingDaysModal);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SettingsView = _Form2.default.extend({
	    events: function events() {
	        return Object.assign(_Form2.default.prototype.events(), {
	            'click .js-edit-holidays': 'showHolidaysModal',
	            'click .js-edit-working-days': 'showWorkingDaysModal',
	            'focusout [name="unpaidLeaveFixedDays"]': 'toggleErrorUnpaidLeaveFixedDays'
	        });
	    },
	    initialize: function initialize(options) {
	        this.options = Object.assign({}, {
	            template: _Payment2.default,
	            unsubmittedPayroll: null,
	            holidaysModal: null,
	            workingDaysModal: null,
	            defaults: true
	        }, options || {});
	
	        this.options.templateExtra = { defaults: this.options.defaults };
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	    render: function render() {
	        _Form2.default.prototype.render.apply(this, arguments);
	        this.$('[name="holidayStates"]').chosen({ width: '100%' });
	
	        // <-- days calculation type -->
	        this.$('#days-calculation-type-container').append((0, _PaymentDaysCalculationType2.default)({
	            model: {
	                name: 'prorate',
	                text: 'Prorate Salary',
	                title: 'Please note that the basis for salary proration applicable to all employees under the ' + 'Employment Act since 1 Jan 2023 is All Days in Current Calendar Month.',
	                calculationType: this.model.get('prorateCalculationType'),
	                fixedDays: this.model.get('prorateFixedDays'),
	                isEnabled: true
	            }
	        }));
	        this.$('#days-calculation-type-container').append((0, _PaymentDaysCalculationType2.default)({
	            model: {
	                name: 'overtime',
	                text: 'Overtime',
	                title: 'Please refer to the Ordinary Rate of Pay paragraph to determine your basis for overtime calculation',
	                calculationType: this.model.get('overtimeCalculationType'),
	                fixedDays: this.model.get('overtimeFixedDays'),
	                isEnabled: true
	            }
	        }));
	        this.$('#days-calculation-type-container').append((0, _PaymentDaysCalculationType2.default)({
	            model: {
	                name: 'unpaidLeave',
	                text: 'Unpaid Leave',
	                title: 'Please note that the basis for unpaid leave calculation applicable to all employees under the ' + 'Employment Act since 1 Jan 2023 is All Days in Current Calendar Month.',
	                calculationType: this.model.get('unpaidLeaveCalculationType'),
	                fixedDays: this.model.get('unpaidLeaveFixedDays'),
	                isEnabled: this.model.get('recordUnpaidLeaveInPayroll') === true
	            }
	        }));
	        // </- days calculation type -->
	        _tooltip2.default.init(this);
	        return false;
	    },
	    bindHandlers: function bindHandlers() {
	        var _this = this;
	
	        var r = _Form2.default.prototype.bindHandlers.apply(this, arguments);
	
	        if (this.options.defaults) {
	            this.model.on('change:recordUnpaidLeaveInPayroll', this.toggleUnpaidLeaveFields, this);
	
	            // <-- days calculation type -->
	            this.model.on('change:prorateCalculationType', function () {
	                return _this.toggleFixedDays('prorate', true);
	            }, this);
	            this.model.on('change:overtimeCalculationType', function () {
	                return _this.toggleFixedDays('overtime', true);
	            }, this);
	            this.model.on('change:unpaidLeaveCalculationType', this.toggleUnpaidLeaveFixedDays, this);
	            // </- days calculation type -->
	        } else {
	            this.model.on('change:useDefaultPaymentSettings', this.toggleLocationSettings, this);
	        }
	
	        return r;
	    },
	    unbindHandlers: function unbindHandlers() {
	        _Form2.default.prototype.unbindHandlers.apply(this, arguments);
	        this.options.holidaysModal.off('save', null, this);
	        return this;
	    },
	    showHolidaysModal: function showHolidaysModal(ev) {
	        ev.preventDefault();
	        this.options.holidaysModal.show();
	    },
	    showWorkingDaysModal: function showWorkingDaysModal(ev) {
	        ev.preventDefault();
	        this.options.workingDaysModal.show();
	    },
	    toggleLocationSettings: function toggleLocationSettings() {
	        var _this2 = this;
	
	        this.$('[name=holidayStates],.js-edit-holidays').each(function (i, el) {
	            $(el).prop('disabled', _this2.model.get('useDefaultPaymentSettings')).attr('disabled', _this2.model.get('useDefaultPaymentSettings'));
	        });
	        this.$('[name=holidayStates]').trigger('chosen:updated');
	        this.$('.js-edit-working-days').attr('disabled', this.model.get('useDefaultPaymentSettings'));
	    },
	    toggleUnpaidLeaveFields: function toggleUnpaidLeaveFields() {
	        this.$('[name=unpaidLeaveCalculationType]').prop('disabled', this.model.get('recordUnpaidLeaveInPayroll') !== true);
	
	        this.toggleError('unpaidLeaveCalculationType');
	
	        this.toggleUnpaidLeaveFixedDays();
	    },
	    toggleUnpaidLeaveFixedDays: function toggleUnpaidLeaveFixedDays() {
	        return this.toggleFixedDays('unpaidLeave', this.model.get('recordUnpaidLeaveInPayroll') === true);
	    },
	    toggleFixedDays: function toggleFixedDays(name, isEnabled) {
	        $('[name=' + name + 'FixedDays]').prop('disabled', !isEnabled);
	
	        if (this.model.get(name + 'CalculationType') === 1) {
	            this.$('#' + name + 'CalculationTypeContainer').removeClass('col-sm-9').addClass('col-sm-4');
	            this.$('#' + name + 'FixedDaysContainer').show();
	        } else {
	            this.$('#' + name + 'CalculationTypeContainer').removeClass('col-sm-4').addClass('col-sm-9');
	            this.$('#' + name + 'FixedDaysContainer').hide();
	        }
	
	        // because we reset ${name}FixedDays when switch to another type
	        // we can use this value again when we switch back
	        if (this.model.get(name + 'CalculationType') === 1) {
	            var days = parseInt(this.$('[name=' + name + 'FixedDays]').val(), 10);
	            this.model.set(_defineProperty({}, name + 'FixedDays', days));
	        }
	    },
	    toggleErrorUnpaidLeaveFixedDays: function toggleErrorUnpaidLeaveFixedDays() {
	        if (!this.model.wasValid()) {
	            this.invalid(this.model, { errors: this.model.validationError });
	        } else {
	            this.valid();
	        }
	    },
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        var _this3 = this;
	
	        return new _bluebird2.default(function (resolve, reject) {
	            if (!_this3.options.unsubmittedPayroll) {
	                return resolve(true);
	            }
	
	            _modal2.default.confirm({
	                title: 'Your saved payroll will be modified!',
	                text: 'You have an unsubmitted payroll saved. ' + 'If you continue, the payroll details of all employees ' + 'will be updated based on the modifications you are ' + 'about to save. Also, any unsaved payroll details ' + 'will be lost.',
	                customClass: 'sweet-alert-error',
	                confirmButtonText: 'Yes, Save Settings',
	                callback: function callback(confirm) {
	                    if (confirm) {
	                        resolve(true);
	                    } else {
	                        reject();
	                    }
	                }
	            });
	        });
	    },
	    save: function save(ev) {
	        var _this4 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = void 0;
	
	        // if we don't return early on an invalid model, setting
	        // holidayStates and payslipSize clears old validation errors and
	        // the model is saved anyway.
	        if (!this.model.wasValid()) {
	            var errors = this.model.validationError;
	            this.invalid(this.model, { errors: errors });
	            // Poping up a form validation message,
	            // advising that Fixed Days (enabled or disabled) as not filled
	            _.forEach(errors, function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 1),
	                    error = _ref2[0];
	
	                return _this4.model.trigger('alert', error);
	            });
	            return;
	        }
	
	        this.model.set({
	            holidayStates: this.$('[name="holidayStates"]').val() || [],
	            payslipSize: this.$('[name="payslipSize"]').val() || 'A4',
	            hrdfContribution: this.$('[name="hrdfContribution"]').val() || 'auto'
	        });
	
	        // make sure the user is OK with resetting any unsubmitted payroll
	        return this.resetPayrollConfirm()
	        // save the settings
	        .then(function () {
	            stopLoader = _loader2.default.startFullScreen($button);
	            return _this4.model.save().catch(function (err) {
	                if (_this4.model.wasValid()) {
	                    // the error is not a validation error
	                    throw err;
	                }
	                throw new Error('validationError');
	            });
	        })
	        // reset the payroll
	        .then(function () {
	            if (_this4.options.unsubmittedPayroll) {
	                return _this4.options.unsubmittedPayroll.reset();
	            }
	
	            return (0, _bluebird.resolve)(true);
	        })
	        // refresh the collection of holidays
	        .then(function () {
	            return app.holidays.fetch();
	        })
	        // finish
	        .then(function () {
	            _modal2.default.showAlertSuccess('Payment settings have been saved');
	            return (0, _bluebird.resolve)(true);
	        }).catch(function (err) {
	            if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object' && err.message !== 'validationError') {
	                _modal2.default.error({ text: err });
	            }
	        }).finally(function () {
	            if (typeof stopLoader === 'function') {
	                stopLoader();
	            }
	        });
	    }
	});
	
	module.exports = Backbone.View.extend({
	    events: function events() {
	        return {
	            'change .js-ext-location': 'changeLocation'
	        };
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PaymentLayout2.default,
	            unsubmittedPayroll: null,
	            locations: null,
	            holidays: null
	        });
	
	        this.locations = this.options.locations;
	
	        return this.render();
	    },
	    render: function render() {
	        this.hqLocation = this.options.locations.find(function (location) {
	            return location.get('primary');
	        });
	
	        this.$el.html(this.options.template({
	            locations: this.options.locations,
	            locationId: this.hqLocation.id
	        }));
	
	        this.$('.js-ext-location').chosen({ width: '100%' });
	        this.renderSettings(this.hqLocation);
	        return this;
	    },
	    changeLocation: function changeLocation(ev) {
	        var $input = this.$(ev.currentTarget);
	        var val = $input.val();
	
	        var location = this.options.locations.find(function (l) {
	            return l.id === val;
	        });
	        this.renderSettings(location);
	    },
	    renderSettings: function renderSettings(location) {
	        if (this.settingsView) {
	            this.settingsView.remove();
	        }
	
	        if (!this.holidaysModal) {
	            this.holidaysModal = new _HolidaysModal2.default({
	                collection: new _holidays2.default(null, {
	                    all: true,
	                    company: app.company,
	                    location: location.id,
	                    dateStart: (0, _moment2.default)().startOf('year').toDate(),
	                    forceFetch: true
	                }),
	                location: location
	            });
	        } else {
	            this.holidaysModal.setLocation(location);
	            this.holidaysModal.collection.setOptions({
	                all: true,
	                company: app.company,
	                location: location.id,
	                dateStart: (0, _moment2.default)().startOf('year').toDate(),
	                forceFetch: true
	            });
	        }
	
	        this.workingDaysModal = new _WorkingDaysModal2.default({
	            company: this.model,
	            location: location
	        });
	
	        this.settingsView = new SettingsView({
	            model: location.get('primary') ? app.company : location,
	            unsubmittedPayroll: this.options.unsubmittedPayroll,
	            holidaysModal: this.holidaysModal,
	            workingDaysModal: this.workingDaysModal,
	            defaults: location.get('primary')
	        });
	
	        this.$('.js-ext-settings-container').append(this.settingsView.el);
	
	        this.holidaysModal.collection.fetch({ reset: true, force: true });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(27), __webpack_require__(523)))

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PaymentLayout.ejs -->\n<form class="form-horizontal" role="form">\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Payment Settings Per Location\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                title="Select the location for which you want to change\n                    payment settings, or \'All Locations\' to edit default\n                    payment settings.">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <select name="location" class="form-control chosen-select js-ext\n                js-ext-location">\n                ';
	 locations.forEach(function(location) { 
	__p+='\n                    <option value="'+
	((__t=( location.id ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( locationId === location.id ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                        '+
	((__t=( location.get('name') ))==null?'':_.escape(__t))+
	'\n                        '+
	((__t=( location.get('primary') ? '(Default Settings)' : '' ))==null?'':_.escape(__t))+
	'\n                    </option>\n                ';
	 }) 
	__p+='\n            </select>\n        </div>\n    </div>\n\n    <div class="js-ext js-ext-settings-container payment-settings">\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Payment.ejs -->\n';
	 if (!defaults) { 
	__p+='\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Use Default Settings\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="By selecting \'Yes\' employees based on this\n                    location will be affected by the default settings">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input class="js-icheck" data-value-type="boolean" type="checkbox"\n                name="useDefaultPaymentSettings"\n                ';
	 if (model.get('useDefaultPaymentSettings')) { 
	__p+=' checked ';
	 } 
	__p+='>\n        </div>\n    </div>\n';
	 } 
	__p+='\n\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Working Days\n        <i class="fa fa-question-circle" data-toggle="tooltip"\n           data-placement="top" data-container="body"\n           data-original-title="By selecting working days any leave\n           calculated will take into account these days">\n        </i>\n    </label>\n    <div class="col-sm-9">\n        <button type="button" class="js-edit-working-days btn btn-w-m btn-white"\n            '+
	((__t=( model.get('useDefaultPaymentSettings') ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'>\n            <i class="fa fa-cog"></i> Edit Working Days\n        </button>\n    </div>\n</div>\n\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Holidays:\n        <i class="fa fa-question-circle" data-toggle="tooltip"\n           data-placement="top" data-container="body"\n           data-original-title="By selecting national and state holidays\n           to display in the calendar any leave calculated will take into\n           account these holidays">\n        </i>\n    </label>\n\n    <div class="col-sm-9">\n        <select data-placeholder=" " multiple\n                class="form-control m-b js-ext"\n                '+
	((__t=( model.get('useDefaultPaymentSettings') ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'\n                name="holidayStates">\n            <option value="national"\n                '+
	((__t=( (
	                    model.get('holidayStates') &&
	                    (model.get('holidayStates').indexOf('national') > -1)
	                ) ? 'selected="selected' : '' ))==null?'':_.escape(__t))+
	'>\n                National\n            </option>\n            ';
	 /* Ugh... TODO fix this */ 
	__p+='\n            ';
	 _.each(__webpack_require__(854).states, function(item, index){ 
	__p+='\n            <option value="'+
	((__t=( index ))==null?'':_.escape(__t))+
	'"\n            '+
	((__t=( (model.get('holidayStates') && (model.get('holidayStates').indexOf(index) > -1)) ? 'selected="selected' : '' ))==null?'':_.escape(__t))+
	'>\n            '+
	((__t=( item ))==null?'':_.escape(__t))+
	'\n            </option>\n            ';
	 }) 
	__p+='\n        </select>\n        <button type="button"\n            '+
	((__t=( model.get('useDefaultPaymentSettings') ? 'disabled' : '' ))==null?'':_.escape(__t))+
	'\n            class="js-edit-holidays btn btn-w-m btn-white m-t-sm">\n            <i class="fa fa-calendar"></i> Edit Holiday Dates\n        </button>\n    </div>\n</div>\n\n';
	 if (defaults) { 
	__p+='\n    <div id="days-calculation-type-container"></div>\n\n\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Record Unpaid Leave In Payroll\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                title="When selected any Unpaid Leave recorded in the Leave\n                    calendar for an employee will be calculated automatically\n                    in payroll runs.  If you want to manually calculate Unpaid\n                    Leave then turn this setting off">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <input type="checkbox" name="recordUnpaidLeaveInPayroll"\n                data-value-type="boolean" class="js-icheck"\n                '+
	((__t=( model.get('recordUnpaidLeaveInPayroll') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-recordUnpaidLeaveInPayroll"></span>\n        </div>\n    </div>\n\n    <!-- Prorate -->\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Adjust Salary Based On Join Date\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body" data-html="true"\n                title="When enabled, salary will be prorated for employees whose first working day is not the first day of the month."></i>\n\n        </label>\n        <div class="col-sm-9">\n            <input class="js-icheck" data-value-type="boolean" type="checkbox"\n                   name="prorateEnabled"\n                ';
	 if (model.get('prorateEnabled')) { 
	__p+=' checked ';
	 } 
	__p+='>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Enable HRDF Contributions\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body" data-html="true"\n                title="Enabling HRDF will automatically calculate HRDF levy."></i>\n        </label>\n        <div class="col-sm-9">\n            <select name="hrdfContribution"\n                class="form-control chosen-select js-ext\n                js-ext-hrdf-contribution">\n                <option value="none"\n                    '+
	((__t=( (
	                        !model.get('hrdfContribution')
	                        || model.get('hrdfContribution') === 'none'
	                    ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    None\n                </option>\n                <option value="auto"\n                    '+
	((__t=( (
	                        model.isNew()
	                        || model.get('hrdfContribution') === 'auto'
	                    ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    Automatic\n                </option>\n                <option value="0.5"\n                    '+
	((__t=( (
	                        model.get('hrdfContribution') === '0.5'
	                    ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    0.5%\n                </option>\n                <option value="1"\n                    '+
	((__t=( (
	                        model.get('hrdfContribution') === '1'
	                    ) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    1%\n                </option>\n            </select>\n        </div>\n    </div>\n';
	 } 
	__p+='\n\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Payslip Format\n        <i class="fa fa-question-circle" data-toggle="tooltip"\n            data-placement="top" data-container="body"\n            title="Please note: A4 payslip format does not display Leave Balance, Working Days, and Public Holidays. Those are only displayed in A5 format.">\n        </i>\n    </label>\n    <div class="col-sm-9">\n        <select name="payslipSize" class="form-control chosen-select js-ext\n            js-ext-payslip-size">\n            <option value="A4"\n                '+
	((__t=( model.get('payslipSize') === 'A4' ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                A4 size\n            </option>\n            <option value="A5"\n                '+
	((__t=( model.get('payslipSize') === 'A5' ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                A5 size\n            </option>\n        </select>\n    </div>\n</div>\n\n<div class="text-right">\n    <button type="button"\n        class="js-cancel btn btn-w-m btn-warning"\n        data-toggle="tooltip" data-title="No changes will be saved"\n        data-placement="top" data-delayed>\n        <i class="fa fa-exclamation-triangle"></i> Cancel\n    </button>\n    <button type="button"\n        class="js-save btn btn-w-m btn-primary m-l-xs">\n        <i class="fa fa-check"></i> Save\n    </button>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = {
	    'fc-sun': 1,
	    'fc-mon': 2,
	    'fc-tue': 3,
	    'fc-wed': 4,
	    'fc-thu': 5,
	    'fc-fri': 6,
	    'fc-sat': 7
	};
	
	function defineDayName(element) {
	    return element.attr('class').split(' ').filter(function (dayName) {
	        return _.has(days, dayName);
	    })[0];
	}
	
	function getWorkingDays(location) {
	    var workingDays = location ? location.get('workingDays') : app.company.get('workingDays');
	
	    return workingDays ? workingDays : [0, 1, 1, 1, 1, 1, 0];
	}
	
	function getDayWorkLoad(cell, location) {
	    var dayName = defineDayName(cell);
	    var workingDays = getWorkingDays(location);
	    var dayNumber = days[dayName] && days[dayName] - 1;
	
	    return workingDays[dayNumber];
	}
	
	var states = {
	    '01': 'Johor',
	    '02': 'Kedah',
	    '03': 'Kelantan',
	    '14': 'Kuala Lumpur',
	    '15': 'Labuan',
	    '04': 'Malacca',
	    '05': 'Negeri Sembilan',
	    '06': 'Pahang',
	    '07': 'Penang',
	    '08': 'Perak',
	    '09': 'Perlis',
	    '16': 'Putrajaya',
	    '12': 'Sabah',
	    '13': 'Sarawak',
	    '10': 'Selangor',
	    '11': 'Terengganu'
	};
	
	function renderHoliday(_holidays, date, cell) {
	    var formattedHolidays = _holidays.filter(function (x) {
	        return x.get('enabled') === true || x.get('enabled') === undefined;
	    }).map(function (holiday) {
	        return {
	            date: _moment2.default.utc(holiday.get('date')).toDate(),
	            isNational: holiday.get('isNational'),
	            title: holiday.get('title'),
	            description: holiday.get('description'),
	            include: holiday.get('include'),
	            exclude: holiday.get('exclude'),
	            custom: !!holiday.get('company')
	        };
	    });
	
	    var holidays = formattedHolidays.filter(function (holiday) {
	        return (0, _moment2.default)(holiday.date).isSame(date, 'day');
	    }).sort(function (holiday) {
	        return holiday.isNational ? -1 : 1;
	    });
	
	    if (!holidays.length) {
	        return;
	    }
	
	    var $holidays = [];
	
	    holidays.forEach(function (holiday, index) {
	        var title = holiday.title + '. ';
	        title += '<br/><i>';
	        if (holiday.isNational) {
	            title += 'National. ';
	            $(cell).addClass('fc-national-holiday');
	        } else {
	            $(cell).addClass('fc-holiday');
	        }
	        if (!_.isEmpty(holiday.include)) {
	            title += _.map(holiday.include, function (code) {
	                return states[code];
	            }).join(', ') + ' only.';
	        }
	        if (!_.isEmpty(holiday.exclude)) {
	            title += 'All states except ' + _.map(holiday.exclude, function (code) {
	                return states[code];
	            }).join(', ') + '.';
	        }
	        title += '</i>';
	
	        var $holiday = $('<div>').text(holiday.title).tooltip({
	            title: title,
	            placement: 'top',
	            trigger: 'hover',
	            html: true,
	            container: 'body'
	        });
	        if (holidays.length > 1) {
	            $holiday.addClass('font-small');
	        }
	        $holidays.push($holiday);
	        if (index !== holidays.length - 1) {
	            $holidays.push('<hr/>');
	        }
	    });
	
	    $(cell).append($holidays);
	}
	
	module.exports = {
	    getDayWorkLoad: getDayWorkLoad,
	    states: states,
	    renderHoliday: renderHoliday
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/PaymentDaysCalculationType.ejs -->\n\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Basis for '+
	((__t=( model.text ))==null?'':_.escape(__t))+
	' Calculation\n        <i class="fa fa-question-circle" data-toggle="tooltip"\n        data-placement="top" data-container="body"\n        data-html="true"\n        title=\''+
	((__t=( model.title ))==null?'':_.escape(__t))+
	'\'>\n        </i>\n    </label>\n    <div id="'+
	((__t=( model.name ))==null?'':_.escape(__t))+
	'CalculationTypeContainer"\n        class="col-sm-'+
	((__t=( model.calculationType === 1 ? 4 : 9 ))==null?'':_.escape(__t))+
	'">\n        <select class="form-control"\n            name="'+
	((__t=( model.name ))==null?'':_.escape(__t))+
	'CalculationType"\n            data-value-type="integer"\n            '+
	((__t=( model.isEnabled ? '' : 'disabled' ))==null?'':_.escape(__t))+
	'>\n            <option value="1"\n                '+
	((__t=( model.calculationType === 1 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Fixed Number of Days\n            </option>\n            <option value="3"\n                '+
	((__t=( model.calculationType === 3 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                Working Days in Current Calendar Month\n            </option>\n            <option value="2"\n                '+
	((__t=( model.calculationType === 2 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                All Days in Current Calendar Month\n            </option>\n        </select>\n        <span class="error error-'+
	((__t=( model.name ))==null?'':_.escape(__t))+
	'CalculationType"></span>\n    </div>\n\n    <div id="'+
	((__t=( model.name ))==null?'':_.escape(__t))+
	'FixedDaysContainer"\n        '+
	((__t=( model.calculationType === 1 ? '' : 'style=display:none' ))==null?'':_.escape(__t))+
	'>\n        <label class="col-sm-2 control-label">\n            Fixed Days\n        </label>\n        <div class="col-sm-3">\n            <input type="text" class="form-control"\n                data-value-type="integer"\n                name="'+
	((__t=( model.name ))==null?'':_.escape(__t))+
	'FixedDays"\n                value="'+
	((__t=( model.fixedDays ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.isEnabled ? '' : 'disabled' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-'+
	((__t=( model.name ))==null?'':_.escape(__t))+
	'FixedDays"></span>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _HolidaysModal = __webpack_require__(857);
	
	var _HolidaysModal2 = _interopRequireDefault(_HolidaysModal);
	
	var _HolidaysList = __webpack_require__(858);
	
	var _HolidaysList2 = _interopRequireDefault(_HolidaysList);
	
	var _HolidaysRow = __webpack_require__(859);
	
	var _HolidaysRow2 = _interopRequireDefault(_HolidaysRow);
	
	var _HolidaysAddModal = __webpack_require__(860);
	
	var _HolidaysAddModal2 = _interopRequireDefault(_HolidaysAddModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _RowEdit = __webpack_require__(690);
	
	var _RowEdit2 = _interopRequireDefault(_RowEdit);
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _holiday = __webpack_require__(627);
	
	var _holiday2 = _interopRequireDefault(_holiday);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RowView = _RowEdit2.default.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        return Object.assign(_RowEdit2.default.prototype.events.apply(this), {
	            'ifToggled .js-ext-toggle': 'toggle'
	        });
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _HolidaysRow2.default,
	            deletable: app.company.id === this.model.get('companyId')
	        });
	
	        this.location = options.additional.location;
	
	        return _RowEdit2.default.prototype.initialize.apply(this, [this.options]);
	    },
	    render: function render() {
	        var r = _RowEdit2.default.prototype.render.apply(this, arguments);
	        setTimeout(this.initializeControls.bind(this), 1);
	        return r;
	    },
	    toggle: function toggle(ev) {
	        var $input = this.$(ev.currentTarget);
	        var value = this.getInputValue($input);
	
	        this.model.toggle(value, this.location);
	    },
	    initializeControls: function initializeControls() {
	        var _this = this;
	
	        // The UI design has a weird placement for the delete button
	        this.$('.form-control-with-delete').each(function (i, control) {
	            var $control = _this.$(control);
	            var $value = $control.find('.form-control-value');
	            var $input = $control.find('.form-control');
	
	            $value.css({
	                display: 'inline-block',
	                maxWidth: $input.width() - $control.find('.btn-delete').outerWidth(true) - 5 + 'px'
	            }).text($input.val());
	
	            $value.on('click', function () {
	                $control.addClass('focus');
	                $input.focus();
	            });
	
	            $input.on('keyup', function (ev) {
	                var val = _this.$(ev.target).val();
	                $value.html(val);
	            }).on('focus', function () {
	                $control.addClass('focus');
	            }).on('blur', function () {
	                $control.removeClass('focus');
	            });
	        });
	    }
	});
	
	var ModalView = _ModalForm2.default.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _HolidaysAddModal2.default
	        });
	
	        return _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	    }
	});
	
	var ListView = _ListEditables2.default.extend({
	    itemViews: [],
	    modalView: null,
	    tagName: 'table',
	    className: 'table table-striped table-settings',
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            template: _HolidaysList2.default,
	            location: null,
	            Model: _holiday2.default,
	            ModalEditView: ModalView,
	            ModelView: RowView,
	            unsubmittedPayroll: null,
	            unsubmittedPayrollDetails: null
	        }, options || {});
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    },
	    bindHandlers: function bindHandlers() {
	        var r = _ListEditables2.default.prototype.bindHandlers.apply(this, []);
	
	        if (this.modalEditView) {
	            this.modalEditView.on('hide', this.restoreSelf, this);
	            this.modalEditView.on('show', this.hideSelf, this);
	        }
	
	        return r;
	    },
	    createModel: function createModel() {
	        var model = _ListEditables2.default.prototype.createModel.apply(this, []);
	        var include = (this.options.location.get('holidayStates') || app.company.get('holidayStates')).filter(function (name) {
	            return name !== 'national';
	        });
	        model.set({
	            description: '',
	            include: include,
	            isNational: false,
	            companyId: app.company.id,
	            companyLocationId: this.options.location.id,
	            date: new Date()
	        });
	        return model;
	    },
	    restoreSelf: function restoreSelf() {
	        this.trigger('show');
	    },
	    hideSelf: function hideSelf() {
	        this.trigger('hide');
	    },
	    showSelectModal: function showSelectModal() {
	        var restoreSelf = function () {
	            this.show();
	            this.payrollItemSelectionModal.off('hide', restoreSelf);
	        }.bind(this);
	
	        this.hide();
	        this.payrollItemSelectionModal.on('hide', restoreSelf);
	        this.payrollItemSelectionModal.show();
	    }
	});
	
	module.exports = _ModalForm2.default.extend({
	    events: function events() {
	        return Object.assign(_ModalForm2.default.prototype.events(), {
	            'click .js-add': 'add'
	        });
	    },
	    initialize: function initialize(options) {
	        var _this2 = this;
	
	        this.options = Object.assign({
	            template: _HolidaysModal2.default,
	            location: null,
	            templateExtra: {},
	            actOnSave: false,
	            actOnDestroy: false,
	            actOnCancel: false
	        }, options || {});
	
	        this.listView = new ListView({
	            collection: this.collection,
	            location: this.options.location
	        });
	        this.listView.on('hide', this.hide, this);
	        this.listView.on('show', this.show, this);
	        this.listView.on('saved cancelled', this.hide, this);
	        this.listView.on('saved', function () {
	            return _this2.trigger('saved');
	        });
	        this.listView.on('save', function () {
	            return _this2.trigger('save');
	        });
	        this.on('cancel', this.listView.cancel, this.listView);
	
	        _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	        this.render();
	        return this;
	    },
	    setLocation: function setLocation(location) {
	        this.options.location = location;
	        this.listView.options.location = location;
	    },
	    render: function render() {
	        if (!this.options.template) {
	            return null;
	        }
	
	        if (!this.collection) {
	            return this;
	        }
	
	        this.$el.html(this.options.template(this.options.templateExtra || {}));
	        this.listView.render();
	        this.$('.js-modal-body').append(this.listView.$el);
	        this.listView.undelegateEvents();
	        this.listView.delegateEvents();
	        return this;
	    },
	    save: function save(ev) {
	        this.listView.save(ev);
	    },
	    add: function add(ev) {
	        if (this.listView) {
	            this.listView.add(ev);
	        }
	        return this;
	    },
	
	
	    //disable
	    markMandatoryFields: function markMandatoryFields() {},
	    bindHandlers: function bindHandlers() {},
	    unbindHandlers: function unbindHandlers() {}
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/HolidaysModal.ejs -->\n<div class="modal-dialog holidays-modal" style="width: 700px">\n    <div class="modal-content animated sweet">\n        <div class="modal-header js-modal-header">\n            <h1>Holidays</h1>\n        </div>\n        <div class="modal-body js-modal-body js-ext">\n        </div>\n        <div class="modal-footer">\n            <button type="button"\n                class="js-add btn btn-w-m btn-outline btn-default pull-left">\n                + Add Custom Holiday\n            </button>\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                    class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/HolidaysList.ejs -->\n<thead>\n    <tr>\n        <th width="170px">Date</th>\n        <th>Title</th>\n        <th width="80px">Enabled</th>\n    </tr>\n</thead>\n<tbody class="js-model-views">\n    <tr class="empty-table-msg js-empty">\n        <td colspan="3">\n            <h2>No holidays found</h2>\n        </td>\n    </tr>\n</tbody>\n';
	}
	return __p;
	};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/HolidaysRow.ejs -->\n';
	 if (!model.get('companyId')) { 
	__p+='\n    <td class="td-nowrap date-readonly">\n        <div class="m-t-sm m-b-sm">\n            '+
	((__t=( model.getFormatted('date', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'\n        </div>\n    </td>\n    <td>\n        <div class="m-l-sm m-t-sm m-b-sm">\n            '+
	((__t=( model.get('title') ))==null?'':_.escape(__t))+
	'\n        </div>\n    </td>\n    <td class="form-group">\n        <label class="ichecks">\n            <input type="checkbox" value="1" name="enabled"\n                data-value-type="boolean"\n                class="js-icheck js-ext js-ext-toggle"\n                '+
	((__t=( model.isEnabled() ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <i></i>\n        </label>\n    </td>\n';
	 } 
	__p+='\n';
	 if (model.get('companyId')) { 
	__p+='\n    <td class="td-nowrap">\n        <span class="date js-datepicker input-group input-group-invisible"\n            data-date-format="dd/mm/yyyy">\n            <span class="input-group-addon">\n                <span class="glyphicon glyphicon-calendar"></span>\n            </span>\n            <input type="text" class="form-control\n                js-datepicker-input"\n                name="date"\n                value="'+
	((__t=( model.getFormatted('date', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'">\n        </span>\n    </td>\n    <td>\n        <div class="form-control form-control-with-delete">\n            <span class="form-control-value"></span>\n            <input name="title"\n                class="form-control form-control-invisible"\n                type="text" autocomplete="off"\n                value="'+
	((__t=( model.get('title') ))==null?'':_.escape(__t))+
	'">\n            <a class="form-control-delete fa fa-times btn-delete js-destroy"\n                tabindex="-1"></a>\n        </div>\n    </td>\n    <td class="form-group">\n    </td>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/HolidaysAddModal.ejs -->\n<div class="modal-dialog">\n    <form class="modal-content animated sweet form-horizontal" role="form">\n        <div class="modal-header" style="border-bottom: none;">\n            <h1 class="modal-title">Add Holiday</h1>\n        </div>\n\n        <div class="modal-body" style="background: #ffffff; padding: 0 50px\n            40px 50px;">\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Date\n                </label>\n                <div class="col-sm-8">\n                    <span class="date js-datepicker input-group"\n                        data-date-format="dd/mm/yyyy">\n                        <span class="input-group-addon">\n                            <span class="glyphicon glyphicon-calendar"></span>\n                        </span>\n                        <input type="text" class="form-control\n                            js-datepicker-input"\n                            name="date"\n                            value="'+
	((__t=( model.getFormatted('date', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'">\n                    </span>\n                    <span class="error-date error"></span>\n                </div>\n            </div>\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Title\n                </label>\n                <div class="col-sm-8">\n                    <input name="title" class="form-control" type="text"\n                       value="">\n                    <span class="error error-title"></span>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer" style="border-top: none; text-align:\n            center;">\n            <button type="reset" class="btn btn-warning btn-w-m js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit" class="btn btn-primary btn-w-m btn-save\n                js-save m-l-md">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _WorkingDaysModal = __webpack_require__(862);
	
	var _WorkingDaysModal2 = _interopRequireDefault(_WorkingDaysModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ModalForm2.default.extend({
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            template: _WorkingDaysModal2.default,
	            actOnSave: false,
	            actOnDestroy: false,
	            actOnCancel: false
	        }, options || {});
	
	        this.company = options.company;
	        this.location = options.location;
	        this.isHQ = this.location && this.location.get('primary');
	        this.isLocationWorkingDays = this.location && this.location.get('workingDays');
	
	        // different layout for
	        // Kedah 02 , Kelantan 03 , Terenganu 11 , Johor 01
	        this.address = this.location && this.location.getAddress();
	        this.state = this.address && this.address.get('state');
	
	        this.isSundayWeekStart = ['01', '02', '03', '11'].includes(this.state);
	        this.weekdayList = this.isSundayWeekStart ? ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] : ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
	
	        this.workingDays = this.isLocationWorkingDays ? this.location.get('workingDays') : this.company.get('workingDays');
	
	        _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	        this.render();
	        return this;
	    },
	    render: function render() {
	        if (!this.options.template) {
	            return null;
	        }
	
	        this.$el.html(this.options.template({
	            weekdayList: this.weekdayList,
	            workingDays: this.workingDays,
	            isSundayWeekStart: this.isSundayWeekStart
	        }));
	
	        return this;
	    },
	    save: function save() {
	        var selector = 'input[type=radio]:checked';
	        var elements = this.$el[0].querySelectorAll(selector);
	
	        var workingDays = [];
	        elements.forEach(function (e) {
	            return workingDays.push(parseFloat(e.value));
	        });
	
	        // validate array
	        if (workingDays.length !== 7) {
	            return;
	        }
	
	        // rotate array one place to the right if isSundayWeekStart is true
	        this.workingDays = this.isSundayWeekStart ? workingDays : [workingDays[6]].concat(workingDays.slice(0, 6));
	
	        this.location.set('workingDays', this.workingDays);
	        this.location.save();
	
	        if (this.isHQ) {
	            this.company.set('workingDays', this.workingDays);
	        }
	
	        this.hide();
	    },
	
	
	    //disable
	    markMandatoryFields: function markMandatoryFields() {},
	    bindHandlers: function bindHandlers() {},
	    unbindHandlers: function unbindHandlers() {}
	});

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/WorkingDaysModal.ejs -->\n<div class="modal-dialog holidays-modal" style="width: 900px">\n    <div class="modal-content animated sweet">\n        <div class="modal-header js-modal-header">\n            <h1>Working Days</h1>\n        </div>\n        <div class="modal-body js-modal-body js-ext">\n            <div class="col-sm-10 col-sm-offset-1">\n                <div class="working-days-form">\n                    ';
	 for (var i = 0; i < weekdayList.length; i++) { 
	__p+='\n                        <div class="weekday-settings">\n                            <div class="weekday-label">'+
	((__t=( weekdayList[i].charAt(0).toUpperCase() + weekdayList[i].substr(1) ))==null?'':_.escape(__t))+
	'</div>\n                            <div class="weekday-options pp-radio-container">\n                                <div class="pp-radio">\n                                    <label>\n                                        <input type="radio" name="'+
	((__t=( weekdayList[i] ))==null?'':_.escape(__t))+
	'" value="1"\n                                            ';
	 if (workingDays[isSundayWeekStart ? i : (i + 1) % 7] === 1) { 
	__p+='checked';
	 } 
	__p+='>\n                                        <span class="check"></span>\n                                        <span>Full Day</span>\n                                    </label>\n                                </div>\n                                <div class="pp-radio">\n                                    <label>\n                                        <input type="radio" name="'+
	((__t=( weekdayList[i] ))==null?'':_.escape(__t))+
	'" value="0.5"\n                                            ';
	 if (workingDays[isSundayWeekStart ? i : (i + 1) % 7] === 0.5) { 
	__p+='checked';
	 } 
	__p+='>\n                                        <span class="check"></span>\n                                        <span>Half Day</span>\n                                    </label>\n                                </div>\n                                <div class="pp-radio">\n                                    <label>\n                                        <input type="radio" name="'+
	((__t=( weekdayList[i] ))==null?'':_.escape(__t))+
	'" value="0"\n                                            ';
	 if (workingDays[isSundayWeekStart ? i : (i + 1) % 7] === 0) { 
	__p+='checked';
	 } 
	__p+='>\n                                        <span class="check"></span>\n                                        <span>Off Day</span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    ';
	 } 
	__p+='\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-container="body"\n                data-title="No changes will be saved" data-placement="top"\n                data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                    class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Leave = __webpack_require__(864);
	
	var _Leave2 = _interopRequireDefault(_Leave);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _leaveType = __webpack_require__(630);
	
	var _leaveType2 = _interopRequireDefault(_leaveType);
	
	var _LeaveTypeModal = __webpack_require__(865);
	
	var _LeaveTypeModal2 = _interopRequireDefault(_LeaveTypeModal);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leavePolicyPresets = [{
	    leaveRenewalPolicy: 'calendarYear',
	    leaveAccrual: false,
	    leaveProrate: true
	}, {
	    leaveRenewalPolicy: 'joinDate',
	    leaveAccrual: false,
	    leaveProrate: false
	}, {
	    leaveRenewalPolicy: 'calendarYear',
	    leaveAccrual: true,
	    leaveProrate: true
	}, {
	    leaveRenewalPolicy: 'joinDate',
	    leaveAccrual: true,
	    leaveProrate: false
	}];
	
	module.exports = _Form2.default.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(_Form2.default.prototype.events) ? _Form2.default.prototype.events() : _Form2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'change .js-ext-days': 'updateDays',
	            'change .js-ext-leave-type-name': 'updateLeaveTypeName',
	            'click .js-add-leave-type': 'addLeaveType',
	            'click .js-destroy-leave-type': 'destroyLeaveType'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _Leave2.default,
	            unsubmittedPayroll: null,
	            leaveTypes: null
	        });
	        this.options.templateExtra = { leaveTypes: this.options.leaveTypes };
	        this.modalEditView = new _LeaveTypeModal2.default({
	            actOnSave: true,
	            actOnCancel: false,
	            actOnDestroy: false
	        });
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    render: function render() {
	        _Form2.default.prototype.render.apply(this, arguments);
	        setTimeout(this.initializeControls.bind(this), 1);
	        this.toggleLeaveCarryForward();
	        return false;
	    },
	
	    bindHandlers: function bindHandlers() {
	        var r = _Form2.default.prototype.bindHandlers.apply(this, arguments);
	
	        this.model.on('change:allowLeaveCarryForward', this.toggleLeaveCarryForward, this);
	        this.model.on('change:annualLeavePolicy', this.updateLeavePolicy, this);
	        this.options.leaveTypes.on('add sync reset remove', this.render, this);
	
	        this.modalEditView.on('saved', this.options.leaveTypes.add, this.options.leaveTypes);
	
	        return r;
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        var r = _Form2.default.prototype.bindHandlers.apply(this, arguments);
	        this.options.leaveTypes.off(null, null, this);
	        this.modalEditView.off(null, null, this.options.leaveTypes);
	        return r;
	    },
	
	    initializeControls: function initializeControls() {
	        // The UI design has a weird placement for the delete button
	        this.$('.form-control-with-delete').each(function (i, control) {
	            var $control = this.$(control);
	            var $value = $control.find('.form-control-value');
	            var $input = $control.find('.form-control');
	
	            $value.css({
	                display: 'inline-block',
	                maxWidth: $input.width() - $control.find('.btn-delete').outerWidth(true) - 5 + 'px'
	            }).text($input.val());
	
	            $value.on('click', function () {
	                $control.addClass('focus');
	                $input.focus();
	            });
	
	            $input.on('keyup', function (ev) {
	                var val = this.$(ev.target).val();
	                $value.html(val);
	            }.bind(this)).on('focus', function () {
	                $control.addClass('focus');
	            }).on('blur', function () {
	                $control.removeClass('focus');
	            });
	        }.bind(this));
	    },
	
	    getRandomColor: function getRandomColor() {
	        var random = function random() {
	            var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 256;
	            return Math.floor(Math.random() * max + 1);
	        };
	        var pastel = function pastel(color) {
	            return Math.floor((color + 255) / 2);
	        };
	        var hex = function hex() {
	            return pastel(random()).toString(16);
	        };
	        return '#' + hex() + hex() + hex();
	    },
	
	    addLeaveType: function addLeaveType(ev) {
	        ev.preventDefault();
	        this.modalEditView.setModel(new _leaveType2.default({
	            accruable: false,
	            paid: true,
	            annual: false,
	            company: app.company,
	            optional: true,
	            color: this.getRandomColor()
	        })).show();
	        return this;
	    },
	
	    destroyLeaveType: function destroyLeaveType(ev) {
	        var _this = this;
	
	        var typeId = this.$(ev.currentTarget).data('type-id');
	        var model = this.options.leaveTypes.find(function (type) {
	            return type.id === typeId;
	        });
	
	        if (!model) {
	            return;
	        }
	
	        var text = 'Note: If this leave type has been utilized by an ' + 'employee, it will remain under employment details.';
	
	        _alerts2.default.show('dangerConfirm', {
	            text: text,
	            confirmButtonText: 'Yes, Remove',
	            callback: function callback(confirm) {
	                if (!confirm) {
	                    return;
	                }
	                return model.destroy().then(function () {
	                    _this.options.leaveTypes.remove(model);
	                }, function (err) {
	                    _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    updateLeavePolicy: function updateLeavePolicy() {
	        this.model.set(leavePolicyPresets[this.$('[name=annualLeavePolicy]').val()]);
	    },
	
	    updateDays: function updateDays($ev) {
	        var typeId = this.$($ev.currentTarget).data('type-id');
	        var days = this.getInputValue(this.$($ev.currentTarget));
	        this.model.setLeaveDays({
	            typeId: typeId,
	            days: days
	        });
	    },
	
	    updateLeaveTypeName: function updateLeaveTypeName(ev) {
	        var typeId = this.$(ev.currentTarget).data('type-id');
	        var name = this.getInputValue(this.$(ev.currentTarget));
	        this.options.leaveTypes.find(function (type) {
	            return type.id === typeId;
	        }).set({
	            name: name
	        });
	    },
	
	    toggleLeaveCarryForward: function toggleLeaveCarryForward() {
	        this.$('[name=daysCanCarryForward]').prop('disabled', this.model.get('allowLeaveCarryForward') !== true);
	
	        this.$('[name=carryForwardExpiryMonths]').prop('disabled', this.model.get('allowLeaveCarryForward') !== true);
	    },
	
	    toggleUnpaidLeaveFixedDays: function toggleUnpaidLeaveFixedDays() {
	        this.$('[name=unpaidLeaveFixedDays]').prop('disabled', this.model.get('recordUnpaidLeaveInPayroll') !== true || this.model.get('unpaidLeaveCalculationType') !== 1);
	
	        // because we reset unpaidLeaveFixedDays when switch to other type
	        // we can use this value again whe switch back
	        if (this.model.get('unpaidLeaveCalculationType') === 1) {
	            var days = parseInt(this.$('[name=unpaidLeaveFixedDays]').val());
	            this.model.set({ 'unpaidLeaveFixedDays': days });
	        }
	        this.toggleError('unpaidLeaveFixedDays');
	    },
	
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        if (!_.isObject(this.options.unsubmittedPayroll)) {
	            return (0, _bluebird.resolve)(true);
	        }
	
	        return new _bluebird2.default(function (resolve, reject) {
	            _modal2.default.confirm({
	                title: 'Your saved payroll will be modified!',
	                text: 'You have an unsubmitted payroll saved. ' + 'If you continue, the payroll details of all employees ' + 'with unpaid leaves will be updated based on the ' + 'modifications you are about to save. Also, any unsaved ' + 'payroll details will be lost.',
	                customClass: 'sweet-alert-error',
	                confirmButtonText: 'Yes, save settings',
	                callback: function callback(confirm) {
	                    if (confirm) {
	                        resolve(true);
	                    } else {
	                        reject();
	                    }
	                }
	            });
	        });
	    },
	
	    save: function save(ev) {
	        var _this2 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader;
	
	        if (
	        // TODO: Investigate - !this.model.wasValid() ||
	        !this.model.isValid({ forcePresenceValidation: true })) {
	            this.invalid(this.model, { errors: this.model.validationError });
	            return;
	        }
	
	        return this.resetPayrollConfirm().then(function () {
	            stopLoader = _loader2.default.startFullScreen($button);
	            return _this2.model.save().catch(function (err) {
	                if (_this2.model.wasValid()) {
	                    // the error is not a validation error
	                    throw err;
	                }
	                throw new Error('validationError');
	            });
	        }).then(function () {
	            return _this2.options.leaveTypes.save();
	        }).then(function () {
	            return app.leaveTypes.fetch();
	        }).then(function () {
	            if (_this2.options.unsubmittedPayroll) {
	                return _this2.options.unsubmittedPayroll.resetUnpaidLeave();
	            }
	
	            return (0, _bluebird.resolve)(true);
	        }).then(function () {
	            _modal2.default.showAlertSuccess('Leave settings have been saved');
	            return (0, _bluebird.resolve)(true);
	        }).catch(function (err) {
	            if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object' && err.message !== 'validationError') {
	                _modal2.default.error({ text: err });
	            }
	        }).finally(function () {
	            if (typeof stopLoader === 'function') {
	                stopLoader();
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Leave.ejs -->\n<form class="form-horizontal" role="form">\n    <table id="required" class="table table-striped table-settings">\n        <thead>\n            <th width="30%">Required</th>\n            <th width="20%">Entitled</th>\n            <th>Policy</th>\n        </thead>\n        <tbody>\n            ';
	 leaveTypes.forEach(function (type) { 
	__p+='\n                ';
	 if (type.get('optional')) return; 
	__p+='\n                ';
	 if (type.get('companyId')) return; 
	__p+='\n                <tr class="item">\n                    <td class="td-nowrap">\n                        <input name="name-'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                            class="form-control form-control-invisible"\n                            type="text" autocomplete="off"\n                            value="'+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'"\n                            readonly>\n                    </td>\n                    <td>\n                        ';
	 if (type.get('paid')) { 
	__p+='\n                        <input type="text" class="form-control js-ext-days js-ext"\n                            data-value-type="float"\n                            data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                            name="leaveDays-'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                            value="'+
	((__t=( (model.get('leaveDays') || {})[type.id] || 0 ))==null?'':_.escape(__t))+
	'"\n                        <span class="error error-leaveDays"></span>\n                        ';
	 } 
	__p+='\n                    </td>\n                    <td>\n                        ';
	 if (leaveTypes.at(0).id === type.id) { 
	__p+='\n                            <select class="form-control"\n                                name="annualLeavePolicy"\n                                data-value-type="integer">\n                                <option value="0"\n                                    '+
	((__t=( model.get('annualLeavePolicy') === 0 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Earned all at once (renews at the beginning of the year)\n                                </option>\n                                <option value="1"\n                                    '+
	((__t=( model.get('annualLeavePolicy') === 1 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Earned all at once (renews on employee\'s join date)\n                                </option>\n                                <option value="2"\n                                    '+
	((__t=( model.get('annualLeavePolicy') === 2 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Earned throughout the year (renews at the beginning of the year)\n                                </option>\n                                <option value="3"\n                                    '+
	((__t=( model.get('annualLeavePolicy') === 3 ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                    Earned throughout the year (renews on employee\'s join date)\n                                </option>\n                            </select>\n                            <span class="error error-annualLeavePolicy"></span>\n                        ';
	 } 
	__p+='\n                    </td>\n                </tr>\n            ';
	 }) 
	__p+='\n        <thead>\n            <th>Optional</th>\n            <th>Entitled</th>\n            <th>Policy</th>\n        </thead>\n        <tbody>\n            ';
	 leaveTypes.forEach(function (type) { 
	__p+='\n                ';
	 if (!type.get('optional')) return; 
	__p+='\n                <tr class="item">\n                    <td class="td-nowrap">\n                        ';
	 if (!type.get('companyId')) { 
	__p+='\n                            <input name="name-'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                class="form-control form-control-invisible"\n                                type="text" autocomplete="off"\n                                value="'+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'"\n                                readonly>\n                        ';
	 } else { 
	__p+='\n                            <div class="form-control form-control-with-delete">\n                                <span class="form-control-value"></span>\n\n                                <input name="name-'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                    class="form-control form-control-invisible\n                                        js-ext js-ext-leave-type-name"\n                                    data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                    type="text" autocomplete="off"\n                                    value="'+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'">\n\n                                <a class="form-control-delete fa fa-times\n                                    btn-delete js-destroy-leave-type"\n                                    data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                    tabindex="-1"></a>\n                            </div>\n                        ';
	 } 
	__p+='\n                    </td>\n                    <td>\n                        <input type="text" class="form-control\n                            js-ext js-ext-days"\n                            data-value-type="float"\n                            data-type-id="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                            name="leaveDays-'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                            value="'+
	((__t=( (model.get('leaveDays') || {})[type.id] || 0 ))==null?'':_.escape(__t))+
	'">\n                        <span class="error error-leaveDays"></span>\n                    </td>\n                    <td></td>\n                </tr>\n            ';
	 }) 
	__p+='\n        </tbody>\n        <tfoot>\n            <tr><td colspan="3">\n                <button class="btn btn-outline pull-right\n                    btn-primary\n                    js-add-leave-type"\n                    data-loading-text="Adding..."\n                    data-complete-text="+ Add Leave Type">\n                    + Add Leave Type\n                </button>\n            </td></tr>\n        </tfoot>\n    </table>\n    <div class="form-group">\n        <label class="col-sm-6 control-label left">\n            Allow employees to carry forward their unused leave to next year?\n        </label>\n        <div class="col-sm-2">\n            <input type="checkbox" name="allowLeaveCarryForward"\n                data-value-type="boolean" class="js-icheck"\n                '+
	((__t=( model.get('allowLeaveCarryForward') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-allowLeaveCarryForward"></span>\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-sm-6 control-label left">\n            How many leave days can employees carry forward?\n        </label>\n        <div class="col-sm-2">\n            <input type="text" class="form-control"\n                data-value-type="float"\n                name="daysCanCarryForward"\n                value="'+
	((__t=( model.get('daysCanCarryForward') ))==null?'':_.escape(__t))+
	'">\n            <span class="error error-daysCanCarryForward"></span>\n        </div>\n        <label class="col-sm-1 control-label left">\n            days\n        </label>\n    </div>\n    <div class="form-group">\n        <label class="col-sm-6 control-label left">\n            When does the carry forward leave expire?\n        </label>\n        <div class="col-sm-2">\n            <input type="text" class="form-control"\n                data-value-type="integer"\n                name="carryForwardExpiryMonths"\n                value="'+
	((__t=( model.get('carryForwardExpiryMonths') ))==null?'':_.escape(__t))+
	'"\n            <span class="error error-carryForwardExpiryMonths"></span>\n        </div>\n        <label class="col-sm-1">\n            months\n        </label>\n    </div>\n\n    <div class="text-right">\n        <button type="button"\n            class="js-cancel btn btn-w-m btn-warning"\n            data-toggle="tooltip" data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i> Cancel\n        </button>\n        <button type="button"\n            class="js-save btn btn-w-m btn-primary m-l-xs">\n            <i class="fa fa-check"></i> Save\n        </button>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _LeaveTypeModal = __webpack_require__(866);
	
	var _LeaveTypeModal2 = _interopRequireDefault(_LeaveTypeModal);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ModalForm2.default.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { template: _LeaveTypeModal2.default });
	        return _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/LeaveTypeModal.ejs -->\n<div class="modal-dialog" style="width: 540px;">\n    <form class="modal-content animated sweet form-horizontal" role="form">\n        <div class="modal-header" style="border-bottom: none;">\n            <h1 class="modal-title">Add Leave Type</h1>\n        </div>\n\n        <div class="modal-body" style="background: #ffffff; padding: 0 50px\n            40px 50px;">\n            <div class="form-group row">\n                <label class="col-sm-4 control-label">\n                    Name\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                        data-placement="top" data-container="body"\n                        data-original-title="Choose the name you would like to\n                            identify this leave type by"></i>\n                </label>\n                <div class="col-sm-8">\n                    <input name="name" class="form-control" type="text"\n                        placeholder="Enter the name of the leave type"\n                       value="">\n                    <span class="error error-name"></span>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer" style="border-top: none; text-align:\n            center;">\n            <button type="reset" class="btn btn-warning btn-w-m js-cancel"\n                data-dismiss="modal">\n                Cancel\n            </button>\n            <button type="submit" class="btn btn-primary btn-w-m btn-save\n                js-save m-l-md">\n                Save\n            </button>\n        </div>\n    </form>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(868);
	var FormView = __webpack_require__(550);
	var modal = __webpack_require__(532);
	
	module.exports = FormView.extend({
	
	    initialize: function initialize(options) {
	        var self = this;
	
	        self.options = _.defaults(options || {}, { template: template });
	
	        return FormView.prototype.initialize.apply(self, [self.options]);
	    },
	
	    save: function save(ev) {
	        FormView.prototype.save.apply(this, [ev]).then(function () {
	            modal.showAlertSuccess('Settings have been saved');
	        });
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Notifications.ejs -->\n<div class="form-horizontal">\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Email Employees Payslips?\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="If this is checked, then employees with\n                    email addresses entered in their profiles, will receive\n                    payslips by email after you submit your monthly payroll">\n            </i>\n        </label>\n\n        <div class="col-sm-1">\n            <input type="checkbox" name="isEnabledEmployeePayslipEmail"\n                data-value-type="boolean" class="js-icheck"\n                '+
	((__t=( model.get('isEnabledEmployeePayslipEmail') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-isEnabledEmployeePayslipEmail"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label" for="isEnabledPayslipPassword">\n            Password Protect Payslips\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n               data-placement="top" data-container="body"\n               data-original-title="The payslips PDFs that are emailed out will\n               be password protected with the employee\'s IC or passport number.\n               If you want more security you should not email the payslips but\n               instead invite your employees to use the app by sending welcome\n               emails from the employee profiles and once they have signed up\n               for their online account they can access their payslips using\n               the app">\n            </i>\n        </label>\n\n        <div class="col-sm-1">\n            <input type="checkbox" name="isEnabledPayslipPassword"\n                   data-value-type="boolean" class="js-icheck"\n                '+
	((__t=( model.get('isEnabledPayslipPassword') === true ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-isEnabledPayslipPassword"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Email Payslips Text\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="You can enter an optional message here\n                    that your employees will see when they receive emails with\n                    their payslips">\n            </i>\n        </label>\n\n        <div class="col-sm-9">\n            <textarea rows="5" name="employeePayslipEmailText"\n                class="form-control"\n                style="width: 100%;">'+
	((__t=( model.get('employeePayslipEmailText') ))==null?'':_.escape(__t))+
	'</textarea>\n            <span class="error error-employeePayslipEmailText"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Email Leave Notification\n        </label>\n\n        <div class="col-sm-9">\n            <input type="checkbox" name="isEnabledLeaveEmail"\n                   data-value-type="boolean" class="js-icheck"\n                '+
	((__t=( model.get('isEnabledLeaveEmail') !== false ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n            <span class="error error-isEnabledLeaveEmail"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Reminder to Approve Leave\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                data-original-title="Email reminder to approve leave will be sent after leave was applied, at set day(s)">\n            </i>\n        </label>\n\n        <div class="col-sm-1">\n            <input type="text" class="form-control" name="reminderApproveLeaveEmailDays"\n                data-value-type="integer"\n                value="'+
	((__t=( (model.get('reminderApproveLeaveEmailDays') || 0)))==null?'':_.escape(__t))+
	'">\n            <span class="error error-reminderApproveLeaveEmailDays"></span>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Show Birthdays\n        </label>\n        <div class="col-sm-9">\n            <input class="js-icheck" data-value-type="boolean" type="checkbox"\n                   name="showBirthdaysInCalendar"\n                ';
	 if (model.get('showBirthdaysInCalendar')) { 
	__p+=' checked ';
	 } 
	__p+='>\n        </div>\n    </div>\n\n</div>\n\n<div class="text-right">\n    <button class="js-cancel btn btn-warning btn-w-m"\n        data-loading-text="Cancelling..." data-complete-text="Cancel"\n        data-toggle="tooltip" data-title="No changes will be saved"\n        data-placement="top" data-delayed>\n        <i class="fa fa-exclamation-triangle"></i>\n        Cancel\n    </button>\n    <button class="js-save btn btn-primary m-l-xs">\n        <i class="fa fa-check"></i>\n        Save changes\n    </button>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _Subscription = __webpack_require__(870);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Form2.default.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(_Form2.default.prototype.events) ? _Form2.default.prototype.events() : _Form2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-online-payment': 'onlinePayment',
	            'change #subscription-type': 'toggleYearlyInfo'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({ template: _Subscription2.default }, options || {});
	        _Form2.default.prototype.initialize.apply(this, [this.options]);
	
	        // FormView doesn't render if there is no model, but we want to
	        // render the view anyway to show an error that the model is missing
	        if (!this.model) {
	            this.render();
	        }
	
	        this.onRedirectError();
	        return this;
	    },
	
	    onRedirectError: function onRedirectError() {
	        // catch redirects from online payments
	        var hash = decodeURI(window.location.hash);
	        var keyword = 'error=';
	        var i = hash.indexOf(keyword);
	
	        // return if no error
	        if (i === -1) {
	            return;
	        }
	
	        var errorMessage = hash.substr(i + keyword.length);
	
	        _modal2.default.warning({
	            title: 'Payment Error',
	            text: errorMessage
	        });
	    },
	
	    render: function render() {
	        var r = _Form2.default.prototype.render.apply(this, arguments);
	
	        // As in the initialize method. FormView's render returns early
	        // if there is no model, but we want to render the template
	        // anyway
	        if (!this.model) {
	            this.$el.html(this.options.template(Object.assign(this.options.templateExtra || {}, { model: false })));
	            return r;
	        }
	
	        if (this.options.templateExtra.invoices.length) {
	            this.$('.js-empty').hide();
	        } else {
	            this.$('.js-table-invoices').hide();
	        }
	
	        this.toggleYearlyInfo();
	
	        return r;
	    },
	
	    onlinePayment: function onlinePayment(e) {
	        e.preventDefault();
	
	        var invoiceId = $(e.currentTarget).data('id');
	        var invoice = this.options.templateExtra.invoices.find(function (i) {
	            return i.id === invoiceId;
	        });
	
	        if (!invoice) {
	            return false;
	        }
	
	        this.model.onlinePayment(invoiceId).then(function (response) {
	            window.location.replace(response.result.url);
	        });
	    },
	
	    save: function save(ev) {
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	        if (app.user.isAdmin()) {
	            if (this.$('select[name="type"]').val() === 'yearly') {
	                var yearlyInvoice = this.model.get('yearlyInvoice') || {};
	                this.model.set('yearlyInvoice', Object.assign(yearlyInvoice, {
	                    id: this.$('#yearlyInvoiceId').val(),
	                    payslipCount: parseInt(this.$('#yearlyInvoicePayslipCount').val() || 0, 10)
	                }));
	            }
	
	            var discountName = this.$('#discount').val();
	            if (!discountName) {
	                this.model.set({
	                    couponCode: ''
	                });
	            } else {
	                var discountCode = this.options.templateExtra.discountCodes.find(function (code) {
	                    return [
	                    // jscs:disable
	                    code.invoice_name, code.name].includes(discountName);
	                });
	
	                if (!discountCode) {
	                    stopLoader();
	                    _modal2.default.warning({
	                        text: 'Invalid discount specified. Please choose                         from the dropdown list'
	                    });
	                    return;
	                }
	                this.model.set({
	                    couponCode: discountCode.id
	                });
	            }
	        }
	
	        this.model.save().then(function () {
	            _modal2.default.showAlertSuccess('Your changes have been saved');
	        }).catch(function () {
	            _modal2.default.error({
	                text: 'Please contact customer support'
	            });
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    toggleYearlyInfo: function toggleYearlyInfo() {
	        var subsType = this.$('#subscription-type').val();
	
	        if (subsType === 'yearly') {
	            this.$('.yearly-info').show();
	        } else {
	            this.$('.yearly-info').hide();
	        }
	        this.model.set({ type: subsType });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Subscription.ejs -->\n';
	 var moment = __webpack_require__(101); 
	__p+='\n<h3>Subscription settings</h3>\n<div class="form-horizontal">\n    ';
	 if (!model) { 
	__p+='\n        <div class="row m-t-lg">\n        ';
	 if (mppCustomer) { 
	__p+='\n            <div class="alert alert-warning col-sm-6 col-sm-offset-3 m-t-lg">\n                <div class="alert-message">\n                    This company is managed by an MPP. To see\n                    and change subscription settings, please log in to the\n                    MPP admin account.\n                </div>\n            </div>\n        ';
	 } else { 
	__p+='\n            <div class="alert alert-danger col-sm-6 col-sm-offset-3 m-t-lg">\n                <div class="alert-message">\n                    An error occurred while trying to load subscription\n                    information. Please try logging back in or contact\n                    customer support.\n                </div>\n            </div>\n        ';
	 } 
	__p+='\n        </div>\n    ';
	 } else { 
	__p+='\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Subscription Type\n        </label>\n        <div class="col-sm-3">\n            <select\n                name="type" class="form-control" id="subscription-type"\n                '+
	((__t=( app.user.isAdmin() || model.get('type') === 'monthly' ? '' : 'disabled' ))==null?'':_.escape(__t))+
	'\n            >\n                <option value="monthly"\n                        ';
	 if (!model.get('type') ||
	                           model.get('type') === 'monthly') {
	                           
	__p+='selected';
	 } 
	__p+='>\n                    Monthly\n                </option>\n                <option value="yearly"\n                        ';
	 if (model.get('type') === 'yearly') {
	                           
	__p+='selected';
	 } 
	__p+='>\n                    Yearly\n                </option>\n            </select>\n        </div>\n    </div>\n    <div class="form-group yearly-info">\n        <label class="col-sm-3 control-label">\n            Yearly Subscription Period\n        </label>\n        <div class="col-sm-3" style="padding-top: 5px;">\n            '+
	((__t=( moment(yearlyStartDate || new Date()).format('MMM YYYY') ))==null?'':_.escape(__t))+
	' -\n            '+
	((__t=( moment(yearlyStartDate || new Date()).add(11, 'months').format('MMM YYYY') ))==null?'':_.escape(__t))+
	'\n        </div>\n    </div>\n    ';
	 if (app.user.isAdmin()) { 
	__p+='\n        ';
	 if (model.get('type') === 'yearly') { 
	__p+='\n        <div class="form-group yearly-info">\n            <label class="col-sm-3 control-label">\n                Current Yearly Subscription Invoice ID\n            </label>\n            <div class="col-sm-3">\n                <input type="text" class="form-control"\n                    id="yearlyInvoiceId"\n                    value="'+
	((__t=( (model.get('yearlyInvoice') || {}).id ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group yearly-info">\n            <label class="col-sm-3 control-label">\n                Current Yearly Subscription Employee Count\n            </label>\n            <div class="col-sm-3">\n                <input type="text" class="form-control"\n                    id="yearlyInvoicePayslipCount"\n                    value="'+
	((__t=( (model.get('yearlyInvoice') || {}).payslipCount ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Signed Up Date\n            </label>\n            <div class="col-sm-3 input-group js-datepicker date"\n            data-date-format="dd/mm/yyyy">\n                <span class="input-group-addon">\n                    <span class="glyphicon glyphicon-calendar"></span>\n                </span>\n                <input type="text" class="form-control js-ext js-datepicker-input"\n                    name="startDate"\n                    value="'+
	((__t=( moment(model.get('startDate')).format('DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Discount(%)\n            </label>\n            ';
	
	                var matchingCoupon = discountCodes.find(function (code) { return code.id === model.get('couponCode'); });
	            
	__p+='\n            <div class="col-sm-3">\n                <input id="discount"\n                    list="couponCode"\n                    value="'+
	((__t=( matchingCoupon ? matchingCoupon.invoice_name || matchingCoupon.name : '' ))==null?'':_.escape(__t))+
	'"\n                >\n                <datalist id="couponCode">\n                ';
	 discountCodes.forEach(function (discountCode) { 
	__p+='\n                    <option value="'+
	((__t=( discountCode.invoice_name || discountCode.name ))==null?'':_.escape(__t))+
	'">\n                ';
	 }) 
	__p+='\n                </datalist>\n                <span class="error error-discount"></span>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Discount Limit\n            </label>\n            <div class="col-sm-3">\n                <input name="isDiscountLimited" type="checkbox"\n                    class="form-control js-icheck"\n                    '+
	((__t=( model.get('isDiscountLimited') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                > Enable Limit <br/>\n                <input name="discountLimit" type="number"\n                       class="form-control steps"\n                       placeholder="Number of free invoices entitled to"\n                       value="'+
	((__t=( model.get('discountLimit') || 0 ))==null?'':_.escape(__t))+
	'"\n                       max="100" min="0" step="1"\n                >\n                <span class="error error-discount"></span>\n            </div>\n        </div>\n\n        <div class="form-group" >\n            <label class="col-sm-3 control-label">\n                Custom prices\n            </label>\n            <div class="col-sm-3 input-group">\n                BASE:\n                <br/>\n                <input type="number" class="form-control"\n                    name="customBasePrice"\n                    value="'+
	((__t=( model.get('customBasePrice') || 0 ))==null?'':_.escape(__t))+
	'">\n                <br/>\n                PER EMPLOYEE (FLAT):\n                <br/>\n                <input type="number" class="form-control"\n                    name="customEmployeePrice"\n                    value="'+
	((__t=( model.get('customEmployeePrice') || 0 ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n    ';
	 } 
	__p+='\n\n    <div class="form-group">\n        <div class="col-sm-1 col-sm-offset-3">\n            <button class="js-save btn btn-w-m btn-primary">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </div>\n</div>\n\n<div class="hr-line-dashed"></div>\n\n<h3>Invoices</h3>\n<div>\n    <h2 class="text-center js-empty">\n        You don\'t have any invoices yet\n    </h2>\n    <table class="table table-striped table-settings js-table-invoices">\n        <thead>\n            <tr>\n                <th width="10%">Date</th>\n                <th>Description</th>\n                <th width="10%">Amount</th>\n                <th width="10%">Invoice</th>\n                <th width="10%">Status</th>\n                <th width="10%">\n                    Payment\n                </th>\n            </tr>\n        </thead>\n        <tbody>\n            ';
	 _(invoices).each(function(invoice) { 
	__p+='\n            <tr>\n                <td>\n                    '+
	((__t=( invoice.date ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td>\n                    '+
	((__t=( invoice.description ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td>\n                    RM '+
	((__t=( invoice.amount ))==null?'':_.escape(__t))+
	'\n                </td>\n                <td>\n                    <a href="'+
	((__t=( model.invoiceDownloadUrl(invoice.id) ))==null?'':_.escape(__t))+
	'"\n                        class="js-download-invoice"\n                        role="button"\n                        data-id="'+
	((__t=( invoice.id ))==null?'':_.escape(__t))+
	'">\n                        <i class="fa fa-2x fa-file-pdf-o" aria-hidden="true"></i>\n                        '+
	((__t=( invoice.id ))==null?'':_.escape(__t))+
	'\n                    </a>\n                </td>\n                <td>\n                    ';
	 if (invoice.status === 'Payment due') { 
	__p+='\n                        <div class="status payment-due">\n                            Payment Due\n                        </div>\n                    ';
	 } else if (invoice.status === 'Not paid') { 
	__p+='\n                        <div class="status not-paid">\n                            Not Paid\n                        </div>\n                    ';
	 } else if (invoice.status === 'Voided') { 
	__p+='\n                        <div class="status voided">\n                            Voided\n                        </div>\n                    ';
	 } else { 
	__p+='\n                        <div class="status paid">\n                            Paid\n                        </div>\n                    ';
	 } 
	__p+='\n                </td>\n\n                <td>\n                    ';
	 if (invoice.status === 'Payment due' || invoice.status === 'Not paid') { 
	__p+='\n                        <button class="btn btn-sm btn-primary js-online-payment" data-id="'+
	((__t=( invoice.id ))==null?'':_.escape(__t))+
	'">\n                            Pay Online\n                        </button>\n                    ';
	 } else if (invoice.status === 'Voided') { 
	__p+='\n                        <span>'+
	((__t=( invoice.voidedDate ))==null?'':_.escape(__t))+
	'</span>\n                    ';
	 } else { 
	__p+='\n                        <span>'+
	((__t=( invoice.paymentDate ))==null?'':_.escape(__t))+
	'</span>\n                    ';
	 } 
	__p+='\n                </td>\n            </tr>\n            ';
	 }); 
	__p+='\n        </tbody>\n    </table>\n    ';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _Integrations = __webpack_require__(872);
	
	var _Integrations2 = _interopRequireDefault(_Integrations);
	
	var _IntegrationsConnect = __webpack_require__(875);
	
	var _IntegrationsConnect2 = _interopRequireDefault(_IntegrationsConnect);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _PayrollItems = __webpack_require__(876);
	
	var _PayrollItems2 = _interopRequireDefault(_PayrollItems);
	
	var _PayrollItems3 = __webpack_require__(881);
	
	var _PayrollItems4 = _interopRequireDefault(_PayrollItems3);
	
	var _PaymentAccounts = __webpack_require__(885);
	
	var _PaymentAccounts2 = _interopRequireDefault(_PaymentAccounts);
	
	var _config = __webpack_require__(527);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Form2.default.extend({
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events() || {}, {
	            'ifToggled input.js-ext-payrollSyncDate': 'togglePayrollSyncDatepicker',
	            'changeDate .js-ext-datepicker': 'updatePayrollSyncDate',
	            'change .js-contact select': 'updateContact',
	            'change .js-mapping-type select': 'updateMappingType',
	            'click .js-connect': 'closeCurrentWindow',
	            'click .js-destroy': 'renderConnectButton',
	            'change .js-mapping-type': 'renderXeroMappedItems'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            template: _Integrations2.default,
	            mappedItems: null,
	            mappableItems: null,
	            defaults: null,
	            paymentAccounts: null,
	            items: null
	        }, options || {});
	
	        this.options.templateExtra = {
	            employeeDebit: this.options.employeeDebit,
	            provider: this.options.provider,
	            qbAccounts: this.options.qbAccounts,
	            organisations: this.options.organisations,
	            contacts: this.options.contacts,
	            debitAccounts: this.options.debitAccounts,
	            creditAccounts: this.options.creditAccounts,
	            mappingTypes: this.options.mappingTypes
	        };
	
	        this.payrollItemIntegrationsView = null;
	        this.paymentAccountIntegrationsView = null;
	
	        if (!this.model) {
	            this.renderConnectButton();
	        }
	
	        _Form2.default.prototype.initialize.apply(this, [this.options]);
	
	        if (this.model) {
	            this.model.off('destroy');
	            this.model.off('sync');
	            this.model.on('destroy', this.renderConnectButton, this);
	            this.model.on('saved', this.afterSave, this);
	            this.checkIntegration();
	        }
	
	        return this;
	    },
	
	    checkIntegration: function checkIntegration() {
	        var _this = this;
	
	        if (this.options.provider === 'xero') {
	            // checking currency
	            var selectedOrg = this.options.organisations.find(function (org) {
	                return _this.model.get('organisationID') === org.organisationID;
	            });
	            var isValidCurrency = !!selectedOrg && selectedOrg.currency === 'MYR';
	
	            if (!!selectedOrg && !isValidCurrency) {
	
	                _modal2.default.showError('You tried to connect to a Xero organisation that ' + 'follows a non-MYR currency, PayrollPanda only ' + 'connects to organisations that follow MYR currency.', false);
	            }
	        }
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.model.on('change:payrollSyncDate', this.togglePayrollSyncButtons, this);
	
	        return _Form2.default.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    render: function render() {
	        var provider = this.options.provider;
	
	        _Form2.default.prototype.render.apply(this, arguments);
	
	        if (this.model) {
	            if (provider === 'quickbooks') {
	                this.renderQuickbooksMappedItems();
	                this.renderQuickbooksPaymentAccounts();
	            }
	
	            if (provider === 'xero') {
	                this.renderXeroMappedItems();
	            }
	        }
	
	        this.$('.js-ext.js-ext-datepicker').addClass('js-ignore').datepicker({
	            autoclose: true,
	            format: 'dd',
	            keyboardNavigation: false,
	            todayBtn: 'linked',
	            todayHighlight: true
	        }).removeClass('js-ignore');
	
	        return this;
	    },
	
	    renderQuickbooksMappedItems: function renderQuickbooksMappedItems() {
	        if (!this.payrollItemIntegrationsView) {
	            this.payrollItemIntegrationsView = new _PayrollItems4.default({
	                collection: this.options.mappedItems,
	                defaults: this.options.defaults,
	                mappableItems: this.options.mappableItems,
	                qbAccounts: this.options.qbAccounts,
	                integration: this.model
	            });
	        }
	
	        this.$('.js-payroll-item-integrations').append(this.payrollItemIntegrationsView.$el);
	
	        return this;
	    },
	
	    renderQuickbooksPaymentAccounts: function renderQuickbooksPaymentAccounts() {
	        if (!this.paymentAccountIntegrationsView) {
	            this.paymentAccountIntegrationsView = new _PaymentAccounts2.default({
	                collection: this.options.paymentAccounts,
	                qbAccounts: this.options.qbAccounts,
	                integration: this.model
	            });
	        }
	
	        this.$('.js-payment-accounts-integrations').append(this.paymentAccountIntegrationsView.$el);
	
	        return this;
	    },
	
	    renderXeroMappedItems: function renderXeroMappedItems() {
	        var mappingType = this.model.get('mappingType');
	
	        this.payrollItemIntegrationsView = new _PayrollItems2.default({
	            collection: this.options.items,
	            integration: this.model,
	            mappingType: mappingType,
	            mappableItems: this.options.mappableItems,
	            debitAccounts: this.options.debitAccounts,
	            creditAccounts: this.options.creditAccounts,
	            contacts: this.options.contacts
	        });
	
	        this.$('.js-payroll-item-integrations').html(this.payrollItemIntegrationsView.$el);
	
	        return this;
	    },
	
	    renderConnectButton: function renderConnectButton() {
	        if (this.model) {
	            this.model.destroy();
	        }
	        var baseUrl = _config2.default.apiUrl + '/integrations/auth';
	
	        var authUrl = function authUrl(provider) {
	            return baseUrl + '/' + app.company.id + '/' + (provider + '?access_token=' + app.user.getAccessToken().id);
	        };
	
	        this.$el.html('').html((0, _IntegrationsConnect2.default)({
	            quickbooksAuthUrl: authUrl('quickbooks'),
	            xeroAuthUrl: authUrl('xero')
	        }));
	
	        return this;
	    },
	
	    togglePayrollSyncButtons: function togglePayrollSyncButtons(model) {
	        if (!model.get('payrollSyncDate')) {
	            this.$('.js-ext-payrollSyncDate[value=0]:not(:checked)').iCheck('check');
	        } else {
	            this.$('.js-ext-payrollSyncDate[value=1]:not(:checked)').iCheck('check');
	        }
	    },
	
	    togglePayrollSyncDatepicker: function togglePayrollSyncDatepicker(ev) {
	        var $input = this.$(ev.currentTarget);
	        var customDate = $input.val() === '1';
	
	        if (!$input.is(':checked')) {
	            return;
	        }
	
	        this.$('.js-payrollSyncDateFormGroup').toggleClass('hidden', !customDate);
	
	        if (!customDate) {
	            this.model.set('payrollSyncDate', null, { silent: true });
	            this.renderAttribute(this.model, 'payrollSyncDate');
	        }
	    },
	
	    updatePayrollSyncDate: function updatePayrollSyncDate() {
	        var $input = this.$('input[name="payrollSyncDate"]');
	        var date = parseInt($input.val()) || (0, _moment2.default)().date();
	
	        this.model.set('payrollSyncDate', date);
	    },
	
	    updateContact: function updateContact(ev) {
	        var $input = this.$(ev.currentTarget);
	        var id = this.getInputValue($input);
	
	        this.model.set({ contact: id });
	    },
	
	    updateMappingType: function updateMappingType(ev) {
	        var $input = this.$(ev.currentTarget);
	        var id = this.getInputValue($input);
	
	        this.model.set({ mappingType: id });
	    },
	
	    closeCurrentWindow: function closeCurrentWindow() {
	        setTimeout(window.close, 500);
	    },
	
	    afterSave: function afterSave() {
	        var _this2 = this;
	
	        _modal2.default.showAlertSuccess('Integration settings have been saved');
	        if (this.options.provider === 'xero') {
	            return this.model.fetchData().then(function (_ref) {
	                var organisations = _ref.organisations,
	                    contacts = _ref.contacts,
	                    debitAccounts = _ref.debitAccounts,
	                    creditAccounts = _ref.creditAccounts;
	
	                _this2.options = Object.assign(_this2.options, {
	                    organisations: organisations,
	                    contacts: contacts,
	                    debitAccounts: debitAccounts,
	                    creditAccounts: creditAccounts
	                });
	
	                _this2.renderXeroMappedItems();
	            });
	        }
	    }
	});

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/Integrations.ejs -->\n';
	 if (provider === 'quickbooks') { 
	__p+='\n    '+
	((__t=( __webpack_require__(873)({model: model}) ))==null?'':__t)+
	'\n';
	 } else if (provider === 'xero') { 
	__p+='\n    '+
	((__t=( __webpack_require__(874)({
	        model: model, contacts: contacts, mappingTypes: mappingTypes, organisations: organisations
	    }) ))==null?'':__t)+
	'\n';
	 } else { 
	__p+='\n    Missing template for provider: '+
	((__t=( provider ))==null?'':_.escape(__t))+
	'\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/Quickbooks.ejs -->\n<h3>\n    Quickbooks\n\n    <button class="btn btn-sm btn-danger pull-right js-destroy">\n        Disconnect from Quickbooks\n    </button>\n</h3>\n\n<div>\n    <form class="form-horizontal" role="form">\n        <div class="form-group">\n            <label class="col-sm-4 control-label">\n                Renew Connection Automatically\n                <i class="fa fa-question-circle" data-toggle="tooltip"\n                    data-placement="top" data-container="body"\n                    title="Quickbooks expires our connection with them after 6\n                        months. To improve the experience, PayrollPanda\n                        automatically renews the connection for you.">\n                </i>\n            </label>\n            <div class="col-sm-3">\n                <input type="checkbox" name="renewToken"\n                    data-value-type="boolean" class="js-icheck"\n                    '+
	((__t=( model.get('renewToken') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                <span class="error error-renewToken"></span>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-4 control-label">\n                Generate Journals Upon Payroll Submission\n                <i class="fa fa-question-circle" data-toggle="tooltip"\n                    data-placement="top" data-container="body"\n                    title="Whenever a payroll is run new journal entries will\n                        be created on QuickBooks">\n                </i>\n            </label>\n            <div class="col-sm-3">\n                <input type="checkbox" name="autoSyncPayroll"\n                    data-value-type="boolean" class="js-icheck"\n                    '+
	((__t=( model.get('autoSyncPayroll') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                <span class="error error-autoSyncPayroll"></span>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-4 control-label">\n                Journal Entry Date\n                <i class="fa fa-question-circle" data-toggle="tooltip"\n                    data-placement="top" data-container="body"\n                    title="The date used when creating a journal entry in\n                        Quickbooks">\n                </i>\n            </label>\n            <div class="col-sm-8">\n                <label style="margin-right: 32px;">\n                    <input type="radio" value="0"\n                        name="payrollSyncDateToggle"\n                        '+
	((__t=( (!model.get('payrollSyncDate')) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                        class="js-icheck js-ext js-ext-payrollSyncDate">\n                    <span>Payroll Date</span>\n                </label>\n                <label style="margin-right: 32px;">\n                    <input type="radio" value="1"\n                        name="payrollSyncDateToggle"\n                        '+
	((__t=( (model.get('payrollSyncDate')) ? 'checked' : '' ))==null?'':_.escape(__t))+
	'\n                        class="js-icheck js-ext js-ext-payrollSyncDate">\n                    <span>\n                        Custom Calendar Date\n                    </span>\n                </label>\n            </div>\n        </div>\n        <div class="form-group js-payrollSyncDateFormGroup\n            '+
	((__t=( !model.get('payrollSyncDate') ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n            <div class="col-sm-8 col-sm-offset-4">\n                <span class="date js-ext js-ext-datepicker input-group"\n                    data-date-format="dd">\n                    <span class="input-group-addon">\n                        <span class="glyphicon glyphicon-calendar"></span>\n                    </span>\n                    <input type="text" class="form-control\n                        js-datepicker-input"\n                        name="payrollSyncDate"\n                        value="'+
	((__t=( model.get('payrollSyncDate') ))==null?'':_.escape(__t))+
	'">\n                </span>\n            </div>\n        </div>\n\n        <div class="text-right">\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-title="No changes will be saved"\n                data-placement="top" data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </form>\n</div>\n\n<div class="hr-line-dashed m-t-xl m-b-xl"></div>\n\n<h3 class="m-b-md">Accounts Mapping</h3>\n\n<div class="js-ext js-payment-accounts-integrations m-b-md"></div>\n<div class="js-ext js-payroll-item-integrations"></div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/xero/Xero.ejs -->\n<div>\n    <form class="form-horizontal" role="form">\n        <div class="form-group">\n            <div class="col-sm-4">\n                <select name="organisationID">\n                    ';
	 organisations.forEach(function (org) { 
	__p+='\n                    <option\n                        value="'+
	((__t=( org.organisationID ))==null?'':_.escape(__t))+
	'"\n                        '+
	((__t=( model.get('organisationID') === org.organisationID ? 'selected' : '' ))==null?'':_.escape(__t))+
	'\n                    >\n                        '+
	((__t=( org.name ))==null?'':_.escape(__t))+
	'\n                    </option>\n                    ';
	 }) 
	__p+='\n                </select>\n            </div>\n            <button class="btn btn-sm btn-danger pull-right js-destroy">\n                Disconnect from Xero\n            </button>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-4 control-label">\n                Generate Bills Upon Payroll Submission\n                <i class="fa fa-question-circle" data-toggle="tooltip"\n                    data-placement="top" data-container="body"\n                    title="Whenever a payroll is completed new billing\n                        entries will be created in Xero">\n                </i>\n            </label>\n            <div class="col-sm-3">\n                <input type="checkbox" name="autoSyncPayroll"\n                    data-value-type="boolean" class="js-icheck"\n                    '+
	((__t=( model.get('autoSyncPayroll') ? 'checked' : '' ))==null?'':_.escape(__t))+
	'>\n                <span class="error error-autoSyncPayroll"></span>\n            </div>\n        </div>\n\n        <div class="form-group js-payrollSyncDateFormGroup\n            '+
	((__t=( !model.get('payrollSyncDate') ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n            <div class="col-sm-8 col-sm-offset-4">\n                <span class="date js-ext js-ext-datepicker input-group"\n                    data-date-format="dd">\n                    <span class="input-group-addon">\n                        <span class="glyphicon glyphicon-calendar"></span>\n                    </span>\n                    <input type="text" class="form-control\n                        js-datepicker-input"\n                        name="payrollSyncDate"\n                        value="'+
	((__t=( model.get('payrollSyncDate') ))==null?'':_.escape(__t))+
	'">\n                </span>\n            </div>\n        </div>\n\n        <div class="form-group js-mapping-type">\n            <label class="col-sm-4 control-label">\n                Mapping Type\n            </label>\n            <div class="col-sm-3">\n                <select name="mappingType" class="form-control">\n                    ';
	 mappingTypes.forEach(function (type) { 
	__p+='\n                        <option value="'+
	((__t=( type.id ))==null?'':_.escape(__t))+
	'"\n                                '+
	((__t=( model.get('mappingType') === type.id ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                            '+
	((__t=( type.label ))==null?'':_.escape(__t))+
	'\n                        </option>\n                    ';
	 }) 
	__p+='\n                </select>\n            </div>\n        </div>\n\n        <div class="text-right">\n            <button type="button"\n                class="js-cancel btn btn-w-m btn-warning"\n                data-toggle="tooltip" data-title="No changes will be saved"\n                data-placement="top" data-delayed>\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Save\n            </button>\n        </div>\n    </form>\n</div>\n\n<div class="hr-line-dashed m-t-xl m-b-xl"></div>\n\n<h3 class="m-b-md">Payroll Item Mapping</h3>\n\n<div class="js-ext js-payroll-item-integrations"></div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/IntegrationsConnect.ejs -->\n<div class="row wrapper integrations-connect">\n    <div class="col-md-6 col-lg-4 m-t-md connect-container connect-quickbooks">\n        <div class="m-t-md logo">\n            <img src="/images/quickbooks.png">\n        </div>\n\n        <div class="m-t-md description">\n            Connect your QuickBooks account with PayrollPanda and auto-sync your payroll data.\n        </div>\n\n        <div class="m-t-md connect">\n            <a href="'+
	((__t=( quickbooksAuthUrl ))==null?'':_.escape(__t))+
	'" class="btn btn-primary js-connect"\n                target="_blank">\n                Connect with Quickbooks\n            </a>\n        </div>\n    </div>\n\n    <div class="col-md-6 col-lg-4 m-t-md connect-container connect-xero">\n        <div class="m-t-md logo">\n            <img src="/images/xero.png">\n        </div>\n\n        <div class="m-t-md description">\n            Integrate Xero with PayrollPanda and your payroll data is auto-synced.\n        </div>\n\n        <div class="m-t-md connect">\n            <a href="'+
	((__t=( xeroAuthUrl ))==null?'':_.escape(__t))+
	'" class="btn btn-primary js-connect"\n                target="_blank">\n                Connect with Xero\n            </a>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _PayrollItem = __webpack_require__(877);
	
	var _PayrollItem2 = _interopRequireDefault(_PayrollItem);
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _payrollItemIntegration = __webpack_require__(879);
	
	var _payrollItemIntegration2 = _interopRequireDefault(_payrollItemIntegration);
	
	var _PayrollItems = __webpack_require__(880);
	
	var _PayrollItems2 = _interopRequireDefault(_PayrollItems);
	
	var _PayrollItemSelectionModal = __webpack_require__(722);
	
	var _PayrollItemSelectionModal2 = _interopRequireDefault(_PayrollItemSelectionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ListEditables2.default.extend({
	    modelViews: [],
	    modalView: null,
	
	    events: function events() {
	        var parentEvents = _.isFunction(_ListEditables2.default.prototype.events) ? _ListEditables2.default.prototype.events() : _ListEditables2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-add-items': 'showSelectModal',
	            'click .js-show-all-items': 'addAllItems',
	            'click .js-hide-unmapped-items': 'destroyUnmappedItems'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItems2.default,
	            Model: _payrollItemIntegration2.default,
	            ModelView: _PayrollItem2.default,
	            mappableItems: null
	        });
	
	        this.options.templateExtra = {
	            mappingType: this.options.mappingType,
	            debitAccounts: this.options.debitAccounts,
	            creditAccounts: this.options.creditAccounts,
	            contacts: this.options.contacts
	        };
	
	        this.integration = options.integration;
	        this.mappingType = this.options.mappingType;
	        this.mappingTypeMap = {
	            'net': ['Net Salary', 'PCB', 'PCB borne by employer', 'EPF (Employee)', 'EPF (Employer)', 'SOCSO (Employee)', 'SOCSO (Employer)', 'EIS (Employee)', 'EIS (Employer)', 'HRDF', 'ZAKAT'],
	            'base': ['Basic Salary', 'PCB', 'PCB borne by employer', 'EPF (Employee)', 'EPF (Employer)', 'SOCSO (Employee)', 'SOCSO (Employer)', 'EIS (Employee)', 'EIS (Employer)', 'HRDF', 'ZAKAT'],
	            'gross': ['Gross Salary', 'PCB', 'PCB borne by employer', 'EPF (Employee)', 'EPF (Employer)', 'SOCSO (Employee)', 'SOCSO (Employer)', 'EIS (Employee)', 'EIS (Employer)', 'HRDF', 'ZAKAT']
	        };
	
	        this.mapping = this.mappingTypeMap[this.mappingType];
	
	        // for adding new payroll items such as additions/deductions
	        this.unmappedItems = this.options.mappableItems.clone();
	        this.updateItemAvailability();
	        this.payrollItemsModal = new _PayrollItemSelectionModal2.default({
	            collection: this.unmappedItems
	        });
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    getFormState: function getFormState() {
	        // check weather the form is empty or just partially done
	        // partial example is when we add contact but not account
	        // or vice versa
	        var isEmpty = true;
	        var isPartial = false;
	        for (var i = 0; i < this.filteredCollection.length; ++i) {
	            var item = this.filteredCollection[i];
	            var hasAccount = !!item.get('debitAccount') && !!item.get('creditAccount');
	            var hasContact = !!item.get('contact');
	
	            if (hasAccount && hasContact) {
	                isEmpty = false;
	            } else if (!hasAccount && !hasContact) {
	                // dont have nothing
	            } else {
	                isPartial = true;
	            }
	
	            // wall case, cannot change anymore
	            if (!isEmpty && isPartial) {
	                break;
	            }
	        }
	
	        return {
	            isEmpty: isEmpty,
	            isPartial: isPartial
	        };
	    },
	
	    isDirty: function isDirty() {
	        var tainted = this.modelViews.filter(function (m) {
	            return m.tainted;
	        });
	        return tainted.length > 0;
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.payrollItemsModal.on('select', this.addItems, this);
	
	        this.collection.on('add remove reset', this.updateItemAvailability, this);
	
	        this.collection.on('remove', this.removeModelView, this);
	
	        app.events.on('navigate', function (status) {
	            if (this.isDirty()) {
	                status.unsaved = true;
	                status.msg = 'You have unsaved changes.  Exiting this ' + 'page will result in the changes being discarded.';
	            } else {
	                status.unsaved = false;
	            }
	        }, this);
	
	        app.events.on('hard-exit', this.hardExit, this);
	
	        return _ListEditables2.default.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        return _ListEditables2.default.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    renderModels: function renderModels() {
	        var _this = this;
	
	        if (!this.options.ModelView) {
	            return this;
	        }
	
	        this.removeModelViews();
	
	        if (!this.collection) {
	            return this;
	        }
	
	        // filter collections based on mapping type
	        // very big problem for basic type since there are
	        // custom elementts also...
	        this.filteredCollection = this.collection.filter(function (c) {
	            return _this.mapping.indexOf(c.get('label')) > -1 || _this.mappingType === 'base' && c.get('isCustom');
	        });
	
	        // eliminate duplicate payrollitems to avoid sync problems
	        // only applicable to 'base' mapping type
	        if (this.mappingType === 'base') {
	            var uniques = [];
	            this.filteredCollection = this.filteredCollection.filter(function (c) {
	                var payrollItemId = c.get('payrollItemId');
	
	                if (uniques.indexOf(payrollItemId) > -1) {
	                    return false;
	                }
	
	                uniques.push(payrollItemId);
	                return true;
	            });
	        }
	
	        // sort filteredCollection by index
	        this.filteredCollection.sort(function (x, y) {
	            return x.get('index') - y.get('index');
	        });
	
	        this.filteredCollection.forEach(function (model) {
	            _this.renderModel(model);
	        });
	
	        return this;
	    },
	
	    renderModel: function renderModel(model) {
	        var view = new this.options.ModelView({
	            model: model,
	            debitAccounts: this.options.debitAccounts,
	            creditAccounts: this.options.creditAccounts,
	            contacts: this.options.contacts,
	            mappingType: this.mappingType,
	            mapping: this.mapping
	        });
	
	        this.$('.js-model-views').append(view.$el);
	        this.modelViews.push(view);
	        return this;
	    },
	
	    showSelectModal: function showSelectModal(e) {
	        e.preventDefault();
	
	        this.payrollItemsModal.show();
	    },
	
	    addItems: function addItems(payrollItems) {
	        var _this2 = this;
	
	        payrollItems.forEach(function (payrollItem) {
	            _this2.collection.add({
	                companyId: app.company.id,
	                integrationId: _this2.options.integration.id,
	                payrollItemId: payrollItem.id,
	                affects: payrollItem.get('type'),
	                employee: false,
	                label: payrollItem.get('name'),
	                index: _this2.collection.length + 1,
	                isCustom: true,
	                debitAccount: null,
	                creditAccount: null,
	                contact: null
	            }, { silent: true });
	        });
	
	        this.renderModels();
	    },
	
	    addAllItems: function addAllItems(e) {
	        e.preventDefault();
	
	        this.addItems(this.unmappedItems);
	    },
	
	    destroyUnmappedItems: function destroyUnmappedItems(e) {
	        var _this3 = this;
	
	        e.preventDefault();
	
	        var unmapped = this.collection.filter(function (model) {
	            var isMissingProperty = !model.get('debitAccount') || !model.get('creditAccount') || !model.get('contact');
	            var isCustom = model.get('isCustom') || false;
	
	            return isMissingProperty && isCustom;
	        });
	
	        unmapped.forEach(function (model) {
	            return _this3.collection.remove(model);
	        });
	    },
	
	    updateItemAvailability: function updateItemAvailability() {
	        var _this4 = this;
	
	        this.unmappedItems.reset(this.options.mappableItems.clone().filter(function (model) {
	            return !_this4.collection.find(function (itemIntegration) {
	                var itemId = itemIntegration.get('payrollItemId');
	                return itemId === model.id;
	            });
	        }));
	    },
	
	    save: function save(ev) {
	        var _this5 = this;
	
	        var formState = this.getFormState();
	
	        if (formState.isPartial) {
	            this.integration.set('ready', false);
	            this.integration.save().then(function () {
	                return _modal2.default.showError('You must assign debit/credit account and contact to ' + 'payroll item in order for sync to work properly!', false);
	            });
	
	            return false;
	        }
	
	        if (formState.isEmpty) {
	            this.integration.set('ready', false);
	            this.integration.save().then(function () {
	                return _modal2.default.showError('Contact field is required to be mapped', false);
	            });
	
	            return false;
	        }
	
	        this.integration.set('ready', true).save().then(function () {
	            return _ListEditables2.default.prototype.save.apply(_this5, [ev]).then(function () {
	                return _modal2.default.showAlertSuccess('Mappings have been saved');
	            });
	        });
	
	        return false;
	    },
	
	    removeModelView: function removeModelView(model) {
	        var view = _(this.modelViews).find(function (v) {
	            return v.model.cid === model.cid;
	        });
	
	        if (!view) {
	            return;
	        }
	
	        view.remove();
	        view = null;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _PayrollItem = __webpack_require__(878);
	
	var _PayrollItem2 = _interopRequireDefault(_PayrollItem);
	
	var _RowEdit = __webpack_require__(690);
	
	var _RowEdit2 = _interopRequireDefault(_RowEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _RowEdit2.default.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        return Object.assign({}, _RowEdit2.default.prototype.events() || {}, {
	            'change .js-integration[name=remoteId]': 'updateIntegration'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItem2.default,
	            deletable: true
	        });
	
	        this.options.templateExtra = {
	            debitAccounts: this.options.debitAccounts,
	            creditAccounts: this.options.creditAccounts,
	            contacts: this.options.contacts,
	            mapping: this.options.mapping,
	            mappingType: this.options.mappingType
	        };
	
	        return _RowEdit2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    updateIntegration: function updateIntegration(ev) {
	        var $input = this.$(ev.currentTarget);
	        var remoteId = this.getInputValue($input);
	        var remoteName = $.trim($input.find('option[value="' + remoteId + '"]').text());
	
	        this.model.set({
	            remoteId: remoteId,
	            remoteName: remoteName
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/xero/PayrollItem.ejs -->\n<td class="td-nowrap">\n    ';
	 if ((mappingType === 'base' || mappingType === 'gross') && model.get('label') === 'HRDF') { 
	__p+='\n        HRDF (Employer)\n    ';
	 } else { 
	__p+='\n        '+
	((__t=( model.get('label') ))==null?'':_.escape(__t))+
	'\n    ';
	 } 
	__p+='\n</td>\n\n<td>\n        <select name="debitAccount" class="form-control js-debit-account">\n            <option></option>\n            ';
	 debitAccounts && debitAccounts.forEach(function (account) { 
	__p+='\n                <option value="'+
	((__t=( account.id ))==null?'':_.escape(__t))+
	'"\n                    '+
	((__t=( model.get('debitAccount') === account.id ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( account.label ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n    </td>\n\n<td>\n    <select name="creditAccount" class="form-control js-credit-account">\n        <option></option>\n        ';
	 creditAccounts && creditAccounts.forEach(function (account) { 
	__p+='\n            <option value="'+
	((__t=( account.id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.get('creditAccount') === account.id ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( account.label ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n\n<td>\n    <select name="contact" class="form-control js-contact">\n        <option></option>\n        ';
	 contacts && contacts.forEach(function (contact) { 
	__p+='\n            <option value="'+
	((__t=( contact.id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.get('contact') === contact.id ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( contact.label ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var log = (0, _log2.default)('newModels/payroll-item-integration');
	
	var PayrollItemIntegration = function (_Model) {
	    _inherits(PayrollItemIntegration, _Model);
	
	    function PayrollItemIntegration() {
	        _classCallCheck(this, PayrollItemIntegration);
	
	        return _possibleConstructorReturn(this, (PayrollItemIntegration.__proto__ || Object.getPrototypeOf(PayrollItemIntegration)).apply(this, arguments));
	    }
	
	    _createClass(PayrollItemIntegration, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/PayrollItemIntegrations';
	        }
	    }, {
	        key: 'defaults',
	        value: function defaults() {
	            return {
	                payrollItemId: null,
	                remoteId: null,
	                syncedAt: new Date()
	            };
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            _get(PayrollItemIntegration.prototype.__proto__ || Object.getPrototypeOf(PayrollItemIntegration.prototype), 'initialize', this).apply(this, arguments);
	            this.payrollItem = this.getPayrollItem();
	        }
	    }, {
	        key: 'constraints',
	        value: function constraints() {
	            return {
	                companyId: { presence: true },
	                integrationId: { presence: true }
	            };
	        }
	    }, {
	        key: 'getPayrollItem',
	        value: function getPayrollItem() {
	            if (this.payrollItem) {
	                return this.payrollItem;
	            }
	            return this._setPayrollItem(this.get('payrollItemId'));
	        }
	    }, {
	        key: '_setPayrollItem',
	        value: function _setPayrollItem(id) {
	            if (!app.payrollItems) {
	                log.warn('App hasn\'t any payroll items loaded');
	                return;
	            }
	
	            if (!id) {
	                log.warn('Payroll item integration doesn\'t have a payroll item');
	                return;
	            }
	
	            this.payrollItem = app.payrollItems.find(function (model) {
	                return model.id === id;
	            });
	
	            return this.payrollItem;
	        }
	    }]);
	
	    return PayrollItemIntegration;
	}(_model2.default);
	
	exports.default = PayrollItemIntegration;

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/xero/PayrollItems.ejs -->\n<table class="table table-striped table-settings js-ext">\n    <thead>\n        <tr>\n            <th width="25%">Payroll Item</th>\n            <th width="25%">Xero Account (Dr - Expense)</th>\n            <th width="25%">Xero Account (Cr - Liability)</th>\n            <th width="25%">Xero Contact</th>\n        </tr>\n    </thead>\n    <tbody class="js-empty">\n        <tr><td colspan="4">\n            <h2 class="text-center">\n                You don\'t have any mapped payroll items yet.\n            </h2>\n        </td></tr>\n    </tbody>\n    <tbody class="js-model-views">\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan="4">\n                ';
	 if (mappingType === 'base') { 
	__p+='\n                    <button type="button"\n                        class="btn btn-outline btn-default js-add-items\n                            pull-left"\n                        data-loading-text="Adding..."\n                        data-complete-text="+ Add Items">\n                        + Add Items\n                    </button>\n                    <button type="button"\n                        class="btn btn-outline btn-default js-show-all-items\n                            pull-left m-l-md"\n                        data-loading-text="Showing..."\n                        data-complete-text="Show All Items">\n                        Show All Items\n                    </button>\n                    <button type="button"\n                        class="btn btn-outline btn-default js-hide-unmapped-items\n                            pull-left m-l-md"\n                        data-loading-text="Hiding..."\n                        data-complete-text="Hide Umapped Items">\n                        Hide Unmapped Items\n                    </button>\n                ';
	 } 
	__p+='\n                <button type="submit" class="btn btn-primary\n                    js-save pull-right">\n                    Save\n                </button>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n';
	}
	return __p;
	};


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _PayrollItem = __webpack_require__(882);
	
	var _PayrollItem2 = _interopRequireDefault(_PayrollItem);
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _payrollItemIntegration = __webpack_require__(879);
	
	var _payrollItemIntegration2 = _interopRequireDefault(_payrollItemIntegration);
	
	var _PayrollItems = __webpack_require__(884);
	
	var _PayrollItems2 = _interopRequireDefault(_PayrollItems);
	
	var _PayrollItemSelectionModal = __webpack_require__(722);
	
	var _PayrollItemSelectionModal2 = _interopRequireDefault(_PayrollItemSelectionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ListEditables2.default.extend({
	    modelViews: [],
	    modalView: null,
	
	    events: function events() {
	        var parentEvents = _.isFunction(_ListEditables2.default.prototype.events) ? _ListEditables2.default.prototype.events() : _ListEditables2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-add-items': 'showSelectModal',
	            'click .js-show-all-items': 'addAllItems',
	            'click .js-hide-unmapped-items': 'destroyUnmappedItems'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItems2.default,
	            Model: _payrollItemIntegration2.default,
	            ModelView: _PayrollItem2.default,
	            qbAccounts: [],
	            mappableItems: null,
	            defaults: null
	        });
	        this.options.templateExtra = { qbAccounts: this.options.qbAccounts };
	
	        this.unmappedItems = this.options.mappableItems.clone();
	        this.updateItemAvailability();
	
	        this.payrollItemsModal = new _PayrollItemSelectionModal2.default({
	            collection: this.unmappedItems
	        });
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    bindHandlers: function bindHandlers() {
	        this.payrollItemsModal.on('select', this.addItems, this);
	        this.collection.on('add remove reset', this.updateItemAvailability, this);
	        this.collection.on('remove', this.removeModelView, this);
	        return _ListEditables2.default.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    unbindHandlers: function unbindHandlers() {
	        this.payrollItemsModal.off(null, null, this);
	        return _ListEditables2.default.prototype.bindHandlers.apply(this, arguments);
	    },
	
	    renderModels: function renderModels() {
	        var _this = this;
	
	        if (!this.options.ModelView) {
	            return this;
	        }
	
	        if (!this.collection) {
	            return this;
	        }
	
	        var payrollItemIds = _(this.collection.map(function (model) {
	            return model.get('payrollItemId');
	        })).uniq();
	
	        var payrollItems = app.payrollItems.filter(function (model) {
	            if (payrollItemIds.includes(model.id)) {
	                return model;
	            }
	        });
	
	        this.removeModelViews();
	        // loop through payrollItemIds because that list is sorted
	        payrollItemIds.forEach(function (itemId) {
	            var item = payrollItems.find(function (item) {
	                return item.id === itemId;
	            });
	            if (!item) {
	                return;
	            }
	
	            var employeeIntegration = null;
	            var employerIntegration = null;
	
	            if (_this.isEmployeePayable(item)) {
	                employeeIntegration = _this.collection.find(function (model) {
	                    return model.get('affects') === 'employee' && model.get('payrollItemId') === item.id;
	                }) || new _payrollItemIntegration2.default({
	                    companyId: app.company.id,
	                    payrollItemId: item.id,
	                    integrationId: _this.options.integration.id,
	                    affects: 'employee',
	                    remoteId: null,
	                    remoteName: null,
	                    syncedAt: null
	                });
	                if (employeeIntegration.isNew()) {
	                    _this.collection.add(employeeIntegration, { silent: true });
	                }
	            }
	
	            if (_this.isEmployerPayable(item)) {
	                employerIntegration = _this.collection.find(function (model) {
	                    return model.get('affects') !== 'employee' && model.get('payrollItemId') === item.id;
	                }) || new _payrollItemIntegration2.default({
	                    companyId: app.company.id,
	                    payrollItemId: item.id,
	                    integrationId: _this.options.integration.id,
	                    // 20210913 PPKAN-256
	                    // hard-coded logic, again, for our dear "Employer HRDF Levy (Custom)"
	                    affects: item.get('subtype') === 'hrdf' ? 'hrdf' : item.get('type'),
	                    remoteId: null,
	                    remoteName: null,
	                    syncedAt: null
	                });
	                if (employerIntegration.isNew()) {
	                    _this.collection.add(employerIntegration, { silent: true });
	                }
	            }
	
	            _this.renderModel(item, employeeIntegration, employerIntegration);
	        });
	
	        return this;
	    },
	
	    renderModel: function renderModel(model, employeeIntegration, employerIntegration) {
	        var view = new this.options.ModelView({
	            model: model,
	            employeeIntegration: employeeIntegration,
	            employerIntegration: employerIntegration,
	            qbAccounts: this.options.qbAccounts
	        });
	        this.$('.js-model-views').append(view.$el);
	        this.modelViews.push(view);
	        return this;
	    },
	
	    save: function save(ev) {
	        _ListEditables2.default.prototype.save.apply(this, [ev]).then(function () {
	            _modal2.default.showAlertSuccess('Mappings have been saved');
	        });
	        return false;
	    },
	
	    showSelectModal: function showSelectModal(ev) {
	        ev.preventDefault();
	        this.payrollItemsModal.show();
	    },
	
	    addAllItems: function addAllItems(ev) {
	        ev.preventDefault();
	        this.addItems(this.unmappedItems);
	    },
	
	    // Destroy all unmapped items, except the defaults
	    destroyUnmappedItems: function destroyUnmappedItems(ev) {
	        var _this2 = this;
	
	        ev.preventDefault();
	        var unmapped = this.collection.filter(function (model) {
	            var isDefault = !!_this2.options.defaults.find(function (m) {
	                return m.id === model.get('payrollItemId');
	            });
	            return !isDefault && !model.get('remoteId');
	        });
	        unmapped.forEach(function (model) {
	            return _this2.collection.remove(model);
	        });
	    },
	
	    updateItemAvailability: function updateItemAvailability() {
	        var _this3 = this;
	
	        this.unmappedItems.reset(this.options.mappableItems.clone().filter(function (model) {
	            return !_this3.collection.find(function (itemIntegration) {
	                var itemId = itemIntegration.get('payrollItemId');
	                return itemId === model.id;
	            });
	        }));
	    },
	
	    isEmployerPayable: function isEmployerPayable(payrollItem) {
	        return ['mtd', 'socso', 'epf', 'zakat', 'eis', 'hrdf', 'cp38'].includes(payrollItem.get('type')) || payrollItem.get('subtype') === 'hrdf';
	    },
	
	    isEmployeePayable: function isEmployeePayable(payrollItem) {
	        return !this.isEmployerPayable(payrollItem) || payrollItem.get('isNet');
	    },
	
	    addItems: function addItems(payrollItems) {
	        var _this4 = this;
	
	        payrollItems.forEach(function (payrollItem) {
	            if (_this4.isEmployeePayable(payrollItem)) {
	                _this4.collection.add({
	                    companyId: app.company.id,
	                    payrollItemId: payrollItem.id,
	                    integrationId: _this4.options.integration.id,
	                    affects: 'employee',
	                    remoteId: null,
	                    remoteName: null,
	                    syncedAt: null
	                }, { silent: true });
	            }
	
	            if (_this4.isEmployerPayable(payrollItem)) {
	                _this4.collection.add({
	                    companyId: app.company.id,
	                    payrollItemId: payrollItem.id,
	                    integrationId: _this4.options.integration.id,
	                    // 20210913 PPKAN-256
	                    // hard-coded logic, again, for our dear "Employer HRDF Levy (Custom)"
	                    affects: payrollItem.get('subtype') === 'hrdf' ? 'hrdf' : payrollItem.get('type'),
	                    remoteId: null,
	                    remoteName: null,
	                    syncedAt: null
	                }, { silent: true });
	            }
	        });
	
	        this.renderModels();
	    },
	
	    removeModelView: function removeModelView(model) {
	        var view = this.modelViews.find(function (v) {
	            return v.model.id === model.get('payrollItemId');
	        });
	        if (!view) {
	            return;
	        }
	        view.remove();
	        view = null;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _PayrollItem = __webpack_require__(883);
	
	var _PayrollItem2 = _interopRequireDefault(_PayrollItem);
	
	var _RowEdit = __webpack_require__(690);
	
	var _RowEdit2 = _interopRequireDefault(_RowEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _RowEdit2.default.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        var parentEvents = _.isFunction(_RowEdit2.default.prototype.events) ? _RowEdit2.default.prototype.events() : _RowEdit2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'change .js-ext-employee[name=remoteId]': 'updateEmployeeIntegration',
	            'change .js-ext-employer[name=remoteId]': 'updateEmployerIntegration'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PayrollItem2.default,
	            deletable: true,
	            qbAccounts: [],
	            employerIntegration: null,
	            employeeIntegration: null
	        });
	        this.options.templateExtra = {
	            qbAccounts: this.options.qbAccounts,
	            employerIntegration: this.options.employerIntegration,
	            employeeIntegration: this.options.employeeIntegration
	        };
	        return _RowEdit2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    updateEmployeeIntegration: function updateEmployeeIntegration(ev) {
	        this.updateIntegration('employee', ev);
	    },
	
	    updateEmployerIntegration: function updateEmployerIntegration(ev) {
	        this.updateIntegration('employer', ev);
	    },
	
	    updateIntegration: function updateIntegration(affects, ev) {
	        var $input = this.$(ev.currentTarget);
	        var remoteId = this.getInputValue($input);
	        var remoteName = $.trim($input.find('option[value="' + remoteId + '"]').text());
	
	        if (affects === 'employee') {
	            this.options.employeeIntegration.set({
	                remoteId: remoteId,
	                remoteName: remoteName
	            });
	        } else if (affects === 'employer') {
	            this.options.employerIntegration.set({
	                remoteId: remoteId,
	                remoteName: remoteName
	            });
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PayrollItem.ejs -->\n<td class="td-nowrap">\n    '+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'\n</td>\n<td>\n    ';
	 if (employerIntegration) { 
	__p+='\n        <select name="remoteId"\n            class="form-control js-ext js-ext-employer">\n            <option></option>\n            ';
	 qbAccounts.forEach(function (account) { 
	__p+='\n                <option value="'+
	((__t=( account.Id ))==null?'':_.escape(__t))+
	'"\n                    '+
	((__t=( employerIntegration.get('remoteId') === account.Id ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                    '+
	((__t=( account.FullyQualifiedName ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n    ';
	 } 
	__p+='\n</td>\n<td>\n    ';
	 if (employeeIntegration) { 
	__p+='\n    <select name="remoteId"\n        class="form-control js-ext js-ext-employee">\n        <option></option>\n        ';
	 qbAccounts.forEach(function (account) { 
	__p+='\n            <option value="'+
	((__t=( account.Id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( employeeIntegration.get('remoteId') === account.Id ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( account.FullyQualifiedName ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n    ';
	 } 
	__p+='\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PayrollItems.ejs -->\n<table class="table table-striped table-settings js-ext">\n    <thead>\n        <tr>\n            <th width="50%">Payroll Item</th>\n            <th width="25%">Employer Portion</th>\n            <th width="25%">Employee Portion</th>\n        </tr>\n    </thead>\n    <tbody class="js-empty">\n        <tr><td colspan="3">\n            <h2 class="text-center">\n                You don\'t have any mapped payroll items yet.\n            </h2>\n        </td></tr>\n    </tbody>\n    <tbody class="js-model-views">\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan="3">\n                <button type="button"\n                    class="btn btn-outline btn-default js-add-items\n                        pull-left"\n                    data-loading-text="Adding..."\n                    data-complete-text="+ Add Items">\n                    + Add Items\n                </button>\n                <button type="button"\n                    class="btn btn-outline btn-default js-show-all-items\n                        pull-left m-l-md"\n                    data-loading-text="Showing..."\n                    data-complete-text="Show All Items">\n                    Show All Items\n                </button>\n                <button type="button"\n                    class="btn btn-outline btn-default js-hide-unmapped-items\n                        pull-left m-l-md"\n                    data-loading-text="Hiding..."\n                    data-complete-text="Hide Umapped Items">\n                    Hide Unmapped Items\n                </button>\n                <button type="submit" class="btn btn-primary\n                    js-save pull-right">\n                    Save\n                </button>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n';
	}
	return __p;
	};


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _PaymentAccount = __webpack_require__(886);
	
	var _PaymentAccount2 = _interopRequireDefault(_PaymentAccount);
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _PaymentAccounts = __webpack_require__(888);
	
	var _PaymentAccounts2 = _interopRequireDefault(_PaymentAccounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ListEditables2.default.extend({
	    modelViews: [],
	    modalView: null,
	
	    events: function events() {
	        var parentEvents = _.isFunction(_ListEditables2.default.prototype.events) ? _ListEditables2.default.prototype.events() : _ListEditables2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {});
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PaymentAccounts2.default,
	            ModelView: _PaymentAccount2.default,
	            qbAccounts: []
	        });
	        this.options.templateExtra = {
	            qbAccounts: this.options.qbAccounts
	        };
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    renderModel: function renderModel(model) {
	        var view = new this.options.ModelView({
	            model: model,
	            qbAccounts: this.options.qbAccounts
	        });
	        this.$('.js-model-views').append(view.$el);
	        this.modelViews.push(view);
	        return this;
	    },
	
	    save: function save(ev) {
	        _ListEditables2.default.prototype.save.apply(this, [ev]).then(function () {
	            _modal2.default.showAlertSuccess('Mappings have been saved');
	        });
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _PaymentAccount = __webpack_require__(887);
	
	var _PaymentAccount2 = _interopRequireDefault(_PaymentAccount);
	
	var _RowEdit = __webpack_require__(690);
	
	var _RowEdit2 = _interopRequireDefault(_RowEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _RowEdit2.default.extend({
	    tagName: 'tr',
	
	    events: function events() {
	        var parentEvents = _.isFunction(_RowEdit2.default.prototype.events) ? _RowEdit2.default.prototype.events() : _RowEdit2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'change [name=remoteId]': 'setRemoteName'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _PaymentAccount2.default,
	            deletable: true,
	            qbAccounts: []
	        });
	        this.options.templateExtra = { qbAccounts: this.options.qbAccounts };
	        return _RowEdit2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    setRemoteName: function setRemoteName(ev) {
	        var $input = this.$(ev.currentTarget);
	        var remoteId = this.getInputValue($input);
	        var remoteName = $.trim($input.find('option[value="' + remoteId + '"]').text());
	        this.model.set({ remoteName: remoteName || '' });
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PaymentAccount.ejs -->\n<td class="td-nowrap">\n    '+
	((__t=(
	        model.get('affects') === 'employee' ? 'Employee' :
	        model.get('affects') === 'mtd' ? 'PCB (LHDN)' :
	        model.get('affects') === 'epf' ? 'EPF (KWSP)' :
	        model.get('affects') === 'socso' ? 'SOCSO (PKS)' :
	        model.get('affects') === 'eis' ? 'EIS' :
	        model.get('affects') === 'hrdf' ? 'HRDF' :
	        model.get('affects') === 'zakat' ? 'Zakat' : 'Unknown'
	    ))==null?'':_.escape(__t))+
	'\n</td>\n<td>\n    <select name="remoteId"\n        class="form-control">\n        <option></option>\n        ';
	 qbAccounts.forEach(function (account) { 
	__p+='\n            <option value="'+
	((__t=( account.Id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( model.get('remoteId') === account.Id ? 'selected': '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( account.FullyQualifiedName ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PaymentAccounts.ejs -->\n<table class="table table-striped table-settings js-ext">\n    <thead>\n        <tr>\n            <th width="50%">Payment Recipient</th>\n            <th>Account</th>\n        </tr>\n    </thead>\n    <tbody class="js-empty">\n        <tr><td colspan="2">\n            <h2 class="text-center">\n                An error ocurred loading this list. Please contact support to\n                get assistance.\n            </h2>\n        </td></tr>\n    </tbody>\n    <tbody class="js-model-views">\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan="2">\n                <button type="submit" class="btn btn-primary\n                    js-save pull-right">\n                    Save\n                </button>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n';
	}
	return __p;
	};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _payrollItemIntegration = __webpack_require__(879);
	
	var _payrollItemIntegration2 = _interopRequireDefault(_payrollItemIntegration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayrollItemIntegrations = function (_Collection) {
	    _inherits(PayrollItemIntegrations, _Collection);
	
	    function PayrollItemIntegrations() {
	        _classCallCheck(this, PayrollItemIntegrations);
	
	        return _possibleConstructorReturn(this, (PayrollItemIntegrations.__proto__ || Object.getPrototypeOf(PayrollItemIntegrations)).apply(this, arguments));
	    }
	
	    _createClass(PayrollItemIntegrations, [{
	        key: 'url',
	        value: function url() {
	            if (this.company) {
	                return this.company.url() + '/payrollItemIntegrations';
	            }
	            return '/payrollItemIntegrations';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize(models, _ref) {
	            var _ref$company = _ref.company,
	                company = _ref$company === undefined ? null : _ref$company;
	
	            this.model = _payrollItemIntegration2.default;
	            _get(PayrollItemIntegrations.prototype.__proto__ || Object.getPrototypeOf(PayrollItemIntegrations.prototype), 'initialize', this).apply(this, arguments);
	            this.company = company;
	            return this;
	        }
	    }, {
	        key: 'comparator',
	        value: function comparator(model) {
	            var weightByType = {
	                base: 100,
	                mtd: 90,
	                epf: 80,
	                socso: 70,
	                eis: 60,
	                zakat: 50,
	                hrdf: 40,
	                addition: 30,
	                benefit: 20,
	                deduction: 10
	            };
	            var weightByAffects = {
	                employee: 100,
	                mtd: 90,
	                epf: 80,
	                socso: 70,
	                eis: 60,
	                zakat: 50,
	                hrdf: 40
	            };
	            var item = model.getPayrollItem();
	
	            if (!item) {
	                return -(weightByAffects[model.get('affects')] || 0);
	            }
	
	            return -((weightByType[item.get('type')] || 0) - (item.get('isNet') ? 5 : 0));
	        }
	    }], [{
	        key: 'fetchForCompany',
	        value: function fetchForCompany(company, integration) {
	            var nullItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var where = {
	                integrationId: integration.id
	            };
	
	            if (!nullItems) {
	                where.payrollItemId = { neq: null };
	            }
	
	            return new PayrollItemIntegrations(null, {
	                company: company,
	                pagination: false,
	                syncRemove: true
	            }).fetch({ filter: {
	                    where: where,
	                    order: '-createdAt',
	                    limit: 9999
	                } });
	        }
	    }, {
	        key: 'fetchPaymentAccountsForCompany',
	        value: function fetchPaymentAccountsForCompany(company, integration) {
	            return new PayrollItemIntegrations(null, {
	                company: company
	            }).fetch({ filter: {
	                    where: {
	                        integrationId: integration.id,
	                        payrollItemId: null,
	                        affects: { inq: ['employee', 'mtd', 'socso', 'epf', 'zakat', 'eis', 'hrdf'] }
	                    }
	                } });
	        }
	    }]);
	
	    return PayrollItemIntegrations;
	}(_collection2.default);
	
	exports.default = PayrollItemIntegrations;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Calendar = __webpack_require__(891);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _companyLocations = __webpack_require__(603);
	
	var _companyLocations2 = _interopRequireDefault(_companyLocations);
	
	var _companyLocation = __webpack_require__(574);
	
	var _companyLocation2 = _interopRequireDefault(_companyLocation);
	
	var _holidays = __webpack_require__(626);
	
	var _holidays2 = _interopRequireDefault(_holidays);
	
	var _Main = __webpack_require__(907);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Calendar2.default.extend({
	    initialize: function initialize() {
	        this.LeaveMainView = _Main2.default;
	        _Calendar2.default.prototype.initialize.apply(this, arguments);
	    },
	
	    _fetchCalendarData: function _fetchCalendarData(locationId) {
	        var locationPromise = locationId ? new _companyLocation2.default({ objectId: locationId }).fetch() : (0, _bluebird.resolve)(null);
	        return locationPromise.then(function (location) {
	            var holidayOptions = { company: app.company };
	            var employeeWhere = {};
	
	            if (location) {
	                employeeWhere.companyLocationId = location.id;
	                holidayOptions.location = location;
	            }
	
	            // Employees with companyLocationId set to null are considered
	            // to be in HQ
	            // NOTE this is a hack because of an issue in the staging
	            // database and PP1.0. Once fixed this block can be removed
	            if (location && location.get('primary')) {
	                employeeWhere = { or: [{
	                        hiddenAt: null,
	                        companyLocationId: location.id
	                    }, {
	                        hiddenAt: null,
	                        companyLocationId: null
	                    }] };
	            }
	
	            return (0, _bluebird.all)([new _employees2.default(null, {
	                company: app.company,
	                pagination: false
	            }).fetch({
	                filter: {
	                    where: employeeWhere,
	                    limit: 9999
	                },
	                validate: false
	            }), new _companyLocations2.default(null, {
	                company: app.company,
	                pagination: false
	            }).fetch({
	                filter: { where: { hiddenAt: null } }
	            }), new _holidays2.default(null, holidayOptions).fetch(), (0, _bluebird.resolve)(location)]);
	        }).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 4),
	                employees = _ref2[0],
	                locations = _ref2[1],
	                holidays = _ref2[2],
	                selectedLocation = _ref2[3];
	
	            var enabledHolidays = selectedLocation ? holidays.filter(function (h) {
	                return h._enabled;
	            }) : holidays;
	
	            return {
	                employees: employees,
	                locations: locations,
	                selectedLocation: selectedLocation,
	                holidays: enabledHolidays,
	                isEmployer: true
	            };
	        });
	    }
	});

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _leaveRequest2 = _interopRequireDefault(_leaveRequest);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alerts = __webpack_require__(529);
	var moment = __webpack_require__(101);
	var EmployerBaseRouter = __webpack_require__(625);
	var CalendarView = __webpack_require__(892);
	var loader = __webpack_require__(534);
	var LeaveRequestLayoutView = __webpack_require__(905);
	
	
	var log = (0, _log2.default)('commons/router/calendar');
	
	module.exports = EmployerBaseRouter.extend({
	    routes: {
	        'calendar/date/:date': 'calendarDate',
	        'calendar/add/:date': 'add',
	        'calendar/add': 'add',
	        'calendar/edit/:id': 'edit',
	        'calendar/:id/:action': 'calendarAction',
	        'calendar(/:locationId)': 'calendar',
	
	        // Backwards compatibility
	        'requestLeave/add': 'add',
	        'requestLeave/add/:date': 'add',
	        'requestLeave/edit/:id': 'edit'
	    },
	
	    titles: {
	        'calendar': 'Calendar',
	        'calendar/:date': 'Calendar',
	        'calendar/:id/:action': 'Calendar',
	        'calendar/add': 'Request Leave',
	        'calendar/add/:date': 'Request Leave',
	        'calendar/edit/:id': 'Request Leave',
	        'requestLeave/add': 'Request Leave',
	        'requestLeave/add/:date': 'Request Leave',
	        'requestLeave/edit/:id': 'Request Leave'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        EmployerBaseRouter.prototype.initialize.apply(this, [this.options]);
	    },
	
	    calendarDate: function calendarDate(date) {
	        this.calendar({
	            date: moment(date, 'DD-MM-YYYY')
	        });
	    },
	
	    calendarAction: function calendarAction(id, action) {
	        this.calendar({
	            id: id,
	            action: action
	        });
	    },
	
	    calendar: function calendar(arg) {
	        var options = typeof arg === 'string' ? {} : arg || {};
	        var locationId = app.user.isEmployee() && app.employee.companyLocation.id;
	
	        var stopLoader = loader.startFullPage(this.el);
	
	        this._fetchCalendarData(locationId).then(function () {
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                allEmployees = _ref.allEmployees,
	                employees = _ref.employees,
	                userEmployee = _ref.userEmployee,
	                locations = _ref.locations,
	                selectedLocation = _ref.selectedLocation,
	                holidays = _ref.holidays,
	                isEmployer = _ref.isEmployer,
	                collection = _ref.collection,
	                fetchMore = _ref.fetchMore,
	                layerMap = _ref.layerMap;
	
	            new CalendarView({
	                allEmployees: allEmployees,
	                employees: employees,
	                userEmployee: userEmployee,
	                locations: locations,
	                selectedLocation: selectedLocation,
	                holidays: holidays,
	                isEmployer: isEmployer,
	                collection: collection,
	                fetchMore: fetchMore,
	                layerMap: layerMap,
	                el: '#main-area'
	            }).render(options);
	        }).catch(function (err) {
	            log.error(err);
	            Alerts.show('criticalError', err);
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    _fetchCalendarData: function _fetchCalendarData() {
	        return (0, _bluebird.reject)('You must override this fn');
	    },
	
	    _fetchLeaveData: function _fetchLeaveData() {
	        var employees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        return employees.fetch({
	            filter: { where: { hiddenAt: null }, limit: 9999 },
	            validate: false
	        });
	    },
	
	    add: function add(date) {
	        var _this = this;
	
	        this.layout = new LeaveRequestLayoutView({
	            el: '#main-area',
	            MainView: this.LeaveMainView
	        });
	
	        this._fetchLeaveData().then(function (employees) {
	            /* TODO: at the moment employees and types are expected
	             to be arrays. Make them collections. */
	            var leaveRequest = new _leaveRequest2.default({
	                dateFromType: _leaveRequest.consts.DATE_TYPE_FULL_DAY,
	                dateToType: _leaveRequest.consts.DATE_TYPE_FULL_DAY
	            });
	            var leaveDays = app.company.get('leaveDays');
	            if (date) {
	                var m = moment(date, 'DD-MM-YYYY');
	                leaveRequest.set({
	                    'dateFrom': new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)),
	                    'dateTo': new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0))
	                });
	            }
	            var leaveTypes = app.leaveTypes.filter(function (type) {
	                var isHidden = type.get('hiddenAt');
	                var leaveDaysOf = leaveDays[type.id] || 0;
	                var companyId = type.get('companyId');
	                var unpaid = !type.get('paid');
	                var allCustomLeaveDays = leaveDaysOf >= 0 && companyId;
	                var entitledDefaultLeaveDays = leaveDaysOf > 0;
	                return !isHidden && (entitledDefaultLeaveDays || allCustomLeaveDays || unpaid);
	            });
	
	            _this.layout.renderContent({
	                employees: employees,
	                leaveRequest: leaveRequest,
	                leaveTypes: leaveTypes,
	                attachments: null
	            });
	        }).catch(function (err) {
	            log.error(err);
	            Alerts.show('criticalError', err);
	        }).finally(function () {
	            return _this.layout.hideLoader();
	        });
	    },
	
	    edit: function edit(id) {
	        var _this2 = this;
	
	        var employees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        var leaveRequest = new _leaveRequest2.default({ objectId: id });
	
	        this.layout = new LeaveRequestLayoutView({ el: this.el });
	
	        return (0, _bluebird.all)([leaveRequest.fetch(), employees.fetch({ filter: {
	                where: { hiddenAt: null },
	                limit: 9999
	            }, validate: false })]).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                leaveRequest = _ref3[0];
	
	            _this2.layout.renderContent({
	                employees: employees,
	                leaveRequest: leaveRequest,
	                leaveTypes: app.leaveTypes.models,
	                attachments: []
	            });
	        }).catch(function (err) {
	            log.error(err);
	            Alerts.show('criticalError', err);
	        }).finally(function () {
	            return _this2.layout.hideLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Calendar = __webpack_require__(893);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Birthday = __webpack_require__(894);
	
	var _Birthday2 = _interopRequireDefault(_Birthday);
	
	var _Event = __webpack_require__(895);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _LeaveRequestModal = __webpack_require__(896);
	
	var _LeaveRequestModal2 = _interopRequireDefault(_LeaveRequestModal);
	
	var _ActionLog = __webpack_require__(804);
	
	var _ActionLog2 = _interopRequireDefault(_ActionLog);
	
	var _CalendarList = __webpack_require__(901);
	
	var _CalendarList2 = _interopRequireDefault(_CalendarList);
	
	var _calendar = __webpack_require__(854);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _leaveRequests = __webpack_require__(752);
	
	var _leaveRequests2 = _interopRequireDefault(_leaveRequests);
	
	var _holidays = __webpack_require__(626);
	
	var _holidays2 = _interopRequireDefault(_holidays);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _leaveRequest2 = _interopRequireDefault(_leaveRequest);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// for reference: https://github.com/fullcalendar/fullcalendar/tree/9aa9e4400ac72d53362706927ac3c902c8544032
	__webpack_require__(904);
	
	module.exports = Backbone.View.extend({
	    leaveEvents: null,
	    leaveRequestModal: null,
	    selectedRegions: [],
	
	    events: {
	        'change .js-location-select': 'changeLocation',
	        'change .js-status-select': 'changeStatus',
	        'change .js-display-radio': 'changeDisplay'
	    },
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            statuses: _leaveRequest.statuses,
	            template: _Calendar2.default,
	            templateExtra: {}
	        }, options || {});
	        this.locations = options.locations;
	        this.location = app.user.isEmployee() ? app.employee.get('companyLocationId') : null;
	        this.holidays = this.location ? options.holidays.filter(function (_ref) {
	            var _enabled = _ref._enabled;
	            return _enabled;
	        }) : options.holidays;
	        this.status = null;
	        this.display = '1';
	        this.month = null;
	        this.leaveRequestModal = new _LeaveRequestModal2.default();
	        this.leaveRequestModal.on('update', function () {
	            if (this.$('.js-calendar.hidden-xs')) {
	                // means that actionLog is in display instead of calendar
	                this.render(this.options);
	            } else {
	                // 20200429 set location to null before another refetch of
	                // calendar data refetch (note that the leave requests don't get
	                // re-fetched)
	                this.location = null;
	                this.$calendar.fullCalendar('refetchEvents');
	            }
	        }.bind(this));
	    },
	
	    render: function render(options) {
	        var id = options.id;
	        var action = options.action;
	        var date = options.date;
	        this.$el.html((0, _Calendar2.default)(this.options));
	
	        this.$('.js-location-select').chosen({
	            width: '160px'
	        });
	
	        this.$calendar = this.$('.js-calendar');
	        this.initCalendar();
	
	        if (id && action) {
	            this.calendarAction(id, action);
	        } else if (date) {
	            this.$calendar.fullCalendar('gotoDate', date);
	        }
	
	        if (this.options.employees.length > 0) {
	            this.calendarListEvents();
	        }
	
	        if (this.options.collection) {
	            this.actionLog = new _ActionLog2.default({
	                collection: this.options.collection,
	                fetchMore: this.options.fetchMore,
	                layerMap: this.options.layerMap
	            });
	            this.$('.js-action-log').html(this.actionLog.render().el);
	        }
	
	        this.$('.js-display-radio[value="' + this.display + '"]').parent().addClass('active');
	
	        return this;
	    },
	
	    initCalendar: function initCalendar() {
	        //this.$calendar.fullCalendar('destroy');
	        this.$('.js-loader').show();
	        this.$calendar.fullCalendar({
	            header: {
	                left: 'prev,next today',
	                center: 'title',
	                right: ''
	            },
	            timezone: 'UTC',
	            aspectRatio: 2.5,
	            eventLimit: 4,
	            displayEventTime: false,
	            eventRender: this.calendarEventRender.bind(this),
	            eventAfterRender: this.calendarEventAfterRender.bind(this),
	            dayRender: this.calendarDayRender.bind(this),
	            dayClick: this.calendarDayClick.bind(this),
	            eventClick: this.calendarEventClick.bind(this),
	            eventMouseover: this.calendarEventMouseover,
	            events: this.calendarEvents.bind(this),
	            loading: function (isLoading) {
	                // Don't show loader if there are
	                // no employees assigned to location
	                if (isLoading && this.options.employees.length > 0) {
	                    this.$('.js-loader').show();
	                } else {
	                    this.$('.js-loader').hide();
	                }
	            }.bind(this)
	        });
	    },
	
	
	    changeLocation: function changeLocation(e) {
	        var _this = this;
	
	        new _holidays2.default(null, { location: e.target.value, companyId: app.company }).fetch().then(function (holidays) {
	            _this.location = e.target.value;
	            _this.holidays = _this.location ? holidays.filter(function (_ref2) {
	                var _enabled = _ref2._enabled;
	                return _enabled;
	            }) : holidays;
	            _this.$calendar.fullCalendar('prev');
	            _this.$calendar.fullCalendar('next');
	        });
	    },
	
	    changeStatus: function changeStatus(e) {
	        this.status = parseInt(e.target.value);
	        this.$calendar.fullCalendar('refetchEvents');
	        //this.initCalendar();
	    },
	
	    changeDisplay: function changeDisplay(e) {
	        var _this2 = this;
	
	        this.display = e.target.value;
	        this.$('.js-display-radio').each(function () {
	            $(_this2).parent().removeClass('active');
	        });
	        this.$(e.target).toggleClass('active');
	        this.$('.js-calendar-list').removeClass('hidden');
	
	        if (this.display === '2') {
	            this.$('.js-calendar .fc-view-container').hide();
	            this.$('.js-calendar .fc-view-container').addClass('hidden');
	        } else {
	            this.$('.js-calendar .fc-view-container').show();
	            this.$('.js-calendar .fc-view-container').removeClass('hidden');
	            this.$('.js-calendar-list').addClass('hidden');
	        }
	    },
	
	    calendarListEvents: function calendarListEvents() {
	        var _this3 = this;
	
	        this.month = (0, _moment2.default)(this.$calendar.fullCalendar('getDate'));
	        _leaveRequests2.default.fetchForCalendar({
	            employees: this.options.employees,
	            start: this.month.startOf('month').toDate(),
	            end: this.month.endOf('month').toDate(),
	            status: this.status,
	            location: this.location
	        }).then(function (leaveRequests) {
	            _this3.calendarList = new _CalendarList2.default({
	                leaveRequests: leaveRequests
	            });
	            _this3.$('.js-calendar-list').html(_this3.calendarList.render().el);
	        });
	    },
	
	    calendarEvents: function calendarEvents(start, end, timezone, callback) {
	        if (this.options.employees.length === 0) {
	            return callback || function () {};
	        }
	
	        this.calendarListEvents();
	        return _leaveRequests2.default.fetchForCalendar({
	            employees: this.options.employees,
	            start: start,
	            end: end,
	            status: this.status,
	            location: this.location
	        }).then(function (leaveRequests) {
	            callback(leaveRequests.asCalendarEvents());
	        });
	    },
	
	    calendarAction: function calendarAction(id, action) {
	        var _this4 = this;
	
	        var leaveRequest = new _leaveRequest2.default({ objectId: id });
	
	        return leaveRequest.fetch().then(function () {
	            return leaveRequest.fetchType();
	        }).then(function () {
	            return leaveRequest.fetchEmployee();
	        }).then(function (emp) {
	            if (!emp || !leaveRequest.getType()) {
	                return (0, _bluebird.reject)('Couldn\'t fetch data from server');
	            }
	
	            return emp.fetchLeaveApprovals();
	        }).then(function () {
	            _this4.calendarEventClick({ model: leaveRequest });
	            setTimeout(function () {
	                switch (action) {
	                    case 'reject':
	                        _this4.leaveRequestModal.$('.js-reject').click();
	                        break;
	                    case 'approve':
	                        _this4.leaveRequestModal.$('.js-approve').click();
	                        break;
	                }
	                _this4.$calendar.fullCalendar('gotoDate', (0, _moment2.default)(leaveRequest.get('dateFrom')));
	            }, 1000);
	            return true;
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        });
	    },
	
	    calendarDayClick: function calendarDayClick(date, ev) {
	        $(ev.target).tooltip('hide');
	        app.mainRouter.navigate('#calendar/add/' + date.format('DD-MM-YYYY'), { trigger: true });
	    },
	
	    calendarEventClick: function calendarEventClick(event) {
	        var _this5 = this;
	
	        var stopLoader = _loader2.default.startFullPage('.tab-content');
	        var leaveRequest = event.model;
	
	        leaveRequest.userEmployee = this.options.userEmployee;
	        leaveRequest.attachments = new _attachments2.default(null, { attachable: leaveRequest });
	
	        return leaveRequest.canBeCancelled().then(function (response) {
	            leaveRequest.isCancellable = response;
	        }).then(function () {
	            return leaveRequest.attachments.fetch();
	        }).then(function () {
	            _this5.leaveRequestModal.setModel(leaveRequest).render().show();
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    // Fix tooltip zindex issue
	    calendarEventMouseover: function calendarEventMouseover() {
	        $(this).closest('.fc-day-grid').find('.fc-row').css({ 'zIndex': 1 });
	        $(this).closest('.fc-row').css({ 'zIndex': 2 });
	    },
	
	    updateEvents: function updateEvents() {
	        this.leaveEvents = this.collection.asCalendarEvents();
	        this.$calendar.fullCalendar('rerenderEvents');
	    },
	
	    calendarEventRender: function calendarEventRender(event, $el, view) {
	        var leaveRequest = event.model;
	        var leaveRequestData = leaveRequest.asCalendarEvent();
	        var type = leaveRequest.getType();
	        var $content = $el.find('.fc-content');
	        $content.attr('data-employee', leaveRequest.getEmployee().get('fullName')).attr('data-dateFrom', leaveRequestData.start.format('YYYY-MM-DD')).attr('data-dateTo', leaveRequestData.end.format('YYYY-MM-DD')).attr('data-leaveType', type.get('name')).attr('data-status', leaveRequest.getStatusText());
	        var $employee = $('<strong>').addClass('fc-title').append(leaveRequest.getEmployee().get('fullName'));
	
	        if (leaveRequest.isCancelled()) {
	            return false;
	        }
	
	        if (view.isEventsRendered) {
	            this.calendarFixHalfEvent(event, $el, view, '50%');
	            this.calendarEventAfterRender(event, $el);
	        }
	
	        $content.html('').append($employee).append(' ' + type.get('name'));
	        if (type.get('color') && !leaveRequest.isAwaiting() && !leaveRequest.isRejected()) {
	            $el.css({ backgroundColor: type.get('color') });
	        }
	
	        $el.toggleClass('event-leave-awaiting', leaveRequest.isAwaiting());
	        $el.toggleClass('event-leave-rejected', leaveRequest.isRejected());
	        return $el;
	    },
	
	    calendarEventAfterRender: function calendarEventAfterRender(event, $el) {
	        var firstRow = $el.closest('.fc-row').is(':first-child');
	
	        $el.attr('data-toggle', 'tooltip').tooltip({
	            title: (0, _Event2.default)({
	                leaveRequest: event.model,
	                leaveType: event.model.getType()
	            }),
	            placement: firstRow ? 'bottom' : 'top',
	            html: true,
	            trigger: 'hover',
	            delay: { hide: 2000 }
	        });
	
	        this.calendarFixHalfEvent.apply(this, arguments);
	    },
	
	    calendarDayRender: function calendarDayRender(date, cell) {
	        var _this6 = this;
	
	        var location = this.location ? this.locations.find(function (_ref3) {
	            var id = _ref3.id;
	            return id === _this6.location;
	        }) : null;
	        var workload = _calendar2.default.getDayWorkLoad(cell, location);
	
	        if (workload === 0) {
	            cell.addClass('day-off');
	        } else if (workload === 0.5) {
	            cell.addClass('half-day');
	        }
	
	        _calendar2.default.renderHoliday(this.holidays, date, cell);
	
	        this.calendarBirthdaysRender(date, cell);
	    },
	
	    calendarBirthdaysRender: function calendarBirthdaysRender(date, cell) {
	        if (!app.company.get('showBirthdaysInCalendar')) {
	            return false;
	        }
	
	        var employees = this.options.employees.filter(function (employee) {
	            return (0, _moment2.default)(employee.get('dob')).format('MMDD') === (0, _moment2.default)(date).format('MMDD');
	        });
	        var $tooltip;
	
	        var activeEmployees = employees.filter(function (emp) {
	            return emp.get('hiddenAt') === null || emp.get('hiddenAt') === undefined;
	        });
	        if (activeEmployees.length === 0) {
	            return;
	        }
	        $tooltip = (0, _Birthday2.default)({
	            header: activeEmployees.length === 1 ? 'Birthday' : 'Birthdays',
	            description: _.map(activeEmployees, function (employee) {
	                return employee.get('fullName');
	            }).join(', ')
	        });
	
	        this.$(cell).append($tooltip).find('[data-toggle=tooltip]').tooltip();
	    },
	
	    calendarFixHalfEvent: function calendarFixHalfEvent(event, $el, view, offset) {
	        var leaveRequest = event.model;
	
	        if (!offset) {
	            offset = 50 / ($el.parent().attr('colspan') || 1) + '%';
	        }
	
	        if (leaveRequest.dateFromIsMorning() && !leaveRequest.get('dateTo') && $el.hasClass('fc-start')) {
	            $el.css('margin-right', offset);
	        }
	
	        if (leaveRequest.dateFromIsAfternoon() && $el.hasClass('fc-start')) {
	            $el.css('margin-left', offset);
	        }
	
	        if (leaveRequest.dateToIsMorning() && $el.hasClass('fc-end')) {
	            $el.css('margin-right', offset);
	        }
	    },
	
	    remove: function remove() {
	        this.leaveRequestModal.remove();
	        this.undelegateEvents();
	        return Backbone.View.prototype.remove.apply(this, arguments);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14), __webpack_require__(27)))

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/calendar/Calendar.ejs -->\n<div class="js-content wrapper wrapper-content calendar">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <div class="row">\n                        <div class="col-xs-3">\n                            <h3>Leave</h3>\n                        </div>\n\n                        <div class="col-xs-9 visible-xs text-right">\n                            <a href="#calendar/add" class="btn btn-w-m btn-primary">\n                                <i class="fa fa-plus-circle"></i> Leave\n                            </a>\n                        </div>\n                        <div class="col-xs-9 hidden-xs">\n                            <div class="row">\n                                <div class="col-xs-3 pull-right">\n                                    <div class="btn-group btn-group-justified" data-toggle="buttons">\n                                        <label class="btn btn-default">\n                                            <input type="radio" name="display"\n                                                class="js-display-radio" value="1"> Calendar\n                                        </label>\n                                        <label class="btn btn-default">\n                                            <input type="radio" name="display"\n                                                class="js-display-radio" value="2"> List\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="ibox-content">\n                    <div class="js-loader loader hidden-xs">\n                        '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                    </div>\n\n                    <div class="row hidden-xs">\n                        <div class="col-md-10">\n                            <div class="col-md-4">\n                                <div class="form-group location-switch">\n                                    <label class="form-label">Location</label>\n\n                                    <select name="location" class="js-location-select"\n                                    >\n                                        <option value="" '+
	((__t=( (!selectedLocation) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                            All\n                                        </option>\n                                        ';
	 _(locations.models || locations).each(function (location) { 
	__p+='\n                                            <option value="'+
	((__t=( location.id ))==null?'':_.escape(__t))+
	'"\n                                                '+
	((__t=( (selectedLocation && selectedLocation.id === location.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                                                '+
	((__t=( location.get('name') ))==null?'':_.escape(__t))+
	'\n                                            </option>\n                                        ';
	 }); 
	__p+='\n                                    </select>\n                                </div>\n                            </div>\n                            <div class="col-md-4 form-inline">\n                                <div class="form-group">\n                                    <label class="form-label">Status</label>\n\n                                    <select name="status" class="js-status-select form-control is-rounded">\n                                        <option value="">\n                                            All\n                                        </option>\n\n                                        ';
	 Object.keys(statuses).forEach(function (status) { 
	__p+='\n                                            <option value="'+
	((__t=( status ))==null?'':_.escape(__t))+
	'">\n                                                '+
	((__t=( statuses[status] ))==null?'':_.escape(__t))+
	'\n                                            </option>\n                                        ';
	 }); 
	__p+='\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class="col-md-2">\n                            <div class="form-group float-right">\n                                <a href="#calendar/add" class="btn btn-w-m btn-primary">\n                                    Apply Leave\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="js-calendar hidden-xs"></div>\n                    <div class="js-calendar-list hidden hidden-xs"></div>\n                    ';
	 if (!isEmployer) { 
	__p+='\n                        <div class="js-action-log visible-xs"></div>\n                    ';
	 } 
	__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/calendar/Birthday.ejs -->\n<i class="fa fa-star" data-toggle="tooltip" data-placement="top"\n    data-html="true"  data-container="body" data-title="\n        <div class=\'tooltip-birthday\\\'>\n            <div class=\'tooltip-header\'>'+
	((__t=( header ))==null?'':_.escape(__t))+
	'</div>\n            <div class=\'tooltip-description\'>'+
	((__t=( description ))==null?'':_.escape(__t))+
	'</div>\n        </div>">\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/calendar/Event.ejs -->\n<div class="tooltip-event">\n    <div class="tooltip-header">\n        '+
	((__t=( leaveRequest.getEmployee().get('fullName') ))==null?'':_.escape(__t))+
	'\n    </div>\n    <div class="tooltip-description">\n        <div>'+
	((__t=( leaveType.get('name') ))==null?'':_.escape(__t))+
	'</div>\n        <div>\n            ';
	 var approvedBy = leaveRequest.get('employeeApprovedByName') 
	__p+='\n            ';
	 var approvedByL2 = leaveRequest.get('employeeApprovedByNameL2') 
	__p+='\n            ';
	 var approvedByL3 = leaveRequest.get('employeeApprovedByNameL3') 
	__p+='\n            ';
	 var layer1Label = approvedByL2 ? 'Approved By (Layer 1):' : 'Approved By:' 
	__p+='\n            ';
	 var layer2Label = app.company.get('contactName') !== approvedByL2 ? 'Approved By (Layer 2):' : 'Approved By:' 
	__p+='\n            ';
	 var layer3Label = app.company.get('contactName') !== approvedByL3 ? 'Approved By (Layer 3):' : 'Approved By:' 
	__p+='\n\n            ';
	 if (leaveRequest.isAwaiting()) { 
	__p+='\n                Awaiting Approval\n            ';
	 } else if (leaveRequest.isApproved()) { 
	__p+='\n                '+
	((__t=( layer1Label ))==null?'':_.escape(__t))+
	'\n                '+
	((__t=( approvedBy || '-' ))==null?'':_.escape(__t))+
	'\n            ';
	 } else if (leaveRequest.isRejected()) { 
	__p+='\n                Rejected By:\n                '+
	((__t=( leaveRequest.get('rejectedByName') || '-' ))==null?'':_.escape(__t))+
	'\n            ';
	 } else if (leaveRequest.isCancelled()) { 
	__p+='\n                Cancelled By:\n                '+
	((__t=( leaveRequest.get('canceledByName') || '-' ))==null?'':_.escape(__t))+
	'\n            ';
	 } 
	__p+='\n        </div>\n        ';
	 if (leaveRequest.isApproved()) { 
	__p+='\n            ';
	 if (approvedByL2) { 
	__p+='\n                <div>\n                    '+
	((__t=( layer2Label ))==null?'':_.escape(__t))+
	'\n                    '+
	((__t=( approvedByL2 ))==null?'':_.escape(__t))+
	'\n                </div>\n            ';
	 } 
	__p+='\n            ';
	 if (approvedByL3) { 
	__p+='\n                <div>\n                    '+
	((__t=( layer3Label ))==null?'':_.escape(__t))+
	'\n                    '+
	((__t=( approvedByL3 ))==null?'':_.escape(__t))+
	'\n                </div>\n            ';
	 } 
	__p+='\n        ';
	 } else if (leaveRequest.hasApprovals() && !leaveRequest.isApproved()) { 
	__p+='\n            <div>\n                Approved By (Layer 1):\n                '+
	((__t=( approvedBy || '-' ))==null?'':_.escape(__t))+
	'\n            </div>\n            ';
	 if (approvedByL2) { 
	__p+='\n                <div>\n                    Approved By (Layer 2):\n                    '+
	((__t=( approvedByL2 ))==null?'':_.escape(__t))+
	'\n                </div>\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _LeaveRequestModal = __webpack_require__(897);
	
	var _LeaveRequestModal2 = _interopRequireDefault(_LeaveRequestModal);
	
	var _Rejection = __webpack_require__(898);
	
	var _Rejection2 = _interopRequireDefault(_Rejection);
	
	var _Cancelation = __webpack_require__(899);
	
	var _Cancelation2 = _interopRequireDefault(_Cancelation);
	
	var _Awaiting = __webpack_require__(900);
	
	var _Awaiting2 = _interopRequireDefault(_Awaiting);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ModalForm2.default.extend({
	    events: function events() {
	        return Object.assign({}, _ModalForm2.default.prototype.events(), {
	            'click .js-cancel-leave': 'cancelLeave',
	            'click .js-reject': 'reject',
	            'click .js-approve': 'approve',
	            'click .js-reject-submit': 'rejectSubmit',
	            'click .js-reject-cancel': 'rejectCancel'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = Object.assign({
	            template: _LeaveRequestModal2.default,
	            templateExtra: {}
	        }, options || {});
	        return _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    setModel: function setModel(model) {
	        var canCancel = function () {
	            var iAmManager = model.userEmployee && model.getEmployee() && model.getEmployee().isManagedBy(model.userEmployee);
	
	            // Employee himself
	            if (!iAmManager && app.user.get('role') === 'employee' && model.isAwaiting()) {
	                return true;
	            }
	
	            // Employer
	            if (app.user.get('role') !== 'employee' && model.isCancellable && !model.isAwaiting()) {
	                return true;
	            }
	
	            // Manager
	            if (iAmManager && !model.isAwaiting()) {
	                return true;
	            }
	
	            return false;
	        }();
	
	        var canApprove = function () {
	            if (!model.isAwaiting()) {
	                return false;
	            }
	            if (app.user.get('role') !== 'employee') {
	                return true;
	            }
	            if (model.userEmployee && model.getEmployee() && model.getEmployee().isManagedBy(model.userEmployee) && model.getEmployee().getApprovalLayer(model.userEmployee) > (model.get('approvalStatus') || 0)) {
	                return true;
	            }
	        }();
	
	        Object.assign(this.options.templateExtra, {
	            leaveType: model.getType(),
	            isCancellable: model.isCancellable,
	            daysAllowed: 2,
	            period: this.getPeriod(model),
	            isEmployee: app.user.get('role') === 'employee',
	            canCancel: canCancel,
	            canApprove: canApprove
	        });
	
	        return _ModalForm2.default.prototype.setModel.apply(this, arguments);
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var statusMessage = false;
	        if (this.model.isRejected()) {
	            statusMessage = (0, _Rejection2.default)({ model: this.model });
	        }
	
	        if (this.model.isCancelled()) {
	            statusMessage = (0, _Cancelation2.default)({ model: this.model });
	        }
	
	        if (this.model.isAwaiting()) {
	            statusMessage = (0, _Awaiting2.default)({ model: this.model });
	        }
	
	        this.options.templateExtra.statusMessage = statusMessage;
	
	        this.model.fetchDaysAllowed().then(function (days) {
	            _this.renderDaysAllowed(days);
	        });
	
	        return _ModalForm2.default.prototype.render.apply(this, arguments);
	    },
	
	    renderDaysAllowed: function renderDaysAllowed(days) {
	        this.$('.js-allowed').text(days);
	        this.$('.js-allowed-label').text((days > 0 ? 'days' : '') + ' allowed');
	    },
	
	    cancelLeave: function cancelLeave() {
	        var _this2 = this;
	
	        this.hide();
	
	        _alerts2.default.show('dangerConfirm', {
	            text: 'You will not be able to recover this leave.',
	            loader: true,
	            callback: function callback(isConfirm) {
	                if (!isConfirm) {
	                    return;
	                }
	
	                _this2.model.cancel().then(function () {
	                    _this2.trigger('update');
	
	                    _alerts2.default.show('success', {
	                        title: 'Leave Cancelled',
	                        text: 'The leave has been cancelled'
	                    });
	                }).catch(function (err) {
	                    _alerts2.default.show('criticalError', err);
	                });
	            }
	        });
	    },
	
	    approve: function approve() {
	        var _this3 = this;
	
	        var stopLoader = _loader2.default.startFullScreen(this.$('.js-approve'));
	        this.model.approve().then(function () {
	            _this3.trigger('update');
	
	            _alerts2.default.show('success', {
	                title: 'Leave Approved',
	                text: 'The leave has been approved'
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            _this3.hide();
	            stopLoader();
	        });
	    },
	
	    reject: function reject() {
	        this.$('.modal-body.js-leave').hide();
	        this.$('.modal-body.js-leave-reject').fadeIn(200);
	        this.$('textarea.js-reason').focus();
	        return false;
	    },
	
	    rejectCancel: function rejectCancel() {
	        this.$('.modal-body.js-leave').fadeIn(200);
	        this.$('.modal-body.js-leave-reject').hide();
	        return false;
	    },
	
	    rejectSubmit: function rejectSubmit() {
	        var _this4 = this;
	
	        var rejectReason = this.$('.js-reason').val();
	        var stopLoader = _loader2.default.startFullScreen(this.$('.js-submit'));
	
	        this.model.set({
	            status: _leaveRequest.consts.STATUS_REJECTED,
	            rejectReason: rejectReason
	        });
	
	        this.model.save().then(function () {
	            _this4.trigger('update');
	            _this4.$('.js-reject-modal').off('hidden.bs.modal');
	
	            _alerts2.default.show('success', {
	                title: 'Leave Rejected',
	                text: 'The leave has been rejected'
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            _this4.hide();
	            stopLoader();
	        });
	    },
	
	    getPeriod: function getPeriod(model) {
	        model = model || this.model;
	
	        if (!model.get('dateTo') || this.getDateFromFormatted(model) === this.getDateToFormatted(model)) {
	            return _moment2.default.utc(model.get('dateFrom')).format('D MMM YYYY');
	        }
	
	        return this.getDateFromFormatted(model) + ' to ' + this.getDateToFormatted(model);
	    },
	
	    getDateFromFormatted: function getDateFromFormatted(model) {
	        return this.getDateFormatted('dateFrom', model);
	    },
	
	    getDateToFormatted: function getDateToFormatted(model) {
	        return this.getDateFormatted('dateTo', model);
	    },
	
	    getDateFormatted: function getDateFormatted(attr, model) {
	        var r = '';
	
	        model = model || this.model;
	
	        if (!model.has(attr) && !model.get(attr)) {
	            return r;
	        }
	
	        if (model[attr + 'IsMorning']()) {
	            r += 'Morning of ';
	        }
	
	        if (model[attr + 'IsAfternoon']()) {
	            r += 'Afternoon of ';
	        }
	
	        return r + _moment2.default.utc(model.get(attr)).format('D MMM YYYY');
	    }
	});

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/LeaveRequestModal.ejs -->\n<div class="modal-dialog modal-leave-request">\n<div class="modal-content animated sweet">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal">\n            <span aria-hidden="true">×</span>\n            <span class="sr-only">Close</span>\n        </button>\n        <div class="modal-title">\n            '+
	((__t=( model.getEmployee().get('fullName') ))==null?'':_.escape(__t))+
	'\n        </div>\n    </div>\n    <div class="modal-body js-leave">\n        <h3>'+
	((__t=( leaveType.get('name') ))==null?'':_.escape(__t))+
	'</h3>\n        <div class="period">'+
	((__t=( period ))==null?'':_.escape(__t))+
	'</div>\n\n        ';
	 if (model.attachments.length) { 
	__p+='\n            <div class="attachments '+
	((__t=( model.attachments.length ? '' : 'hidden' ))==null?'':_.escape(__t))+
	'">\n                ';
	 model.attachments.each(function(attachment) { 
	__p+='\n                    <a href="'+
	((__t=( attachment.downloadUrl() ))==null?'':_.escape(__t))+
	'"\n                        target="_blank">\n                        <i class="fa fa-file"></i>\n                        '+
	((__t=( attachment.get('name') ))==null?'':_.escape(__t))+
	'\n                    </a>\n                ';
	 }); 
	__p+='\n                <hr>\n            </div>\n        ';
	 } 
	__p+='\n\n        <div class="row row-days">\n            <div class="'+
	((__t=((canApprove && leaveType.get('name') !== 'Unpaid Leave') ? 'col-sm-6' : 'col-sm-12' ))==null?'':_.escape(__t))+
	' text-center">\n                <div class="days">'+
	((__t=( model.get('daysRequired') ))==null?'':_.escape(__t))+
	'</div>\n                <div>'+
	((__t=( (model.get('daysRequired') > 1) ? 'days' : 'day' ))==null?'':_.escape(__t))+
	'\n                    required</div>\n            </div>\n            ';
	 if (canApprove && leaveType.get('name') !== 'Unpaid Leave') { 
	__p+='\n            <div class="col-sm-6 text-center">\n                <div class="days js-allowed"></div>\n                <div class="js-allowed-label">'+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'</div>\n            </div>\n            ';
	 } 
	__p+='\n        </div>\n\n        ';
	 if (model.get('reason')) { 
	__p+='\n            <hr />\n            <div class="row">\n                <div class="col-sm-12 text-center">\n                    '+
	((__t=( model.get('reason') ))==null?'':_.escape(__t))+
	'\n                </div>\n            </div>\n        ';
	 } 
	__p+='\n\n        ';
	 if (statusMessage) { 
	__p+='\n            <hr>\n            '+
	((__t=( statusMessage ))==null?'':__t)+
	'\n        ';
	 } 
	__p+='\n\n        ';
	 if (isCancellable || canCancel || canApprove) { 
	__p+='\n            <hr>\n            <div class="text-center">\n                ';
	 if (isCancellable && canCancel) { 
	__p+='\n                    <button type="button" class="js-cancel-leave btn btn-danger\n                        btn-w-m btn-lg">\n                        Remove Leave\n                    </button>\n                ';
	 } 
	__p+='\n\n                ';
	 if (canApprove) { 
	__p+='\n                    <button type="button" class="js-reject btn btn-danger\n                        btn-w-m btn-lg">\n                        Reject\n                    </button>\n                    <button type="button" class="js-approve btn btn-primary\n                        btn-w-m btn-lg m-l">\n                        Approve\n                    </button>\n                ';
	 } 
	__p+='\n            </div>\n        ';
	 } 
	__p+='\n\n        ';
	 if (!isCancellable && !model.isAwaiting() && !model.isCancelled()) { 
	__p+='\n            <hr>\n            <div class="text-center">\n                Cannot be cancelled as payroll for this '+
	((__t=( leaveType.get('name').toLowerCase() ))==null?'':_.escape(__t))+
	'\n                has already been run\n            </div>\n        ';
	 } 
	__p+='\n\n        ';
	 if (isCancellable && !canCancel && !canApprove) { 
	__p+='\n            <div class="row">\n                <div class="col-sm-12 text-center">\n                    <i>Note: This leave cannot be removed by you</i>\n                </div>\n            </div>\n        ';
	 } 
	__p+='\n    </div>\n\n    ';
	 if (canApprove) { 
	__p+='\n        <div class="modal-body js-leave-reject" style="display: none">\n            <h2>Enter reject reason:</h2>\n            <textarea class="js-reason form-control" rows="4"></textarea>\n            <div class="text-center m-b-md">\n                <button type="button" class="js-reject-cancel btn btn-default\n                    btn-w-m btn-lg">\n                    Cancel &amp; Back\n                </button>\n                <button type="button" class="js-reject-submit btn btn-success\n                    btn-w-m btn-lg m-l">\n                    Submit\n                </button>\n            </div>\n        </div>\n    ';
	 } 
	__p+='\n</div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/LeaveRequestModal/Rejection.ejs -->\n<strong>Reject reason:</strong>\n<div class="row">\n    <div class="col-sm-12 text-center">\n        '+
	((__t=( model.get('rejectReason') || '-' ))==null?'':_.escape(__t))+
	'\n    </div>\n</div>\n<hr/>\n<div>\n    <strong>Rejected by:\n        '+
	((__t=( model.get('rejectedByName') || '-' ))==null?'':_.escape(__t))+
	'\n    </strong>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/LeaveRequestModal/Cancelation.ejs -->\n<div>\n    <strong>Cancelled by:\n        '+
	((__t=( model.get('canceledByName') || '-' ))==null?'':_.escape(__t))+
	'\n    </strong>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/LeaveRequestModal/Awaiting.ejs -->\n<div class="text-center"><strong>Awaiting approval</strong></div>\n';
	}
	return __p;
	};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _CalendarList = __webpack_require__(902);
	
	var _CalendarList2 = _interopRequireDefault(_CalendarList);
	
	var _CalendarListRow = __webpack_require__(903);
	
	var _CalendarListRow2 = _interopRequireDefault(_CalendarListRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tabName: 'div',
	    leaveRequestModal: null,
	
	    initialize: function initialize(options) {
	        this.leaveRequests = options.leaveRequests;
	    },
	
	    render: function render() {
	        this.$el.html((0, _CalendarList2.default)({
	            leaveRequests: this.leaveRequests,
	            RowTpl: _CalendarListRow2.default,
	            limit: this.limit
	        }));
	        this.appendleaveRequests(this.leaveRequests);
	        return this;
	    },
	
	    appendleaveRequests: function appendleaveRequests(leaveRequests) {
	        var _this = this;
	
	        var promises = leaveRequests.map(function (leaveRequest) {
	            return leaveRequest.fetchEmployee().then(function (employee) {
	                return (0, _bluebird.all)([employee.fetchCompanyLocation(), employee.fetchPosition()]).then(function () {
	                    return employee;
	                });
	            }).then(function () {
	                return leaveRequest;
	            });
	        });
	        (0, _bluebird.each)(promises, function (leaveRequest) {
	            _this.$('tbody').append((0, _CalendarListRow2.default)({
	                leaveRequest: leaveRequest
	            }));
	            return (0, _bluebird.resolve)(true);
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/calendar/CalendarList.ejs -->\n<div class="calendar-list">\n    <table class="footable table table-striped">\n        <thead>\n            <tr>\n                <th>Location</th>\n                <th width="35%">Name</th>\n                <th>Leave type</th>\n                <th>Leave start</th>\n                <th>Leave end</th>\n                <th>Status</th>\n            </tr>\n        </thead>\n        <tbody>\n            ';
	 if (leaveRequests.length === 0) { 
	__p+='\n                <tr class="table-no-entries">\n                    <td colspan="6">\n                        <h2>There are currently no leave requested</h2>\n                    </td>\n                </tr>\n            ';
	 } 
	__p+='\n        </tbody>\n    </table>\n</div>\n\n';
	}
	return __p;
	};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/calendar/CalendarListRow.ejs -->\n';
	
	    var employee = leaveRequest.getEmployee();
	    var leaveType = leaveRequest.getType();
	
	__p+='\n<tr class="is-clickable" onclick="document.location = \''+
	((__t=( leaveRequest.getLink() ))==null?'':_.escape(__t))+
	'\';">\n    <td data-cy="location">'+
	((__t=( employee.getCompanyLocationName() ))==null?'':_.escape(__t))+
	'</td>\n    <td data-cy="employeeName">'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</td>\n    <td data-cy="leaveType">'+
	((__t=( leaveType.get('name') ))==null?'':_.escape(__t))+
	'</td>\n    <td data-cy="leaveStartDate">'+
	((__t=( leaveRequest.getFormattedDateFrom() ))==null?'':_.escape(__t))+
	'</td>\n    <td data-cy="leaveEndDate">'+
	((__t=( leaveRequest.getFormattedDateTo() ))==null?'':_.escape(__t))+
	'</td>\n    <td data-cy="leaveStatus" class="text-bold '+
	((__t=( leaveRequest.getStatusColor() ))==null?'':_.escape(__t))+
	'">'+
	((__t=( leaveRequest.getStatusText() ))==null?'':_.escape(__t))+
	'</td>\n</tr>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * <%= meta.title %> v<%= meta.version %>
	 * Docs & License: <%= meta.homepage %>
	 * (c) <%= meta.copyright %>
	 */
	
	(function(factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(14), __webpack_require__(101) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof exports === 'object') { // Node/CommonJS
			module.exports = factory(require('jquery'), require('moment'));
		}
		else {
			factory(jQuery, moment);
		}
	})(function($, moment) {
	
	;;
	
	var FC = $.fullCalendar = {
		version: "<%= meta.version %>",
		internalApiVersion: 5
	};
	var fcViews = FC.views = {};
	
	
	$.fn.fullCalendar = function(options) {
		var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
		var res = this; // what this function will return (this jQuery object by default)
	
		this.each(function(i, _element) { // loop each DOM element involved
			var element = $(_element);
			var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
			var singleRes; // the returned value of this single method call
	
			// a method call
			if (typeof options === 'string') {
				if (calendar && $.isFunction(calendar[options])) {
					singleRes = calendar[options].apply(calendar, args);
					if (!i) {
						res = singleRes; // record the first method call result
					}
					if (options === 'destroy') { // for the destroy method, must remove Calendar object data
						element.removeData('fullCalendar');
					}
				}
			}
			// a new calendar initialization
			else if (!calendar) { // don't initialize twice
				calendar = new Calendar(element, options);
				element.data('fullCalendar', calendar);
				calendar.render();
			}
		});
		
		return res;
	};
	
	
	var complexOptions = [ // names of options that are objects whose properties should be combined
		'header',
		'buttonText',
		'buttonIcons',
		'themeButtonIcons'
	];
	
	
	// Merges an array of option objects into a single object
	function mergeOptions(optionObjs) {
		return mergeProps(optionObjs, complexOptions);
	}
	
	
	// Given options specified for the calendar's constructor, massages any legacy options into a non-legacy form.
	// Converts View-Option-Hashes into the View-Specific-Options format.
	function massageOverrides(input) {
		var overrides = { views: input.views || {} }; // the output. ensure a `views` hash
		var subObj;
	
		// iterate through all option override properties (except `views`)
		$.each(input, function(name, val) {
			if (name != 'views') {
	
				// could the value be a legacy View-Option-Hash?
				if (
					$.isPlainObject(val) &&
					!/(time|duration|interval)$/i.test(name) && // exclude duration options. might be given as objects
					$.inArray(name, complexOptions) == -1 // complex options aren't allowed to be View-Option-Hashes
				) {
					subObj = null;
	
					// iterate through the properties of this possible View-Option-Hash value
					$.each(val, function(subName, subVal) {
	
						// is the property targeting a view?
						if (/^(month|week|day|default|basic(Week|Day)?|agenda(Week|Day)?)$/.test(subName)) {
							if (!overrides.views[subName]) { // ensure the view-target entry exists
								overrides.views[subName] = {};
							}
							overrides.views[subName][name] = subVal; // record the value in the `views` object
						}
						else { // a non-View-Option-Hash property
							if (!subObj) {
								subObj = {};
							}
							subObj[subName] = subVal; // accumulate these unrelated values for later
						}
					});
	
					if (subObj) { // non-View-Option-Hash properties? transfer them as-is
						overrides[name] = subObj;
					}
				}
				else {
					overrides[name] = val; // transfer normal options as-is
				}
			}
		});
	
		return overrides;
	}
	
	;;
	
	// exports
	FC.intersectRanges = intersectRanges;
	FC.applyAll = applyAll;
	FC.debounce = debounce;
	FC.isInt = isInt;
	FC.htmlEscape = htmlEscape;
	FC.cssToStr = cssToStr;
	FC.proxy = proxy;
	FC.capitaliseFirstLetter = capitaliseFirstLetter;
	
	
	/* FullCalendar-specific DOM Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	
	// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
	// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
	function compensateScroll(rowEls, scrollbarWidths) {
		if (scrollbarWidths.left) {
			rowEls.css({
				'border-left-width': 1,
				'margin-left': scrollbarWidths.left - 1
			});
		}
		if (scrollbarWidths.right) {
			rowEls.css({
				'border-right-width': 1,
				'margin-right': scrollbarWidths.right - 1
			});
		}
	}
	
	
	// Undoes compensateScroll and restores all borders/margins
	function uncompensateScroll(rowEls) {
		rowEls.css({
			'margin-left': '',
			'margin-right': '',
			'border-left-width': '',
			'border-right-width': ''
		});
	}
	
	
	// Make the mouse cursor express that an event is not allowed in the current area
	function disableCursor() {
		$('body').addClass('fc-not-allowed');
	}
	
	
	// Returns the mouse cursor to its original look
	function enableCursor() {
		$('body').removeClass('fc-not-allowed');
	}
	
	
	// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
	// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
	// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and 
	// reduces the available height.
	function distributeHeight(els, availableHeight, shouldRedistribute) {
	
		// *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
		// and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
	
		var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
		var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
		var flexEls = []; // elements that are allowed to expand. array of DOM nodes
		var flexOffsets = []; // amount of vertical space it takes up
		var flexHeights = []; // actual css height
		var usedHeight = 0;
	
		undistributeHeight(els); // give all elements their natural height
	
		// find elements that are below the recommended height (expandable).
		// important to query for heights in a single first pass (to avoid reflow oscillation).
		els.each(function(i, el) {
			var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
			var naturalOffset = $(el).outerHeight(true);
	
			if (naturalOffset < minOffset) {
				flexEls.push(el);
				flexOffsets.push(naturalOffset);
				flexHeights.push($(el).height());
			}
			else {
				// this element stretches past recommended height (non-expandable). mark the space as occupied.
				usedHeight += naturalOffset;
			}
		});
	
		// readjust the recommended height to only consider the height available to non-maxed-out rows.
		if (shouldRedistribute) {
			availableHeight -= usedHeight;
			minOffset1 = Math.floor(availableHeight / flexEls.length);
			minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
		}
	
		// assign heights to all expandable elements
		$(flexEls).each(function(i, el) {
			var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
			var naturalOffset = flexOffsets[i];
			var naturalHeight = flexHeights[i];
			var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
	
			if (naturalOffset < minOffset) { // we check this again because redistribution might have changed things
				$(el).height(newHeight);
			}
		});
	}
	
	
	// Undoes distrubuteHeight, restoring all els to their natural height
	function undistributeHeight(els) {
		els.height('');
	}
	
	
	// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
	// cells to be that width.
	// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
	function matchCellWidths(els) {
		var maxInnerWidth = 0;
	
		els.find('> span').each(function(i, innerEl) {
			var innerWidth = $(innerEl).outerWidth();
			if (innerWidth > maxInnerWidth) {
				maxInnerWidth = innerWidth;
			}
		});
	
		maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
	
		els.width(maxInnerWidth);
	
		return maxInnerWidth;
	}
	
	
	// Given one element that resides inside another,
	// Subtracts the height of the inner element from the outer element.
	function subtractInnerElHeight(outerEl, innerEl) {
		var both = outerEl.add(innerEl);
		var diff;
	
		// effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
		both.css({
			position: 'relative', // cause a reflow, which will force fresh dimension recalculation
			left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
		});
		diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
		both.css({ position: '', left: '' }); // undo hack
	
		return diff;
	}
	
	
	/* Element Geom Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.getOuterRect = getOuterRect;
	FC.getClientRect = getClientRect;
	FC.getContentRect = getContentRect;
	FC.getScrollbarWidths = getScrollbarWidths;
	
	
	// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
	function getScrollParent(el) {
		var position = el.css('position'),
			scrollParent = el.parents().filter(function() {
				var parent = $(this);
				return (/(auto|scroll)/).test(
					parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x')
				);
			}).eq(0);
	
		return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
	}
	
	
	// Queries the outer bounding area of a jQuery element.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getOuterRect(el, origin) {
		var offset = el.offset();
		var left = offset.left - (origin ? origin.left : 0);
		var top = offset.top - (origin ? origin.top : 0);
	
		return {
			left: left,
			right: left + el.outerWidth(),
			top: top,
			bottom: top + el.outerHeight()
		};
	}
	
	
	// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getClientRect(el, origin) {
		var offset = el.offset();
		var scrollbarWidths = getScrollbarWidths(el);
		var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
		var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);
	
		return {
			left: left,
			right: left + el[0].clientWidth, // clientWidth includes padding but NOT scrollbars
			top: top,
			bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
		};
	}
	
	
	// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getContentRect(el, origin) {
		var offset = el.offset(); // just outside of border, margin not included
		var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
			(origin ? origin.left : 0);
		var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
			(origin ? origin.top : 0);
	
		return {
			left: left,
			right: left + el.width(),
			top: top,
			bottom: top + el.height()
		};
	}
	
	
	// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getScrollbarWidths(el) {
		var leftRightWidth = el.innerWidth() - el[0].clientWidth; // the paddings cancel out, leaving the scrollbars
		var widths = {
			left: 0,
			right: 0,
			top: 0,
			bottom: el.innerHeight() - el[0].clientHeight // the paddings cancel out, leaving the bottom scrollbar
		};
	
		if (getIsLeftRtlScrollbars() && el.css('direction') == 'rtl') { // is the scrollbar on the left side?
			widths.left = leftRightWidth;
		}
		else {
			widths.right = leftRightWidth;
		}
	
		return widths;
	}
	
	
	// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
	
	var _isLeftRtlScrollbars = null;
	
	function getIsLeftRtlScrollbars() { // responsible for caching the computation
		if (_isLeftRtlScrollbars === null) {
			_isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
		}
		return _isLeftRtlScrollbars;
	}
	
	function computeIsLeftRtlScrollbars() { // creates an offscreen test element, then removes it
		var el = $('<div><div/></div>')
			.css({
				position: 'absolute',
				top: -1000,
				left: 0,
				border: 0,
				padding: 0,
				overflow: 'scroll',
				direction: 'rtl'
			})
			.appendTo('body');
		var innerEl = el.children();
		var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
		el.remove();
		return res;
	}
	
	
	// Retrieves a jQuery element's computed CSS value as a floating-point number.
	// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
	function getCssFloat(el, prop) {
		return parseFloat(el.css(prop)) || 0;
	}
	
	
	/* Mouse / Touch Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.preventDefault = preventDefault;
	
	
	// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
	function isPrimaryMouseButton(ev) {
		return ev.which == 1 && !ev.ctrlKey;
	}
	
	
	function getEvX(ev) {
		if (ev.pageX !== undefined) {
			return ev.pageX;
		}
		var touches = ev.originalEvent.touches;
		if (touches) {
			return touches[0].pageX;
		}
	}
	
	
	function getEvY(ev) {
		if (ev.pageY !== undefined) {
			return ev.pageY;
		}
		var touches = ev.originalEvent.touches;
		if (touches) {
			return touches[0].pageY;
		}
	}
	
	
	function getEvIsTouch(ev) {
		return /^touch/.test(ev.type);
	}
	
	
	function preventSelection(el) {
		el.addClass('fc-unselectable')
			.on('selectstart', preventDefault);
	}
	
	
	// Stops a mouse/touch event from doing it's native browser action
	function preventDefault(ev) {
		ev.preventDefault();
	}
	
	
	// attach a handler to get called when ANY scroll action happens on the page.
	// this was impossible to do with normal on/off because 'scroll' doesn't bubble.
	// http://stackoverflow.com/a/32954565/96342
	// returns `true` on success.
	function bindAnyScroll(handler) {
		if (window.addEventListener) {
			window.addEventListener('scroll', handler, true); // useCapture=true
			return true;
		}
		return false;
	}
	
	
	// undoes bindAnyScroll. must pass in the original function.
	// returns `true` on success.
	function unbindAnyScroll(handler) {
		if (window.removeEventListener) {
			window.removeEventListener('scroll', handler, true); // useCapture=true
			return true;
		}
		return false;
	}
	
	
	/* General Geometry Utils
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.intersectRects = intersectRects;
	
	// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
	function intersectRects(rect1, rect2) {
		var res = {
			left: Math.max(rect1.left, rect2.left),
			right: Math.min(rect1.right, rect2.right),
			top: Math.max(rect1.top, rect2.top),
			bottom: Math.min(rect1.bottom, rect2.bottom)
		};
	
		if (res.left < res.right && res.top < res.bottom) {
			return res;
		}
		return false;
	}
	
	
	// Returns a new point that will have been moved to reside within the given rectangle
	function constrainPoint(point, rect) {
		return {
			left: Math.min(Math.max(point.left, rect.left), rect.right),
			top: Math.min(Math.max(point.top, rect.top), rect.bottom)
		};
	}
	
	
	// Returns a point that is the center of the given rectangle
	function getRectCenter(rect) {
		return {
			left: (rect.left + rect.right) / 2,
			top: (rect.top + rect.bottom) / 2
		};
	}
	
	
	// Subtracts point2's coordinates from point1's coordinates, returning a delta
	function diffPoints(point1, point2) {
		return {
			left: point1.left - point2.left,
			top: point1.top - point2.top
		};
	}
	
	
	/* Object Ordering by Field
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.parseFieldSpecs = parseFieldSpecs;
	FC.compareByFieldSpecs = compareByFieldSpecs;
	FC.compareByFieldSpec = compareByFieldSpec;
	FC.flexibleCompare = flexibleCompare;
	
	
	function parseFieldSpecs(input) {
		var specs = [];
		var tokens = [];
		var i, token;
	
		if (typeof input === 'string') {
			tokens = input.split(/\s*,\s*/);
		}
		else if (typeof input === 'function') {
			tokens = [ input ];
		}
		else if ($.isArray(input)) {
			tokens = input;
		}
	
		for (i = 0; i < tokens.length; i++) {
			token = tokens[i];
	
			if (typeof token === 'string') {
				specs.push(
					token.charAt(0) == '-' ?
						{ field: token.substring(1), order: -1 } :
						{ field: token, order: 1 }
				);
			}
			else if (typeof token === 'function') {
				specs.push({ func: token });
			}
		}
	
		return specs;
	}
	
	
	function compareByFieldSpecs(obj1, obj2, fieldSpecs) {
		var i;
		var cmp;
	
		for (i = 0; i < fieldSpecs.length; i++) {
			cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i]);
			if (cmp) {
				return cmp;
			}
		}
	
		return 0;
	}
	
	
	function compareByFieldSpec(obj1, obj2, fieldSpec) {
		if (fieldSpec.func) {
			return fieldSpec.func(obj1, obj2);
		}
		return flexibleCompare(obj1[fieldSpec.field], obj2[fieldSpec.field]) *
			(fieldSpec.order || 1);
	}
	
	
	function flexibleCompare(a, b) {
		if (!a && !b) {
			return 0;
		}
		if (b == null) {
			return -1;
		}
		if (a == null) {
			return 1;
		}
		if ($.type(a) === 'string' || $.type(b) === 'string') {
			return String(a).localeCompare(String(b));
		}
		return a - b;
	}
	
	
	/* FullCalendar-specific Misc Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	
	// Computes the intersection of the two ranges. Returns undefined if no intersection.
	// Expects all dates to be normalized to the same timezone beforehand.
	// TODO: move to date section?
	function intersectRanges(subjectRange, constraintRange) {
		var subjectStart = subjectRange.start;
		var subjectEnd = subjectRange.end;
		var constraintStart = constraintRange.start;
		var constraintEnd = constraintRange.end;
		var segStart, segEnd;
		var isStart, isEnd;
	
		if (subjectEnd > constraintStart && subjectStart < constraintEnd) { // in bounds at all?
	
			if (subjectStart >= constraintStart) {
				segStart = subjectStart.clone();
				isStart = true;
			}
			else {
				segStart = constraintStart.clone();
				isStart =  false;
			}
	
			if (subjectEnd <= constraintEnd) {
				segEnd = subjectEnd.clone();
				isEnd = true;
			}
			else {
				segEnd = constraintEnd.clone();
				isEnd = false;
			}
	
			return {
				start: segStart,
				end: segEnd,
				isStart: isStart,
				isEnd: isEnd
			};
		}
	}
	
	
	/* Date Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.computeIntervalUnit = computeIntervalUnit;
	FC.divideRangeByDuration = divideRangeByDuration;
	FC.divideDurationByDuration = divideDurationByDuration;
	FC.multiplyDuration = multiplyDuration;
	FC.durationHasTime = durationHasTime;
	
	var dayIDs = [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat' ];
	var intervalUnits = [ 'year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond' ];
	
	
	// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
	// Moments will have their timezones normalized.
	function diffDayTime(a, b) {
		return moment.duration({
			days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
			ms: a.time() - b.time() // time-of-day from day start. disregards timezone
		});
	}
	
	
	// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
	function diffDay(a, b) {
		return moment.duration({
			days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
		});
	}
	
	
	// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
	function diffByUnit(a, b, unit) {
		return moment.duration(
			Math.round(a.diff(b, unit, true)), // returnFloat=true
			unit
		);
	}
	
	
	// Computes the unit name of the largest whole-unit period of time.
	// For example, 48 hours will be "days" whereas 49 hours will be "hours".
	// Accepts start/end, a range object, or an original duration object.
	function computeIntervalUnit(start, end) {
		var i, unit;
		var val;
	
		for (i = 0; i < intervalUnits.length; i++) {
			unit = intervalUnits[i];
			val = computeRangeAs(unit, start, end);
	
			if (val >= 1 && isInt(val)) {
				break;
			}
		}
	
		return unit; // will be "milliseconds" if nothing else matches
	}
	
	
	// Computes the number of units (like "hours") in the given range.
	// Range can be a {start,end} object, separate start/end args, or a Duration.
	// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
	// of month-diffing logic (which tends to vary from version to version).
	function computeRangeAs(unit, start, end) {
	
		if (end != null) { // given start, end
			return end.diff(start, unit, true);
		}
		else if (moment.isDuration(start)) { // given duration
			return start.as(unit);
		}
		else { // given { start, end } range object
			return start.end.diff(start.start, unit, true);
		}
	}
	
	
	// Intelligently divides a range (specified by a start/end params) by a duration
	function divideRangeByDuration(start, end, dur) {
		var months;
	
		if (durationHasTime(dur)) {
			return (end - start) / dur;
		}
		months = dur.asMonths();
		if (Math.abs(months) >= 1 && isInt(months)) {
			return end.diff(start, 'months', true) / months;
		}
		return end.diff(start, 'days', true) / dur.asDays();
	}
	
	
	// Intelligently divides one duration by another
	function divideDurationByDuration(dur1, dur2) {
		var months1, months2;
	
		if (durationHasTime(dur1) || durationHasTime(dur2)) {
			return dur1 / dur2;
		}
		months1 = dur1.asMonths();
		months2 = dur2.asMonths();
		if (
			Math.abs(months1) >= 1 && isInt(months1) &&
			Math.abs(months2) >= 1 && isInt(months2)
		) {
			return months1 / months2;
		}
		return dur1.asDays() / dur2.asDays();
	}
	
	
	// Intelligently multiplies a duration by a number
	function multiplyDuration(dur, n) {
		var months;
	
		if (durationHasTime(dur)) {
			return moment.duration(dur * n);
		}
		months = dur.asMonths();
		if (Math.abs(months) >= 1 && isInt(months)) {
			return moment.duration({ months: months * n });
		}
		return moment.duration({ days: dur.asDays() * n });
	}
	
	
	// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
	function durationHasTime(dur) {
		return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
	}
	
	
	function isNativeDate(input) {
		return  Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
	}
	
	
	// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
	function isTimeString(str) {
		return /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
	}
	
	
	/* Logging and Debug
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.log = function() {
		var console = window.console;
	
		if (console && console.log) {
			return console.log.apply(console, arguments);
		}
	};
	
	FC.warn = function() {
		var console = window.console;
	
		if (console && console.warn) {
			return console.warn.apply(console, arguments);
		}
		else {
			return FC.log.apply(FC, arguments);
		}
	};
	
	
	/* General Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	var hasOwnPropMethod = {}.hasOwnProperty;
	
	
	// Merges an array of objects into a single object.
	// The second argument allows for an array of property names who's object values will be merged together.
	function mergeProps(propObjs, complexProps) {
		var dest = {};
		var i, name;
		var complexObjs;
		var j, val;
		var props;
	
		if (complexProps) {
			for (i = 0; i < complexProps.length; i++) {
				name = complexProps[i];
				complexObjs = [];
	
				// collect the trailing object values, stopping when a non-object is discovered
				for (j = propObjs.length - 1; j >= 0; j--) {
					val = propObjs[j][name];
	
					if (typeof val === 'object') {
						complexObjs.unshift(val);
					}
					else if (val !== undefined) {
						dest[name] = val; // if there were no objects, this value will be used
						break;
					}
				}
	
				// if the trailing values were objects, use the merged value
				if (complexObjs.length) {
					dest[name] = mergeProps(complexObjs);
				}
			}
		}
	
		// copy values into the destination, going from last to first
		for (i = propObjs.length - 1; i >= 0; i--) {
			props = propObjs[i];
	
			for (name in props) {
				if (!(name in dest)) { // if already assigned by previous props or complex props, don't reassign
					dest[name] = props[name];
				}
			}
		}
	
		return dest;
	}
	
	
	// Create an object that has the given prototype. Just like Object.create
	function createObject(proto) {
		var f = function() {};
		f.prototype = proto;
		return new f();
	}
	
	
	function copyOwnProps(src, dest) {
		for (var name in src) {
			if (hasOwnProp(src, name)) {
				dest[name] = src[name];
			}
		}
	}
	
	
	// Copies over certain methods with the same names as Object.prototype methods. Overcomes an IE<=8 bug:
	// https://developer.mozilla.org/en-US/docs/ECMAScript_DontEnum_attribute#JScript_DontEnum_Bug
	function copyNativeMethods(src, dest) {
		var names = [ 'constructor', 'toString', 'valueOf' ];
		var i, name;
	
		for (i = 0; i < names.length; i++) {
			name = names[i];
	
			if (src[name] !== Object.prototype[name]) {
				dest[name] = src[name];
			}
		}
	}
	
	
	function hasOwnProp(obj, name) {
		return hasOwnPropMethod.call(obj, name);
	}
	
	
	// Is the given value a non-object non-function value?
	function isAtomic(val) {
		return /undefined|null|boolean|number|string/.test($.type(val));
	}
	
	
	function applyAll(functions, thisObj, args) {
		if ($.isFunction(functions)) {
			functions = [ functions ];
		}
		if (functions) {
			var i;
			var ret;
			for (i=0; i<functions.length; i++) {
				ret = functions[i].apply(thisObj, args) || ret;
			}
			return ret;
		}
	}
	
	
	function firstDefined() {
		for (var i=0; i<arguments.length; i++) {
			if (arguments[i] !== undefined) {
				return arguments[i];
			}
		}
	}
	
	
	function htmlEscape(s) {
		return (s + '').replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/'/g, '&#039;')
			.replace(/"/g, '&quot;')
			.replace(/\n/g, '<br />');
	}
	
	
	function stripHtmlEntities(text) {
		return text.replace(/&.*?;/g, '');
	}
	
	
	// Given a hash of CSS properties, returns a string of CSS.
	// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
	function cssToStr(cssProps) {
		var statements = [];
	
		$.each(cssProps, function(name, val) {
			if (val != null) {
				statements.push(name + ':' + val);
			}
		});
	
		return statements.join(';');
	}
	
	
	function capitaliseFirstLetter(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
	
	function compareNumbers(a, b) { // for .sort()
		return a - b;
	}
	
	
	function isInt(n) {
		return n % 1 === 0;
	}
	
	
	// Returns a method bound to the given object context.
	// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
	// different contexts as identical when binding/unbinding events.
	function proxy(obj, methodName) {
		var method = obj[methodName];
	
		return function() {
			return method.apply(obj, arguments);
		};
	}
	
	
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
	function debounce(func, wait, immediate) {
		var timeout, args, context, timestamp, result;
	
		var later = function() {
			var last = +new Date() - timestamp;
			if (last < wait) {
				timeout = setTimeout(later, wait - last);
			}
			else {
				timeout = null;
				if (!immediate) {
					result = func.apply(context, args);
					context = args = null;
				}
			}
		};
	
		return function() {
			context = this;
			args = arguments;
			timestamp = +new Date();
			var callNow = immediate && !timeout;
			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
			if (callNow) {
				result = func.apply(context, args);
				context = args = null;
			}
			return result;
		};
	}
	
	
	// HACK around jQuery's now A+ promises: execute callback synchronously if already resolved.
	// thenFunc shouldn't accept args.
	// similar to whenResources in Scheduler plugin.
	function syncThen(promise, thenFunc) {
		// not a promise, or an already-resolved promise?
		if (!promise || !promise.then || promise.state() === 'resolved') {
			return $.when(thenFunc()); // resolve immediately
		}
		else if (thenFunc) {
			return promise.then(thenFunc);
		}
	}
	
	;;
	
	var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
	var ambigTimeOrZoneRegex =
		/^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
	var newMomentProto = moment.fn; // where we will attach our new methods
	var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
	var allowValueOptimization;
	var setUTCValues; // function defined below
	var setLocalValues; // function defined below
	
	
	// Creating
	// -------------------------------------------------------------------------------------------------
	
	// Creates a new moment, similar to the vanilla moment(...) constructor, but with
	// extra features (ambiguous time, enhanced formatting). When given an existing moment,
	// it will function as a clone (and retain the zone of the moment). Anything else will
	// result in a moment in the local zone.
	FC.moment = function() {
		return makeMoment(arguments);
	};
	
	// Sames as FC.moment, but forces the resulting moment to be in the UTC timezone.
	FC.moment.utc = function() {
		var mom = makeMoment(arguments, true);
	
		// Force it into UTC because makeMoment doesn't guarantee it
		// (if given a pre-existing moment for example)
		if (mom.hasTime()) { // don't give ambiguously-timed moments a UTC zone
			mom.utc();
		}
	
		return mom;
	};
	
	// Same as FC.moment, but when given an ISO8601 string, the timezone offset is preserved.
	// ISO8601 strings with no timezone offset will become ambiguously zoned.
	FC.moment.parseZone = function() {
		return makeMoment(arguments, true, true);
	};
	
	// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
	// native Date, or called with no arguments (the current time), the resulting moment will be local.
	// Anything else needs to be "parsed" (a string or an array), and will be affected by:
	//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
	//    parseZone - if there is zone information, should we force the zone of the moment?
	function makeMoment(args, parseAsUTC, parseZone) {
		var input = args[0];
		var isSingleString = args.length == 1 && typeof input === 'string';
		var isAmbigTime;
		var isAmbigZone;
		var ambigMatch;
		var mom;
	
		if (moment.isMoment(input)) {
			mom = moment.apply(null, args); // clone it
			transferAmbigs(input, mom); // the ambig flags weren't transfered with the clone
		}
		else if (isNativeDate(input) || input === undefined) {
			mom = moment.apply(null, args); // will be local
		}
		else { // "parsing" is required
			isAmbigTime = false;
			isAmbigZone = false;
	
			if (isSingleString) {
				if (ambigDateOfMonthRegex.test(input)) {
					// accept strings like '2014-05', but convert to the first of the month
					input += '-01';
					args = [ input ]; // for when we pass it on to moment's constructor
					isAmbigTime = true;
					isAmbigZone = true;
				}
				else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
					isAmbigTime = !ambigMatch[5]; // no time part?
					isAmbigZone = true;
				}
			}
			else if ($.isArray(input)) {
				// arrays have no timezone information, so assume ambiguous zone
				isAmbigZone = true;
			}
			// otherwise, probably a string with a format
	
			if (parseAsUTC || isAmbigTime) {
				mom = moment.utc.apply(moment, args);
			}
			else {
				mom = moment.apply(null, args);
			}
	
			if (isAmbigTime) {
				mom._ambigTime = true;
				mom._ambigZone = true; // ambiguous time always means ambiguous zone
			}
			else if (parseZone) { // let's record the inputted zone somehow
				if (isAmbigZone) {
					mom._ambigZone = true;
				}
				else if (isSingleString) {
					if (mom.utcOffset) {
						mom.utcOffset(input); // if not a valid zone, will assign UTC
					}
					else {
						mom.zone(input); // for moment-pre-2.9
					}
				}
			}
		}
	
		mom._fullCalendar = true; // flag for extended functionality
	
		return mom;
	}
	
	
	// A clone method that works with the flags related to our enhanced functionality.
	// In the future, use moment.momentProperties
	newMomentProto.clone = function() {
		var mom = oldMomentProto.clone.apply(this, arguments);
	
		// these flags weren't transfered with the clone
		transferAmbigs(this, mom);
		if (this._fullCalendar) {
			mom._fullCalendar = true;
		}
	
		return mom;
	};
	
	
	// Week Number
	// -------------------------------------------------------------------------------------------------
	
	
	// Returns the week number, considering the locale's custom week number calcuation
	// `weeks` is an alias for `week`
	newMomentProto.week = newMomentProto.weeks = function(input) {
		var weekCalc = (this._locale || this._lang) // works pre-moment-2.8
			._fullCalendar_weekCalc;
	
		if (input == null && typeof weekCalc === 'function') { // custom function only works for getter
			return weekCalc(this);
		}
		else if (weekCalc === 'ISO') {
			return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
		}
	
		return oldMomentProto.week.apply(this, arguments); // local getter/setter
	};
	
	
	// Time-of-day
	// -------------------------------------------------------------------------------------------------
	
	// GETTER
	// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
	// If the moment has an ambiguous time, a duration of 00:00 will be returned.
	//
	// SETTER
	// You can supply a Duration, a Moment, or a Duration-like argument.
	// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
	newMomentProto.time = function(time) {
	
		// Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
		// `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
		if (!this._fullCalendar) {
			return oldMomentProto.time.apply(this, arguments);
		}
	
		if (time == null) { // getter
			return moment.duration({
				hours: this.hours(),
				minutes: this.minutes(),
				seconds: this.seconds(),
				milliseconds: this.milliseconds()
			});
		}
		else { // setter
	
			this._ambigTime = false; // mark that the moment now has a time
	
			if (!moment.isDuration(time) && !moment.isMoment(time)) {
				time = moment.duration(time);
			}
	
			// The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
			// Only for Duration times, not Moment times.
			var dayHours = 0;
			if (moment.isDuration(time)) {
				dayHours = Math.floor(time.asDays()) * 24;
			}
	
			// We need to set the individual fields.
			// Can't use startOf('day') then add duration. In case of DST at start of day.
			return this.hours(dayHours + time.hours())
				.minutes(time.minutes())
				.seconds(time.seconds())
				.milliseconds(time.milliseconds());
		}
	};
	
	// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
	// but preserving its YMD. A moment with a stripped time will display no time
	// nor timezone offset when .format() is called.
	newMomentProto.stripTime = function() {
		var a;
	
		if (!this._ambigTime) {
	
			// get the values before any conversion happens
			a = this.toArray(); // array of y/m/d/h/m/s/ms
	
			// TODO: use keepLocalTime in the future
			this.utc(); // set the internal UTC flag (will clear the ambig flags)
			setUTCValues(this, a.slice(0, 3)); // set the year/month/date. time will be zero
	
			// Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
			// which clears all ambig flags. Same with setUTCValues with moment-timezone.
			this._ambigTime = true;
			this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
		}
	
		return this; // for chaining
	};
	
	// Returns if the moment has a non-ambiguous time (boolean)
	newMomentProto.hasTime = function() {
		return !this._ambigTime;
	};
	
	
	// Timezone
	// -------------------------------------------------------------------------------------------------
	
	// Converts the moment to UTC, stripping out its timezone offset, but preserving its
	// YMD and time-of-day. A moment with a stripped timezone offset will display no
	// timezone offset when .format() is called.
	// TODO: look into Moment's keepLocalTime functionality
	newMomentProto.stripZone = function() {
		var a, wasAmbigTime;
	
		if (!this._ambigZone) {
	
			// get the values before any conversion happens
			a = this.toArray(); // array of y/m/d/h/m/s/ms
			wasAmbigTime = this._ambigTime;
	
			this.utc(); // set the internal UTC flag (might clear the ambig flags, depending on Moment internals)
			setUTCValues(this, a); // will set the year/month/date/hours/minutes/seconds/ms
	
			// the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
			this._ambigTime = wasAmbigTime || false;
	
			// Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
			// which clears the ambig flags. Same with setUTCValues with moment-timezone.
			this._ambigZone = true;
		}
	
		return this; // for chaining
	};
	
	// Returns of the moment has a non-ambiguous timezone offset (boolean)
	newMomentProto.hasZone = function() {
		return !this._ambigZone;
	};
	
	
	// this method implicitly marks a zone
	newMomentProto.local = function() {
		var a = this.toArray(); // year,month,date,hours,minutes,seconds,ms as an array
		var wasAmbigZone = this._ambigZone;
	
		oldMomentProto.local.apply(this, arguments);
	
		// ensure non-ambiguous
		// this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
		this._ambigTime = false;
		this._ambigZone = false;
	
		if (wasAmbigZone) {
			// If the moment was ambiguously zoned, the date fields were stored as UTC.
			// We want to preserve these, but in local time.
			// TODO: look into Moment's keepLocalTime functionality
			setLocalValues(this, a);
		}
	
		return this; // for chaining
	};
	
	
	// implicitly marks a zone
	newMomentProto.utc = function() {
		oldMomentProto.utc.apply(this, arguments);
	
		// ensure non-ambiguous
		// this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
		this._ambigTime = false;
		this._ambigZone = false;
	
		return this;
	};
	
	
	// methods for arbitrarily manipulating timezone offset.
	// should clear time/zone ambiguity when called.
	$.each([
		'zone', // only in moment-pre-2.9. deprecated afterwards
		'utcOffset'
	], function(i, name) {
		if (oldMomentProto[name]) { // original method exists?
	
			// this method implicitly marks a zone (will probably get called upon .utc() and .local())
			newMomentProto[name] = function(tzo) {
	
				if (tzo != null) { // setter
					// these assignments needs to happen before the original zone method is called.
					// I forget why, something to do with a browser crash.
					this._ambigTime = false;
					this._ambigZone = false;
				}
	
				return oldMomentProto[name].apply(this, arguments);
			};
		}
	});
	
	
	// Formatting
	// -------------------------------------------------------------------------------------------------
	
	newMomentProto.format = function() {
		if (this._fullCalendar && arguments[0]) { // an enhanced moment? and a format string provided?
			return formatDate(this, arguments[0]); // our extended formatting
		}
		if (this._ambigTime) {
			return oldMomentFormat(this, 'YYYY-MM-DD');
		}
		if (this._ambigZone) {
			return oldMomentFormat(this, 'YYYY-MM-DD[T]HH:mm:ss');
		}
		return oldMomentProto.format.apply(this, arguments);
	};
	
	newMomentProto.toISOString = function() {
		if (this._ambigTime) {
			return oldMomentFormat(this, 'YYYY-MM-DD');
		}
		if (this._ambigZone) {
			return oldMomentFormat(this, 'YYYY-MM-DD[T]HH:mm:ss');
		}
		return oldMomentProto.toISOString.apply(this, arguments);
	};
	
	
	// Querying
	// -------------------------------------------------------------------------------------------------
	
	// Is the moment within the specified range? `end` is exclusive.
	// FYI, this method is not a standard Moment method, so always do our enhanced logic.
	newMomentProto.isWithin = function(start, end) {
		var a = commonlyAmbiguate([ this, start, end ]);
		return a[0] >= a[1] && a[0] < a[2];
	};
	
	// When isSame is called with units, timezone ambiguity is normalized before the comparison happens.
	// If no units specified, the two moments must be identically the same, with matching ambig flags.
	newMomentProto.isSame = function(input, units) {
		var a;
	
		// only do custom logic if this is an enhanced moment
		if (!this._fullCalendar) {
			return oldMomentProto.isSame.apply(this, arguments);
		}
	
		if (units) {
			a = commonlyAmbiguate([ this, input ], true); // normalize timezones but don't erase times
			return oldMomentProto.isSame.call(a[0], a[1], units);
		}
		else {
			input = FC.moment.parseZone(input); // normalize input
			return oldMomentProto.isSame.call(this, input) &&
				Boolean(this._ambigTime) === Boolean(input._ambigTime) &&
				Boolean(this._ambigZone) === Boolean(input._ambigZone);
		}
	};
	
	// Make these query methods work with ambiguous moments
	$.each([
		'isBefore',
		'isAfter'
	], function(i, methodName) {
		newMomentProto[methodName] = function(input, units) {
			var a;
	
			// only do custom logic if this is an enhanced moment
			if (!this._fullCalendar) {
				return oldMomentProto[methodName].apply(this, arguments);
			}
	
			a = commonlyAmbiguate([ this, input ]);
			return oldMomentProto[methodName].call(a[0], a[1], units);
		};
	});
	
	
	// Misc Internals
	// -------------------------------------------------------------------------------------------------
	
	// given an array of moment-like inputs, return a parallel array w/ moments similarly ambiguated.
	// for example, of one moment has ambig time, but not others, all moments will have their time stripped.
	// set `preserveTime` to `true` to keep times, but only normalize zone ambiguity.
	// returns the original moments if no modifications are necessary.
	function commonlyAmbiguate(inputs, preserveTime) {
		var anyAmbigTime = false;
		var anyAmbigZone = false;
		var len = inputs.length;
		var moms = [];
		var i, mom;
	
		// parse inputs into real moments and query their ambig flags
		for (i = 0; i < len; i++) {
			mom = inputs[i];
			if (!moment.isMoment(mom)) {
				mom = FC.moment.parseZone(mom);
			}
			anyAmbigTime = anyAmbigTime || mom._ambigTime;
			anyAmbigZone = anyAmbigZone || mom._ambigZone;
			moms.push(mom);
		}
	
		// strip each moment down to lowest common ambiguity
		// use clones to avoid modifying the original moments
		for (i = 0; i < len; i++) {
			mom = moms[i];
			if (!preserveTime && anyAmbigTime && !mom._ambigTime) {
				moms[i] = mom.clone().stripTime();
			}
			else if (anyAmbigZone && !mom._ambigZone) {
				moms[i] = mom.clone().stripZone();
			}
		}
	
		return moms;
	}
	
	// Transfers all the flags related to ambiguous time/zone from the `src` moment to the `dest` moment
	// TODO: look into moment.momentProperties for this.
	function transferAmbigs(src, dest) {
		if (src._ambigTime) {
			dest._ambigTime = true;
		}
		else if (dest._ambigTime) {
			dest._ambigTime = false;
		}
	
		if (src._ambigZone) {
			dest._ambigZone = true;
		}
		else if (dest._ambigZone) {
			dest._ambigZone = false;
		}
	}
	
	
	// Sets the year/month/date/etc values of the moment from the given array.
	// Inefficient because it calls each individual setter.
	function setMomentValues(mom, a) {
		mom.year(a[0] || 0)
			.month(a[1] || 0)
			.date(a[2] || 0)
			.hours(a[3] || 0)
			.minutes(a[4] || 0)
			.seconds(a[5] || 0)
			.milliseconds(a[6] || 0);
	}
	
	// Can we set the moment's internal date directly?
	allowValueOptimization = '_d' in moment() && 'updateOffset' in moment;
	
	// Utility function. Accepts a moment and an array of the UTC year/month/date/etc values to set.
	// Assumes the given moment is already in UTC mode.
	setUTCValues = allowValueOptimization ? function(mom, a) {
		// simlate what moment's accessors do
		mom._d.setTime(Date.UTC.apply(Date, a));
		moment.updateOffset(mom, false); // keepTime=false
	} : setMomentValues;
	
	// Utility function. Accepts a moment and an array of the local year/month/date/etc values to set.
	// Assumes the given moment is already in local mode.
	setLocalValues = allowValueOptimization ? function(mom, a) {
		// simlate what moment's accessors do
		mom._d.setTime(+new Date( // FYI, there is now way to apply an array of args to a constructor
			a[0] || 0,
			a[1] || 0,
			a[2] || 0,
			a[3] || 0,
			a[4] || 0,
			a[5] || 0,
			a[6] || 0
		));
		moment.updateOffset(mom, false); // keepTime=false
	} : setMomentValues;
	
	;;
	
	// Single Date Formatting
	// -------------------------------------------------------------------------------------------------
	
	
	// call this if you want Moment's original format method to be used
	function oldMomentFormat(mom, formatStr) {
		return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
	}
	
	
	// Formats `date` with a Moment formatting string, but allow our non-zero areas and
	// additional token.
	function formatDate(date, formatStr) {
		return formatDateWithChunks(date, getFormatStringChunks(formatStr));
	}
	
	
	function formatDateWithChunks(date, chunks) {
		var s = '';
		var i;
	
		for (i=0; i<chunks.length; i++) {
			s += formatDateWithChunk(date, chunks[i]);
		}
	
		return s;
	}
	
	
	// addition formatting tokens we want recognized
	var tokenOverrides = {
		t: function(date) { // "a" or "p"
			return oldMomentFormat(date, 'a').charAt(0);
		},
		T: function(date) { // "A" or "P"
			return oldMomentFormat(date, 'A').charAt(0);
		}
	};
	
	
	function formatDateWithChunk(date, chunk) {
		var token;
		var maybeStr;
	
		if (typeof chunk === 'string') { // a literal string
			return chunk;
		}
		else if ((token = chunk.token)) { // a token, like "YYYY"
			if (tokenOverrides[token]) {
				return tokenOverrides[token](date); // use our custom token
			}
			return oldMomentFormat(date, token);
		}
		else if (chunk.maybe) { // a grouping of other chunks that must be non-zero
			maybeStr = formatDateWithChunks(date, chunk.maybe);
			if (maybeStr.match(/[1-9]/)) {
				return maybeStr;
			}
		}
	
		return '';
	}
	
	
	// Date Range Formatting
	// -------------------------------------------------------------------------------------------------
	// TODO: make it work with timezone offset
	
	// Using a formatting string meant for a single date, generate a range string, like
	// "Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
	// If the dates are the same as far as the format string is concerned, just return a single
	// rendering of one date, without any separator.
	function formatRange(date1, date2, formatStr, separator, isRTL) {
		var localeData;
	
		date1 = FC.moment.parseZone(date1);
		date2 = FC.moment.parseZone(date2);
	
		localeData = (date1.localeData || date1.lang).call(date1); // works with moment-pre-2.8
	
		// Expand localized format strings, like "LL" -> "MMMM D YYYY"
		formatStr = localeData.longDateFormat(formatStr) || formatStr;
		// BTW, this is not important for `formatDate` because it is impossible to put custom tokens
		// or non-zero areas in Moment's localized format strings.
	
		separator = separator || ' - ';
	
		return formatRangeWithChunks(
			date1,
			date2,
			getFormatStringChunks(formatStr),
			separator,
			isRTL
		);
	}
	FC.formatRange = formatRange; // expose
	
	
	function formatRangeWithChunks(date1, date2, chunks, separator, isRTL) {
		var unzonedDate1 = date1.clone().stripZone(); // for formatSimilarChunk
		var unzonedDate2 = date2.clone().stripZone(); // "
		var chunkStr; // the rendering of the chunk
		var leftI;
		var leftStr = '';
		var rightI;
		var rightStr = '';
		var middleI;
		var middleStr1 = '';
		var middleStr2 = '';
		var middleStr = '';
	
		// Start at the leftmost side of the formatting string and continue until you hit a token
		// that is not the same between dates.
		for (leftI=0; leftI<chunks.length; leftI++) {
			chunkStr = formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2, chunks[leftI]);
			if (chunkStr === false) {
				break;
			}
			leftStr += chunkStr;
		}
	
		// Similarly, start at the rightmost side of the formatting string and move left
		for (rightI=chunks.length-1; rightI>leftI; rightI--) {
			chunkStr = formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2,  chunks[rightI]);
			if (chunkStr === false) {
				break;
			}
			rightStr = chunkStr + rightStr;
		}
	
		// The area in the middle is different for both of the dates.
		// Collect them distinctly so we can jam them together later.
		for (middleI=leftI; middleI<=rightI; middleI++) {
			middleStr1 += formatDateWithChunk(date1, chunks[middleI]);
			middleStr2 += formatDateWithChunk(date2, chunks[middleI]);
		}
	
		if (middleStr1 || middleStr2) {
			if (isRTL) {
				middleStr = middleStr2 + separator + middleStr1;
			}
			else {
				middleStr = middleStr1 + separator + middleStr2;
			}
		}
	
		return leftStr + middleStr + rightStr;
	}
	
	
	var similarUnitMap = {
		Y: 'year',
		M: 'month',
		D: 'day', // day of month
		d: 'day', // day of week
		// prevents a separator between anything time-related...
		A: 'second', // AM/PM
		a: 'second', // am/pm
		T: 'second', // A/P
		t: 'second', // a/p
		H: 'second', // hour (24)
		h: 'second', // hour (12)
		m: 'second', // minute
		s: 'second' // second
	};
	// TODO: week maybe?
	
	
	// Given a formatting chunk, and given that both dates are similar in the regard the
	// formatting chunk is concerned, format date1 against `chunk`. Otherwise, return `false`.
	function formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2, chunk) {
		var token;
		var unit;
	
		if (typeof chunk === 'string') { // a literal string
			return chunk;
		}
		else if ((token = chunk.token)) {
			unit = similarUnitMap[token.charAt(0)];
	
			// are the dates the same for this unit of measurement?
			// use the unzoned dates for this calculation because unreliable when near DST (bug #2396)
			if (unit && unzonedDate1.isSame(unzonedDate2, unit)) {
				return oldMomentFormat(date1, token); // would be the same if we used `date2`
				// BTW, don't support custom tokens
			}
		}
	
		return false; // the chunk is NOT the same for the two dates
		// BTW, don't support splitting on non-zero areas
	}
	
	
	// Chunking Utils
	// -------------------------------------------------------------------------------------------------
	
	
	var formatStringChunkCache = {};
	
	
	function getFormatStringChunks(formatStr) {
		if (formatStr in formatStringChunkCache) {
			return formatStringChunkCache[formatStr];
		}
		return (formatStringChunkCache[formatStr] = chunkFormatString(formatStr));
	}
	
	
	// Break the formatting string into an array of chunks
	function chunkFormatString(formatStr) {
		var chunks = [];
		var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g; // TODO: more descrimination
		var match;
	
		while ((match = chunker.exec(formatStr))) {
			if (match[1]) { // a literal string inside [ ... ]
				chunks.push(match[1]);
			}
			else if (match[2]) { // non-zero formatting inside ( ... )
				chunks.push({ maybe: chunkFormatString(match[2]) });
			}
			else if (match[3]) { // a formatting token
				chunks.push({ token: match[3] });
			}
			else if (match[5]) { // an unenclosed literal string
				chunks.push(match[5]);
			}
		}
	
		return chunks;
	}
	
	;;
	
	FC.Class = Class; // export
	
	// Class that all other classes will inherit from
	function Class() { }
	
	
	// Called on a class to create a subclass.
	// Last argument contains instance methods. Any argument before the last are considered mixins.
	Class.extend = function() {
		var len = arguments.length;
		var i;
		var members;
	
		for (i = 0; i < len; i++) {
			members = arguments[i];
			if (i < len - 1) { // not the last argument?
				mixIntoClass(this, members);
			}
		}
	
		return extendClass(this, members || {}); // members will be undefined if no arguments
	};
	
	
	// Adds new member variables/methods to the class's prototype.
	// Can be called with another class, or a plain object hash containing new members.
	Class.mixin = function(members) {
		mixIntoClass(this, members);
	};
	
	
	function extendClass(superClass, members) {
		var subClass;
	
		// ensure a constructor for the subclass, forwarding all arguments to the super-constructor if it doesn't exist
		if (hasOwnProp(members, 'constructor')) {
			subClass = members.constructor;
		}
		if (typeof subClass !== 'function') {
			subClass = members.constructor = function() {
				superClass.apply(this, arguments);
			};
		}
	
		// build the base prototype for the subclass, which is an new object chained to the superclass's prototype
		subClass.prototype = createObject(superClass.prototype);
	
		// copy each member variable/method onto the the subclass's prototype
		copyOwnProps(members, subClass.prototype);
		copyNativeMethods(members, subClass.prototype); // hack for IE8
	
		// copy over all class variables/methods to the subclass, such as `extend` and `mixin`
		copyOwnProps(superClass, subClass);
	
		return subClass;
	}
	
	
	function mixIntoClass(theClass, members) {
		copyOwnProps(members, theClass.prototype); // TODO: copyNativeMethods?
	}
	;;
	
	var EmitterMixin = FC.EmitterMixin = {
	
		// jQuery-ification via $(this) allows a non-DOM object to have
		// the same event handling capabilities (including namespaces).
	
	
		on: function(types, handler) {
	
			// handlers are always called with an "event" object as their first param.
			// sneak the `this` context and arguments into the extra parameter object
			// and forward them on to the original handler.
			var intercept = function(ev, extra) {
				return handler.apply(
					extra.context || this,
					extra.args || []
				);
			};
	
			// mimick jQuery's internal "proxy" system (risky, I know)
			// causing all functions with the same .guid to appear to be the same.
			// https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
			// this is needed for calling .off with the original non-intercept handler.
			if (!handler.guid) {
				handler.guid = $.guid++;
			}
			intercept.guid = handler.guid;
	
			$(this).on(types, intercept);
	
			return this; // for chaining
		},
	
	
		off: function(types, handler) {
			$(this).off(types, handler);
	
			return this; // for chaining
		},
	
	
		trigger: function(types) {
			var args = Array.prototype.slice.call(arguments, 1); // arguments after the first
	
			// pass in "extra" info to the intercept
			$(this).triggerHandler(types, { args: args });
	
			return this; // for chaining
		},
	
	
		triggerWith: function(types, context, args) {
	
			// `triggerHandler` is less reliant on the DOM compared to `trigger`.
			// pass in "extra" info to the intercept.
			$(this).triggerHandler(types, { context: context, args: args });
	
			return this; // for chaining
		}
	
	};
	
	;;
	
	/*
	Utility methods for easily listening to events on another object,
	and more importantly, easily unlistening from them.
	*/
	var ListenerMixin = FC.ListenerMixin = (function() {
		var guid = 0;
		var ListenerMixin = {
	
			listenerId: null,
	
			/*
			Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
			The `callback` will be called with the `this` context of the object that .listenTo is being called on.
			Can be called:
				.listenTo(other, eventName, callback)
			OR
				.listenTo(other, {
					eventName1: callback1,
					eventName2: callback2
				})
			*/
			listenTo: function(other, arg, callback) {
				if (typeof arg === 'object') { // given dictionary of callbacks
					for (var eventName in arg) {
						if (arg.hasOwnProperty(eventName)) {
							this.listenTo(other, eventName, arg[eventName]);
						}
					}
				}
				else if (typeof arg === 'string') {
					other.on(
						arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
						$.proxy(callback, this) // always use `this` context
							// the usually-undesired jQuery guid behavior doesn't matter,
							// because we always unbind via namespace
					);
				}
			},
	
			/*
			Causes the current object to stop listening to events on the `other` object.
			`eventName` is optional. If omitted, will stop listening to ALL events on `other`.
			*/
			stopListeningTo: function(other, eventName) {
				other.off((eventName || '') + '.' + this.getListenerNamespace());
			},
	
			/*
			Returns a string, unique to this object, to be used for event namespacing
			*/
			getListenerNamespace: function() {
				if (this.listenerId == null) {
					this.listenerId = guid++;
				}
				return '_listener' + this.listenerId;
			}
	
		};
		return ListenerMixin;
	})();
	;;
	
	// simple class for toggle a `isIgnoringMouse` flag on delay
	// initMouseIgnoring must first be called, with a millisecond delay setting.
	var MouseIgnorerMixin = {
	
		isIgnoringMouse: false, // bool
		delayUnignoreMouse: null, // method
	
	
		initMouseIgnoring: function(delay) {
			this.delayUnignoreMouse = debounce(proxy(this, 'unignoreMouse'), delay || 1000);
		},
	
	
		// temporarily ignore mouse actions on segments
		tempIgnoreMouse: function() {
			this.isIgnoringMouse = true;
			this.delayUnignoreMouse();
		},
	
	
		// delayUnignoreMouse eventually calls this
		unignoreMouse: function() {
			this.isIgnoringMouse = false;
		}
	
	};
	
	;;
	
	/* A rectangular panel that is absolutely positioned over other content
	------------------------------------------------------------------------------------------------------------------------
	Options:
		- className (string)
		- content (HTML string or jQuery element set)
		- parentEl
		- top
		- left
		- right (the x coord of where the right edge should be. not a "CSS" right)
		- autoHide (boolean)
		- show (callback)
		- hide (callback)
	*/
	
	var Popover = Class.extend(ListenerMixin, {
	
		isHidden: true,
		options: null,
		el: null, // the container element for the popover. generated by this object
		margin: 10, // the space required between the popover and the edges of the scroll container
	
	
		constructor: function(options) {
			this.options = options || {};
		},
	
	
		// Shows the popover on the specified position. Renders it if not already
		show: function() {
			if (this.isHidden) {
				if (!this.el) {
					this.render();
				}
				this.el.show();
				this.position();
				this.isHidden = false;
				this.trigger('show');
			}
		},
	
	
		// Hides the popover, through CSS, but does not remove it from the DOM
		hide: function() {
			if (!this.isHidden) {
				this.el.hide();
				this.isHidden = true;
				this.trigger('hide');
			}
		},
	
	
		// Creates `this.el` and renders content inside of it
		render: function() {
			var _this = this;
			var options = this.options;
	
			this.el = $('<div class="fc-popover"/>')
				.addClass(options.className || '')
				.css({
					// position initially to the top left to avoid creating scrollbars
					top: 0,
					left: 0
				})
				.append(options.content)
				.appendTo(options.parentEl);
	
			// when a click happens on anything inside with a 'fc-close' className, hide the popover
			this.el.on('click', '.fc-close', function() {
				_this.hide();
			});
	
			if (options.autoHide) {
				this.listenTo($(document), 'mousedown', this.documentMousedown);
			}
		},
	
	
		// Triggered when the user clicks *anywhere* in the document, for the autoHide feature
		documentMousedown: function(ev) {
			// only hide the popover if the click happened outside the popover
			if (this.el && !$(ev.target).closest(this.el).length) {
				this.hide();
			}
		},
	
	
		// Hides and unregisters any handlers
		removeElement: function() {
			this.hide();
	
			if (this.el) {
				this.el.remove();
				this.el = null;
			}
	
			this.stopListeningTo($(document), 'mousedown');
		},
	
	
		// Positions the popover optimally, using the top/left/right options
		position: function() {
			var options = this.options;
			var origin = this.el.offsetParent().offset();
			var width = this.el.outerWidth();
			var height = this.el.outerHeight();
			var windowEl = $(window);
			var viewportEl = getScrollParent(this.el);
			var viewportTop;
			var viewportLeft;
			var viewportOffset;
			var top; // the "position" (not "offset") values for the popover
			var left; //
	
			// compute top and left
			top = options.top || 0;
			if (options.left !== undefined) {
				left = options.left;
			}
			else if (options.right !== undefined) {
				left = options.right - width; // derive the left value from the right value
			}
			else {
				left = 0;
			}
	
			if (viewportEl.is(window) || viewportEl.is(document)) { // normalize getScrollParent's result
				viewportEl = windowEl;
				viewportTop = 0; // the window is always at the top left
				viewportLeft = 0; // (and .offset() won't work if called here)
			}
			else {
				viewportOffset = viewportEl.offset();
				viewportTop = viewportOffset.top;
				viewportLeft = viewportOffset.left;
			}
	
			// if the window is scrolled, it causes the visible area to be further down
			viewportTop += windowEl.scrollTop();
			viewportLeft += windowEl.scrollLeft();
	
			// constrain to the view port. if constrained by two edges, give precedence to top/left
			if (options.viewportConstrain !== false) {
				top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
				top = Math.max(top, viewportTop + this.margin);
				left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
				left = Math.max(left, viewportLeft + this.margin);
			}
	
			this.el.css({
				top: top - origin.top,
				left: left - origin.left
			});
		},
	
	
		// Triggers a callback. Calls a function in the option hash of the same name.
		// Arguments beyond the first `name` are forwarded on.
		// TODO: better code reuse for this. Repeat code
		trigger: function(name) {
			if (this.options[name]) {
				this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
			}
		}
	
	});
	
	;;
	
	/*
	A cache for the left/right/top/bottom/width/height values for one or more elements.
	Works with both offset (from topleft document) and position (from offsetParent).
	
	options:
	- els
	- isHorizontal
	- isVertical
	*/
	var CoordCache = FC.CoordCache = Class.extend({
	
		els: null, // jQuery set (assumed to be siblings)
		forcedOffsetParentEl: null, // options can override the natural offsetParent
		origin: null, // {left,top} position of offsetParent of els
		boundingRect: null, // constrain cordinates to this rectangle. {left,right,top,bottom} or null
		isHorizontal: false, // whether to query for left/right/width
		isVertical: false, // whether to query for top/bottom/height
	
		// arrays of coordinates (offsets from topleft of document)
		lefts: null,
		rights: null,
		tops: null,
		bottoms: null,
	
	
		constructor: function(options) {
			this.els = $(options.els);
			this.isHorizontal = options.isHorizontal;
			this.isVertical = options.isVertical;
			this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
		},
	
	
		// Queries the els for coordinates and stores them.
		// Call this method before using and of the get* methods below.
		build: function() {
			var offsetParentEl = this.forcedOffsetParentEl || this.els.eq(0).offsetParent();
	
			this.origin = offsetParentEl.offset();
			this.boundingRect = this.queryBoundingRect();
	
			if (this.isHorizontal) {
				this.buildElHorizontals();
			}
			if (this.isVertical) {
				this.buildElVerticals();
			}
		},
	
	
		// Destroys all internal data about coordinates, freeing memory
		clear: function() {
			this.origin = null;
			this.boundingRect = null;
			this.lefts = null;
			this.rights = null;
			this.tops = null;
			this.bottoms = null;
		},
	
	
		// When called, if coord caches aren't built, builds them
		ensureBuilt: function() {
			if (!this.origin) {
				this.build();
			}
		},
	
	
		// Populates the left/right internal coordinate arrays
		buildElHorizontals: function() {
			var lefts = [];
			var rights = [];
	
			this.els.each(function(i, node) {
				var el = $(node);
				var left = el.offset().left;
				var width = el.outerWidth();
	
				lefts.push(left);
				rights.push(left + width);
			});
	
			this.lefts = lefts;
			this.rights = rights;
		},
	
	
		// Populates the top/bottom internal coordinate arrays
		buildElVerticals: function() {
			var tops = [];
			var bottoms = [];
	
			this.els.each(function(i, node) {
				var el = $(node);
				var top = el.offset().top;
				var height = el.outerHeight();
	
				tops.push(top);
				bottoms.push(top + height);
			});
	
			this.tops = tops;
			this.bottoms = bottoms;
		},
	
	
		// Given a left offset (from document left), returns the index of the el that it horizontally intersects.
		// If no intersection is made, returns undefined.
		getHorizontalIndex: function(leftOffset) {
			this.ensureBuilt();
	
			var lefts = this.lefts;
			var rights = this.rights;
			var len = lefts.length;
			var i;
	
			for (i = 0; i < len; i++) {
				if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
					return i;
				}
			}
		},
	
	
		// Given a top offset (from document top), returns the index of the el that it vertically intersects.
		// If no intersection is made, returns undefined.
		getVerticalIndex: function(topOffset) {
			this.ensureBuilt();
	
			var tops = this.tops;
			var bottoms = this.bottoms;
			var len = tops.length;
			var i;
	
			for (i = 0; i < len; i++) {
				if (topOffset >= tops[i] && topOffset < bottoms[i]) {
					return i;
				}
			}
		},
	
	
		// Gets the left offset (from document left) of the element at the given index
		getLeftOffset: function(leftIndex) {
			this.ensureBuilt();
			return this.lefts[leftIndex];
		},
	
	
		// Gets the left position (from offsetParent left) of the element at the given index
		getLeftPosition: function(leftIndex) {
			this.ensureBuilt();
			return this.lefts[leftIndex] - this.origin.left;
		},
	
	
		// Gets the right offset (from document left) of the element at the given index.
		// This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
		getRightOffset: function(leftIndex) {
			this.ensureBuilt();
			return this.rights[leftIndex];
		},
	
	
		// Gets the right position (from offsetParent left) of the element at the given index.
		// This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
		getRightPosition: function(leftIndex) {
			this.ensureBuilt();
			return this.rights[leftIndex] - this.origin.left;
		},
	
	
		// Gets the width of the element at the given index
		getWidth: function(leftIndex) {
			this.ensureBuilt();
			return this.rights[leftIndex] - this.lefts[leftIndex];
		},
	
	
		// Gets the top offset (from document top) of the element at the given index
		getTopOffset: function(topIndex) {
			this.ensureBuilt();
			return this.tops[topIndex];
		},
	
	
		// Gets the top position (from offsetParent top) of the element at the given position
		getTopPosition: function(topIndex) {
			this.ensureBuilt();
			return this.tops[topIndex] - this.origin.top;
		},
	
		// Gets the bottom offset (from the document top) of the element at the given index.
		// This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
		getBottomOffset: function(topIndex) {
			this.ensureBuilt();
			return this.bottoms[topIndex];
		},
	
	
		// Gets the bottom position (from the offsetParent top) of the element at the given index.
		// This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
		getBottomPosition: function(topIndex) {
			this.ensureBuilt();
			return this.bottoms[topIndex] - this.origin.top;
		},
	
	
		// Gets the height of the element at the given index
		getHeight: function(topIndex) {
			this.ensureBuilt();
			return this.bottoms[topIndex] - this.tops[topIndex];
		},
	
	
		// Bounding Rect
		// TODO: decouple this from CoordCache
	
		// Compute and return what the elements' bounding rectangle is, from the user's perspective.
		// Right now, only returns a rectangle if constrained by an overflow:scroll element.
		queryBoundingRect: function() {
			var scrollParentEl = getScrollParent(this.els.eq(0));
	
			if (!scrollParentEl.is(document)) {
				return getClientRect(scrollParentEl);
			}
		},
	
		isPointInBounds: function(leftOffset, topOffset) {
			return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
		},
	
		isLeftInBounds: function(leftOffset) {
			return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
		},
	
		isTopInBounds: function(topOffset) {
			return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
		}
	
	});
	
	;;
	
	/* Tracks a drag's mouse movement, firing various handlers
	----------------------------------------------------------------------------------------------------------------------*/
	// TODO: use Emitter
	
	var DragListener = FC.DragListener = Class.extend(ListenerMixin, MouseIgnorerMixin, {
	
		options: null,
	
		// for IE8 bug-fighting behavior
		subjectEl: null,
		subjectHref: null,
	
		// coordinates of the initial mousedown
		originX: null,
		originY: null,
	
		// the wrapping element that scrolls, or MIGHT scroll if there's overflow.
		// TODO: do this for wrappers that have overflow:hidden as well.
		scrollEl: null,
	
		isInteracting: false,
		isDistanceSurpassed: false,
		isDelayEnded: false,
		isDragging: false,
		isTouch: false,
	
		delay: null,
		delayTimeoutId: null,
		minDistance: null,
	
		handleTouchScrollProxy: null, // calls handleTouchScroll, always bound to `this`
	
	
		constructor: function(options) {
			this.options = options || {};
			this.handleTouchScrollProxy = proxy(this, 'handleTouchScroll');
			this.initMouseIgnoring(500);
		},
	
	
		// Interaction (high-level)
		// -----------------------------------------------------------------------------------------------------------------
	
	
		startInteraction: function(ev, extraOptions) {
			var isTouch = getEvIsTouch(ev);
	
			if (ev.type === 'mousedown') {
				if (this.isIgnoringMouse) {
					return;
				}
				else if (!isPrimaryMouseButton(ev)) {
					return;
				}
				else {
					ev.preventDefault(); // prevents native selection in most browsers
				}
			}
	
			if (!this.isInteracting) {
	
				// process options
				extraOptions = extraOptions || {};
				this.delay = firstDefined(extraOptions.delay, this.options.delay, 0);
				this.minDistance = firstDefined(extraOptions.distance, this.options.distance, 0);
				this.subjectEl = this.options.subjectEl;
	
				this.isInteracting = true;
				this.isTouch = isTouch;
				this.isDelayEnded = false;
				this.isDistanceSurpassed = false;
	
				this.originX = getEvX(ev);
				this.originY = getEvY(ev);
				this.scrollEl = getScrollParent($(ev.target));
	
				this.bindHandlers();
				this.initAutoScroll();
				this.handleInteractionStart(ev);
				this.startDelay(ev);
	
				if (!this.minDistance) {
					this.handleDistanceSurpassed(ev);
				}
			}
		},
	
	
		handleInteractionStart: function(ev) {
			this.trigger('interactionStart', ev);
		},
	
	
		endInteraction: function(ev, isCancelled) {
			if (this.isInteracting) {
				this.endDrag(ev);
	
				if (this.delayTimeoutId) {
					clearTimeout(this.delayTimeoutId);
					this.delayTimeoutId = null;
				}
	
				this.destroyAutoScroll();
				this.unbindHandlers();
	
				this.isInteracting = false;
				this.handleInteractionEnd(ev, isCancelled);
	
				// a touchstart+touchend on the same element will result in the following addition simulated events:
				// mouseover + mouseout + click
				// let's ignore these bogus events
				if (this.isTouch) {
					this.tempIgnoreMouse();
				}
			}
		},
	
	
		handleInteractionEnd: function(ev, isCancelled) {
			this.trigger('interactionEnd', ev, isCancelled || false);
		},
	
	
		// Binding To DOM
		// -----------------------------------------------------------------------------------------------------------------
	
	
		bindHandlers: function() {
			var _this = this;
			var touchStartIgnores = 1;
	
			if (this.isTouch) {
				this.listenTo($(document), {
					touchmove: this.handleTouchMove,
					touchend: this.endInteraction,
					touchcancel: this.endInteraction,
	
					// Sometimes touchend doesn't fire
					// (can't figure out why. touchcancel doesn't fire either. has to do with scrolling?)
					// If another touchstart happens, we know it's bogus, so cancel the drag.
					// touchend will continue to be broken until user does a shorttap/scroll, but this is best we can do.
					touchstart: function(ev) {
						if (touchStartIgnores) { // bindHandlers is called from within a touchstart,
							touchStartIgnores--; // and we don't want this to fire immediately, so ignore.
						}
						else {
							_this.endInteraction(ev, true); // isCancelled=true
						}
					}
				});
	
				// listen to ALL scroll actions on the page
				if (
					!bindAnyScroll(this.handleTouchScrollProxy) && // hopefully this works and short-circuits the rest
					this.scrollEl // otherwise, attach a single handler to this
				) {
					this.listenTo(this.scrollEl, 'scroll', this.handleTouchScroll);
				}
			}
			else {
				this.listenTo($(document), {
					mousemove: this.handleMouseMove,
					mouseup: this.endInteraction
				});
			}
	
			this.listenTo($(document), {
				selectstart: preventDefault, // don't allow selection while dragging
				contextmenu: preventDefault // long taps would open menu on Chrome dev tools
			});
		},
	
	
		unbindHandlers: function() {
			this.stopListeningTo($(document));
	
			// unbind scroll listening
			unbindAnyScroll(this.handleTouchScrollProxy);
			if (this.scrollEl) {
				this.stopListeningTo(this.scrollEl, 'scroll');
			}
		},
	
	
		// Drag (high-level)
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// extraOptions ignored if drag already started
		startDrag: function(ev, extraOptions) {
			this.startInteraction(ev, extraOptions); // ensure interaction began
	
			if (!this.isDragging) {
				this.isDragging = true;
				this.handleDragStart(ev);
			}
		},
	
	
		handleDragStart: function(ev) {
			this.trigger('dragStart', ev);
			this.initHrefHack();
		},
	
	
		handleMove: function(ev) {
			var dx = getEvX(ev) - this.originX;
			var dy = getEvY(ev) - this.originY;
			var minDistance = this.minDistance;
			var distanceSq; // current distance from the origin, squared
	
			if (!this.isDistanceSurpassed) {
				distanceSq = dx * dx + dy * dy;
				if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
					this.handleDistanceSurpassed(ev);
				}
			}
	
			if (this.isDragging) {
				this.handleDrag(dx, dy, ev);
			}
		},
	
	
		// Called while the mouse is being moved and when we know a legitimate drag is taking place
		handleDrag: function(dx, dy, ev) {
			this.trigger('drag', dx, dy, ev);
			this.updateAutoScroll(ev); // will possibly cause scrolling
		},
	
	
		endDrag: function(ev) {
			if (this.isDragging) {
				this.isDragging = false;
				this.handleDragEnd(ev);
			}
		},
	
	
		handleDragEnd: function(ev) {
			this.trigger('dragEnd', ev);
			this.destroyHrefHack();
		},
	
	
		// Delay
		// -----------------------------------------------------------------------------------------------------------------
	
	
		startDelay: function(initialEv) {
			var _this = this;
	
			if (this.delay) {
				this.delayTimeoutId = setTimeout(function() {
					_this.handleDelayEnd(initialEv);
				}, this.delay);
			}
			else {
				this.handleDelayEnd(initialEv);
			}
		},
	
	
		handleDelayEnd: function(initialEv) {
			this.isDelayEnded = true;
	
			if (this.isDistanceSurpassed) {
				this.startDrag(initialEv);
			}
		},
	
	
		// Distance
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleDistanceSurpassed: function(ev) {
			this.isDistanceSurpassed = true;
	
			if (this.isDelayEnded) {
				this.startDrag(ev);
			}
		},
	
	
		// Mouse / Touch
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleTouchMove: function(ev) {
			// prevent inertia and touchmove-scrolling while dragging
			if (this.isDragging) {
				ev.preventDefault();
			}
	
			this.handleMove(ev);
		},
	
	
		handleMouseMove: function(ev) {
			this.handleMove(ev);
		},
	
	
		// Scrolling (unrelated to auto-scroll)
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleTouchScroll: function(ev) {
			// if the drag is being initiated by touch, but a scroll happens before
			// the drag-initiating delay is over, cancel the drag
			if (!this.isDragging) {
				this.endInteraction(ev, true); // isCancelled=true
			}
		},
	
	
		// <A> HREF Hack
		// -----------------------------------------------------------------------------------------------------------------
	
	
		initHrefHack: function() {
			var subjectEl = this.subjectEl;
	
			// remove a mousedown'd <a>'s href so it is not visited (IE8 bug)
			if ((this.subjectHref = subjectEl ? subjectEl.attr('href') : null)) {
				subjectEl.removeAttr('href');
			}
		},
	
	
		destroyHrefHack: function() {
			var subjectEl = this.subjectEl;
			var subjectHref = this.subjectHref;
	
			// restore a mousedown'd <a>'s href (for IE8 bug)
			setTimeout(function() { // must be outside of the click's execution
				if (subjectHref) {
					subjectEl.attr('href', subjectHref);
				}
			}, 0);
		},
	
	
		// Utils
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// Triggers a callback. Calls a function in the option hash of the same name.
		// Arguments beyond the first `name` are forwarded on.
		trigger: function(name) {
			if (this.options[name]) {
				this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
			}
			// makes _methods callable by event name. TODO: kill this
			if (this['_' + name]) {
				this['_' + name].apply(this, Array.prototype.slice.call(arguments, 1));
			}
		}
	
	
	});
	
	;;
	/*
	this.scrollEl is set in DragListener
	*/
	DragListener.mixin({
	
		isAutoScroll: false,
	
		scrollBounds: null, // { top, bottom, left, right }
		scrollTopVel: null, // pixels per second
		scrollLeftVel: null, // pixels per second
		scrollIntervalId: null, // ID of setTimeout for scrolling animation loop
	
		// defaults
		scrollSensitivity: 30, // pixels from edge for scrolling to start
		scrollSpeed: 200, // pixels per second, at maximum speed
		scrollIntervalMs: 50, // millisecond wait between scroll increment
	
	
		initAutoScroll: function() {
			var scrollEl = this.scrollEl;
	
			this.isAutoScroll =
				this.options.scroll &&
				scrollEl &&
				!scrollEl.is(window) &&
				!scrollEl.is(document);
	
			if (this.isAutoScroll) {
				// debounce makes sure rapid calls don't happen
				this.listenTo(scrollEl, 'scroll', debounce(this.handleDebouncedScroll, 100));
			}
		},
	
	
		destroyAutoScroll: function() {
			this.endAutoScroll(); // kill any animation loop
	
			// remove the scroll handler if there is a scrollEl
			if (this.isAutoScroll) {
				this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
			}
		},
	
	
		// Computes and stores the bounding rectangle of scrollEl
		computeScrollBounds: function() {
			if (this.isAutoScroll) {
				this.scrollBounds = getOuterRect(this.scrollEl);
				// TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
			}
		},
	
	
		// Called when the dragging is in progress and scrolling should be updated
		updateAutoScroll: function(ev) {
			var sensitivity = this.scrollSensitivity;
			var bounds = this.scrollBounds;
			var topCloseness, bottomCloseness;
			var leftCloseness, rightCloseness;
			var topVel = 0;
			var leftVel = 0;
	
			if (bounds) { // only scroll if scrollEl exists
	
				// compute closeness to edges. valid range is from 0.0 - 1.0
				topCloseness = (sensitivity - (getEvY(ev) - bounds.top)) / sensitivity;
				bottomCloseness = (sensitivity - (bounds.bottom - getEvY(ev))) / sensitivity;
				leftCloseness = (sensitivity - (getEvX(ev) - bounds.left)) / sensitivity;
				rightCloseness = (sensitivity - (bounds.right - getEvX(ev))) / sensitivity;
	
				// translate vertical closeness into velocity.
				// mouse must be completely in bounds for velocity to happen.
				if (topCloseness >= 0 && topCloseness <= 1) {
					topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
				}
				else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
					topVel = bottomCloseness * this.scrollSpeed;
				}
	
				// translate horizontal closeness into velocity
				if (leftCloseness >= 0 && leftCloseness <= 1) {
					leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
				}
				else if (rightCloseness >= 0 && rightCloseness <= 1) {
					leftVel = rightCloseness * this.scrollSpeed;
				}
			}
	
			this.setScrollVel(topVel, leftVel);
		},
	
	
		// Sets the speed-of-scrolling for the scrollEl
		setScrollVel: function(topVel, leftVel) {
	
			this.scrollTopVel = topVel;
			this.scrollLeftVel = leftVel;
	
			this.constrainScrollVel(); // massages into realistic values
	
			// if there is non-zero velocity, and an animation loop hasn't already started, then START
			if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
				this.scrollIntervalId = setInterval(
					proxy(this, 'scrollIntervalFunc'), // scope to `this`
					this.scrollIntervalMs
				);
			}
		},
	
	
		// Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
		constrainScrollVel: function() {
			var el = this.scrollEl;
	
			if (this.scrollTopVel < 0) { // scrolling up?
				if (el.scrollTop() <= 0) { // already scrolled all the way up?
					this.scrollTopVel = 0;
				}
			}
			else if (this.scrollTopVel > 0) { // scrolling down?
				if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) { // already scrolled all the way down?
					this.scrollTopVel = 0;
				}
			}
	
			if (this.scrollLeftVel < 0) { // scrolling left?
				if (el.scrollLeft() <= 0) { // already scrolled all the left?
					this.scrollLeftVel = 0;
				}
			}
			else if (this.scrollLeftVel > 0) { // scrolling right?
				if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) { // already scrolled all the way right?
					this.scrollLeftVel = 0;
				}
			}
		},
	
	
		// This function gets called during every iteration of the scrolling animation loop
		scrollIntervalFunc: function() {
			var el = this.scrollEl;
			var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
	
			// change the value of scrollEl's scroll
			if (this.scrollTopVel) {
				el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
			}
			if (this.scrollLeftVel) {
				el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
			}
	
			this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
	
			// if scrolled all the way, which causes the vels to be zero, stop the animation loop
			if (!this.scrollTopVel && !this.scrollLeftVel) {
				this.endAutoScroll();
			}
		},
	
	
		// Kills any existing scrolling animation loop
		endAutoScroll: function() {
			if (this.scrollIntervalId) {
				clearInterval(this.scrollIntervalId);
				this.scrollIntervalId = null;
	
				this.handleScrollEnd();
			}
		},
	
	
		// Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
		handleDebouncedScroll: function() {
			// recompute all coordinates, but *only* if this is *not* part of our scrolling animation
			if (!this.scrollIntervalId) {
				this.handleScrollEnd();
			}
		},
	
	
		// Called when scrolling has stopped, whether through auto scroll, or the user scrolling
		handleScrollEnd: function() {
		}
	
	});
	;;
	
	/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
	------------------------------------------------------------------------------------------------------------------------
	options:
	- subjectEl
	- subjectCenter
	*/
	
	var HitDragListener = DragListener.extend({
	
		component: null, // converts coordinates to hits
			// methods: prepareHits, releaseHits, queryHit
	
		origHit: null, // the hit the mouse was over when listening started
		hit: null, // the hit the mouse is over
		coordAdjust: null, // delta that will be added to the mouse coordinates when computing collisions
	
	
		constructor: function(component, options) {
			DragListener.call(this, options); // call the super-constructor
	
			this.component = component;
		},
	
	
		// Called when drag listening starts (but a real drag has not necessarily began).
		// ev might be undefined if dragging was started manually.
		handleInteractionStart: function(ev) {
			var subjectEl = this.subjectEl;
			var subjectRect;
			var origPoint;
			var point;
	
			this.computeCoords();
	
			if (ev) {
				origPoint = { left: getEvX(ev), top: getEvY(ev) };
				point = origPoint;
	
				// constrain the point to bounds of the element being dragged
				if (subjectEl) {
					subjectRect = getOuterRect(subjectEl); // used for centering as well
					point = constrainPoint(point, subjectRect);
				}
	
				this.origHit = this.queryHit(point.left, point.top);
	
				// treat the center of the subject as the collision point?
				if (subjectEl && this.options.subjectCenter) {
	
					// only consider the area the subject overlaps the hit. best for large subjects.
					// TODO: skip this if hit didn't supply left/right/top/bottom
					if (this.origHit) {
						subjectRect = intersectRects(this.origHit, subjectRect) ||
							subjectRect; // in case there is no intersection
					}
	
					point = getRectCenter(subjectRect);
				}
	
				this.coordAdjust = diffPoints(point, origPoint); // point - origPoint
			}
			else {
				this.origHit = null;
				this.coordAdjust = null;
			}
	
			// call the super-method. do it after origHit has been computed
			DragListener.prototype.handleInteractionStart.apply(this, arguments);
		},
	
	
		// Recomputes the drag-critical positions of elements
		computeCoords: function() {
			this.component.prepareHits();
			this.computeScrollBounds(); // why is this here??????
		},
	
	
		// Called when the actual drag has started
		handleDragStart: function(ev) {
			var hit;
	
			DragListener.prototype.handleDragStart.apply(this, arguments); // call the super-method
	
			// might be different from this.origHit if the min-distance is large
			hit = this.queryHit(getEvX(ev), getEvY(ev));
	
			// report the initial hit the mouse is over
			// especially important if no min-distance and drag starts immediately
			if (hit) {
				this.handleHitOver(hit);
			}
		},
	
	
		// Called when the drag moves
		handleDrag: function(dx, dy, ev) {
			var hit;
	
			DragListener.prototype.handleDrag.apply(this, arguments); // call the super-method
	
			hit = this.queryHit(getEvX(ev), getEvY(ev));
	
			if (!isHitsEqual(hit, this.hit)) { // a different hit than before?
				if (this.hit) {
					this.handleHitOut();
				}
				if (hit) {
					this.handleHitOver(hit);
				}
			}
		},
	
	
		// Called when dragging has been stopped
		handleDragEnd: function() {
			this.handleHitDone();
			DragListener.prototype.handleDragEnd.apply(this, arguments); // call the super-method
		},
	
	
		// Called when a the mouse has just moved over a new hit
		handleHitOver: function(hit) {
			var isOrig = isHitsEqual(hit, this.origHit);
	
			this.hit = hit;
	
			this.trigger('hitOver', this.hit, isOrig, this.origHit);
		},
	
	
		// Called when the mouse has just moved out of a hit
		handleHitOut: function() {
			if (this.hit) {
				this.trigger('hitOut', this.hit);
				this.handleHitDone();
				this.hit = null;
			}
		},
	
	
		// Called after a hitOut. Also called before a dragStop
		handleHitDone: function() {
			if (this.hit) {
				this.trigger('hitDone', this.hit);
			}
		},
	
	
		// Called when the interaction ends, whether there was a real drag or not
		handleInteractionEnd: function() {
			DragListener.prototype.handleInteractionEnd.apply(this, arguments); // call the super-method
	
			this.origHit = null;
			this.hit = null;
	
			this.component.releaseHits();
		},
	
	
		// Called when scrolling has stopped, whether through auto scroll, or the user scrolling
		handleScrollEnd: function() {
			DragListener.prototype.handleScrollEnd.apply(this, arguments); // call the super-method
	
			this.computeCoords(); // hits' absolute positions will be in new places. recompute
		},
	
	
		// Gets the hit underneath the coordinates for the given mouse event
		queryHit: function(left, top) {
	
			if (this.coordAdjust) {
				left += this.coordAdjust.left;
				top += this.coordAdjust.top;
			}
	
			return this.component.queryHit(left, top);
		}
	
	});
	
	
	// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
	// Two null values will be considered equal, as two "out of the component" states are the same.
	function isHitsEqual(hit0, hit1) {
	
		if (!hit0 && !hit1) {
			return true;
		}
	
		if (hit0 && hit1) {
			return hit0.component === hit1.component &&
				isHitPropsWithin(hit0, hit1) &&
				isHitPropsWithin(hit1, hit0); // ensures all props are identical
		}
	
		return false;
	}
	
	
	// Returns true if all of subHit's non-standard properties are within superHit
	function isHitPropsWithin(subHit, superHit) {
		for (var propName in subHit) {
			if (!/^(component|left|right|top|bottom)$/.test(propName)) {
				if (subHit[propName] !== superHit[propName]) {
					return false;
				}
			}
		}
		return true;
	}
	
	;;
	
	/* Creates a clone of an element and lets it track the mouse as it moves
	----------------------------------------------------------------------------------------------------------------------*/
	
	var MouseFollower = Class.extend(ListenerMixin, {
	
		options: null,
	
		sourceEl: null, // the element that will be cloned and made to look like it is dragging
		el: null, // the clone of `sourceEl` that will track the mouse
		parentEl: null, // the element that `el` (the clone) will be attached to
	
		// the initial position of el, relative to the offset parent. made to match the initial offset of sourceEl
		top0: null,
		left0: null,
	
		// the absolute coordinates of the initiating touch/mouse action
		y0: null,
		x0: null,
	
		// the number of pixels the mouse has moved from its initial position
		topDelta: null,
		leftDelta: null,
	
		isFollowing: false,
		isHidden: false,
		isAnimating: false, // doing the revert animation?
	
		constructor: function(sourceEl, options) {
			this.options = options = options || {};
			this.sourceEl = sourceEl;
			this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
		},
	
	
		// Causes the element to start following the mouse
		start: function(ev) {
			if (!this.isFollowing) {
				this.isFollowing = true;
	
				this.y0 = getEvY(ev);
				this.x0 = getEvX(ev);
				this.topDelta = 0;
				this.leftDelta = 0;
	
				if (!this.isHidden) {
					this.updatePosition();
				}
	
				if (getEvIsTouch(ev)) {
					this.listenTo($(document), 'touchmove', this.handleMove);
				}
				else {
					this.listenTo($(document), 'mousemove', this.handleMove);
				}
			}
		},
	
	
		// Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
		// `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
		stop: function(shouldRevert, callback) {
			var _this = this;
			var revertDuration = this.options.revertDuration;
	
			function complete() { // might be called by .animate(), which might change `this` context
				_this.isAnimating = false;
				_this.removeElement();
	
				_this.top0 = _this.left0 = null; // reset state for future updatePosition calls
	
				if (callback) {
					callback();
				}
			}
	
			if (this.isFollowing && !this.isAnimating) { // disallow more than one stop animation at a time
				this.isFollowing = false;
	
				this.stopListeningTo($(document));
	
				if (shouldRevert && revertDuration && !this.isHidden) { // do a revert animation?
					this.isAnimating = true;
					this.el.animate({
						top: this.top0,
						left: this.left0
					}, {
						duration: revertDuration,
						complete: complete
					});
				}
				else {
					complete();
				}
			}
		},
	
	
		// Gets the tracking element. Create it if necessary
		getEl: function() {
			var el = this.el;
	
			if (!el) {
				this.sourceEl.width(); // hack to force IE8 to compute correct bounding box
				el = this.el = this.sourceEl.clone()
					.addClass(this.options.additionalClass || '')
					.css({
						position: 'absolute',
						visibility: '', // in case original element was hidden (commonly through hideEvents())
						display: this.isHidden ? 'none' : '', // for when initially hidden
						margin: 0,
						right: 'auto', // erase and set width instead
						bottom: 'auto', // erase and set height instead
						width: this.sourceEl.width(), // explicit height in case there was a 'right' value
						height: this.sourceEl.height(), // explicit width in case there was a 'bottom' value
						opacity: this.options.opacity || '',
						zIndex: this.options.zIndex
					});
	
				// we don't want long taps or any mouse interaction causing selection/menus.
				// would use preventSelection(), but that prevents selectstart, causing problems.
				el.addClass('fc-unselectable');
	
				el.appendTo(this.parentEl);
			}
	
			return el;
		},
	
	
		// Removes the tracking element if it has already been created
		removeElement: function() {
			if (this.el) {
				this.el.remove();
				this.el = null;
			}
		},
	
	
		// Update the CSS position of the tracking element
		updatePosition: function() {
			var sourceOffset;
			var origin;
	
			this.getEl(); // ensure this.el
	
			// make sure origin info was computed
			if (this.top0 === null) {
				this.sourceEl.width(); // hack to force IE8 to compute correct bounding box
				sourceOffset = this.sourceEl.offset();
				origin = this.el.offsetParent().offset();
				this.top0 = sourceOffset.top - origin.top;
				this.left0 = sourceOffset.left - origin.left;
			}
	
			this.el.css({
				top: this.top0 + this.topDelta,
				left: this.left0 + this.leftDelta
			});
		},
	
	
		// Gets called when the user moves the mouse
		handleMove: function(ev) {
			this.topDelta = getEvY(ev) - this.y0;
			this.leftDelta = getEvX(ev) - this.x0;
	
			if (!this.isHidden) {
				this.updatePosition();
			}
		},
	
	
		// Temporarily makes the tracking element invisible. Can be called before following starts
		hide: function() {
			if (!this.isHidden) {
				this.isHidden = true;
				if (this.el) {
					this.el.hide();
				}
			}
		},
	
	
		// Show the tracking element after it has been temporarily hidden
		show: function() {
			if (this.isHidden) {
				this.isHidden = false;
				this.updatePosition();
				this.getEl().show();
			}
		}
	
	});
	
	;;
	
	/* An abstract class comprised of a "grid" of areas that each represent a specific datetime
	----------------------------------------------------------------------------------------------------------------------*/
	
	var Grid = FC.Grid = Class.extend(ListenerMixin, MouseIgnorerMixin, {
	
		view: null, // a View object
		isRTL: null, // shortcut to the view's isRTL option
	
		start: null,
		end: null,
	
		el: null, // the containing element
		elsByFill: null, // a hash of jQuery element sets used for rendering each fill. Keyed by fill name.
	
		// derived from options
		eventTimeFormat: null,
		displayEventTime: null,
		displayEventEnd: null,
	
		minResizeDuration: null, // TODO: hack. set by subclasses. minumum event resize duration
	
		// if defined, holds the unit identified (ex: "year" or "month") that determines the level of granularity
		// of the date areas. if not defined, assumes to be day and time granularity.
		// TODO: port isTimeScale into same system?
		largeUnit: null,
	
		dayDragListener: null,
		segDragListener: null,
		segResizeListener: null,
		externalDragListener: null,
	
	
		constructor: function(view) {
			this.view = view;
			this.isRTL = view.opt('isRTL');
			this.elsByFill = {};
	
			this.dayDragListener = this.buildDayDragListener();
			this.initMouseIgnoring();
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates the format string used for event time text, if not explicitly defined by 'timeFormat'
		computeEventTimeFormat: function() {
			return this.view.opt('smallTimeFormat');
		},
	
	
		// Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventTime'.
		// Only applies to non-all-day events.
		computeDisplayEventTime: function() {
			return true;
		},
	
	
		// Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventEnd'
		computeDisplayEventEnd: function() {
			return true;
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Tells the grid about what period of time to display.
		// Any date-related internal data should be generated.
		setRange: function(range) {
			this.start = range.start.clone();
			this.end = range.end.clone();
	
			this.rangeUpdated();
			this.processRangeOptions();
		},
	
	
		// Called when internal variables that rely on the range should be updated
		rangeUpdated: function() {
		},
	
	
		// Updates values that rely on options and also relate to range
		processRangeOptions: function() {
			var view = this.view;
			var displayEventTime;
			var displayEventEnd;
	
			this.eventTimeFormat =
				view.opt('eventTimeFormat') ||
				view.opt('timeFormat') || // deprecated
				this.computeEventTimeFormat();
	
			displayEventTime = view.opt('displayEventTime');
			if (displayEventTime == null) {
				displayEventTime = this.computeDisplayEventTime(); // might be based off of range
			}
	
			displayEventEnd = view.opt('displayEventEnd');
			if (displayEventEnd == null) {
				displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
			}
	
			this.displayEventTime = displayEventTime;
			this.displayEventEnd = displayEventEnd;
		},
	
	
		// Converts a span (has unzoned start/end and any other grid-specific location information)
		// into an array of segments (pieces of events whose format is decided by the grid).
		spanToSegs: function(span) {
			// subclasses must implement
		},
	
	
		// Diffs the two dates, returning a duration, based on granularity of the grid
		// TODO: port isTimeScale into this system?
		diffDates: function(a, b) {
			if (this.largeUnit) {
				return diffByUnit(a, b, this.largeUnit);
			}
			else {
				return diffDayTime(a, b);
			}
		},
	
	
		/* Hit Area
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Called before one or more queryHit calls might happen. Should prepare any cached coordinates for queryHit
		prepareHits: function() {
		},
	
	
		// Called when queryHit calls have subsided. Good place to clear any coordinate caches.
		releaseHits: function() {
		},
	
	
		// Given coordinates from the topleft of the document, return data about the date-related area underneath.
		// Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
		// Must have a `grid` property, a reference to this current grid. TODO: avoid this
		// The returned object will be processed by getHitSpan and getHitEl.
		queryHit: function(leftOffset, topOffset) {
		},
	
	
		// Given position-level information about a date-related area within the grid,
		// should return an object with at least a start/end date. Can provide other information as well.
		getHitSpan: function(hit) {
		},
	
	
		// Given position-level information about a date-related area within the grid,
		// should return a jQuery element that best represents it. passed to dayClick callback.
		getHitEl: function(hit) {
		},
	
	
		/* Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the container element that the grid should render inside of.
		// Does other DOM-related initializations.
		setElement: function(el) {
			this.el = el;
			preventSelection(el);
	
			this.bindDayHandler('touchstart', this.dayTouchStart);
			this.bindDayHandler('mousedown', this.dayMousedown);
	
			// attach event-element-related handlers. in Grid.events
			// same garbage collection note as above.
			this.bindSegHandlers();
	
			this.bindGlobalHandlers();
		},
	
	
		bindDayHandler: function(name, handler) {
			var _this = this;
	
			// attach a handler to the grid's root element.
			// jQuery will take care of unregistering them when removeElement gets called.
			this.el.on(name, function(ev) {
				if (
					!$(ev.target).is('.fc-event-container *, .fc-more') // not an an event element, or "more.." link
				) {
					return handler.call(_this, ev);
				}
			});
		},
	
	
		// Removes the grid's container element from the DOM. Undoes any other DOM-related attachments.
		// DOES NOT remove any content beforehand (doesn't clear events or call unrenderDates), unlike View
		removeElement: function() {
			this.unbindGlobalHandlers();
			this.clearDragListeners();
	
			this.el.remove();
	
			// NOTE: we don't null-out this.el for the same reasons we don't do it within View::removeElement
		},
	
	
		// Renders the basic structure of grid view before any content is rendered
		renderSkeleton: function() {
			// subclasses should implement
		},
	
	
		// Renders the grid's date-related content (like areas that represent days/times).
		// Assumes setRange has already been called and the skeleton has already been rendered.
		renderDates: function() {
			// subclasses should implement
		},
	
	
		// Unrenders the grid's date-related content
		unrenderDates: function() {
			// subclasses should implement
		},
	
	
		/* Handlers
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Binds DOM handlers to elements that reside outside the grid, such as the document
		bindGlobalHandlers: function() {
			this.listenTo($(document), {
				dragstart: this.externalDragStart, // jqui
				sortstart: this.externalDragStart // jqui
			});
		},
	
	
		// Unbinds DOM handlers from elements that reside outside the grid
		unbindGlobalHandlers: function() {
			this.stopListeningTo($(document));
		},
	
	
		// Process a mousedown on an element that represents a day. For day clicking and selecting.
		dayMousedown: function(ev) {
			if (!this.isIgnoringMouse) {
				this.dayDragListener.startInteraction(ev, {
					//distance: 5, // needs more work if we want dayClick to fire correctly
				});
			}
		},
	
	
		dayTouchStart: function(ev) {
			var view = this.view;
	
			// HACK to prevent a user's clickaway for unselecting a range or an event
			// from causing a dayClick.
			if (view.isSelected || view.selectedEvent) {
				this.tempIgnoreMouse();
			}
	
			this.dayDragListener.startInteraction(ev, {
				delay: this.view.opt('longPressDelay')
			});
		},
	
	
		// Creates a listener that tracks the user's drag across day elements.
		// For day clicking and selecting.
		buildDayDragListener: function() {
			var _this = this;
			var view = this.view;
			var isSelectable = view.opt('selectable');
			var dayClickHit; // null if invalid dayClick
			var selectionSpan; // null if invalid selection
	
			// this listener tracks a mousedown on a day element, and a subsequent drag.
			// if the drag ends on the same day, it is a 'dayClick'.
			// if 'selectable' is enabled, this listener also detects selections.
			var dragListener = new HitDragListener(this, {
				scroll: view.opt('dragScroll'),
				interactionStart: function() {
					dayClickHit = dragListener.origHit; // for dayClick, where no dragging happens
					selectionSpan = null;
				},
				dragStart: function() {
					view.unselect(); // since we could be rendering a new selection, we want to clear any old one
				},
				hitOver: function(hit, isOrig, origHit) {
					if (origHit) { // click needs to have started on a hit
	
						// if user dragged to another cell at any point, it can no longer be a dayClick
						if (!isOrig) {
							dayClickHit = null;
						}
	
						if (isSelectable) {
							selectionSpan = _this.computeSelection(
								_this.getHitSpan(origHit),
								_this.getHitSpan(hit)
							);
							if (selectionSpan) {
								_this.renderSelection(selectionSpan);
							}
							else if (selectionSpan === false) {
								disableCursor();
							}
						}
					}
				},
				hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
					dayClickHit = null;
					selectionSpan = null;
					_this.unrenderSelection();
				},
				hitDone: function() { // called after a hitOut OR before a dragEnd
					enableCursor();
				},
				interactionEnd: function(ev, isCancelled) {
					if (!isCancelled) {
						if (
							dayClickHit &&
							!_this.isIgnoringMouse // see hack in dayTouchStart
						) {
							view.triggerDayClick(
								_this.getHitSpan(dayClickHit),
								_this.getHitEl(dayClickHit),
								ev
							);
						}
						if (selectionSpan) {
							// the selection will already have been rendered. just report it
							view.reportSelection(selectionSpan, ev);
						}
					}
				}
			});
	
			return dragListener;
		},
	
	
		// Kills all in-progress dragging.
		// Useful for when public API methods that result in re-rendering are invoked during a drag.
		// Also useful for when touch devices misbehave and don't fire their touchend.
		clearDragListeners: function() {
			this.dayDragListener.endInteraction();
	
			if (this.segDragListener) {
				this.segDragListener.endInteraction(); // will clear this.segDragListener
			}
			if (this.segResizeListener) {
				this.segResizeListener.endInteraction(); // will clear this.segResizeListener
			}
			if (this.externalDragListener) {
				this.externalDragListener.endInteraction(); // will clear this.externalDragListener
			}
		},
	
	
		/* Event Helper
		------------------------------------------------------------------------------------------------------------------*/
		// TODO: should probably move this to Grid.events, like we did event dragging / resizing
	
	
		// Renders a mock event at the given event location, which contains zoned start/end properties.
		// Returns all mock event elements.
		renderEventLocationHelper: function(eventLocation, sourceSeg) {
			var fakeEvent = this.fabricateHelperEvent(eventLocation, sourceSeg);
	
			return this.renderHelper(fakeEvent, sourceSeg); // do the actual rendering
		},
	
	
		// Builds a fake event given zoned event date properties and a segment is should be inspired from.
		// The range's end can be null, in which case the mock event that is rendered will have a null end time.
		// `sourceSeg` is the internal segment object involved in the drag. If null, something external is dragging.
		fabricateHelperEvent: function(eventLocation, sourceSeg) {
			var fakeEvent = sourceSeg ? createObject(sourceSeg.event) : {}; // mask the original event object if possible
	
			fakeEvent.start = eventLocation.start.clone();
			fakeEvent.end = eventLocation.end ? eventLocation.end.clone() : null;
			fakeEvent.allDay = null; // force it to be freshly computed by normalizeEventDates
			this.view.calendar.normalizeEventDates(fakeEvent);
	
			// this extra className will be useful for differentiating real events from mock events in CSS
			fakeEvent.className = (fakeEvent.className || []).concat('fc-helper');
	
			// if something external is being dragged in, don't render a resizer
			if (!sourceSeg) {
				fakeEvent.editable = false;
			}
	
			return fakeEvent;
		},
	
	
		// Renders a mock event. Given zoned event date properties.
		// Must return all mock event elements.
		renderHelper: function(eventLocation, sourceSeg) {
			// subclasses must implement
		},
	
	
		// Unrenders a mock event
		unrenderHelper: function() {
			// subclasses must implement
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection. Will highlight by default but can be overridden by subclasses.
		// Given a span (unzoned start/end and other misc data)
		renderSelection: function(span) {
			this.renderHighlight(span);
		},
	
	
		// Unrenders any visual indications of a selection. Will unrender a highlight by default.
		unrenderSelection: function() {
			this.unrenderHighlight();
		},
	
	
		// Given the first and last date-spans of a selection, returns another date-span object.
		// Subclasses can override and provide additional data in the span object. Will be passed to renderSelection().
		// Will return false if the selection is invalid and this should be indicated to the user.
		// Will return null/undefined if a selection invalid but no error should be reported.
		computeSelection: function(span0, span1) {
			var span = this.computeSelectionSpan(span0, span1);
	
			if (span && !this.view.calendar.isSelectionSpanAllowed(span)) {
				return false;
			}
	
			return span;
		},
	
	
		// Given two spans, must return the combination of the two.
		// TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
		computeSelectionSpan: function(span0, span1) {
			var dates = [ span0.start, span0.end, span1.start, span1.end ];
	
			dates.sort(compareNumbers); // sorts chronologically. works with Moments
	
			return { start: dates[0].clone(), end: dates[3].clone() };
		},
	
	
		/* Highlight
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
		renderHighlight: function(span) {
			this.renderFill('highlight', this.spanToSegs(span));
		},
	
	
		// Unrenders the emphasis on a date range
		unrenderHighlight: function() {
			this.unrenderFill('highlight');
		},
	
	
		// Generates an array of classNames for rendering the highlight. Used by the fill system.
		highlightSegClasses: function() {
			return [ 'fc-highlight' ];
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessHours: function() {
		},
	
	
		unrenderBusinessHours: function() {
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		getNowIndicatorUnit: function() {
		},
	
	
		renderNowIndicator: function(date) {
		},
	
	
		unrenderNowIndicator: function() {
		},
	
	
		/* Fill System (highlight, background events, business hours)
		--------------------------------------------------------------------------------------------------------------------
		TODO: remove this system. like we did in TimeGrid
		*/
	
	
		// Renders a set of rectangles over the given segments of time.
		// MUST RETURN a subset of segs, the segs that were actually rendered.
		// Responsible for populating this.elsByFill. TODO: better API for expressing this requirement
		renderFill: function(type, segs) {
			// subclasses must implement
		},
	
	
		// Unrenders a specific type of fill that is currently rendered on the grid
		unrenderFill: function(type) {
			var el = this.elsByFill[type];
	
			if (el) {
				el.remove();
				delete this.elsByFill[type];
			}
		},
	
	
		// Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
		// Only returns segments that successfully rendered.
		// To be harnessed by renderFill (implemented by subclasses).
		// Analagous to renderFgSegEls.
		renderFillSegEls: function(type, segs) {
			var _this = this;
			var segElMethod = this[type + 'SegEl'];
			var html = '';
			var renderedSegs = [];
			var i;
	
			if (segs.length) {
	
				// build a large concatenation of segment HTML
				for (i = 0; i < segs.length; i++) {
					html += this.fillSegHtml(type, segs[i]);
				}
	
				// Grab individual elements from the combined HTML string. Use each as the default rendering.
				// Then, compute the 'el' for each segment.
				$(html).each(function(i, node) {
					var seg = segs[i];
					var el = $(node);
	
					// allow custom filter methods per-type
					if (segElMethod) {
						el = segElMethod.call(_this, seg, el);
					}
	
					if (el) { // custom filters did not cancel the render
						el = $(el); // allow custom filter to return raw DOM node
	
						// correct element type? (would be bad if a non-TD were inserted into a table for example)
						if (el.is(_this.fillSegTag)) {
							seg.el = el;
							renderedSegs.push(seg);
						}
					}
				});
			}
	
			return renderedSegs;
		},
	
	
		fillSegTag: 'div', // subclasses can override
	
	
		// Builds the HTML needed for one fill segment. Generic enough to work with different types.
		fillSegHtml: function(type, seg) {
	
			// custom hooks per-type
			var classesMethod = this[type + 'SegClasses'];
			var cssMethod = this[type + 'SegCss'];
	
			var classes = classesMethod ? classesMethod.call(this, seg) : [];
			var css = cssToStr(cssMethod ? cssMethod.call(this, seg) : {});
	
			return '<' + this.fillSegTag +
				(classes.length ? ' class="' + classes.join(' ') + '"' : '') +
				(css ? ' style="' + css + '"' : '') +
				' />';
		},
	
	
	
		/* Generic rendering utilities for subclasses
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes HTML classNames for a single-day element
		getDayClasses: function(date) {
			var view = this.view;
			var today = view.calendar.getNow();
			var classes = [ 'fc-' + dayIDs[date.day()] ];
	
			if (
				view.intervalDuration.as('months') == 1 &&
				date.month() != view.intervalStart.month()
			) {
				classes.push('fc-other-month');
			}
	
			if (date.isSame(today, 'day')) {
				classes.push(
					'fc-today',
					view.highlightStateClass
				);
			}
			else if (date < today) {
				classes.push('fc-past');
			}
			else {
				classes.push('fc-future');
			}
	
			return classes;
		}
	
	});
	
	;;
	
	/* Event-rendering and event-interaction methods for the abstract Grid class
	----------------------------------------------------------------------------------------------------------------------*/
	
	Grid.mixin({
	
		mousedOverSeg: null, // the segment object the user's mouse is over. null if over nothing
		isDraggingSeg: false, // is a segment being dragged? boolean
		isResizingSeg: false, // is a segment being resized? boolean
		isDraggingExternal: false, // jqui-dragging an external element? boolean
		segs: null, // the *event* segments currently rendered in the grid. TODO: rename to `eventSegs`
	
	
		// Renders the given events onto the grid
		renderEvents: function(events) {
			var bgEvents = [];
			var fgEvents = [];
			var i;
	
			for (i = 0; i < events.length; i++) {
				(isBgEvent(events[i]) ? bgEvents : fgEvents).push(events[i]);
			}
	
			this.segs = [].concat( // record all segs
				this.renderBgEvents(bgEvents),
				this.renderFgEvents(fgEvents)
			);
		},
	
	
		renderBgEvents: function(events) {
			var segs = this.eventsToSegs(events);
	
			// renderBgSegs might return a subset of segs, segs that were actually rendered
			return this.renderBgSegs(segs) || segs;
		},
	
	
		renderFgEvents: function(events) {
			var segs = this.eventsToSegs(events);
	
			// renderFgSegs might return a subset of segs, segs that were actually rendered
			return this.renderFgSegs(segs) || segs;
		},
	
	
		// Unrenders all events currently rendered on the grid
		unrenderEvents: function() {
			this.handleSegMouseout(); // trigger an eventMouseout if user's mouse is over an event
			this.clearDragListeners();
	
			this.unrenderFgSegs();
			this.unrenderBgSegs();
	
			this.segs = null;
		},
	
	
		// Retrieves all rendered segment objects currently rendered on the grid
		getEventSegs: function() {
			return this.segs || [];
		},
	
	
		/* Foreground Segment Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders foreground event segments onto the grid. May return a subset of segs that were rendered.
		renderFgSegs: function(segs) {
			// subclasses must implement
		},
	
	
		// Unrenders all currently rendered foreground segments
		unrenderFgSegs: function() {
			// subclasses must implement
		},
	
	
		// Renders and assigns an `el` property for each foreground event segment.
		// Only returns segments that successfully rendered.
		// A utility that subclasses may use.
		renderFgSegEls: function(segs, disableResizing) {
			var view = this.view;
			var html = '';
			var renderedSegs = [];
			var i;
	
			if (segs.length) { // don't build an empty html string
	
				// build a large concatenation of event segment HTML
				for (i = 0; i < segs.length; i++) {
					html += this.fgSegHtml(segs[i], disableResizing);
				}
	
				// Grab individual elements from the combined HTML string. Use each as the default rendering.
				// Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
				$(html).each(function(i, node) {
					var seg = segs[i];
					var el = view.resolveEventEl(seg.event, $(node));
	
					if (el) {
						el.data('fc-seg', seg); // used by handlers
						seg.el = el;
						renderedSegs.push(seg);
					}
				});
			}
	
			return renderedSegs;
		},
	
	
		// Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
		fgSegHtml: function(seg, disableResizing) {
			// subclasses should implement
		},
	
	
		/* Background Segment Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders the given background event segments onto the grid.
		// Returns a subset of the segs that were actually rendered.
		renderBgSegs: function(segs) {
			return this.renderFill('bgEvent', segs);
		},
	
	
		// Unrenders all the currently rendered background event segments
		unrenderBgSegs: function() {
			this.unrenderFill('bgEvent');
		},
	
	
		// Renders a background event element, given the default rendering. Called by the fill system.
		bgEventSegEl: function(seg, el) {
			return this.view.resolveEventEl(seg.event, el); // will filter through eventRender
		},
	
	
		// Generates an array of classNames to be used for the default rendering of a background event.
		// Called by fillSegHtml.
		bgEventSegClasses: function(seg) {
			var event = seg.event;
			var source = event.source || {};
	
			return [ 'fc-bgevent' ].concat(
				event.className,
				source.className || []
			);
		},
	
	
		// Generates a semicolon-separated CSS string to be used for the default rendering of a background event.
		// Called by fillSegHtml.
		bgEventSegCss: function(seg) {
			return {
				'background-color': this.getSegSkinCss(seg)['background-color']
			};
		},
	
	
		// Generates an array of classNames to be used for the rendering business hours overlay. Called by the fill system.
		// Called by fillSegHtml.
		businessHoursSegClasses: function(seg) {
			return [ 'fc-nonbusiness', 'fc-bgevent' ];
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Compute business hour segs for the grid's current date range.
		// Caller must ask if whole-day business hours are needed.
		buildBusinessHourSegs: function(wholeDay) {
			var events = this.view.calendar.getCurrentBusinessHourEvents(wholeDay);
	
			// HACK. Eventually refactor business hours "events" system.
			// If no events are given, but businessHours is activated, this means the entire visible range should be
			// marked as *not* business-hours, via inverse-background rendering.
			if (
				!events.length &&
				this.view.calendar.options.businessHours // don't access view option. doesn't update with dynamic options
			) {
				events = [
					$.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, {
						start: this.view.end, // guaranteed out-of-range
						end: this.view.end,   // "
						dow: null
					})
				];
			}
	
			return this.eventsToSegs(events);
		},
	
	
		/* Handlers
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Attaches event-element-related handlers for *all* rendered event segments of the view.
		bindSegHandlers: function() {
			this.bindSegHandlersToEl(this.el);
		},
	
	
		// Attaches event-element-related handlers to an arbitrary container element. leverages bubbling.
		bindSegHandlersToEl: function(el) {
			this.bindSegHandlerToEl(el, 'touchstart', this.handleSegTouchStart);
			this.bindSegHandlerToEl(el, 'touchend', this.handleSegTouchEnd);
			this.bindSegHandlerToEl(el, 'mouseenter', this.handleSegMouseover);
			this.bindSegHandlerToEl(el, 'mouseleave', this.handleSegMouseout);
			this.bindSegHandlerToEl(el, 'mousedown', this.handleSegMousedown);
			this.bindSegHandlerToEl(el, 'click', this.handleSegClick);
		},
	
	
		// Executes a handler for any a user-interaction on a segment.
		// Handler gets called with (seg, ev), and with the `this` context of the Grid
		bindSegHandlerToEl: function(el, name, handler) {
			var _this = this;
	
			el.on(name, '.fc-event-container > *', function(ev) {
				var seg = $(this).data('fc-seg'); // grab segment data. put there by View::renderEvents
	
				// only call the handlers if there is not a drag/resize in progress
				if (seg && !_this.isDraggingSeg && !_this.isResizingSeg) {
					return handler.call(_this, seg, ev); // context will be the Grid
				}
			});
		},
	
	
		handleSegClick: function(seg, ev) {
			return this.view.trigger('eventClick', seg.el[0], seg.event, ev); // can return `false` to cancel
		},
	
	
		// Updates internal state and triggers handlers for when an event element is moused over
		handleSegMouseover: function(seg, ev) {
			if (
				!this.isIgnoringMouse &&
				!this.mousedOverSeg
			) {
				this.mousedOverSeg = seg;
				seg.el.addClass('fc-allow-mouse-resize');
				this.view.trigger('eventMouseover', seg.el[0], seg.event, ev);
			}
		},
	
	
		// Updates internal state and triggers handlers for when an event element is moused out.
		// Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
		handleSegMouseout: function(seg, ev) {
			ev = ev || {}; // if given no args, make a mock mouse event
	
			if (this.mousedOverSeg) {
				seg = seg || this.mousedOverSeg; // if given no args, use the currently moused-over segment
				this.mousedOverSeg = null;
				seg.el.removeClass('fc-allow-mouse-resize');
				this.view.trigger('eventMouseout', seg.el[0], seg.event, ev);
			}
		},
	
	
		handleSegMousedown: function(seg, ev) {
			var isResizing = this.startSegResize(seg, ev, { distance: 5 });
	
			if (!isResizing && this.view.isEventDraggable(seg.event)) {
				this.buildSegDragListener(seg)
					.startInteraction(ev, {
						distance: 5
					});
			}
		},
	
	
		handleSegTouchStart: function(seg, ev) {
			var view = this.view;
			var event = seg.event;
			var isSelected = view.isEventSelected(event);
			var isDraggable = view.isEventDraggable(event);
			var isResizable = view.isEventResizable(event);
			var isResizing = false;
			var dragListener;
	
			if (isSelected && isResizable) {
				// only allow resizing of the event is selected
				isResizing = this.startSegResize(seg, ev);
			}
	
			if (!isResizing && (isDraggable || isResizable)) { // allowed to be selected?
	
				dragListener = isDraggable ?
					this.buildSegDragListener(seg) :
					this.buildSegSelectListener(seg); // seg isn't draggable, but still needs to be selected
	
				dragListener.startInteraction(ev, { // won't start if already started
					delay: isSelected ? 0 : this.view.opt('longPressDelay') // do delay if not already selected
				});
			}
	
			// a long tap simulates a mouseover. ignore this bogus mouseover.
			this.tempIgnoreMouse();
		},
	
	
		handleSegTouchEnd: function(seg, ev) {
			// touchstart+touchend = click, which simulates a mouseover.
			// ignore this bogus mouseover.
			this.tempIgnoreMouse();
		},
	
	
		// returns boolean whether resizing actually started or not.
		// assumes the seg allows resizing.
		// `dragOptions` are optional.
		startSegResize: function(seg, ev, dragOptions) {
			if ($(ev.target).is('.fc-resizer')) {
				this.buildSegResizeListener(seg, $(ev.target).is('.fc-start-resizer'))
					.startInteraction(ev, dragOptions);
				return true;
			}
			return false;
		},
	
	
	
		/* Event Dragging
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Builds a listener that will track user-dragging on an event segment.
		// Generic enough to work with any type of Grid.
		// Has side effect of setting/unsetting `segDragListener`
		buildSegDragListener: function(seg) {
			var _this = this;
			var view = this.view;
			var calendar = view.calendar;
			var el = seg.el;
			var event = seg.event;
			var isDragging;
			var mouseFollower; // A clone of the original element that will move with the mouse
			var dropLocation; // zoned event date properties
	
			if (this.segDragListener) {
				return this.segDragListener;
			}
	
			// Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
			// of the view.
			var dragListener = this.segDragListener = new HitDragListener(view, {
				scroll: view.opt('dragScroll'),
				subjectEl: el,
				subjectCenter: true,
				interactionStart: function(ev) {
					seg.component = _this; // for renderDrag
					isDragging = false;
					mouseFollower = new MouseFollower(seg.el, {
						additionalClass: 'fc-dragging',
						parentEl: view.el,
						opacity: dragListener.isTouch ? null : view.opt('dragOpacity'),
						revertDuration: view.opt('dragRevertDuration'),
						zIndex: 2 // one above the .fc-view
					});
					mouseFollower.hide(); // don't show until we know this is a real drag
					mouseFollower.start(ev);
				},
				dragStart: function(ev) {
					if (dragListener.isTouch && !view.isEventSelected(event)) {
						// if not previously selected, will fire after a delay. then, select the event
						view.selectEvent(event);
					}
					isDragging = true;
					_this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
					_this.segDragStart(seg, ev);
					view.hideEvent(event); // hide all event segments. our mouseFollower will take over
				},
				hitOver: function(hit, isOrig, origHit) {
					var dragHelperEls;
	
					// starting hit could be forced (DayGrid.limit)
					if (seg.hit) {
						origHit = seg.hit;
					}
	
					// since we are querying the parent view, might not belong to this grid
					dropLocation = _this.computeEventDrop(
						origHit.component.getHitSpan(origHit),
						hit.component.getHitSpan(hit),
						event
					);
	
					if (dropLocation && !calendar.isEventSpanAllowed(_this.eventToSpan(dropLocation), event)) {
						disableCursor();
						dropLocation = null;
					}
	
					// if a valid drop location, have the subclass render a visual indication
					if (dropLocation && (dragHelperEls = view.renderDrag(dropLocation, seg))) {
	
						dragHelperEls.addClass('fc-dragging');
						if (!dragListener.isTouch) {
							_this.applyDragOpacity(dragHelperEls);
						}
	
						mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
					}
					else {
						mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
					}
	
					if (isOrig) {
						dropLocation = null; // needs to have moved hits to be a valid drop
					}
				},
				hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
					view.unrenderDrag(); // unrender whatever was done in renderDrag
					mouseFollower.show(); // show in case we are moving out of all hits
					dropLocation = null;
				},
				hitDone: function() { // Called after a hitOut OR before a dragEnd
					enableCursor();
				},
				interactionEnd: function(ev) {
					delete seg.component; // prevent side effects
	
					// do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
					mouseFollower.stop(!dropLocation, function() {
						if (isDragging) {
							view.unrenderDrag();
							view.showEvent(event);
							_this.segDragStop(seg, ev);
						}
						if (dropLocation) {
							view.reportEventDrop(event, dropLocation, this.largeUnit, el, ev);
						}
					});
					_this.segDragListener = null;
				}
			});
	
			return dragListener;
		},
	
	
		// seg isn't draggable, but let's use a generic DragListener
		// simply for the delay, so it can be selected.
		// Has side effect of setting/unsetting `segDragListener`
		buildSegSelectListener: function(seg) {
			var _this = this;
			var view = this.view;
			var event = seg.event;
	
			if (this.segDragListener) {
				return this.segDragListener;
			}
	
			var dragListener = this.segDragListener = new DragListener({
				dragStart: function(ev) {
					if (dragListener.isTouch && !view.isEventSelected(event)) {
						// if not previously selected, will fire after a delay. then, select the event
						view.selectEvent(event);
					}
				},
				interactionEnd: function(ev) {
					_this.segDragListener = null;
				}
			});
	
			return dragListener;
		},
	
	
		// Called before event segment dragging starts
		segDragStart: function(seg, ev) {
			this.isDraggingSeg = true;
			this.view.trigger('eventDragStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Called after event segment dragging stops
		segDragStop: function(seg, ev) {
			this.isDraggingSeg = false;
			this.view.trigger('eventDragStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Given the spans an event drag began, and the span event was dropped, calculates the new zoned start/end/allDay
		// values for the event. Subclasses may override and set additional properties to be used by renderDrag.
		// A falsy returned value indicates an invalid drop.
		// DOES NOT consider overlap/constraint.
		computeEventDrop: function(startSpan, endSpan, event) {
			var calendar = this.view.calendar;
			var dragStart = startSpan.start;
			var dragEnd = endSpan.start;
			var delta;
			var dropLocation; // zoned event date properties
	
			if (dragStart.hasTime() === dragEnd.hasTime()) {
				delta = this.diffDates(dragEnd, dragStart);
	
				// if an all-day event was in a timed area and it was dragged to a different time,
				// guarantee an end and adjust start/end to have times
				if (event.allDay && durationHasTime(delta)) {
					dropLocation = {
						start: event.start.clone(),
						end: calendar.getEventEnd(event), // will be an ambig day
						allDay: false // for normalizeEventTimes
					};
					calendar.normalizeEventTimes(dropLocation);
				}
				// othewise, work off existing values
				else {
					dropLocation = {
						start: event.start.clone(),
						end: event.end ? event.end.clone() : null,
						allDay: event.allDay // keep it the same
					};
				}
	
				dropLocation.start.add(delta);
				if (dropLocation.end) {
					dropLocation.end.add(delta);
				}
			}
			else {
				// if switching from day <-> timed, start should be reset to the dropped date, and the end cleared
				dropLocation = {
					start: dragEnd.clone(),
					end: null, // end should be cleared
					allDay: !dragEnd.hasTime()
				};
			}
	
			return dropLocation;
		},
	
	
		// Utility for apply dragOpacity to a jQuery set
		applyDragOpacity: function(els) {
			var opacity = this.view.opt('dragOpacity');
	
			if (opacity != null) {
				els.each(function(i, node) {
					// Don't use jQuery (will set an IE filter), do it the old fashioned way.
					// In IE8, a helper element will disappears if there's a filter.
					node.style.opacity = opacity;
				});
			}
		},
	
	
		/* External Element Dragging
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Called when a jQuery UI drag is initiated anywhere in the DOM
		externalDragStart: function(ev, ui) {
			var view = this.view;
			var el;
			var accept;
	
			if (view.opt('droppable')) { // only listen if this setting is on
				el = $((ui ? ui.item : null) || ev.target);
	
				// Test that the dragged element passes the dropAccept selector or filter function.
				// FYI, the default is "*" (matches all)
				accept = view.opt('dropAccept');
				if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
					if (!this.isDraggingExternal) { // prevent double-listening if fired twice
						this.listenToExternalDrag(el, ev, ui);
					}
				}
			}
		},
	
	
		// Called when a jQuery UI drag starts and it needs to be monitored for dropping
		listenToExternalDrag: function(el, ev, ui) {
			var _this = this;
			var calendar = this.view.calendar;
			var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
			var dropLocation; // a null value signals an unsuccessful drag
	
			// listener that tracks mouse movement over date-associated pixel regions
			var dragListener = _this.externalDragListener = new HitDragListener(this, {
				interactionStart: function() {
					_this.isDraggingExternal = true;
				},
				hitOver: function(hit) {
					dropLocation = _this.computeExternalDrop(
						hit.component.getHitSpan(hit), // since we are querying the parent view, might not belong to this grid
						meta
					);
	
					if ( // invalid hit?
						dropLocation &&
						!calendar.isExternalSpanAllowed(_this.eventToSpan(dropLocation), dropLocation, meta.eventProps)
					) {
						disableCursor();
						dropLocation = null;
					}
	
					if (dropLocation) {
						_this.renderDrag(dropLocation); // called without a seg parameter
					}
				},
				hitOut: function() {
					dropLocation = null; // signal unsuccessful
				},
				hitDone: function() { // Called after a hitOut OR before a dragEnd
					enableCursor();
					_this.unrenderDrag();
				},
				interactionEnd: function(ev) {
					if (dropLocation) { // element was dropped on a valid hit
						_this.view.reportExternalDrop(meta, dropLocation, el, ev, ui);
					}
					_this.isDraggingExternal = false;
					_this.externalDragListener = null;
				}
			});
	
			dragListener.startDrag(ev); // start listening immediately
		},
	
	
		// Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
		// returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
		// Returning a null value signals an invalid drop hit.
		// DOES NOT consider overlap/constraint.
		computeExternalDrop: function(span, meta) {
			var calendar = this.view.calendar;
			var dropLocation = {
				start: calendar.applyTimezone(span.start), // simulate a zoned event start date
				end: null
			};
	
			// if dropped on an all-day span, and element's metadata specified a time, set it
			if (meta.startTime && !dropLocation.start.hasTime()) {
				dropLocation.start.time(meta.startTime);
			}
	
			if (meta.duration) {
				dropLocation.end = dropLocation.start.clone().add(meta.duration);
			}
	
			return dropLocation;
		},
	
	
	
		/* Drag Rendering (for both events and an external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event or external element being dragged.
		// `dropLocation` contains hypothetical start/end/allDay values the event would have if dropped. end can be null.
		// `seg` is the internal segment object that is being dragged. If dragging an external element, `seg` is null.
		// A truthy returned value indicates this method has rendered a helper element.
		// Must return elements used for any mock events.
		renderDrag: function(dropLocation, seg) {
			// subclasses must implement
		},
	
	
		// Unrenders a visual indication of an event or external element being dragged
		unrenderDrag: function() {
			// subclasses must implement
		},
	
	
		/* Resizing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Creates a listener that tracks the user as they resize an event segment.
		// Generic enough to work with any type of Grid.
		buildSegResizeListener: function(seg, isStart) {
			var _this = this;
			var view = this.view;
			var calendar = view.calendar;
			var el = seg.el;
			var event = seg.event;
			var eventEnd = calendar.getEventEnd(event);
			var isDragging;
			var resizeLocation; // zoned event date properties. falsy if invalid resize
	
			// Tracks mouse movement over the *grid's* coordinate map
			var dragListener = this.segResizeListener = new HitDragListener(this, {
				scroll: view.opt('dragScroll'),
				subjectEl: el,
				interactionStart: function() {
					isDragging = false;
				},
				dragStart: function(ev) {
					isDragging = true;
					_this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
					_this.segResizeStart(seg, ev);
				},
				hitOver: function(hit, isOrig, origHit) {
					var origHitSpan = _this.getHitSpan(origHit);
					var hitSpan = _this.getHitSpan(hit);
	
					resizeLocation = isStart ?
						_this.computeEventStartResize(origHitSpan, hitSpan, event) :
						_this.computeEventEndResize(origHitSpan, hitSpan, event);
	
					if (resizeLocation) {
						if (!calendar.isEventSpanAllowed(_this.eventToSpan(resizeLocation), event)) {
							disableCursor();
							resizeLocation = null;
						}
						// no change? (TODO: how does this work with timezones?)
						else if (resizeLocation.start.isSame(event.start) && resizeLocation.end.isSame(eventEnd)) {
							resizeLocation = null;
						}
					}
	
					if (resizeLocation) {
						view.hideEvent(event);
						_this.renderEventResize(resizeLocation, seg);
					}
				},
				hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
					resizeLocation = null;
				},
				hitDone: function() { // resets the rendering to show the original event
					_this.unrenderEventResize();
					view.showEvent(event);
					enableCursor();
				},
				interactionEnd: function(ev) {
					if (isDragging) {
						_this.segResizeStop(seg, ev);
					}
					if (resizeLocation) { // valid date to resize to?
						view.reportEventResize(event, resizeLocation, this.largeUnit, el, ev);
					}
					_this.segResizeListener = null;
				}
			});
	
			return dragListener;
		},
	
	
		// Called before event segment resizing starts
		segResizeStart: function(seg, ev) {
			this.isResizingSeg = true;
			this.view.trigger('eventResizeStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Called after event segment resizing stops
		segResizeStop: function(seg, ev) {
			this.isResizingSeg = false;
			this.view.trigger('eventResizeStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Returns new date-information for an event segment being resized from its start
		computeEventStartResize: function(startSpan, endSpan, event) {
			return this.computeEventResize('start', startSpan, endSpan, event);
		},
	
	
		// Returns new date-information for an event segment being resized from its end
		computeEventEndResize: function(startSpan, endSpan, event) {
			return this.computeEventResize('end', startSpan, endSpan, event);
		},
	
	
		// Returns new zoned date information for an event segment being resized from its start OR end
		// `type` is either 'start' or 'end'.
		// DOES NOT consider overlap/constraint.
		computeEventResize: function(type, startSpan, endSpan, event) {
			var calendar = this.view.calendar;
			var delta = this.diffDates(endSpan[type], startSpan[type]);
			var resizeLocation; // zoned event date properties
			var defaultDuration;
	
			// build original values to work from, guaranteeing a start and end
			resizeLocation = {
				start: event.start.clone(),
				end: calendar.getEventEnd(event),
				allDay: event.allDay
			};
	
			// if an all-day event was in a timed area and was resized to a time, adjust start/end to have times
			if (resizeLocation.allDay && durationHasTime(delta)) {
				resizeLocation.allDay = false;
				calendar.normalizeEventTimes(resizeLocation);
			}
	
			resizeLocation[type].add(delta); // apply delta to start or end
	
			// if the event was compressed too small, find a new reasonable duration for it
			if (!resizeLocation.start.isBefore(resizeLocation.end)) {
	
				defaultDuration =
					this.minResizeDuration || // TODO: hack
					(event.allDay ?
						calendar.defaultAllDayEventDuration :
						calendar.defaultTimedEventDuration);
	
				if (type == 'start') { // resizing the start?
					resizeLocation.start = resizeLocation.end.clone().subtract(defaultDuration);
				}
				else { // resizing the end?
					resizeLocation.end = resizeLocation.start.clone().add(defaultDuration);
				}
			}
	
			return resizeLocation;
		},
	
	
		// Renders a visual indication of an event being resized.
		// `range` has the updated dates of the event. `seg` is the original segment object involved in the drag.
		// Must return elements used for any mock events.
		renderEventResize: function(range, seg) {
			// subclasses must implement
		},
	
	
		// Unrenders a visual indication of an event being resized.
		unrenderEventResize: function() {
			// subclasses must implement
		},
	
	
		/* Rendering Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Compute the text that should be displayed on an event's element.
		// `range` can be the Event object itself, or something range-like, with at least a `start`.
		// If event times are disabled, or the event has no time, will return a blank string.
		// If not specified, formatStr will default to the eventTimeFormat setting,
		// and displayEnd will default to the displayEventEnd setting.
		getEventTimeText: function(range, formatStr, displayEnd) {
	
			if (formatStr == null) {
				formatStr = this.eventTimeFormat;
			}
	
			if (displayEnd == null) {
				displayEnd = this.displayEventEnd;
			}
	
			if (this.displayEventTime && range.start.hasTime()) {
				if (displayEnd && range.end) {
					return this.view.formatRange(range, formatStr);
				}
				else {
					return range.start.format(formatStr);
				}
			}
	
			return '';
		},
	
	
		// Generic utility for generating the HTML classNames for an event segment's element
		getSegClasses: function(seg, isDraggable, isResizable) {
			var view = this.view;
			var event = seg.event;
			var classes = [
				'fc-event',
				seg.isStart ? 'fc-start' : 'fc-not-start',
				seg.isEnd ? 'fc-end' : 'fc-not-end'
			].concat(
				event.className,
				event.source ? event.source.className : []
			);
	
			if (isDraggable) {
				classes.push('fc-draggable');
			}
			if (isResizable) {
				classes.push('fc-resizable');
			}
	
			// event is currently selected? attach a className.
			if (view.isEventSelected(event)) {
				classes.push('fc-selected');
			}
	
			return classes;
		},
	
	
		// Utility for generating event skin-related CSS properties
		getSegSkinCss: function(seg) {
			var event = seg.event;
			var view = this.view;
			var source = event.source || {};
			var eventColor = event.color;
			var sourceColor = source.color;
			var optionColor = view.opt('eventColor');
	
			return {
				'background-color':
					event.backgroundColor ||
					eventColor ||
					source.backgroundColor ||
					sourceColor ||
					view.opt('eventBackgroundColor') ||
					optionColor,
				'border-color':
					event.borderColor ||
					eventColor ||
					source.borderColor ||
					sourceColor ||
					view.opt('eventBorderColor') ||
					optionColor,
				color:
					event.textColor ||
					source.textColor ||
					view.opt('eventTextColor')
			};
		},
	
	
		/* Converting events -> eventRange -> eventSpan -> eventSegs
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates an array of segments for the given single event
		// Can accept an event "location" as well (which only has start/end and no allDay)
		eventToSegs: function(event) {
			return this.eventsToSegs([ event ]);
		},
	
	
		eventToSpan: function(event) {
			return this.eventToSpans(event)[0];
		},
	
	
		// Generates spans (always unzoned) for the given event.
		// Does not do any inverting for inverse-background events.
		// Can accept an event "location" as well (which only has start/end and no allDay)
		eventToSpans: function(event) {
			var range = this.eventToRange(event);
			return this.eventRangeToSpans(range, event);
		},
	
	
	
		// Converts an array of event objects into an array of event segment objects.
		// A custom `segSliceFunc` may be given for arbitrarily slicing up events.
		// Doesn't guarantee an order for the resulting array.
		eventsToSegs: function(allEvents, segSliceFunc) {
			var _this = this;
			var eventsById = groupEventsById(allEvents);
			var segs = [];
	
			$.each(eventsById, function(id, events) {
				var ranges = [];
				var i;
	
				for (i = 0; i < events.length; i++) {
					ranges.push(_this.eventToRange(events[i]));
				}
	
				// inverse-background events (utilize only the first event in calculations)
				if (isInverseBgEvent(events[0])) {
					ranges = _this.invertRanges(ranges);
	
					for (i = 0; i < ranges.length; i++) {
						segs.push.apply(segs, // append to
							_this.eventRangeToSegs(ranges[i], events[0], segSliceFunc));
					}
				}
				// normal event ranges
				else {
					for (i = 0; i < ranges.length; i++) {
						segs.push.apply(segs, // append to
							_this.eventRangeToSegs(ranges[i], events[i], segSliceFunc));
					}
				}
			});
	
			return segs;
		},
	
	
		// Generates the unzoned start/end dates an event appears to occupy
		// Can accept an event "location" as well (which only has start/end and no allDay)
		eventToRange: function(event) {
			return {
				start: event.start.clone().stripZone(),
				end: (
					event.end ?
						event.end.clone() :
						// derive the end from the start and allDay. compute allDay if necessary
						this.view.calendar.getDefaultEventEnd(
							event.allDay != null ?
								event.allDay :
								!event.start.hasTime(),
							event.start
						)
				).stripZone()
			};
		},
	
	
		// Given an event's range (unzoned start/end), and the event itself,
		// slice into segments (using the segSliceFunc function if specified)
		eventRangeToSegs: function(range, event, segSliceFunc) {
			var spans = this.eventRangeToSpans(range, event);
			var segs = [];
			var i;
	
			for (i = 0; i < spans.length; i++) {
				segs.push.apply(segs, // append to
					this.eventSpanToSegs(spans[i], event, segSliceFunc));
			}
	
			return segs;
		},
	
	
		// Given an event's unzoned date range, return an array of "span" objects.
		// Subclasses can override.
		eventRangeToSpans: function(range, event) {
			return [ $.extend({}, range) ]; // copy into a single-item array
		},
	
	
		// Given an event's span (unzoned start/end and other misc data), and the event itself,
		// slices into segments and attaches event-derived properties to them.
		eventSpanToSegs: function(span, event, segSliceFunc) {
			var segs = segSliceFunc ? segSliceFunc(span) : this.spanToSegs(span);
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.event = event;
				seg.eventStartMS = +span.start; // TODO: not the best name after making spans unzoned
				seg.eventDurationMS = span.end - span.start;
			}
	
			return segs;
		},
	
	
		// Produces a new array of range objects that will cover all the time NOT covered by the given ranges.
		// SIDE EFFECT: will mutate the given array and will use its date references.
		invertRanges: function(ranges) {
			var view = this.view;
			var viewStart = view.start.clone(); // need a copy
			var viewEnd = view.end.clone(); // need a copy
			var inverseRanges = [];
			var start = viewStart; // the end of the previous range. the start of the new range
			var i, range;
	
			// ranges need to be in order. required for our date-walking algorithm
			ranges.sort(compareRanges);
	
			for (i = 0; i < ranges.length; i++) {
				range = ranges[i];
	
				// add the span of time before the event (if there is any)
				if (range.start > start) { // compare millisecond time (skip any ambig logic)
					inverseRanges.push({
						start: start,
						end: range.start
					});
				}
	
				start = range.end;
			}
	
			// add the span of time after the last event (if there is any)
			if (start < viewEnd) { // compare millisecond time (skip any ambig logic)
				inverseRanges.push({
					start: start,
					end: viewEnd
				});
			}
	
			return inverseRanges;
		},
	
	
		sortEventSegs: function(segs) {
			segs.sort(proxy(this, 'compareEventSegs'));
		},
	
	
		// A cmp function for determining which segments should take visual priority
		compareEventSegs: function(seg1, seg2) {
			return seg1.eventStartMS - seg2.eventStartMS || // earlier events go first
				seg2.eventDurationMS - seg1.eventDurationMS || // tie? longer events go first
				seg2.event.allDay - seg1.event.allDay || // tie? put all-day events first (booleans cast to 0/1)
				compareByFieldSpecs(seg1.event, seg2.event, this.view.eventOrderSpecs);
		}
	
	});
	
	
	/* Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	
	function isBgEvent(event) { // returns true if background OR inverse-background
		var rendering = getEventRendering(event);
		return rendering === 'background' || rendering === 'inverse-background';
	}
	FC.isBgEvent = isBgEvent; // export
	
	
	function isInverseBgEvent(event) {
		return getEventRendering(event) === 'inverse-background';
	}
	
	
	function getEventRendering(event) {
		return firstDefined((event.source || {}).rendering, event.rendering);
	}
	
	
	function groupEventsById(events) {
		var eventsById = {};
		var i, event;
	
		for (i = 0; i < events.length; i++) {
			event = events[i];
			(eventsById[event._id] || (eventsById[event._id] = [])).push(event);
		}
	
		return eventsById;
	}
	
	
	// A cmp function for determining which non-inverted "ranges" (see above) happen earlier
	function compareRanges(range1, range2) {
		return range1.start - range2.start; // earlier ranges go first
	}
	
	
	/* External-Dragging-Element Data
	----------------------------------------------------------------------------------------------------------------------*/
	
	// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
	// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
	FC.dataAttrPrefix = '';
	
	// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
	// to be used for Event Object creation.
	// A defined `.eventProps`, even when empty, indicates that an event should be created.
	function getDraggedElMeta(el) {
		var prefix = FC.dataAttrPrefix;
		var eventProps; // properties for creating the event, not related to date/time
		var startTime; // a Duration
		var duration;
		var stick;
	
		if (prefix) { prefix += '-'; }
		eventProps = el.data(prefix + 'event') || null;
	
		if (eventProps) {
			if (typeof eventProps === 'object') {
				eventProps = $.extend({}, eventProps); // make a copy
			}
			else { // something like 1 or true. still signal event creation
				eventProps = {};
			}
	
			// pluck special-cased date/time properties
			startTime = eventProps.start;
			if (startTime == null) { startTime = eventProps.time; } // accept 'time' as well
			duration = eventProps.duration;
			stick = eventProps.stick;
			delete eventProps.start;
			delete eventProps.time;
			delete eventProps.duration;
			delete eventProps.stick;
		}
	
		// fallback to standalone attribute values for each of the date/time properties
		if (startTime == null) { startTime = el.data(prefix + 'start'); }
		if (startTime == null) { startTime = el.data(prefix + 'time'); } // accept 'time' as well
		if (duration == null) { duration = el.data(prefix + 'duration'); }
		if (stick == null) { stick = el.data(prefix + 'stick'); }
	
		// massage into correct data types
		startTime = startTime != null ? moment.duration(startTime) : null;
		duration = duration != null ? moment.duration(duration) : null;
		stick = Boolean(stick);
	
		return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
	}
	
	
	;;
	
	/*
	A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
	Prerequisite: the object being mixed into needs to be a *Grid*
	*/
	var DayTableMixin = FC.DayTableMixin = {
	
		breakOnWeeks: false, // should create a new row for each week?
		dayDates: null, // whole-day dates for each column. left to right
		dayIndices: null, // for each day from start, the offset
		daysPerRow: null,
		rowCnt: null,
		colCnt: null,
		colHeadFormat: null,
	
	
		// Populates internal variables used for date calculation and rendering
		updateDayTable: function() {
			var view = this.view;
			var date = this.start.clone();
			var dayIndex = -1;
			var dayIndices = [];
			var dayDates = [];
			var daysPerRow;
			var firstDay;
			var rowCnt;
	
			while (date.isBefore(this.end)) { // loop each day from start to end
				if (view.isHiddenDay(date)) {
					dayIndices.push(dayIndex + 0.5); // mark that it's between indices
				}
				else {
					dayIndex++;
					dayIndices.push(dayIndex);
					dayDates.push(date.clone());
				}
				date.add(1, 'days');
			}
	
			if (this.breakOnWeeks) {
				// count columns until the day-of-week repeats
				firstDay = dayDates[0].day();
				for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
					if (dayDates[daysPerRow].day() == firstDay) {
						break;
					}
				}
				rowCnt = Math.ceil(dayDates.length / daysPerRow);
			}
			else {
				rowCnt = 1;
				daysPerRow = dayDates.length;
			}
	
			this.dayDates = dayDates;
			this.dayIndices = dayIndices;
			this.daysPerRow = daysPerRow;
			this.rowCnt = rowCnt;
			
			this.updateDayTableCols();
		},
	
	
		// Computes and assigned the colCnt property and updates any options that may be computed from it
		updateDayTableCols: function() {
			this.colCnt = this.computeColCnt();
			this.colHeadFormat = this.view.opt('columnFormat') || this.computeColHeadFormat();
		},
	
	
		// Determines how many columns there should be in the table
		computeColCnt: function() {
			return this.daysPerRow;
		},
	
	
		// Computes the ambiguously-timed moment for the given cell
		getCellDate: function(row, col) {
			return this.dayDates[
					this.getCellDayIndex(row, col)
				].clone();
		},
	
	
		// Computes the ambiguously-timed date range for the given cell
		getCellRange: function(row, col) {
			var start = this.getCellDate(row, col);
			var end = start.clone().add(1, 'days');
	
			return { start: start, end: end };
		},
	
	
		// Returns the number of day cells, chronologically, from the first of the grid (0-based)
		getCellDayIndex: function(row, col) {
			return row * this.daysPerRow + this.getColDayIndex(col);
		},
	
	
		// Returns the numner of day cells, chronologically, from the first cell in *any given row*
		getColDayIndex: function(col) {
			if (this.isRTL) {
				return this.colCnt - 1 - col;
			}
			else {
				return col;
			}
		},
	
	
		// Given a date, returns its chronolocial cell-index from the first cell of the grid.
		// If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
		// If before the first offset, returns a negative number.
		// If after the last offset, returns an offset past the last cell offset.
		// Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
		getDateDayIndex: function(date) {
			var dayIndices = this.dayIndices;
			var dayOffset = date.diff(this.start, 'days');
	
			if (dayOffset < 0) {
				return dayIndices[0] - 1;
			}
			else if (dayOffset >= dayIndices.length) {
				return dayIndices[dayIndices.length - 1] + 1;
			}
			else {
				return dayIndices[dayOffset];
			}
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes a default column header formatting string if `colFormat` is not explicitly defined
		computeColHeadFormat: function() {
			// if more than one week row, or if there are a lot of columns with not much space,
			// put just the day numbers will be in each cell
			if (this.rowCnt > 1 || this.colCnt > 10) {
				return 'ddd'; // "Sat"
			}
			// multiple days, so full single date string WON'T be in title text
			else if (this.colCnt > 1) {
				return this.view.opt('dayOfMonthFormat'); // "Sat 12/10"
			}
			// single day, so full single date string will probably be in title text
			else {
				return 'dddd'; // "Saturday"
			}
		},
	
	
		/* Slicing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Slices up a date range into a segment for every week-row it intersects with
		sliceRangeByRow: function(range) {
			var daysPerRow = this.daysPerRow;
			var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
			var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
			var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
			var segs = [];
			var row;
			var rowFirst, rowLast; // inclusive day-index range for current row
			var segFirst, segLast; // inclusive day-index range for segment
	
			for (row = 0; row < this.rowCnt; row++) {
				rowFirst = row * daysPerRow;
				rowLast = rowFirst + daysPerRow - 1;
	
				// intersect segment's offset range with the row's
				segFirst = Math.max(rangeFirst, rowFirst);
				segLast = Math.min(rangeLast, rowLast);
	
				// deal with in-between indices
				segFirst = Math.ceil(segFirst); // in-between starts round to next cell
				segLast = Math.floor(segLast); // in-between ends round to prev cell
	
				if (segFirst <= segLast) { // was there any intersection with the current row?
					segs.push({
						row: row,
	
						// normalize to start of row
						firstRowDayIndex: segFirst - rowFirst,
						lastRowDayIndex: segLast - rowFirst,
	
						// must be matching integers to be the segment's start/end
						isStart: segFirst === rangeFirst,
						isEnd: segLast === rangeLast
					});
				}
			}
	
			return segs;
		},
	
	
		// Slices up a date range into a segment for every day-cell it intersects with.
		// TODO: make more DRY with sliceRangeByRow somehow.
		sliceRangeByDay: function(range) {
			var daysPerRow = this.daysPerRow;
			var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
			var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
			var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
			var segs = [];
			var row;
			var rowFirst, rowLast; // inclusive day-index range for current row
			var i;
			var segFirst, segLast; // inclusive day-index range for segment
	
			for (row = 0; row < this.rowCnt; row++) {
				rowFirst = row * daysPerRow;
				rowLast = rowFirst + daysPerRow - 1;
	
				for (i = rowFirst; i <= rowLast; i++) {
	
					// intersect segment's offset range with the row's
					segFirst = Math.max(rangeFirst, i);
					segLast = Math.min(rangeLast, i);
	
					// deal with in-between indices
					segFirst = Math.ceil(segFirst); // in-between starts round to next cell
					segLast = Math.floor(segLast); // in-between ends round to prev cell
	
					if (segFirst <= segLast) { // was there any intersection with the current row?
						segs.push({
							row: row,
	
							// normalize to start of row
							firstRowDayIndex: segFirst - rowFirst,
							lastRowDayIndex: segLast - rowFirst,
	
							// must be matching integers to be the segment's start/end
							isStart: segFirst === rangeFirst,
							isEnd: segLast === rangeLast
						});
					}
				}
			}
	
			return segs;
		},
	
	
		/* Header Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHeadHtml: function() {
			var view = this.view;
	
			return '' +
				'<div class="fc-row ' + view.widgetHeaderClass + '">' +
					'<table>' +
						'<thead>' +
							this.renderHeadTrHtml() +
						'</thead>' +
					'</table>' +
				'</div>';
		},
	
	
		renderHeadIntroHtml: function() {
			return this.renderIntroHtml(); // fall back to generic
		},
	
	
		renderHeadTrHtml: function() {
			return '' +
				'<tr>' +
					(this.isRTL ? '' : this.renderHeadIntroHtml()) +
					this.renderHeadDateCellsHtml() +
					(this.isRTL ? this.renderHeadIntroHtml() : '') +
				'</tr>';
		},
	
	
		renderHeadDateCellsHtml: function() {
			var htmls = [];
			var col, date;
	
			for (col = 0; col < this.colCnt; col++) {
				date = this.getCellDate(0, col);
				htmls.push(this.renderHeadDateCellHtml(date));
			}
	
			return htmls.join('');
		},
	
	
		// TODO: when internalApiVersion, accept an object for HTML attributes
		// (colspan should be no different)
		renderHeadDateCellHtml: function(date, colspan, otherAttrs) {
			var view = this.view;
	
			return '' +
				'<th class="fc-day-header ' + view.widgetHeaderClass + ' fc-' + dayIDs[date.day()] + '"' +
					(this.rowCnt == 1 ?
						' data-date="' + date.format('YYYY-MM-DD') + '"' :
						'') +
					(colspan > 1 ?
						' colspan="' + colspan + '"' :
						'') +
					(otherAttrs ?
						' ' + otherAttrs :
						'') +
				'>' +
					htmlEscape(date.format(this.colHeadFormat)) +
				'</th>';
		},
	
	
		/* Background Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBgTrHtml: function(row) {
			return '' +
				'<tr>' +
					(this.isRTL ? '' : this.renderBgIntroHtml(row)) +
					this.renderBgCellsHtml(row) +
					(this.isRTL ? this.renderBgIntroHtml(row) : '') +
				'</tr>';
		},
	
	
		renderBgIntroHtml: function(row) {
			return this.renderIntroHtml(); // fall back to generic
		},
	
	
		renderBgCellsHtml: function(row) {
			var htmls = [];
			var col, date;
	
			for (col = 0; col < this.colCnt; col++) {
				date = this.getCellDate(row, col);
				htmls.push(this.renderBgCellHtml(date));
			}
	
			return htmls.join('');
		},
	
	
		renderBgCellHtml: function(date, otherAttrs) {
			var view = this.view;
			var classes = this.getDayClasses(date);
	
			classes.unshift('fc-day', view.widgetContentClass);
	
			return '<td class="' + classes.join(' ') + '"' +
				' data-date="' + date.format('YYYY-MM-DD') + '"' + // if date has a time, won't format it
				(otherAttrs ?
					' ' + otherAttrs :
					'') +
				'></td>';
		},
	
	
		/* Generic
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates the default HTML intro for any row. User classes should override
		renderIntroHtml: function() {
		},
	
	
		// TODO: a generic method for dealing with <tr>, RTL, intro
		// when increment internalApiVersion
		// wrapTr (scheduler)
	
	
		/* Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Applies the generic "intro" and "outro" HTML to the given cells.
		// Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
		bookendCells: function(trEl) {
			var introHtml = this.renderIntroHtml();
	
			if (introHtml) {
				if (this.isRTL) {
					trEl.append(introHtml);
				}
				else {
					trEl.prepend(introHtml);
				}
			}
		}
	
	};
	
	;;
	
	/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
	----------------------------------------------------------------------------------------------------------------------*/
	
	var DayGrid = FC.DayGrid = Grid.extend(DayTableMixin, {
	
		numbersVisible: false, // should render a row for day/week numbers? set by outside view. TODO: make internal
		bottomCoordPadding: 0, // hack for extending the hit area for the last row of the coordinate grid
	
		rowEls: null, // set of fake row elements
		cellEls: null, // set of whole-day elements comprising the row's background
		helperEls: null, // set of cell skeleton elements for rendering the mock event "helper"
	
		rowCoordCache: null,
		colCoordCache: null,
	
	
		// Renders the rows and columns into the component's `this.el`, which should already be assigned.
		// isRigid determins whether the individual rows should ignore the contents and be a constant height.
		// Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
		renderDates: function(isRigid) {
			var view = this.view;
			var rowCnt = this.rowCnt;
			var colCnt = this.colCnt;
			var html = '';
			var row;
			var col;
	
			for (row = 0; row < rowCnt; row++) {
				html += this.renderDayRowHtml(row, isRigid);
			}
			this.el.html(html);
	
			this.rowEls = this.el.find('.fc-row');
			this.cellEls = this.el.find('.fc-day');
	
			this.rowCoordCache = new CoordCache({
				els: this.rowEls,
				isVertical: true
			});
			this.colCoordCache = new CoordCache({
				els: this.cellEls.slice(0, this.colCnt), // only the first row
				isHorizontal: true
			});
	
			// trigger dayRender with each cell's element
			for (row = 0; row < rowCnt; row++) {
				for (col = 0; col < colCnt; col++) {
					view.trigger(
						'dayRender',
						null,
						this.getCellDate(row, col),
						this.getCellEl(row, col)
					);
				}
			}
		},
	
	
		unrenderDates: function() {
			this.removeSegPopover();
		},
	
	
		renderBusinessHours: function() {
			var segs = this.buildBusinessHourSegs(true); // wholeDay=true
			this.renderFill('businessHours', segs, 'bgevent');
		},
	
	
		unrenderBusinessHours: function() {
			this.unrenderFill('businessHours');
		},
	
	
		// Generates the HTML for a single row, which is a div that wraps a table.
		// `row` is the row number.
		renderDayRowHtml: function(row, isRigid) {
			var view = this.view;
			var classes = [ 'fc-row', 'fc-week', view.widgetContentClass ];
	
			if (isRigid) {
				classes.push('fc-rigid');
			}
	
			return '' +
				'<div class="' + classes.join(' ') + '">' +
					'<div class="fc-bg">' +
						'<table>' +
							this.renderBgTrHtml(row) +
						'</table>' +
					'</div>' +
					'<div class="fc-content-skeleton">' +
						'<table>' +
							(this.numbersVisible ?
								'<thead>' +
									this.renderNumberTrHtml(row) +
								'</thead>' :
								''
								) +
						'</table>' +
					'</div>' +
				'</div>';
		},
	
	
		/* Grid Number Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderNumberTrHtml: function(row) {
			return '' +
				'<tr>' +
					(this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
					this.renderNumberCellsHtml(row) +
					(this.isRTL ? this.renderNumberIntroHtml(row) : '') +
				'</tr>';
		},
	
	
		renderNumberIntroHtml: function(row) {
			return this.renderIntroHtml();
		},
	
	
		renderNumberCellsHtml: function(row) {
			var htmls = [];
			var col, date;
	
			for (col = 0; col < this.colCnt; col++) {
				date = this.getCellDate(row, col);
				htmls.push(this.renderNumberCellHtml(date));
			}
	
			return htmls.join('');
		},
	
	
		// Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
		// The number row will only exist if either day numbers or week numbers are turned on.
		renderNumberCellHtml: function(date) {
			var classes;
	
			if (!this.view.dayNumbersVisible) { // if there are week numbers but not day numbers
				return '<td/>'; //  will create an empty space above events :(
			}
	
			classes = this.getDayClasses(date);
			classes.unshift('fc-day-number');
	
			return '' +
				'<td class="' + classes.join(' ') + '" data-date="' + date.format() + '">' +
					date.date() +
				'</td>';
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes a default event time formatting string if `timeFormat` is not explicitly defined
		computeEventTimeFormat: function() {
			return this.view.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
		},
	
	
		// Computes a default `displayEventEnd` value if one is not expliclty defined
		computeDisplayEventEnd: function() {
			return this.colCnt == 1; // we'll likely have space if there's only one day
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		rangeUpdated: function() {
			this.updateDayTable();
		},
	
	
		// Slices up the given span (unzoned start/end with other misc data) into an array of segments
		spanToSegs: function(span) {
			var segs = this.sliceRangeByRow(span);
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				if (this.isRTL) {
					seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
					seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
				}
				else {
					seg.leftCol = seg.firstRowDayIndex;
					seg.rightCol = seg.lastRowDayIndex;
				}
			}
	
			return segs;
		},
	
	
		/* Hit System
		------------------------------------------------------------------------------------------------------------------*/
	
	
		prepareHits: function() {
			this.colCoordCache.build();
			this.rowCoordCache.build();
			this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
		},
	
	
		releaseHits: function() {
			this.colCoordCache.clear();
			this.rowCoordCache.clear();
		},
	
	
		queryHit: function(leftOffset, topOffset) {
			if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
				var col = this.colCoordCache.getHorizontalIndex(leftOffset);
				var row = this.rowCoordCache.getVerticalIndex(topOffset);
	
				if (row != null && col != null) {
					return this.getCellHit(row, col);
				}
			}
		},
	
	
		getHitSpan: function(hit) {
			return this.getCellRange(hit.row, hit.col);
		},
	
	
		getHitEl: function(hit) {
			return this.getCellEl(hit.row, hit.col);
		},
	
	
		/* Cell System
		------------------------------------------------------------------------------------------------------------------*/
		// FYI: the first column is the leftmost column, regardless of date
	
	
		getCellHit: function(row, col) {
			return {
				row: row,
				col: col,
				component: this, // needed unfortunately :(
				left: this.colCoordCache.getLeftOffset(col),
				right: this.colCoordCache.getRightOffset(col),
				top: this.rowCoordCache.getTopOffset(row),
				bottom: this.rowCoordCache.getBottomOffset(row)
			};
		},
	
	
		getCellEl: function(row, col) {
			return this.cellEls.eq(row * this.colCnt + col);
		},
	
	
		/* Event Drag Visualization
		------------------------------------------------------------------------------------------------------------------*/
		// TODO: move to DayGrid.event, similar to what we did with Grid's drag methods
	
	
		// Renders a visual indication of an event or external element being dragged.
		// `eventLocation` has zoned start and end (optional)
		renderDrag: function(eventLocation, seg) {
	
			// always render a highlight underneath
			this.renderHighlight(this.eventToSpan(eventLocation));
	
			// if a segment from the same calendar but another component is being dragged, render a helper event
			if (seg && seg.component !== this) {
				return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
			}
		},
	
	
		// Unrenders any visual indication of a hovering event
		unrenderDrag: function() {
			this.unrenderHighlight();
			this.unrenderHelper();
		},
	
	
		/* Event Resize Visualization
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event being resized
		renderEventResize: function(eventLocation, seg) {
			this.renderHighlight(this.eventToSpan(eventLocation));
			return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
		},
	
	
		// Unrenders a visual indication of an event being resized
		unrenderEventResize: function() {
			this.unrenderHighlight();
			this.unrenderHelper();
		},
	
	
		/* Event Helper
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
		renderHelper: function(event, sourceSeg) {
			var helperNodes = [];
			var segs = this.eventToSegs(event);
			var rowStructs;
	
			segs = this.renderFgSegEls(segs); // assigns each seg's el and returns a subset of segs that were rendered
			rowStructs = this.renderSegRows(segs);
	
			// inject each new event skeleton into each associated row
			this.rowEls.each(function(row, rowNode) {
				var rowEl = $(rowNode); // the .fc-row
				var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned
				var skeletonTop;
	
				// If there is an original segment, match the top position. Otherwise, put it at the row's top level
				if (sourceSeg && sourceSeg.row === row) {
					skeletonTop = sourceSeg.el.position().top;
				}
				else {
					skeletonTop = rowEl.find('.fc-content-skeleton tbody').position().top;
				}
	
				skeletonEl.css('top', skeletonTop)
					.find('table')
						.append(rowStructs[row].tbodyEl);
	
				rowEl.append(skeletonEl);
				helperNodes.push(skeletonEl[0]);
			});
	
			return ( // must return the elements rendered
				this.helperEls = $(helperNodes) // array -> jQuery set
			);
		},
	
	
		// Unrenders any visual indication of a mock helper event
		unrenderHelper: function() {
			if (this.helperEls) {
				this.helperEls.remove();
				this.helperEls = null;
			}
		},
	
	
		/* Fill System (highlight, background events, business hours)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		fillSegTag: 'td', // override the default tag name
	
	
		// Renders a set of rectangles over the given segments of days.
		// Only returns segments that successfully rendered.
		renderFill: function(type, segs, className) {
			var nodes = [];
			var i, seg;
			var skeletonEl;
	
			segs = this.renderFillSegEls(type, segs); // assignes `.el` to each seg. returns successfully rendered segs
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				skeletonEl = this.renderFillRow(type, seg, className);
				this.rowEls.eq(seg.row).append(skeletonEl);
				nodes.push(skeletonEl[0]);
			}
	
			this.elsByFill[type] = $(nodes);
	
			return segs;
		},
	
	
		// Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
		renderFillRow: function(type, seg, className) {
			var colCnt = this.colCnt;
			var startCol = seg.leftCol;
			var endCol = seg.rightCol + 1;
			var skeletonEl;
			var trEl;
	
			className = className || type.toLowerCase();
	
			skeletonEl = $(
				'<div class="fc-' + className + '-skeleton">' +
					'<table><tr/></table>' +
				'</div>'
			);
			trEl = skeletonEl.find('tr');
	
			if (startCol > 0) {
				trEl.append('<td colspan="' + startCol + '"/>');
			}
	
			trEl.append(
				seg.el.attr('colspan', endCol - startCol)
			);
	
			if (endCol < colCnt) {
				trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
			}
	
			this.bookendCells(trEl);
	
			return skeletonEl;
		}
	
	});
	
	;;
	
	/* Event-rendering methods for the DayGrid class
	----------------------------------------------------------------------------------------------------------------------*/
	
	DayGrid.mixin({
	
		rowStructs: null, // an array of objects, each holding information about a row's foreground event-rendering
	
	
		// Unrenders all events currently rendered on the grid
		unrenderEvents: function() {
			this.removeSegPopover(); // removes the "more.." events popover
			Grid.prototype.unrenderEvents.apply(this, arguments); // calls the super-method
		},
	
	
		// Retrieves all rendered segment objects currently rendered on the grid
		getEventSegs: function() {
			return Grid.prototype.getEventSegs.call(this) // get the segments from the super-method
				.concat(this.popoverSegs || []); // append the segments from the "more..." popover
		},
	
	
		// Renders the given background event segments onto the grid
		renderBgSegs: function(segs) {
	
			// don't render timed background events
			var allDaySegs = $.grep(segs, function(seg) {
				return seg.event.allDay;
			});
	
			return Grid.prototype.renderBgSegs.call(this, allDaySegs); // call the super-method
		},
	
	
		// Renders the given foreground event segments onto the grid
		renderFgSegs: function(segs) {
			var rowStructs;
	
			// render an `.el` on each seg
			// returns a subset of the segs. segs that were actually rendered
			segs = this.renderFgSegEls(segs);
	
			rowStructs = this.rowStructs = this.renderSegRows(segs);
	
			// append to each row's content skeleton
			this.rowEls.each(function(i, rowNode) {
				$(rowNode).find('.fc-content-skeleton > table').append(
					rowStructs[i].tbodyEl
				);
			});
	
			return segs; // return only the segs that were actually rendered
		},
	
	
		// Unrenders all currently rendered foreground event segments
		unrenderFgSegs: function() {
			var rowStructs = this.rowStructs || [];
			var rowStruct;
	
			while ((rowStruct = rowStructs.pop())) {
				rowStruct.tbodyEl.remove();
			}
	
			this.rowStructs = null;
		},
	
	
		// Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
		// Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
		// PRECONDITION: each segment shoud already have a rendered and assigned `.el`
		renderSegRows: function(segs) {
			var rowStructs = [];
			var segRows;
			var row;
	
			segRows = this.groupSegRows(segs); // group into nested arrays
	
			// iterate each row of segment groupings
			for (row = 0; row < segRows.length; row++) {
				rowStructs.push(
					this.renderSegRow(row, segRows[row])
				);
			}
	
			return rowStructs;
		},
	
	
		// Builds the HTML to be used for the default element for an individual segment
		fgSegHtml: function(seg, disableResizing) {
			var view = this.view;
			var event = seg.event;
			var isDraggable = view.isEventDraggable(event);
			var isResizableFromStart = !disableResizing && event.allDay &&
				seg.isStart && view.isEventResizableFromStart(event);
			var isResizableFromEnd = !disableResizing && event.allDay &&
				seg.isEnd && view.isEventResizableFromEnd(event);
			var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
			var skinCss = cssToStr(this.getSegSkinCss(seg));
			var timeHtml = '';
			var timeText;
			var titleHtml;
	
			classes.unshift('fc-day-grid-event', 'fc-h-event');
	
			// Only display a timed events time if it is the starting segment
			if (seg.isStart) {
				timeText = this.getEventTimeText(event);
				if (timeText) {
					timeHtml = '<span class="fc-time">' + htmlEscape(timeText) + '</span>';
				}
			}
	
			titleHtml =
				'<span class="fc-title">' +
					(htmlEscape(event.title || '') || '&nbsp;') + // we always want one line of height
				'</span>';
			
			return '<a class="' + classes.join(' ') + '"' +
					(event.url ?
						' href="' + htmlEscape(event.url) + '"' :
						''
						) +
					(skinCss ?
						' style="' + skinCss + '"' :
						''
						) +
				'>' +
					'<div class="fc-content">' +
						(this.isRTL ?
							titleHtml + ' ' + timeHtml : // put a natural space in between
							timeHtml + ' ' + titleHtml   //
							) +
					'</div>' +
					(isResizableFromStart ?
						'<div class="fc-resizer fc-start-resizer" />' :
						''
						) +
					(isResizableFromEnd ?
						'<div class="fc-resizer fc-end-resizer" />' :
						''
						) +
				'</a>';
		},
	
	
		// Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
		// the segments. Returns object with a bunch of internal data about how the render was calculated.
		// NOTE: modifies rowSegs
		renderSegRow: function(row, rowSegs) {
			var colCnt = this.colCnt;
			var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
			var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
			var tbody = $('<tbody/>');
			var segMatrix = []; // lookup for which segments are rendered into which level+col cells
			var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
			var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
			var i, levelSegs;
			var col;
			var tr;
			var j, seg;
			var td;
	
			// populates empty cells from the current column (`col`) to `endCol`
			function emptyCellsUntil(endCol) {
				while (col < endCol) {
					// try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
					td = (loneCellMatrix[i - 1] || [])[col];
					if (td) {
						td.attr(
							'rowspan',
							parseInt(td.attr('rowspan') || 1, 10) + 1
						);
					}
					else {
						td = $('<td/>');
						tr.append(td);
					}
					cellMatrix[i][col] = td;
					loneCellMatrix[i][col] = td;
					col++;
				}
			}
	
			for (i = 0; i < levelCnt; i++) { // iterate through all levels
				levelSegs = segLevels[i];
				col = 0;
				tr = $('<tr/>');
	
				segMatrix.push([]);
				cellMatrix.push([]);
				loneCellMatrix.push([]);
	
				// levelCnt might be 1 even though there are no actual levels. protect against this.
				// this single empty row is useful for styling.
				if (levelSegs) {
					for (j = 0; j < levelSegs.length; j++) { // iterate through segments in level
						seg = levelSegs[j];
	
						emptyCellsUntil(seg.leftCol);
	
						// create a container that occupies or more columns. append the event element.
						td = $('<td class="fc-event-container"/>').append(seg.el);
						if (seg.leftCol != seg.rightCol) {
							td.attr('colspan', seg.rightCol - seg.leftCol + 1);
						}
						else { // a single-column segment
							loneCellMatrix[i][col] = td;
						}
	
						while (col <= seg.rightCol) {
							cellMatrix[i][col] = td;
							segMatrix[i][col] = seg;
							col++;
						}
	
						tr.append(td);
					}
				}
	
				emptyCellsUntil(colCnt); // finish off the row
				this.bookendCells(tr);
				tbody.append(tr);
			}
	
			return { // a "rowStruct"
				row: row, // the row number
				tbodyEl: tbody,
				cellMatrix: cellMatrix,
				segMatrix: segMatrix,
				segLevels: segLevels,
				segs: rowSegs
			};
		},
	
	
		// Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
		// NOTE: modifies segs
		buildSegLevels: function(segs) {
			var levels = [];
			var i, seg;
			var j;
	
			// Give preference to elements with certain criteria, so they have
			// a chance to be closer to the top.
			this.sortEventSegs(segs);
			
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
	
				// loop through levels, starting with the topmost, until the segment doesn't collide with other segments
				for (j = 0; j < levels.length; j++) {
					if (!isDaySegCollision(seg, levels[j])) {
						break;
					}
				}
				// `j` now holds the desired subrow index
				seg.level = j;
	
				// create new level array if needed and append segment
				(levels[j] || (levels[j] = [])).push(seg);
			}
	
			// order segments left-to-right. very important if calendar is RTL
			for (j = 0; j < levels.length; j++) {
				levels[j].sort(compareDaySegCols);
			}
	
			return levels;
		},
	
	
		// Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
		groupSegRows: function(segs) {
			var segRows = [];
			var i;
	
			for (i = 0; i < this.rowCnt; i++) {
				segRows.push([]);
			}
	
			for (i = 0; i < segs.length; i++) {
				segRows[segs[i].row].push(segs[i]);
			}
	
			return segRows;
		}
	
	});
	
	
	// Computes whether two segments' columns collide. They are assumed to be in the same row.
	function isDaySegCollision(seg, otherSegs) {
		var i, otherSeg;
	
		for (i = 0; i < otherSegs.length; i++) {
			otherSeg = otherSegs[i];
	
			if (
				otherSeg.leftCol <= seg.rightCol &&
				otherSeg.rightCol >= seg.leftCol
			) {
				return true;
			}
		}
	
		return false;
	}
	
	
	// A cmp function for determining the leftmost event
	function compareDaySegCols(a, b) {
		return a.leftCol - b.leftCol;
	}
	
	;;
	
	/* Methods relate to limiting the number events for a given day on a DayGrid
	----------------------------------------------------------------------------------------------------------------------*/
	// NOTE: all the segs being passed around in here are foreground segs
	
	DayGrid.mixin({
	
		segPopover: null, // the Popover that holds events that can't fit in a cell. null when not visible
		popoverSegs: null, // an array of segment objects that the segPopover holds. null when not visible
	
	
		removeSegPopover: function() {
			if (this.segPopover) {
				this.segPopover.hide(); // in handler, will call segPopover's removeElement
			}
		},
	
	
		// Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
		// `levelLimit` can be false (don't limit), a number, or true (should be computed).
		limitRows: function(levelLimit) {
			var rowStructs = this.rowStructs || [];
			var row; // row #
			var rowLevelLimit;
	
			for (row = 0; row < rowStructs.length; row++) {
				this.unlimitRow(row);
	
				if (!levelLimit) {
					rowLevelLimit = false;
				}
				else if (typeof levelLimit === 'number') {
					rowLevelLimit = levelLimit;
				}
				else {
					rowLevelLimit = this.computeRowLevelLimit(row);
				}
	
				if (rowLevelLimit !== false) {
					this.limitRow(row, rowLevelLimit);
				}
			}
		},
	
	
		// Computes the number of levels a row will accomodate without going outside its bounds.
		// Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
		// `row` is the row number.
		computeRowLevelLimit: function(row) {
			var rowEl = this.rowEls.eq(row); // the containing "fake" row div
			var rowHeight = rowEl.height(); // TODO: cache somehow?
			var trEls = this.rowStructs[row].tbodyEl.children();
			var i, trEl;
			var trHeight;
	
			function iterInnerHeights(i, childNode) {
				trHeight = Math.max(trHeight, $(childNode).outerHeight());
			}
	
			// Reveal one level <tr> at a time and stop when we find one out of bounds
			for (i = 0; i < trEls.length; i++) {
				trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)
	
				// with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
				// so instead, find the tallest inner content element.
				trHeight = 0;
				trEl.find('> td > :first-child').each(iterInnerHeights);
	
				if (trEl.position().top + trHeight > rowHeight) {
					return i;
				}
			}
	
			return false; // should not limit at all
		},
	
	
		// Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
		// `row` is the row number.
		// `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
		limitRow: function(row, levelLimit) {
			var _this = this;
			var rowStruct = this.rowStructs[row];
			var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
			var col = 0; // col #, left-to-right (not chronologically)
			var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
			var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
			var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
			var i, seg;
			var segsBelow; // array of segment objects below `seg` in the current `col`
			var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
			var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
			var td, rowspan;
			var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
			var j;
			var moreTd, moreWrap, moreLink;
	
			// Iterates through empty level cells and places "more" links inside if need be
			function emptyCellsUntil(endCol) { // goes from current `col` to `endCol`
				while (col < endCol) {
					segsBelow = _this.getCellSegs(row, col, levelLimit);
					if (segsBelow.length) {
						td = cellMatrix[levelLimit - 1][col];
						moreLink = _this.renderMoreLink(row, col, segsBelow);
						moreWrap = $('<div/>').append(moreLink);
						td.append(moreWrap);
						moreNodes.push(moreWrap[0]);
					}
					col++;
				}
			}
	
			if (levelLimit && levelLimit < rowStruct.segLevels.length) { // is it actually over the limit?
				levelSegs = rowStruct.segLevels[levelLimit - 1];
				cellMatrix = rowStruct.cellMatrix;
	
				limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
					.addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array
	
				// iterate though segments in the last allowable level
				for (i = 0; i < levelSegs.length; i++) {
					seg = levelSegs[i];
					emptyCellsUntil(seg.leftCol); // process empty cells before the segment
	
					// determine *all* segments below `seg` that occupy the same columns
					colSegsBelow = [];
					totalSegsBelow = 0;
					while (col <= seg.rightCol) {
						segsBelow = this.getCellSegs(row, col, levelLimit);
						colSegsBelow.push(segsBelow);
						totalSegsBelow += segsBelow.length;
						col++;
					}
	
					if (totalSegsBelow) { // do we need to replace this segment with one or many "more" links?
						td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
						rowspan = td.attr('rowspan') || 1;
						segMoreNodes = [];
	
						// make a replacement <td> for each column the segment occupies. will be one for each colspan
						for (j = 0; j < colSegsBelow.length; j++) {
							moreTd = $('<td class="fc-more-cell"/>').attr('rowspan', rowspan);
							segsBelow = colSegsBelow[j];
							moreLink = this.renderMoreLink(
								row,
								seg.leftCol + j,
								[ seg ].concat(segsBelow) // count seg as hidden too
							);
							moreWrap = $('<div/>').append(moreLink);
							moreTd.append(moreWrap);
							segMoreNodes.push(moreTd[0]);
							moreNodes.push(moreTd[0]);
						}
	
						td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
						limitedNodes.push(td[0]);
					}
				}
	
				emptyCellsUntil(this.colCnt); // finish off the level
				rowStruct.moreEls = $(moreNodes); // for easy undoing later
				rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
			}
		},
	
	
		// Reveals all levels and removes all "more"-related elements for a grid's row.
		// `row` is a row number.
		unlimitRow: function(row) {
			var rowStruct = this.rowStructs[row];
	
			if (rowStruct.moreEls) {
				rowStruct.moreEls.remove();
				rowStruct.moreEls = null;
			}
	
			if (rowStruct.limitedEls) {
				rowStruct.limitedEls.removeClass('fc-limited');
				rowStruct.limitedEls = null;
			}
		},
	
	
		// Renders an <a> element that represents hidden event element for a cell.
		// Responsible for attaching click handler as well.
		renderMoreLink: function(row, col, hiddenSegs) {
			var _this = this;
			var view = this.view;
	
			return $('<a class="fc-more"/>')
				.text(
					this.getMoreLinkText(hiddenSegs.length)
				)
				.on('click', function(ev) {
					var clickOption = view.opt('eventLimitClick');
					var date = _this.getCellDate(row, col);
					var moreEl = $(this);
					var dayEl = _this.getCellEl(row, col);
					var allSegs = _this.getCellSegs(row, col);
	
					// rescope the segments to be within the cell's date
					var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
					var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
	
					if (typeof clickOption === 'function') {
						// the returned value can be an atomic option
						clickOption = view.trigger('eventLimitClick', null, {
							date: date,
							dayEl: dayEl,
							moreEl: moreEl,
							segs: reslicedAllSegs,
							hiddenSegs: reslicedHiddenSegs
						}, ev);
					}
	
					if (clickOption === 'popover') {
						_this.showSegPopover(row, col, moreEl, reslicedAllSegs);
					}
					else if (typeof clickOption === 'string') { // a view name
						view.calendar.zoomTo(date, clickOption);
					}
				});
		},
	
	
		// Reveals the popover that displays all events within a cell
		showSegPopover: function(row, col, moreLink, segs) {
			var _this = this;
			var view = this.view;
			var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
			var topEl; // the element we want to match the top coordinate of
			var options;
	
			if (this.rowCnt == 1) {
				topEl = view.el; // will cause the popover to cover any sort of header
			}
			else {
				topEl = this.rowEls.eq(row); // will align with top of row
			}
	
			options = {
				className: 'fc-more-popover',
				content: this.renderSegPopoverContent(row, col, segs),
				parentEl: this.view.el, // attach to root of view. guarantees outside of scrollbars.
				top: topEl.offset().top,
				autoHide: true, // when the user clicks elsewhere, hide the popover
				viewportConstrain: view.opt('popoverViewportConstrain'),
				hide: function() {
					// kill everything when the popover is hidden
					_this.segPopover.removeElement();
					_this.segPopover = null;
					_this.popoverSegs = null;
				}
			};
	
			// Determine horizontal coordinate.
			// We use the moreWrap instead of the <td> to avoid border confusion.
			if (this.isRTL) {
				options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
			}
			else {
				options.left = moreWrap.offset().left - 1; // -1 to be over cell border
			}
	
			this.segPopover = new Popover(options);
			this.segPopover.show();
	
			// the popover doesn't live within the grid's container element, and thus won't get the event
			// delegated-handlers for free. attach event-related handlers to the popover.
			this.bindSegHandlersToEl(this.segPopover.el);
		},
	
	
		// Builds the inner DOM contents of the segment popover
		renderSegPopoverContent: function(row, col, segs) {
			var view = this.view;
			var isTheme = view.opt('theme');
			var title = this.getCellDate(row, col).format(view.opt('dayPopoverFormat'));
			var content = $(
				'<div class="fc-header ' + view.widgetHeaderClass + '">' +
					'<span class="fc-close ' +
						(isTheme ? 'ui-icon ui-icon-closethick' : 'fc-icon fc-icon-x') +
					'"></span>' +
					'<span class="fc-title">' +
						htmlEscape(title) +
					'</span>' +
					'<div class="fc-clear"/>' +
				'</div>' +
				'<div class="fc-body ' + view.widgetContentClass + '">' +
					'<div class="fc-event-container"></div>' +
				'</div>'
			);
			var segContainer = content.find('.fc-event-container');
			var i;
	
			// render each seg's `el` and only return the visible segs
			segs = this.renderFgSegEls(segs, true); // disableResizing=true
			this.popoverSegs = segs;
	
			for (i = 0; i < segs.length; i++) {
	
				// because segments in the popover are not part of a grid coordinate system, provide a hint to any
				// grids that want to do drag-n-drop about which cell it came from
				this.prepareHits();
				segs[i].hit = this.getCellHit(row, col);
				this.releaseHits();
	
				segContainer.append(segs[i].el);
			}
	
			return content;
		},
	
	
		// Given the events within an array of segment objects, reslice them to be in a single day
		resliceDaySegs: function(segs, dayDate) {
	
			// build an array of the original events
			var events = $.map(segs, function(seg) {
				return seg.event;
			});
	
			var dayStart = dayDate.clone();
			var dayEnd = dayStart.clone().add(1, 'days');
			var dayRange = { start: dayStart, end: dayEnd };
	
			// slice the events with a custom slicing function
			segs = this.eventsToSegs(
				events,
				function(range) {
					var seg = intersectRanges(range, dayRange); // undefind if no intersection
					return seg ? [ seg ] : []; // must return an array of segments
				}
			);
	
			// force an order because eventsToSegs doesn't guarantee one
			this.sortEventSegs(segs);
	
			return segs;
		},
	
	
		// Generates the text that should be inside a "more" link, given the number of events it represents
		getMoreLinkText: function(num) {
			var opt = this.view.opt('eventLimitText');
	
			if (typeof opt === 'function') {
				return opt(num);
			}
			else {
				return '+' + num + ' ' + opt;
			}
		},
	
	
		// Returns segments within a given cell.
		// If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
		getCellSegs: function(row, col, startLevel) {
			var segMatrix = this.rowStructs[row].segMatrix;
			var level = startLevel || 0;
			var segs = [];
			var seg;
	
			while (level < segMatrix.length) {
				seg = segMatrix[level][col];
				if (seg) {
					segs.push(seg);
				}
				level++;
			}
	
			return segs;
		}
	
	});
	
	;;
	
	/* A component that renders one or more columns of vertical time slots
	----------------------------------------------------------------------------------------------------------------------*/
	// We mixin DayTable, even though there is only a single row of days
	
	var TimeGrid = FC.TimeGrid = Grid.extend(DayTableMixin, {
	
		slotDuration: null, // duration of a "slot", a distinct time segment on given day, visualized by lines
		snapDuration: null, // granularity of time for dragging and selecting
		snapsPerSlot: null,
		minTime: null, // Duration object that denotes the first visible time of any given day
		maxTime: null, // Duration object that denotes the exclusive visible end time of any given day
		labelFormat: null, // formatting string for times running along vertical axis
		labelInterval: null, // duration of how often a label should be displayed for a slot
	
		colEls: null, // cells elements in the day-row background
		slatContainerEl: null, // div that wraps all the slat rows
		slatEls: null, // elements running horizontally across all columns
		nowIndicatorEls: null,
	
		colCoordCache: null,
		slatCoordCache: null,
	
	
		constructor: function() {
			Grid.apply(this, arguments); // call the super-constructor
	
			this.processOptions();
		},
	
	
		// Renders the time grid into `this.el`, which should already be assigned.
		// Relies on the view's colCnt. In the future, this component should probably be self-sufficient.
		renderDates: function() {
			this.el.html(this.renderHtml());
			this.colEls = this.el.find('.fc-day');
			this.slatContainerEl = this.el.find('.fc-slats');
			this.slatEls = this.slatContainerEl.find('tr');
	
			this.colCoordCache = new CoordCache({
				els: this.colEls,
				isHorizontal: true
			});
			this.slatCoordCache = new CoordCache({
				els: this.slatEls,
				isVertical: true
			});
	
			this.renderContentSkeleton();
		},
	
	
		// Renders the basic HTML skeleton for the grid
		renderHtml: function() {
			return '' +
				'<div class="fc-bg">' +
					'<table>' +
						this.renderBgTrHtml(0) + // row=0
					'</table>' +
				'</div>' +
				'<div class="fc-slats">' +
					'<table>' +
						this.renderSlatRowHtml() +
					'</table>' +
				'</div>';
		},
	
	
		// Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
		renderSlatRowHtml: function() {
			var view = this.view;
			var isRTL = this.isRTL;
			var html = '';
			var slotTime = moment.duration(+this.minTime); // wish there was .clone() for durations
			var slotDate; // will be on the view's first day, but we only care about its time
			var isLabeled;
			var axisHtml;
	
			// Calculate the time for each slot
			while (slotTime < this.maxTime) {
				slotDate = this.start.clone().time(slotTime);
				isLabeled = isInt(divideDurationByDuration(slotTime, this.labelInterval));
	
				axisHtml =
					'<td class="fc-axis fc-time ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '>' +
						(isLabeled ?
							'<span>' + // for matchCellWidths
								htmlEscape(slotDate.format(this.labelFormat)) +
							'</span>' :
							''
							) +
					'</td>';
	
				html +=
					'<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
						(isLabeled ? '' : ' class="fc-minor"') +
						'>' +
						(!isRTL ? axisHtml : '') +
						'<td class="' + view.widgetContentClass + '"/>' +
						(isRTL ? axisHtml : '') +
					"</tr>";
	
				slotTime.add(this.slotDuration);
			}
	
			return html;
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Parses various options into properties of this object
		processOptions: function() {
			var view = this.view;
			var slotDuration = view.opt('slotDuration');
			var snapDuration = view.opt('snapDuration');
			var input;
	
			slotDuration = moment.duration(slotDuration);
			snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
	
			this.slotDuration = slotDuration;
			this.snapDuration = snapDuration;
			this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
	
			this.minResizeDuration = snapDuration; // hack
	
			this.minTime = moment.duration(view.opt('minTime'));
			this.maxTime = moment.duration(view.opt('maxTime'));
	
			// might be an array value (for TimelineView).
			// if so, getting the most granular entry (the last one probably).
			input = view.opt('slotLabelFormat');
			if ($.isArray(input)) {
				input = input[input.length - 1];
			}
	
			this.labelFormat =
				input ||
				view.opt('axisFormat') || // deprecated
				view.opt('smallTimeFormat'); // the computed default
	
			input = view.opt('slotLabelInterval');
			this.labelInterval = input ?
				moment.duration(input) :
				this.computeLabelInterval(slotDuration);
		},
	
	
		// Computes an automatic value for slotLabelInterval
		computeLabelInterval: function(slotDuration) {
			var i;
			var labelInterval;
			var slotsPerLabel;
	
			// find the smallest stock label interval that results in more than one slots-per-label
			for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
				labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
				slotsPerLabel = divideDurationByDuration(labelInterval, slotDuration);
				if (isInt(slotsPerLabel) && slotsPerLabel > 1) {
					return labelInterval;
				}
			}
	
			return moment.duration(slotDuration); // fall back. clone
		},
	
	
		// Computes a default event time formatting string if `timeFormat` is not explicitly defined
		computeEventTimeFormat: function() {
			return this.view.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
		},
	
	
		// Computes a default `displayEventEnd` value if one is not expliclty defined
		computeDisplayEventEnd: function() {
			return true;
		},
	
	
		/* Hit System
		------------------------------------------------------------------------------------------------------------------*/
	
	
		prepareHits: function() {
			this.colCoordCache.build();
			this.slatCoordCache.build();
		},
	
	
		releaseHits: function() {
			this.colCoordCache.clear();
			// NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
		},
	
	
		queryHit: function(leftOffset, topOffset) {
			var snapsPerSlot = this.snapsPerSlot;
			var colCoordCache = this.colCoordCache;
			var slatCoordCache = this.slatCoordCache;
	
			if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
				var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
				var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
	
				if (colIndex != null && slatIndex != null) {
					var slatTop = slatCoordCache.getTopOffset(slatIndex);
					var slatHeight = slatCoordCache.getHeight(slatIndex);
					var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
					var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
					var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
					var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
					var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
	
					return {
						col: colIndex,
						snap: snapIndex,
						component: this, // needed unfortunately :(
						left: colCoordCache.getLeftOffset(colIndex),
						right: colCoordCache.getRightOffset(colIndex),
						top: snapTop,
						bottom: snapBottom
					};
				}
			}
		},
	
	
		getHitSpan: function(hit) {
			var start = this.getCellDate(0, hit.col); // row=0
			var time = this.computeSnapTime(hit.snap); // pass in the snap-index
			var end;
	
			start.time(time);
			end = start.clone().add(this.snapDuration);
	
			return { start: start, end: end };
		},
	
	
		getHitEl: function(hit) {
			return this.colEls.eq(hit.col);
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		rangeUpdated: function() {
			this.updateDayTable();
		},
	
	
		// Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
		computeSnapTime: function(snapIndex) {
			return moment.duration(this.minTime + this.snapDuration * snapIndex);
		},
	
	
		// Slices up the given span (unzoned start/end with other misc data) into an array of segments
		spanToSegs: function(span) {
			var segs = this.sliceRangeByTimes(span);
			var i;
	
			for (i = 0; i < segs.length; i++) {
				if (this.isRTL) {
					segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
				}
				else {
					segs[i].col = segs[i].dayIndex;
				}
			}
	
			return segs;
		},
	
	
		sliceRangeByTimes: function(range) {
			var segs = [];
			var seg;
			var dayIndex;
			var dayDate;
			var dayRange;
	
			for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
				dayDate = this.dayDates[dayIndex].clone(); // TODO: better API for this?
				dayRange = {
					start: dayDate.clone().time(this.minTime),
					end: dayDate.clone().time(this.maxTime)
				};
				seg = intersectRanges(range, dayRange); // both will be ambig timezone
				if (seg) {
					seg.dayIndex = dayIndex;
					segs.push(seg);
				}
			}
	
			return segs;
		},
	
	
		/* Coordinates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		updateSize: function(isResize) { // NOT a standard Grid method
			this.slatCoordCache.build();
	
			if (isResize) {
				this.updateSegVerticals(
					[].concat(this.fgSegs || [], this.bgSegs || [], this.businessSegs || [])
				);
			}
		},
	
	
		getTotalSlatHeight: function() {
			return this.slatContainerEl.outerHeight();
		},
	
	
		// Computes the top coordinate, relative to the bounds of the grid, of the given date.
		// A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
		computeDateTop: function(date, startOfDayDate) {
			return this.computeTimeTop(
				moment.duration(
					date - startOfDayDate.clone().stripTime()
				)
			);
		},
	
	
		// Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
		computeTimeTop: function(time) {
			var len = this.slatEls.length;
			var slatCoverage = (time - this.minTime) / this.slotDuration; // floating-point value of # of slots covered
			var slatIndex;
			var slatRemainder;
	
			// compute a floating-point number for how many slats should be progressed through.
			// from 0 to number of slats (inclusive)
			// constrained because minTime/maxTime might be customized.
			slatCoverage = Math.max(0, slatCoverage);
			slatCoverage = Math.min(len, slatCoverage);
	
			// an integer index of the furthest whole slat
			// from 0 to number slats (*exclusive*, so len-1)
			slatIndex = Math.floor(slatCoverage);
			slatIndex = Math.min(slatIndex, len - 1);
	
			// how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
			// could be 1.0 if slatCoverage is covering *all* the slots
			slatRemainder = slatCoverage - slatIndex;
	
			return this.slatCoordCache.getTopPosition(slatIndex) +
				this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
		},
	
	
	
		/* Event Drag Visualization
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event being dragged over the specified date(s).
		// A returned value of `true` signals that a mock "helper" event has been rendered.
		renderDrag: function(eventLocation, seg) {
	
			if (seg) { // if there is event information for this drag, render a helper event
	
				// returns mock event elements
				// signal that a helper has been rendered
				return this.renderEventLocationHelper(eventLocation, seg);
			}
			else {
				// otherwise, just render a highlight
				this.renderHighlight(this.eventToSpan(eventLocation));
			}
		},
	
	
		// Unrenders any visual indication of an event being dragged
		unrenderDrag: function() {
			this.unrenderHelper();
			this.unrenderHighlight();
		},
	
	
		/* Event Resize Visualization
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event being resized
		renderEventResize: function(eventLocation, seg) {
			return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
		},
	
	
		// Unrenders any visual indication of an event being resized
		unrenderEventResize: function() {
			this.unrenderHelper();
		},
	
	
		/* Event Helper
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a mock "helper" event. `sourceSeg` is the original segment object and might be null (an external drag)
		renderHelper: function(event, sourceSeg) {
			return this.renderHelperSegs(this.eventToSegs(event), sourceSeg); // returns mock event elements
		},
	
	
		// Unrenders any mock helper event
		unrenderHelper: function() {
			this.unrenderHelperSegs();
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessHours: function() {
			this.renderBusinessSegs(
				this.buildBusinessHourSegs()
			);
		},
	
	
		unrenderBusinessHours: function() {
			this.unrenderBusinessSegs();
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		getNowIndicatorUnit: function() {
			return 'minute'; // will refresh on the minute
		},
	
	
		renderNowIndicator: function(date) {
			// seg system might be overkill, but it handles scenario where line needs to be rendered
			//  more than once because of columns with the same date (resources columns for example)
			var segs = this.spanToSegs({ start: date, end: date });
			var top = this.computeDateTop(date, date);
			var nodes = [];
			var i;
	
			// render lines within the columns
			for (i = 0; i < segs.length; i++) {
				nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
					.css('top', top)
					.appendTo(this.colContainerEls.eq(segs[i].col))[0]);
			}
	
			// render an arrow over the axis
			if (segs.length > 0) { // is the current time in view?
				nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
					.css('top', top)
					.appendTo(this.el.find('.fc-content-skeleton'))[0]);
			}
	
			this.nowIndicatorEls = $(nodes);
		},
	
	
		unrenderNowIndicator: function() {
			if (this.nowIndicatorEls) {
				this.nowIndicatorEls.remove();
				this.nowIndicatorEls = null;
			}
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
		renderSelection: function(span) {
			if (this.view.opt('selectHelper')) { // this setting signals that a mock helper event should be rendered
	
				// normally acceps an eventLocation, span has a start/end, which is good enough
				this.renderEventLocationHelper(span);
			}
			else {
				this.renderHighlight(span);
			}
		},
	
	
		// Unrenders any visual indication of a selection
		unrenderSelection: function() {
			this.unrenderHelper();
			this.unrenderHighlight();
		},
	
	
		/* Highlight
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHighlight: function(span) {
			this.renderHighlightSegs(this.spanToSegs(span));
		},
	
	
		unrenderHighlight: function() {
			this.unrenderHighlightSegs();
		}
	
	});
	
	;;
	
	/* Methods for rendering SEGMENTS, pieces of content that live on the view
	 ( this file is no longer just for events )
	----------------------------------------------------------------------------------------------------------------------*/
	
	TimeGrid.mixin({
	
		colContainerEls: null, // containers for each column
	
		// inner-containers for each column where different types of segs live
		fgContainerEls: null,
		bgContainerEls: null,
		helperContainerEls: null,
		highlightContainerEls: null,
		businessContainerEls: null,
	
		// arrays of different types of displayed segments
		fgSegs: null,
		bgSegs: null,
		helperSegs: null,
		highlightSegs: null,
		businessSegs: null,
	
	
		// Renders the DOM that the view's content will live in
		renderContentSkeleton: function() {
			var cellHtml = '';
			var i;
			var skeletonEl;
	
			for (i = 0; i < this.colCnt; i++) {
				cellHtml +=
					'<td>' +
						'<div class="fc-content-col">' +
							'<div class="fc-event-container fc-helper-container"></div>' +
							'<div class="fc-event-container"></div>' +
							'<div class="fc-highlight-container"></div>' +
							'<div class="fc-bgevent-container"></div>' +
							'<div class="fc-business-container"></div>' +
						'</div>' +
					'</td>';
			}
	
			skeletonEl = $(
				'<div class="fc-content-skeleton">' +
					'<table>' +
						'<tr>' + cellHtml + '</tr>' +
					'</table>' +
				'</div>'
			);
	
			this.colContainerEls = skeletonEl.find('.fc-content-col');
			this.helperContainerEls = skeletonEl.find('.fc-helper-container');
			this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
			this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
			this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
			this.businessContainerEls = skeletonEl.find('.fc-business-container');
	
			this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
			this.el.append(skeletonEl);
		},
	
	
		/* Foreground Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderFgSegs: function(segs) {
			segs = this.renderFgSegsIntoContainers(segs, this.fgContainerEls);
			this.fgSegs = segs;
			return segs; // needed for Grid::renderEvents
		},
	
	
		unrenderFgSegs: function() {
			this.unrenderNamedSegs('fgSegs');
		},
	
	
		/* Foreground Helper Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHelperSegs: function(segs, sourceSeg) {
			var helperEls = [];
			var i, seg;
			var sourceEl;
	
			segs = this.renderFgSegsIntoContainers(segs, this.helperContainerEls);
	
			// Try to make the segment that is in the same row as sourceSeg look the same
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				if (sourceSeg && sourceSeg.col === seg.col) {
					sourceEl = sourceSeg.el;
					seg.el.css({
						left: sourceEl.css('left'),
						right: sourceEl.css('right'),
						'margin-left': sourceEl.css('margin-left'),
						'margin-right': sourceEl.css('margin-right')
					});
				}
				helperEls.push(seg.el[0]);
			}
	
			this.helperSegs = segs;
	
			return $(helperEls); // must return rendered helpers
		},
	
	
		unrenderHelperSegs: function() {
			this.unrenderNamedSegs('helperSegs');
		},
	
	
		/* Background Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBgSegs: function(segs) {
			segs = this.renderFillSegEls('bgEvent', segs); // TODO: old fill system
			this.updateSegVerticals(segs);
			this.attachSegsByCol(this.groupSegsByCol(segs), this.bgContainerEls);
			this.bgSegs = segs;
			return segs; // needed for Grid::renderEvents
		},
	
	
		unrenderBgSegs: function() {
			this.unrenderNamedSegs('bgSegs');
		},
	
	
		/* Highlight
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHighlightSegs: function(segs) {
			segs = this.renderFillSegEls('highlight', segs); // TODO: old fill system
			this.updateSegVerticals(segs);
			this.attachSegsByCol(this.groupSegsByCol(segs), this.highlightContainerEls);
			this.highlightSegs = segs;
		},
	
	
		unrenderHighlightSegs: function() {
			this.unrenderNamedSegs('highlightSegs');
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessSegs: function(segs) {
			segs = this.renderFillSegEls('businessHours', segs); // TODO: old fill system
			this.updateSegVerticals(segs);
			this.attachSegsByCol(this.groupSegsByCol(segs), this.businessContainerEls);
			this.businessSegs = segs;
		},
	
	
		unrenderBusinessSegs: function() {
			this.unrenderNamedSegs('businessSegs');
		},
	
	
		/* Seg Rendering Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
		groupSegsByCol: function(segs) {
			var segsByCol = [];
			var i;
	
			for (i = 0; i < this.colCnt; i++) {
				segsByCol.push([]);
			}
	
			for (i = 0; i < segs.length; i++) {
				segsByCol[segs[i].col].push(segs[i]);
			}
	
			return segsByCol;
		},
	
	
		// Given segments grouped by column, insert the segments' elements into a parallel array of container
		// elements, each living within a column.
		attachSegsByCol: function(segsByCol, containerEls) {
			var col;
			var segs;
			var i;
	
			for (col = 0; col < this.colCnt; col++) { // iterate each column grouping
				segs = segsByCol[col];
	
				for (i = 0; i < segs.length; i++) {
					containerEls.eq(col).append(segs[i].el);
				}
			}
		},
	
	
		// Given the name of a property of `this` object, assumed to be an array of segments,
		// loops through each segment and removes from DOM. Will null-out the property afterwards.
		unrenderNamedSegs: function(propName) {
			var segs = this[propName];
			var i;
	
			if (segs) {
				for (i = 0; i < segs.length; i++) {
					segs[i].el.remove();
				}
				this[propName] = null;
			}
		},
	
	
	
		/* Foreground Event Rendering Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Given an array of foreground segments, render a DOM element for each, computes position,
		// and attaches to the column inner-container elements.
		renderFgSegsIntoContainers: function(segs, containerEls) {
			var segsByCol;
			var col;
	
			segs = this.renderFgSegEls(segs); // will call fgSegHtml
			segsByCol = this.groupSegsByCol(segs);
	
			for (col = 0; col < this.colCnt; col++) {
				this.updateFgSegCoords(segsByCol[col]);
			}
	
			this.attachSegsByCol(segsByCol, containerEls);
	
			return segs;
		},
	
	
		// Renders the HTML for a single event segment's default rendering
		fgSegHtml: function(seg, disableResizing) {
			var view = this.view;
			var event = seg.event;
			var isDraggable = view.isEventDraggable(event);
			var isResizableFromStart = !disableResizing && seg.isStart && view.isEventResizableFromStart(event);
			var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventResizableFromEnd(event);
			var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
			var skinCss = cssToStr(this.getSegSkinCss(seg));
			var timeText;
			var fullTimeText; // more verbose time text. for the print stylesheet
			var startTimeText; // just the start time text
	
			classes.unshift('fc-time-grid-event', 'fc-v-event');
	
			if (view.isMultiDayEvent(event)) { // if the event appears to span more than one day...
				// Don't display time text on segments that run entirely through a day.
				// That would appear as midnight-midnight and would look dumb.
				// Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
				if (seg.isStart || seg.isEnd) {
					timeText = this.getEventTimeText(seg);
					fullTimeText = this.getEventTimeText(seg, 'LT');
					startTimeText = this.getEventTimeText(seg, null, false); // displayEnd=false
				}
			} else {
				// Display the normal time text for the *event's* times
				timeText = this.getEventTimeText(event);
				fullTimeText = this.getEventTimeText(event, 'LT');
				startTimeText = this.getEventTimeText(event, null, false); // displayEnd=false
			}
	
			return '<a class="' + classes.join(' ') + '"' +
				(event.url ?
					' href="' + htmlEscape(event.url) + '"' :
					''
					) +
				(skinCss ?
					' style="' + skinCss + '"' :
					''
					) +
				'>' +
					'<div class="fc-content">' +
						(timeText ?
							'<div class="fc-time"' +
							' data-start="' + htmlEscape(startTimeText) + '"' +
							' data-full="' + htmlEscape(fullTimeText) + '"' +
							'>' +
								'<span>' + htmlEscape(timeText) + '</span>' +
							'</div>' :
							''
							) +
						(event.title ?
							'<div class="fc-title">' +
								htmlEscape(event.title) +
							'</div>' :
							''
							) +
					'</div>' +
					'<div class="fc-bg"/>' +
					/* TODO: write CSS for this
					(isResizableFromStart ?
						'<div class="fc-resizer fc-start-resizer" />' :
						''
						) +
					*/
					(isResizableFromEnd ?
						'<div class="fc-resizer fc-end-resizer" />' :
						''
						) +
				'</a>';
		},
	
	
		/* Seg Position Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Refreshes the CSS top/bottom coordinates for each segment element.
		// Works when called after initial render, after a window resize/zoom for example.
		updateSegVerticals: function(segs) {
			this.computeSegVerticals(segs);
			this.assignSegVerticals(segs);
		},
	
	
		// For each segment in an array, computes and assigns its top and bottom properties
		computeSegVerticals: function(segs) {
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.top = this.computeDateTop(seg.start, seg.start);
				seg.bottom = this.computeDateTop(seg.end, seg.start);
			}
		},
	
	
		// Given segments that already have their top/bottom properties computed, applies those values to
		// the segments' elements.
		assignSegVerticals: function(segs) {
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.el.css(this.generateSegVerticalCss(seg));
			}
		},
	
	
		// Generates an object with CSS properties for the top/bottom coordinates of a segment element
		generateSegVerticalCss: function(seg) {
			return {
				top: seg.top,
				bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
			};
		},
	
	
		/* Foreground Event Positioning Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Given segments that are assumed to all live in the *same column*,
		// compute their verical/horizontal coordinates and assign to their elements.
		updateFgSegCoords: function(segs) {
			this.computeSegVerticals(segs); // horizontals relies on this
			this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
			this.assignSegVerticals(segs);
			this.assignFgSegHorizontals(segs);
		},
	
	
		// Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
		// NOTE: Also reorders the given array by date!
		computeFgSegHorizontals: function(segs) {
			var levels;
			var level0;
			var i;
	
			this.sortEventSegs(segs); // order by certain criteria
			levels = buildSlotSegLevels(segs);
			computeForwardSlotSegs(levels);
	
			if ((level0 = levels[0])) {
	
				for (i = 0; i < level0.length; i++) {
					computeSlotSegPressures(level0[i]);
				}
	
				for (i = 0; i < level0.length; i++) {
					this.computeFgSegForwardBack(level0[i], 0, 0);
				}
			}
		},
	
	
		// Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
		// from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
		// seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
		//
		// The segment might be part of a "series", which means consecutive segments with the same pressure
		// who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
		// segments behind this one in the current series, and `seriesBackwardCoord` is the starting
		// coordinate of the first segment in the series.
		computeFgSegForwardBack: function(seg, seriesBackwardPressure, seriesBackwardCoord) {
			var forwardSegs = seg.forwardSegs;
			var i;
	
			if (seg.forwardCoord === undefined) { // not already computed
	
				if (!forwardSegs.length) {
	
					// if there are no forward segments, this segment should butt up against the edge
					seg.forwardCoord = 1;
				}
				else {
	
					// sort highest pressure first
					this.sortForwardSegs(forwardSegs);
	
					// this segment's forwardCoord will be calculated from the backwardCoord of the
					// highest-pressure forward segment.
					this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
					seg.forwardCoord = forwardSegs[0].backwardCoord;
				}
	
				// calculate the backwardCoord from the forwardCoord. consider the series
				seg.backwardCoord = seg.forwardCoord -
					(seg.forwardCoord - seriesBackwardCoord) / // available width for series
					(seriesBackwardPressure + 1); // # of segments in the series
	
				// use this segment's coordinates to computed the coordinates of the less-pressurized
				// forward segments
				for (i=0; i<forwardSegs.length; i++) {
					this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
				}
			}
		},
	
	
		sortForwardSegs: function(forwardSegs) {
			forwardSegs.sort(proxy(this, 'compareForwardSegs'));
		},
	
	
		// A cmp function for determining which forward segment to rely on more when computing coordinates.
		compareForwardSegs: function(seg1, seg2) {
			// put higher-pressure first
			return seg2.forwardPressure - seg1.forwardPressure ||
				// put segments that are closer to initial edge first (and favor ones with no coords yet)
				(seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
				// do normal sorting...
				this.compareEventSegs(seg1, seg2);
		},
	
	
		// Given foreground event segments that have already had their position coordinates computed,
		// assigns position-related CSS values to their elements.
		assignFgSegHorizontals: function(segs) {
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.el.css(this.generateFgSegHorizontalCss(seg));
	
				// if the height is short, add a className for alternate styling
				if (seg.bottom - seg.top < 30) {
					seg.el.addClass('fc-short');
				}
			}
		},
	
	
		// Generates an object with CSS properties/values that should be applied to an event segment element.
		// Contains important positioning-related properties that should be applied to any event element, customized or not.
		generateFgSegHorizontalCss: function(seg) {
			var shouldOverlap = this.view.opt('slotEventOverlap');
			var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
			var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
			var props = this.generateSegVerticalCss(seg); // get top/bottom first
			var left; // amount of space from left edge, a fraction of the total width
			var right; // amount of space from right edge, a fraction of the total width
	
			if (shouldOverlap) {
				// double the width, but don't go beyond the maximum forward coordinate (1.0)
				forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
			}
	
			if (this.isRTL) {
				left = 1 - forwardCoord;
				right = backwardCoord;
			}
			else {
				left = backwardCoord;
				right = 1 - forwardCoord;
			}
	
			props.zIndex = seg.level + 1; // convert from 0-base to 1-based
			props.left = left * 100 + '%';
			props.right = right * 100 + '%';
	
			if (shouldOverlap && seg.forwardPressure) {
				// add padding to the edge so that forward stacked events don't cover the resizer's icon
				props[this.isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
			}
	
			return props;
		}
	
	});
	
	
	// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
	// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
	function buildSlotSegLevels(segs) {
		var levels = [];
		var i, seg;
		var j;
	
		for (i=0; i<segs.length; i++) {
			seg = segs[i];
	
			// go through all the levels and stop on the first level where there are no collisions
			for (j=0; j<levels.length; j++) {
				if (!computeSlotSegCollisions(seg, levels[j]).length) {
					break;
				}
			}
	
			seg.level = j;
	
			(levels[j] || (levels[j] = [])).push(seg);
		}
	
		return levels;
	}
	
	
	// For every segment, figure out the other segments that are in subsequent
	// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
	function computeForwardSlotSegs(levels) {
		var i, level;
		var j, seg;
		var k;
	
		for (i=0; i<levels.length; i++) {
			level = levels[i];
	
			for (j=0; j<level.length; j++) {
				seg = level[j];
	
				seg.forwardSegs = [];
				for (k=i+1; k<levels.length; k++) {
					computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
				}
			}
		}
	}
	
	
	// Figure out which path forward (via seg.forwardSegs) results in the longest path until
	// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
	function computeSlotSegPressures(seg) {
		var forwardSegs = seg.forwardSegs;
		var forwardPressure = 0;
		var i, forwardSeg;
	
		if (seg.forwardPressure === undefined) { // not already computed
	
			for (i=0; i<forwardSegs.length; i++) {
				forwardSeg = forwardSegs[i];
	
				// figure out the child's maximum forward path
				computeSlotSegPressures(forwardSeg);
	
				// either use the existing maximum, or use the child's forward pressure
				// plus one (for the forwardSeg itself)
				forwardPressure = Math.max(
					forwardPressure,
					1 + forwardSeg.forwardPressure
				);
			}
	
			seg.forwardPressure = forwardPressure;
		}
	}
	
	
	// Find all the segments in `otherSegs` that vertically collide with `seg`.
	// Append into an optionally-supplied `results` array and return.
	function computeSlotSegCollisions(seg, otherSegs, results) {
		results = results || [];
	
		for (var i=0; i<otherSegs.length; i++) {
			if (isSlotSegCollision(seg, otherSegs[i])) {
				results.push(otherSegs[i]);
			}
		}
	
		return results;
	}
	
	
	// Do these segments occupy the same vertical space?
	function isSlotSegCollision(seg1, seg2) {
		return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
	}
	
	;;
	
	/* An abstract class from which other views inherit from
	----------------------------------------------------------------------------------------------------------------------*/
	
	var View = FC.View = Class.extend(EmitterMixin, ListenerMixin, {
	
		type: null, // subclass' view name (string)
		name: null, // deprecated. use `type` instead
		title: null, // the text that will be displayed in the header's title
	
		calendar: null, // owner Calendar object
		options: null, // hash containing all options. already merged with view-specific-options
		el: null, // the view's containing element. set by Calendar
	
		displaying: null, // a promise representing the state of rendering. null if no render requested
		isSkeletonRendered: false,
		isEventsRendered: false,
	
		// range the view is actually displaying (moments)
		start: null,
		end: null, // exclusive
	
		// range the view is formally responsible for (moments)
		// may be different from start/end. for example, a month view might have 1st-31st, excluding padded dates
		intervalStart: null,
		intervalEnd: null, // exclusive
		intervalDuration: null,
		intervalUnit: null, // name of largest unit being displayed, like "month" or "week"
	
		isRTL: false,
		isSelected: false, // boolean whether a range of time is user-selected or not
		selectedEvent: null,
	
		eventOrderSpecs: null, // criteria for ordering events when they have same date/time
	
		// classNames styled by jqui themes
		widgetHeaderClass: null,
		widgetContentClass: null,
		highlightStateClass: null,
	
		// for date utils, computed from options
		nextDayThreshold: null,
		isHiddenDayHash: null,
	
		// now indicator
		isNowIndicatorRendered: null,
		initialNowDate: null, // result first getNow call
		initialNowQueriedMs: null, // ms time the getNow was called
		nowIndicatorTimeoutID: null, // for refresh timing of now indicator
		nowIndicatorIntervalID: null, // "
	
	
		constructor: function(calendar, type, options, intervalDuration) {
	
			this.calendar = calendar;
			this.type = this.name = type; // .name is deprecated
			this.options = options;
			this.intervalDuration = intervalDuration || moment.duration(1, 'day');
	
			this.nextDayThreshold = moment.duration(this.opt('nextDayThreshold'));
			this.initThemingProps();
			this.initHiddenDays();
			this.isRTL = this.opt('isRTL');
	
			this.eventOrderSpecs = parseFieldSpecs(this.opt('eventOrder'));
	
			this.initialize();
		},
	
	
		// A good place for subclasses to initialize member variables
		initialize: function() {
			// subclasses can implement
		},
	
	
		// Retrieves an option with the given name
		opt: function(name) {
			return this.options[name];
		},
	
	
		// Triggers handlers that are view-related. Modifies args before passing to calendar.
		trigger: function(name, thisObj) { // arguments beyond thisObj are passed along
			var calendar = this.calendar;
	
			return calendar.trigger.apply(
				calendar,
				[name, thisObj || this].concat(
					Array.prototype.slice.call(arguments, 2), // arguments beyond thisObj
					[ this ] // always make the last argument a reference to the view. TODO: deprecate
				)
			);
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Updates all internal dates to center around the given current unzoned date.
		setDate: function(date) {
			this.setRange(this.computeRange(date));
		},
	
	
		// Updates all internal dates for displaying the given unzoned range.
		setRange: function(range) {
			$.extend(this, range); // assigns every property to this object's member variables
			this.updateTitle();
		},
	
	
		// Given a single current unzoned date, produce information about what range to display.
		// Subclasses can override. Must return all properties.
		computeRange: function(date) {
			var intervalUnit = computeIntervalUnit(this.intervalDuration);
			var intervalStart = date.clone().startOf(intervalUnit);
			var intervalEnd = intervalStart.clone().add(this.intervalDuration);
			var start, end;
	
			// normalize the range's time-ambiguity
			if (/year|month|week|day/.test(intervalUnit)) { // whole-days?
				intervalStart.stripTime();
				intervalEnd.stripTime();
			}
			else { // needs to have a time?
				if (!intervalStart.hasTime()) {
					intervalStart = this.calendar.time(0); // give 00:00 time
				}
				if (!intervalEnd.hasTime()) {
					intervalEnd = this.calendar.time(0); // give 00:00 time
				}
			}
	
			start = intervalStart.clone();
			start = this.skipHiddenDays(start);
			end = intervalEnd.clone();
			end = this.skipHiddenDays(end, -1, true); // exclusively move backwards
	
			return {
				intervalUnit: intervalUnit,
				intervalStart: intervalStart,
				intervalEnd: intervalEnd,
				start: start,
				end: end
			};
		},
	
	
		// Computes the new date when the user hits the prev button, given the current date
		computePrevDate: function(date) {
			return this.massageCurrentDate(
				date.clone().startOf(this.intervalUnit).subtract(this.intervalDuration), -1
			);
		},
	
	
		// Computes the new date when the user hits the next button, given the current date
		computeNextDate: function(date) {
			return this.massageCurrentDate(
				date.clone().startOf(this.intervalUnit).add(this.intervalDuration)
			);
		},
	
	
		// Given an arbitrarily calculated current date of the calendar, returns a date that is ensured to be completely
		// visible. `direction` is optional and indicates which direction the current date was being
		// incremented or decremented (1 or -1).
		massageCurrentDate: function(date, direction) {
			if (this.intervalDuration.as('days') <= 1) { // if the view displays a single day or smaller
				if (this.isHiddenDay(date)) {
					date = this.skipHiddenDays(date, direction);
					date.startOf('day');
				}
			}
	
			return date;
		},
	
	
		/* Title and Date Formatting
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the view's title property to the most updated computed value
		updateTitle: function() {
			this.title = this.computeTitle();
		},
	
	
		// Computes what the title at the top of the calendar should be for this view
		computeTitle: function() {
			return this.formatRange(
				{
					// in case intervalStart/End has a time, make sure timezone is correct
					start: this.calendar.applyTimezone(this.intervalStart),
					end: this.calendar.applyTimezone(this.intervalEnd)
				},
				this.opt('titleFormat') || this.computeTitleFormat(),
				this.opt('titleRangeSeparator')
			);
		},
	
	
		// Generates the format string that should be used to generate the title for the current date range.
		// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
		computeTitleFormat: function() {
			if (this.intervalUnit == 'year') {
				return 'YYYY';
			}
			else if (this.intervalUnit == 'month') {
				return this.opt('monthYearFormat'); // like "September 2014"
			}
			else if (this.intervalDuration.as('days') > 1) {
				return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
			}
			else {
				return 'LL'; // one day. longer, like "September 9 2014"
			}
		},
	
	
		// Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
		// Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
		// The timezones of the dates within `range` will be respected.
		formatRange: function(range, formatStr, separator) {
			var end = range.end;
	
			if (!end.hasTime()) { // all-day?
				end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
			}
	
			return formatRange(range.start, end, formatStr, separator, this.opt('isRTL'));
		},
	
	
		/* Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the container element that the view should render inside of.
		// Does other DOM-related initializations.
		setElement: function(el) {
			this.el = el;
			this.bindGlobalHandlers();
		},
	
	
		// Removes the view's container element from the DOM, clearing any content beforehand.
		// Undoes any other DOM-related attachments.
		removeElement: function() {
			this.clear(); // clears all content
	
			// clean up the skeleton
			if (this.isSkeletonRendered) {
				this.unrenderSkeleton();
				this.isSkeletonRendered = false;
			}
	
			this.unbindGlobalHandlers();
	
			this.el.remove();
	
			// NOTE: don't null-out this.el in case the View was destroyed within an API callback.
			// We don't null-out the View's other jQuery element references upon destroy,
			//  so we shouldn't kill this.el either.
		},
	
	
		// Does everything necessary to display the view centered around the given unzoned date.
		// Does every type of rendering EXCEPT rendering events.
		// Is asychronous and returns a promise.
		display: function(date, explicitScrollState) {
			var _this = this;
			var prevScrollState = null;
	
			if (explicitScrollState != null && this.displaying) { // don't need prevScrollState if explicitScrollState
				prevScrollState = this.queryScroll();
			}
	
			this.calendar.freezeContentHeight();
	
			return syncThen(this.clear(), function() { // clear the content first
				return (
					_this.displaying =
						syncThen(_this.displayView(date), function() { // displayView might return a promise
	
							// caller of display() wants a specific scroll state?
							if (explicitScrollState != null) {
								// we make an assumption that this is NOT the initial render,
								// and thus don't need forceScroll (is inconveniently asynchronous)
								_this.setScroll(explicitScrollState);
							}
							else {
								_this.forceScroll(_this.computeInitialScroll(prevScrollState));
							}
	
							_this.calendar.unfreezeContentHeight();
							_this.triggerRender();
						})
				);
			});
		},
	
	
		// Does everything necessary to clear the content of the view.
		// Clears dates and events. Does not clear the skeleton.
		// Is asychronous and returns a promise.
		clear: function() {
			var _this = this;
			var displaying = this.displaying;
	
			if (displaying) { // previously displayed, or in the process of being displayed?
				return syncThen(displaying, function() { // wait for the display to finish
					_this.displaying = null;
					_this.clearEvents();
					return _this.clearView(); // might return a promise. chain it
				});
			}
			else {
				return $.when(); // an immediately-resolved promise
			}
		},
	
	
		// Displays the view's non-event content, such as date-related content or anything required by events.
		// Renders the view's non-content skeleton if necessary.
		// Can be asynchronous and return a promise.
		displayView: function(date) {
			if (!this.isSkeletonRendered) {
				this.renderSkeleton();
				this.isSkeletonRendered = true;
			}
			if (date) {
				this.setDate(date);
			}
			if (this.render) {
				this.render(); // TODO: deprecate
			}
			this.renderDates();
			this.updateSize();
			this.renderBusinessHours(); // might need coordinates, so should go after updateSize()
			this.startNowIndicator();
		},
	
	
		// Unrenders the view content that was rendered in displayView.
		// Can be asynchronous and return a promise.
		clearView: function() {
			this.unselect();
			this.stopNowIndicator();
			this.triggerUnrender();
			this.unrenderBusinessHours();
			this.unrenderDates();
			if (this.destroy) {
				this.destroy(); // TODO: deprecate
			}
		},
	
	
		// Renders the basic structure of the view before any content is rendered
		renderSkeleton: function() {
			// subclasses should implement
		},
	
	
		// Unrenders the basic structure of the view
		unrenderSkeleton: function() {
			// subclasses should implement
		},
	
	
		// Renders the view's date-related content.
		// Assumes setRange has already been called and the skeleton has already been rendered.
		renderDates: function() {
			// subclasses should implement
		},
	
	
		// Unrenders the view's date-related content
		unrenderDates: function() {
			// subclasses should override
		},
	
	
		// Signals that the view's content has been rendered
		triggerRender: function() {
			this.trigger('viewRender', this, this, this.el);
		},
	
	
		// Signals that the view's content is about to be unrendered
		triggerUnrender: function() {
			this.trigger('viewDestroy', this, this, this.el);
		},
	
	
		// Binds DOM handlers to elements that reside outside the view container, such as the document
		bindGlobalHandlers: function() {
			this.listenTo($(document), 'mousedown', this.handleDocumentMousedown);
			this.listenTo($(document), 'touchstart', this.processUnselect);
		},
	
	
		// Unbinds DOM handlers from elements that reside outside the view container
		unbindGlobalHandlers: function() {
			this.stopListeningTo($(document));
		},
	
	
		// Initializes internal variables related to theming
		initThemingProps: function() {
			var tm = this.opt('theme') ? 'ui' : 'fc';
	
			this.widgetHeaderClass = tm + '-widget-header';
			this.widgetContentClass = tm + '-widget-content';
			this.highlightStateClass = tm + '-state-highlight';
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders business-hours onto the view. Assumes updateSize has already been called.
		renderBusinessHours: function() {
			// subclasses should implement
		},
	
	
		// Unrenders previously-rendered business-hours
		unrenderBusinessHours: function() {
			// subclasses should implement
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Immediately render the current time indicator and begins re-rendering it at an interval,
		// which is defined by this.getNowIndicatorUnit().
		// TODO: somehow do this for the current whole day's background too
		startNowIndicator: function() {
			var _this = this;
			var unit;
			var update;
			var delay; // ms wait value
	
			if (this.opt('nowIndicator')) {
				unit = this.getNowIndicatorUnit();
				if (unit) {
					update = proxy(this, 'updateNowIndicator'); // bind to `this`
	
					this.initialNowDate = this.calendar.getNow();
					this.initialNowQueriedMs = +new Date();
					this.renderNowIndicator(this.initialNowDate);
					this.isNowIndicatorRendered = true;
	
					// wait until the beginning of the next interval
					delay = this.initialNowDate.clone().startOf(unit).add(1, unit) - this.initialNowDate;
					this.nowIndicatorTimeoutID = setTimeout(function() {
						_this.nowIndicatorTimeoutID = null;
						update();
						delay = +moment.duration(1, unit);
						delay = Math.max(100, delay); // prevent too frequent
						_this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
					}, delay);
				}
			}
		},
	
	
		// rerenders the now indicator, computing the new current time from the amount of time that has passed
		// since the initial getNow call.
		updateNowIndicator: function() {
			if (this.isNowIndicatorRendered) {
				this.unrenderNowIndicator();
				this.renderNowIndicator(
					this.initialNowDate.clone().add(new Date() - this.initialNowQueriedMs) // add ms
				);
			}
		},
	
	
		// Immediately unrenders the view's current time indicator and stops any re-rendering timers.
		// Won't cause side effects if indicator isn't rendered.
		stopNowIndicator: function() {
			if (this.isNowIndicatorRendered) {
	
				if (this.nowIndicatorTimeoutID) {
					clearTimeout(this.nowIndicatorTimeoutID);
					this.nowIndicatorTimeoutID = null;
				}
				if (this.nowIndicatorIntervalID) {
					clearTimeout(this.nowIndicatorIntervalID);
					this.nowIndicatorIntervalID = null;
				}
	
				this.unrenderNowIndicator();
				this.isNowIndicatorRendered = false;
			}
		},
	
	
		// Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
		// should be refreshed. If something falsy is returned, no time indicator is rendered at all.
		getNowIndicatorUnit: function() {
			// subclasses should implement
		},
	
	
		// Renders a current time indicator at the given datetime
		renderNowIndicator: function(date) {
			// subclasses should implement
		},
	
	
		// Undoes the rendering actions from renderNowIndicator
		unrenderNowIndicator: function() {
			// subclasses should implement
		},
	
	
		/* Dimensions
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Refreshes anything dependant upon sizing of the container element of the grid
		updateSize: function(isResize) {
			var scrollState;
	
			if (isResize) {
				scrollState = this.queryScroll();
			}
	
			this.updateHeight(isResize);
			this.updateWidth(isResize);
			this.updateNowIndicator();
	
			if (isResize) {
				this.setScroll(scrollState);
			}
		},
	
	
		// Refreshes the horizontal dimensions of the calendar
		updateWidth: function(isResize) {
			// subclasses should implement
		},
	
	
		// Refreshes the vertical dimensions of the calendar
		updateHeight: function(isResize) {
			var calendar = this.calendar; // we poll the calendar for height information
	
			this.setHeight(
				calendar.getSuggestedViewHeight(),
				calendar.isHeightAuto()
			);
		},
	
	
		// Updates the vertical dimensions of the calendar to the specified height.
		// if `isAuto` is set to true, height becomes merely a suggestion and the view should use its "natural" height.
		setHeight: function(height, isAuto) {
			// subclasses should implement
		},
	
	
		/* Scroller
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes the initial pre-configured scroll state prior to allowing the user to change it.
		// Given the scroll state from the previous rendering. If first time rendering, given null.
		computeInitialScroll: function(previousScrollState) {
			return 0;
		},
	
	
		// Retrieves the view's current natural scroll state. Can return an arbitrary format.
		queryScroll: function() {
			// subclasses must implement
		},
	
	
		// Sets the view's scroll state. Will accept the same format computeInitialScroll and queryScroll produce.
		setScroll: function(scrollState) {
			// subclasses must implement
		},
	
	
		// Sets the scroll state, making sure to overcome any predefined scroll value the browser has in mind
		forceScroll: function(scrollState) {
			var _this = this;
	
			this.setScroll(scrollState);
			setTimeout(function() {
				_this.setScroll(scrollState);
			}, 0);
		},
	
	
		/* Event Elements / Segments
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Does everything necessary to display the given events onto the current view
		displayEvents: function(events) {
			var scrollState = this.queryScroll();
	
			this.clearEvents();
			this.renderEvents(events);
			this.isEventsRendered = true;
			this.setScroll(scrollState);
			this.triggerEventRender();
		},
	
	
		// Does everything necessary to clear the view's currently-rendered events
		clearEvents: function() {
			var scrollState;
	
			if (this.isEventsRendered) {
	
				// TODO: optimize: if we know this is part of a displayEvents call, don't queryScroll/setScroll
				scrollState = this.queryScroll();
	
				this.triggerEventUnrender();
				if (this.destroyEvents) {
					this.destroyEvents(); // TODO: deprecate
				}
				this.unrenderEvents();
				this.setScroll(scrollState);
				this.isEventsRendered = false;
			}
		},
	
	
		// Renders the events onto the view.
		renderEvents: function(events) {
			// subclasses should implement
		},
	
	
		// Removes event elements from the view.
		unrenderEvents: function() {
			// subclasses should implement
		},
	
	
		// Signals that all events have been rendered
		triggerEventRender: function() {
			this.renderedEventSegEach(function(seg) {
				this.trigger('eventAfterRender', seg.event, seg.event, seg.el);
			});
			this.trigger('eventAfterAllRender');
		},
	
	
		// Signals that all event elements are about to be removed
		triggerEventUnrender: function() {
			this.renderedEventSegEach(function(seg) {
				this.trigger('eventDestroy', seg.event, seg.event, seg.el);
			});
		},
	
	
		// Given an event and the default element used for rendering, returns the element that should actually be used.
		// Basically runs events and elements through the eventRender hook.
		resolveEventEl: function(event, el) {
			var custom = this.trigger('eventRender', event, event, el);
	
			if (custom === false) { // means don't render at all
				el = null;
			}
			else if (custom && custom !== true) {
				el = $(custom);
			}
	
			return el;
		},
	
	
		// Hides all rendered event segments linked to the given event
		showEvent: function(event) {
			this.renderedEventSegEach(function(seg) {
				seg.el.css('visibility', '');
			}, event);
		},
	
	
		// Shows all rendered event segments linked to the given event
		hideEvent: function(event) {
			this.renderedEventSegEach(function(seg) {
				seg.el.css('visibility', 'hidden');
			}, event);
		},
	
	
		// Iterates through event segments that have been rendered (have an el). Goes through all by default.
		// If the optional `event` argument is specified, only iterates through segments linked to that event.
		// The `this` value of the callback function will be the view.
		renderedEventSegEach: function(func, event) {
			var segs = this.getEventSegs();
			var i;
	
			for (i = 0; i < segs.length; i++) {
				if (!event || segs[i].event._id === event._id) {
					if (segs[i].el) {
						func.call(this, segs[i]);
					}
				}
			}
		},
	
	
		// Retrieves all the rendered segment objects for the view
		getEventSegs: function() {
			// subclasses must implement
			return [];
		},
	
	
		/* Event Drag-n-Drop
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes if the given event is allowed to be dragged by the user
		isEventDraggable: function(event) {
			var source = event.source || {};
	
			return firstDefined(
				event.startEditable,
				source.startEditable,
				this.opt('eventStartEditable'),
				event.editable,
				source.editable,
				this.opt('editable')
			);
		},
	
	
		// Must be called when an event in the view is dropped onto new location.
		// `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
		reportEventDrop: function(event, dropLocation, largeUnit, el, ev) {
			var calendar = this.calendar;
			var mutateResult = calendar.mutateEvent(event, dropLocation, largeUnit);
			var undoFunc = function() {
				mutateResult.undo();
				calendar.reportEventChange();
			};
	
			this.triggerEventDrop(event, mutateResult.dateDelta, undoFunc, el, ev);
			calendar.reportEventChange(); // will rerender events
		},
	
	
		// Triggers event-drop handlers that have subscribed via the API
		triggerEventDrop: function(event, dateDelta, undoFunc, el, ev) {
			this.trigger('eventDrop', el[0], event, dateDelta, undoFunc, ev, {}); // {} = jqui dummy
		},
	
	
		/* External Element Drag-n-Drop
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
		// `meta` is the parsed data that has been embedded into the dragging event.
		// `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
		reportExternalDrop: function(meta, dropLocation, el, ev, ui) {
			var eventProps = meta.eventProps;
			var eventInput;
			var event;
	
			// Try to build an event object and render it. TODO: decouple the two
			if (eventProps) {
				eventInput = $.extend({}, eventProps, dropLocation);
				event = this.calendar.renderEvent(eventInput, meta.stick)[0]; // renderEvent returns an array
			}
	
			this.triggerExternalDrop(event, dropLocation, el, ev, ui);
		},
	
	
		// Triggers external-drop handlers that have subscribed via the API
		triggerExternalDrop: function(event, dropLocation, el, ev, ui) {
	
			// trigger 'drop' regardless of whether element represents an event
			this.trigger('drop', el[0], dropLocation.start, ev, ui);
	
			if (event) {
				this.trigger('eventReceive', null, event); // signal an external event landed
			}
		},
	
	
		/* Drag-n-Drop Rendering (for both events and external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a event or external-element drag over the given drop zone.
		// If an external-element, seg will be `null`.
		// Must return elements used for any mock events.
		renderDrag: function(dropLocation, seg) {
			// subclasses must implement
		},
	
	
		// Unrenders a visual indication of an event or external-element being dragged.
		unrenderDrag: function() {
			// subclasses must implement
		},
	
	
		/* Event Resizing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes if the given event is allowed to be resized from its starting edge
		isEventResizableFromStart: function(event) {
			return this.opt('eventResizableFromStart') && this.isEventResizable(event);
		},
	
	
		// Computes if the given event is allowed to be resized from its ending edge
		isEventResizableFromEnd: function(event) {
			return this.isEventResizable(event);
		},
	
	
		// Computes if the given event is allowed to be resized by the user at all
		isEventResizable: function(event) {
			var source = event.source || {};
	
			return firstDefined(
				event.durationEditable,
				source.durationEditable,
				this.opt('eventDurationEditable'),
				event.editable,
				source.editable,
				this.opt('editable')
			);
		},
	
	
		// Must be called when an event in the view has been resized to a new length
		reportEventResize: function(event, resizeLocation, largeUnit, el, ev) {
			var calendar = this.calendar;
			var mutateResult = calendar.mutateEvent(event, resizeLocation, largeUnit);
			var undoFunc = function() {
				mutateResult.undo();
				calendar.reportEventChange();
			};
	
			this.triggerEventResize(event, mutateResult.durationDelta, undoFunc, el, ev);
			calendar.reportEventChange(); // will rerender events
		},
	
	
		// Triggers event-resize handlers that have subscribed via the API
		triggerEventResize: function(event, durationDelta, undoFunc, el, ev) {
			this.trigger('eventResize', el[0], event, durationDelta, undoFunc, ev, {}); // {} = jqui dummy
		},
	
	
		/* Selection (time range)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Selects a date span on the view. `start` and `end` are both Moments.
		// `ev` is the native mouse event that begin the interaction.
		select: function(span, ev) {
			this.unselect(ev);
			this.renderSelection(span);
			this.reportSelection(span, ev);
		},
	
	
		// Renders a visual indication of the selection
		renderSelection: function(span) {
			// subclasses should implement
		},
	
	
		// Called when a new selection is made. Updates internal state and triggers handlers.
		reportSelection: function(span, ev) {
			this.isSelected = true;
			this.triggerSelect(span, ev);
		},
	
	
		// Triggers handlers to 'select'
		triggerSelect: function(span, ev) {
			this.trigger(
				'select',
				null,
				this.calendar.applyTimezone(span.start), // convert to calendar's tz for external API
				this.calendar.applyTimezone(span.end), // "
				ev
			);
		},
	
	
		// Undoes a selection. updates in the internal state and triggers handlers.
		// `ev` is the native mouse event that began the interaction.
		unselect: function(ev) {
			if (this.isSelected) {
				this.isSelected = false;
				if (this.destroySelection) {
					this.destroySelection(); // TODO: deprecate
				}
				this.unrenderSelection();
				this.trigger('unselect', null, ev);
			}
		},
	
	
		// Unrenders a visual indication of selection
		unrenderSelection: function() {
			// subclasses should implement
		},
	
	
		/* Event Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		selectEvent: function(event) {
			if (!this.selectedEvent || this.selectedEvent !== event) {
				this.unselectEvent();
				this.renderedEventSegEach(function(seg) {
					seg.el.addClass('fc-selected');
				}, event);
				this.selectedEvent = event;
			}
		},
	
	
		unselectEvent: function() {
			if (this.selectedEvent) {
				this.renderedEventSegEach(function(seg) {
					seg.el.removeClass('fc-selected');
				}, this.selectedEvent);
				this.selectedEvent = null;
			}
		},
	
	
		isEventSelected: function(event) {
			// event references might change on refetchEvents(), while selectedEvent doesn't,
			// so compare IDs
			return this.selectedEvent && this.selectedEvent._id === event._id;
		},
	
	
		/* Mouse / Touch Unselecting (time range & event unselection)
		------------------------------------------------------------------------------------------------------------------*/
		// TODO: move consistently to down/start or up/end?
		// TODO: don't kill previous selection if touch scrolling
	
	
		handleDocumentMousedown: function(ev) {
			if (isPrimaryMouseButton(ev)) {
				this.processUnselect(ev);
			}
		},
	
	
		processUnselect: function(ev) {
			this.processRangeUnselect(ev);
			this.processEventUnselect(ev);
		},
	
	
		processRangeUnselect: function(ev) {
			var ignore;
	
			// is there a time-range selection?
			if (this.isSelected && this.opt('unselectAuto')) {
				// only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
				ignore = this.opt('unselectCancel');
				if (!ignore || !$(ev.target).closest(ignore).length) {
					this.unselect(ev);
				}
			}
		},
	
	
		processEventUnselect: function(ev) {
			if (this.selectedEvent) {
				if (!$(ev.target).closest('.fc-selected').length) {
					this.unselectEvent();
				}
			}
		},
	
	
		/* Day Click
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Triggers handlers to 'dayClick'
		// Span has start/end of the clicked area. Only the start is useful.
		triggerDayClick: function(span, dayEl, ev) {
			this.trigger(
				'dayClick',
				dayEl,
				this.calendar.applyTimezone(span.start), // convert to calendar's timezone for external API
				ev
			);
		},
	
	
		/* Date Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Initializes internal variables related to calculating hidden days-of-week
		initHiddenDays: function() {
			var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
			var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
			var dayCnt = 0;
			var i;
	
			if (this.opt('weekends') === false) {
				hiddenDays.push(0, 6); // 0=sunday, 6=saturday
			}
	
			for (i = 0; i < 7; i++) {
				if (
					!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)
				) {
					dayCnt++;
				}
			}
	
			if (!dayCnt) {
				throw 'invalid hiddenDays'; // all days were hidden? bad.
			}
	
			this.isHiddenDayHash = isHiddenDayHash;
		},
	
	
		// Is the current day hidden?
		// `day` is a day-of-week index (0-6), or a Moment
		isHiddenDay: function(day) {
			if (moment.isMoment(day)) {
				day = day.day();
			}
			return this.isHiddenDayHash[day];
		},
	
	
		// Incrementing the current day until it is no longer a hidden day, returning a copy.
		// If the initial value of `date` is not a hidden day, don't do anything.
		// Pass `isExclusive` as `true` if you are dealing with an end date.
		// `inc` defaults to `1` (increment one day forward each time)
		skipHiddenDays: function(date, inc, isExclusive) {
			var out = date.clone();
			inc = inc || 1;
			while (
				this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]
			) {
				out.add(inc, 'days');
			}
			return out;
		},
	
	
		// Returns the date range of the full days the given range visually appears to occupy.
		// Returns a new range object.
		computeDayRange: function(range) {
			var startDay = range.start.clone().stripTime(); // the beginning of the day the range starts
			var end = range.end;
			var endDay = null;
			var endTimeMS;
	
			if (end) {
				endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
				endTimeMS = +end.time(); // # of milliseconds into `endDay`
	
				// If the end time is actually inclusively part of the next day and is equal to or
				// beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
				// Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
				if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
					endDay.add(1, 'days');
				}
			}
	
			// If no end was specified, or if it is within `startDay` but not past nextDayThreshold,
			// assign the default duration of one day.
			if (!end || endDay <= startDay) {
				endDay = startDay.clone().add(1, 'days');
			}
	
			return { start: startDay, end: endDay };
		},
	
	
		// Does the given event visually appear to occupy more than one day?
		isMultiDayEvent: function(event) {
			var range = this.computeDayRange(event); // event is range-ish
	
			return range.end.diff(range.start, 'days') > 1;
		}
	
	});
	
	;;
	
	/*
	Embodies a div that has potential scrollbars
	*/
	var Scroller = FC.Scroller = Class.extend({
	
		el: null, // the guaranteed outer element
		scrollEl: null, // the element with the scrollbars
		overflowX: null,
		overflowY: null,
	
	
		constructor: function(options) {
			options = options || {};
			this.overflowX = options.overflowX || options.overflow || 'auto';
			this.overflowY = options.overflowY || options.overflow || 'auto';
		},
	
	
		render: function() {
			this.el = this.renderEl();
			this.applyOverflow();
		},
	
	
		renderEl: function() {
			return (this.scrollEl = $('<div class="fc-scroller"></div>'));
		},
	
	
		// sets to natural height, unlocks overflow
		clear: function() {
			this.setHeight('auto');
			this.applyOverflow();
		},
	
	
		destroy: function() {
			this.el.remove();
		},
	
	
		// Overflow
		// -----------------------------------------------------------------------------------------------------------------
	
	
		applyOverflow: function() {
			this.scrollEl.css({
				'overflow-x': this.overflowX,
				'overflow-y': this.overflowY
			});
		},
	
	
		// Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
		// Useful for preserving scrollbar widths regardless of future resizes.
		// Can pass in scrollbarWidths for optimization.
		lockOverflow: function(scrollbarWidths) {
			var overflowX = this.overflowX;
			var overflowY = this.overflowY;
	
			scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
	
			if (overflowX === 'auto') {
				overflowX = (
						scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
						// OR scrolling pane with massless scrollbars?
						this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth
							// subtract 1 because of IE off-by-one issue
					) ? 'scroll' : 'hidden';
			}
	
			if (overflowY === 'auto') {
				overflowY = (
						scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
						// OR scrolling pane with massless scrollbars?
						this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight
							// subtract 1 because of IE off-by-one issue
					) ? 'scroll' : 'hidden';
			}
	
			this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
		},
	
	
		// Getters / Setters
		// -----------------------------------------------------------------------------------------------------------------
	
	
		setHeight: function(height) {
			this.scrollEl.height(height);
		},
	
	
		getScrollTop: function() {
			return this.scrollEl.scrollTop();
		},
	
	
		setScrollTop: function(top) {
			this.scrollEl.scrollTop(top);
		},
	
	
		getClientWidth: function() {
			return this.scrollEl[0].clientWidth;
		},
	
	
		getClientHeight: function() {
			return this.scrollEl[0].clientHeight;
		},
	
	
		getScrollbarWidths: function() {
			return getScrollbarWidths(this.scrollEl);
		}
	
	});
	
	;;
	
	var Calendar = FC.Calendar = Class.extend({
	
		dirDefaults: null, // option defaults related to LTR or RTL
		langDefaults: null, // option defaults related to current locale
		overrides: null, // option overrides given to the fullCalendar constructor
		dynamicOverrides: null, // options set with dynamic setter method. higher precedence than view overrides.
		options: null, // all defaults combined with overrides
		viewSpecCache: null, // cache of view definitions
		view: null, // current View object
		header: null,
		loadingLevel: 0, // number of simultaneous loading tasks
	
	
		// a lot of this class' OOP logic is scoped within this constructor function,
		// but in the future, write individual methods on the prototype.
		constructor: Calendar_constructor,
	
	
		// Subclasses can override this for initialization logic after the constructor has been called
		initialize: function() {
		},
	
	
		// Computes the flattened options hash for the calendar and assigns to `this.options`.
		// Assumes this.overrides and this.dynamicOverrides have already been initialized.
		populateOptionsHash: function() {
			var lang, langDefaults;
			var isRTL, dirDefaults;
	
			lang = firstDefined( // explicit lang option given?
				this.dynamicOverrides.lang,
				this.overrides.lang
			);
			langDefaults = langOptionHash[lang];
			if (!langDefaults) { // explicit lang option not given or invalid?
				lang = Calendar.defaults.lang;
				langDefaults = langOptionHash[lang] || {};
			}
	
			isRTL = firstDefined( // based on options computed so far, is direction RTL?
				this.dynamicOverrides.isRTL,
				this.overrides.isRTL,
				langDefaults.isRTL,
				Calendar.defaults.isRTL
			);
			dirDefaults = isRTL ? Calendar.rtlDefaults : {};
	
			this.dirDefaults = dirDefaults;
			this.langDefaults = langDefaults;
			this.options = mergeOptions([ // merge defaults and overrides. lowest to highest precedence
				Calendar.defaults, // global defaults
				dirDefaults,
				langDefaults,
				this.overrides,
				this.dynamicOverrides
			]);
			populateInstanceComputableOptions(this.options); // fill in gaps with computed options
		},
	
	
		// Gets information about how to create a view. Will use a cache.
		getViewSpec: function(viewType) {
			var cache = this.viewSpecCache;
	
			return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
		},
	
	
		// Given a duration singular unit, like "week" or "day", finds a matching view spec.
		// Preference is given to views that have corresponding buttons.
		getUnitViewSpec: function(unit) {
			var viewTypes;
			var i;
			var spec;
	
			if ($.inArray(unit, intervalUnits) != -1) {
	
				// put views that have buttons first. there will be duplicates, but oh well
				viewTypes = this.header.getViewsWithButtons();
				$.each(FC.views, function(viewType) { // all views
					viewTypes.push(viewType);
				});
	
				for (i = 0; i < viewTypes.length; i++) {
					spec = this.getViewSpec(viewTypes[i]);
					if (spec) {
						if (spec.singleUnit == unit) {
							return spec;
						}
					}
				}
			}
		},
	
	
		// Builds an object with information on how to create a given view
		buildViewSpec: function(requestedViewType) {
			var viewOverrides = this.overrides.views || {};
			var specChain = []; // for the view. lowest to highest priority
			var defaultsChain = []; // for the view. lowest to highest priority
			var overridesChain = []; // for the view. lowest to highest priority
			var viewType = requestedViewType;
			var spec; // for the view
			var overrides; // for the view
			var duration;
			var unit;
	
			// iterate from the specific view definition to a more general one until we hit an actual View class
			while (viewType) {
				spec = fcViews[viewType];
				overrides = viewOverrides[viewType];
				viewType = null; // clear. might repopulate for another iteration
	
				if (typeof spec === 'function') { // TODO: deprecate
					spec = { 'class': spec };
				}
	
				if (spec) {
					specChain.unshift(spec);
					defaultsChain.unshift(spec.defaults || {});
					duration = duration || spec.duration;
					viewType = viewType || spec.type;
				}
	
				if (overrides) {
					overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
					duration = duration || overrides.duration;
					viewType = viewType || overrides.type;
				}
			}
	
			spec = mergeProps(specChain);
			spec.type = requestedViewType;
			if (!spec['class']) {
				return false;
			}
	
			if (duration) {
				duration = moment.duration(duration);
				if (duration.valueOf()) { // valid?
					spec.duration = duration;
					unit = computeIntervalUnit(duration);
	
					// view is a single-unit duration, like "week" or "day"
					// incorporate options for this. lowest priority
					if (duration.as(unit) === 1) {
						spec.singleUnit = unit;
						overridesChain.unshift(viewOverrides[unit] || {});
					}
				}
			}
	
			spec.defaults = mergeOptions(defaultsChain);
			spec.overrides = mergeOptions(overridesChain);
	
			this.buildViewSpecOptions(spec);
			this.buildViewSpecButtonText(spec, requestedViewType);
	
			return spec;
		},
	
	
		// Builds and assigns a view spec's options object from its already-assigned defaults and overrides
		buildViewSpecOptions: function(spec) {
			spec.options = mergeOptions([ // lowest to highest priority
				Calendar.defaults, // global defaults
				spec.defaults, // view's defaults (from ViewSubclass.defaults)
				this.dirDefaults,
				this.langDefaults, // locale and dir take precedence over view's defaults!
				this.overrides, // calendar's overrides (options given to constructor)
				spec.overrides, // view's overrides (view-specific options)
				this.dynamicOverrides // dynamically set via setter. highest precedence
			]);
			populateInstanceComputableOptions(spec.options);
		},
	
	
		// Computes and assigns a view spec's buttonText-related options
		buildViewSpecButtonText: function(spec, requestedViewType) {
	
			// given an options object with a possible `buttonText` hash, lookup the buttonText for the
			// requested view, falling back to a generic unit entry like "week" or "day"
			function queryButtonText(options) {
				var buttonText = options.buttonText || {};
				return buttonText[requestedViewType] ||
					(spec.singleUnit ? buttonText[spec.singleUnit] : null);
			}
	
			// highest to lowest priority
			spec.buttonTextOverride =
				queryButtonText(this.dynamicOverrides) ||
				queryButtonText(this.overrides) || // constructor-specified buttonText lookup hash takes precedence
				spec.overrides.buttonText; // `buttonText` for view-specific options is a string
	
			// highest to lowest priority. mirrors buildViewSpecOptions
			spec.buttonTextDefault =
				queryButtonText(this.langDefaults) ||
				queryButtonText(this.dirDefaults) ||
				spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
				queryButtonText(Calendar.defaults) ||
				(spec.duration ? this.humanizeDuration(spec.duration) : null) || // like "3 days"
				requestedViewType; // fall back to given view name
		},
	
	
		// Given a view name for a custom view or a standard view, creates a ready-to-go View object
		instantiateView: function(viewType) {
			var spec = this.getViewSpec(viewType);
	
			return new spec['class'](this, viewType, spec.options, spec.duration);
		},
	
	
		// Returns a boolean about whether the view is okay to instantiate at some point
		isValidViewType: function(viewType) {
			return Boolean(this.getViewSpec(viewType));
		},
	
	
		// Should be called when any type of async data fetching begins
		pushLoading: function() {
			if (!(this.loadingLevel++)) {
				this.trigger('loading', null, true, this.view);
			}
		},
	
	
		// Should be called when any type of async data fetching completes
		popLoading: function() {
			if (!(--this.loadingLevel)) {
				this.trigger('loading', null, false, this.view);
			}
		},
	
	
		// Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
		buildSelectSpan: function(zonedStartInput, zonedEndInput) {
			var start = this.moment(zonedStartInput).stripZone();
			var end;
	
			if (zonedEndInput) {
				end = this.moment(zonedEndInput).stripZone();
			}
			else if (start.hasTime()) {
				end = start.clone().add(this.defaultTimedEventDuration);
			}
			else {
				end = start.clone().add(this.defaultAllDayEventDuration);
			}
	
			return { start: start, end: end };
		}
	
	});
	
	
	Calendar.mixin(EmitterMixin);
	
	
	function Calendar_constructor(element, overrides) {
		var t = this;
	
	
		// Exports
		// -----------------------------------------------------------------------------------
	
		t.render = render;
		t.destroy = destroy;
		t.refetchEvents = refetchEvents;
		t.refetchEventSources = refetchEventSources;
		t.reportEvents = reportEvents;
		t.reportEventChange = reportEventChange;
		t.rerenderEvents = renderEvents; // `renderEvents` serves as a rerender. an API method
		t.changeView = renderView; // `renderView` will switch to another view
		t.select = select;
		t.unselect = unselect;
		t.prev = prev;
		t.next = next;
		t.prevYear = prevYear;
		t.nextYear = nextYear;
		t.today = today;
		t.gotoDate = gotoDate;
		t.incrementDate = incrementDate;
		t.zoomTo = zoomTo;
		t.getDate = getDate;
		t.getCalendar = getCalendar;
		t.getView = getView;
		t.option = option; // getter/setter method
		t.trigger = trigger;
	
	
		// Options
		// -----------------------------------------------------------------------------------
	
		t.dynamicOverrides = {};
		t.viewSpecCache = {};
		t.optionHandlers = {}; // for Calendar.options.js
	
		// convert legacy options into non-legacy ones.
		// in the future, when this is removed, don't use `overrides` reference. make a copy.
		t.overrides = massageOverrides(overrides || {});
	
		t.populateOptionsHash(); // sets this.options
	
	
	
		// Language-data Internals
		// -----------------------------------------------------------------------------------
		// Apply overrides to the current language's data
	
		var localeData;
	
		// Called immediately, and when any of the options change.
		// Happens before any internal objects rebuild or rerender, because this is very core.
		t.bindOptions([
			'lang', 'monthNames', 'monthNamesShort', 'dayNames', 'dayNamesShort', 'firstDay', 'weekNumberCalculation'
		], function(lang, monthNames, monthNamesShort, dayNames, dayNamesShort, firstDay, weekNumberCalculation) {
	
			localeData = createObject( // make a cheap copy
				getMomentLocaleData(lang) // will fall back to en
			);
	
			if (monthNames) {
				localeData._months = monthNames;
			}
			if (monthNamesShort) {
				localeData._monthsShort = monthNamesShort;
			}
			if (dayNames) {
				localeData._weekdays = dayNames;
			}
			if (dayNamesShort) {
				localeData._weekdaysShort = dayNamesShort;
			}
			if (firstDay != null) {
				var _week = createObject(localeData._week); // _week: { dow: # }
				_week.dow = firstDay;
				localeData._week = _week;
			}
	
			if (weekNumberCalculation === 'iso') {
				weekNumberCalculation = 'ISO'; // normalize
			}
			if ( // whitelist certain kinds of input
				weekNumberCalculation === 'ISO' ||
				weekNumberCalculation === 'local' ||
				typeof weekNumberCalculation === 'function'
			) {
				localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
			}
	
			// If the internal current date object already exists, move to new locale.
			// We do NOT need to do this technique for event dates, because this happens when converting to "segments".
			if (date) {
				localizeMoment(date); // sets to localeData
			}
		});
	
	
	
		// Calendar-specific Date Utilities
		// -----------------------------------------------------------------------------------
	
	
		t.defaultAllDayEventDuration = moment.duration(t.options.defaultAllDayEventDuration);
		t.defaultTimedEventDuration = moment.duration(t.options.defaultTimedEventDuration);
	
	
		// Builds a moment using the settings of the current calendar: timezone and language.
		// Accepts anything the vanilla moment() constructor accepts.
		t.moment = function() {
			var mom;
	
			if (t.options.timezone === 'local') {
				mom = FC.moment.apply(null, arguments);
	
				// Force the moment to be local, because FC.moment doesn't guarantee it.
				if (mom.hasTime()) { // don't give ambiguously-timed moments a local zone
					mom.local();
				}
			}
			else if (t.options.timezone === 'UTC') {
				mom = FC.moment.utc.apply(null, arguments); // process as UTC
			}
			else {
				mom = FC.moment.parseZone.apply(null, arguments); // let the input decide the zone
			}
	
			localizeMoment(mom);
	
			return mom;
		};
	
	
		// Updates the given moment's locale settings to the current calendar locale settings.
		function localizeMoment(mom) {
			if ('_locale' in mom) { // moment 2.8 and above
				mom._locale = localeData;
			}
			else { // pre-moment-2.8
				mom._lang = localeData;
			}
		}
	
	
		// Returns a boolean about whether or not the calendar knows how to calculate
		// the timezone offset of arbitrary dates in the current timezone.
		t.getIsAmbigTimezone = function() {
			return t.options.timezone !== 'local' && t.options.timezone !== 'UTC';
		};
	
	
		// Returns a copy of the given date in the current timezone. Has no effect on dates without times.
		t.applyTimezone = function(date) {
			if (!date.hasTime()) {
				return date.clone();
			}
	
			var zonedDate = t.moment(date.toArray());
			var timeAdjust = date.time() - zonedDate.time();
			var adjustedZonedDate;
	
			// Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
			if (timeAdjust) { // is the time result different than expected?
				adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
				if (date.time() - adjustedZonedDate.time() === 0) { // does it match perfectly now?
					zonedDate = adjustedZonedDate;
				}
			}
	
			return zonedDate;
		};
	
	
		// Returns a moment for the current date, as defined by the client's computer or from the `now` option.
		// Will return an moment with an ambiguous timezone.
		t.getNow = function() {
			var now = t.options.now;
			if (typeof now === 'function') {
				now = now();
			}
			return t.moment(now).stripZone();
		};
	
	
		// Get an event's normalized end date. If not present, calculate it from the defaults.
		t.getEventEnd = function(event) {
			if (event.end) {
				return event.end.clone();
			}
			else {
				return t.getDefaultEventEnd(event.allDay, event.start);
			}
		};
	
	
		// Given an event's allDay status and start date, return what its fallback end date should be.
		// TODO: rename to computeDefaultEventEnd
		t.getDefaultEventEnd = function(allDay, zonedStart) {
			var end = zonedStart.clone();
	
			if (allDay) {
				end.stripTime().add(t.defaultAllDayEventDuration);
			}
			else {
				end.add(t.defaultTimedEventDuration);
			}
	
			if (t.getIsAmbigTimezone()) {
				end.stripZone(); // we don't know what the tzo should be
			}
	
			return end;
		};
	
	
		// Produces a human-readable string for the given duration.
		// Side-effect: changes the locale of the given duration.
		t.humanizeDuration = function(duration) {
			return (duration.locale || duration.lang).call(duration, t.options.lang) // works moment-pre-2.8
				.humanize();
		};
	
	
		
		// Imports
		// -----------------------------------------------------------------------------------
	
	
		EventManager.call(t);
		var isFetchNeeded = t.isFetchNeeded;
		var fetchEvents = t.fetchEvents;
		var fetchEventSources = t.fetchEventSources;
	
	
	
		// Locals
		// -----------------------------------------------------------------------------------
	
	
		var _element = element[0];
		var header;
		var content;
		var tm; // for making theme classes
		var currentView; // NOTE: keep this in sync with this.view
		var viewsByType = {}; // holds all instantiated view instances, current or not
		var suggestedViewHeight;
		var windowResizeProxy; // wraps the windowResize function
		var ignoreWindowResize = 0;
		var events = [];
		var date; // unzoned
		
		
		
		// Main Rendering
		// -----------------------------------------------------------------------------------
	
	
		// compute the initial ambig-timezone date
		if (t.options.defaultDate != null) {
			date = t.moment(t.options.defaultDate).stripZone();
		}
		else {
			date = t.getNow(); // getNow already returns unzoned
		}
		
		
		function render() {
			if (!content) {
				initialRender();
			}
			else if (elementVisible()) {
				// mainly for the public API
				calcSize();
				renderView();
			}
		}
		
		
		function initialRender() {
			element.addClass('fc');
	
			// called immediately, and upon option change
			t.bindOption('theme', function(theme) {
				tm = theme ? 'ui' : 'fc'; // affects a larger scope
				element.toggleClass('ui-widget', theme);
				element.toggleClass('fc-unthemed', !theme);
			});
	
			// called immediately, and upon option change.
			// HACK: lang often affects isRTL, so we explicitly listen to that too.
			t.bindOptions([ 'isRTL', 'lang' ], function(isRTL) {
				element.toggleClass('fc-ltr', !isRTL);
				element.toggleClass('fc-rtl', isRTL);
			});
	
			content = $("<div class='fc-view-container'/>").prependTo(element);
	
			header = t.header = new Header(t);
			renderHeader();
	
			renderView(t.options.defaultView);
	
			if (t.options.handleWindowResize) {
				windowResizeProxy = debounce(windowResize, t.options.windowResizeDelay); // prevents rapid calls
				$(window).resize(windowResizeProxy);
			}
		}
	
	
		// can be called repeatedly and Header will rerender
		function renderHeader() {
			header.render();
			if (header.el) {
				element.prepend(header.el);
			}
		}
		
		
		function destroy() {
	
			if (currentView) {
				currentView.removeElement();
	
				// NOTE: don't null-out currentView/t.view in case API methods are called after destroy.
				// It is still the "current" view, just not rendered.
			}
	
			header.removeElement();
			content.remove();
			element.removeClass('fc fc-ltr fc-rtl fc-unthemed ui-widget');
	
			if (windowResizeProxy) {
				$(window).unbind('resize', windowResizeProxy);
			}
		}
		
		
		function elementVisible() {
			return element.is(':visible');
		}
		
		
	
		// View Rendering
		// -----------------------------------------------------------------------------------
	
	
		// Renders a view because of a date change, view-type change, or for the first time.
		// If not given a viewType, keep the current view but render different dates.
		// Accepts an optional scroll state to restore to.
		function renderView(viewType, explicitScrollState) {
			ignoreWindowResize++;
	
			// if viewType is changing, remove the old view's rendering
			if (currentView && viewType && currentView.type !== viewType) {
				freezeContentHeight(); // prevent a scroll jump when view element is removed
				clearView();
			}
	
			// if viewType changed, or the view was never created, create a fresh view
			if (!currentView && viewType) {
				currentView = t.view =
					viewsByType[viewType] ||
					(viewsByType[viewType] = t.instantiateView(viewType));
	
				currentView.setElement(
					$("<div class='fc-view fc-" + viewType + "-view' />").appendTo(content)
				);
				header.activateButton(viewType);
			}
	
			if (currentView) {
	
				// in case the view should render a period of time that is completely hidden
				date = currentView.massageCurrentDate(date);
	
				// render or rerender the view
				if (
					!currentView.displaying ||
					!date.isWithin(currentView.intervalStart, currentView.intervalEnd) // implicit date window change
				) {
					if (elementVisible()) {
	
						currentView.display(date, explicitScrollState); // will call freezeContentHeight
						unfreezeContentHeight(); // immediately unfreeze regardless of whether display is async
	
						// need to do this after View::render, so dates are calculated
						updateHeaderTitle();
						updateTodayButton();
	
						getAndRenderEvents();
					}
				}
			}
	
			unfreezeContentHeight(); // undo any lone freezeContentHeight calls
			ignoreWindowResize--;
		}
	
	
		// Unrenders the current view and reflects this change in the Header.
		// Unregsiters the `currentView`, but does not remove from viewByType hash.
		function clearView() {
			header.deactivateButton(currentView.type);
			currentView.removeElement();
			currentView = t.view = null;
		}
	
	
		// Destroys the view, including the view object. Then, re-instantiates it and renders it.
		// Maintains the same scroll state.
		// TODO: maintain any other user-manipulated state.
		function reinitView() {
			ignoreWindowResize++;
			freezeContentHeight();
	
			var viewType = currentView.type;
			var scrollState = currentView.queryScroll();
			clearView();
			renderView(viewType, scrollState);
	
			unfreezeContentHeight();
			ignoreWindowResize--;
		}
	
		
	
		// Resizing
		// -----------------------------------------------------------------------------------
	
	
		t.getSuggestedViewHeight = function() {
			if (suggestedViewHeight === undefined) {
				calcSize();
			}
			return suggestedViewHeight;
		};
	
	
		t.isHeightAuto = function() {
			return t.options.contentHeight === 'auto' || t.options.height === 'auto';
		};
		
		
		function updateSize(shouldRecalc) {
			if (elementVisible()) {
	
				if (shouldRecalc) {
					_calcSize();
				}
	
				ignoreWindowResize++;
				currentView.updateSize(true); // isResize=true. will poll getSuggestedViewHeight() and isHeightAuto()
				ignoreWindowResize--;
	
				return true; // signal success
			}
		}
	
	
		function calcSize() {
			if (elementVisible()) {
				_calcSize();
			}
		}
		
		
		function _calcSize() { // assumes elementVisible
			var contentHeightInput = t.options.contentHeight;
			var heightInput = t.options.height;
	
			if (typeof contentHeightInput === 'number') { // exists and not 'auto'
				suggestedViewHeight = contentHeightInput;
			}
			else if (typeof contentHeightInput === 'function') { // exists and is a function
				suggestedViewHeight = contentHeightInput();
			}
			else if (typeof heightInput === 'number') { // exists and not 'auto'
				suggestedViewHeight = heightInput - queryHeaderHeight();
			}
			else if (typeof heightInput === 'function') { // exists and is a function
				suggestedViewHeight = heightInput() - queryHeaderHeight();
			}
			else if (heightInput === 'parent') { // set to height of parent element
				suggestedViewHeight = element.parent().height() - queryHeaderHeight();
			}
			else {
				suggestedViewHeight = Math.round(content.width() / Math.max(t.options.aspectRatio, .5));
			}
		}
	
	
		function queryHeaderHeight() {
			return header.el ? header.el.outerHeight(true) : 0; // includes margin
		}
		
		
		function windowResize(ev) {
			if (
				!ignoreWindowResize &&
				ev.target === window && // so we don't process jqui "resize" events that have bubbled up
				currentView.start // view has already been rendered
			) {
				if (updateSize(true)) {
					currentView.trigger('windowResize', _element);
				}
			}
		}
		
		
		
		/* Event Fetching/Rendering
		-----------------------------------------------------------------------------*/
		// TODO: going forward, most of this stuff should be directly handled by the view
	
	
		function refetchEvents() { // can be called as an API method
			fetchAndRenderEvents();
		}
	
	
		// TODO: move this into EventManager?
		function refetchEventSources(matchInputs) {
			fetchEventSources(t.getEventSourcesByMatchArray(matchInputs));
		}
	
	
		function renderEvents() { // destroys old events if previously rendered
			if (elementVisible()) {
				freezeContentHeight();
				currentView.displayEvents(events);
				unfreezeContentHeight();
			}
		}
		
	
		function getAndRenderEvents() {
			if (!t.options.lazyFetching || isFetchNeeded(currentView.start, currentView.end)) {
				fetchAndRenderEvents();
			}
			else {
				renderEvents();
			}
		}
	
	
		function fetchAndRenderEvents() {
			fetchEvents(currentView.start, currentView.end);
				// ... will call reportEvents
				// ... which will call renderEvents
		}
	
		
		// called when event data arrives
		function reportEvents(_events) {
			events = _events;
			renderEvents();
		}
	
	
		// called when a single event's data has been changed
		function reportEventChange() {
			renderEvents();
		}
	
	
	
		/* Header Updating
		-----------------------------------------------------------------------------*/
	
	
		function updateHeaderTitle() {
			header.updateTitle(currentView.title);
		}
	
	
		function updateTodayButton() {
			var now = t.getNow();
			if (now.isWithin(currentView.intervalStart, currentView.intervalEnd)) {
				header.disableButton('today');
			}
			else {
				header.enableButton('today');
			}
		}
		
	
	
		/* Selection
		-----------------------------------------------------------------------------*/
		
	
		// this public method receives start/end dates in any format, with any timezone
		function select(zonedStartInput, zonedEndInput) {
			currentView.select(
				t.buildSelectSpan.apply(t, arguments)
			);
		}
		
	
		function unselect() { // safe to be called before renderView
			if (currentView) {
				currentView.unselect();
			}
		}
		
		
		
		/* Date
		-----------------------------------------------------------------------------*/
		
		
		function prev() {
			date = currentView.computePrevDate(date);
			renderView();
		}
		
		
		function next() {
			date = currentView.computeNextDate(date);
			renderView();
		}
		
		
		function prevYear() {
			date.add(-1, 'years');
			renderView();
		}
		
		
		function nextYear() {
			date.add(1, 'years');
			renderView();
		}
		
		
		function today() {
			date = t.getNow();
			renderView();
		}
		
		
		function gotoDate(zonedDateInput) {
			date = t.moment(zonedDateInput).stripZone();
			renderView();
		}
		
		
		function incrementDate(delta) {
			date.add(moment.duration(delta));
			renderView();
		}
	
	
		// Forces navigation to a view for the given date.
		// `viewType` can be a specific view name or a generic one like "week" or "day".
		function zoomTo(newDate, viewType) {
			var spec;
	
			viewType = viewType || 'day'; // day is default zoom
			spec = t.getViewSpec(viewType) || t.getUnitViewSpec(viewType);
	
			date = newDate.clone();
			renderView(spec ? spec.type : null);
		}
		
		
		// for external API
		function getDate() {
			return t.applyTimezone(date); // infuse the calendar's timezone
		}
	
	
	
		/* Height "Freezing"
		-----------------------------------------------------------------------------*/
		// TODO: move this into the view
	
		t.freezeContentHeight = freezeContentHeight;
		t.unfreezeContentHeight = unfreezeContentHeight;
	
	
		function freezeContentHeight() {
			content.css({
				width: '100%',
				height: content.height(),
				overflow: 'hidden'
			});
		}
	
	
		function unfreezeContentHeight() {
			content.css({
				width: '',
				height: '',
				overflow: ''
			});
		}
		
		
		
		/* Misc
		-----------------------------------------------------------------------------*/
		
	
		function getCalendar() {
			return t;
		}
	
		
		function getView() {
			return currentView;
		}
		
		
		function option(name, value) {
			var newOptionHash;
	
			if (typeof name === 'string') {
				if (value === undefined) { // getter
					return t.options[name];
				}
				else { // setter for individual option
					newOptionHash = {};
					newOptionHash[name] = value;
					setOptions(newOptionHash);
				}
			}
			else if (typeof name === 'object') { // compound setter with object input
				setOptions(name);
			}
		}
	
	
		function setOptions(newOptionHash) {
			var optionCnt = 0;
			var optionName;
	
			for (optionName in newOptionHash) {
				t.dynamicOverrides[optionName] = newOptionHash[optionName];
			}
	
			t.viewSpecCache = {}; // the dynamic override invalidates the options in this cache, so just clear it
			t.populateOptionsHash(); // this.options needs to be recomputed after the dynamic override
	
			// trigger handlers after this.options has been updated
			for (optionName in newOptionHash) {
				t.triggerOptionHandlers(optionName); // recall bindOption/bindOptions
				optionCnt++;
			}
	
			// special-case handling of single option change.
			// if only one option change, `optionName` will be its name.
			if (optionCnt === 1) {
				if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
					updateSize(true); // true = allow recalculation of height
					return;
				}
				else if (optionName === 'defaultDate') {
					return; // can't change date this way. use gotoDate instead
				}
				else if (optionName === 'businessHours') {
					if (currentView) {
						currentView.unrenderBusinessHours();
						currentView.renderBusinessHours();
					}
					return;
				}
				else if (optionName === 'timezone') {
					t.rezoneArrayEventSources();
					refetchEvents();
					return;
				}
			}
	
			// catch-all. rerender the header and rebuild/rerender the current view
			renderHeader();
			viewsByType = {}; // even non-current views will be affected by this option change. do before rerender
			reinitView();
		}
		
		
		function trigger(name, thisObj) { // overrides the Emitter's trigger method :(
			var args = Array.prototype.slice.call(arguments, 2);
	
			thisObj = thisObj || _element;
			this.triggerWith(name, thisObj, args); // Emitter's method
	
			if (t.options[name]) {
				return t.options[name].apply(thisObj, args);
			}
		}
	
		t.initialize();
	}
	
	;;
	/*
	Options binding/triggering system.
	*/
	Calendar.mixin({
	
		// A map of option names to arrays of handler objects. Initialized to {} in Calendar.
		// Format for a handler object:
		// {
		//   func // callback function to be called upon change
		//   names // option names whose values should be given to func
		// }
		optionHandlers: null, 
	
		// Calls handlerFunc immediately, and when the given option has changed.
		// handlerFunc will be given the option value.
		bindOption: function(optionName, handlerFunc) {
			this.bindOptions([ optionName ], handlerFunc);
		},
	
		// Calls handlerFunc immediately, and when any of the given options change.
		// handlerFunc will be given each option value as ordered function arguments.
		bindOptions: function(optionNames, handlerFunc) {
			var handlerObj = { func: handlerFunc, names: optionNames };
			var i;
	
			for (i = 0; i < optionNames.length; i++) {
				this.registerOptionHandlerObj(optionNames[i], handlerObj);
			}
	
			this.triggerOptionHandlerObj(handlerObj);
		},
	
		// Puts the given handler object into the internal hash
		registerOptionHandlerObj: function(optionName, handlerObj) {
			(this.optionHandlers[optionName] || (this.optionHandlers[optionName] = []))
				.push(handlerObj);
		},
	
		// Reports that the given option has changed, and calls all appropriate handlers.
		triggerOptionHandlers: function(optionName) {
			var handlerObjs = this.optionHandlers[optionName] || [];
			var i;
	
			for (i = 0; i < handlerObjs.length; i++) {
				this.triggerOptionHandlerObj(handlerObjs[i]);
			}
		},
	
		// Calls the callback for a specific handler object, passing in the appropriate arguments.
		triggerOptionHandlerObj: function(handlerObj) {
			var optionNames = handlerObj.names;
			var optionValues = [];
			var i;
	
			for (i = 0; i < optionNames.length; i++) {
				optionValues.push(this.options[optionNames[i]]);
			}
	
			handlerObj.func.apply(this, optionValues); // maintain the Calendar's `this` context
		}
	
	});
	
	;;
	
	Calendar.defaults = {
	
		titleRangeSeparator: ' \u2013 ', // en dash
		monthYearFormat: 'MMMM YYYY', // required for en. other languages rely on datepicker computable option
	
		defaultTimedEventDuration: '02:00:00',
		defaultAllDayEventDuration: { days: 1 },
		forceEventDuration: false,
		nextDayThreshold: '09:00:00', // 9am
	
		// display
		defaultView: 'month',
		aspectRatio: 1.35,
		header: {
			left: 'title',
			center: '',
			right: 'today prev,next'
		},
		weekends: true,
		weekNumbers: false,
	
		weekNumberTitle: 'W',
		weekNumberCalculation: 'local',
		
		//editable: false,
	
		//nowIndicator: false,
	
		scrollTime: '06:00:00',
		
		// event ajax
		lazyFetching: true,
		startParam: 'start',
		endParam: 'end',
		timezoneParam: 'timezone',
	
		timezone: false,
	
		//allDayDefault: undefined,
	
		// locale
		isRTL: false,
		buttonText: {
			prev: "prev",
			next: "next",
			prevYear: "prev year",
			nextYear: "next year",
			year: 'year', // TODO: locale files need to specify this
			today: 'today',
			month: 'month',
			week: 'week',
			day: 'day'
		},
	
		buttonIcons: {
			prev: 'left-single-arrow',
			next: 'right-single-arrow',
			prevYear: 'left-double-arrow',
			nextYear: 'right-double-arrow'
		},
		
		// jquery-ui theming
		theme: false,
		themeButtonIcons: {
			prev: 'circle-triangle-w',
			next: 'circle-triangle-e',
			prevYear: 'seek-prev',
			nextYear: 'seek-next'
		},
	
		//eventResizableFromStart: false,
		dragOpacity: .75,
		dragRevertDuration: 500,
		dragScroll: true,
		
		//selectable: false,
		unselectAuto: true,
		
		dropAccept: '*',
	
		eventOrder: 'title',
	
		eventLimit: false,
		eventLimitText: 'more',
		eventLimitClick: 'popover',
		dayPopoverFormat: 'LL',
		
		handleWindowResize: true,
		windowResizeDelay: 100, // milliseconds before an updateSize happens
	
		longPressDelay: 1000
		
	};
	
	
	Calendar.englishDefaults = { // used by lang.js
		dayPopoverFormat: 'dddd, MMMM D'
	};
	
	
	Calendar.rtlDefaults = { // right-to-left defaults
		header: { // TODO: smarter solution (first/center/last ?)
			left: 'next,prev today',
			center: '',
			right: 'title'
		},
		buttonIcons: {
			prev: 'right-single-arrow',
			next: 'left-single-arrow',
			prevYear: 'right-double-arrow',
			nextYear: 'left-double-arrow'
		},
		themeButtonIcons: {
			prev: 'circle-triangle-e',
			next: 'circle-triangle-w',
			nextYear: 'seek-prev',
			prevYear: 'seek-next'
		}
	};
	
	;;
	
	var langOptionHash = FC.langs = {}; // initialize and expose
	
	
	// TODO: document the structure and ordering of a FullCalendar lang file
	// TODO: rename everything "lang" to "locale", like what the moment project did
	
	
	// Initialize jQuery UI datepicker translations while using some of the translations
	// Will set this as the default language for datepicker.
	FC.datepickerLang = function(langCode, dpLangCode, dpOptions) {
	
		// get the FullCalendar internal option hash for this language. create if necessary
		var fcOptions = langOptionHash[langCode] || (langOptionHash[langCode] = {});
	
		// transfer some simple options from datepicker to fc
		fcOptions.isRTL = dpOptions.isRTL;
		fcOptions.weekNumberTitle = dpOptions.weekHeader;
	
		// compute some more complex options from datepicker
		$.each(dpComputableOptions, function(name, func) {
			fcOptions[name] = func(dpOptions);
		});
	
		// is jQuery UI Datepicker is on the page?
		if ($.datepicker) {
	
			// Register the language data.
			// FullCalendar and MomentJS use language codes like "pt-br" but Datepicker
			// does it like "pt-BR" or if it doesn't have the language, maybe just "pt".
			// Make an alias so the language can be referenced either way.
			$.datepicker.regional[dpLangCode] =
				$.datepicker.regional[langCode] = // alias
					dpOptions;
	
			// Alias 'en' to the default language data. Do this every time.
			$.datepicker.regional.en = $.datepicker.regional[''];
	
			// Set as Datepicker's global defaults.
			$.datepicker.setDefaults(dpOptions);
		}
	};
	
	
	// Sets FullCalendar-specific translations. Will set the language as the global default.
	FC.lang = function(langCode, newFcOptions) {
		var fcOptions;
		var momOptions;
	
		// get the FullCalendar internal option hash for this language. create if necessary
		fcOptions = langOptionHash[langCode] || (langOptionHash[langCode] = {});
	
		// provided new options for this language? merge them in
		if (newFcOptions) {
			fcOptions = langOptionHash[langCode] = mergeOptions([ fcOptions, newFcOptions ]);
		}
	
		// compute language options that weren't defined.
		// always do this. newFcOptions can be undefined when initializing from i18n file,
		// so no way to tell if this is an initialization or a default-setting.
		momOptions = getMomentLocaleData(langCode); // will fall back to en
		$.each(momComputableOptions, function(name, func) {
			if (fcOptions[name] == null) {
				fcOptions[name] = func(momOptions, fcOptions);
			}
		});
	
		// set it as the default language for FullCalendar
		Calendar.defaults.lang = langCode;
	};
	
	
	// NOTE: can't guarantee any of these computations will run because not every language has datepicker
	// configs, so make sure there are English fallbacks for these in the defaults file.
	var dpComputableOptions = {
	
		buttonText: function(dpOptions) {
			return {
				// the translations sometimes wrongly contain HTML entities
				prev: stripHtmlEntities(dpOptions.prevText),
				next: stripHtmlEntities(dpOptions.nextText),
				today: stripHtmlEntities(dpOptions.currentText)
			};
		},
	
		// Produces format strings like "MMMM YYYY" -> "September 2014"
		monthYearFormat: function(dpOptions) {
			return dpOptions.showMonthAfterYear ?
				'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
				'MMMM YYYY[' + dpOptions.yearSuffix + ']';
		}
	
	};
	
	var momComputableOptions = {
	
		// Produces format strings like "ddd M/D" -> "Fri 9/15"
		dayOfMonthFormat: function(momOptions, fcOptions) {
			var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
	
			// strip the year off the edge, as well as other misc non-whitespace chars
			format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
	
			if (fcOptions.isRTL) {
				format += ' ddd'; // for RTL, add day-of-week to end
			}
			else {
				format = 'ddd ' + format; // for LTR, add day-of-week to beginning
			}
			return format;
		},
	
		// Produces format strings like "h:mma" -> "6:00pm"
		mediumTimeFormat: function(momOptions) { // can't be called `timeFormat` because collides with option
			return momOptions.longDateFormat('LT')
				.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
		},
	
		// Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
		smallTimeFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(':mm', '(:mm)')
				.replace(/(\Wmm)$/, '($1)') // like above, but for foreign langs
				.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
		},
	
		// Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
		extraSmallTimeFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(':mm', '(:mm)')
				.replace(/(\Wmm)$/, '($1)') // like above, but for foreign langs
				.replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
		},
	
		// Produces format strings like "ha" / "H" -> "6pm" / "18"
		hourFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(':mm', '')
				.replace(/(\Wmm)$/, '') // like above, but for foreign langs
				.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
		},
	
		// Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
		noMeridiemTimeFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(/\s*a$/i, ''); // remove trailing AM/PM
		}
	
	};
	
	
	// options that should be computed off live calendar options (considers override options)
	// TODO: best place for this? related to lang?
	// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
	var instanceComputableOptions = {
	
		// Produces format strings for results like "Mo 16"
		smallDayDateFormat: function(options) {
			return options.isRTL ?
				'D dd' :
				'dd D';
		},
	
		// Produces format strings for results like "Wk 5"
		weekFormat: function(options) {
			return options.isRTL ?
				'w[ ' + options.weekNumberTitle + ']' :
				'[' + options.weekNumberTitle + ' ]w';
		},
	
		// Produces format strings for results like "Wk5"
		smallWeekFormat: function(options) {
			return options.isRTL ?
				'w[' + options.weekNumberTitle + ']' :
				'[' + options.weekNumberTitle + ']w';
		}
	
	};
	
	function populateInstanceComputableOptions(options) {
		$.each(instanceComputableOptions, function(name, func) {
			if (options[name] == null) {
				options[name] = func(options);
			}
		});
	}
	
	
	// Returns moment's internal locale data. If doesn't exist, returns English.
	// Works with moment-pre-2.8
	function getMomentLocaleData(langCode) {
		var func = moment.localeData || moment.langData;
		return func.call(moment, langCode) ||
			func.call(moment, 'en'); // the newer localData could return null, so fall back to en
	}
	
	
	// Initialize English by forcing computation of moment-derived options.
	// Also, sets it as the default.
	FC.lang('en', Calendar.englishDefaults);
	
	;;
	
	/* Top toolbar area with buttons and title
	----------------------------------------------------------------------------------------------------------------------*/
	// TODO: rename all header-related things to "toolbar"
	
	function Header(calendar) {
		var t = this;
		
		// exports
		t.render = render;
		t.removeElement = removeElement;
		t.updateTitle = updateTitle;
		t.activateButton = activateButton;
		t.deactivateButton = deactivateButton;
		t.disableButton = disableButton;
		t.enableButton = enableButton;
		t.getViewsWithButtons = getViewsWithButtons;
		t.el = null; // mirrors local `el`
		
		// locals
		var el;
		var viewsWithButtons = [];
		var tm;
	
	
		// can be called repeatedly and will rerender
		function render() {
			var options = calendar.options;
			var sections = options.header;
	
			tm = options.theme ? 'ui' : 'fc';
	
			if (sections) {
				if (!el) {
					el = this.el = $("<div class='fc-toolbar'/>");
				}
				else {
					el.empty();
				}
				el.append(renderSection('left'))
					.append(renderSection('right'))
					.append(renderSection('center'))
					.append('<div class="fc-clear"/>');
			}
			else {
				removeElement();
			}
		}
		
		
		function removeElement() {
			if (el) {
				el.remove();
				el = t.el = null;
			}
		}
		
		
		function renderSection(position) {
			var sectionEl = $('<div class="fc-' + position + '"/>');
			var options = calendar.options;
			var buttonStr = options.header[position];
	
			if (buttonStr) {
				$.each(buttonStr.split(' '), function(i) {
					var groupChildren = $();
					var isOnlyButtons = true;
					var groupEl;
	
					$.each(this.split(','), function(j, buttonName) {
						var customButtonProps;
						var viewSpec;
						var buttonClick;
						var overrideText; // text explicitly set by calendar's constructor options. overcomes icons
						var defaultText;
						var themeIcon;
						var normalIcon;
						var innerHtml;
						var classes;
						var button; // the element
	
						if (buttonName == 'title') {
							groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
							isOnlyButtons = false;
						}
						else {
							if ((customButtonProps = (options.customButtons || {})[buttonName])) {
								buttonClick = function(ev) {
									if (customButtonProps.click) {
										customButtonProps.click.call(button[0], ev);
									}
								};
								overrideText = ''; // icons will override text
								defaultText = customButtonProps.text;
							}
							else if ((viewSpec = calendar.getViewSpec(buttonName))) {
								buttonClick = function() {
									calendar.changeView(buttonName);
								};
								viewsWithButtons.push(buttonName);
								overrideText = viewSpec.buttonTextOverride;
								defaultText = viewSpec.buttonTextDefault;
							}
							else if (calendar[buttonName]) { // a calendar method
								buttonClick = function() {
									calendar[buttonName]();
								};
								overrideText = (calendar.overrides.buttonText || {})[buttonName];
								defaultText = options.buttonText[buttonName]; // everything else is considered default
							}
	
							if (buttonClick) {
	
								themeIcon =
									customButtonProps ?
										customButtonProps.themeIcon :
										options.themeButtonIcons[buttonName];
	
								normalIcon =
									customButtonProps ?
										customButtonProps.icon :
										options.buttonIcons[buttonName];
	
								if (overrideText) {
									innerHtml = htmlEscape(overrideText);
								}
								else if (themeIcon && options.theme) {
									innerHtml = "<span class='ui-icon ui-icon-" + themeIcon + "'></span>";
								}
								else if (normalIcon && !options.theme) {
									innerHtml = "<span class='fc-icon fc-icon-" + normalIcon + "'></span>";
								}
								else {
									innerHtml = htmlEscape(defaultText);
								}
	
								classes = [
									'fc-' + buttonName + '-button',
									tm + '-button',
									tm + '-state-default'
								];
	
								button = $( // type="button" so that it doesn't submit a form
									'<button type="button" class="' + classes.join(' ') + '">' +
										innerHtml +
									'</button>'
									)
									.click(function(ev) {
										// don't process clicks for disabled buttons
										if (!button.hasClass(tm + '-state-disabled')) {
	
											buttonClick(ev);
	
											// after the click action, if the button becomes the "active" tab, or disabled,
											// it should never have a hover class, so remove it now.
											if (
												button.hasClass(tm + '-state-active') ||
												button.hasClass(tm + '-state-disabled')
											) {
												button.removeClass(tm + '-state-hover');
											}
										}
									})
									.mousedown(function() {
										// the *down* effect (mouse pressed in).
										// only on buttons that are not the "active" tab, or disabled
										button
											.not('.' + tm + '-state-active')
											.not('.' + tm + '-state-disabled')
											.addClass(tm + '-state-down');
									})
									.mouseup(function() {
										// undo the *down* effect
										button.removeClass(tm + '-state-down');
									})
									.hover(
										function() {
											// the *hover* effect.
											// only on buttons that are not the "active" tab, or disabled
											button
												.not('.' + tm + '-state-active')
												.not('.' + tm + '-state-disabled')
												.addClass(tm + '-state-hover');
										},
										function() {
											// undo the *hover* effect
											button
												.removeClass(tm + '-state-hover')
												.removeClass(tm + '-state-down'); // if mouseleave happens before mouseup
										}
									);
	
								groupChildren = groupChildren.add(button);
							}
						}
					});
	
					if (isOnlyButtons) {
						groupChildren
							.first().addClass(tm + '-corner-left').end()
							.last().addClass(tm + '-corner-right').end();
					}
	
					if (groupChildren.length > 1) {
						groupEl = $('<div/>');
						if (isOnlyButtons) {
							groupEl.addClass('fc-button-group');
						}
						groupEl.append(groupChildren);
						sectionEl.append(groupEl);
					}
					else {
						sectionEl.append(groupChildren); // 1 or 0 children
					}
				});
			}
	
			return sectionEl;
		}
		
		
		function updateTitle(text) {
			if (el) {
				el.find('h2').text(text);
			}
		}
		
		
		function activateButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.addClass(tm + '-state-active');
			}
		}
		
		
		function deactivateButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.removeClass(tm + '-state-active');
			}
		}
		
		
		function disableButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.prop('disabled', true)
					.addClass(tm + '-state-disabled');
			}
		}
		
		
		function enableButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.prop('disabled', false)
					.removeClass(tm + '-state-disabled');
			}
		}
	
	
		function getViewsWithButtons() {
			return viewsWithButtons;
		}
	
	}
	
	;;
	
	FC.sourceNormalizers = [];
	FC.sourceFetchers = [];
	
	var ajaxDefaults = {
		dataType: 'json',
		cache: false
	};
	
	var eventGUID = 1;
	
	
	function EventManager() { // assumed to be a calendar
		var t = this;
		
		
		// exports
		t.isFetchNeeded = isFetchNeeded;
		t.fetchEvents = fetchEvents;
		t.fetchEventSources = fetchEventSources;
		t.getEventSources = getEventSources;
		t.getEventSourceById = getEventSourceById;
		t.getEventSourcesByMatchArray = getEventSourcesByMatchArray;
		t.getEventSourcesByMatch = getEventSourcesByMatch;
		t.addEventSource = addEventSource;
		t.removeEventSource = removeEventSource;
		t.removeEventSources = removeEventSources;
		t.updateEvent = updateEvent;
		t.renderEvent = renderEvent;
		t.removeEvents = removeEvents;
		t.clientEvents = clientEvents;
		t.mutateEvent = mutateEvent;
		t.normalizeEventDates = normalizeEventDates;
		t.normalizeEventTimes = normalizeEventTimes;
		
		
		// imports
		var reportEvents = t.reportEvents;
		
		
		// locals
		var stickySource = { events: [] };
		var sources = [ stickySource ];
		var rangeStart, rangeEnd;
		var pendingSourceCnt = 0; // outstanding fetch requests, max one per source
		var cache = []; // holds events that have already been expanded
	
	
		$.each(
			(t.options.events ? [ t.options.events ] : []).concat(t.options.eventSources || []),
			function(i, sourceInput) {
				var source = buildEventSource(sourceInput);
				if (source) {
					sources.push(source);
				}
			}
		);
		
		
		
		/* Fetching
		-----------------------------------------------------------------------------*/
	
	
		// start and end are assumed to be unzoned
		function isFetchNeeded(start, end) {
			return !rangeStart || // nothing has been fetched yet?
				start < rangeStart || end > rangeEnd; // is part of the new range outside of the old range?
		}
		
		
		function fetchEvents(start, end) {
			rangeStart = start;
			rangeEnd = end;
			fetchEventSources(sources, 'reset');
		}
	
	
		// expects an array of event source objects (the originals, not copies)
		// `specialFetchType` is an optimization parameter that affects purging of the event cache.
		function fetchEventSources(specificSources, specialFetchType) {
			var i, source;
	
			if (specialFetchType === 'reset') {
				cache = [];
			}
			else if (specialFetchType !== 'add') {
				cache = excludeEventsBySources(cache, specificSources);
			}
	
			for (i = 0; i < specificSources.length; i++) {
				source = specificSources[i];
	
				// already-pending sources have already been accounted for in pendingSourceCnt
				if (source._status !== 'pending') {
					pendingSourceCnt++;
				}
	
				source._fetchId = (source._fetchId || 0) + 1;
				source._status = 'pending';
			}
	
			for (i = 0; i < specificSources.length; i++) {
				source = specificSources[i];
	
				tryFetchEventSource(source, source._fetchId);
			}
		}
	
	
		// fetches an event source and processes its result ONLY if it is still the current fetch.
		// caller is responsible for incrementing pendingSourceCnt first.
		function tryFetchEventSource(source, fetchId) {
			_fetchEventSource(source, function(eventInputs) {
				var isArraySource = $.isArray(source.events);
				var i, eventInput;
				var abstractEvent;
	
				if (
					// is this the source's most recent fetch?
					// if not, rely on an upcoming fetch of this source to decrement pendingSourceCnt
					fetchId === source._fetchId &&
					// event source no longer valid?
					source._status !== 'rejected'
				) {
					source._status = 'resolved';
	
					if (eventInputs) {
						for (i = 0; i < eventInputs.length; i++) {
							eventInput = eventInputs[i];
	
							if (isArraySource) { // array sources have already been convert to Event Objects
								abstractEvent = eventInput;
							}
							else {
								abstractEvent = buildEventFromInput(eventInput, source);
							}
	
							if (abstractEvent) { // not false (an invalid event)
								cache.push.apply(
									cache,
									expandEvent(abstractEvent) // add individual expanded events to the cache
								);
							}
						}
					}
	
					decrementPendingSourceCnt();
				}
			});
		}
	
	
		function rejectEventSource(source) {
			var wasPending = source._status === 'pending';
	
			source._status = 'rejected';
	
			if (wasPending) {
				decrementPendingSourceCnt();
			}
		}
	
	
		function decrementPendingSourceCnt() {
			pendingSourceCnt--;
			if (!pendingSourceCnt) {
				reportEvents(cache);
			}
		}
		
		
		function _fetchEventSource(source, callback) {
			var i;
			var fetchers = FC.sourceFetchers;
			var res;
	
			for (i=0; i<fetchers.length; i++) {
				res = fetchers[i].call(
					t, // this, the Calendar object
					source,
					rangeStart.clone(),
					rangeEnd.clone(),
					t.options.timezone,
					callback
				);
	
				if (res === true) {
					// the fetcher is in charge. made its own async request
					return;
				}
				else if (typeof res == 'object') {
					// the fetcher returned a new source. process it
					_fetchEventSource(res, callback);
					return;
				}
			}
	
			var events = source.events;
			if (events) {
				if ($.isFunction(events)) {
					t.pushLoading();
					events.call(
						t, // this, the Calendar object
						rangeStart.clone(),
						rangeEnd.clone(),
						t.options.timezone,
						function(events) {
							callback(events);
							t.popLoading();
						}
					);
				}
				else if ($.isArray(events)) {
					callback(events);
				}
				else {
					callback();
				}
			}else{
				var url = source.url;
				if (url) {
					var success = source.success;
					var error = source.error;
					var complete = source.complete;
	
					// retrieve any outbound GET/POST $.ajax data from the options
					var customData;
					if ($.isFunction(source.data)) {
						// supplied as a function that returns a key/value object
						customData = source.data();
					}
					else {
						// supplied as a straight key/value object
						customData = source.data;
					}
	
					// use a copy of the custom data so we can modify the parameters
					// and not affect the passed-in object.
					var data = $.extend({}, customData || {});
	
					var startParam = firstDefined(source.startParam, t.options.startParam);
					var endParam = firstDefined(source.endParam, t.options.endParam);
					var timezoneParam = firstDefined(source.timezoneParam, t.options.timezoneParam);
	
					if (startParam) {
						data[startParam] = rangeStart.format();
					}
					if (endParam) {
						data[endParam] = rangeEnd.format();
					}
					if (t.options.timezone && t.options.timezone != 'local') {
						data[timezoneParam] = t.options.timezone;
					}
	
					t.pushLoading();
					$.ajax($.extend({}, ajaxDefaults, source, {
						data: data,
						success: function(events) {
							events = events || [];
							var res = applyAll(success, this, arguments);
							if ($.isArray(res)) {
								events = res;
							}
							callback(events);
						},
						error: function() {
							applyAll(error, this, arguments);
							callback();
						},
						complete: function() {
							applyAll(complete, this, arguments);
							t.popLoading();
						}
					}));
				}else{
					callback();
				}
			}
		}
		
		
		
		/* Sources
		-----------------------------------------------------------------------------*/
	
	
		function addEventSource(sourceInput) {
			var source = buildEventSource(sourceInput);
			if (source) {
				sources.push(source);
				fetchEventSources([ source ], 'add'); // will eventually call reportEvents
			}
		}
	
	
		function buildEventSource(sourceInput) { // will return undefined if invalid source
			var normalizers = FC.sourceNormalizers;
			var source;
			var i;
	
			if ($.isFunction(sourceInput) || $.isArray(sourceInput)) {
				source = { events: sourceInput };
			}
			else if (typeof sourceInput === 'string') {
				source = { url: sourceInput };
			}
			else if (typeof sourceInput === 'object') {
				source = $.extend({}, sourceInput); // shallow copy
			}
	
			if (source) {
	
				// TODO: repeat code, same code for event classNames
				if (source.className) {
					if (typeof source.className === 'string') {
						source.className = source.className.split(/\s+/);
					}
					// otherwise, assumed to be an array
				}
				else {
					source.className = [];
				}
	
				// for array sources, we convert to standard Event Objects up front
				if ($.isArray(source.events)) {
					source.origArray = source.events; // for removeEventSource
					source.events = $.map(source.events, function(eventInput) {
						return buildEventFromInput(eventInput, source);
					});
				}
	
				for (i=0; i<normalizers.length; i++) {
					normalizers[i].call(t, source);
				}
	
				return source;
			}
		}
	
	
		function removeEventSource(matchInput) {
			removeSpecificEventSources(
				getEventSourcesByMatch(matchInput)
			);
		}
	
	
		// if called with no arguments, removes all.
		function removeEventSources(matchInputs) {
			if (matchInputs == null) {
				removeSpecificEventSources(sources, true); // isAll=true
			}
			else {
				removeSpecificEventSources(
					getEventSourcesByMatchArray(matchInputs)
				);
			}
		}
	
	
		function removeSpecificEventSources(targetSources, isAll) {
			var i;
	
			// cancel pending requests
			for (i = 0; i < targetSources.length; i++) {
				rejectEventSource(targetSources[i]);
			}
	
			if (isAll) { // an optimization
				sources = [];
				cache = [];
			}
			else {
				// remove from persisted source list
				sources = $.grep(sources, function(source) {
					for (i = 0; i < targetSources.length; i++) {
						if (source === targetSources[i]) {
							return false; // exclude
						}
					}
					return true; // include
				});
	
				cache = excludeEventsBySources(cache, targetSources);
			}
	
			reportEvents(cache);
		}
	
	
		function getEventSources() {
			return sources.slice(1); // returns a shallow copy of sources with stickySource removed
		}
	
	
		function getEventSourceById(id) {
			return $.grep(sources, function(source) {
				return source.id && source.id === id;
			})[0];
		}
	
	
		// like getEventSourcesByMatch, but accepts multple match criteria (like multiple IDs)
		function getEventSourcesByMatchArray(matchInputs) {
	
			// coerce into an array
			if (!matchInputs) {
				matchInputs = [];
			}
			else if (!$.isArray(matchInputs)) {
				matchInputs = [ matchInputs ];
			}
	
			var matchingSources = [];
			var i;
	
			// resolve raw inputs to real event source objects
			for (i = 0; i < matchInputs.length; i++) {
				matchingSources.push.apply( // append
					matchingSources,
					getEventSourcesByMatch(matchInputs[i])
				);
			}
	
			return matchingSources;
		}
	
	
		// matchInput can either by a real event source object, an ID, or the function/URL for the source.
		// returns an array of matching source objects.
		function getEventSourcesByMatch(matchInput) {
			var i, source;
	
			// given an proper event source object
			for (i = 0; i < sources.length; i++) {
				source = sources[i];
				if (source === matchInput) {
					return [ source ];
				}
			}
	
			// an ID match
			source = getEventSourceById(matchInput);
			if (source) {
				return [ source ];
			}
	
			return $.grep(sources, function(source) {
				return isSourcesEquivalent(matchInput, source);
			});
		}
	
	
		function isSourcesEquivalent(source1, source2) {
			return source1 && source2 && getSourcePrimitive(source1) == getSourcePrimitive(source2);
		}
	
	
		function getSourcePrimitive(source) {
			return (
				(typeof source === 'object') ? // a normalized event source?
					(source.origArray || source.googleCalendarId || source.url || source.events) : // get the primitive
					null
			) ||
			source; // the given argument *is* the primitive
		}
	
	
		// util
		// returns a filtered array without events that are part of any of the given sources
		function excludeEventsBySources(specificEvents, specificSources) {
			return $.grep(specificEvents, function(event) {
				for (var i = 0; i < specificSources.length; i++) {
					if (event.source === specificSources[i]) {
						return false; // exclude
					}
				}
				return true; // keep
			});
		}
		
		
		
		/* Manipulation
		-----------------------------------------------------------------------------*/
	
	
		// Only ever called from the externally-facing API
		function updateEvent(event) {
	
			// massage start/end values, even if date string values
			event.start = t.moment(event.start);
			if (event.end) {
				event.end = t.moment(event.end);
			}
			else {
				event.end = null;
			}
	
			mutateEvent(event, getMiscEventProps(event)); // will handle start/end/allDay normalization
			reportEvents(cache); // reports event modifications (so we can redraw)
		}
	
	
		// Returns a hash of misc event properties that should be copied over to related events.
		function getMiscEventProps(event) {
			var props = {};
	
			$.each(event, function(name, val) {
				if (isMiscEventPropName(name)) {
					if (val !== undefined && isAtomic(val)) { // a defined non-object
						props[name] = val;
					}
				}
			});
	
			return props;
		}
	
		// non-date-related, non-id-related, non-secret
		function isMiscEventPropName(name) {
			return !/^_|^(id|allDay|start|end)$/.test(name);
		}
	
		
		// returns the expanded events that were created
		function renderEvent(eventInput, stick) {
			var abstractEvent = buildEventFromInput(eventInput);
			var events;
			var i, event;
	
			if (abstractEvent) { // not false (a valid input)
				events = expandEvent(abstractEvent);
	
				for (i = 0; i < events.length; i++) {
					event = events[i];
	
					if (!event.source) {
						if (stick) {
							stickySource.events.push(event);
							event.source = stickySource;
						}
						cache.push(event);
					}
				}
	
				reportEvents(cache);
	
				return events;
			}
	
			return [];
		}
		
		
		function removeEvents(filter) {
			var eventID;
			var i;
	
			if (filter == null) { // null or undefined. remove all events
				filter = function() { return true; }; // will always match
			}
			else if (!$.isFunction(filter)) { // an event ID
				eventID = filter + '';
				filter = function(event) {
					return event._id == eventID;
				};
			}
	
			// Purge event(s) from our local cache
			cache = $.grep(cache, filter, true); // inverse=true
	
			// Remove events from array sources.
			// This works because they have been converted to official Event Objects up front.
			// (and as a result, event._id has been calculated).
			for (i=0; i<sources.length; i++) {
				if ($.isArray(sources[i].events)) {
					sources[i].events = $.grep(sources[i].events, filter, true);
				}
			}
	
			reportEvents(cache);
		}
	
		
		function clientEvents(filter) {
			if ($.isFunction(filter)) {
				return $.grep(cache, filter);
			}
			else if (filter != null) { // not null, not undefined. an event ID
				filter += '';
				return $.grep(cache, function(e) {
					return e._id == filter;
				});
			}
			return cache; // else, return all
		}
	
	
		// Makes sure all array event sources have their internal event objects
		// converted over to the Calendar's current timezone.
		t.rezoneArrayEventSources = function() {
			var i;
			var events;
			var j;
	
			for (i = 0; i < sources.length; i++) {
				events = sources[i].events;
				if ($.isArray(events)) {
	
					for (j = 0; j < events.length; j++) {
						rezoneEventDates(events[j]);
					}
				}
			}
		};
	
		function rezoneEventDates(event) {
			event.start = t.moment(event.start);
			if (event.end) {
				event.end = t.moment(event.end);
			}
			backupEventDates(event);
		}
		
		
		/* Event Normalization
		-----------------------------------------------------------------------------*/
	
	
		// Given a raw object with key/value properties, returns an "abstract" Event object.
		// An "abstract" event is an event that, if recurring, will not have been expanded yet.
		// Will return `false` when input is invalid.
		// `source` is optional
		function buildEventFromInput(input, source) {
			var out = {};
			var start, end;
			var allDay;
	
			if (t.options.eventDataTransform) {
				input = t.options.eventDataTransform(input);
			}
			if (source && source.eventDataTransform) {
				input = source.eventDataTransform(input);
			}
	
			// Copy all properties over to the resulting object.
			// The special-case properties will be copied over afterwards.
			$.extend(out, input);
	
			if (source) {
				out.source = source;
			}
	
			out._id = input._id || (input.id === undefined ? '_fc' + eventGUID++ : input.id + '');
	
			if (input.className) {
				if (typeof input.className == 'string') {
					out.className = input.className.split(/\s+/);
				}
				else { // assumed to be an array
					out.className = input.className;
				}
			}
			else {
				out.className = [];
			}
	
			start = input.start || input.date; // "date" is an alias for "start"
			end = input.end;
	
			// parse as a time (Duration) if applicable
			if (isTimeString(start)) {
				start = moment.duration(start);
			}
			if (isTimeString(end)) {
				end = moment.duration(end);
			}
	
			if (input.dow || moment.isDuration(start) || moment.isDuration(end)) {
	
				// the event is "abstract" (recurring) so don't calculate exact start/end dates just yet
				out.start = start ? moment.duration(start) : null; // will be a Duration or null
				out.end = end ? moment.duration(end) : null; // will be a Duration or null
				out._recurring = true; // our internal marker
			}
			else {
	
				if (start) {
					start = t.moment(start);
					if (!start.isValid()) {
						return false;
					}
				}
	
				if (end) {
					end = t.moment(end);
					if (!end.isValid()) {
						end = null; // let defaults take over
					}
				}
	
				allDay = input.allDay;
				if (allDay === undefined) { // still undefined? fallback to default
					allDay = firstDefined(
						source ? source.allDayDefault : undefined,
						t.options.allDayDefault
					);
					// still undefined? normalizeEventDates will calculate it
				}
	
				assignDatesToEvent(start, end, allDay, out);
			}
	
			t.normalizeEvent(out); // hook for external use. a prototype method
	
			return out;
		}
		t.buildEventFromInput = buildEventFromInput;
	
	
		// Normalizes and assigns the given dates to the given partially-formed event object.
		// NOTE: mutates the given start/end moments. does not make a copy.
		function assignDatesToEvent(start, end, allDay, event) {
			event.start = start;
			event.end = end;
			event.allDay = allDay;
			normalizeEventDates(event);
			backupEventDates(event);
		}
	
	
		// Ensures proper values for allDay/start/end. Accepts an Event object, or a plain object with event-ish properties.
		// NOTE: Will modify the given object.
		function normalizeEventDates(eventProps) {
	
			normalizeEventTimes(eventProps);
	
			if (eventProps.end && !eventProps.end.isAfter(eventProps.start)) {
				eventProps.end = null;
			}
	
			if (!eventProps.end) {
				if (t.options.forceEventDuration) {
					eventProps.end = t.getDefaultEventEnd(eventProps.allDay, eventProps.start);
				}
				else {
					eventProps.end = null;
				}
			}
		}
	
	
		// Ensures the allDay property exists and the timeliness of the start/end dates are consistent
		function normalizeEventTimes(eventProps) {
			if (eventProps.allDay == null) {
				eventProps.allDay = !(eventProps.start.hasTime() || (eventProps.end && eventProps.end.hasTime()));
			}
	
			if (eventProps.allDay) {
				eventProps.start.stripTime();
				if (eventProps.end) {
					// TODO: consider nextDayThreshold here? If so, will require a lot of testing and adjustment
					eventProps.end.stripTime();
				}
			}
			else {
				if (!eventProps.start.hasTime()) {
					eventProps.start = t.applyTimezone(eventProps.start.time(0)); // will assign a 00:00 time
				}
				if (eventProps.end && !eventProps.end.hasTime()) {
					eventProps.end = t.applyTimezone(eventProps.end.time(0)); // will assign a 00:00 time
				}
			}
		}
	
	
		// If the given event is a recurring event, break it down into an array of individual instances.
		// If not a recurring event, return an array with the single original event.
		// If given a falsy input (probably because of a failed buildEventFromInput call), returns an empty array.
		// HACK: can override the recurring window by providing custom rangeStart/rangeEnd (for businessHours).
		function expandEvent(abstractEvent, _rangeStart, _rangeEnd) {
			var events = [];
			var dowHash;
			var dow;
			var i;
			var date;
			var startTime, endTime;
			var start, end;
			var event;
	
			_rangeStart = _rangeStart || rangeStart;
			_rangeEnd = _rangeEnd || rangeEnd;
	
			if (abstractEvent) {
				if (abstractEvent._recurring) {
	
					// make a boolean hash as to whether the event occurs on each day-of-week
					if ((dow = abstractEvent.dow)) {
						dowHash = {};
						for (i = 0; i < dow.length; i++) {
							dowHash[dow[i]] = true;
						}
					}
	
					// iterate through every day in the current range
					date = _rangeStart.clone().stripTime(); // holds the date of the current day
					while (date.isBefore(_rangeEnd)) {
	
						if (!dowHash || dowHash[date.day()]) { // if everyday, or this particular day-of-week
	
							startTime = abstractEvent.start; // the stored start and end properties are times (Durations)
							endTime = abstractEvent.end; // "
							start = date.clone();
							end = null;
	
							if (startTime) {
								start = start.time(startTime);
							}
							if (endTime) {
								end = date.clone().time(endTime);
							}
	
							event = $.extend({}, abstractEvent); // make a copy of the original
							assignDatesToEvent(
								start, end,
								!startTime && !endTime, // allDay?
								event
							);
							events.push(event);
						}
	
						date.add(1, 'days');
					}
				}
				else {
					events.push(abstractEvent); // return the original event. will be a one-item array
				}
			}
	
			return events;
		}
		t.expandEvent = expandEvent;
	
	
	
		/* Event Modification Math
		-----------------------------------------------------------------------------------------*/
	
	
		// Modifies an event and all related events by applying the given properties.
		// Special date-diffing logic is used for manipulation of dates.
		// If `props` does not contain start/end dates, the updated values are assumed to be the event's current start/end.
		// All date comparisons are done against the event's pristine _start and _end dates.
		// Returns an object with delta information and a function to undo all operations.
		// For making computations in a granularity greater than day/time, specify largeUnit.
		// NOTE: The given `newProps` might be mutated for normalization purposes.
		function mutateEvent(event, newProps, largeUnit) {
			var miscProps = {};
			var oldProps;
			var clearEnd;
			var startDelta;
			var endDelta;
			var durationDelta;
			var undoFunc;
	
			// diffs the dates in the appropriate way, returning a duration
			function diffDates(date1, date0) { // date1 - date0
				if (largeUnit) {
					return diffByUnit(date1, date0, largeUnit);
				}
				else if (newProps.allDay) {
					return diffDay(date1, date0);
				}
				else {
					return diffDayTime(date1, date0);
				}
			}
	
			newProps = newProps || {};
	
			// normalize new date-related properties
			if (!newProps.start) {
				newProps.start = event.start.clone();
			}
			if (newProps.end === undefined) {
				newProps.end = event.end ? event.end.clone() : null;
			}
			if (newProps.allDay == null) { // is null or undefined?
				newProps.allDay = event.allDay;
			}
			normalizeEventDates(newProps);
	
			// create normalized versions of the original props to compare against
			// need a real end value, for diffing
			oldProps = {
				start: event._start.clone(),
				end: event._end ? event._end.clone() : t.getDefaultEventEnd(event._allDay, event._start),
				allDay: newProps.allDay // normalize the dates in the same regard as the new properties
			};
			normalizeEventDates(oldProps);
	
			// need to clear the end date if explicitly changed to null
			clearEnd = event._end !== null && newProps.end === null;
	
			// compute the delta for moving the start date
			startDelta = diffDates(newProps.start, oldProps.start);
	
			// compute the delta for moving the end date
			if (newProps.end) {
				endDelta = diffDates(newProps.end, oldProps.end);
				durationDelta = endDelta.subtract(startDelta);
			}
			else {
				durationDelta = null;
			}
	
			// gather all non-date-related properties
			$.each(newProps, function(name, val) {
				if (isMiscEventPropName(name)) {
					if (val !== undefined) {
						miscProps[name] = val;
					}
				}
			});
	
			// apply the operations to the event and all related events
			undoFunc = mutateEvents(
				clientEvents(event._id), // get events with this ID
				clearEnd,
				newProps.allDay,
				startDelta,
				durationDelta,
				miscProps
			);
	
			return {
				dateDelta: startDelta,
				durationDelta: durationDelta,
				undo: undoFunc
			};
		}
	
	
		// Modifies an array of events in the following ways (operations are in order):
		// - clear the event's `end`
		// - convert the event to allDay
		// - add `dateDelta` to the start and end
		// - add `durationDelta` to the event's duration
		// - assign `miscProps` to the event
		//
		// Returns a function that can be called to undo all the operations.
		//
		// TODO: don't use so many closures. possible memory issues when lots of events with same ID.
		//
		function mutateEvents(events, clearEnd, allDay, dateDelta, durationDelta, miscProps) {
			var isAmbigTimezone = t.getIsAmbigTimezone();
			var undoFunctions = [];
	
			// normalize zero-length deltas to be null
			if (dateDelta && !dateDelta.valueOf()) { dateDelta = null; }
			if (durationDelta && !durationDelta.valueOf()) { durationDelta = null; }
	
			$.each(events, function(i, event) {
				var oldProps;
				var newProps;
	
				// build an object holding all the old values, both date-related and misc.
				// for the undo function.
				oldProps = {
					start: event.start.clone(),
					end: event.end ? event.end.clone() : null,
					allDay: event.allDay
				};
				$.each(miscProps, function(name) {
					oldProps[name] = event[name];
				});
	
				// new date-related properties. work off the original date snapshot.
				// ok to use references because they will be thrown away when backupEventDates is called.
				newProps = {
					start: event._start,
					end: event._end,
					allDay: allDay // normalize the dates in the same regard as the new properties
				};
				normalizeEventDates(newProps); // massages start/end/allDay
	
				// strip or ensure the end date
				if (clearEnd) {
					newProps.end = null;
				}
				else if (durationDelta && !newProps.end) { // the duration translation requires an end date
					newProps.end = t.getDefaultEventEnd(newProps.allDay, newProps.start);
				}
	
				if (dateDelta) {
					newProps.start.add(dateDelta);
					if (newProps.end) {
						newProps.end.add(dateDelta);
					}
				}
	
				if (durationDelta) {
					newProps.end.add(durationDelta); // end already ensured above
				}
	
				// if the dates have changed, and we know it is impossible to recompute the
				// timezone offsets, strip the zone.
				if (
					isAmbigTimezone &&
					!newProps.allDay &&
					(dateDelta || durationDelta)
				) {
					newProps.start.stripZone();
					if (newProps.end) {
						newProps.end.stripZone();
					}
				}
	
				$.extend(event, miscProps, newProps); // copy over misc props, then date-related props
				backupEventDates(event); // regenerate internal _start/_end/_allDay
	
				undoFunctions.push(function() {
					$.extend(event, oldProps);
					backupEventDates(event); // regenerate internal _start/_end/_allDay
				});
			});
	
			return function() {
				for (var i = 0; i < undoFunctions.length; i++) {
					undoFunctions[i]();
				}
			};
		}
	
	
		/* Overlapping / Constraining
		-----------------------------------------------------------------------------------------*/
	
		t.isEventSpanAllowed = isEventSpanAllowed;
		t.isExternalSpanAllowed = isExternalSpanAllowed;
		t.isSelectionSpanAllowed = isSelectionSpanAllowed;
	
	
		// Determines if the given event can be relocated to the given span (unzoned start/end with other misc data)
		function isEventSpanAllowed(span, event) {
			var source = event.source || {};
			var constraint = firstDefined(
				event.constraint,
				source.constraint,
				t.options.eventConstraint
			);
			var overlap = firstDefined(
				event.overlap,
				source.overlap,
				t.options.eventOverlap
			);
			return isSpanAllowed(span, constraint, overlap, event);
		}
	
	
		// Determines if an external event can be relocated to the given span (unzoned start/end with other misc data)
		function isExternalSpanAllowed(eventSpan, eventLocation, eventProps) {
			var eventInput;
			var event;
	
			// note: very similar logic is in View's reportExternalDrop
			if (eventProps) {
				eventInput = $.extend({}, eventProps, eventLocation);
				event = expandEvent(buildEventFromInput(eventInput))[0];
			}
	
			if (event) {
				return isEventSpanAllowed(eventSpan, event);
			}
			else { // treat it as a selection
	
				return isSelectionSpanAllowed(eventSpan);
			}
		}
	
	
		// Determines the given span (unzoned start/end with other misc data) can be selected.
		function isSelectionSpanAllowed(span) {
			return isSpanAllowed(span, t.options.selectConstraint, t.options.selectOverlap);
		}
	
	
		// Returns true if the given span (caused by an event drop/resize or a selection) is allowed to exist
		// according to the constraint/overlap settings.
		// `event` is not required if checking a selection.
		function isSpanAllowed(span, constraint, overlap, event) {
			var constraintEvents;
			var anyContainment;
			var peerEvents;
			var i, peerEvent;
			var peerOverlap;
	
			// the range must be fully contained by at least one of produced constraint events
			if (constraint != null) {
	
				// not treated as an event! intermediate data structure
				// TODO: use ranges in the future
				constraintEvents = constraintToEvents(constraint);
	
				anyContainment = false;
				for (i = 0; i < constraintEvents.length; i++) {
					if (t.spanContainsSpan(constraintEvents[i], span)) {
						anyContainment = true;
						break;
					}
				}
	
				if (!anyContainment) {
					return false;
				}
			}
	
			peerEvents = t.getPeerEvents(span, event);
	
			for (i = 0; i < peerEvents.length; i++)  {
				peerEvent = peerEvents[i];
	
				// there needs to be an actual intersection before disallowing anything
				if (eventIntersectsRange(peerEvent, span)) {
	
					// evaluate overlap for the given range and short-circuit if necessary
					if (overlap === false) {
						return false;
					}
					// if the event's overlap is a test function, pass the peer event in question as the first param
					else if (typeof overlap === 'function' && !overlap(peerEvent, event)) {
						return false;
					}
	
					// if we are computing if the given range is allowable for an event, consider the other event's
					// EventObject-specific or Source-specific `overlap` property
					if (event) {
						peerOverlap = firstDefined(
							peerEvent.overlap,
							(peerEvent.source || {}).overlap
							// we already considered the global `eventOverlap`
						);
						if (peerOverlap === false) {
							return false;
						}
						// if the peer event's overlap is a test function, pass the subject event as the first param
						if (typeof peerOverlap === 'function' && !peerOverlap(event, peerEvent)) {
							return false;
						}
					}
				}
			}
	
			return true;
		}
	
	
		// Given an event input from the API, produces an array of event objects. Possible event inputs:
		// 'businessHours'
		// An event ID (number or string)
		// An object with specific start/end dates or a recurring event (like what businessHours accepts)
		function constraintToEvents(constraintInput) {
	
			if (constraintInput === 'businessHours') {
				return t.getCurrentBusinessHourEvents();
			}
	
			if (typeof constraintInput === 'object') {
				return expandEvent(buildEventFromInput(constraintInput));
			}
	
			return clientEvents(constraintInput); // probably an ID
		}
	
	
		// Does the event's date range intersect with the given range?
		// start/end already assumed to have stripped zones :(
		function eventIntersectsRange(event, range) {
			var eventStart = event.start.clone().stripZone();
			var eventEnd = t.getEventEnd(event).stripZone();
	
			return range.start < eventEnd && range.end > eventStart;
		}
	
	
		t.getEventCache = function() {
			return cache;
		};
	
	}
	
	
	// hook for external libs to manipulate event properties upon creation.
	// should manipulate the event in-place.
	Calendar.prototype.normalizeEvent = function(event) {
	};
	
	
	// Does the given span (start, end, and other location information)
	// fully contain the other?
	Calendar.prototype.spanContainsSpan = function(outerSpan, innerSpan) {
		var eventStart = outerSpan.start.clone().stripZone();
		var eventEnd = this.getEventEnd(outerSpan).stripZone();
	
		return innerSpan.start >= eventStart && innerSpan.end <= eventEnd;
	};
	
	
	// Returns a list of events that the given event should be compared against when being considered for a move to
	// the specified span. Attached to the Calendar's prototype because EventManager is a mixin for a Calendar.
	Calendar.prototype.getPeerEvents = function(span, event) {
		var cache = this.getEventCache();
		var peerEvents = [];
		var i, otherEvent;
	
		for (i = 0; i < cache.length; i++) {
			otherEvent = cache[i];
			if (
				!event ||
				event._id !== otherEvent._id // don't compare the event to itself or other related [repeating] events
			) {
				peerEvents.push(otherEvent);
			}
		}
	
		return peerEvents;
	};
	
	
	// updates the "backup" properties, which are preserved in order to compute diffs later on.
	function backupEventDates(event) {
		event._allDay = event.allDay;
		event._start = event.start.clone();
		event._end = event.end ? event.end.clone() : null;
	}
	
	
	/* Business Hours
	-----------------------------------------------------------------------------------------*/
	
	var BUSINESS_HOUR_EVENT_DEFAULTS = {
		id: '_fcBusinessHours', // will relate events from different calls to expandEvent
		start: '09:00',
		end: '17:00',
		dow: [ 1, 2, 3, 4, 5 ], // monday - friday
		rendering: 'inverse-background'
		// classNames are defined in businessHoursSegClasses
	};
	
	// Return events objects for business hours within the current view.
	// Abuse of our event system :(
	Calendar.prototype.getCurrentBusinessHourEvents = function(wholeDay) {
		return this.computeBusinessHourEvents(wholeDay, this.options.businessHours);
	};
	
	// Given a raw input value from options, return events objects for business hours within the current view.
	Calendar.prototype.computeBusinessHourEvents = function(wholeDay, input) {
		if (input === true) {
			return this.expandBusinessHourEvents(wholeDay, [ {} ]);
		}
		else if ($.isPlainObject(input)) {
			return this.expandBusinessHourEvents(wholeDay, [ input ]);
		}
		else if ($.isArray(input)) {
			return this.expandBusinessHourEvents(wholeDay, input, true);
		}
		else {
			return [];
		}
	};
	
	// inputs expected to be an array of objects.
	// if ignoreNoDow is true, will ignore entries that don't specify a day-of-week (dow) key.
	Calendar.prototype.expandBusinessHourEvents = function(wholeDay, inputs, ignoreNoDow) {
		var view = this.getView();
		var events = [];
		var i, input;
	
		for (i = 0; i < inputs.length; i++) {
			input = inputs[i];
	
			if (ignoreNoDow && !input.dow) {
				continue;
			}
	
			// give defaults. will make a copy
			input = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, input);
	
			// if a whole-day series is requested, clear the start/end times
			if (wholeDay) {
				input.start = null;
				input.end = null;
			}
	
			events.push.apply(events, // append
				this.expandEvent(
					this.buildEventFromInput(input),
					view.start,
					view.end
				)
			);
		}
	
		return events;
	};
	
	;;
	
	/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
	----------------------------------------------------------------------------------------------------------------------*/
	// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
	// It is responsible for managing width/height.
	
	var BasicView = FC.BasicView = View.extend({
	
		scroller: null,
	
		dayGridClass: DayGrid, // class the dayGrid will be instantiated from (overridable by subclasses)
		dayGrid: null, // the main subcomponent that does most of the heavy lifting
	
		dayNumbersVisible: false, // display day numbers on each day cell?
		weekNumbersVisible: false, // display week numbers along the side?
	
		weekNumberWidth: null, // width of all the week-number cells running down the side
	
		headContainerEl: null, // div that hold's the dayGrid's rendered date header
		headRowEl: null, // the fake row element of the day-of-week header
	
	
		initialize: function() {
			this.dayGrid = this.instantiateDayGrid();
	
			this.scroller = new Scroller({
				overflowX: 'hidden',
				overflowY: 'auto'
			});
		},
	
	
		// Generates the DayGrid object this view needs. Draws from this.dayGridClass
		instantiateDayGrid: function() {
			// generate a subclass on the fly with BasicView-specific behavior
			// TODO: cache this subclass
			var subclass = this.dayGridClass.extend(basicDayGridMethods);
	
			return new subclass(this);
		},
	
	
		// Sets the display range and computes all necessary dates
		setRange: function(range) {
			View.prototype.setRange.call(this, range); // call the super-method
	
			this.dayGrid.breakOnWeeks = /year|month|week/.test(this.intervalUnit); // do before setRange
			this.dayGrid.setRange(range);
		},
	
	
		// Compute the value to feed into setRange. Overrides superclass.
		computeRange: function(date) {
			var range = View.prototype.computeRange.call(this, date); // get value from the super-method
	
			// year and month views should be aligned with weeks. this is already done for week
			if (/year|month/.test(range.intervalUnit)) {
				range.start.startOf('week');
				range.start = this.skipHiddenDays(range.start);
	
				// make end-of-week if not already
				if (range.end.weekday()) {
					range.end.add(1, 'week').startOf('week');
					range.end = this.skipHiddenDays(range.end, -1, true); // exclusively move backwards
				}
			}
	
			return range;
		},
	
	
		// Renders the view into `this.el`, which should already be assigned
		renderDates: function() {
	
			this.dayNumbersVisible = this.dayGrid.rowCnt > 1; // TODO: make grid responsible
			this.weekNumbersVisible = this.opt('weekNumbers');
			this.dayGrid.numbersVisible = this.dayNumbersVisible || this.weekNumbersVisible;
	
			this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
			this.renderHead();
	
			this.scroller.render();
			var dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
			var dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
			this.el.find('.fc-body > tr > td').append(dayGridContainerEl);
	
			this.dayGrid.setElement(dayGridEl);
			this.dayGrid.renderDates(this.hasRigidRows());
		},
	
	
		// render the day-of-week headers
		renderHead: function() {
			this.headContainerEl =
				this.el.find('.fc-head-container')
					.html(this.dayGrid.renderHeadHtml());
			this.headRowEl = this.headContainerEl.find('.fc-row');
		},
	
	
		// Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
		// always completely kill the dayGrid's rendering.
		unrenderDates: function() {
			this.dayGrid.unrenderDates();
			this.dayGrid.removeElement();
			this.scroller.destroy();
		},
	
	
		renderBusinessHours: function() {
			this.dayGrid.renderBusinessHours();
		},
	
	
		unrenderBusinessHours: function() {
			this.dayGrid.unrenderBusinessHours();
		},
	
	
		// Builds the HTML skeleton for the view.
		// The day-grid component will render inside of a container defined by this HTML.
		renderSkeletonHtml: function() {
			return '' +
				'<table>' +
					'<thead class="fc-head">' +
						'<tr>' +
							'<td class="fc-head-container ' + this.widgetHeaderClass + '"></td>' +
						'</tr>' +
					'</thead>' +
					'<tbody class="fc-body">' +
						'<tr>' +
							'<td class="' + this.widgetContentClass + '"></td>' +
						'</tr>' +
					'</tbody>' +
				'</table>';
		},
	
	
		// Generates an HTML attribute string for setting the width of the week number column, if it is known
		weekNumberStyleAttr: function() {
			if (this.weekNumberWidth !== null) {
				return 'style="width:' + this.weekNumberWidth + 'px"';
			}
			return '';
		},
	
	
		// Determines whether each row should have a constant height
		hasRigidRows: function() {
			var eventLimit = this.opt('eventLimit');
			return eventLimit && typeof eventLimit !== 'number';
		},
	
	
		/* Dimensions
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Refreshes the horizontal dimensions of the view
		updateWidth: function() {
			if (this.weekNumbersVisible) {
				// Make sure all week number cells running down the side have the same width.
				// Record the width for cells created later.
				this.weekNumberWidth = matchCellWidths(
					this.el.find('.fc-week-number')
				);
			}
		},
	
	
		// Adjusts the vertical dimensions of the view to the specified values
		setHeight: function(totalHeight, isAuto) {
			var eventLimit = this.opt('eventLimit');
			var scrollerHeight;
			var scrollbarWidths;
	
			// reset all heights to be natural
			this.scroller.clear();
			uncompensateScroll(this.headRowEl);
	
			this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	
			// is the event limit a constant level number?
			if (eventLimit && typeof eventLimit === 'number') {
				this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
			}
	
			// distribute the height to the rows
			// (totalHeight is a "recommended" value if isAuto)
			scrollerHeight = this.computeScrollerHeight(totalHeight);
			this.setGridHeight(scrollerHeight, isAuto);
	
			// is the event limit dynamically calculated?
			if (eventLimit && typeof eventLimit !== 'number') {
				this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
			}
	
			if (!isAuto) { // should we force dimensions of the scroll container?
	
				this.scroller.setHeight(scrollerHeight);
				scrollbarWidths = this.scroller.getScrollbarWidths();
	
				if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
	
					compensateScroll(this.headRowEl, scrollbarWidths);
	
					// doing the scrollbar compensation might have created text overflow which created more height. redo
					scrollerHeight = this.computeScrollerHeight(totalHeight);
					this.scroller.setHeight(scrollerHeight);
				}
	
				// guarantees the same scrollbar widths
				this.scroller.lockOverflow(scrollbarWidths);
			}
		},
	
	
		// given a desired total height of the view, returns what the height of the scroller should be
		computeScrollerHeight: function(totalHeight) {
			return totalHeight -
				subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
		},
	
	
		// Sets the height of just the DayGrid component in this view
		setGridHeight: function(height, isAuto) {
			if (isAuto) {
				undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
			}
			else {
				distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
			}
		},
	
	
		/* Scroll
		------------------------------------------------------------------------------------------------------------------*/
	
	
		queryScroll: function() {
			return this.scroller.getScrollTop();
		},
	
	
		setScroll: function(top) {
			this.scroller.setScrollTop(top);
		},
	
	
		/* Hit Areas
		------------------------------------------------------------------------------------------------------------------*/
		// forward all hit-related method calls to dayGrid
	
	
		prepareHits: function() {
			this.dayGrid.prepareHits();
		},
	
	
		releaseHits: function() {
			this.dayGrid.releaseHits();
		},
	
	
		queryHit: function(left, top) {
			return this.dayGrid.queryHit(left, top);
		},
	
	
		getHitSpan: function(hit) {
			return this.dayGrid.getHitSpan(hit);
		},
	
	
		getHitEl: function(hit) {
			return this.dayGrid.getHitEl(hit);
		},
	
	
		/* Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders the given events onto the view and populates the segments array
		renderEvents: function(events) {
			this.dayGrid.renderEvents(events);
	
			this.updateHeight(); // must compensate for events that overflow the row
		},
	
	
		// Retrieves all segment objects that are rendered in the view
		getEventSegs: function() {
			return this.dayGrid.getEventSegs();
		},
	
	
		// Unrenders all event elements and clears internal segment data
		unrenderEvents: function() {
			this.dayGrid.unrenderEvents();
	
			// we DON'T need to call updateHeight() because:
			// A) a renderEvents() call always happens after this, which will eventually call updateHeight()
			// B) in IE8, this causes a flash whenever events are rerendered
		},
	
	
		/* Dragging (for both events and external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// A returned value of `true` signals that a mock "helper" event has been rendered.
		renderDrag: function(dropLocation, seg) {
			return this.dayGrid.renderDrag(dropLocation, seg);
		},
	
	
		unrenderDrag: function() {
			this.dayGrid.unrenderDrag();
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection
		renderSelection: function(span) {
			this.dayGrid.renderSelection(span);
		},
	
	
		// Unrenders a visual indications of a selection
		unrenderSelection: function() {
			this.dayGrid.unrenderSelection();
		}
	
	});
	
	
	// Methods that will customize the rendering behavior of the BasicView's dayGrid
	var basicDayGridMethods = {
	
	
		// Generates the HTML that will go before the day-of week header cells
		renderHeadIntroHtml: function() {
			var view = this.view;
	
			if (view.weekNumbersVisible) {
				return '' +
					'<th class="fc-week-number ' + view.widgetHeaderClass + '" ' + view.weekNumberStyleAttr() + '>' +
						'<span>' + // needed for matchCellWidths
							htmlEscape(view.opt('weekNumberTitle')) +
						'</span>' +
					'</th>';
			}
	
			return '';
		},
	
	
		// Generates the HTML that will go before content-skeleton cells that display the day/week numbers
		renderNumberIntroHtml: function(row) {
			var view = this.view;
	
			if (view.weekNumbersVisible) {
				return '' +
					'<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
						'<span>' + // needed for matchCellWidths
							this.getCellDate(row, 0).format('w') +
						'</span>' +
					'</td>';
			}
	
			return '';
		},
	
	
		// Generates the HTML that goes before the day bg cells for each day-row
		renderBgIntroHtml: function() {
			var view = this.view;
	
			if (view.weekNumbersVisible) {
				return '<td class="fc-week-number ' + view.widgetContentClass + '" ' +
					view.weekNumberStyleAttr() + '></td>';
			}
	
			return '';
		},
	
	
		// Generates the HTML that goes before every other type of row generated by DayGrid.
		// Affects helper-skeleton and highlight-skeleton rows.
		renderIntroHtml: function() {
			var view = this.view;
	
			if (view.weekNumbersVisible) {
				return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
			}
	
			return '';
		}
	
	};
	
	;;
	
	/* A month view with day cells running in rows (one-per-week) and columns
	----------------------------------------------------------------------------------------------------------------------*/
	
	var MonthView = FC.MonthView = BasicView.extend({
	
		// Produces information about what range to display
		computeRange: function(date) {
			var range = BasicView.prototype.computeRange.call(this, date); // get value from super-method
			var rowCnt;
	
			// ensure 6 weeks
			if (this.isFixedWeeks()) {
				rowCnt = Math.ceil(range.end.diff(range.start, 'weeks', true)); // could be partial weeks due to hiddenDays
				range.end.add(6 - rowCnt, 'weeks');
			}
	
			return range;
		},
	
	
		// Overrides the default BasicView behavior to have special multi-week auto-height logic
		setGridHeight: function(height, isAuto) {
	
			isAuto = isAuto || this.opt('weekMode') === 'variable'; // LEGACY: weekMode is deprecated
	
			// if auto, make the height of each row the height that it would be if there were 6 weeks
			if (isAuto) {
				height *= this.rowCnt / 6;
			}
	
			distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
		},
	
	
		isFixedWeeks: function() {
			var weekMode = this.opt('weekMode'); // LEGACY: weekMode is deprecated
			if (weekMode) {
				return weekMode === 'fixed'; // if any other type of weekMode, assume NOT fixed
			}
	
			return this.opt('fixedWeekCount');
		}
	
	});
	
	;;
	
	fcViews.basic = {
		'class': BasicView
	};
	
	fcViews.basicDay = {
		type: 'basic',
		duration: { days: 1 }
	};
	
	fcViews.basicWeek = {
		type: 'basic',
		duration: { weeks: 1 }
	};
	
	fcViews.month = {
		'class': MonthView,
		duration: { months: 1 }, // important for prev/next
		defaults: {
			fixedWeekCount: true
		}
	};
	;;
	
	/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
	----------------------------------------------------------------------------------------------------------------------*/
	// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
	// Responsible for managing width/height.
	
	var AgendaView = FC.AgendaView = View.extend({
	
		scroller: null,
	
		timeGridClass: TimeGrid, // class used to instantiate the timeGrid. subclasses can override
		timeGrid: null, // the main time-grid subcomponent of this view
	
		dayGridClass: DayGrid, // class used to instantiate the dayGrid. subclasses can override
		dayGrid: null, // the "all-day" subcomponent. if all-day is turned off, this will be null
	
		axisWidth: null, // the width of the time axis running down the side
	
		headContainerEl: null, // div that hold's the timeGrid's rendered date header
		noScrollRowEls: null, // set of fake row elements that must compensate when scroller has scrollbars
	
		// when the time-grid isn't tall enough to occupy the given height, we render an <hr> underneath
		bottomRuleEl: null,
	
	
		initialize: function() {
			this.timeGrid = this.instantiateTimeGrid();
	
			if (this.opt('allDaySlot')) { // should we display the "all-day" area?
				this.dayGrid = this.instantiateDayGrid(); // the all-day subcomponent of this view
			}
	
			this.scroller = new Scroller({
				overflowX: 'hidden',
				overflowY: 'auto'
			});
		},
	
	
		// Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
		instantiateTimeGrid: function() {
			var subclass = this.timeGridClass.extend(agendaTimeGridMethods);
	
			return new subclass(this);
		},
	
	
		// Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
		instantiateDayGrid: function() {
			var subclass = this.dayGridClass.extend(agendaDayGridMethods);
	
			return new subclass(this);
		},
	
	
		/* Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the display range and computes all necessary dates
		setRange: function(range) {
			View.prototype.setRange.call(this, range); // call the super-method
	
			this.timeGrid.setRange(range);
			if (this.dayGrid) {
				this.dayGrid.setRange(range);
			}
		},
	
	
		// Renders the view into `this.el`, which has already been assigned
		renderDates: function() {
	
			this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
			this.renderHead();
	
			this.scroller.render();
			var timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
			var timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
			this.el.find('.fc-body > tr > td').append(timeGridWrapEl);
	
			this.timeGrid.setElement(timeGridEl);
			this.timeGrid.renderDates();
	
			// the <hr> that sometimes displays under the time-grid
			this.bottomRuleEl = $('<hr class="fc-divider ' + this.widgetHeaderClass + '"/>')
				.appendTo(this.timeGrid.el); // inject it into the time-grid
	
			if (this.dayGrid) {
				this.dayGrid.setElement(this.el.find('.fc-day-grid'));
				this.dayGrid.renderDates();
	
				// have the day-grid extend it's coordinate area over the <hr> dividing the two grids
				this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
			}
	
			this.noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)'); // fake rows not within the scroller
		},
	
	
		// render the day-of-week headers
		renderHead: function() {
			this.headContainerEl =
				this.el.find('.fc-head-container')
					.html(this.timeGrid.renderHeadHtml());
		},
	
	
		// Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
		// always completely kill each grid's rendering.
		unrenderDates: function() {
			this.timeGrid.unrenderDates();
			this.timeGrid.removeElement();
	
			if (this.dayGrid) {
				this.dayGrid.unrenderDates();
				this.dayGrid.removeElement();
			}
	
			this.scroller.destroy();
		},
	
	
		// Builds the HTML skeleton for the view.
		// The day-grid and time-grid components will render inside containers defined by this HTML.
		renderSkeletonHtml: function() {
			return '' +
				'<table>' +
					'<thead class="fc-head">' +
						'<tr>' +
							'<td class="fc-head-container ' + this.widgetHeaderClass + '"></td>' +
						'</tr>' +
					'</thead>' +
					'<tbody class="fc-body">' +
						'<tr>' +
							'<td class="' + this.widgetContentClass + '">' +
								(this.dayGrid ?
									'<div class="fc-day-grid"/>' +
									'<hr class="fc-divider ' + this.widgetHeaderClass + '"/>' :
									''
									) +
							'</td>' +
						'</tr>' +
					'</tbody>' +
				'</table>';
		},
	
	
		// Generates an HTML attribute string for setting the width of the axis, if it is known
		axisStyleAttr: function() {
			if (this.axisWidth !== null) {
				 return 'style="width:' + this.axisWidth + 'px"';
			}
			return '';
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessHours: function() {
			this.timeGrid.renderBusinessHours();
	
			if (this.dayGrid) {
				this.dayGrid.renderBusinessHours();
			}
		},
	
	
		unrenderBusinessHours: function() {
			this.timeGrid.unrenderBusinessHours();
	
			if (this.dayGrid) {
				this.dayGrid.unrenderBusinessHours();
			}
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		getNowIndicatorUnit: function() {
			return this.timeGrid.getNowIndicatorUnit();
		},
	
	
		renderNowIndicator: function(date) {
			this.timeGrid.renderNowIndicator(date);
		},
	
	
		unrenderNowIndicator: function() {
			this.timeGrid.unrenderNowIndicator();
		},
	
	
		/* Dimensions
		------------------------------------------------------------------------------------------------------------------*/
	
	
		updateSize: function(isResize) {
			this.timeGrid.updateSize(isResize);
	
			View.prototype.updateSize.call(this, isResize); // call the super-method
		},
	
	
		// Refreshes the horizontal dimensions of the view
		updateWidth: function() {
			// make all axis cells line up, and record the width so newly created axis cells will have it
			this.axisWidth = matchCellWidths(this.el.find('.fc-axis'));
		},
	
	
		// Adjusts the vertical dimensions of the view to the specified values
		setHeight: function(totalHeight, isAuto) {
			var eventLimit;
			var scrollerHeight;
			var scrollbarWidths;
	
			// reset all dimensions back to the original state
			this.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
			this.scroller.clear(); // sets height to 'auto' and clears overflow
			uncompensateScroll(this.noScrollRowEls);
	
			// limit number of events in the all-day area
			if (this.dayGrid) {
				this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	
				eventLimit = this.opt('eventLimit');
				if (eventLimit && typeof eventLimit !== 'number') {
					eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
				}
				if (eventLimit) {
					this.dayGrid.limitRows(eventLimit);
				}
			}
	
			if (!isAuto) { // should we force dimensions of the scroll container?
	
				scrollerHeight = this.computeScrollerHeight(totalHeight);
				this.scroller.setHeight(scrollerHeight);
				scrollbarWidths = this.scroller.getScrollbarWidths();
	
				if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
	
					// make the all-day and header rows lines up
					compensateScroll(this.noScrollRowEls, scrollbarWidths);
	
					// the scrollbar compensation might have changed text flow, which might affect height, so recalculate
					// and reapply the desired height to the scroller.
					scrollerHeight = this.computeScrollerHeight(totalHeight);
					this.scroller.setHeight(scrollerHeight);
				}
	
				// guarantees the same scrollbar widths
				this.scroller.lockOverflow(scrollbarWidths);
	
				// if there's any space below the slats, show the horizontal rule.
				// this won't cause any new overflow, because lockOverflow already called.
				if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
					this.bottomRuleEl.show();
				}
			}
		},
	
	
		// given a desired total height of the view, returns what the height of the scroller should be
		computeScrollerHeight: function(totalHeight) {
			return totalHeight -
				subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
		},
	
	
		/* Scroll
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes the initial pre-configured scroll state prior to allowing the user to change it
		computeInitialScroll: function() {
			var scrollTime = moment.duration(this.opt('scrollTime'));
			var top = this.timeGrid.computeTimeTop(scrollTime);
	
			// zoom can give weird floating-point values. rather scroll a little bit further
			top = Math.ceil(top);
	
			if (top) {
				top++; // to overcome top border that slots beyond the first have. looks better
			}
	
			return top;
		},
	
	
		queryScroll: function() {
			return this.scroller.getScrollTop();
		},
	
	
		setScroll: function(top) {
			this.scroller.setScrollTop(top);
		},
	
	
		/* Hit Areas
		------------------------------------------------------------------------------------------------------------------*/
		// forward all hit-related method calls to the grids (dayGrid might not be defined)
	
	
		prepareHits: function() {
			this.timeGrid.prepareHits();
			if (this.dayGrid) {
				this.dayGrid.prepareHits();
			}
		},
	
	
		releaseHits: function() {
			this.timeGrid.releaseHits();
			if (this.dayGrid) {
				this.dayGrid.releaseHits();
			}
		},
	
	
		queryHit: function(left, top) {
			var hit = this.timeGrid.queryHit(left, top);
	
			if (!hit && this.dayGrid) {
				hit = this.dayGrid.queryHit(left, top);
			}
	
			return hit;
		},
	
	
		getHitSpan: function(hit) {
			// TODO: hit.component is set as a hack to identify where the hit came from
			return hit.component.getHitSpan(hit);
		},
	
	
		getHitEl: function(hit) {
			// TODO: hit.component is set as a hack to identify where the hit came from
			return hit.component.getHitEl(hit);
		},
	
	
		/* Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders events onto the view and populates the View's segment array
		renderEvents: function(events) {
			var dayEvents = [];
			var timedEvents = [];
			var daySegs = [];
			var timedSegs;
			var i;
	
			// separate the events into all-day and timed
			for (i = 0; i < events.length; i++) {
				if (events[i].allDay) {
					dayEvents.push(events[i]);
				}
				else {
					timedEvents.push(events[i]);
				}
			}
	
			// render the events in the subcomponents
			timedSegs = this.timeGrid.renderEvents(timedEvents);
			if (this.dayGrid) {
				daySegs = this.dayGrid.renderEvents(dayEvents);
			}
	
			// the all-day area is flexible and might have a lot of events, so shift the height
			this.updateHeight();
		},
	
	
		// Retrieves all segment objects that are rendered in the view
		getEventSegs: function() {
			return this.timeGrid.getEventSegs().concat(
				this.dayGrid ? this.dayGrid.getEventSegs() : []
			);
		},
	
	
		// Unrenders all event elements and clears internal segment data
		unrenderEvents: function() {
	
			// unrender the events in the subcomponents
			this.timeGrid.unrenderEvents();
			if (this.dayGrid) {
				this.dayGrid.unrenderEvents();
			}
	
			// we DON'T need to call updateHeight() because:
			// A) a renderEvents() call always happens after this, which will eventually call updateHeight()
			// B) in IE8, this causes a flash whenever events are rerendered
		},
	
	
		/* Dragging (for events and external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// A returned value of `true` signals that a mock "helper" event has been rendered.
		renderDrag: function(dropLocation, seg) {
			if (dropLocation.start.hasTime()) {
				return this.timeGrid.renderDrag(dropLocation, seg);
			}
			else if (this.dayGrid) {
				return this.dayGrid.renderDrag(dropLocation, seg);
			}
		},
	
	
		unrenderDrag: function() {
			this.timeGrid.unrenderDrag();
			if (this.dayGrid) {
				this.dayGrid.unrenderDrag();
			}
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection
		renderSelection: function(span) {
			if (span.start.hasTime() || span.end.hasTime()) {
				this.timeGrid.renderSelection(span);
			}
			else if (this.dayGrid) {
				this.dayGrid.renderSelection(span);
			}
		},
	
	
		// Unrenders a visual indications of a selection
		unrenderSelection: function() {
			this.timeGrid.unrenderSelection();
			if (this.dayGrid) {
				this.dayGrid.unrenderSelection();
			}
		}
	
	});
	
	
	// Methods that will customize the rendering behavior of the AgendaView's timeGrid
	// TODO: move into TimeGrid
	var agendaTimeGridMethods = {
	
	
		// Generates the HTML that will go before the day-of week header cells
		renderHeadIntroHtml: function() {
			var view = this.view;
			var weekText;
	
			if (view.opt('weekNumbers')) {
				weekText = this.start.format(view.opt('smallWeekFormat'));
	
				return '' +
					'<th class="fc-axis fc-week-number ' + view.widgetHeaderClass + '" ' + view.axisStyleAttr() + '>' +
						'<span>' + // needed for matchCellWidths
							htmlEscape(weekText) +
						'</span>' +
					'</th>';
			}
			else {
				return '<th class="fc-axis ' + view.widgetHeaderClass + '" ' + view.axisStyleAttr() + '></th>';
			}
		},
	
	
		// Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
		renderBgIntroHtml: function() {
			var view = this.view;
	
			return '<td class="fc-axis ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '></td>';
		},
	
	
		// Generates the HTML that goes before all other types of cells.
		// Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
		renderIntroHtml: function() {
			var view = this.view;
	
			return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
		}
	
	};
	
	
	// Methods that will customize the rendering behavior of the AgendaView's dayGrid
	var agendaDayGridMethods = {
	
	
		// Generates the HTML that goes before the all-day cells
		renderBgIntroHtml: function() {
			var view = this.view;
	
			return '' +
				'<td class="fc-axis ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '>' +
					'<span>' + // needed for matchCellWidths
						(view.opt('allDayHtml') || htmlEscape(view.opt('allDayText'))) +
					'</span>' +
				'</td>';
		},
	
	
		// Generates the HTML that goes before all other types of cells.
		// Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
		renderIntroHtml: function() {
			var view = this.view;
	
			return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
		}
	
	};
	
	;;
	
	var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
	
	// potential nice values for the slot-duration and interval-duration
	// from largest to smallest
	var AGENDA_STOCK_SUB_DURATIONS = [
		{ hours: 1 },
		{ minutes: 30 },
		{ minutes: 15 },
		{ seconds: 30 },
		{ seconds: 15 }
	];
	
	fcViews.agenda = {
		'class': AgendaView,
		defaults: {
			allDaySlot: true,
			allDayText: 'all-day',
			slotDuration: '00:30:00',
			minTime: '00:00:00',
			maxTime: '24:00:00',
			slotEventOverlap: true // a bad name. confused with overlap/constraint system
		}
	};
	
	fcViews.agendaDay = {
		type: 'agenda',
		duration: { days: 1 }
	};
	
	fcViews.agendaWeek = {
		type: 'agenda',
		duration: { weeks: 1 }
	};
	;;
	
	return FC; // export for Node/CommonJS
	});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _LeaveLayout = __webpack_require__(906);
	
	var _LeaveLayout2 = _interopRequireDefault(_LeaveLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize(options) {
	        this.MainView = options.MainView;
	        this.render();
	    },
	
	    render: function render() {
	        this.$el.html((0, _LeaveLayout2.default)());
	        return this;
	    },
	
	    renderContent: function renderContent(options) {
	        new this.MainView(Object.assign({ el: this.$('.js-content') }, options || {}));
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-loader').hide();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/LeaveLayout.html -->\n<div class="js-loader loader">\n    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n</div>\n\n<div class="js-content wrapper wrapper-content wrapper-request-leave"></div>\n';
	}
	return __p;
	};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Leave = __webpack_require__(908);
	
	var _Leave2 = _interopRequireDefault(_Leave);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _LeaveEmployeeChooser = __webpack_require__(912);
	
	var _LeaveEmployeeChooser2 = _interopRequireDefault(_LeaveEmployeeChooser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployerLeaveView = _Leave2.default.extend({
	    _onSubmitSetLeaveRequest: function _onSubmitSetLeaveRequest() {
	        this.leaveRequest.set({
	            employeeToApprove: app.user,
	            employeeApprovedBy: app.user,
	            employeeApprovedByName: app.user.get('name'),
	            status: _leaveRequest.consts.STATUS_APPROVED
	        });
	    },
	
	    _renderTemplate: function _renderTemplate() {
	        return this.template({
	            employees: this.employees,
	            leaveTypes: this.leaveTypes,
	            leaveRequest: this.leaveRequest,
	            allowHalfDays: this.allowHalfDays,
	            employeeChooser: (0, _LeaveEmployeeChooser2.default)({ employees: this.employees })
	        });
	    }
	});
	
	module.exports = EmployerLeaveView;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Cocktail = __webpack_require__(548);
	
	var _Cocktail2 = _interopRequireDefault(_Cocktail);
	
	var _Leave = __webpack_require__(909);
	
	var _Leave2 = _interopRequireDefault(_Leave);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _leaveRequest = __webpack_require__(753);
	
	var _leaveRequest2 = _interopRequireDefault(_leaveRequest);
	
	var _PeriodPicker = __webpack_require__(910);
	
	var _PeriodPicker2 = _interopRequireDefault(_PeriodPicker);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Cocktail2.default.mixin(_Form2.default.extend({
	    events: {
	        'change .js-employee-select': 'changeEmployee',
	        'change input[type="file"]': 'uploadFiles',
	        'change .js-leave-type': 'setLeaveType',
	        'change .js-details': 'setDetails',
	        'click .js-cancel': 'cancel',
	        'submit .js-form': 'submit',
	        'change input,select,textarea': 'taint',
	        'ifToggled input': 'taint'
	    },
	
	    initialize: function initialize(options) {
	        this.template = _Leave2.default;
	        /* Mock */
	        this.allowHalfDays = true;
	
	        this.employees = options.employees;
	        this._leaveTypes = options.leaveTypes;
	        //this.attachments = options.attachments;
	        //this.attachmentsHasChanged = false;
	        //this.attachments.on('add', this.addAttachment, this);
	        this.daysRequested = 0;
	        this.files = [];
	
	        this.leaveRequest = options.leaveRequest;
	        if (typeof this.leaveRequest.get('dateTo') === 'undefined') {
	            this.leaveRequest.set('dateTo', null);
	        }
	        this.model = this.leaveRequest;
	        this._onInitializeSetLeaveRequest(options);
	
	        _Form2.default.prototype.initialize.apply(this, [this.options]);
	
	        // if we're dealing with one employee
	        if (this.employees.length === 1) {
	            var employee = this.employees.at(0);
	            this.filterEmployeeLeaveTypes(employee);
	        }
	
	        return this.render();
	    },
	
	    _onInitializeSetLeaveRequest: function _onInitializeSetLeaveRequest() {},
	
	    _renderTemplate: function _renderTemplate() {
	        return this.template({
	            employees: this.employees,
	            leaveTypes: this.leaveTypes,
	            leaveRequest: this.leaveRequest,
	            allowHalfDays: this.allowHalfDays,
	            employeeChooser: ''
	        });
	    },
	
	    render: function render() {
	        var _this = this;
	
	        this.$el.html(this._renderTemplate());
	        _tooltip2.default.init(this);
	
	        this.$submit = this.$('.js-submit');
	        this.$cancel = this.$('.js-cancel');
	
	        this.$('.js-employee-select').chosen({ width: '100%' });
	        this.$('.js-leave-type').chosen({ width: '100%' });
	
	        if (this.leaveRequest.getEmployee()) {
	            var employee = this.leaveRequest.getEmployee();
	            this.leaveTypes = this._leaveTypes.filter(this.getEntitledDays(employee));
	
	            this.$('.js-employee-select').val(employee.id).trigger('chosen:updated');
	        }
	
	        if (this.leaveRequest.getType()) {
	            this.$('.js-leave-type').val(this.leaveRequest.getType().id);
	        }
	
	        this.$('.input-daterange').datepicker({
	            weekStart: 1,
	            daysOfWeekDisabled: [0, 6],
	            autoclose: true,
	            format: 'dd/mm/yyyy',
	            todayHighlight: true
	        });
	
	        this.$('.input-daterange input[name="from"]').datepicker('setDate', this.leaveRequest.get('dateFrom'));
	        this.$('.input-daterange input[name="to"]').datepicker('setDate', this.leaveRequest.get('dateTo'));
	
	        this.$('.js-attachments').html('');
	
	        this.periodPicker = new _PeriodPicker2.default({
	            el: this.$('.js-date'),
	            allowHalfDays: true,
	            dateFrom: this.leaveRequest.get('dateFrom'),
	            dateFromType: this.leaveRequest.get('dateFromType'),
	            dateTo: this.leaveRequest.get('dateTo'),
	            dateToType: this.leaveRequest.get('dateToType'),
	            daysOfWeekDisabled: []
	        });
	        this.periodPicker.on('change', function (data) {
	            _this.$('.js-save').removeClass('disabled');
	            _this.leaveRequest.set(data, { silent: true });
	            _this.updateButtonsState();
	            _this.toggleError('dateFrom');
	            _this.canLeaveRequestBeAdded();
	        });
	
	        //this.attachments.each(this.addAttachment, this);
	        $(window).trigger('scroll');
	        this.markMandatoryFields();
	        this.rendered = true;
	    },
	
	    renderRequestedDays: function renderRequestedDays(daysRequested, daysAllowed) {
	        var type = this.leaveRequest.getType();
	
	        this.daysRequested = daysRequested;
	        this.$('.js-requested-days-box').toggleClass('col-sm-6', type.get('paid')).toggleClass('col-sm-12', !type.get('paid'));
	        this.$('.js-requested-days').text(daysRequested);
	        this.$('.js-requested-days-label').text(daysRequested === 1 ? 'day' : 'days');
	        this.$('.js-allowed-days-box').toggle(type.get('paid'));
	
	        if (!type.get('paid')) {
	            this.$('.js-allowed-warning').hide();
	        } else {
	            this.$('.js-allowed-warning').toggle(daysRequested > daysAllowed);
	
	            this.$('.js-allowed-days').text(daysAllowed);
	            this.$('.js-allowed-days-label').text(daysAllowed === 1 ? 'day' : 'days');
	        }
	    },
	
	    changeEmployee: function changeEmployee(e) {
	        var employeeId = this.$(e.currentTarget).val();
	        var employee = this.employees.find(function (employee) {
	            return employee.id === employeeId;
	        });
	        this.filterEmployeeLeaveTypes(employee);
	        this.render();
	    },
	
	    filterEmployeeLeaveTypes: function filterEmployeeLeaveTypes(employee) {
	        employee.company = app.company;
	        this.leaveRequest.setEmployee(employee);
	        this.canLeaveRequestBeAdded();
	
	        this.leaveTypes = this._leaveTypes.filter(function (type) {
	            return !type.get('gender') || type.get('gender') === employee.get('gender');
	        });
	        this.leaveTypes = this.leaveTypes.filter(this.getEntitledDays(employee));
	    },
	
	    setLeaveType: function setLeaveType() {
	        this.toggleError('type');
	        var id = this.$('.js-leave-type').val();
	        if (!id) {
	            return;
	        }
	        this.leaveRequest.set({ typeId: id });
	        this.canLeaveRequestBeAdded();
	    },
	
	    setDetails: function setDetails() {
	        var text = this.$('.js-details').val();
	        this.leaveRequest.set({ reason: text }, { validate: false });
	        this.updateButtonsState();
	    },
	
	    uploadFiles: function uploadFiles(e) {
	        var files = $(e.currentTarget)[0].files;
	        if (files.length === 0) {
	            return false;
	        }
	
	        if (files[0].size <= 4 * 1024 * 1024) {
	            this.addAttachment(files[0]);
	        } else {
	            _alerts2.default.show('error', {
	                title: 'Error',
	                text: 'You are trying to upload a file that is way too big.\n' + 'Maximum file size allowed is 4MB.\n' + 'Please re-upload a smaller file.'
	            });
	        }
	    },
	
	    addAttachment: function addAttachment(file) {
	        var self = this;
	        this.files.push(file);
	        var $attachments = self.$('.js-attachments');
	
	        var $link = $('<span style="margin-right: 10px;">' + '<i class="fa fa-file"></i> ' + file.name + '</span>');
	
	        var $close = $('<i class="fa fa-times"></i>');
	
	        var $item = $link.append($close);
	        $('<div class="file-label">').append($item);
	
	        $close.on('click', function () {
	            $item.remove();
	            var index = self.files.indexOf(file);
	            if (index > -1) {
	                self.files.splice(index, 1);
	            }
	        });
	        $attachments.append($item);
	    },
	
	    taint: function taint(ev) {
	        var $el = this.$(ev.currentTarget);
	
	        if (!this.rendered || $el.closest('.js-date').length) {
	            return;
	        }
	
	        this.tainted = true;
	    },
	
	    cancel: function cancel() {
	        this.leaveRequest = new _leaveRequest2.default({
	            dateFromType: _leaveRequest.consts.DATE_TYPE_FULL_DAY,
	            dateToType: _leaveRequest.consts.DATE_TYPE_FULL_DAY
	        });
	        this.attachmentsHasChanged = false;
	        this.updateButtonsState();
	        this.rendered = false;
	        this.render();
	    },
	
	    submit: function submit(e) {
	        var _this2 = this;
	
	        var stopLoader = function stopLoader() {};
	
	        e.preventDefault();
	        if (!this.model.isValid()) {
	            this.invalid(this.model, {
	                errors: this.model.validationError
	            });
	            return;
	        }
	
	        var employee = this.leaveRequest.getEmployee();
	        if (!employee) {
	            _alerts2.default.show('error', { text: 'You need to select an employee' });
	            return;
	        }
	
	        if ((0, _moment2.default)(this.leaveRequest.get('dateTo')).isSame(this.leaveRequest.get('dateFrom')) || !this.leaveRequest.get('dateTo')) {
	            /* NOTE: overlapping checking relies on dateTo being null when
	             not used */
	            this.leaveRequest.set('dateTo', null);
	            this.leaveRequest.set('dateToType', null);
	        }
	
	        this._onSubmitSetLeaveRequest();
	
	        stopLoader = _loader2.default.startFullScreen(this.$('.js-submit'));
	
	        return this.leaveRequest.save().then(function () {
	            return (0, _bluebird.join)(_this2.files.map(function (file) {
	                return new _bluebird2.default(function (resolve, reject) {
	                    var reader = new FileReader();
	                    reader.onload = function (ev) {
	                        var base64 = ev.target.result.split(',')[1];
	                        return _this2.leaveRequest.createAttachment({
	                            file: base64,
	                            name: file.name,
	                            description: ''
	                        }).then(function () {
	                            return resolve(true);
	                        }).catch(function (err) {
	                            return reject(err);
	                        });
	                    };
	                    reader.onerror = function (err) {
	                        return reject(err);
	                    };
	                    reader.readAsDataURL(file);
	                });
	            }));
	        }).then(function () {
	            var dateNavigation = (0, _moment2.default)(_this2.leaveRequest.get('dateFrom')).format('DD-MM-YYYY');
	
	            app.mainRouter.navigate('calendar/date/' + dateNavigation, {
	                trigger: true,
	                replace: true
	            });
	
	            if (app.user.get('role') === 'employee') {
	                _alerts2.default.show('info', {
	                    title: 'Leave Requested',
	                    text: 'Your leave request has been sent for review'
	                });
	            } else {
	                _alerts2.default.show('success', {
	                    title: 'Leave Approved',
	                    text: 'The leave has been approved'
	                });
	            }
	        }).catch(function (err) {
	            if (app.company.get('leaveRequestsRestricted')) {
	                _modal2.default.showError('Leaves feature has been migrated to Jibble and is restricted on Payroll Panda', false);
	            } else {
	                _alerts2.default.show('criticalError', err);
	            }
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    _onSubmitSetLeaveRequest: function _onSubmitSetLeaveRequest() {
	        // To be overridden
	    },
	
	    updateButtonsState: function updateButtonsState() {
	        if (!this.rendered) {
	            return false;
	        }
	
	        var enabled = false;
	        enabled = this.leaveRequest.hasChanged() || this.attachmentsHasChanged;
	        if (!this.canBeAdded) {
	            enabled = false;
	        }
	
	        if (enabled) {
	            this.$submit.attr('disabled', false);
	            this.$submit.removeClass('disabled');
	            this.$cancel.removeClass('disabled');
	        } else {
	            this.$submit.attr('disabled', true);
	            this.$submit.addClass('disabled');
	            this.$cancel.addClass('disabled');
	        }
	    },
	
	    canLeaveRequestBeAdded: function canLeaveRequestBeAdded() {
	        var _this3 = this;
	
	        this.canBeAdded = false;
	        if (!this.leaveRequest.get('dateFrom')) {
	            this.updateButtonsState();
	            return;
	        }
	
	        if (!this.leaveRequest.get('typeId')) {
	            this.updateButtonsState();
	            return;
	        }
	
	        var startDate = (0, _moment2.default)(this.leaveRequest.get('dateFrom'));
	        var endDate = (0, _moment2.default)(this.leaveRequest.get('dateTo') || new Date());
	
	        if (endDate.diff(startDate, 'year') > 0) {
	            return;
	        }
	
	        return this.leaveRequest.canBeAdded().then(function (r) {
	            var type = _this3.leaveRequest.getType();
	
	            if (type.get('paid') !== true) {
	                return (0, _bluebird.resolve)(r);
	            }
	
	            return _this3.leaveRequest.fetchDaysAllowed().then(function (daysAllowed) {
	                r.daysAllowed = daysAllowed;
	                return r;
	            });
	        }).then(function (result) {
	            _this3.canBeAdded = true;
	            _this3.$('.js-days-error').hide();
	            _this3.$('.js-payroll-error').hide();
	            _this3.$('.js-days-warning').hide();
	
	            _this3.renderRequestedDays(result.daysRequired, result.daysAllowed);
	
	            if (result.status) {
	                if (result.reason === 'overlapping' && result.warning) {
	                    _this3.$('.js-days-warning').show();
	                }
	            } else if (!result.status) {
	                _this3.canBeAdded = false;
	                if (result.reason === 'overlapping') {
	                    _this3.$('.js-days-error').show();
	                } else if (result.reason === 'payroll') {
	                    _this3.$('.js-payroll-error').show();
	                }
	            }
	            _this3.updateButtonsState();
	            return result;
	        }).catch(function (err) {
	            var errorMessage = err && err.response && err.response.data && err.response.data.error && err.response.data.error.message;
	            if (typeof errorMessage === 'string') {
	                _alerts2.default.show('error', errorMessage);
	            } else {
	                _alerts2.default.show('error', 'Couldn\'t determine the validity of the request due to a ' + 'server error. Please try again.');
	            }
	        });
	    },
	
	    getEntitledDays: function getEntitledDays(employee) {
	        return function (type) {
	            var isCustom = !!type.get('companyId');
	
	            var daysOf = employee.getDaysEntitled(type);
	
	            return isCustom ? daysOf > 0 : true;
	        };
	    }
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/Leave.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h3>Add Leave</h3>\n    </div>\n    <div class="ibox-content">\n        <form role="form" class="js-form form-horizontal">\n            '+
	((__t=( employeeChooser ))==null?'':__t)+
	'\n            <!-- Leave Type & Reason -->\n            <div class="form-group">\n                <label class="col-sm-3 control-label">\n                    Leave Type\n                </label>\n                <div class="col-sm-4">\n                    <select name="typeId"\n                            data-placeholder="Choose a type..."\n                            class="js-leave-type js-ext form-control">\n                        <option></option>\n                        ';
	 _(leaveTypes).each(function (type) { 
	__p+='\n                            <option value="'+
	((__t=( type.get('objectId') ))==null?'':_.escape(__t))+
	'">\n                                '+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'\n                            </option>\n                        ';
	 }); 
	__p+='\n                    </select>\n                    <span class="error-type error"></span>\n                </div>\n            </div>\n\n            <!-- Select dates -->\n            <div class="js-date"></div>\n\n            <!-- Display days -->\n            <div class="form-group form-group-days">\n                <div class="col-sm-offset-3 col-sm-9">\n                    <hr class="m-t-none m-b-sm">\n                    <div class="row">\n                        <div class="js-requested-days-box col-xs-6 text-center m-b-sm">\n                            <div>\n                                <span class="js-requested-days days">-</span>\n                            </div>\n                            <div>\n                                <span class="js-requested-days-label">days</span>\n                                required\n                            </div>\n                        </div>\n                        <div class="js-allowed-days-box col-xs-6 text-center m-b-sm">\n                            <div>\n                                <span class="js-allowed-days days">-</span>\n                            </div>\n                            <div>\n                                <span class="js-allowed-days-label">days</span>\n                                allowed\n                            </div>\n                        </div>\n                    </div>\n                    <hr class="m-t-none m-b-none">\n\n                    <div class="js-allowed-warning alert alert-warning" style="display: none">\n                        <i class="fa fa-check-square-o pull-left"></i>\n                        <div class="alert-message">\n                            The leave request can still be submitted but note that\n                            the days required exceed the days allowed\n                        </div>\n                    </div>\n\n                    <div class="js-days-warning alert alert-warning" style="display: none">\n                        <i class="fa fa-check-square-o pull-left"></i>\n                        <div class="alert-message">\n                            There is already some leave pending of\n                            approval for the requested dates. This\n                            leave request can be added, though.\n                            Please check the calendar for more\n                            information.\n                        </div>\n                    </div>\n\n                    <div class="js-days-error alert alert-danger" style="display: none">\n                        <i class="fa fa-warning pull-left"></i>\n                        <div class="alert-message">\n                            There is already some leave approved for the\n                            requested dates. Please check the calendar.\n                        </div>\n                    </div>\n\n                    <div class="js-payroll-error alert alert-danger" style="display: none">\n                        <i class="fa fa-warning pull-left"></i>\n                        <div class="alert-message">\n                            Unpaid leave can\'t be added to a month in\n                            which payroll has already been run\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Other Details -->\n            <div class="form-group">\n                <label class="col-sm-3 control-label">\n                    Other Details\n                </label>\n                <div class="col-sm-9">\n                    <textarea class="js-details form-control" rows="3">'+
	((__t=( leaveRequest.get('reason') ))==null?'':_.escape(__t))+
	'</textarea>\n                </div>\n            </div>\n\n            <!-- Upload File -->\n            <div class="form-group form-group-files">\n                <label class="col-sm-3 control-label">\n                    Upload File\n                    <!-- Tooltip -->\n                    <i class="fa fa-question-circle" data-toggle="tooltip"\n                    data-placement="bottom" data-container="body"\n                    data-html="true"\n                    title="An optional Medical Certificate can be\n                            uploaded for reference purposes">\n                    </i>\n                </label>\n                <div class="col-sm-9">\n\n                    <label class="js-select-files btn btn-w-m btn-success ladda-button" data-style="swap">\n                        Select Files\n                        <input type="file" class="js-file-input hide">\n                    </label>\n\n                    <div class="js-attachments attachments"></div>\n                </div>\n            </div>\n\n            <div class="text-right">\n                <a class="btn btn-w-m btn-warning"\n                    href="#calendar">\n                    <i class="fa fa-warning"></i>\n                    Cancel\n                </a>\n                <button type="submit"\n                    class="js-submit btn btn-w-m btn-primary ladda-button"\n                    data-style="swap"\n                    disabled>\n                    <i class="fa fa-check"></i>\n                    Submit\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var template = __webpack_require__(911);
	var moment = __webpack_require__(101);
	var config = {
	    DATE_TYPE_FULL_DAY: 1,
	    DATE_TYPE_MORNING: 2,
	    DATE_TYPE_AFTERNOON: 3
	};
	
	module.exports = Backbone.View.extend({
	
	    events: {
	        'click .js-dropdown-menu a': 'onChangeType',
	        'changeDate .input-daterange input': 'onChangeDate',
	        'clearDate .input-daterange input': 'onChangeDate'
	    },
	
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = options;
	        self.config = config;
	        self.render();
	    },
	
	    render: function render() {
	        var self = this;
	        self.$el.html(template({
	            allowHalfDays: self.options.allowHalfDays,
	            config: self.config
	        }));
	
	        var daysOfWeekDisabled = this.options.daysOfWeekDisabled || [0, 6];
	        self.$('.input-daterange').datepicker({
	            weekStart: 1,
	            daysOfWeekDisabled: daysOfWeekDisabled,
	            autoclose: true,
	            format: 'dd/mm/yyyy',
	            todayHighlight: true
	        });
	        self.$('.js-from').datepicker('setDate', self.options.dateFrom);
	        self.$('.js-to').datepicker('setDate', self.options.dateTo);
	
	        self.renderTypeLabel(self.$('.js-from-type .js-label'), self.options.dateFromType);
	        self.renderTypeLabel(self.$('.js-to-type .js-label'), self.options.dateToType);
	        self.renderTypes();
	
	        return self;
	    },
	
	    renderTypeLabel: function renderTypeLabel($label, type) {
	        var self = this;
	        if (type === self.config.DATE_TYPE_MORNING) {
	            $label.text('morning only');
	        } else if (type === self.config.DATE_TYPE_AFTERNOON) {
	            $label.text('afternoon only');
	        } else {
	            $label.text('full day');
	        }
	    },
	
	    onChangeType: function onChangeType(e) {
	        e.preventDefault();
	        var self = this;
	        var $link = self.$(e.currentTarget);
	        var value = $link.data('value');
	
	        self.options[$link.data('type')] = value;
	
	        var data = {};
	        data[$link.data('type')] = value;
	        self.trigger('change', data);
	
	        self.renderTypeLabel($link.parents('.input-group-btn').find('.js-label'), value);
	    },
	
	    onChangeDate: function onChangeDate(e) {
	        var self = this;
	        var name = self.$(e.currentTarget).attr('name');
	        var data = {};
	        var m = e.date ? moment(e.date) : null;
	
	        self.options[name] = m ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : null;
	        data[name] = m ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : null;
	        self.trigger('change', data);
	        self.renderTypes();
	    },
	
	    renderTypes: function renderTypes() {
	        var self = this;
	        if (!self.options.dateFrom) {
	            self.$('.js-from-type [data-toggle="dropdown"]').addClass('disabled');
	        } else {
	            self.$('.js-from-type [data-toggle="dropdown"]').removeClass('disabled');
	        }
	
	        if (!self.options.dateTo) {
	            self.$('.js-to-type [data-toggle="dropdown"]').addClass('disabled');
	            if (self.options.allowHalfDays) {
	                self.$('.js-from-morning').show();
	            }
	        } else {
	            self.$('.js-to-type [data-toggle="dropdown"]').removeClass('disabled');
	            if (moment(self.options.dateTo).isSame(self.options.dateFrom)) {
	                self.$('.js-from-type [data-toggle="dropdown"]').removeClass('disabled');
	                self.$('.js-to-type [data-toggle="dropdown"]').addClass('disabled');
	                if (self.options.allowHalfDays) {
	                    self.$('.js-from-morning').show();
	                    self.$('.js-to-afternoon').show();
	                }
	            } else if (self.options.allowHalfDays) {
	                self.$('.js-from-morning').hide();
	                self.$('.js-to-afternoon').hide();
	                if (self.options.dateFromType === config.DATE_TYPE_MORNING) {
	                    self.options.dateFromType = config.DATE_TYPE_FULL_DAY;
	                    self.renderTypeLabel(self.$('.js-from-type .js-label'), self.options.dateFromType);
	                    self.trigger('change', {
	                        dateFromType: self.options.dateFromType
	                    });
	                }
	            }
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/PeriodPicker.html -->\n<div class="period-picker form-group">\n    <label class="col-sm-3 control-label">\n        Select dates\n    </label>\n    <div class="col-sm-9">\n        <div class="row">\n            <div class="col-sm-5">\n                <div class="input-daterange input-group">\n                    <input type="text" class="js-from form-control" name="dateFrom">\n                    <div class="js-from-type input-group-btn">\n                        <button data-toggle="dropdown" type="button"\n                                class="btn btn-white dropdown-toggle">\n                            <span class="js-label"></span>\n                            <span class="caret"></span>\n                        </button>\n                        <ul class="js-dropdown-menu dropdown-menu pull-right">\n                            <li>\n                                <a href="" data-type="dateFromType"\n                                    data-value="'+
	((__t=( config.DATE_TYPE_FULL_DAY ))==null?'':_.escape(__t))+
	'">\n                                    Full day\n                                </a>\n                            </li>\n                            ';
	 if (allowHalfDays) { 
	__p+='\n                                <li class="js-from-morning">\n                                    <a href="" data-type="dateFromType"\n                                        data-value="'+
	((__t=( config.DATE_TYPE_MORNING ))==null?'':_.escape(__t))+
	'">\n                                        Morning only\n                                    </a>\n                                </li>\n                                <li>\n                                    <a href="" data-type="dateFromType"\n                                        data-value="'+
	((__t=( config.DATE_TYPE_AFTERNOON ))==null?'':_.escape(__t))+
	'">\n                                        Afternoon only\n                                    </a>\n                                </li>\n                            ';
	 } 
	__p+='\n                        </ul>\n                    </div>\n                </div>\n            </div>\n            <label class="col-sm-2 control-label text-center is-marginless">\n                to\n            </label>\n            <div class="col-sm-5">\n                <div class="input-daterange input-group">\n                    <input type="text" class="js-to form-control" name="dateTo">\n                    <div class="js-to-type input-group-btn">\n                        <button data-toggle="dropdown" type="button"\n                                class="btn btn-white dropdown-toggle">\n                            <span class="js-label"></span>\n                            <span class="caret"></span>\n                        </button>\n                        <ul class="js-dropdown-menu dropdown-menu pull-right">\n                            <li>\n                                <a href="" data-type="dateToType"\n                                    data-value="'+
	((__t=( config.DATE_TYPE_FULL_DAY ))==null?'':_.escape(__t))+
	'">\n                                    Full day\n                                </a>\n                            </li>\n                            ';
	 if (allowHalfDays) { 
	__p+='\n                                <li>\n                                    <a href="" data-type="dateToType"\n                                        data-value="'+
	((__t=( config.DATE_TYPE_MORNING ))==null?'':_.escape(__t))+
	'">\n                                        Morning only\n                                    </a>\n                                </li>\n                                <li class="js-to-afternoon">\n                                    <a href="" data-type="dateToType"\n                                        data-value="'+
	((__t=( config.DATE_TYPE_AFTERNOON ))==null?'':_.escape(__t))+
	'">\n                                        Afternoon only\n                                    </a>\n                                </li>\n                            ';
	 } 
	__p+='\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <label class="error" style="display: none;"></label>\n    </div>\n    <div class="col-sm-9 col-sm-offset-3">\n        <span class="error-dateFrom error"></span>\n        <span class="error-dateTo error"></span>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/LeaveEmployeeChooser.html -->\n<!-- Employee -->\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Employee\n    </label>\n    <div class="col-sm-9">\n        <select name="employeeId" data-placeholder="Choose an employee..."\n            class="js-ext js-employee-select chosen-select">\n            <option></option>\n            ';
	 employees.each(function (employee) { 
	__p+='\n                <option value="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'">\n                    '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n                </option>\n            ';
	 }) 
	__p+='\n        </select>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _EForms = __webpack_require__(914);
	
	var _EForms2 = _interopRequireDefault(_EForms);
	
	var _LHDNFiles = __webpack_require__(918);
	
	var _LHDNFiles2 = _interopRequireDefault(_LHDNFiles);
	
	var _EaForms = __webpack_require__(921);
	
	var _EaForms2 = _interopRequireDefault(_EaForms);
	
	var _EaFormsMultiple = __webpack_require__(923);
	
	var _EaFormsMultiple2 = _interopRequireDefault(_EaFormsMultiple);
	
	var _Pcb2Forms = __webpack_require__(1006);
	
	var _Pcb2Forms2 = _interopRequireDefault(_Pcb2Forms);
	
	var _Pcb2FormsMultiple = __webpack_require__(1008);
	
	var _Pcb2FormsMultiple2 = _interopRequireDefault(_Pcb2FormsMultiple);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _queryString = __webpack_require__(554);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/govt-forms-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'governmentForms': 'e',
	        'governmentForms/e': 'e',
	        'governmentForms/ea': 'ea',
	        'governmentForms/ea/multiple/:actionMode': 'eaMultiple',
	        'governmentForms/pcb2': 'pcb2',
	        'governmentForms/pcb2/multiple': 'pcb2Multiple',
	        'governmentForms/lhdn': 'lhdn'
	    },
	
	    titles: {
	        'governmentForms': 'Government Forms',
	        'governmentForms/e': 'Government Form E',
	        'governmentForms/ea': 'Government Form EA',
	        'governmentForms/ea/multiple': 'Multiple Government Form EA',
	        'governmentForms/pcb2': 'Government Form PCB II',
	        'governmentForms/pcb2/multiple': 'Multiple Government Form PCB II',
	        'governmentForms/lhdn': 'LHDN Audit Files'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    e: function e() {
	        var _this = this;
	
	        var params = _queryString2.default.parse(window.location.search);
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	
	        var year = params.year || 2025;
	
	        var payrolls = new _payrolls2.default(null, {
	            company: app.company
	        });
	
	        var attachments = new _attachments2.default(null, {
	            attachable: app.company,
	            pagination: false
	        });
	
	        var startOfYear = (0, _moment2.default)().year(year).startOf('year').toDate();
	        var endOfYear = (0, _moment2.default)().year(year).endOf('year').toDate();
	
	        return (0, _bluebird.all)([payrolls.fetch({ filter: {
	                where: {
	                    status: { eq: 9 },
	                    and: [{ periodDate: { gte: startOfYear } }, { periodDate: { lte: endOfYear } }]
	                }
	            } }), attachments.fetch({ filter: {
	                where: { tags: 'E' },
	                limit: 30
	            } })]).then(function () {
	            _this.view = new _EForms2.default({
	                el: _this.el,
	                model: app.company,
	                attachments: attachments,
	                hideFormEButton: false,
	                year: year
	            });
	        }).finally(stopLoader);
	    },
	
	    fetchEaFormEmployees: function fetchEaFormEmployees(year) {
	        return app.company.fetchFormEAEmployees(year || (0, _moment2.default)().year() - 1);
	    },
	
	    fetchEmployeesAttachments: function fetchEmployeesAttachments(tag) {
	        var employees = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        return (0, _bluebird.all)(employees.map(function (emp) {
	            return emp.fetchAttachments([tag]);
	        })).then(function (attachmentList) {
	            return _.indexBy(attachmentList, function (att, i) {
	                return employees[i].id;
	            });
	        });
	    },
	
	    ea: function ea() {
	        var _this2 = this;
	
	        var params = _queryString2.default.parse(window.location.search);
	        var stopLoader = _loader2.default.startFullPage(this.el);
	
	        return this.fetchEaFormEmployees(params.year || 2025).then(function (employees) {
	            return (0, _bluebird.all)([employees, _this2.fetchEmployeesAttachments('EA', employees.models)]);
	        }).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                employees = _ref2[0],
	                employeeAttachments = _ref2[1];
	
	            var view = new _EaForms2.default({
	                el: _this2.el,
	                model: app.company,
	                collection: employees,
	                attachments: employeeAttachments
	            }).render();
	            _this2.view = view;
	        }).finally(stopLoader);
	    },
	
	    eaMultiple: function eaMultiple(actionMode) {
	        var _this3 = this;
	
	        var params = _queryString2.default.parse(window.location.search);
	        var stopLoader = _loader2.default.startFullPage(this.el);
	        return this.fetchEaFormEmployees(params.year || undefined).then(function (employees) {
	            var view = new _EaFormsMultiple2.default({
	                el: _this3.el,
	                model: app.company,
	                collection: employees,
	                actionMode: actionMode
	            }).render();
	            _this3.view = view;
	        }).finally(stopLoader);
	    },
	
	    pcb2: function pcb2() {
	        var _this4 = this;
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	
	        if (!['admin_manager', 'super_admin', 'employer', 'mpp_admin'].includes(app.user.get('role'))) {
	            app.mainRouter.navigate('dashboard', { trigger: true });
	            return;
	        }
	
	        var employees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        return employees.fetch({
	            filter: {
	                where: {
	                    // exclude Freelancers
	                    residentSubType: {
	                        nin: [3]
	                    }
	                },
	                limit: 9999
	            },
	            validate: false
	        }).then(function () {
	            return _this4.fetchEmployeesAttachments('PCB2', employees.models);
	        }).then(function (employeeAttachments) {
	            var view = new _Pcb2Forms2.default({
	                el: _this4.el,
	                model: app.company,
	                collection: employees,
	                attachments: employeeAttachments
	            }).render();
	            _this4.view = view;
	        }).finally(stopLoader);
	    },
	
	    pcb2Multiple: function pcb2Multiple() {
	        var _this5 = this;
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	        return this.fetchEaFormEmployees(2025).then(function (employees) {
	            return (0, _bluebird.all)([employees, _this5.fetchEmployeesAttachments('PCB2', employees.models)]);
	        }).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                employees = _ref4[0],
	                employeeAttachments = _ref4[1];
	
	            var view = new _Pcb2FormsMultiple2.default({
	                el: _this5.el,
	                model: app.company,
	                collection: employees,
	                attachments: employeeAttachments
	            }).render();
	            _this5.view = view;
	        }).finally(stopLoader);
	    },
	
	    lhdn: function lhdn() {
	        var _this6 = this;
	
	        var stopLoader = _loader2.default.startFullPage(this.el);
	
	        var attachments = new _attachments2.default(null, {
	            attachable: app.company,
	            pagination: false
	        });
	
	        return attachments.fetch({ filter: { limit: 9999 } }).then(function () {
	            _this6.view = new _LHDNFiles2.default({
	                el: _this6.el,
	                model: app.company,
	                attachments: attachments.findByTags(['lhdn-audit'])
	            });
	        }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var AttachmentView = __webpack_require__(915);
	var template = __webpack_require__(917);
	var loader = __webpack_require__(534);
	
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	
	    events: {
	        'click .js-generate': 'generateForm'
	    },
	
	    initialize: function initialize(options) {
	        this.itemViews = [];
	        this.options = _.defaults(options || {}, {
	            attachments: null,
	            hideFormEButton: false,
	            year: 2025
	        });
	
	        this.options.attachments.on('reset add remove', this.render, this);
	
	        this.render();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var companyStartYear = (0, _moment2.default)(app.company.get('createdAt')).year();
	        var currentYear = 2025;
	        var availableYears = Array(currentYear - companyStartYear + 1).fill(null).map(function (_, index) {
	            return currentYear - index;
	        }).filter(function (year) {
	            return !_this.options.attachments.hasTag('period-' + year);
	        });
	
	        this.$el.html(template({
	            collection: this.options.attachments,
	            hideFormEButton: this.options.hideFormEButton,
	            availableYears: availableYears,
	            year: this.options.year
	        }));
	
	        if (this.options.attachments.length > 0) {
	            this.options.attachments.forEach(this.renderItem.bind(this));
	        } else {
	            this.$('.empty-list').removeClass('hidden');
	        }
	
	        this.$('.sk-spinner').hide();
	        return this;
	    },
	
	    renderItem: function renderItem(model) {
	        var view = new AttachmentView({ model: model, mainView: this });
	
	        this.itemViews.push(view);
	        this.$('.items').append(view.$el);
	    },
	
	    generateForm: function generateForm(e) {
	        var _this2 = this;
	
	        loader.startFullScreen(e.target);
	        var year = parseInt(this.$('#year').val() || '2025', 10);
	
	        // Exclude XLSX for year >= 2023
	        (0, _bluebird.all)([this.model.generateFormE(year), this.model.generateFormCp8d('txt', year)].concat(_toConsumableArray(year < 2023 ? [this.model.generateFormCp8d('excel', year)] : []))).then(function () {
	            return _this2.model.fetchAttachments(['E']);
	        }).then(function (attachments) {
	            _this2.options.attachments.add(attachments.models);
	            loader.stopLoader();
	        });
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _Attachment = __webpack_require__(916);
	
	var _Attachment2 = _interopRequireDefault(_Attachment);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _downloadjs = __webpack_require__(666);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    className: 'col-lg-6 col-md-6 col-sm-6',
	
	    events: {
	        'click .js-submit': 'submit',
	        'click .js-destroy': 'destroyModel',
	        'click .js-download': 'download'
	    },
	
	    initialize: function initialize() {
	        this.model.on('sync', this.render, this);
	        this.model.on('destroy', this.remove, this);
	
	        return this.render();
	    },
	
	    render: function render() {
	        var showDelete = (0, _moment2.default)(this.model.get('createdAt')).year() === (0, _moment2.default)().year();
	        this.$el.html((0, _Attachment2.default)({ model: this.model, showDelete: showDelete }));
	
	        return this;
	    },
	
	    submit: function submit() {
	        this.model.addTag('submitted');
	    },
	
	    destroyModel: function destroyModel(ev) {
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        this.model.destroy().finally(stopLoader);
	    },
	
	    download: function download(ev) {
	        ev.preventDefault();
	        var that = this;
	
	        /* jQuery ajax cannot be used here because messes up the response */
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', this.model.getUrl(), true);
	        xhr.responseType = 'blob';
	        xhr.onload = function () {
	            // TODO: handle errors
	            // Alternatively we could use the whatwg-fetch polyfill
	            if (this.status == 200) {
	                // get binary data as a response
	                var blob = this.response;
	                (0, _downloadjs2.default)(blob, that.model.get('name'), 'application/pdf');
	            }
	        };
	        xhr.send();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/Attachment.ejs -->\n<div class="ibox float-e-margins govt-form-item\n    '+
	((__t=( model.hasTag('period-' + (new Date()).getFullYear()) ?
	        'current' : '' ))==null?'':_.escape(__t))+
	'">\n    <div class="ibox-title">\n        <h2>\n            '+
	((__t=( model.get('description') ))==null?'':_.escape(__t))+
	'\n            '+
	((__t=( (model.findTag(/^period-\d{4}$/) || '').substr(-4) ))==null?'':_.escape(__t))+
	'\n            <span class="small">\n                ('+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	')\n            </span>\n        </h2>\n    </div>\n    <div class="ibox-content">\n        <div class="row '+
	((__t=( showDelete ? 'text-right' : 'text-center' ))==null?'':_.escape(__t))+
	'">\n            <div class="col-xs-12 clearfix">\n                ';
	 if (showDelete) { 
	__p+='\n                <button class="btn btn-outline btn-danger js-destroy\n                    float-left">\n                    <i class="fa fa-trash"></i>\n                    Delete\n                </button>\n                ';
	 } 
	__p+='\n\n                <!-- Display icon based on the extension of attachment -->\n                ';
	 icon = model.getUrl().includes('.pdf') ? 'fa-file-pdf-o' : 'fa-file-excel-o' 
	__p+='\n                <a class="btn btn-outline btn-primary js-download"\n                    href="'+
	((__t=( model.downloadUrl() ))==null?'':_.escape(__t))+
	'" target="_blank">\n                    <i class="fa '+
	((__t=( icon ))==null?'':_.escape(__t))+
	'"></i>\n                    Download\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/EForms.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">Yearly Forms</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-content">\n                    <div class="row vertical-align">\n                        <div class="col-sm-1 text-center">\n                            <i class="fa fa-2x fa-info-circle m-t-sm"></i>\n                        </div>\n                        <h3 class="col-sm-11 line-height-md">\n                            Please be reminded to check the forms as it is the\n                            employer\'s responsibility to provide accurate\n                            information to the statutory bodies.\n                        </h3>\n                    </div>\n                </div>\n            </div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    ';
	 if (collection.length <= 0) { 
	__p+='\n                        <h5>No Forms Available</h5>\n                    ';
	 } else if (collection.length === 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' E Form</h5>\n                    ';
	 } else if (collection.length > 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' E Forms</h5>\n                    ';
	 } 
	__p+='\n                </div>\n\n                <div class="ibox-content">\n                    <div class="row items">\n                        <div class="col-xs-12">\n                            '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n\n                            <div class="empty-list text-center hidden">\n                                <h1>\n                                    You haven\'t generated an E Form yet.\n                                </h1>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="ibox-footer text-right">\n                    ';
	 if (!hideFormEButton && availableYears.length) { 
	__p+='\n                    <select id="year">\n                        ';
	 for (var year in availableYears) { 
	__p+='\n                            <option value="'+
	((__t=( availableYears[year] ))==null?'':_.escape(__t))+
	'">'+
	((__t=( availableYears[year] ))==null?'':_.escape(__t))+
	'</option>\n                        ';
	 } 
	__p+='\n                    </select>\n                    <button class="btn btn-primary js-generate">\n                        Generate Form\n                    </button>\n                    ';
	 } 
	__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var AttachmentView = __webpack_require__(915);
	var template = __webpack_require__(919);
	var Payroll = __webpack_require__(920);
	var loader = __webpack_require__(534);
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	
	    events: {
	        'click .js-generate': 'generateForm'
	    },
	
	    initialize: function initialize(options) {
	        this.itemViews = [];
	        this.options = _.defaults(options || {}, {
	            attachments: null
	        });
	
	        this.options.attachments.on('reset add remove', this.render, this);
	
	        this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            collection: this.options.attachments,
	            year: Payroll.getCurrentPeriodDate().getFullYear() - 1
	        }));
	
	        if (this.options.attachments.length > 0) {
	            this.options.attachments.forEach(this.renderItem.bind(this));
	        } else {
	            this.$('.empty-list').removeClass('hidden');
	        }
	
	        this.$('.sk-spinner').hide();
	        return this;
	    },
	
	    renderItem: function renderItem(model) {
	        var view = new AttachmentView({ model: model, mainView: this });
	
	        this.itemViews.push(view);
	        this.$('.items').append(view.$el);
	    },
	
	    generateForm: function generateForm(e) {
	        var _this = this;
	
	        loader.startFullScreen(e.target);
	
	        var year = parseInt(this.$('select[name="period-year"]').val(), 10) || new Date().getFullYear();
	
	        return (0, _bluebird.all)(this.options.attachments.findByTags(['lhdn-audit', 'period-' + year]).map(function (attachment) {
	            _this.options.attachments.remove(attachment);
	            return attachment.destroy();
	        })).then(function () {
	            return _this.model.generateLHDNAuditFiles(year);
	        }).then(function () {
	            return _this.model.fetchAttachments(['lhdn-audit']);
	        }).then(function (attachments) {
	            _this.options.attachments.add(attachments.models);
	
	            loader.stopLoader();
	        });
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/LHDNFiles.ejs -->\n';
	 var moment = __webpack_require__(101) 
	__p+='\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">LHDN Audit Files</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-content">\n                    <div class="row vertical-align">\n                        <div class="col-sm-1 text-center">\n                            <i class="fa fa-2x fa-info-circle m-t-sm"></i>\n                        </div>\n                        <h3 class="col-sm-11 line-height-md">\n                            Please be reminded to check the forms as it is the\n                            employer\'s responsibility to provide accurate\n                            information.\n                        </h3>\n                    </div>\n                </div>\n            </div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    ';
	 if (collection.length <= 0) { 
	__p+='\n                        <h5>No Files Available</h5>\n                    ';
	 } else if (collection.length === 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' LHDN Audit Files</h5>\n                    ';
	 } else if (collection.length > 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' LHDN Audit Files</h5>\n                    ';
	 } 
	__p+='\n                </div>\n\n                <div class="ibox-content">\n                    <div class="row items">\n                        <div class="col-xs-12">\n                            '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n\n                            <div class="empty-list text-center hidden">\n                                <h1>\n                                    You haven\'t generated LHDN audit files yet.\n                                </h1>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="ibox-footer text-right">\n                    <select name="period-year">\n                        ';
	
	                        var latestYear = 2025;
	                        for (
	                            var y = (moment(app.company.get('createdAt') || new Date())).year();
	                            y <= latestYear;
	                            y ++
	                        ) { 
	__p+='\n                            <option value="'+
	((__t=(y))==null?'':_.escape(__t))+
	'" '+
	((__t=( y === latestYear ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>'+
	((__t=(y))==null?'':_.escape(__t))+
	'</option>\n                        ';
	 } 
	__p+='\n                    </select>\n                    <button class="btn btn-primary js-generate">\n                        Generate Files\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Parse) {'use strict';
	
	var config = __webpack_require__(527);
	var moment = __webpack_require__(101);
	var BaseModel = __webpack_require__(733);
	
	var Model = void 0;
	
	module.exports = Model = BaseModel.extend('Payroll', {
	    softDelete: false,
	
	    defaults: {
	        company: null,
	        submittedDate: null,
	        chequePickupDate: null,
	        periodDate: null,
	        status: 0,
	        lastEditedEmployee: null,
	        employeeEpf: 0,
	        employeeSocso: 0,
	        employerEpf: 0,
	        employerSocso: 0,
	        mtd: 0,
	        cp38: 0,
	        zakat: 0,
	        grossPay: 0,
	        netPay: 0,
	        base: 0,
	        additions: 0,
	        deductions: 0,
	        payslips: 0
	    },
	
	    constraints: {
	        company: { presence: true },
	        status: {
	            presence: true,
	            numericality: {
	                onlyInteger: true,
	                greaterThanOrEqualTo: 0,
	                lessOrEqualThan: 0
	            }
	        }
	    },
	
	    setters: {
	        status: function status(value) {
	            return !_.isNaN(parseInt(value, 10)) ? parseInt(value, 10) : value;
	        }
	    },
	
	    isCreated: function isCreated() {
	        return (this.get('status') || 0) === 0;
	    },
	
	    isComplete: function isComplete() {
	        return this.get('status') === 9;
	    },
	
	    getStatusLabel: function getStatusLabel() {
	        if (this.get('status') < 3) {
	            return 'Saved';
	        } else if (this.get('status') === 9) {
	            return 'Complete';
	        } else {
	            return 'Submitted';
	        }
	    },
	
	    run: function run(includeAllEmployees) {
	        return Parse.Cloud.run('runPayroll', {
	            payrollId: this.id,
	            includeAllEmployees: includeAllEmployees
	        }).then(function (res) {
	            if (res instanceof Parse.Object) {
	                this.trigger('run-complete', this);
	                return Parse.Promise.as(res);
	            }
	
	            this.trigger('running', this);
	            return this.whenDone(res.job).then(function () {
	                this.trigger('run-complete', this);
	                return Parse.Promise.as(this);
	            }.bind(this));
	        }.bind(this));
	    },
	
	    whenDone: function whenDone(jobId) {
	        var timeout;
	        var promise = new Parse.Promise();
	        var pollStatus = function () {
	            Parse.Cloud.run('payrollJobStatus', {
	                jobId: jobId,
	                payrollId: this.id
	            }).then(function (res) {
	                if (res.done === true) {
	                    clearTimeout(timeout);
	                    promise.resolve(this);
	                    return;
	                }
	
	                timeout = setTimeout(pollStatus, 2000);
	            }.bind(this), function (err) {
	                clearTimeout(timeout);
	                promise.reject(err);
	            });
	        }.bind(this);
	
	        pollStatus();
	
	        return promise;
	    },
	
	    hasPendingJobs: function hasPendingJobs() {
	        return Parse.Cloud.run('payrollHasPendingJobs', {
	            payrollId: this.id
	        });
	    },
	
	    sync: function sync(integration) {
	        return Parse.Cloud.run('payrollSync', {
	            provider: integration.get('provider'),
	            integrationId: integration.id,
	            payrollId: this.id
	        });
	    },
	
	    isCurrentPeriod: function isCurrentPeriod() {
	        return this.getPeriod().month() === moment(this.getPeriodFromDate()).month();
	    },
	
	    getPeriod: function getPeriod() {
	        if (this.get('periodDate')) {
	            return moment(this.get('periodDate'));
	        }
	
	        return moment(this.getPeriodFromDate(this.get('submittedDate') || Date.now()));
	    },
	
	    samePeriodAs: function samePeriodAs(payroll) {
	        return this.getPeriod().isSame(payroll.getPeriod(), 'month');
	    },
	
	    getPeriodFromDate: function getPeriodFromDate(date) {
	        var m = moment(date || Date.now());
	
	        if (m.date() < config.periodStartDate) {
	            m.subtract(1, 'month');
	        }
	
	        return m.toDate();
	    },
	
	    getPeriodFormatted: function getPeriodFormatted() {
	        return this.getPeriod().format('MMMM YYYY');
	    },
	
	    generateForms: function generateForms() {
	        return Parse.Cloud.run('generatePayrollForms', {
	            payrollId: this.id
	        });
	    },
	
	    sendPayslips: function sendPayslips(payslips) {
	        return Parse.Cloud.run('sendPayslips', {
	            payrollId: this.id,
	            payslips: payslips
	        });
	    },
	
	    resetEmployee: function resetEmployee(employee) {
	        var employeeId = typeof employee === 'string' ? employee : employee.id;
	
	        return Parse.Cloud.run('payrollResetEmployee', {
	            payrollId: this.id,
	            employeeId: employeeId
	        });
	    },
	
	    resetUnpaidLeave: function resetUnpaidLeave() {
	        return Parse.Cloud.run('payrollResetUnpaidLeave', {
	            payrollId: this.id
	        });
	    },
	
	    revert: function revert() {
	        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return Parse.Cloud.run('revertPayroll', {
	            payrollId: this.id,
	            savedPayrollAction: opts.savedPayrollAction
	        });
	    },
	
	    createArchive: function createArchive() {
	        return Parse.Cloud.run('createPayrollArchiveFile', {
	            payrollId: this.id,
	            companyId: this.get('company').id
	        });
	    },
	
	    makeArchiveDownloadable: function makeArchiveDownloadable() {
	        return Parse.Cloud.run('makeArchiveDownloadable', {
	            payrollId: this.id
	        });
	    }
	}, {
	    getCurrentPeriodDate: function getCurrentPeriodDate() {
	        var periodStart = moment().date() < config.periodStartDate ? moment().subtract(1, 'month').startOf('month') : moment().startOf('month');
	
	        return periodStart.toDate();
	    },
	
	    fetchById: function fetchById(id) {
	        return new Parse.Query('Payroll').get(id);
	    },
	
	    fetchCurrent: function fetchCurrent(company) {
	        return new Parse.Query('Payroll').include('company').descending('createdAt').lessThanOrEqualTo('status', 2).equalTo('company', company).first();
	    },
	
	    fetchForUser: function fetchForUser(user) {
	        return new Parse.Query('Company').equalTo('user', user).first();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(650)))

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var AttachmentView = __webpack_require__(915);
	var template = __webpack_require__(922);
	var loader = __webpack_require__(534);
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	
	    events: {
	        'click .js-eaforms-toggle': 'toggleAll',
	        'click .js-generate': 'generateForm',
	        'click .js-generate-all': 'generateFormAll'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.itemViews = [];
	        this.collapsed = true;
	
	        this.options = _.defaults(options || {}, {
	            attachments: null,
	            year: 2025
	        });
	
	        this.collection.forEach(function (employee) {
	            _this.options.attachments[employee.id].on('reset', function () {
	                _this.renderItems(employee, 'reset');
	            });
	        });
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            model: this.model,
	            collection: this.collection,
	            year: this.options.year
	        }));
	
	        this.$('.footable').footable({
	            sort: false,
	            addRowToggle: true,
	            paging: {
	                enabled: true
	            }
	        });
	
	        _.each(this.itemViews, function (view) {
	            view.remove();
	        });
	
	        this.itemViews = [];
	
	        if (this.collection.length > 0) {
	            this.collection.forEach(this.renderItems.bind(this));
	        }
	
	        return this;
	    },
	
	    renderItems: function renderItems(employee, reset) {
	        var _this2 = this;
	
	        var attachments = this.options.attachments[employee.id];
	        var $employee = this.$('.js-employee-' + employee.id);
	
	        if (reset) {
	            $employee.html('');
	        }
	
	        attachments.forEach(function (attachment) {
	            _this2.renderItem(attachment, employee);
	        });
	        if (reset) {
	            $employee.fadeIn(200);
	        }
	    },
	
	    renderItem: function renderItem(model, employee) {
	        var employeeView = new AttachmentView({ model: model });
	
	        this.itemViews.push(employeeView);
	
	        this.$('.js-employee-' + employee.id).append(employeeView.$el);
	
	        return this;
	    },
	
	    toggleAll: function toggleAll(ev) {
	        ev.preventDefault();
	
	        this.$('.footable').trigger(this.collapsed ? 'footable_expand_all' : 'footable_collapse_all');
	
	        this.collapsed = !this.collapsed;
	    },
	
	    generateForm: function generateForm(ev) {
	        var $button = this.$(ev.currentTarget);
	        var employee = this.collection.get($button.data('employee'));
	        var year = $button.data('year');
	        var attachments = this.options.attachments[employee.id];
	        var stopLoader = loader.startFullScreen($button);
	
	        var $employee = this.$('.js-employee-' + employee.id);
	        $employee.fadeOut(200);
	
	        (0, _bluebird.all)([employee.generateFormEA(year), employee.generateFormExcel(year)]).then(function () {
	            return employee.fetchAttachments(['EA']);
	        }).then(function (employeeAttachments) {
	            attachments.reset(employeeAttachments.models);
	
	            var $row = $button.closest('tr');
	            var $detail = $row.next('.footable-row-detail');
	
	            if (!$detail.is(':visible')) {
	                $row.trigger('footable_toggle_row');
	            }
	        }).finally(stopLoader);
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/EaForms.ejs -->\n';
	 idSuffix = Math.floor(Math.random() * 10000000) 
	__p+='\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">Yearly Forms</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    ';
	 if (collection.length <= 0) { 
	__p+='\n                        <h5>No Forms Available</h5>\n                    ';
	 } else if (collection.length === 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' EA Form</h5>\n                    ';
	 } else if (collection.length > 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' EA Forms</h5>\n                    ';
	 } 
	__p+='\n                </div>\n\n                <div class="tab-content ibox-content">\n\n                    <div id="employee-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                        class="tab-pane active"\n                        data-tab-name="employee">\n\n                        <button onclick="window.location.href = \'#/governmentForms/ea/multiple/download\'" class="btn btn-primary">\n                            Download EA Forms for Multiple Employees\n                        </button>\n\n                        <button \n                            onclick="window.location.href = \'#/governmentForms/ea/multiple/send\'"\n                            class="btn btn-outline btn-success float-right"\n                        >\n                            <i class="fa fa-envelope-o"></i>\n                            Send EA Forms\n                        </button>\n\n                        <table class="footable footable-eaform table\n                            table-stripped toggle-arrow-tiny" data-page-size="50">\n                            <thead>\n                                <tr>\n                                    <th data-toggle="true"\n                                        class="footable-sortable\n                                            js-eaforms-toggle">\n                                        Employees\n                                    </th>\n                                    <th data-hide="all"></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                ';
	 collection.each(function(employee) { 
	__p+='\n                                    <tr>\n                                        <td>\n                                            '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n\n                                            '+
	((__t=( employee.get('hiddenAt') ? (
	                                                '(archived on ' +
	                                                employee.get('hiddenAt') +
	                                                ')'
	                                            ) : '' ))==null?'':_.escape(__t))+
	'\n\n                                            <button class="btn btn-primary\n                                                          btn-outline pull-right\n                                                          margin-right-small\n                                                          js-generate"\n                                                   data-employee="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'"\n                                                   data-year="'+
	((__t=( year ))==null?'':_.escape(__t))+
	'">\n                                               Generate\n                                               '+
	((__t=( year ))==null?'':_.escape(__t))+
	'\n                                               Form\n                                            </button>\n                                        </td>\n                                        <td>\n                                            <div class="row js-list\n                                                js-employee-'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'">\n                                            </div>\n                                        </td>\n                                    </tr>\n                                ';
	 }) 
	__p+='\n                            </tbody>\n                            <tfoot>\n                                <tfoot>\n                                    <tr>\n                                        <td colspan="2">\n                                            <ul class="pagination pull-right"></ul>\n                                        </td>\n                                    </tr>\n                                </tfoot>\n                            </tfoot>\n                        </table>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var JSZip = __webpack_require__(924);
	var Alerts = __webpack_require__(529);
	var tpl = __webpack_require__(1005);
	var downloadjs = __webpack_require__(666);
	var loader = __webpack_require__(534);
	var tooltip = __webpack_require__(541);
	var moment = __webpack_require__(101);
	var axios = __webpack_require__(28);
	var log = __webpack_require__(525)('employer/form-ea-multidownload');
	
	var Promise = __webpack_require__(63);
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	    employeeIds: [],
	
	    events: {
	        'change .employee-all[type="checkbox"]': 'selectAllEmployee',
	        'change .employee[type="checkbox"]': 'selectEmployee',
	        'change #year': 'selectYear',
	        'click .download-ea': 'downloadEa',
	        'click .send-ea': 'sendEa'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.itemViews = [];
	        this.employeeIds = [];
	        this.collapsed = true;
	
	        this.options = _.defaults(options || {}, {
	            actionMode: 'download',
	            year: moment().year()
	        });
	
	        this.collection.forEach(function (employee) {
	            _this.employeeIds.push(employee.id);
	        });
	    },
	
	    render: function render() {
	        this.$el.html(tpl({
	            model: this.model,
	            collection: this.collection,
	            startYear: moment(app.company.get('createdAt')).year(),
	            selectedYear: this.options.year,
	            actionMode: this.options.actionMode
	        }));
	
	        tooltip.initBody();
	
	        return this;
	    },
	
	    selectYear: function selectYear() {
	        var _this2 = this;
	
	        var year = parseInt(this.$('#year').val() || 2025, 10);
	        this.options.year = year;
	        return app.company.fetchFormEAEmployees(year).then(function (employees) {
	            _this2.collection = employees;
	            _this2.employeeIds = employees.map(function (employee) {
	                return employee.id;
	            });
	            _this2.$('.employee-all[type="checkbox"]').prop('checked', true);
	            _this2.render();
	        });
	    },
	
	    selectEmployee: function selectEmployee(e) {
	        var input = this.$(e.currentTarget);
	        var id = input.val();
	        var checked = input.prop('checked');
	
	        if (checked === false) {
	            var index = this.employeeIds.indexOf(id);
	            this.employeeIds.splice(index, 1);
	
	            this.$('.employee-all[type="checkbox"]').prop('checked', false);
	        } else if (checked === true) {
	            this.employeeIds.push(id);
	        }
	    },
	
	    selectAllEmployee: function selectAllEmployee(e) {
	        var input = this.$(e.currentTarget);
	        var checked = input.prop('checked');
	
	        if (checked === false) {
	            this.employeeIds = [];
	            this.$('.employee[type="checkbox"]').prop('checked', false);
	        } else if (checked === true) {
	            this.employeeIds = this.collection.map(function (emp) {
	                return emp.id;
	            });
	            this.$('.employee[type="checkbox"]').prop('checked', true);
	        }
	    },
	
	    downloadEa: function downloadEa(ev) {
	        var _this3 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = loader.startFullScreen($button);
	        var year = parseInt(this.$('select#year').val(), 10);
	
	        var zip = new JSZip();
	
	        return Promise.each(this.collection.filter(function (emp) {
	            return _this3.employeeIds.includes(emp.id);
	        }), function (employee) {
	            return employee.generateFormEA(year).then(function (attachment) {
	                var fileName = attachment.get('name').replace(/[/]|[\\]/g, '-');
	                return axios.get(attachment.getUrl(), {
	                    timeout: 60000,
	                    responseType: 'blob'
	                }).then(function (response) {
	                    // check if there is file name duplication as it would overwrite the existing ones.
	                    if (zip.file(fileName) !== null) {
	                        var numOfDuplicates = zip.file(new RegExp(fileName)).length;
	                        zip.file(fileName.replace(/^([^().]+).*.pdf$/, function (_, p1) {
	                            return p1 + '(' + numOfDuplicates + ').pdf';
	                        }), response.data);
	                    } else {
	                        zip.file(fileName, response.data);
	                    }
	                }).catch(function (error) {
	                    log.error('Form EA generating failed for employee ' + employee.get('fullName'));
	                    log.error(error.error);
	                });
	            });
	        }).then(function () {
	            return zip.generateAsync({ type: 'blob' });
	        }).then(function (content) {
	            downloadjs(content, 'ea-forms-' + year + '.zip', 'application/zip');
	            stopLoader();
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	            stopLoader();
	        });
	    },
	
	    sendEa: function sendEa(ev) {
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = loader.startFullScreen($button);
	        var year = parseInt(this.$('select#year').val(), 10);
	
	        var ccEmail = this.$('input#ccEmail').val();
	
	        return app.company.sendFormEA(this.employeeIds, year, ccEmail).then(function () {
	            Alerts.show('success', {
	                title: '',
	                text: 'The employees will receive their EA forms                        shortly provided that an email address was                         entered in their profile.'
	            });
	            stopLoader();
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	            stopLoader();
	        });
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 */
	function JSZip() {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) {
	        return new JSZip();
	    }
	
	    if(arguments.length) {
	        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
	    }
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    // NOTE: we use a null prototype because we do not
	    // want filenames like "toString" coming from a zip file
	    // to overwrite methods and attributes in a normal Object.
	    this.files = Object.create(null);
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(925);
	JSZip.prototype.loadAsync = __webpack_require__(996);
	JSZip.support = __webpack_require__(928);
	JSZip.defaults = __webpack_require__(967);
	
	// TODO find a better way to handle this version,
	// a require('package.json').version doesn't work with webpack, see #327
	JSZip.version = "3.7.1";
	
	JSZip.loadAsync = function (content, options) {
	    return new JSZip().loadAsync(content, options);
	};
	
	JSZip.external = __webpack_require__(960);
	module.exports = JSZip;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utf8 = __webpack_require__(926);
	var utils = __webpack_require__(927);
	var GenericWorker = __webpack_require__(963);
	var StreamHelper = __webpack_require__(964);
	var defaults = __webpack_require__(967);
	var CompressedObject = __webpack_require__(968);
	var ZipObject = __webpack_require__(973);
	var generate = __webpack_require__(974);
	var nodejsUtils = __webpack_require__(958);
	var NodejsStreamInputAdapter = __webpack_require__(995);
	
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} originalOptions the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, originalOptions) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	
	    /*
	     * Correct options.
	     */
	
	    var o = utils.extend(originalOptions || {}, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) {
	        o.compression = o.compression.toUpperCase();
	    }
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
	    if (!originalOptions || typeof originalOptions.binary === "undefined") {
	        o.binary = !isUnicodeString;
	    }
	
	
	    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;
	
	    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
	        o.base64 = false;
	        o.binary = true;
	        data = "";
	        o.compression = "STORE";
	        dataType = "string";
	    }
	
	    /*
	     * Convert content to fit.
	     */
	
	    var zipObjectContent = null;
	    if (data instanceof CompressedObject || data instanceof GenericWorker) {
	        zipObjectContent = data;
	    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        zipObjectContent = new NodejsStreamInputAdapter(name, data);
	    } else {
	        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
	    }
	
	    var object = new ZipObject(name, zipObjectContent, o);
	    this.files[name] = object;
	    /*
	    TODO: we can't throw an exception because we have async promises
	    (we can have a promise of a Date() for example) but returning a
	    promise is useless because file(name, data) returns the JSZip
	    object for chaining. Should we break that to allow the user
	    to catch the error ?
	
	    return external.Promise.resolve(zipObjectContent)
	    .then(function () {
	        return object;
	    });
	    */
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) === '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) !== "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	function isRegExp(object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	}
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * @see loadAsync
	     */
	    load: function() {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	
	    /**
	     * Call a callback function for each entry at this folder level.
	     * @param {Function} cb the callback function:
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     */
	    forEach: function(cb) {
	        var filename, relativePath, file;
	        /* jshint ignore:start */
	        // ignore warning about unwanted properties because this.files is a null prototype object
	        for (filename in this.files) {
	            file = this.files[filename];
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
	                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
	            }
	        }
	        /* jshint ignore:end */
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [];
	        this.forEach(function (relativePath, entry) {
	            if (search(relativePath, entry)) { // the file matches the function
	                result.push(entry);
	            }
	
	        });
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                var obj = this.files[this.root + name];
	                if (obj && !obj.dir) {
	                    return obj;
	                } else {
	                    return null;
	                }
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) !== "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	    /**
	     * Generate the complete zip file as an internal stream.
	     * @param {Object} options the options to generate the zip file :
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {StreamHelper} the streamed zip file.
	     */
	    generateInternalStream: function(options) {
	      var worker, opts = {};
	      try {
	          opts = utils.extend(options || {}, {
	              streamFiles: false,
	              compression: "STORE",
	              compressionOptions : null,
	              type: "",
	              platform: "DOS",
	              comment: null,
	              mimeType: 'application/zip',
	              encodeFileName: utf8.utf8encode
	          });
	
	          opts.type = opts.type.toLowerCase();
	          opts.compression = opts.compression.toUpperCase();
	
	          // "binarystring" is preferred but the internals use "string".
	          if(opts.type === "binarystring") {
	            opts.type = "string";
	          }
	
	          if (!opts.type) {
	            throw new Error("No output type specified.");
	          }
	
	          utils.checkSupport(opts.type);
	
	          // accept nodejs `process.platform`
	          if(
	              opts.platform === 'darwin' ||
	              opts.platform === 'freebsd' ||
	              opts.platform === 'linux' ||
	              opts.platform === 'sunos'
	          ) {
	              opts.platform = "UNIX";
	          }
	          if (opts.platform === 'win32') {
	              opts.platform = "DOS";
	          }
	
	          var comment = opts.comment || this.comment || "";
	          worker = generate.generateWorker(this, opts, comment);
	      } catch (e) {
	        worker = new GenericWorker("error");
	        worker.error(e);
	      }
	      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateAsync: function(options, onUpdate) {
	        return this.generateInternalStream(options).accumulate(onUpdate);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateNodeStream: function(options, onUpdate) {
	        options = options || {};
	        if (!options.type) {
	            options.type = "nodebuffer";
	        }
	        return this.generateInternalStream(options).toNodejsStream(onUpdate);
	    }
	};
	module.exports = out;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(927);
	var support = __webpack_require__(928);
	var nodejsUtils = __webpack_require__(958);
	var GenericWorker = __webpack_require__(963);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodejsUtils.newBufferFrom(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    return buf2string(buf);
	};
	
	/**
	 * A worker to decode utf8 encoded binary chunks into string chunks.
	 * @constructor
	 */
	function Utf8DecodeWorker() {
	    GenericWorker.call(this, "utf-8 decode");
	    // the last bytes if a chunk didn't end with a complete codepoint.
	    this.leftOver = null;
	}
	utils.inherits(Utf8DecodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8DecodeWorker.prototype.processChunk = function (chunk) {
	
	    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);
	
	    // 1st step, re-use what's left of the previous chunk
	    if (this.leftOver && this.leftOver.length) {
	        if(support.uint8array) {
	            var previousData = data;
	            data = new Uint8Array(previousData.length + this.leftOver.length);
	            data.set(this.leftOver, 0);
	            data.set(previousData, this.leftOver.length);
	        } else {
	            data = this.leftOver.concat(data);
	        }
	        this.leftOver = null;
	    }
	
	    var nextBoundary = utf8border(data);
	    var usableData = data;
	    if (nextBoundary !== data.length) {
	        if (support.uint8array) {
	            usableData = data.subarray(0, nextBoundary);
	            this.leftOver = data.subarray(nextBoundary, data.length);
	        } else {
	            usableData = data.slice(0, nextBoundary);
	            this.leftOver = data.slice(nextBoundary, data.length);
	        }
	    }
	
	    this.push({
	        data : exports.utf8decode(usableData),
	        meta : chunk.meta
	    });
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	Utf8DecodeWorker.prototype.flush = function () {
	    if(this.leftOver && this.leftOver.length) {
	        this.push({
	            data : exports.utf8decode(this.leftOver),
	            meta : {}
	        });
	        this.leftOver = null;
	    }
	};
	exports.Utf8DecodeWorker = Utf8DecodeWorker;
	
	/**
	 * A worker to endcode string chunks into utf8 encoded binary chunks.
	 * @constructor
	 */
	function Utf8EncodeWorker() {
	    GenericWorker.call(this, "utf-8 encode");
	}
	utils.inherits(Utf8EncodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8EncodeWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : exports.utf8encode(chunk.data),
	        meta : chunk.meta
	    });
	};
	exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var support = __webpack_require__(928);
	var base64 = __webpack_require__(957);
	var nodejsUtils = __webpack_require__(958);
	var setImmediate = __webpack_require__(959);
	var external = __webpack_require__(960);
	
	
	/**
	 * Convert a string that pass as a "binary string": it should represent a byte
	 * array but may have > 255 char codes. Be sure to take only the first byte
	 * and returns the byte array.
	 * @param {String} str the string to transform.
	 * @return {Array|Uint8Array} the string in a binary format.
	 */
	function string2binary(str) {
	    var result = null;
	    if (support.uint8array) {
	      result = new Uint8Array(str.length);
	    } else {
	      result = new Array(str.length);
	    }
	    return stringToArrayLike(str, result);
	}
	
	/**
	 * Create a new blob with the given content and the given type.
	 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
	 * an Uint8Array because the stock browser of android 4 won't accept it (it
	 * will be silently converted to a string, "[object Uint8Array]").
	 *
	 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
	 * when a large amount of Array is used to create the Blob, the amount of
	 * memory consumed is nearly 100 times the original data amount.
	 *
	 * @param {String} type the mime type of the blob.
	 * @return {Blob} the created blob.
	 */
	exports.newBlob = function(part, type) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([part], {
	            type: type
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(part);
	            return builder.getBlob(type);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * An helper for the function arrayLikeToString.
	 * This contains static information and functions that
	 * can be optimized by the browser JIT compiler.
	 */
	var arrayToStringHelper = {
	    /**
	     * Transform an array of int into a string, chunk by chunk.
	     * See the performances notes on arrayLikeToString.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @param {String} type the type of the array.
	     * @param {Integer} chunk the chunk size.
	     * @return {String} the resulting string.
	     * @throws Error if the chunk is too big for the stack.
	     */
	    stringifyByChunk: function(array, type, chunk) {
	        var result = [], k = 0, len = array.length;
	        // shortcut
	        if (len <= chunk) {
	            return String.fromCharCode.apply(null, array);
	        }
	        while (k < len) {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        return result.join("");
	    },
	    /**
	     * Call String.fromCharCode on every item in the array.
	     * This is the naive implementation, which generate A LOT of intermediate string.
	     * This should be used when everything else fail.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @return {String} the result.
	     */
	    stringifyByChar: function(array){
	        var resultStr = "";
	        for(var i = 0; i < array.length; i++) {
	            resultStr += String.fromCharCode(array[i]);
	        }
	        return resultStr;
	    },
	    applyCanBeUsed : {
	        /**
	         * true if the browser accepts to use String.fromCharCode on Uint8Array
	         */
	        uint8array : (function () {
	            try {
	                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })(),
	        /**
	         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
	         */
	        nodebuffer : (function () {
	            try {
	                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })()
	    }
	};
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    // TODO : we now have workers that split the work. Do we still need that ?
	    var chunk = 65536,
	        type = exports.getTypeOf(array),
	        canUseApply = true;
	    if (type === "uint8array") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
	    } else if (type === "nodebuffer") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
	    }
	
	    if (canUseApply) {
	        while (chunk > 1) {
	            try {
	                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
	            } catch (e) {
	                chunk = Math.floor(chunk / 2);
	            }
	        }
	    }
	
	    // no apply or chunk error : slow and painful algorithm
	    // default browser on android 4.*
	    return arrayToStringHelper.stringifyByChar(array);
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this platform");
	    }
	};
	
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Defer the call of a function.
	 * @param {Function} callback the function to call asynchronously.
	 * @param {Array} args the arguments to give to the callback.
	 */
	exports.delay = function(callback, args, self) {
	    setImmediate(function () {
	        callback.apply(self || null, args || []);
	    });
	};
	
	/**
	 * Extends a prototype with an other, without calling a constructor with
	 * side effects. Inspired by nodejs' `utils.inherits`
	 * @param {Function} ctor the constructor to augment
	 * @param {Function} superCtor the parent constructor to use
	 */
	exports.inherits = function (ctor, superCtor) {
	    var Obj = function() {};
	    Obj.prototype = superCtor.prototype;
	    ctor.prototype = new Obj();
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transform arbitrary content into a Promise.
	 * @param {String} name a name for the content being processed.
	 * @param {Object} inputData the content to process.
	 * @param {Boolean} isBinary true if the content is not an unicode string
	 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
	 * @param {Boolean} isBase64 true if the string content is encoded with base64.
	 * @return {Promise} a promise in a format usable by JSZip.
	 */
	exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
	
	    // if inputData is already a promise, this flatten it.
	    var promise = external.Promise.resolve(inputData).then(function(data) {
	        
	        
	        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);
	
	        if (isBlob && typeof FileReader !== "undefined") {
	            return new external.Promise(function (resolve, reject) {
	                var reader = new FileReader();
	
	                reader.onload = function(e) {
	                    resolve(e.target.result);
	                };
	                reader.onerror = function(e) {
	                    reject(e.target.error);
	                };
	                reader.readAsArrayBuffer(data);
	            });
	        } else {
	            return data;
	        }
	    });
	
	    return promise.then(function(data) {
	        var dataType = exports.getTypeOf(data);
	
	        if (!dataType) {
	            return external.Promise.reject(
	                new Error("Can't read the data of '" + name + "'. Is it " +
	                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
	            );
	        }
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = exports.transformTo("uint8array", data);
	        } else if (dataType === "string") {
	            if (isBase64) {
	                data = base64.decode(data);
	            }
	            else if (isBinary) {
	                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
	                if (isOptimizedBinaryString !== true) {
	                    // this is a string, not in a base64 format.
	                    // Be sure that this is a correct "binary string"
	                    data = string2binary(data);
	                }
	            }
	        }
	        return data;
	    });
	};


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	try {
	    exports.nodestream = !!__webpack_require__(933).Readable;
	} catch(e) {
	    exports.nodestream = false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(929).Buffer))

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(930)
	var ieee754 = __webpack_require__(931)
	var isArray = __webpack_require__(932)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 931 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 932 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * This file is used by module bundlers (browserify/webpack/etc) when
	 * including a stream implementation. We use "readable-stream" to get a
	 * consistent behavior between nodejs versions but bundlers often have a shim
	 * for "stream". Using this shim greatly improve the compatibility and greatly
	 * reduce the final size of the bundle (only one stream implementation, not
	 * two).
	 */
	module.exports = __webpack_require__(934);


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(935).EventEmitter;
	var inherits = __webpack_require__(936);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(937);
	Stream.Writable = __webpack_require__(953);
	Stream.Duplex = __webpack_require__(954);
	Stream.Transform = __webpack_require__(955);
	Stream.PassThrough = __webpack_require__(956);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 935 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 936 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(938);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(948);
	exports.Duplex = __webpack_require__(947);
	exports.Transform = __webpack_require__(951);
	exports.PassThrough = __webpack_require__(952);


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(939);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(932);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(935).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(940);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(941).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(942));
	util.inherits = __webpack_require__(936);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(943);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(944);
	var destroyImpl = __webpack_require__(946);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(947);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(950).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(947);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(950).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(935).EventEmitter;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(929)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(929).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),
/* 943 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(941).Buffer;
	var util = __webpack_require__(945);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(939);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(939);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(942));
	util.inherits = __webpack_require__(936);
	/*</replacement>*/
	
	var Readable = __webpack_require__(938);
	var Writable = __webpack_require__(948);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(939);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(942));
	util.inherits = __webpack_require__(936);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(949)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(940);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(941).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(946);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(947);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(947);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(69).setImmediate, (function() { return this; }())))

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(941).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(947);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(942));
	util.inherits = __webpack_require__(936);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(951);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(942));
	util.inherits = __webpack_require__(936);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(948);


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(947);


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(937).Transform


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(937).PassThrough


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(927);
	var support = __webpack_require__(928);
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input) {
	    var output = [];
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0, len = input.length, remainingBytes = len;
	
	    var isArray = utils.getTypeOf(input) !== "string";
	    while (i < input.length) {
	        remainingBytes = len - i;
	
	        if (!isArray) {
	            chr1 = input.charCodeAt(i++);
	            chr2 = i < len ? input.charCodeAt(i++) : 0;
	            chr3 = i < len ? input.charCodeAt(i++) : 0;
	        } else {
	            chr1 = input[i++];
	            chr2 = i < len ? input[i++] : 0;
	            chr3 = i < len ? input[i++] : 0;
	        }
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
	        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;
	
	        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));
	
	    }
	
	    return output.join("");
	};
	
	// public method for decoding
	exports.decode = function(input) {
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0, resultIndex = 0;
	
	    var dataUrlPrefix = "data:";
	
	    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
	        // This is a common error: people give a data url
	        // (data:image/png;base64,iVBOR...) with a {base64: true} and
	        // wonders why things don't work.
	        // We can detect that the string input looks like a data url but we
	        // *can't* be sure it is one: removing everything up to the comma would
	        // be too dangerous.
	        throw new Error("Invalid base64 input, it looks like a data url.");
	    }
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    var totalLength = input.length * 3 / 4;
	    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if (totalLength % 1 !== 0) {
	        // totalLength is not an integer, the length does not match a valid
	        // base64 content. That can happen if:
	        // - the input is not a base64 content
	        // - the input is *almost* a base64 content, with a extra chars at the
	        //   beginning or at the end
	        // - the input uses a base64 variant (base64url for example)
	        throw new Error("Invalid base64 input, bad content length.");
	    }
	    var output;
	    if (support.uint8array) {
	        output = new Uint8Array(totalLength|0);
	    } else {
	        output = new Array(totalLength|0);
	    }
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output[resultIndex++] = chr1;
	
	        if (enc3 !== 64) {
	            output[resultIndex++] = chr2;
	        }
	        if (enc4 !== 64) {
	            output[resultIndex++] = chr3;
	        }
	
	    }
	
	    return output;
	};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	module.exports = {
	    /**
	     * True if this is running in Nodejs, will be undefined in a browser.
	     * In a browser, browserify won't include this file and the whole module
	     * will be resolved an empty object.
	     */
	    isNode : typeof Buffer !== "undefined",
	    /**
	     * Create a new nodejs Buffer from an existing content.
	     * @param {Object} data the data to pass to the constructor.
	     * @param {String} encoding the encoding to use.
	     * @return {Buffer} a new Buffer.
	     */
	    newBufferFrom: function(data, encoding) {
	        if (Buffer.from && Buffer.from !== Uint8Array.from) {
	            return Buffer.from(data, encoding);
	        } else {
	            if (typeof data === "number") {
	                // Safeguard for old Node.js versions. On newer versions,
	                // Buffer.from(number) / Buffer(number, encoding) already throw.
	                throw new Error("The \"data\" argument must not be a number");
	            }
	            return new Buffer(data, encoding);
	        }
	    },
	    /**
	     * Create a new nodejs Buffer with the specified size.
	     * @param {Integer} size the size of the buffer.
	     * @return {Buffer} a new Buffer.
	     */
	    allocBuffer: function (size) {
	        if (Buffer.alloc) {
	            return Buffer.alloc(size);
	        } else {
	            var buf = new Buffer(size);
	            buf.fill(0);
	            return buf;
	        }
	    },
	    /**
	     * Find out if an object is a Buffer.
	     * @param {Object} b the object to test.
	     * @return {Boolean} true if the object is a Buffer, false otherwise.
	     */
	    isBuffer : function(b){
	        return Buffer.isBuffer(b);
	    },
	
	    isStream : function (obj) {
	        return obj &&
	            typeof obj.on === "function" &&
	            typeof obj.pause === "function" &&
	            typeof obj.resume === "function";
	    }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(929).Buffer))

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	module.exports = typeof setImmediate === 'function' ? setImmediate :
		function setImmediate() {
			var args = [].slice.apply(arguments);
			args.splice(1, 0, 0);
			setTimeout.apply(null, args);
		};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69).setImmediate))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	/* global Promise */
	'use strict';
	
	// load the global object first:
	// - it should be better integrated in the system (unhandledRejection in node)
	// - the environment may have a custom Promise implementation (see zone.js)
	var ES6Promise = null;
	if (typeof Promise !== "undefined") {
	    ES6Promise = Promise;
	} else {
	    ES6Promise = __webpack_require__(961);
	}
	
	/**
	 * Let the user use/change some implementations.
	 */
	module.exports = {
	    Promise: ES6Promise
	};


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var immediate = __webpack_require__(962);
	
	/* istanbul ignore next */
	function INTERNAL() {}
	
	var handlers = {};
	
	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];
	
	module.exports = Promise;
	
	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}
	
	Promise.prototype["finally"] = function (callback) {
	  if (typeof callback !== 'function') {
	    return this;
	  }
	  var p = this.constructor;
	  return this.then(resolve, reject);
	
	  function resolve(value) {
	    function yes () {
	      return value;
	    }
	    return p.resolve(callback()).then(yes);
	  }
	  function reject(reason) {
	    function no () {
	      throw reason;
	    }
	    return p.resolve(callback()).then(no);
	  }
	};
	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }
	
	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};
	
	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}
	
	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;
	
	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};
	
	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}
	
	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }
	
	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }
	
	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }
	
	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}
	
	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}
	
	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}
	
	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}
	
	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}
	
	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}


/***/ }),
/* 962 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	
	var scheduleDrain;
	
	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {
	
	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();
	
	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}
	
	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}
	
	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A worker that does nothing but passing chunks to the next one. This is like
	 * a nodejs stream but with some differences. On the good side :
	 * - it works on IE 6-9 without any issue / polyfill
	 * - it weights less than the full dependencies bundled with browserify
	 * - it forwards errors (no need to declare an error handler EVERYWHERE)
	 *
	 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
	 * object containing anything (`percent` for example), see each worker for more
	 * details. The latter is the real data (String, Uint8Array, etc).
	 *
	 * @constructor
	 * @param {String} name the name of the stream (mainly used for debugging purposes)
	 */
	function GenericWorker(name) {
	    // the name of the worker
	    this.name = name || "default";
	    // an object containing metadata about the workers chain
	    this.streamInfo = {};
	    // an error which happened when the worker was paused
	    this.generatedError = null;
	    // an object containing metadata to be merged by this worker into the general metadata
	    this.extraStreamInfo = {};
	    // true if the stream is paused (and should not do anything), false otherwise
	    this.isPaused = true;
	    // true if the stream is finished (and should not do anything), false otherwise
	    this.isFinished = false;
	    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
	    this.isLocked = false;
	    // the event listeners
	    this._listeners = {
	        'data':[],
	        'end':[],
	        'error':[]
	    };
	    // the previous worker, if any
	    this.previous = null;
	}
	
	GenericWorker.prototype = {
	    /**
	     * Push a chunk to the next workers.
	     * @param {Object} chunk the chunk to push
	     */
	    push : function (chunk) {
	        this.emit("data", chunk);
	    },
	    /**
	     * End the stream.
	     * @return {Boolean} true if this call ended the worker, false otherwise.
	     */
	    end : function () {
	        if (this.isFinished) {
	            return false;
	        }
	
	        this.flush();
	        try {
	            this.emit("end");
	            this.cleanUp();
	            this.isFinished = true;
	        } catch (e) {
	            this.emit("error", e);
	        }
	        return true;
	    },
	    /**
	     * End the stream with an error.
	     * @param {Error} e the error which caused the premature end.
	     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
	     */
	    error : function (e) {
	        if (this.isFinished) {
	            return false;
	        }
	
	        if(this.isPaused) {
	            this.generatedError = e;
	        } else {
	            this.isFinished = true;
	
	            this.emit("error", e);
	
	            // in the workers chain exploded in the middle of the chain,
	            // the error event will go downward but we also need to notify
	            // workers upward that there has been an error.
	            if(this.previous) {
	                this.previous.error(e);
	            }
	
	            this.cleanUp();
	        }
	        return true;
	    },
	    /**
	     * Add a callback on an event.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Function} listener the function to call when the event is triggered
	     * @return {GenericWorker} the current object for chainability
	     */
	    on : function (name, listener) {
	        this._listeners[name].push(listener);
	        return this;
	    },
	    /**
	     * Clean any references when a worker is ending.
	     */
	    cleanUp : function () {
	        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
	        this._listeners = [];
	    },
	    /**
	     * Trigger an event. This will call registered callback with the provided arg.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Object} arg the argument to call the callback with.
	     */
	    emit : function (name, arg) {
	        if (this._listeners[name]) {
	            for(var i = 0; i < this._listeners[name].length; i++) {
	                this._listeners[name][i].call(this, arg);
	            }
	        }
	    },
	    /**
	     * Chain a worker with an other.
	     * @param {Worker} next the worker receiving events from the current one.
	     * @return {worker} the next worker for chainability
	     */
	    pipe : function (next) {
	        return next.registerPrevious(this);
	    },
	    /**
	     * Same as `pipe` in the other direction.
	     * Using an API with `pipe(next)` is very easy.
	     * Implementing the API with the point of view of the next one registering
	     * a source is easier, see the ZipFileWorker.
	     * @param {Worker} previous the previous worker, sending events to this one
	     * @return {Worker} the current worker for chainability
	     */
	    registerPrevious : function (previous) {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	
	        // sharing the streamInfo...
	        this.streamInfo = previous.streamInfo;
	        // ... and adding our own bits
	        this.mergeStreamInfo();
	        this.previous =  previous;
	        var self = this;
	        previous.on('data', function (chunk) {
	            self.processChunk(chunk);
	        });
	        previous.on('end', function () {
	            self.end();
	        });
	        previous.on('error', function (e) {
	            self.error(e);
	        });
	        return this;
	    },
	    /**
	     * Pause the stream so it doesn't send events anymore.
	     * @return {Boolean} true if this call paused the worker, false otherwise.
	     */
	    pause : function () {
	        if(this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = true;
	
	        if(this.previous) {
	            this.previous.pause();
	        }
	        return true;
	    },
	    /**
	     * Resume a paused stream.
	     * @return {Boolean} true if this call resumed the worker, false otherwise.
	     */
	    resume : function () {
	        if(!this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = false;
	
	        // if true, the worker tried to resume but failed
	        var withError = false;
	        if(this.generatedError) {
	            this.error(this.generatedError);
	            withError = true;
	        }
	        if(this.previous) {
	            this.previous.resume();
	        }
	
	        return !withError;
	    },
	    /**
	     * Flush any remaining bytes as the stream is ending.
	     */
	    flush : function () {},
	    /**
	     * Process a chunk. This is usually the method overridden.
	     * @param {Object} chunk the chunk to process.
	     */
	    processChunk : function(chunk) {
	        this.push(chunk);
	    },
	    /**
	     * Add a key/value to be added in the workers chain streamInfo once activated.
	     * @param {String} key the key to use
	     * @param {Object} value the associated value
	     * @return {Worker} the current worker for chainability
	     */
	    withStreamInfo : function (key, value) {
	        this.extraStreamInfo[key] = value;
	        this.mergeStreamInfo();
	        return this;
	    },
	    /**
	     * Merge this worker's streamInfo into the chain's streamInfo.
	     */
	    mergeStreamInfo : function () {
	        for(var key in this.extraStreamInfo) {
	            if (!this.extraStreamInfo.hasOwnProperty(key)) {
	                continue;
	            }
	            this.streamInfo[key] = this.extraStreamInfo[key];
	        }
	    },
	
	    /**
	     * Lock the stream to prevent further updates on the workers chain.
	     * After calling this method, all calls to pipe will fail.
	     */
	    lock: function () {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	        this.isLocked = true;
	        if (this.previous) {
	            this.previous.lock();
	        }
	    },
	
	    /**
	     *
	     * Pretty print the workers chain.
	     */
	    toString : function () {
	        var me = "Worker " + this.name;
	        if (this.previous) {
	            return this.previous + " -> " + me;
	        } else {
	            return me;
	        }
	    }
	};
	
	module.exports = GenericWorker;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var utils = __webpack_require__(927);
	var ConvertWorker = __webpack_require__(965);
	var GenericWorker = __webpack_require__(963);
	var base64 = __webpack_require__(957);
	var support = __webpack_require__(928);
	var external = __webpack_require__(960);
	
	var NodejsStreamOutputAdapter = null;
	if (support.nodestream) {
	    try {
	        NodejsStreamOutputAdapter = __webpack_require__(966);
	    } catch(e) {}
	}
	
	/**
	 * Apply the final transformation of the data. If the user wants a Blob for
	 * example, it's easier to work with an U8intArray and finally do the
	 * ArrayBuffer/Blob conversion.
	 * @param {String} type the name of the final type
	 * @param {String|Uint8Array|Buffer} content the content to transform
	 * @param {String} mimeType the mime type of the content, if applicable.
	 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
	 */
	function transformZipOutput(type, content, mimeType) {
	    switch(type) {
	        case "blob" :
	            return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
	        case "base64" :
	            return base64.encode(content);
	        default :
	            return utils.transformTo(type, content);
	    }
	}
	
	/**
	 * Concatenate an array of data of the given type.
	 * @param {String} type the type of the data in the given array.
	 * @param {Array} dataArray the array containing the data chunks to concatenate
	 * @return {String|Uint8Array|Buffer} the concatenated data
	 * @throws Error if the asked type is unsupported
	 */
	function concat (type, dataArray) {
	    var i, index = 0, res = null, totalLength = 0;
	    for(i = 0; i < dataArray.length; i++) {
	        totalLength += dataArray[i].length;
	    }
	    switch(type) {
	        case "string":
	            return dataArray.join("");
	          case "array":
	            return Array.prototype.concat.apply([], dataArray);
	        case "uint8array":
	            res = new Uint8Array(totalLength);
	            for(i = 0; i < dataArray.length; i++) {
	                res.set(dataArray[i], index);
	                index += dataArray[i].length;
	            }
	            return res;
	        case "nodebuffer":
	            return Buffer.concat(dataArray);
	        default:
	            throw new Error("concat : unsupported type '"  + type + "'");
	    }
	}
	
	/**
	 * Listen a StreamHelper, accumulate its content and concatenate it into a
	 * complete block.
	 * @param {StreamHelper} helper the helper to use.
	 * @param {Function} updateCallback a callback called on each update. Called
	 * with one arg :
	 * - the metadata linked to the update received.
	 * @return Promise the promise for the accumulation.
	 */
	function accumulate(helper, updateCallback) {
	    return new external.Promise(function (resolve, reject){
	        var dataArray = [];
	        var chunkType = helper._internalType,
	            resultType = helper._outputType,
	            mimeType = helper._mimeType;
	        helper
	        .on('data', function (data, meta) {
	            dataArray.push(data);
	            if(updateCallback) {
	                updateCallback(meta);
	            }
	        })
	        .on('error', function(err) {
	            dataArray = [];
	            reject(err);
	        })
	        .on('end', function (){
	            try {
	                var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
	                resolve(result);
	            } catch (e) {
	                reject(e);
	            }
	            dataArray = [];
	        })
	        .resume();
	    });
	}
	
	/**
	 * An helper to easily use workers outside of JSZip.
	 * @constructor
	 * @param {Worker} worker the worker to wrap
	 * @param {String} outputType the type of data expected by the use
	 * @param {String} mimeType the mime type of the content, if applicable.
	 */
	function StreamHelper(worker, outputType, mimeType) {
	    var internalType = outputType;
	    switch(outputType) {
	        case "blob":
	        case "arraybuffer":
	            internalType = "uint8array";
	        break;
	        case "base64":
	            internalType = "string";
	        break;
	    }
	
	    try {
	        // the type used internally
	        this._internalType = internalType;
	        // the type used to output results
	        this._outputType = outputType;
	        // the mime type
	        this._mimeType = mimeType;
	        utils.checkSupport(internalType);
	        this._worker = worker.pipe(new ConvertWorker(internalType));
	        // the last workers can be rewired without issues but we need to
	        // prevent any updates on previous workers.
	        worker.lock();
	    } catch(e) {
	        this._worker = new GenericWorker("error");
	        this._worker.error(e);
	    }
	}
	
	StreamHelper.prototype = {
	    /**
	     * Listen a StreamHelper, accumulate its content and concatenate it into a
	     * complete block.
	     * @param {Function} updateCb the update callback.
	     * @return Promise the promise for the accumulation.
	     */
	    accumulate : function (updateCb) {
	        return accumulate(this, updateCb);
	    },
	    /**
	     * Add a listener on an event triggered on a stream.
	     * @param {String} evt the name of the event
	     * @param {Function} fn the listener
	     * @return {StreamHelper} the current helper.
	     */
	    on : function (evt, fn) {
	        var self = this;
	
	        if(evt === "data") {
	            this._worker.on(evt, function (chunk) {
	                fn.call(self, chunk.data, chunk.meta);
	            });
	        } else {
	            this._worker.on(evt, function () {
	                utils.delay(fn, arguments, self);
	            });
	        }
	        return this;
	    },
	    /**
	     * Resume the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    resume : function () {
	        utils.delay(this._worker.resume, [], this._worker);
	        return this;
	    },
	    /**
	     * Pause the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    pause : function () {
	        this._worker.pause();
	        return this;
	    },
	    /**
	     * Return a nodejs stream for this helper.
	     * @param {Function} updateCb the update callback.
	     * @return {NodejsStreamOutputAdapter} the nodejs stream.
	     */
	    toNodejsStream : function (updateCb) {
	        utils.checkSupport("nodestream");
	        if (this._outputType !== "nodebuffer") {
	            // an object stream containing blob/arraybuffer/uint8array/string
	            // is strange and I don't know if it would be useful.
	            // I you find this comment and have a good usecase, please open a
	            // bug report !
	            throw new Error(this._outputType + " is not supported by this method");
	        }
	
	        return new NodejsStreamOutputAdapter(this, {
	            objectMode : this._outputType !== "nodebuffer"
	        }, updateCb);
	    }
	};
	
	
	module.exports = StreamHelper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(929).Buffer))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GenericWorker = __webpack_require__(963);
	var utils = __webpack_require__(927);
	
	/**
	 * A worker which convert chunks to a specified type.
	 * @constructor
	 * @param {String} destType the destination type.
	 */
	function ConvertWorker(destType) {
	    GenericWorker.call(this, "ConvertWorker to " + destType);
	    this.destType = destType;
	}
	utils.inherits(ConvertWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	ConvertWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : utils.transformTo(this.destType, chunk.data),
	        meta : chunk.meta
	    });
	};
	module.exports = ConvertWorker;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Readable = __webpack_require__(933).Readable;
	
	var utils = __webpack_require__(927);
	utils.inherits(NodejsStreamOutputAdapter, Readable);
	
	/**
	* A nodejs stream using a worker as source.
	* @see the SourceWrapper in http://nodejs.org/api/stream.html
	* @constructor
	* @param {StreamHelper} helper the helper wrapping the worker
	* @param {Object} options the nodejs stream options
	* @param {Function} updateCb the update callback.
	*/
	function NodejsStreamOutputAdapter(helper, options, updateCb) {
	    Readable.call(this, options);
	    this._helper = helper;
	
	    var self = this;
	    helper.on("data", function (data, meta) {
	        if (!self.push(data)) {
	            self._helper.pause();
	        }
	        if(updateCb) {
	            updateCb(meta);
	        }
	    })
	    .on("error", function(e) {
	        self.emit('error', e);
	    })
	    .on("end", function () {
	        self.push(null);
	    });
	}
	
	
	NodejsStreamOutputAdapter.prototype._read = function() {
	    this._helper.resume();
	};
	
	module.exports = NodejsStreamOutputAdapter;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = true;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var external = __webpack_require__(960);
	var DataWorker = __webpack_require__(969);
	var Crc32Probe = __webpack_require__(970);
	var DataLengthProbe = __webpack_require__(972);
	
	/**
	 * Represent a compressed object, with everything needed to decompress it.
	 * @constructor
	 * @param {number} compressedSize the size of the data compressed.
	 * @param {number} uncompressedSize the size of the data after decompression.
	 * @param {number} crc32 the crc32 of the decompressed file.
	 * @param {object} compression the type of compression, see lib/compressions.js.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
	 */
	function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
	    this.compressedSize = compressedSize;
	    this.uncompressedSize = uncompressedSize;
	    this.crc32 = crc32;
	    this.compression = compression;
	    this.compressedContent = data;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Create a worker to get the uncompressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getContentWorker: function () {
	        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
	            .pipe(this.compression.uncompressWorker())
	            .pipe(new DataLengthProbe("data_length"));
	
	        var that = this;
	        worker.on("end", function () {
	            if (this.streamInfo['data_length'] !== that.uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	        });
	        return worker;
	    },
	    /**
	     * Create a worker to get the compressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getCompressedWorker: function () {
	        return new DataWorker(external.Promise.resolve(this.compressedContent))
	            .withStreamInfo("compressedSize", this.compressedSize)
	            .withStreamInfo("uncompressedSize", this.uncompressedSize)
	            .withStreamInfo("crc32", this.crc32)
	            .withStreamInfo("compression", this.compression)
	            ;
	    }
	};
	
	/**
	 * Chain the given worker with other workers to compress the content with the
	 * given compression.
	 * @param {GenericWorker} uncompressedWorker the worker to pipe.
	 * @param {Object} compression the compression object.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {GenericWorker} the new worker compressing the content.
	 */
	CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
	    return uncompressedWorker
	        .pipe(new Crc32Probe())
	        .pipe(new DataLengthProbe("uncompressedSize"))
	        .pipe(compression.compressWorker(compressionOptions))
	        .pipe(new DataLengthProbe("compressedSize"))
	        .withStreamInfo("compression", compression);
	};
	
	module.exports = CompressedObject;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(927);
	var GenericWorker = __webpack_require__(963);
	
	// the size of the generated chunks
	// TODO expose this as a public variable
	var DEFAULT_BLOCK_SIZE = 16 * 1024;
	
	/**
	 * A worker that reads a content and emits chunks.
	 * @constructor
	 * @param {Promise} dataP the promise of the data to split
	 */
	function DataWorker(dataP) {
	    GenericWorker.call(this, "DataWorker");
	    var self = this;
	    this.dataIsReady = false;
	    this.index = 0;
	    this.max = 0;
	    this.data = null;
	    this.type = "";
	
	    this._tickScheduled = false;
	
	    dataP.then(function (data) {
	        self.dataIsReady = true;
	        self.data = data;
	        self.max = data && data.length || 0;
	        self.type = utils.getTypeOf(data);
	        if(!self.isPaused) {
	            self._tickAndRepeat();
	        }
	    }, function (e) {
	        self.error(e);
	    });
	}
	
	utils.inherits(DataWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.cleanUp
	 */
	DataWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this.data = null;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	DataWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this._tickScheduled && this.dataIsReady) {
	        this._tickScheduled = true;
	        utils.delay(this._tickAndRepeat, [], this);
	    }
	    return true;
	};
	
	/**
	 * Trigger a tick a schedule an other call to this function.
	 */
	DataWorker.prototype._tickAndRepeat = function() {
	    this._tickScheduled = false;
	    if(this.isPaused || this.isFinished) {
	        return;
	    }
	    this._tick();
	    if(!this.isFinished) {
	        utils.delay(this._tickAndRepeat, [], this);
	        this._tickScheduled = true;
	    }
	};
	
	/**
	 * Read and push a chunk.
	 */
	DataWorker.prototype._tick = function() {
	
	    if(this.isPaused || this.isFinished) {
	        return false;
	    }
	
	    var size = DEFAULT_BLOCK_SIZE;
	    var data = null, nextIndex = Math.min(this.max, this.index + size);
	    if (this.index >= this.max) {
	        // EOF
	        return this.end();
	    } else {
	        switch(this.type) {
	            case "string":
	                data = this.data.substring(this.index, nextIndex);
	            break;
	            case "uint8array":
	                data = this.data.subarray(this.index, nextIndex);
	            break;
	            case "array":
	            case "nodebuffer":
	                data = this.data.slice(this.index, nextIndex);
	            break;
	        }
	        this.index = nextIndex;
	        return this.push({
	            data : data,
	            meta : {
	                percent : this.max ? this.index / this.max * 100 : 0
	            }
	        });
	    }
	};
	
	module.exports = DataWorker;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GenericWorker = __webpack_require__(963);
	var crc32 = __webpack_require__(971);
	var utils = __webpack_require__(927);
	
	/**
	 * A worker which calculate the crc32 of the data flowing through.
	 * @constructor
	 */
	function Crc32Probe() {
	    GenericWorker.call(this, "Crc32Probe");
	    this.withStreamInfo("crc32", 0);
	}
	utils.inherits(Crc32Probe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Crc32Probe.prototype.processChunk = function (chunk) {
	    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
	    this.push(chunk);
	};
	module.exports = Crc32Probe;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(927);
	
	/**
	 * The following functions come from pako, from pako/lib/zlib/crc32.js
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	    var c, table = [];
	
	    for(var n =0; n < 256; n++){
	        c = n;
	        for(var k =0; k < 8; k++){
	            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	        }
	        table[n] = c;
	    }
	
	    return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	// That's all for the pako functions.
	
	/**
	 * Compute the crc32 of a string.
	 * This is almost the same as the function crc32, but for strings. Using the
	 * same function for the two use cases leads to horrible performances.
	 * @param {Number} crc the starting value of the crc.
	 * @param {String} str the string to use.
	 * @param {Number} len the length of the string.
	 * @param {Number} pos the starting position for the crc32 computation.
	 * @return {Number} the computed crc32.
	 */
	function crc32str(crc, str, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	module.exports = function crc32wrapper(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if(isArray) {
	        return crc32(crc|0, input, input.length, 0);
	    } else {
	        return crc32str(crc|0, input, input.length, 0);
	    }
	};


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(927);
	var GenericWorker = __webpack_require__(963);
	
	/**
	 * A worker which calculate the total length of the data flowing through.
	 * @constructor
	 * @param {String} propName the name used to expose the length
	 */
	function DataLengthProbe(propName) {
	    GenericWorker.call(this, "DataLengthProbe for " + propName);
	    this.propName = propName;
	    this.withStreamInfo(propName, 0);
	}
	utils.inherits(DataLengthProbe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	DataLengthProbe.prototype.processChunk = function (chunk) {
	    if(chunk) {
	        var length = this.streamInfo[this.propName] || 0;
	        this.streamInfo[this.propName] = length + chunk.data.length;
	    }
	    GenericWorker.prototype.processChunk.call(this, chunk);
	};
	module.exports = DataLengthProbe;
	


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var StreamHelper = __webpack_require__(964);
	var DataWorker = __webpack_require__(969);
	var utf8 = __webpack_require__(926);
	var CompressedObject = __webpack_require__(968);
	var GenericWorker = __webpack_require__(963);
	
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this._dataBinary = options.binary;
	    // keep only the compression
	    this.options = {
	        compression : options.compression,
	        compressionOptions : options.compressionOptions
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Create an internal stream for the content of this object.
	     * @param {String} type the type of each chunk.
	     * @return StreamHelper the stream.
	     */
	    internalStream: function (type) {
	        var result = null, outputType = "string";
	        try {
	            if (!type) {
	                throw new Error("No output type specified.");
	            }
	            outputType = type.toLowerCase();
	            var askUnicodeString = outputType === "string" || outputType === "text";
	            if (outputType === "binarystring" || outputType === "text") {
	                outputType = "string";
	            }
	            result = this._decompressWorker();
	
	            var isUnicodeString = !this._dataBinary;
	
	            if (isUnicodeString && !askUnicodeString) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            if (!isUnicodeString && askUnicodeString) {
	                result = result.pipe(new utf8.Utf8DecodeWorker());
	            }
	        } catch (e) {
	            result = new GenericWorker("error");
	            result.error(e);
	        }
	
	        return new StreamHelper(result, outputType, "");
	    },
	
	    /**
	     * Prepare the content in the asked type.
	     * @param {String} type the type of the result.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Promise the promise of the result.
	     */
	    async: function (type, onUpdate) {
	        return this.internalStream(type).accumulate(onUpdate);
	    },
	
	    /**
	     * Prepare the content as a nodejs stream.
	     * @param {String} type the type of each chunk.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Stream the stream.
	     */
	    nodeStream: function (type, onUpdate) {
	        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
	    },
	
	    /**
	     * Return a worker for the compressed content.
	     * @private
	     * @param {Object} compression the compression object to use.
	     * @param {Object} compressionOptions the options to use when compressing.
	     * @return Worker the worker.
	     */
	    _compressWorker: function (compression, compressionOptions) {
	        if (
	            this._data instanceof CompressedObject &&
	            this._data.compression.magic === compression.magic
	        ) {
	            return this._data.getCompressedWorker();
	        } else {
	            var result = this._decompressWorker();
	            if(!this._dataBinary) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
	        }
	    },
	    /**
	     * Return a worker for the decompressed content.
	     * @private
	     * @return Worker the worker.
	     */
	    _decompressWorker : function () {
	        if (this._data instanceof CompressedObject) {
	            return this._data.getContentWorker();
	        } else if (this._data instanceof GenericWorker) {
	            return this._data;
	        } else {
	            return new DataWorker(this._data);
	        }
	    }
	};
	
	var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
	var removedFn = function () {
	    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	};
	
	for(var i = 0; i < removedMethods.length; i++) {
	    ZipObject.prototype[removedMethods[i]] = removedFn;
	}
	module.exports = ZipObject;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var compressions = __webpack_require__(975);
	var ZipFileWorker = __webpack_require__(993);
	
	/**
	 * Find the compression to use.
	 * @param {String} fileCompression the compression defined at the file level, if any.
	 * @param {String} zipCompression the compression defined at the load() level.
	 * @return {Object} the compression object to use.
	 */
	var getCompression = function (fileCompression, zipCompression) {
	
	    var compressionName = fileCompression || zipCompression;
	    var compression = compressions[compressionName];
	    if (!compression) {
	        throw new Error(compressionName + " is not a valid compression method !");
	    }
	    return compression;
	};
	
	/**
	 * Create a worker to generate a zip file.
	 * @param {JSZip} zip the JSZip instance at the right root level.
	 * @param {Object} options to generate the zip file.
	 * @param {String} comment the comment to use.
	 */
	exports.generateWorker = function (zip, options, comment) {
	
	    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
	    var entriesCount = 0;
	    try {
	
	        zip.forEach(function (relativePath, file) {
	            entriesCount++;
	            var compression = getCompression(file.options.compression, options.compression);
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	            var dir = file.dir, date = file.date;
	
	            file._compressWorker(compression, compressionOptions)
	            .withStreamInfo("file", {
	                name : relativePath,
	                dir : dir,
	                date : date,
	                comment : file.comment || "",
	                unixPermissions : file.unixPermissions,
	                dosPermissions : file.dosPermissions
	            })
	            .pipe(zipFileWorker);
	        });
	        zipFileWorker.entriesCount = entriesCount;
	    } catch (e) {
	        zipFileWorker.error(e);
	    }
	
	    return zipFileWorker;
	};


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GenericWorker = __webpack_require__(963);
	
	exports.STORE = {
	    magic: "\x00\x00",
	    compressWorker : function (compressionOptions) {
	        return new GenericWorker("STORE compression");
	    },
	    uncompressWorker : function () {
	        return new GenericWorker("STORE decompression");
	    }
	};
	exports.DEFLATE = __webpack_require__(976);


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = __webpack_require__(977);
	var utils = __webpack_require__(927);
	var GenericWorker = __webpack_require__(963);
	
	var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	
	/**
	 * Create a worker that uses pako to inflate/deflate.
	 * @constructor
	 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
	 * @param {Object} options the options to use when (de)compressing.
	 */
	function FlateWorker(action, options) {
	    GenericWorker.call(this, "FlateWorker/" + action);
	
	    this._pako = null;
	    this._pakoAction = action;
	    this._pakoOptions = options;
	    // the `meta` object from the last chunk received
	    // this allow this worker to pass around metadata
	    this.meta = {};
	}
	
	utils.inherits(FlateWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	FlateWorker.prototype.processChunk = function (chunk) {
	    this.meta = chunk.meta;
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	FlateWorker.prototype.flush = function () {
	    GenericWorker.prototype.flush.call(this);
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push([], true);
	};
	/**
	 * @see GenericWorker.cleanUp
	 */
	FlateWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this._pako = null;
	};
	
	/**
	 * Create the _pako object.
	 * TODO: lazy-loading this object isn't the best solution but it's the
	 * quickest. The best solution is to lazy-load the worker list. See also the
	 * issue #446.
	 */
	FlateWorker.prototype._createPako = function () {
	    this._pako = new pako[this._pakoAction]({
	        raw: true,
	        level: this._pakoOptions.level || -1 // default compression
	    });
	    var self = this;
	    this._pako.onData = function(data) {
	        self.push({
	            data : data,
	            meta : self.meta
	        });
	    };
	};
	
	exports.compressWorker = function (compressionOptions) {
	    return new FlateWorker("Deflate", compressionOptions);
	};
	exports.uncompressWorker = function () {
	    return new FlateWorker("Inflate", {});
	};


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(978).assign;
	
	var deflate   = __webpack_require__(979);
	var inflate   = __webpack_require__(987);
	var constants = __webpack_require__(991);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(980);
	var utils        = __webpack_require__(978);
	var strings      = __webpack_require__(985);
	var msg          = __webpack_require__(984);
	var ZStream      = __webpack_require__(986);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(978);
	var trees   = __webpack_require__(981);
	var adler32 = __webpack_require__(982);
	var crc32   = __webpack_require__(983);
	var msg     = __webpack_require__(984);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	        );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	/* eslint-disable space-unary-ops */
	
	var utils = __webpack_require__(978);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 983 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 984 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(978);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ }),
/* 986 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(988);
	var utils        = __webpack_require__(978);
	var strings      = __webpack_require__(985);
	var c            = __webpack_require__(991);
	var msg          = __webpack_require__(984);
	var ZStream      = __webpack_require__(986);
	var GZheader     = __webpack_require__(992);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	
	  // Setup dictionary
	  if (opt.dictionary) {
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      opt.dictionary = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      opt.dictionary = new Uint8Array(opt.dictionary);
	    }
	    if (opt.raw) { //In raw mode we need to set the dictionary early
	      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
	      if (status !== c.Z_OK) {
	        throw new Error(msg[status]);
	      }
	    }
	  }
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(978);
	var adler32       = __webpack_require__(982);
	var crc32         = __webpack_require__(983);
	var inflate_fast  = __webpack_require__(989);
	var inflate_table = __webpack_require__(990);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 989 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(978);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 991 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 992 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(927);
	var GenericWorker = __webpack_require__(963);
	var utf8 = __webpack_require__(926);
	var crc32 = __webpack_require__(971);
	var signature = __webpack_require__(994);
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "", i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions, isDir) {
	
	    // the dir flag is already set for compatibility
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {Object} streamInfo the hash with information about the compressed file.
	 * @param {Boolean} streamedContent is the content streamed ?
	 * @param {Boolean} streamingEnded is the stream finished ?
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {Object} the zip parts.
	 */
	var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
	    var file = streamInfo['file'],
	    compression = streamInfo['compression'],
	    useCustomEncoding = encodeFileName !== utf8.utf8encode,
	    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	    comment = file.comment,
	    encodedComment = utils.transformTo("string", encodeFileName(comment)),
	    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	    useUTF8ForComment = utfEncodedComment.length !== comment.length,
	    dosTime,
	    dosDate,
	    extraFields = "",
	    unicodePathExtraField = "",
	    unicodeCommentExtraField = "",
	    dir = file.dir,
	    date = file.date;
	
	
	    var dataInfo = {
	        crc32 : 0,
	        compressedSize : 0,
	        uncompressedSize : 0
	    };
	
	    // if the content is streamed, the sizes/crc32 are only available AFTER
	    // the end of the stream.
	    if (!streamedContent || streamingEnded) {
	        dataInfo.crc32 = streamInfo['crc32'];
	        dataInfo.compressedSize = streamInfo['compressedSize'];
	        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
	    }
	
	    var bitflag = 0;
	    if (streamedContent) {
	        // Bit 3: the sizes/crc32 are set to zero in the local header.
	        // The correct values are put in the data descriptor immediately
	        // following the compressed data.
	        bitflag |= 0x0008;
	    }
	    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
	        // Bit 11: Language encoding flag (EFS).
	        bitflag |= 0x0800;
	    }
	
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getUTCHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getUTCMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getUTCSeconds() / 2;
	
	    dosDate = date.getUTCFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getUTCMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getUTCDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    header += decToHex(bitflag, 2);
	    // compression method
	    header += compression.magic;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(dataInfo.crc32, 4);
	    // compressed size
	    header += decToHex(dataInfo.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(dataInfo.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	        // version made by (00: DOS)
	        decToHex(versionMadeBy, 2) +
	        // file header (common to file and central directory)
	        header +
	        // file comment length
	        decToHex(encodedComment.length, 2) +
	        // disk number start
	        "\x00\x00" +
	        // internal file attributes TODO
	        "\x00\x00" +
	        // external file attributes
	        decToHex(extFileAttr, 4) +
	        // relative offset of local header
	        decToHex(offset, 4) +
	        // file name
	        encodedFileName +
	        // extra field
	        extraFields +
	        // file comment
	        encodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord
	    };
	};
	
	/**
	 * Generate the EOCD record.
	 * @param {Number} entriesCount the number of entries in the zip file.
	 * @param {Number} centralDirLength the length (in bytes) of the central dir.
	 * @param {Number} localDirLength the length (in bytes) of the local dir.
	 * @param {String} comment the zip file comment as a binary string.
	 * @param {Function} encodeFileName the function to encode the comment.
	 * @return {String} the EOCD record.
	 */
	var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
	    var dirEnd = "";
	    var encodedComment = utils.transformTo("string", encodeFileName(comment));
	
	    // end of central dir signature
	    dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(entriesCount, 2) +
	        // total number of entries in the central directory
	        decToHex(entriesCount, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;
	
	    return dirEnd;
	};
	
	/**
	 * Generate data descriptors for a file entry.
	 * @param {Object} streamInfo the hash generated by a worker, containing information
	 * on the file entry.
	 * @return {String} the data descriptors.
	 */
	var generateDataDescriptors = function (streamInfo) {
	    var descriptor = "";
	    descriptor = signature.DATA_DESCRIPTOR +
	        // crc-32                          4 bytes
	        decToHex(streamInfo['crc32'], 4) +
	        // compressed size                 4 bytes
	        decToHex(streamInfo['compressedSize'], 4) +
	        // uncompressed size               4 bytes
	        decToHex(streamInfo['uncompressedSize'], 4);
	
	    return descriptor;
	};
	
	
	/**
	 * A worker to concatenate other workers to create a zip file.
	 * @param {Boolean} streamFiles `true` to stream the content of the files,
	 * `false` to accumulate it.
	 * @param {String} comment the comment to use.
	 * @param {String} platform the platform to use, "UNIX" or "DOS".
	 * @param {Function} encodeFileName the function to encode file names and comments.
	 */
	function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
	    GenericWorker.call(this, "ZipFileWorker");
	    // The number of bytes written so far. This doesn't count accumulated chunks.
	    this.bytesWritten = 0;
	    // The comment of the zip file
	    this.zipComment = comment;
	    // The platform "generating" the zip file.
	    this.zipPlatform = platform;
	    // the function to encode file names and comments.
	    this.encodeFileName = encodeFileName;
	    // Should we stream the content of the files ?
	    this.streamFiles = streamFiles;
	    // If `streamFiles` is false, we will need to accumulate the content of the
	    // files to calculate sizes / crc32 (and write them *before* the content).
	    // This boolean indicates if we are accumulating chunks (it will change a lot
	    // during the lifetime of this worker).
	    this.accumulate = false;
	    // The buffer receiving chunks when accumulating content.
	    this.contentBuffer = [];
	    // The list of generated directory records.
	    this.dirRecords = [];
	    // The offset (in bytes) from the beginning of the zip file for the current source.
	    this.currentSourceOffset = 0;
	    // The total number of entries in this zip file.
	    this.entriesCount = 0;
	    // the name of the file currently being added, null when handling the end of the zip file.
	    // Used for the emitted metadata.
	    this.currentFile = null;
	
	
	
	    this._sources = [];
	}
	utils.inherits(ZipFileWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.push
	 */
	ZipFileWorker.prototype.push = function (chunk) {
	
	    var currentFilePercent = chunk.meta.percent || 0;
	    var entriesCount = this.entriesCount;
	    var remainingFiles = this._sources.length;
	
	    if(this.accumulate) {
	        this.contentBuffer.push(chunk);
	    } else {
	        this.bytesWritten += chunk.data.length;
	
	        GenericWorker.prototype.push.call(this, {
	            data : chunk.data,
	            meta : {
	                currentFile : this.currentFile,
	                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
	            }
	        });
	    }
	};
	
	/**
	 * The worker started a new source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the new source.
	 */
	ZipFileWorker.prototype.openedSource = function (streamInfo) {
	    this.currentSourceOffset = this.bytesWritten;
	    this.currentFile = streamInfo['file'].name;
	
	    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
	
	    // don't stream folders (because they don't have any content)
	    if(streamedContent) {
	        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	    } else {
	        // we need to wait for the whole file before pushing anything
	        this.accumulate = true;
	    }
	};
	
	/**
	 * The worker finished a source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the finished source.
	 */
	ZipFileWorker.prototype.closedSource = function (streamInfo) {
	    this.accumulate = false;
	    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
	    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	
	    this.dirRecords.push(record.dirRecord);
	    if(streamedContent) {
	        // after the streamed file, we put data descriptors
	        this.push({
	            data : generateDataDescriptors(streamInfo),
	            meta : {percent:100}
	        });
	    } else {
	        // the content wasn't streamed, we need to push everything now
	        // first the file record, then the content
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	        while(this.contentBuffer.length) {
	            this.push(this.contentBuffer.shift());
	        }
	    }
	    this.currentFile = null;
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	ZipFileWorker.prototype.flush = function () {
	
	    var localDirLength = this.bytesWritten;
	    for(var i = 0; i < this.dirRecords.length; i++) {
	        this.push({
	            data : this.dirRecords[i],
	            meta : {percent:100}
	        });
	    }
	    var centralDirLength = this.bytesWritten - localDirLength;
	
	    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
	
	    this.push({
	        data : dirEnd,
	        meta : {percent:100}
	    });
	};
	
	/**
	 * Prepare the next source to be read.
	 */
	ZipFileWorker.prototype.prepareNextSource = function () {
	    this.previous = this._sources.shift();
	    this.openedSource(this.previous.streamInfo);
	    if (this.isPaused) {
	        this.previous.pause();
	    } else {
	        this.previous.resume();
	    }
	};
	
	/**
	 * @see GenericWorker.registerPrevious
	 */
	ZipFileWorker.prototype.registerPrevious = function (previous) {
	    this._sources.push(previous);
	    var self = this;
	
	    previous.on('data', function (chunk) {
	        self.processChunk(chunk);
	    });
	    previous.on('end', function () {
	        self.closedSource(self.previous.streamInfo);
	        if(self._sources.length) {
	            self.prepareNextSource();
	        } else {
	            self.end();
	        }
	    });
	    previous.on('error', function (e) {
	        self.error(e);
	    });
	    return this;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	ZipFileWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this.previous && this._sources.length) {
	        this.prepareNextSource();
	        return true;
	    }
	    if (!this.previous && !this._sources.length && !this.generatedError) {
	        this.end();
	        return true;
	    }
	};
	
	/**
	 * @see GenericWorker.error
	 */
	ZipFileWorker.prototype.error = function (e) {
	    var sources = this._sources;
	    if(!GenericWorker.prototype.error.call(this, e)) {
	        return false;
	    }
	    for(var i = 0; i < sources.length; i++) {
	        try {
	            sources[i].error(e);
	        } catch(e) {
	            // the `error` exploded, nothing to do
	        }
	    }
	    return true;
	};
	
	/**
	 * @see GenericWorker.lock
	 */
	ZipFileWorker.prototype.lock = function () {
	    GenericWorker.prototype.lock.call(this);
	    var sources = this._sources;
	    for(var i = 0; i < sources.length; i++) {
	        sources[i].lock();
	    }
	};
	
	module.exports = ZipFileWorker;


/***/ }),
/* 994 */
/***/ (function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(927);
	var GenericWorker = __webpack_require__(963);
	
	/**
	 * A worker that use a nodejs stream as source.
	 * @constructor
	 * @param {String} filename the name of the file entry for this stream.
	 * @param {Readable} stream the nodejs stream.
	 */
	function NodejsStreamInputAdapter(filename, stream) {
	    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
	    this._upstreamEnded = false;
	    this._bindStream(stream);
	}
	
	utils.inherits(NodejsStreamInputAdapter, GenericWorker);
	
	/**
	 * Prepare the stream and bind the callbacks on it.
	 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
	 * @param {Stream} stream the nodejs stream to use.
	 */
	NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
	    var self = this;
	    this._stream = stream;
	    stream.pause();
	    stream
	    .on("data", function (chunk) {
	        self.push({
	            data: chunk,
	            meta : {
	                percent : 0
	            }
	        });
	    })
	    .on("error", function (e) {
	        if(self.isPaused) {
	            this.generatedError = e;
	        } else {
	            self.error(e);
	        }
	    })
	    .on("end", function () {
	        if(self.isPaused) {
	            self._upstreamEnded = true;
	        } else {
	            self.end();
	        }
	    });
	};
	NodejsStreamInputAdapter.prototype.pause = function () {
	    if(!GenericWorker.prototype.pause.call(this)) {
	        return false;
	    }
	    this._stream.pause();
	    return true;
	};
	NodejsStreamInputAdapter.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if(this._upstreamEnded) {
	        this.end();
	    } else {
	        this._stream.resume();
	    }
	
	    return true;
	};
	
	module.exports = NodejsStreamInputAdapter;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(927);
	var external = __webpack_require__(960);
	var utf8 = __webpack_require__(926);
	var ZipEntries = __webpack_require__(997);
	var Crc32Probe = __webpack_require__(970);
	var nodejsUtils = __webpack_require__(958);
	
	/**
	 * Check the CRC32 of an entry.
	 * @param {ZipEntry} zipEntry the zip entry to check.
	 * @return {Promise} the result.
	 */
	function checkEntryCRC32(zipEntry) {
	    return new external.Promise(function (resolve, reject) {
	        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
	        worker.on("error", function (e) {
	            reject(e);
	        })
	            .on("end", function () {
	                if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
	                    reject(new Error("Corrupted zip : CRC32 mismatch"));
	                } else {
	                    resolve();
	                }
	            })
	            .resume();
	    });
	}
	
	module.exports = function (data, options) {
	    var zip = this;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString: false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	
	    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
	    }
	
	    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
	        .then(function (data) {
	            var zipEntries = new ZipEntries(options);
	            zipEntries.load(data);
	            return zipEntries;
	        }).then(function checkCRC32(zipEntries) {
	            var promises = [external.Promise.resolve(zipEntries)];
	            var files = zipEntries.files;
	            if (options.checkCRC32) {
	                for (var i = 0; i < files.length; i++) {
	                    promises.push(checkEntryCRC32(files[i]));
	                }
	            }
	            return external.Promise.all(promises);
	        }).then(function addFiles(results) {
	            var zipEntries = results.shift();
	            var files = zipEntries.files;
	            for (var i = 0; i < files.length; i++) {
	                var input = files[i];
	                zip.file(input.fileNameStr, input.decompressed, {
	                    binary: true,
	                    optimizedBinaryString: true,
	                    date: input.date,
	                    dir: input.dir,
	                    comment: input.fileCommentStr.length ? input.fileCommentStr : null,
	                    unixPermissions: input.unixPermissions,
	                    dosPermissions: input.dosPermissions,
	                    createFolders: options.createFolders
	                });
	            }
	            if (zipEntries.zipComment.length) {
	                zip.comment = zipEntries.zipComment;
	            }
	
	            return zip;
	        });
	};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var readerFor = __webpack_require__(998);
	var utils = __webpack_require__(927);
	var sig = __webpack_require__(994);
	var ZipEntry = __webpack_require__(1004);
	var utf8 = __webpack_require__(926);
	var support = __webpack_require__(928);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the specified signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        if (!this.reader.readAndCheckSignature(expectedSignature)) {
	            this.reader.index -= 4;
	            var signature = this.reader.readString(4);
	            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.reader.skip(4);
	        // this.versionMadeBy = this.reader.readString(2);
	        // this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readData(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	
	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip: can't find end of central directory");
	            }
	
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	
	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }
	
	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
	
	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        this.reader = readerFor(data);
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(927);
	var support = __webpack_require__(928);
	var ArrayReader = __webpack_require__(999);
	var StringReader = __webpack_require__(1001);
	var NodeBufferReader = __webpack_require__(1002);
	var Uint8ArrayReader = __webpack_require__(1003);
	
	/**
	 * Create a reader adapted to the data.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
	 * @return {DataReader} the data reader.
	 */
	module.exports = function (data) {
	    var type = utils.getTypeOf(data);
	    utils.checkSupport(type);
	    if (type === "string" && !support.uint8array) {
	        return new StringReader(data);
	    }
	    if (type === "nodebuffer") {
	        return new NodeBufferReader(data);
	    }
	    if (support.uint8array) {
	        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
	    }
	    return new ArrayReader(utils.transformTo("array", data));
	};


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(1000);
	var utils = __webpack_require__(927);
	
	function ArrayReader(data) {
	    DataReader.call(this, data);
		for(var i = 0; i < this.data.length; i++) {
			data[i] = data[i] & 0xFF;
		}
	}
	utils.inherits(ArrayReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	ArrayReader.prototype.readAndCheckSignature = function (sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3),
	        data = this.readData(4);
	    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(927);
	
	function DataReader(data) {
	    this.data = data; // type : see implementation
	    this.length = data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specified index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurrence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurrence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Read the signature (4 bytes) at the current position and compare it with sig.
	     * @param {string} sig the expected signature
	     * @return {boolean} true if the signature matches, false otherwise.
	     */
	    readAndCheckSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(Date.UTC(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1)); // second
	    }
	};
	module.exports = DataReader;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(1000);
	var utils = __webpack_require__(927);
	
	function StringReader(data) {
	    DataReader.call(this, data);
	}
	utils.inherits(StringReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	StringReader.prototype.readAndCheckSignature = function (sig) {
	    var data = this.readData(4);
	    return sig === data;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(1003);
	var utils = __webpack_require__(927);
	
	function NodeBufferReader(data) {
	    Uint8ArrayReader.call(this, data);
	}
	utils.inherits(NodeBufferReader, Uint8ArrayReader);
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayReader = __webpack_require__(999);
	var utils = __webpack_require__(927);
	
	function Uint8ArrayReader(data) {
	    ArrayReader.call(this, data);
	}
	utils.inherits(Uint8ArrayReader, ArrayReader);
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var readerFor = __webpack_require__(998);
	var utils = __webpack_require__(927);
	var CompressedObject = __webpack_require__(968);
	var crc32fn = __webpack_require__(971);
	var utf8 = __webpack_require__(926);
	var compressions = __webpack_require__(975);
	var support = __webpack_require__(928);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	var findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
	        }
	
	        compression = findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        reader.skip(2);
	        // this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        var fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        // will be read in the local part, see the comments there
	        reader.skip(fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = readerFor(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var end = reader.index + this.extraFieldsLength,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        if (!this.extraFields) {
	            this.extraFields = {};
	        }
	
	        while (reader.index + 4 < end) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readData(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	
	        reader.setIndex(end);
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = utf8.utf8decode(this.fileName);
	            this.fileCommentStr = utf8.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                // ASCII text or unsupported code page
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }
	
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                // ASCII text or unsupported code page
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = readerFor(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = readerFor(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/EaFormsMultiple.ejs -->\n';
	 idSuffix = Math.floor(Math.random() * 10000000) 
	__p+='\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">Yearly Forms</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>'+
	((__t=( actionMode === 'download' ? 'Download' : 'Send' ))==null?'':_.escape(__t))+
	' EA Forms for Multiple Employees</h5>\n\n                    ';
	 if (actionMode === 'send') { 
	__p+='\n                        <br/><br/>\n                        <div class="form-group" style="height: 30px;">\n                            <label class="col-sm-2 control-label" style="font-weight: 400; padding-top: 7px;">\n                                Email to be cc\'d\n                                <i class="fa fa-question-circle" data-toggle="tooltip"\n                                    data-placement="top" data-container="body"\n                                    title="Please add your email address if you want to be cc’ed on all EA form emails."\n                                >\n                                </i>\n                            </label>\n                            <div class="col-sm-4">\n                                <input id="ccEmail" class="form-control" type="text"\n                                    placeholder="Enter Email"\n                                    value=""\n                                    data-value-type="string">\n                                <span class="error-email error"></span>\n                            </div>\n                        </div>\n                    ';
	 }
	__p+='\n                </div>\n\n                <div class="tab-content ibox-content">\n                    <div id="employee-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                        class="tab-pane active"\n                        data-tab-name="employee">\n\n                        <table class="table\n                            table-stripped toggle-arrow-tiny" data-page-size="300">\n                            <thead>\n                                <tr>\n                                    <th>\n                                        <input type="checkbox" class="employee-all" value="all" checked>\n                                    </th>\n                                    <th data-toggle="true"\n-                                        class="footable-sortable\n-                                            js-eaforms-toggle">\n                                        Employee\n                                    </th>\n                                    <th data-hide="all"></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                ';
	 collection.each(function(employee) { 
	__p+='\n                                    <tr>\n                                        <td><input type="checkbox" class="employee" value="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'" name="ids" checked></td>\n                                        <td>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</td>\n                                      </tr>\n                                  ';
	 }) 
	__p+='\n                            </tbody>\n                        </table>\n\n                        <select id="year">\n                            ';
	 for (var y = 2025; y >= startYear; y--) { 
	__p+='\n                            <option value="'+
	((__t=( y ))==null?'':_.escape(__t))+
	'" '+
	((__t=( y === selectedYear ? 'selected' : '' ))==null?'':_.escape(__t))+
	'>'+
	((__t=( y ))==null?'':_.escape(__t))+
	'</option>\n                            ';
	 } 
	__p+='\n                        </select>\n\n                        ';
	 if (actionMode === 'download') { 
	__p+='\n                        <button class="btn btn-primary download-ea">Download EA Forms</button>\n                        ';
	 } else { 
	__p+='\n                        <button class="btn btn-primary send-ea">Send EA Forms</button>\n                        ';
	 } 
	__p+='\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var AttachmentView = __webpack_require__(915);
	var template = __webpack_require__(1007);
	var loader = __webpack_require__(534);
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	
	    events: {
	        'click .js-pcb2forms-toggle': 'toggleAll',
	        'click .js-generate': 'generateForm'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.itemViews = [];
	        this.collapsed = true;
	
	        this.options = _.defaults(options || {}, {
	            attachments: null
	        });
	
	        this.collection.forEach(function (employee) {
	            _this.options.attachments[employee.id].on('reset', function () {
	                _this.renderItems(employee, 'reset');
	            });
	        });
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            model: this.model,
	            collection: this.collection
	        }));
	
	        this.$('.footable').footable({
	            sort: false,
	            addRowToggle: true,
	            paging: {
	                enabled: true
	            }
	        });
	
	        _.each(this.itemViews, function (view) {
	            view.remove();
	        });
	
	        this.itemViews = [];
	
	        if (this.collection.length > 0) {
	            this.collection.forEach(this.renderItems.bind(this));
	        }
	
	        return this;
	    },
	
	    renderItems: function renderItems(employee, reset) {
	        var _this2 = this;
	
	        var attachments = this.options.attachments[employee.id];
	        var $employee = this.$('.js-employee-' + employee.id);
	
	        if (reset) {
	            $employee.html('');
	        }
	
	        attachments.forEach(function (attachment) {
	            _this2.renderItem(attachment, employee);
	        });
	        if (reset) {
	            $employee.fadeIn(200);
	        }
	    },
	
	    renderItem: function renderItem(model, employee) {
	        var employeeView = new AttachmentView({ model: model });
	
	        this.itemViews.push(employeeView);
	
	        this.$('.js-employee-' + employee.id).append(employeeView.$el);
	
	        return this;
	    },
	
	    toggleAll: function toggleAll(ev) {
	        ev.preventDefault();
	
	        this.$('.footable').trigger(this.collapsed ? 'footable_expand_all' : 'footable_collapse_all');
	
	        this.collapsed = !this.collapsed;
	    },
	
	    generateForm: function generateForm(ev) {
	        var $button = this.$(ev.currentTarget);
	        var employee = this.collection.get($button.data('employee'));
	        var year = $button.data('year');
	        var attachments = this.options.attachments[employee.id];
	        var stopLoader = loader.startFullScreen($button);
	
	        var $employee = this.$('.js-employee-' + employee.id);
	        $employee.fadeOut(200);
	
	        return employee.generateFormPcb2(year).then(function () {
	            return employee.fetchAttachments(['PCB2']);
	        }).then(function (employeeAttachments) {
	            attachments.reset(employeeAttachments.models);
	
	            var $row = $button.closest('tr');
	            var $detail = $row.next('.footable-row-detail');
	
	            if (!$detail.is(':visible')) {
	                $row.trigger('footable_toggle_row');
	            }
	        }).finally(stopLoader);
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/Pcb2Forms.ejs -->\n';
	 idSuffix = Math.floor(Math.random() * 10000000) 
	__p+='\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">Yearly Forms</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    ';
	 if (collection.length <= 0) { 
	__p+='\n                        <h5>No Forms Available</h5>\n                    ';
	 } else if (collection.length === 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' PCB II Form</h5>\n                    ';
	 } else if (collection.length > 1) { 
	__p+='\n                        <h5>'+
	((__t=( collection.length ))==null?'':_.escape(__t))+
	' PCB 2(II) Forms</h5>\n                    ';
	 } 
	__p+='\n                </div>\n\n                <div class="tab-content ibox-content">\n                    <div id="employee-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                        class="tab-pane active"\n                        data-tab-name="employee">\n\n                        <button onclick="window.location.href = \'#/governmentForms/pcb2/multiple\'" class="btn btn-primary">Download PCB 2(II) Forms for Multiple Employees</button>\n\n                        <table class="footable footable-pdb2form table\n                            table-stripped toggle-arrow-tiny" data-page-size="300">\n                            <thead>\n                                <tr>\n                                    <th data-toggle="true"\n                                        class="footable-sortable\n                                            js-pcb2forms-toggle">\n                                        Employees\n                                    </th>\n                                    <th data-hide="all"></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                ';
	 collection.each(function(employee) { 
	__p+='\n                                    <tr>\n                                        <td>\n                                            '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n                                            '+
	((__t=( employee.get('hiddenAt') ? (
	                                                '(archived on ' +
	                                                employee.get('hiddenAt') +
	                                                ')'
	                                            ) : '' ))==null?'':_.escape(__t))+
	'\n\n                                            ';
	 var year = 2025; 
	__p+='\n                                            <button class="btn btn-primary\n                                                          btn-outline pull-right\n                                                          margin-right-small\n                                                          js-generate"\n                                                   data-employee="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'"\n                                                   data-year="'+
	((__t=( year ))==null?'':_.escape(__t))+
	'">\n                                               Generate\n                                               '+
	((__t=( year ))==null?'':_.escape(__t))+
	'\n                                               Form\n                                            </button>\n                                        </td>\n                                        <td>\n                                            <div class="row js-list\n                                                js-employee-'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'">\n                                            </div>\n                                        </td>\n                                    </tr>\n                                ';
	 }) 
	__p+='\n                            </tbody>\n                            <tfoot>\n                            <tr>\n                                <td colspan="2">\n                                    <ul class="pagination pull-right"></ul>\n                                </td>\n                            </tr>\n                            </tfoot>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var JSZip = __webpack_require__(924);
	var Alerts = __webpack_require__(529);
	var AttachmentView = __webpack_require__(915);
	var tpl = __webpack_require__(1009);
	var downloadjs = __webpack_require__(666);
	var loader = __webpack_require__(534);
	var moment = __webpack_require__(101);
	var axios = __webpack_require__(28);
	var log = __webpack_require__(525)('employer/form-pcb2-multidownload');
	
	var Promise = __webpack_require__(63);
	
	module.exports = Backbone.View.extend({
	    itemViews: null,
	    employeeIds: [],
	
	    events: {
	        'change [type="checkbox"]': 'selectEmployee',
	        'click .download-pcb2': 'downloadPcb2',
	        'change select#year': 'toggleEmployeeListByYear'
	    },
	
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.itemViews = [];
	        this.employeeIds = [];
	        this.collapsed = true;
	
	        this.options = _.defaults(options || {}, {
	            attachments: null
	        });
	
	        this.collection.forEach(function (employee) {
	            _this.employeeIds.push(employee.id);
	            if (_this.options.attachments[employee.id]) {
	                _this.options.attachments[employee.id].on('reset', function () {
	                    _this.renderItems(employee, 'reset');
	                });
	            }
	        });
	    },
	
	    render: function render() {
	        this.$el.html(tpl({
	            model: this.model,
	            collection: this.collection
	        }));
	
	        _.each(this.itemViews, function (view) {
	            view.remove();
	        });
	
	        this.itemViews = [];
	
	        if (this.collection.length > 0) {
	            this.collection.forEach(this.renderItems.bind(this));
	        }
	
	        this.toggleEmployeeListByYear();
	
	        return this;
	    },
	
	    renderItems: function renderItems(employee, reset) {
	        var _this2 = this;
	
	        var attachments = this.options.attachments[employee.id];
	        var $employee = this.$('.js-employee-' + employee.id);
	
	        if (reset) {
	            $employee.html('');
	        }
	
	        attachments.forEach(function (attachment) {
	            _this2.renderItem(attachment, employee);
	        });
	        if (reset) {
	            $employee.fadeIn(200);
	        }
	    },
	
	    renderItem: function renderItem(model, employee) {
	        var employeeView = new AttachmentView({ model: model });
	
	        this.itemViews.push(employeeView);
	
	        this.$('.js-employee-' + employee.id).append(employeeView.$el);
	
	        return this;
	    },
	
	    selectEmployee: function selectEmployee(e) {
	        var input = this.$(e.currentTarget);
	        var id = input.val();
	        var checked = input.prop('checked');
	
	        if (checked === false) {
	            var index = this.employeeIds.indexOf(id);
	            this.employeeIds.splice(index, 1);
	        }
	    },
	
	    toggleEmployeeListByYear: function toggleEmployeeListByYear() {
	        var year = parseInt(this.$('select#year').val(), 10);
	        var employeeIds = [];
	
	        this.collection.forEach(function (employee) {
	            var $targetRow = $('tr.js-employee-row-' + employee.id);
	            var $targerCheckBox = $targetRow.find('input[type="checkbox"]');
	            if (moment(employee.get('commencementDate')).year() > year || employee.get('cessationDate') && moment(employee.get('cessationDate')).year() < year) {
	                $targetRow.addClass('hide');
	                $targerCheckBox.prop('checked', false);
	            } else {
	                $targetRow.removeClass('hide');
	                $targerCheckBox.prop('checked', true);
	                employeeIds.push(employee.id);
	            }
	        });
	
	        this.employeeIds = employeeIds;
	    },
	
	    downloadPcb2: function downloadPcb2(ev) {
	        var _this3 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = loader.startFullScreen($button);
	        var year = parseInt(this.$('select#year').val(), 10);
	
	        var zip = new JSZip();
	
	        return Promise.each(this.collection.filter(function (emp) {
	            return _this3.employeeIds.includes(emp.id);
	        }), function (employee) {
	            return employee.generateFormPcb2(year).then(function (attachment) {
	                var fileName = attachment.get('name').replace(/[\/]|[\\]/g, '-');
	                return axios.get(attachment.getUrl(), {
	                    timeout: 60000,
	                    responseType: 'blob'
	                }).then(function (response) {
	                    // check if there is file name duplication as it would overwrite the existing ones.
	                    if (zip.file(fileName) !== null) {
	                        var numOfDuplicates = zip.file(new RegExp(fileName)).length;
	                        zip.file(fileName.replace(/^([^\(\)\.]+).*.pdf$/, function (_, p1) {
	                            return p1 + '(' + numOfDuplicates + ').pdf';
	                        }), response.data);
	                    } else {
	                        zip.file(fileName, response.data);
	                    }
	                }).catch(function (error) {
	                    log.error('Form PCB2 generating failed for employee ' + employee.get('fullName'));
	                    log.error(error.error);
	                });
	            });
	        }).then(function () {
	            return zip.generateAsync({ type: 'blob' });
	        }).then(function (content) {
	            downloadjs(content, 'PCB2(II)-Forms-' + year + '.zip', 'application/zip');
	            stopLoader();
	        }).catch(function (err) {
	            Alerts.show('criticalError', err);
	            stopLoader();
	        });
	    },
	
	    remove: function remove() {
	        this.undelegateEvents();
	        this.itemViews.forEach(function (view) {
	            return view.remove();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/governmentForms/Pcb2FormsMultiple.ejs -->\n';
	 idSuffix = Math.floor(Math.random() * 10000000) 
	__p+='\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">Yearly Forms</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>Download PCB 2(II) Forms for Multiple Employees</h5>\n                </div>\n\n                <div class="tab-content ibox-content">\n                    <div id="employee-view-'+
	((__t=( idSuffix ))==null?'':_.escape(__t))+
	'"\n                        class="tab-pane active"\n                        data-tab-name="employee">\n\n                        <table class="table\n                            table-stripped toggle-arrow-tiny" data-page-size="300">\n                            <thead>\n                                <tr>\n                                    <th></th>\n                                    <th data-toggle="true"\n-                                        class="footable-sortable\n-                                            js-pcb2forms-toggle">\n                                        Employee\n                                    </th>\n                                    <th data-hide="all"></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                ';
	 collection.each(function(employee) { 
	__p+='\n                                    <tr class="js-employee-row-'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'">\n                                        <td><input type="checkbox" class="employee" value="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'" name="ids" checked></td>\n                                        <td>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</td>\n                                      </tr>\n                                  ';
	 }) 
	__p+='\n                            </tbody>\n                        </table>\n\n                        <select id="year">\n                            <option value="2025">2025</option>\n                            <option value="2024">2024</option>\n                            <option value="2023">2023</option>\n                            <option value="2022">2022</option>\n                            <option value="2021">2021</option>\n                            <option value="2020">2020</option>\n                            <option value="2019">2019</option>\n                            <option value="2018">2018</option>\n                            <option value="2017">2017</option>\n                            <option value="2016">2016</option>\n                        </select>\n\n                        <button class="btn btn-primary download-pcb2">Download PCB 2(II) Forms</button>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Layout = __webpack_require__(1011);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _isMobile = __webpack_require__(1023);
	
	var _isMobile2 = _interopRequireDefault(_isMobile);
	
	var _actionLogs = __webpack_require__(817);
	
	var _actionLogs2 = _interopRequireDefault(_actionLogs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/dashboard-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'dashboard': 'dashboard'
	    },
	
	    titles: {
	        'dashboard': 'Dashboard'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    dashboard: function dashboard() {
	        var _this = this;
	
	        if (!_isMobile2.default.isWorkingWidth()) {
	            return this.navigate('errorMobile', { trigger: true });
	        }
	
	        this.layout = new _Layout2.default({
	            el: this.el
	        });
	
	        var options = {
	            /* To identify the object later */
	            _isOptions: true,
	
	            isSetupCompany: false,
	            isAddEmployee: false,
	            isPayrollSaved: false,
	            isPayrollProcessing: false,
	            /* TODO Naming of isPayrollDue and isPayrollDueReminder is
	             * confusing */
	            isPayrollDue: false,
	            isPayrollDueReminder: false,
	            isPayrollToBeFinished: false,
	            payrollDueText: ''
	        };
	
	        /* On my last commit here I just flattened this callback hell we had.
	         * This can be further improved, the method is way too long.
	         * */
	        new _actionLogs2.default().fetchForCompany(app.company).then(function (collection) {
	            return collection.models;
	        }).then(function (actionLogs) {
	            options.actionLogs = actionLogs;
	            options.actionLogsFetchMore = function (options) {
	                return new _actionLogs2.default().fetchForCompany(app.company, options).then(function (collection) {
	                    return collection.models;
	                });
	            };
	            if (!app.company.isBasicInfoSetUp()) {
	                return (0, _bluebird.reject)(Object.assign(options, { isSetupCompany: true }));
	            }
	
	            return (0, _bluebird.resolve)((app.company.get('employeeCount') || 0) > 0);
	        }).then(function (hasEmployees) {
	            if (!hasEmployees) {
	                return (0, _bluebird.reject)(Object.assign(options, { isAddEmployee: true }));
	            }
	
	            // TODO
	            return false;
	            /* return new Payrolls(null, {company: app.company})
	                .fetch({filter: {where: {submittedDate: null}}})
	                .then(r => r.collection.at(0)); */
	        }).then(function (unsubmittedPayroll) {
	            if (unsubmittedPayroll) {
	                return (0, _bluebird.reject)(Object.assign(options, { isPayrollSaved: true }));
	            }
	
	            // TODO
	            /* return (new Parse.Query('Payroll'))
	                .equalTo('companyId', app.company.id)
	                .greaterThanOrEqualTo('status', 3)
	                .lessThan('status', 9)
	                .first(); */
	            return false;
	        }).then(function (processingPayroll) {
	            if (processingPayroll && app.company.get('mppAdminId')) {
	                return (0, _bluebird.reject)(Object.assign(options, { isPayrollToBeFinished: true }));
	            } else if (processingPayroll) {
	                return (0, _bluebird.reject)(Object.assign(options, { isPayrollProcessing: true }));
	            }
	
	            _this.layout.renderContent(options);
	        }).catch(function (errOrOptions) {
	            if (errOrOptions._isOptions === true) {
	                _this.layout.renderContent(errOrOptions);
	                return;
	            }
	
	            log.error(errOrOptions);
	            _alerts2.default.show('criticalError', errOrOptions);
	        }).finally(function () {
	            return _this.layout.hideLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = __webpack_require__(1012);
	var dashboardHeader = __webpack_require__(1013);
	
	var fullScreenMsg = __webpack_require__(1014);
	var celcomWelcomeTpl = __webpack_require__(1015);
	var miaWelcomeTpl = __webpack_require__(1016);
	
	var EmployeesView = __webpack_require__(1017);
	var ActionLogView = __webpack_require__(1021);
	
	var FreeAccountSetup = __webpack_require__(707);
	
	module.exports = Backbone.View.extend({
	    employeesViews: null,
	
	    events: {
	        'keyup .js-coupon-code': 'resetCouponError',
	        'click .js-apply-coupon-code': 'applyCouponCode',
	        'click .js-reset-coupon-code': 'resetCouponCode',
	        'click .js-free-account-setup': 'freeAccountSetup'
	    },
	
	    initialize: function initialize() {
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template());
	        return this;
	    },
	
	    renderContent: function renderContent(options) {
	        this.$('.js-dashboard-header').html(dashboardHeader(options));
	
	        if (!options.isSetupCompany && !options.isAddEmployee) {
	            this.employeesView = new EmployeesView({
	                $el: this.$('.js-dashboard-employees')
	            });
	            this.$el.find('.js-dashboard-action-log').html(new ActionLogView({
	                collection: options.actionLogs,
	                fetchMore: options.actionLogsFetchMore
	            }).render().el);
	            this.$el.trigger('resize');
	            return;
	        }
	
	        if (options.isAddEmployee) {
	            this.$('.js-dashboard-content').html(fullScreenMsg(options));
	            this.$el.trigger('resize');
	            return;
	        }
	
	        var tags = app.company.get('tags') || [];
	        if (tags.indexOf('celcom') >= 0) {
	            this.$('.js-dashboard-content').html(celcomWelcomeTpl(_.extend(options || {}, {
	                couponCode: app.company.get('couponCode')
	            })));
	        } else if (tags.indexOf('malaysian-institute-of-accountants') >= 0) {
	            this.$('.js-dashboard-content').html(miaWelcomeTpl(_.extend(options || {}, {
	                couponCode: app.company.get('couponCode')
	            })));
	        } else {
	            this.$('.js-dashboard-content').html(fullScreenMsg(options));
	        }
	        this.$el.trigger('resize');
	        FreeAccountSetup.shouldShowFreeSetup().then(this.toggleFreeAccountSetup);
	        return;
	    },
	
	    freeAccountSetup: function freeAccountSetup() {
	        return FreeAccountSetup.freeAccountSetupRequest().then(this.toggleFreeAccountSetup);
	    },
	
	    toggleFreeAccountSetup: function toggleFreeAccountSetup(show) {
	        var button = $('.js-free-account-setup');
	        if (show) {
	            button.show();
	        } else {
	            button.hide();
	        }
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-layout-loader').hide();
	    },
	
	    // These two methods would be cleaner if I could just call renderContent
	    // but that method takes some annoying parameters that are not persisted
	    // in the object. Not even sure if I can save them either.
	    applyCouponCode: function applyCouponCode() {
	        var _this = this;
	
	        var couponCode = this.$('.js-coupon-code').val();
	        if (!/^[A-Z0-9]+$/.test(couponCode)) {
	            this.toggleCouponError('Your coupon code must be entered in all capital letters and ' + 'must not contain any special characters');
	
	            return;
	        }
	
	        this.toggleCouponError(false);
	        app.company.save({ couponCode: couponCode }, { skipValidation: true }).then(function () {
	            _alerts2.default.show('success', { text: 'Your coupon has been saved' });
	            _this.$('.js-coupon-code').prop('readonly', true);
	            _this.$('.js-apply-coupon-code').addClass('hidden');
	            _this.$('.js-reset-coupon-code').removeClass('hidden');
	        }).fail(function () {
	            _alerts2.default.show('error', { text: 'Could not save your coupon code. If the error persist ' + 'please contact support. Also know that you can add it ' + 'at any time before submitting your first payroll'
	            });
	        });
	    },
	
	    resetCouponCode: function resetCouponCode() {
	        var _this2 = this;
	
	        this.toggleCouponError(false);
	        app.company.save({ couponCode: null }, { skipValidation: true }).then(function () {
	            _this2.$('.js-coupon-code').prop('readonly', false).val('');
	            _this2.$('.js-apply-coupon-code').removeClass('hidden');
	            _this2.$('.js-reset-coupon-code').addClass('hidden');
	        });
	    },
	
	    resetCouponError: function resetCouponError() {
	        this.toggleCouponError(false);
	    },
	
	    toggleCouponError: function toggleCouponError(err) {
	        var $formGroup = this.$('.js-coupon-code-form-group');
	        var $error = this.$('.js-coupon-code-form-group .error');
	
	        if (!err) {
	            $formGroup.removeClass('has-error');
	            $error.text('');
	            return;
	        }
	
	        $formGroup.addClass('has-error');
	        $error.text(err);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/Layout.ejs -->\n<div class="employer-dashboard">\n\n    <div class="js-dashboard-header"></div>\n    <div class="js-dashboard-content">\n        <div class="row panels">\n            <div class="js-dashboard-employees col-lg-12"></div>\n        </div>\n\n        <div class="row panels">\n            <div class="js-dashboard-action-log col-lg-12 m-b-lg"></div>\n        </div>\n    </div>\n\n    <div class="js-layout-loader loader">\n        '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n    </div>\n\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/Header.ejs -->\n';
	 /* JBP: I came here and modified this template to make it bearable but it
	 still is retarded */ 
	__p+='\n';
	 if (isPayrollSaved || isPayrollProcessing || isPayrollDue || isPayrollDueReminder || isPayrollToBeFinished) { 
	__p+='\n    <div class="row wrapper page-heading">\n        <div class="col-xs-12">\n            ';
	 if (isPayrollSaved) { 
	__p+='\n                <img src="/images/processed.png" class="pull-left">\n                <h2>\n                    You have a <b>saved payroll</b> you were working on.\n                    Would you like to continue with it?\n                </h2>\n                <br>\n                <a class="btn btn-primary btn-large" href="#payroll">\n                    Continue With Payroll\n                </a>\n            ';
	 } else if (isPayrollProcessing) { 
	__p+='\n                <img src="/images/processed.png" class="pull-left">\n                <h2>\n                    Your payroll is currently <b>being processed</b> by Payroll\n                    Panda. You can view your payroll details and its status in\n                    Payroll History. You can also cancel a payroll before it is\n                    submitted to the government agencies\n                </h2>\n                <br>\n                <a class="btn btn-primary btn-large" href="#payroll/history">\n                    View Payroll\n                </a>\n            ';
	 } else if (isPayrollToBeFinished) { 
	__p+='\n                <img src="/images/processed.png" class="pull-left">\n                <h2>\n                    Your payroll is waiting for you to mark it as finished.\n                    You can view your payroll details and its status in\n                    Payroll\n                </h2>\n                <br>\n                <a class="btn btn-primary btn-large" href="#payroll/history">\n                    View Payroll\n                </a>\n            ';
	 } else if (isPayrollDue) { 
	__p+='\n                <img src="/images/day.png" class="pull-left">\n                <h2>'+
	((__t=( payrollDueText ))==null?'':_.escape(__t))+
	'</h2>\n                <br>\n                <a class="btn btn-primary btn-large" href="#payroll">\n                    Run Payroll\n                </a>\n            ';
	 } else if (isPayrollDueReminder) { 
	__p+='\n                <img src="/images/Addempl.png" class="pull-left">\n                <h2>\n                    You haven\'t set a Payroll Reminder Day so we can\'t send you\n                    an  email to remind you when your next payroll is due.\n                    You can set this up now if you like\n                </h2>\n                <br>\n                <a class="btn btn-primary btn-large" href="#settings/company">\n                    Company Setup\n                </a>\n            ';
	 } 
	__p+='\n        </div>\n    </div>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/FullScreenMessage.ejs -->\n<div class="wrapper wrapper-content">\n    <div id="full-screen-message" style="pointer-events: none;">\n        <div class="fsm-container-1">\n            <div class="fsm-container-2">\n                ';
	 if (isAddEmployee) { 
	__p+='\n                    <img src="/images/Addempl.png">\n                    <h2>\n                        You need to add <b>at least one</b> employee\n                        before you can Run Payroll\n                    </h2>\n                    <a class="btn btn-primary btn-large"\n                       href="#employee/add"\n                       style="pointer-events: initial;">\n                        Add Employee\n                    </a>\n                ';
	 } else if (isSetupCompany) { 
	__p+='\n                    <img src="/images/start.png">\n                    <h2>\n                        <b>Let\'s start</b> by setting up your company with a\n                        short form\n                    </h2>\n                    <a class="btn btn-primary btn-large"\n                       href="#settings/company"\n                       style="pointer-events: initial;">\n                        Company Setup\n                    </a>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/CelcomWelcome.ejs -->\n<div class="wrapper wrapper-content">\n    <div id="full-screen-message">\n        <div class="fsm-container-1">\n            <div class="fsm-container-2">\n                <img src="/images/start.png">\n                <h2>\n                    Welcome to PayrollPanda<br>\n                    Add your coupon code to enjoy your Celcom\n                    benefits\n                </h2>\n\n                <div class="form-group m-b-lg js-coupon-code-form-group">\n                    <div class="input-group text-center welcome-coupon-code">\n                        <input type="text" class="form-control js-coupon-code"\n                            placeholder="Coupon Code"\n                            value="'+
	((__t=( couponCode ))==null?'':_.escape(__t))+
	'"\n                            '+
	((__t=( couponCode ? 'readonly' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span class="input-group-btn">\n                            <button class="btn btn-secondary\n                                js-apply-coupon-code\n                                '+
	((__t=( couponCode ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n                                Apply\n                            </button>\n                            <button class="btn btn-secondary\n                                js-reset-coupon-code\n                                '+
	((__t=( !couponCode ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n                                Reset\n                            </button>\n                        </span>\n                    </div>\n                    <span class="error error-couponCode"></span>\n                </div>\n\n                <a class="btn btn-primary btn-large m-t-lg"\n                    href="#settings/company">\n                    Company Setup\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/MIAWelcome.ejs -->\n<div class="wrapper wrapper-content">\n    <div id="full-screen-message">\n        <div class="fsm-container-1">\n            <div class="fsm-container-2">\n                <img src="/images/start.png">\n                <h2>\n                    Welcome, key in your MIA member firm ID and enjoy\n                    PayrollPanda free for life\n                </h2>\n\n                <div class="form-group m-b-lg js-coupon-code-form-group">\n                    <div class="input-group text-center welcome-coupon-code">\n                        <input type="text" class="form-control js-coupon-code"\n                            placeholder="MIA Member Firm ID"\n                            value="'+
	((__t=( couponCode ))==null?'':_.escape(__t))+
	'"\n                            '+
	((__t=( couponCode ? 'readonly' : '' ))==null?'':_.escape(__t))+
	'>\n                        <span class="input-group-btn">\n                            <button class="btn btn-success\n                                js-apply-coupon-code\n                                '+
	((__t=( couponCode ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n                                Apply\n                            </button>\n                            <button class="btn btn-success\n                                js-reset-coupon-code\n                                '+
	((__t=( !couponCode ? 'hidden' : '' ))==null?'':_.escape(__t))+
	'">\n                                Reset\n                            </button>\n                        </span>\n                    </div>\n                    <span class="error error-couponCode"></span>\n                </div>\n\n                <a class="btn btn-primary btn-large m-t-lg"\n                    href="#settings/company">\n                    Company Setup\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Employees = __webpack_require__(1018);
	
	var _Employees2 = _interopRequireDefault(_Employees);
	
	var _EmployeesContent = __webpack_require__(1019);
	
	var _EmployeesContent2 = _interopRequireDefault(_EmployeesContent);
	
	var _EmployeeRow = __webpack_require__(1020);
	
	var _EmployeeRow2 = _interopRequireDefault(_EmployeeRow);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _InviteMessage = __webpack_require__(778);
	
	var _InviteMessage2 = _interopRequireDefault(_InviteMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-show-more': 'loadEmployees'
	    },
	
	    initialize: function initialize(options) {
	        /* FIXME NEVER extend this with the options argument */
	        _.extend(this, options);
	        this.offset = 0;
	        this.limit = 8;
	        this.isLoading = false;
	        this.employees = new _employees2.default(null, {
	            company: app.company,
	            pagination: false
	        });
	        this.render();
	        this.loadEmployees();
	
	        return this;
	    },
	
	    loadEmployees: function loadEmployees() {
	        var _this = this;
	
	        if (this.isLoading) {
	            return false;
	        }
	
	        this.isLoading = true;
	        this.$('.js-show-more').button('loading');
	        return this.employees.fetch({ filter: {
	                where: {
	                    hiddenAt: null,
	                    userId: null
	                },
	                order: 'fullName ASC',
	                offset: this.offset,
	                limit: this.limit
	            } }).then(function () {
	            if (_this.offset === 0 && _this.employees.length <= 0) {
	                _this.remove();
	                return true;
	            }
	
	            if (_this.offset === 0) {
	                (0, _bluebird.join)(_this.employees.count({ hiddenAt: null }), _this.employees.count({
	                    hiddenAt: null,
	                    userId: null
	                })).then(function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        total = _ref2[0],
	                        inactive = _ref2[1];
	
	                    _this.renderContent({
	                        total: total || 0,
	                        inactive: inactive || 0
	                    });
	
	                    _this.renderEmployees(_this.employees);
	                });
	            } else {
	                _this.renderEmployees(_this.employees);
	            }
	        }).catch(function (err) {
	            _alerts2.default.show('criticalError', err);
	        }).finally(function () {
	            _this.isLoading = false;
	            _this.$('.js-show-more').button('reset');
	            _this.hideLoader();
	        });
	    },
	
	    renderEmployees: function renderEmployees(employees) {
	        var _this2 = this;
	
	        employees.each(function (employee) {
	            var $employee = $((0, _EmployeeRow2.default)({ employee: employee }));
	            $employee.find('.js-invite').on('click', function (ev) {
	                ev.preventDefault();
	                _this2.sendInvite(employee, $employee);
	            });
	            _this2.$('.js-employees').append($employee);
	        });
	
	        this.$('.js-employees-completed').toggleClass('hidden', employees.length !== 0);
	
	        this.offset += this.limit;
	
	        this.$('.js-show-more').toggleClass('hidden', employees.length !== this.limit);
	    },
	
	    sendInvite: function sendInvite(employee) {
	        var _this3 = this;
	
	        var stopLoader = _loader2.default.startFullScreen(this.$('.btn-invite-employee'));
	
	        return employee.invite().then(function () {
	            _this3.offset = 0;
	            _this3.render();
	            _this3.loadEmployees.apply(_this3);
	
	            _alerts2.default.show('success', {
	                text: (0, _InviteMessage2.default)()
	            });
	        }).catch(function (err) {
	            _alerts2.default.show('error', { text: err.message });
	        }).finally(stopLoader);
	    },
	
	    render: function render() {
	        this.$el.html((0, _Employees2.default)());
	        return this;
	    },
	
	    renderContent: function renderContent(options) {
	        this.$('.js-employees-content').html((0, _EmployeesContent2.default)(options));
	        this.undelegateEvents();
	        this.delegateEvents();
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-loader').hide();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/Employees.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>Employees</h5>\n    </div>\n\n    <div class="js-loader ibox-content loader-container">\n        <div class="loader">\n            '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n        </div>\n    </div>\n\n    <div class="js-employees-content"></div>\n\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/EmployeesContent.ejs -->\n<div class="ibox-content">\n    <div class="row employee-header">\n        <div class="col-xs-3">\n            <i class="fa fa-users"></i>\n            <div style="display: inline-block;">\n                <div class="count">\n                    '+
	((__t=( total ))==null?'':_.escape(__t))+
	'\n                </div>\n                <div>\n                    Total '+
	((__t=( total  === 1 ? 'Employee' : 'Employees' ))==null?'':_.escape(__t))+
	'\n                </div>\n            </div>\n        </div>\n        <div class="col-xs-3">\n            ';
	 if (total && inactive) { 
	__p+='\n                <i class="fa fa-users"></i>\n                <div style="display: inline-block;">\n                    <div class="count">\n                        '+
	((__t=( inactive ))==null?'':_.escape(__t))+
	'\n                    </div>\n                    <div>\n                        Not using the app\n                    </div>\n                </div>\n            ';
	 } 
	__p+='\n        </div>\n        <div class="col-xs-6 text-right">\n            <a href="#employees" class="btn btn-outline btn-success m-r-md">\n                Manage Employees\n            </a>\n            <a href="#employee/add" class="btn btn-outline btn-primary">\n                Add New Employee\n            </a>\n        </div>\n        <div class="clearfix"></div>\n        <hr class="m-b-xs">\n    </div>\n\n    <table class="footable footable-employees footable-ellipsis table"\n        data-striping="false">\n        <thead>\n        <tr>\n            <th style="width: auto;">Employees not using the app</th>\n            <th style="width: 200px;" class="text-right">Status</th>\n            <th style="width: 260px;" class="text-right">Action</th>\n        </tr>\n        </thead>\n        <tbody class="js-employees"></tbody>\n    </table>\n    <div class="js-employees-completed empty-list text-center hidden">\n        <h1>\n            All Employees have logged in at least once\n        </h1>\n    </div>\n\n    <a class="js-show-more underline hidden" data-loading-text="Loading...">\n        Show more <i class="fa fa-angle-down"></i>\n    </a>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/EmployeeRow.ejs -->\n<tr>\n    <td>'+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'</td>\n    <td class="text-right">\n        ';
	 if (!employee.has('invitedAt')) { 
	__p+='\n            <span class="label label-success">Uninvited</span>\n        ';
	 } else if (!employee.get('userId')) { 
	__p+='\n            Has never logged in\n        ';
	 } 
	__p+='\n    </td>\n    <td class="text-right">\n        ';
	 if (!employee.has('invitedAt') && employee.get('email')) { 
	__p+='\n            <a class="js-invite">Invite</a>\n        ';
	 } else if (employee.get('email')) { 
	__p+='\n            <a class="js-invite">Invite again</a>\n        ';
	 } else { 
	__p+='\n            <a href="'+
	((__t=( '#employee/' + employee.id ))==null?'':_.escape(__t))+
	'">\n                Add email to invite\n            </a>\n        ';
	 } 
	__p+='\n        <a class="m-l-md" href="'+
	((__t=( '#employee/' + employee.id ))==null?'':_.escape(__t))+
	'">\n            Edit profile\n        </a>\n    </td>\n</tr>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var template = __webpack_require__(1022);
	var ContentView = __webpack_require__(804);
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize(options) {
	        this.fetchMore = options.fetchMore;
	    },
	
	    render: function render() {
	        this.$el.html(template({}));
	        this.hideLoader();
	        this.renderContent();
	        return this;
	    },
	
	    renderContent: function renderContent() {
	        this.$('.js-action-log-content').html(new ContentView({
	            collection: this.collection,
	            fetchMore: this.fetchMore
	        }).render().el);
	        this.undelegateEvents();
	        this.delegateEvents();
	    },
	
	    hideLoader: function hideLoader() {
	        this.$('.js-loader').hide();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/dashboard/ActionLog.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>Action Log</h5>\n    </div>\n\n    <div class="js-action-log-content"></div>\n\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	'use strict';
	
	var isMobile = {
	    Android: function Android() {
	        return navigator.userAgent.match(/Android/i);
	    },
	    BlackBerry: function BlackBerry() {
	        return navigator.userAgent.match(/BlackBerry/i);
	    },
	    iOS: function iOS() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    },
	    Opera: function Opera() {
	        return navigator.userAgent.match(/Opera Mini/i);
	    },
	    Windows: function Windows() {
	        return navigator.userAgent.match(/IEMobile/i);
	    },
	    any: function any() {
	        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
	    },
	    isWorkingWidth: function isWorkingWidth() {
	        return window.screen.width >= 600;
	    }
	};
	
	module.exports = isMobile;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _Base = __webpack_require__(712);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _bulkUploads = __webpack_require__(819);
	
	var _bulkUploads2 = _interopRequireDefault(_bulkUploads);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _payrolls = __webpack_require__(598);
	
	var _payrolls2 = _interopRequireDefault(_payrolls);
	
	var _payrollItems = __webpack_require__(628);
	
	var _payrollItems2 = _interopRequireDefault(_payrollItems);
	
	var _Layout = __webpack_require__(1025);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _TimesheetUpload = __webpack_require__(1032);
	
	var _TimesheetUpload2 = _interopRequireDefault(_TimesheetUpload);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('employer/timesheet-router');
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'timesheet(/:date)': 'timesheet',
	        'timesheet-upload': 'timesheetUpload'
	    },
	
	    titles: {
	        'timesheet(/:date)': 'Timesheet',
	        'timesheet-upload': 'TimesheetUpload'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { log: log });
	        _Base2.default.prototype.initialize.apply(this, [this.options]);
	    },
	    timesheet: function timesheet(date) {
	        var _this = this;
	
	        date = !date ? (0, _moment2.default)().startOf('week') : (0, _moment2.default)(date, 'DD-MM-YYYY').startOf('week');
	
	        var employees = new _employees2.default(null, {
	            sortKey: 'canonicalFullName',
	            sortOrder: 'ascending',
	            pagination: { rowsPerPage: 5 },
	            company: app.company,
	            filter: {
	                where: {
	                    and: [{ commencementDate: { neq: null } }, { commencementDate: { lte: (0, _moment2.default)(date).endOf('week') } }],
	                    or: [{ hiddenAt: null }, {
	                        and: [{ cessationDate: { neq: null } }, { cessationDate: {
	                                gte: (0, _moment2.default)(date).startOf('week')
	                            } }]
	                    }]
	                }
	            }
	        });
	
	        var stopLoader = _loader2.default.startFullScreen(this.$el);
	        var overtimeItems = app.payrollItems.chain().filter(function (item) {
	            return !item.get('hiddenAt') && item.get('type') === 'overtime';
	        }).sortBy(function (item) {
	            return new Date(item.get('createdAt')).getTime() * -1;
	        }).value();
	        var payrolls = new _payrolls2.default(null, {
	            company: app.company,
	            sortKey: 'createdAt',
	            sortOrder: 'descending'
	        });
	
	        return payrolls.fetch({
	            filter: { where: { status: { lte: 2 } } }
	        }).then(function () {
	            var unsubmittedPayroll = null;
	            if (payrolls.length > 0) {
	                unsubmittedPayroll = payrolls.at(0);
	            }
	            _this.view = new _Layout2.default({
	                el: _this.el,
	                collection: employees,
	                overtimeItems: new _payrollItems2.default(overtimeItems, { company: app.company }),
	                unsubmittedPayroll: unsubmittedPayroll,
	                date: date.toDate()
	            }).render();
	        }).finally(stopLoader);
	    },
	    timesheetUpload: function timesheetUpload() {
	        var _this2 = this;
	
	        var stopLoader = _loader2.default.startFullScreen(this.$el);
	        new _bulkUploads2.default(null, { company: app.company }).fetch({ where: { status: { neq: 'done' } } }).then(function (pendingUploads) {
	            var view = new _TimesheetUpload2.default({
	                model: pendingUploads.at(0)
	            });
	            $(_this2.el).html(view.render().el);
	        }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(14)))

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _Layout = __webpack_require__(1026);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _List = __webpack_require__(1027);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {},
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            date: (0, _moment2.default)().startOf('week').toDate(),
	            overtimeItems: [],
	            unsubmittedPayroll: null
	        });
	        this.listView = new _List2.default({
	            collection: this.collection,
	            date: this.options.date,
	            overtimeItems: this.options.overtimeItems,
	            unsubmittedPayroll: this.options.unsubmittedPayroll
	        });
	        return this.render();
	    },
	    render: function render() {
	        var weekStart = (0, _moment2.default)(this.options.date).startOf('week');
	        var weekEnd = (0, _moment2.default)(this.options.date).endOf('week');
	        var week = weekStart.format('DD') + ' - ' + weekEnd.format('DD MMM YYYY');
	        this.$el.html((0, _Layout2.default)({
	            week: week,
	            prevWeek: (0, _moment2.default)(this.options.date).add(-1, 'week').format('DD-MM-YYYY'),
	            nextWeek: (0, _moment2.default)(this.options.date).add(1, 'week').format('DD-MM-YYYY')
	        }));
	        this.$('.js-content').append(this.listView.$el);
	        return this;
	    },
	    remove: function remove() {
	        this.listView.remove();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/timesheet/Layout.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2> Timesheets </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h3 class="timesheet-header">\n                        Week of:\n                        <a class="fa fa-angle-left m-l-md m-r-sm" href="#timesheet/'+
	((__t=( prevWeek ))==null?'':_.escape(__t))+
	'"></a>\n                        <span class="date-box">'+
	((__t=( week ))==null?'':_.escape(__t))+
	'</span>\n                        <a class="fa fa-angle-right m-l-sm" href="#timesheet/'+
	((__t=( nextWeek ))==null?'':_.escape(__t))+
	'"></a>\n                    </h3>\n                </div>\n\n                <div class="ibox-content js-content">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _ModalForm = __webpack_require__(665);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _List = __webpack_require__(1028);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _OvertimeModal = __webpack_require__(1029);
	
	var _OvertimeModal2 = _interopRequireDefault(_OvertimeModal);
	
	var _Row = __webpack_require__(1030);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddOvertimeModal = _ModalForm2.default.extend({
	    events: function events() {
	        var parentEvents = _.isFunction(_ModalForm2.default.prototype.events) ? _ModalForm2.default.prototype.events() : _ModalForm2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'change .js-ext-employees': 'selectEmployees',
	            'change .js-ext-overtime': 'selectOvertime'
	        });
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _OvertimeModal2.default,
	            employees: null,
	            overtimeItems: null,
	            actOnSave: false,
	            actOnCancel: false,
	            actOnDestroy: false,
	            templateExtra: {}
	        });
	
	        this.options.templateExtra = _.extend(this.options.templateExtra, {
	            employees: this.options.employees || [],
	            overtimeItems: this.options.overtimeItems || []
	        });
	
	        this.selectedEmployees = [];
	        this.selectedOvertime = this.options.overtimeItems.map(function (o) {
	            return o.id;
	        });
	        _ModalForm2.default.prototype.initialize.apply(this, [this.options]);
	        this.bindHandlers();
	        return this.render();
	    },
	    bindHandlers: function bindHandlers() {
	        this.options.employees.on('sync', this.render, this);
	        this.options.employees.on('sync', this.updateSelectedEmployees, this);
	        return this;
	    },
	    unbindHandlers: function unbindHandlers() {
	        this.options.employees.off(null, null, this);
	        return this;
	    },
	    updateSelectedEmployees: function updateSelectedEmployees() {
	        this.$('.js-ext-employees').val(false);
	        this.selectedEmployees = this.options.employees.map(function (e) {
	            return e.id;
	        });
	    },
	    render: function render() {
	        this.$el.html(this.options.template(this.options.templateExtra || {}));
	        this.$('.js-chosen').chosen({ width: '100%' });
	        return this;
	    },
	    selectEmployees: function selectEmployees(ev) {
	        var $select = this.$(ev.currentTarget);
	        var selected = $select.val();
	
	        if (selected.length === 0) {
	            this.selectedEmployees = this.options.employees.map(function (e) {
	                return e.id;
	            });
	            return;
	        }
	        this.selectedEmployees = selected;
	    },
	    selectOvertime: function selectOvertime(ev) {
	        var $select = this.$(ev.currentTarget);
	        var selected = $select.val();
	
	        if (selected.length === 0) {
	            this.selectedOvertime = this.options.overtimeItems.map(function (o) {
	                return o.id;
	            });
	            return;
	        }
	        this.selectedOvertime = selected;
	    },
	    save: function save(ev) {
	        ev.preventDefault();
	        this.trigger('save', {
	            employees: this.selectedEmployees,
	            overtime: this.selectedOvertime
	        });
	
	        this.updateSelectedEmployees();
	        this.selectedOvertime = this.options.overtimeItems.map(function (o) {
	            return o.id;
	        });
	    }
	});
	
	module.exports = _PaginatedList2.default.extend({
	    tagName: 'table',
	    className: 'table table-striped table-timesheet',
	
	    events: function events() {
	        return Object.assign(_PaginatedList2.default.prototype.events(), {
	            'click .js-save': 'save',
	            'click .js-cancel': 'fetchTimeEntries',
	            'click .js-add-overtime': 'showAddOvertime'
	        });
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            unsubmittedPayroll: null,
	            date: (0, _moment2.default)().startOf('week').toDate(),
	            overtimeItems: []
	        });
	        this.addOvertimeModal = new AddOvertimeModal({
	            employees: this.collection,
	            overtimeItems: this.options.overtimeItems
	        });
	        this.views = [];
	        this.collection.on('sync', this.fetchTimeEntries, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	        this.bindHandlers();
	        return this;
	    },
	    bindHandlers: function bindHandlers() {
	        this.addOvertimeModal.on('save', this.addOvertimeTimeEntries, this);
	        this.addOvertimeModal.on('save', this.hideAddOvertime, this);
	
	        app.events.on('navigate', function (status) {
	            if (this.collection.dirtyTimeEntries()) {
	                status.unsaved = true;
	                status.msg = 'You have unsaved changes.  Exiting this ' + 'page will result in the changes being discarded.';
	            } else {
	                status.unsaved = false;
	            }
	        }, this);
	
	        return this;
	    },
	    unbindHandlers: function unbindHandlers() {
	        this.addOvertimeModal.off(null, null, this);
	        app.events.off(null, null, this);
	        return this;
	    },
	    beforePageChange: function beforePageChange() {
	        if (this.collection.dirtyTimeEntries()) {
	            return _alerts2.default.show('confirm', {
	                title: 'Unsaved changes',
	                text: 'There are unsaved changes. Navigating to a different' + 'page will result in the changes being discarded.',
	                confirmButtonText: 'Continue',
	                cancelButtonText: 'Stay'
	            });
	        }
	        return (0, _bluebird.resolve)(true);
	    },
	    render: function render() {
	        this.$el.html((0, _List2.default)({
	            dayLabels: _moment2.default.weekdaysShort(),
	            total: this.collection.length,
	            pagination: this.collection.getPaginationInfo()
	        }));
	        this.renderModels();
	        this.hideLoader();
	
	        this.undelegateEvents();
	        this.delegateEvents();
	        return this;
	    },
	    fetchTimeEntries: function fetchTimeEntries() {
	        var _this = this;
	
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	        this.collection.fetchTimeEntries(app.company, this.options.date).then(function () {
	            return _this.render();
	        });
	    },
	    renderModels: function renderModels() {
	        var _this2 = this;
	
	        this.views.forEach(function (view) {
	            return view.remove();
	        });
	        this.views = [];
	
	        this.collection.forEach(function (model) {
	            var view = new _Row2.default({
	                model: model,
	                date: _this2.options.date
	            });
	            view.on('re-render', _this2.render, _this2);
	            _this2.views.push(view.render());
	            _this2.$('.js-rows-anchor').after(view.$el);
	        });
	        return this;
	    },
	    hideLoader: function hideLoader() {
	        this.stopLoader();
	    },
	    resetPayrollConfirm: function resetPayrollConfirm() {
	        var _this3 = this;
	
	        return new _bluebird2.default(function (resolve, reject) {
	            if (!_.isObject(_this3.options.unsubmittedPayroll)) {
	                return resolve(true);
	            }
	
	            _modal2.default.confirm({
	                title: 'Your saved payroll will be modified!',
	                text: 'You have an unsubmitted payroll saved. ' + 'If you continue, the payroll details of all employees ' + 'will be updated based on the modifications you are ' + 'about to save. Also, any unsaved payroll details ' + 'will be lost.',
	                customClass: 'sweet-alert-error',
	                confirmButtonText: 'Yes, Save Timesheet',
	                callback: function callback(confirm) {
	                    if (confirm) {
	                        resolve(true);
	                    } else {
	                        reject();
	                    }
	                }
	            });
	        });
	    },
	    save: function save(ev) {
	        var _this4 = this;
	
	        ev.preventDefault();
	
	        return this.resetPayrollConfirm().then(function () {
	            _this4.stopLoader = _loader2.default.startFullScreen(_this4.$(ev.currentTarget));
	        }).then(function () {
	            return _this4.collection.saveTimeEntries();
	        })
	        // reset the payroll
	        .then(function () {
	            if (_this4.options.unsubmittedPayroll) {
	                return _this4.options.unsubmittedPayroll.reset();
	            }
	
	            return (0, _bluebird.resolve)(true);
	        }).then(function () {
	            _modal2.default.showAlertSuccess('Your changes have been saved');
	        }).catch(function () {
	            _this4.stopLoader = _loader2.default.startFullScreen(_this4.$(ev.currentTarget));
	        }).finally(function () {
	            return _this4.hideLoader();
	        });
	    },
	    navigate: function navigate() {
	        app.mainRouter.navigate('timesheet');
	    },
	    showAddOvertime: function showAddOvertime() {
	        this.addOvertimeModal.show();
	    },
	    hideAddOvertime: function hideAddOvertime() {
	        this.addOvertimeModal.hide();
	    },
	    addOvertimeTimeEntries: function addOvertimeTimeEntries(data) {
	        var _this5 = this;
	
	        var selectedEmployees = data.employees.map(function (id) {
	            return _this5.collection.get(id);
	        });
	        var selectedOvertime = data.overtime.map(function (id) {
	            return _this5.options.overtimeItems.get(id);
	        });
	        selectedEmployees.forEach(function (employee) {
	            selectedOvertime.forEach(function (overtime) {
	                var date = _this5.options.date;
	                var commencementDate = employee.get('commencementDate') ? (0, _moment2.default)(employee.get('commencementDate')).startOf('day') : (0, _moment2.default)(date);
	                if ((0, _moment2.default)(date).startOf('day').isBefore(commencementDate)) {
	                    date = commencementDate.toDate();
	                }
	                employee.getTimeEntry(date, overtime);
	            });
	        });
	
	        this.render();
	    },
	    remove: function remove() {
	        _PaginatedList2.default.prototype.remove.apply(this, arguments);
	        this.views.forEach(function (view) {
	            return view.remove();
	        });
	        this.views = [];
	        this.undelegateEvents();
	        this.unbindHandlers();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/timesheet/List.ejs -->\n<thead>\n    <tr>\n        <th class="employee"></th>\n        ';
	 dayLabels.forEach(function (label) { 
	__p+='\n            <th class="day">'+
	((__t=( label ))==null?'':_.escape(__t))+
	'</th>\n        ';
	 }) 
	__p+='\n        <th class="total">Weekly Total</th>\n        <th class="total">Monthly Total</th>\n    </tr>\n</thead>\n<tbody class="js-empty-msg hidden">\n    <tr>\n        <td colspan="10">\n            <h1 class="text-center">\n                You haven\'t added any employees yet.\n            </h1>\n        </td>\n    </tr>\n</tbody>\n<tbody class="js-rows-anchor hidden"></tbody>\n<tfoot>\n    <tr>\n        <td colspan="10">\n            '+
	((__t=( __webpack_require__(669)(
	                { pagination: pagination, items: 'employees' }
	            ) ))==null?'':__t)+
	'\n        </td>\n    </tr>\n</tfoot>\n<tfoot>\n    <tr>\n        <td colspan="10">\n            <div class="pull-left">\n                <button class="js-add-overtime btn btn-primary btn-outline btn-w-m">\n                    + Add Overtime\n                </button>\n\n                <a class="btn btn-primary btn-outline" href="#timesheet-upload"\n                    data-toggle="tooltip" data-title="Add multiple timesheets at once" data-placement="top" data-delayed>\n                    Upload Timesheets\n                </a>\n            </div>\n            <div class="pull-right">\n                <button class="js-cancel btn btn-warning btn-w-m btn-cancel"\n                    data-toggle="tooltip" data-title="No changes will be saved"\n                    data-placement="top" data-delayed>\n                    <i class="fa fa-exclamation-triangle"></i>\n                    Cancel\n                </button>\n                <button class="js-save btn btn-primary m-l-xs">\n                    <i class="fa fa-check"></i>\n                    Save changes\n                </button>\n            </div>\n        </td>\n    </tr>\n</tfoot>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/timesheet/OvertimeModal.ejs -->\n<div class="modal-dialog">\n    <div class="modal-content animated sweet">\n        <div class="modal-header">\n            Add Overtime\n        </div>\n        <div class="modal-body">\n            <div class="row">\n                <form class="form-horizontal" role="form">\n                    <div class="form-group">\n                        <label class="col-sm-4 control-label">\n                            Employees\n                        </label>\n                        <div class="col-sm-8">\n                            <select name="employees" class="form-control\n                                js-ext js-ext-employees js-chosen" multiple\n                                data-placeholder="All">\n                                ';
	 employees.forEach(function(employee) { 
	__p+='\n                                    <option value="'+
	((__t=( employee.id ))==null?'':_.escape(__t))+
	'">\n                                        '+
	((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-4 control-label">\n                            Overtime\n                        </label>\n                        <div class="col-sm-8">\n                            <select name="overtime" class="form-control\n                                js-ext js-ext-overtime js-chosen" multiple\n                                data-placeholder="All">\n                                ';
	 overtimeItems.forEach(function(ot) { 
	__p+='\n                                    <option value="'+
	((__t=( ot.id ))==null?'':_.escape(__t))+
	'">\n                                        '+
	((__t=( ot.get('name') ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="js-cancel btn btn-w-m btn-warning">\n                <i class="fa fa-exclamation-triangle"></i> Cancel\n            </button>\n            <button type="button"\n                    class="js-save btn btn-w-m btn-primary m-l-xs">\n                <i class="fa fa-check"></i> Add\n            </button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _Row = __webpack_require__(1031);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _payrollItem = __webpack_require__(591);
	
	var _payrollItem2 = _interopRequireDefault(_payrollItem);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    tagName: 'tbody',
	
	    events: function events() {
	        return {
	            'change .js-hours': 'updateHours',
	            'focus .js-hours': 'selectAllText',
	            'click .js-destroy': 'destroy'
	        };
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            date: (0, _moment2.default)().startOf('week').toDate()
	        });
	        return this;
	    },
	    render: function render() {
	        var date = (0, _moment2.default)(this.options.date);
	        var weekStart = date.clone().startOf('week');
	        var weekEnd = date.clone().endOf('week');
	        var dates = [];
	        while (!weekStart.isAfter(weekEnd)) {
	            dates.push(weekStart.clone());
	            weekStart.add(1, 'day');
	        }
	        this.$el.html((0, _Row2.default)({
	            model: this.model,
	            dates: dates
	        }));
	        this.renderTotals();
	        return this;
	    },
	    selectAllText: function selectAllText(ev) {
	        this.$(ev.currentTarget).select();
	    },
	    updateHours: function updateHours(ev) {
	        var $input = this.$(ev.currentTarget);
	        var hours = _.isNaN(parseFloat($input.val() || 0)) ? 0 : parseFloat($input.val() || 0);
	        var date = (0, _moment2.default)($input.data('entryDate'), 'DDMMYYYY');
	        var item = $input.data('entryItem') ? new _payrollItem2.default({ id: $input.data('entryItem') }) : null;
	        var timeEntry = this.model.getTimeEntry(date.toDate(), item);
	
	        if (!timeEntry) {
	            return;
	        }
	
	        timeEntry.set({ hours: hours });
	        $input.val(hours);
	        this.renderTotals(date);
	        return this;
	    },
	    renderTotals: function renderTotals() {
	        var _this = this;
	
	        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	        var $weeklyTotal = this.$('.js-weekly-row-total');
	        var $monthlyTotal = this.$('.js-monthly-row-total');
	        var $globalWeekly = this.$('.js-totals .js-weekly-total');
	        var $globalMonthly = this.$('.js-totals .js-monthly-total');
	
	        var globalWeeklyTotal = 0;
	        var globalMonthlyTotal = 0;
	
	        $weeklyTotal.each(function (i, el) {
	            var $el = _this.$(el);
	            var item = $el.data('entryItem') ? new _payrollItem2.default({ id: $el.data('entryItem') }) : null;
	            var total = _this.model.getTimeEntriesWeeklyTotal(_this.options.date, item);
	            $el.val(parseFloat((total || 0).toFixed(2)));
	            globalWeeklyTotal += total || 0;
	        });
	
	        $monthlyTotal.each(function (i, el) {
	            var $el = _this.$(el);
	            var item = $el.data('entryItem') ? new _payrollItem2.default({ id: $el.data('entryItem') }) : null;
	            var total = _this.model.getTimeEntriesMonthlyTotal(_this.options.date, item);
	            $el.val(parseFloat((total || 0).toFixed(2)));
	            globalMonthlyTotal += total || 0;
	        });
	
	        $globalWeekly.val(parseFloat((globalWeeklyTotal || 0).toFixed(2)));
	        $globalMonthly.val(parseFloat((globalMonthlyTotal || 0).toFixed(2)));
	
	        if (date) {
	            var $dailyTotal = this.$('.js-daily-total[data-entry-date=' + date.format('DDMMYYYY') + ']');
	            $dailyTotal.val(parseFloat((this.model.getTimeEntriesDailyTotal(date.toDate()) || 0).toFixed(2)));
	        }
	    },
	    destroyConfirm: function destroyConfirm() {
	        var resolver = (0, _bluebird.defer)();
	
	        _alerts2.default.show('infoConfirm', {
	            showCloseButton: true,
	            allowEscapeKey: true,
	            width: 700,
	            title: 'Delete all entries in current month?',
	            text: 'If you agree we\'ll delete all monthly entries related to ' + 'this item. Otherwise, we\'ll only delete the entries for ' + 'the current week.\n\n' + 'Note that you can cancel this operation by clicking ' + 'outside this modal dialog, or pressing the "Esc" key.',
	            confirmButtonText: 'Yes, Delete All Month Entries',
	            cancelButtonText: 'No, Only Delete Week Entries',
	            callback: function callback(confirm) {
	                if (confirm) {
	                    resolver.resolve(false);
	                } else {
	                    resolver.resolve(true);
	                }
	            }
	        });
	
	        return resolver.promise;
	    },
	    destroy: function destroy(ev) {
	        var _this2 = this;
	
	        var $el = this.$(ev.currentTarget);
	        var itemId = $el.data('entryItemId');
	        var item = itemId ? new _payrollItem2.default({ id: itemId }) : null;
	        var stopLoader = function stopLoader() {};
	
	        return this.destroyConfirm().then(function (weekOnly) {
	            stopLoader = _loader2.default.startFullScreen();
	            return _this2.model.deleteTimeEntries(_this2.options.date, item, weekOnly ? 'week' : 'month');
	        }).then(function () {
	            _this2.trigger('re-render');
	        }, function () {
	            return stopLoader();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/timesheet/Row.ejs -->\n';
	 model.getTimeEntryItems().forEach(function (item) { 
	__p+='\n<tr>\n    <td>\n        ';
	 if (!item) { 
	__p+='\n            '+
	((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
	'\n        ';
	 } else { 
	__p+='\n            '+
	((__t=( item.get('name') ))==null?'':_.escape(__t))+
	'\n            <a class="fa fa-times btn-delete js-destroy m-l-sm"\n                data-entry-item-id="'+
	((__t=( item.id ))==null?'':_.escape(__t))+
	'"\n                tabindex="-1"></a>\n        ';
	 } 
	__p+='\n    </td>\n    ';
	 rowEntry = null; 
	__p+='\n    ';
	 dates.forEach(function (date) { 
	__p+='\n        ';
	 entry = model.getTimeEntry(date.toDate(), item) 
	__p+='\n        <td class="form-group">\n            ';
	 if (entry) { 
	__p+='\n                ';
	 rowEntry = entry 
	__p+='\n            <input type="text" name="hours-'+
	((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
	'"\n                data-entry-date="'+
	((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
	'"\n                data-entry-item="'+
	((__t=( entry.get('payrollItemId') ))==null?'':_.escape(__t))+
	'"\n                class="form-control form-control-invisible js-hours"\n                value="'+
	((__t=( parseFloat((entry.get('hours') || 0).toFixed(2)) ))==null?'':_.escape(__t))+
	'"\n                data-value-type="float">\n            ';
	 } 
	__p+='\n        </td>\n    ';
	 }) 
	__p+='\n    <td class="total">\n        <input type="text" name="weekly-regular-total-'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n            class="form-control form-control-invisible js-weekly-row-total"\n            ';
	 if (rowEntry) { 
	__p+='\n                data-entry-item="'+
	((__t=( rowEntry.get('payrollItemId') ))==null?'':_.escape(__t))+
	'"\n            ';
	 } 
	__p+='\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n    </td>\n    <td class="total">\n        <input type="text" name="monthly-regular-total-'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n            class="form-control form-control-invisible js-monthly-row-total"\n            ';
	 if (rowEntry) { 
	__p+='\n                data-entry-item="'+
	((__t=( rowEntry.get('payrollItemId') ))==null?'':_.escape(__t))+
	'"\n            ';
	 } 
	__p+='\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n    </td>\n</tr>\n';
	 }) 
	__p+='\n<tr class="js-totals">\n    <td>\n        <strong>Totals</strong>\n    </td>\n    ';
	 dates.forEach(function (date) { 
	__p+='\n        <td class="form-group">\n            <input type="text" name="daily-hours-'+
	((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
	'"\n                class="form-control form-control-invisible js-daily-total"\n                data-entry-date="'+
	((__t=( date.format('DDMMYYYY') ))==null?'':_.escape(__t))+
	'"\n                value="'+
	((__t=( model.getTimeEntriesDailyTotal(date.toDate()) ))==null?'':_.escape(__t))+
	'"\n                readonly tabindex="-1"\n                data-value-type="float">\n        </td>\n    ';
	 }) 
	__p+='\n    <td class="total">\n        <input type="text" name="weekly-total-'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n            class="form-control form-control-invisible js-weekly-total"\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n    </td>\n    <td class="total">\n        <input type="text" name="monthly-total-'+
	((__t=( model.id ))==null?'':_.escape(__t))+
	'"\n            class="form-control form-control-invisible js-monthly-total"\n            value="0"\n            tabindex="-1"\n            readonly data-value-type="float">\n        </td>\n</tr>\n\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {/* global Backbone */
	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _Main = __webpack_require__(1033);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _JobStatus = __webpack_require__(1034);
	
	var _JobStatus2 = _interopRequireDefault(_JobStatus);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _bulkUpload = __webpack_require__(813);
	
	var _bulkUpload2 = _interopRequireDefault(_bulkUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'change input[type="file"]': 'selectFile',
	        'click .js-action-1': 'uploadFile'
	    },
	
	    render: function render() {
	        this.$el.html((0, _Main2.default)({
	            model: this.model || false
	        }));
	
	        this.$('.js-action-1').prop('disabled', true);
	
	        _tooltip2.default.init(this);
	
	        if (this.model && this.model.get('state') !== 'done') {
	            this.renderJobStatus();
	        }
	        return this;
	    },
	
	    selectFile: function selectFile(e) {
	        var _this = this;
	
	        var files = [].concat(_toConsumableArray(this.$(e.currentTarget)[0].files));
	
	        if (files.length === 0) {
	            return;
	        }
	
	        var file = files.shift();
	        var ext = file.name.split('.').pop();
	
	        if (!ext.match(/^(xls|xlsx)$/i)) {
	            return _alerts2.default.show('error', {
	                title: 'Wrong file type',
	                text: 'Please choose an Excel file'
	            });
	        }
	
	        this.$('.js-action-1').prop('disabled', false);
	        this._file = file;
	        this.$('.js-file-name').text(this._file.name);
	        if (this.$result) {
	            this.$result.fadeOut(50, function () {
	                _this.$('.js-result').html('');
	            });
	        }
	    },
	
	    uploadFile: function uploadFile() {
	        var _this2 = this;
	
	        this.$('.js-file-btn').prop('disabled', true);
	
	        var stopLoader = _loader2.default.startFullScreen(this.$('.js-action-1'));
	        var file = this._file;
	        var originalName = file.name;
	        var ext = originalName.split('.').pop();
	
	        return new _bluebird2.default(function (resolve, reject) {
	            var reader = new FileReader();
	            reader.onload = function (ev) {
	                var base64 = ev.target.result.split(',')[1];
	                _this2.model = new _bulkUpload2.default({
	                    type: 'timesheet',
	                    file: {
	                        name: 'spreadsheet.' + ext,
	                        content: base64
	                    },
	                    companyId: app.company.id
	                });
	                return resolve(true);
	            };
	            reader.onerror = function (err) {
	                return reject(err);
	            };
	            reader.readAsDataURL(file);
	        }).then(function () {
	            return _this2.model.save();
	        }).then(function () {
	            _this2.render();
	        }).finally(stopLoader);
	    },
	
	    renderJobStatus: function renderJobStatus() {
	        var _this3 = this;
	
	        if (!this.model) {
	            this.$('.js-status').html('');
	            return;
	        }
	
	        this.$('.js-status').html((0, _JobStatus2.default)({
	            model: this.model
	        }));
	
	        var refresh = function refresh() {
	            if (!_this3.model || _this3.model.get('state') === 'done') {
	                _this3.render();
	                _this3.$('.js-status').html((0, _JobStatus2.default)({
	                    model: _this3.model
	                }));
	                return;
	            }
	
	            setTimeout(function () {
	                _this3.model.fetch().then(function () {
	                    _this3.$('.js-status').html((0, _JobStatus2.default)({
	                        model: _this3.model
	                    }));
	                    refresh();
	                });
	            }, 2000);
	        };
	        refresh();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/timesheet/timesheetUpload/Main.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Upload Timesheets for Employees</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="ibox float-e-margins\n        '+
	((__t=( model && model.get('state') !== 'done' ? 'hidden': '' ))==null?'':_.escape(__t))+
	'">\n        <div class="ibox-title">\n            <h5>Choose a file and click \'Continue\'</h5>\n        </div>\n        <div class="ibox-content tab-content">\n            <div class="flex-container-row">\n                <label class="js-file-btn btn btn-w-m btn-success ladda-button"\n                data-style="swap">\n                    Select File\n                    <input type="file" class="js-file-input hide">\n                </label>\n                <span class="js-file-name m-l-md">\n                    No file chosen\n                </span>\n            </div>\n            <div class="row m-t-md m-l-sm">\n                <a href="'+
	((__t=( app.company.timesheetsTemplateDownloadUrl() ))==null?'':_.escape(__t))+
	'"\n                    target="_blank">\n                    Download template\n                </a>\n            </div>\n\n            <div class="row m-t-md">\n                <div class="col-md-10">\n                    Note:\n                    <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" data-container="body" data-html="true" title=""\n                        data-original-title=\n                            \'Timesheets upload\'\n                    ></i>\n                    Any overtime items paid on a monthly basis should be added as Monthly Recurring Payroll Items in Employment Details tab in the employee\'s profile (leaving the units as 0) before uploading timesheets to ensure accurate PCB calculations.\n                </div>\n\n                <div class="col-md-2">\n                    <button type="button" class="btn btn-primary js-action-1">\n                        Continue\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="js-status"></div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employer/templates/timesheet/timesheetUpload/JobStatus.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        ';
	 if (model.get('state') === 'pending') { 
	__p+='\n            <h5>File uploaded. Process about to start...</h5>\n        ';
	 } else if (model.get('state') === 'processing') { 
	__p+='\n            <h5>Creating timesheets...</h5>\n        ';
	 } else { 
	__p+='\n            <h5>Bulk upload complete.</h5>\n        ';
	 } 
	__p+='\n    </div>\n    <div class="ibox-content tab-content">\n        ';
	 if (model.get('state') !== 'done') { 
	__p+='\n            <div>\n                <i class="fa fa-clock-o"></i>\n                <label>Awaiting results...</label>\n            </div>\n        ';
	 } else { 
	__p+='\n            ';
	 if (model.get('itemCount')) { 
	__p+='\n                <div>\n                    <i class="fa fa-check green" aria-hidden="true"></i>\n                    <label>\n                        Successfully created time entries for\n                        '+
	((__t=( model.get('itemCount') ))==null?'':_.escape(__t))+
	' employees.\n                    </label>\n                </div>\n            ';
	 } else { 
	__p+='\n                <div>\n                    <i class="fa fa-times red" aria-hidden="true"></i>\n                    <label>\n                        No data imported.\n                    </label>\n                </div>\n            ';
	 } 
	__p+='\n\n            ';
	 if (model.get('itemCount') && model.get('uploadErrors').length) { 
	__p+='\n                <hr/>\n            ';
	 } 
	__p+='\n\n            ';
	 if (model.get('uploadErrors').length) { 
	__p+='\n                <div>\n                    <label>\n                        There were some errors when trying to import timesheets:\n                    </label>\n                </div>\n                <div>\n                    ';
	 model.get('uploadErrors').forEach(function (e) { 
	__p+='\n                        <div>\n                            <i class="fa fa-times red" aria-hidden="true"></i>\n                            <span>'+
	((__t=( e.name ))==null?'':_.escape(__t))+
	'</span>\n                            <ul>\n                                ';
	 e.errors.forEach(function (error) { 
	__p+='\n                                    <li>'+
	((__t=( error ))==null?'':_.escape(__t))+
	'</li>\n                                ';
	 }); 
	__p+='\n                            </ul>\n                        </div>\n                    ';
	 }); 
	__p+='\n                </div>\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Backbone) {'use strict';
	
	var _Main = __webpack_require__(1036);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Profile = __webpack_require__(1038);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Base = __webpack_require__(625);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _PersonalSettings = __webpack_require__(681);
	
	var _PersonalSettings2 = _interopRequireDefault(_PersonalSettings);
	
	var _CustomerSupportForm = __webpack_require__(1043);
	
	var _CustomerSupportForm2 = _interopRequireDefault(_CustomerSupportForm);
	
	var _PersonalSettings3 = __webpack_require__(1045);
	
	var _PersonalSettings4 = _interopRequireDefault(_PersonalSettings3);
	
	var _Dashboard = __webpack_require__(1047);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Payslips = __webpack_require__(1055);
	
	var _Payslips2 = _interopRequireDefault(_Payslips);
	
	var _Calendar = __webpack_require__(1062);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'profile': 'profile',
	        'personalSettings': 'personalSettings',
	        'customerSupport': 'customerSupport'
	    },
	
	    titles: {
	        'profile': 'Profile',
	        'personalSettings': 'Personal Settings',
	        'customerSupport': 'Contact Support'
	    },
	
	    initialize: function initialize() {
	        this.mainView = new _Main2.default();
	        if (app.company.get('updateRestricted')) {
	            $('#update-restricted-notification').css({ display: 'block' });
	        }
	
	        this.subRouters = [new _Dashboard2.default({ el: this.mainView.childEl }), new _Payslips2.default({ el: this.mainView.childEl }), new _Calendar2.default({ el: this.mainView.childEl })];
	
	        Backbone.history.on('route', function () {
	            this.mainView.setActiveLink(Backbone.history.getFragment());
	            window.scrollTo(0, 0);
	        }.bind(this));
	
	        $(window).trigger('resize');
	        $(window).on('scroll', function () {
	            var scroll = $(window).scrollTop();
	            if (scroll >= 185) {
	                $('.ibox-help').addClass('fixed');
	            } else {
	                $('.ibox-help').removeClass('fixed');
	            }
	        });
	    },
	
	    profile: function profile() {
	        this.undelegateEvents();
	        this.view = new _Profile2.default({
	            el: this.mainView.childEl
	        });
	    },
	
	    personalSettings: function personalSettings() {
	        this.undelegateEvents();
	
	        this.view = new _PersonalSettings2.default({
	            el: this.mainView.childEl,
	            model: app.user,
	            subViews: [new _PersonalSettings4.default({ model: app.user })]
	        });
	    },
	
	    customerSupport: function customerSupport() {
	        this.undelegateEvents();
	
	        this.view = new _CustomerSupportForm2.default({
	            el: this.mainView.childEl,
	            model: app.user
	        });
	    },
	
	    notFound: function notFound() {
	        window.location.replace('/#dashboard');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(523)))

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(645);
	var navMenuTpl = __webpack_require__(1037);
	var tooltip = __webpack_require__(541);
	var QueryString = __webpack_require__(554);
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	    childEl: '#main-area',
	
	    events: {
	        'click .js-free-account-setup': 'freeAccountSetup'
	    },
	
	    initialize: function initialize() {
	        this.render();
	    },
	
	    render: function render() {
	        var id = app.company.get('mppAdminId');
	        var logoUrl = app.user.getLogoUrl(id);
	        var params = QueryString.parse(window.location.search);
	
	        this.$el.html(template({
	            navMenu: navMenuTpl({
	                userName: app.user.get('name'),
	                companyName: app.company ? app.company.get('companyName') || '' : '',
	                isAdmin: params && params.employee
	            }),
	            headerMenu: null,
	            version: app.version,
	            whitelabel: app.company.get('mppAdminId') || app.subscription && app.subscription.get('plan') !== 'client',
	            logoUrl: logoUrl
	        }));
	
	        $('body').removeClass('gray-bg');
	
	        this.$('#side-menu').metisMenu({
	            toggle: false,
	            activeClass: 'active-group'
	        });
	
	        this.$el.find('.logo img').on('load', function (e) {
	            $(e.target.parentElement).removeClass('hidden');
	        }).on('error', function (e) {
	            e.target.src = '';
	        });
	
	        tooltip.initBody();
	    },
	
	    setActiveLink: function setActiveLink(route) {
	        this.$el.find('#side-menu li').removeClass('active');
	
	        this.$el.find('#side-menu a[href="#' + route + '"]').parent().addClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/NavMenu.ejs -->\n<ul class="nav metismenu" id="side-menu">\n    <li class="nav-header">\n        <div class="dropdown profile-element">\n            <a data-toggle="dropdown" class="dropdown-toggle"\n               href="#">\n                <span class="clear">\n                    <span class="block m-t-xs">\n                        <strong class="font-bold">\n                            '+
	((__t=( companyName ))==null?'':_.escape(__t))+
	'\n                        </strong>\n                        ';
	 if (isAdmin) { 
	__p+='\n                            <br>[Logged in as Admin]\n                        ';
	 } 
	__p+='\n                    </span>\n                    <span class="text-muted text-xs block">\n                        '+
	((__t=( userName ))==null?'':_.escape(__t))+
	'\n                        <b class="caret"></b>\n                    </span>\n                </span>\n            </a>\n            <ul class="dropdown-menu animated fadeInDown m-t-xs">\n                <li>\n                    <a href="#personalSettings">\n                        Personal Settings\n                    </a>\n                </li>\n                <li>\n                    <a href="#logout">Logout</a>\n                </li>\n            </ul>\n        </div>\n        <div class="dropdown mini-navbar-profile-element">\n            <a data-toggle="dropdown" class="dropdown-toggle">\n                <i class="fa fa-user"></i>\n                <b class="caret"></b>\n            </a>\n            <ul class="dropdown-menu animated fadeInDown m-t-xs">\n                <li>\n                    <a href="#personalSettings">\n                        Personal Settings\n                    </a>\n                </li>\n                <li><a href="#logout">Logout</a></li>\n            </ul>\n        </div>\n    </li>\n    <li id="li-lnk-dashboard-view" class="active">\n        <a id="lnk-dashboard-view" href="#dashboard"><i\n                class="fa fa-tachometer"></i> <span\n                class="nav-label">Dashboard</span></a>\n    </li>\n    <li><a href="#profile"><i class="fa fa-user"></i> <span\n                class="nav-label">Profile</span></a></li>\n    <li>\n        <a href="#calendar">\n            <i class="fa fa-calendar"></i>\n            <span class="nav-label">Leave</span>\n        </a>\n    </li>\n    <li><a href="#payslips"><i class="fa fa-clipboard"></i> <span\n                class="nav-label">Payslips</span></a></li>\n</ul>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var template = __webpack_require__(1039);
	var RequestChangesModal = __webpack_require__(1040);
	var Address = __webpack_require__(1042);
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize() {
	        this.showProfile();
	    },
	    events: {
	        'click .js-request-changes': 'actionRequestChanges'
	    },
	
	    showProfile: function showProfile() {
	        var _this = this;
	
	        return (0, _bluebird.all)([app.employee.fetchCompanyLocation(), app.employee.fetchPosition(), app.employee.fetchAddress(), app.employee.fetchBankAccount()]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                location = _ref2[0];
	
	            if (location) {
	                return location.fetchAddress();
	            }
	            return (0, _bluebird.resolve)();
	        }).then(function () {
	            _this.model = app.employee;
	            _this.render();
	        });
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            model: this.model,
	            Address: Address,
	            nameAbbreviation: this.model.has('imageUrl') ? '' : this.model.getNameAbbreviation()
	        }));
	
	        this.requestChangesModal = new RequestChangesModal();
	        this.$el.append(this.requestChangesModal.$el);
	    },
	
	    actionRequestChanges: function actionRequestChanges(event) {
	        this.requestChangesModal.render(event);
	        this.requestChangesModal.show();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/Profile.ejs -->\n<div id="content" class="wrapper wrapper-content"><div>\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <div class="row">\n                        <div class="col-xs-3">\n                            <h3>Profile</h3>\n                        </div>\n\n                        <div class="col-xs-9 visible-xs text-right">\n                            <button type="button" class="btn btn-w-m btn-primary is-marginless\n                                ladda-button js-request-changes" data-style="swap">\n                                <i class="fa fa-pencil-square-o"></i>\n                                Request Changes\n                            </button>\n                        </div>\n                    </div>\n                </div>\n                <div class="ibox-content user-profile">\n                    <div class="user-image"\n                            style="background-image: url('+
	((__t=( model.getImageUrl() || '' ))==null?'':_.escape(__t))+
	');">\n                        <abbr>'+
	((__t=( nameAbbreviation ))==null?'':_.escape(__t))+
	'</abbr>\n                    </div>\n                    <h3 class="user-profile-name">\n                        '+
	((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
	'\n                    </h3>\n\n                    <h3>Personal Details</h3>\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-sm-6"><b>Email</b></p>\n                                <p class="col-sm-6">'+
	((__t=( model.get('email') ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>ID Type & Number</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('idStr') ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Gender</b></p>\n                                <p class="col-xs-6">'+
	((__t=(
	                                    model.isMale() ? 'Male' :
	                                    model.isFemale() ? 'Female' : 'Unknown'
	                                    ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Date of Birth</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getFormattedDate('dob', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                    </div>\n                    <hr class="hr-line-dashed">\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Resident Status</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('isResident') ? 'Resident' : 'Non-Resident'))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Race</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getRace() ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Type of Resident</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getResidentType() ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Disability Status</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('isDisabled') ? 'Disabled' : 'Not Disabled'))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Nationality</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getNationality() ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                    </div>\n                    <hr class="hr-line-dashed">\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Marital Status</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getMarriedStatus() ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Children and PCB deduction</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getChildrenCount() ))==null?'':_.escape(__t))+
	'\n                                    ';
	 if (model.getChildrenCount() > 0) { 
	__p+='\n                                    ('+
	((__t=(model.getChildren().join(', ')))==null?'':_.escape(__t))+
	')\n                                    ';
	 } 
	__p+='</p>\n                            </div>\n                        </div>\n                    </div>\n                    <hr class="hr-line-dashed">\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Personal Email</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('personalEmail') ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>State</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getAddress() ? model.getAddress().getStateName() : '' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        ';
	 address = model.getAddress() || false; 
	__p+='\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Street Address</b></p>\n                                <p class="col-xs-6">'+
	((__t=( address ? address.get('line1') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Post Code</b></p>\n                                <p class="col-xs-6">'+
	((__t=( address ? address.get('postcode') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>City</b></p>\n                                <p class="col-xs-6">'+
	((__t=( address ? address.get('city') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Mobile Phone</b></p>\n                                <p class="col-xs-6">'+
	((__t=( address ? address.get('contactPhone') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                    </div>\n                    <hr class="hr-line-dashed">\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Emergency Contact Name</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('emergencyContactName') ? model.get('emergencyContactName') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Preferred Method of Payment</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getPreferredPaymentMethod() ? model.getPreferredPaymentMethod() : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Emergency Contact Phone</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('emergencyContactPhone') ? model.get('emergencyContactPhone') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Bank Details</b></p>\n                                <p class="col-xs-6">';
	 if (model.getBankAccount()) { 
	__p+='\n                                    '+
	((__t=( model.getBankAccount().get('bankName') ))==null?'':_.escape(__t))+
	',\n                                    '+
	((__t=( model.getBankAccount().get('number') ))==null?'':_.escape(__t))+
	'\n                                ';
	 } else { 
	__p+='\n                                    -\n                                ';
	 } 
	__p+='</p>\n                            </div>\n                        </div>\n                    </div>\n                    <hr>\n                    <h3>Employment Details</h3>\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Join Date</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getFormattedDate('commencementDate', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Earning Frequency</b></p>\n                                <p class="col-xs-6">'+
	((__t=(
	                                    ['Unknown', 'Hourly', 'Daily', 'Monthly'][
	                                    model.get('earningsFrequency') || 0
	                                        ]
	                                    ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Position</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.getPositionName() ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Location</b></p>\n                                ';
	 var la = (model.getCompanyLocation()) ?
	                                    model.getCompanyLocation().getAddress() : null 
	__p+='\n                                ';
	 if (la) { 
	__p+='\n                                    <p class="col-xs-6">\n                                        '+
	((__t=( la.getStateName() ))==null?'':_.escape(__t))+
	'\n                                        '+
	((__t=( la.get('city') ))==null?'':_.escape(__t))+
	'\n                                        '+
	((__t=( la.get('line1') ))==null?'':_.escape(__t))+
	'\n                                        ('+
	((__t=(la.get('postcode') ))==null?'':_.escape(__t))+
	')\n                                    </p>\n                                ';
	 } else { 
	__p+='\n                                    <p class="col-xs-6">-</p>\n                                ';
	 } 
	__p+='\n                            </div>\n                        </div>\n                    </div>\n                    <hr>\n                    <h3>Statutory Requirements</h3>\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>Contributing EPF</b></p>\n                                <p class="col-xs-6">'+
	((__t=(
	                                            !model.get('isEpf') ? 'No' :
	                                            !model.get('epfNumber') ? 'Yes, but number is missing':
	                                                'Yes'
	                                        ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>SOCSO Category</b></p>\n                                <p class="col-xs-6">'+
	((__t=(
	                                    [
	                                        'Not applicable',
	                                        'Employment Injury Scheme and Invalidity Scheme',
	                                        'Employment Injury Scheme'
	                                    ][model.get('socsoCategory') || 0]
	                                ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>SSFW number</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('ssfwNumber') ? model.get('ssfwNumber') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <p class="col-xs-6"><b>PCB Number</b></p>\n                                <p class="col-xs-6">'+
	((__t=( model.get('taxNumber') ? model.get('taxNumber') : '-' ))==null?'':_.escape(__t))+
	'</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="wizard-footer text-right hidden-xs">\n                    <a href="#payslips" type="button"\n                        class="btn btn-w-m btn-success ladda-button js-profile-payslips"\n                        data-style="swap"\n                        data-toggle="tooltip" data-title=""\n                        data-placement="top" data-delayed=""\n                        data-original-title="" title="">\n                        <i class="fa fa-clipboard"></i>\n                        Payslips\n                    </a>\n                    <button type="button" class="btn btn-w-m btn-primary\n                        ladda-button js-request-changes" data-style="swap">\n                        <i class="fa fa-pencil-square-o"></i>\n                        Request Changes\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div></div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var template = __webpack_require__(1041);
	var modal = __webpack_require__(532);
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-send': 'actionSend'
	    },
	
	    render: function render(event) {
	        this.event = event;
	        this.$el.html(template({}));
	        return this;
	    },
	
	    actionSend: function actionSend() {
	        var _this = this;
	
	        var text = this.$('.js-text').val();
	        app.employee.requestChanges(text).then(function () {
	            _this.hide();
	            modal.showAlertSuccess('Your request has been sent!');
	        });
	    },
	
	    show: function show() {
	        this.$('.js-approval-modal').modal('show');
	        this.$('textarea').focus();
	    },
	
	    hide: function hide() {
	        this.$('.js-approval-modal').modal('hide');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/RequestChangesModal.ejs -->\n<div class="js-approval-modal modal modal-requestChanges" tabindex="-1" aria-hidden="true" role="dialog">\n    <div class="modal-dialog">\n        <div class="modal-content animated sweet">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal">\n                    <span aria-hidden="true">×</span><span class="sr-only">Close</span>\n                </button>\n                <div class="modal-title"><h3>Request Changes</h3></div>\n            </div>\n            <div class="modal-body">\n                Description\n                <textarea class="form-control js-text" rows="5"></textarea>\n                <hr>\n                <div class="text-center">\n                    <button type="button" data-dismiss="modal" class="btn btn-danger btn-w-m btn-lg">Cancel</button>\n                    <button type="button" class="js-send btn btn-primary btn-w-m btn-lg">Send Request</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseModel = __webpack_require__(733);
	var Model;
	
	/**
	 * @name module:models.Address
	 * @augments module:models.BaseModel
	 * @constructor
	 *
	 * @property {string} line1 - The street name, building and apt number
	 * @property {string} city - The city's name
	 * @property {string} state - The state code
	 * @property {string} postcode - The postal code
	 * @property {string} contactPhone - A contact phone
	 */
	module.exports = Model = BaseModel.extend('Address',
	/** @lends module:models.Address */
	{
	    /**
	     * Addresses are not softDeletable
	     *
	     * @type {boolean}
	     * @default
	     * @protected
	     */
	    softDelete: false,
	
	    defaults: {
	        line1: '',
	        city: '',
	        state: '',
	        postcode: '',
	        contactPhone: ''
	    },
	
	    constraints: {
	        line1: { presence: { message: '^Street Address is required' } },
	        city: { presence: { message: '^City is required' } },
	        state: { presence: { message: '^State is required' } },
	        postcode: {
	            presence: { message: '^Post Code is required' },
	            format: {
	                pattern: /\d{5}/,
	                message: '^Invalid post code format'
	            }
	        },
	        contactPhone: { presence: { message: '^Contact Phone is required' } }
	    },
	
	    /**
	     * Return the state name from the code we have stored in
	     * the instance
	     *
	     * @instance
	     * @returns {string} The state name as a string. Empty string
	     *  if code is invalid
	     */
	    getStateName: function getStateName() {
	        return Model.getStateName(this.get('state'));
	    },
	
	    /**
	     * Returns the model's attributes as JSON. We override
	     * {@link module:models.BaseModel#toJSON} so we can return the actual
	     * state name if needed.
	     *
	     * @instance
	     * @param {object} options - A backbone-style options object
	     * @returns {object} The attributes as JSON
	     */
	    toJSON: function toJSON(options) {
	        var self = this;
	        var r = BaseModel.prototype.toJSON.apply(self, arguments);
	
	        options = _.defaults(options || {}, {
	            asAdditionalInformation: false
	        });
	
	        if (options.asAdditionalInformation === true) {
	            r.state = self.getStateName();
	        }
	
	        return r;
	    }
	}, {
	    /**
	     * The states
	     *
	     * @memberof module:models.Address
	     * @static
	     * @public
	     */
	    states: [{ code: '01', name: 'Johor' }, { code: '02', name: 'Kedah' }, { code: '03', name: 'Kelantan' }, { code: '14', name: 'Kuala Lumpur' }, { code: '15', name: 'Labuan' }, { code: '04', name: 'Malacca' }, { code: '05', name: 'Negeri Sembilan' }, { code: '06', name: 'Pahang' }, { code: '07', name: 'Penang' }, { code: '08', name: 'Perak' }, { code: '09', name: 'Perlis' }, { code: '16', name: 'Putrajaya' }, { code: '12', name: 'Sabah' }, { code: '13', name: 'Sarawak' }, { code: '10', name: 'Selangor' }, { code: '11', name: 'Terengganu' }],
	
	    /**
	     * Get the state name corresponding to a code
	     *
	     * @memberof module:models.Address
	     * @static
	     * @param {string} code - The code to lookup
	     * @returns {string} The state name. Empty string if no
	     *  state name found.
	     */
	    getStateName: function getStateName(code) {
	        var state = _.find(Model.states, function (state) {
	            return state.code === code;
	        });
	        return state ? state.name : '';
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _CustomerSupportForm = __webpack_require__(1044);
	
	var _CustomerSupportForm2 = _interopRequireDefault(_CustomerSupportForm);
	
	var _Form = __webpack_require__(550);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _validate = __webpack_require__(58);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('common/customer-support-form');
	
	var questionSubjects = ['How do I apply for leave?', 'How do I know my leave request is approved?', 'How do I know my leave request is rejected?', 'How do I know my leave balance?', 'How do I change my login email?', 'How do I change my login password?', 'How do I change my personal details?', 'How to check my bank details?', 'What should I do when I forgot my login password?', 'Where can I find my previous payslips?'];
	
	_validate2.default.extend(_validate2.default.validators.datetime, {
	    parse: function parse(value) {
	        return +_moment2.default.utc(value, 'DD/MM/YYYY');
	    },
	
	    format: function format(value) {
	        var format = 'DD/MM/YYYY';
	        return _moment2.default.utc(value).format(format);
	    }
	});
	
	module.exports = _Form2.default.extend({
	
	    subViews: null,
	
	    events: function events() {
	        return Object.assign({}, _Form2.default.prototype.events(), {
	            'click .send': 'send'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.events = Object.assign({}, _Form2.default.prototype.events || {}, this.events);
	
	        this.options = Object.assign({
	            template: _CustomerSupportForm2.default,
	            templateExtra: {}
	        }, options || {});
	
	        this.options.templateExtra = Object.assign(this.options.templateExtra, {
	            questionSubjects: questionSubjects
	        });
	
	        return _Form2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    render: function render() {
	        _Form2.default.prototype.render.apply(this, arguments);
	        return this;
	    },
	
	    showSendEmailErrors: function showSendEmailErrors(errors) {
	        if (!_.isEmpty(errors)) {
	            this.invalid(null, errors);
	        } else {
	            _alerts2.default.show('error', {
	                title: 'Unable to send the message',
	                text: 'Error occured while sending your message. Sorry.'
	            });
	        }
	    },
	
	    send: function send(ev) {
	        var _this = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader;
	
	        ev.preventDefault();
	
	        if ($button.closest('.js-ext', this.el).length > 0) {
	            return;
	        }
	
	        stopLoader = _loader2.default.startFullScreen($button);
	
	        this.trigger('save');
	
	        this.sendEmail().then(function () {
	            return stopLoader();
	        }).then(function () {
	            return _this.sent();
	        }).then(function () {
	            return _this.render();
	        }).catch(function (errors) {
	            return _this.showSendEmailErrors(errors);
	        }).finally(function () {
	            return stopLoader();
	        });
	    },
	
	    sendEmail: function sendEmail() {
	        var questionSubject = this.$('select[name=questionSubject]').val();
	        var desc = this.$('[name=desc]').val();
	        var validationError = this.validateSendEmail({
	            questionSubject: questionSubject
	        });
	
	        if (!_.isEmpty(validationError)) {
	            return (0, _bluebird.reject)(validationError);
	        }
	
	        return this.model.sendCustomerSupportEmail(questionSubject, desc).catch(function (errors) {
	            log.error(errors);
	            return (0, _bluebird.reject)();
	        });
	    },
	
	    validateSendEmail: function validateSendEmail(values) {
	        var errs = (0, _validate2.default)(values, {
	            questionSubject: { presence: true }
	        });
	
	        return _.isEmpty(errs) ? false : { errors: errs };
	    },
	
	    sent: function sent() {
	        return new _bluebird2.default(function (resolve) {
	            _alerts2.default.show('success', {
	                title: 'Message sent!',
	                text: 'Your question has been sent successfully!',
	                callback: function callback() {
	                    return resolve(true);
	                }
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/commons/templates/CustomerSupportForm.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <h2>Contact Support</h2>\n</div>\n\n<div class="wrapper wrapper-content customer-support">\n    <div class="row">\n        <div class="col-md-10 col-lg-12">\n            <div class="js-ext js-ext-container"></div>\n\n            <div class="ibox float-e-margins">\n                <form class="js-form-customer-support form-horizontal">\n                    <div class="ibox-content">\n                        <div class="row">\n                            <div class="col-sm-3">&nbsp;</div>\n                            <div class="col-sm-7">\n                                <h2 class="font-bold">Need some help?</h2>\n                                <h2 class="font-bold">We\'d love to assist</h2>\n                                <p>\n                                    Please fill out the contact form below and we will reply as soon as\n                                    possible.\n                                </p>\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <label class="col-sm-3 control-label">\n                                Email\n                            </label>\n                            <div class="col-sm-7">\n                                <input disabled\n                                    class="js-ext form-control"\n                                    type="text"\n                                    value="'+
	((__t=( this.model.get("email") ))==null?'':_.escape(__t))+
	'">\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <label class="col-sm-3 control-label">\n                                Name\n                            </label>\n                            <div class="col-sm-7">\n                                <input disabled\n                                    class="js-ext form-control"\n                                    type="text"\n                                    value="'+
	((__t=( this.model.get("name") ))==null?'':_.escape(__t))+
	'">\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <label class="col-sm-3 control-label">\n                                Subject\n                            </label>\n                            <div class="col-sm-7">\n                                <select name="questionSubject" class="form-control\n                                    js-ext js-chosen">\n                                    <option value="" disabled selected>Select a subject</option>\n                                    ';
	 _.map(questionSubjects, function(subject) { 
	__p+='\n                                        <option value="'+
	((__t=( subject ))==null?'':_.escape(__t))+
	'">\n                                            '+
	((__t=( subject ))==null?'':_.escape(__t))+
	'\n                                        </option>\n                                    ';
	 }) 
	__p+='\n                                </select>\n                                <span class="error error-questionSubject"></span>\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <label class="col-sm-3 control-label">\n                                Description\n                            </label>\n                            <div class="col-sm-7">\n                                <textarea name="desc"\n                                    class="js-ext form-control"\n                                    rows="4"\n                                    placeholder="Description (details)"\n                                ></textarea>\n                                <span class="error error-desc"></span>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-sm-3">&nbsp;</div>\n                            <div class="col-sm-7 text-right">\n                                <button type="submit"\n                                        class="btn btn-w-m btn-primary m-l-xs send">\n                                    Contact Support\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var template = __webpack_require__(1046);
	var PanelView = __webpack_require__(710);
	
	module.exports = PanelView.extend({
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, { template: template });
	        return PanelView.prototype.initialize.apply(this, [this.options]);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/PersonalSettings.ejs -->\n<div class="ibox-title">\n    <h5>Employee Settings</h5>\n</div>\n<form class="js-form-settings form-horizontal">\n    <div class="ibox-content">\n        <div class="form-group">\n            <label class="col-sm-3 control-label">\n                Email\n            </label>\n            <div class="col-sm-9">\n                <input type="text" name="username" class="form-control"\n                       placeholder="Enter email"\n                       value="'+
	((__t=( model.get('username') ))==null?'':_.escape(__t))+
	'"/>\n                <span class="error error-username"></span>\n            </div>\n        </div>\n    </div>\n\n    <div class="ibox-footer text-right">\n        <button type="button"\n            class="js-cancel btn btn-w-m btn-warning"\n            data-toggle="tooltip" \n            data-title="No changes will be saved" \n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i> \n            Cancel\n        </button>\n        <button type="submit"\n            class="js-save btn btn-w-m btn-primary m-l-xs">\n            <i class="fa fa-check"></i> Save\n        </button>\n    </div>\n</form>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Base = __webpack_require__(1048);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Layout = __webpack_require__(1049);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _leaveTypes = __webpack_require__(629);
	
	var _leaveTypes2 = _interopRequireDefault(_leaveTypes);
	
	var _actionLogs = __webpack_require__(817);
	
	var _actionLogs2 = _interopRequireDefault(_actionLogs);
	
	var _leaveApprovals = __webpack_require__(587);
	
	var _leaveApprovals2 = _interopRequireDefault(_leaveApprovals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'dashboard': 'dashboard'
	    },
	
	    titles: {
	        'dashboard': 'Dashboard'
	    },
	
	    dashboard: function dashboard() {
	        var _this = this;
	
	        this.layout = new _Layout2.default({ el: this.el });
	
	        var approvals = new _leaveApprovals2.default(null, {
	            approver: app.employee,
	            pagination: false
	        });
	        var leaveTypes = new _leaveTypes2.default(null, { company: app.company });
	        return leaveTypes.fetch().then(function () {
	            return (0, _bluebird.all)([new _actionLogs2.default().fetchForEmployee(app.employee), leaveTypes.fetchBalances(app.employee), _leaveTypes2.default.fetchCarryForwardDays(app.employee), approvals.fetch({ filter: { limit: 9999 } })]);
	        }).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 4),
	                actionLogs = _ref2[0],
	                types = _ref2[1],
	                counters = _ref2[2],
	                cfDays = _ref2[3];
	
	            _this.layout.renderLeave({
	                leaveTypes: types,
	                carryForwardDays: cfDays
	            });
	
	            var layerMap = {};
	            approvals.forEach(function (approval) {
	                layerMap[approval.get('requesterId')] = approval.get('layer');
	            });
	            layerMap[app.employee.id] = 0;
	            _this.layout.renderActionLog({
	                collection: actionLogs,
	                fetchMore: function fetchMore(options) {
	                    return new _actionLogs2.default().fetchForEmployee(app.employee, options);
	                },
	                layerMap: layerMap
	            });
	
	            if (!app.employee.get('isSetUp')) {
	                _this.layout.renderDefault({ company: app.company });
	            }
	        });
	    }
	});

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseRouter = __webpack_require__(625);
	
	module.exports = BaseRouter.extend({
	    initialize: function initialize(options) {
	        options = _.defaults(options || {}, {
	            el: null
	        });
	        this.el = options.el;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(1050);
	var ActionLogView = __webpack_require__(804);
	var LeaveView = __webpack_require__(1051);
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize() {
	        this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template());
	        return this;
	    },
	
	    renderDefault: function renderDefault(options) {
	        this.$('.js-leave-loader').hide();
	        this.$('.js-isNotSetUp').show();
	        this.$('.js-isSetUp').hide();
	        this.$('.js-contact-link').attr('href', 'mailto:' + options.company.get('contactEmail')).html(options.company.get('contactEmail'));
	    },
	
	    renderActionLog: function renderActionLog(options) {
	        this.actionLog = new ActionLogView({
	            collection: options.collection,
	            fetchMore: options.fetchMore,
	            layerMap: options.layerMap
	        });
	        this.$('.js-action-log').html(this.actionLog.render().el);
	        this.$('.js-action-log-loader').hide();
	    },
	
	    renderLeave: function renderLeave(options) {
	        var self = this;
	        self.leave = new LeaveView(_.extend({ $el: self.$('.js-leave') }, options));
	        self.$('.js-leave-loader').hide();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/dashboard/Layout.ejs -->\n<div class="wrapper wrapper-content panels">\n    <div class="js-isNotSetUp" style="display: none;">\n        <div id="full-screen-message">\n            <div class="fsm-container-1">\n                <div class="fsm-container-2" >\n                    <img src="/images/panda_jump.png" alt="panda-jump"/>\n                    <h2>\n                        Your profile has not yet been updated by your\n                        company.\n                        <br/>\n                        Please come back later or email the administrator\n                        for an update:\n                        <a class="js-contact-link"\n                            href="mailto:admin@payrollpanda.my">\n                            PayrollPanda\n                        </a>\n                    </h2>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="js-isSetUp">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Leave Taken</h5>\n            </div>\n            <div class="js-leave-loader ibox-content">\n                <div class="loader">\n                    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                </div>\n            </div>\n            <div class="js-leave"></div>\n        </div>\n    </div>\n\n    <div class="js-isSetUp">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>My Action Log</h5>\n            </div>\n            <div class="js-action-log-loader ibox-content">\n                <div class="loader">\n                    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                </div>\n            </div>\n            <div class="js-action-log ibox-content is-paddingless"></div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(1052);
	var Chart = __webpack_require__(1053);
	
	module.exports = Backbone.View.extend({
	    initialize: function initialize(_ref) {
	        var _ref$$el = _ref.$el,
	            $el = _ref$$el === undefined ? null : _ref$$el,
	            _ref$leaveTypes = _ref.leaveTypes,
	            leaveTypes = _ref$leaveTypes === undefined ? null : _ref$leaveTypes;
	
	        Backbone.View.prototype.initialize.apply(this, arguments);
	        this.$el = $el;
	        this.leaveTypes = leaveTypes;
	
	        var annualLeave = this.leaveTypes.find(function (type) {
	            return type.get('annual');
	        });
	
	        this.annualExtraCounters = {
	            entitled: annualLeave ? annualLeave.getDefaultEntitled() : 0,
	            carryForward: annualLeave ? (annualLeave.getCarriedFoward() || 0).formatWithoutRounding() : 0,
	            remaining: parseFloat(Math.max(0, annualLeave ? annualLeave.getEntitled() - annualLeave.getTaken() : 0).formatWithoutRounding())
	        };
	        this.render();
	        return this;
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var counters = this.leaveTypes.filter(function (type) {
	            return type.get('annual') || type.getTaken() > 0;
	        });
	        this.$el.html(template({
	            leaveTypes: counters,
	            annualExtraCounters: this.annualExtraCounters
	        }));
	
	        var doughnutOptions = {
	            segmentShowStroke: true,
	            segmentStrokeColor: '#fff',
	            segmentStrokeWidth: 5,
	            percentageInnerCutout: 50,
	            animation: false,
	            tooltipTemplate: '<%- value %> <% if (value === 1) { %>day<% }' + ' else { %>days<%}%> <%-label%>',
	            customTooltips: function customTooltips(tooltip) {
	                if (!tooltip) {
	                    _this.$('.tooltip').remove();
	                    return;
	                }
	
	                var $tooltip = $('<div>').addClass('tooltip tooltip-chart fade top in').append('<div class="tooltip-arrow"></div>');
	                var $inner = $('<div>').addClass('tooltip-inner').html(tooltip.text);
	                $tooltip.append($inner);
	                $tooltip.css({
	                    left: tooltip.chart.canvas.offsetLeft + tooltip.x + 'px',
	                    top: tooltip.chart.canvas.offsetTop + tooltip.y + 'px'
	                });
	                _this.$('.js-chart').after($tooltip);
	            }
	        };
	
	        var ctx = this.$('.js-chart')[0].getContext('2d');
	        this.chart = new Chart(ctx).Doughnut(this.getDoughnutData(this.leaveTypes), doughnutOptions);
	        return this;
	    },
	
	    getDoughnutData: function getDoughnutData(leaveTypes) {
	        var doughnutData = [];
	        leaveTypes.filter(function (type) {
	            return type.getTaken() > 0;
	        }).forEach(function (type) {
	            if (!type) {
	                return;
	            }
	
	            doughnutData.push({
	                value: type.getTaken(),
	                label: type.get('name'),
	                color: type.get('color') || '#CCC'
	            });
	        });
	
	        return doughnutData;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/dashboard/Leave.ejs -->\n<div class="ibox-content">\n    <div class="row is-marginless">\n        <div class="col-sm-3 col-xs-12 text-center m-t-lg">\n            <canvas class="js-chart" width="160" height="160"></canvas>\n        </div>\n        <div class="col-sm-9">\n            <div class="row m-b-lg">\n                ';
	 leaveTypes.forEach(function (type) { 
	__p+='\n                    <div class="col-sm-3 col-xs-4">\n                        <div class="h1">'+
	((__t=( type.getTaken() ))==null?'':_.escape(__t))+
	'</div>\n                        <div>\n                            '+
	((__t=( type.get('name') ))==null?'':_.escape(__t))+
	'\n                            ';
	 print(type.getTaken() === 1 ? 'Day' : 'Days') 
	__p+=' Taken\n                        </div>\n                    </div>\n                ';
	 }); 
	__p+='\n                <div class="col-sm-3 col-xs-4">\n                    <div class="h1">'+
	((__t=( annualExtraCounters.entitled ))==null?'':_.escape(__t))+
	'</div>\n                    <div>\n                        Annual Leave Entitled Days\n                    </div>\n                </div>\n\n                <div class="col-sm-3 col-xs-4">\n                    <div class="h1">'+
	((__t=( annualExtraCounters.carryForward ))==null?'':_.escape(__t))+
	'</div>\n                    <div>\n                        Annual Leave Carried Forward Days\n                    </div>\n                </div>\n\n                <div class="col-sm-3 col-xs-4">\n                    <div class="h1">'+
	((__t=( annualExtraCounters.remaining ))==null?'':_.escape(__t))+
	'</div>\n                    <div>\n                        Annual Leave Remaining Days\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="text-right">\n        <a href="#calendar" type="button" class="btn btn-outline btn-success btn-w-m">\n            Calendar\n        </a>\n        <a href="#requestLeave/add" type="button" class="btn btn-outline btn-primary btn-w-m">\n            Apply Leave\n        </a>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Chart.js
	 * http://chartjs.org/
	 * Version: 1.1.1
	 *
	 * Copyright 2015 Nick Downie
	 * Released under the MIT license
	 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
	 */
	
	
	(function(){
	
		"use strict";
	
		//Declare root variable - window in the browser, global on the server
		var root = this,
			previous = root.Chart;
	
		//Occupy the global variable of Chart, and create a simple base class
		var Chart = function(context){
			var chart = this;
			this.canvas = context.canvas;
	
			this.ctx = context;
	
			//Variables global to the chart
			var computeDimension = function(element,dimension)
			{
				if (element['offset'+dimension])
				{
					return element['offset'+dimension];
				}
				else
				{
					return document.defaultView.getComputedStyle(element).getPropertyValue(dimension);
				}
			};
	
			var width = this.width = computeDimension(context.canvas,'Width') || context.canvas.width;
			var height = this.height = computeDimension(context.canvas,'Height') || context.canvas.height;
	
			this.aspectRatio = this.width / this.height;
			//High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
			helpers.retinaScale(this);
	
			return this;
		};
		//Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				// Boolean - Whether to animate the chart
				animation: true,
	
				// Number - Number of animation steps
				animationSteps: 60,
	
				// String - Animation easing effect
				animationEasing: "easeOutQuart",
	
				// Boolean - If we should show the scale at all
				showScale: true,
	
				// Boolean - If we want to override with a hard coded scale
				scaleOverride: false,
	
				// ** Required if scaleOverride is true **
				// Number - The number of steps in a hard coded scale
				scaleSteps: null,
				// Number - The value jump in the hard coded scale
				scaleStepWidth: null,
				// Number - The scale starting value
				scaleStartValue: null,
	
				// String - Colour of the scale line
				scaleLineColor: "rgba(0,0,0,.1)",
	
				// Number - Pixel width of the scale line
				scaleLineWidth: 1,
	
				// Boolean - Whether to show labels on the scale
				scaleShowLabels: true,
	
				// Interpolated JS string - can access value
				scaleLabel: "<%=value%>",
	
				// Boolean - Whether the scale should stick to integers, and not show any floats even if drawing space is there
				scaleIntegersOnly: true,
	
				// Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
				scaleBeginAtZero: false,
	
				// String - Scale label font declaration for the scale label
				scaleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	
				// Number - Scale label font size in pixels
				scaleFontSize: 12,
	
				// String - Scale label font weight style
				scaleFontStyle: "normal",
	
				// String - Scale label font colour
				scaleFontColor: "#666",
	
				// Boolean - whether or not the chart should be responsive and resize when the browser does.
				responsive: false,
	
				// Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
				maintainAspectRatio: true,
	
				// Boolean - Determines whether to draw tooltips on the canvas or not - attaches events to touchmove & mousemove
				showTooltips: true,
	
				// Boolean - Determines whether to draw built-in tooltip or call custom tooltip function
				customTooltips: false,
	
				// Array - Array of string names to attach tooltip events
				tooltipEvents: ["mousemove", "touchstart", "touchmove", "mouseout"],
	
				// String - Tooltip background colour
				tooltipFillColor: "rgba(0,0,0,0.8)",
	
				// String - Tooltip label font declaration for the scale label
				tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	
				// Number - Tooltip label font size in pixels
				tooltipFontSize: 14,
	
				// String - Tooltip font weight style
				tooltipFontStyle: "normal",
	
				// String - Tooltip label font colour
				tooltipFontColor: "#fff",
	
				// String - Tooltip title font declaration for the scale label
				tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	
				// Number - Tooltip title font size in pixels
				tooltipTitleFontSize: 14,
	
				// String - Tooltip title font weight style
				tooltipTitleFontStyle: "bold",
	
				// String - Tooltip title font colour
				tooltipTitleFontColor: "#fff",
	
				// String - Tooltip title template
				tooltipTitleTemplate: "<%= label%>",
	
				// Number - pixel width of padding around tooltip text
				tooltipYPadding: 6,
	
				// Number - pixel width of padding around tooltip text
				tooltipXPadding: 6,
	
				// Number - Size of the caret on the tooltip
				tooltipCaretSize: 8,
	
				// Number - Pixel radius of the tooltip border
				tooltipCornerRadius: 6,
	
				// Number - Pixel offset from point x to tooltip edge
				tooltipXOffset: 10,
	
				// String - Template string for single tooltips
				tooltipTemplate: "<%if (label){%><%=label%>: <%}%><%= value %>",
	
				// String - Template string for single tooltips
				multiTooltipTemplate: "<%= datasetLabel %>: <%= value %>",
	
				// String - Colour behind the legend colour block
				multiTooltipKeyBackground: '#fff',
	
				// Array - A list of colors to use as the defaults
				segmentColorDefault: ["#A6CEE3", "#1F78B4", "#B2DF8A", "#33A02C", "#FB9A99", "#E31A1C", "#FDBF6F", "#FF7F00", "#CAB2D6", "#6A3D9A", "#B4B482", "#B15928" ],
	
				// Array - A list of highlight colors to use as the defaults
				segmentHighlightColorDefaults: [ "#CEF6FF", "#47A0DC", "#DAFFB2", "#5BC854", "#FFC2C1", "#FF4244", "#FFE797", "#FFA728", "#F2DAFE", "#9265C2", "#DCDCAA", "#D98150" ],
	
				// Function - Will fire on animation progression.
				onAnimationProgress: function(){},
	
				// Function - Will fire on animation completion.
				onAnimationComplete: function(){}
	
			}
		};
	
		//Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		//Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
			//-- Basic js utility methods
		var each = helpers.each = function(loopable,callback,self){
				var additionalArgs = Array.prototype.slice.call(arguments, 3);
				// Check to see if null or undefined firstly.
				if (loopable){
					if (loopable.length === +loopable.length){
						var i;
						for (i=0; i<loopable.length; i++){
							callback.apply(self,[loopable[i], i].concat(additionalArgs));
						}
					}
					else{
						for (var item in loopable){
							callback.apply(self,[loopable[item],item].concat(additionalArgs));
						}
					}
				}
			},
			clone = helpers.clone = function(obj){
				var objClone = {};
				each(obj,function(value,key){
					if (obj.hasOwnProperty(key)){
						objClone[key] = value;
					}
				});
				return objClone;
			},
			extend = helpers.extend = function(base){
				each(Array.prototype.slice.call(arguments,1), function(extensionObject) {
					each(extensionObject,function(value,key){
						if (extensionObject.hasOwnProperty(key)){
							base[key] = value;
						}
					});
				});
				return base;
			},
			merge = helpers.merge = function(base,master){
				//Merge properties in left object over to a shallow clone of object right.
				var args = Array.prototype.slice.call(arguments,0);
				args.unshift({});
				return extend.apply(null, args);
			},
			indexOf = helpers.indexOf = function(arrayToSearch, item){
				if (Array.prototype.indexOf) {
					return arrayToSearch.indexOf(item);
				}
				else{
					for (var i = 0; i < arrayToSearch.length; i++) {
						if (arrayToSearch[i] === item) return i;
					}
					return -1;
				}
			},
			where = helpers.where = function(collection, filterCallback){
				var filtered = [];
	
				helpers.each(collection, function(item){
					if (filterCallback(item)){
						filtered.push(item);
					}
				});
	
				return filtered;
			},
			findNextWhere = helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex){
				// Default to start of the array
				if (!startIndex){
					startIndex = -1;
				}
				for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
					var currentItem = arrayToSearch[i];
					if (filterCallback(currentItem)){
						return currentItem;
					}
				}
			},
			findPreviousWhere = helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex){
				// Default to end of the array
				if (!startIndex){
					startIndex = arrayToSearch.length;
				}
				for (var i = startIndex - 1; i >= 0; i--) {
					var currentItem = arrayToSearch[i];
					if (filterCallback(currentItem)){
						return currentItem;
					}
				}
			},
			inherits = helpers.inherits = function(extensions){
				//Basic javascript inheritance based on the model created in Backbone.js
				var parent = this;
				var ChartElement = (extensions && extensions.hasOwnProperty("constructor")) ? extensions.constructor : function(){ return parent.apply(this, arguments); };
	
				var Surrogate = function(){ this.constructor = ChartElement;};
				Surrogate.prototype = parent.prototype;
				ChartElement.prototype = new Surrogate();
	
				ChartElement.extend = inherits;
	
				if (extensions) extend(ChartElement.prototype, extensions);
	
				ChartElement.__super__ = parent.prototype;
	
				return ChartElement;
			},
			noop = helpers.noop = function(){},
			uid = helpers.uid = (function(){
				var id=0;
				return function(){
					return "chart-" + id++;
				};
			})(),
			warn = helpers.warn = function(str){
				//Method for warning of errors
				if (window.console && typeof window.console.warn === "function") console.warn(str);
			},
			amd = helpers.amd = ("function" === 'function' && __webpack_require__(1054)),
			//-- Math methods
			isNumber = helpers.isNumber = function(n){
				return !isNaN(parseFloat(n)) && isFinite(n);
			},
			max = helpers.max = function(array){
				return Math.max.apply( Math, array );
			},
			min = helpers.min = function(array){
				return Math.min.apply( Math, array );
			},
			cap = helpers.cap = function(valueToCap,maxValue,minValue){
				if(isNumber(maxValue)) {
					if( valueToCap > maxValue ) {
						return maxValue;
					}
				}
				else if(isNumber(minValue)){
					if ( valueToCap < minValue ){
						return minValue;
					}
				}
				return valueToCap;
			},
			getDecimalPlaces = helpers.getDecimalPlaces = function(num){
				if (num%1!==0 && isNumber(num)){
					var s = num.toString();
					if(s.indexOf("e-") < 0){
						// no exponent, e.g. 0.01
						return s.split(".")[1].length;
					}
					else if(s.indexOf(".") < 0) {
						// no decimal point, e.g. 1e-9
						return parseInt(s.split("e-")[1]);
					}
					else {
						// exponent and decimal point, e.g. 1.23e-9
						var parts = s.split(".")[1].split("e-");
						return parts[0].length + parseInt(parts[1]);
					}
				}
				else {
					return 0;
				}
			},
			toRadians = helpers.radians = function(degrees){
				return degrees * (Math.PI/180);
			},
			// Gets the angle from vertical upright to the point about a centre.
			getAngleFromPoint = helpers.getAngleFromPoint = function(centrePoint, anglePoint){
				var distanceFromXCenter = anglePoint.x - centrePoint.x,
					distanceFromYCenter = anglePoint.y - centrePoint.y,
					radialDistanceFromCenter = Math.sqrt( distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
	
				var angle = Math.PI * 2 + Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
				//If the segment is in the top left quadrant, we need to add another rotation to the angle
				if (distanceFromXCenter < 0 && distanceFromYCenter < 0){
					angle += Math.PI*2;
				}
	
				return {
					angle: angle,
					distance: radialDistanceFromCenter
				};
			},
			aliasPixel = helpers.aliasPixel = function(pixelWidth){
				return (pixelWidth % 2 === 0) ? 0 : 0.5;
			},
			splineCurve = helpers.splineCurve = function(FirstPoint,MiddlePoint,AfterPoint,t){
				//Props to Rob Spencer at scaled innovation for his post on splining between points
				//http://scaledinnovation.com/analytics/splines/aboutSplines.html
				var d01=Math.sqrt(Math.pow(MiddlePoint.x-FirstPoint.x,2)+Math.pow(MiddlePoint.y-FirstPoint.y,2)),
					d12=Math.sqrt(Math.pow(AfterPoint.x-MiddlePoint.x,2)+Math.pow(AfterPoint.y-MiddlePoint.y,2)),
					fa=t*d01/(d01+d12),// scaling factor for triangle Ta
					fb=t*d12/(d01+d12);
				return {
					inner : {
						x : MiddlePoint.x-fa*(AfterPoint.x-FirstPoint.x),
						y : MiddlePoint.y-fa*(AfterPoint.y-FirstPoint.y)
					},
					outer : {
						x: MiddlePoint.x+fb*(AfterPoint.x-FirstPoint.x),
						y : MiddlePoint.y+fb*(AfterPoint.y-FirstPoint.y)
					}
				};
			},
			calculateOrderOfMagnitude = helpers.calculateOrderOfMagnitude = function(val){
				return Math.floor(Math.log(val) / Math.LN10);
			},
			calculateScaleRange = helpers.calculateScaleRange = function(valuesArray, drawingSize, textSize, startFromZero, integersOnly){
	
				//Set a minimum step of two - a point at the top of the graph, and a point at the base
				var minSteps = 2,
					maxSteps = Math.floor(drawingSize/(textSize * 1.5)),
					skipFitting = (minSteps >= maxSteps);
	
				// Filter out null values since these would min() to zero
				var values = [];
				each(valuesArray, function( v ){
					v == null || values.push( v );
				});
				var minValue = min(values),
				    maxValue = max(values);
	
				// We need some degree of separation here to calculate the scales if all the values are the same
				// Adding/minusing 0.5 will give us a range of 1.
				if (maxValue === minValue){
					maxValue += 0.5;
					// So we don't end up with a graph with a negative start value if we've said always start from zero
					if (minValue >= 0.5 && !startFromZero){
						minValue -= 0.5;
					}
					else{
						// Make up a whole number above the values
						maxValue += 0.5;
					}
				}
	
				var	valueRange = Math.abs(maxValue - minValue),
					rangeOrderOfMagnitude = calculateOrderOfMagnitude(valueRange),
					graphMax = Math.ceil(maxValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
					graphMin = (startFromZero) ? 0 : Math.floor(minValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
					graphRange = graphMax - graphMin,
					stepValue = Math.pow(10, rangeOrderOfMagnitude),
					numberOfSteps = Math.round(graphRange / stepValue);
	
				//If we have more space on the graph we'll use it to give more definition to the data
				while((numberOfSteps > maxSteps || (numberOfSteps * 2) < maxSteps) && !skipFitting) {
					if(numberOfSteps > maxSteps){
						stepValue *=2;
						numberOfSteps = Math.round(graphRange/stepValue);
						// Don't ever deal with a decimal number of steps - cancel fitting and just use the minimum number of steps.
						if (numberOfSteps % 1 !== 0){
							skipFitting = true;
						}
					}
					//We can fit in double the amount of scale points on the scale
					else{
						//If user has declared ints only, and the step value isn't a decimal
						if (integersOnly && rangeOrderOfMagnitude >= 0){
							//If the user has said integers only, we need to check that making the scale more granular wouldn't make it a float
							if(stepValue/2 % 1 === 0){
								stepValue /=2;
								numberOfSteps = Math.round(graphRange/stepValue);
							}
							//If it would make it a float break out of the loop
							else{
								break;
							}
						}
						//If the scale doesn't have to be an int, make the scale more granular anyway.
						else{
							stepValue /=2;
							numberOfSteps = Math.round(graphRange/stepValue);
						}
	
					}
				}
	
				if (skipFitting){
					numberOfSteps = minSteps;
					stepValue = graphRange / numberOfSteps;
				}
	
				return {
					steps : numberOfSteps,
					stepValue : stepValue,
					min : graphMin,
					max	: graphMin + (numberOfSteps * stepValue)
				};
	
			},
			/* jshint ignore:start */
			// Blows up jshint errors based on the new Function constructor
			//Templating methods
			//Javascript micro templating by John Resig - source at http://ejohn.org/blog/javascript-micro-templating/
			template = helpers.template = function(templateString, valuesObject){
	
				// If templateString is function rather than string-template - call the function for valuesObject
	
				if(templateString instanceof Function){
				 	return templateString(valuesObject);
			 	}
	
				var cache = {};
				function tmpl(str, data){
					// Figure out if we're getting a template, or if we need to
					// load the template - and be sure to cache the result.
					var fn = !/\W/.test(str) ?
					cache[str] = cache[str] :
	
					// Generate a reusable function that will serve as a template
					// generator (and which will be cached).
					new Function("obj",
						"var p=[],print=function(){p.push.apply(p,arguments);};" +
	
						// Introduce the data as local variables using with(){}
						"with(obj){p.push('" +
	
						// Convert the template into pure JavaScript
						str
							.replace(/[\r\t\n]/g, " ")
							.split("<%").join("\t")
							.replace(/((^|%>)[^\t]*)'/g, "$1\r")
							.replace(/\t=(.*?)%>/g, "',$1,'")
							.split("\t").join("');")
							.split("%>").join("p.push('")
							.split("\r").join("\\'") +
						"');}return p.join('');"
					);
	
					// Provide some basic currying to the user
					return data ? fn( data ) : fn;
				}
				return tmpl(templateString,valuesObject);
			},
			/* jshint ignore:end */
			generateLabels = helpers.generateLabels = function(templateString,numberOfSteps,graphMin,stepValue){
				var labelsArray = new Array(numberOfSteps);
				if (templateString){
					each(labelsArray,function(val,index){
						labelsArray[index] = template(templateString,{value: (graphMin + (stepValue*(index+1)))});
					});
				}
				return labelsArray;
			},
			//--Animation methods
			//Easing functions adapted from Robert Penner's easing equations
			//http://www.robertpenner.com/easing/
			easingEffects = helpers.easingEffects = {
				linear: function (t) {
					return t;
				},
				easeInQuad: function (t) {
					return t * t;
				},
				easeOutQuad: function (t) {
					return -1 * t * (t - 2);
				},
				easeInOutQuad: function (t) {
					if ((t /= 1 / 2) < 1){
						return 1 / 2 * t * t;
					}
					return -1 / 2 * ((--t) * (t - 2) - 1);
				},
				easeInCubic: function (t) {
					return t * t * t;
				},
				easeOutCubic: function (t) {
					return 1 * ((t = t / 1 - 1) * t * t + 1);
				},
				easeInOutCubic: function (t) {
					if ((t /= 1 / 2) < 1){
						return 1 / 2 * t * t * t;
					}
					return 1 / 2 * ((t -= 2) * t * t + 2);
				},
				easeInQuart: function (t) {
					return t * t * t * t;
				},
				easeOutQuart: function (t) {
					return -1 * ((t = t / 1 - 1) * t * t * t - 1);
				},
				easeInOutQuart: function (t) {
					if ((t /= 1 / 2) < 1){
						return 1 / 2 * t * t * t * t;
					}
					return -1 / 2 * ((t -= 2) * t * t * t - 2);
				},
				easeInQuint: function (t) {
					return 1 * (t /= 1) * t * t * t * t;
				},
				easeOutQuint: function (t) {
					return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
				},
				easeInOutQuint: function (t) {
					if ((t /= 1 / 2) < 1){
						return 1 / 2 * t * t * t * t * t;
					}
					return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
				},
				easeInSine: function (t) {
					return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
				},
				easeOutSine: function (t) {
					return 1 * Math.sin(t / 1 * (Math.PI / 2));
				},
				easeInOutSine: function (t) {
					return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
				},
				easeInExpo: function (t) {
					return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
				},
				easeOutExpo: function (t) {
					return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
				},
				easeInOutExpo: function (t) {
					if (t === 0){
						return 0;
					}
					if (t === 1){
						return 1;
					}
					if ((t /= 1 / 2) < 1){
						return 1 / 2 * Math.pow(2, 10 * (t - 1));
					}
					return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
				},
				easeInCirc: function (t) {
					if (t >= 1){
						return t;
					}
					return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
				},
				easeOutCirc: function (t) {
					return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
				},
				easeInOutCirc: function (t) {
					if ((t /= 1 / 2) < 1){
						return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
					}
					return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
				},
				easeInElastic: function (t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0){
						return 0;
					}
					if ((t /= 1) == 1){
						return 1;
					}
					if (!p){
						p = 1 * 0.3;
					}
					if (a < Math.abs(1)) {
						a = 1;
						s = p / 4;
					} else{
						s = p / (2 * Math.PI) * Math.asin(1 / a);
					}
					return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				},
				easeOutElastic: function (t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0){
						return 0;
					}
					if ((t /= 1) == 1){
						return 1;
					}
					if (!p){
						p = 1 * 0.3;
					}
					if (a < Math.abs(1)) {
						a = 1;
						s = p / 4;
					} else{
						s = p / (2 * Math.PI) * Math.asin(1 / a);
					}
					return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
				},
				easeInOutElastic: function (t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0){
						return 0;
					}
					if ((t /= 1 / 2) == 2){
						return 1;
					}
					if (!p){
						p = 1 * (0.3 * 1.5);
					}
					if (a < Math.abs(1)) {
						a = 1;
						s = p / 4;
					} else {
						s = p / (2 * Math.PI) * Math.asin(1 / a);
					}
					if (t < 1){
						return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));}
					return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
				},
				easeInBack: function (t) {
					var s = 1.70158;
					return 1 * (t /= 1) * t * ((s + 1) * t - s);
				},
				easeOutBack: function (t) {
					var s = 1.70158;
					return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
				},
				easeInOutBack: function (t) {
					var s = 1.70158;
					if ((t /= 1 / 2) < 1){
						return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
					}
					return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
				},
				easeInBounce: function (t) {
					return 1 - easingEffects.easeOutBounce(1 - t);
				},
				easeOutBounce: function (t) {
					if ((t /= 1) < (1 / 2.75)) {
						return 1 * (7.5625 * t * t);
					} else if (t < (2 / 2.75)) {
						return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
					} else if (t < (2.5 / 2.75)) {
						return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
					} else {
						return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
					}
				},
				easeInOutBounce: function (t) {
					if (t < 1 / 2){
						return easingEffects.easeInBounce(t * 2) * 0.5;
					}
					return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
				}
			},
			//Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
			requestAnimFrame = helpers.requestAnimFrame = (function(){
				return window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					window.oRequestAnimationFrame ||
					window.msRequestAnimationFrame ||
					function(callback) {
						return window.setTimeout(callback, 1000 / 60);
					};
			})(),
			cancelAnimFrame = helpers.cancelAnimFrame = (function(){
				return window.cancelAnimationFrame ||
					window.webkitCancelAnimationFrame ||
					window.mozCancelAnimationFrame ||
					window.oCancelAnimationFrame ||
					window.msCancelAnimationFrame ||
					function(callback) {
						return window.clearTimeout(callback, 1000 / 60);
					};
			})(),
			animationLoop = helpers.animationLoop = function(callback,totalSteps,easingString,onProgress,onComplete,chartInstance){
	
				var currentStep = 0,
					easingFunction = easingEffects[easingString] || easingEffects.linear;
	
				var animationFrame = function(){
					currentStep++;
					var stepDecimal = currentStep/totalSteps;
					var easeDecimal = easingFunction(stepDecimal);
	
					callback.call(chartInstance,easeDecimal,stepDecimal, currentStep);
					onProgress.call(chartInstance,easeDecimal,stepDecimal);
					if (currentStep < totalSteps){
						chartInstance.animationFrame = requestAnimFrame(animationFrame);
					} else{
						onComplete.apply(chartInstance);
					}
				};
				requestAnimFrame(animationFrame);
			},
			//-- DOM methods
			getRelativePosition = helpers.getRelativePosition = function(evt){
				var mouseX, mouseY;
				var e = evt.originalEvent || evt,
					canvas = evt.currentTarget || evt.srcElement,
					boundingRect = canvas.getBoundingClientRect();
	
				if (e.touches){
					mouseX = e.touches[0].clientX - boundingRect.left;
					mouseY = e.touches[0].clientY - boundingRect.top;
	
				}
				else{
					mouseX = e.clientX - boundingRect.left;
					mouseY = e.clientY - boundingRect.top;
				}
	
				return {
					x : mouseX,
					y : mouseY
				};
	
			},
			addEvent = helpers.addEvent = function(node,eventType,method){
				if (node.addEventListener){
					node.addEventListener(eventType,method);
				} else if (node.attachEvent){
					node.attachEvent("on"+eventType, method);
				} else {
					node["on"+eventType] = method;
				}
			},
			removeEvent = helpers.removeEvent = function(node, eventType, handler){
				if (node.removeEventListener){
					node.removeEventListener(eventType, handler, false);
				} else if (node.detachEvent){
					node.detachEvent("on"+eventType,handler);
				} else{
					node["on" + eventType] = noop;
				}
			},
			bindEvents = helpers.bindEvents = function(chartInstance, arrayOfEvents, handler){
				// Create the events object if it's not already present
				if (!chartInstance.events) chartInstance.events = {};
	
				each(arrayOfEvents,function(eventName){
					chartInstance.events[eventName] = function(){
						handler.apply(chartInstance, arguments);
					};
					addEvent(chartInstance.chart.canvas,eventName,chartInstance.events[eventName]);
				});
			},
			unbindEvents = helpers.unbindEvents = function (chartInstance, arrayOfEvents) {
				each(arrayOfEvents, function(handler,eventName){
					removeEvent(chartInstance.chart.canvas, eventName, handler);
				});
			},
			getMaximumWidth = helpers.getMaximumWidth = function(domNode){
				var container = domNode.parentNode,
				    padding = parseInt(getStyle(container, 'padding-left')) + parseInt(getStyle(container, 'padding-right'));
				// TODO = check cross browser stuff with this.
				return container ? container.clientWidth - padding : 0;
			},
			getMaximumHeight = helpers.getMaximumHeight = function(domNode){
				var container = domNode.parentNode,
				    padding = parseInt(getStyle(container, 'padding-bottom')) + parseInt(getStyle(container, 'padding-top'));
				// TODO = check cross browser stuff with this.
				return container ? container.clientHeight - padding : 0;
			},
			getStyle = helpers.getStyle = function (el, property) {
				return el.currentStyle ?
					el.currentStyle[property] :
					document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
			},
			getMaximumSize = helpers.getMaximumSize = helpers.getMaximumWidth, // legacy support
			retinaScale = helpers.retinaScale = function(chart){
				var ctx = chart.ctx,
					width = chart.canvas.width,
					height = chart.canvas.height;
	
				if (window.devicePixelRatio) {
					ctx.canvas.style.width = width + "px";
					ctx.canvas.style.height = height + "px";
					ctx.canvas.height = height * window.devicePixelRatio;
					ctx.canvas.width = width * window.devicePixelRatio;
					ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
				}
			},
			//-- Canvas methods
			clear = helpers.clear = function(chart){
				chart.ctx.clearRect(0,0,chart.width,chart.height);
			},
			fontString = helpers.fontString = function(pixelSize,fontStyle,fontFamily){
				return fontStyle + " " + pixelSize+"px " + fontFamily;
			},
			longestText = helpers.longestText = function(ctx,font,arrayOfStrings){
				ctx.font = font;
				var longest = 0;
				each(arrayOfStrings,function(string){
					var textWidth = ctx.measureText(string).width;
					longest = (textWidth > longest) ? textWidth : longest;
				});
				return longest;
			},
			drawRoundedRectangle = helpers.drawRoundedRectangle = function(ctx,x,y,width,height,radius){
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
			};
	
	
		//Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		//Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		Chart.Type = function(data,options,chart){
			this.options = options;
			this.chart = chart;
			this.id = uid();
			//Add the chart instance to the global namespace
			Chart.instances[this.id] = this;
	
			// Initialize is always called when a chart type is created
			// By default it is a no op, but it should be extended
			if (options.responsive){
				this.resize();
			}
			this.initialize.call(this,data);
		};
	
		//Core methods that'll be a part of every chart type
		extend(Chart.Type.prototype,{
			initialize : function(){return this;},
			clear : function(){
				clear(this.chart);
				return this;
			},
			stop : function(){
				// Stops any current animation loop occuring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
			resize : function(callback){
				this.stop();
				var canvas = this.chart.canvas,
					newWidth = getMaximumWidth(this.chart.canvas),
					newHeight = this.options.maintainAspectRatio ? newWidth / this.chart.aspectRatio : getMaximumHeight(this.chart.canvas);
	
				canvas.width = this.chart.width = newWidth;
				canvas.height = this.chart.height = newHeight;
	
				retinaScale(this.chart);
	
				if (typeof callback === "function"){
					callback.apply(this, Array.prototype.slice.call(arguments, 1));
				}
				return this;
			},
			reflow : noop,
			render : function(reflow){
				if (reflow){
					this.reflow();
				}
				
				if (this.options.animation && !reflow){
					var animation = new Chart.Animation();
					animation.numSteps = this.options.animationSteps;
					animation.easing = this.options.animationEasing;
					
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
						
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
					
					// user events
					animation.onAnimationProgress = this.options.onAnimationProgress;
					animation.onAnimationComplete = this.options.onAnimationComplete;
					
					Chart.animationService.addAnimation(this, animation);
				}
				else{
					this.draw();
					this.options.onAnimationComplete.call(this);
				}
				return this;
			},
			generateLegend : function(){
				return helpers.template(this.options.legendTemplate, this);
			},
			destroy : function(){
				this.stop();
				this.clear();
				unbindEvents(this, this.events);
				var canvas = this.chart.canvas;
	
				// Reset canvas height/width attributes starts a fresh with the canvas context
				canvas.width = this.chart.width;
				canvas.height = this.chart.height;
	
				// < IE9 doesn't support removeProperty
				if (canvas.style.removeProperty) {
					canvas.style.removeProperty('width');
					canvas.style.removeProperty('height');
				} else {
					canvas.style.removeAttribute('width');
					canvas.style.removeAttribute('height');
				}
	
				delete Chart.instances[this.id];
			},
			showTooltip : function(ChartElements, forceRedraw){
				// Only redraw the chart if we've actually changed what we're hovering on.
				if (typeof this.activeElements === 'undefined') this.activeElements = [];
	
				var isChanged = (function(Elements){
					var changed = false;
	
					if (Elements.length !== this.activeElements.length){
						changed = true;
						return changed;
					}
	
					each(Elements, function(element, index){
						if (element !== this.activeElements[index]){
							changed = true;
						}
					}, this);
					return changed;
				}).call(this, ChartElements);
	
				if (!isChanged && !forceRedraw){
					return;
				}
				else{
					this.activeElements = ChartElements;
				}
				this.draw();
				if(this.options.customTooltips){
					this.options.customTooltips(false);
				}
				if (ChartElements.length > 0){
					// If we have multiple datasets, show a MultiTooltip for all of the data points at that index
					if (this.datasets && this.datasets.length > 1) {
						var dataArray,
							dataIndex;
	
						for (var i = this.datasets.length - 1; i >= 0; i--) {
							dataArray = this.datasets[i].points || this.datasets[i].bars || this.datasets[i].segments;
							dataIndex = indexOf(dataArray, ChartElements[0]);
							if (dataIndex !== -1){
								break;
							}
						}
						var tooltipLabels = [],
							tooltipColors = [],
							medianPosition = (function(index) {
	
								// Get all the points at that particular index
								var Elements = [],
									dataCollection,
									xPositions = [],
									yPositions = [],
									xMax,
									yMax,
									xMin,
									yMin;
								helpers.each(this.datasets, function(dataset){
									dataCollection = dataset.points || dataset.bars || dataset.segments;
									if (dataCollection[dataIndex] && dataCollection[dataIndex].hasValue()){
										Elements.push(dataCollection[dataIndex]);
									}
								});
	
								helpers.each(Elements, function(element) {
									xPositions.push(element.x);
									yPositions.push(element.y);
	
	
									//Include any colour information about the element
									tooltipLabels.push(helpers.template(this.options.multiTooltipTemplate, element));
									tooltipColors.push({
										fill: element._saved.fillColor || element.fillColor,
										stroke: element._saved.strokeColor || element.strokeColor
									});
	
								}, this);
	
								yMin = min(yPositions);
								yMax = max(yPositions);
	
								xMin = min(xPositions);
								xMax = max(xPositions);
	
								return {
									x: (xMin > this.chart.width/2) ? xMin : xMax,
									y: (yMin + yMax)/2
								};
							}).call(this, dataIndex);
	
						new Chart.MultiTooltip({
							x: medianPosition.x,
							y: medianPosition.y,
							xPadding: this.options.tooltipXPadding,
							yPadding: this.options.tooltipYPadding,
							xOffset: this.options.tooltipXOffset,
							fillColor: this.options.tooltipFillColor,
							textColor: this.options.tooltipFontColor,
							fontFamily: this.options.tooltipFontFamily,
							fontStyle: this.options.tooltipFontStyle,
							fontSize: this.options.tooltipFontSize,
							titleTextColor: this.options.tooltipTitleFontColor,
							titleFontFamily: this.options.tooltipTitleFontFamily,
							titleFontStyle: this.options.tooltipTitleFontStyle,
							titleFontSize: this.options.tooltipTitleFontSize,
							cornerRadius: this.options.tooltipCornerRadius,
							labels: tooltipLabels,
							legendColors: tooltipColors,
							legendColorBackground : this.options.multiTooltipKeyBackground,
							title: template(this.options.tooltipTitleTemplate,ChartElements[0]),
							chart: this.chart,
							ctx: this.chart.ctx,
							custom: this.options.customTooltips
						}).draw();
	
					} else {
						each(ChartElements, function(Element) {
							var tooltipPosition = Element.tooltipPosition();
							new Chart.Tooltip({
								x: Math.round(tooltipPosition.x),
								y: Math.round(tooltipPosition.y),
								xPadding: this.options.tooltipXPadding,
								yPadding: this.options.tooltipYPadding,
								fillColor: this.options.tooltipFillColor,
								textColor: this.options.tooltipFontColor,
								fontFamily: this.options.tooltipFontFamily,
								fontStyle: this.options.tooltipFontStyle,
								fontSize: this.options.tooltipFontSize,
								caretHeight: this.options.tooltipCaretSize,
								cornerRadius: this.options.tooltipCornerRadius,
								text: template(this.options.tooltipTemplate, Element),
								chart: this.chart,
								custom: this.options.customTooltips
							}).draw();
						}, this);
					}
				}
				return this;
			},
			toBase64Image : function(){
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			}
		});
	
		Chart.Type.extend = function(extensions){
	
			var parent = this;
	
			var ChartType = function(){
				return parent.apply(this,arguments);
			};
	
			//Copy the prototype object of the this class
			ChartType.prototype = clone(parent.prototype);
			//Now overwrite some of the properties in the base class with the new extensions
			extend(ChartType.prototype, extensions);
	
			ChartType.extend = Chart.Type.extend;
	
			if (extensions.name || parent.prototype.name){
	
				var chartName = extensions.name || parent.prototype.name;
				//Assign any potential default values of the new chart type
	
				//If none are defined, we'll use a clone of the chart type this is being extended from.
				//I.e. if we extend a line chart, we'll use the defaults from the line chart if our new chart
				//doesn't define some defaults of their own.
	
				var baseDefaults = (Chart.defaults[parent.prototype.name]) ? clone(Chart.defaults[parent.prototype.name]) : {};
	
				Chart.defaults[chartName] = extend(baseDefaults,extensions.defaults);
	
				Chart.types[chartName] = ChartType;
	
				//Register this new chart type in the Chart prototype
				Chart.prototype[chartName] = function(data,options){
					var config = merge(Chart.defaults.global, Chart.defaults[chartName], options || {});
					return new ChartType(data,config,this);
				};
			} else{
				warn("Name not provided for this chart, so it hasn't been registered");
			}
			return parent;
		};
	
		Chart.Element = function(configuration){
			extend(this,configuration);
			this.initialize.apply(this,arguments);
			this.save();
		};
		extend(Chart.Element.prototype,{
			initialize : function(){},
			restore : function(props){
				if (!props){
					extend(this,this._saved);
				} else {
					each(props,function(key){
						this[key] = this._saved[key];
					},this);
				}
				return this;
			},
			save : function(){
				this._saved = clone(this);
				delete this._saved._saved;
				return this;
			},
			update : function(newProps){
				each(newProps,function(value,key){
					this._saved[key] = this[key];
					this[key] = value;
				},this);
				return this;
			},
			transition : function(props,ease){
				each(props,function(value,key){
					this[key] = ((value - this._saved[key]) * ease) + this._saved[key];
				},this);
				return this;
			},
			tooltipPosition : function(){
				return {
					x : this.x,
					y : this.y
				};
			},
			hasValue: function(){
				return isNumber(this.value);
			}
		});
	
		Chart.Element.extend = inherits;
	
	
		Chart.Point = Chart.Element.extend({
			display: true,
			inRange: function(chartX,chartY){
				var hitDetectionRange = this.hitDetectionRadius + this.radius;
				return ((Math.pow(chartX-this.x, 2)+Math.pow(chartY-this.y, 2)) < Math.pow(hitDetectionRange,2));
			},
			draw : function(){
				if (this.display){
					var ctx = this.ctx;
					ctx.beginPath();
	
					ctx.arc(this.x, this.y, this.radius, 0, Math.PI*2);
					ctx.closePath();
	
					ctx.strokeStyle = this.strokeColor;
					ctx.lineWidth = this.strokeWidth;
	
					ctx.fillStyle = this.fillColor;
	
					ctx.fill();
					ctx.stroke();
				}
	
	
				//Quick debug for bezier curve splining
				//Highlights control points and the line between them.
				//Handy for dev - stripped in the min version.
	
				// ctx.save();
				// ctx.fillStyle = "black";
				// ctx.strokeStyle = "black"
				// ctx.beginPath();
				// ctx.arc(this.controlPoints.inner.x,this.controlPoints.inner.y, 2, 0, Math.PI*2);
				// ctx.fill();
	
				// ctx.beginPath();
				// ctx.arc(this.controlPoints.outer.x,this.controlPoints.outer.y, 2, 0, Math.PI*2);
				// ctx.fill();
	
				// ctx.moveTo(this.controlPoints.inner.x,this.controlPoints.inner.y);
				// ctx.lineTo(this.x, this.y);
				// ctx.lineTo(this.controlPoints.outer.x,this.controlPoints.outer.y);
				// ctx.stroke();
	
				// ctx.restore();
	
	
	
			}
		});
	
		Chart.Arc = Chart.Element.extend({
			inRange : function(chartX,chartY){
	
				var pointRelativePosition = helpers.getAngleFromPoint(this, {
					x: chartX,
					y: chartY
				});
	
				// Normalize all angles to 0 - 2*PI (0 - 360°)
				var pointRelativeAngle = pointRelativePosition.angle % (Math.PI * 2),
				    startAngle = (Math.PI * 2 + this.startAngle) % (Math.PI * 2),
				    endAngle = (Math.PI * 2 + this.endAngle) % (Math.PI * 2) || 360;
	
				// Calculate wether the pointRelativeAngle is between the start and the end angle
				var betweenAngles = (endAngle < startAngle) ?
					pointRelativeAngle <= endAngle || pointRelativeAngle >= startAngle:
					pointRelativeAngle >= startAngle && pointRelativeAngle <= endAngle;
	
				//Check if within the range of the open/close angle
				var withinRadius = (pointRelativePosition.distance >= this.innerRadius && pointRelativePosition.distance <= this.outerRadius);
	
				return (betweenAngles && withinRadius);
				//Ensure within the outside of the arc centre, but inside arc outer
			},
			tooltipPosition : function(){
				var centreAngle = this.startAngle + ((this.endAngle - this.startAngle) / 2),
					rangeFromCentre = (this.outerRadius - this.innerRadius) / 2 + this.innerRadius;
				return {
					x : this.x + (Math.cos(centreAngle) * rangeFromCentre),
					y : this.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw : function(animationPercent){
	
				var easingDecimal = animationPercent || 1;
	
				var ctx = this.ctx;
	
				ctx.beginPath();
	
				ctx.arc(this.x, this.y, this.outerRadius < 0 ? 0 : this.outerRadius, this.startAngle, this.endAngle);
	
	            ctx.arc(this.x, this.y, this.innerRadius < 0 ? 0 : this.innerRadius, this.endAngle, this.startAngle, true);
	
				ctx.closePath();
				ctx.strokeStyle = this.strokeColor;
				ctx.lineWidth = this.strokeWidth;
	
				ctx.fillStyle = this.fillColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (this.showStroke){
					ctx.stroke();
				}
			}
		});
	
		Chart.Rectangle = Chart.Element.extend({
			draw : function(){
				var ctx = this.ctx,
					halfWidth = this.width/2,
					leftX = this.x - halfWidth,
					rightX = this.x + halfWidth,
					top = this.base - (this.base - this.y),
					halfStroke = this.strokeWidth / 2;
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (this.showStroke){
					leftX += halfStroke;
					rightX -= halfStroke;
					top += halfStroke;
				}
	
				ctx.beginPath();
	
				ctx.fillStyle = this.fillColor;
				ctx.strokeStyle = this.strokeColor;
				ctx.lineWidth = this.strokeWidth;
	
				// It'd be nice to keep this class totally generic to any rectangle
				// and simply specify which border to miss out.
				ctx.moveTo(leftX, this.base);
				ctx.lineTo(leftX, top);
				ctx.lineTo(rightX, top);
				ctx.lineTo(rightX, this.base);
				ctx.fill();
				if (this.showStroke){
					ctx.stroke();
				}
			},
			height : function(){
				return this.base - this.y;
			},
			inRange : function(chartX,chartY){
				return (chartX >= this.x - this.width/2 && chartX <= this.x + this.width/2) && (chartY >= this.y && chartY <= this.base);
			}
		});
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: "", // the easing to use for this animation
			render: null, // render function used by the animation service
			
			onAnimationProgress: null, // user specified callback to fire on each step of the animation 
			onAnimationComplete: null, // user specified callback to fire when the animation finishes
		});
		
		Chart.Tooltip = Chart.Element.extend({
			draw : function(){
	
				var ctx = this.chart.ctx;
	
				ctx.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
	
				this.xAlign = "center";
				this.yAlign = "above";
	
				//Distance between the actual element.y position and the start of the tooltip caret
				var caretPadding = this.caretPadding = 2;
	
				var tooltipWidth = ctx.measureText(this.text).width + 2*this.xPadding,
					tooltipRectHeight = this.fontSize + 2*this.yPadding,
					tooltipHeight = tooltipRectHeight + this.caretHeight + caretPadding;
	
				if (this.x + tooltipWidth/2 >this.chart.width){
					this.xAlign = "left";
				} else if (this.x - tooltipWidth/2 < 0){
					this.xAlign = "right";
				}
	
				if (this.y - tooltipHeight < 0){
					this.yAlign = "below";
				}
	
	
				var tooltipX = this.x - tooltipWidth/2,
					tooltipY = this.y - tooltipHeight;
	
				ctx.fillStyle = this.fillColor;
	
				// Custom Tooltips
				if(this.custom){
					this.custom(this);
				}
				else{
					switch(this.yAlign)
					{
					case "above":
						//Draw a caret above the x/y
						ctx.beginPath();
						ctx.moveTo(this.x,this.y - caretPadding);
						ctx.lineTo(this.x + this.caretHeight, this.y - (caretPadding + this.caretHeight));
						ctx.lineTo(this.x - this.caretHeight, this.y - (caretPadding + this.caretHeight));
						ctx.closePath();
						ctx.fill();
						break;
					case "below":
						tooltipY = this.y + caretPadding + this.caretHeight;
						//Draw a caret below the x/y
						ctx.beginPath();
						ctx.moveTo(this.x, this.y + caretPadding);
						ctx.lineTo(this.x + this.caretHeight, this.y + caretPadding + this.caretHeight);
						ctx.lineTo(this.x - this.caretHeight, this.y + caretPadding + this.caretHeight);
						ctx.closePath();
						ctx.fill();
						break;
					}
	
					switch(this.xAlign)
					{
					case "left":
						tooltipX = this.x - tooltipWidth + (this.cornerRadius + this.caretHeight);
						break;
					case "right":
						tooltipX = this.x - (this.cornerRadius + this.caretHeight);
						break;
					}
	
					drawRoundedRectangle(ctx,tooltipX,tooltipY,tooltipWidth,tooltipRectHeight,this.cornerRadius);
	
					ctx.fill();
	
					ctx.fillStyle = this.textColor;
					ctx.textAlign = "center";
					ctx.textBaseline = "middle";
					ctx.fillText(this.text, tooltipX + tooltipWidth/2, tooltipY + tooltipRectHeight/2);
				}
			}
		});
	
		Chart.MultiTooltip = Chart.Element.extend({
			initialize : function(){
				this.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
	
				this.titleFont = fontString(this.titleFontSize,this.titleFontStyle,this.titleFontFamily);
	
				this.titleHeight = this.title ? this.titleFontSize * 1.5 : 0;
				this.height = (this.labels.length * this.fontSize) + ((this.labels.length-1) * (this.fontSize/2)) + (this.yPadding*2) + this.titleHeight;
	
				this.ctx.font = this.titleFont;
	
				var titleWidth = this.ctx.measureText(this.title).width,
					//Label has a legend square as well so account for this.
					labelWidth = longestText(this.ctx,this.font,this.labels) + this.fontSize + 3,
					longestTextWidth = max([labelWidth,titleWidth]);
	
				this.width = longestTextWidth + (this.xPadding*2);
	
	
				var halfHeight = this.height/2;
	
				//Check to ensure the height will fit on the canvas
				if (this.y - halfHeight < 0 ){
					this.y = halfHeight;
				} else if (this.y + halfHeight > this.chart.height){
					this.y = this.chart.height - halfHeight;
				}
	
				//Decide whether to align left or right based on position on canvas
				if (this.x > this.chart.width/2){
					this.x -= this.xOffset + this.width;
				} else {
					this.x += this.xOffset;
				}
	
	
			},
			getLineHeight : function(index){
				var baseLineHeight = this.y - (this.height/2) + this.yPadding,
					afterTitleIndex = index-1;
	
				//If the index is zero, we're getting the title
				if (index === 0){
					return baseLineHeight + this.titleHeight / 3;
				} else{
					return baseLineHeight + ((this.fontSize * 1.5 * afterTitleIndex) + this.fontSize / 2) + this.titleHeight;
				}
	
			},
			draw : function(){
				// Custom Tooltips
				if(this.custom){
					this.custom(this);
				}
				else{
					drawRoundedRectangle(this.ctx,this.x,this.y - this.height/2,this.width,this.height,this.cornerRadius);
					var ctx = this.ctx;
					ctx.fillStyle = this.fillColor;
					ctx.fill();
					ctx.closePath();
	
					ctx.textAlign = "left";
					ctx.textBaseline = "middle";
					ctx.fillStyle = this.titleTextColor;
					ctx.font = this.titleFont;
	
					ctx.fillText(this.title,this.x + this.xPadding, this.getLineHeight(0));
	
					ctx.font = this.font;
					helpers.each(this.labels,function(label,index){
						ctx.fillStyle = this.textColor;
						ctx.fillText(label,this.x + this.xPadding + this.fontSize + 3, this.getLineHeight(index + 1));
	
						//A bit gnarly, but clearing this rectangle breaks when using explorercanvas (clears whole canvas)
						//ctx.clearRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
						//Instead we'll make a white filled block to put the legendColour palette over.
	
						ctx.fillStyle = this.legendColorBackground;
						ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
	
						ctx.fillStyle = this.legendColors[index].fill;
						ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
	
	
					},this);
				}
			}
		});
	
		Chart.Scale = Chart.Element.extend({
			initialize : function(){
				this.fit();
			},
			buildYLabels : function(){
				this.yLabels = [];
	
				var stepDecimalPlaces = getDecimalPlaces(this.stepValue);
	
				for (var i=0; i<=this.steps; i++){
					this.yLabels.push(template(this.templateString,{value:(this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces)}));
				}
				this.yLabelWidth = (this.display && this.showLabels) ? longestText(this.ctx,this.font,this.yLabels) + 10 : 0;
			},
			addXLabel : function(label){
				this.xLabels.push(label);
				this.valuesCount++;
				this.fit();
			},
			removeXLabel : function(){
				this.xLabels.shift();
				this.valuesCount--;
				this.fit();
			},
			// Fitting loop to rotate x Labels and figure out what fits there, and also calculate how many Y steps to use
			fit: function(){
				// First we need the width of the yLabels, assuming the xLabels aren't rotated
	
				// To do that we need the base line at the top and base of the chart, assuming there is no x label rotation
				this.startPoint = (this.display) ? this.fontSize : 0;
				this.endPoint = (this.display) ? this.height - (this.fontSize * 1.5) - 5 : this.height; // -5 to pad labels
	
				// Apply padding settings to the start and end point.
				this.startPoint += this.padding;
				this.endPoint -= this.padding;
	
				// Cache the starting endpoint, excluding the space for x labels
				var cachedEndPoint = this.endPoint;
	
				// Cache the starting height, so can determine if we need to recalculate the scale yAxis
				var cachedHeight = this.endPoint - this.startPoint,
					cachedYLabelWidth;
	
				// Build the current yLabels so we have an idea of what size they'll be to start
				/*
				 *	This sets what is returned from calculateScaleRange as static properties of this class:
				 *
					this.steps;
					this.stepValue;
					this.min;
					this.max;
				 *
				 */
				this.calculateYRange(cachedHeight);
	
				// With these properties set we can now build the array of yLabels
				// and also the width of the largest yLabel
				this.buildYLabels();
	
				this.calculateXLabelRotation();
	
				while((cachedHeight > this.endPoint - this.startPoint)){
					cachedHeight = this.endPoint - this.startPoint;
					cachedYLabelWidth = this.yLabelWidth;
	
					this.calculateYRange(cachedHeight);
					this.buildYLabels();
	
					// Only go through the xLabel loop again if the yLabel width has changed
					if (cachedYLabelWidth < this.yLabelWidth){
						this.endPoint = cachedEndPoint;
						this.calculateXLabelRotation();
					}
				}
	
			},
			calculateXLabelRotation : function(){
				//Get the width of each grid by calculating the difference
				//between x offsets between 0 and 1.
	
				this.ctx.font = this.font;
	
				var firstWidth = this.ctx.measureText(this.xLabels[0]).width,
					lastWidth = this.ctx.measureText(this.xLabels[this.xLabels.length - 1]).width,
					firstRotated,
					lastRotated;
	
	
				this.xScalePaddingRight = lastWidth/2 + 3;
				this.xScalePaddingLeft = (firstWidth/2 > this.yLabelWidth) ? firstWidth/2 : this.yLabelWidth;
	
				this.xLabelRotation = 0;
				if (this.display){
					var originalLabelWidth = longestText(this.ctx,this.font,this.xLabels),
						cosRotation,
						firstRotatedWidth;
					this.xLabelWidth = originalLabelWidth;
					//Allow 3 pixels x2 padding either side for label readability
					var xGridWidth = Math.floor(this.calculateX(1) - this.calculateX(0)) - 6;
	
					//Max label rotate should be 90 - also act as a loop counter
					while ((this.xLabelWidth > xGridWidth && this.xLabelRotation === 0) || (this.xLabelWidth > xGridWidth && this.xLabelRotation <= 90 && this.xLabelRotation > 0)){
						cosRotation = Math.cos(toRadians(this.xLabelRotation));
	
						firstRotated = cosRotation * firstWidth;
						lastRotated = cosRotation * lastWidth;
	
						// We're right aligning the text now.
						if (firstRotated + this.fontSize / 2 > this.yLabelWidth){
							this.xScalePaddingLeft = firstRotated + this.fontSize / 2;
						}
						this.xScalePaddingRight = this.fontSize/2;
	
	
						this.xLabelRotation++;
						this.xLabelWidth = cosRotation * originalLabelWidth;
	
					}
					if (this.xLabelRotation > 0){
						this.endPoint -= Math.sin(toRadians(this.xLabelRotation))*originalLabelWidth + 3;
					}
				}
				else{
					this.xLabelWidth = 0;
					this.xScalePaddingRight = this.padding;
					this.xScalePaddingLeft = this.padding;
				}
	
			},
			// Needs to be overidden in each Chart type
			// Otherwise we need to pass all the data into the scale class
			calculateYRange: noop,
			drawingArea: function(){
				return this.startPoint - this.endPoint;
			},
			calculateY : function(value){
				var scalingFactor = this.drawingArea() / (this.min - this.max);
				return this.endPoint - (scalingFactor * (value - this.min));
			},
			calculateX : function(index){
				var isRotated = (this.xLabelRotation > 0),
					// innerWidth = (this.offsetGridLines) ? this.width - offsetLeft - this.padding : this.width - (offsetLeft + halfLabelWidth * 2) - this.padding,
					innerWidth = this.width - (this.xScalePaddingLeft + this.xScalePaddingRight),
					valueWidth = innerWidth/Math.max((this.valuesCount - ((this.offsetGridLines) ? 0 : 1)), 1),
					valueOffset = (valueWidth * index) + this.xScalePaddingLeft;
	
				if (this.offsetGridLines){
					valueOffset += (valueWidth/2);
				}
	
				return Math.round(valueOffset);
			},
			update : function(newProps){
				helpers.extend(this, newProps);
				this.fit();
			},
			draw : function(){
				var ctx = this.ctx,
					yLabelGap = (this.endPoint - this.startPoint) / this.steps,
					xStart = Math.round(this.xScalePaddingLeft);
				if (this.display){
					ctx.fillStyle = this.textColor;
					ctx.font = this.font;
					each(this.yLabels,function(labelString,index){
						var yLabelCenter = this.endPoint - (yLabelGap * index),
							linePositionY = Math.round(yLabelCenter),
							drawHorizontalLine = this.showHorizontalLines;
	
						ctx.textAlign = "right";
						ctx.textBaseline = "middle";
						if (this.showLabels){
							ctx.fillText(labelString,xStart - 10,yLabelCenter);
						}
	
						// This is X axis, so draw it
						if (index === 0 && !drawHorizontalLine){
							drawHorizontalLine = true;
						}
	
						if (drawHorizontalLine){
							ctx.beginPath();
						}
	
						if (index > 0){
							// This is a grid line in the centre, so drop that
							ctx.lineWidth = this.gridLineWidth;
							ctx.strokeStyle = this.gridLineColor;
						} else {
							// This is the first line on the scale
							ctx.lineWidth = this.lineWidth;
							ctx.strokeStyle = this.lineColor;
						}
	
						linePositionY += helpers.aliasPixel(ctx.lineWidth);
	
						if(drawHorizontalLine){
							ctx.moveTo(xStart, linePositionY);
							ctx.lineTo(this.width, linePositionY);
							ctx.stroke();
							ctx.closePath();
						}
	
						ctx.lineWidth = this.lineWidth;
						ctx.strokeStyle = this.lineColor;
						ctx.beginPath();
						ctx.moveTo(xStart - 5, linePositionY);
						ctx.lineTo(xStart, linePositionY);
						ctx.stroke();
						ctx.closePath();
	
					},this);
	
					each(this.xLabels,function(label,index){
						var xPos = this.calculateX(index) + aliasPixel(this.lineWidth),
							// Check to see if line/bar here and decide where to place the line
							linePos = this.calculateX(index - (this.offsetGridLines ? 0.5 : 0)) + aliasPixel(this.lineWidth),
							isRotated = (this.xLabelRotation > 0),
							drawVerticalLine = this.showVerticalLines;
	
						// This is Y axis, so draw it
						if (index === 0 && !drawVerticalLine){
							drawVerticalLine = true;
						}
	
						if (drawVerticalLine){
							ctx.beginPath();
						}
	
						if (index > 0){
							// This is a grid line in the centre, so drop that
							ctx.lineWidth = this.gridLineWidth;
							ctx.strokeStyle = this.gridLineColor;
						} else {
							// This is the first line on the scale
							ctx.lineWidth = this.lineWidth;
							ctx.strokeStyle = this.lineColor;
						}
	
						if (drawVerticalLine){
							ctx.moveTo(linePos,this.endPoint);
							ctx.lineTo(linePos,this.startPoint - 3);
							ctx.stroke();
							ctx.closePath();
						}
	
	
						ctx.lineWidth = this.lineWidth;
						ctx.strokeStyle = this.lineColor;
	
	
						// Small lines at the bottom of the base grid line
						ctx.beginPath();
						ctx.moveTo(linePos,this.endPoint);
						ctx.lineTo(linePos,this.endPoint + 5);
						ctx.stroke();
						ctx.closePath();
	
						ctx.save();
						ctx.translate(xPos,(isRotated) ? this.endPoint + 12 : this.endPoint + 8);
						ctx.rotate(toRadians(this.xLabelRotation)*-1);
						ctx.font = this.font;
						ctx.textAlign = (isRotated) ? "right" : "center";
						ctx.textBaseline = (isRotated) ? "middle" : "top";
						ctx.fillText(label, 0, 0);
						ctx.restore();
					},this);
	
				}
			}
	
		});
	
		Chart.RadialScale = Chart.Element.extend({
			initialize: function(){
				this.size = min([this.height, this.width]);
				this.drawingArea = (this.display) ? (this.size/2) - (this.fontSize/2 + this.backdropPaddingY) : (this.size/2);
			},
			calculateCenterOffset: function(value){
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = this.drawingArea / (this.max - this.min);
	
				return (value - this.min) * scalingFactor;
			},
			update : function(){
				if (!this.lineArc){
					this.setScaleSize();
				} else {
					this.drawingArea = (this.display) ? (this.size/2) - (this.fontSize/2 + this.backdropPaddingY) : (this.size/2);
				}
				this.buildYLabels();
			},
			buildYLabels: function(){
				this.yLabels = [];
	
				var stepDecimalPlaces = getDecimalPlaces(this.stepValue);
	
				for (var i=0; i<=this.steps; i++){
					this.yLabels.push(template(this.templateString,{value:(this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces)}));
				}
			},
			getCircumference : function(){
				return ((Math.PI*2) / this.valuesCount);
			},
			setScaleSize: function(){
				/*
				 * Right, this is really confusing and there is a lot of maths going on here
				 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
				 *
				 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
				 *
				 * Solution:
				 *
				 * We assume the radius of the polygon is half the size of the canvas at first
				 * at each index we check if the text overlaps.
				 *
				 * Where it does, we store that angle and that index.
				 *
				 * After finding the largest index and angle we calculate how much we need to remove
				 * from the shape radius to move the point inwards by that x.
				 *
				 * We average the left and right distances to get the maximum shape radius that can fit in the box
				 * along with labels.
				 *
				 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
				 * on each side, removing that from the size, halving it and adding the left x protrusion width.
				 *
				 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
				 * and position it in the most space efficient manner
				 *
				 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
				 */
	
	
				// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
				// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
				var largestPossibleRadius = min([(this.height/2 - this.pointLabelFontSize - 5), this.width/2]),
					pointPosition,
					i,
					textWidth,
					halfTextWidth,
					furthestRight = this.width,
					furthestRightIndex,
					furthestRightAngle,
					furthestLeft = 0,
					furthestLeftIndex,
					furthestLeftAngle,
					xProtrusionLeft,
					xProtrusionRight,
					radiusReductionRight,
					radiusReductionLeft,
					maxWidthRadius;
				this.ctx.font = fontString(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily);
				for (i=0;i<this.valuesCount;i++){
					// 5px to space the text slightly out - similar to what we do in the draw function.
					pointPosition = this.getPointPosition(i, largestPossibleRadius);
					textWidth = this.ctx.measureText(template(this.templateString, { value: this.labels[i] })).width + 5;
					if (i === 0 || i === this.valuesCount/2){
						// If we're at index zero, or exactly the middle, we're at exactly the top/bottom
						// of the radar chart, so text will be aligned centrally, so we'll half it and compare
						// w/left and right text sizes
						halfTextWidth = textWidth/2;
						if (pointPosition.x + halfTextWidth > furthestRight) {
							furthestRight = pointPosition.x + halfTextWidth;
							furthestRightIndex = i;
						}
						if (pointPosition.x - halfTextWidth < furthestLeft) {
							furthestLeft = pointPosition.x - halfTextWidth;
							furthestLeftIndex = i;
						}
					}
					else if (i < this.valuesCount/2) {
						// Less than half the values means we'll left align the text
						if (pointPosition.x + textWidth > furthestRight) {
							furthestRight = pointPosition.x + textWidth;
							furthestRightIndex = i;
						}
					}
					else if (i > this.valuesCount/2){
						// More than half the values means we'll right align the text
						if (pointPosition.x - textWidth < furthestLeft) {
							furthestLeft = pointPosition.x - textWidth;
							furthestLeftIndex = i;
						}
					}
				}
	
				xProtrusionLeft = furthestLeft;
	
				xProtrusionRight = Math.ceil(furthestRight - this.width);
	
				furthestRightAngle = this.getIndexAngle(furthestRightIndex);
	
				furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);
	
				radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI/2);
	
				radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI/2);
	
				// Ensure we actually need to reduce the size of the chart
				radiusReductionRight = (isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
				radiusReductionLeft = (isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;
	
				this.drawingArea = largestPossibleRadius - (radiusReductionLeft + radiusReductionRight)/2;
	
				//this.drawingArea = min([maxWidthRadius, (this.height - (2 * (this.pointLabelFontSize + 5)))/2])
				this.setCenterPoint(radiusReductionLeft, radiusReductionRight);
	
			},
			setCenterPoint: function(leftMovement, rightMovement){
	
				var maxRight = this.width - rightMovement - this.drawingArea,
					maxLeft = leftMovement + this.drawingArea;
	
				this.xCenter = (maxLeft + maxRight)/2;
				// Always vertically in the centre as the text height doesn't change
				this.yCenter = (this.height/2);
			},
	
			getIndexAngle : function(index){
				var angleMultiplier = (Math.PI * 2) / this.valuesCount;
				// Start from the top instead of right, so remove a quarter of the circle
	
				return index * angleMultiplier - (Math.PI/2);
			},
			getPointPosition : function(index, distanceFromCenter){
				var thisAngle = this.getIndexAngle(index);
				return {
					x : (Math.cos(thisAngle) * distanceFromCenter) + this.xCenter,
					y : (Math.sin(thisAngle) * distanceFromCenter) + this.yCenter
				};
			},
			draw: function(){
				if (this.display){
					var ctx = this.ctx;
					each(this.yLabels, function(label, index){
						// Don't draw a centre value
						if (index > 0){
							var yCenterOffset = index * (this.drawingArea/this.steps),
								yHeight = this.yCenter - yCenterOffset,
								pointPosition;
	
							// Draw circular lines around the scale
							if (this.lineWidth > 0){
								ctx.strokeStyle = this.lineColor;
								ctx.lineWidth = this.lineWidth;
	
								if(this.lineArc){
									ctx.beginPath();
									ctx.arc(this.xCenter, this.yCenter, yCenterOffset, 0, Math.PI*2);
									ctx.closePath();
									ctx.stroke();
								} else{
									ctx.beginPath();
									for (var i=0;i<this.valuesCount;i++)
									{
										pointPosition = this.getPointPosition(i, this.calculateCenterOffset(this.min + (index * this.stepValue)));
										if (i === 0){
											ctx.moveTo(pointPosition.x, pointPosition.y);
										} else {
											ctx.lineTo(pointPosition.x, pointPosition.y);
										}
									}
									ctx.closePath();
									ctx.stroke();
								}
							}
							if(this.showLabels){
								ctx.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
								if (this.showLabelBackdrop){
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = this.backdropColor;
									ctx.fillRect(
										this.xCenter - labelWidth/2 - this.backdropPaddingX,
										yHeight - this.fontSize/2 - this.backdropPaddingY,
										labelWidth + this.backdropPaddingX*2,
										this.fontSize + this.backdropPaddingY*2
									);
								}
								ctx.textAlign = 'center';
								ctx.textBaseline = "middle";
								ctx.fillStyle = this.fontColor;
								ctx.fillText(label, this.xCenter, yHeight);
							}
						}
					}, this);
	
					if (!this.lineArc){
						ctx.lineWidth = this.angleLineWidth;
						ctx.strokeStyle = this.angleLineColor;
						for (var i = this.valuesCount - 1; i >= 0; i--) {
							var centerOffset = null, outerPosition = null;
	
							if (this.angleLineWidth > 0 && (i % this.angleLineInterval === 0)){
								centerOffset = this.calculateCenterOffset(this.max);
								outerPosition = this.getPointPosition(i, centerOffset);
								ctx.beginPath();
								ctx.moveTo(this.xCenter, this.yCenter);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.stroke();
								ctx.closePath();
							}
	
							if (this.backgroundColors && this.backgroundColors.length == this.valuesCount) {
								if (centerOffset == null)
									centerOffset = this.calculateCenterOffset(this.max);
	
								if (outerPosition == null)
									outerPosition = this.getPointPosition(i, centerOffset);
	
								var previousOuterPosition = this.getPointPosition(i === 0 ? this.valuesCount - 1 : i - 1, centerOffset);
								var nextOuterPosition = this.getPointPosition(i === this.valuesCount - 1 ? 0 : i + 1, centerOffset);
	
								var previousOuterHalfway = { x: (previousOuterPosition.x + outerPosition.x) / 2, y: (previousOuterPosition.y + outerPosition.y) / 2 };
								var nextOuterHalfway = { x: (outerPosition.x + nextOuterPosition.x) / 2, y: (outerPosition.y + nextOuterPosition.y) / 2 };
	
								ctx.beginPath();
								ctx.moveTo(this.xCenter, this.yCenter);
								ctx.lineTo(previousOuterHalfway.x, previousOuterHalfway.y);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.lineTo(nextOuterHalfway.x, nextOuterHalfway.y);
								ctx.fillStyle = this.backgroundColors[i];
								ctx.fill();
								ctx.closePath();
							}
							// Extra 3px out for some label spacing
							var pointLabelPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max) + 5);
							ctx.font = fontString(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily);
							ctx.fillStyle = this.pointLabelFontColor;
	
							var labelsCount = this.labels.length,
								halfLabelsCount = this.labels.length/2,
								quarterLabelsCount = halfLabelsCount/2,
								upperHalf = (i < quarterLabelsCount || i > labelsCount - quarterLabelsCount),
								exactQuarter = (i === quarterLabelsCount || i === labelsCount - quarterLabelsCount);
							if (i === 0){
								ctx.textAlign = 'center';
							} else if(i === halfLabelsCount){
								ctx.textAlign = 'center';
							} else if (i < halfLabelsCount){
								ctx.textAlign = 'left';
							} else {
								ctx.textAlign = 'right';
							}
	
							// Set the correct text baseline based on outer positioning
							if (exactQuarter){
								ctx.textBaseline = 'middle';
							} else if (upperHalf){
								ctx.textBaseline = 'bottom';
							} else {
								ctx.textBaseline = 'top';
							}
	
							ctx.fillText(this.labels[i], pointLabelPosition.x, pointLabelPosition.y);
						}
					}
				}
			}
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			addAnimation: function(chartInstance, animationObject) {
				for (var index = 0; index < this.animations.length; ++ index){
					if (this.animations[index].chartInstance === chartInstance){
						// replacing an in progress animation
						this.animations[index].animationObject = animationObject;
						return;
					}
				}
				
				this.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (this.animations.length == 1) {
					helpers.requestAnimFrame.call(window, this.digestWrapper);
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findNextWhere(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
				
				if (index)
				{
					this.animations.splice(index, 1);
				}
			},
			// calls startDigest with the proper context
			digestWrapper: function() {
				Chart.animationService.startDigest.call(Chart.animationService);
			},
			startDigest: function() {
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if(this.dropFrames > 1){
					framesToDrop = Math.floor(this.dropFrames);
					this.dropFrames -= framesToDrop;
				}
	
				for (var i = 0; i < this.animations.length; i++) {
	
					if (this.animations[i].animationObject.currentStep === null){
						this.animations[i].animationObject.currentStep = 0;
					}
	
					this.animations[i].animationObject.currentStep += 1 + framesToDrop;
					if(this.animations[i].animationObject.currentStep > this.animations[i].animationObject.numSteps){
						this.animations[i].animationObject.currentStep = this.animations[i].animationObject.numSteps;
					}
					
					this.animations[i].animationObject.render(this.animations[i].chartInstance, this.animations[i].animationObject);
					
					// Check if executed the last frame.
					if (this.animations[i].animationObject.currentStep == this.animations[i].animationObject.numSteps){
						// Call onAnimationComplete
						this.animations[i].animationObject.onAnimationComplete.call(this.animations[i].chartInstance);
						// Remove the animation.
						this.animations.splice(i, 1);
						// Keep the index in place to offset the splice
						i--;
					}
				}
	
				var endTime = Date.now();
				var delay = endTime - startTime - this.frameDuration;
				var frameDelay = delay / this.frameDuration;
	
				if(frameDelay > 1){
					this.dropFrames += frameDelay;
				}
	
				// Do we have more stuff to animate?
				if (this.animations.length > 0){
					helpers.requestAnimFrame.call(window, this.digestWrapper);
				}
			}
		};
	
		// Attach global event to resize each chart instance when the browser resizes
		helpers.addEvent(window, "resize", (function(){
			// Basic debounce of resize function so it doesn't hurt performance when resizing browser.
			var timeout;
			return function(){
				clearTimeout(timeout);
				timeout = setTimeout(function(){
					each(Chart.instances,function(instance){
						// If the responsive flag is set in the chart instance config
						// Cascade the resize event down to the chart.
						if (instance.options.responsive){
							instance.resize(instance.render, true);
						}
					});
				}, 50);
			};
		})());
	
	
		if (amd) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
				return Chart;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === 'object' && module.exports) {
			module.exports = Chart;
		}
	
		root.Chart = Chart;
	
		Chart.noConflict = function(){
			root.Chart = previous;
			return Chart;
		};
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			helpers = Chart.helpers;
	
	
		var defaultConfig = {
			//Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
			scaleBeginAtZero : true,
	
			//Boolean - Whether grid lines are shown across the chart
			scaleShowGridLines : true,
	
			//String - Colour of the grid lines
			scaleGridLineColor : "rgba(0,0,0,.05)",
	
			//Number - Width of the grid lines
			scaleGridLineWidth : 1,
	
			//Boolean - Whether to show horizontal lines (except X axis)
			scaleShowHorizontalLines: true,
	
			//Boolean - Whether to show vertical lines (except Y axis)
			scaleShowVerticalLines: true,
	
			//Boolean - If there is a stroke on each bar
			barShowStroke : true,
	
			//Number - Pixel width of the bar stroke
			barStrokeWidth : 2,
	
			//Number - Spacing between each of the X value sets
			barValueSpacing : 5,
	
			//Number - Spacing between data sets within X values
			barDatasetSpacing : 1,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span class=\"<%=name.toLowerCase()%>-legend-icon\" style=\"background-color:<%=datasets[i].fillColor%>\"></span><span class=\"<%=name.toLowerCase()%>-legend-text\"><%if(datasets[i].label){%><%=datasets[i].label%><%}%></span></li><%}%></ul>"
	
		};
	
	
		Chart.Type.extend({
			name: "Bar",
			defaults : defaultConfig,
			initialize:  function(data){
	
				//Expose options as a scope variable here so we can access it in the ScaleClass
				var options = this.options;
	
				this.ScaleClass = Chart.Scale.extend({
					offsetGridLines : true,
					calculateBarX : function(datasetCount, datasetIndex, barIndex){
						//Reusable method for calculating the xPosition of a given bar based on datasetIndex & width of the bar
						var xWidth = this.calculateBaseWidth(),
							xAbsolute = this.calculateX(barIndex) - (xWidth/2),
							barWidth = this.calculateBarWidth(datasetCount);
	
						return xAbsolute + (barWidth * datasetIndex) + (datasetIndex * options.barDatasetSpacing) + barWidth/2;
					},
					calculateBaseWidth : function(){
						return (this.calculateX(1) - this.calculateX(0)) - (2*options.barValueSpacing);
					},
					calculateBarWidth : function(datasetCount){
						//The padding between datasets is to the right of each bar, providing that there are more than 1 dataset
						var baseWidth = this.calculateBaseWidth() - ((datasetCount - 1) * options.barDatasetSpacing);
	
						return (baseWidth / datasetCount);
					}
				});
	
				this.datasets = [];
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activeBars = (evt.type !== 'mouseout') ? this.getBarsAtEvent(evt) : [];
	
						this.eachBars(function(bar){
							bar.restore(['fillColor', 'strokeColor']);
						});
						helpers.each(activeBars, function(activeBar){
							if (activeBar) {
								activeBar.fillColor = activeBar.highlightFill;
								activeBar.strokeColor = activeBar.highlightStroke;
							}
						});
						this.showTooltip(activeBars);
					});
				}
	
				//Declare the extension of the default point, to cater for the options passed in to the constructor
				this.BarClass = Chart.Rectangle.extend({
					strokeWidth : this.options.barStrokeWidth,
					showStroke : this.options.barShowStroke,
					ctx : this.chart.ctx
				});
	
				//Iterate through each of the datasets, and build this into a property of the chart
				helpers.each(data.datasets,function(dataset,datasetIndex){
	
					var datasetObject = {
						label : dataset.label || null,
						fillColor : dataset.fillColor,
						strokeColor : dataset.strokeColor,
						bars : []
					};
	
					this.datasets.push(datasetObject);
	
					helpers.each(dataset.data,function(dataPoint,index){
						//Add a new point for each piece of data, passing any required data to draw.
						datasetObject.bars.push(new this.BarClass({
							value : dataPoint,
							label : data.labels[index],
							datasetLabel: dataset.label,
							strokeColor : (typeof dataset.strokeColor == 'object') ? dataset.strokeColor[index] : dataset.strokeColor,
							fillColor : (typeof dataset.fillColor == 'object') ? dataset.fillColor[index] : dataset.fillColor,
							highlightFill : (dataset.highlightFill) ? (typeof dataset.highlightFill == 'object') ? dataset.highlightFill[index] : dataset.highlightFill : (typeof dataset.fillColor == 'object') ? dataset.fillColor[index] : dataset.fillColor,
							highlightStroke : (dataset.highlightStroke) ? (typeof dataset.highlightStroke == 'object') ? dataset.highlightStroke[index] : dataset.highlightStroke : (typeof dataset.strokeColor == 'object') ? dataset.strokeColor[index] : dataset.strokeColor
						}));
					},this);
	
				},this);
	
				this.buildScale(data.labels);
	
				this.BarClass.prototype.base = this.scale.endPoint;
	
				this.eachBars(function(bar, index, datasetIndex){
					helpers.extend(bar, {
						width : this.scale.calculateBarWidth(this.datasets.length),
						x: this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
						y: this.scale.endPoint
					});
					bar.save();
				}, this);
	
				this.render();
			},
			update : function(){
				this.scale.update();
				// Reset any highlight colours before updating.
				helpers.each(this.activeElements, function(activeElement){
					activeElement.restore(['fillColor', 'strokeColor']);
				});
	
				this.eachBars(function(bar){
					bar.save();
				});
				this.render();
			},
			eachBars : function(callback){
				helpers.each(this.datasets,function(dataset, datasetIndex){
					helpers.each(dataset.bars, callback, this, datasetIndex);
				},this);
			},
			getBarsAtEvent : function(e){
				var barsArray = [],
					eventPosition = helpers.getRelativePosition(e),
					datasetIterator = function(dataset){
						barsArray.push(dataset.bars[barIndex]);
					},
					barIndex;
	
				for (var datasetIndex = 0; datasetIndex < this.datasets.length; datasetIndex++) {
					for (barIndex = 0; barIndex < this.datasets[datasetIndex].bars.length; barIndex++) {
						if (this.datasets[datasetIndex].bars[barIndex].inRange(eventPosition.x,eventPosition.y)){
							helpers.each(this.datasets, datasetIterator);
							return barsArray;
						}
					}
				}
	
				return barsArray;
			},
			buildScale : function(labels){
				var self = this;
	
				var dataTotal = function(){
					var values = [];
					self.eachBars(function(bar){
						values.push(bar.value);
					});
					return values;
				};
	
				var scaleOptions = {
					templateString : this.options.scaleLabel,
					height : this.chart.height,
					width : this.chart.width,
					ctx : this.chart.ctx,
					textColor : this.options.scaleFontColor,
					fontSize : this.options.scaleFontSize,
					fontStyle : this.options.scaleFontStyle,
					fontFamily : this.options.scaleFontFamily,
					valuesCount : labels.length,
					beginAtZero : this.options.scaleBeginAtZero,
					integersOnly : this.options.scaleIntegersOnly,
					calculateYRange: function(currentHeight){
						var updatedRanges = helpers.calculateScaleRange(
							dataTotal(),
							currentHeight,
							this.fontSize,
							this.beginAtZero,
							this.integersOnly
						);
						helpers.extend(this, updatedRanges);
					},
					xLabels : labels,
					font : helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
					lineWidth : this.options.scaleLineWidth,
					lineColor : this.options.scaleLineColor,
					showHorizontalLines : this.options.scaleShowHorizontalLines,
					showVerticalLines : this.options.scaleShowVerticalLines,
					gridLineWidth : (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
					gridLineColor : (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : "rgba(0,0,0,0)",
					padding : (this.options.showScale) ? 0 : (this.options.barShowStroke) ? this.options.barStrokeWidth : 0,
					showLabels : this.options.scaleShowLabels,
					display : this.options.showScale
				};
	
				if (this.options.scaleOverride){
					helpers.extend(scaleOptions, {
						calculateYRange: helpers.noop,
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					});
				}
	
				this.scale = new this.ScaleClass(scaleOptions);
			},
			addData : function(valuesArray,label){
				//Map the values array for each of the datasets
				helpers.each(valuesArray,function(value,datasetIndex){
					//Add a new point for each piece of data, passing any required data to draw.
					this.datasets[datasetIndex].bars.push(new this.BarClass({
						value : value,
						label : label,
						datasetLabel: this.datasets[datasetIndex].label,
						x: this.scale.calculateBarX(this.datasets.length, datasetIndex, this.scale.valuesCount+1),
						y: this.scale.endPoint,
						width : this.scale.calculateBarWidth(this.datasets.length),
						base : this.scale.endPoint,
						strokeColor : this.datasets[datasetIndex].strokeColor,
						fillColor : this.datasets[datasetIndex].fillColor
					}));
				},this);
	
				this.scale.addXLabel(label);
				//Then re-render the chart.
				this.update();
			},
			removeData : function(){
				this.scale.removeXLabel();
				//Then re-render the chart.
				helpers.each(this.datasets,function(dataset){
					dataset.bars.shift();
				},this);
				this.update();
			},
			reflow : function(){
				helpers.extend(this.BarClass.prototype,{
					y: this.scale.endPoint,
					base : this.scale.endPoint
				});
				var newScaleProps = helpers.extend({
					height : this.chart.height,
					width : this.chart.width
				});
				this.scale.update(newScaleProps);
			},
			draw : function(ease){
				var easingDecimal = ease || 1;
				this.clear();
	
				var ctx = this.chart.ctx;
	
				this.scale.draw(easingDecimal);
	
				//Draw all the bars for each dataset
				helpers.each(this.datasets,function(dataset,datasetIndex){
					helpers.each(dataset.bars,function(bar,index){
						if (bar.hasValue()){
							bar.base = this.scale.endPoint;
							//Transition then draw
							bar.transition({
								x : this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
								y : this.scale.calculateY(bar.value),
								width : this.scale.calculateBarWidth(this.datasets.length)
							}, easingDecimal).draw();
						}
					},this);
	
				},this);
			}
		});
	
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			//Cache a local reference to Chart.helpers
			helpers = Chart.helpers;
	
		var defaultConfig = {
			//Boolean - Whether we should show a stroke on each segment
			segmentShowStroke : true,
	
			//String - The colour of each segment stroke
			segmentStrokeColor : "#fff",
	
			//Number - The width of each segment stroke
			segmentStrokeWidth : 2,
	
			//The percentage of the chart that we cut out of the middle.
			percentageInnerCutout : 50,
	
			//Number - Amount of animation steps
			animationSteps : 100,
	
			//String - Animation easing effect
			animationEasing : "easeOutBounce",
	
			//Boolean - Whether we animate the rotation of the Doughnut
			animateRotate : true,
	
			//Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale : false,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span class=\"<%=name.toLowerCase()%>-legend-icon\" style=\"background-color:<%=segments[i].fillColor%>\"></span><span class=\"<%=name.toLowerCase()%>-legend-text\"><%if(segments[i].label){%><%=segments[i].label%><%}%></span></li><%}%></ul>"
	
		};
	
		Chart.Type.extend({
			//Passing in a name registers this chart in the Chart namespace
			name: "Doughnut",
			//Providing a defaults will also register the defaults in the chart namespace
			defaults : defaultConfig,
			//Initialize is fired when the chart is initialized - Data is passed in as a parameter
			//Config is automatically merged by the core of Chart.js, and is available at this.options
			initialize:  function(data){
	
				//Declare segments as a static property to prevent inheriting across the Chart type prototype
				this.segments = [];
				this.outerRadius = (helpers.min([this.chart.width,this.chart.height]) -	this.options.segmentStrokeWidth/2)/2;
	
				this.SegmentArc = Chart.Arc.extend({
					ctx : this.chart.ctx,
					x : this.chart.width/2,
					y : this.chart.height/2
				});
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : [];
	
						helpers.each(this.segments,function(segment){
							segment.restore(["fillColor"]);
						});
						helpers.each(activeSegments,function(activeSegment){
							activeSegment.fillColor = activeSegment.highlightColor;
						});
						this.showTooltip(activeSegments);
					});
				}
				this.calculateTotal(data);
	
				helpers.each(data,function(datapoint, index){
					if (!datapoint.color) {
						datapoint.color = 'hsl(' + (360 * index / data.length) + ', 100%, 50%)';
					}
					this.addData(datapoint, index, true);
				},this);
	
				this.render();
			},
			getSegmentsAtEvent : function(e){
				var segmentsArray = [];
	
				var location = helpers.getRelativePosition(e);
	
				helpers.each(this.segments,function(segment){
					if (segment.inRange(location.x,location.y)) segmentsArray.push(segment);
				},this);
				return segmentsArray;
			},
			addData : function(segment, atIndex, silent){
				var index = atIndex !== undefined ? atIndex : this.segments.length;
				if ( typeof(segment.color) === "undefined" ) {
					segment.color = Chart.defaults.global.segmentColorDefault[index % Chart.defaults.global.segmentColorDefault.length];
					segment.highlight = Chart.defaults.global.segmentHighlightColorDefaults[index % Chart.defaults.global.segmentHighlightColorDefaults.length];				
				}
				this.segments.splice(index, 0, new this.SegmentArc({
					value : segment.value,
					outerRadius : (this.options.animateScale) ? 0 : this.outerRadius,
					innerRadius : (this.options.animateScale) ? 0 : (this.outerRadius/100) * this.options.percentageInnerCutout,
					fillColor : segment.color,
					highlightColor : segment.highlight || segment.color,
					showStroke : this.options.segmentShowStroke,
					strokeWidth : this.options.segmentStrokeWidth,
					strokeColor : this.options.segmentStrokeColor,
					startAngle : Math.PI * 1.5,
					circumference : (this.options.animateRotate) ? 0 : this.calculateCircumference(segment.value),
					label : segment.label
				}));
				if (!silent){
					this.reflow();
					this.update();
				}
			},
			calculateCircumference : function(value) {
				if ( this.total > 0 ) {
					return (Math.PI*2)*(value / this.total);
				} else {
					return 0;
				}
			},
			calculateTotal : function(data){
				this.total = 0;
				helpers.each(data,function(segment){
					this.total += Math.abs(segment.value);
				},this);
			},
			update : function(){
				this.calculateTotal(this.segments);
	
				// Reset any highlight colours before updating.
				helpers.each(this.activeElements, function(activeElement){
					activeElement.restore(['fillColor']);
				});
	
				helpers.each(this.segments,function(segment){
					segment.save();
				});
				this.render();
			},
	
			removeData: function(atIndex){
				var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length-1;
				this.segments.splice(indexToDelete, 1);
				this.reflow();
				this.update();
			},
	
			reflow : function(){
				helpers.extend(this.SegmentArc.prototype,{
					x : this.chart.width/2,
					y : this.chart.height/2
				});
				this.outerRadius = (helpers.min([this.chart.width,this.chart.height]) -	this.options.segmentStrokeWidth/2)/2;
				helpers.each(this.segments, function(segment){
					segment.update({
						outerRadius : this.outerRadius,
						innerRadius : (this.outerRadius/100) * this.options.percentageInnerCutout
					});
				}, this);
			},
			draw : function(easeDecimal){
				var animDecimal = (easeDecimal) ? easeDecimal : 1;
				this.clear();
				helpers.each(this.segments,function(segment,index){
					segment.transition({
						circumference : this.calculateCircumference(segment.value),
						outerRadius : this.outerRadius,
						innerRadius : (this.outerRadius/100) * this.options.percentageInnerCutout
					},animDecimal);
	
					segment.endAngle = segment.startAngle + segment.circumference;
	
					segment.draw();
					if (index === 0){
						segment.startAngle = Math.PI * 1.5;
					}
					//Check to see if it's the last segment, if not get the next and update the start angle
					if (index < this.segments.length-1){
						this.segments[index+1].startAngle = segment.endAngle;
					}
				},this);
	
			}
		});
	
		Chart.types.Doughnut.extend({
			name : "Pie",
			defaults : helpers.merge(defaultConfig,{percentageInnerCutout : 0})
		});
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			helpers = Chart.helpers;
	
		var defaultConfig = {
	
			///Boolean - Whether grid lines are shown across the chart
			scaleShowGridLines : true,
	
			//String - Colour of the grid lines
			scaleGridLineColor : "rgba(0,0,0,.05)",
	
			//Number - Width of the grid lines
			scaleGridLineWidth : 1,
	
			//Boolean - Whether to show horizontal lines (except X axis)
			scaleShowHorizontalLines: true,
	
			//Boolean - Whether to show vertical lines (except Y axis)
			scaleShowVerticalLines: true,
	
			//Boolean - Whether the line is curved between points
			bezierCurve : true,
	
			//Number - Tension of the bezier curve between points
			bezierCurveTension : 0.4,
	
			//Boolean - Whether to show a dot for each point
			pointDot : true,
	
			//Number - Radius of each point dot in pixels
			pointDotRadius : 4,
	
			//Number - Pixel width of point dot stroke
			pointDotStrokeWidth : 1,
	
			//Number - amount extra to add to the radius to cater for hit detection outside the drawn point
			pointHitDetectionRadius : 20,
	
			//Boolean - Whether to show a stroke for datasets
			datasetStroke : true,
	
			//Number - Pixel width of dataset stroke
			datasetStrokeWidth : 2,
	
			//Boolean - Whether to fill the dataset with a colour
			datasetFill : true,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span class=\"<%=name.toLowerCase()%>-legend-icon\" style=\"background-color:<%=datasets[i].strokeColor%>\"></span><span class=\"<%=name.toLowerCase()%>-legend-text\"><%if(datasets[i].label){%><%=datasets[i].label%><%}%></span></li><%}%></ul>",
	
			//Boolean - Whether to horizontally center the label and point dot inside the grid
			offsetGridLines : false
	
		};
	
	
		Chart.Type.extend({
			name: "Line",
			defaults : defaultConfig,
			initialize:  function(data){
				//Declare the extension of the default point, to cater for the options passed in to the constructor
				this.PointClass = Chart.Point.extend({
					offsetGridLines : this.options.offsetGridLines,
					strokeWidth : this.options.pointDotStrokeWidth,
					radius : this.options.pointDotRadius,
					display: this.options.pointDot,
					hitDetectionRadius : this.options.pointHitDetectionRadius,
					ctx : this.chart.ctx,
					inRange : function(mouseX){
						return (Math.pow(mouseX-this.x, 2) < Math.pow(this.radius + this.hitDetectionRadius,2));
					}
				});
	
				this.datasets = [];
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activePoints = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : [];
						this.eachPoints(function(point){
							point.restore(['fillColor', 'strokeColor']);
						});
						helpers.each(activePoints, function(activePoint){
							activePoint.fillColor = activePoint.highlightFill;
							activePoint.strokeColor = activePoint.highlightStroke;
						});
						this.showTooltip(activePoints);
					});
				}
	
				//Iterate through each of the datasets, and build this into a property of the chart
				helpers.each(data.datasets,function(dataset){
	
					var datasetObject = {
						label : dataset.label || null,
						fillColor : dataset.fillColor,
						strokeColor : dataset.strokeColor,
						pointColor : dataset.pointColor,
						pointStrokeColor : dataset.pointStrokeColor,
						points : []
					};
	
					this.datasets.push(datasetObject);
	
	
					helpers.each(dataset.data,function(dataPoint,index){
						//Add a new point for each piece of data, passing any required data to draw.
						datasetObject.points.push(new this.PointClass({
							value : dataPoint,
							label : data.labels[index],
							datasetLabel: dataset.label,
							strokeColor : dataset.pointStrokeColor,
							fillColor : dataset.pointColor,
							highlightFill : dataset.pointHighlightFill || dataset.pointColor,
							highlightStroke : dataset.pointHighlightStroke || dataset.pointStrokeColor
						}));
					},this);
	
					this.buildScale(data.labels);
	
	
					this.eachPoints(function(point, index){
						helpers.extend(point, {
							x: this.scale.calculateX(index),
							y: this.scale.endPoint
						});
						point.save();
					}, this);
	
				},this);
	
	
				this.render();
			},
			update : function(){
				this.scale.update();
				// Reset any highlight colours before updating.
				helpers.each(this.activeElements, function(activeElement){
					activeElement.restore(['fillColor', 'strokeColor']);
				});
				this.eachPoints(function(point){
					point.save();
				});
				this.render();
			},
			eachPoints : function(callback){
				helpers.each(this.datasets,function(dataset){
					helpers.each(dataset.points,callback,this);
				},this);
			},
			getPointsAtEvent : function(e){
				var pointsArray = [],
					eventPosition = helpers.getRelativePosition(e);
				helpers.each(this.datasets,function(dataset){
					helpers.each(dataset.points,function(point){
						if (point.inRange(eventPosition.x,eventPosition.y)) pointsArray.push(point);
					});
				},this);
				return pointsArray;
			},
			buildScale : function(labels){
				var self = this;
	
				var dataTotal = function(){
					var values = [];
					self.eachPoints(function(point){
						values.push(point.value);
					});
	
					return values;
				};
	
				var scaleOptions = {
					templateString : this.options.scaleLabel,
					height : this.chart.height,
					width : this.chart.width,
					ctx : this.chart.ctx,
					textColor : this.options.scaleFontColor,
					offsetGridLines : this.options.offsetGridLines,
					fontSize : this.options.scaleFontSize,
					fontStyle : this.options.scaleFontStyle,
					fontFamily : this.options.scaleFontFamily,
					valuesCount : labels.length,
					beginAtZero : this.options.scaleBeginAtZero,
					integersOnly : this.options.scaleIntegersOnly,
					calculateYRange : function(currentHeight){
						var updatedRanges = helpers.calculateScaleRange(
							dataTotal(),
							currentHeight,
							this.fontSize,
							this.beginAtZero,
							this.integersOnly
						);
						helpers.extend(this, updatedRanges);
					},
					xLabels : labels,
					font : helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
					lineWidth : this.options.scaleLineWidth,
					lineColor : this.options.scaleLineColor,
					showHorizontalLines : this.options.scaleShowHorizontalLines,
					showVerticalLines : this.options.scaleShowVerticalLines,
					gridLineWidth : (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
					gridLineColor : (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : "rgba(0,0,0,0)",
					padding: (this.options.showScale) ? 0 : this.options.pointDotRadius + this.options.pointDotStrokeWidth,
					showLabels : this.options.scaleShowLabels,
					display : this.options.showScale
				};
	
				if (this.options.scaleOverride){
					helpers.extend(scaleOptions, {
						calculateYRange: helpers.noop,
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					});
				}
	
	
				this.scale = new Chart.Scale(scaleOptions);
			},
			addData : function(valuesArray,label){
				//Map the values array for each of the datasets
	
				helpers.each(valuesArray,function(value,datasetIndex){
					//Add a new point for each piece of data, passing any required data to draw.
					this.datasets[datasetIndex].points.push(new this.PointClass({
						value : value,
						label : label,
						datasetLabel: this.datasets[datasetIndex].label,
						x: this.scale.calculateX(this.scale.valuesCount+1),
						y: this.scale.endPoint,
						strokeColor : this.datasets[datasetIndex].pointStrokeColor,
						fillColor : this.datasets[datasetIndex].pointColor
					}));
				},this);
	
				this.scale.addXLabel(label);
				//Then re-render the chart.
				this.update();
			},
			removeData : function(){
				this.scale.removeXLabel();
				//Then re-render the chart.
				helpers.each(this.datasets,function(dataset){
					dataset.points.shift();
				},this);
				this.update();
			},
			reflow : function(){
				var newScaleProps = helpers.extend({
					height : this.chart.height,
					width : this.chart.width
				});
				this.scale.update(newScaleProps);
			},
			draw : function(ease){
				var easingDecimal = ease || 1;
				this.clear();
	
				var ctx = this.chart.ctx;
	
				// Some helper methods for getting the next/prev points
				var hasValue = function(item){
					return item.value !== null;
				},
				nextPoint = function(point, collection, index){
					return helpers.findNextWhere(collection, hasValue, index) || point;
				},
				previousPoint = function(point, collection, index){
					return helpers.findPreviousWhere(collection, hasValue, index) || point;
				};
	
				if (!this.scale) return;
				this.scale.draw(easingDecimal);
	
	
				helpers.each(this.datasets,function(dataset){
					var pointsWithValues = helpers.where(dataset.points, hasValue);
	
					//Transition each point first so that the line and point drawing isn't out of sync
					//We can use this extra loop to calculate the control points of this dataset also in this loop
	
					helpers.each(dataset.points, function(point, index){
						if (point.hasValue()){
							point.transition({
								y : this.scale.calculateY(point.value),
								x : this.scale.calculateX(index)
							}, easingDecimal);
						}
					},this);
	
	
					// Control points need to be calculated in a separate loop, because we need to know the current x/y of the point
					// This would cause issues when there is no animation, because the y of the next point would be 0, so beziers would be skewed
					if (this.options.bezierCurve){
						helpers.each(pointsWithValues, function(point, index){
							var tension = (index > 0 && index < pointsWithValues.length - 1) ? this.options.bezierCurveTension : 0;
							point.controlPoints = helpers.splineCurve(
								previousPoint(point, pointsWithValues, index),
								point,
								nextPoint(point, pointsWithValues, index),
								tension
							);
	
							// Prevent the bezier going outside of the bounds of the graph
	
							// Cap puter bezier handles to the upper/lower scale bounds
							if (point.controlPoints.outer.y > this.scale.endPoint){
								point.controlPoints.outer.y = this.scale.endPoint;
							}
							else if (point.controlPoints.outer.y < this.scale.startPoint){
								point.controlPoints.outer.y = this.scale.startPoint;
							}
	
							// Cap inner bezier handles to the upper/lower scale bounds
							if (point.controlPoints.inner.y > this.scale.endPoint){
								point.controlPoints.inner.y = this.scale.endPoint;
							}
							else if (point.controlPoints.inner.y < this.scale.startPoint){
								point.controlPoints.inner.y = this.scale.startPoint;
							}
						},this);
					}
	
	
					//Draw the line between all the points
					ctx.lineWidth = this.options.datasetStrokeWidth;
					ctx.strokeStyle = dataset.strokeColor;
					ctx.beginPath();
	
					helpers.each(pointsWithValues, function(point, index){
						if (index === 0){
							ctx.moveTo(point.x, point.y);
						}
						else{
							if(this.options.bezierCurve){
								var previous = previousPoint(point, pointsWithValues, index);
	
								ctx.bezierCurveTo(
									previous.controlPoints.outer.x,
									previous.controlPoints.outer.y,
									point.controlPoints.inner.x,
									point.controlPoints.inner.y,
									point.x,
									point.y
								);
							}
							else{
								ctx.lineTo(point.x,point.y);
							}
						}
					}, this);
	
					if (this.options.datasetStroke) {
						ctx.stroke();
					}
	
					if (this.options.datasetFill && pointsWithValues.length > 0){
						//Round off the line by going to the base of the chart, back to the start, then fill.
						ctx.lineTo(pointsWithValues[pointsWithValues.length - 1].x, this.scale.endPoint);
						ctx.lineTo(pointsWithValues[0].x, this.scale.endPoint);
						ctx.fillStyle = dataset.fillColor;
						ctx.closePath();
						ctx.fill();
					}
	
					//Now draw the points over the line
					//A little inefficient double looping, but better than the line
					//lagging behind the point positions
					helpers.each(pointsWithValues,function(point){
						point.draw();
					});
				},this);
			}
		});
	
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			//Cache a local reference to Chart.helpers
			helpers = Chart.helpers;
	
		var defaultConfig = {
			//Boolean - Show a backdrop to the scale label
			scaleShowLabelBackdrop : true,
	
			//String - The colour of the label backdrop
			scaleBackdropColor : "rgba(255,255,255,0.75)",
	
			// Boolean - Whether the scale should begin at zero
			scaleBeginAtZero : true,
	
			//Number - The backdrop padding above & below the label in pixels
			scaleBackdropPaddingY : 2,
	
			//Number - The backdrop padding to the side of the label in pixels
			scaleBackdropPaddingX : 2,
	
			//Boolean - Show line for each value in the scale
			scaleShowLine : true,
	
			//Boolean - Stroke a line around each segment in the chart
			segmentShowStroke : true,
	
			//String - The colour of the stroke on each segment.
			segmentStrokeColor : "#fff",
	
			//Number - The width of the stroke value in pixels
			segmentStrokeWidth : 2,
	
			//Number - Amount of animation steps
			animationSteps : 100,
	
			//String - Animation easing effect.
			animationEasing : "easeOutBounce",
	
			//Boolean - Whether to animate the rotation of the chart
			animateRotate : true,
	
			//Boolean - Whether to animate scaling the chart from the centre
			animateScale : false,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span class=\"<%=name.toLowerCase()%>-legend-icon\" style=\"background-color:<%=segments[i].fillColor%>\"></span><span class=\"<%=name.toLowerCase()%>-legend-text\"><%if(segments[i].label){%><%=segments[i].label%><%}%></span></li><%}%></ul>"
		};
	
	
		Chart.Type.extend({
			//Passing in a name registers this chart in the Chart namespace
			name: "PolarArea",
			//Providing a defaults will also register the defaults in the chart namespace
			defaults : defaultConfig,
			//Initialize is fired when the chart is initialized - Data is passed in as a parameter
			//Config is automatically merged by the core of Chart.js, and is available at this.options
			initialize:  function(data){
				this.segments = [];
				//Declare segment class as a chart instance specific class, so it can share props for this instance
				this.SegmentArc = Chart.Arc.extend({
					showStroke : this.options.segmentShowStroke,
					strokeWidth : this.options.segmentStrokeWidth,
					strokeColor : this.options.segmentStrokeColor,
					ctx : this.chart.ctx,
					innerRadius : 0,
					x : this.chart.width/2,
					y : this.chart.height/2
				});
				this.scale = new Chart.RadialScale({
					display: this.options.showScale,
					fontStyle: this.options.scaleFontStyle,
					fontSize: this.options.scaleFontSize,
					fontFamily: this.options.scaleFontFamily,
					fontColor: this.options.scaleFontColor,
					showLabels: this.options.scaleShowLabels,
					showLabelBackdrop: this.options.scaleShowLabelBackdrop,
					backdropColor: this.options.scaleBackdropColor,
					backdropPaddingY : this.options.scaleBackdropPaddingY,
					backdropPaddingX: this.options.scaleBackdropPaddingX,
					lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
					lineColor: this.options.scaleLineColor,
					lineArc: true,
					width: this.chart.width,
					height: this.chart.height,
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2,
					ctx : this.chart.ctx,
					templateString: this.options.scaleLabel,
					valuesCount: data.length
				});
	
				this.updateScaleRange(data);
	
				this.scale.update();
	
				helpers.each(data,function(segment,index){
					this.addData(segment,index,true);
				},this);
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : [];
						helpers.each(this.segments,function(segment){
							segment.restore(["fillColor"]);
						});
						helpers.each(activeSegments,function(activeSegment){
							activeSegment.fillColor = activeSegment.highlightColor;
						});
						this.showTooltip(activeSegments);
					});
				}
	
				this.render();
			},
			getSegmentsAtEvent : function(e){
				var segmentsArray = [];
	
				var location = helpers.getRelativePosition(e);
	
				helpers.each(this.segments,function(segment){
					if (segment.inRange(location.x,location.y)) segmentsArray.push(segment);
				},this);
				return segmentsArray;
			},
			addData : function(segment, atIndex, silent){
				var index = atIndex || this.segments.length;
	
				this.segments.splice(index, 0, new this.SegmentArc({
					fillColor: segment.color,
					highlightColor: segment.highlight || segment.color,
					label: segment.label,
					value: segment.value,
					outerRadius: (this.options.animateScale) ? 0 : this.scale.calculateCenterOffset(segment.value),
					circumference: (this.options.animateRotate) ? 0 : this.scale.getCircumference(),
					startAngle: Math.PI * 1.5
				}));
				if (!silent){
					this.reflow();
					this.update();
				}
			},
			removeData: function(atIndex){
				var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length-1;
				this.segments.splice(indexToDelete, 1);
				this.reflow();
				this.update();
			},
			calculateTotal: function(data){
				this.total = 0;
				helpers.each(data,function(segment){
					this.total += segment.value;
				},this);
				this.scale.valuesCount = this.segments.length;
			},
			updateScaleRange: function(datapoints){
				var valuesArray = [];
				helpers.each(datapoints,function(segment){
					valuesArray.push(segment.value);
				});
	
				var scaleSizes = (this.options.scaleOverride) ?
					{
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					} :
					helpers.calculateScaleRange(
						valuesArray,
						helpers.min([this.chart.width, this.chart.height])/2,
						this.options.scaleFontSize,
						this.options.scaleBeginAtZero,
						this.options.scaleIntegersOnly
					);
	
				helpers.extend(
					this.scale,
					scaleSizes,
					{
						size: helpers.min([this.chart.width, this.chart.height]),
						xCenter: this.chart.width/2,
						yCenter: this.chart.height/2
					}
				);
	
			},
			update : function(){
				this.calculateTotal(this.segments);
	
				helpers.each(this.segments,function(segment){
					segment.save();
				});
				
				this.reflow();
				this.render();
			},
			reflow : function(){
				helpers.extend(this.SegmentArc.prototype,{
					x : this.chart.width/2,
					y : this.chart.height/2
				});
				this.updateScaleRange(this.segments);
				this.scale.update();
	
				helpers.extend(this.scale,{
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2
				});
	
				helpers.each(this.segments, function(segment){
					segment.update({
						outerRadius : this.scale.calculateCenterOffset(segment.value)
					});
				}, this);
	
			},
			draw : function(ease){
				var easingDecimal = ease || 1;
				//Clear & draw the canvas
				this.clear();
				helpers.each(this.segments,function(segment, index){
					segment.transition({
						circumference : this.scale.getCircumference(),
						outerRadius : this.scale.calculateCenterOffset(segment.value)
					},easingDecimal);
	
					segment.endAngle = segment.startAngle + segment.circumference;
	
					// If we've removed the first segment we need to set the first one to
					// start at the top.
					if (index === 0){
						segment.startAngle = Math.PI * 1.5;
					}
	
					//Check to see if it's the last segment, if not get the next and update the start angle
					if (index < this.segments.length - 1){
						this.segments[index+1].startAngle = segment.endAngle;
					}
					segment.draw();
				}, this);
				this.scale.draw();
			}
		});
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			helpers = Chart.helpers;
	
	
	
		Chart.Type.extend({
			name: "Radar",
			defaults:{
				//Boolean - Whether to show lines for each scale point
				scaleShowLine : true,
	
				//Boolean - Whether we show the angle lines out of the radar
				angleShowLineOut : true,
	
				//Boolean - Whether to show labels on the scale
				scaleShowLabels : false,
	
				// Boolean - Whether the scale should begin at zero
				scaleBeginAtZero : true,
	
				//String - Colour of the angle line
				angleLineColor : "rgba(0,0,0,.1)",
	
				//Number - Pixel width of the angle line
				angleLineWidth : 1,
	
				//Number - Interval at which to draw angle lines ("every Nth point")
				angleLineInterval: 1,
	
				//String - Point label font declaration
				pointLabelFontFamily : "'Arial'",
	
				//String - Point label font weight
				pointLabelFontStyle : "normal",
	
				//Number - Point label font size in pixels
				pointLabelFontSize : 10,
	
				//String - Point label font colour
				pointLabelFontColor : "#666",
	
				//Boolean - Whether to show a dot for each point
				pointDot : true,
	
				//Number - Radius of each point dot in pixels
				pointDotRadius : 3,
	
				//Number - Pixel width of point dot stroke
				pointDotStrokeWidth : 1,
	
				//Number - amount extra to add to the radius to cater for hit detection outside the drawn point
				pointHitDetectionRadius : 20,
	
				//Boolean - Whether to show a stroke for datasets
				datasetStroke : true,
	
				//Number - Pixel width of dataset stroke
				datasetStrokeWidth : 2,
	
				//Boolean - Whether to fill the dataset with a colour
				datasetFill : true,
	
				//String - A legend template
				legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span class=\"<%=name.toLowerCase()%>-legend-icon\" style=\"background-color:<%=datasets[i].strokeColor%>\"></span><span class=\"<%=name.toLowerCase()%>-legend-text\"><%if(datasets[i].label){%><%=datasets[i].label%><%}%></span></li><%}%></ul>"
	
			},
	
			initialize: function(data){
				this.PointClass = Chart.Point.extend({
					strokeWidth : this.options.pointDotStrokeWidth,
					radius : this.options.pointDotRadius,
					display: this.options.pointDot,
					hitDetectionRadius : this.options.pointHitDetectionRadius,
					ctx : this.chart.ctx
				});
	
				this.datasets = [];
	
				this.buildScale(data);
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activePointsCollection = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : [];
	
						this.eachPoints(function(point){
							point.restore(['fillColor', 'strokeColor']);
						});
						helpers.each(activePointsCollection, function(activePoint){
							activePoint.fillColor = activePoint.highlightFill;
							activePoint.strokeColor = activePoint.highlightStroke;
						});
	
						this.showTooltip(activePointsCollection);
					});
				}
	
				//Iterate through each of the datasets, and build this into a property of the chart
				helpers.each(data.datasets,function(dataset){
	
					var datasetObject = {
						label: dataset.label || null,
						fillColor : dataset.fillColor,
						strokeColor : dataset.strokeColor,
						pointColor : dataset.pointColor,
						pointStrokeColor : dataset.pointStrokeColor,
						points : []
					};
	
					this.datasets.push(datasetObject);
	
					helpers.each(dataset.data,function(dataPoint,index){
						//Add a new point for each piece of data, passing any required data to draw.
						var pointPosition;
						if (!this.scale.animation){
							pointPosition = this.scale.getPointPosition(index, this.scale.calculateCenterOffset(dataPoint));
						}
						datasetObject.points.push(new this.PointClass({
							value : dataPoint,
							label : data.labels[index],
							datasetLabel: dataset.label,
							x: (this.options.animation) ? this.scale.xCenter : pointPosition.x,
							y: (this.options.animation) ? this.scale.yCenter : pointPosition.y,
							strokeColor : dataset.pointStrokeColor,
							fillColor : dataset.pointColor,
							highlightFill : dataset.pointHighlightFill || dataset.pointColor,
							highlightStroke : dataset.pointHighlightStroke || dataset.pointStrokeColor
						}));
					},this);
	
				},this);
	
				this.render();
			},
			eachPoints : function(callback){
				helpers.each(this.datasets,function(dataset){
					helpers.each(dataset.points,callback,this);
				},this);
			},
	
			getPointsAtEvent : function(evt){
				var mousePosition = helpers.getRelativePosition(evt),
					fromCenter = helpers.getAngleFromPoint({
						x: this.scale.xCenter,
						y: this.scale.yCenter
					}, mousePosition);
	
				var anglePerIndex = (Math.PI * 2) /this.scale.valuesCount,
					pointIndex = Math.round((fromCenter.angle - Math.PI * 1.5) / anglePerIndex),
					activePointsCollection = [];
	
				// If we're at the top, make the pointIndex 0 to get the first of the array.
				if (pointIndex >= this.scale.valuesCount || pointIndex < 0){
					pointIndex = 0;
				}
	
				if (fromCenter.distance <= this.scale.drawingArea){
					helpers.each(this.datasets, function(dataset){
						activePointsCollection.push(dataset.points[pointIndex]);
					});
				}
	
				return activePointsCollection;
			},
	
			buildScale : function(data){
				this.scale = new Chart.RadialScale({
					display: this.options.showScale,
					fontStyle: this.options.scaleFontStyle,
					fontSize: this.options.scaleFontSize,
					fontFamily: this.options.scaleFontFamily,
					fontColor: this.options.scaleFontColor,
					showLabels: this.options.scaleShowLabels,
					showLabelBackdrop: this.options.scaleShowLabelBackdrop,
					backdropColor: this.options.scaleBackdropColor,
					backgroundColors: this.options.scaleBackgroundColors,
					backdropPaddingY : this.options.scaleBackdropPaddingY,
					backdropPaddingX: this.options.scaleBackdropPaddingX,
					lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
					lineColor: this.options.scaleLineColor,
					angleLineColor : this.options.angleLineColor,
					angleLineWidth : (this.options.angleShowLineOut) ? this.options.angleLineWidth : 0,
	        angleLineInterval: (this.options.angleLineInterval) ? this.options.angleLineInterval : 1,
					// Point labels at the edge of each line
					pointLabelFontColor : this.options.pointLabelFontColor,
					pointLabelFontSize : this.options.pointLabelFontSize,
					pointLabelFontFamily : this.options.pointLabelFontFamily,
					pointLabelFontStyle : this.options.pointLabelFontStyle,
					height : this.chart.height,
					width: this.chart.width,
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2,
					ctx : this.chart.ctx,
					templateString: this.options.scaleLabel,
					labels: data.labels,
					valuesCount: data.datasets[0].data.length
				});
	
				this.scale.setScaleSize();
				this.updateScaleRange(data.datasets);
				this.scale.buildYLabels();
			},
			updateScaleRange: function(datasets){
				var valuesArray = (function(){
					var totalDataArray = [];
					helpers.each(datasets,function(dataset){
						if (dataset.data){
							totalDataArray = totalDataArray.concat(dataset.data);
						}
						else {
							helpers.each(dataset.points, function(point){
								totalDataArray.push(point.value);
							});
						}
					});
					return totalDataArray;
				})();
	
	
				var scaleSizes = (this.options.scaleOverride) ?
					{
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					} :
					helpers.calculateScaleRange(
						valuesArray,
						helpers.min([this.chart.width, this.chart.height])/2,
						this.options.scaleFontSize,
						this.options.scaleBeginAtZero,
						this.options.scaleIntegersOnly
					);
	
				helpers.extend(
					this.scale,
					scaleSizes
				);
	
			},
			addData : function(valuesArray,label){
				//Map the values array for each of the datasets
				this.scale.valuesCount++;
				helpers.each(valuesArray,function(value,datasetIndex){
					var pointPosition = this.scale.getPointPosition(this.scale.valuesCount, this.scale.calculateCenterOffset(value));
					this.datasets[datasetIndex].points.push(new this.PointClass({
						value : value,
						label : label,
						datasetLabel: this.datasets[datasetIndex].label,
						x: pointPosition.x,
						y: pointPosition.y,
						strokeColor : this.datasets[datasetIndex].pointStrokeColor,
						fillColor : this.datasets[datasetIndex].pointColor
					}));
				},this);
	
				this.scale.labels.push(label);
	
				this.reflow();
	
				this.update();
			},
			removeData : function(){
				this.scale.valuesCount--;
				this.scale.labels.shift();
				helpers.each(this.datasets,function(dataset){
					dataset.points.shift();
				},this);
				this.reflow();
				this.update();
			},
			update : function(){
				this.eachPoints(function(point){
					point.save();
				});
				this.reflow();
				this.render();
			},
			reflow: function(){
				helpers.extend(this.scale, {
					width : this.chart.width,
					height: this.chart.height,
					size : helpers.min([this.chart.width, this.chart.height]),
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2
				});
				this.updateScaleRange(this.datasets);
				this.scale.setScaleSize();
				this.scale.buildYLabels();
			},
			draw : function(ease){
				var easeDecimal = ease || 1,
					ctx = this.chart.ctx;
				this.clear();
				this.scale.draw();
	
				helpers.each(this.datasets,function(dataset){
	
					//Transition each point first so that the line and point drawing isn't out of sync
					helpers.each(dataset.points,function(point,index){
						if (point.hasValue()){
							point.transition(this.scale.getPointPosition(index, this.scale.calculateCenterOffset(point.value)), easeDecimal);
						}
					},this);
	
	
	
					//Draw the line between all the points
					ctx.lineWidth = this.options.datasetStrokeWidth;
					ctx.strokeStyle = dataset.strokeColor;
					ctx.beginPath();
					helpers.each(dataset.points,function(point,index){
						if (index === 0){
							ctx.moveTo(point.x,point.y);
						}
						else{
							ctx.lineTo(point.x,point.y);
						}
					},this);
					ctx.closePath();
					ctx.stroke();
	
					ctx.fillStyle = dataset.fillColor;
					if(this.options.datasetFill){
						ctx.fill();
					}
					//Now draw the points over the line
					//A little inefficient double looping, but better than the line
					//lagging behind the point positions
					helpers.each(dataset.points,function(point){
						if (point.hasValue()){
							point.draw();
						}
					});
	
				},this);
	
			}
	
		});
	
	
	
	
	
	}).call(this);


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _payslip = __webpack_require__(582);
	
	var _payslip2 = _interopRequireDefault(_payslip);
	
	var _payslips = __webpack_require__(581);
	
	var _payslips2 = _interopRequireDefault(_payslips);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _leaveRequests = __webpack_require__(752);
	
	var _leaveRequests2 = _interopRequireDefault(_leaveRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeBaseRouter = __webpack_require__(1048);
	var Layout = __webpack_require__(1056);
	
	module.exports = EmployeeBaseRouter.extend({
	    routes: {
	        'payslips': 'payslips',
	        'view/:id': 'view'
	    },
	
	    titles: {
	        'payslips': 'Payslips',
	        'view': 'View',
	        'view/:id': 'View'
	    },
	
	    // TODO it is a big and multiplied method, refactor it later
	    fetchBalance: function fetchBalance(payslip) {
	        var fetchYearlyBalances = function fetchYearlyBalances() {
	            return app.leaveTypes.fetchBalances(payslip.getEmployee(), payslip.getPeriod().endOf('month').toDate());
	        };
	
	        var transformYearly = function transformYearly(leaveTypes) {
	            return leaveTypes.map(function (leaveType) {
	                var name = leaveType.get('name');
	                var id = leaveType.id;
	                var entitled = leaveType.getEntitled() || 0;
	                var taken = leaveType.getTaken() || 0;
	                var remaining = Math.max(0, entitled - taken);
	                return {
	                    id: id,
	                    name: name,
	                    entitled: entitled,
	                    remaining: remaining,
	                    taken: taken
	                };
	            });
	        };
	
	        var mergeBalances = function mergeBalances(yearly, monthly) {
	            var obligated = _.filter(yearly, function (balance) {
	                return ['Medical Leave', 'Annual Leave', 'Unpaid Leave'].includes(balance.name);
	            });
	            var yearlyHasInMontly = _.filter(yearly, function (balance) {
	                return _.map(monthly, function (t) {
	                    return t.id;
	                }).includes(balance.id) && balance.taken > 0;
	            }).concat(obligated);
	
	            var mergeBalances = _.map(yearlyHasInMontly, function (balance) {
	                var sameMonthlyBalance = monthly.find(function (t) {
	                    return t.id === balance.id;
	                });
	                if (balance.taken > 0) {
	                    var newTaken = sameMonthlyBalance ? sameMonthlyBalance.taken : 0;
	                    balance.taken = newTaken;
	                }
	                return balance;
	            });
	            return mergeBalances;
	        };
	
	        var fetchMonthlyBalance = function fetchMonthlyBalance(types, reference) {
	            var end = (0, _moment2.default)(reference).endOf('month').toDate();
	            var start = (0, _moment2.default)(reference).startOf('month').toDate();
	            return _leaveRequests2.default.fetchForBalances({
	                employee: payslip.getEmployee(),
	                typeIds: types.map(function (t) {
	                    return t.id;
	                }),
	                start: start,
	                end: end
	            }).then(function (requests) {
	                var simplified = requests.map(function (request) {
	                    var id = request.get('typeId');
	                    var taken = request.get('daysRequired');
	                    return {
	                        id: id,
	                        taken: taken
	                    };
	                }) || [];
	                var groupedById = _.groupBy(simplified, 'id');
	                var summedById = _.map(groupedById, function (requests) {
	                    var taken = _.reduce(requests, function (sum, request) {
	                        return sum + request.taken;
	                    }, 0);
	                    return {
	                        id: requests[0].id,
	                        taken: taken
	                    };
	                });
	
	                return summedById;
	            });
	        };
	
	        return fetchYearlyBalances().then(function (yearlyBalances) {
	            return (0, _bluebird.all)([transformYearly(yearlyBalances), fetchMonthlyBalance(yearlyBalances, payslip.getPeriod().toDate())]);
	        }).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                yearly = _ref2[0],
	                monthly = _ref2[1];
	
	            return mergeBalances(yearly, monthly);
	        });
	    },
	
	    payslips: function payslips() {
	        var _this = this;
	
	        this.undelegateEvents();
	        this.layout = new Layout({
	            el: this.el
	        });
	
	        var payslips = new _payslips2.default(null, {
	            employee: app.employee,
	            pagination: { rowsPerPage: 20 },
	            sortKey: 'createdAt',
	            sortOrder: 'descending',
	            validate: false
	        });
	        return payslips.fetch({ filter: { where: { status: 'done' } } }).then(function () {
	            return (0, _bluebird.all)(payslips.map(function (payslip) {
	                var attachments = new _attachments2.default(null, {
	                    attachable: payslip
	                });
	                return payslip.fetch().then(function () {
	                    return attachments.fetch({
	                        filter: {
	                            order: 'createdAt DESC'
	                        }
	                    });
	                }).then(function () {
	                    return [payslip.id, attachments];
	                });
	            }));
	        }).then(function (attchMap) {
	            return (0, _bluebird.resolve)(_.object(attchMap));
	        }).then(function (attachments) {
	            _this.layout.renderPayslips({
	                payslips: payslips,
	                attachments: attachments
	            });
	        });
	    },
	
	    view: function view(id) {
	        var _this2 = this;
	
	        // .. in progress ..
	        this.undelegateEvents();
	
	        this.layout = new Layout({
	            el: this.el
	        });
	
	        return (0, _bluebird.all)([new _payslip2.default({ objectId: id }).fetch({ validate: false }), app.company.fetchPrimaryLocation()]).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                payslip = _ref4[0],
	                companyLocation = _ref4[1];
	
	            payslip.employee = app.employee;
	            return (0, _bluebird.all)([payslip, payslip.fetchDetails(), companyLocation, _this2.fetchBalance(payslip), companyLocation.fetchAddress()]);
	        }).then(function (_ref5) {
	            var _ref6 = _slicedToArray(_ref5, 4),
	                payslip = _ref6[0],
	                payslipDetails = _ref6[1],
	                companyLocation = _ref6[2],
	                balances = _ref6[3];
	
	            payslipDetails.balances = balances;
	            _this2.layout.renderView({
	                payslip: payslip,
	                payslipDetails: payslipDetails,
	                companyLocation: companyLocation,
	                company: app.company
	            });
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(1057);
	var PayslipsView = __webpack_require__(1058);
	var ViewView = __webpack_require__(1060);
	
	module.exports = Backbone.View.extend({
	
	    initialize: function initialize(options) {
	        var self = this;
	        _.extend(self, options);
	        self.render();
	    },
	
	    render: function render() {
	        var self = this;
	        self.$el.html(template());
	
	        return self;
	    },
	
	    renderPayslips: function renderPayslips(options) {
	        var self = this;
	        self.payslip = new PayslipsView(_.extend({ $el: self.$('.js-tab-content') }, options));
	        self.$('.sk-spinner').hide();
	
	        return self;
	    },
	
	    renderView: function renderView(options) {
	        var self = this;
	        self.payslip = new ViewView(_.extend({ el: self.$('.js-tab-content') }, options));
	        self.$('.sk-spinner').hide();
	
	        return self;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/payslips/Layout.ejs -->\n<div id="content" class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>Payslips</h5>\n                </div>\n                <div class="tab-content js-tab-content">\n                    <div class="js-leave-loader ibox-content">\n                        <div class="row">\n                            <div class="col-xs-12" style="height: 200px">\n                                <div class="loader">\n                                    '+
	((__t=( __webpack_require__(535)() ))==null?'':__t)+
	'\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _attachments = __webpack_require__(578);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var template = __webpack_require__(1059);
	
	module.exports = _PaginatedList2.default.extend({
	
	    initialize: function initialize(options) {
	        //FIXME NEVER extend this with options
	        _.extend(this, options);
	        this.delegateEvents();
	        this.collection = options.payslips;
	        this.collection.on('sync', this.render, this);
	        this.collection.fetchPage(undefined, { validate: false });
	        this.render();
	    },
	
	    events: function events() {
	        return _PaginatedList2.default.prototype.events.apply(this);
	    },
	
	    render: function render() {
	        var _this = this;
	
	        if (this.payslips.length <= 0) {
	            this.$el.html(template({
	                payslips: this.payslips,
	                pagination: this.collection.pagination
	            }));
	        }
	        var getAttachments = (0, _bluebird.all)(this.payslips.map(function (payslip) {
	            return new _attachments2.default(null, {
	                attachable: payslip
	            }).fetch({ filter: { order: 'createdAt DESC' }
	            }).then(function (attach) {
	                return [payslip.id, attach];
	            });
	        }));
	        getAttachments.then(function (attachments) {
	            return (0, _bluebird.resolve)(_.object(attachments));
	        }).then(function (attachments) {
	            _this.$el.html(template({
	                payslips: _this.payslips,
	                attachments: attachments,
	                pagination: _this.collection.pagination
	            }));
	        });
	
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/payslips/Payslips.ejs -->\n<div class="ibox-content">\n    <div class="row">\n        ';
	 payslips.each(function(payslip, index) { 
	__p+='\n            ';
	 var pdf = attachments[payslip.id].first() 
	__p+='           \n            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n                '+
	((__t=( __webpack_require__(803)({
	                    payslip: payslip,
	                    payslipPdf: pdf,
	                    viewUrl: '#view/' + payslip.id
	                }) ))==null?'':__t)+
	'\n            </div>\n        ';
	 }) 
	__p+='\n        \n    </div>\n    ';
	 /* FIXME: apparently we dont render payslips of payrolls whose status
	        * isnt 8. If those payslips can be part of the collection just checking
	        * length here doesnt cut it
	        */ 
	__p+='\n    ';
	 if (payslips.length === 0) { 
	__p+='\n        <div class="row">\n            <div class="col-xs-12">\n                <h2>There are currently no payslips</h2>\n            </div>\n        </div>\n    ';
	 } 
	__p+='\n    <div class="row">\n        <div class="col-xs-12">\n            '+
	((__t=( __webpack_require__(669)({ pagination: pagination, items: 'payslips' }) ))==null?'':__t)+
	'\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(1061);
	var CommonPayslipView = __webpack_require__(749);
	
	module.exports = Backbone.View.extend({
	    payslipView: null,
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            payslip: null,
	            payslipDetails: null,
	            companyLocation: null,
	            company: null
	        });
	
	        this.payslipView = new CommonPayslipView({
	            model: this.options.payslip,
	            payslipDetails: this.options.payslipDetails,
	            companyLocation: this.options.companyLocation,
	            company: this.options.company
	        });
	
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({}));
	
	        this.$('.js-payslip').append(this.payslipView.el);
	
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/employee/templates/payslips/View.ejs -->\n<div class="ibox-content js-payslip">\n    <a href="#payslips" class="previous-link">\n        <i class="fa fa-angle-left"></i>\n        Back to list</a>\n    <br/>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Calendar = __webpack_require__(891);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _employees = __webpack_require__(570);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _companyLocation = __webpack_require__(574);
	
	var _companyLocation2 = _interopRequireDefault(_companyLocation);
	
	var _holidays = __webpack_require__(626);
	
	var _holidays2 = _interopRequireDefault(_holidays);
	
	var _leaveApprovals = __webpack_require__(587);
	
	var _leaveApprovals2 = _interopRequireDefault(_leaveApprovals);
	
	var _actionLogs = __webpack_require__(817);
	
	var _actionLogs2 = _interopRequireDefault(_actionLogs);
	
	var _Main = __webpack_require__(1063);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Calendar2.default.extend({
	    initialize: function initialize() {
	        this.LeaveMainView = _Main2.default;
	        _Calendar2.default.prototype.initialize.apply(this, arguments);
	    },
	
	    _fetchCalendarData: function _fetchCalendarData(locationId) {
	        var result = {};
	        var layerMap = {};
	        var fetchEmployees = function fetchEmployees() {
	            var approvals = new _leaveApprovals2.default(null, {
	                approver: app.employee,
	                pagination: false
	            });
	            return approvals.fetch({ filter: { limit: 9999 } }).then(function () {
	                return (0, _bluebird.all)(approvals.map(function (approval) {
	                    layerMap[approval.get('requesterId')] = approval.get('layer');
	                    return approval.fetchRequester();
	                }));
	            }).then(function (managed) {
	                managed = managed.filter(function (e) {
	                    return !!e;
	                });
	                return (0, _bluebird.all)(managed.map(function (e) {
	                    e.fetchLeaveApprovals();
	                })).then(function () {
	                    return new _employees2.default(managed);
	                });
	            }).then(function (managed) {
	                managed.add(app.employee);
	                return {
	                    employees: managed,
	                    userEmployee: app.employee
	                };
	            });
	        };
	
	        return (0, _bluebird.all)([new _actionLogs2.default().fetchForEmployee(app.employee), fetchEmployees(), locationId ? new _companyLocation2.default({ objectId: locationId }).fetch() :
	        // 20200427 make default to nnull (show employees at ALL
	        // locations)
	        (0, _bluebird.resolve)(null)]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 3),
	                actionLogs = _ref2[0],
	                res = _ref2[1],
	                location = _ref2[2];
	
	            var employees = res.employees,
	                userEmployee = res.userEmployee;
	
	            result.userEmployee = userEmployee;
	            result.selectedLocation = location;
	            result.employees = employees;
	
	            result.collection = actionLogs;
	            result.fetchMore = function (options) {
	                return new _actionLogs2.default().fetchForEmployee(app.employee, options);
	            };
	            layerMap[app.employee.id] = 0;
	
	            // keep only unique locations
	            var locations = [];
	            var locationIds = [];
	
	            return (0, _bluebird.join)(employees.map(function (employee) {
	                return employee.fetchCompanyLocation().then(function (employeeLocation) {
	                    if (!locationIds.includes(employeeLocation.id)) {
	                        locationIds.push(employeeLocation.id);
	                        locations.push(employeeLocation);
	                    }
	                });
	            })).then(function () {
	                result.locations = locations;
	            });
	        }).then(function () {
	            return new _holidays2.default(null, {
	                company: app.company,
	                location: result.selectedLocation.id
	            }).fetch();
	        }).then(function (holidays) {
	            var enabledHolidays = result.selectedLocation ? holidays.filter(function (h) {
	                return h._enabled;
	            }) : holidays;
	
	            result.holidays = enabledHolidays;
	            result.isEmployer = false;
	            return result;
	        });
	    },
	
	    _fetchLeaveData: function _fetchLeaveData() {
	        return (0, _bluebird.resolve)(new _employees2.default([app.employee], {}));
	    }
	});

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Leave = __webpack_require__(908);
	
	var _Leave2 = _interopRequireDefault(_Leave);
	
	var _leaveRequest = __webpack_require__(753);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeLeaveView = _Leave2.default.extend({
	    _onInitializeSetLeaveRequest: function _onInitializeSetLeaveRequest(_ref) {
	        var _ref$employees = _ref.employees,
	            employees = _ref$employees === undefined ? null : _ref$employees;
	
	        if (!employees) {
	            throw new Error('Don\'t have an employee to add a leave request to');
	        }
	        this.leaveRequest.setEmployee(employees.at(0));
	    },
	
	    _onSubmitSetLeaveRequest: function _onSubmitSetLeaveRequest() {
	        this.leaveRequest.set({ status: _leaveRequest.consts.STATUS_AWAITING });
	    }
	});
	
	module.exports = EmployeeLeaveView;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Base = __webpack_require__(625);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Main = __webpack_require__(1065);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(1067);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	var _Main5 = __webpack_require__(1072);
	
	var _Main6 = _interopRequireDefault(_Main5);
	
	var _Subscription = __webpack_require__(1081);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _TaxSettings = __webpack_require__(843);
	
	var _TaxSettings2 = _interopRequireDefault(_TaxSettings);
	
	var _companies = __webpack_require__(563);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _users = __webpack_require__(642);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _moment = __webpack_require__(101);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _Base2.default.extend({
	    routes: {
	        'managers': 'managers',
	        'companies': 'companies',
	        'companies/:sort/:order': 'companies',
	        'companies/:sort/:order/:searchTerm': 'companies',
	        'subscription': 'subscription',
	        'tax': 'tax'
	    },
	
	    titles: {
	        'companies': 'Companies',
	        'companies/:sort/:order': 'Companies',
	        'companies/:sort/:order/:searchTerm': 'Companies',
	        'managers': 'Managers',
	        'subscription': 'Subscription',
	        'tax': 'Tax Settings'
	    },
	
	    childEl: '#main-area',
	
	    // The initialization of this router is way to complex because the
	    // MainView is the container for all the others and it requires async
	    // info. TODO Fix MainView
	    initialize: function initialize() {
	        this.mainView = new _Main2.default({});
	
	        Backbone.history.on('route', function () {
	            this.mainView.setActiveLink(Backbone.history.getFragment());
	            window.scrollTo(0, 0);
	        }.bind(this));
	
	        /*
	        if (
	            app.user.get('taxInfoValidationStatus') !== 1 &&
	            ['employer', 'mpp_admin'].includes(app.user.get('role'))) {
	             modal.warning({
	                text: 'Please update tax information',
	                allowEscapeKey: false,
	                allowOutsideClick: false,
	                allowEnterKey: false,
	                callback: () => app.mainRouter.navigate('tax', {trigger: true})
	            });
	             $('#tax-info-update-notification').css({display: 'block'});
	        }
	         */
	    },
	
	    companies: function companies(sortKey, sortOrder, searchTerm) {
	        var options = {
	            sortKey: 'companyName',
	            sortOrder: 'ascending',
	            user: app.user,
	            // 20200810 why do you need paging on mpp admin at all?
	            pagination: false
	        };
	
	        if (sortKey) {
	            options.sortKey = sortKey;
	        }
	        if (sortOrder) {
	            options.sortOrder = sortOrder;
	        }
	        if (searchTerm) {
	            options.searchString = searchTerm;
	        }
	
	        this.view = new _Main4.default({
	            el: this.mainView.childEl,
	            collection: new _companies2.default(null, options)
	        });
	    },
	
	    managers: function managers() {
	        var _this = this;
	
	        /* Since this router is also used by mpp managers, prevent them
	         from accessing some routes */
	        if (app.user.get('role') !== 'mpp_admin') {
	            return;
	        }
	
	        var options = {
	            user: app.user,
	            pagination: false
	        };
	
	        var stopLoader = _loader2.default.startFullPage(this.mainView.childEl);
	        (0, _bluebird.all)([new _users2.default(null, options).fetch(), new _companies2.default(null, options).fetch({ filter: { limit: 9999 } })]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                managers = _ref2[0],
	                companies = _ref2[1];
	
	            _this.view = new _Main6.default({
	                el: _this.mainView.childEl,
	                collection: managers,
	                companies: companies
	            }).render();
	        }).finally(stopLoader);
	    },
	
	    subscription: function subscription() {
	        var _this2 = this;
	
	        if (app.user.get('role') !== 'mpp_admin') {
	            return;
	        }
	
	        var stopLoader = _loader2.default.startFullPage(this.mainView.childEl);
	        app.subscription.listInvoices().then(function (data) {
	            var invoices = data.map(function (i) {
	                var description = '-';
	                var status = i.status.replace(/_/, ' ');
	                status = status[0].toUpperCase() + status.slice(1);
	                /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers*/
	                if (i.line_items && i.line_items.length) {
	                    /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers*/
	                    description = i.line_items[0].description;
	                }
	                return {
	                    id: i._id,
	                    date: _moment2.default.unix(i.date).format('DD/MM/YYYY'),
	                    description: description,
	                    amount: (i.total / 100).formatWithoutRounding(),
	                    status: status,
	                    paymentDate: i.paid_at ? _moment2.default.unix(i.paid_at).format('DD/MM/YYYY') : '',
	                    voidedDate: i.voided_at ? _moment2.default.unix(i.voided_at).format('DD/MM/YYYY') : ''
	                };
	            });
	            _this2.view = new _Subscription2.default({
	                el: _this2.mainView.childEl,
	                model: app.subscription,
	                collection: invoices
	            }).render();
	        }).finally(stopLoader);
	    },
	
	    tax: function tax() {
	        var _this3 = this;
	
	        if (app.user.get('role') !== 'mpp_admin') {
	            return;
	        }
	        var stopLoader = _loader2.default.startFullPage(this.mainView.childEl);
	        app.user.fetch().then(function (model) {
	            _this3.view = new _TaxSettings2.default({
	                el: _this3.mainView.childEl,
	                model: model
	            });
	        }).finally(stopLoader);
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(645);
	var navMenuTpl = __webpack_require__(1066);
	var tooltip = __webpack_require__(541);
	
	module.exports = Backbone.View.extend({
	    el: '.content',
	    childEl: '#main-area',
	
	    initialize: function initialize() {
	        this.render();
	    },
	
	    render: function render() {
	        var id = app.user.get('mppAdminId');
	        var logoUrl = app.user.getLogoUrl(id);
	        this.$el.html(template({
	            navMenu: navMenuTpl({
	                userName: app.user.get('name'),
	                role: app.user.get('role')
	            }),
	            headerMenu: null,
	            version: app.version,
	            whitelabel: app.user.get('plan') !== 'client',
	            logoUrl: logoUrl
	        }));
	
	        $('body').removeClass('gray-bg');
	
	        this.$el.find('.logo img').on('load', function (e) {
	            $(e.target.parentElement).removeClass('hidden');
	        }).on('error', function (e) {
	            e.target.src = '';
	        });
	
	        tooltip.initBody();
	    },
	
	    setActiveLink: function setActiveLink(route) {
	        this.$el.find('#side-menu li').removeClass('active');
	
	        this.$el.find('#side-menu a[href="#' + route + '"]').parent().addClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/NavMenu.ejs -->\n<ul class="nav metismenu" id="side-menu">\n    <li class="nav-header">\n        <div class="dropdown profile-element">\n            <a data-toggle="dropdown" class="dropdown-toggle" href="#">\n                <span class="clear">\n                    <span class="block m-t-xs">\n                        <strong class="font-bold">'+
	((__t=( role ))==null?'':_.escape(__t))+
	'</strong>\n                    </span>\n                    <span class="text-muted text-xs block">\n                        '+
	((__t=( userName ))==null?'':_.escape(__t))+
	'\n                        <b class="caret"></b>\n                    </span>\n                </span>\n            </a>\n            <ul class="dropdown-menu animated fadeInRight m-t-xs">\n                <li><a href="#logout">Logout</a></li>\n            </ul>\n        </div>\n        <div class="logo-element">\n            IN+\n        </div>\n    </li>\n    <li id="li-lnk-companies-view" class="active">\n        <a id="lnk-companies-view" href="#companies">\n            <i class="fa fa-building"></i>\n            <span class="nav-label">Companies</span>\n        </a>\n    </li>\n    ';
	 if (role === 'mpp_admin') { 
	__p+='\n    <li id="li-lnk-managers-view" >\n        <a id="lnk-managers-view" href="#managers">\n            <i class="fa fa-building"></i>\n            <span class="nav-label">Managers</span>\n        </a>\n    </li>\n    <li id="li-lnk-subscription-view" >\n        <a id="lnk-subscription-view" href="#subscription">\n            <i class="fa fa-building"></i>\n            <span class="nav-label">Subscription</span>\n        </a>\n    </li>\n    <li id="li-lnk-tax-view" >\n        <a id="lnk-subscription-view" href="#tax">\n            <i class="fa fa-building"></i>\n            <span class="nav-label">Tax Settings</span>\n        </a>\n    </li>\n    ';
	 } 
	__p+='\n</ul>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _Main = __webpack_require__(1068);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Company = __webpack_require__(1069);
	
	var _Company2 = _interopRequireDefault(_Company);
	
	var _PaginatedList = __webpack_require__(638);
	
	var _PaginatedList2 = _interopRequireDefault(_PaginatedList);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _Add = __webpack_require__(1071);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginatedList2.default.extend({
	    events: {
	        'click .js-save': 'save',
	        'input .js-email': 'onEmailChange'
	    },
	
	    views: [],
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            pagination: false
	        });
	
	        this.views = [];
	
	        this.collection.on('sync', this.render, this);
	
	        // 20200810 why do you need paging on mpp admin at all?
	        this.collection.fetch({
	            validate: false,
	            filter: {
	                limit: 9999
	            }
	        });
	
	        this.stopLoader = _loader2.default.startFullPage(this.$('table'));
	
	        return this;
	    },
	
	    save: function save(ev) {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullScreen(ev.currentTarget);
	        var email = this.$('.js-email').val();
	        var name = this.$('.js-name').val();
	
	        _user2.default.inviteMppCustomer(name, email, app.user.id).then(function () {
	            stopLoader();
	            _this.$('#add-modal').modal('hide');
	            return _alerts2.default.show('success', {
	                title: 'MPP Customer Invitation',
	                text: 'Invitation successfully sent!'
	            });
	        }, function (err) {
	            stopLoader();
	            _this.$('#add-modal').modal('hide');
	            return _alerts2.default.show('error', {
	                title: 'MPP Invitation not sent',
	                text: err
	            });
	        });
	    },
	
	    onEmailChange: function onEmailChange() {
	        if (this.$('.js-email').val()) {
	            this.$('.js-save').prop('disabled', false);
	        } else {
	            this.$('.js-save').prop('disabled', true);
	        }
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var sortClass = this.collection.getSort().order === 'ascending' ? 'footable-sorted-desc' : 'footable-sorted';
	
	        this.$el.html((0, _Main2.default)({
	            searchTerm: this.collection.getSearchTerm(),
	            total: this.collection.length,
	            pagination: this.options.pagination && this.collection.getPaginationInfo(),
	            sort: this.collection.getSort(),
	            addModal: (0, _Add2.default)(),
	            role: app.user.get('role')
	        }));
	
	        this.collection.forEach(function (company) {
	            _this2.views.push(new _Company2.default({ model: company }));
	            _this2.$('.js-companies').append(_(_this2.views).last().$el);
	        });
	
	        this.$('.footable-sortable').removeClass('footable-sorted-desc').removeClass('footable-sorted');
	
	        this.$('[data-sort="' + this.collection.getSort().key + '"]').addClass(sortClass);
	
	        this.stopLoader();
	        return this;
	    },
	
	    navigate: function navigate() {
	        app.mainRouter.navigate('companies' + '/' + this.collection.getSort().key + '/' + this.collection.getSort().order + (this.collection.getSearchTerm() ? '/' + this.collection.getSearchTerm() : ''), { trigger: true });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/companies/Main.html -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        ';
	 if (pagination) { 
	__p+='\n        <div class="col-md-3 col-md-offset-9">\n            <div class="searchbox">\n                <input type="text" name="search" placeholder="Search"\n                    class="form-control js-searchbox" value="'+
	((__t=( searchTerm ))==null?'':_.escape(__t))+
	'">\n                <i class="fa fa-search"></i>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <div class="flex-container-row">\n                    <h5>Companies</h5>\n                </div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable footable-ellipsis table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th class="footable-sortable" data-sort="companyName">\n                                Company name <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="contactName">\n                                Name <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="contactEmail">\n                                Email <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="lastActiveTime">\n                                Last Active Date<span class="footable-sort-indicator"></span>\n                            </th>\n                            <th class="footable-sortable" data-sort="createdAt">\n                                Sign Up Date <span class="footable-sort-indicator"></span>\n                            </th>\n                            <th style="width:250px;">\n                                Actions\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-companies"></tbody>\n                </table>\n            </div>\n        </div>\n\n        ';
	 if (pagination) { 
	__p+='\n        '+
	((__t=( __webpack_require__(669)({ pagination: pagination, items: 'companies' }) ))==null?'':__t)+
	'\n        ';
	 } 
	__p+='\n\n    </div>\n</div>\n\n'+
	((__t=( addModal ))==null?'':__t)+
	'\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var template = __webpack_require__(1070);
	
	module.exports = Backbone.View.extend({
	    tagName: 'tr',
	    events: {
	        'click .js-login-to-company': 'loginToCompany'
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            attachments: null
	        });
	        this.model.on('sync', this.render, this);
	
	        return this.render();
	    },
	
	    render: function render() {
	        this.$el.html(template({
	            model: this.model
	        }));
	
	        return this;
	    },
	
	    loginToCompany: function loginToCompany() {
	        window.open('/?company=' + this.model.id, '_blank');
	        return false;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(27)))

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/companies/Company.ejs -->\n';
	 var moment = __webpack_require__(101) 
	__p+='\n<td>'+
	((__t=( model.get('companyName') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('contactName') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('contactEmail') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('lastActiveTime') ? moment(model.get('lastActiveTime'))
	            .format('DD.MM.YYYY HH:mm') : '' ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( moment(model.get('createdAt')).format('DD.MM.YYYY') ))==null?'':_.escape(__t))+
	'</td>\n<td class="flex-container-row" style="overflow: visible;">\n    <a href="" class="js-login-to-company" title="Login to Company">\n        <i class="fa fa-2x fa-sign-in"></i>\n    </a>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/companies/Add.ejs -->\n<!-- Modal -->\n<div class="modal fade" id="add-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\n  <div class="modal-dialog" role="document">\n    <div class="modal-content">\n      <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n        <h4 class="modal-title" id="myModalLabel">Add new Company</h4>\n      </div>\n      <div class="modal-body">\n          <div class="form-horizontal">\n              <div class="form-group">\n                  <label class="col-sm-3 control-label">\n                      Name\n                  </label>\n                  <div class="col-sm-9">\n                      <input name="name" class="js-name form-control" type="text"\n                             placeholder="Name"\n                             data-value-type="string">\n                      <span class="error-name error"></span>\n                  </div>\n              </div>\n\n              <div class="form-group">\n                  <label class="col-sm-3 control-label">\n                      Email\n                  </label>\n                  <div class="col-sm-9">\n                      <input name="email" class="js-email form-control" type="text"\n                             placeholder="Enter Email"\n                             data-value-type="string">\n                      <span class="error-email error"></span>\n                  </div>\n              </div>\n          </div>\n\n      </div>\n      <div class="modal-footer">\n          <button type="button" class="btn btn-default" data-dismiss="modal">\n              Close\n          </button>\n          <button type="button"\n                  class="btn btn-primary js-save"\n                  disabled="disabled"\n                  >\n              Send invitation\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _bluebird = __webpack_require__(63);
	
	var _ListEditables = __webpack_require__(684);
	
	var _ListEditables2 = _interopRequireDefault(_ListEditables);
	
	var _Main = __webpack_require__(1073);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Add = __webpack_require__(1074);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _Account = __webpack_require__(1075);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _user = __webpack_require__(557);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _loader = __webpack_require__(534);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _alerts = __webpack_require__(529);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _modal = __webpack_require__(532);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _ListEditables2.default.extend({
	    itemViews: [],
	    modalView: null,
	
	    events: function events() {
	        var parentEvents = _.isFunction(_ListEditables2.default.prototype.events) ? _ListEditables2.default.prototype.events() : _ListEditables2.default.prototype.events;
	
	        return _.extend(_.clone(parentEvents), {
	            'click .js-add': 'add',
	            'input .js-email': 'onEmailChange'
	        });
	    },
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _Main2.default,
	            Model: _user2.default,
	            ModelView: _Account2.default,
	            companies: null
	        });
	        this.options.templateExtra = {
	            companies: this.options.companies,
	            addModal: (0, _Add2.default)({ companies: this.options.companies })
	        };
	
	        return _ListEditables2.default.prototype.initialize.apply(this, [this.options]);
	    },
	
	    add: function add(ev) {
	        var _this = this;
	
	        var stopLoader = _loader2.default.startFullScreen(ev.currentTarget);
	        var email = this.$('.js-email').val();
	        var name = this.$('.js-name').val();
	        var companies = this.$('.js-companies').val() || [];
	
	        _user2.default.inviteMppManager(name, email, companies).then(function () {
	            stopLoader();
	            _this.$('#add-modal').modal('hide');
	            return _alerts2.default.show('success', {
	                title: 'MPP Manager Invitation',
	                text: 'Invitation successfully sent!'
	            });
	        }, function (err) {
	            stopLoader();
	            _this.$('#add-modal').modal('hide');
	            return _alerts2.default.show('error', {
	                title: 'MPP Invitation not sent',
	                text: err
	            });
	        });
	    },
	
	    onEmailChange: function onEmailChange() {
	        if (this.$('.js-email').val()) {
	            this.$('.js-add').prop('disabled', false);
	        } else {
	            this.$('.js-add').prop('disabled', true);
	        }
	    },
	
	    render: function render() {
	        var r = _ListEditables2.default.prototype.render.apply(this, arguments);
	        this.$('.chosen-select').chosen({ width: '100%' });
	        return r;
	    },
	
	    renderModel: function renderModel(model) {
	        var view = new this.options.ModelView({
	            model: model,
	            companies: this.options.companies
	        });
	        this.$('.js-model-views').append(view.$el);
	        this.modelViews.push(view);
	        return this;
	    },
	
	    save: function save(ev) {
	        var _this2 = this;
	
	        var $button = this.$(ev.currentTarget);
	        var stopLoader = _loader2.default.startFullScreen($button);
	
	        this.trigger('save', this.collection);
	
	        return (0, _bluebird.all)(this.collection.filter(function (model) {
	            return model.dirty();
	        }).map(function (user) {
	            return _user2.default.setMppManagerPermissions(user.id, user.get('managedCompanies'));
	        })).then(function () {
	            return _this2.collection.fetch({ reset: true });
	        }).then(function () {
	            return _modal2.default.showAlertSuccess('Your changes have been saved');
	        }).finally(stopLoader);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/managers/Main.ejs -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <div class="flex-container-row">\n                    <h3>\n                        MPP Managers\n                    </h3>\n                    <a href=""\n                       class="js-add-user"\n                       data-toggle="modal"\n                       data-target="#add-modal"\n                       title="Add new user">\n                        <i class="fa fa-2x fa-plus-circle"></i>\n                    </a>\n                </div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th>Name</th>\n                            <th>Email</th>\n                            <th>Companies</th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-model-views">\n\n                    </tbody>\n                    <tfoot>\n                        <tr>\n                            <td colspan="3">\n                                <div class="pull-right">\n                                    <button class="js-cancel btn btn-warning btn-w-m btn-cancel"\n                                        data-toggle="tooltip" data-title="No changes will be saved"\n                                        data-placement="top" data-delayed>\n                                        <i class="fa fa-exclamation-triangle"></i>\n                                        Cancel\n                                    </button>\n                                    <button class="js-save btn btn-primary m-l-xs">\n                                        <i class="fa fa-check"></i>\n                                        Save changes\n                                    </button>\n                                </div>\n                            </td>\n                        </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n'+
	((__t=( addModal ))==null?'':__t)+
	'\n';
	}
	return __p;
	};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/managers/Add.ejs -->\n<!-- Modal -->\n<div class="modal fade" id="add-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\n    <div class="modal-dialog" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal"\n                    aria-label="Close"><span aria-hidden="true">&times;</span>\n                </button>\n                <h4 class="modal-title" id="myModalLabel">Add new MPP Manager</h4>\n            </div>\n            <div class="modal-body">\n                <div class="form-horizontal">\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Name\n                        </label>\n                        <div class="col-sm-9">\n                            <input name="name" class="js-name form-control"\n                                type="text"\n                                placeholder="Name"\n                                data-value-type="string">\n                            <span class="error-name error"></span>\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Email\n                        </label>\n                        <div class="col-sm-9">\n                            <input name="email" class="js-email form-control"\n                                type="text"\n                                placeholder="Enter Email"\n                                data-value-type="string">\n                            <span class="error-email error"></span>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <label class="col-sm-3 control-label">\n                            Companies\n                        </label>\n                        <div class="col-sm-9">\n                            <select name="companies"\n                                class="form-control chosen-select js-companies"\n                                multiple data-placeholder="No companies">\n                                ';
	 companies.forEach(function (c) { 
	__p+='\n                                    <option value="'+
	((__t=( c.id ))==null?'':_.escape(__t))+
	'">\n                                        '+
	((__t=( c.get('companyName') ))==null?'':_.escape(__t))+
	'\n                                    </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default"\n                    data-dismiss="modal">\n                    Close\n                </button>\n                <button type="button"\n                    class="btn btn-primary js-add"\n                    disabled="disabled">\n                    Send invitation\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _RowEdit = __webpack_require__(690);
	
	var _RowEdit2 = _interopRequireDefault(_RowEdit);
	
	var _Account = __webpack_require__(1076);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _Companies = __webpack_require__(1077);
	
	var _Companies2 = _interopRequireDefault(_Companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _RowEdit2.default.extend({
	    tagName: 'tr',
	
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            template: _Account2.default,
	            deletable: false,
	            companies: new _Companies2.default()
	        });
	        this.options.templateExtra = {
	            companies: this.options.companies
	        };
	
	        return _RowEdit2.default.prototype.initialize.apply(this, arguments);
	    },
	
	    render: function render() {
	        var r = _RowEdit2.default.prototype.render.apply(this, arguments);
	        this.$('.chosen-select').chosen({ width: '100%' });
	        return r;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/managers/Account.ejs -->\n<td>'+
	((__t=( model.get('name') ))==null?'':_.escape(__t))+
	'</td>\n<td>'+
	((__t=( model.get('username') ))==null?'':_.escape(__t))+
	'</td>\n<td>\n    <select name="managedCompanies"\n        class="form-control chosen-select"\n        multiple data-placeholder="No companies">\n        ';
	 companies.forEach(function (c) { 
	__p+='\n            <option value="'+
	((__t=( c.id ))==null?'':_.escape(__t))+
	'"\n                '+
	((__t=( (model.get('managedCompanies') || []).indexOf(c.id) >= 0 ?
	                    'selected' : '' ))==null?'':_.escape(__t))+
	'>\n                '+
	((__t=( c.get('companyName') ))==null?'':_.escape(__t))+
	'\n            </option>\n        ';
	 }) 
	__p+='\n    </select>\n</td>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _Base = __webpack_require__(1078);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Company = __webpack_require__(1079);
	
	var _Company2 = _interopRequireDefault(_Company);
	
	var _escapeStringRegexp = __webpack_require__(791);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Collection = void 0;
	
	module.exports = Collection = _Base2.default.extend(
	/** @lends module:collections.Companies */
	{
	    /**
	     * Companies can be searched by companyName and email
	     * @type {Array<String>}
	     * @protected
	     */
	    searchableAttributes: ['companyName', 'contactName', 'contactEmail', 'contactPhone', 'username'],
	
	    /**
	     * This is specific to company collections. Searchable attributes of
	     * mpp admins
	     * @type {Array<String>}
	     * @protected
	     */
	    mppSearchableAttributes: ['email', 'name'],
	
	    /**
	     * Search term of mpp admins
	     */
	    mppSearchTerm: '',
	
	    /**
	     * @constructs
	     * @augments module:collections.BaseCollection
	     * @param {Array<module:models.Company>=} models
	     * @param {module:collections.BaseCollection~initOptions=} options
	     */
	    initialize: function initialize(models, options) {
	        this.model = _Company2.default;
	        if (options && options.mppSearchTerm) {
	            this.mppSearchTerm = options.mppSearchTerm;
	        }
	        return _Base2.default.prototype.initialize.apply(this, arguments);
	    },
	
	
	    /**
	     * A more complex comparator. Companies can be sorted by some attributes
	     * with date values and by the contactPhone in the primary location's
	     * address model, for those cases when need to prep the value first.
	     *
	     * @instance
	     * @param {module:models.Company} a
	     * @param {module:models.Company} b
	     * @returns {Number} The number to sort by
	     */
	    comparator: function comparator(a, b) {
	        if (this.getSort().key === 'createdAt') {
	            return _Base2.default.prototype.valueComparator.apply(this, [a.createdAt.valueOf(), b.createdAt.valueOf()]);
	        }
	
	        if (this.getSort().key === 'contactPhone') {
	            var phones = [];
	
	            _([a, b]).each(function (model) {
	                try {
	                    phones.push(model.get('location').get('address').get('contactPhone'));
	                } catch (e) {
	                    phones.push('');
	                }
	            });
	
	            return _Base2.default.prototype.valueComparator.apply(this, phones);
	        }
	
	        if (this.getSort().key === 'lastActiveTime') {
	            return _Base2.default.prototype.valueComparator.apply(this, [(a.get('lastActiveTime') || '').valueOf(), (b.get('lastActiveTime') || '').valueOf()]);
	        }
	
	        return _Base2.default.prototype.comparator.apply(this, arguments);
	    },
	
	
	    /*
	     * @instance
	     * @returns {String}
	     */
	    getMppSearchTerm: function getMppSearchTerm() {
	        return this.mppSearchTerm || '';
	    },
	    postProcessQuery: function postProcessQuery(query) {
	        var matches = this.getMppSearchTerm().match(/\S+/g);
	        if (!matches) {
	            return query;
	        }
	
	        var term = '(' + matches.map(function (unescaped) {
	            return (0, _escapeStringRegexp2.default)(unescaped);
	        }).join('|') + ')';
	
	        query._where || (query._where = {});
	        query._where.mppAdmin = { $inQuery: {
	                className: '_User',
	                where: {
	                    $or: this.mppSearchableAttributes.map(function (attr) {
	                        var r = {};
	                        r[attr] = { $regex: term, $options: 'i' };
	                        return r;
	                    })
	                }
	            } };
	
	        return query;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Parse, _) {/** @module collections */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _log = __webpack_require__(525);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _escapeStringRegexp = __webpack_require__(791);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _log2.default)('base-collection');
	
	function createParseQuery(collection) {
	    var model = collection.model;
	    var query = JSON.parse(JSON.stringify(collection._query));
	    var defaultIncludes = collection.defaultIncludes || [];
	    var pagination = collection.getPagination();
	    var sort = collection.getSort();
	    var searchableAttributes = collection.searchableAttributes || [];
	    var searchTerm = collection.getSearchTerm();
	    var parseQuery = new Parse.Query(model);
	
	    // properties of the query object have precedence over pagination and
	    // order configs until we can unify that logic into a single query object
	    if (pagination) {
	        query.limit = query.limit || pagination.limit;
	        query.skip = query.skip || pagination.offset;
	    }
	
	    if (sort && sort.key) {
	        query.order = query.order || (sort.order === 'descending' ? '-' : '') + sort.key;
	    }
	
	    if (defaultIncludes.length) {
	        query.include = query.include || defaultIncludes;
	    }
	
	    ['where', 'include', 'keys', 'limit', 'skip', 'order'].forEach(function (attr) {
	        if (query[attr]) {
	            parseQuery['_' + attr] = query[attr];
	        }
	
	        if (['include', 'keys', 'order'].indexOf(attr)) {
	            if (query[attr] && typeof query[attr].split === 'function') {
	                parseQuery['_' + attr] = query[attr].split(',');
	            }
	        }
	    });
	
	    if (searchTerm && searchTerm.length && searchableAttributes.length) {
	        var term = '(' + searchTerm.match(/\S+/g).map(function (unescaped) {
	            return (0, _escapeStringRegexp2.default)(unescaped);
	        }).join('|') + ')';
	
	        parseQuery._orQuery(searchableAttributes.map(function (attr) {
	            return new Parse.Query(model).matches(attr, term, 'i');
	        }));
	    }
	
	    if (typeof collection.postProcessQuery === 'function') {
	        parseQuery = collection.postProcessQuery(parseQuery);
	    }
	
	    return parseQuery;
	}
	
	module.exports = Parse.Collection.extend(
	/** @lends module:collections.BaseCollection */
	{
	
	    /**
	     * The class name of the models that the collection holds
	     * @type {String}
	     * @protected
	     */
	    className: null,
	
	    /**
	     * If enabled, models removed from the collection will be removed from the
	     * server as well as soon as {@link module:collections.BaseCollection#save}
	     * is called
	     *
	     * @type {Boolean}
	     * @default
	     * @protected
	     */
	    syncRemove: false,
	
	    /**
	     * An array of references to any removed models from the collection. If
	     * {@link module:collections.BaseCollection#syncRemove} is true, these
	     * models will be deleted on save
	     *
	     * @type {Object[]}
	     * @default
	     * @protected
	     */
	    removedModels: [],
	
	    /**
	     * List of searchable attributes by which we can query the backend
	     * to get a subset of models where the value of any of these attributes
	     * matches the searchTerm provided.
	     *
	     * See also {@link module:collections.BaseCollection#searchTerm}
	     * @type {String[]}
	     * @default []
	     * @protected
	     */
	    searchableAttributes: [],
	
	    /**
	     * The code sometimes depends that the collection populates some of the
	     * pointers stored in the models. We can set a sensitive default of
	     * includes as an array that we know (unless overriden) will be included
	     * in the models
	     *
	     * @type {String[]}
	     * @default []
	     * @protected
	     */
	    defaultIncludes: [],
	
	    /**
	     * Key used to sort by. Must be a valid attribute of whatever models the
	     * collection holds.
	     *
	     * @type {String}
	     * @default
	     * @protected
	     */
	    sortKey: null,
	
	    /**
	     * Order in which the collection is sorted.
	     * Value can be 'ascending' or 'descending'. If sortOrder is a truthy
	     * value different from 'ascending', it is always considered as
	     * 'descending'. IE, if sortOrder === 'whatever' the collection will be
	     * sorted in descending order (provided sortKey is set)
	     *
	     * @type {String}
	     * @default
	     * @protected
	     */
	    sortOrder: null,
	
	    /**
	     * A search term used to filter the collection. If set, subsequent
	     * calls to {@link module:collections.BaseCollection#fetch} will
	     * try to include it in the base query object. But it ultimately depends
	     * on the subclasses overriding
	     * {@link module:collections.BaseCollection#querySearchTerm}
	     *
	     * @type {String}
	     * @default
	     * @protected
	     */
	    searchTerm: null,
	
	    /**
	     * @typedef {Object} module:collections.BaseCollection~Pagination
	     * @prop {number} offset
	     * @prop {number} [limit=5000]
	     * @prop {number} page
	     * @prop {number} pages
	     * @prop {number} count
	     */
	
	    /**
	     * Pagination config object.
	     * @type {module:collections.BaseCollection~Pagination}
	     * @protected
	     */
	    pagination: null,
	
	    /**
	     * The model constructor
	     * @type {Object}
	     * @protected
	     */
	    model: null,
	
	    /**
	     * @typedef {Object} module:collections.BaseCollection~Query
	     * @prop {Object=} where - The where clause of the query. In it's simplest
	     *  form it's a set of key-value pairs where the key is a model attribute
	     *  and the value is matched for equality against persisted values. Example:
	     *  <br>
	     *  To fetch all rows where the name equals to 'John':
	     *  <pre><code>{where: {name : 'John'}}</code></pre>
	     *  <br><br>
	     *
	     *  The where clause supports a set of operators that look and work
	     *  pretty much like a mongodb query. Namely $or, $ne, $in, etc. For a
	     *  comprehensive list of supported operators, see:
	     *  {@link http://parseplatform.github.io/docs/rest/guide/#queries}<br><br>
	     *
	     *  A few gotchas you need to know:
	     *  <ul>
	     *      <li>
	     *          If the attribute you are querying by
	     *          is a "pointer" you can't compare it against a model instance.
	     *          You need to turn the model into "pointer object" first. See
	     *          {@link module:models.BaseModel#toPointerObj}. Example:
	     *  <pre><code>{where: {somePointerAttr: model.toPointerObj()}}</code></pre>
	     *      </li>
	     *      <li>
	     *          If the attribute is a date, you need to turn it into something
	     *          Parse understands. Querying by date looks something like this:
	     *  <pre><code>{where: {
	     *      date: {
	     *          __type: 'Date',
	     *          iso:    new Date().toISOString()
	     *      }
	     *  }}
	     *  </code></pre>
	     *      </li>
	     *  </ul>
	     * @prop {Number} limit - The amount of rows to fetch
	     * @prop {Number} skip - The offset in Parse parlance.
	     * @prop {String|Array<String>} include - An array or a comma separated
	     *  list of includes. Pointers will be populated by the query if
	     *  specified in this list
	     * @prop {String|Array<String>} sort - An array or a comma separated
	     *  list of attributes to sort by. If the attribute name is preceded by
	     *  a minus sign, the order is reversed. IE:
	     *  <code>{order: '-createdAt'}</code> will sort by the createdAt
	     *  attribute in descending order.
	     */
	
	    /**
	     * An object literal expression of the base Parse.Query object used to
	     * fetch data
	     *
	     * @type {module:collections.BaseCollection~Query}
	     * @private
	     */
	    _query: {},
	
	    /**
	     * The base parse query for this collection
	     *
	     * @type {external:Parse.Query}
	     * @protected
	     */
	    query: null,
	
	    /**
	     * @typedef {Object} module:collections.BaseCollection~initOptions
	     * @prop {Boolean} syncRemove - If true models in this collection
	     *  that are removed from it, are later deleted from the server if the
	     *  collection is saved
	     * @prop {String} sortKey
	     * @prop {String} sortKey - See
	     *  {@link module:collections.BaseCollection.sortKey}
	     * @prop {String} sortOrder - See
	     *  {@link module:collections.BaseCollection.sortOrder}
	     * @prop {module:collections.BaseCollection~Pagination} pagination -
	     *  See {@link module:collections.BaseCollection.pagination}
	     * @prop {module:collections.BaseCollection~Query} query
	     */
	
	    /**
	     * @constructs
	     * @augments external:Parse.Collection
	     * @param {Array<external:Parse.Object>=} models
	     * @param {module:collections.BaseCollection~initOptions} options
	     */
	    initialize: function initialize(models, options) {
	        this.pagination || (this.pagination = {});
	        options = _.defaults(options || {}, {
	            syncRemove: false,
	            sortKey: null,
	            sortOrder: null,
	            pagination: {
	                offset: this.pagination.offset || 0,
	                limit: this.pagination.limit || 5000,
	                page: this.pagination.page || 0,
	                pages: this.pagination.pages || 0,
	                count: this.pagination.count || 0
	            },
	            query: null
	        });
	
	        this.className = this.model.prototype.className || '';
	
	        this.query = null;
	
	        this.syncRemove = options.syncRemove === true;
	        this.removedModels = [];
	        if (this.syncRemove === true) {
	            log.info(this.className + ' collection configured to sync removed ' + 'models');
	            this.on('remove', this.destroyLater, this);
	        }
	
	        if (options.pagination && _typeof(options.pagination) === 'object') {
	            _.extend(this.pagination, _.omit(options.pagination, ['count', 'pages', 'page']));
	        }
	
	        // TODO As with pagination this can be all included in the query
	        // object.
	        if (options.sortKey) {
	            this.sortKey = options.sortKey;
	        }
	        if (options.sortOrder) {
	            this.sortOrder = options.sortOrder;
	        }
	        if (options.searchTerm) {
	            this.searchTerm = options.searchTerm;
	        }
	        if (options.query) {
	            this._query = options.query || {};
	        }
	
	        return this;
	    },
	
	
	    /**
	     * Whenever the models in this collection change (add, remove, reset, etc)
	     * comparator is called to sort them based on
	     * {@link module:collections.BaseCollection#sortKey} and
	     * {@link module:collections.BaseCollection#sortOrder}.
	     *
	     * If sortKey is set, this method does calls to
	     * {@link module:collections.BaseCollection#valueComparator} to ultimately
	     * compare the two values of the specified key.
	     *
	     * @instance
	     * @param {Object} a - A model instance
	     * @param {Object} b - Another model to compare to
	     */
	    comparator: function comparator(a, b) {
	        var keys = void 0;
	
	        if (!_.isString(this.sortKey)) {
	            return 0;
	        }
	
	        keys = this.sortKey.split('.');
	
	        _(keys).each(function (key) {
	            if (typeof (a || {}).get !== 'function' || typeof (b || {}).get !== 'function') {
	                a = 0;
	                b = 0;
	                return;
	            }
	
	            a = a.get(key);
	            b = b.get(key);
	        });
	
	        return this.valueComparator(a, b);
	    },
	
	
	    /**
	     * Compare two values mainly for the purpose of sorting the collection.
	     * Unless overriden, it's generally always called by
	     * {@link module:collections.BaseCollection#comparator}
	     *
	     * It is assumed that the parameters are of the same type or that can be
	     * compared against each other.
	     *
	     * @instance
	     * @param {*} a - Some value
	     * @param {*} b - Another value to compare against.
	     * @returns {Number} -1, 1 or 0.
	     */
	    valueComparator: function valueComparator(a, b) {
	        var order = this.sortOrder || 'ascending';
	
	        if (typeof a === 'string') {
	            a = a.toLowerCase();
	        }
	        if (typeof b === 'string') {
	            b = b.toLowerCase();
	        }
	
	        if (a instanceof Date) {
	            a = a.getTime();
	        }
	        if (b instanceof Date) {
	            b = b.getTime();
	        }
	
	        return order === 'ascending' ? a < b ? -1 : a > b ? 1 : 0 : a < b ? 1 : a > b ? -1 : 0;
	    },
	
	
	    /**
	     * @typedef {Object} module:collections.BaseCollection~sortConfig
	     * @prop {String|null} key - The collection's sortKey
	     * @prop {String|null} order - The collection's sortOrder
	     */
	
	    /**
	     * Get the sort config of this collection
	     *
	     * @instance
	     * @returns {module:collections.BaseCollection~sortConfig}
	     */
	    getSort: function getSort() {
	        return {
	            key: this.sortKey || null,
	            order: this.sortOrder || null
	        };
	    },
	
	
	    /*
	     * @instance
	     * @returns {String}
	     */
	    getSearchTerm: function getSearchTerm() {
	        return this.searchTerm || '';
	    },
	
	
	    /**
	     * Overriden Parse.Collection.save() method.
	     * Firstly, only dirty or new  models are saved, instead of the whole
	     * collection. Secondly, if syncREmove is enabled, any model that was
	     * removed from the instance is destroyed from the server.
	     *
	     * @instance
	     * @returns {external:Parse.Promise<module:collections.BaseCollection>}
	     */
	    save: function save() {
	        log.info('saving dirty models');
	
	        return Parse.Promise.when(_.map(this.filter(function (model) {
	            return model.dirty() || model.isNew();
	        }), function (model) {
	            return model.save();
	        })).then(function () {
	            log.info('models saved');
	
	            if (!this.syncRemove || this.removedModels.length === 0) {
	                return Parse.Promise.as(true);
	            }
	
	            log.info('destroying removed models');
	            return Parse.Object.destroyAll(this.removedModels);
	        }.bind(this)).then(function () {
	            log.info('done saving');
	
	            this.removedModels = [];
	            return Parse.Promise.as(this);
	        }.bind(this));
	    },
	
	
	    /**
	     * Should be overriden when subclassing. Meant to create a query that
	     * includes the search term in it.
	     *
	     * @instance
	     * @returns {external:Parse.Query}
	     */
	    querySearchTerm: function querySearchTerm() {
	        if (this.getSearchTerm()) {
	            log.warn('Method not implemented in subclass. Not searching.');
	        }
	
	        return this.query;
	    },
	
	
	    /**
	     * @instance
	     * @param {Object=} options - A backbone compatible options object,
	     *  extended.
	     * @param {module:collections.BaseCollection~Query} options.query
	     * @returns {external:Parse.Promise<module:collections.BaseCollection>}
	     */
	    fetch: function fetch() {
	        var _this = this,
	            _arguments = arguments;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { query: null };
	
	        // override our current _query with the new one if provided
	        if (options.query) {
	            this._query = options.query;
	        }
	
	        this.query = createParseQuery(this);
	
	        //If you are wondering (like I did), you can't use .always() to
	        //reset the collections query. It breaks the thenable chain
	        return Parse.Collection.prototype.fetch.apply(this, arguments).then(function () {
	            return Parse.Promise.as(_this);
	        }, function (err) {
	            log.error(_this.className, 'collection unable to fetch:', err);
	            return Parse.Promise.error(_arguments);
	        });
	    },
	
	
	    /**
	     * @instance
	     * @returns {external:Parse.Promise<Number>}
	     */
	    fetchCount: function fetchCount() {
	        if (!this.query) {
	            this.query = createParseQuery(this);
	        }
	
	        return this.query.count();
	    },
	
	
	    /**
	     * @instance
	     * @returns {external:Parse.Promise<module:collections.BaseCollection>}
	     */
	    fetchPage: function fetchPage(page, options) {
	        var _this2 = this;
	
	        return this.fetchCount().then(function (count) {
	            _this2.pagination.count = count;
	            _this2.pagination.page = page || 0;
	            _this2.pagination.offset = _this2.pagination.page * _this2.pagination.limit;
	            _this2.pagination.pages = Math.ceil(_this2.pagination.count / _this2.pagination.limit);
	        }).then(function () {
	            return _this2.fetch(options).then(function () {
	                return Parse.Promise.as(_this2);
	            });
	        });
	    },
	
	
	    /**
	     * Get pagination data
	     *
	     * @instance
	     * @returns {module:collections.BaseCollection~Pagination}
	     */
	    getPagination: function getPagination() {
	        return this.pagination || {};
	    },
	
	
	    /**
	     * Save model reference to
	     * {@link module:collections.BaseCollection#removedModels} so that it is
	     * destroyed whenever the collection is saved
	     *
	     * @todo TODO validate that the model already belongs or belonged to the
	     * collection. Make private?
	     * @instance
	     * @returns {module:collections.BaseCollection} this
	     */
	    destroyLater: function destroyLater(model) {
	        if (!model.id) {
	            return;
	        }
	
	        log.info('model ' + model.id + ' will be deleted when collection syncs');
	        this.removedModels.push(model);
	        return this;
	    },
	
	
	    /**
	     * @instance
	     * @returns {Boolean} True if the models in this collection are all new
	     *  models
	     */
	    isNew: function isNew() {
	        return this.reduce(function (memo, model) {
	            return memo && model.isNew();
	        }, true);
	    },
	
	
	    /**
	     * @instance
	     * @returns {Boolean} True if the models in this collection are all valid
	     */
	    isValid: function isValid() {
	        return this.reduce(function (memo, model) {
	            return memo && model.isValid();
	        }, true);
	    },
	
	
	    /**
	     * Alias for {@link module:collections.BaseCollection#dirty}
	     *
	     * @instance
	     * @returns {Boolean} True if at least one model in the collection is
	     *  dirty, new or there are removed models pending to be destroyed
	     */
	    isDirty: function isDirty() {
	        return this.dirty();
	    },
	
	
	    /**
	     * @instance
	     * @returns {Boolean} True if at least one model in the collection is
	     *  dirty, new or there are removed models pending to be destroyed
	     */
	    dirty: function dirty() {
	        return this.reduce(function (memo, model) {
	            return memo || model.dirty() || model.isNew();
	        }, false) || this.removedModels.length > 0;
	    }
	}, {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(650), __webpack_require__(27)))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Parse) {/*global*/
	'use strict';
	
	var BaseModel = __webpack_require__(733);
	var CompanyLocation = __webpack_require__(1080);
	var moment = __webpack_require__(101);
	var Model = void 0;
	
	module.exports = Model = BaseModel.extend('Company',
	/** @lends module:models.Company */
	{
	    /**
	     * @default
	     * @type {object}
	     * @protected
	     */
	    defaults: {
	        user: null,
	
	        companyName: '',
	        type: '',
	        eNumber: '',
	        regNumber: '',
	        taxRegNumber: '',
	        epfRegNumber: '',
	        socsoRegNumber: '',
	        zakatRefNumber: '',
	
	        contactEmail: '',
	        contactName: '',
	
	        employeeCount: 0,
	
	        isSetUp: false,
	
	        bankAccount: null,
	
	        emailPayslipsText: '',
	        employeePayslipEmailText: '',
	        isEnabledEmailPayslips: false,
	        isEnabledEmployeePayslipEmail: false,
	        isEnabledLeaveEmail: false,
	
	        recordUnpaidLeaveInPayroll: true,
	        unpaidLeaveCalculationType: 1,
	        unpaidLeaveFixedDays: 22,
	        areNationalHolidaysWorking: false,
	        workingHoursPerDay: 8,
	        showBirthdaysInCalendar: true,
	        showAnniversariesInCalendar: true,
	        showCompanyHolidaysInCalendar: true,
	        showNationalHolidaysInCalendar: true,
	        showLeavePolicies: false,
	        showAdditionalLeaveInfo: '',
	        nonWorkingDays: [1, 7],
	        holidayStates: ['national'],
	        leaveRenewalPolicy: 'joinDate',
	        annualLeavePolicy: 1,
	        allowLeaveCarryForward: true,
	        daysCanCarryForward: 5,
	        carryForwardExpiryMonths: 3,
	        leaveDays: {},
	        eisEnabled: true,
	        payslipSize: 'A4',
	        hrdfContribution: 'auto'
	    },
	
	    /**
	     * Company registration numbers against government authorities
	     * plus labels.
	     *
	     * @type {object}
	     * @default
	     * @protected
	     */
	    companyNumbers: {
	        eNumber: 'E Number',
	        regNumber: 'Company Registration Number',
	        epfRegNumber: 'EPF Number',
	        socsoRegNumber: 'SOCSO Number'
	    },
	
	    /**
	     * Validation constraints
	     *
	     * @type {object}
	     * @protected
	     */
	    constraints: {
	        user: { presence: true },
	
	        companyName: { presence: { message: '^Company Name cannot be blank' } },
	        type: { presence: true },
	        eNumber: {
	            format: {
	                pattern: /^\d{1,8}-\d{2}$/,
	                message: 'Invalid E Number format (Example: 99999999-99)'
	            },
	            length: {
	                is: 11,
	                message: '^The E Number must be 10 digits long and a hyphen'
	            }
	        },
	        socsoRegNumber: {
	            format: {
	                pattern: /^[a-zA-Z]([0-9]{10})[a-zA-Z]$/,
	                message: 'Invalid SOCSO Number format (Example: B3201002997A)'
	            }
	        },
	        contactEmail: { presence: true, email: true },
	        contactName: { presence: true },
	        employeeCount: {
	            numericality: {
	                onlyInteger: true,
	                greaterThanOrEqualTo: 0
	            }
	        },
	        annualLeaveDays: { numericality: true },
	        hospitalizationLeaveDays: { numericality: true },
	        maternityLeaveDays: { numericality: true },
	        medicalLeaveDays: { numericality: true },
	        marriageLeaveDays: { numericality: true },
	        compassionateLeaveDays: { numericality: true },
	        reminderApproveLeaveEmailDays: {
	            numericality: {
	                onlyInteger: true,
	                greaterThanOrEqualTo: 0
	            }
	        }
	    },
	
	    /**
	     * Grouped validation constraints
	     *
	     * @default
	     * @type {object}
	     * @protected
	     */
	    groupedConstraints: {
	        leaveSettings: {
	            unpaidLeaveCalculationType: function unpaidLeaveCalculationType(value, attrs) {
	                if (attrs.recordUnpaidLeaveInPayroll === true) {
	                    return {
	                        numericality: {
	                            onlyInteger: true,
	                            greaterThanOrEqualTo: 1,
	                            lessThanOrEqualTo: 3
	                        },
	                        presence: true
	                    };
	                }
	
	                return null;
	            },
	
	            unpaidLeaveFixedDays: function unpaidLeaveFixedDays(value, attrs) {
	                var r = {
	                    numericality: {
	                        onlyInteger: true,
	                        greaterThanOrEqualTo: 1,
	                        lessThanOrEqualTo: 31
	                    }
	                };
	
	                if (attrs.recordUnpaidLeaveInPayroll === true && attrs.unpaidLeaveCalculationType === 1) {
	                    r = _.extend(r, { presence: true });
	                }
	
	                return r;
	            }
	        }
	    },
	
	    /**
	     * @constructs
	     * @augments module:models.BaseModel
	     *
	     * @prop {external:Parse.User} user - The user associated to the company
	     * @prop {string} companyName
	     * @prop {string} type
	     * @prop {string} eNumber
	     * @prop {string} regNumber
	     * @prop {string} taxRegNumber
	     * @prop {string} epfRegNumber
	     * @prop {string} socsoRegNumber
	     * @prop {string} zakatRefNumber
	     * @prop {string} contactEmail
	     * @prop {string} contactName
	     * @prop {integer} employeeCount
	     * @prop {boolean} isSetUp
	     * @prop {module:models.BankAccount} bankAccount
	     * @prop {string} emailPayslipText
	     * @prop {string} employeePayslipEmailText
	     * @prop {boolean} isEnabledEmailPayslips
	     * @prop {boolean} isEnabledEmployeePayslipEmail
	     * @prop {boolean} isEnabledLeaveEmail
	     * @prop {boolean} reminderApproveLeaveEmailDays
	     * @prop {boolean} recordUnpaidLeaveInPayroll
	     * @prop {integer} unpaidLeaveCalculationType
	     * @prop {integer} unpaidLeaveFixedDays
	     * @prop {integer} leaveDayRoundingType
	     * @prop {float} leaveDayRoundingSize
	     * @prop {integer} leaveBalanceResetType
	     * @prop {integer} leaveBalanceResetMonth
	     * @prop {integer} leaveBalanceResetDay
	     * @prop {boolean} areNationalHolidaysWorking
	     * @prop {integer} workingHoursPerDay
	     * @prop {boolean} showBirthdaysInCalendar
	     * @prop {boolean} showAnniversariesInCalendar
	     * @prop {boolean} showCompanyHolidaysInCalendar
	     * @prop {boolean} showNationalHolidaysInCalendar
	     * @prop {boolean} showLeavePolicies
	     * @prop {string} showAdditionalLeaveInfo
	     * @prop {array<integer>} nonWorkingDays
	     * @prop {array<string>} holidayStates
	     * @prop {boolean} eisEnabled - If EIS should be calculated for this
	     *  employer or not
	     */
	    initialize: function initialize() {
	        BaseModel.prototype.initialize.apply(this, arguments);
	
	        this.on('change:recordUnpaidLeaveInPayroll', this.toggleUnpaidLeaveFixedDays, this);
	        this.on('change:unpaidLeaveCalculationType', this.toggleUnpaidLeaveFixedDays, this);
	
	        this.primaryLocation = null;
	    },
	
	    /**
	     * Check if the company is fully setup
	     *
	     * @instance
	     * @returns {boolean} true if it is
	     */
	    isSetUp: function isSetUp() {
	        return this.get('isSetUp') || this.isBasicInfoSetUp() && this.get('regNumber') && this.get('eNumber') && this.get('epfRegNumber') && this.get('socsoRegNumber');
	    },
	
	    /**
	     * Check if the company has a location, a name, a type and an address
	     *
	     * @instance
	     * @returns {boolean} true if it does
	     */
	    isBasicInfoSetUp: function isBasicInfoSetUp() {
	        return this.get('isSetUp') || this.primaryLocation && this.get('companyName') && this.get('type');
	    },
	
	    /**
	     * Get the primary location of this company
	     *
	     * @instance
	     * @param {boolean} options.forceFetch - If true we fetch from the server
	     *  no matter what. If false we can use a previously fetched reference if
	     *  available
	     * @returns {module:models.CompanyLocation} The primary location
	     */
	    getPrimaryLocation: function getPrimaryLocation(options) {
	        var _this = this;
	
	        options = _.defaults(options || {}, {
	            forceFetch: false
	        });
	
	        if (this.primaryLocation && options.forceFetch !== true) {
	            return Parse.Promise.as(this.primaryLocation);
	        }
	
	        return CompanyLocation.fetchPrimaryForCompany(this).then(function (location) {
	            _this.primaryLocation = location;
	            return Parse.Promise.as(location);
	        });
	    },
	
	    /**
	     * Set unpaidLeaveFixedDays to null if the leave settings don't require
	     * a value in unpaidLeaveFixedDays
	     *
	     * @instance
	     */
	    toggleUnpaidLeaveFixedDays: function toggleUnpaidLeaveFixedDays() {
	        if (this.get('recordUnpaidLeaveInPayroll') !== true || this.get('unpaidLeaveCalculationType') !== 1) {
	            this.set({ 'unpaidLeaveFixedDays': null });
	        }
	    },
	
	    /**
	     * Like {@link module:models.BaseModel#fetch} but we make sure to fetch
	     * the primary location as well, see
	     * {@link module:models.Company#getPrimaryLocation}
	     *
	     * Also bank account is included
	     *
	     * @instance
	     * @returns {module:models.Company} the company
	     */
	    fetch: function fetch() {
	        var _this2 = this;
	
	        return this.getPrimaryLocation({ forceFetch: true }).then(function () {
	            return BaseModel.prototype.fetch.call(_this2, { success: function success() {} });
	        }).then(function (model) {
	            return Parse.Promise.as().then(function () {
	                if (!model.get('bankAccount')) {
	                    return true;
	                }
	
	                return model.get('bankAccount').fetch();
	            }).then(function () {
	                model.trigger('sync', model);
	                return model;
	            });
	        });
	    },
	
	    /**
	     * Generate the company's form E
	     *
	     * @instance
	     * @returns {Parse.Promise<?>} A promise... of what?
	     */
	    generateFormE: function generateFormE() {
	        return Parse.Cloud.run('generateFormE', { companyId: this.id });
	    },
	
	    generateFormCp8d: function generateFormCp8d() {
	        return Parse.Cloud.run('generateFormCp8d', { companyId: this.id });
	    },
	
	    getLeaveDays: function getLeaveDays(type) {
	        var days = this.get('leaveDays') || {};
	        return parseFloat(days[type.id]) || 0;
	    },
	
	    setLeaveDays: function setLeaveDays(options) {
	        var type = options.type,
	            typeId = options.typeId,
	            days = options.days;
	
	        var leaveDays = this.get('leaveDays') || {};
	        if (!typeId) {
	            typeId = type.id;
	        }
	        leaveDays[typeId] = parseFloat(days || 0);
	        this.set('leaveDays', leaveDays);
	    },
	
	    isWorkingDay: function isWorkingDay(date) {
	        var _this3 = this;
	
	        if (!(date instanceof moment)) {
	            date = moment(date);
	        }
	
	        if (!date.isValid()) {
	            return false;
	        }
	
	        if (_(this.get('nonWorkingDays')).contains(date.day() + 1)) {
	            return false;
	        }
	
	        var isHoliday = app.holidays.find(function (holiday) {
	            if (moment(holiday.get('date')).isSame(date, 'day')) {
	                return _.intersection(holiday.get('states'), _this3.get('holidayStates')).length > 0;
	            }
	        });
	
	        return !isHoliday;
	    },
	
	    getWorkingDaysInMonth: function getWorkingDaysInMonth(date) {
	        date = date || moment();
	        var start = date.clone().startOf('month');
	        var end = date.clone().endOf('month');
	        var workingDays = [];
	
	        while (!start.isAfter(end)) {
	            if (this.isWorkingDay(start)) {
	                workingDays.push(start.clone());
	            }
	            start.add(1, 'day');
	        }
	
	        return workingDays;
	    }
	}, {
	    fetchById: function fetchById(id) {
	        return new Parse.Query('Company').include('user').include('bankAccount').include('mppAdmin').get(id).then(function (company) {
	            return company.getPrimaryLocation().then(function () {
	                return Parse.Promise.as(company);
	            });
	        });
	    },
	
	    fetchForUser: function fetchForUser(user) {
	        if (user.get('role') === 'employee') {
	            return Model.fetchForEmployee(user);
	        }
	
	        return new Parse.Query('Company').include('user').include('bankAccount').include('mppAdmin').equalTo('user', user).first().then(function (company) {
	            if (!company) {
	                return Parse.Promise.error('Couldn\'t find company.');
	            }
	
	            return company.getPrimaryLocation().then(function () {
	                return Parse.Promise.as(company);
	            });
	        });
	    },
	
	    fetchForEmployee: function fetchForEmployee(user) {
	        return new Parse.Query('Employee').include('user').include('company').include('company.bankAccount').include('company.mppAdmin').equalTo('user', user).first().then(function (employee) {
	            return employee.get('company');
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(650)))

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Parse) {'use strict';
	
	var BaseModel = __webpack_require__(733);
	var Model;
	
	module.exports = Model = BaseModel.extend('CompanyLocation', {
	    softDelete: false,
	
	    defaults: {
	        name: 'HQ',
	        company: null,
	        address: null,
	        primary: true
	    },
	
	    constraints: {
	        name: { presence: { message: '^Name is required' } },
	        company: { presence: true },
	        primary: { presence: true }
	    },
	
	    initialize: function initialize() {
	        BaseModel.prototype.initialize.apply(this, arguments);
	
	        this.proxyAddressChangeEvent();
	    },
	
	    proxyAddressChangeEvent: function proxyAddressChangeEvent() {
	        var self = this;
	        var _address = false;
	        var bind = function bind() {
	            _address = self.get('address');
	            _address.on('change', function (model, options) {
	                self.trigger('change', self, options);
	                self.trigger('change:address', self, options);
	            });
	        };
	
	        if (self.get('address')) {
	            bind();
	        }
	
	        self.on('change:address', function () {
	            if (self.get('address')) {
	                if (_address) {
	                    _address.off('change');
	                }
	                bind();
	            }
	        }, self);
	    },
	
	    /* NOTE We need to validate the address contained in this object and a
	     * simple constraint doesn't cut it as we need an error per attribute
	     * in the address class.
	     * To overcome this I run BaseModel validation and append the address
	     * model errors to the result.
	     *
	     * The good: validation for this model works as expected by any backbone
	     * dev. The bad: BaseModel.validation() is too complex and we now are
	     * required to keep an eye out to avoid this method from breaking which
	     * is likely to happen in the future.
	     * */
	    validate: function validate(attrs, options) {
	        var self = this;
	        BaseModel.prototype.validate.apply(self, arguments);
	
	        if (self.get('address') && self.get('primary') === true) {
	            var r = self.get('address').validate(self.get('address').attributes, options);
	
	            if (r !== false) {
	                self.validationError = _.extend(self.validationError || {}, r.validationError);
	            }
	        }
	
	        return _.isObject(self.validationError) && !_.isEmpty(self.validationError) ? {
	            code: 1100,
	            error: 'Validation error',
	            errors: self.validationError
	        } : false;
	    },
	
	    dirty: function dirty() {
	        var self = this;
	        var dirty = BaseModel.prototype.dirty.apply(this, arguments);
	
	        if (self.get('address')) {
	            dirty = dirty || self.get('address').dirty();
	        }
	
	        return dirty;
	    },
	
	    isValid: function isValid() {
	        var self = this;
	        var valid = BaseModel.prototype.isValid.apply(self, arguments);
	        var hasState = self.get('address').get('state') !== '';
	
	        if (self.get('address') && self.get('primary') === true) {
	            valid = valid && self.get('address').isValid();
	        } else if (!hasState) {
	            valid = false;
	        }
	
	        return valid;
	    },
	
	    wasValid: function wasValid() {
	        var address = this.get('address');
	        if (!address) {
	            return true;
	        }
	
	        return this.getValidationError() === false || _.isEmpty(this.getValidationError());
	    },
	
	    getValidationError: function getValidationError() {
	        var address = this.get('address');
	        var addressValidationError = {};
	        if (address) {
	            addressValidationError = address.validationError;
	        }
	        return _.extend({}, this.validationError, addressValidationError);
	    }
	}, {
	    fetchById: function fetchById(id) {
	        return new Parse.Query('CompanyLocation').include('address').include('company').get(id);
	    },
	
	    fetchForCompany: function fetchForCompany(company) {
	        return new Parse.Query('CompanyLocation').equalTo('company', company).include('company').include('address').first();
	    },
	
	    fetchAllForCompany: function fetchAllForCompany(company) {
	        return new Parse.Query('CompanyLocation').equalTo('company', company);
	    },
	
	    fetchPrimaryForCompany: function fetchPrimaryForCompany(company) {
	        return new Parse.Query('CompanyLocation').equalTo('company', company).equalTo('primary', true).include('company').include('address').first();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(650)))

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var _Subscription = __webpack_require__(1082);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _tooltip = __webpack_require__(541);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Backbone.View.extend({
	    events: {
	        'click .js-online-payment': 'onlinePayment'
	    },
	
	    render: function render() {
	        this.$el.html((0, _Subscription2.default)({
	            model: this.model,
	            collection: this.collection
	        }));
	
	        if (this.collection.length) {
	            this.$('.js-empty').hide();
	        } else {
	            this.$('.js-table-invoices').hide();
	        }
	
	        _tooltip2.default.init(this);
	    },
	
	    onlinePayment: function onlinePayment(e) {
	        e.preventDefault();
	
	        var invoiceId = $(e.currentTarget).data('id');
	        var invoice = this.collection.find(function (i) {
	            return i.id === invoiceId;
	        });
	
	        if (!invoice) {
	            return false;
	        }
	
	        this.model.onlinePayment(invoiceId).then(function (response) {
	            window.location.replace(response.result.url);
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/mpp/templates/Subscription.ejs -->\n<div class="wrapper wrapper-content wrapper-tabs wrapper-settings">\n    <h2>MPP Subscription</h2>\n\n    <h3>Invoices</h3>\n    <div>\n        <h2 class="text-center js-empty">\n            You don\'t have any invoices yet\n        </h2>\n        <table class="table table-striped table-settings js-table-invoices">\n            <thead>\n                <tr>\n                    <th width="10%">Date</th>\n                    <th>Description</th>\n                    <th width="10%">Amount</th>\n                    <th width="10%">Invoice</th>\n                    <th width="10%">Status</th>\n                    <th width="10%">\n                        Payment\n                        <i class="fa fa-question-circle" data-toggle="tooltip"\n                            data-placement="top" data-container="body" data-html="true"\n                            title="Invoices can be paid online">\n                        </i>\n                    </th>\n                </tr>\n            </thead>\n            <tbody>\n                ';
	 _(collection).each(function(invoice) { 
	__p+='\n                    <tr>\n                        <td>\n                            '+
	((__t=( invoice.date ))==null?'':_.escape(__t))+
	'\n                        </td>\n\n                        <td>\n                            '+
	((__t=( invoice.description ))==null?'':_.escape(__t))+
	'\n                        </td>\n\n                        <td>\n                            RM '+
	((__t=( invoice.amount ))==null?'':_.escape(__t))+
	'\n                        </td>\n\n                        <td>\n                            <a href="'+
	((__t=( model.invoiceDownloadUrl(invoice.id) ))==null?'':_.escape(__t))+
	'"\n                               role="button"\n                               data-id="'+
	((__t=( invoice.id ))==null?'':_.escape(__t))+
	'"\n                               >\n                                <i class="fa fa-2x fa-file-pdf-o" aria-hidden="true"></i>\n                                '+
	((__t=( invoice.id ))==null?'':_.escape(__t))+
	'\n                            </a>\n                        </td>\n\n                        <td>\n                            ';
	 if (invoice.status === 'Payment due') { 
	__p+='\n                                <div class="status payment-due">\n                                    Payment Due\n                                </div>\n                            ';
	 } else if (invoice.status === 'Not paid') { 
	__p+='\n                                <div class="status not-paid">\n                                    Not Paid\n                                </div>\n                            ';
	 } else if (invoice.status === 'Voided') { 
	__p+='\n                                <div class="status voided">\n                                    Voided\n                                </div>\n                            ';
	 } else { 
	__p+='\n                                <div class="status paid">\n                                    Paid\n                                </div>\n                            ';
	 } 
	__p+='\n                        </td>\n\n                        <td>\n                            ';
	 if (invoice.status === 'Payment due' || invoice.status === 'Not paid') { 
	__p+='\n                                <button href="#" class="btn btn-sm btn-primary js-online-payment" data-id="'+
	((__t=( invoice.id ))==null?'':_.escape(__t))+
	'">\n                                    Pay Online\n                                </button>\n                            ';
	 } else if (invoice.status === 'Voided') { 
	__p+='\n                                <span>\n                                    '+
	((__t=( invoice.voidedDate ))==null?'':_.escape(__t))+
	'\n                                </span>\n                            ';
	 } else { 
	__p+='\n                                <span>\n                                    '+
	((__t=( invoice.paymentDate ))==null?'':_.escape(__t))+
	'\n                                </span>\n                            ';
	 } 
	__p+='\n                        </td>\n                    </tr>\n                ';
	 }); 
	__p+='\n            </tbody>\n        </table>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var numeral = __webpack_require__(1084);
	
	Number.prototype.format = function (format) {
	    return numeral(this).format(format || '0,0.00');
	};
	
	module.exports = {};

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 1.5.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function() {
	
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        VERSION = '1.5.6',
	        // internal storage for language config files
	        languages = {},
	        defaults = {
	            currentLanguage: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0'
	        },
	        options = {
	            currentLanguage: defaults.currentLanguage,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat
	        },
	        byteSuffixes = {
	            bytes: ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            iec: ['B','KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	
	    // Numeral prototype object
	    function Numeral(number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed (value, maxDecimals, roundingFunction, optionals) {
	        var splitValue = value.toString().split('.'),
	            minDecimals = maxDecimals - (optionals || 0),
	            boundedPrecision,
	            optionalsRegExp,
	            power,
	            output;
	
	        // Use the smallest precision value possible to avoid errors from floating point representation
	        if (splitValue.length === 2) {
	          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	        } else {
	          boundedPrecision = minDecimals;
	        }
	
	        power = Math.pow(10, boundedPrecision);
	
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	        if (optionals > maxDecimals - boundedPrecision) {
	            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral(n, format, roundingFunction) {
	        var output;
	
	        if (n._value === 0 && options.zeroFormat !== null) {
	            output = options.zeroFormat;
	        } else if (n._value === null && options.nullFormat !== null) {
	            output = options.nullFormat;
	        } else {
	            // figure out what kind of format we are dealing with
	            if (format.indexOf('$') > -1) {
	                output = formatCurrency(n, format, roundingFunction);
	            } else if (format.indexOf('%') > -1) {
	                output = formatPercentage(n, format, roundingFunction);
	            } else if (format.indexOf(':') > -1) {
	                output = formatTime(n, format);
	            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
	                output = formatBytes(n, format, roundingFunction);
	            } else if (format.indexOf('o') > -1) {
	                output = formatOrdinal(n, format, roundingFunction);
	            } else {
	                output = formatNumber(n._value, format, roundingFunction);
	            }
	        }
	
	        return output;
	    }
	
	    function formatCurrency(n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction, false);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[options.currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[options.currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatBytes(n, format, roundingFunction) {
	        var output,
	            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
	            value = n._value,
	            suffix = '',
	            power,
	            min,
	            max;
	
	        // check for space before
	        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
	            suffix = ' ';
	            format = format.replace(' ib', '').replace(' b', '');
	        } else {
	            format = format.replace('ib', '').replace('b', '');
	        }
	
	        for (power = 0; power <= suffixes.length; power++) {
	            min = Math.pow(1024, power);
	            max = Math.pow(1024, power + 1);
	
	            if (value === null || value === 0 || value >= min && value < max) {
	                suffix += suffixes[power];
	
	                if (min > 0) {
	                    value = value / min;
	                }
	
	                break;
	            }
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        return output + suffix;
	    }
	
	    function formatOrdinal(n, format, roundingFunction) {
	        var output,
	            ordinal = '';
	
	        // check for space before
	        if (format.indexOf(' o') > -1) {
	            ordinal = ' ';
	            format = format.replace(' o', '');
	        } else {
	            format = format.replace('o', '');
	        }
	
	        ordinal += languages[options.currentLanguage].ordinal(n._value);
	
	        output = formatNumber(n._value, format, roundingFunction);
	
	        return output + ordinal;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
	            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
	
	        return hours + ':' + ((minutes < 10) ? '0' + minutes : minutes) + ':' + ((seconds < 10) ? '0' + seconds : seconds);
	    }
	
	    function formatNumber(value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false, // force abbreviation to thousands
	            abbrM = false, // force abbreviation to millions
	            abbrB = false, // force abbreviation to billions
	            abbrT = false, // force abbreviation to trillions
	            abbrForce = false, // force abbreviation
	            abs,
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        if (value === null) {
	            value = 0;
	        }
	
	        abs = Math.abs(value);
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	            }
	
	            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
	
	            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                // trillion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
	                value = value / Math.pow(10, 12);
	            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                // billion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
	                value = value / Math.pow(10, 9);
	            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                // million
	                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
	                value = value / Math.pow(10, 6);
	            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                // thousand
	                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
	                value = value / Math.pow(10, 3);
	            }
	        }
	
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        w = value.toString().split('.')[0];
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            if (precision.indexOf('[') > -1) {
	                precision = precision.replace(']', '');
	                precision = precision.split('[');
	                d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	            } else {
	                d = toFixed(value, precision.length, roundingFunction);
	            }
	
	            w = d.split('.')[0];
	
	            if (d.indexOf('.') > -1) {
	                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, null, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        return ((negP && neg) ? '(' : '') + ((!negP && neg) ? '-' : '') + ((!neg && signed) ? '+' : '') + w + d + ((abbr) ? abbr : '') + ((negP && neg) ? ')' : '');
	    }
	
	
	    /************************************
	        Unformatting
	    ************************************/
	
	    // revert to number
	    function unformatNumeral(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power,
	            value;
	
	        if (string.indexOf(':') > -1) {
	            value = unformatTime(string);
	        } else {
	            if (string === options.zeroFormat || string === options.nullFormat) {
	                value = 0;
	            } else {
	                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
	                    bytesMultiplier = ((string.indexOf(byteSuffixes.bytes[power]) > -1) || (string.indexOf(byteSuffixes.iec[power]) > -1))? Math.pow(1024, power) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                value = bytesMultiplier ? bytesMultiplier : 1;
	                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
	                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
	                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
	                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
	                // check for percentage
	                value *= string.indexOf('%') > -1 ? 0.01 : 1;
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	                // remove non numbers
	                value *= Number(string.replace(/[^0-9\.]+/g, ''));
	                // round if we are talking about bytes
	                value = bytesMultiplier ? Math.ceil(value) : value;
	            }
	        }
	
	        n._value = value;
	
	        return n._value;
	    }
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	            // minutes
	            seconds = seconds + (Number(timeArray[1]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + (Number(timeArray[0]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    numeral = function(input) {
	        if (numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (input === null) {
	            input = null;
	        } else if (!Number(input)) {
	            input = numeral.fn.unformat(input);
	        } else {
	            input = Number(input);
	        }
	
	        return new Numeral(input);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    numeral.language = function(key, values) {
	        if (!key) {
	            return options.currentLanguage;
	        }
	
	        key = key.toLowerCase();
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	
	            options.currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return numeral;
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    numeral.languageData = function(key) {
	        if (!key) {
	            return languages[options.currentLanguage];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            languageData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if ( !! val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.languageData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current language
	            languageData = numeral.languageData(culture);
	        } catch (e) {
	            languageData = numeral.languageData(numeral.language());
	        }
	
	        //setup the delimiters and currency symbol based on culture/language
	        _currSymbol = languageData.currency.symbol;
	        _abbrObj = languageData.abbreviations;
	        _decimalSep = languageData.delimiters.decimal;
	        if (languageData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = languageData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	    // Reference: http://es5.github.io/#x15.4.4.21
	    if (!Array.prototype.reduce) {
	        Array.prototype.reduce = function(callback /*, initialValue*/) {
	            'use strict';
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(this), len = t.length >>> 0, k = 0, value;
	
	            if (arguments.length === 2) {
	                value = arguments[1];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        };
	    }
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function(prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	
	    numeral.fn = Numeral.prototype = {
	
	        clone: function() {
	            return numeral(this);
	        },
	
	        format: function (inputString, roundingFunction) {
	            return formatNumeral(this,
	                inputString ? inputString : options.defaultFormat,
	                roundingFunction !== undefined ? roundingFunction : Math.round
	            );
	        },
	
	        unformat: function (inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') {
	                return inputString;
	            }
	
	            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
	        },
	
	        value: function() {
	            return this._value;
	        },
	
	        valueOf: function() {
	            return this._value;
	        },
	
	        set: function(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) * (curr * corrFactor) /
	                    (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(this);


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {'use strict';
	
	var template = __webpack_require__(1086);
	
	module.exports = Backbone.View.extend({
	    // Instead of generating a new element, bind to the existing skeleton of
	    // the App already present in the HTML.
	    el: $('body'),
	
	    initialize: function initialize() {
	        this.render();
	
	        $(window).on('resize', function () {
	            $('body').toggleClass('mini-navbar', $(this).width() < 1200);
	        });
	
	        $(document).on('keydown', function (e) {
	            if (e.which === 8 && !$(e.target).is('input:not([readonly])' + ':not([type=radio]):not([type=checkbox]), textarea, ' + '[contentEditable], [contentEditable=true]')) {
	                e.preventDefault();
	            }
	        });
	
	        return this;
	    },
	
	    render: function render() {
	        this.$el.append(template());
	
	        $(window).trigger('resize');
	
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523), __webpack_require__(14)))

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- src/app/templates/App.html -->\n<div id="payrollpandaapp">\n\n    <div class="content"></div>\n\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _collection = __webpack_require__(564);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _bank = __webpack_require__(1088);
	
	var _bank2 = _interopRequireDefault(_bank);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banks = function (_Collection) {
	    _inherits(Banks, _Collection);
	
	    function Banks() {
	        _classCallCheck(this, Banks);
	
	        return _possibleConstructorReturn(this, (Banks.__proto__ || Object.getPrototypeOf(Banks)).apply(this, arguments));
	    }
	
	    _createClass(Banks, [{
	        key: 'url',
	        value: function url() {
	            return '/Banks';
	        }
	    }, {
	        key: 'initialize',
	        value: function initialize() {
	            _get(Banks.prototype.__proto__ || Object.getPrototypeOf(Banks.prototype), 'initialize', this).apply(this, arguments);
	            this.model = _bank2.default;
	            this.pagination = false;
	            return this;
	        }
	    }]);
	
	    return Banks;
	}(_collection2.default);
	
	exports.default = Banks;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(558);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bank = function (_Model) {
	    _inherits(Bank, _Model);
	
	    _createClass(Bank, [{
	        key: 'urlRoot',
	        value: function urlRoot() {
	            return '/Banks';
	        }
	    }]);
	
	    function Bank() {
	        _classCallCheck(this, Bank);
	
	        var _this = _possibleConstructorReturn(this, (Bank.__proto__ || Object.getPrototypeOf(Bank)).apply(this, arguments));
	
	        _this.softDelete = false;
	        return _this;
	    }
	
	    _createClass(Bank, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.idAttribute = 'objectId';
	            return _get(Bank.prototype.__proto__ || Object.getPrototypeOf(Bank.prototype), 'initialize', this).apply(this, arguments);
	        }
	    }]);
	
	    return Bank;
	}(_model2.default);
	
	exports.default = Bank;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1090);
	moment.tz.load(__webpack_require__(1091));


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.34
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(101)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(101)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.34",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * metismenu - v2.7.4
	 * A jQuery menu plugin
	 * https://github.com/onokumus/metismenu#readme
	 *
	 * Made by Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)
	 * Under MIT License
	 */
	
	(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(require('jquery'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(global.jQuery);
	    global.metisMenu = mod.exports;
	  }
	})(this, function (_jquery) {
	  'use strict';
	
	  var _jquery2 = _interopRequireDefault(_jquery);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  var Util = function ($) {
	    var transition = false;
	
	    function getSpecialTransitionEndEvent() {
	      return {
	        bindType: transition.end,
	        delegateType: transition.end,
	        handle: function handle(event) {
	          if ($(event.target).is(this)) {
	            return event.handleObj.handler.apply(this, arguments);
	          }
	          return undefined;
	        }
	      };
	    }
	
	    function transitionEndTest() {
	      if (typeof window !== 'undefined' && window.QUnit) {
	        return false;
	      }
	
	      return {
	        end: 'transitionend'
	      };
	    }
	
	    function transitionEndEmulator(duration) {
	      var _this2 = this;
	
	      var called = false;
	
	      $(this).one(Util.TRANSITION_END, function () {
	        called = true;
	      });
	
	      setTimeout(function () {
	        if (!called) {
	          Util.triggerTransitionEnd(_this2);
	        }
	      }, duration);
	
	      return this;
	    }
	
	    function setTransitionEndSupport() {
	      transition = transitionEndTest();
	      $.fn.mmEmulateTransitionEnd = transitionEndEmulator;
	
	      if (Util.supportsTransitionEnd()) {
	        $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
	      }
	    }
	
	    var Util = {
	      TRANSITION_END: 'mmTransitionEnd',
	
	      triggerTransitionEnd: function triggerTransitionEnd(element) {
	        $(element).trigger(transition.end);
	      },
	      supportsTransitionEnd: function supportsTransitionEnd() {
	        return Boolean(transition);
	      }
	    };
	
	    setTransitionEndSupport();
	
	    return Util;
	  }(_jquery2.default);
	
	  var MetisMenu = function ($) {
	
	    var NAME = 'metisMenu';
	    var DATA_KEY = 'metisMenu';
	    var EVENT_KEY = '.' + DATA_KEY;
	    var DATA_API_KEY = '.data-api';
	    var JQUERY_NO_CONFLICT = $.fn[NAME];
	    var TRANSITION_DURATION = 350;
	
	    var Default = {
	      toggle: true,
	      preventDefault: true,
	      activeClass: 'active',
	      collapseClass: 'collapse',
	      collapseInClass: 'in',
	      collapsingClass: 'collapsing',
	      triggerElement: 'a',
	      parentTrigger: 'li',
	      subMenu: 'ul'
	    };
	
	    var Event = {
	      SHOW: 'show' + EVENT_KEY,
	      SHOWN: 'shown' + EVENT_KEY,
	      HIDE: 'hide' + EVENT_KEY,
	      HIDDEN: 'hidden' + EVENT_KEY,
	      CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	    };
	
	    var MetisMenu = function () {
	      function MetisMenu(element, config) {
	        _classCallCheck(this, MetisMenu);
	
	        this._element = element;
	        this._config = this._getConfig(config);
	        this._transitioning = null;
	
	        this.init();
	      }
	
	      _createClass(MetisMenu, [{
	        key: 'init',
	        value: function init() {
	          var self = this;
	          $(this._element).find(this._config.parentTrigger + '.' + this._config.activeClass).has(this._config.subMenu).children(this._config.subMenu).attr('aria-expanded', true).addClass(this._config.collapseClass + ' ' + this._config.collapseInClass);
	
	          $(this._element).find(this._config.parentTrigger).not('.' + this._config.activeClass).has(this._config.subMenu).children(this._config.subMenu).attr('aria-expanded', false).addClass(this._config.collapseClass);
	
	          $(this._element).find(this._config.parentTrigger).has(this._config.subMenu).children(this._config.triggerElement).on(Event.CLICK_DATA_API, function (e) {
	            var _this = $(this);
	            var _parent = _this.parent(self._config.parentTrigger);
	            var _siblings = _parent.siblings(self._config.parentTrigger).children(self._config.triggerElement);
	            var _list = _parent.children(self._config.subMenu);
	            if (self._config.preventDefault) {
	              e.preventDefault();
	            }
	            if (_this.attr('aria-disabled') === 'true') {
	              return;
	            }
	            if (_parent.hasClass(self._config.activeClass)) {
	              _this.attr('aria-expanded', false);
	              self._hide(_list);
	            } else {
	              self._show(_list);
	              _this.attr('aria-expanded', true);
	              if (self._config.toggle) {
	                _siblings.attr('aria-expanded', false);
	              }
	            }
	
	            if (self._config.onTransitionStart) {
	              self._config.onTransitionStart(e);
	            }
	          });
	        }
	      }, {
	        key: '_show',
	        value: function _show(element) {
	          if (this._transitioning || $(element).hasClass(this._config.collapsingClass)) {
	            return;
	          }
	          var _this = this;
	          var _el = $(element);
	
	          var startEvent = $.Event(Event.SHOW);
	          _el.trigger(startEvent);
	
	          if (startEvent.isDefaultPrevented()) {
	            return;
	          }
	
	          _el.parent(this._config.parentTrigger).addClass(this._config.activeClass);
	
	          if (this._config.toggle) {
	            this._hide(_el.parent(this._config.parentTrigger).siblings().children(this._config.subMenu + '.' + this._config.collapseInClass).attr('aria-expanded', false));
	          }
	
	          _el.removeClass(this._config.collapseClass).addClass(this._config.collapsingClass).height(0);
	
	          this.setTransitioning(true);
	
	          var complete = function complete() {
	            // check if disposed
	            if (!_this._config || !_this._element) {
	              return;
	            }
	            _el.removeClass(_this._config.collapsingClass).addClass(_this._config.collapseClass + ' ' + _this._config.collapseInClass).height('').attr('aria-expanded', true);
	
	            _this.setTransitioning(false);
	
	            _el.trigger(Event.SHOWN);
	          };
	
	          if (!Util.supportsTransitionEnd()) {
	            complete();
	            return;
	          }
	
	          _el.height(_el[0].scrollHeight).one(Util.TRANSITION_END, complete).mmEmulateTransitionEnd(TRANSITION_DURATION);
	        }
	      }, {
	        key: '_hide',
	        value: function _hide(element) {
	
	          if (this._transitioning || !$(element).hasClass(this._config.collapseInClass)) {
	            return;
	          }
	          var _this = this;
	          var _el = $(element);
	
	          var startEvent = $.Event(Event.HIDE);
	          _el.trigger(startEvent);
	
	          if (startEvent.isDefaultPrevented()) {
	            return;
	          }
	
	          _el.parent(this._config.parentTrigger).removeClass(this._config.activeClass);
	          _el.height(_el.height())[0].offsetHeight;
	
	          _el.addClass(this._config.collapsingClass).removeClass(this._config.collapseClass).removeClass(this._config.collapseInClass);
	
	          this.setTransitioning(true);
	
	          var complete = function complete() {
	            // check if disposed
	            if (!_this._config || !_this._element) {
	              return;
	            }
	            if (_this._transitioning && _this._config.onTransitionEnd) {
	              _this._config.onTransitionEnd();
	            }
	
	            _this.setTransitioning(false);
	            _el.trigger(Event.HIDDEN);
	
	            _el.removeClass(_this._config.collapsingClass).addClass(_this._config.collapseClass).attr('aria-expanded', false);
	          };
	
	          if (!Util.supportsTransitionEnd()) {
	            complete();
	            return;
	          }
	
	          _el.height() == 0 || _el.css('display') == 'none' ? complete() : _el.height(0).one(Util.TRANSITION_END, complete).mmEmulateTransitionEnd(TRANSITION_DURATION);
	        }
	      }, {
	        key: 'setTransitioning',
	        value: function setTransitioning(isTransitioning) {
	          this._transitioning = isTransitioning;
	        }
	      }, {
	        key: 'dispose',
	        value: function dispose() {
	          $.removeData(this._element, DATA_KEY);
	
	          $(this._element).find(this._config.parentTrigger).has(this._config.subMenu).children(this._config.triggerElement).off('click');
	
	          this._transitioning = null;
	          this._config = null;
	          this._element = null;
	        }
	      }, {
	        key: '_getConfig',
	        value: function _getConfig(config) {
	          config = $.extend({}, Default, config);
	          return config;
	        }
	      }], [{
	        key: '_jQueryInterface',
	        value: function _jQueryInterface(config) {
	          return this.each(function () {
	            var $this = $(this);
	            var data = $this.data(DATA_KEY);
	            var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);
	
	            if (!data && /dispose/.test(config)) {
	              this.dispose();
	            }
	
	            if (!data) {
	              data = new MetisMenu(this, _config);
	              $this.data(DATA_KEY, data);
	            }
	
	            if (typeof config === 'string') {
	              if (data[config] === undefined) {
	                throw new Error('No method named "' + config + '"');
	              }
	              data[config]();
	            }
	          });
	        }
	      }]);
	
	      return MetisMenu;
	    }();
	
	    /**
	     * ------------------------------------------------------------------------
	     * jQuery
	     * ------------------------------------------------------------------------
	     */
	
	    $.fn[NAME] = MetisMenu._jQueryInterface;
	    $.fn[NAME].Constructor = MetisMenu;
	    $.fn[NAME].noConflict = function () {
	      $.fn[NAME] = JQUERY_NO_CONFLICT;
	      return MetisMenu._jQueryInterface;
	    };
	    return MetisMenu;
	  }(_jquery2.default);
	});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
	 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
	 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
	 *
	 * Version: 1.3.8
	 *
	 */
	(function($) {
	
	  $.fn.extend({
	    slimScroll: function(options) {
	
	      var defaults = {
	
	        // width in pixels of the visible scroll area
	        width : 'auto',
	
	        // height in pixels of the visible scroll area
	        height : '250px',
	
	        // width in pixels of the scrollbar and rail
	        size : '7px',
	
	        // scrollbar color, accepts any hex/color value
	        color: '#000',
	
	        // scrollbar position - left/right
	        position : 'right',
	
	        // distance in pixels between the side edge and the scrollbar
	        distance : '1px',
	
	        // default scroll position on load - top / bottom / $('selector')
	        start : 'top',
	
	        // sets scrollbar opacity
	        opacity : .4,
	
	        // enables always-on mode for the scrollbar
	        alwaysVisible : false,
	
	        // check if we should hide the scrollbar when user is hovering over
	        disableFadeOut : false,
	
	        // sets visibility of the rail
	        railVisible : false,
	
	        // sets rail color
	        railColor : '#333',
	
	        // sets rail opacity
	        railOpacity : .2,
	
	        // whether  we should use jQuery UI Draggable to enable bar dragging
	        railDraggable : true,
	
	        // defautlt CSS class of the slimscroll rail
	        railClass : 'slimScrollRail',
	
	        // defautlt CSS class of the slimscroll bar
	        barClass : 'slimScrollBar',
	
	        // defautlt CSS class of the slimscroll wrapper
	        wrapperClass : 'slimScrollDiv',
	
	        // check if mousewheel should scroll the window if we reach top/bottom
	        allowPageScroll : false,
	
	        // scroll amount applied to each mouse wheel step
	        wheelStep : 20,
	
	        // scroll amount applied when user is using gestures
	        touchScrollStep : 200,
	
	        // sets border radius
	        borderRadius: '7px',
	
	        // sets border radius of the rail
	        railBorderRadius : '7px'
	      };
	
	      var o = $.extend(defaults, options);
	
	      // do it for every element that matches selector
	      this.each(function(){
	
	      var isOverPanel, isOverBar, isDragg, queueHide, touchDif,
	        barHeight, percentScroll, lastScroll,
	        divS = '<div></div>',
	        minBarHeight = 30,
	        releaseScroll = false;
	
	        // used in event handlers and for better minification
	        var me = $(this);
	
	        // ensure we are not binding it again
	        if (me.parent().hasClass(o.wrapperClass))
	        {
	            // start from last bar position
	            var offset = me.scrollTop();
	
	            // find bar and rail
	            bar = me.siblings('.' + o.barClass);
	            rail = me.siblings('.' + o.railClass);
	
	            getBarHeight();
	
	            // check if we should scroll existing instance
	            if ($.isPlainObject(options))
	            {
	              // Pass height: auto to an existing slimscroll object to force a resize after contents have changed
	              if ( 'height' in options && options.height == 'auto' ) {
	                me.parent().css('height', 'auto');
	                me.css('height', 'auto');
	                var height = me.parent().parent().height();
	                me.parent().css('height', height);
	                me.css('height', height);
	              } else if ('height' in options) {
	                var h = options.height;
	                me.parent().css('height', h);
	                me.css('height', h);
	              }
	
	              if ('scrollTo' in options)
	              {
	                // jump to a static point
	                offset = parseInt(o.scrollTo);
	              }
	              else if ('scrollBy' in options)
	              {
	                // jump by value pixels
	                offset += parseInt(o.scrollBy);
	              }
	              else if ('destroy' in options)
	              {
	                // remove slimscroll elements
	                bar.remove();
	                rail.remove();
	                me.unwrap();
	                return;
	              }
	
	              // scroll content by the given offset
	              scrollContent(offset, false, true);
	            }
	
	            return;
	        }
	        else if ($.isPlainObject(options))
	        {
	            if ('destroy' in options)
	            {
	            	return;
	            }
	        }
	
	        // optionally set height to the parent's height
	        o.height = (o.height == 'auto') ? me.parent().height() : o.height;
	
	        // wrap content
	        var wrapper = $(divS)
	          .addClass(o.wrapperClass)
	          .css({
	            position: 'relative',
	            overflow: 'hidden',
	            width: o.width,
	            height: o.height
	          });
	
	        // update style for the div
	        me.css({
	          overflow: 'hidden',
	          width: o.width,
	          height: o.height
	        });
	
	        // create scrollbar rail
	        var rail = $(divS)
	          .addClass(o.railClass)
	          .css({
	            width: o.size,
	            height: '100%',
	            position: 'absolute',
	            top: 0,
	            display: (o.alwaysVisible && o.railVisible) ? 'block' : 'none',
	            'border-radius': o.railBorderRadius,
	            background: o.railColor,
	            opacity: o.railOpacity,
	            zIndex: 90
	          });
	
	        // create scrollbar
	        var bar = $(divS)
	          .addClass(o.barClass)
	          .css({
	            background: o.color,
	            width: o.size,
	            position: 'absolute',
	            top: 0,
	            opacity: o.opacity,
	            display: o.alwaysVisible ? 'block' : 'none',
	            'border-radius' : o.borderRadius,
	            BorderRadius: o.borderRadius,
	            MozBorderRadius: o.borderRadius,
	            WebkitBorderRadius: o.borderRadius,
	            zIndex: 99
	          });
	
	        // set position
	        var posCss = (o.position == 'right') ? { right: o.distance } : { left: o.distance };
	        rail.css(posCss);
	        bar.css(posCss);
	
	        // wrap it
	        me.wrap(wrapper);
	
	        // append to parent div
	        me.parent().append(bar);
	        me.parent().append(rail);
	
	        // make it draggable and no longer dependent on the jqueryUI
	        if (o.railDraggable){
	          bar.bind("mousedown", function(e) {
	            var $doc = $(document);
	            isDragg = true;
	            t = parseFloat(bar.css('top'));
	            pageY = e.pageY;
	
	            $doc.bind("mousemove.slimscroll", function(e){
	              currTop = t + e.pageY - pageY;
	              bar.css('top', currTop);
	              scrollContent(0, bar.position().top, false);// scroll content
	            });
	
	            $doc.bind("mouseup.slimscroll", function(e) {
	              isDragg = false;hideBar();
	              $doc.unbind('.slimscroll');
	            });
	            return false;
	          }).bind("selectstart.slimscroll", function(e){
	            e.stopPropagation();
	            e.preventDefault();
	            return false;
	          });
	        }
	
	        // on rail over
	        rail.hover(function(){
	          showBar();
	        }, function(){
	          hideBar();
	        });
	
	        // on bar over
	        bar.hover(function(){
	          isOverBar = true;
	        }, function(){
	          isOverBar = false;
	        });
	
	        // show on parent mouseover
	        me.hover(function(){
	          isOverPanel = true;
	          showBar();
	          hideBar();
	        }, function(){
	          isOverPanel = false;
	          hideBar();
	        });
	
	        // support for mobile
	        me.bind('touchstart', function(e,b){
	          if (e.originalEvent.touches.length)
	          {
	            // record where touch started
	            touchDif = e.originalEvent.touches[0].pageY;
	          }
	        });
	
	        me.bind('touchmove', function(e){
	          // prevent scrolling the page if necessary
	          if(!releaseScroll)
	          {
	  		      e.originalEvent.preventDefault();
			      }
	          if (e.originalEvent.touches.length)
	          {
	            // see how far user swiped
	            var diff = (touchDif - e.originalEvent.touches[0].pageY) / o.touchScrollStep;
	            // scroll content
	            scrollContent(diff, true);
	            touchDif = e.originalEvent.touches[0].pageY;
	          }
	        });
	
	        // set up initial height
	        getBarHeight();
	
	        // check start position
	        if (o.start === 'bottom')
	        {
	          // scroll content to bottom
	          bar.css({ top: me.outerHeight() - bar.outerHeight() });
	          scrollContent(0, true);
	        }
	        else if (o.start !== 'top')
	        {
	          // assume jQuery selector
	          scrollContent($(o.start).position().top, null, true);
	
	          // make sure bar stays hidden
	          if (!o.alwaysVisible) { bar.hide(); }
	        }
	
	        // attach scroll events
	        attachWheel(this);
	
	        function _onWheel(e)
	        {
	          // use mouse wheel only when mouse is over
	          if (!isOverPanel) { return; }
	
	          var e = e || window.event;
	
	          var delta = 0;
	          if (e.wheelDelta) { delta = -e.wheelDelta/120; }
	          if (e.detail) { delta = e.detail / 3; }
	
	          var target = e.target || e.srcTarget || e.srcElement;
	          if ($(target).closest('.' + o.wrapperClass).is(me.parent())) {
	            // scroll content
	            scrollContent(delta, true);
	          }
	
	          // stop window scroll
	          if (e.preventDefault && !releaseScroll) { e.preventDefault(); }
	          if (!releaseScroll) { e.returnValue = false; }
	        }
	
	        function scrollContent(y, isWheel, isJump)
	        {
	          releaseScroll = false;
	          var delta = y;
	          var maxTop = me.outerHeight() - bar.outerHeight();
	
	          if (isWheel)
	          {
	            // move bar with mouse wheel
	            delta = parseInt(bar.css('top')) + y * parseInt(o.wheelStep) / 100 * bar.outerHeight();
	
	            // move bar, make sure it doesn't go out
	            delta = Math.min(Math.max(delta, 0), maxTop);
	
	            // if scrolling down, make sure a fractional change to the
	            // scroll position isn't rounded away when the scrollbar's CSS is set
	            // this flooring of delta would happened automatically when
	            // bar.css is set below, but we floor here for clarity
	            delta = (y > 0) ? Math.ceil(delta) : Math.floor(delta);
	
	            // scroll the scrollbar
	            bar.css({ top: delta + 'px' });
	          }
	
	          // calculate actual scroll amount
	          percentScroll = parseInt(bar.css('top')) / (me.outerHeight() - bar.outerHeight());
	          delta = percentScroll * (me[0].scrollHeight - me.outerHeight());
	
	          if (isJump)
	          {
	            delta = y;
	            var offsetTop = delta / me[0].scrollHeight * me.outerHeight();
	            offsetTop = Math.min(Math.max(offsetTop, 0), maxTop);
	            bar.css({ top: offsetTop + 'px' });
	          }
	
	          // scroll content
	          me.scrollTop(delta);
	
	          // fire scrolling event
	          me.trigger('slimscrolling', ~~delta);
	
	          // ensure bar is visible
	          showBar();
	
	          // trigger hide when scroll is stopped
	          hideBar();
	        }
	
	        function attachWheel(target)
	        {
	          if (window.addEventListener)
	          {
	            target.addEventListener('DOMMouseScroll', _onWheel, false );
	            target.addEventListener('mousewheel', _onWheel, false );
	          }
	          else
	          {
	            document.attachEvent("onmousewheel", _onWheel)
	          }
	        }
	
	        function getBarHeight()
	        {
	          // calculate scrollbar height and make sure it is not too small
	          barHeight = Math.max((me.outerHeight() / me[0].scrollHeight) * me.outerHeight(), minBarHeight);
	          bar.css({ height: barHeight + 'px' });
	
	          // hide scrollbar if content is not long enough
	          var display = barHeight == me.outerHeight() ? 'none' : 'block';
	          bar.css({ display: display });
	        }
	
	        function showBar()
	        {
	          // recalculate bar height
	          getBarHeight();
	          clearTimeout(queueHide);
	
	          // when bar reached top or bottom
	          if (percentScroll == ~~percentScroll)
	          {
	            //release wheel
	            releaseScroll = o.allowPageScroll;
	
	            // publish approporiate event
	            if (lastScroll != percentScroll)
	            {
	                var msg = (~~percentScroll == 0) ? 'top' : 'bottom';
	                me.trigger('slimscroll', msg);
	            }
	          }
	          else
	          {
	            releaseScroll = false;
	          }
	          lastScroll = percentScroll;
	
	          // show only when required
	          if(barHeight >= me.outerHeight()) {
	            //allow window scroll
	            releaseScroll = true;
	            return;
	          }
	          bar.stop(true,true).fadeIn('fast');
	          if (o.railVisible) { rail.stop(true,true).fadeIn('fast'); }
	        }
	
	        function hideBar()
	        {
	          // only hide when options allow it
	          if (!o.alwaysVisible)
	          {
	            queueHide = setTimeout(function(){
	              if (!(o.disableFadeOut && isOverPanel) && !isOverBar && !isDragg)
	              {
	                bar.fadeOut('slow');
	                rail.fadeOut('slow');
	              }
	            }, 1000);
	          }
	        }
	
	      });
	
	      // maintain chainability
	      return this;
	    }
	  });
	
	  $.fn.extend({
	    slimscroll: $.fn.slimScroll
	  });
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.6.0
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
	                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div aria-live="polite" class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 1) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 1) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick',
	                '*:not(.slick-arrow)', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this;
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        _.$slideTrack.attr('role', 'listbox');
	
	        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	            $(this).attr({
	                'role': 'option',
	                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
	            });
	        });
	
	        if (_.$dots !== null) {
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                $(this).attr({
	                    'role': 'presentation',
	                    'aria-selected': 'false',
	                    'aria-controls': 'navigation' + _.instanceUid + i + '',
	                    'id': 'slick-slide' + _.instanceUid + i + ''
	                });
	            })
	                .first().attr('aria-selected', 'true').end()
	                .find('button').attr('role', 'button').end()
	                .closest('div').attr('role', 'toolbar');
	        }
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	        }
	
	        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            _.setPosition();
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	
	                    _.$slides
	                        .slice(index - centerOffset, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand') {
	            _.lazyLoad();
	        }
	
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.setSlideClasses(index);
	            _.asNavFor(index);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = Math.round(Math.sqrt(
	                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (swipeDirection === 'vertical') {
	            return;
	        }
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                .removeClass('slick-active')
	                .attr('aria-hidden', 'true');
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active')
	                .attr('aria-hidden', 'false');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Datepicker for Bootstrap v1.6.4 (https://github.com/eternicode/bootstrap-datepicker)
	 *
	 * Copyright 2012 Stefan Petre
	 * Improvements by Andrew Rowls
	 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
	 */(function(factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	}(function($, undefined){
	
		function UTCDate(){
			return new Date(Date.UTC.apply(Date, arguments));
		}
		function UTCToday(){
			var today = new Date();
			return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
		}
		function isUTCEquals(date1, date2) {
			return (
				date1.getUTCFullYear() === date2.getUTCFullYear() &&
				date1.getUTCMonth() === date2.getUTCMonth() &&
				date1.getUTCDate() === date2.getUTCDate()
			);
		}
		function alias(method){
			return function(){
				return this[method].apply(this, arguments);
			};
		}
		function isValidDate(d) {
			return d && !isNaN(d.getTime());
		}
	
		var DateArray = (function(){
			var extras = {
				get: function(i){
					return this.slice(i)[0];
				},
				contains: function(d){
					// Array.indexOf is not cross-browser;
					// $.inArray doesn't work with Dates
					var val = d && d.valueOf();
					for (var i=0, l=this.length; i < l; i++)
						if (this[i].valueOf() === val)
							return i;
					return -1;
				},
				remove: function(i){
					this.splice(i,1);
				},
				replace: function(new_array){
					if (!new_array)
						return;
					if (!$.isArray(new_array))
						new_array = [new_array];
					this.clear();
					this.push.apply(this, new_array);
				},
				clear: function(){
					this.length = 0;
				},
				copy: function(){
					var a = new DateArray();
					a.replace(this);
					return a;
				}
			};
	
			return function(){
				var a = [];
				a.push.apply(a, arguments);
				$.extend(a, extras);
				return a;
			};
		})();
	
	
		// Picker object
	
		var Datepicker = function(element, options){
			$(element).data('datepicker', this);
			this._process_options(options);
	
			this.dates = new DateArray();
			this.viewDate = this.o.defaultViewDate;
			this.focusDate = null;
	
			this.element = $(element);
			this.isInput = this.element.is('input');
			this.inputField = this.isInput ? this.element : this.element.find('input');
			this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
			this.hasInput = this.component && this.inputField.length;
			if (this.component && this.component.length === 0)
				this.component = false;
			this.isInline = !this.component && this.element.is('div');
	
			this.picker = $(DPGlobal.template);
	
			// Checking templates and inserting
			if (this._check_template(this.o.templates.leftArrow)) {
				this.picker.find('.prev').html(this.o.templates.leftArrow);
			}
			if (this._check_template(this.o.templates.rightArrow)) {
				this.picker.find('.next').html(this.o.templates.rightArrow);
			}
	
			this._buildEvents();
			this._attachEvents();
	
			if (this.isInline){
				this.picker.addClass('datepicker-inline').appendTo(this.element);
			}
			else {
				this.picker.addClass('datepicker-dropdown dropdown-menu');
			}
	
			if (this.o.rtl){
				this.picker.addClass('datepicker-rtl');
			}
	
			this.viewMode = this.o.startView;
	
			if (this.o.calendarWeeks)
				this.picker.find('thead .datepicker-title, tfoot .today, tfoot .clear')
							.attr('colspan', function(i, val){
								return parseInt(val) + 1;
							});
	
			this._allow_update = false;
	
			this.setStartDate(this._o.startDate);
			this.setEndDate(this._o.endDate);
			this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);
			this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted);
			this.setDatesDisabled(this.o.datesDisabled);
	
			this.fillDow();
			this.fillMonths();
	
			this._allow_update = true;
	
			this.update();
			this.showMode();
	
			if (this.isInline){
				this.show();
			}
		};
	
		Datepicker.prototype = {
			constructor: Datepicker,
	
			_resolveViewName: function(view, default_value){
				if (view === 0 || view === 'days' || view === 'month') {
					return 0;
				}
				if (view === 1 || view === 'months' || view === 'year') {
					return 1;
				}
				if (view === 2 || view === 'years' || view === 'decade') {
					return 2;
				}
				if (view === 3 || view === 'decades' || view === 'century') {
					return 3;
				}
				if (view === 4 || view === 'centuries' || view === 'millennium') {
					return 4;
				}
				return default_value === undefined ? false : default_value;
			},
	
			_check_template: function(tmp){
				try {
					// If empty
					if (tmp === undefined || tmp === "") {
						return false;
					}
					// If no html, everything ok
					if ((tmp.match(/[<>]/g) || []).length <= 0) {
						return true;
					}
					// Checking if html is fine
					var jDom = $(tmp);
					return jDom.length > 0;
				}
				catch (ex) {
					return false;
				}
			},
	
			_process_options: function(opts){
				// Store raw options for reference
				this._o = $.extend({}, this._o, opts);
				// Processed options
				var o = this.o = $.extend({}, this._o);
	
				// Check if "de-DE" style date is available, if not language should
				// fallback to 2 letter code eg "de"
				var lang = o.language;
				if (!dates[lang]){
					lang = lang.split('-')[0];
					if (!dates[lang])
						lang = defaults.language;
				}
				o.language = lang;
	
				// Retrieve view index from any aliases
				o.startView = this._resolveViewName(o.startView, 0);
				o.minViewMode = this._resolveViewName(o.minViewMode, 0);
				o.maxViewMode = this._resolveViewName(o.maxViewMode, 4);
	
				// Check that the start view is between min and max
				o.startView = Math.min(o.startView, o.maxViewMode);
				o.startView = Math.max(o.startView, o.minViewMode);
	
				// true, false, or Number > 0
				if (o.multidate !== true){
					o.multidate = Number(o.multidate) || false;
					if (o.multidate !== false)
						o.multidate = Math.max(0, o.multidate);
				}
				o.multidateSeparator = String(o.multidateSeparator);
	
				o.weekStart %= 7;
				o.weekEnd = (o.weekStart + 6) % 7;
	
				var format = DPGlobal.parseFormat(o.format);
				if (o.startDate !== -Infinity){
					if (!!o.startDate){
						if (o.startDate instanceof Date)
							o.startDate = this._local_to_utc(this._zero_time(o.startDate));
						else
							o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.startDate = -Infinity;
					}
				}
				if (o.endDate !== Infinity){
					if (!!o.endDate){
						if (o.endDate instanceof Date)
							o.endDate = this._local_to_utc(this._zero_time(o.endDate));
						else
							o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.endDate = Infinity;
					}
				}
	
				o.daysOfWeekDisabled = o.daysOfWeekDisabled||[];
				if (!$.isArray(o.daysOfWeekDisabled))
					o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
				o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function(d){
					return parseInt(d, 10);
				});
	
				o.daysOfWeekHighlighted = o.daysOfWeekHighlighted||[];
				if (!$.isArray(o.daysOfWeekHighlighted))
					o.daysOfWeekHighlighted = o.daysOfWeekHighlighted.split(/[,\s]*/);
				o.daysOfWeekHighlighted = $.map(o.daysOfWeekHighlighted, function(d){
					return parseInt(d, 10);
				});
	
				o.datesDisabled = o.datesDisabled||[];
				if (!$.isArray(o.datesDisabled)) {
					o.datesDisabled = [
						o.datesDisabled
					];
				}
				o.datesDisabled = $.map(o.datesDisabled,function(d){
					return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
				});
	
				var plc = String(o.orientation).toLowerCase().split(/\s+/g),
					_plc = o.orientation.toLowerCase();
				plc = $.grep(plc, function(word){
					return /^auto|left|right|top|bottom$/.test(word);
				});
				o.orientation = {x: 'auto', y: 'auto'};
				if (!_plc || _plc === 'auto')
					; // no action
				else if (plc.length === 1){
					switch (plc[0]){
						case 'top':
						case 'bottom':
							o.orientation.y = plc[0];
							break;
						case 'left':
						case 'right':
							o.orientation.x = plc[0];
							break;
					}
				}
				else {
					_plc = $.grep(plc, function(word){
						return /^left|right$/.test(word);
					});
					o.orientation.x = _plc[0] || 'auto';
	
					_plc = $.grep(plc, function(word){
						return /^top|bottom$/.test(word);
					});
					o.orientation.y = _plc[0] || 'auto';
				}
				if (o.defaultViewDate) {
					var year = o.defaultViewDate.year || new Date().getFullYear();
					var month = o.defaultViewDate.month || 0;
					var day = o.defaultViewDate.day || 1;
					o.defaultViewDate = UTCDate(year, month, day);
				} else {
					o.defaultViewDate = UTCToday();
				}
			},
			_events: [],
			_secondaryEvents: [],
			_applyEvents: function(evs){
				for (var i=0, el, ch, ev; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					}
					else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			},
			_unapplyEvents: function(evs){
				for (var i=0, el, ev, ch; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					}
					else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			},
			_buildEvents: function(){
	            var events = {
	                keyup: $.proxy(function(e){
	                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
	                        this.update();
	                }, this),
	                keydown: $.proxy(this.keydown, this),
	                paste: $.proxy(this.paste, this)
	            };
	
	            if (this.o.showOnFocus === true) {
	                events.focus = $.proxy(this.show, this);
	            }
	
	            if (this.isInput) { // single input
	                this._events = [
	                    [this.element, events]
	                ];
	            }
	            else if (this.component && this.hasInput) { // component: input + button
	                this._events = [
	                    // For components that are not readonly, allow keyboard nav
	                    [this.inputField, events],
	                    [this.component, {
	                        click: $.proxy(this.show, this)
	                    }]
	                ];
	            }
				else {
					this._events = [
						[this.element, {
							click: $.proxy(this.show, this),
							keydown: $.proxy(this.keydown, this)
						}]
					];
				}
				this._events.push(
					// Component: listen for blur on element descendants
					[this.element, '*', {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}],
					// Input: listen for blur on element
					[this.element, {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}]
				);
	
				if (this.o.immediateUpdates) {
					// Trigger input updates immediately on changed year/month
					this._events.push([this.element, {
						'changeYear changeMonth': $.proxy(function(e){
							this.update(e.date);
						}, this)
					}]);
				}
	
				this._secondaryEvents = [
					[this.picker, {
						click: $.proxy(this.click, this)
					}],
					[$(window), {
						resize: $.proxy(this.place, this)
					}],
					[$(document), {
						mousedown: $.proxy(function(e){
							// Clicked outside the datepicker, hide it
							if (!(
								this.element.is(e.target) ||
								this.element.find(e.target).length ||
								this.picker.is(e.target) ||
								this.picker.find(e.target).length ||
								this.isInline
							)){
								this.hide();
							}
						}, this)
					}]
				];
			},
			_attachEvents: function(){
				this._detachEvents();
				this._applyEvents(this._events);
			},
			_detachEvents: function(){
				this._unapplyEvents(this._events);
			},
			_attachSecondaryEvents: function(){
				this._detachSecondaryEvents();
				this._applyEvents(this._secondaryEvents);
			},
			_detachSecondaryEvents: function(){
				this._unapplyEvents(this._secondaryEvents);
			},
			_trigger: function(event, altdate){
				var date = altdate || this.dates.get(-1),
					local_date = this._utc_to_local(date);
	
				this.element.trigger({
					type: event,
					date: local_date,
					dates: $.map(this.dates, this._utc_to_local),
					format: $.proxy(function(ix, format){
						if (arguments.length === 0){
							ix = this.dates.length - 1;
							format = this.o.format;
						}
						else if (typeof ix === 'string'){
							format = ix;
							ix = this.dates.length - 1;
						}
						format = format || this.o.format;
						var date = this.dates.get(ix);
						return DPGlobal.formatDate(date, format, this.o.language);
					}, this)
				});
			},
	
			show: function(){
				if (this.inputField.prop('disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
					return;
				if (!this.isInline)
					this.picker.appendTo(this.o.container);
				this.place();
				this.picker.show();
				this._attachSecondaryEvents();
				this._trigger('show');
				if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
					$(this.element).blur();
				}
				return this;
			},
	
			hide: function(){
				if (this.isInline || !this.picker.is(':visible'))
					return this;
				this.focusDate = null;
				this.picker.hide().detach();
				this._detachSecondaryEvents();
				this.viewMode = this.o.startView;
				this.showMode();
	
				if (this.o.forceParse && this.inputField.val())
					this.setValue();
				this._trigger('hide');
				return this;
			},
	
			destroy: function(){
				this.hide();
				this._detachEvents();
				this._detachSecondaryEvents();
				this.picker.remove();
				delete this.element.data().datepicker;
				if (!this.isInput){
					delete this.element.data().date;
				}
				return this;
			},
	
			paste: function(evt){
				var dateString;
				if (evt.originalEvent.clipboardData && evt.originalEvent.clipboardData.types
					&& $.inArray('text/plain', evt.originalEvent.clipboardData.types) !== -1) {
					dateString = evt.originalEvent.clipboardData.getData('text/plain');
				}
				else if (window.clipboardData) {
					dateString = window.clipboardData.getData('Text');
				}
				else {
					return;
				}
				this.setDate(dateString);
				this.update();
				evt.preventDefault();
			},
	
			_utc_to_local: function(utc){
				return utc && new Date(utc.getTime() + (utc.getTimezoneOffset()*60000));
			},
			_local_to_utc: function(local){
				return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
			},
			_zero_time: function(local){
				return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
			},
			_zero_utc_time: function(utc){
				return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
			},
	
			getDates: function(){
				return $.map(this.dates, this._utc_to_local);
			},
	
			getUTCDates: function(){
				return $.map(this.dates, function(d){
					return new Date(d);
				});
			},
	
			getDate: function(){
				return this._utc_to_local(this.getUTCDate());
			},
	
			getUTCDate: function(){
				var selected_date = this.dates.get(-1);
				if (typeof selected_date !== 'undefined') {
					return new Date(selected_date);
				} else {
					return null;
				}
			},
	
			clearDates: function(){
				if (this.inputField) {
					this.inputField.val('');
				}
	
				this.update();
				this._trigger('changeDate');
	
				if (this.o.autoclose) {
					this.hide();
				}
			},
			setDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, args);
				this._trigger('changeDate');
				this.setValue();
				return this;
			},
	
			setUTCDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, $.map(args, this._utc_to_local));
				this._trigger('changeDate');
				this.setValue();
				return this;
			},
	
			setDate: alias('setDates'),
			setUTCDate: alias('setUTCDates'),
			remove: alias('destroy'),
	
			setValue: function(){
				var formatted = this.getFormattedDate();
				this.inputField.val(formatted);
				return this;
			},
	
			getFormattedDate: function(format){
				if (format === undefined)
					format = this.o.format;
	
				var lang = this.o.language;
				return $.map(this.dates, function(d){
					return DPGlobal.formatDate(d, format, lang);
				}).join(this.o.multidateSeparator);
			},
	
			getStartDate: function(){
				return this.o.startDate;
			},
	
			setStartDate: function(startDate){
				this._process_options({startDate: startDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			getEndDate: function(){
				return this.o.endDate;
			},
	
			setEndDate: function(endDate){
				this._process_options({endDate: endDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			setDaysOfWeekDisabled: function(daysOfWeekDisabled){
				this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			setDaysOfWeekHighlighted: function(daysOfWeekHighlighted){
				this._process_options({daysOfWeekHighlighted: daysOfWeekHighlighted});
				this.update();
				return this;
			},
	
			setDatesDisabled: function(datesDisabled){
				this._process_options({datesDisabled: datesDisabled});
				this.update();
				this.updateNavArrows();
			},
	
			place: function(){
				if (this.isInline)
					return this;
				var calendarWidth = this.picker.outerWidth(),
					calendarHeight = this.picker.outerHeight(),
					visualPadding = 10,
					container = $(this.o.container),
					windowWidth = container.width(),
					scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
					appendOffset = container.offset();
	
				var parentsZindex = [];
				this.element.parents().each(function(){
					var itemZIndex = $(this).css('z-index');
					if (itemZIndex !== 'auto' && itemZIndex !== 0) parentsZindex.push(parseInt(itemZIndex));
				});
				var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
				var offset = this.component ? this.component.parent().offset() : this.element.offset();
				var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
				var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
				var left = offset.left - appendOffset.left,
					top = offset.top - appendOffset.top;
	
				if (this.o.container !== 'body') {
					top += scrollTop;
				}
	
				this.picker.removeClass(
					'datepicker-orient-top datepicker-orient-bottom '+
					'datepicker-orient-right datepicker-orient-left'
				);
	
				if (this.o.orientation.x !== 'auto'){
					this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
					if (this.o.orientation.x === 'right')
						left -= calendarWidth - width;
				}
				// auto x orientation is best-placement: if it crosses a window
				// edge, fudge it sideways
				else {
					if (offset.left < 0) {
						// component is outside the window on the left side. Move it into visible range
						this.picker.addClass('datepicker-orient-left');
						left -= offset.left - visualPadding;
					} else if (left + calendarWidth > windowWidth) {
						// the calendar passes the widow right edge. Align it to component right side
						this.picker.addClass('datepicker-orient-right');
						left += width - calendarWidth;
					} else {
						// Default to left
						this.picker.addClass('datepicker-orient-left');
					}
				}
	
				// auto y orientation is best-situation: top or bottom, no fudging,
				// decision based on which shows more of the calendar
				var yorient = this.o.orientation.y,
					top_overflow;
				if (yorient === 'auto'){
					top_overflow = -scrollTop + top - calendarHeight;
					yorient = top_overflow < 0 ? 'bottom' : 'top';
				}
	
				this.picker.addClass('datepicker-orient-' + yorient);
				if (yorient === 'top')
					top -= calendarHeight + parseInt(this.picker.css('padding-top'));
				else
					top += height;
	
				if (this.o.rtl) {
					var right = windowWidth - (left + width);
					this.picker.css({
						top: top,
						right: right,
						zIndex: zIndex
					});
				} else {
					this.picker.css({
						top: top,
						left: left,
						zIndex: zIndex
					});
				}
				return this;
			},
	
			_allow_update: true,
			update: function(){
				if (!this._allow_update)
					return this;
	
				var oldDates = this.dates.copy(),
					dates = [],
					fromArgs = false;
				if (arguments.length){
					$.each(arguments, $.proxy(function(i, date){
						if (date instanceof Date)
							date = this._local_to_utc(date);
						dates.push(date);
					}, this));
					fromArgs = true;
				}
				else {
					dates = this.isInput
							? this.element.val()
							: this.element.data('date') || this.inputField.val();
					if (dates && this.o.multidate)
						dates = dates.split(this.o.multidateSeparator);
					else
						dates = [dates];
					delete this.element.data().date;
				}
	
				dates = $.map(dates, $.proxy(function(date){
					return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
				}, this));
				dates = $.grep(dates, $.proxy(function(date){
					return (
						!this.dateWithinRange(date) ||
						!date
					);
				}, this), true);
				this.dates.replace(dates);
	
				if (this.dates.length)
					this.viewDate = new Date(this.dates.get(-1));
				else if (this.viewDate < this.o.startDate)
					this.viewDate = new Date(this.o.startDate);
				else if (this.viewDate > this.o.endDate)
					this.viewDate = new Date(this.o.endDate);
				else
					this.viewDate = this.o.defaultViewDate;
	
				if (fromArgs){
					// setting date by clicking
					this.setValue();
				}
				else if (dates.length){
					// setting date by typing
					if (String(oldDates) !== String(this.dates))
						this._trigger('changeDate');
				}
				if (!this.dates.length && oldDates.length)
					this._trigger('clearDate');
	
				this.fill();
				this.element.change();
				return this;
			},
	
			fillDow: function(){
				var dowCnt = this.o.weekStart,
					html = '<tr>';
				if (this.o.calendarWeeks){
					this.picker.find('.datepicker-days .datepicker-switch')
						.attr('colspan', function(i, val){
							return parseInt(val) + 1;
						});
					html += '<th class="cw">&#160;</th>';
				}
				while (dowCnt < this.o.weekStart + 7){
					html += '<th class="dow';
	        if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) > -1)
	          html += ' disabled';
	        html += '">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
				}
				html += '</tr>';
				this.picker.find('.datepicker-days thead').append(html);
			},
	
			fillMonths: function(){
	      var localDate = this._utc_to_local(this.viewDate);
				var html = '',
				i = 0;
				while (i < 12){
	        var focused = localDate && localDate.getMonth() === i ? ' focused' : '';
					html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i++]+'</span>';
				}
				this.picker.find('.datepicker-months td').html(html);
			},
	
			setRange: function(range){
				if (!range || !range.length)
					delete this.range;
				else
					this.range = $.map(range, function(d){
						return d.valueOf();
					});
				this.fill();
			},
	
			getClassNames: function(date){
				var cls = [],
					year = this.viewDate.getUTCFullYear(),
					month = this.viewDate.getUTCMonth(),
					today = new Date();
				if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
					cls.push('old');
				}
				else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
					cls.push('new');
				}
				if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
					cls.push('focused');
				// Compare internal UTC date with local today, not UTC today
				if (this.o.todayHighlight &&
					date.getUTCFullYear() === today.getFullYear() &&
					date.getUTCMonth() === today.getMonth() &&
					date.getUTCDate() === today.getDate()){
					cls.push('today');
				}
				if (this.dates.contains(date) !== -1)
					cls.push('active');
				if (!this.dateWithinRange(date)){
					cls.push('disabled');
				}
				if (this.dateIsDisabled(date)){
					cls.push('disabled', 'disabled-date');	
				} 
				if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1){
					cls.push('highlighted');
				}
	
				if (this.range){
					if (date > this.range[0] && date < this.range[this.range.length-1]){
						cls.push('range');
					}
					if ($.inArray(date.valueOf(), this.range) !== -1){
						cls.push('selected');
					}
					if (date.valueOf() === this.range[0]){
	          cls.push('range-start');
	        }
	        if (date.valueOf() === this.range[this.range.length-1]){
	          cls.push('range-end');
	        }
				}
				return cls;
			},
	
			_fill_yearsView: function(selector, cssClass, factor, step, currentYear, startYear, endYear, callback){
				var html, view, year, steps, startStep, endStep, thisYear, i, classes, tooltip, before;
	
				html      = '';
				view      = this.picker.find(selector);
				year      = parseInt(currentYear / factor, 10) * factor;
				startStep = parseInt(startYear / step, 10) * step;
				endStep   = parseInt(endYear / step, 10) * step;
				steps     = $.map(this.dates, function(d){
					return parseInt(d.getUTCFullYear() / step, 10) * step;
				});
	
				view.find('.datepicker-switch').text(year + '-' + (year + step * 9));
	
				thisYear = year - step;
				for (i = -1; i < 11; i += 1) {
					classes = [cssClass];
					tooltip = null;
	
					if (i === -1) {
						classes.push('old');
					} else if (i === 10) {
						classes.push('new');
					}
					if ($.inArray(thisYear, steps) !== -1) {
						classes.push('active');
					}
					if (thisYear < startStep || thisYear > endStep) {
						classes.push('disabled');
					}
	        if (thisYear === this.viewDate.getFullYear()) {
					  classes.push('focused');
	        }
	
					if (callback !== $.noop) {
						before = callback(new Date(thisYear, 0, 1));
						if (before === undefined) {
							before = {};
						} else if (typeof(before) === 'boolean') {
							before = {enabled: before};
						} else if (typeof(before) === 'string') {
							before = {classes: before};
						}
						if (before.enabled === false) {
							classes.push('disabled');
						}
						if (before.classes) {
							classes = classes.concat(before.classes.split(/\s+/));
						}
						if (before.tooltip) {
							tooltip = before.tooltip;
						}
					}
	
					html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + thisYear + '</span>';
					thisYear += step;
				}
				view.find('td').html(html);
			},
	
			fill: function(){
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					todaytxt = dates[this.o.language].today || dates['en'].today || '',
					cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
					titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
					tooltip,
					before;
				if (isNaN(year) || isNaN(month))
					return;
				this.picker.find('.datepicker-days .datepicker-switch')
							.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
				this.picker.find('tfoot .today')
							.text(todaytxt)
							.toggle(this.o.todayBtn !== false);
				this.picker.find('tfoot .clear')
							.text(cleartxt)
							.toggle(this.o.clearBtn !== false);
				this.picker.find('thead .datepicker-title')
							.text(this.o.title)
							.toggle(this.o.title !== '');
				this.updateNavArrows();
				this.fillMonths();
				var prevMonth = UTCDate(year, month-1, 28),
					day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
				prevMonth.setUTCDate(day);
				prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
				var nextMonth = new Date(prevMonth);
				if (prevMonth.getUTCFullYear() < 100){
	        nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
	      }
				nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
				nextMonth = nextMonth.valueOf();
				var html = [];
				var clsName;
				while (prevMonth.valueOf() < nextMonth){
					if (prevMonth.getUTCDay() === this.o.weekStart){
						html.push('<tr>');
						if (this.o.calendarWeeks){
							// ISO 8601: First week contains first thursday.
							// ISO also states week starts on Monday, but we can be more abstract here.
							var
								// Start of current week: based on weekstart/current date
								ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
								// Thursday of this week
								th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
								// First Thursday of year, year from thursday
								yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay())%7*864e5),
								// Calendar week: ms between thursdays, div ms per day, div 7 days
								calWeek =  (th - yth) / 864e5 / 7 + 1;
							html.push('<td class="cw">'+ calWeek +'</td>');
						}
					}
					clsName = this.getClassNames(prevMonth);
					clsName.push('day');
	
					if (this.o.beforeShowDay !== $.noop){
						before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
						if (before === undefined)
							before = {};
						else if (typeof(before) === 'boolean')
							before = {enabled: before};
						else if (typeof(before) === 'string')
							before = {classes: before};
						if (before.enabled === false)
							clsName.push('disabled');
						if (before.classes)
							clsName = clsName.concat(before.classes.split(/\s+/));
						if (before.tooltip)
							tooltip = before.tooltip;
					}
	
					//Check if uniqueSort exists (supported by jquery >=1.12 and >=2.2)
					//Fallback to unique function for older jquery versions
					if ($.isFunction($.uniqueSort)) {
						clsName = $.uniqueSort(clsName);
					} else {
						clsName = $.unique(clsName);
					}
	
					html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + '>'+prevMonth.getUTCDate() + '</td>');
					tooltip = null;
					if (prevMonth.getUTCDay() === this.o.weekEnd){
						html.push('</tr>');
					}
					prevMonth.setUTCDate(prevMonth.getUTCDate()+1);
				}
				this.picker.find('.datepicker-days tbody').empty().append(html.join(''));
	
				var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
				var months = this.picker.find('.datepicker-months')
							.find('.datepicker-switch')
								.text(this.o.maxViewMode < 2 ? monthsTitle : year)
								.end()
							.find('span').removeClass('active');
	
				$.each(this.dates, function(i, d){
					if (d.getUTCFullYear() === year)
						months.eq(d.getUTCMonth()).addClass('active');
				});
	
				if (year < startYear || year > endYear){
					months.addClass('disabled');
				}
				if (year === startYear){
					months.slice(0, startMonth).addClass('disabled');
				}
				if (year === endYear){
					months.slice(endMonth+1).addClass('disabled');
				}
	
				if (this.o.beforeShowMonth !== $.noop){
					var that = this;
					$.each(months, function(i, month){
	          var moDate = new Date(year, i, 1);
	          var before = that.o.beforeShowMonth(moDate);
						if (before === undefined)
							before = {};
						else if (typeof(before) === 'boolean')
							before = {enabled: before};
						else if (typeof(before) === 'string')
							before = {classes: before};
						if (before.enabled === false && !$(month).hasClass('disabled'))
						    $(month).addClass('disabled');
						if (before.classes)
						    $(month).addClass(before.classes);
						if (before.tooltip)
						    $(month).prop('title', before.tooltip);
					});
				}
	
				// Generating decade/years picker
				this._fill_yearsView(
					'.datepicker-years',
					'year',
					10,
					1,
					year,
					startYear,
					endYear,
					this.o.beforeShowYear
				);
	
				// Generating century/decades picker
				this._fill_yearsView(
					'.datepicker-decades',
					'decade',
					100,
					10,
					year,
					startYear,
					endYear,
					this.o.beforeShowDecade
				);
	
				// Generating millennium/centuries picker
				this._fill_yearsView(
					'.datepicker-centuries',
					'century',
					1000,
					100,
					year,
					startYear,
					endYear,
					this.o.beforeShowCentury
				);
			},
	
			updateNavArrows: function(){
				if (!this._allow_update)
					return;
	
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth();
				switch (this.viewMode){
					case 0:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()){
							this.picker.find('.prev').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.prev').css({visibility: 'visible'});
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()){
							this.picker.find('.next').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.next').css({visibility: 'visible'});
						}
						break;
					case 1:
					case 2:
					case 3:
					case 4:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2){
							this.picker.find('.prev').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.prev').css({visibility: 'visible'});
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2){
							this.picker.find('.next').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.next').css({visibility: 'visible'});
						}
						break;
				}
			},
	
			click: function(e){
				e.preventDefault();
				e.stopPropagation();
	
				var target, dir, day, year, month, monthChanged, yearChanged;
				target = $(e.target);
	
				// Clicked on the switch
				if (target.hasClass('datepicker-switch')){
					this.showMode(1);
				}
	
				// Clicked on prev or next
				var navArrow = target.closest('.prev, .next');
				if (navArrow.length > 0) {
					dir = DPGlobal.modes[this.viewMode].navStep * (navArrow.hasClass('prev') ? -1 : 1);
					if (this.viewMode === 0){
						this.viewDate = this.moveMonth(this.viewDate, dir);
						this._trigger('changeMonth', this.viewDate);
					} else {
						this.viewDate = this.moveYear(this.viewDate, dir);
						if (this.viewMode === 1){
							this._trigger('changeYear', this.viewDate);
						}
					}
					this.fill();
				}
	
				// Clicked on today button
				if (target.hasClass('today') && !target.hasClass('day')){
					this.showMode(-2);
					this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
				}
	
				// Clicked on clear button
				if (target.hasClass('clear')){
					this.clearDates();
				}
	
				if (!target.hasClass('disabled')){
					// Clicked on a day
					if (target.hasClass('day')){
						day = parseInt(target.text(), 10) || 1;
						year = this.viewDate.getUTCFullYear();
						month = this.viewDate.getUTCMonth();
	
						// From last month
						if (target.hasClass('old')){
							if (month === 0) {
								month = 11;
								year = year - 1;
								monthChanged = true;
								yearChanged = true;
							} else {
								month = month - 1;
								monthChanged = true;
	 						}
	 					}
	
						// From next month
						if (target.hasClass('new')) {
							if (month === 11){
								month = 0;
								year = year + 1;
								monthChanged = true;
								yearChanged = true;
	 						} else {
								month = month + 1;
								monthChanged = true;
	 						}
						}
						this._setDate(UTCDate(year, month, day));
						if (yearChanged) {
							this._trigger('changeYear', this.viewDate);
						}
						if (monthChanged) {
							this._trigger('changeMonth', this.viewDate);
						}
					}
	
					// Clicked on a month
					if (target.hasClass('month')) {
						this.viewDate.setUTCDate(1);
						day = 1;
						month = target.parent().find('span').index(target);
						year = this.viewDate.getUTCFullYear();
						this.viewDate.setUTCMonth(month);
						this._trigger('changeMonth', this.viewDate);
						if (this.o.minViewMode === 1){
							this._setDate(UTCDate(year, month, day));
							this.showMode();
						} else {
							this.showMode(-1);
						}
						this.fill();
					}
	
					// Clicked on a year
					if (target.hasClass('year')
							|| target.hasClass('decade')
							|| target.hasClass('century')) {
						this.viewDate.setUTCDate(1);
	
						day = 1;
						month = 0;
						year = parseInt(target.text(), 10)||0;
						this.viewDate.setUTCFullYear(year);
	
						if (target.hasClass('year')){
							this._trigger('changeYear', this.viewDate);
							if (this.o.minViewMode === 2){
								this._setDate(UTCDate(year, month, day));
							}
						}
						if (target.hasClass('decade')){
							this._trigger('changeDecade', this.viewDate);
							if (this.o.minViewMode === 3){
								this._setDate(UTCDate(year, month, day));
							}
						}
						if (target.hasClass('century')){
							this._trigger('changeCentury', this.viewDate);
							if (this.o.minViewMode === 4){
								this._setDate(UTCDate(year, month, day));
							}
						}
	
						this.showMode(-1);
						this.fill();
					}
				}
	
				if (this.picker.is(':visible') && this._focused_from){
					$(this._focused_from).focus();
				}
				delete this._focused_from;
			},
	
			_toggle_multidate: function(date){
				var ix = this.dates.contains(date);
				if (!date){
					this.dates.clear();
				}
	
				if (ix !== -1){
					if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive){
						this.dates.remove(ix);
					}
				} else if (this.o.multidate === false) {
					this.dates.clear();
					this.dates.push(date);
				}
				else {
					this.dates.push(date);
				}
	
				if (typeof this.o.multidate === 'number')
					while (this.dates.length > this.o.multidate)
						this.dates.remove(0);
			},
	
			_setDate: function(date, which){
				if (!which || which === 'date')
					this._toggle_multidate(date && new Date(date));
				if (!which || which === 'view')
					this.viewDate = date && new Date(date);
	
				this.fill();
				this.setValue();
				if (!which || which !== 'view') {
					this._trigger('changeDate');
				}
				if (this.inputField){
					this.inputField.change();
				}
				if (this.o.autoclose && (!which || which === 'date')){
					this.hide();
				}
			},
	
			moveDay: function(date, dir){
				var newDate = new Date(date);
				newDate.setUTCDate(date.getUTCDate() + dir);
	
				return newDate;
			},
	
			moveWeek: function(date, dir){
				return this.moveDay(date, dir * 7);
			},
	
			moveMonth: function(date, dir){
				if (!isValidDate(date))
					return this.o.defaultViewDate;
				if (!dir)
					return date;
				var new_date = new Date(date.valueOf()),
					day = new_date.getUTCDate(),
					month = new_date.getUTCMonth(),
					mag = Math.abs(dir),
					new_month, test;
				dir = dir > 0 ? 1 : -1;
				if (mag === 1){
					test = dir === -1
						// If going back one month, make sure month is not current month
						// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
						? function(){
							return new_date.getUTCMonth() === month;
						}
						// If going forward one month, make sure month is as expected
						// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
						: function(){
							return new_date.getUTCMonth() !== new_month;
						};
					new_month = month + dir;
					new_date.setUTCMonth(new_month);
					// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
					if (new_month < 0 || new_month > 11)
						new_month = (new_month + 12) % 12;
				}
				else {
					// For magnitudes >1, move one month at a time...
					for (var i=0; i < mag; i++)
						// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
						new_date = this.moveMonth(new_date, dir);
					// ...then reset the day, keeping it in the new month
					new_month = new_date.getUTCMonth();
					new_date.setUTCDate(day);
					test = function(){
						return new_month !== new_date.getUTCMonth();
					};
				}
				// Common date-resetting loop -- if date is beyond end of month, make it
				// end of month
				while (test()){
					new_date.setUTCDate(--day);
					new_date.setUTCMonth(new_month);
				}
				return new_date;
			},
	
			moveYear: function(date, dir){
				return this.moveMonth(date, dir*12);
			},
	
			moveAvailableDate: function(date, dir, fn){
				do {
					date = this[fn](date, dir);
	
					if (!this.dateWithinRange(date))
						return false;
	
					fn = 'moveDay';
				}
				while (this.dateIsDisabled(date));
	
				return date;
			},
	
			weekOfDateIsDisabled: function(date){
				return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
			},
	
			dateIsDisabled: function(date){
				return (
					this.weekOfDateIsDisabled(date) ||
					$.grep(this.o.datesDisabled, function(d){
						return isUTCEquals(date, d);
					}).length > 0
				);
			},
	
			dateWithinRange: function(date){
				return date >= this.o.startDate && date <= this.o.endDate;
			},
	
			keydown: function(e){
				if (!this.picker.is(':visible')){
					if (e.keyCode === 40 || e.keyCode === 27) { // allow down to re-show picker
						this.show();
						e.stopPropagation();
	        }
					return;
				}
				var dateChanged = false,
					dir, newViewDate,
					focusDate = this.focusDate || this.viewDate;
				switch (e.keyCode){
					case 27: // escape
						if (this.focusDate){
							this.focusDate = null;
							this.viewDate = this.dates.get(-1) || this.viewDate;
							this.fill();
						}
						else
							this.hide();
						e.preventDefault();
						e.stopPropagation();
						break;
					case 37: // left
					case 38: // up
					case 39: // right
					case 40: // down
						if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
							break;
						dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
	          if (this.viewMode === 0) {
	  					if (e.ctrlKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	
	  						if (newViewDate)
	  							this._trigger('changeYear', this.viewDate);
	  					}
	  					else if (e.shiftKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	
	  						if (newViewDate)
	  							this._trigger('changeMonth', this.viewDate);
	  					}
	  					else if (e.keyCode === 37 || e.keyCode === 39){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
	  					}
	  					else if (!this.weekOfDateIsDisabled(focusDate)){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
	  					}
	          } else if (this.viewMode === 1) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	          } else if (this.viewMode === 2) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	          }
						if (newViewDate){
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 13: // enter
						if (!this.o.forceParse)
							break;
						focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
						if (this.o.keyboardNavigation) {
							this._toggle_multidate(focusDate);
							dateChanged = true;
						}
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.setValue();
						this.fill();
						if (this.picker.is(':visible')){
							e.preventDefault();
							e.stopPropagation();
							if (this.o.autoclose)
								this.hide();
						}
						break;
					case 9: // tab
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
						this.hide();
						break;
				}
				if (dateChanged){
					if (this.dates.length)
						this._trigger('changeDate');
					else
						this._trigger('clearDate');
					if (this.inputField){
						this.inputField.change();
					}
				}
			},
	
			showMode: function(dir){
				if (dir){
					this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + dir));
				}
				this.picker
					.children('div')
					.hide()
					.filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName)
						.show();
				this.updateNavArrows();
			}
		};
	
		var DateRangePicker = function(element, options){
			$(element).data('datepicker', this);
			this.element = $(element);
			this.inputs = $.map(options.inputs, function(i){
				return i.jquery ? i[0] : i;
			});
			delete options.inputs;
	
			datepickerPlugin.call($(this.inputs), options)
				.on('changeDate', $.proxy(this.dateUpdated, this));
	
			this.pickers = $.map(this.inputs, function(i){
				return $(i).data('datepicker');
			});
			this.updateDates();
		};
		DateRangePicker.prototype = {
			updateDates: function(){
				this.dates = $.map(this.pickers, function(i){
					return i.getUTCDate();
				});
				this.updateRanges();
			},
			updateRanges: function(){
				var range = $.map(this.dates, function(d){
					return d.valueOf();
				});
				$.each(this.pickers, function(i, p){
					p.setRange(range);
				});
			},
			dateUpdated: function(e){
				// `this.updating` is a workaround for preventing infinite recursion
				// between `changeDate` triggering and `setUTCDate` calling.  Until
				// there is a better mechanism.
				if (this.updating)
					return;
				this.updating = true;
	
				var dp = $(e.target).data('datepicker');
	
				if (typeof(dp) === "undefined") {
					return;
				}
	
				var new_date = dp.getUTCDate(),
					i = $.inArray(e.target, this.inputs),
					j = i - 1,
					k = i + 1,
					l = this.inputs.length;
				if (i === -1)
					return;
	
				$.each(this.pickers, function(i, p){
					if (!p.getUTCDate())
						p.setUTCDate(new_date);
				});
	
				if (new_date < this.dates[j]){
					// Date being moved earlier/left
					while (j >= 0 && new_date < this.dates[j]){
						this.pickers[j--].setUTCDate(new_date);
					}
				}
				else if (new_date > this.dates[k]){
					// Date being moved later/right
					while (k < l && new_date > this.dates[k]){
						this.pickers[k++].setUTCDate(new_date);
					}
				}
				this.updateDates();
	
				delete this.updating;
			},
			remove: function(){
				$.map(this.pickers, function(p){ p.remove(); });
				delete this.element.data().datepicker;
			}
		};
	
		function opts_from_el(el, prefix){
			// Derive options from element data-attrs
			var data = $(el).data(),
				out = {}, inkey,
				replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
			prefix = new RegExp('^' + prefix.toLowerCase());
			function re_lower(_,a){
				return a.toLowerCase();
			}
			for (var key in data)
				if (prefix.test(key)){
					inkey = key.replace(replace, re_lower);
					out[inkey] = data[key];
				}
			return out;
		}
	
		function opts_from_locale(lang){
			// Derive options from locale plugins
			var out = {};
			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					return;
			}
			var d = dates[lang];
			$.each(locale_opts, function(i,k){
				if (k in d)
					out[k] = d[k];
			});
			return out;
		}
	
		var old = $.fn.datepicker;
		var datepickerPlugin = function(option){
			var args = Array.apply(null, arguments);
			args.shift();
			var internal_return;
			this.each(function(){
				var $this = $(this),
					data = $this.data('datepicker'),
					options = typeof option === 'object' && option;
				if (!data){
					var elopts = opts_from_el(this, 'date'),
						// Preliminary otions
						xopts = $.extend({}, defaults, elopts, options),
						locopts = opts_from_locale(xopts.language),
						// Options priority: js args, data-attrs, locales, defaults
						opts = $.extend({}, defaults, locopts, elopts, options);
					if ($this.hasClass('input-daterange') || opts.inputs){
						$.extend(opts, {
							inputs: opts.inputs || $this.find('input').toArray()
						});
						data = new DateRangePicker(this, opts);
					}
					else {
						data = new Datepicker(this, opts);
					}
					$this.data('datepicker', data);
				}
				if (typeof option === 'string' && typeof data[option] === 'function'){
					internal_return = data[option].apply(data, args);
				}
			});
	
			if (
				internal_return === undefined ||
				internal_return instanceof Datepicker ||
				internal_return instanceof DateRangePicker
			)
				return this;
	
			if (this.length > 1)
				throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
			else
				return internal_return;
		};
		$.fn.datepicker = datepickerPlugin;
	
		var defaults = $.fn.datepicker.defaults = {
			assumeNearbyYear: false,
			autoclose: false,
			beforeShowDay: $.noop,
			beforeShowMonth: $.noop,
			beforeShowYear: $.noop,
			beforeShowDecade: $.noop,
			beforeShowCentury: $.noop,
			calendarWeeks: false,
			clearBtn: false,
			toggleActive: false,
			daysOfWeekDisabled: [],
			daysOfWeekHighlighted: [],
			datesDisabled: [],
			endDate: Infinity,
			forceParse: true,
			format: 'mm/dd/yyyy',
			keyboardNavigation: true,
			language: 'en',
			minViewMode: 0,
			maxViewMode: 4,
			multidate: false,
			multidateSeparator: ',',
			orientation: "auto",
			rtl: false,
			startDate: -Infinity,
			startView: 0,
			todayBtn: false,
			todayHighlight: false,
			weekStart: 0,
			disableTouchKeyboard: false,
			enableOnReadonly: true,
			showOnFocus: true,
			zIndexOffset: 10,
			container: 'body',
			immediateUpdates: false,
			title: '',
			templates: {
				leftArrow: '&laquo;',
				rightArrow: '&raquo;'
			}
		};
		var locale_opts = $.fn.datepicker.locale_opts = [
			'format',
			'rtl',
			'weekStart'
		];
		$.fn.datepicker.Constructor = Datepicker;
		var dates = $.fn.datepicker.dates = {
			en: {
				days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
				daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
				months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				today: "Today",
				clear: "Clear",
				titleFormat: "MM yyyy"
			}
		};
	
		var DPGlobal = {
			modes: [
				{
					clsName: 'days',
					navFnc: 'Month',
					navStep: 1
				},
				{
					clsName: 'months',
					navFnc: 'FullYear',
					navStep: 1
				},
				{
					clsName: 'years',
					navFnc: 'FullYear',
					navStep: 10
				},
				{
					clsName: 'decades',
					navFnc: 'FullDecade',
					navStep: 100
				},
				{
					clsName: 'centuries',
					navFnc: 'FullCentury',
					navStep: 1000
			}],
			isLeapYear: function(year){
				return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
			},
			getDaysInMonth: function(year, month){
				return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
			},
			validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
			nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
			parseFormat: function(format){
				if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
	                return format;
	            // IE treats \0 as a string end in inputs (truncating the value),
				// so it's a bad format delimiter, anyway
				var separators = format.replace(this.validParts, '\0').split('\0'),
					parts = format.match(this.validParts);
				if (!separators || !separators.length || !parts || parts.length === 0){
					throw new Error("Invalid date format.");
				}
				return {separators: separators, parts: parts};
			},
			parseDate: function(date, format, language, assumeNearby){
				if (!date)
					return undefined;
				if (date instanceof Date)
					return date;
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toValue)
	                return format.toValue(date, format, language);
	            var part_re = /([\-+]\d+)([dmwy])/,
					parts = date.match(/([\-+]\d+)([dmwy])/g),
					fn_map = {
						d: 'moveDay',
						m: 'moveMonth',
						w: 'moveWeek',
						y: 'moveYear'
					},
					dateAliases = {
						yesterday: '-1d',
						today: '+0d',
						tomorrow: '+1d'
					},
					part, dir, i, fn;
				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
					date = new Date();
					for (i=0; i < parts.length; i++){
						part = part_re.exec(parts[i]);
						dir = parseInt(part[1]);
						fn = fn_map[part[2]];
						date = Datepicker.prototype[fn](date, dir);
					}
					return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
				}
	
				if (typeof dateAliases[date] !== 'undefined') {
					date = dateAliases[date];
					parts = date.match(/([\-+]\d+)([dmwy])/g);
	
					if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
						date = new Date();
					  	for (i=0; i < parts.length; i++){
							part = part_re.exec(parts[i]);
							dir = parseInt(part[1]);
							fn = fn_map[part[2]];
							date = Datepicker.prototype[fn](date, dir);
					  	}
	
				  		return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
					}
				}
	
				parts = date && date.match(this.nonpunctuation) || [];
				date = new Date();
	
				function applyNearbyYear(year, threshold){
					if (threshold === true)
						threshold = 10;
	
					// if year is 2 digits or less, than the user most likely is trying to get a recent century
					if (year < 100){
						year += 2000;
						// if the new year is more than threshold years in advance, use last century
						if (year > ((new Date()).getFullYear()+threshold)){
							year -= 100;
						}
					}
	
					return year;
				}
	
				var parsed = {},
					setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
					setters_map = {
						yyyy: function(d,v){
							return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
						},
						yy: function(d,v){
							return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
						},
						m: function(d,v){
							if (isNaN(d))
								return d;
							v -= 1;
							while (v < 0) v += 12;
							v %= 12;
							d.setUTCMonth(v);
							while (d.getUTCMonth() !== v)
								d.setUTCDate(d.getUTCDate()-1);
							return d;
						},
						d: function(d,v){
							return d.setUTCDate(v);
						}
					},
					val, filtered;
				setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
				setters_map['dd'] = setters_map['d'];
				date = UTCToday();
				var fparts = format.parts.slice();
				// Remove noop parts
				if (parts.length !== fparts.length){
					fparts = $(fparts).filter(function(i,p){
						return $.inArray(p, setters_order) !== -1;
					}).toArray();
				}
				// Process remainder
				function match_part(){
					var m = this.slice(0, parts[i].length),
						p = parts[i].slice(0, m.length);
					return m.toLowerCase() === p.toLowerCase();
				}
				if (parts.length === fparts.length){
					var cnt;
					for (i=0, cnt = fparts.length; i < cnt; i++){
						val = parseInt(parts[i], 10);
						part = fparts[i];
						if (isNaN(val)){
							switch (part){
								case 'MM':
									filtered = $(dates[language].months).filter(match_part);
									val = $.inArray(filtered[0], dates[language].months) + 1;
									break;
								case 'M':
									filtered = $(dates[language].monthsShort).filter(match_part);
									val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
									break;
							}
						}
						parsed[part] = val;
					}
					var _date, s;
					for (i=0; i < setters_order.length; i++){
						s = setters_order[i];
						if (s in parsed && !isNaN(parsed[s])){
							_date = new Date(date);
							setters_map[s](_date, parsed[s]);
							if (!isNaN(_date))
								date = _date;
						}
					}
				}
				return date;
			},
			formatDate: function(date, format, language){
				if (!date)
					return '';
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toDisplay)
	                return format.toDisplay(date, format, language);
	            var val = {
					d: date.getUTCDate(),
					D: dates[language].daysShort[date.getUTCDay()],
					DD: dates[language].days[date.getUTCDay()],
					m: date.getUTCMonth() + 1,
					M: dates[language].monthsShort[date.getUTCMonth()],
					MM: dates[language].months[date.getUTCMonth()],
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				};
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				date = [];
				var seps = $.extend([], format.separators);
				for (var i=0, cnt = format.parts.length; i <= cnt; i++){
					if (seps.length)
						date.push(seps.shift());
					date.push(val[format.parts[i]]);
				}
				return date.join('');
			},
			headTemplate: '<thead>'+
				              '<tr>'+
				                '<th colspan="7" class="datepicker-title"></th>'+
				              '</tr>'+
								'<tr>'+
									'<th class="prev">&laquo;</th>'+
									'<th colspan="5" class="datepicker-switch"></th>'+
									'<th class="next">&raquo;</th>'+
								'</tr>'+
							'</thead>',
			contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
			footTemplate: '<tfoot>'+
								'<tr>'+
									'<th colspan="7" class="today"></th>'+
								'</tr>'+
								'<tr>'+
									'<th colspan="7" class="clear"></th>'+
								'</tr>'+
							'</tfoot>'
		};
		DPGlobal.template = '<div class="datepicker">'+
								'<div class="datepicker-days">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										'<tbody></tbody>'+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-months">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-years">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-decades">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-centuries">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
							'</div>';
	
		$.fn.datepicker.DPGlobal = DPGlobal;
	
	
		/* DATEPICKER NO CONFLICT
		* =================== */
	
		$.fn.datepicker.noConflict = function(){
			$.fn.datepicker = old;
			return this;
		};
	
		/* DATEPICKER VERSION
		 * =================== */
		$.fn.datepicker.version = '1.6.4';
	
		/* DATEPICKER DATA-API
		* ================== */
	
		$(document).on(
			'focus.datepicker.data-api click.datepicker.data-api',
			'[data-provide="datepicker"]',
			function(e){
				var $this = $(this);
				if ($this.data('datepicker'))
					return;
				e.preventDefault();
				// component click requires us to explicitly show it
				datepickerPlugin.call($this, 'show');
			}
		);
		$(function(){
			datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
		});
	
	}));


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*!
	 * iCheck v1.0.2, http://git.io/arlzeA
	 * ===================================
	 * Powerful jQuery and Zepto plugin for checkboxes and radio buttons customization
	 *
	 * (c) 2013 Damir Sultanov, http://fronteed.com
	 * MIT Licensed
	 */
	
	(function($) {
	
	  // Cached vars
	  var _iCheck = 'iCheck',
	    _iCheckHelper = _iCheck + '-helper',
	    _checkbox = 'checkbox',
	    _radio = 'radio',
	    _checked = 'checked',
	    _unchecked = 'un' + _checked,
	    _disabled = 'disabled',
	    _determinate = 'determinate',
	    _indeterminate = 'in' + _determinate,
	    _update = 'update',
	    _type = 'type',
	    _click = 'click',
	    _touch = 'touchbegin.i touchend.i',
	    _add = 'addClass',
	    _remove = 'removeClass',
	    _callback = 'trigger',
	    _label = 'label',
	    _cursor = 'cursor',
	    _mobile = /ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);
	
	  // Plugin init
	  $.fn[_iCheck] = function(options, fire) {
	
	    // Walker
	    var handle = 'input[type="' + _checkbox + '"], input[type="' + _radio + '"]',
	      stack = $(),
	      walker = function(object) {
	        object.each(function() {
	          var self = $(this);
	
	          if (self.is(handle)) {
	            stack = stack.add(self);
	          } else {
	            stack = stack.add(self.find(handle));
	          }
	        });
	      };
	
	    // Check if we should operate with some method
	    if (/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(options)) {
	
	      // Normalize method's name
	      options = options.toLowerCase();
	
	      // Find checkboxes and radio buttons
	      walker(this);
	
	      return stack.each(function() {
	        var self = $(this);
	
	        if (options == 'destroy') {
	          tidy(self, 'ifDestroyed');
	        } else {
	          operate(self, true, options);
	        }
	
	        // Fire method's callback
	        if ($.isFunction(fire)) {
	          fire();
	        }
	      });
	
	    // Customization
	    } else if (typeof options == 'object' || !options) {
	
	      // Check if any options were passed
	      var settings = $.extend({
	          checkedClass: _checked,
	          disabledClass: _disabled,
	          indeterminateClass: _indeterminate,
	          labelHover: true
	        }, options),
	
	        selector = settings.handle,
	        hoverClass = settings.hoverClass || 'hover',
	        focusClass = settings.focusClass || 'focus',
	        activeClass = settings.activeClass || 'active',
	        labelHover = !!settings.labelHover,
	        labelHoverClass = settings.labelHoverClass || 'hover',
	
	        // Setup clickable area
	        area = ('' + settings.increaseArea).replace('%', '') | 0;
	
	      // Selector limit
	      if (selector == _checkbox || selector == _radio) {
	        handle = 'input[type="' + selector + '"]';
	      }
	
	      // Clickable area limit
	      if (area < -50) {
	        area = -50;
	      }
	
	      // Walk around the selector
	      walker(this);
	
	      return stack.each(function() {
	        var self = $(this);
	
	        // If already customized
	        tidy(self);
	
	        var node = this,
	          id = node.id,
	
	          // Layer styles
	          offset = -area + '%',
	          size = 100 + (area * 2) + '%',
	          layer = {
	            position: 'absolute',
	            top: offset,
	            left: offset,
	            display: 'block',
	            width: size,
	            height: size,
	            margin: 0,
	            padding: 0,
	            background: '#fff',
	            border: 0,
	            opacity: 0
	          },
	
	          // Choose how to hide input
	          hide = _mobile ? {
	            position: 'absolute',
	            visibility: 'hidden'
	          } : area ? layer : {
	            position: 'absolute',
	            opacity: 0
	          },
	
	          // Get proper class
	          className = node[_type] == _checkbox ? settings.checkboxClass || 'i' + _checkbox : settings.radioClass || 'i' + _radio,
	
	          // Find assigned labels
	          label = $(_label + '[for="' + id + '"]').add(self.closest(_label)),
	
	          // Check ARIA option
	          aria = !!settings.aria,
	
	          // Set ARIA placeholder
	          ariaID = _iCheck + '-' + Math.random().toString(36).substr(2,6),
	
	          // Parent & helper
	          parent = '<div class="' + className + '" ' + (aria ? 'role="' + node[_type] + '" ' : ''),
	          helper;
	
	        // Set ARIA "labelledby"
	        if (aria) {
	          label.each(function() {
	            parent += 'aria-labelledby="';
	
	            if (this.id) {
	              parent += this.id;
	            } else {
	              this.id = ariaID;
	              parent += ariaID;
	            }
	
	            parent += '"';
	          });
	        }
	
	        // Wrap input
	        parent = self.wrap(parent + '/>')[_callback]('ifCreated').parent().append(settings.insert);
	
	        // Layer addition
	        helper = $('<ins class="' + _iCheckHelper + '"/>').css(layer).appendTo(parent);
	
	        // Finalize customization
	        self.data(_iCheck, {o: settings, s: self.attr('style')}).css(hide);
	        !!settings.inheritClass && parent[_add](node.className || '');
	        !!settings.inheritID && id && parent.attr('id', _iCheck + '-' + id);
	        parent.css('position') == 'static' && parent.css('position', 'relative');
	        operate(self, true, _update);
	
	        // Label events
	        if (label.length) {
	          label.on(_click + '.i mouseover.i mouseout.i ' + _touch, function(event) {
	            var type = event[_type],
	              item = $(this);
	
	            // Do nothing if input is disabled
	            if (!node[_disabled]) {
	
	              // Click
	              if (type == _click) {
	                if ($(event.target).is('a')) {
	                  return;
	                }
	                operate(self, false, true);
	
	              // Hover state
	              } else if (labelHover) {
	
	                // mouseout|touchend
	                if (/ut|nd/.test(type)) {
	                  parent[_remove](hoverClass);
	                  item[_remove](labelHoverClass);
	                } else {
	                  parent[_add](hoverClass);
	                  item[_add](labelHoverClass);
	                }
	              }
	
	              if (_mobile) {
	                event.stopPropagation();
	              } else {
	                return false;
	              }
	            }
	          });
	        }
	
	        // Input events
	        self.on(_click + '.i focus.i blur.i keyup.i keydown.i keypress.i', function(event) {
	          var type = event[_type],
	            key = event.keyCode;
	
	          // Click
	          if (type == _click) {
	            return false;
	
	          // Keydown
	          } else if (type == 'keydown' && key == 32) {
	            if (!(node[_type] == _radio && node[_checked])) {
	              if (node[_checked]) {
	                off(self, _checked);
	              } else {
	                on(self, _checked);
	              }
	            }
	
	            return false;
	
	          // Keyup
	          } else if (type == 'keyup' && node[_type] == _radio) {
	            !node[_checked] && on(self, _checked);
	
	          // Focus/blur
	          } else if (/us|ur/.test(type)) {
	            parent[type == 'blur' ? _remove : _add](focusClass);
	          }
	        });
	
	        // Helper events
	        helper.on(_click + ' mousedown mouseup mouseover mouseout ' + _touch, function(event) {
	          var type = event[_type],
	
	            // mousedown|mouseup
	            toggle = /wn|up/.test(type) ? activeClass : hoverClass;
	
	          // Do nothing if input is disabled
	          if (!node[_disabled]) {
	
	            // Click
	            if (type == _click) {
	              operate(self, false, true);
	
	            // Active and hover states
	            } else {
	
	              // State is on
	              if (/wn|er|in/.test(type)) {
	
	                // mousedown|mouseover|touchbegin
	                parent[_add](toggle);
	
	              // State is off
	              } else {
	                parent[_remove](toggle + ' ' + activeClass);
	              }
	
	              // Label hover
	              if (label.length && labelHover && toggle == hoverClass) {
	
	                // mouseout|touchend
	                label[/ut|nd/.test(type) ? _remove : _add](labelHoverClass);
	              }
	            }
	
	            if (_mobile) {
	              event.stopPropagation();
	            } else {
	              return false;
	            }
	          }
	        });
	      });
	    } else {
	      return this;
	    }
	  };
	
	  // Do something with inputs
	  function operate(input, direct, method) {
	    var node = input[0],
	      state = /er/.test(method) ? _indeterminate : /bl/.test(method) ? _disabled : _checked,
	      active = method == _update ? {
	        checked: node[_checked],
	        disabled: node[_disabled],
	        indeterminate: input.attr(_indeterminate) == 'true' || input.attr(_determinate) == 'false'
	      } : node[state];
	
	    // Check, disable or indeterminate
	    if (/^(ch|di|in)/.test(method) && !active) {
	      on(input, state);
	
	    // Uncheck, enable or determinate
	    } else if (/^(un|en|de)/.test(method) && active) {
	      off(input, state);
	
	    // Update
	    } else if (method == _update) {
	
	      // Handle states
	      for (var each in active) {
	        if (active[each]) {
	          on(input, each, true);
	        } else {
	          off(input, each, true);
	        }
	      }
	
	    } else if (!direct || method == 'toggle') {
	
	      // Helper or label was clicked
	      if (!direct) {
	        input[_callback]('ifClicked');
	      }
	
	      // Toggle checked state
	      if (active) {
	        if (node[_type] !== _radio) {
	          off(input, state);
	        }
	      } else {
	        on(input, state);
	      }
	    }
	  }
	
	  // Add checked, disabled or indeterminate state
	  function on(input, state, keep) {
	    var node = input[0],
	      parent = input.parent(),
	      checked = state == _checked,
	      indeterminate = state == _indeterminate,
	      disabled = state == _disabled,
	      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
	      regular = option(input, callback + capitalize(node[_type])),
	      specific = option(input, state + capitalize(node[_type]));
	
	    // Prevent unnecessary actions
	    if (node[state] !== true) {
	
	      // Toggle assigned radio buttons
	      if (!keep && state == _checked && node[_type] == _radio && node.name) {
	        var form = input.closest('form'),
	          inputs = 'input[name="' + node.name + '"]';
	
	        inputs = form.length ? form.find(inputs) : $(inputs);
	
	        inputs.each(function() {
	          if (this !== node && $(this).data(_iCheck)) {
	            off($(this), state);
	          }
	        });
	      }
	
	      // Indeterminate state
	      if (indeterminate) {
	
	        // Add indeterminate state
	        node[state] = true;
	
	        // Remove checked state
	        if (node[_checked]) {
	          off(input, _checked, 'force');
	        }
	
	      // Checked or disabled state
	      } else {
	
	        // Add checked or disabled state
	        if (!keep) {
	          node[state] = true;
	        }
	
	        // Remove indeterminate state
	        if (checked && node[_indeterminate]) {
	          off(input, _indeterminate, false);
	        }
	      }
	
	      // Trigger callbacks
	      callbacks(input, checked, state, keep);
	    }
	
	    // Add proper cursor
	    if (node[_disabled] && !!option(input, _cursor, true)) {
	      parent.find('.' + _iCheckHelper).css(_cursor, 'default');
	    }
	
	    // Add state class
	    parent[_add](specific || option(input, state) || '');
	
	    // Set ARIA attribute
	    if (!!parent.attr('role') && !indeterminate) {
	      parent.attr('aria-' + (disabled ? _disabled : _checked), 'true');
	    }
	
	    // Remove regular state class
	    parent[_remove](regular || option(input, callback) || '');
	  }
	
	  // Remove checked, disabled or indeterminate state
	  function off(input, state, keep) {
	    var node = input[0],
	      parent = input.parent(),
	      checked = state == _checked,
	      indeterminate = state == _indeterminate,
	      disabled = state == _disabled,
	      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
	      regular = option(input, callback + capitalize(node[_type])),
	      specific = option(input, state + capitalize(node[_type]));
	
	    // Prevent unnecessary actions
	    if (node[state] !== false) {
	
	      // Toggle state
	      if (indeterminate || !keep || keep == 'force') {
	        node[state] = false;
	      }
	
	      // Trigger callbacks
	      callbacks(input, checked, callback, keep);
	    }
	
	    // Add proper cursor
	    if (!node[_disabled] && !!option(input, _cursor, true)) {
	      parent.find('.' + _iCheckHelper).css(_cursor, 'pointer');
	    }
	
	    // Remove state class
	    parent[_remove](specific || option(input, state) || '');
	
	    // Set ARIA attribute
	    if (!!parent.attr('role') && !indeterminate) {
	      parent.attr('aria-' + (disabled ? _disabled : _checked), 'false');
	    }
	
	    // Add regular state class
	    parent[_add](regular || option(input, callback) || '');
	  }
	
	  // Remove all traces
	  function tidy(input, callback) {
	    if (input.data(_iCheck)) {
	
	      // Remove everything except input
	      input.parent().html(input.attr('style', input.data(_iCheck).s || ''));
	
	      // Callback
	      if (callback) {
	        input[_callback](callback);
	      }
	
	      // Unbind events
	      input.off('.i').unwrap();
	      $(_label + '[for="' + input[0].id + '"]').add(input.closest(_label)).off('.i');
	    }
	  }
	
	  // Get some option
	  function option(input, state, regular) {
	    if (input.data(_iCheck)) {
	      return input.data(_iCheck).o[state + (regular ? '' : 'Class')];
	    }
	  }
	
	  // Capitalize some string
	  function capitalize(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  // Executable handlers
	  function callbacks(input, checked, callback, keep) {
	    if (!keep) {
	      if (checked) {
	        input[_callback]('ifToggled');
	      }
	
	      input[_callback]('ifChanged')[_callback]('if' + capitalize(callback));
	    }
	  }
	})(__webpack_provided_window_dot_jQuery || window.Zepto);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate) {/*!
	 * typeahead.js 0.11.1
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(14) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return root["Bloodhound"] = factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === "object") {
	        module.exports = factory(require("jquery"));
	    } else {
	        root["Bloodhound"] = factory(jQuery);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            noop: function() {}
	        };
	    }();
	    var VERSION = "0.11.1";
	    var tokenizers = function() {
	        "use strict";
	        return {
	            nonword: nonword,
	            whitespace: whitespace,
	            obj: {
	                nonword: getObjTokenizer(nonword),
	                whitespace: getObjTokenizer(whitespace)
	            }
	        };
	        function whitespace(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\s+/) : [];
	        }
	        function nonword(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\W+/) : [];
	        }
	        function getObjTokenizer(tokenizer) {
	            return function setKey(keys) {
	                keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
	                return function tokenize(o) {
	                    var tokens = [];
	                    _.each(keys, function(k) {
	                        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
	                    });
	                    return tokens;
	                };
	            };
	        }
	    }();
	    var LruCache = function() {
	        "use strict";
	        function LruCache(maxSize) {
	            this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
	            this.reset();
	            if (this.maxSize <= 0) {
	                this.set = this.get = $.noop;
	            }
	        }
	        _.mixin(LruCache.prototype, {
	            set: function set(key, val) {
	                var tailItem = this.list.tail, node;
	                if (this.size >= this.maxSize) {
	                    this.list.remove(tailItem);
	                    delete this.hash[tailItem.key];
	                    this.size--;
	                }
	                if (node = this.hash[key]) {
	                    node.val = val;
	                    this.list.moveToFront(node);
	                } else {
	                    node = new Node(key, val);
	                    this.list.add(node);
	                    this.hash[key] = node;
	                    this.size++;
	                }
	            },
	            get: function get(key) {
	                var node = this.hash[key];
	                if (node) {
	                    this.list.moveToFront(node);
	                    return node.val;
	                }
	            },
	            reset: function reset() {
	                this.size = 0;
	                this.hash = {};
	                this.list = new List();
	            }
	        });
	        function List() {
	            this.head = this.tail = null;
	        }
	        _.mixin(List.prototype, {
	            add: function add(node) {
	                if (this.head) {
	                    node.next = this.head;
	                    this.head.prev = node;
	                }
	                this.head = node;
	                this.tail = this.tail || node;
	            },
	            remove: function remove(node) {
	                node.prev ? node.prev.next = node.next : this.head = node.next;
	                node.next ? node.next.prev = node.prev : this.tail = node.prev;
	            },
	            moveToFront: function(node) {
	                this.remove(node);
	                this.add(node);
	            }
	        });
	        function Node(key, val) {
	            this.key = key;
	            this.val = val;
	            this.prev = this.next = null;
	        }
	        return LruCache;
	    }();
	    var PersistentStorage = function() {
	        "use strict";
	        var LOCAL_STORAGE;
	        try {
	            LOCAL_STORAGE = window.localStorage;
	            LOCAL_STORAGE.setItem("~~~", "!");
	            LOCAL_STORAGE.removeItem("~~~");
	        } catch (err) {
	            LOCAL_STORAGE = null;
	        }
	        function PersistentStorage(namespace, override) {
	            this.prefix = [ "__", namespace, "__" ].join("");
	            this.ttlKey = "__ttl__";
	            this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
	            this.ls = override || LOCAL_STORAGE;
	            !this.ls && this._noop();
	        }
	        _.mixin(PersistentStorage.prototype, {
	            _prefix: function(key) {
	                return this.prefix + key;
	            },
	            _ttlKey: function(key) {
	                return this._prefix(key) + this.ttlKey;
	            },
	            _noop: function() {
	                this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
	            },
	            _safeSet: function(key, val) {
	                try {
	                    this.ls.setItem(key, val);
	                } catch (err) {
	                    if (err.name === "QuotaExceededError") {
	                        this.clear();
	                        this._noop();
	                    }
	                }
	            },
	            get: function(key) {
	                if (this.isExpired(key)) {
	                    this.remove(key);
	                }
	                return decode(this.ls.getItem(this._prefix(key)));
	            },
	            set: function(key, val, ttl) {
	                if (_.isNumber(ttl)) {
	                    this._safeSet(this._ttlKey(key), encode(now() + ttl));
	                } else {
	                    this.ls.removeItem(this._ttlKey(key));
	                }
	                return this._safeSet(this._prefix(key), encode(val));
	            },
	            remove: function(key) {
	                this.ls.removeItem(this._ttlKey(key));
	                this.ls.removeItem(this._prefix(key));
	                return this;
	            },
	            clear: function() {
	                var i, keys = gatherMatchingKeys(this.keyMatcher);
	                for (i = keys.length; i--; ) {
	                    this.remove(keys[i]);
	                }
	                return this;
	            },
	            isExpired: function(key) {
	                var ttl = decode(this.ls.getItem(this._ttlKey(key)));
	                return _.isNumber(ttl) && now() > ttl ? true : false;
	            }
	        });
	        return PersistentStorage;
	        function now() {
	            return new Date().getTime();
	        }
	        function encode(val) {
	            return JSON.stringify(_.isUndefined(val) ? null : val);
	        }
	        function decode(val) {
	            return $.parseJSON(val);
	        }
	        function gatherMatchingKeys(keyMatcher) {
	            var i, key, keys = [], len = LOCAL_STORAGE.length;
	            for (i = 0; i < len; i++) {
	                if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
	                    keys.push(key.replace(keyMatcher, ""));
	                }
	            }
	            return keys;
	        }
	    }();
	    var Transport = function() {
	        "use strict";
	        var pendingRequestsCount = 0, pendingRequests = {}, maxPendingRequests = 6, sharedCache = new LruCache(10);
	        function Transport(o) {
	            o = o || {};
	            this.cancelled = false;
	            this.lastReq = null;
	            this._send = o.transport;
	            this._get = o.limiter ? o.limiter(this._get) : this._get;
	            this._cache = o.cache === false ? new LruCache(0) : sharedCache;
	        }
	        Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
	            maxPendingRequests = num;
	        };
	        Transport.resetCache = function resetCache() {
	            sharedCache.reset();
	        };
	        _.mixin(Transport.prototype, {
	            _fingerprint: function fingerprint(o) {
	                o = o || {};
	                return o.url + o.type + $.param(o.data || {});
	            },
	            _get: function(o, cb) {
	                var that = this, fingerprint, jqXhr;
	                fingerprint = this._fingerprint(o);
	                if (this.cancelled || fingerprint !== this.lastReq) {
	                    return;
	                }
	                if (jqXhr = pendingRequests[fingerprint]) {
	                    jqXhr.done(done).fail(fail);
	                } else if (pendingRequestsCount < maxPendingRequests) {
	                    pendingRequestsCount++;
	                    pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
	                } else {
	                    this.onDeckRequestArgs = [].slice.call(arguments, 0);
	                }
	                function done(resp) {
	                    cb(null, resp);
	                    that._cache.set(fingerprint, resp);
	                }
	                function fail() {
	                    cb(true);
	                }
	                function always() {
	                    pendingRequestsCount--;
	                    delete pendingRequests[fingerprint];
	                    if (that.onDeckRequestArgs) {
	                        that._get.apply(that, that.onDeckRequestArgs);
	                        that.onDeckRequestArgs = null;
	                    }
	                }
	            },
	            get: function(o, cb) {
	                var resp, fingerprint;
	                cb = cb || $.noop;
	                o = _.isString(o) ? {
	                    url: o
	                } : o || {};
	                fingerprint = this._fingerprint(o);
	                this.cancelled = false;
	                this.lastReq = fingerprint;
	                if (resp = this._cache.get(fingerprint)) {
	                    cb(null, resp);
	                } else {
	                    this._get(o, cb);
	                }
	            },
	            cancel: function() {
	                this.cancelled = true;
	            }
	        });
	        return Transport;
	    }();
	    var SearchIndex = window.SearchIndex = function() {
	        "use strict";
	        var CHILDREN = "c", IDS = "i";
	        function SearchIndex(o) {
	            o = o || {};
	            if (!o.datumTokenizer || !o.queryTokenizer) {
	                $.error("datumTokenizer and queryTokenizer are both required");
	            }
	            this.identify = o.identify || _.stringify;
	            this.datumTokenizer = o.datumTokenizer;
	            this.queryTokenizer = o.queryTokenizer;
	            this.reset();
	        }
	        _.mixin(SearchIndex.prototype, {
	            bootstrap: function bootstrap(o) {
	                this.datums = o.datums;
	                this.trie = o.trie;
	            },
	            add: function(data) {
	                var that = this;
	                data = _.isArray(data) ? data : [ data ];
	                _.each(data, function(datum) {
	                    var id, tokens;
	                    that.datums[id = that.identify(datum)] = datum;
	                    tokens = normalizeTokens(that.datumTokenizer(datum));
	                    _.each(tokens, function(token) {
	                        var node, chars, ch;
	                        node = that.trie;
	                        chars = token.split("");
	                        while (ch = chars.shift()) {
	                            node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
	                            node[IDS].push(id);
	                        }
	                    });
	                });
	            },
	            get: function get(ids) {
	                var that = this;
	                return _.map(ids, function(id) {
	                    return that.datums[id];
	                });
	            },
	            search: function search(query) {
	                var that = this, tokens, matches;
	                tokens = normalizeTokens(this.queryTokenizer(query));
	                _.each(tokens, function(token) {
	                    var node, chars, ch, ids;
	                    if (matches && matches.length === 0) {
	                        return false;
	                    }
	                    node = that.trie;
	                    chars = token.split("");
	                    while (node && (ch = chars.shift())) {
	                        node = node[CHILDREN][ch];
	                    }
	                    if (node && chars.length === 0) {
	                        ids = node[IDS].slice(0);
	                        matches = matches ? getIntersection(matches, ids) : ids;
	                    } else {
	                        matches = [];
	                        return false;
	                    }
	                });
	                return matches ? _.map(unique(matches), function(id) {
	                    return that.datums[id];
	                }) : [];
	            },
	            all: function all() {
	                var values = [];
	                for (var key in this.datums) {
	                    values.push(this.datums[key]);
	                }
	                return values;
	            },
	            reset: function reset() {
	                this.datums = {};
	                this.trie = newNode();
	            },
	            serialize: function serialize() {
	                return {
	                    datums: this.datums,
	                    trie: this.trie
	                };
	            }
	        });
	        return SearchIndex;
	        function normalizeTokens(tokens) {
	            tokens = _.filter(tokens, function(token) {
	                return !!token;
	            });
	            tokens = _.map(tokens, function(token) {
	                return token.toLowerCase();
	            });
	            return tokens;
	        }
	        function newNode() {
	            var node = {};
	            node[IDS] = [];
	            node[CHILDREN] = {};
	            return node;
	        }
	        function unique(array) {
	            var seen = {}, uniques = [];
	            for (var i = 0, len = array.length; i < len; i++) {
	                if (!seen[array[i]]) {
	                    seen[array[i]] = true;
	                    uniques.push(array[i]);
	                }
	            }
	            return uniques;
	        }
	        function getIntersection(arrayA, arrayB) {
	            var ai = 0, bi = 0, intersection = [];
	            arrayA = arrayA.sort();
	            arrayB = arrayB.sort();
	            var lenArrayA = arrayA.length, lenArrayB = arrayB.length;
	            while (ai < lenArrayA && bi < lenArrayB) {
	                if (arrayA[ai] < arrayB[bi]) {
	                    ai++;
	                } else if (arrayA[ai] > arrayB[bi]) {
	                    bi++;
	                } else {
	                    intersection.push(arrayA[ai]);
	                    ai++;
	                    bi++;
	                }
	            }
	            return intersection;
	        }
	    }();
	    var Prefetch = function() {
	        "use strict";
	        var keys;
	        keys = {
	            data: "data",
	            protocol: "protocol",
	            thumbprint: "thumbprint"
	        };
	        function Prefetch(o) {
	            this.url = o.url;
	            this.ttl = o.ttl;
	            this.cache = o.cache;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = o.transport;
	            this.thumbprint = o.thumbprint;
	            this.storage = new PersistentStorage(o.cacheKey);
	        }
	        _.mixin(Prefetch.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            store: function store(data) {
	                if (!this.cache) {
	                    return;
	                }
	                this.storage.set(keys.data, data, this.ttl);
	                this.storage.set(keys.protocol, location.protocol, this.ttl);
	                this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
	            },
	            fromCache: function fromCache() {
	                var stored = {}, isExpired;
	                if (!this.cache) {
	                    return null;
	                }
	                stored.data = this.storage.get(keys.data);
	                stored.protocol = this.storage.get(keys.protocol);
	                stored.thumbprint = this.storage.get(keys.thumbprint);
	                isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
	                return stored.data && !isExpired ? stored.data : null;
	            },
	            fromNetwork: function(cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                settings = this.prepare(this._settings());
	                this.transport(settings).fail(onError).done(onResponse);
	                function onError() {
	                    cb(true);
	                }
	                function onResponse(resp) {
	                    cb(null, that.transform(resp));
	                }
	            },
	            clear: function clear() {
	                this.storage.clear();
	                return this;
	            }
	        });
	        return Prefetch;
	    }();
	    var Remote = function() {
	        "use strict";
	        function Remote(o) {
	            this.url = o.url;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = new Transport({
	                cache: o.cache,
	                limiter: o.limiter,
	                transport: o.transport
	            });
	        }
	        _.mixin(Remote.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            get: function get(query, cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                query = query || "";
	                settings = this.prepare(query, this._settings());
	                return this.transport.get(settings, onResponse);
	                function onResponse(err, resp) {
	                    err ? cb([]) : cb(that.transform(resp));
	                }
	            },
	            cancelLastRequest: function cancelLastRequest() {
	                this.transport.cancel();
	            }
	        });
	        return Remote;
	    }();
	    var oParser = function() {
	        "use strict";
	        return function parse(o) {
	            var defaults, sorter;
	            defaults = {
	                initialize: true,
	                identify: _.stringify,
	                datumTokenizer: null,
	                queryTokenizer: null,
	                sufficient: 5,
	                sorter: null,
	                local: [],
	                prefetch: null,
	                remote: null
	            };
	            o = _.mixin(defaults, o || {});
	            !o.datumTokenizer && $.error("datumTokenizer is required");
	            !o.queryTokenizer && $.error("queryTokenizer is required");
	            sorter = o.sorter;
	            o.sorter = sorter ? function(x) {
	                return x.sort(sorter);
	            } : _.identity;
	            o.local = _.isFunction(o.local) ? o.local() : o.local;
	            o.prefetch = parsePrefetch(o.prefetch);
	            o.remote = parseRemote(o.remote);
	            return o;
	        };
	        function parsePrefetch(o) {
	            var defaults;
	            if (!o) {
	                return null;
	            }
	            defaults = {
	                url: null,
	                ttl: 24 * 60 * 60 * 1e3,
	                cache: true,
	                cacheKey: null,
	                thumbprint: "",
	                prepare: _.identity,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("prefetch requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.cacheKey = o.cacheKey || o.url;
	            o.thumbprint = VERSION + o.thumbprint;
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            return o;
	        }
	        function parseRemote(o) {
	            var defaults;
	            if (!o) {
	                return;
	            }
	            defaults = {
	                url: null,
	                cache: true,
	                prepare: null,
	                replace: null,
	                wildcard: null,
	                limiter: null,
	                rateLimitBy: "debounce",
	                rateLimitWait: 300,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("remote requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.prepare = toRemotePrepare(o);
	            o.limiter = toLimiter(o);
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            delete o.replace;
	            delete o.wildcard;
	            delete o.rateLimitBy;
	            delete o.rateLimitWait;
	            return o;
	        }
	        function toRemotePrepare(o) {
	            var prepare, replace, wildcard;
	            prepare = o.prepare;
	            replace = o.replace;
	            wildcard = o.wildcard;
	            if (prepare) {
	                return prepare;
	            }
	            if (replace) {
	                prepare = prepareByReplace;
	            } else if (o.wildcard) {
	                prepare = prepareByWildcard;
	            } else {
	                prepare = idenityPrepare;
	            }
	            return prepare;
	            function prepareByReplace(query, settings) {
	                settings.url = replace(settings.url, query);
	                return settings;
	            }
	            function prepareByWildcard(query, settings) {
	                settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
	                return settings;
	            }
	            function idenityPrepare(query, settings) {
	                return settings;
	            }
	        }
	        function toLimiter(o) {
	            var limiter, method, wait;
	            limiter = o.limiter;
	            method = o.rateLimitBy;
	            wait = o.rateLimitWait;
	            if (!limiter) {
	                limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
	            }
	            return limiter;
	            function debounce(wait) {
	                return function debounce(fn) {
	                    return _.debounce(fn, wait);
	                };
	            }
	            function throttle(wait) {
	                return function throttle(fn) {
	                    return _.throttle(fn, wait);
	                };
	            }
	        }
	        function callbackToDeferred(fn) {
	            return function wrapper(o) {
	                var deferred = $.Deferred();
	                fn(o, onSuccess, onError);
	                return deferred;
	                function onSuccess(resp) {
	                    _.defer(function() {
	                        deferred.resolve(resp);
	                    });
	                }
	                function onError(err) {
	                    _.defer(function() {
	                        deferred.reject(err);
	                    });
	                }
	            };
	        }
	    }();
	    var Bloodhound = function() {
	        "use strict";
	        var old;
	        old = window && window.Bloodhound;
	        function Bloodhound(o) {
	            o = oParser(o);
	            this.sorter = o.sorter;
	            this.identify = o.identify;
	            this.sufficient = o.sufficient;
	            this.local = o.local;
	            this.remote = o.remote ? new Remote(o.remote) : null;
	            this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
	            this.index = new SearchIndex({
	                identify: this.identify,
	                datumTokenizer: o.datumTokenizer,
	                queryTokenizer: o.queryTokenizer
	            });
	            o.initialize !== false && this.initialize();
	        }
	        Bloodhound.noConflict = function noConflict() {
	            window && (window.Bloodhound = old);
	            return Bloodhound;
	        };
	        Bloodhound.tokenizers = tokenizers;
	        _.mixin(Bloodhound.prototype, {
	            __ttAdapter: function ttAdapter() {
	                var that = this;
	                return this.remote ? withAsync : withoutAsync;
	                function withAsync(query, sync, async) {
	                    return that.search(query, sync, async);
	                }
	                function withoutAsync(query, sync) {
	                    return that.search(query, sync);
	                }
	            },
	            _loadPrefetch: function loadPrefetch() {
	                var that = this, deferred, serialized;
	                deferred = $.Deferred();
	                if (!this.prefetch) {
	                    deferred.resolve();
	                } else if (serialized = this.prefetch.fromCache()) {
	                    this.index.bootstrap(serialized);
	                    deferred.resolve();
	                } else {
	                    this.prefetch.fromNetwork(done);
	                }
	                return deferred.promise();
	                function done(err, data) {
	                    if (err) {
	                        return deferred.reject();
	                    }
	                    that.add(data);
	                    that.prefetch.store(that.index.serialize());
	                    deferred.resolve();
	                }
	            },
	            _initialize: function initialize() {
	                var that = this, deferred;
	                this.clear();
	                (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
	                return this.initPromise;
	                function addLocalToIndex() {
	                    that.add(that.local);
	                }
	            },
	            initialize: function initialize(force) {
	                return !this.initPromise || force ? this._initialize() : this.initPromise;
	            },
	            add: function add(data) {
	                this.index.add(data);
	                return this;
	            },
	            get: function get(ids) {
	                ids = _.isArray(ids) ? ids : [].slice.call(arguments);
	                return this.index.get(ids);
	            },
	            search: function search(query, sync, async) {
	                var that = this, local;
	                local = this.sorter(this.index.search(query));
	                sync(this.remote ? local.slice() : local);
	                if (this.remote && local.length < this.sufficient) {
	                    this.remote.get(query, processRemote);
	                } else if (this.remote) {
	                    this.remote.cancelLastRequest();
	                }
	                return this;
	                function processRemote(remote) {
	                    var nonDuplicates = [];
	                    _.each(remote, function(r) {
	                        !_.some(local, function(l) {
	                            return that.identify(r) === that.identify(l);
	                        }) && nonDuplicates.push(r);
	                    });
	                    async && async(nonDuplicates);
	                }
	            },
	            all: function all() {
	                return this.index.all();
	            },
	            clear: function clear() {
	                this.index.reset();
	                return this;
	            },
	            clearPrefetchCache: function clearPrefetchCache() {
	                this.prefetch && this.prefetch.clear();
	                return this;
	            },
	            clearRemoteCache: function clearRemoteCache() {
	                Transport.resetCache();
	                return this;
	            },
	            ttAdapter: function ttAdapter() {
	                return this.__ttAdapter();
	            }
	        });
	        return Bloodhound;
	    }();
	    return Bloodhound;
	});
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(14) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === "object") {
	        module.exports = factory(require("jquery"));
	    } else {
	        factory(jQuery);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            noop: function() {}
	        };
	    }();
	    var WWW = function() {
	        "use strict";
	        var defaultClassNames = {
	            wrapper: "twitter-typeahead",
	            input: "tt-input",
	            hint: "tt-hint",
	            menu: "tt-menu",
	            dataset: "tt-dataset",
	            suggestion: "tt-suggestion",
	            selectable: "tt-selectable",
	            empty: "tt-empty",
	            open: "tt-open",
	            cursor: "tt-cursor",
	            highlight: "tt-highlight"
	        };
	        return build;
	        function build(o) {
	            var www, classes;
	            classes = _.mixin({}, defaultClassNames, o);
	            www = {
	                css: buildCss(),
	                classes: classes,
	                html: buildHtml(classes),
	                selectors: buildSelectors(classes)
	            };
	            return {
	                css: www.css,
	                html: www.html,
	                classes: www.classes,
	                selectors: www.selectors,
	                mixin: function(o) {
	                    _.mixin(o, www);
	                }
	            };
	        }
	        function buildHtml(c) {
	            return {
	                wrapper: '<span class="' + c.wrapper + '"></span>',
	                menu: '<div class="' + c.menu + '"></div>'
	            };
	        }
	        function buildSelectors(classes) {
	            var selectors = {};
	            _.each(classes, function(v, k) {
	                selectors[k] = "." + v;
	            });
	            return selectors;
	        }
	        function buildCss() {
	            var css = {
	                wrapper: {
	                    position: "relative",
	                    display: "inline-block"
	                },
	                hint: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    borderColor: "transparent",
	                    boxShadow: "none",
	                    opacity: "1"
	                },
	                input: {
	                    position: "relative",
	                    verticalAlign: "top",
	                    backgroundColor: "transparent"
	                },
	                inputWithNoHint: {
	                    position: "relative",
	                    verticalAlign: "top"
	                },
	                menu: {
	                    position: "absolute",
	                    top: "100%",
	                    left: "0",
	                    zIndex: "100",
	                    display: "none"
	                },
	                ltr: {
	                    left: "0",
	                    right: "auto"
	                },
	                rtl: {
	                    left: "auto",
	                    right: " 0"
	                }
	            };
	            if (_.isMsie()) {
	                _.mixin(css.input, {
	                    backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
	                });
	            }
	            return css;
	        }
	    }();
	    var EventBus = function() {
	        "use strict";
	        var namespace, deprecationMap;
	        namespace = "typeahead:";
	        deprecationMap = {
	            render: "rendered",
	            cursorchange: "cursorchanged",
	            select: "selected",
	            autocomplete: "autocompleted"
	        };
	        function EventBus(o) {
	            if (!o || !o.el) {
	                $.error("EventBus initialized without el");
	            }
	            this.$el = $(o.el);
	        }
	        _.mixin(EventBus.prototype, {
	            _trigger: function(type, args) {
	                var $e;
	                $e = $.Event(namespace + type);
	                (args = args || []).unshift($e);
	                this.$el.trigger.apply(this.$el, args);
	                return $e;
	            },
	            before: function(type) {
	                var args, $e;
	                args = [].slice.call(arguments, 1);
	                $e = this._trigger("before" + type, args);
	                return $e.isDefaultPrevented();
	            },
	            trigger: function(type) {
	                var deprecatedType;
	                this._trigger(type, [].slice.call(arguments, 1));
	                if (deprecatedType = deprecationMap[type]) {
	                    this._trigger(deprecatedType, [].slice.call(arguments, 1));
	                }
	            }
	        });
	        return EventBus;
	    }();
	    var EventEmitter = function() {
	        "use strict";
	        var splitter = /\s+/, nextTick = getNextTick();
	        return {
	            onSync: onSync,
	            onAsync: onAsync,
	            off: off,
	            trigger: trigger
	        };
	        function on(method, types, cb, context) {
	            var type;
	            if (!cb) {
	                return this;
	            }
	            types = types.split(splitter);
	            cb = context ? bindContext(cb, context) : cb;
	            this._callbacks = this._callbacks || {};
	            while (type = types.shift()) {
	                this._callbacks[type] = this._callbacks[type] || {
	                    sync: [],
	                    async: []
	                };
	                this._callbacks[type][method].push(cb);
	            }
	            return this;
	        }
	        function onAsync(types, cb, context) {
	            return on.call(this, "async", types, cb, context);
	        }
	        function onSync(types, cb, context) {
	            return on.call(this, "sync", types, cb, context);
	        }
	        function off(types) {
	            var type;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            while (type = types.shift()) {
	                delete this._callbacks[type];
	            }
	            return this;
	        }
	        function trigger(types) {
	            var type, callbacks, args, syncFlush, asyncFlush;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            args = [].slice.call(arguments, 1);
	            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
	                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
	                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
	                syncFlush() && nextTick(asyncFlush);
	            }
	            return this;
	        }
	        function getFlush(callbacks, context, args) {
	            return flush;
	            function flush() {
	                var cancelled;
	                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
	                    cancelled = callbacks[i].apply(context, args) === false;
	                }
	                return !cancelled;
	            }
	        }
	        function getNextTick() {
	            var nextTickFn;
	            if (window.setImmediate) {
	                nextTickFn = function nextTickSetImmediate(fn) {
	                    setImmediate(function() {
	                        fn();
	                    });
	                };
	            } else {
	                nextTickFn = function nextTickSetTimeout(fn) {
	                    setTimeout(function() {
	                        fn();
	                    }, 0);
	                };
	            }
	            return nextTickFn;
	        }
	        function bindContext(fn, context) {
	            return fn.bind ? fn.bind(context) : function() {
	                fn.apply(context, [].slice.call(arguments, 0));
	            };
	        }
	    }();
	    var highlight = function(doc) {
	        "use strict";
	        var defaults = {
	            node: null,
	            pattern: null,
	            tagName: "strong",
	            className: null,
	            wordsOnly: false,
	            caseSensitive: false
	        };
	        return function hightlight(o) {
	            var regex;
	            o = _.mixin({}, defaults, o);
	            if (!o.node || !o.pattern) {
	                return;
	            }
	            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
	            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
	            traverse(o.node, hightlightTextNode);
	            function hightlightTextNode(textNode) {
	                var match, patternNode, wrapperNode;
	                if (match = regex.exec(textNode.data)) {
	                    wrapperNode = doc.createElement(o.tagName);
	                    o.className && (wrapperNode.className = o.className);
	                    patternNode = textNode.splitText(match.index);
	                    patternNode.splitText(match[0].length);
	                    wrapperNode.appendChild(patternNode.cloneNode(true));
	                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
	                }
	                return !!match;
	            }
	            function traverse(el, hightlightTextNode) {
	                var childNode, TEXT_NODE_TYPE = 3;
	                for (var i = 0; i < el.childNodes.length; i++) {
	                    childNode = el.childNodes[i];
	                    if (childNode.nodeType === TEXT_NODE_TYPE) {
	                        i += hightlightTextNode(childNode) ? 1 : 0;
	                    } else {
	                        traverse(childNode, hightlightTextNode);
	                    }
	                }
	            }
	        };
	        function getRegex(patterns, caseSensitive, wordsOnly) {
	            var escapedPatterns = [], regexStr;
	            for (var i = 0, len = patterns.length; i < len; i++) {
	                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
	            }
	            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
	            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
	        }
	    }(window.document);
	    var Input = function() {
	        "use strict";
	        var specialKeyCodeMap;
	        specialKeyCodeMap = {
	            9: "tab",
	            27: "esc",
	            37: "left",
	            39: "right",
	            13: "enter",
	            38: "up",
	            40: "down"
	        };
	        function Input(o, www) {
	            o = o || {};
	            if (!o.input) {
	                $.error("input is missing");
	            }
	            www.mixin(this);
	            this.$hint = $(o.hint);
	            this.$input = $(o.input);
	            this.query = this.$input.val();
	            this.queryWhenFocused = this.hasFocus() ? this.query : null;
	            this.$overflowHelper = buildOverflowHelper(this.$input);
	            this._checkLanguageDirection();
	            if (this.$hint.length === 0) {
	                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
	            }
	        }
	        Input.normalizeQuery = function(str) {
	            return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
	        };
	        _.mixin(Input.prototype, EventEmitter, {
	            _onBlur: function onBlur() {
	                this.resetInputValue();
	                this.trigger("blurred");
	            },
	            _onFocus: function onFocus() {
	                this.queryWhenFocused = this.query;
	                this.trigger("focused");
	            },
	            _onKeydown: function onKeydown($e) {
	                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
	                this._managePreventDefault(keyName, $e);
	                if (keyName && this._shouldTrigger(keyName, $e)) {
	                    this.trigger(keyName + "Keyed", $e);
	                }
	            },
	            _onInput: function onInput() {
	                this._setQuery(this.getInputValue());
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            _managePreventDefault: function managePreventDefault(keyName, $e) {
	                var preventDefault;
	                switch (keyName) {
	                  case "up":
	                  case "down":
	                    preventDefault = !withModifier($e);
	                    break;
	
	                  default:
	                    preventDefault = false;
	                }
	                preventDefault && $e.preventDefault();
	            },
	            _shouldTrigger: function shouldTrigger(keyName, $e) {
	                var trigger;
	                switch (keyName) {
	                  case "tab":
	                    trigger = !withModifier($e);
	                    break;
	
	                  default:
	                    trigger = true;
	                }
	                return trigger;
	            },
	            _checkLanguageDirection: function checkLanguageDirection() {
	                var dir = (this.$input.css("direction") || "ltr").toLowerCase();
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.$hint.attr("dir", dir);
	                    this.trigger("langDirChanged", dir);
	                }
	            },
	            _setQuery: function setQuery(val, silent) {
	                var areEquivalent, hasDifferentWhitespace;
	                areEquivalent = areQueriesEquivalent(val, this.query);
	                hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
	                this.query = val;
	                if (!silent && !areEquivalent) {
	                    this.trigger("queryChanged", this.query);
	                } else if (!silent && hasDifferentWhitespace) {
	                    this.trigger("whitespaceChanged", this.query);
	                }
	            },
	            bind: function() {
	                var that = this, onBlur, onFocus, onKeydown, onInput;
	                onBlur = _.bind(this._onBlur, this);
	                onFocus = _.bind(this._onFocus, this);
	                onKeydown = _.bind(this._onKeydown, this);
	                onInput = _.bind(this._onInput, this);
	                this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
	                if (!_.isMsie() || _.isMsie() > 9) {
	                    this.$input.on("input.tt", onInput);
	                } else {
	                    this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
	                        if (specialKeyCodeMap[$e.which || $e.keyCode]) {
	                            return;
	                        }
	                        _.defer(_.bind(that._onInput, that, $e));
	                    });
	                }
	                return this;
	            },
	            focus: function focus() {
	                this.$input.focus();
	            },
	            blur: function blur() {
	                this.$input.blur();
	            },
	            getLangDir: function getLangDir() {
	                return this.dir;
	            },
	            getQuery: function getQuery() {
	                return this.query || "";
	            },
	            setQuery: function setQuery(val, silent) {
	                this.setInputValue(val);
	                this._setQuery(val, silent);
	            },
	            hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
	                return this.query !== this.queryWhenFocused;
	            },
	            getInputValue: function getInputValue() {
	                return this.$input.val();
	            },
	            setInputValue: function setInputValue(value) {
	                this.$input.val(value);
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            resetInputValue: function resetInputValue() {
	                this.setInputValue(this.query);
	            },
	            getHint: function getHint() {
	                return this.$hint.val();
	            },
	            setHint: function setHint(value) {
	                this.$hint.val(value);
	            },
	            clearHint: function clearHint() {
	                this.setHint("");
	            },
	            clearHintIfInvalid: function clearHintIfInvalid() {
	                var val, hint, valIsPrefixOfHint, isValid;
	                val = this.getInputValue();
	                hint = this.getHint();
	                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
	                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
	                !isValid && this.clearHint();
	            },
	            hasFocus: function hasFocus() {
	                return this.$input.is(":focus");
	            },
	            hasOverflow: function hasOverflow() {
	                var constraint = this.$input.width() - 2;
	                this.$overflowHelper.text(this.getInputValue());
	                return this.$overflowHelper.width() >= constraint;
	            },
	            isCursorAtEnd: function() {
	                var valueLength, selectionStart, range;
	                valueLength = this.$input.val().length;
	                selectionStart = this.$input[0].selectionStart;
	                if (_.isNumber(selectionStart)) {
	                    return selectionStart === valueLength;
	                } else if (document.selection) {
	                    range = document.selection.createRange();
	                    range.moveStart("character", -valueLength);
	                    return valueLength === range.text.length;
	                }
	                return true;
	            },
	            destroy: function destroy() {
	                this.$hint.off(".tt");
	                this.$input.off(".tt");
	                this.$overflowHelper.remove();
	                this.$hint = this.$input = this.$overflowHelper = $("<div>");
	            }
	        });
	        return Input;
	        function buildOverflowHelper($input) {
	            return $('<pre aria-hidden="true"></pre>').css({
	                position: "absolute",
	                visibility: "hidden",
	                whiteSpace: "pre",
	                fontFamily: $input.css("font-family"),
	                fontSize: $input.css("font-size"),
	                fontStyle: $input.css("font-style"),
	                fontVariant: $input.css("font-variant"),
	                fontWeight: $input.css("font-weight"),
	                wordSpacing: $input.css("word-spacing"),
	                letterSpacing: $input.css("letter-spacing"),
	                textIndent: $input.css("text-indent"),
	                textRendering: $input.css("text-rendering"),
	                textTransform: $input.css("text-transform")
	            }).insertAfter($input);
	        }
	        function areQueriesEquivalent(a, b) {
	            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
	        }
	        function withModifier($e) {
	            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
	        }
	    }();
	    var Dataset = function() {
	        "use strict";
	        var keys, nameGenerator;
	        keys = {
	            val: "tt-selectable-display",
	            obj: "tt-selectable-object"
	        };
	        nameGenerator = _.getIdGenerator();
	        function Dataset(o, www) {
	            o = o || {};
	            o.templates = o.templates || {};
	            o.templates.notFound = o.templates.notFound || o.templates.empty;
	            if (!o.source) {
	                $.error("missing source");
	            }
	            if (!o.node) {
	                $.error("missing node");
	            }
	            if (o.name && !isValidName(o.name)) {
	                $.error("invalid dataset name: " + o.name);
	            }
	            www.mixin(this);
	            this.highlight = !!o.highlight;
	            this.name = o.name || nameGenerator();
	            this.limit = o.limit || 5;
	            this.displayFn = getDisplayFn(o.display || o.displayKey);
	            this.templates = getTemplates(o.templates, this.displayFn);
	            this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
	            this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
	            this._resetLastSuggestion();
	            this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
	        }
	        Dataset.extractData = function extractData(el) {
	            var $el = $(el);
	            if ($el.data(keys.obj)) {
	                return {
	                    val: $el.data(keys.val) || "",
	                    obj: $el.data(keys.obj) || null
	                };
	            }
	            return null;
	        };
	        _.mixin(Dataset.prototype, EventEmitter, {
	            _overwrite: function overwrite(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (this.async && this.templates.pending) {
	                    this._renderPending(query);
	                } else if (!this.async && this.templates.notFound) {
	                    this._renderNotFound(query);
	                } else {
	                    this._empty();
	                }
	                this.trigger("rendered", this.name, suggestions, false);
	            },
	            _append: function append(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length && this.$lastSuggestion.length) {
	                    this._appendSuggestions(query, suggestions);
	                } else if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (!this.$lastSuggestion.length && this.templates.notFound) {
	                    this._renderNotFound(query);
	                }
	                this.trigger("rendered", this.name, suggestions, true);
	            },
	            _renderSuggestions: function renderSuggestions(query, suggestions) {
	                var $fragment;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                this.$lastSuggestion = $fragment.children().last();
	                this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
	            },
	            _appendSuggestions: function appendSuggestions(query, suggestions) {
	                var $fragment, $lastSuggestion;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                $lastSuggestion = $fragment.children().last();
	                this.$lastSuggestion.after($fragment);
	                this.$lastSuggestion = $lastSuggestion;
	            },
	            _renderPending: function renderPending(query) {
	                var template = this.templates.pending;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _renderNotFound: function renderNotFound(query) {
	                var template = this.templates.notFound;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _empty: function empty() {
	                this.$el.empty();
	                this._resetLastSuggestion();
	            },
	            _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
	                var that = this, fragment;
	                fragment = document.createDocumentFragment();
	                _.each(suggestions, function getSuggestionNode(suggestion) {
	                    var $el, context;
	                    context = that._injectQuery(query, suggestion);
	                    $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
	                    fragment.appendChild($el[0]);
	                });
	                this.highlight && highlight({
	                    className: this.classes.highlight,
	                    node: fragment,
	                    pattern: query
	                });
	                return $(fragment);
	            },
	            _getFooter: function getFooter(query, suggestions) {
	                return this.templates.footer ? this.templates.footer({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _getHeader: function getHeader(query, suggestions) {
	                return this.templates.header ? this.templates.header({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _resetLastSuggestion: function resetLastSuggestion() {
	                this.$lastSuggestion = $();
	            },
	            _injectQuery: function injectQuery(query, obj) {
	                return _.isObject(obj) ? _.mixin({
	                    _query: query
	                }, obj) : obj;
	            },
	            update: function update(query) {
	                var that = this, canceled = false, syncCalled = false, rendered = 0;
	                this.cancel();
	                this.cancel = function cancel() {
	                    canceled = true;
	                    that.cancel = $.noop;
	                    that.async && that.trigger("asyncCanceled", query);
	                };
	                this.source(query, sync, async);
	                !syncCalled && sync([]);
	                function sync(suggestions) {
	                    if (syncCalled) {
	                        return;
	                    }
	                    syncCalled = true;
	                    suggestions = (suggestions || []).slice(0, that.limit);
	                    rendered = suggestions.length;
	                    that._overwrite(query, suggestions);
	                    if (rendered < that.limit && that.async) {
	                        that.trigger("asyncRequested", query);
	                    }
	                }
	                function async(suggestions) {
	                    suggestions = suggestions || [];
	                    if (!canceled && rendered < that.limit) {
	                        that.cancel = $.noop;
	                        rendered += suggestions.length;
	                        that._append(query, suggestions.slice(0, that.limit - rendered));
	                        that.async && that.trigger("asyncReceived", query);
	                    }
	                }
	            },
	            cancel: $.noop,
	            clear: function clear() {
	                this._empty();
	                this.cancel();
	                this.trigger("cleared");
	            },
	            isEmpty: function isEmpty() {
	                return this.$el.is(":empty");
	            },
	            destroy: function destroy() {
	                this.$el = $("<div>");
	            }
	        });
	        return Dataset;
	        function getDisplayFn(display) {
	            display = display || _.stringify;
	            return _.isFunction(display) ? display : displayFn;
	            function displayFn(obj) {
	                return obj[display];
	            }
	        }
	        function getTemplates(templates, displayFn) {
	            return {
	                notFound: templates.notFound && _.templatify(templates.notFound),
	                pending: templates.pending && _.templatify(templates.pending),
	                header: templates.header && _.templatify(templates.header),
	                footer: templates.footer && _.templatify(templates.footer),
	                suggestion: templates.suggestion || suggestionTemplate
	            };
	            function suggestionTemplate(context) {
	                return $("<div>").text(displayFn(context));
	            }
	        }
	        function isValidName(str) {
	            return /^[_a-zA-Z0-9-]+$/.test(str);
	        }
	    }();
	    var Menu = function() {
	        "use strict";
	        function Menu(o, www) {
	            var that = this;
	            o = o || {};
	            if (!o.node) {
	                $.error("node is required");
	            }
	            www.mixin(this);
	            this.$node = $(o.node);
	            this.query = null;
	            this.datasets = _.map(o.datasets, initializeDataset);
	            function initializeDataset(oDataset) {
	                var node = that.$node.find(oDataset.node).first();
	                oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
	                return new Dataset(oDataset, www);
	            }
	        }
	        _.mixin(Menu.prototype, EventEmitter, {
	            _onSelectableClick: function onSelectableClick($e) {
	                this.trigger("selectableClicked", $($e.currentTarget));
	            },
	            _onRendered: function onRendered(type, dataset, suggestions, async) {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetRendered", dataset, suggestions, async);
	            },
	            _onCleared: function onCleared() {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetCleared");
	            },
	            _propagate: function propagate() {
	                this.trigger.apply(this, arguments);
	            },
	            _allDatasetsEmpty: function allDatasetsEmpty() {
	                return _.every(this.datasets, isDatasetEmpty);
	                function isDatasetEmpty(dataset) {
	                    return dataset.isEmpty();
	                }
	            },
	            _getSelectables: function getSelectables() {
	                return this.$node.find(this.selectors.selectable);
	            },
	            _removeCursor: function _removeCursor() {
	                var $selectable = this.getActiveSelectable();
	                $selectable && $selectable.removeClass(this.classes.cursor);
	            },
	            _ensureVisible: function ensureVisible($el) {
	                var elTop, elBottom, nodeScrollTop, nodeHeight;
	                elTop = $el.position().top;
	                elBottom = elTop + $el.outerHeight(true);
	                nodeScrollTop = this.$node.scrollTop();
	                nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
	                if (elTop < 0) {
	                    this.$node.scrollTop(nodeScrollTop + elTop);
	                } else if (nodeHeight < elBottom) {
	                    this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
	                }
	            },
	            bind: function() {
	                var that = this, onSelectableClick;
	                onSelectableClick = _.bind(this._onSelectableClick, this);
	                this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
	                _.each(this.datasets, function(dataset) {
	                    dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                return this.$node.hasClass(this.classes.open);
	            },
	            open: function open() {
	                this.$node.addClass(this.classes.open);
	            },
	            close: function close() {
	                this.$node.removeClass(this.classes.open);
	                this._removeCursor();
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.attr("dir", dir);
	            },
	            selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
	                var $selectables, $oldCursor, oldIndex, newIndex;
	                $oldCursor = this.getActiveSelectable();
	                $selectables = this._getSelectables();
	                oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
	                newIndex = oldIndex + delta;
	                newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
	                newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
	                return newIndex === -1 ? null : $selectables.eq(newIndex);
	            },
	            setCursor: function setCursor($selectable) {
	                this._removeCursor();
	                if ($selectable = $selectable && $selectable.first()) {
	                    $selectable.addClass(this.classes.cursor);
	                    this._ensureVisible($selectable);
	                }
	            },
	            getSelectableData: function getSelectableData($el) {
	                return $el && $el.length ? Dataset.extractData($el) : null;
	            },
	            getActiveSelectable: function getActiveSelectable() {
	                var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
	                return $selectable.length ? $selectable : null;
	            },
	            getTopSelectable: function getTopSelectable() {
	                var $selectable = this._getSelectables().first();
	                return $selectable.length ? $selectable : null;
	            },
	            update: function update(query) {
	                var isValidUpdate = query !== this.query;
	                if (isValidUpdate) {
	                    this.query = query;
	                    _.each(this.datasets, updateDataset);
	                }
	                return isValidUpdate;
	                function updateDataset(dataset) {
	                    dataset.update(query);
	                }
	            },
	            empty: function empty() {
	                _.each(this.datasets, clearDataset);
	                this.query = null;
	                this.$node.addClass(this.classes.empty);
	                function clearDataset(dataset) {
	                    dataset.clear();
	                }
	            },
	            destroy: function destroy() {
	                this.$node.off(".tt");
	                this.$node = $("<div>");
	                _.each(this.datasets, destroyDataset);
	                function destroyDataset(dataset) {
	                    dataset.destroy();
	                }
	            }
	        });
	        return Menu;
	    }();
	    var DefaultMenu = function() {
	        "use strict";
	        var s = Menu.prototype;
	        function DefaultMenu() {
	            Menu.apply(this, [].slice.call(arguments, 0));
	        }
	        _.mixin(DefaultMenu.prototype, Menu.prototype, {
	            open: function open() {
	                !this._allDatasetsEmpty() && this._show();
	                return s.open.apply(this, [].slice.call(arguments, 0));
	            },
	            close: function close() {
	                this._hide();
	                return s.close.apply(this, [].slice.call(arguments, 0));
	            },
	            _onRendered: function onRendered() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onRendered.apply(this, [].slice.call(arguments, 0));
	            },
	            _onCleared: function onCleared() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onCleared.apply(this, [].slice.call(arguments, 0));
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
	                return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
	            },
	            _hide: function hide() {
	                this.$node.hide();
	            },
	            _show: function show() {
	                this.$node.css("display", "block");
	            }
	        });
	        return DefaultMenu;
	    }();
	    var Typeahead = function() {
	        "use strict";
	        function Typeahead(o, www) {
	            var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
	            o = o || {};
	            if (!o.input) {
	                $.error("missing input");
	            }
	            if (!o.menu) {
	                $.error("missing menu");
	            }
	            if (!o.eventBus) {
	                $.error("missing event bus");
	            }
	            www.mixin(this);
	            this.eventBus = o.eventBus;
	            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
	            this.input = o.input;
	            this.menu = o.menu;
	            this.enabled = true;
	            this.active = false;
	            this.input.hasFocus() && this.activate();
	            this.dir = this.input.getLangDir();
	            this._hacks();
	            this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
	            onFocused = c(this, "activate", "open", "_onFocused");
	            onBlurred = c(this, "deactivate", "_onBlurred");
	            onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
	            onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
	            onEscKeyed = c(this, "isActive", "_onEscKeyed");
	            onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
	            onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
	            onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
	            onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
	            onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
	            onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
	            this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
	        }
	        _.mixin(Typeahead.prototype, {
	            _hacks: function hacks() {
	                var $input, $menu;
	                $input = this.input.$input || $("<div>");
	                $menu = this.menu.$node || $("<div>");
	                $input.on("blur.tt", function($e) {
	                    var active, isActive, hasActive;
	                    active = document.activeElement;
	                    isActive = $menu.is(active);
	                    hasActive = $menu.has(active).length > 0;
	                    if (_.isMsie() && (isActive || hasActive)) {
	                        $e.preventDefault();
	                        $e.stopImmediatePropagation();
	                        _.defer(function() {
	                            $input.focus();
	                        });
	                    }
	                });
	                $menu.on("mousedown.tt", function($e) {
	                    $e.preventDefault();
	                });
	            },
	            _onSelectableClicked: function onSelectableClicked(type, $el) {
	                this.select($el);
	            },
	            _onDatasetCleared: function onDatasetCleared() {
	                this._updateHint();
	            },
	            _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
	                this._updateHint();
	                this.eventBus.trigger("render", suggestions, async, dataset);
	            },
	            _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
	                this.eventBus.trigger("asyncrequest", query, dataset);
	            },
	            _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
	                this.eventBus.trigger("asynccancel", query, dataset);
	            },
	            _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
	                this.eventBus.trigger("asyncreceive", query, dataset);
	            },
	            _onFocused: function onFocused() {
	                this._minLengthMet() && this.menu.update(this.input.getQuery());
	            },
	            _onBlurred: function onBlurred() {
	                if (this.input.hasQueryChangedSinceLastFocus()) {
	                    this.eventBus.trigger("change", this.input.getQuery());
	                }
	            },
	            _onEnterKeyed: function onEnterKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                }
	            },
	            _onTabKeyed: function onTabKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                } else if ($selectable = this.menu.getTopSelectable()) {
	                    this.autocomplete($selectable) && $e.preventDefault();
	                }
	            },
	            _onEscKeyed: function onEscKeyed() {
	                this.close();
	            },
	            _onUpKeyed: function onUpKeyed() {
	                this.moveCursor(-1);
	            },
	            _onDownKeyed: function onDownKeyed() {
	                this.moveCursor(+1);
	            },
	            _onLeftKeyed: function onLeftKeyed() {
	                if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getTopSelectable());
	                }
	            },
	            _onRightKeyed: function onRightKeyed() {
	                if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getTopSelectable());
	                }
	            },
	            _onQueryChanged: function onQueryChanged(e, query) {
	                this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
	            },
	            _onWhitespaceChanged: function onWhitespaceChanged() {
	                this._updateHint();
	            },
	            _onLangDirChanged: function onLangDirChanged(e, dir) {
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.menu.setLanguageDirection(dir);
	                }
	            },
	            _openIfActive: function openIfActive() {
	                this.isActive() && this.open();
	            },
	            _minLengthMet: function minLengthMet(query) {
	                query = _.isString(query) ? query : this.input.getQuery() || "";
	                return query.length >= this.minLength;
	            },
	            _updateHint: function updateHint() {
	                var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
	                $selectable = this.menu.getTopSelectable();
	                data = this.menu.getSelectableData($selectable);
	                val = this.input.getInputValue();
	                if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
	                    query = Input.normalizeQuery(val);
	                    escapedQuery = _.escapeRegExChars(query);
	                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
	                    match = frontMatchRegEx.exec(data.val);
	                    match && this.input.setHint(val + match[1]);
	                } else {
	                    this.input.clearHint();
	                }
	            },
	            isEnabled: function isEnabled() {
	                return this.enabled;
	            },
	            enable: function enable() {
	                this.enabled = true;
	            },
	            disable: function disable() {
	                this.enabled = false;
	            },
	            isActive: function isActive() {
	                return this.active;
	            },
	            activate: function activate() {
	                if (this.isActive()) {
	                    return true;
	                } else if (!this.isEnabled() || this.eventBus.before("active")) {
	                    return false;
	                } else {
	                    this.active = true;
	                    this.eventBus.trigger("active");
	                    return true;
	                }
	            },
	            deactivate: function deactivate() {
	                if (!this.isActive()) {
	                    return true;
	                } else if (this.eventBus.before("idle")) {
	                    return false;
	                } else {
	                    this.active = false;
	                    this.close();
	                    this.eventBus.trigger("idle");
	                    return true;
	                }
	            },
	            isOpen: function isOpen() {
	                return this.menu.isOpen();
	            },
	            open: function open() {
	                if (!this.isOpen() && !this.eventBus.before("open")) {
	                    this.menu.open();
	                    this._updateHint();
	                    this.eventBus.trigger("open");
	                }
	                return this.isOpen();
	            },
	            close: function close() {
	                if (this.isOpen() && !this.eventBus.before("close")) {
	                    this.menu.close();
	                    this.input.clearHint();
	                    this.input.resetInputValue();
	                    this.eventBus.trigger("close");
	                }
	                return !this.isOpen();
	            },
	            setVal: function setVal(val) {
	                this.input.setQuery(_.toStr(val));
	            },
	            getVal: function getVal() {
	                return this.input.getQuery();
	            },
	            select: function select($selectable) {
	                var data = this.menu.getSelectableData($selectable);
	                if (data && !this.eventBus.before("select", data.obj)) {
	                    this.input.setQuery(data.val, true);
	                    this.eventBus.trigger("select", data.obj);
	                    this.close();
	                    return true;
	                }
	                return false;
	            },
	            autocomplete: function autocomplete($selectable) {
	                var query, data, isValid;
	                query = this.input.getQuery();
	                data = this.menu.getSelectableData($selectable);
	                isValid = data && query !== data.val;
	                if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
	                    this.input.setQuery(data.val);
	                    this.eventBus.trigger("autocomplete", data.obj);
	                    return true;
	                }
	                return false;
	            },
	            moveCursor: function moveCursor(delta) {
	                var query, $candidate, data, payload, cancelMove;
	                query = this.input.getQuery();
	                $candidate = this.menu.selectableRelativeToCursor(delta);
	                data = this.menu.getSelectableData($candidate);
	                payload = data ? data.obj : null;
	                cancelMove = this._minLengthMet() && this.menu.update(query);
	                if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
	                    this.menu.setCursor($candidate);
	                    if (data) {
	                        this.input.setInputValue(data.val);
	                    } else {
	                        this.input.resetInputValue();
	                        this._updateHint();
	                    }
	                    this.eventBus.trigger("cursorchange", payload);
	                    return true;
	                }
	                return false;
	            },
	            destroy: function destroy() {
	                this.input.destroy();
	                this.menu.destroy();
	            }
	        });
	        return Typeahead;
	        function c(ctx) {
	            var methods = [].slice.call(arguments, 1);
	            return function() {
	                var args = [].slice.call(arguments);
	                _.each(methods, function(method) {
	                    return ctx[method].apply(ctx, args);
	                });
	            };
	        }
	    }();
	    (function() {
	        "use strict";
	        var old, keys, methods;
	        old = $.fn.typeahead;
	        keys = {
	            www: "tt-www",
	            attrs: "tt-attrs",
	            typeahead: "tt-typeahead"
	        };
	        methods = {
	            initialize: function initialize(o, datasets) {
	                var www;
	                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
	                o = o || {};
	                www = WWW(o.classNames);
	                return this.each(attach);
	                function attach() {
	                    var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
	                    _.each(datasets, function(d) {
	                        d.highlight = !!o.highlight;
	                    });
	                    $input = $(this);
	                    $wrapper = $(www.html.wrapper);
	                    $hint = $elOrNull(o.hint);
	                    $menu = $elOrNull(o.menu);
	                    defaultHint = o.hint !== false && !$hint;
	                    defaultMenu = o.menu !== false && !$menu;
	                    defaultHint && ($hint = buildHintFromInput($input, www));
	                    defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
	                    $hint && $hint.val("");
	                    $input = prepInput($input, www);
	                    if (defaultHint || defaultMenu) {
	                        $wrapper.css(www.css.wrapper);
	                        $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
	                        $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
	                    }
	                    MenuConstructor = defaultMenu ? DefaultMenu : Menu;
	                    eventBus = new EventBus({
	                        el: $input
	                    });
	                    input = new Input({
	                        hint: $hint,
	                        input: $input
	                    }, www);
	                    menu = new MenuConstructor({
	                        node: $menu,
	                        datasets: datasets
	                    }, www);
	                    typeahead = new Typeahead({
	                        input: input,
	                        menu: menu,
	                        eventBus: eventBus,
	                        minLength: o.minLength
	                    }, www);
	                    $input.data(keys.www, www);
	                    $input.data(keys.typeahead, typeahead);
	                }
	            },
	            isEnabled: function isEnabled() {
	                var enabled;
	                ttEach(this.first(), function(t) {
	                    enabled = t.isEnabled();
	                });
	                return enabled;
	            },
	            enable: function enable() {
	                ttEach(this, function(t) {
	                    t.enable();
	                });
	                return this;
	            },
	            disable: function disable() {
	                ttEach(this, function(t) {
	                    t.disable();
	                });
	                return this;
	            },
	            isActive: function isActive() {
	                var active;
	                ttEach(this.first(), function(t) {
	                    active = t.isActive();
	                });
	                return active;
	            },
	            activate: function activate() {
	                ttEach(this, function(t) {
	                    t.activate();
	                });
	                return this;
	            },
	            deactivate: function deactivate() {
	                ttEach(this, function(t) {
	                    t.deactivate();
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                var open;
	                ttEach(this.first(), function(t) {
	                    open = t.isOpen();
	                });
	                return open;
	            },
	            open: function open() {
	                ttEach(this, function(t) {
	                    t.open();
	                });
	                return this;
	            },
	            close: function close() {
	                ttEach(this, function(t) {
	                    t.close();
	                });
	                return this;
	            },
	            select: function select(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.select($el);
	                });
	                return success;
	            },
	            autocomplete: function autocomplete(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.autocomplete($el);
	                });
	                return success;
	            },
	            moveCursor: function moveCursoe(delta) {
	                var success = false;
	                ttEach(this.first(), function(t) {
	                    success = t.moveCursor(delta);
	                });
	                return success;
	            },
	            val: function val(newVal) {
	                var query;
	                if (!arguments.length) {
	                    ttEach(this.first(), function(t) {
	                        query = t.getVal();
	                    });
	                    return query;
	                } else {
	                    ttEach(this, function(t) {
	                        t.setVal(newVal);
	                    });
	                    return this;
	                }
	            },
	            destroy: function destroy() {
	                ttEach(this, function(typeahead, $input) {
	                    revert($input);
	                    typeahead.destroy();
	                });
	                return this;
	            }
	        };
	        $.fn.typeahead = function(method) {
	            if (methods[method]) {
	                return methods[method].apply(this, [].slice.call(arguments, 1));
	            } else {
	                return methods.initialize.apply(this, arguments);
	            }
	        };
	        $.fn.typeahead.noConflict = function noConflict() {
	            $.fn.typeahead = old;
	            return this;
	        };
	        function ttEach($els, fn) {
	            $els.each(function() {
	                var $input = $(this), typeahead;
	                (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
	            });
	        }
	        function buildHintFromInput($input, www) {
	            return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
	                autocomplete: "off",
	                spellcheck: "false",
	                tabindex: -1
	            });
	        }
	        function prepInput($input, www) {
	            $input.data(keys.attrs, {
	                dir: $input.attr("dir"),
	                autocomplete: $input.attr("autocomplete"),
	                spellcheck: $input.attr("spellcheck"),
	                style: $input.attr("style")
	            });
	            $input.addClass(www.classes.input).attr({
	                autocomplete: "off",
	                spellcheck: false
	            });
	            try {
	                !$input.attr("dir") && $input.attr("dir", "auto");
	            } catch (e) {}
	            return $input;
	        }
	        function getBackgroundStyles($el) {
	            return {
	                backgroundAttachment: $el.css("background-attachment"),
	                backgroundClip: $el.css("background-clip"),
	                backgroundColor: $el.css("background-color"),
	                backgroundImage: $el.css("background-image"),
	                backgroundOrigin: $el.css("background-origin"),
	                backgroundPosition: $el.css("background-position"),
	                backgroundRepeat: $el.css("background-repeat"),
	                backgroundSize: $el.css("background-size")
	            };
	        }
	        function revert($input) {
	            var www, $wrapper;
	            www = $input.data(keys.www);
	            $wrapper = $input.parent().filter(www.selectors.wrapper);
	            _.each($input.data(keys.attrs), function(val, key) {
	                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
	            });
	            $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
	            if ($wrapper.length) {
	                $input.detach().insertAfter($wrapper);
	                $wrapper.remove();
	            }
	        }
	        function $elOrNull(obj) {
	            var isValid, $el;
	            isValid = _.isJQuery(obj) || _.isElement(obj);
	            $el = isValid ? $(obj).first() : [];
	            return $el.length ? $el : null;
	        }
	    })();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69).setImmediate))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*! 
	 * jQuery Steps v1.1.0 - 09/04/2014
	 * Copyright (c) 2014 Rafael Staib (http://www.jquery-steps.com)
	 * Licensed under MIT http://www.opensource.org/licenses/MIT
	 */
	;(function ($, undefined)
	{
	$.fn.extend({
	    _aria: function (name, value)
	    {
	        return this.attr("aria-" + name, value);
	    },
	
	    _removeAria: function (name)
	    {
	        return this.removeAttr("aria-" + name);
	    },
	
	    _enableAria: function (enable)
	    {
	        return (enable == null || enable) ? 
	            this.removeClass("disabled")._aria("disabled", "false") : 
	            this.addClass("disabled")._aria("disabled", "true");
	    },
	
	    _showAria: function (show)
	    {
	        return (show == null || show) ? 
	            this.show()._aria("hidden", "false") : 
	            this.hide()._aria("hidden", "true");
	    },
	
	    _selectAria: function (select)
	    {
	        return (select == null || select) ? 
	            this.addClass("current")._aria("selected", "true") : 
	            this.removeClass("current")._aria("selected", "false");
	    },
	
	    _id: function (id)
	    {
	        return (id) ? this.attr("id", id) : this.attr("id");
	    }
	});
	
	if (!String.prototype.format)
	{
	    String.prototype.format = function()
	    {
	        var args = (arguments.length === 1 && $.isArray(arguments[0])) ? arguments[0] : arguments;
	        var formattedString = this;
	        for (var i = 0; i < args.length; i++)
	        {
	            var pattern = new RegExp("\\{" + i + "\\}", "gm");
	            formattedString = formattedString.replace(pattern, args[i]);
	        }
	        return formattedString;
	    };
	}
	
	/**
	 * A global unique id count.
	 *
	 * @static
	 * @private
	 * @property _uniqueId
	 * @type Integer
	 **/
	var _uniqueId = 0;
	
	/**
	 * The plugin prefix for cookies.
	 *
	 * @final
	 * @private
	 * @property _cookiePrefix
	 * @type String
	 **/
	var _cookiePrefix = "jQu3ry_5teps_St@te_";
	
	/**
	 * Suffix for the unique tab id.
	 *
	 * @final
	 * @private
	 * @property _tabSuffix
	 * @type String
	 * @since 0.9.7
	 **/
	var _tabSuffix = "-t-";
	
	/**
	 * Suffix for the unique tabpanel id.
	 *
	 * @final
	 * @private
	 * @property _tabpanelSuffix
	 * @type String
	 * @since 0.9.7
	 **/
	var _tabpanelSuffix = "-p-";
	
	/**
	 * Suffix for the unique title id.
	 *
	 * @final
	 * @private
	 * @property _titleSuffix
	 * @type String
	 * @since 0.9.7
	 **/
	var _titleSuffix = "-h-";
	
	/**
	 * An error message for an "index out of range" error.
	 *
	 * @final
	 * @private
	 * @property _indexOutOfRangeErrorMessage
	 * @type String
	 **/
	var _indexOutOfRangeErrorMessage = "Index out of range.";
	
	/**
	 * An error message for an "missing corresponding element" error.
	 *
	 * @final
	 * @private
	 * @property _missingCorrespondingElementErrorMessage
	 * @type String
	 **/
	var _missingCorrespondingElementErrorMessage = "One or more corresponding step {0} are missing.";
	
	/**
	 * Adds a step to the cache.
	 *
	 * @static
	 * @private
	 * @method addStepToCache
	 * @param wizard {Object} A jQuery wizard object
	 * @param step {Object} The step object to add
	 **/
	function addStepToCache(wizard, step)
	{
	    getSteps(wizard).push(step);
	}
	
	function analyzeData(wizard, options, state)
	{
	    var stepTitles = wizard.children(options.headerTag),
	        stepContents = wizard.children(options.bodyTag);
	
	    // Validate content
	    if (stepTitles.length > stepContents.length)
	    {
	        throwError(_missingCorrespondingElementErrorMessage, "contents");
	    }
	    else if (stepTitles.length < stepContents.length)
	    {
	        throwError(_missingCorrespondingElementErrorMessage, "titles");
	    }
	        
	    var startIndex = options.startIndex;
	
	    state.stepCount = stepTitles.length;
	
	    // Tries to load the saved state (step position)
	    if (options.saveState && $.cookie)
	    {
	        var savedState = $.cookie(_cookiePrefix + getUniqueId(wizard));
	        // Sets the saved position to the start index if not undefined or out of range 
	        var savedIndex = parseInt(savedState, 0);
	        if (!isNaN(savedIndex) && savedIndex < state.stepCount)
	        {
	            startIndex = savedIndex;
	        }
	    }
	
	    state.currentIndex = startIndex;
	
	    stepTitles.each(function (index)
	    {
	        var item = $(this), // item == header
	            content = stepContents.eq(index),
	            modeData = content.data("mode"),
	            mode = (modeData == null) ? contentMode.html : getValidEnumValue(contentMode,
	                (/^\s*$/.test(modeData) || isNaN(modeData)) ? modeData : parseInt(modeData, 0)),
	            contentUrl = (mode === contentMode.html || content.data("url") === undefined) ?
	                "" : content.data("url"),
	            contentLoaded = (mode !== contentMode.html && content.data("loaded") === "1"),
	            step = $.extend({}, stepModel, {
	                title: item.html(),
	                content: (mode === contentMode.html) ? content.html() : "",
	                contentUrl: contentUrl,
	                contentMode: mode,
	                contentLoaded: contentLoaded
	            });
	
	        addStepToCache(wizard, step);
	    });
	}
	
	/**
	 * Triggers the onCanceled event.
	 *
	 * @static
	 * @private
	 * @method cancel
	 * @param wizard {Object} The jQuery wizard object
	 **/
	function cancel(wizard)
	{
	    wizard.triggerHandler("canceled");
	}
	
	function decreaseCurrentIndexBy(state, decreaseBy)
	{
	    return state.currentIndex - decreaseBy;
	}
	
	/**
	 * Removes the control functionality completely and transforms the current state to the initial HTML structure.
	 *
	 * @static
	 * @private
	 * @method destroy
	 * @param wizard {Object} A jQuery wizard object
	 **/
	function destroy(wizard, options)
	{
	    var eventNamespace = getEventNamespace(wizard);
	
	    // Remove virtual data objects from the wizard
	    wizard.unbind(eventNamespace).removeData("uid").removeData("options")
	        .removeData("state").removeData("steps").removeData("eventNamespace")
	        .find(".actions a").unbind(eventNamespace);
	
	    // Remove attributes and CSS classes from the wizard
	    wizard.removeClass(options.clearFixCssClass + " vertical");
	
	    var contents = wizard.find(".content > *");
	
	    // Remove virtual data objects from panels and their titles
	    contents.removeData("loaded").removeData("mode").removeData("url");
	
	    // Remove attributes, CSS classes and reset inline styles on all panels and their titles
	    contents.removeAttr("id").removeAttr("role").removeAttr("tabindex")
	        .removeAttr("class").removeAttr("style")._removeAria("labelledby")
	        ._removeAria("hidden");
	
	    // Empty panels if the mode is set to 'async' or 'iframe'
	    wizard.find(".content > [data-mode='async'],.content > [data-mode='iframe']").empty();
	
	    var wizardSubstitute = $("<{0} class=\"{1}\"></{0}>".format(wizard.get(0).tagName, wizard.attr("class")));
	
	    var wizardId = wizard._id();
	    if (wizardId != null && wizardId !== "")
	    {
	        wizardSubstitute._id(wizardId);
	    }
	
	    wizardSubstitute.html(wizard.find(".content").html());
	    wizard.after(wizardSubstitute);
	    wizard.remove();
	
	    return wizardSubstitute;
	}
	
	/**
	 * Triggers the onFinishing and onFinished event.
	 *
	 * @static
	 * @private
	 * @method finishStep
	 * @param wizard {Object} The jQuery wizard object
	 * @param state {Object} The state container of the current wizard
	 **/
	function finishStep(wizard, state)
	{
	    var currentStep = wizard.find(".steps li").eq(state.currentIndex);
	
	    if (wizard.triggerHandler("finishing", [state.currentIndex]))
	    {
	        currentStep.addClass("done").removeClass("error");
	        wizard.triggerHandler("finished", [state.currentIndex]);
	    }
	    else
	    {
	        currentStep.addClass("error");
	    }
	}
	
	/**
	 * Gets or creates if not exist an unique event namespace for the given wizard instance.
	 *
	 * @static
	 * @private
	 * @method getEventNamespace
	 * @param wizard {Object} A jQuery wizard object
	 * @return {String} Returns the unique event namespace for the given wizard
	 */
	function getEventNamespace(wizard)
	{
	    var eventNamespace = wizard.data("eventNamespace");
	
	    if (eventNamespace == null)
	    {
	        eventNamespace = "." + getUniqueId(wizard);
	        wizard.data("eventNamespace", eventNamespace);
	    }
	
	    return eventNamespace;
	}
	
	function getStepAnchor(wizard, index)
	{
	    var uniqueId = getUniqueId(wizard);
	
	    return wizard.find("#" + uniqueId + _tabSuffix + index);
	}
	
	function getStepPanel(wizard, index)
	{
	    var uniqueId = getUniqueId(wizard);
	
	    return wizard.find("#" + uniqueId + _tabpanelSuffix + index);
	}
	
	function getStepTitle(wizard, index)
	{
	    var uniqueId = getUniqueId(wizard);
	
	    return wizard.find("#" + uniqueId + _titleSuffix + index);
	}
	
	function getOptions(wizard)
	{
	    return wizard.data("options");
	}
	
	function getState(wizard)
	{
	    return wizard.data("state");
	}
	
	function getSteps(wizard)
	{
	    return wizard.data("steps");
	}
	
	/**
	 * Gets a specific step object by index.
	 *
	 * @static
	 * @private
	 * @method getStep
	 * @param index {Integer} An integer that belongs to the position of a step
	 * @return {Object} A specific step object
	 **/
	function getStep(wizard, index)
	{
	    var steps = getSteps(wizard);
	
	    if (index < 0 || index >= steps.length)
	    {
	        throwError(_indexOutOfRangeErrorMessage);
	    }
	
	    return steps[index];
	}
	
	/**
	 * Gets or creates if not exist an unique id from the given wizard instance.
	 *
	 * @static
	 * @private
	 * @method getUniqueId
	 * @param wizard {Object} A jQuery wizard object
	 * @return {String} Returns the unique id for the given wizard
	 */
	function getUniqueId(wizard)
	{
	    var uniqueId = wizard.data("uid");
	
	    if (uniqueId == null)
	    {
	        uniqueId = wizard._id();
	        if (uniqueId == null)
	        {
	            uniqueId = "steps-uid-".concat(_uniqueId);
	            wizard._id(uniqueId);
	        }
	
	        _uniqueId++;
	        wizard.data("uid", uniqueId);
	    }
	
	    return uniqueId;
	}
	
	/**
	 * Gets a valid enum value by checking a specific enum key or value.
	 * 
	 * @static
	 * @private
	 * @method getValidEnumValue
	 * @param enumType {Object} Type of enum
	 * @param keyOrValue {Object} Key as `String` or value as `Integer` to check for
	 */
	function getValidEnumValue(enumType, keyOrValue)
	{
	    validateArgument("enumType", enumType);
	    validateArgument("keyOrValue", keyOrValue);
	
	    // Is key
	    if (typeof keyOrValue === "string")
	    {
	        var value = enumType[keyOrValue];
	        if (value === undefined)
	        {
	            throwError("The enum key '{0}' does not exist.", keyOrValue);
	        }
	
	        return value;
	    }
	    // Is value
	    else if (typeof keyOrValue === "number")
	    {
	        for (var key in enumType)
	        {
	            if (enumType[key] === keyOrValue)
	            {
	                return keyOrValue;
	            }
	        }
	
	        throwError("Invalid enum value '{0}'.", keyOrValue);
	    }
	    // Type is not supported
	    else
	    {
	        throwError("Invalid key or value type.");
	    }
	}
	
	/**
	 * Routes to the next step.
	 *
	 * @static
	 * @private
	 * @method goToNextStep
	 * @param wizard {Object} The jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @return {Boolean} Indicates whether the action executed
	 **/
	function goToNextStep(wizard, options, state)
	{
	    return paginationClick(wizard, options, state, increaseCurrentIndexBy(state, 1));
	}
	
	/**
	 * Routes to the previous step.
	 *
	 * @static
	 * @private
	 * @method goToPreviousStep
	 * @param wizard {Object} The jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @return {Boolean} Indicates whether the action executed
	 **/
	function goToPreviousStep(wizard, options, state)
	{
	    return paginationClick(wizard, options, state, decreaseCurrentIndexBy(state, 1));
	}
	
	/**
	 * Routes to a specific step by a given index.
	 *
	 * @static
	 * @private
	 * @method goToStep
	 * @param wizard {Object} The jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param index {Integer} The position (zero-based) to route to
	 * @return {Boolean} Indicates whether the action succeeded or failed
	 **/
	function goToStep(wizard, options, state, index)
	{
	    if (index < 0 || index >= state.stepCount)
	    {
	        throwError(_indexOutOfRangeErrorMessage);
	    }
	
	    if (options.forceMoveForward && index < state.currentIndex)
	    {
	        return;
	    }
	
	    var oldIndex = state.currentIndex;
	    if (wizard.triggerHandler("stepChanging", [state.currentIndex, index]))
	    {
	        // Save new state
	        state.currentIndex = index;
	        saveCurrentStateToCookie(wizard, options, state);
	
	        // Change visualisation
	        refreshStepNavigation(wizard, options, state, oldIndex);
	        refreshPagination(wizard, options, state);
	        loadAsyncContent(wizard, options, state);
	        startTransitionEffect(wizard, options, state, index, oldIndex, function()
	        {
	            wizard.triggerHandler("stepChanged", [index, oldIndex]);
	        });
	    }
	    else
	    {
	        wizard.find(".steps li").eq(oldIndex).addClass("error");
	    }
	
	    return true;
	}
	
	function increaseCurrentIndexBy(state, increaseBy)
	{
	    return state.currentIndex + increaseBy;
	}
	
	/**
	 * Initializes the component.
	 *
	 * @static
	 * @private
	 * @method initialize
	 * @param options {Object} The component settings
	 **/
	function initialize(options)
	{
	    /*jshint -W040 */
	    var opts = $.extend(true, {}, defaults, options);
	
	    return this.each(function ()
	    {
	        var wizard = $(this);
	        var state = {
	            currentIndex: opts.startIndex,
	            currentStep: null,
	            stepCount: 0,
	            transitionElement: null
	        };
	
	        // Create data container
	        wizard.data("options", opts);
	        wizard.data("state", state);
	        wizard.data("steps", []);
	
	        analyzeData(wizard, opts, state);
	        render(wizard, opts, state);
	        registerEvents(wizard, opts);
	
	        // Trigger focus
	        if (opts.autoFocus && _uniqueId === 0)
	        {
	            getStepAnchor(wizard, opts.startIndex).focus();
	        }
	
	        wizard.triggerHandler("init", [opts.startIndex]);
	    });
	}
	
	/**
	 * Inserts a new step to a specific position.
	 *
	 * @static
	 * @private
	 * @method insertStep
	 * @param wizard {Object} The jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param index {Integer} The position (zero-based) to add
	 * @param step {Object} The step object to add
	 * @example
	 *     $("#wizard").steps().insert(0, {
	 *         title: "Title",
	 *         content: "", // optional
	 *         contentMode: "async", // optional
	 *         contentUrl: "/Content/Step/1" // optional
	 *     });
	 * @chainable
	 **/
	function insertStep(wizard, options, state, index, step)
	{
	    if (index < 0 || index > state.stepCount)
	    {
	        throwError(_indexOutOfRangeErrorMessage);
	    }
	
	    // TODO: Validate step object
	
	    // Change data
	    step = $.extend({}, stepModel, step);
	    insertStepToCache(wizard, index, step);
	    if (state.currentIndex !== state.stepCount && state.currentIndex >= index)
	    {
	        state.currentIndex++;
	        saveCurrentStateToCookie(wizard, options, state);
	    }
	    state.stepCount++;
	
	    var contentContainer = wizard.find(".content"),
	        header = $("<{0}>{1}</{0}>".format(options.headerTag, step.title)),
	        body = $("<{0}></{0}>".format(options.bodyTag));
	
	    if (step.contentMode == null || step.contentMode === contentMode.html)
	    {
	        body.html(step.content);
	    }
	
	    if (index === 0)
	    {
	        contentContainer.prepend(body).prepend(header);
	    }
	    else
	    {
	        getStepPanel(wizard, (index - 1)).after(body).after(header);
	    }
	
	    renderBody(wizard, state, body, index);
	    renderTitle(wizard, options, state, header, index);
	    refreshSteps(wizard, options, state, index);
	    if (index === state.currentIndex)
	    {
	        refreshStepNavigation(wizard, options, state);
	    }
	    refreshPagination(wizard, options, state);
	
	    return wizard;
	}
	
	/**
	 * Inserts a step object to the cache at a specific position.
	 *
	 * @static
	 * @private
	 * @method insertStepToCache
	 * @param wizard {Object} A jQuery wizard object
	 * @param index {Integer} The position (zero-based) to add
	 * @param step {Object} The step object to add
	 **/
	function insertStepToCache(wizard, index, step)
	{
	    getSteps(wizard).splice(index, 0, step);
	}
	
	/**
	 * Handles the keyup DOM event for pagination.
	 *
	 * @static
	 * @private
	 * @event keyup
	 * @param event {Object} An event object
	 */
	function keyUpHandler(event)
	{
	    var wizard = $(this),
	        options = getOptions(wizard),
	        state = getState(wizard);
	
	    if (options.suppressPaginationOnFocus && wizard.find(":focus").is(":input"))
	    {
	        event.preventDefault();
	        return false;
	    }
	
	    var keyCodes = { left: 37, right: 39 };
	    if (event.keyCode === keyCodes.left)
	    {
	        event.preventDefault();
	        goToPreviousStep(wizard, options, state);
	    }
	    else if (event.keyCode === keyCodes.right)
	    {
	        event.preventDefault();
	        goToNextStep(wizard, options, state);
	    }
	}
	
	/**
	 * Loads and includes async content.
	 *
	 * @static
	 * @private
	 * @method loadAsyncContent
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 */
	function loadAsyncContent(wizard, options, state)
	{
	    if (state.stepCount > 0)
	    {
	        var currentIndex = state.currentIndex,
	            currentStep = getStep(wizard, currentIndex);
	
	        if (!options.enableContentCache || !currentStep.contentLoaded)
	        {
	            switch (getValidEnumValue(contentMode, currentStep.contentMode))
	            {
	                case contentMode.iframe:
	                    wizard.find(".content > .body").eq(state.currentIndex).empty()
	                        .html("<iframe src=\"" + currentStep.contentUrl + "\" frameborder=\"0\" scrolling=\"no\" />")
	                        .data("loaded", "1");
	                    break;
	
	                case contentMode.async:
	                    var currentStepContent = getStepPanel(wizard, currentIndex)._aria("busy", "true")
	                        .empty().append(renderTemplate(options.loadingTemplate, { text: options.labels.loading }));
	
	                    $.ajax({ url: currentStep.contentUrl, cache: false }).done(function (data)
	                    {
	                        currentStepContent.empty().html(data)._aria("busy", "false").data("loaded", "1");
	                        wizard.triggerHandler("contentLoaded", [currentIndex]);
	                    });
	                    break;
	            }
	        }
	    }
	}
	
	/**
	 * Fires the action next or previous click event.
	 *
	 * @static
	 * @private
	 * @method paginationClick
	 * @param wizard {Object} The jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param index {Integer} The position (zero-based) to route to
	 * @return {Boolean} Indicates whether the event fired successfully or not
	 **/
	function paginationClick(wizard, options, state, index)
	{
	    var oldIndex = state.currentIndex;
	
	    if (index >= 0 && index < state.stepCount && !(options.forceMoveForward && index < state.currentIndex))
	    {
	        var anchor = getStepAnchor(wizard, index),
	            parent = anchor.parent(),
	            isDisabled = parent.hasClass("disabled");
	
	        // Enable the step to make the anchor clickable!
	        parent._enableAria();
	        anchor.click();
	
	        // An error occured
	        if (oldIndex === state.currentIndex && isDisabled)
	        {
	            // Disable the step again if current index has not changed; prevents click action.
	            parent._enableAria(false);
	            return false;
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Fires when a pagination click happens.
	 *
	 * @static
	 * @private
	 * @event click
	 * @param event {Object} An event object
	 */
	function paginationClickHandler(event)
	{
	    event.preventDefault();
	
	    var anchor = $(this),
	        wizard = anchor.parent().parent().parent().parent(),
	        options = getOptions(wizard),
	        state = getState(wizard),
	        href = anchor.attr("href");
	
	    switch (href.substring(href.lastIndexOf("#") + 1))
	    {
	        case "cancel":
	            cancel(wizard);
	            break;
	
	        case "finish":
	            finishStep(wizard, state);
	            break;
	
	        case "next":
	            goToNextStep(wizard, options, state);
	            break;
	
	        case "previous":
	            goToPreviousStep(wizard, options, state);
	            break;
	    }
	}
	
	/**
	 * Refreshs the visualization state for the entire pagination.
	 *
	 * @static
	 * @private
	 * @method refreshPagination
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 */
	function refreshPagination(wizard, options, state)
	{
	    if (options.enablePagination)
	    {
	        var finish = wizard.find(".actions a[href$='#finish']").parent(),
	            next = wizard.find(".actions a[href$='#next']").parent();
	
	        if (!options.forceMoveForward)
	        {
	            var previous = wizard.find(".actions a[href$='#previous']").parent();
	            previous._enableAria(state.currentIndex > 0);
	        }
	
	        if (options.enableFinishButton && options.showFinishButtonAlways)
	        {
	            finish._enableAria(state.stepCount > 0);
	            next._enableAria(state.stepCount > 1 && state.stepCount > (state.currentIndex + 1));
	        }
	        else
	        {
	            finish._showAria(options.enableFinishButton && state.stepCount === (state.currentIndex + 1));
	            next._showAria(state.stepCount === 0 || state.stepCount > (state.currentIndex + 1)).
	                _enableAria(state.stepCount > (state.currentIndex + 1) || !options.enableFinishButton);
	        }
	    }
	}
	
	/**
	 * Refreshs the visualization state for the step navigation (tabs).
	 *
	 * @static
	 * @private
	 * @method refreshStepNavigation
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param [oldIndex] {Integer} The index of the prior step
	 */
	function refreshStepNavigation(wizard, options, state, oldIndex)
	{
	    var currentOrNewStepAnchor = getStepAnchor(wizard, state.currentIndex),
	        currentInfo = $("<span class=\"current-info audible\">" + options.labels.current + " </span>"),
	        stepTitles = wizard.find(".content > .title");
	
	    if (oldIndex != null)
	    {
	        var oldStepAnchor = getStepAnchor(wizard, oldIndex);
	        oldStepAnchor.parent().addClass("done").removeClass("error")._selectAria(false);
	        stepTitles.eq(oldIndex).removeClass("current").next(".body").removeClass("current");
	        currentInfo = oldStepAnchor.find(".current-info");
	        currentOrNewStepAnchor.focus();
	    }
	
	    currentOrNewStepAnchor.prepend(currentInfo).parent()._selectAria().removeClass("done")._enableAria();
	    stepTitles.eq(state.currentIndex).addClass("current").next(".body").addClass("current");
	}
	
	/**
	 * Refreshes step buttons and their related titles beyond a certain position.
	 *
	 * @static
	 * @private
	 * @method refreshSteps
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param index {Integer} The start point for refreshing ids
	 */
	function refreshSteps(wizard, options, state, index)
	{
	    var uniqueId = getUniqueId(wizard);
	
	    for (var i = index; i < state.stepCount; i++)
	    {
	        var uniqueStepId = uniqueId + _tabSuffix + i,
	            uniqueBodyId = uniqueId + _tabpanelSuffix + i,
	            uniqueHeaderId = uniqueId + _titleSuffix + i,
	            title = wizard.find(".title").eq(i)._id(uniqueHeaderId);
	
	        wizard.find(".steps a").eq(i)._id(uniqueStepId)
	            ._aria("controls", uniqueBodyId).attr("href", "#" + uniqueHeaderId)
	            .html(renderTemplate(options.titleTemplate, { index: i + 1, title: title.html() }));
	        wizard.find(".body").eq(i)._id(uniqueBodyId)
	            ._aria("labelledby", uniqueHeaderId);
	    }
	}
	
	function registerEvents(wizard, options)
	{
	    var eventNamespace = getEventNamespace(wizard);
	
	    wizard.bind("canceled" + eventNamespace, options.onCanceled);
	    wizard.bind("contentLoaded" + eventNamespace, options.onContentLoaded);
	    wizard.bind("finishing" + eventNamespace, options.onFinishing);
	    wizard.bind("finished" + eventNamespace, options.onFinished);
	    wizard.bind("init" + eventNamespace, options.onInit);
	    wizard.bind("stepChanging" + eventNamespace, options.onStepChanging);
	    wizard.bind("stepChanged" + eventNamespace, options.onStepChanged);
	
	    if (options.enableKeyNavigation)
	    {
	        wizard.bind("keyup" + eventNamespace, keyUpHandler);
	    }
	
	    wizard.find(".actions a").bind("click" + eventNamespace, paginationClickHandler);
	}
	
	/**
	 * Removes a specific step by an given index.
	 *
	 * @static
	 * @private
	 * @method removeStep
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param index {Integer} The position (zero-based) of the step to remove
	 * @return Indecates whether the item is removed.
	 **/
	function removeStep(wizard, options, state, index)
	{
	    // Index out of range and try deleting current item will return false.
	    if (index < 0 || index >= state.stepCount || state.currentIndex === index)
	    {
	        return false;
	    }
	
	    // Change data
	    removeStepFromCache(wizard, index);
	    if (state.currentIndex > index)
	    {
	        state.currentIndex--;
	        saveCurrentStateToCookie(wizard, options, state);
	    }
	    state.stepCount--;
	
	    getStepTitle(wizard, index).remove();
	    getStepPanel(wizard, index).remove();
	    getStepAnchor(wizard, index).parent().remove();
	
	    // Set the "first" class to the new first step button 
	    if (index === 0)
	    {
	        wizard.find(".steps li").first().addClass("first");
	    }
	
	    // Set the "last" class to the new last step button 
	    if (index === state.stepCount)
	    {
	        wizard.find(".steps li").eq(index).addClass("last");
	    }
	
	    refreshSteps(wizard, options, state, index);
	    refreshPagination(wizard, options, state);
	
	    return true;
	}
	
	function removeStepFromCache(wizard, index)
	{
	    getSteps(wizard).splice(index, 1);
	}
	
	/**
	 * Transforms the base html structure to a more sensible html structure.
	 *
	 * @static
	 * @private
	 * @method render
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 **/
	function render(wizard, options, state)
	{
	    // Create a content wrapper and copy HTML from the intial wizard structure
	    var wrapperTemplate = "<{0} class=\"{1}\">{2}</{0}>",
	        orientation = getValidEnumValue(stepsOrientation, options.stepsOrientation),
	        verticalCssClass = (orientation === stepsOrientation.vertical) ? " vertical" : "",
	        contentWrapper = $(wrapperTemplate.format(options.contentContainerTag, "content " + options.clearFixCssClass, wizard.html())),
	        stepsWrapper = $(wrapperTemplate.format(options.stepsContainerTag, "steps " + options.clearFixCssClass, "<ul role=\"tablist\"></ul>")),
	        stepTitles = contentWrapper.children(options.headerTag),
	        stepContents = contentWrapper.children(options.bodyTag);
	
	    // Transform the wizard wrapper and remove the inner HTML
	    wizard.attr("role", "application").empty().append(stepsWrapper).append(contentWrapper)
	        .addClass(options.cssClass + " " + options.clearFixCssClass + verticalCssClass);
	
	    // Add WIA-ARIA support
	    stepContents.each(function (index)
	    {
	        renderBody(wizard, state, $(this), index);
	    });
	
	    stepTitles.each(function (index)
	    {
	        renderTitle(wizard, options, state, $(this), index);
	    });
	
	    refreshStepNavigation(wizard, options, state);
	    renderPagination(wizard, options, state);
	}
	
	/**
	 * Transforms the body to a proper tabpanel.
	 *
	 * @static
	 * @private
	 * @method renderBody
	 * @param wizard {Object} A jQuery wizard object
	 * @param body {Object} A jQuery body object
	 * @param index {Integer} The position of the body
	 */
	function renderBody(wizard, state, body, index)
	{
	    var uniqueId = getUniqueId(wizard),
	        uniqueBodyId = uniqueId + _tabpanelSuffix + index,
	        uniqueHeaderId = uniqueId + _titleSuffix + index;
	
	    body._id(uniqueBodyId).attr("role", "tabpanel")._aria("labelledby", uniqueHeaderId)
	        .addClass("body")._showAria(state.currentIndex === index);
	}
	
	/**
	 * Renders a pagination if enabled.
	 *
	 * @static
	 * @private
	 * @method renderPagination
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 */
	function renderPagination(wizard, options, state)
	{
	    if (options.enablePagination)
	    {
	        var pagination = "<{0} class=\"actions {1}\"><ul role=\"menu\" aria-label=\"{2}\">{3}</ul></{0}>",
	            buttonTemplate = "<li><a href=\"#{0}\" role=\"menuitem\">{1}</a></li>",
	            buttons = "";
	
	        if (!options.forceMoveForward)
	        {
	            buttons += buttonTemplate.format("previous", options.labels.previous);
	        }
	
	        buttons += buttonTemplate.format("next", options.labels.next);
	
	        if (options.enableFinishButton)
	        {
	            buttons += buttonTemplate.format("finish", options.labels.finish);
	        }
	
	        if (options.enableCancelButton)
	        {
	            buttons += buttonTemplate.format("cancel", options.labels.cancel);
	        }
	
	        wizard.append(pagination.format(options.actionContainerTag, options.clearFixCssClass,
	            options.labels.pagination, buttons));
	
	        refreshPagination(wizard, options, state);
	        loadAsyncContent(wizard, options, state);
	    }
	}
	
	/**
	 * Renders a template and replaces all placeholder.
	 *
	 * @static
	 * @private
	 * @method renderTemplate
	 * @param template {String} A template
	 * @param substitutes {Object} A list of substitute
	 * @return {String} The rendered template
	 */
	function renderTemplate(template, substitutes)
	{
	    var matches = template.match(/#([a-z]*)#/gi);
	
	    for (var i = 0; i < matches.length; i++)
	    {
	        var match = matches[i], 
	            key = match.substring(1, match.length - 1);
	
	        if (substitutes[key] === undefined)
	        {
	            throwError("The key '{0}' does not exist in the substitute collection!", key);
	        }
	
	        template = template.replace(match, substitutes[key]);
	    }
	
	    return template;
	}
	
	/**
	 * Transforms the title to a step item button.
	 *
	 * @static
	 * @private
	 * @method renderTitle
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 * @param header {Object} A jQuery header object
	 * @param index {Integer} The position of the header
	 */
	function renderTitle(wizard, options, state, header, index)
	{
	    var uniqueId = getUniqueId(wizard),
	        uniqueStepId = uniqueId + _tabSuffix + index,
	        uniqueBodyId = uniqueId + _tabpanelSuffix + index,
	        uniqueHeaderId = uniqueId + _titleSuffix + index,
	        stepCollection = wizard.find(".steps > ul"),
	        title = renderTemplate(options.titleTemplate, {
	            index: index + 1,
	            title: header.html()
	        }),
	        stepItem = $("<li role=\"tab\"><a id=\"" + uniqueStepId + "\" href=\"#" + uniqueHeaderId + 
	            "\" aria-controls=\"" + uniqueBodyId + "\">" + title + "</a></li>");
	        
	    stepItem._enableAria(options.enableAllSteps || state.currentIndex > index);
	
	    if (state.currentIndex > index)
	    {
	        stepItem.addClass("done");
	    }
	
	    header._id(uniqueHeaderId).attr("tabindex", "-1").addClass("title");
	
	    if (index === 0)
	    {
	        stepCollection.prepend(stepItem);
	    }
	    else
	    {
	        stepCollection.find("li").eq(index - 1).after(stepItem);
	    }
	
	    // Set the "first" class to the new first step button
	    if (index === 0)
	    {
	        stepCollection.find("li").removeClass("first").eq(index).addClass("first");
	    }
	
	    // Set the "last" class to the new last step button
	    if (index === (state.stepCount - 1))
	    {
	        stepCollection.find("li").removeClass("last").eq(index).addClass("last");
	    }
	
	    // Register click event
	    stepItem.children("a").bind("click" + getEventNamespace(wizard), stepClickHandler);
	}
	
	/**
	 * Saves the current state to a cookie.
	 *
	 * @static
	 * @private
	 * @method saveCurrentStateToCookie
	 * @param wizard {Object} A jQuery wizard object
	 * @param options {Object} Settings of the current wizard
	 * @param state {Object} The state container of the current wizard
	 */
	function saveCurrentStateToCookie(wizard, options, state)
	{
	    if (options.saveState && $.cookie)
	    {
	        $.cookie(_cookiePrefix + getUniqueId(wizard), state.currentIndex);
	    }
	}
	
	function startTransitionEffect(wizard, options, state, index, oldIndex, doneCallback)
	{
	    var stepContents = wizard.find(".content > .body"),
	        effect = getValidEnumValue(transitionEffect, options.transitionEffect),
	        effectSpeed = options.transitionEffectSpeed,
	        newStep = stepContents.eq(index),
	        currentStep = stepContents.eq(oldIndex);
	
	    switch (effect)
	    {
	        case transitionEffect.fade:
	        case transitionEffect.slide:
	            var hide = (effect === transitionEffect.fade) ? "fadeOut" : "slideUp",
	                show = (effect === transitionEffect.fade) ? "fadeIn" : "slideDown";
	
	            state.transitionElement = newStep;
	            currentStep[hide](effectSpeed, function ()
	            {
	                var wizard = $(this)._showAria(false).parent().parent(),
	                    state = getState(wizard);
	
	                if (state.transitionElement)
	                {
	                    state.transitionElement[show](effectSpeed, function ()
	                    {
	                        $(this)._showAria();
	                    }).promise().done(doneCallback);
	                    state.transitionElement = null;
	                }
	            });
	            break;
	
	        case transitionEffect.slideLeft:
	            var outerWidth = currentStep.outerWidth(true),
	                posFadeOut = (index > oldIndex) ? -(outerWidth) : outerWidth,
	                posFadeIn = (index > oldIndex) ? outerWidth : -(outerWidth);
	
	            $.when(currentStep.animate({ left: posFadeOut }, effectSpeed, 
	                    function () { $(this)._showAria(false); }),
	                newStep.css("left", posFadeIn + "px")._showAria()
	                    .animate({ left: 0 }, effectSpeed)).done(doneCallback);
	            break;
	
	        default:
	            $.when(currentStep._showAria(false), newStep._showAria())
	                .done(doneCallback);
	            break;
	    }
	}
	
	/**
	 * Fires when a step click happens.
	 *
	 * @static
	 * @private
	 * @event click
	 * @param event {Object} An event object
	 */
	function stepClickHandler(event)
	{
	    event.preventDefault();
	
	    var anchor = $(this),
	        wizard = anchor.parent().parent().parent().parent(),
	        options = getOptions(wizard),
	        state = getState(wizard),
	        oldIndex = state.currentIndex;
	
	    if (anchor.parent().is(":not(.disabled):not(.current)"))
	    {
	        var href = anchor.attr("href"),
	            position = parseInt(href.substring(href.lastIndexOf("-") + 1), 0);
	
	        goToStep(wizard, options, state, position);
	    }
	
	    // If nothing has changed
	    if (oldIndex === state.currentIndex)
	    {
	        getStepAnchor(wizard, oldIndex).focus();
	        return false;
	    }
	}
	
	function throwError(message)
	{
	    if (arguments.length > 1)
	    {
	        message = message.format(Array.prototype.slice.call(arguments, 1));
	    }
	
	    throw new Error(message);
	}
	
	/**
	 * Checks an argument for null or undefined and throws an error if one check applies.
	 *
	 * @static
	 * @private
	 * @method validateArgument
	 * @param argumentName {String} The name of the given argument
	 * @param argumentValue {Object} The argument itself
	 */
	function validateArgument(argumentName, argumentValue)
	{
	    if (argumentValue == null)
	    {
	        throwError("The argument '{0}' is null or undefined.", argumentName);
	    }
	}
	
	/**
	 * Represents a jQuery wizard plugin.
	 *
	 * @class steps
	 * @constructor
	 * @param [method={}] The name of the method as `String` or an JSON object for initialization
	 * @param [params=]* {Array} Additional arguments for a method call
	 * @chainable
	 **/
	$.fn.steps = function (method)
	{
	    if ($.fn.steps[method])
	    {
	        return $.fn.steps[method].apply(this, Array.prototype.slice.call(arguments, 1));
	    }
	    else if (typeof method === "object" || !method)
	    {
	        return initialize.apply(this, arguments);
	    }
	    else
	    {
	        $.error("Method " + method + " does not exist on jQuery.steps");
	    }
	};
	
	/**
	 * Adds a new step.
	 *
	 * @method add
	 * @param step {Object} The step object to add
	 * @chainable
	 **/
	$.fn.steps.add = function (step)
	{
	    var state = getState(this);
	    return insertStep(this, getOptions(this), state, state.stepCount, step);
	};
	
	/**
	 * Removes the control functionality completely and transforms the current state to the initial HTML structure.
	 *
	 * @method destroy
	 * @chainable
	 **/
	$.fn.steps.destroy = function ()
	{
	    return destroy(this, getOptions(this));
	};
	
	/**
	 * Triggers the onFinishing and onFinished event.
	 *
	 * @method finish
	 **/
	$.fn.steps.finish = function ()
	{
	    finishStep(this, getState(this));
	};
	
	/**
	 * Gets the current step index.
	 *
	 * @method getCurrentIndex
	 * @return {Integer} The actual step index (zero-based)
	 * @for steps
	 **/
	$.fn.steps.getCurrentIndex = function ()
	{
	    return getState(this).currentIndex;
	};
	
	/**
	 * Gets the current step object.
	 *
	 * @method getCurrentStep
	 * @return {Object} The actual step object
	 **/
	$.fn.steps.getCurrentStep = function ()
	{
	    return getStep(this, getState(this).currentIndex);
	};
	
	/**
	 * Gets a specific step object by index.
	 *
	 * @method getStep
	 * @param index {Integer} An integer that belongs to the position of a step
	 * @return {Object} A specific step object
	 **/
	$.fn.steps.getStep = function (index)
	{
	    return getStep(this, index);
	};
	
	/**
	 * Inserts a new step to a specific position.
	 *
	 * @method insert
	 * @param index {Integer} The position (zero-based) to add
	 * @param step {Object} The step object to add
	 * @example
	 *     $("#wizard").steps().insert(0, {
	 *         title: "Title",
	 *         content: "", // optional
	 *         contentMode: "async", // optional
	 *         contentUrl: "/Content/Step/1" // optional
	 *     });
	 * @chainable
	 **/
	$.fn.steps.insert = function (index, step)
	{
	    return insertStep(this, getOptions(this), getState(this), index, step);
	};
	
	/**
	 * Routes to the next step.
	 *
	 * @method next
	 * @return {Boolean} Indicates whether the action executed
	 **/
	$.fn.steps.next = function ()
	{
	    return goToNextStep(this, getOptions(this), getState(this));
	};
	
	/**
	 * Routes to the previous step.
	 *
	 * @method previous
	 * @return {Boolean} Indicates whether the action executed
	 **/
	$.fn.steps.previous = function ()
	{
	    return goToPreviousStep(this, getOptions(this), getState(this));
	};
	
	/**
	 * Removes a specific step by an given index.
	 *
	 * @method remove
	 * @param index {Integer} The position (zero-based) of the step to remove
	 * @return Indecates whether the item is removed.
	 **/
	$.fn.steps.remove = function (index)
	{
	    return removeStep(this, getOptions(this), getState(this), index);
	};
	
	/**
	 * Sets a specific step object by index.
	 *
	 * @method setStep
	 * @param index {Integer} An integer that belongs to the position of a step
	 * @param step {Object} The step object to change
	 **/
	$.fn.steps.setStep = function (index, step)
	{
	    throw new Error("Not yet implemented!");
	};
	
	/**
	 * Skips an certain amount of steps.
	 *
	 * @method skip
	 * @param count {Integer} The amount of steps that should be skipped
	 * @return {Boolean} Indicates whether the action executed
	 **/
	$.fn.steps.skip = function (count)
	{
	    throw new Error("Not yet implemented!");
	};
	
	/**
	 * An enum represents the different content types of a step and their loading mechanisms.
	 *
	 * @class contentMode
	 * @for steps
	 **/
	var contentMode = $.fn.steps.contentMode = {
	    /**
	     * HTML embedded content
	     *
	     * @readOnly
	     * @property html
	     * @type Integer
	     * @for contentMode
	     **/
	    html: 0,
	
	    /**
	     * IFrame embedded content
	     *
	     * @readOnly
	     * @property iframe
	     * @type Integer
	     * @for contentMode
	     **/
	    iframe: 1,
	
	    /**
	     * Async embedded content
	     *
	     * @readOnly
	     * @property async
	     * @type Integer
	     * @for contentMode
	     **/
	    async: 2
	};
	
	/**
	 * An enum represents the orientation of the steps navigation.
	 *
	 * @class stepsOrientation
	 * @for steps
	 **/
	var stepsOrientation = $.fn.steps.stepsOrientation = {
	    /**
	     * Horizontal orientation
	     *
	     * @readOnly
	     * @property horizontal
	     * @type Integer
	     * @for stepsOrientation
	     **/
	    horizontal: 0,
	
	    /**
	     * Vertical orientation
	     *
	     * @readOnly
	     * @property vertical
	     * @type Integer
	     * @for stepsOrientation
	     **/
	    vertical: 1
	};
	
	/**
	 * An enum that represents the various transition animations.
	 *
	 * @class transitionEffect
	 * @for steps
	 **/
	var transitionEffect = $.fn.steps.transitionEffect = {
	    /**
	     * No transition animation
	     *
	     * @readOnly
	     * @property none
	     * @type Integer
	     * @for transitionEffect
	     **/
	    none: 0,
	
	    /**
	     * Fade in transition
	     *
	     * @readOnly
	     * @property fade
	     * @type Integer
	     * @for transitionEffect
	     **/
	    fade: 1,
	
	    /**
	     * Slide up transition
	     *
	     * @readOnly
	     * @property slide
	     * @type Integer
	     * @for transitionEffect
	     **/
	    slide: 2,
	
	    /**
	     * Slide left transition
	     *
	     * @readOnly
	     * @property slideLeft
	     * @type Integer
	     * @for transitionEffect
	     **/
	    slideLeft: 3
	};
	
	var stepModel = $.fn.steps.stepModel = {
	    title: "",
	    content: "",
	    contentUrl: "",
	    contentMode: contentMode.html,
	    contentLoaded: false
	};
	
	/**
	 * An object that represents the default settings.
	 * There are two possibities to override the sub-properties.
	 * Either by doing it generally (global) or on initialization.
	 *
	 * @static
	 * @class defaults
	 * @for steps
	 * @example
	 *   // Global approach
	 *   $.steps.defaults.headerTag = "h3";
	 * @example
	 *   // Initialization approach
	 *   $("#wizard").steps({ headerTag: "h3" });
	 **/
	var defaults = $.fn.steps.defaults = {
	    /**
	     * The header tag is used to find the step button text within the declared wizard area.
	     *
	     * @property headerTag
	     * @type String
	     * @default "h1"
	     * @for defaults
	     **/
	    headerTag: "h1",
	
	    /**
	     * The body tag is used to find the step content within the declared wizard area.
	     *
	     * @property bodyTag
	     * @type String
	     * @default "div"
	     * @for defaults
	     **/
	    bodyTag: "div",
	
	    /**
	     * The content container tag which will be used to wrap all step contents.
	     *
	     * @property contentContainerTag
	     * @type String
	     * @default "div"
	     * @for defaults
	     **/
	    contentContainerTag: "div",
	
	    /**
	     * The action container tag which will be used to wrap the pagination navigation.
	     *
	     * @property actionContainerTag
	     * @type String
	     * @default "div"
	     * @for defaults
	     **/
	    actionContainerTag: "div",
	
	    /**
	     * The steps container tag which will be used to wrap the steps navigation.
	     *
	     * @property stepsContainerTag
	     * @type String
	     * @default "div"
	     * @for defaults
	     **/
	    stepsContainerTag: "div",
	
	    /**
	     * The css class which will be added to the outer component wrapper.
	     *
	     * @property cssClass
	     * @type String
	     * @default "wizard"
	     * @for defaults
	     * @example
	     *     <div class="wizard">
	     *         ...
	     *     </div>
	     **/
	    cssClass: "wizard",
	
	    /**
	     * The css class which will be used for floating scenarios.
	     *
	     * @property clearFixCssClass
	     * @type String
	     * @default "clearfix"
	     * @for defaults
	     **/
	    clearFixCssClass: "clearfix",
	
	    /**
	     * Determines whether the steps are vertically or horizontally oriented.
	     *
	     * @property stepsOrientation
	     * @type stepsOrientation
	     * @default horizontal
	     * @for defaults
	     * @since 1.0.0
	     **/
	    stepsOrientation: stepsOrientation.horizontal,
	
	    /*
	     * Tempplates
	     */
	
	    /**
	     * The title template which will be used to create a step button.
	     *
	     * @property titleTemplate
	     * @type String
	     * @default "<span class=\"number\">#index#.</span> #title#"
	     * @for defaults
	     **/
	    titleTemplate: "<span class=\"number\">#index#.</span> #title#",
	
	    /**
	     * The loading template which will be used to create the loading animation.
	     *
	     * @property loadingTemplate
	     * @type String
	     * @default "<span class=\"spinner\"></span> #text#"
	     * @for defaults
	     **/
	    loadingTemplate: "<span class=\"spinner\"></span> #text#",
	
	    /*
	     * Behaviour
	     */
	
	    /**
	     * Sets the focus to the first wizard instance in order to enable the key navigation from the begining if `true`. 
	     *
	     * @property autoFocus
	     * @type Boolean
	     * @default false
	     * @for defaults
	     * @since 0.9.4
	     **/
	    autoFocus: false,
	
	    /**
	     * Enables all steps from the begining if `true` (all steps are clickable).
	     *
	     * @property enableAllSteps
	     * @type Boolean
	     * @default false
	     * @for defaults
	     **/
	    enableAllSteps: false,
	
	    /**
	     * Enables keyboard navigation if `true` (arrow left and arrow right).
	     *
	     * @property enableKeyNavigation
	     * @type Boolean
	     * @default true
	     * @for defaults
	     **/
	    enableKeyNavigation: true,
	
	    /**
	     * Enables pagination if `true`.
	     *
	     * @property enablePagination
	     * @type Boolean
	     * @default true
	     * @for defaults
	     **/
	    enablePagination: true,
	
	    /**
	     * Suppresses pagination if a form field is focused.
	     *
	     * @property suppressPaginationOnFocus
	     * @type Boolean
	     * @default true
	     * @for defaults
	     **/
	    suppressPaginationOnFocus: true,
	
	    /**
	     * Enables cache for async loaded or iframe embedded content.
	     *
	     * @property enableContentCache
	     * @type Boolean
	     * @default true
	     * @for defaults
	     **/
	    enableContentCache: true,
	
	    /**
	     * Shows the cancel button if enabled.
	     *
	     * @property enableCancelButton
	     * @type Boolean
	     * @default false
	     * @for defaults
	     **/
	    enableCancelButton: false,
	
	    /**
	     * Shows the finish button if enabled.
	     *
	     * @property enableFinishButton
	     * @type Boolean
	     * @default true
	     * @for defaults
	     **/
	    enableFinishButton: true,
	
	    /**
	     * Not yet implemented.
	     *
	     * @property preloadContent
	     * @type Boolean
	     * @default false
	     * @for defaults
	     **/
	    preloadContent: false,
	
	    /**
	     * Shows the finish button always (on each step; right beside the next button) if `true`. 
	     * Otherwise the next button will be replaced by the finish button if the last step becomes active.
	     *
	     * @property showFinishButtonAlways
	     * @type Boolean
	     * @default false
	     * @for defaults
	     **/
	    showFinishButtonAlways: false,
	
	    /**
	     * Prevents jumping to a previous step.
	     *
	     * @property forceMoveForward
	     * @type Boolean
	     * @default false
	     * @for defaults
	     **/
	    forceMoveForward: false,
	
	    /**
	     * Saves the current state (step position) to a cookie.
	     * By coming next time the last active step becomes activated.
	     *
	     * @property saveState
	     * @type Boolean
	     * @default false
	     * @for defaults
	     **/
	    saveState: false,
	
	    /**
	     * The position to start on (zero-based).
	     *
	     * @property startIndex
	     * @type Integer
	     * @default 0
	     * @for defaults
	     **/
	    startIndex: 0,
	
	    /*
	     * Animation Effect Configuration
	     */
	
	    /**
	     * The animation effect which will be used for step transitions.
	     *
	     * @property transitionEffect
	     * @type transitionEffect
	     * @default none
	     * @for defaults
	     **/
	    transitionEffect: transitionEffect.none,
	
	    /**
	     * Animation speed for step transitions (in milliseconds).
	     *
	     * @property transitionEffectSpeed
	     * @type Integer
	     * @default 200
	     * @for defaults
	     **/
	    transitionEffectSpeed: 200,
	
	    /*
	     * Events
	     */
	
	    /**
	     * Fires before the step changes and can be used to prevent step changing by returning `false`. 
	     * Very useful for form validation. 
	     *
	     * @property onStepChanging
	     * @type Event
	     * @default function (event, currentIndex, newIndex) { return true; }
	     * @for defaults
	     **/
	    onStepChanging: function (event, currentIndex, newIndex) { return true; },
	
	    /**
	     * Fires after the step has change. 
	     *
	     * @property onStepChanged
	     * @type Event
	     * @default function (event, currentIndex, priorIndex) { }
	     * @for defaults
	     **/
	    onStepChanged: function (event, currentIndex, priorIndex) { },
	
	    /**
	     * Fires after cancelation. 
	     *
	     * @property onCanceled
	     * @type Event
	     * @default function (event) { }
	     * @for defaults
	     **/
	    onCanceled: function (event) { },
	
	    /**
	     * Fires before finishing and can be used to prevent completion by returning `false`. 
	     * Very useful for form validation. 
	     *
	     * @property onFinishing
	     * @type Event
	     * @default function (event, currentIndex) { return true; }
	     * @for defaults
	     **/
	    onFinishing: function (event, currentIndex) { return true; },
	
	    /**
	     * Fires after completion. 
	     *
	     * @property onFinished
	     * @type Event
	     * @default function (event, currentIndex) { }
	     * @for defaults
	     **/
	    onFinished: function (event, currentIndex) { },
	
	    /**
	     * Fires after async content is loaded. 
	     *
	     * @property onContentLoaded
	     * @type Event
	     * @default function (event, index) { }
	     * @for defaults
	     **/
	    onContentLoaded: function (event, currentIndex) { },
	
	    /**
	     * Fires when the wizard is initialized. 
	     *
	     * @property onInit
	     * @type Event
	     * @default function (event) { }
	     * @for defaults
	     **/
	    onInit: function (event, currentIndex) { },
	
	    /**
	     * Contains all labels. 
	     *
	     * @property labels
	     * @type Object
	     * @for defaults
	     **/
	    labels: {
	        /**
	         * Label for the cancel button.
	         *
	         * @property cancel
	         * @type String
	         * @default "Cancel"
	         * @for defaults
	         **/
	        cancel: "Cancel",
	
	        /**
	         * This label is important for accessability reasons.
	         * Indicates which step is activated.
	         *
	         * @property current
	         * @type String
	         * @default "current step:"
	         * @for defaults
	         **/
	        current: "current step:",
	
	        /**
	         * This label is important for accessability reasons and describes the kind of navigation.
	         *
	         * @property pagination
	         * @type String
	         * @default "Pagination"
	         * @for defaults
	         * @since 0.9.7
	         **/
	        pagination: "Pagination",
	
	        /**
	         * Label for the finish button.
	         *
	         * @property finish
	         * @type String
	         * @default "Finish"
	         * @for defaults
	         **/
	        finish: "Finish",
	
	        /**
	         * Label for the next button.
	         *
	         * @property next
	         * @type String
	         * @default "Next"
	         * @for defaults
	         **/
	        next: "Next",
	
	        /**
	         * Label for the previous button.
	         *
	         * @property previous
	         * @type String
	         * @default "Previous"
	         * @for defaults
	         **/
	        previous: "Previous",
	
	        /**
	         * Label for the loading animation.
	         *
	         * @property loading
	         * @type String
	         * @default "Loading ..."
	         * @for defaults
	         **/
	        loading: "Loading ..."
	    }
	};
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * FooTable - Awesome Responsive Tables
	 * Version : 2.0.3
	 * http://fooplugins.com/plugins/footable-jquery/
	 *
	 * Requires jQuery - http://jquery.com/
	 *
	 * Copyright 2014 Steven Usher & Brad Vincent
	 * Released under the MIT license
	 * You are free to use FooTable in commercial projects as long as this copyright header is left intact.
	 *
	 * Date: 11 Nov 2014
	 */
	(function(e,t){function a(){var e=this;e.id=null,e.busy=!1,e.start=function(t,a){e.busy||(e.stop(),e.id=setTimeout(function(){t(),e.id=null,e.busy=!1},a),e.busy=!0)},e.stop=function(){null!==e.id&&(clearTimeout(e.id),e.id=null,e.busy=!1)}}function i(i,o,n){var r=this;r.id=n,r.table=i,r.options=o,r.breakpoints=[],r.breakpointNames="",r.columns={},r.plugins=t.footable.plugins.load(r);var l=r.options,d=l.classes,s=l.events,u=l.triggers,f=0;return r.timers={resize:new a,register:function(e){return r.timers[e]=new a,r.timers[e]}},r.init=function(){var a=e(t),i=e(r.table);if(t.footable.plugins.init(r),i.hasClass(d.loaded))return r.raise(s.alreadyInitialized),undefined;r.raise(s.initializing),i.addClass(d.loading),i.find(l.columnDataSelector).each(function(){var e=r.getColumnData(this);r.columns[e.index]=e});for(var o in l.breakpoints)r.breakpoints.push({name:o,width:l.breakpoints[o]}),r.breakpointNames+=o+" ";r.breakpoints.sort(function(e,t){return e.width-t.width}),i.unbind(u.initialize).bind(u.initialize,function(){i.removeData("footable_info"),i.data("breakpoint",""),i.trigger(u.resize),i.removeClass(d.loading),i.addClass(d.loaded).addClass(d.main),r.raise(s.initialized)}).unbind(u.redraw).bind(u.redraw,function(){r.redraw()}).unbind(u.resize).bind(u.resize,function(){r.resize()}).unbind(u.expandFirstRow).bind(u.expandFirstRow,function(){i.find(l.toggleSelector).first().not("."+d.detailShow).trigger(u.toggleRow)}).unbind(u.expandAll).bind(u.expandAll,function(){i.find(l.toggleSelector).not("."+d.detailShow).trigger(u.toggleRow)}).unbind(u.collapseAll).bind(u.collapseAll,function(){i.find("."+d.detailShow).trigger(u.toggleRow)}),i.trigger(u.initialize),a.bind("resize.footable",function(){r.timers.resize.stop(),r.timers.resize.start(function(){r.raise(u.resize)},l.delay)})},r.addRowToggle=function(){if(l.addRowToggle){var t=e(r.table),a=!1;t.find("span."+d.toggle).remove();for(var i in r.columns){var o=r.columns[i];if(o.toggle){a=!0;var n="> tbody > tr:not(."+d.detail+",."+d.disabled+") > td:nth-child("+(parseInt(o.index,10)+1)+"),"+"> tbody > tr:not(."+d.detail+",."+d.disabled+") > th:nth-child("+(parseInt(o.index,10)+1)+")";return t.find(n).not("."+d.detailCell).prepend(e(l.toggleHTMLElement).addClass(d.toggle)),undefined}}a||t.find("> tbody > tr:not(."+d.detail+",."+d.disabled+") > td:first-child").add("> tbody > tr:not(."+d.detail+",."+d.disabled+") > th:first-child").not("."+d.detailCell).prepend(e(l.toggleHTMLElement).addClass(d.toggle))}},r.setColumnClasses=function(){var t=e(r.table);for(var a in r.columns){var i=r.columns[a];if(null!==i.className){var o="",n=!0;e.each(i.matches,function(e,t){n||(o+=", "),o+="> tbody > tr:not(."+d.detail+") > td:nth-child("+(parseInt(t,10)+1)+")",n=!1}),t.find(o).not("."+d.detailCell).addClass(i.className)}}},r.bindToggleSelectors=function(){var t=e(r.table);r.hasAnyBreakpointColumn()&&(t.find(l.toggleSelector).unbind(u.toggleRow).bind(u.toggleRow,function(){var t=e(this).is("tr")?e(this):e(this).parents("tr:first");r.toggleDetail(t)}),t.find(l.toggleSelector).unbind("click.footable").bind("click.footable",function(a){t.is(".breakpoint")&&e(a.target).is("td,th,."+d.toggle)&&e(this).trigger(u.toggleRow)}))},r.parse=function(e,t){var a=l.parsers[t.type]||l.parsers.alpha;return a(e)},r.getColumnData=function(t){var a=e(t),i=a.data("hide"),o=a.index();i=i||"",i=jQuery.map(i.split(","),function(e){return jQuery.trim(e)});var n={index:o,hide:{},type:a.data("type")||"alpha",name:a.data("name")||e.trim(a.text()),ignore:a.data("ignore")||!1,toggle:a.data("toggle")||!1,className:a.data("class")||null,matches:[],names:{},group:a.data("group")||null,groupName:null,isEditable:a.data("editable")};if(null!==n.group){var d=e(r.table).find('> thead > tr.footable-group-row > th[data-group="'+n.group+'"], > thead > tr.footable-group-row > td[data-group="'+n.group+'"]').first();n.groupName=r.parse(d,{type:"alpha"})}var u=parseInt(a.prev().attr("colspan")||0,10);f+=u>1?u-1:0;var p=parseInt(a.attr("colspan")||0,10),c=n.index+f;if(p>1){var b=a.data("names");b=b||"",b=b.split(",");for(var g=0;p>g;g++)n.matches.push(g+c),b.length>g&&(n.names[g+c]=b[g])}else n.matches.push(c);n.hide["default"]="all"===a.data("hide")||e.inArray("default",i)>=0;var h=!1;for(var m in l.breakpoints)n.hide[m]="all"===a.data("hide")||e.inArray(m,i)>=0,h=h||n.hide[m];n.hasBreakpoint=h;var v=r.raise(s.columnData,{column:{data:n,th:t}});return v.column.data},r.getViewportWidth=function(){return window.innerWidth||(document.body?document.body.offsetWidth:0)},r.calculateWidth=function(e,t){return jQuery.isFunction(l.calculateWidthOverride)?l.calculateWidthOverride(e,t):(t.viewportWidth<t.width&&(t.width=t.viewportWidth),t.parentWidth<t.width&&(t.width=t.parentWidth),t)},r.hasBreakpointColumn=function(e){for(var t in r.columns)if(r.columns[t].hide[e]){if(r.columns[t].ignore)continue;return!0}return!1},r.hasAnyBreakpointColumn=function(){for(var e in r.columns)if(r.columns[e].hasBreakpoint)return!0;return!1},r.resize=function(){var t=e(r.table);if(t.is(":visible")){if(!r.hasAnyBreakpointColumn())return t.trigger(u.redraw),undefined;var a={width:t.width(),viewportWidth:r.getViewportWidth(),parentWidth:t.parent().width()};a=r.calculateWidth(t,a);var i=t.data("footable_info");if(t.data("footable_info",a),r.raise(s.resizing,{old:i,info:a}),!i||i&&i.width&&i.width!==a.width){for(var o,n=null,l=0;r.breakpoints.length>l;l++)if(o=r.breakpoints[l],o&&o.width&&a.width<=o.width){n=o;break}var d=null===n?"default":n.name,f=r.hasBreakpointColumn(d),p=t.data("breakpoint");t.data("breakpoint",d).removeClass("default breakpoint").removeClass(r.breakpointNames).addClass(d+(f?" breakpoint":"")),d!==p&&(t.trigger(u.redraw),r.raise(s.breakpoint,{breakpoint:d,info:a}))}r.raise(s.resized,{old:i,info:a})}},r.redraw=function(){r.addRowToggle(),r.bindToggleSelectors(),r.setColumnClasses();var t=e(r.table),a=t.data("breakpoint"),i=r.hasBreakpointColumn(a);t.find("> tbody > tr:not(."+d.detail+")").data("detail_created",!1).end().find("> thead > tr:last-child > th").each(function(){var i=r.columns[e(this).index()],o="",n=!0;e.each(i.matches,function(e,t){n||(o+=", ");var a=t+1;o+="> tbody > tr:not(."+d.detail+") > td:nth-child("+a+")",o+=", > tfoot > tr:not(."+d.detail+") > td:nth-child("+a+")",o+=", > colgroup > col:nth-child("+a+")",n=!1}),o+=', > thead > tr[data-group-row="true"] > th[data-group="'+i.group+'"]';var l=t.find(o).add(this);if(""!==a&&(i.hide[a]===!1?l.addClass("footable-visible").show():l.removeClass("footable-visible").hide()),1===t.find("> thead > tr.footable-group-row").length){var s=t.find('> thead > tr:last-child > th[data-group="'+i.group+'"]:visible, > thead > tr:last-child > th[data-group="'+i.group+'"]:visible'),u=t.find('> thead > tr.footable-group-row > th[data-group="'+i.group+'"], > thead > tr.footable-group-row > td[data-group="'+i.group+'"]'),f=0;e.each(s,function(){f+=parseInt(e(this).attr("colspan")||1,10)}),f>0?u.attr("colspan",f).show():u.hide()}}).end().find("> tbody > tr."+d.detailShow).each(function(){r.createOrUpdateDetailRow(this)}),t.find("[data-bind-name]").each(function(){r.toggleInput(this)}),t.find("> tbody > tr."+d.detailShow+":visible").each(function(){var t=e(this).next();t.hasClass(d.detail)&&(i?t.show():t.hide())}),t.find("> thead > tr > th.footable-last-column, > tbody > tr > td.footable-last-column").removeClass("footable-last-column"),t.find("> thead > tr > th.footable-first-column, > tbody > tr > td.footable-first-column").removeClass("footable-first-column"),t.find("> thead > tr, > tbody > tr").find("> th.footable-visible:last, > td.footable-visible:last").addClass("footable-last-column").end().find("> th.footable-visible:first, > td.footable-visible:first").addClass("footable-first-column"),r.raise(s.redrawn)},r.toggleDetail=function(t){var a=t.jquery?t:e(t),i=a.next();a.hasClass(d.detailShow)?(a.removeClass(d.detailShow),i.hasClass(d.detail)&&i.hide(),r.raise(s.rowCollapsed,{row:a[0]})):(r.createOrUpdateDetailRow(a[0]),a.addClass(d.detailShow).next().show(),r.raise(s.rowExpanded,{row:a[0]}))},r.removeRow=function(t){var a=t.jquery?t:e(t);a.hasClass(d.detail)&&(a=a.prev());var i=a.next();a.data("detail_created")===!0&&i.remove(),a.remove(),r.raise(s.rowRemoved)},r.appendRow=function(t){var a=t.jquery?t:e(t);e(r.table).find("tbody").append(a),r.redraw()},r.getColumnFromTdIndex=function(t){var a=null;for(var i in r.columns)if(e.inArray(t,r.columns[i].matches)>=0){a=r.columns[i];break}return a},r.createOrUpdateDetailRow=function(t){var a,i=e(t),o=i.next(),n=[];if(i.data("detail_created")===!0)return!0;if(i.is(":hidden"))return!1;if(r.raise(s.rowDetailUpdating,{row:i,detail:o}),i.find("> td:hidden").each(function(){var t=e(this).index(),a=r.getColumnFromTdIndex(t),i=a.name;if(a.ignore===!0)return!0;t in a.names&&(i=a.names[t]);var o=e(this).attr("data-bind-name");if(null!=o&&e(this).is(":empty")){var l=e("."+d.detailInnerValue+"["+'data-bind-value="'+o+'"]');e(this).html(e(l).contents().detach())}var s;return a.isEditable!==!1&&(a.isEditable||e(this).find(":input").length>0)&&(null==o&&(o="bind-"+e.now()+"-"+t,e(this).attr("data-bind-name",o)),s=e(this).contents().detach()),s||(s=e(this).contents().clone(!0,!0)),n.push({name:i,value:r.parse(this,a),display:s,group:a.group,groupName:a.groupName,bindName:o}),!0}),0===n.length)return!1;var u=i.find("> td:visible").length,f=o.hasClass(d.detail);return f||(o=e('<tr class="'+d.detail+'"><td class="'+d.detailCell+'"><div class="'+d.detailInner+'"></div></td></tr>'),i.after(o)),o.find("> td:first").attr("colspan",u),a=o.find("."+d.detailInner).empty(),l.createDetail(a,n,l.createGroupedDetail,l.detailSeparator,d),i.data("detail_created",!0),r.raise(s.rowDetailUpdated,{row:i,detail:o}),!f},r.raise=function(t,a){r.options.debug===!0&&e.isFunction(r.options.log)&&r.options.log(t,"event"),a=a||{};var i={ft:r};e.extend(!0,i,a);var o=e.Event(t,i);return o.ft||e.extend(!0,o,i),e(r.table).trigger(o),o},r.reset=function(){var t=e(r.table);t.removeData("footable_info").data("breakpoint","").removeClass(d.loading).removeClass(d.loaded),t.find(l.toggleSelector).unbind(u.toggleRow).unbind("click.footable"),t.find("> tbody > tr").removeClass(d.detailShow),t.find("> tbody > tr."+d.detail).remove(),r.raise(s.reset)},r.toggleInput=function(t){var a=e(t).attr("data-bind-name");if(null!=a){var i=e("."+d.detailInnerValue+"["+'data-bind-value="'+a+'"]');null!=i&&(e(t).is(":visible")?e(i).is(":empty")||e(t).html(e(i).contents().detach()):e(t).is(":empty")||e(i).html(e(t).contents().detach()))}},r.init(),r}t.footable={options:{delay:100,breakpoints:{phone:480,tablet:1024},parsers:{alpha:function(t){return e(t).data("value")||e.trim(e(t).text())},numeric:function(t){var a=e(t).data("value")||e(t).text().replace(/[^0-9.\-]/g,"");return a=parseFloat(a),isNaN(a)&&(a=0),a}},addRowToggle:!0,calculateWidthOverride:null,toggleSelector:" > tbody > tr:not(.footable-row-detail)",columnDataSelector:"> thead > tr:last-child > th, > thead > tr:last-child > td",detailSeparator:":",toggleHTMLElement:"<span />",createGroupedDetail:function(e){for(var t={_none:{name:null,data:[]}},a=0;e.length>a;a++){var i=e[a].group;null!==i?(i in t||(t[i]={name:e[a].groupName||e[a].group,data:[]}),t[i].data.push(e[a])):t._none.data.push(e[a])}return t},createDetail:function(t,a,i,o,n){var r=i(a);for(var l in r)if(0!==r[l].data.length){"_none"!==l&&t.append('<div class="'+n.detailInnerGroup+'">'+r[l].name+"</div>");for(var d=0;r[l].data.length>d;d++){var s=r[l].data[d].name?o:"";t.append(e("<div></div>").addClass(n.detailInnerRow).append(e("<div></div>").addClass(n.detailInnerName).append(r[l].data[d].name+s)).append(e("<div></div>").addClass(n.detailInnerValue).attr("data-bind-value",r[l].data[d].bindName).append(r[l].data[d].display)))}}},classes:{main:"footable",loading:"footable-loading",loaded:"footable-loaded",toggle:"footable-toggle",disabled:"footable-disabled",detail:"footable-row-detail",detailCell:"footable-row-detail-cell",detailInner:"footable-row-detail-inner",detailInnerRow:"footable-row-detail-row",detailInnerGroup:"footable-row-detail-group",detailInnerName:"footable-row-detail-name",detailInnerValue:"footable-row-detail-value",detailShow:"footable-detail-show"},triggers:{initialize:"footable_initialize",resize:"footable_resize",redraw:"footable_redraw",toggleRow:"footable_toggle_row",expandFirstRow:"footable_expand_first_row",expandAll:"footable_expand_all",collapseAll:"footable_collapse_all"},events:{alreadyInitialized:"footable_already_initialized",initializing:"footable_initializing",initialized:"footable_initialized",resizing:"footable_resizing",resized:"footable_resized",redrawn:"footable_redrawn",breakpoint:"footable_breakpoint",columnData:"footable_column_data",rowDetailUpdating:"footable_row_detail_updating",rowDetailUpdated:"footable_row_detail_updated",rowCollapsed:"footable_row_collapsed",rowExpanded:"footable_row_expanded",rowRemoved:"footable_row_removed",reset:"footable_reset"},debug:!1,log:null},version:{major:0,minor:5,toString:function(){return t.footable.version.major+"."+t.footable.version.minor},parse:function(e){var t=/(\d+)\.?(\d+)?\.?(\d+)?/.exec(e);return{major:parseInt(t[1],10)||0,minor:parseInt(t[2],10)||0,patch:parseInt(t[3],10)||0}}},plugins:{_validate:function(a){if(!e.isFunction(a))return t.footable.options.debug===!0&&console.error('Validation failed, expected type "function", received type "{0}".',typeof a),!1;var i=new a;return"string"!=typeof i.name?(t.footable.options.debug===!0&&console.error('Validation failed, plugin does not implement a string property called "name".',i),!1):e.isFunction(i.init)?(t.footable.options.debug===!0&&console.log('Validation succeeded for plugin "'+i.name+'".',i),!0):(t.footable.options.debug===!0&&console.error('Validation failed, plugin "'+i.name+'" does not implement a function called "init".',i),!1)},registered:[],register:function(a,i){t.footable.plugins._validate(a)&&(t.footable.plugins.registered.push(a),"object"==typeof i&&e.extend(!0,t.footable.options,i))},load:function(e){var a,i,o=[];for(i=0;t.footable.plugins.registered.length>i;i++)try{a=t.footable.plugins.registered[i],o.push(new a(e))}catch(n){t.footable.options.debug===!0&&console.error(n)}return o},init:function(e){for(var a=0;e.plugins.length>a;a++)try{e.plugins[a].init(e)}catch(i){t.footable.options.debug===!0&&console.error(i)}}}};var o=0;e.fn.footable=function(a){a=a||{};var n=e.extend(!0,{},t.footable.options,a);return this.each(function(){o++;var t=new i(this,n,o);e(this).data("footable",t)})}})(jQuery,window);;(function(e,t,undefined){function a(t){var a=e("<th>"+t.title+"</th>");return e.isPlainObject(t.data)&&a.data(t.data),e.isPlainObject(t.style)&&a.css(t.style),t.className&&a.addClass(t.className),a}function o(t,o){var i=t.find("thead");0===i.size()&&(i=e("<thead>").appendTo(t));for(var n=e("<tr>").appendTo(i),r=0,l=o.cols.length;l>r;r++)n.append(a(o.cols[r]))}function i(t){var a=t.find("tbody");0===a.size()&&(a=e("<tbody>").appendTo(t))}function n(t,a,o){if(o){t.attr("data-page-size",o["page-size"]);var i=t.find("tfoot");0===i.size()&&(i=e('<tfoot class="hide-if-no-paging"></tfoot>').appendTo(t)),i.append("<tr><td colspan="+a.length+"></td></tr>");var n=e("<div>").appendTo(i.find("tr:last-child td"));n.addClass(o["pagination-class"])}}function r(t){for(var a=t[0],o=0,i=t.length;i>o;o++){var n=t[o];if(n.data&&(n.data.toggle===!0||"true"===n.data.toggle))return}a.data=e.extend(a.data,{toggle:!0})}function l(e,t,a){0===e.find("tr.emptyInfo").size()&&e.find("tbody").append('<tr class="emptyInfo"><td colspan="'+t.length+'">'+a+"</td></tr>")}function d(t,a,o,i){t.find("tr:not(."+o+")").each(function(){var t=e(this),o=a.data("index"),n=parseInt(t.data("index"),0),r=n+i;n>=o&&this!==a.get(0)&&t.attr("data-index",r).data("index",r)})}function s(){function t(t,a,o){var i=e("<td>");return t.formatter?i.html(t.formatter(a,i,o)):i.html(a||""),i}var a=this;a.name="Footable Grid",a.init=function(t){var d=t.options.classes.toggle,s=t.options.classes.detail,f=t.options.grid;if(f.cols){a.footable=t;var u=e(t.table);u.data("grid",a),e.isPlainObject(f.data)&&u.data(f.data),a._items=[],r(f.cols),f.showCheckbox&&(f.multiSelect=!0,f.cols.unshift({title:f.checkboxFormatter(!0),name:"",data:{"sort-ignore":!0},formatter:f.checkboxFormatter})),f.showIndex&&f.cols.unshift({title:"#",name:"index",data:{"sort-ignore":!0},formatter:f.indexFormatter}),o(u,f),i(u),n(u,f.cols,f.pagination),u.off(".grid").on({"footable_initialized.grid":function(){f.url||f.ajax?e.ajax(f.ajax||{url:f.url}).then(function(e){a.newItem(e),t.raise(f.events.loaded)},function(){throw"load data from "+(f.url||f.ajax.url)+" fail"}):(a.newItem(f.items||[]),t.raise(f.events.loaded))},"footable_sorted.grid footable_grid_created.grid footable_grid_removed.grid":function(){f.showIndex&&a.getItem().length>0&&u.find("tbody tr:not(."+s+")").each(function(t){var a=e(this).find("td:first");a.html(f.indexFormatter(null,a,t))})},"footable_redrawn.grid footable_row_removed.grid":function(){0===a.getItem().length&&f.showEmptyInfo&&l(u,f.cols,f.emptyInfo)}}).on({"click.grid":function(a){if(e(a.target).closest("td").find(">."+d).size()>0)return!0;var o=e(a.currentTarget);return o.hasClass(s)?!0:(f.multiSelect||o.hasClass(f.activeClass)||u.find("tbody tr."+f.activeClass).removeClass(f.activeClass),o.toggleClass(f.activeClass),f.showCheckbox&&o.find("input:checkbox.check").prop("checked",function(e,t){return a.target===this?t:!t}),t.toggleDetail(o),undefined)}},"tbody tr").on("click.grid","thead input:checkbox.checkAll",function(e){var t=!!e.currentTarget.checked;t?u.find("tbody tr").addClass(f.activeClass):u.find("tbody tr").removeClass(f.activeClass),u.find("tbody input:checkbox.check").prop("checked",t)})}},a.getSelected=function(){var t=a.footable.options.grid,o=e(a.footable.table).find("tbody>tr."+t.activeClass);return o.map(function(){return e(this).data("index")})},a.getItem=function(t){return t!==undefined?e.isArray(t)?e.map(t,function(e){return a._items[e]}):a._items[t]:a._items},a._makeRow=function(o,i){var n,r=a.footable.options.grid;if(e.isFunction(r.template))n=e(r.template(e.extend({},{__index:i},o)));else{n=e("<tr>");for(var l=0,d=r.cols.length;d>l;l++){var s=r.cols[l];n.append(t(s,o[s.name]||"",i))}}return n.attr("data-index",i),n},a.newItem=function(t,o,i){var n=e(a.footable.table).find("tbody"),r=a.footable.options.classes.detail;if(n.find("tr.emptyInfo").remove(),e.isArray(t)){for(var l;l=t.pop();)a.newItem(l,o,!0);return a.footable.redraw(),a.footable.raise(a.footable.options.grid.events.created,{item:t,index:o}),undefined}if(e.isPlainObject(t)){var s,f=a._items.length;if(o===undefined||0>o||o>f)s=a._makeRow(t,f++),a._items.push(t),n.append(s);else{if(s=a._makeRow(t,o),0===o)a._items.unshift(t),n.prepend(s);else{var u=n.find("tr[data-index="+(o-1)+"]");a._items.splice(o,0,t),u.data("detail_created")===!0&&(u=u.next()),u.after(s)}d(n,s,r,1)}i||(a.footable.redraw(),a.footable.raise(a.footable.options.grid.events.created,{item:t,index:o}))}},a.setItem=function(t,o){if(e.isPlainObject(t)){var i=e(a.footable.table).find("tbody"),n=a._makeRow(t,o);e.extend(a._items[o],t);var r=i.find("tr").eq(o);r.html(n.html()),a.footable.redraw(),a.footable.raise(a.footable.options.grid.events.updated,{item:t,index:o})}},a.removeItem=function(t){var o=e(a.footable.table).find("tbody"),i=a.footable.options.classes.detail,n=[];if(e.isArray(t)){for(var r;r=t.pop();)n.push(a.removeItem(r));return a.footable.raise(a.footable.options.grid.events.removed,{item:n,index:t}),n}if(t===undefined)o.find("tr").each(function(){n.push(a._items.shift()),a.footable.removeRow(this)});else{var l=o.find("tr[data-index="+t+"]");n=a._items.splice(t,1)[0],a.footable.removeRow(l),d(o,l,i,-1)}return a.footable.raise(a.footable.options.grid.events.removed,{item:n,index:t}),n}}if(t.footable===undefined||null===t.foobox)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var f={grid:{enabled:!0,data:null,template:null,cols:null,items:null,url:null,ajax:null,activeClass:"active",multiSelect:!1,showIndex:!1,showCheckbox:!1,showEmptyInfo:!1,emptyInfo:'<p class="text-center text-warning">No Data</p>',pagination:{"page-size":20,"pagination-class":"pagination pagination-centered"},indexFormatter:function(e,t,a){return a+1},checkboxFormatter:function(e){return'<input type="checkbox" class="'+(e?"checkAll":"check")+'">'},events:{loaded:"footable_grid_loaded",created:"footable_grid_created",removed:"footable_grid_removed",updated:"footable_grid_updated"}}};t.footable.plugins.register(s,f)})(jQuery,window);;(function(t,e,undefined){function a(){var e=this;e.name="Footable Filter",e.init=function(a){if(e.footable=a,a.options.filter.enabled===!0){if(t(a.table).data("filter")===!1)return;a.timers.register("filter"),t(a.table).unbind(".filtering").bind({"footable_initialized.filtering":function(){var i=t(a.table),o={input:i.data("filter")||a.options.filter.input,timeout:i.data("filter-timeout")||a.options.filter.timeout,minimum:i.data("filter-minimum")||a.options.filter.minimum,disableEnter:i.data("filter-disable-enter")||a.options.filter.disableEnter};o.disableEnter&&t(o.input).keypress(function(t){return window.event?13!==window.event.keyCode:13!==t.which}),i.bind("footable_clear_filter",function(){t(o.input).val(""),e.clearFilter()}),i.bind("footable_filter",function(t,a){e.filter(a.filter)}),t(o.input).keyup(function(i){a.timers.filter.stop(),27===i.which&&t(o.input).val(""),a.timers.filter.start(function(){var a=t(o.input).val()||"";e.filter(a)},o.timeout)})},"footable_redrawn.filtering":function(){var i=t(a.table),o=i.data("filter-string");o&&e.filter(o)}}).data("footable-filter",e)}},e.filter=function(a){var i=e.footable,o=t(i.table),n=o.data("filter-minimum")||i.options.filter.minimum,r=!a,l=i.raise("footable_filtering",{filter:a,clear:r});if(!(l&&l.result===!1||l.filter&&n>l.filter.length))if(l.clear)e.clearFilter();else{var d=l.filter.split(" ");o.find("> tbody > tr").hide().addClass("footable-filtered");var s=o.find("> tbody > tr:not(.footable-row-detail)");t.each(d,function(t,e){e&&e.length>0&&(o.data("current-filter",e),s=s.filter(i.options.filter.filterFunction))}),s.each(function(){e.showRow(this,i),t(this).removeClass("footable-filtered")}),o.data("filter-string",l.filter),i.raise("footable_filtered",{filter:l.filter,clear:!1})}},e.clearFilter=function(){var a=e.footable,i=t(a.table);i.find("> tbody > tr:not(.footable-row-detail)").removeClass("footable-filtered").each(function(){e.showRow(this,a)}),i.removeData("filter-string"),a.raise("footable_filtered",{clear:!0})},e.showRow=function(e,a){var i=t(e),o=i.next(),n=t(a.table);i.is(":visible")||(n.hasClass("breakpoint")&&i.hasClass("footable-detail-show")&&o.hasClass("footable-row-detail")?(i.add(o).show(),a.createOrUpdateDetailRow(e)):i.show())}}if(e.footable===undefined||null===e.footable)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var i={filter:{enabled:!0,input:".footable-filter",timeout:300,minimum:2,disableEnter:!1,filterFunction:function(){var e=t(this),a=e.parents("table:first"),i=a.data("current-filter").toUpperCase(),o=e.find("td").text();return a.data("filter-text-only")||e.find("td[data-value]").each(function(){o+=t(this).data("value")}),o.toUpperCase().indexOf(i)>=0}}};e.footable.plugins.register(a,i)})(jQuery,window);;(function(e,t,undefined){function a(t){var a=e(t.table),i=a.data();this.pageNavigation=i.pageNavigation||t.options.pageNavigation,this.pageSize=i.pageSize||t.options.pageSize,this.firstText=i.firstText||t.options.firstText,this.previousText=i.previousText||t.options.previousText,this.nextText=i.nextText||t.options.nextText,this.lastText=i.lastText||t.options.lastText,this.limitNavigation=parseInt(i.limitNavigation||t.options.limitNavigation||o.limitNavigation,10),this.limitPreviousText=i.limitPreviousText||t.options.limitPreviousText,this.limitNextText=i.limitNextText||t.options.limitNextText,this.limit=this.limitNavigation>0,this.currentPage=i.currentPage||0,this.pages=[],this.control=!1}function i(){var t=this;t.name="Footable Paginate",t.init=function(a){if(a.options.paginate===!0){if(e(a.table).data("page")===!1)return;t.footable=a,e(a.table).unbind(".paging").bind({"footable_initialized.paging footable_row_removed.paging footable_redrawn.paging footable_sorted.paging footable_filtered.paging":function(){t.setupPaging()}}).data("footable-paging",t)}},t.setupPaging=function(){var i=t.footable,o=e(i.table).find("> tbody");i.pageInfo=new a(i),t.createPages(i,o),t.createNavigation(i,o),t.fillPage(i,o,i.pageInfo.currentPage)},t.createPages=function(t,a){var i=1,o=t.pageInfo,n=i*o.pageSize,r=[],l=[];o.pages=[];var d=a.find("> tr:not(.footable-filtered,.footable-row-detail)");d.each(function(e,t){r.push(t),e===n-1?(o.pages.push(r),i++,n=i*o.pageSize,r=[]):e>=d.length-d.length%o.pageSize&&l.push(t)}),l.length>0&&o.pages.push(l),o.currentPage>=o.pages.length&&(o.currentPage=o.pages.length-1),0>o.currentPage&&(o.currentPage=0),1===o.pages.length?e(t.table).addClass("no-paging"):e(t.table).removeClass("no-paging")},t.createNavigation=function(a){var i=e(a.table).find(a.pageInfo.pageNavigation);if(0===i.length){if(i=e(a.pageInfo.pageNavigation),i.parents("table:first").length>0&&i.parents("table:first")!==e(a.table))return;i.length>1&&a.options.debug===!0&&console.error("More than one pagination control was found!")}if(0!==i.length){i.is("ul")||(0===i.find("ul:first").length&&i.append("<ul />"),i=i.find("ul")),i.find("li").remove();var o=a.pageInfo;o.control=i,o.pages.length>0&&(i.append('<li class="footable-page-arrow"><a data-page="first" href="#first">'+a.pageInfo.firstText+"</a>"),i.append('<li class="footable-page-arrow"><a data-page="prev" href="#prev">'+a.pageInfo.previousText+"</a></li>"),o.limit&&i.append('<li class="footable-page-arrow"><a data-page="limit-prev" href="#limit-prev">'+a.pageInfo.limitPreviousText+"</a></li>"),o.limit||e.each(o.pages,function(e,t){t.length>0&&i.append('<li class="footable-page"><a data-page="'+e+'" href="#">'+(e+1)+"</a></li>")}),o.limit&&(i.append('<li class="footable-page-arrow"><a data-page="limit-next" href="#limit-next">'+a.pageInfo.limitNextText+"</a></li>"),t.createLimited(i,o,0)),i.append('<li class="footable-page-arrow"><a data-page="next" href="#next">'+a.pageInfo.nextText+"</a></li>"),i.append('<li class="footable-page-arrow"><a data-page="last" href="#last">'+a.pageInfo.lastText+"</a></li>")),i.off("click","a[data-page]").on("click","a[data-page]",function(n){n.preventDefault();var r=e(this).data("page"),l=o.currentPage;if("first"===r)l=0;else if("prev"===r)l>0&&l--;else if("next"===r)o.pages.length-1>l&&l++;else if("last"===r)l=o.pages.length-1;else if("limit-prev"===r){l=-1;var d=i.find(".footable-page:first a").data("page");t.createLimited(i,o,d-o.limitNavigation),t.setPagingClasses(i,o.currentPage,o.pages.length)}else if("limit-next"===r){l=-1;var s=i.find(".footable-page:last a").data("page");t.createLimited(i,o,s+1),t.setPagingClasses(i,o.currentPage,o.pages.length)}else l=r;if(l>=0){if(o.limit&&o.currentPage!=l){for(var f=l;0!==f%o.limitNavigation;)f-=1;t.createLimited(i,o,f)}t.paginate(a,l)}}),t.setPagingClasses(i,o.currentPage,o.pages.length)}},t.createLimited=function(e,t,a){a=a||0,e.find("li.footable-page").remove();var i,o,n=e.find('li.footable-page-arrow > a[data-page="limit-prev"]').parent(),r=e.find('li.footable-page-arrow > a[data-page="limit-next"]').parent();for(i=t.pages.length-1;i>=0;i--)o=t.pages[i],i>=a&&a+t.limitNavigation>i&&o.length>0&&n.after('<li class="footable-page"><a data-page="'+i+'" href="#">'+(i+1)+"</a></li>");0===a?n.hide():n.show(),a+t.limitNavigation>=t.pages.length?r.hide():r.show()},t.paginate=function(a,i){var o=a.pageInfo;if(o.currentPage!==i){var n=e(a.table).find("> tbody"),r=a.raise("footable_paging",{page:i,size:o.pageSize});if(r&&r.result===!1)return;t.fillPage(a,n,i),o.control.find("li").removeClass("active disabled"),t.setPagingClasses(o.control,o.currentPage,o.pages.length)}},t.setPagingClasses=function(e,t,a){e.find("li.footable-page > a[data-page="+t+"]").parent().addClass("active"),t>=a-1&&(e.find('li.footable-page-arrow > a[data-page="next"]').parent().addClass("disabled"),e.find('li.footable-page-arrow > a[data-page="last"]').parent().addClass("disabled")),1>t&&(e.find('li.footable-page-arrow > a[data-page="first"]').parent().addClass("disabled"),e.find('li.footable-page-arrow > a[data-page="prev"]').parent().addClass("disabled"))},t.fillPage=function(a,i,o){a.pageInfo.currentPage=o,e(a.table).data("currentPage",o),i.find("> tr").hide(),e(a.pageInfo.pages[o]).each(function(){t.showRow(this,a)}),a.raise("footable_page_filled")},t.showRow=function(t,a){var i=e(t),o=i.next(),n=e(a.table);n.hasClass("breakpoint")&&i.hasClass("footable-detail-show")&&o.hasClass("footable-row-detail")?(i.add(o).show(),a.createOrUpdateDetailRow(t)):i.show()}}if(t.footable===undefined||null===t.footable)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var o={paginate:!0,pageSize:10,pageNavigation:".pagination",firstText:"&laquo;",previousText:"&lsaquo;",nextText:"&rsaquo;",lastText:"&raquo;",limitNavigation:0,limitPreviousText:"...",limitNextText:"..."};t.footable.plugins.register(i,o)})(jQuery,window);;(function(t,e,undefined){function a(){var e=this;e.name="Footable Sortable",e.init=function(a){e.footable=a,a.options.sort===!0&&t(a.table).unbind(".sorting").bind({"footable_initialized.sorting":function(){var i,o,n=t(a.table),r=(n.find("> tbody"),a.options.classes.sort);if(n.data("sort")!==!1){n.find("> thead > tr:last-child > th, > thead > tr:last-child > td").each(function(){var e=t(this),i=a.columns[e.index()];i.sort.ignore===!0||e.hasClass(r.sortable)||(e.addClass(r.sortable),t("<span />").addClass(r.indicator).appendTo(e))}),n.find("> thead > tr:last-child > th."+r.sortable+", > thead > tr:last-child > td."+r.sortable).unbind("click.footable").bind("click.footable",function(a){a.preventDefault(),o=t(this);var i=!o.hasClass(r.sorted);return e.doSort(o.index(),i),!1});var l=!1;for(var s in a.columns)if(i=a.columns[s],i.sort.initial){var d="descending"!==i.sort.initial;e.doSort(i.index,d);break}l&&a.bindToggleSelectors()}},"footable_redrawn.sorting":function(){var i=t(a.table),o=a.options.classes.sort;i.data("sorted")>=0&&i.find("> thead > tr:last-child > th").each(function(a){var i=t(this);return i.hasClass(o.sorted)||i.hasClass(o.descending)?(e.doSort(a),undefined):undefined})},"footable_column_data.sorting":function(e){var a=t(e.column.th);e.column.data.sort=e.column.data.sort||{},e.column.data.sort.initial=a.data("sort-initial")||!1,e.column.data.sort.ignore=a.data("sort-ignore")||!1,e.column.data.sort.selector=a.data("sort-selector")||null;var i=a.data("sort-match")||0;i>=e.column.data.matches.length&&(i=0),e.column.data.sort.match=e.column.data.matches[i]}}).data("footable-sort",e)},e.doSort=function(a,i){var o=e.footable;if(t(o.table).data("sort")!==!1){var n=t(o.table),r=n.find("> tbody"),l=o.columns[a],s=n.find("> thead > tr:last-child > th:eq("+a+")"),d=o.options.classes.sort,f=o.options.events.sort;if(i=i===undefined?s.hasClass(d.sorted):"toggle"===i?!s.hasClass(d.sorted):i,l.sort.ignore===!0)return!0;var u=o.raise(f.sorting,{column:l,direction:i?"ASC":"DESC"});u&&u.result===!1||(n.data("sorted",l.index),n.find("> thead > tr:last-child > th, > thead > tr:last-child > td").not(s).removeClass(d.sorted+" "+d.descending),i===undefined&&(i=s.hasClass(d.sorted)),i?s.removeClass(d.descending).addClass(d.sorted):s.removeClass(d.sorted).addClass(d.descending),e.sort(o,r,l,i),o.bindToggleSelectors(),o.raise(f.sorted,{column:l,direction:i?"ASC":"DESC"}))}},e.rows=function(e,a,i){var o=[];return a.find("> tr").each(function(){var a=t(this),n=null;if(a.hasClass(e.options.classes.detail))return!0;a.next().hasClass(e.options.classes.detail)&&(n=a.next().get(0));var r={row:a,detail:n};return i!==undefined&&(r.value=e.parse(this.cells[i.sort.match],i)),o.push(r),!0}).detach(),o},e.sort=function(t,a,i,o){var n=e.rows(t,a,i),r=t.options.sorters[i.type]||t.options.sorters.alpha;n.sort(function(t,e){return o?r(t.value,e.value):r(e.value,t.value)});for(var l=0;n.length>l;l++)a.append(n[l].row),null!==n[l].detail&&a.append(n[l].detail)}}if(e.footable===undefined||null===e.footable)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var i={sort:!0,sorters:{alpha:function(t,e){return"string"==typeof t&&(t=t.toLowerCase()),"string"==typeof e&&(e=e.toLowerCase()),t===e?0:e>t?-1:1},numeric:function(t,e){return t-e}},classes:{sort:{sortable:"footable-sortable",sorted:"footable-sorted",descending:"footable-sorted-desc",indicator:"footable-sort-indicator"}},events:{sort:{sorting:"footable_sorting",sorted:"footable_sorted"}}};e.footable.plugins.register(a,i)})(jQuery,window);;(function(t,e,undefined){function a(){var e=this;e.name="Footable Striping",e.init=function(a){e.footable=a,t(a.table).unbind("striping").bind({"footable_initialized.striping footable_row_removed.striping footable_redrawn.striping footable_sorted.striping footable_filtered.striping":function(){t(this).data("striping")!==!1&&e.setupStriping(a)}})},e.setupStriping=function(e){var a=0;t(e.table).find("> tbody > tr:not(.footable-row-detail)").each(function(){var i=t(this);i.removeClass(e.options.classes.striping.even).removeClass(e.options.classes.striping.odd),0===a%2?i.addClass(e.options.classes.striping.even):i.addClass(e.options.classes.striping.odd),a++})}}if(e.footable===undefined||null===e.foobox)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var i={striping:{enabled:!0},classes:{striping:{odd:"footable-odd",even:"footable-even"}}};e.footable.plugins.register(a,i)})(jQuery,window);;(function(t,e,undefined){function a(t,e){e=e?e:location.hash;var a=RegExp("&"+t+"(?:=([^&]*))?(?=&|$)","i");return(e=e.replace(/^\#/,"&").match(a))?e[1]===undefined?"":decodeURIComponent(e[1]):undefined}function i(e,a){var i=t(e.table).find("tbody").find("tr:not(.footable-row-detail, .footable-filtered)").length;t(e.table).data("status_num_total",i);var o=t(e.table).find("tbody").find("tr:not(.footable-row-detail)").filter(":visible").length;t(e.table).data("status_num_shown",o);var n=t(e.table).data("sorted"),r=t(e.table).find("th")[n],l=t(r).hasClass("footable-sorted-desc");if(t(e.table).data("status_descending",l),e.pageInfo){var s=e.pageInfo.currentPage;t(e.table).data("status_pagenum",s)}var d="",f=t(e.table).data("filter");t(f).length&&(d=t(f).val()),t(e.table).data("status_filter_val",d);var u,p,c;if("footable_row_expanded"==a.type&&(u=a.row,u&&(p=t(e.table).data("expanded_rows"),c=[],p&&(c=p.split(",")),c.push(u.rowIndex),t(e.table).data("expanded_rows",c.join(",")))),"footable_row_collapsed"==a.type&&(u=a.row)){p=t(e.table).data("expanded_rows"),c=[],p&&(c=p.split(","));var g=[];for(var b in c)if(c[b]==u.rowIndex){g=c.splice(b,1);break}t(e.table).data("expanded_rows",g.join(","))}}function o(){var e=this;e.name="Footable LucidBookmarkable",e.init=function(e){e.options.bookmarkable.enabled&&t(e.table).bind({footable_initialized:function(){var i=e.table.id,o=a(i+"_f"),n=a(i+"_p"),r=a(i+"_s"),l=a(i+"_d"),s=a(i+"_e");if(o){var d=t(e.table).data("filter");t(d).val(o),t(e.table).trigger("footable_filter",{filter:o})}if(n&&t(e.table).data("currentPage",n),r!==undefined){var f=t(e.table).data("footable-sort"),u=!0;"true"==l&&(u=!1),f.doSort(r,u)}else t(e.table).trigger("footable_setup_paging");if(s){var p=s.split(",");for(var c in p){var g=t(e.table.rows[p[c]]);g.find("> td:first").trigger("footable_toggle_row")}}e.lucid_bookmark_read=!0},"footable_page_filled footable_redrawn footable_filtered footable_sorted footable_row_expanded footable_row_collapsed":function(a){if(i(e,a),e.lucid_bookmark_read){var o=e.table.id,n=o+"_f",r=o+"_p",l=o+"_s",s=o+"_d",d=o+"_e",f=location.hash.replace(/^\#/,"&"),u=[n,r,l,s,d];for(var p in u){var c=RegExp("&"+u[p]+"=([^&]*)","g");f=f.replace(c,"")}var g={};g[n]=t(e.table).data("status_filter_val"),g[r]=t(e.table).data("status_pagenum"),g[l]=t(e.table).data("sorted"),g[s]=t(e.table).data("status_descending"),g[d]=t(e.table).data("expanded_rows");var b=[];for(var h in g)g[h]!==undefined&&b.push(h+"="+encodeURIComponent(g[h]));f.length&&b.push(f),location.hash=b.join("&")}}})}}if(e.footable===undefined||null===e.foobox)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var n={bookmarkable:{enabled:!1}};e.footable.plugins.register(o,n)})(jQuery,window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	* jquery.inputmask.bundle.js
	* https://github.com/RobinHerbots/jquery.inputmask
	* Copyright (c) 2010 - 2016 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.3
	*/
	!function($) {
	    function Inputmask(alias, options) {
	        return this instanceof Inputmask ? ($.isPlainObject(alias) ? options = alias : (options = options || {}, 
	        options.alias = alias), this.el = void 0, this.opts = $.extend(!0, {}, this.defaults, options), 
	        this.noMasksCache = options && void 0 !== options.definitions, this.userOptions = options || {}, 
	        this.events = {}, void resolveAlias(this.opts.alias, options, this.opts)) : new Inputmask(alias, options);
	    }
	    function isInputEventSupported(eventName) {
	        var el = document.createElement("input"), evName = "on" + eventName, isSupported = evName in el;
	        return isSupported || (el.setAttribute(evName, "return;"), isSupported = "function" == typeof el[evName]), 
	        el = null, isSupported;
	    }
	    function isElementTypeSupported(input, opts) {
	        var elementType = input.getAttribute("type"), isSupported = "INPUT" === input.tagName && $.inArray(elementType, opts.supportsInputType) !== -1 || input.isContentEditable || "TEXTAREA" === input.tagName;
	        if (!isSupported && "INPUT" === input.tagName) {
	            var el = document.createElement("input");
	            el.setAttribute("type", elementType), isSupported = "text" === el.type, el = null;
	        }
	        return isSupported;
	    }
	    function resolveAlias(aliasStr, options, opts) {
	        var aliasDefinition = opts.aliases[aliasStr];
	        return aliasDefinition ? (aliasDefinition.alias && resolveAlias(aliasDefinition.alias, void 0, opts), 
	        $.extend(!0, opts, aliasDefinition), $.extend(!0, opts, options), !0) : (null === opts.mask && (opts.mask = aliasStr), 
	        !1);
	    }
	    function importAttributeOptions(npt, opts, userOptions) {
	        function importOption(option, optionData) {
	            optionData = void 0 !== optionData ? optionData : npt.getAttribute("data-inputmask-" + option), 
	            null !== optionData && ("string" == typeof optionData && (0 === option.indexOf("on") ? optionData = window[optionData] : "false" === optionData ? optionData = !1 : "true" === optionData && (optionData = !0)), 
	            userOptions[option] = optionData);
	        }
	        var option, dataoptions, optionData, p, attrOptions = npt.getAttribute("data-inputmask");
	        if (attrOptions && "" !== attrOptions && (attrOptions = attrOptions.replace(new RegExp("'", "g"), '"'), 
	        dataoptions = JSON.parse("{" + attrOptions + "}")), dataoptions) {
	            optionData = void 0;
	            for (p in dataoptions) if ("alias" === p.toLowerCase()) {
	                optionData = dataoptions[p];
	                break;
	            }
	        }
	        importOption("alias", optionData), userOptions.alias && resolveAlias(userOptions.alias, userOptions, opts);
	        for (option in opts) {
	            if (dataoptions) {
	                optionData = void 0;
	                for (p in dataoptions) if (p.toLowerCase() === option.toLowerCase()) {
	                    optionData = dataoptions[p];
	                    break;
	                }
	            }
	            importOption(option, optionData);
	        }
	        return $.extend(!0, opts, userOptions), opts;
	    }
	    function generateMaskSet(opts, nocache) {
	        function analyseMask(mask) {
	            function MaskToken(isGroup, isOptional, isQuantifier, isAlternator) {
	                this.matches = [], this.isGroup = isGroup || !1, this.isOptional = isOptional || !1, 
	                this.isQuantifier = isQuantifier || !1, this.isAlternator = isAlternator || !1, 
	                this.quantifier = {
	                    min: 1,
	                    max: 1
	                };
	            }
	            function insertTestDefinition(mtoken, element, position) {
	                var maskdef = opts.definitions[element];
	                position = void 0 !== position ? position : mtoken.matches.length;
	                var prevMatch = mtoken.matches[position - 1];
	                if (maskdef && !escaped) {
	                    maskdef.placeholder = $.isFunction(maskdef.placeholder) ? maskdef.placeholder(opts) : maskdef.placeholder;
	                    for (var prevalidators = maskdef.prevalidator, prevalidatorsL = prevalidators ? prevalidators.length : 0, i = 1; i < maskdef.cardinality; i++) {
	                        var prevalidator = prevalidatorsL >= i ? prevalidators[i - 1] : [], validator = prevalidator.validator, cardinality = prevalidator.cardinality;
	                        mtoken.matches.splice(position++, 0, {
	                            fn: validator ? "string" == typeof validator ? new RegExp(validator) : new function() {
	                                this.test = validator;
	                            }() : new RegExp("."),
	                            cardinality: cardinality ? cardinality : 1,
	                            optionality: mtoken.isOptional,
	                            newBlockMarker: void 0 === prevMatch || prevMatch.def !== (maskdef.definitionSymbol || element),
	                            casing: maskdef.casing,
	                            def: maskdef.definitionSymbol || element,
	                            placeholder: maskdef.placeholder,
	                            mask: element
	                        }), prevMatch = mtoken.matches[position - 1];
	                    }
	                    mtoken.matches.splice(position++, 0, {
	                        fn: maskdef.validator ? "string" == typeof maskdef.validator ? new RegExp(maskdef.validator) : new function() {
	                            this.test = maskdef.validator;
	                        }() : new RegExp("."),
	                        cardinality: maskdef.cardinality,
	                        optionality: mtoken.isOptional,
	                        newBlockMarker: void 0 === prevMatch || prevMatch.def !== (maskdef.definitionSymbol || element),
	                        casing: maskdef.casing,
	                        def: maskdef.definitionSymbol || element,
	                        placeholder: maskdef.placeholder,
	                        mask: element
	                    });
	                } else mtoken.matches.splice(position++, 0, {
	                    fn: null,
	                    cardinality: 0,
	                    optionality: mtoken.isOptional,
	                    newBlockMarker: void 0 === prevMatch || prevMatch.def !== element,
	                    casing: null,
	                    def: opts.staticDefinitionSymbol || element,
	                    placeholder: void 0 !== opts.staticDefinitionSymbol ? element : void 0,
	                    mask: element
	                }), escaped = !1;
	            }
	            function verifyGroupMarker(lastMatch, isOpenGroup) {
	                lastMatch.isGroup && (lastMatch.isGroup = !1, insertTestDefinition(lastMatch, opts.groupmarker.start, 0), 
	                isOpenGroup !== !0 && insertTestDefinition(lastMatch, opts.groupmarker.end));
	            }
	            function maskCurrentToken(m, currentToken, lastMatch, extraCondition) {
	                currentToken.matches.length > 0 && (void 0 === extraCondition || extraCondition) && (lastMatch = currentToken.matches[currentToken.matches.length - 1], 
	                verifyGroupMarker(lastMatch)), insertTestDefinition(currentToken, m);
	            }
	            function defaultCase() {
	                if (openenings.length > 0) {
	                    if (currentOpeningToken = openenings[openenings.length - 1], maskCurrentToken(m, currentOpeningToken, lastMatch, !currentOpeningToken.isAlternator), 
	                    currentOpeningToken.isAlternator) {
	                        alternator = openenings.pop();
	                        for (var mndx = 0; mndx < alternator.matches.length; mndx++) alternator.matches[mndx].isGroup = !1;
	                        openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                        currentOpeningToken.matches.push(alternator)) : currentToken.matches.push(alternator);
	                    }
	                } else maskCurrentToken(m, currentToken, lastMatch);
	            }
	            function reverseTokens(maskToken) {
	                function reverseStatic(st) {
	                    return st === opts.optionalmarker.start ? st = opts.optionalmarker.end : st === opts.optionalmarker.end ? st = opts.optionalmarker.start : st === opts.groupmarker.start ? st = opts.groupmarker.end : st === opts.groupmarker.end && (st = opts.groupmarker.start), 
	                    st;
	                }
	                maskToken.matches = maskToken.matches.reverse();
	                for (var match in maskToken.matches) {
	                    var intMatch = parseInt(match);
	                    if (maskToken.matches[match].isQuantifier && maskToken.matches[intMatch + 1] && maskToken.matches[intMatch + 1].isGroup) {
	                        var qt = maskToken.matches[match];
	                        maskToken.matches.splice(match, 1), maskToken.matches.splice(intMatch + 1, 0, qt);
	                    }
	                    void 0 !== maskToken.matches[match].matches ? maskToken.matches[match] = reverseTokens(maskToken.matches[match]) : maskToken.matches[match] = reverseStatic(maskToken.matches[match]);
	                }
	                return maskToken;
	            }
	            for (var match, m, openingToken, currentOpeningToken, alternator, lastMatch, groupToken, tokenizer = /(?:[?*+]|\{[0-9\+\*]+(?:,[0-9\+\*]*)?\})|[^.?*+^${[]()|\\]+|./g, escaped = !1, currentToken = new MaskToken(), openenings = [], maskTokens = []; match = tokenizer.exec(mask); ) if (m = match[0], 
	            escaped) defaultCase(); else switch (m.charAt(0)) {
	              case opts.escapeChar:
	                escaped = !0;
	                break;
	
	              case opts.optionalmarker.end:
	              case opts.groupmarker.end:
	                if (openingToken = openenings.pop(), void 0 !== openingToken) if (openenings.length > 0) {
	                    if (currentOpeningToken = openenings[openenings.length - 1], currentOpeningToken.matches.push(openingToken), 
	                    currentOpeningToken.isAlternator) {
	                        alternator = openenings.pop();
	                        for (var mndx = 0; mndx < alternator.matches.length; mndx++) alternator.matches[mndx].isGroup = !1;
	                        openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                        currentOpeningToken.matches.push(alternator)) : currentToken.matches.push(alternator);
	                    }
	                } else currentToken.matches.push(openingToken); else defaultCase();
	                break;
	
	              case opts.optionalmarker.start:
	                openenings.push(new MaskToken((!1), (!0)));
	                break;
	
	              case opts.groupmarker.start:
	                openenings.push(new MaskToken((!0)));
	                break;
	
	              case opts.quantifiermarker.start:
	                var quantifier = new MaskToken((!1), (!1), (!0));
	                m = m.replace(/[{}]/g, "");
	                var mq = m.split(","), mq0 = isNaN(mq[0]) ? mq[0] : parseInt(mq[0]), mq1 = 1 === mq.length ? mq0 : isNaN(mq[1]) ? mq[1] : parseInt(mq[1]);
	                if ("*" !== mq1 && "+" !== mq1 || (mq0 = "*" === mq1 ? 0 : 1), quantifier.quantifier = {
	                    min: mq0,
	                    max: mq1
	                }, openenings.length > 0) {
	                    var matches = openenings[openenings.length - 1].matches;
	                    match = matches.pop(), match.isGroup || (groupToken = new MaskToken((!0)), groupToken.matches.push(match), 
	                    match = groupToken), matches.push(match), matches.push(quantifier);
	                } else match = currentToken.matches.pop(), match.isGroup || (groupToken = new MaskToken((!0)), 
	                groupToken.matches.push(match), match = groupToken), currentToken.matches.push(match), 
	                currentToken.matches.push(quantifier);
	                break;
	
	              case opts.alternatormarker:
	                openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                lastMatch = currentOpeningToken.matches.pop()) : lastMatch = currentToken.matches.pop(), 
	                lastMatch.isAlternator ? openenings.push(lastMatch) : (alternator = new MaskToken((!1), (!1), (!1), (!0)), 
	                alternator.matches.push(lastMatch), openenings.push(alternator));
	                break;
	
	              default:
	                defaultCase();
	            }
	            for (;openenings.length > 0; ) openingToken = openenings.pop(), verifyGroupMarker(openingToken, !0), 
	            currentToken.matches.push(openingToken);
	            return currentToken.matches.length > 0 && (lastMatch = currentToken.matches[currentToken.matches.length - 1], 
	            verifyGroupMarker(lastMatch), maskTokens.push(currentToken)), opts.numericInput && reverseTokens(maskTokens[0]), 
	            maskTokens;
	        }
	        function generateMask(mask, metadata) {
	            if (null !== mask && "" !== mask) {
	                if (1 === mask.length && opts.greedy === !1 && 0 !== opts.repeat && (opts.placeholder = ""), 
	                opts.repeat > 0 || "*" === opts.repeat || "+" === opts.repeat) {
	                    var repeatStart = "*" === opts.repeat ? 0 : "+" === opts.repeat ? 1 : opts.repeat;
	                    mask = opts.groupmarker.start + mask + opts.groupmarker.end + opts.quantifiermarker.start + repeatStart + "," + opts.repeat + opts.quantifiermarker.end;
	                }
	                var masksetDefinition;
	                return void 0 === Inputmask.prototype.masksCache[mask] || nocache === !0 ? (masksetDefinition = {
	                    mask: mask,
	                    maskToken: analyseMask(mask),
	                    validPositions: {},
	                    _buffer: void 0,
	                    buffer: void 0,
	                    tests: {},
	                    metadata: metadata,
	                    maskLength: void 0
	                }, nocache !== !0 && (Inputmask.prototype.masksCache[opts.numericInput ? mask.split("").reverse().join("") : mask] = masksetDefinition, 
	                masksetDefinition = $.extend(!0, {}, Inputmask.prototype.masksCache[opts.numericInput ? mask.split("").reverse().join("") : mask]))) : masksetDefinition = $.extend(!0, {}, Inputmask.prototype.masksCache[opts.numericInput ? mask.split("").reverse().join("") : mask]), 
	                masksetDefinition;
	            }
	        }
	        function preProcessMask(mask) {
	            return mask = mask.toString();
	        }
	        var ms;
	        if ($.isFunction(opts.mask) && (opts.mask = opts.mask(opts)), $.isArray(opts.mask)) {
	            if (opts.mask.length > 1) {
	                opts.keepStatic = null === opts.keepStatic || opts.keepStatic;
	                var altMask = "(";
	                return $.each(opts.numericInput ? opts.mask.reverse() : opts.mask, function(ndx, msk) {
	                    altMask.length > 1 && (altMask += ")|("), altMask += preProcessMask(void 0 === msk.mask || $.isFunction(msk.mask) ? msk : msk.mask);
	                }), altMask += ")", generateMask(altMask, opts.mask);
	            }
	            opts.mask = opts.mask.pop();
	        }
	        return opts.mask && (ms = void 0 === opts.mask.mask || $.isFunction(opts.mask.mask) ? generateMask(preProcessMask(opts.mask), opts.mask) : generateMask(preProcessMask(opts.mask.mask), opts.mask)), 
	        ms;
	    }
	    function maskScope(actionObj, maskset, opts) {
	        function getMaskTemplate(baseOnInput, minimalPos, includeInput) {
	            minimalPos = minimalPos || 0;
	            var ndxIntlzr, test, testPos, maskTemplate = [], pos = 0, lvp = getLastValidPosition();
	            maxLength = void 0 !== el ? el.maxLength : void 0, maxLength === -1 && (maxLength = void 0);
	            do {
	                if (baseOnInput === !0 && getMaskSet().validPositions[pos]) {
	                    var validPos = getMaskSet().validPositions[pos];
	                    test = validPos.match, ndxIntlzr = validPos.locator.slice(), maskTemplate.push(includeInput === !0 ? validPos.input : getPlaceholder(pos, test));
	                } else testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), test = testPos.match, 
	                ndxIntlzr = testPos.locator.slice(), (opts.jitMasking === !1 || pos < lvp || isFinite(opts.jitMasking) && opts.jitMasking > pos) && maskTemplate.push(getPlaceholder(pos, test));
	                pos++;
	            } while ((void 0 === maxLength || pos < maxLength) && (null !== test.fn || "" !== test.def) || minimalPos > pos);
	            return "" === maskTemplate[maskTemplate.length - 1] && maskTemplate.pop(), getMaskSet().maskLength = pos + 1, 
	            maskTemplate;
	        }
	        function getMaskSet() {
	            return maskset;
	        }
	        function resetMaskSet(soft) {
	            var maskset = getMaskSet();
	            maskset.buffer = void 0, soft !== !0 && (maskset._buffer = void 0, maskset.validPositions = {}, 
	            maskset.p = 0);
	        }
	        function getLastValidPosition(closestTo, strict, validPositions) {
	            var before = -1, after = -1, valids = validPositions || getMaskSet().validPositions;
	            void 0 === closestTo && (closestTo = -1);
	            for (var posNdx in valids) {
	                var psNdx = parseInt(posNdx);
	                valids[psNdx] && (strict || null !== valids[psNdx].match.fn) && (psNdx <= closestTo && (before = psNdx), 
	                psNdx >= closestTo && (after = psNdx));
	            }
	            return before !== -1 && closestTo - before > 1 || after < closestTo ? before : after;
	        }
	        function stripValidPositions(start, end, nocheck, strict) {
	            function IsEnclosedStatic(pos) {
	                var posMatch = getMaskSet().validPositions[pos];
	                if (void 0 !== posMatch && null === posMatch.match.fn) {
	                    var prevMatch = getMaskSet().validPositions[pos - 1], nextMatch = getMaskSet().validPositions[pos + 1];
	                    return void 0 !== prevMatch && void 0 !== nextMatch;
	                }
	                return !1;
	            }
	            var i, startPos = start, positionsClone = $.extend(!0, {}, getMaskSet().validPositions), needsValidation = !1;
	            for (getMaskSet().p = start, i = end - 1; i >= startPos; i--) void 0 !== getMaskSet().validPositions[i] && (nocheck === !0 || !IsEnclosedStatic(i) && opts.canClearPosition(getMaskSet(), i, getLastValidPosition(), strict, opts) !== !1) && delete getMaskSet().validPositions[i];
	            for (resetMaskSet(!0), i = startPos + 1; i <= getLastValidPosition(); ) {
	                for (;void 0 !== getMaskSet().validPositions[startPos]; ) startPos++;
	                var s = getMaskSet().validPositions[startPos];
	                if (i < startPos && (i = startPos + 1), void 0 === getMaskSet().validPositions[i] && isMask(i) || void 0 !== s) i++; else {
	                    var t = getTestTemplate(i);
	                    needsValidation === !1 && positionsClone[startPos] && positionsClone[startPos].match.def === t.match.def ? (getMaskSet().validPositions[startPos] = $.extend(!0, {}, positionsClone[startPos]), 
	                    getMaskSet().validPositions[startPos].input = t.input, delete getMaskSet().validPositions[i], 
	                    i++) : positionCanMatchDefinition(startPos, t.match.def) ? isValid(startPos, t.input || getPlaceholder(i), !0) !== !1 && (delete getMaskSet().validPositions[i], 
	                    i++, needsValidation = !0) : isMask(i) || (i++, startPos--), startPos++;
	                }
	            }
	            resetMaskSet(!0);
	        }
	        function determineTestTemplate(tests, guessNextBest) {
	            for (var testPos, testPositions = tests, lvp = getLastValidPosition(), lvTest = getMaskSet().validPositions[lvp] || getTests(0)[0], lvTestAltArr = void 0 !== lvTest.alternation ? lvTest.locator[lvTest.alternation].toString().split(",") : [], ndx = 0; ndx < testPositions.length && (testPos = testPositions[ndx], 
	            !(testPos.match && (opts.greedy && testPos.match.optionalQuantifier !== !0 || (testPos.match.optionality === !1 || testPos.match.newBlockMarker === !1) && testPos.match.optionalQuantifier !== !0) && (void 0 === lvTest.alternation || lvTest.alternation !== testPos.alternation || void 0 !== testPos.locator[lvTest.alternation] && checkAlternationMatch(testPos.locator[lvTest.alternation].toString().split(","), lvTestAltArr))) || guessNextBest === !0 && (null !== testPos.match.fn || /[0-9a-bA-Z]/.test(testPos.match.def))); ndx++) ;
	            return testPos;
	        }
	        function getTestTemplate(pos, ndxIntlzr, tstPs) {
	            return getMaskSet().validPositions[pos] || determineTestTemplate(getTests(pos, ndxIntlzr ? ndxIntlzr.slice() : ndxIntlzr, tstPs));
	        }
	        function getTest(pos) {
	            return getMaskSet().validPositions[pos] ? getMaskSet().validPositions[pos] : getTests(pos)[0];
	        }
	        function positionCanMatchDefinition(pos, def) {
	            for (var valid = !1, tests = getTests(pos), tndx = 0; tndx < tests.length; tndx++) if (tests[tndx].match && tests[tndx].match.def === def) {
	                valid = !0;
	                break;
	            }
	            return valid;
	        }
	        function selectBestMatch(pos, alternateNdx) {
	            var bestMatch, indexPos;
	            return (getMaskSet().tests[pos] || getMaskSet().validPositions[pos]) && $.each(getMaskSet().tests[pos] || [ getMaskSet().validPositions[pos] ], function(ndx, lmnt) {
	                var ndxPos = lmnt.alternation ? lmnt.locator[lmnt.alternation].toString().indexOf(alternateNdx) : -1;
	                (void 0 === indexPos || ndxPos < indexPos) && ndxPos !== -1 && (bestMatch = lmnt, 
	                indexPos = ndxPos);
	            }), bestMatch;
	        }
	        function getTests(pos, ndxIntlzr, tstPs) {
	            function resolveTestFromToken(maskToken, ndxInitializer, loopNdx, quantifierRecurse) {
	                function handleMatch(match, loopNdx, quantifierRecurse) {
	                    function isFirstMatch(latestMatch, tokenGroup) {
	                        var firstMatch = 0 === $.inArray(latestMatch, tokenGroup.matches);
	                        return firstMatch || $.each(tokenGroup.matches, function(ndx, match) {
	                            if (match.isQuantifier === !0 && (firstMatch = isFirstMatch(latestMatch, tokenGroup.matches[ndx - 1]))) return !1;
	                        }), firstMatch;
	                    }
	                    function resolveNdxInitializer(pos, alternateNdx) {
	                        var bestMatch = selectBestMatch(pos, alternateNdx);
	                        return bestMatch ? bestMatch.locator.slice(bestMatch.alternation + 1) : void 0;
	                    }
	                    function staticCanMatchDefinition(source, target) {
	                        return null === source.match.fn && null !== target.match.fn && target.match.fn.test(source.match.def, getMaskSet(), pos, !1, opts, !1);
	                    }
	                    if (testPos > 1e4) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + getMaskSet().mask;
	                    if (testPos === pos && void 0 === match.matches) return matches.push({
	                        match: match,
	                        locator: loopNdx.reverse(),
	                        cd: cacheDependency
	                    }), !0;
	                    if (void 0 !== match.matches) {
	                        if (match.isGroup && quantifierRecurse !== match) {
	                            if (match = handleMatch(maskToken.matches[$.inArray(match, maskToken.matches) + 1], loopNdx)) return !0;
	                        } else if (match.isOptional) {
	                            var optionalToken = match;
	                            if (match = resolveTestFromToken(match, ndxInitializer, loopNdx, quantifierRecurse)) {
	                                if (latestMatch = matches[matches.length - 1].match, !isFirstMatch(latestMatch, optionalToken)) return !0;
	                                insertStop = !0, testPos = pos;
	                            }
	                        } else if (match.isAlternator) {
	                            var maltMatches, alternateToken = match, malternateMatches = [], currentMatches = matches.slice(), loopNdxCnt = loopNdx.length, altIndex = ndxInitializer.length > 0 ? ndxInitializer.shift() : -1;
	                            if (altIndex === -1 || "string" == typeof altIndex) {
	                                var amndx, currentPos = testPos, ndxInitializerClone = ndxInitializer.slice(), altIndexArr = [];
	                                if ("string" == typeof altIndex) altIndexArr = altIndex.split(","); else for (amndx = 0; amndx < alternateToken.matches.length; amndx++) altIndexArr.push(amndx);
	                                for (var ndx = 0; ndx < altIndexArr.length; ndx++) {
	                                    if (amndx = parseInt(altIndexArr[ndx]), matches = [], ndxInitializer = resolveNdxInitializer(testPos, amndx) || ndxInitializerClone.slice(), 
	                                    match = handleMatch(alternateToken.matches[amndx] || maskToken.matches[amndx], [ amndx ].concat(loopNdx), quantifierRecurse) || match, 
	                                    match !== !0 && void 0 !== match && altIndexArr[altIndexArr.length - 1] < alternateToken.matches.length) {
	                                        var ntndx = $.inArray(match, maskToken.matches) + 1;
	                                        maskToken.matches.length > ntndx && (match = handleMatch(maskToken.matches[ntndx], [ ntndx ].concat(loopNdx.slice(1, loopNdx.length)), quantifierRecurse), 
	                                        match && (altIndexArr.push(ntndx.toString()), $.each(matches, function(ndx, lmnt) {
	                                            lmnt.alternation = loopNdx.length - 1;
	                                        })));
	                                    }
	                                    maltMatches = matches.slice(), testPos = currentPos, matches = [];
	                                    for (var ndx1 = 0; ndx1 < maltMatches.length; ndx1++) {
	                                        var altMatch = maltMatches[ndx1], hasMatch = !1;
	                                        altMatch.alternation = altMatch.alternation || loopNdxCnt;
	                                        for (var ndx2 = 0; ndx2 < malternateMatches.length; ndx2++) {
	                                            var altMatch2 = malternateMatches[ndx2];
	                                            if (("string" != typeof altIndex || $.inArray(altMatch.locator[altMatch.alternation].toString(), altIndexArr) !== -1) && (altMatch.match.def === altMatch2.match.def || staticCanMatchDefinition(altMatch, altMatch2))) {
	                                                hasMatch = altMatch.match.mask === altMatch2.match.mask, altMatch2.locator[altMatch.alternation].toString().indexOf(altMatch.locator[altMatch.alternation]) === -1 && (altMatch2.locator[altMatch.alternation] = altMatch2.locator[altMatch.alternation] + "," + altMatch.locator[altMatch.alternation], 
	                                                altMatch2.alternation = altMatch.alternation, null == altMatch.match.fn && (altMatch2.na = altMatch2.na || altMatch.locator[altMatch.alternation].toString(), 
	                                                altMatch2.na.indexOf(altMatch.locator[altMatch.alternation]) === -1 && (altMatch2.na = altMatch2.na + "," + altMatch.locator[altMatch.alternation])));
	                                                break;
	                                            }
	                                        }
	                                        hasMatch || malternateMatches.push(altMatch);
	                                    }
	                                }
	                                "string" == typeof altIndex && (malternateMatches = $.map(malternateMatches, function(lmnt, ndx) {
	                                    if (isFinite(ndx)) {
	                                        var mamatch, alternation = lmnt.alternation, altLocArr = lmnt.locator[alternation].toString().split(",");
	                                        lmnt.locator[alternation] = void 0, lmnt.alternation = void 0;
	                                        for (var alndx = 0; alndx < altLocArr.length; alndx++) mamatch = $.inArray(altLocArr[alndx], altIndexArr) !== -1, 
	                                        mamatch && (void 0 !== lmnt.locator[alternation] ? (lmnt.locator[alternation] += ",", 
	                                        lmnt.locator[alternation] += altLocArr[alndx]) : lmnt.locator[alternation] = parseInt(altLocArr[alndx]), 
	                                        lmnt.alternation = alternation);
	                                        if (void 0 !== lmnt.locator[alternation]) return lmnt;
	                                    }
	                                })), matches = currentMatches.concat(malternateMatches), testPos = pos, insertStop = matches.length > 0, 
	                                ndxInitializer = ndxInitializerClone.slice();
	                            } else match = handleMatch(alternateToken.matches[altIndex] || maskToken.matches[altIndex], [ altIndex ].concat(loopNdx), quantifierRecurse);
	                            if (match) return !0;
	                        } else if (match.isQuantifier && quantifierRecurse !== maskToken.matches[$.inArray(match, maskToken.matches) - 1]) for (var qt = match, qndx = ndxInitializer.length > 0 ? ndxInitializer.shift() : 0; qndx < (isNaN(qt.quantifier.max) ? qndx + 1 : qt.quantifier.max) && testPos <= pos; qndx++) {
	                            var tokenGroup = maskToken.matches[$.inArray(qt, maskToken.matches) - 1];
	                            if (match = handleMatch(tokenGroup, [ qndx ].concat(loopNdx), tokenGroup)) {
	                                if (latestMatch = matches[matches.length - 1].match, latestMatch.optionalQuantifier = qndx > qt.quantifier.min - 1, 
	                                isFirstMatch(latestMatch, tokenGroup)) {
	                                    if (qndx > qt.quantifier.min - 1) {
	                                        insertStop = !0, testPos = pos;
	                                        break;
	                                    }
	                                    return !0;
	                                }
	                                return !0;
	                            }
	                        } else if (match = resolveTestFromToken(match, ndxInitializer, loopNdx, quantifierRecurse)) return !0;
	                    } else testPos++;
	                }
	                for (var tndx = ndxInitializer.length > 0 ? ndxInitializer.shift() : 0; tndx < maskToken.matches.length; tndx++) if (maskToken.matches[tndx].isQuantifier !== !0) {
	                    var match = handleMatch(maskToken.matches[tndx], [ tndx ].concat(loopNdx), quantifierRecurse);
	                    if (match && testPos === pos) return match;
	                    if (testPos > pos) break;
	                }
	            }
	            function mergeLocators(tests) {
	                var locator = [];
	                return $.isArray(tests) || (tests = [ tests ]), tests.length > 0 && (void 0 === tests[0].alternation ? (locator = determineTestTemplate(tests.slice()).locator.slice(), 
	                0 === locator.length && (locator = tests[0].locator.slice())) : $.each(tests, function(ndx, tst) {
	                    if ("" !== tst.def) if (0 === locator.length) locator = tst.locator.slice(); else for (var i = 0; i < locator.length; i++) tst.locator[i] && locator[i].toString().indexOf(tst.locator[i]) === -1 && (locator[i] += "," + tst.locator[i]);
	                })), locator;
	            }
	            function filterTests(tests) {
	                return opts.keepStatic && pos > 0 && tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0) && tests[0].match.optionality !== !0 && tests[0].match.optionalQuantifier !== !0 && null === tests[0].match.fn && !/[0-9a-bA-Z]/.test(tests[0].match.def) ? [ determineTestTemplate(tests) ] : tests;
	            }
	            var latestMatch, maskTokens = getMaskSet().maskToken, testPos = ndxIntlzr ? tstPs : 0, ndxInitializer = ndxIntlzr ? ndxIntlzr.slice() : [ 0 ], matches = [], insertStop = !1, cacheDependency = ndxIntlzr ? ndxIntlzr.join("") : "";
	            if (pos > -1) {
	                if (void 0 === ndxIntlzr) {
	                    for (var test, previousPos = pos - 1; void 0 === (test = getMaskSet().validPositions[previousPos] || getMaskSet().tests[previousPos]) && previousPos > -1; ) previousPos--;
	                    void 0 !== test && previousPos > -1 && (ndxInitializer = mergeLocators(test), cacheDependency = ndxInitializer.join(""), 
	                    testPos = previousPos);
	                }
	                if (getMaskSet().tests[pos] && getMaskSet().tests[pos][0].cd === cacheDependency) return filterTests(getMaskSet().tests[pos]);
	                for (var mtndx = ndxInitializer.shift(); mtndx < maskTokens.length; mtndx++) {
	                    var match = resolveTestFromToken(maskTokens[mtndx], ndxInitializer, [ mtndx ]);
	                    if (match && testPos === pos || testPos > pos) break;
	                }
	            }
	            return (0 === matches.length || insertStop) && matches.push({
	                match: {
	                    fn: null,
	                    cardinality: 0,
	                    optionality: !0,
	                    casing: null,
	                    def: "",
	                    placeholder: ""
	                },
	                locator: [],
	                cd: cacheDependency
	            }), void 0 !== ndxIntlzr && getMaskSet().tests[pos] ? filterTests($.extend(!0, [], matches)) : (getMaskSet().tests[pos] = $.extend(!0, [], matches), 
	            filterTests(getMaskSet().tests[pos]));
	        }
	        function getBufferTemplate() {
	            return void 0 === getMaskSet()._buffer && (getMaskSet()._buffer = getMaskTemplate(!1, 1), 
	            void 0 === getMaskSet().buffer && getMaskSet()._buffer.slice()), getMaskSet()._buffer;
	        }
	        function getBuffer(noCache) {
	            return void 0 !== getMaskSet().buffer && noCache !== !0 || (getMaskSet().buffer = getMaskTemplate(!0, getLastValidPosition(), !0)), 
	            getMaskSet().buffer;
	        }
	        function refreshFromBuffer(start, end, buffer) {
	            var i;
	            if (start === !0) resetMaskSet(), start = 0, end = buffer.length; else for (i = start; i < end; i++) delete getMaskSet().validPositions[i];
	            for (i = start; i < end; i++) resetMaskSet(!0), buffer[i] !== opts.skipOptionalPartCharacter && isValid(i, buffer[i], !0, !0);
	        }
	        function casing(elem, test, pos) {
	            switch (opts.casing || test.casing) {
	              case "upper":
	                elem = elem.toUpperCase();
	                break;
	
	              case "lower":
	                elem = elem.toLowerCase();
	                break;
	
	              case "title":
	                var posBefore = getMaskSet().validPositions[pos - 1];
	                elem = 0 === pos || posBefore && posBefore.input === String.fromCharCode(Inputmask.keyCode.SPACE) ? elem.toUpperCase() : elem.toLowerCase();
	            }
	            return elem;
	        }
	        function checkAlternationMatch(altArr1, altArr2) {
	            for (var altArrC = opts.greedy ? altArr2 : altArr2.slice(0, 1), isMatch = !1, alndx = 0; alndx < altArr1.length; alndx++) if ($.inArray(altArr1[alndx], altArrC) !== -1) {
	                isMatch = !0;
	                break;
	            }
	            return isMatch;
	        }
	        function isValid(pos, c, strict, fromSetValid, fromAlternate) {
	            function isSelection(posObj) {
	                return isRTL ? posObj.begin - posObj.end > 1 || posObj.begin - posObj.end === 1 && opts.insertMode : posObj.end - posObj.begin > 1 || posObj.end - posObj.begin === 1 && opts.insertMode;
	            }
	            function _isValid(position, c, strict) {
	                var rslt = !1;
	                return $.each(getTests(position), function(ndx, tst) {
	                    for (var test = tst.match, loopend = c ? 1 : 0, chrs = "", i = test.cardinality; i > loopend; i--) chrs += getBufferElement(position - (i - 1));
	                    if (c && (chrs += c), getBuffer(!0), rslt = null != test.fn ? test.fn.test(chrs, getMaskSet(), position, strict, opts, isSelection(pos)) : (c === test.def || c === opts.skipOptionalPartCharacter) && "" !== test.def && {
	                        c: test.placeholder || test.def,
	                        pos: position
	                    }, rslt !== !1) {
	                        var elem = void 0 !== rslt.c ? rslt.c : c;
	                        elem = elem === opts.skipOptionalPartCharacter && null === test.fn ? test.placeholder || test.def : elem;
	                        var validatedPos = position, possibleModifiedBuffer = getBuffer();
	                        if (void 0 !== rslt.remove && ($.isArray(rslt.remove) || (rslt.remove = [ rslt.remove ]), 
	                        $.each(rslt.remove.sort(function(a, b) {
	                            return b - a;
	                        }), function(ndx, lmnt) {
	                            stripValidPositions(lmnt, lmnt + 1, !0);
	                        })), void 0 !== rslt.insert && ($.isArray(rslt.insert) || (rslt.insert = [ rslt.insert ]), 
	                        $.each(rslt.insert.sort(function(a, b) {
	                            return a - b;
	                        }), function(ndx, lmnt) {
	                            isValid(lmnt.pos, lmnt.c, !1, fromSetValid);
	                        })), rslt.refreshFromBuffer) {
	                            var refresh = rslt.refreshFromBuffer;
	                            if (strict = !0, refreshFromBuffer(refresh === !0 ? refresh : refresh.start, refresh.end, possibleModifiedBuffer), 
	                            void 0 === rslt.pos && void 0 === rslt.c) return rslt.pos = getLastValidPosition(), 
	                            !1;
	                            if (validatedPos = void 0 !== rslt.pos ? rslt.pos : position, validatedPos !== position) return rslt = $.extend(rslt, isValid(validatedPos, elem, !0, fromSetValid)), 
	                            !1;
	                        } else if (rslt !== !0 && void 0 !== rslt.pos && rslt.pos !== position && (validatedPos = rslt.pos, 
	                        refreshFromBuffer(position, validatedPos, getBuffer().slice()), validatedPos !== position)) return rslt = $.extend(rslt, isValid(validatedPos, elem, !0)), 
	                        !1;
	                        return (rslt === !0 || void 0 !== rslt.pos || void 0 !== rslt.c) && (ndx > 0 && resetMaskSet(!0), 
	                        setValidPosition(validatedPos, $.extend({}, tst, {
	                            input: casing(elem, test, validatedPos)
	                        }), fromSetValid, isSelection(pos)) || (rslt = !1), !1);
	                    }
	                }), rslt;
	            }
	            function alternate(pos, c, strict) {
	                var lastAlt, alternation, altPos, prevAltPos, i, validPos, altNdxs, decisionPos, validPsClone = $.extend(!0, {}, getMaskSet().validPositions), isValidRslt = !1, lAltPos = getLastValidPosition();
	                for (prevAltPos = getMaskSet().validPositions[lAltPos]; lAltPos >= 0; lAltPos--) if (altPos = getMaskSet().validPositions[lAltPos], 
	                altPos && void 0 !== altPos.alternation) {
	                    if (lastAlt = lAltPos, alternation = getMaskSet().validPositions[lastAlt].alternation, 
	                    prevAltPos.locator[altPos.alternation] !== altPos.locator[altPos.alternation]) break;
	                    prevAltPos = altPos;
	                }
	                if (void 0 !== alternation) {
	                    decisionPos = parseInt(lastAlt);
	                    var decisionTaker = void 0 !== prevAltPos.locator[prevAltPos.alternation || alternation] ? prevAltPos.locator[prevAltPos.alternation || alternation] : altNdxs[0];
	                    decisionTaker.length > 0 && (decisionTaker = decisionTaker.split(",")[0]);
	                    var possibilityPos = getMaskSet().validPositions[decisionPos], prevPos = getMaskSet().validPositions[decisionPos - 1];
	                    $.each(getTests(decisionPos, prevPos ? prevPos.locator : void 0, decisionPos - 1), function(ndx, test) {
	                        altNdxs = test.locator[alternation] ? test.locator[alternation].toString().split(",") : [];
	                        for (var mndx = 0; mndx < altNdxs.length; mndx++) {
	                            var validInputs = [], staticInputsBeforePos = 0, staticInputsBeforePosAlternate = 0, verifyValidInput = !1;
	                            if (decisionTaker < altNdxs[mndx] && (void 0 === test.na || $.inArray(altNdxs[mndx], test.na.split(",")) === -1)) {
	                                getMaskSet().validPositions[decisionPos] = $.extend(!0, {}, test);
	                                var possibilities = getMaskSet().validPositions[decisionPos].locator;
	                                for (getMaskSet().validPositions[decisionPos].locator[alternation] = parseInt(altNdxs[mndx]), 
	                                null == test.match.fn ? (possibilityPos.input !== test.match.def && (verifyValidInput = !0, 
	                                possibilityPos.generatedInput !== !0 && validInputs.push(possibilityPos.input)), 
	                                staticInputsBeforePosAlternate++, getMaskSet().validPositions[decisionPos].generatedInput = !/[0-9a-bA-Z]/.test(test.match.def), 
	                                getMaskSet().validPositions[decisionPos].input = test.match.def) : getMaskSet().validPositions[decisionPos].input = possibilityPos.input, 
	                                i = decisionPos + 1; i < getLastValidPosition(void 0, !0) + 1; i++) validPos = getMaskSet().validPositions[i], 
	                                validPos && validPos.generatedInput !== !0 && /[0-9a-bA-Z]/.test(validPos.input) ? validInputs.push(validPos.input) : i < pos && staticInputsBeforePos++, 
	                                delete getMaskSet().validPositions[i];
	                                for (verifyValidInput && validInputs[0] === test.match.def && validInputs.shift(), 
	                                resetMaskSet(!0), isValidRslt = !0; validInputs.length > 0; ) {
	                                    var input = validInputs.shift();
	                                    if (input !== opts.skipOptionalPartCharacter && !(isValidRslt = isValid(getLastValidPosition(void 0, !0) + 1, input, !1, fromSetValid, !0))) break;
	                                }
	                                if (isValidRslt) {
	                                    getMaskSet().validPositions[decisionPos].locator = possibilities;
	                                    var targetLvp = getLastValidPosition(pos) + 1;
	                                    for (i = decisionPos + 1; i < getLastValidPosition() + 1; i++) validPos = getMaskSet().validPositions[i], 
	                                    (void 0 === validPos || null == validPos.match.fn) && i < pos + (staticInputsBeforePosAlternate - staticInputsBeforePos) && staticInputsBeforePosAlternate++;
	                                    pos += staticInputsBeforePosAlternate - staticInputsBeforePos, isValidRslt = isValid(pos > targetLvp ? targetLvp : pos, c, strict, fromSetValid, !0);
	                                }
	                                if (isValidRslt) return !1;
	                                resetMaskSet(), getMaskSet().validPositions = $.extend(!0, {}, validPsClone);
	                            }
	                        }
	                    });
	                }
	                return isValidRslt;
	            }
	            function trackbackAlternations(originalPos, newPos) {
	                for (var vp = getMaskSet().validPositions[newPos], targetLocator = vp.locator, tll = targetLocator.length, ps = originalPos; ps < newPos; ps++) if (void 0 === getMaskSet().validPositions[ps] && !isMask(ps, !0)) {
	                    var tests = getTests(ps), bestMatch = tests[0], equality = -1;
	                    $.each(tests, function(ndx, tst) {
	                        for (var i = 0; i < tll && (void 0 !== tst.locator[i] && checkAlternationMatch(tst.locator[i].toString().split(","), targetLocator[i].toString().split(","))); i++) equality < i && (equality = i, 
	                        bestMatch = tst);
	                    }), setValidPosition(ps, $.extend({}, bestMatch, {
	                        input: bestMatch.match.placeholder || bestMatch.match.def
	                    }), !0);
	                }
	            }
	            function setValidPosition(pos, validTest, fromSetValid, isSelection) {
	                if (isSelection || opts.insertMode && void 0 !== getMaskSet().validPositions[pos] && void 0 === fromSetValid) {
	                    var i, positionsClone = $.extend(!0, {}, getMaskSet().validPositions), lvp = getLastValidPosition();
	                    for (i = pos; i <= lvp; i++) delete getMaskSet().validPositions[i];
	                    getMaskSet().validPositions[pos] = $.extend(!0, {}, validTest);
	                    var j, valid = !0, vps = getMaskSet().validPositions, needsValidation = !1, initialLength = getMaskSet().maskLength;
	                    for (i = j = pos; i <= lvp; i++) {
	                        var t = positionsClone[i];
	                        if (void 0 !== t) for (var posMatch = j; posMatch < getMaskSet().maskLength && (null == t.match.fn && vps[i] && (vps[i].match.optionalQuantifier === !0 || vps[i].match.optionality === !0) || null != t.match.fn); ) {
	                            if (posMatch++, needsValidation === !1 && positionsClone[posMatch] && positionsClone[posMatch].match.def === t.match.def) getMaskSet().validPositions[posMatch] = $.extend(!0, {}, positionsClone[posMatch]), 
	                            getMaskSet().validPositions[posMatch].input = t.input, fillMissingNonMask(posMatch), 
	                            j = posMatch, valid = !0; else if (positionCanMatchDefinition(posMatch, t.match.def)) {
	                                var result = isValid(posMatch, t.input, !0, !0);
	                                valid = result !== !1, j = result.caret || result.insert ? getLastValidPosition() : posMatch, 
	                                needsValidation = !0;
	                            } else valid = t.generatedInput === !0;
	                            if (getMaskSet().maskLength < initialLength && (getMaskSet().maskLength = initialLength), 
	                            valid) break;
	                        }
	                        if (!valid) break;
	                    }
	                    if (!valid) return getMaskSet().validPositions = $.extend(!0, {}, positionsClone), 
	                    resetMaskSet(!0), !1;
	                } else getMaskSet().validPositions[pos] = $.extend(!0, {}, validTest);
	                return resetMaskSet(!0), !0;
	            }
	            function fillMissingNonMask(maskPos) {
	                for (var pndx = maskPos - 1; pndx > -1 && !getMaskSet().validPositions[pndx]; pndx--) ;
	                var testTemplate, testsFromPos;
	                for (pndx++; pndx < maskPos; pndx++) void 0 === getMaskSet().validPositions[pndx] && (opts.jitMasking === !1 || opts.jitMasking > pndx) && (testsFromPos = getTests(pndx, getTestTemplate(pndx - 1).locator, pndx - 1).slice(), 
	                "" === testsFromPos[testsFromPos.length - 1].match.def && testsFromPos.pop(), testTemplate = determineTestTemplate(testsFromPos), 
	                testTemplate && (testTemplate.match.def === opts.radixPointDefinitionSymbol || !isMask(pndx, !0) || $.inArray(opts.radixPoint, getBuffer()) < pndx && testTemplate.match.fn && testTemplate.match.fn.test(getPlaceholder(pndx), getMaskSet(), pndx, !1, opts)) && (result = _isValid(pndx, testTemplate.match.placeholder || (null == testTemplate.match.fn ? testTemplate.match.def : "" !== getPlaceholder(pndx) ? getPlaceholder(pndx) : getBuffer()[pndx]), !0), 
	                result !== !1 && (getMaskSet().validPositions[result.pos || pndx].generatedInput = !0)));
	            }
	            strict = strict === !0;
	            var maskPos = pos;
	            void 0 !== pos.begin && (maskPos = isRTL && !isSelection(pos) ? pos.end : pos.begin);
	            var result = !1, positionsClone = $.extend(!0, {}, getMaskSet().validPositions);
	            if (fillMissingNonMask(maskPos), isSelection(pos) && (handleRemove(void 0, Inputmask.keyCode.DELETE, pos), 
	            maskPos = getMaskSet().p), maskPos < getMaskSet().maskLength && (result = _isValid(maskPos, c, strict), 
	            (!strict || fromSetValid === !0) && result === !1)) {
	                var currentPosValid = getMaskSet().validPositions[maskPos];
	                if (!currentPosValid || null !== currentPosValid.match.fn || currentPosValid.match.def !== c && c !== opts.skipOptionalPartCharacter) {
	                    if ((opts.insertMode || void 0 === getMaskSet().validPositions[seekNext(maskPos)]) && !isMask(maskPos, !0)) {
	                        var testsFromPos = getTests(maskPos).slice();
	                        "" === testsFromPos[testsFromPos.length - 1].match.def && testsFromPos.pop();
	                        var staticChar = determineTestTemplate(testsFromPos, !0);
	                        staticChar && (staticChar = staticChar.match.placeholder || staticChar.match.def, 
	                        _isValid(maskPos, staticChar, strict), getMaskSet().validPositions[maskPos].generatedInput = !0);
	                        for (var nPos = maskPos + 1, snPos = seekNext(maskPos); nPos <= snPos; nPos++) if (result = _isValid(nPos, c, strict), 
	                        result !== !1) {
	                            trackbackAlternations(maskPos, nPos), maskPos = nPos;
	                            break;
	                        }
	                    }
	                } else result = {
	                    caret: seekNext(maskPos)
	                };
	            }
	            return result === !1 && opts.keepStatic && !strict && fromAlternate !== !0 && (result = alternate(maskPos, c, strict)), 
	            result === !0 && (result = {
	                pos: maskPos
	            }), $.isFunction(opts.postValidation) && result !== !1 && !strict && fromSetValid !== !0 && (result = !!opts.postValidation(getBuffer(!0), result, opts) && result), 
	            void 0 === result.pos && (result.pos = maskPos), result === !1 && (resetMaskSet(!0), 
	            getMaskSet().validPositions = $.extend(!0, {}, positionsClone)), result;
	        }
	        function isMask(pos, strict) {
	            var test;
	            if (strict ? (test = getTestTemplate(pos).match, "" === test.def && (test = getTest(pos).match)) : test = getTest(pos).match, 
	            null != test.fn) return test.fn;
	            if (strict !== !0 && pos > -1) {
	                var tests = getTests(pos);
	                return tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0);
	            }
	            return !1;
	        }
	        function seekNext(pos, newBlock) {
	            var maskL = getMaskSet().maskLength;
	            if (pos >= maskL) return maskL;
	            for (var position = pos; ++position < maskL && (newBlock === !0 && (getTest(position).match.newBlockMarker !== !0 || !isMask(position)) || newBlock !== !0 && !isMask(position)); ) ;
	            return position;
	        }
	        function seekPrevious(pos, newBlock) {
	            var tests, position = pos;
	            if (position <= 0) return 0;
	            for (;--position > 0 && (newBlock === !0 && getTest(position).match.newBlockMarker !== !0 || newBlock !== !0 && !isMask(position) && (tests = getTests(position), 
	            tests.length < 2 || 2 === tests.length && "" === tests[1].match.def)); ) ;
	            return position;
	        }
	        function getBufferElement(position) {
	            return void 0 === getMaskSet().validPositions[position] ? getPlaceholder(position) : getMaskSet().validPositions[position].input;
	        }
	        function writeBuffer(input, buffer, caretPos, event, triggerInputEvent) {
	            if (event && $.isFunction(opts.onBeforeWrite)) {
	                var result = opts.onBeforeWrite(event, buffer, caretPos, opts);
	                if (result) {
	                    if (result.refreshFromBuffer) {
	                        var refresh = result.refreshFromBuffer;
	                        refreshFromBuffer(refresh === !0 ? refresh : refresh.start, refresh.end, result.buffer || buffer), 
	                        buffer = getBuffer(!0);
	                    }
	                    void 0 !== caretPos && (caretPos = void 0 !== result.caret ? result.caret : caretPos);
	                }
	            }
	            input.inputmask._valueSet(buffer.join("")), void 0 === caretPos || void 0 !== event && "blur" === event.type || caret(input, caretPos), 
	            triggerInputEvent === !0 && (skipInputEvent = !0, $(input).trigger("input"));
	        }
	        function getPlaceholder(pos, test) {
	            if (test = test || getTest(pos).match, void 0 !== test.placeholder) return test.placeholder;
	            if (null === test.fn) {
	                if (pos > -1 && void 0 === getMaskSet().validPositions[pos]) {
	                    var prevTest, tests = getTests(pos), staticAlternations = [];
	                    if (tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0)) for (var i = 0; i < tests.length; i++) if (tests[i].match.optionality !== !0 && tests[i].match.optionalQuantifier !== !0 && (null === tests[i].match.fn || void 0 === prevTest || tests[i].match.fn.test(prevTest.match.def, getMaskSet(), pos, !0, opts) !== !1) && (staticAlternations.push(tests[i]), 
	                    null === tests[i].match.fn && (prevTest = tests[i]), staticAlternations.length > 1 && /[0-9a-bA-Z]/.test(staticAlternations[0].match.def))) return opts.placeholder.charAt(pos % opts.placeholder.length);
	                }
	                return test.def;
	            }
	            return opts.placeholder.charAt(pos % opts.placeholder.length);
	        }
	        function checkVal(input, writeOut, strict, nptvl, initiatingEvent, stickyCaret) {
	            function isTemplateMatch() {
	                var isMatch = !1, charCodeNdx = getBufferTemplate().slice(initialNdx, seekNext(initialNdx)).join("").indexOf(charCodes);
	                if (charCodeNdx !== -1 && !isMask(initialNdx)) {
	                    isMatch = !0;
	                    for (var bufferTemplateArr = getBufferTemplate().slice(initialNdx, initialNdx + charCodeNdx), i = 0; i < bufferTemplateArr.length; i++) if (" " !== bufferTemplateArr[i]) {
	                        isMatch = !1;
	                        break;
	                    }
	                }
	                return isMatch;
	            }
	            var inputValue = nptvl.slice(), charCodes = "", initialNdx = 0, result = void 0;
	            if (resetMaskSet(), getMaskSet().p = seekNext(-1), !strict) if (opts.autoUnmask !== !0) {
	                var staticInput = getBufferTemplate().slice(0, seekNext(-1)).join(""), matches = inputValue.join("").match(new RegExp("^" + Inputmask.escapeRegex(staticInput), "g"));
	                matches && matches.length > 0 && (inputValue.splice(0, matches.length * staticInput.length), 
	                initialNdx = seekNext(initialNdx));
	            } else initialNdx = seekNext(initialNdx);
	            if ($.each(inputValue, function(ndx, charCode) {
	                if (void 0 !== charCode) {
	                    var keypress = new $.Event("keypress");
	                    keypress.which = charCode.charCodeAt(0), charCodes += charCode;
	                    var lvp = getLastValidPosition(void 0, !0), lvTest = getMaskSet().validPositions[lvp], nextTest = getTestTemplate(lvp + 1, lvTest ? lvTest.locator.slice() : void 0, lvp);
	                    if (!isTemplateMatch() || strict || opts.autoUnmask) {
	                        var pos = strict ? ndx : null == nextTest.match.fn && nextTest.match.optionality && lvp + 1 < getMaskSet().p ? lvp + 1 : getMaskSet().p;
	                        result = keypressEvent.call(input, keypress, !0, !1, strict, pos), initialNdx = pos + 1, 
	                        charCodes = "";
	                    } else result = keypressEvent.call(input, keypress, !0, !1, !0, lvp + 1);
	                    if (!strict && $.isFunction(opts.onBeforeWrite) && (result = opts.onBeforeWrite(keypress, getBuffer(), result.forwardPosition, opts), 
	                    result && result.refreshFromBuffer)) {
	                        var refresh = result.refreshFromBuffer;
	                        refreshFromBuffer(refresh === !0 ? refresh : refresh.start, refresh.end, result.buffer), 
	                        resetMaskSet(!0), result.caret && (getMaskSet().p = result.caret);
	                    }
	                }
	            }), writeOut) {
	                var caretPos = void 0, lvp = getLastValidPosition();
	                document.activeElement === input && (initiatingEvent || result) && (caretPos = caret(input).begin - (stickyCaret === !0 ? 1 : 0), 
	                result && stickyCaret !== !0 && (caretPos < lvp + 1 || lvp === -1) && (caretPos = opts.numericInput && void 0 === result.caret ? seekPrevious(result.forwardPosition) : result.forwardPosition)), 
	                writeBuffer(input, getBuffer(), caretPos, initiatingEvent || new $.Event("checkval"));
	            }
	        }
	        function unmaskedvalue(input) {
	            if (input && void 0 === input.inputmask) return input.value;
	            var umValue = [], vps = getMaskSet().validPositions;
	            for (var pndx in vps) vps[pndx].match && null != vps[pndx].match.fn && umValue.push(vps[pndx].input);
	            var unmaskedValue = 0 === umValue.length ? "" : (isRTL ? umValue.reverse() : umValue).join("");
	            if ($.isFunction(opts.onUnMask)) {
	                var bufferValue = (isRTL ? getBuffer().slice().reverse() : getBuffer()).join("");
	                unmaskedValue = opts.onUnMask(bufferValue, unmaskedValue, opts) || unmaskedValue;
	            }
	            return unmaskedValue;
	        }
	        function caret(input, begin, end, notranslate) {
	            function translatePosition(pos) {
	                if (notranslate !== !0 && isRTL && "number" == typeof pos && (!opts.greedy || "" !== opts.placeholder)) {
	                    var bffrLght = getBuffer().join("").length;
	                    pos = bffrLght - pos;
	                }
	                return pos;
	            }
	            var range;
	            if ("number" != typeof begin) return input.setSelectionRange ? (begin = input.selectionStart, 
	            end = input.selectionEnd) : window.getSelection ? (range = window.getSelection().getRangeAt(0), 
	            range.commonAncestorContainer.parentNode !== input && range.commonAncestorContainer !== input || (begin = range.startOffset, 
	            end = range.endOffset)) : document.selection && document.selection.createRange && (range = document.selection.createRange(), 
	            begin = 0 - range.duplicate().moveStart("character", -input.inputmask._valueGet().length), 
	            end = begin + range.text.length), {
	                begin: translatePosition(begin),
	                end: translatePosition(end)
	            };
	            begin = translatePosition(begin), end = translatePosition(end), end = "number" == typeof end ? end : begin;
	            var scrollCalc = parseInt(((input.ownerDocument.defaultView || window).getComputedStyle ? (input.ownerDocument.defaultView || window).getComputedStyle(input, null) : input.currentStyle).fontSize) * end;
	            if (input.scrollLeft = scrollCalc > input.scrollWidth ? scrollCalc : 0, mobile || opts.insertMode !== !1 || begin !== end || end++, 
	            input.setSelectionRange) input.selectionStart = begin, input.selectionEnd = end; else if (window.getSelection) {
	                if (range = document.createRange(), void 0 === input.firstChild || null === input.firstChild) {
	                    var textNode = document.createTextNode("");
	                    input.appendChild(textNode);
	                }
	                range.setStart(input.firstChild, begin < input.inputmask._valueGet().length ? begin : input.inputmask._valueGet().length), 
	                range.setEnd(input.firstChild, end < input.inputmask._valueGet().length ? end : input.inputmask._valueGet().length), 
	                range.collapse(!0);
	                var sel = window.getSelection();
	                sel.removeAllRanges(), sel.addRange(range);
	            } else input.createTextRange && (range = input.createTextRange(), range.collapse(!0), 
	            range.moveEnd("character", end), range.moveStart("character", begin), range.select());
	        }
	        function determineLastRequiredPosition(returnDefinition) {
	            var pos, testPos, buffer = getBuffer(), bl = buffer.length, lvp = getLastValidPosition(), positions = {}, lvTest = getMaskSet().validPositions[lvp], ndxIntlzr = void 0 !== lvTest ? lvTest.locator.slice() : void 0;
	            for (pos = lvp + 1; pos < buffer.length; pos++) testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	            ndxIntlzr = testPos.locator.slice(), positions[pos] = $.extend(!0, {}, testPos);
	            var lvTestAlt = lvTest && void 0 !== lvTest.alternation ? lvTest.locator[lvTest.alternation] : void 0;
	            for (pos = bl - 1; pos > lvp && (testPos = positions[pos], (testPos.match.optionality || testPos.match.optionalQuantifier || lvTestAlt && (lvTestAlt !== positions[pos].locator[lvTest.alternation] && null != testPos.match.fn || null === testPos.match.fn && testPos.locator[lvTest.alternation] && checkAlternationMatch(testPos.locator[lvTest.alternation].toString().split(","), lvTestAlt.toString().split(",")) && "" !== getTests(pos)[0].def)) && buffer[pos] === getPlaceholder(pos, testPos.match)); pos--) bl--;
	            return returnDefinition ? {
	                l: bl,
	                def: positions[bl] ? positions[bl].match : void 0
	            } : bl;
	        }
	        function clearOptionalTail(buffer) {
	            for (var rl = determineLastRequiredPosition(), lmib = buffer.length - 1; lmib > rl && !isMask(lmib); lmib--) ;
	            return buffer.splice(rl, lmib + 1 - rl), buffer;
	        }
	        function isComplete(buffer) {
	            if ($.isFunction(opts.isComplete)) return opts.isComplete(buffer, opts);
	            if ("*" !== opts.repeat) {
	                var complete = !1, lrp = determineLastRequiredPosition(!0), aml = seekPrevious(lrp.l);
	                if (void 0 === lrp.def || lrp.def.newBlockMarker || lrp.def.optionality || lrp.def.optionalQuantifier) {
	                    complete = !0;
	                    for (var i = 0; i <= aml; i++) {
	                        var test = getTestTemplate(i).match;
	                        if (null !== test.fn && void 0 === getMaskSet().validPositions[i] && test.optionality !== !0 && test.optionalQuantifier !== !0 || null === test.fn && buffer[i] !== getPlaceholder(i, test)) {
	                            complete = !1;
	                            break;
	                        }
	                    }
	                }
	                return complete;
	            }
	        }
	        function patchValueProperty(npt) {
	            function patchValhook(type) {
	                if ($.valHooks && (void 0 === $.valHooks[type] || $.valHooks[type].inputmaskpatch !== !0)) {
	                    var valhookGet = $.valHooks[type] && $.valHooks[type].get ? $.valHooks[type].get : function(elem) {
	                        return elem.value;
	                    }, valhookSet = $.valHooks[type] && $.valHooks[type].set ? $.valHooks[type].set : function(elem, value) {
	                        return elem.value = value, elem;
	                    };
	                    $.valHooks[type] = {
	                        get: function(elem) {
	                            if (elem.inputmask) {
	                                if (elem.inputmask.opts.autoUnmask) return elem.inputmask.unmaskedvalue();
	                                var result = valhookGet(elem);
	                                return getLastValidPosition(void 0, void 0, elem.inputmask.maskset.validPositions) !== -1 || opts.nullable !== !0 ? result : "";
	                            }
	                            return valhookGet(elem);
	                        },
	                        set: function(elem, value) {
	                            var result, $elem = $(elem);
	                            return result = valhookSet(elem, value), elem.inputmask && $elem.trigger("setvalue"), 
	                            result;
	                        },
	                        inputmaskpatch: !0
	                    };
	                }
	            }
	            function getter() {
	                return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : getLastValidPosition() !== -1 || opts.nullable !== !0 ? document.activeElement === this && opts.clearMaskOnLostFocus ? (isRTL ? clearOptionalTail(getBuffer().slice()).reverse() : clearOptionalTail(getBuffer().slice())).join("") : valueGet.call(this) : "" : valueGet.call(this);
	            }
	            function setter(value) {
	                valueSet.call(this, value), this.inputmask && $(this).trigger("setvalue");
	            }
	            function installNativeValueSetFallback(npt) {
	                EventRuler.on(npt, "mouseenter", function(event) {
	                    var $input = $(this), input = this, value = input.inputmask._valueGet();
	                    value !== getBuffer().join("") && $input.trigger("setvalue");
	                });
	            }
	            var valueGet, valueSet;
	            if (!npt.inputmask.__valueGet) {
	                if (Object.getOwnPropertyDescriptor) {
	                    "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" == typeof "test".__proto__ ? function(object) {
	                        return object.__proto__;
	                    } : function(object) {
	                        return object.constructor.prototype;
	                    });
	                    var valueProperty = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(npt), "value") : void 0;
	                    valueProperty && valueProperty.get && valueProperty.set ? (valueGet = valueProperty.get, 
	                    valueSet = valueProperty.set, Object.defineProperty(npt, "value", {
	                        get: getter,
	                        set: setter,
	                        configurable: !0
	                    })) : "INPUT" !== npt.tagName && (valueGet = function() {
	                        return this.textContent;
	                    }, valueSet = function(value) {
	                        this.textContent = value;
	                    }, Object.defineProperty(npt, "value", {
	                        get: getter,
	                        set: setter,
	                        configurable: !0
	                    }));
	                } else document.__lookupGetter__ && npt.__lookupGetter__("value") && (valueGet = npt.__lookupGetter__("value"), 
	                valueSet = npt.__lookupSetter__("value"), npt.__defineGetter__("value", getter), 
	                npt.__defineSetter__("value", setter));
	                npt.inputmask.__valueGet = valueGet, npt.inputmask._valueGet = function(overruleRTL) {
	                    return isRTL && overruleRTL !== !0 ? valueGet.call(this.el).split("").reverse().join("") : valueGet.call(this.el);
	                }, npt.inputmask.__valueSet = valueSet, npt.inputmask._valueSet = function(value, overruleRTL) {
	                    valueSet.call(this.el, null === value || void 0 === value ? "" : overruleRTL !== !0 && isRTL ? value.split("").reverse().join("") : value);
	                }, void 0 === valueGet && (valueGet = function() {
	                    return this.value;
	                }, valueSet = function(value) {
	                    this.value = value;
	                }, patchValhook(npt.type), installNativeValueSetFallback(npt));
	            }
	        }
	        function handleRemove(input, k, pos, strict) {
	            function generalize() {
	                if (opts.keepStatic) {
	                    for (var validInputs = [], lastAlt = getLastValidPosition(-1, !0), positionsClone = $.extend(!0, {}, getMaskSet().validPositions), prevAltPos = getMaskSet().validPositions[lastAlt]; lastAlt >= 0; lastAlt--) {
	                        var altPos = getMaskSet().validPositions[lastAlt];
	                        if (altPos) {
	                            if (altPos.generatedInput !== !0 && /[0-9a-bA-Z]/.test(altPos.input) && validInputs.push(altPos.input), 
	                            delete getMaskSet().validPositions[lastAlt], void 0 !== altPos.alternation && altPos.locator[altPos.alternation] !== prevAltPos.locator[altPos.alternation]) break;
	                            prevAltPos = altPos;
	                        }
	                    }
	                    if (lastAlt > -1) for (getMaskSet().p = seekNext(getLastValidPosition(-1, !0)); validInputs.length > 0; ) {
	                        var keypress = new $.Event("keypress");
	                        keypress.which = validInputs.pop().charCodeAt(0), keypressEvent.call(input, keypress, !0, !1, !1, getMaskSet().p);
	                    } else getMaskSet().validPositions = $.extend(!0, {}, positionsClone);
	                }
	            }
	            if ((opts.numericInput || isRTL) && (k === Inputmask.keyCode.BACKSPACE ? k = Inputmask.keyCode.DELETE : k === Inputmask.keyCode.DELETE && (k = Inputmask.keyCode.BACKSPACE), 
	            isRTL)) {
	                var pend = pos.end;
	                pos.end = pos.begin, pos.begin = pend;
	            }
	            k === Inputmask.keyCode.BACKSPACE && (pos.end - pos.begin < 1 || opts.insertMode === !1) ? (pos.begin = seekPrevious(pos.begin), 
	            void 0 === getMaskSet().validPositions[pos.begin] || getMaskSet().validPositions[pos.begin].input !== opts.groupSeparator && getMaskSet().validPositions[pos.begin].input !== opts.radixPoint || pos.begin--) : k === Inputmask.keyCode.DELETE && pos.begin === pos.end && (pos.end = isMask(pos.end, !0) ? pos.end + 1 : seekNext(pos.end) + 1, 
	            void 0 === getMaskSet().validPositions[pos.begin] || getMaskSet().validPositions[pos.begin].input !== opts.groupSeparator && getMaskSet().validPositions[pos.begin].input !== opts.radixPoint || pos.end++), 
	            stripValidPositions(pos.begin, pos.end, !1, strict), strict !== !0 && generalize();
	            var lvp = getLastValidPosition(pos.begin, !0);
	            lvp < pos.begin ? getMaskSet().p = seekNext(lvp) : strict !== !0 && (getMaskSet().p = pos.begin);
	        }
	        function keydownEvent(e) {
	            var input = this, $input = $(input), k = e.keyCode, pos = caret(input);
	            if (k === Inputmask.keyCode.BACKSPACE || k === Inputmask.keyCode.DELETE || iphone && k === Inputmask.keyCode.BACKSPACE_SAFARI || e.ctrlKey && k === Inputmask.keyCode.X && !isInputEventSupported("cut")) e.preventDefault(), 
	            handleRemove(input, k, pos), writeBuffer(input, getBuffer(!0), getMaskSet().p, e, input.inputmask._valueGet() !== getBuffer().join("")), 
	            input.inputmask._valueGet() === getBufferTemplate().join("") ? $input.trigger("cleared") : isComplete(getBuffer()) === !0 && $input.trigger("complete"), 
	            opts.showTooltip && (input.title = opts.tooltip || getMaskSet().mask); else if (k === Inputmask.keyCode.END || k === Inputmask.keyCode.PAGE_DOWN) {
	                e.preventDefault();
	                var caretPos = seekNext(getLastValidPosition());
	                opts.insertMode || caretPos !== getMaskSet().maskLength || e.shiftKey || caretPos--, 
	                caret(input, e.shiftKey ? pos.begin : caretPos, caretPos, !0);
	            } else k === Inputmask.keyCode.HOME && !e.shiftKey || k === Inputmask.keyCode.PAGE_UP ? (e.preventDefault(), 
	            caret(input, 0, e.shiftKey ? pos.begin : 0, !0)) : (opts.undoOnEscape && k === Inputmask.keyCode.ESCAPE || 90 === k && e.ctrlKey) && e.altKey !== !0 ? (checkVal(input, !0, !1, undoValue.split("")), 
	            $input.trigger("click")) : k !== Inputmask.keyCode.INSERT || e.shiftKey || e.ctrlKey ? opts.tabThrough === !0 && k === Inputmask.keyCode.TAB ? (e.shiftKey === !0 ? (null === getTest(pos.begin).match.fn && (pos.begin = seekNext(pos.begin)), 
	            pos.end = seekPrevious(pos.begin, !0), pos.begin = seekPrevious(pos.end, !0)) : (pos.begin = seekNext(pos.begin, !0), 
	            pos.end = seekNext(pos.begin, !0), pos.end < getMaskSet().maskLength && pos.end--), 
	            pos.begin < getMaskSet().maskLength && (e.preventDefault(), caret(input, pos.begin, pos.end))) : opts.insertMode !== !1 || e.shiftKey || (k === Inputmask.keyCode.RIGHT ? setTimeout(function() {
	                var caretPos = caret(input);
	                caret(input, caretPos.begin);
	            }, 0) : k === Inputmask.keyCode.LEFT && setTimeout(function() {
	                var caretPos = caret(input);
	                caret(input, isRTL ? caretPos.begin + 1 : caretPos.begin - 1);
	            }, 0)) : (opts.insertMode = !opts.insertMode, caret(input, opts.insertMode || pos.begin !== getMaskSet().maskLength ? pos.begin : pos.begin - 1));
	            opts.onKeyDown.call(this, e, getBuffer(), caret(input).begin, opts), ignorable = $.inArray(k, opts.ignorables) !== -1;
	        }
	        function keypressEvent(e, checkval, writeOut, strict, ndx) {
	            var input = this, $input = $(input), k = e.which || e.charCode || e.keyCode;
	            if (!(checkval === !0 || e.ctrlKey && e.altKey) && (e.ctrlKey || e.metaKey || ignorable)) return k === Inputmask.keyCode.ENTER && undoValue !== getBuffer().join("") && (undoValue = getBuffer().join(""), 
	            setTimeout(function() {
	                $input.trigger("change");
	            }, 0)), !0;
	            if (k) {
	                46 === k && e.shiftKey === !1 && "," === opts.radixPoint && (k = 44);
	                var forwardPosition, pos = checkval ? {
	                    begin: ndx,
	                    end: ndx
	                } : caret(input), c = String.fromCharCode(k);
	                getMaskSet().writeOutBuffer = !0;
	                var valResult = isValid(pos, c, strict);
	                if (valResult !== !1 && (resetMaskSet(!0), forwardPosition = void 0 !== valResult.caret ? valResult.caret : checkval ? valResult.pos + 1 : seekNext(valResult.pos), 
	                getMaskSet().p = forwardPosition), writeOut !== !1) {
	                    var self = this;
	                    if (setTimeout(function() {
	                        opts.onKeyValidation.call(self, k, valResult, opts);
	                    }, 0), getMaskSet().writeOutBuffer && valResult !== !1) {
	                        var buffer = getBuffer();
	                        writeBuffer(input, buffer, opts.numericInput && void 0 === valResult.caret ? seekPrevious(forwardPosition) : forwardPosition, e, checkval !== !0), 
	                        checkval !== !0 && setTimeout(function() {
	                            isComplete(buffer) === !0 && $input.trigger("complete");
	                        }, 0);
	                    }
	                }
	                if (opts.showTooltip && (input.title = opts.tooltip || getMaskSet().mask), e.preventDefault(), 
	                checkval) return valResult.forwardPosition = forwardPosition, valResult;
	            }
	        }
	        function pasteEvent(e) {
	            var tempValue, input = this, ev = e.originalEvent || e, $input = $(input), inputValue = input.inputmask._valueGet(!0), caretPos = caret(input);
	            isRTL && (tempValue = caretPos.end, caretPos.end = caretPos.begin, caretPos.begin = tempValue);
	            var valueBeforeCaret = inputValue.substr(0, caretPos.begin), valueAfterCaret = inputValue.substr(caretPos.end, inputValue.length);
	            if (valueBeforeCaret === (isRTL ? getBufferTemplate().reverse() : getBufferTemplate()).slice(0, caretPos.begin).join("") && (valueBeforeCaret = ""), 
	            valueAfterCaret === (isRTL ? getBufferTemplate().reverse() : getBufferTemplate()).slice(caretPos.end).join("") && (valueAfterCaret = ""), 
	            isRTL && (tempValue = valueBeforeCaret, valueBeforeCaret = valueAfterCaret, valueAfterCaret = tempValue), 
	            window.clipboardData && window.clipboardData.getData) inputValue = valueBeforeCaret + window.clipboardData.getData("Text") + valueAfterCaret; else {
	                if (!ev.clipboardData || !ev.clipboardData.getData) return !0;
	                inputValue = valueBeforeCaret + ev.clipboardData.getData("text/plain") + valueAfterCaret;
	            }
	            var pasteValue = inputValue;
	            if ($.isFunction(opts.onBeforePaste)) {
	                if (pasteValue = opts.onBeforePaste(inputValue, opts), pasteValue === !1) return e.preventDefault();
	                pasteValue || (pasteValue = inputValue);
	            }
	            return checkVal(input, !1, !1, isRTL ? pasteValue.split("").reverse() : pasteValue.toString().split("")), 
	            writeBuffer(input, getBuffer(), seekNext(getLastValidPosition()), e, undoValue !== getBuffer().join("")), 
	            isComplete(getBuffer()) === !0 && $input.trigger("complete"), e.preventDefault();
	        }
	        function inputFallBackEvent(e) {
	            var input = this, inputValue = input.inputmask._valueGet();
	            if (getBuffer().join("") !== inputValue) {
	                var caretPos = caret(input);
	                if (inputValue = inputValue.replace(new RegExp("(" + Inputmask.escapeRegex(getBufferTemplate().join("")) + ")*"), ""), 
	                iemobile) {
	                    var inputChar = inputValue.replace(getBuffer().join(""), "");
	                    if (1 === inputChar.length) {
	                        var keypress = new $.Event("keypress");
	                        return keypress.which = inputChar.charCodeAt(0), keypressEvent.call(input, keypress, !0, !0, !1, getMaskSet().validPositions[caretPos.begin - 1] ? caretPos.begin : caretPos.begin - 1), 
	                        !1;
	                    }
	                }
	                if (caretPos.begin > inputValue.length && (caret(input, inputValue.length), caretPos = caret(input)), 
	                getBuffer().length - inputValue.length !== 1 || inputValue.charAt(caretPos.begin) === getBuffer()[caretPos.begin] || inputValue.charAt(caretPos.begin + 1) === getBuffer()[caretPos.begin] || isMask(caretPos.begin)) {
	                    for (var lvp = getLastValidPosition() + 1, bufferTemplate = getBuffer().slice(lvp).join(""); null === inputValue.match(Inputmask.escapeRegex(bufferTemplate) + "$"); ) bufferTemplate = bufferTemplate.slice(1);
	                    inputValue = inputValue.replace(bufferTemplate, ""), inputValue = inputValue.split(""), 
	                    checkVal(input, !0, !1, inputValue, e, caretPos.begin < lvp), isComplete(getBuffer()) === !0 && $(input).trigger("complete");
	                } else e.keyCode = Inputmask.keyCode.BACKSPACE, keydownEvent.call(input, e);
	                e.preventDefault();
	            }
	        }
	        function setValueEvent(e) {
	            var input = this, value = input.inputmask._valueGet();
	            checkVal(input, !0, !1, ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(value, opts) || value : value).split("")), 
	            undoValue = getBuffer().join(""), (opts.clearMaskOnLostFocus || opts.clearIncomplete) && input.inputmask._valueGet() === getBufferTemplate().join("") && input.inputmask._valueSet("");
	        }
	        function focusEvent(e) {
	            var input = this, nptValue = input.inputmask._valueGet();
	            opts.showMaskOnFocus && (!opts.showMaskOnHover || opts.showMaskOnHover && "" === nptValue) ? input.inputmask._valueGet() !== getBuffer().join("") && writeBuffer(input, getBuffer(), seekNext(getLastValidPosition())) : mouseEnter === !1 && caret(input, seekNext(getLastValidPosition())), 
	            opts.positionCaretOnTab === !0 && setTimeout(function() {
	                clickEvent.apply(this, [ e ]);
	            }, 0), undoValue = getBuffer().join("");
	        }
	        function mouseleaveEvent(e) {
	            var input = this;
	            if (mouseEnter = !1, opts.clearMaskOnLostFocus && document.activeElement !== input) {
	                var buffer = getBuffer().slice(), nptValue = input.inputmask._valueGet();
	                nptValue !== input.getAttribute("placeholder") && "" !== nptValue && (getLastValidPosition() === -1 && nptValue === getBufferTemplate().join("") ? buffer = [] : clearOptionalTail(buffer), 
	                writeBuffer(input, buffer));
	            }
	        }
	        function clickEvent(e) {
	            function doRadixFocus(clickPos) {
	                if ("" !== opts.radixPoint) {
	                    var vps = getMaskSet().validPositions;
	                    if (void 0 === vps[clickPos] || vps[clickPos].input === getPlaceholder(clickPos)) {
	                        if (clickPos < seekNext(-1)) return !0;
	                        var radixPos = $.inArray(opts.radixPoint, getBuffer());
	                        if (radixPos !== -1) {
	                            for (var vp in vps) if (radixPos < vp && vps[vp].input !== getPlaceholder(vp)) return !1;
	                            return !0;
	                        }
	                    }
	                }
	                return !1;
	            }
	            var input = this;
	            setTimeout(function() {
	                if (document.activeElement === input) {
	                    var selectedCaret = caret(input);
	                    if (selectedCaret.begin === selectedCaret.end) switch (opts.positionCaretOnClick) {
	                      case "none":
	                        break;
	
	                      case "radixFocus":
	                        if (doRadixFocus(selectedCaret.begin)) {
	                            var radixPos = $.inArray(opts.radixPoint, getBuffer().join(""));
	                            caret(input, opts.numericInput ? seekNext(radixPos) : radixPos);
	                            break;
	                        }
	
	                      default:
	                        var clickPosition = selectedCaret.begin, lvclickPosition = getLastValidPosition(clickPosition, !0), lastPosition = seekNext(lvclickPosition);
	                        if (clickPosition < lastPosition) caret(input, isMask(clickPosition) || isMask(clickPosition - 1) ? clickPosition : seekNext(clickPosition)); else {
	                            var placeholder = getPlaceholder(lastPosition);
	                            ("" !== placeholder && getBuffer()[lastPosition] !== placeholder && getTest(lastPosition).match.optionalQuantifier !== !0 || !isMask(lastPosition, !0) && getTest(lastPosition).match.def === placeholder) && (lastPosition = seekNext(lastPosition)), 
	                            caret(input, lastPosition);
	                        }
	                    }
	                }
	            }, 0);
	        }
	        function dblclickEvent(e) {
	            var input = this;
	            setTimeout(function() {
	                caret(input, 0, seekNext(getLastValidPosition()));
	            }, 0);
	        }
	        function cutEvent(e) {
	            var input = this, $input = $(input), pos = caret(input), ev = e.originalEvent || e, clipboardData = window.clipboardData || ev.clipboardData, clipData = isRTL ? getBuffer().slice(pos.end, pos.begin) : getBuffer().slice(pos.begin, pos.end);
	            clipboardData.setData("text", isRTL ? clipData.reverse().join("") : clipData.join("")), 
	            document.execCommand && document.execCommand("copy"), handleRemove(input, Inputmask.keyCode.DELETE, pos), 
	            writeBuffer(input, getBuffer(), getMaskSet().p, e, undoValue !== getBuffer().join("")), 
	            input.inputmask._valueGet() === getBufferTemplate().join("") && $input.trigger("cleared"), 
	            opts.showTooltip && (input.title = opts.tooltip || getMaskSet().mask);
	        }
	        function blurEvent(e) {
	            var $input = $(this), input = this;
	            if (input.inputmask) {
	                var nptValue = input.inputmask._valueGet(), buffer = getBuffer().slice();
	                undoValue !== buffer.join("") && setTimeout(function() {
	                    $input.trigger("change"), undoValue = buffer.join("");
	                }, 0), "" !== nptValue && (opts.clearMaskOnLostFocus && (getLastValidPosition() === -1 && nptValue === getBufferTemplate().join("") ? buffer = [] : clearOptionalTail(buffer)), 
	                isComplete(buffer) === !1 && (setTimeout(function() {
	                    $input.trigger("incomplete");
	                }, 0), opts.clearIncomplete && (resetMaskSet(), buffer = opts.clearMaskOnLostFocus ? [] : getBufferTemplate().slice())), 
	                writeBuffer(input, buffer, void 0, e));
	            }
	        }
	        function mouseenterEvent(e) {
	            var input = this;
	            mouseEnter = !0, document.activeElement !== input && opts.showMaskOnHover && input.inputmask._valueGet() !== getBuffer().join("") && writeBuffer(input, getBuffer());
	        }
	        function submitEvent(e) {
	            undoValue !== getBuffer().join("") && $el.trigger("change"), opts.clearMaskOnLostFocus && getLastValidPosition() === -1 && el.inputmask._valueGet && el.inputmask._valueGet() === getBufferTemplate().join("") && el.inputmask._valueSet(""), 
	            opts.removeMaskOnSubmit && (el.inputmask._valueSet(el.inputmask.unmaskedvalue(), !0), 
	            setTimeout(function() {
	                writeBuffer(el, getBuffer());
	            }, 0));
	        }
	        function resetEvent(e) {
	            setTimeout(function() {
	                $el.trigger("setvalue");
	            }, 0);
	        }
	        function mask(elem) {
	            if (el = elem, $el = $(el), opts.showTooltip && (el.title = opts.tooltip || getMaskSet().mask), 
	            ("rtl" === el.dir || opts.rightAlign) && (el.style.textAlign = "right"), ("rtl" === el.dir || opts.numericInput) && (el.dir = "ltr", 
	            el.removeAttribute("dir"), el.inputmask.isRTL = !0, isRTL = !0), EventRuler.off(el), 
	            patchValueProperty(el), isElementTypeSupported(el, opts) && (EventRuler.on(el, "submit", submitEvent), 
	            EventRuler.on(el, "reset", resetEvent), EventRuler.on(el, "mouseenter", mouseenterEvent), 
	            EventRuler.on(el, "blur", blurEvent), EventRuler.on(el, "focus", focusEvent), EventRuler.on(el, "mouseleave", mouseleaveEvent), 
	            EventRuler.on(el, "click", clickEvent), EventRuler.on(el, "dblclick", dblclickEvent), 
	            EventRuler.on(el, "paste", pasteEvent), EventRuler.on(el, "dragdrop", pasteEvent), 
	            EventRuler.on(el, "drop", pasteEvent), EventRuler.on(el, "cut", cutEvent), EventRuler.on(el, "complete", opts.oncomplete), 
	            EventRuler.on(el, "incomplete", opts.onincomplete), EventRuler.on(el, "cleared", opts.oncleared), 
	            opts.inputEventOnly !== !0 && (EventRuler.on(el, "keydown", keydownEvent), EventRuler.on(el, "keypress", keypressEvent)), 
	            EventRuler.on(el, "input", inputFallBackEvent)), EventRuler.on(el, "setvalue", setValueEvent), 
	            getBufferTemplate(), "" !== el.inputmask._valueGet() || opts.clearMaskOnLostFocus === !1 || document.activeElement === el) {
	                var initialValue = $.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(el.inputmask._valueGet(), opts) || el.inputmask._valueGet() : el.inputmask._valueGet();
	                checkVal(el, !0, !1, initialValue.split(""));
	                var buffer = getBuffer().slice();
	                undoValue = buffer.join(""), isComplete(buffer) === !1 && opts.clearIncomplete && resetMaskSet(), 
	                opts.clearMaskOnLostFocus && document.activeElement !== el && (getLastValidPosition() === -1 ? buffer = [] : clearOptionalTail(buffer)), 
	                writeBuffer(el, buffer), document.activeElement === el && caret(el, seekNext(getLastValidPosition()));
	            }
	        }
	        var undoValue, el, $el, maxLength, valueBuffer, isRTL = !1, skipKeyPressEvent = !1, skipInputEvent = !1, ignorable = !1, mouseEnter = !0, EventRuler = {
	            on: function(input, eventName, eventHandler) {
	                var ev = function(e) {
	                    if (void 0 === this.inputmask && "FORM" !== this.nodeName) {
	                        var imOpts = $.data(this, "_inputmask_opts");
	                        imOpts ? new Inputmask(imOpts).mask(this) : EventRuler.off(this);
	                    } else {
	                        if ("setvalue" === e.type || !(this.disabled || this.readOnly && !("keydown" === e.type && e.ctrlKey && 67 === e.keyCode || opts.tabThrough === !1 && e.keyCode === Inputmask.keyCode.TAB))) {
	                            switch (e.type) {
	                              case "input":
	                                if (skipInputEvent === !0) return skipInputEvent = !1, e.preventDefault();
	                                break;
	
	                              case "keydown":
	                                skipKeyPressEvent = !1, skipInputEvent = !1;
	                                break;
	
	                              case "keypress":
	                                if (skipKeyPressEvent === !0) return e.preventDefault();
	                                skipKeyPressEvent = !0;
	                                break;
	
	                              case "click":
	                                if (iemobile) {
	                                    var that = this;
	                                    return setTimeout(function() {
	                                        eventHandler.apply(that, arguments);
	                                    }, 0), !1;
	                                }
	                            }
	                            var returnVal = eventHandler.apply(this, arguments);
	                            return returnVal === !1 && (e.preventDefault(), e.stopPropagation()), returnVal;
	                        }
	                        e.preventDefault();
	                    }
	                };
	                input.inputmask.events[eventName] = input.inputmask.events[eventName] || [], input.inputmask.events[eventName].push(ev), 
	                $.inArray(eventName, [ "submit", "reset" ]) !== -1 ? null != input.form && $(input.form).on(eventName, ev) : $(input).on(eventName, ev);
	            },
	            off: function(input, event) {
	                if (input.inputmask && input.inputmask.events) {
	                    var events;
	                    event ? (events = [], events[event] = input.inputmask.events[event]) : events = input.inputmask.events, 
	                    $.each(events, function(eventName, evArr) {
	                        for (;evArr.length > 0; ) {
	                            var ev = evArr.pop();
	                            $.inArray(eventName, [ "submit", "reset" ]) !== -1 ? null != input.form && $(input.form).off(eventName, ev) : $(input).off(eventName, ev);
	                        }
	                        delete input.inputmask.events[eventName];
	                    });
	                }
	            }
	        };
	        if (void 0 !== actionObj) switch (actionObj.action) {
	          case "isComplete":
	            return el = actionObj.el, isComplete(getBuffer());
	
	          case "unmaskedvalue":
	            return el = actionObj.el, void 0 !== el && void 0 !== el.inputmask ? (maskset = el.inputmask.maskset, 
	            opts = el.inputmask.opts, isRTL = el.inputmask.isRTL) : (valueBuffer = actionObj.value, 
	            opts.numericInput && (isRTL = !0), valueBuffer = ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(valueBuffer, opts) || valueBuffer : valueBuffer).split(""), 
	            checkVal(void 0, !1, !1, isRTL ? valueBuffer.reverse() : valueBuffer), $.isFunction(opts.onBeforeWrite) && opts.onBeforeWrite(void 0, getBuffer(), 0, opts)), 
	            unmaskedvalue(el);
	
	          case "mask":
	            el = actionObj.el, maskset = el.inputmask.maskset, opts = el.inputmask.opts, isRTL = el.inputmask.isRTL, 
	            mask(el);
	            break;
	
	          case "format":
	            return opts.numericInput && (isRTL = !0), valueBuffer = ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(actionObj.value, opts) || actionObj.value : actionObj.value).split(""), 
	            checkVal(void 0, !1, !1, isRTL ? valueBuffer.reverse() : valueBuffer), $.isFunction(opts.onBeforeWrite) && opts.onBeforeWrite(void 0, getBuffer(), 0, opts), 
	            actionObj.metadata ? {
	                value: isRTL ? getBuffer().slice().reverse().join("") : getBuffer().join(""),
	                metadata: maskScope({
	                    action: "getmetadata"
	                }, maskset, opts)
	            } : isRTL ? getBuffer().slice().reverse().join("") : getBuffer().join("");
	
	          case "isValid":
	            opts.numericInput && (isRTL = !0), actionObj.value ? (valueBuffer = actionObj.value.split(""), 
	            checkVal(void 0, !1, !0, isRTL ? valueBuffer.reverse() : valueBuffer)) : actionObj.value = getBuffer().join("");
	            for (var buffer = getBuffer(), rl = determineLastRequiredPosition(), lmib = buffer.length - 1; lmib > rl && !isMask(lmib); lmib--) ;
	            return buffer.splice(rl, lmib + 1 - rl), isComplete(buffer) && actionObj.value === getBuffer().join("");
	
	          case "getemptymask":
	            return getBufferTemplate().join("");
	
	          case "remove":
	            el = actionObj.el, $el = $(el), maskset = el.inputmask.maskset, opts = el.inputmask.opts, 
	            el.inputmask._valueSet(unmaskedvalue(el)), EventRuler.off(el);
	            var valueProperty;
	            Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? (valueProperty = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), "value"), 
	            valueProperty && el.inputmask.__valueGet && Object.defineProperty(el, "value", {
	                get: el.inputmask.__valueGet,
	                set: el.inputmask.__valueSet,
	                configurable: !0
	            })) : document.__lookupGetter__ && el.__lookupGetter__("value") && el.inputmask.__valueGet && (el.__defineGetter__("value", el.inputmask.__valueGet), 
	            el.__defineSetter__("value", el.inputmask.__valueSet)), el.inputmask = void 0;
	            break;
	
	          case "getmetadata":
	            if ($.isArray(maskset.metadata)) {
	                for (var alternation, lvp = getLastValidPosition(void 0, !0), firstAlt = lvp; firstAlt >= 0; firstAlt--) if (getMaskSet().validPositions[firstAlt] && void 0 !== getMaskSet().validPositions[firstAlt].alternation) {
	                    alternation = getMaskSet().validPositions[firstAlt].alternation;
	                    break;
	                }
	                return void 0 !== alternation ? maskset.metadata[getMaskSet().validPositions[firstAlt].locator[alternation]] : [];
	            }
	            return maskset.metadata;
	        }
	    }
	    Inputmask.prototype = {
	        defaults: {
	            placeholder: "_",
	            optionalmarker: {
	                start: "[",
	                end: "]"
	            },
	            quantifiermarker: {
	                start: "{",
	                end: "}"
	            },
	            groupmarker: {
	                start: "(",
	                end: ")"
	            },
	            alternatormarker: "|",
	            escapeChar: "\\",
	            mask: null,
	            oncomplete: $.noop,
	            onincomplete: $.noop,
	            oncleared: $.noop,
	            repeat: 0,
	            greedy: !0,
	            autoUnmask: !1,
	            removeMaskOnSubmit: !1,
	            clearMaskOnLostFocus: !0,
	            insertMode: !0,
	            clearIncomplete: !1,
	            aliases: {},
	            alias: null,
	            onKeyDown: $.noop,
	            onBeforeMask: null,
	            onBeforePaste: function(pastedValue, opts) {
	                return $.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(pastedValue, opts) : pastedValue;
	            },
	            onBeforeWrite: null,
	            onUnMask: null,
	            showMaskOnFocus: !0,
	            showMaskOnHover: !0,
	            onKeyValidation: $.noop,
	            skipOptionalPartCharacter: " ",
	            showTooltip: !1,
	            tooltip: void 0,
	            numericInput: !1,
	            rightAlign: !1,
	            undoOnEscape: !0,
	            radixPoint: "",
	            radixPointDefinitionSymbol: void 0,
	            groupSeparator: "",
	            keepStatic: null,
	            positionCaretOnTab: !0,
	            tabThrough: !1,
	            supportsInputType: [ "text", "tel", "password" ],
	            definitions: {
	                "9": {
	                    validator: "[0-9]",
	                    cardinality: 1,
	                    definitionSymbol: "*"
	                },
	                a: {
	                    validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	                    cardinality: 1,
	                    definitionSymbol: "*"
	                },
	                "*": {
	                    validator: "[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	                    cardinality: 1
	                }
	            },
	            ignorables: [ 8, 9, 13, 19, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123 ],
	            isComplete: null,
	            canClearPosition: $.noop,
	            postValidation: null,
	            staticDefinitionSymbol: void 0,
	            jitMasking: !1,
	            nullable: !0,
	            inputEventOnly: !1,
	            positionCaretOnClick: "lvp",
	            casing: null
	        },
	        masksCache: {},
	        mask: function(elems) {
	            var that = this;
	            return "string" == typeof elems && (elems = document.getElementById(elems) || document.querySelectorAll(elems)), 
	            elems = elems.nodeName ? [ elems ] : elems, $.each(elems, function(ndx, el) {
	                var scopedOpts = $.extend(!0, {}, that.opts);
	                importAttributeOptions(el, scopedOpts, $.extend(!0, {}, that.userOptions));
	                var maskset = generateMaskSet(scopedOpts, that.noMasksCache);
	                void 0 !== maskset && (void 0 !== el.inputmask && el.inputmask.remove(), el.inputmask = new Inputmask(), 
	                el.inputmask.opts = scopedOpts, el.inputmask.noMasksCache = that.noMasksCache, el.inputmask.userOptions = $.extend(!0, {}, that.userOptions), 
	                el.inputmask.el = el, el.inputmask.maskset = maskset, el.inputmask.isRTL = !1, $.data(el, "_inputmask_opts", scopedOpts), 
	                maskScope({
	                    action: "mask",
	                    el: el
	                }));
	            }), elems && elems[0] ? elems[0].inputmask || this : this;
	        },
	        option: function(options, noremask) {
	            return "string" == typeof options ? this.opts[options] : "object" == typeof options ? ($.extend(this.userOptions, options), 
	            this.el && noremask !== !0 && this.mask(this.el), this) : void 0;
	        },
	        unmaskedvalue: function(value) {
	            return maskScope({
	                action: "unmaskedvalue",
	                el: this.el,
	                value: value
	            }, this.el && this.el.inputmask ? this.el.inputmask.maskset : generateMaskSet(this.opts, this.noMasksCache), this.opts);
	        },
	        remove: function() {
	            if (this.el) return maskScope({
	                action: "remove",
	                el: this.el
	            }), this.el.inputmask = void 0, this.el;
	        },
	        getemptymask: function() {
	            return maskScope({
	                action: "getemptymask"
	            }, this.maskset || generateMaskSet(this.opts, this.noMasksCache), this.opts);
	        },
	        hasMaskedValue: function() {
	            return !this.opts.autoUnmask;
	        },
	        isComplete: function() {
	            return maskScope({
	                action: "isComplete",
	                el: this.el
	            }, this.maskset || generateMaskSet(this.opts, this.noMasksCache), this.opts);
	        },
	        getmetadata: function() {
	            return maskScope({
	                action: "getmetadata"
	            }, this.maskset || generateMaskSet(this.opts, this.noMasksCache), this.opts);
	        },
	        isValid: function(value) {
	            return maskScope({
	                action: "isValid",
	                value: value
	            }, this.maskset || generateMaskSet(this.opts, this.noMasksCache), this.opts);
	        },
	        format: function(value, metadata) {
	            return maskScope({
	                action: "format",
	                value: value,
	                metadata: metadata
	            }, this.maskset || generateMaskSet(this.opts, this.noMasksCache), this.opts);
	        }
	    }, Inputmask.extendDefaults = function(options) {
	        $.extend(!0, Inputmask.prototype.defaults, options);
	    }, Inputmask.extendDefinitions = function(definition) {
	        $.extend(!0, Inputmask.prototype.defaults.definitions, definition);
	    }, Inputmask.extendAliases = function(alias) {
	        $.extend(!0, Inputmask.prototype.defaults.aliases, alias);
	    }, Inputmask.format = function(value, options, metadata) {
	        return Inputmask(options).format(value, metadata);
	    }, Inputmask.unmask = function(value, options) {
	        return Inputmask(options).unmaskedvalue(value);
	    }, Inputmask.isValid = function(value, options) {
	        return Inputmask(options).isValid(value);
	    }, Inputmask.remove = function(elems) {
	        $.each(elems, function(ndx, el) {
	            el.inputmask && el.inputmask.remove();
	        });
	    }, Inputmask.escapeRegex = function(str) {
	        var specials = [ "/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^" ];
	        return str.replace(new RegExp("(\\" + specials.join("|\\") + ")", "gim"), "\\$1");
	    }, Inputmask.keyCode = {
	        ALT: 18,
	        BACKSPACE: 8,
	        BACKSPACE_SAFARI: 127,
	        CAPS_LOCK: 20,
	        COMMA: 188,
	        COMMAND: 91,
	        COMMAND_LEFT: 91,
	        COMMAND_RIGHT: 93,
	        CONTROL: 17,
	        DELETE: 46,
	        DOWN: 40,
	        END: 35,
	        ENTER: 13,
	        ESCAPE: 27,
	        HOME: 36,
	        INSERT: 45,
	        LEFT: 37,
	        MENU: 93,
	        NUMPAD_ADD: 107,
	        NUMPAD_DECIMAL: 110,
	        NUMPAD_DIVIDE: 111,
	        NUMPAD_ENTER: 108,
	        NUMPAD_MULTIPLY: 106,
	        NUMPAD_SUBTRACT: 109,
	        PAGE_DOWN: 34,
	        PAGE_UP: 33,
	        PERIOD: 190,
	        RIGHT: 39,
	        SHIFT: 16,
	        SPACE: 32,
	        TAB: 9,
	        UP: 38,
	        WINDOWS: 91,
	        X: 88
	    };
	    var ua = navigator.userAgent, mobile = /mobile/i.test(ua), iemobile = /iemobile/i.test(ua), iphone = /iphone/i.test(ua) && !iemobile;
	    return window.Inputmask = Inputmask, Inputmask;
	}(jQuery), function($, Inputmask) {
	    return void 0 === $.fn.inputmask && ($.fn.inputmask = function(fn, options) {
	        var nptmask, input = this[0];
	        if (void 0 === options && (options = {}), "string" == typeof fn) switch (fn) {
	          case "unmaskedvalue":
	            return input && input.inputmask ? input.inputmask.unmaskedvalue() : $(input).val();
	
	          case "remove":
	            return this.each(function() {
	                this.inputmask && this.inputmask.remove();
	            });
	
	          case "getemptymask":
	            return input && input.inputmask ? input.inputmask.getemptymask() : "";
	
	          case "hasMaskedValue":
	            return !(!input || !input.inputmask) && input.inputmask.hasMaskedValue();
	
	          case "isComplete":
	            return !input || !input.inputmask || input.inputmask.isComplete();
	
	          case "getmetadata":
	            return input && input.inputmask ? input.inputmask.getmetadata() : void 0;
	
	          case "setvalue":
	            $(input).val(options), input && void 0 === input.inputmask && $(input).triggerHandler("setvalue");
	            break;
	
	          case "option":
	            if ("string" != typeof options) return this.each(function() {
	                if (void 0 !== this.inputmask) return this.inputmask.option(options);
	            });
	            if (input && void 0 !== input.inputmask) return input.inputmask.option(options);
	            break;
	
	          default:
	            return options.alias = fn, nptmask = new Inputmask(options), this.each(function() {
	                nptmask.mask(this);
	            });
	        } else {
	            if ("object" == typeof fn) return nptmask = new Inputmask(fn), void 0 === fn.mask && void 0 === fn.alias ? this.each(function() {
	                return void 0 !== this.inputmask ? this.inputmask.option(fn) : void nptmask.mask(this);
	            }) : this.each(function() {
	                nptmask.mask(this);
	            });
	            if (void 0 === fn) return this.each(function() {
	                nptmask = new Inputmask(options), nptmask.mask(this);
	            });
	        }
	    }), $.fn.inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendDefinitions({
	        h: {
	            validator: "[01][0-9]|2[0-3]",
	            cardinality: 2,
	            prevalidator: [ {
	                validator: "[0-2]",
	                cardinality: 1
	            } ]
	        },
	        s: {
	            validator: "[0-5][0-9]",
	            cardinality: 2,
	            prevalidator: [ {
	                validator: "[0-5]",
	                cardinality: 1
	            } ]
	        },
	        d: {
	            validator: "0[1-9]|[12][0-9]|3[01]",
	            cardinality: 2,
	            prevalidator: [ {
	                validator: "[0-3]",
	                cardinality: 1
	            } ]
	        },
	        m: {
	            validator: "0[1-9]|1[012]",
	            cardinality: 2,
	            prevalidator: [ {
	                validator: "[01]",
	                cardinality: 1
	            } ]
	        },
	        y: {
	            validator: "(19|20)\\d{2}",
	            cardinality: 4,
	            prevalidator: [ {
	                validator: "[12]",
	                cardinality: 1
	            }, {
	                validator: "(19|20)",
	                cardinality: 2
	            }, {
	                validator: "(19|20)\\d",
	                cardinality: 3
	            } ]
	        }
	    }), Inputmask.extendAliases({
	        "dd/mm/yyyy": {
	            mask: "1/2/y",
	            placeholder: "dd/mm/yyyy",
	            regex: {
	                val1pre: new RegExp("[0-3]"),
	                val1: new RegExp("0[1-9]|[12][0-9]|3[01]"),
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|[12][0-9]|3[01])" + escapedSeparator + "[01])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|[12][0-9])" + escapedSeparator + "(0[1-9]|1[012]))|(30" + escapedSeparator + "(0[13-9]|1[012]))|(31" + escapedSeparator + "(0[13578]|1[02]))");
	                }
	            },
	            leapday: "29/02/",
	            separator: "/",
	            yearrange: {
	                minyear: 1900,
	                maxyear: 2099
	            },
	            isInYearRange: function(chrs, minyear, maxyear) {
	                if (isNaN(chrs)) return !1;
	                var enteredyear = parseInt(chrs.concat(minyear.toString().slice(chrs.length))), enteredyear2 = parseInt(chrs.concat(maxyear.toString().slice(chrs.length)));
	                return !isNaN(enteredyear) && (minyear <= enteredyear && enteredyear <= maxyear) || !isNaN(enteredyear2) && (minyear <= enteredyear2 && enteredyear2 <= maxyear);
	            },
	            determinebaseyear: function(minyear, maxyear, hint) {
	                var currentyear = new Date().getFullYear();
	                if (minyear > currentyear) return minyear;
	                if (maxyear < currentyear) {
	                    for (var maxYearPrefix = maxyear.toString().slice(0, 2), maxYearPostfix = maxyear.toString().slice(2, 4); maxyear < maxYearPrefix + hint; ) maxYearPrefix--;
	                    var maxxYear = maxYearPrefix + maxYearPostfix;
	                    return minyear > maxxYear ? minyear : maxxYear;
	                }
	                if (minyear <= currentyear && currentyear <= maxyear) {
	                    for (var currentYearPrefix = currentyear.toString().slice(0, 2); maxyear < currentYearPrefix + hint; ) currentYearPrefix--;
	                    var currentYearAndHint = currentYearPrefix + hint;
	                    return currentYearAndHint < minyear ? minyear : currentYearAndHint;
	                }
	                return currentyear;
	            },
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val(today.getDate().toString() + (today.getMonth() + 1).toString() + today.getFullYear().toString()), 
	                    $input.trigger("setvalue");
	                }
	            },
	            getFrontValue: function(mask, buffer, opts) {
	                for (var start = 0, length = 0, i = 0; i < mask.length && "2" !== mask.charAt(i); i++) {
	                    var definition = opts.definitions[mask.charAt(i)];
	                    definition ? (start += length, length = definition.cardinality) : length++;
	                }
	                return buffer.join("").substr(start, length);
	            },
	            definitions: {
	                "1": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.regex.val1.test(chrs);
	                        return strict || isValid || chrs.charAt(1) !== opts.separator && "-./".indexOf(chrs.charAt(1)) === -1 || !(isValid = opts.regex.val1.test("0" + chrs.charAt(0))) ? isValid : (maskset.buffer[pos - 1] = "0", 
	                        {
	                            refreshFromBuffer: {
	                                start: pos - 1,
	                                end: pos
	                            },
	                            pos: pos,
	                            c: chrs.charAt(0)
	                        });
	                    },
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var pchrs = chrs;
	                            isNaN(maskset.buffer[pos + 1]) || (pchrs += maskset.buffer[pos + 1]);
	                            var isValid = 1 === pchrs.length ? opts.regex.val1pre.test(pchrs) : opts.regex.val1.test(pchrs);
	                            if (!strict && !isValid) {
	                                if (isValid = opts.regex.val1.test(chrs + "0")) return maskset.buffer[pos] = chrs, 
	                                maskset.buffer[++pos] = "0", {
	                                    pos: pos,
	                                    c: "0"
	                                };
	                                if (isValid = opts.regex.val1.test("0" + chrs)) return maskset.buffer[pos] = "0", 
	                                pos++, {
	                                    pos: pos
	                                };
	                            }
	                            return isValid;
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                "2": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var frontValue = opts.getFrontValue(maskset.mask, maskset.buffer, opts);
	                        frontValue.indexOf(opts.placeholder[0]) !== -1 && (frontValue = "01" + opts.separator);
	                        var isValid = opts.regex.val2(opts.separator).test(frontValue + chrs);
	                        if (!strict && !isValid && (chrs.charAt(1) === opts.separator || "-./".indexOf(chrs.charAt(1)) !== -1) && (isValid = opts.regex.val2(opts.separator).test(frontValue + "0" + chrs.charAt(0)))) return maskset.buffer[pos - 1] = "0", 
	                        {
	                            refreshFromBuffer: {
	                                start: pos - 1,
	                                end: pos
	                            },
	                            pos: pos,
	                            c: chrs.charAt(0)
	                        };
	                        if (opts.mask.indexOf("2") === opts.mask.length - 1 && isValid) {
	                            var dayMonthValue = maskset.buffer.join("").substr(4, 4) + chrs;
	                            if (dayMonthValue !== opts.leapday) return !0;
	                            var year = parseInt(maskset.buffer.join("").substr(0, 4), 10);
	                            return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	                        }
	                        return isValid;
	                    },
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            isNaN(maskset.buffer[pos + 1]) || (chrs += maskset.buffer[pos + 1]);
	                            var frontValue = opts.getFrontValue(maskset.mask, maskset.buffer, opts);
	                            frontValue.indexOf(opts.placeholder[0]) !== -1 && (frontValue = "01" + opts.separator);
	                            var isValid = 1 === chrs.length ? opts.regex.val2pre(opts.separator).test(frontValue + chrs) : opts.regex.val2(opts.separator).test(frontValue + chrs);
	                            return strict || isValid || !(isValid = opts.regex.val2(opts.separator).test(frontValue + "0" + chrs)) ? isValid : (maskset.buffer[pos] = "0", 
	                            pos++, {
	                                pos: pos
	                            });
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                y: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        if (opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) {
	                            var dayMonthValue = maskset.buffer.join("").substr(0, 6);
	                            if (dayMonthValue !== opts.leapday) return !0;
	                            var year = parseInt(chrs, 10);
	                            return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	                        }
	                        return !1;
	                    },
	                    cardinality: 4,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                            if (!strict && !isValid) {
	                                var yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs + "0").toString().slice(0, 1);
	                                if (isValid = opts.isInYearRange(yearPrefix + chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos++] = yearPrefix.charAt(0), 
	                                {
	                                    pos: pos
	                                };
	                                if (yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs + "0").toString().slice(0, 2), 
	                                isValid = opts.isInYearRange(yearPrefix + chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos++] = yearPrefix.charAt(0), 
	                                maskset.buffer[pos++] = yearPrefix.charAt(1), {
	                                    pos: pos
	                                };
	                            }
	                            return isValid;
	                        },
	                        cardinality: 1
	                    }, {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                            if (!strict && !isValid) {
	                                var yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs).toString().slice(0, 2);
	                                if (isValid = opts.isInYearRange(chrs[0] + yearPrefix[1] + chrs[1], opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos++] = yearPrefix.charAt(1), 
	                                {
	                                    pos: pos
	                                };
	                                if (yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs).toString().slice(0, 2), 
	                                opts.isInYearRange(yearPrefix + chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) {
	                                    var dayMonthValue = maskset.buffer.join("").substr(0, 6);
	                                    if (dayMonthValue !== opts.leapday) isValid = !0; else {
	                                        var year = parseInt(chrs, 10);
	                                        isValid = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	                                    }
	                                } else isValid = !1;
	                                if (isValid) return maskset.buffer[pos - 1] = yearPrefix.charAt(0), maskset.buffer[pos++] = yearPrefix.charAt(1), 
	                                maskset.buffer[pos++] = chrs.charAt(0), {
	                                    refreshFromBuffer: {
	                                        start: pos - 3,
	                                        end: pos
	                                    },
	                                    pos: pos
	                                };
	                            }
	                            return isValid;
	                        },
	                        cardinality: 2
	                    }, {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            return opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                        },
	                        cardinality: 3
	                    } ]
	                }
	            },
	            insertMode: !1,
	            autoUnmask: !1
	        },
	        "mm/dd/yyyy": {
	            placeholder: "mm/dd/yyyy",
	            alias: "dd/mm/yyyy",
	            regex: {
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[13-9]|1[012])" + escapedSeparator + "[0-3])|(02" + escapedSeparator + "[0-2])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + escapedSeparator + "30)|((0[13578]|1[02])" + escapedSeparator + "31)");
	                },
	                val1pre: new RegExp("[01]"),
	                val1: new RegExp("0[1-9]|1[012]")
	            },
	            leapday: "02/29/",
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val((today.getMonth() + 1).toString() + today.getDate().toString() + today.getFullYear().toString()), 
	                    $input.trigger("setvalue");
	                }
	            }
	        },
	        "yyyy/mm/dd": {
	            mask: "y/1/2",
	            placeholder: "yyyy/mm/dd",
	            alias: "mm/dd/yyyy",
	            leapday: "/02/29",
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val(today.getFullYear().toString() + (today.getMonth() + 1).toString() + today.getDate().toString()), 
	                    $input.trigger("setvalue");
	                }
	            }
	        },
	        "dd.mm.yyyy": {
	            mask: "1.2.y",
	            placeholder: "dd.mm.yyyy",
	            leapday: "29.02.",
	            separator: ".",
	            alias: "dd/mm/yyyy"
	        },
	        "dd-mm-yyyy": {
	            mask: "1-2-y",
	            placeholder: "dd-mm-yyyy",
	            leapday: "29-02-",
	            separator: "-",
	            alias: "dd/mm/yyyy"
	        },
	        "mm.dd.yyyy": {
	            mask: "1.2.y",
	            placeholder: "mm.dd.yyyy",
	            leapday: "02.29.",
	            separator: ".",
	            alias: "mm/dd/yyyy"
	        },
	        "mm-dd-yyyy": {
	            mask: "1-2-y",
	            placeholder: "mm-dd-yyyy",
	            leapday: "02-29-",
	            separator: "-",
	            alias: "mm/dd/yyyy"
	        },
	        "yyyy.mm.dd": {
	            mask: "y.1.2",
	            placeholder: "yyyy.mm.dd",
	            leapday: ".02.29",
	            separator: ".",
	            alias: "yyyy/mm/dd"
	        },
	        "yyyy-mm-dd": {
	            mask: "y-1-2",
	            placeholder: "yyyy-mm-dd",
	            leapday: "-02-29",
	            separator: "-",
	            alias: "yyyy/mm/dd"
	        },
	        datetime: {
	            mask: "1/2/y h:s",
	            placeholder: "dd/mm/yyyy hh:mm",
	            alias: "dd/mm/yyyy",
	            regex: {
	                hrspre: new RegExp("[012]"),
	                hrs24: new RegExp("2[0-4]|1[3-9]"),
	                hrs: new RegExp("[01][0-9]|2[0-4]"),
	                ampm: new RegExp("^[a|p|A|P][m|M]"),
	                mspre: new RegExp("[0-5]"),
	                ms: new RegExp("[0-5][0-9]")
	            },
	            timeseparator: ":",
	            hourFormat: "24",
	            definitions: {
	                h: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        if ("24" === opts.hourFormat && 24 === parseInt(chrs, 10)) return maskset.buffer[pos - 1] = "0", 
	                        maskset.buffer[pos] = "0", {
	                            refreshFromBuffer: {
	                                start: pos - 1,
	                                end: pos
	                            },
	                            c: "0"
	                        };
	                        var isValid = opts.regex.hrs.test(chrs);
	                        if (!strict && !isValid && (chrs.charAt(1) === opts.timeseparator || "-.:".indexOf(chrs.charAt(1)) !== -1) && (isValid = opts.regex.hrs.test("0" + chrs.charAt(0)))) return maskset.buffer[pos - 1] = "0", 
	                        maskset.buffer[pos] = chrs.charAt(0), pos++, {
	                            refreshFromBuffer: {
	                                start: pos - 2,
	                                end: pos
	                            },
	                            pos: pos,
	                            c: opts.timeseparator
	                        };
	                        if (isValid && "24" !== opts.hourFormat && opts.regex.hrs24.test(chrs)) {
	                            var tmp = parseInt(chrs, 10);
	                            return 24 === tmp ? (maskset.buffer[pos + 5] = "a", maskset.buffer[pos + 6] = "m") : (maskset.buffer[pos + 5] = "p", 
	                            maskset.buffer[pos + 6] = "m"), tmp -= 12, tmp < 10 ? (maskset.buffer[pos] = tmp.toString(), 
	                            maskset.buffer[pos - 1] = "0") : (maskset.buffer[pos] = tmp.toString().charAt(1), 
	                            maskset.buffer[pos - 1] = tmp.toString().charAt(0)), {
	                                refreshFromBuffer: {
	                                    start: pos - 1,
	                                    end: pos + 6
	                                },
	                                c: maskset.buffer[pos]
	                            };
	                        }
	                        return isValid;
	                    },
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.regex.hrspre.test(chrs);
	                            return strict || isValid || !(isValid = opts.regex.hrs.test("0" + chrs)) ? isValid : (maskset.buffer[pos] = "0", 
	                            pos++, {
	                                pos: pos
	                            });
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                s: {
	                    validator: "[0-5][0-9]",
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.regex.mspre.test(chrs);
	                            return strict || isValid || !(isValid = opts.regex.ms.test("0" + chrs)) ? isValid : (maskset.buffer[pos] = "0", 
	                            pos++, {
	                                pos: pos
	                            });
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                t: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return opts.regex.ampm.test(chrs + "m");
	                    },
	                    casing: "lower",
	                    cardinality: 1
	                }
	            },
	            insertMode: !1,
	            autoUnmask: !1
	        },
	        datetime12: {
	            mask: "1/2/y h:s t\\m",
	            placeholder: "dd/mm/yyyy hh:mm xm",
	            alias: "datetime",
	            hourFormat: "12"
	        },
	        "mm/dd/yyyy hh:mm xm": {
	            mask: "1/2/y h:s t\\m",
	            placeholder: "mm/dd/yyyy hh:mm xm",
	            alias: "datetime12",
	            regex: {
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[13-9]|1[012])" + escapedSeparator + "[0-3])|(02" + escapedSeparator + "[0-2])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + escapedSeparator + "30)|((0[13578]|1[02])" + escapedSeparator + "31)");
	                },
	                val1pre: new RegExp("[01]"),
	                val1: new RegExp("0[1-9]|1[012]")
	            },
	            leapday: "02/29/",
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val((today.getMonth() + 1).toString() + today.getDate().toString() + today.getFullYear().toString()), 
	                    $input.trigger("setvalue");
	                }
	            }
	        },
	        "hh:mm t": {
	            mask: "h:s t\\m",
	            placeholder: "hh:mm xm",
	            alias: "datetime",
	            hourFormat: "12"
	        },
	        "h:s t": {
	            mask: "h:s t\\m",
	            placeholder: "hh:mm xm",
	            alias: "datetime",
	            hourFormat: "12"
	        },
	        "hh:mm:ss": {
	            mask: "h:s:s",
	            placeholder: "hh:mm:ss",
	            alias: "datetime",
	            autoUnmask: !1
	        },
	        "hh:mm": {
	            mask: "h:s",
	            placeholder: "hh:mm",
	            alias: "datetime",
	            autoUnmask: !1
	        },
	        date: {
	            alias: "dd/mm/yyyy"
	        },
	        "mm/yyyy": {
	            mask: "1/y",
	            placeholder: "mm/yyyy",
	            leapday: "donotuse",
	            separator: "/",
	            alias: "mm/dd/yyyy"
	        },
	        shamsi: {
	            regex: {
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "[0-3])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "(0[1-9]|[12][0-9]))|((0[1-9]|1[012])" + escapedSeparator + "30)|((0[1-6])" + escapedSeparator + "31)");
	                },
	                val1pre: new RegExp("[01]"),
	                val1: new RegExp("0[1-9]|1[012]")
	            },
	            yearrange: {
	                minyear: 1300,
	                maxyear: 1499
	            },
	            mask: "y/1/2",
	            leapday: "/12/30",
	            placeholder: "yyyy/mm/dd",
	            alias: "mm/dd/yyyy",
	            clearIncomplete: !0
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendDefinitions({
	        A: {
	            validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	            cardinality: 1,
	            casing: "upper"
	        },
	        "&": {
	            validator: "[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	            cardinality: 1,
	            casing: "upper"
	        },
	        "#": {
	            validator: "[0-9A-Fa-f]",
	            cardinality: 1,
	            casing: "upper"
	        }
	    }), Inputmask.extendAliases({
	        url: {
	            definitions: {
	                i: {
	                    validator: ".",
	                    cardinality: 1
	                }
	            },
	            mask: "(\\http://)|(\\http\\s://)|(ftp://)|(ftp\\s://)i{+}",
	            insertMode: !1,
	            autoUnmask: !1
	        },
	        ip: {
	            mask: "i[i[i]].i[i[i]].i[i[i]].i[i[i]]",
	            definitions: {
	                i: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return pos - 1 > -1 && "." !== maskset.buffer[pos - 1] ? (chrs = maskset.buffer[pos - 1] + chrs, 
	                        chrs = pos - 2 > -1 && "." !== maskset.buffer[pos - 2] ? maskset.buffer[pos - 2] + chrs : "0" + chrs) : chrs = "00" + chrs, 
	                        new RegExp("25[0-5]|2[0-4][0-9]|[01][0-9][0-9]").test(chrs);
	                    },
	                    cardinality: 1
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                return maskedValue;
	            }
	        },
	        email: {
	            mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]",
	            greedy: !1,
	            onBeforePaste: function(pastedValue, opts) {
	                return pastedValue = pastedValue.toLowerCase(), pastedValue.replace("mailto:", "");
	            },
	            definitions: {
	                "*": {
	                    validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]",
	                    cardinality: 1,
	                    casing: "lower"
	                },
	                "-": {
	                    validator: "[0-9A-Za-z-]",
	                    cardinality: 1,
	                    casing: "lower"
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                return maskedValue;
	            }
	        },
	        mac: {
	            mask: "##:##:##:##:##:##"
	        },
	        vin: {
	            mask: "V{13}9{4}",
	            definitions: {
	                V: {
	                    validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
	                    cardinality: 1,
	                    casing: "upper"
	                }
	            },
	            clearIncomplete: !0,
	            autoUnmask: !0
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendAliases({
	        numeric: {
	            mask: function(opts) {
	                function autoEscape(txt) {
	                    for (var escapedTxt = "", i = 0; i < txt.length; i++) escapedTxt += opts.definitions[txt.charAt(i)] || opts.optionalmarker.start === txt.charAt(i) || opts.optionalmarker.end === txt.charAt(i) || opts.quantifiermarker.start === txt.charAt(i) || opts.quantifiermarker.end === txt.charAt(i) || opts.groupmarker.start === txt.charAt(i) || opts.groupmarker.end === txt.charAt(i) || opts.alternatormarker === txt.charAt(i) ? "\\" + txt.charAt(i) : txt.charAt(i);
	                    return escapedTxt;
	                }
	                if (0 !== opts.repeat && isNaN(opts.integerDigits) && (opts.integerDigits = opts.repeat), 
	                opts.repeat = 0, opts.groupSeparator === opts.radixPoint && ("." === opts.radixPoint ? opts.groupSeparator = "," : "," === opts.radixPoint ? opts.groupSeparator = "." : opts.groupSeparator = ""), 
	                " " === opts.groupSeparator && (opts.skipOptionalPartCharacter = void 0), opts.autoGroup = opts.autoGroup && "" !== opts.groupSeparator, 
	                opts.autoGroup && ("string" == typeof opts.groupSize && isFinite(opts.groupSize) && (opts.groupSize = parseInt(opts.groupSize)), 
	                isFinite(opts.integerDigits))) {
	                    var seps = Math.floor(opts.integerDigits / opts.groupSize), mod = opts.integerDigits % opts.groupSize;
	                    opts.integerDigits = parseInt(opts.integerDigits) + (0 === mod ? seps - 1 : seps), 
	                    opts.integerDigits < 1 && (opts.integerDigits = "*");
	                }
	                opts.placeholder.length > 1 && (opts.placeholder = opts.placeholder.charAt(0)), 
	                "radixFocus" === opts.positionCaretOnClick && "" === opts.placeholder && opts.integerOptional === !1 && (opts.positionCaretOnClick = "lvp"), 
	                opts.definitions[";"] = opts.definitions["~"], opts.definitions[";"].definitionSymbol = "~", 
	                opts.numericInput === !0 && (opts.positionCaretOnClick = "radixFocus" === opts.positionCaretOnClick ? "lvp" : opts.positionCaretOnClick, 
	                opts.digitsOptional = !1, isNaN(opts.digits) && (opts.digits = 2), opts.decimalProtect = !1);
	                var mask = autoEscape(opts.prefix);
	                if (mask += "[+]", mask += opts.integerOptional === !0 ? "~{1," + opts.integerDigits + "}" : "~{" + opts.integerDigits + "}", 
	                void 0 !== opts.digits) {
	                    opts.decimalProtect && (opts.radixPointDefinitionSymbol = ":");
	                    var dq = opts.digits.toString().split(",");
	                    isFinite(dq[0] && dq[1] && isFinite(dq[1])) ? mask += (opts.decimalProtect ? ":" : opts.radixPoint) + ";{" + opts.digits + "}" : (isNaN(opts.digits) || parseInt(opts.digits) > 0) && (mask += opts.digitsOptional ? "[" + (opts.decimalProtect ? ":" : opts.radixPoint) + ";{1," + opts.digits + "}]" : (opts.decimalProtect ? ":" : opts.radixPoint) + ";{" + opts.digits + "}");
	                }
	                return mask += "[-]", mask += autoEscape(opts.suffix), opts.greedy = !1, null !== opts.min && (opts.min = opts.min.toString().replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (opts.min = opts.min.replace(opts.radixPoint, "."))), 
	                null !== opts.max && (opts.max = opts.max.toString().replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (opts.max = opts.max.replace(opts.radixPoint, "."))), 
	                mask;
	            },
	            placeholder: "",
	            greedy: !1,
	            digits: "*",
	            digitsOptional: !0,
	            radixPoint: ".",
	            positionCaretOnClick: "radixFocus",
	            groupSize: 3,
	            groupSeparator: "",
	            autoGroup: !1,
	            allowPlus: !0,
	            allowMinus: !0,
	            negationSymbol: {
	                front: "-",
	                back: ""
	            },
	            integerDigits: "+",
	            integerOptional: !0,
	            prefix: "",
	            suffix: "",
	            rightAlign: !0,
	            decimalProtect: !0,
	            min: null,
	            max: null,
	            step: 1,
	            insertMode: !0,
	            autoUnmask: !1,
	            unmaskAsNumber: !1,
	            postFormat: function(buffer, pos, opts) {
	                opts.numericInput === !0 && (buffer = buffer.reverse(), isFinite(pos) && (pos = buffer.join("").length - pos - 1));
	                var i, l;
	                pos = pos >= buffer.length ? buffer.length - 1 : pos < opts.prefix.length ? opts.prefix.length : pos;
	                var charAtPos = buffer[pos], cbuf = buffer.slice();
	                charAtPos === opts.groupSeparator && (cbuf.splice(pos--, 1), charAtPos = cbuf[pos]), 
	                cbuf[pos] = "!";
	                var bufVal = cbuf.join(""), bufValOrigin = bufVal;
	                if (bufVal = bufVal.replace(new RegExp(Inputmask.escapeRegex(opts.suffix) + "$"), ""), 
	                bufVal = bufVal.replace(new RegExp("^" + Inputmask.escapeRegex(opts.prefix)), ""), 
	                bufVal.length > 0 && opts.autoGroup || bufVal.indexOf(opts.groupSeparator) !== -1) {
	                    var escapedGroupSeparator = Inputmask.escapeRegex(opts.groupSeparator);
	                    bufVal = bufVal.replace(new RegExp(escapedGroupSeparator, "g"), "");
	                    var radixSplit = bufVal.split(charAtPos === opts.radixPoint ? "!" : opts.radixPoint);
	                    if (bufVal = "" === opts.radixPoint ? bufVal : radixSplit[0], charAtPos !== opts.negationSymbol.front && (bufVal = bufVal.replace("!", "?")), 
	                    bufVal.length > opts.groupSize) for (var reg = new RegExp("([-+]?[\\d?]+)([\\d?]{" + opts.groupSize + "})"); reg.test(bufVal) && "" !== opts.groupSeparator; ) bufVal = bufVal.replace(reg, "$1" + opts.groupSeparator + "$2"), 
	                    bufVal = bufVal.replace(opts.groupSeparator + opts.groupSeparator, opts.groupSeparator);
	                    bufVal = bufVal.replace("?", "!"), "" !== opts.radixPoint && radixSplit.length > 1 && (bufVal += (charAtPos === opts.radixPoint ? "!" : opts.radixPoint) + radixSplit[1]);
	                }
	                bufVal = opts.prefix + bufVal + opts.suffix;
	                var needsRefresh = bufValOrigin !== bufVal;
	                if (needsRefresh) for (buffer.length = bufVal.length, i = 0, l = bufVal.length; i < l; i++) buffer[i] = bufVal.charAt(i);
	                var newPos = $.inArray("!", bufVal);
	                return buffer[newPos] = charAtPos, newPos = opts.numericInput && isFinite(pos) ? buffer.join("").length - newPos - 1 : newPos, 
	                opts.numericInput && (buffer = buffer.reverse(), $.inArray(opts.radixPoint, buffer) < newPos && buffer.join("").length - opts.suffix.length !== newPos && (newPos -= 1)), 
	                {
	                    pos: newPos,
	                    refreshFromBuffer: needsRefresh,
	                    buffer: buffer
	                };
	            },
	            onBeforeWrite: function(e, buffer, caretPos, opts) {
	                var rslt;
	                if (e && ("blur" === e.type || "checkval" === e.type || "keydown" === e.type)) {
	                    var maskedValue = opts.numericInput ? buffer.slice().reverse().join("") : buffer.join(""), processValue = maskedValue.replace(opts.prefix, "");
	                    processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                    "," === opts.radixPoint && (processValue = processValue.replace(opts.radixPoint, "."));
	                    var isNegative = processValue.match(new RegExp("[-" + Inputmask.escapeRegex(opts.negationSymbol.front) + "]", "g"));
	                    if (isNegative = null !== isNegative && 1 === isNegative.length, processValue = processValue.replace(new RegExp("[-" + Inputmask.escapeRegex(opts.negationSymbol.front) + "]", "g"), ""), 
	                    processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.negationSymbol.back) + "$"), ""), 
	                    isNaN(opts.placeholder) && (processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.placeholder), "g"), "")), 
	                    processValue = processValue === opts.negationSymbol.front ? processValue + "0" : processValue, 
	                    "" !== processValue && isFinite(processValue)) {
	                        var floatValue = parseFloat(processValue), signedFloatValue = isNegative ? floatValue * -1 : floatValue;
	                        if (null !== opts.min && isFinite(opts.min) && signedFloatValue < parseFloat(opts.min) ? (floatValue = Math.abs(opts.min), 
	                        isNegative = opts.min < 0, maskedValue = void 0) : null !== opts.max && isFinite(opts.max) && signedFloatValue > parseFloat(opts.max) && (floatValue = Math.abs(opts.max), 
	                        isNegative = opts.max < 0, maskedValue = void 0), processValue = floatValue.toString().replace(".", opts.radixPoint).split(""), 
	                        isFinite(opts.digits)) {
	                            var radixPosition = $.inArray(opts.radixPoint, processValue), rpb = $.inArray(opts.radixPoint, maskedValue);
	                            radixPosition === -1 && (processValue.push(opts.radixPoint), radixPosition = processValue.length - 1);
	                            for (var i = 1; i <= opts.digits; i++) opts.digitsOptional || void 0 !== processValue[radixPosition + i] && processValue[radixPosition + i] !== opts.placeholder.charAt(0) ? rpb !== -1 && void 0 !== maskedValue[rpb + i] && (processValue[radixPosition + i] = processValue[radixPosition + i] || maskedValue[rpb + i]) : processValue[radixPosition + i] = "0";
	                            processValue[processValue.length - 1] === opts.radixPoint && delete processValue[processValue.length - 1];
	                        }
	                        if (floatValue.toString() !== processValue && floatValue.toString() + "." !== processValue || isNegative) return !isNegative || 0 === floatValue && "blur" === e.type || (processValue.unshift(opts.negationSymbol.front), 
	                        processValue.push(opts.negationSymbol.back)), processValue = (opts.prefix + processValue.join("")).split(""), 
	                        opts.numericInput && (processValue = processValue.reverse()), rslt = opts.postFormat(processValue, opts.numericInput ? caretPos : caretPos - 1, opts), 
	                        rslt.buffer && (rslt.refreshFromBuffer = rslt.buffer.join("") !== buffer.join("")), 
	                        rslt;
	                    }
	                }
	                if (opts.autoGroup) return rslt = opts.postFormat(buffer, opts.numericInput ? caretPos : caretPos - 1, opts), 
	                rslt.caret = caretPos <= opts.prefix.length ? rslt.pos : rslt.pos + 1, rslt;
	            },
	            regex: {
	                integerPart: function(opts) {
	                    return new RegExp("[" + Inputmask.escapeRegex(opts.negationSymbol.front) + "+]?\\d+");
	                },
	                integerNPart: function(opts) {
	                    return new RegExp("[\\d" + Inputmask.escapeRegex(opts.groupSeparator) + Inputmask.escapeRegex(opts.placeholder.charAt(0)) + "]+");
	                }
	            },
	            signHandler: function(chrs, maskset, pos, strict, opts) {
	                if (!strict && opts.allowMinus && "-" === chrs || opts.allowPlus && "+" === chrs) {
	                    var matchRslt = maskset.buffer.join("").match(opts.regex.integerPart(opts));
	                    if (matchRslt && matchRslt[0].length > 0) return maskset.buffer[matchRslt.index] === ("-" === chrs ? "+" : opts.negationSymbol.front) ? "-" === chrs ? "" !== opts.negationSymbol.back ? {
	                        pos: matchRslt.index,
	                        c: opts.negationSymbol.front,
	                        remove: matchRslt.index,
	                        caret: pos,
	                        insert: {
	                            pos: maskset.buffer.length - opts.suffix.length - 1,
	                            c: opts.negationSymbol.back
	                        }
	                    } : {
	                        pos: matchRslt.index,
	                        c: opts.negationSymbol.front,
	                        remove: matchRslt.index,
	                        caret: pos
	                    } : "" !== opts.negationSymbol.back ? {
	                        pos: matchRslt.index,
	                        c: "+",
	                        remove: [ matchRslt.index, maskset.buffer.length - opts.suffix.length - 1 ],
	                        caret: pos
	                    } : {
	                        pos: matchRslt.index,
	                        c: "+",
	                        remove: matchRslt.index,
	                        caret: pos
	                    } : maskset.buffer[matchRslt.index] === ("-" === chrs ? opts.negationSymbol.front : "+") ? "-" === chrs && "" !== opts.negationSymbol.back ? {
	                        remove: [ matchRslt.index, maskset.buffer.length - opts.suffix.length - 1 ],
	                        caret: pos - 1
	                    } : {
	                        remove: matchRslt.index,
	                        caret: pos - 1
	                    } : "-" === chrs ? "" !== opts.negationSymbol.back ? {
	                        pos: matchRslt.index,
	                        c: opts.negationSymbol.front,
	                        caret: pos + 1,
	                        insert: {
	                            pos: maskset.buffer.length - opts.suffix.length,
	                            c: opts.negationSymbol.back
	                        }
	                    } : {
	                        pos: matchRslt.index,
	                        c: opts.negationSymbol.front,
	                        caret: pos + 1
	                    } : {
	                        pos: matchRslt.index,
	                        c: chrs,
	                        caret: pos + 1
	                    };
	                }
	                return !1;
	            },
	            radixHandler: function(chrs, maskset, pos, strict, opts) {
	                if (!strict && opts.numericInput !== !0 && chrs === opts.radixPoint && void 0 !== opts.digits && (isNaN(opts.digits) || parseInt(opts.digits) > 0)) {
	                    var radixPos = $.inArray(opts.radixPoint, maskset.buffer), integerValue = maskset.buffer.join("").match(opts.regex.integerPart(opts));
	                    if (radixPos !== -1 && maskset.validPositions[radixPos]) return maskset.validPositions[radixPos - 1] ? {
	                        caret: radixPos + 1
	                    } : {
	                        pos: integerValue.index,
	                        c: integerValue[0],
	                        caret: radixPos + 1
	                    };
	                    if (!integerValue || "0" === integerValue[0] && integerValue.index + 1 !== pos) return maskset.buffer[integerValue ? integerValue.index : pos] = "0", 
	                    {
	                        pos: (integerValue ? integerValue.index : pos) + 1,
	                        c: opts.radixPoint
	                    };
	                }
	                return !1;
	            },
	            leadingZeroHandler: function(chrs, maskset, pos, strict, opts, isSelection) {
	                if (!strict) {
	                    var buffer = maskset.buffer.slice("");
	                    if (buffer.splice(0, opts.prefix.length), buffer.splice(buffer.length - opts.suffix.length, opts.suffix.length), 
	                    opts.numericInput === !0) {
	                        var buffer = buffer.reverse(), bufferChar = buffer[0];
	                        if ("0" === bufferChar && void 0 === maskset.validPositions[pos - 1]) return {
	                            pos: pos,
	                            remove: buffer.length - 1
	                        };
	                    } else {
	                        pos -= opts.prefix.length;
	                        var radixPosition = $.inArray(opts.radixPoint, buffer), matchRslt = buffer.slice(0, radixPosition !== -1 ? radixPosition : void 0).join("").match(opts.regex.integerNPart(opts));
	                        if (matchRslt && (radixPosition === -1 || pos <= radixPosition)) {
	                            var decimalPart = radixPosition === -1 ? 0 : parseInt(buffer.slice(radixPosition + 1).join(""));
	                            if (0 === matchRslt[0].indexOf("" !== opts.placeholder ? opts.placeholder.charAt(0) : "0") && (matchRslt.index + 1 === pos || isSelection !== !0 && 0 === decimalPart)) return maskset.buffer.splice(matchRslt.index + opts.prefix.length, 1), 
	                            {
	                                pos: matchRslt.index + opts.prefix.length,
	                                remove: matchRslt.index + opts.prefix.length
	                            };
	                            if ("0" === chrs && pos <= matchRslt.index && matchRslt[0] !== opts.groupSeparator) return !1;
	                        }
	                    }
	                }
	                return !0;
	            },
	            definitions: {
	                "~": {
	                    validator: function(chrs, maskset, pos, strict, opts, isSelection) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        if (!isValid && (isValid = opts.radixHandler(chrs, maskset, pos, strict, opts), 
	                        !isValid && (isValid = strict ? new RegExp("[0-9" + Inputmask.escapeRegex(opts.groupSeparator) + "]").test(chrs) : new RegExp("[0-9]").test(chrs), 
	                        isValid === !0 && (isValid = opts.leadingZeroHandler(chrs, maskset, pos, strict, opts, isSelection), 
	                        isValid === !0)))) {
	                            var radixPosition = $.inArray(opts.radixPoint, maskset.buffer);
	                            isValid = radixPosition !== -1 && (opts.digitsOptional === !1 || maskset.validPositions[pos]) && opts.numericInput !== !0 && pos > radixPosition && !strict ? {
	                                pos: pos,
	                                remove: pos
	                            } : {
	                                pos: pos
	                            };
	                        }
	                        return isValid;
	                    },
	                    cardinality: 1
	                },
	                "+": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        return !isValid && (strict && opts.allowMinus && chrs === opts.negationSymbol.front || opts.allowMinus && "-" === chrs || opts.allowPlus && "+" === chrs) && (isValid = !(!strict && "-" === chrs) || ("" !== opts.negationSymbol.back ? {
	                            pos: pos,
	                            c: "-" === chrs ? opts.negationSymbol.front : "+",
	                            caret: pos + 1,
	                            insert: {
	                                pos: maskset.buffer.length,
	                                c: opts.negationSymbol.back
	                            }
	                        } : {
	                            pos: pos,
	                            c: "-" === chrs ? opts.negationSymbol.front : "+",
	                            caret: pos + 1
	                        })), isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: ""
	                },
	                "-": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        return !isValid && strict && opts.allowMinus && chrs === opts.negationSymbol.back && (isValid = !0), 
	                        isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: ""
	                },
	                ":": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        if (!isValid) {
	                            var radix = "[" + Inputmask.escapeRegex(opts.radixPoint) + "]";
	                            isValid = new RegExp(radix).test(chrs), isValid && maskset.validPositions[pos] && maskset.validPositions[pos].match.placeholder === opts.radixPoint && (isValid = {
	                                caret: pos + 1
	                            });
	                        }
	                        return isValid ? {
	                            c: opts.radixPoint
	                        } : isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: function(opts) {
	                        return opts.radixPoint;
	                    }
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                if ("" === unmaskedValue && opts.nullable === !0) return unmaskedValue;
	                var processValue = maskedValue.replace(opts.prefix, "");
	                return processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                opts.unmaskAsNumber ? ("" !== opts.radixPoint && processValue.indexOf(opts.radixPoint) !== -1 && (processValue = processValue.replace(Inputmask.escapeRegex.call(this, opts.radixPoint), ".")), 
	                Number(processValue)) : processValue;
	            },
	            isComplete: function(buffer, opts) {
	                var maskedValue = buffer.join(""), bufClone = buffer.slice();
	                if (opts.postFormat(bufClone, 0, opts), bufClone.join("") !== maskedValue) return !1;
	                var processValue = maskedValue.replace(opts.prefix, "");
	                return processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (processValue = processValue.replace(Inputmask.escapeRegex(opts.radixPoint), ".")), 
	                isFinite(processValue);
	            },
	            onBeforeMask: function(initialValue, opts) {
	                if (opts.numericInput === !0 && (initialValue = initialValue.split("").reverse().join("")), 
	                "" !== opts.radixPoint && isFinite(initialValue)) initialValue = initialValue.toString().replace(".", opts.radixPoint); else {
	                    var kommaMatches = initialValue.match(/,/g), dotMatches = initialValue.match(/\./g);
	                    dotMatches && kommaMatches ? dotMatches.length > kommaMatches.length ? (initialValue = initialValue.replace(/\./g, ""), 
	                    initialValue = initialValue.replace(",", opts.radixPoint)) : kommaMatches.length > dotMatches.length ? (initialValue = initialValue.replace(/,/g, ""), 
	                    initialValue = initialValue.replace(".", opts.radixPoint)) : initialValue = initialValue.indexOf(".") < initialValue.indexOf(",") ? initialValue.replace(/\./g, "") : initialValue = initialValue.replace(/,/g, "") : initialValue = initialValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), "");
	                }
	                if (0 === opts.digits && (initialValue.indexOf(".") !== -1 ? initialValue = initialValue.substring(0, initialValue.indexOf(".")) : initialValue.indexOf(",") !== -1 && (initialValue = initialValue.substring(0, initialValue.indexOf(",")))), 
	                "" !== opts.radixPoint && isFinite(opts.digits) && initialValue.indexOf(opts.radixPoint) !== -1) {
	                    var valueParts = initialValue.split(opts.radixPoint), decPart = valueParts[1].match(new RegExp("\\d*"))[0];
	                    if (parseInt(opts.digits) < decPart.toString().length) {
	                        var digitsFactor = Math.pow(10, parseInt(opts.digits));
	                        initialValue = initialValue.replace(Inputmask.escapeRegex(opts.radixPoint), "."), 
	                        initialValue = Math.round(parseFloat(initialValue) * digitsFactor) / digitsFactor, 
	                        initialValue = initialValue.toString().replace(".", opts.radixPoint);
	                    }
	                }
	                return opts.numericInput === !0 && (initialValue = initialValue.split("").reverse().join("")), 
	                initialValue.toString();
	            },
	            canClearPosition: function(maskset, position, lvp, strict, opts) {
	                var positionInput = maskset.validPositions[position].input, canClear = positionInput !== opts.radixPoint || null !== maskset.validPositions[position].match.fn && opts.decimalProtect === !1 || isFinite(positionInput) || position === lvp || positionInput === opts.groupSeparator || positionInput === opts.negationSymbol.front || positionInput === opts.negationSymbol.back;
	                return canClear;
	            },
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey) switch (e.keyCode) {
	                  case Inputmask.keyCode.UP:
	                    $input.val(parseFloat(this.inputmask.unmaskedvalue()) + parseInt(opts.step)), $input.trigger("setvalue");
	                    break;
	
	                  case Inputmask.keyCode.DOWN:
	                    $input.val(parseFloat(this.inputmask.unmaskedvalue()) - parseInt(opts.step)), $input.trigger("setvalue");
	                }
	            }
	        },
	        currency: {
	            prefix: "$ ",
	            groupSeparator: ",",
	            alias: "numeric",
	            placeholder: "0",
	            autoGroup: !0,
	            digits: 2,
	            digitsOptional: !1,
	            clearMaskOnLostFocus: !1
	        },
	        decimal: {
	            alias: "numeric"
	        },
	        integer: {
	            alias: "numeric",
	            digits: 0,
	            radixPoint: ""
	        },
	        percentage: {
	            alias: "numeric",
	            digits: 2,
	            radixPoint: ".",
	            placeholder: "0",
	            autoGroup: !1,
	            min: 0,
	            max: 100,
	            suffix: " %",
	            allowPlus: !1,
	            allowMinus: !1
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendAliases({
	        abstractphone: {
	            countrycode: "",
	            phoneCodes: [],
	            mask: function(opts) {
	                opts.definitions = {
	                    "#": opts.definitions[9]
	                };
	                var masks = opts.phoneCodes.sort(function(a, b) {
	                    var maska = (a.mask || a).replace(/#/g, "9").replace(/[\+\(\)#-]/g, ""), maskb = (b.mask || b).replace(/#/g, "9").replace(/[\+\(\)#-]/g, ""), maskas = (a.mask || a).split("#")[0], maskbs = (b.mask || b).split("#")[0];
	                    return 0 === maskbs.indexOf(maskas) ? -1 : 0 === maskas.indexOf(maskbs) ? 1 : maska.localeCompare(maskb);
	                });
	                return masks;
	            },
	            keepStatic: !0,
	            onBeforeMask: function(value, opts) {
	                var processedValue = value.replace(/^0{1,2}/, "").replace(/[\s]/g, "");
	                return (processedValue.indexOf(opts.countrycode) > 1 || processedValue.indexOf(opts.countrycode) === -1) && (processedValue = "+" + opts.countrycode + processedValue), 
	                processedValue;
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                return unmaskedValue;
	            }
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendAliases({
	        Regex: {
	            mask: "r",
	            greedy: !1,
	            repeat: "*",
	            regex: null,
	            regexTokens: null,
	            tokenizer: /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g,
	            quantifierFilter: /[0-9]+[^,]/,
	            isComplete: function(buffer, opts) {
	                return new RegExp(opts.regex).test(buffer.join(""));
	            },
	            definitions: {
	                r: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        function RegexToken(isGroup, isQuantifier) {
	                            this.matches = [], this.isGroup = isGroup || !1, this.isQuantifier = isQuantifier || !1, 
	                            this.quantifier = {
	                                min: 1,
	                                max: 1
	                            }, this.repeaterPart = void 0;
	                        }
	                        function analyseRegex() {
	                            var match, m, currentToken = new RegexToken(), opengroups = [];
	                            for (opts.regexTokens = []; match = opts.tokenizer.exec(opts.regex); ) switch (m = match[0], 
	                            m.charAt(0)) {
	                              case "(":
	                                opengroups.push(new RegexToken((!0)));
	                                break;
	
	                              case ")":
	                                groupToken = opengroups.pop(), opengroups.length > 0 ? opengroups[opengroups.length - 1].matches.push(groupToken) : currentToken.matches.push(groupToken);
	                                break;
	
	                              case "{":
	                              case "+":
	                              case "*":
	                                var quantifierToken = new RegexToken((!1), (!0));
	                                m = m.replace(/[{}]/g, "");
	                                var mq = m.split(","), mq0 = isNaN(mq[0]) ? mq[0] : parseInt(mq[0]), mq1 = 1 === mq.length ? mq0 : isNaN(mq[1]) ? mq[1] : parseInt(mq[1]);
	                                if (quantifierToken.quantifier = {
	                                    min: mq0,
	                                    max: mq1
	                                }, opengroups.length > 0) {
	                                    var matches = opengroups[opengroups.length - 1].matches;
	                                    match = matches.pop(), match.isGroup || (groupToken = new RegexToken((!0)), groupToken.matches.push(match), 
	                                    match = groupToken), matches.push(match), matches.push(quantifierToken);
	                                } else match = currentToken.matches.pop(), match.isGroup || (groupToken = new RegexToken((!0)), 
	                                groupToken.matches.push(match), match = groupToken), currentToken.matches.push(match), 
	                                currentToken.matches.push(quantifierToken);
	                                break;
	
	                              default:
	                                opengroups.length > 0 ? opengroups[opengroups.length - 1].matches.push(m) : currentToken.matches.push(m);
	                            }
	                            currentToken.matches.length > 0 && opts.regexTokens.push(currentToken);
	                        }
	                        function validateRegexToken(token, fromGroup) {
	                            var isvalid = !1;
	                            fromGroup && (regexPart += "(", openGroupCount++);
	                            for (var mndx = 0; mndx < token.matches.length; mndx++) {
	                                var matchToken = token.matches[mndx];
	                                if (matchToken.isGroup === !0) isvalid = validateRegexToken(matchToken, !0); else if (matchToken.isQuantifier === !0) {
	                                    var crrntndx = $.inArray(matchToken, token.matches), matchGroup = token.matches[crrntndx - 1], regexPartBak = regexPart;
	                                    if (isNaN(matchToken.quantifier.max)) {
	                                        for (;matchToken.repeaterPart && matchToken.repeaterPart !== regexPart && matchToken.repeaterPart.length > regexPart.length && !(isvalid = validateRegexToken(matchGroup, !0)); ) ;
	                                        isvalid = isvalid || validateRegexToken(matchGroup, !0), isvalid && (matchToken.repeaterPart = regexPart), 
	                                        regexPart = regexPartBak + matchToken.quantifier.max;
	                                    } else {
	                                        for (var i = 0, qm = matchToken.quantifier.max - 1; i < qm && !(isvalid = validateRegexToken(matchGroup, !0)); i++) ;
	                                        regexPart = regexPartBak + "{" + matchToken.quantifier.min + "," + matchToken.quantifier.max + "}";
	                                    }
	                                } else if (void 0 !== matchToken.matches) for (var k = 0; k < matchToken.length && !(isvalid = validateRegexToken(matchToken[k], fromGroup)); k++) ; else {
	                                    var testExp;
	                                    if ("[" == matchToken.charAt(0)) {
	                                        testExp = regexPart, testExp += matchToken;
	                                        for (var j = 0; j < openGroupCount; j++) testExp += ")";
	                                        var exp = new RegExp("^(" + testExp + ")$");
	                                        isvalid = exp.test(bufferStr);
	                                    } else for (var l = 0, tl = matchToken.length; l < tl; l++) if ("\\" !== matchToken.charAt(l)) {
	                                        testExp = regexPart, testExp += matchToken.substr(0, l + 1), testExp = testExp.replace(/\|$/, "");
	                                        for (var j = 0; j < openGroupCount; j++) testExp += ")";
	                                        var exp = new RegExp("^(" + testExp + ")$");
	                                        if (isvalid = exp.test(bufferStr)) break;
	                                    }
	                                    regexPart += matchToken;
	                                }
	                                if (isvalid) break;
	                            }
	                            return fromGroup && (regexPart += ")", openGroupCount--), isvalid;
	                        }
	                        var bufferStr, groupToken, cbuffer = maskset.buffer.slice(), regexPart = "", isValid = !1, openGroupCount = 0;
	                        null === opts.regexTokens && analyseRegex(), cbuffer.splice(pos, 0, chrs), bufferStr = cbuffer.join("");
	                        for (var i = 0; i < opts.regexTokens.length; i++) {
	                            var regexToken = opts.regexTokens[i];
	                            if (isValid = validateRegexToken(regexToken, regexToken.isGroup)) break;
	                        }
	                        return isValid;
	                    },
	                    cardinality: 1
	                }
	            }
	        }
	    }), Inputmask;
	}(jQuery, Inputmask);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function() {
	  var $, AbstractChosen, Chosen, SelectParser, _ref,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  SelectParser = (function() {
	    function SelectParser() {
	      this.options_index = 0;
	      this.parsed = [];
	    }
	
	    SelectParser.prototype.add_node = function(child) {
	      if (child.nodeName.toUpperCase() === "OPTGROUP") {
	        return this.add_group(child);
	      } else {
	        return this.add_option(child);
	      }
	    };
	
	    SelectParser.prototype.add_group = function(group) {
	      var group_position, option, _i, _len, _ref, _results;
	      group_position = this.parsed.length;
	      this.parsed.push({
	        array_index: group_position,
	        group: true,
	        label: this.escapeExpression(group.label),
	        title: group.title ? group.title : void 0,
	        children: 0,
	        disabled: group.disabled,
	        classes: group.className
	      });
	      _ref = group.childNodes;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        option = _ref[_i];
	        _results.push(this.add_option(option, group_position, group.disabled));
	      }
	      return _results;
	    };
	
	    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
	      if (option.nodeName.toUpperCase() === "OPTION") {
	        if (option.text !== "") {
	          if (group_position != null) {
	            this.parsed[group_position].children += 1;
	          }
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            value: option.value,
	            text: option.text,
	            html: option.innerHTML,
	            title: option.title ? option.title : void 0,
	            selected: option.selected,
	            disabled: group_disabled === true ? group_disabled : option.disabled,
	            group_array_index: group_position,
	            group_label: group_position != null ? this.parsed[group_position].label : null,
	            classes: option.className,
	            style: option.style.cssText
	          });
	        } else {
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            empty: true
	          });
	        }
	        return this.options_index += 1;
	      }
	    };
	
	    SelectParser.prototype.escapeExpression = function(text) {
	      var map, unsafe_chars;
	      if ((text == null) || text === false) {
	        return "";
	      }
	      if (!/[\&\<\>\"\'\`]/.test(text)) {
	        return text;
	      }
	      map = {
	        "<": "&lt;",
	        ">": "&gt;",
	        '"': "&quot;",
	        "'": "&#x27;",
	        "`": "&#x60;"
	      };
	      unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
	      return text.replace(unsafe_chars, function(chr) {
	        return map[chr] || "&amp;";
	      });
	    };
	
	    return SelectParser;
	
	  })();
	
	  SelectParser.select_to_array = function(select) {
	    var child, parser, _i, _len, _ref;
	    parser = new SelectParser();
	    _ref = select.childNodes;
	    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	      child = _ref[_i];
	      parser.add_node(child);
	    }
	    return parser.parsed;
	  };
	
	  AbstractChosen = (function() {
	    function AbstractChosen(form_field, options) {
	      this.form_field = form_field;
	      this.options = options != null ? options : {};
	      if (!AbstractChosen.browser_is_supported()) {
	        return;
	      }
	      this.is_multiple = this.form_field.multiple;
	      this.set_default_text();
	      this.set_default_values();
	      this.setup();
	      this.set_up_html();
	      this.register_observers();
	      this.on_ready();
	    }
	
	    AbstractChosen.prototype.set_default_values = function() {
	      var _this = this;
	      this.click_test_action = function(evt) {
	        return _this.test_active_click(evt);
	      };
	      this.activate_action = function(evt) {
	        return _this.activate_field(evt);
	      };
	      this.active_field = false;
	      this.mouse_on_container = false;
	      this.results_showing = false;
	      this.result_highlighted = null;
	      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
	      this.disable_search_threshold = this.options.disable_search_threshold || 0;
	      this.disable_search = this.options.disable_search || false;
	      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
	      this.group_search = this.options.group_search != null ? this.options.group_search : true;
	      this.search_contains = this.options.search_contains || false;
	      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
	      this.max_selected_options = this.options.max_selected_options || Infinity;
	      this.inherit_select_classes = this.options.inherit_select_classes || false;
	      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
	      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
	      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
	      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
	      return this.case_sensitive_search = this.options.case_sensitive_search || false;
	    };
	
	    AbstractChosen.prototype.set_default_text = function() {
	      if (this.form_field.getAttribute("data-placeholder")) {
	        this.default_text = this.form_field.getAttribute("data-placeholder");
	      } else if (this.is_multiple) {
	        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
	      } else {
	        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
	      }
	      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
	    };
	
	    AbstractChosen.prototype.choice_label = function(item) {
	      if (this.include_group_label_in_selected && (item.group_label != null)) {
	        return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
	      } else {
	        return item.html;
	      }
	    };
	
	    AbstractChosen.prototype.mouse_enter = function() {
	      return this.mouse_on_container = true;
	    };
	
	    AbstractChosen.prototype.mouse_leave = function() {
	      return this.mouse_on_container = false;
	    };
	
	    AbstractChosen.prototype.input_focus = function(evt) {
	      var _this = this;
	      if (this.is_multiple) {
	        if (!this.active_field) {
	          return setTimeout((function() {
	            return _this.container_mousedown();
	          }), 50);
	        }
	      } else {
	        if (!this.active_field) {
	          return this.activate_field();
	        }
	      }
	    };
	
	    AbstractChosen.prototype.input_blur = function(evt) {
	      var _this = this;
	      if (!this.mouse_on_container) {
	        this.active_field = false;
	        return setTimeout((function() {
	          return _this.blur_test();
	        }), 100);
	      }
	    };
	
	    AbstractChosen.prototype.results_option_build = function(options) {
	      var content, data, data_content, shown_results, _i, _len, _ref;
	      content = '';
	      shown_results = 0;
	      _ref = this.results_data;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        data = _ref[_i];
	        data_content = '';
	        if (data.group) {
	          data_content = this.result_add_group(data);
	        } else {
	          data_content = this.result_add_option(data);
	        }
	        if (data_content !== '') {
	          shown_results++;
	          content += data_content;
	        }
	        if (options != null ? options.first : void 0) {
	          if (data.selected && this.is_multiple) {
	            this.choice_build(data);
	          } else if (data.selected && !this.is_multiple) {
	            this.single_set_selected_text(this.choice_label(data));
	          }
	        }
	        if (shown_results >= this.max_shown_results) {
	          break;
	        }
	      }
	      return content;
	    };
	
	    AbstractChosen.prototype.result_add_option = function(option) {
	      var classes, option_el;
	      if (!option.search_match) {
	        return '';
	      }
	      if (!this.include_option_in_results(option)) {
	        return '';
	      }
	      classes = [];
	      if (!option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("active-result");
	      }
	      if (option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("disabled-result");
	      }
	      if (option.selected) {
	        classes.push("result-selected");
	      }
	      if (option.group_array_index != null) {
	        classes.push("group-option");
	      }
	      if (option.classes !== "") {
	        classes.push(option.classes);
	      }
	      option_el = document.createElement("li");
	      option_el.className = classes.join(" ");
	      option_el.style.cssText = option.style;
	      option_el.setAttribute("data-option-array-index", option.array_index);
	      option_el.innerHTML = option.search_text;
	      if (option.title) {
	        option_el.title = option.title;
	      }
	      return this.outerHTML(option_el);
	    };
	
	    AbstractChosen.prototype.result_add_group = function(group) {
	      var classes, group_el;
	      if (!(group.search_match || group.group_match)) {
	        return '';
	      }
	      if (!(group.active_options > 0)) {
	        return '';
	      }
	      classes = [];
	      classes.push("group-result");
	      if (group.classes) {
	        classes.push(group.classes);
	      }
	      group_el = document.createElement("li");
	      group_el.className = classes.join(" ");
	      group_el.innerHTML = group.search_text;
	      if (group.title) {
	        group_el.title = group.title;
	      }
	      return this.outerHTML(group_el);
	    };
	
	    AbstractChosen.prototype.results_update_field = function() {
	      this.set_default_text();
	      if (!this.is_multiple) {
	        this.results_reset_cleanup();
	      }
	      this.result_clear_highlight();
	      this.results_build();
	      if (this.results_showing) {
	        return this.winnow_results();
	      }
	    };
	
	    AbstractChosen.prototype.reset_single_select_options = function() {
	      var result, _i, _len, _ref, _results;
	      _ref = this.results_data;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        result = _ref[_i];
	        if (result.selected) {
	          _results.push(result.selected = false);
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    AbstractChosen.prototype.results_toggle = function() {
	      if (this.results_showing) {
	        return this.results_hide();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.results_search = function(evt) {
	      if (this.results_showing) {
	        return this.winnow_results();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.winnow_results = function() {
	      var escapedSearchText, option, regex, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;
	      this.no_results_clear();
	      results = 0;
	      searchText = this.get_search_text();
	      escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	      zregex = new RegExp(escapedSearchText, 'i');
	      regex = this.get_search_regex(escapedSearchText);
	      _ref = this.results_data;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        option = _ref[_i];
	        option.search_match = false;
	        results_group = null;
	        if (this.include_option_in_results(option)) {
	          if (option.group) {
	            option.group_match = false;
	            option.active_options = 0;
	          }
	          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
	            results_group = this.results_data[option.group_array_index];
	            if (results_group.active_options === 0 && results_group.search_match) {
	              results += 1;
	            }
	            results_group.active_options += 1;
	          }
	          option.search_text = option.group ? option.label : option.html;
	          if (!(option.group && !this.group_search)) {
	            option.search_match = this.search_string_match(option.search_text, regex);
	            if (option.search_match && !option.group) {
	              results += 1;
	            }
	            if (option.search_match) {
	              if (searchText.length) {
	                startpos = option.search_text.search(zregex);
	                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
	                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
	              }
	              if (results_group != null) {
	                results_group.group_match = true;
	              }
	            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
	              option.search_match = true;
	            }
	          }
	        }
	      }
	      this.result_clear_highlight();
	      if (results < 1 && searchText.length) {
	        this.update_results_content("");
	        return this.no_results(searchText);
	      } else {
	        this.update_results_content(this.results_option_build());
	        return this.winnow_results_set_highlight();
	      }
	    };
	
	    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
	      var regex_anchor, regex_flag;
	      regex_anchor = this.search_contains ? "" : "^";
	      regex_flag = this.case_sensitive_search ? "" : "i";
	      return new RegExp(regex_anchor + escaped_search_string, regex_flag);
	    };
	
	    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
	      var part, parts, _i, _len;
	      if (regex.test(search_string)) {
	        return true;
	      } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
	        parts = search_string.replace(/\[|\]/g, "").split(" ");
	        if (parts.length) {
	          for (_i = 0, _len = parts.length; _i < _len; _i++) {
	            part = parts[_i];
	            if (regex.test(part)) {
	              return true;
	            }
	          }
	        }
	      }
	    };
	
	    AbstractChosen.prototype.choices_count = function() {
	      var option, _i, _len, _ref;
	      if (this.selected_option_count != null) {
	        return this.selected_option_count;
	      }
	      this.selected_option_count = 0;
	      _ref = this.form_field.options;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        option = _ref[_i];
	        if (option.selected) {
	          this.selected_option_count += 1;
	        }
	      }
	      return this.selected_option_count;
	    };
	
	    AbstractChosen.prototype.choices_click = function(evt) {
	      evt.preventDefault();
	      if (!(this.results_showing || this.is_disabled)) {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.keyup_checker = function(evt) {
	      var stroke, _ref;
	      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
	      this.search_field_scale();
	      switch (stroke) {
	        case 8:
	          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
	            return this.keydown_backstroke();
	          } else if (!this.pending_backstroke) {
	            this.result_clear_highlight();
	            return this.results_search();
	          }
	          break;
	        case 13:
	          evt.preventDefault();
	          if (this.results_showing) {
	            return this.result_select(evt);
	          }
	          break;
	        case 27:
	          if (this.results_showing) {
	            this.results_hide();
	          }
	          return true;
	        case 9:
	        case 38:
	        case 40:
	        case 16:
	        case 91:
	        case 17:
	        case 18:
	          break;
	        default:
	          return this.results_search();
	      }
	    };
	
	    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
	      var _this = this;
	      return setTimeout((function() {
	        return _this.results_search();
	      }), 50);
	    };
	
	    AbstractChosen.prototype.container_width = function() {
	      if (this.options.width != null) {
	        return this.options.width;
	      } else {
	        return "" + this.form_field.offsetWidth + "px";
	      }
	    };
	
	    AbstractChosen.prototype.include_option_in_results = function(option) {
	      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
	        return false;
	      }
	      if (!this.display_disabled_options && option.disabled) {
	        return false;
	      }
	      if (option.empty) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.prototype.search_results_touchstart = function(evt) {
	      this.touch_started = true;
	      return this.search_results_mouseover(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchmove = function(evt) {
	      this.touch_started = false;
	      return this.search_results_mouseout(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchend = function(evt) {
	      if (this.touch_started) {
	        return this.search_results_mouseup(evt);
	      }
	    };
	
	    AbstractChosen.prototype.outerHTML = function(element) {
	      var tmp;
	      if (element.outerHTML) {
	        return element.outerHTML;
	      }
	      tmp = document.createElement("div");
	      tmp.appendChild(element);
	      return tmp.innerHTML;
	    };
	
	    AbstractChosen.browser_is_supported = function() {
	      if ("Microsoft Internet Explorer" === window.navigator.appName) {
	        return document.documentMode >= 8;
	      }
	      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.default_multiple_text = "Select Some Options";
	
	    AbstractChosen.default_single_text = "Select an Option";
	
	    AbstractChosen.default_no_result_text = "No results match";
	
	    return AbstractChosen;
	
	  })();
	
	  $ = jQuery;
	
	  $.fn.extend({
	    chosen: function(options) {
	      if (!AbstractChosen.browser_is_supported()) {
	        return this;
	      }
	      return this.each(function(input_field) {
	        var $this, chosen;
	        $this = $(this);
	        chosen = $this.data('chosen');
	        if (options === 'destroy') {
	          if (chosen instanceof Chosen) {
	            chosen.destroy();
	          }
	          return;
	        }
	        if (!(chosen instanceof Chosen)) {
	          $this.data('chosen', new Chosen(this, options));
	        }
	      });
	    }
	  });
	
	  Chosen = (function(_super) {
	    __extends(Chosen, _super);
	
	    function Chosen() {
	      _ref = Chosen.__super__.constructor.apply(this, arguments);
	      return _ref;
	    }
	
	    Chosen.prototype.setup = function() {
	      this.form_field_jq = $(this.form_field);
	      this.current_selectedIndex = this.form_field.selectedIndex;
	      return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
	    };
	
	    Chosen.prototype.set_up_html = function() {
	      var container_classes, container_props;
	      container_classes = ["chosen-container"];
	      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
	      if (this.inherit_select_classes && this.form_field.className) {
	        container_classes.push(this.form_field.className);
	      }
	      if (this.is_rtl) {
	        container_classes.push("chosen-rtl");
	      }
	      container_props = {
	        'class': container_classes.join(' '),
	        'style': "width: " + (this.container_width()) + ";",
	        'title': this.form_field.title
	      };
	      if (this.form_field.id.length) {
	        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
	      }
	      this.container = $("<div />", container_props);
	      if (this.is_multiple) {
	        this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
	      } else {
	        this.container.html('<a class="chosen-single chosen-default"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
	      }
	      this.form_field_jq.hide().after(this.container);
	      this.dropdown = this.container.find('div.chosen-drop').first();
	      this.search_field = this.container.find('input').first();
	      this.search_results = this.container.find('ul.chosen-results').first();
	      this.search_field_scale();
	      this.search_no_results = this.container.find('li.no-results').first();
	      if (this.is_multiple) {
	        this.search_choices = this.container.find('ul.chosen-choices').first();
	        this.search_container = this.container.find('li.search-field').first();
	      } else {
	        this.search_container = this.container.find('div.chosen-search').first();
	        this.selected_item = this.container.find('.chosen-single').first();
	      }
	      this.results_build();
	      this.set_tab_index();
	      return this.set_label_behavior();
	    };
	
	    Chosen.prototype.on_ready = function() {
	      return this.form_field_jq.trigger("chosen:ready", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.register_observers = function() {
	      var _this = this;
	      this.container.bind('touchstart.chosen', function(evt) {
	        _this.container_mousedown(evt);
	        return evt.preventDefault();
	      });
	      this.container.bind('touchend.chosen', function(evt) {
	        _this.container_mouseup(evt);
	        return evt.preventDefault();
	      });
	      this.container.bind('mousedown.chosen', function(evt) {
	        _this.container_mousedown(evt);
	      });
	      this.container.bind('mouseup.chosen', function(evt) {
	        _this.container_mouseup(evt);
	      });
	      this.container.bind('mouseenter.chosen', function(evt) {
	        _this.mouse_enter(evt);
	      });
	      this.container.bind('mouseleave.chosen', function(evt) {
	        _this.mouse_leave(evt);
	      });
	      this.search_results.bind('mouseup.chosen', function(evt) {
	        _this.search_results_mouseup(evt);
	      });
	      this.search_results.bind('mouseover.chosen', function(evt) {
	        _this.search_results_mouseover(evt);
	      });
	      this.search_results.bind('mouseout.chosen', function(evt) {
	        _this.search_results_mouseout(evt);
	      });
	      this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function(evt) {
	        _this.search_results_mousewheel(evt);
	      });
	      this.search_results.bind('touchstart.chosen', function(evt) {
	        _this.search_results_touchstart(evt);
	      });
	      this.search_results.bind('touchmove.chosen', function(evt) {
	        _this.search_results_touchmove(evt);
	      });
	      this.search_results.bind('touchend.chosen', function(evt) {
	        _this.search_results_touchend(evt);
	      });
	      this.form_field_jq.bind("chosen:updated.chosen", function(evt) {
	        _this.results_update_field(evt);
	      });
	      this.form_field_jq.bind("chosen:activate.chosen", function(evt) {
	        _this.activate_field(evt);
	      });
	      this.form_field_jq.bind("chosen:open.chosen", function(evt) {
	        _this.container_mousedown(evt);
	      });
	      this.form_field_jq.bind("chosen:close.chosen", function(evt) {
	        _this.input_blur(evt);
	      });
	      this.search_field.bind('blur.chosen', function(evt) {
	        _this.input_blur(evt);
	      });
	      this.search_field.bind('keyup.chosen', function(evt) {
	        _this.keyup_checker(evt);
	      });
	      this.search_field.bind('keydown.chosen', function(evt) {
	        _this.keydown_checker(evt);
	      });
	      this.search_field.bind('focus.chosen', function(evt) {
	        _this.input_focus(evt);
	      });
	      this.search_field.bind('cut.chosen', function(evt) {
	        _this.clipboard_event_checker(evt);
	      });
	      this.search_field.bind('paste.chosen', function(evt) {
	        _this.clipboard_event_checker(evt);
	      });
	      if (this.is_multiple) {
	        return this.search_choices.bind('click.chosen', function(evt) {
	          _this.choices_click(evt);
	        });
	      } else {
	        return this.container.bind('click.chosen', function(evt) {
	          evt.preventDefault();
	        });
	      }
	    };
	
	    Chosen.prototype.destroy = function() {
	      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
	      if (this.search_field[0].tabIndex) {
	        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
	      }
	      this.container.remove();
	      this.form_field_jq.removeData('chosen');
	      return this.form_field_jq.show();
	    };
	
	    Chosen.prototype.search_field_disabled = function() {
	      this.is_disabled = this.form_field_jq[0].disabled;
	      if (this.is_disabled) {
	        this.container.addClass('chosen-disabled');
	        this.search_field[0].disabled = true;
	        if (!this.is_multiple) {
	          this.selected_item.unbind("focus.chosen", this.activate_action);
	        }
	        return this.close_field();
	      } else {
	        this.container.removeClass('chosen-disabled');
	        this.search_field[0].disabled = false;
	        if (!this.is_multiple) {
	          return this.selected_item.bind("focus.chosen", this.activate_action);
	        }
	      }
	    };
	
	    Chosen.prototype.container_mousedown = function(evt) {
	      if (!this.is_disabled) {
	        if (evt && evt.type === "mousedown" && !this.results_showing) {
	          evt.preventDefault();
	        }
	        if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
	          if (!this.active_field) {
	            if (this.is_multiple) {
	              this.search_field.val("");
	            }
	            $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
	            this.results_show();
	          } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
	            evt.preventDefault();
	            this.results_toggle();
	          }
	          return this.activate_field();
	        }
	      }
	    };
	
	    Chosen.prototype.container_mouseup = function(evt) {
	      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
	        return this.results_reset(evt);
	      }
	    };
	
	    Chosen.prototype.search_results_mousewheel = function(evt) {
	      var delta;
	      if (evt.originalEvent) {
	        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
	      }
	      if (delta != null) {
	        evt.preventDefault();
	        if (evt.type === 'DOMMouseScroll') {
	          delta = delta * 40;
	        }
	        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
	      }
	    };
	
	    Chosen.prototype.blur_test = function(evt) {
	      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.close_field = function() {
	      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
	      this.active_field = false;
	      this.results_hide();
	      this.container.removeClass("chosen-container-active");
	      this.clear_backstroke();
	      this.show_search_field_default();
	      return this.search_field_scale();
	    };
	
	    Chosen.prototype.activate_field = function() {
	      this.container.addClass("chosen-container-active");
	      this.active_field = true;
	      this.search_field.val(this.search_field.val());
	      return this.search_field.focus();
	    };
	
	    Chosen.prototype.test_active_click = function(evt) {
	      var active_container;
	      active_container = $(evt.target).closest('.chosen-container');
	      if (active_container.length && this.container[0] === active_container[0]) {
	        return this.active_field = true;
	      } else {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.results_build = function() {
	      this.parsing = true;
	      this.selected_option_count = null;
	      this.results_data = SelectParser.select_to_array(this.form_field);
	      if (this.is_multiple) {
	        this.search_choices.find("li.search-choice").remove();
	      } else if (!this.is_multiple) {
	        this.single_set_selected_text();
	        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
	          this.search_field[0].readOnly = true;
	          this.container.addClass("chosen-container-single-nosearch");
	        } else {
	          this.search_field[0].readOnly = false;
	          this.container.removeClass("chosen-container-single-nosearch");
	        }
	      }
	      this.update_results_content(this.results_option_build({
	        first: true
	      }));
	      this.search_field_disabled();
	      this.show_search_field_default();
	      this.search_field_scale();
	      return this.parsing = false;
	    };
	
	    Chosen.prototype.result_do_highlight = function(el) {
	      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
	      if (el.length) {
	        this.result_clear_highlight();
	        this.result_highlight = el;
	        this.result_highlight.addClass("highlighted");
	        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
	        visible_top = this.search_results.scrollTop();
	        visible_bottom = maxHeight + visible_top;
	        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
	        high_bottom = high_top + this.result_highlight.outerHeight();
	        if (high_bottom >= visible_bottom) {
	          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
	        } else if (high_top < visible_top) {
	          return this.search_results.scrollTop(high_top);
	        }
	      }
	    };
	
	    Chosen.prototype.result_clear_highlight = function() {
	      if (this.result_highlight) {
	        this.result_highlight.removeClass("highlighted");
	      }
	      return this.result_highlight = null;
	    };
	
	    Chosen.prototype.results_show = function() {
	      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	        this.form_field_jq.trigger("chosen:maxselected", {
	          chosen: this
	        });
	        return false;
	      }
	      this.container.addClass("chosen-with-drop");
	      this.results_showing = true;
	      this.search_field.focus();
	      this.search_field.val(this.search_field.val());
	      this.winnow_results();
	      return this.form_field_jq.trigger("chosen:showing_dropdown", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.update_results_content = function(content) {
	      return this.search_results.html(content);
	    };
	
	    Chosen.prototype.results_hide = function() {
	      if (this.results_showing) {
	        this.result_clear_highlight();
	        this.container.removeClass("chosen-with-drop");
	        this.form_field_jq.trigger("chosen:hiding_dropdown", {
	          chosen: this
	        });
	      }
	      return this.results_showing = false;
	    };
	
	    Chosen.prototype.set_tab_index = function(el) {
	      var ti;
	      if (this.form_field.tabIndex) {
	        ti = this.form_field.tabIndex;
	        this.form_field.tabIndex = -1;
	        return this.search_field[0].tabIndex = ti;
	      }
	    };
	
	    Chosen.prototype.set_label_behavior = function() {
	      var _this = this;
	      this.form_field_label = this.form_field_jq.parents("label");
	      if (!this.form_field_label.length && this.form_field.id.length) {
	        this.form_field_label = $("label[for='" + this.form_field.id + "']");
	      }
	      if (this.form_field_label.length > 0) {
	        return this.form_field_label.bind('click.chosen', function(evt) {
	          if (_this.is_multiple) {
	            return _this.container_mousedown(evt);
	          } else {
	            return _this.activate_field();
	          }
	        });
	      }
	    };
	
	    Chosen.prototype.show_search_field_default = function() {
	      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
	        this.search_field.val(this.default_text);
	        return this.search_field.addClass("default");
	      } else {
	        this.search_field.val("");
	        return this.search_field.removeClass("default");
	      }
	    };
	
	    Chosen.prototype.search_results_mouseup = function(evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target.length) {
	        this.result_highlight = target;
	        this.result_select(evt);
	        return this.search_field.focus();
	      }
	    };
	
	    Chosen.prototype.search_results_mouseover = function(evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target) {
	        return this.result_do_highlight(target);
	      }
	    };
	
	    Chosen.prototype.search_results_mouseout = function(evt) {
	      if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
	        return this.result_clear_highlight();
	      }
	    };
	
	    Chosen.prototype.choice_build = function(item) {
	      var choice, close_link,
	        _this = this;
	      choice = $('<li />', {
	        "class": "search-choice"
	      }).html("<span>" + (this.choice_label(item)) + "</span>");
	      if (item.disabled) {
	        choice.addClass('search-choice-disabled');
	      } else {
	        close_link = $('<a />', {
	          "class": 'search-choice-close',
	          'data-option-array-index': item.array_index
	        });
	        close_link.bind('click.chosen', function(evt) {
	          return _this.choice_destroy_link_click(evt);
	        });
	        choice.append(close_link);
	      }
	      return this.search_container.before(choice);
	    };
	
	    Chosen.prototype.choice_destroy_link_click = function(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      if (!this.is_disabled) {
	        return this.choice_destroy($(evt.target));
	      }
	    };
	
	    Chosen.prototype.choice_destroy = function(link) {
	      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
	        this.show_search_field_default();
	        if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
	          this.results_hide();
	        }
	        link.parents('li').first().remove();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.results_reset = function() {
	      this.reset_single_select_options();
	      this.form_field.options[0].selected = true;
	      this.single_set_selected_text();
	      this.show_search_field_default();
	      this.results_reset_cleanup();
	      this.form_field_jq.trigger("change");
	      if (this.active_field) {
	        return this.results_hide();
	      }
	    };
	
	    Chosen.prototype.results_reset_cleanup = function() {
	      this.current_selectedIndex = this.form_field.selectedIndex;
	      return this.selected_item.find("abbr").remove();
	    };
	
	    Chosen.prototype.result_select = function(evt) {
	      var high, item;
	      if (this.result_highlight) {
	        high = this.result_highlight;
	        this.result_clear_highlight();
	        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	          this.form_field_jq.trigger("chosen:maxselected", {
	            chosen: this
	          });
	          return false;
	        }
	        if (this.is_multiple) {
	          high.removeClass("active-result");
	        } else {
	          this.reset_single_select_options();
	        }
	        high.addClass("result-selected");
	        item = this.results_data[high[0].getAttribute("data-option-array-index")];
	        item.selected = true;
	        this.form_field.options[item.options_index].selected = true;
	        this.selected_option_count = null;
	        if (this.is_multiple) {
	          this.choice_build(item);
	        } else {
	          this.single_set_selected_text(this.choice_label(item));
	        }
	        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
	          this.results_hide();
	        }
	        this.show_search_field_default();
	        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
	          this.form_field_jq.trigger("change", {
	            'selected': this.form_field.options[item.options_index].value
	          });
	        }
	        this.current_selectedIndex = this.form_field.selectedIndex;
	        evt.preventDefault();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.single_set_selected_text = function(text) {
	      if (text == null) {
	        text = this.default_text;
	      }
	      if (text === this.default_text) {
	        this.selected_item.addClass("chosen-default");
	      } else {
	        this.single_deselect_control_build();
	        this.selected_item.removeClass("chosen-default");
	      }
	      return this.selected_item.find("span").html(text);
	    };
	
	    Chosen.prototype.result_deselect = function(pos) {
	      var result_data;
	      result_data = this.results_data[pos];
	      if (!this.form_field.options[result_data.options_index].disabled) {
	        result_data.selected = false;
	        this.form_field.options[result_data.options_index].selected = false;
	        this.selected_option_count = null;
	        this.result_clear_highlight();
	        if (this.results_showing) {
	          this.winnow_results();
	        }
	        this.form_field_jq.trigger("change", {
	          deselected: this.form_field.options[result_data.options_index].value
	        });
	        this.search_field_scale();
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    Chosen.prototype.single_deselect_control_build = function() {
	      if (!this.allow_single_deselect) {
	        return;
	      }
	      if (!this.selected_item.find("abbr").length) {
	        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
	      }
	      return this.selected_item.addClass("chosen-single-with-deselect");
	    };
	
	    Chosen.prototype.get_search_text = function() {
	      return $('<div/>').text($.trim(this.search_field.val())).html();
	    };
	
	    Chosen.prototype.winnow_results_set_highlight = function() {
	      var do_high, selected_results;
	      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
	      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
	      if (do_high != null) {
	        return this.result_do_highlight(do_high);
	      }
	    };
	
	    Chosen.prototype.no_results = function(terms) {
	      var no_results_html;
	      no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
	      no_results_html.find("span").first().html(terms);
	      this.search_results.append(no_results_html);
	      return this.form_field_jq.trigger("chosen:no_results", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.no_results_clear = function() {
	      return this.search_results.find(".no-results").remove();
	    };
	
	    Chosen.prototype.keydown_arrow = function() {
	      var next_sib;
	      if (this.results_showing && this.result_highlight) {
	        next_sib = this.result_highlight.nextAll("li.active-result").first();
	        if (next_sib) {
	          return this.result_do_highlight(next_sib);
	        }
	      } else {
	        return this.results_show();
	      }
	    };
	
	    Chosen.prototype.keyup_arrow = function() {
	      var prev_sibs;
	      if (!this.results_showing && !this.is_multiple) {
	        return this.results_show();
	      } else if (this.result_highlight) {
	        prev_sibs = this.result_highlight.prevAll("li.active-result");
	        if (prev_sibs.length) {
	          return this.result_do_highlight(prev_sibs.first());
	        } else {
	          if (this.choices_count() > 0) {
	            this.results_hide();
	          }
	          return this.result_clear_highlight();
	        }
	      }
	    };
	
	    Chosen.prototype.keydown_backstroke = function() {
	      var next_available_destroy;
	      if (this.pending_backstroke) {
	        this.choice_destroy(this.pending_backstroke.find("a").first());
	        return this.clear_backstroke();
	      } else {
	        next_available_destroy = this.search_container.siblings("li.search-choice").last();
	        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
	          this.pending_backstroke = next_available_destroy;
	          if (this.single_backstroke_delete) {
	            return this.keydown_backstroke();
	          } else {
	            return this.pending_backstroke.addClass("search-choice-focus");
	          }
	        }
	      }
	    };
	
	    Chosen.prototype.clear_backstroke = function() {
	      if (this.pending_backstroke) {
	        this.pending_backstroke.removeClass("search-choice-focus");
	      }
	      return this.pending_backstroke = null;
	    };
	
	    Chosen.prototype.keydown_checker = function(evt) {
	      var stroke, _ref1;
	      stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
	      this.search_field_scale();
	      if (stroke !== 8 && this.pending_backstroke) {
	        this.clear_backstroke();
	      }
	      switch (stroke) {
	        case 8:
	          this.backstroke_length = this.search_field.val().length;
	          break;
	        case 9:
	          if (this.results_showing && !this.is_multiple) {
	            this.result_select(evt);
	          }
	          this.mouse_on_container = false;
	          break;
	        case 13:
	          if (this.results_showing) {
	            evt.preventDefault();
	          }
	          break;
	        case 32:
	          if (this.disable_search) {
	            evt.preventDefault();
	          }
	          break;
	        case 38:
	          evt.preventDefault();
	          this.keyup_arrow();
	          break;
	        case 40:
	          evt.preventDefault();
	          this.keydown_arrow();
	          break;
	      }
	    };
	
	    Chosen.prototype.search_field_scale = function() {
	      var div, f_width, h, style, style_block, styles, w, _i, _len;
	      if (this.is_multiple) {
	        h = 0;
	        w = 0;
	        style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
	        styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
	        for (_i = 0, _len = styles.length; _i < _len; _i++) {
	          style = styles[_i];
	          style_block += style + ":" + this.search_field.css(style) + ";";
	        }
	        div = $('<div />', {
	          'style': style_block
	        });
	        div.text(this.search_field.val());
	        $('body').append(div);
	        w = div.width() + 25;
	        div.remove();
	        f_width = this.container.outerWidth();
	        if (w > f_width - 10) {
	          w = f_width - 10;
	        }
	        return this.search_field.css({
	          'width': w + 'px'
	        });
	      }
	    };
	
	    return Chosen;
	
	  })(AbstractChosen);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, module) {/*!
	* jQuery Password Strength plugin for Twitter Bootstrap
	* Version: 2.0.2
	*
	* Copyright (c) 2008-2013 Tane Piper
	* Copyright (c) 2013 Alejandro Blanco
	* Dual licensed under the MIT and GPL licenses.
	*/
	
	(function (jQuery) {
	// Source: src/i18n.js
	
	
	
	
	var i18n = {};
	
	(function (i18n, i18next) {
	    'use strict';
	
	    i18n.fallback = {
	        "wordLength": "Your password is too short",
	        "wordNotEmail": "Do not use your email as your password",
	        "wordSimilarToUsername": "Your password cannot contain your username",
	        "wordTwoCharacterClasses": "Use different character classes",
	        "wordRepetitions": "Too many repetitions",
	        "wordSequences": "Your password contains sequences",
	        "errorList": "Errors:",
	        "veryWeak": "Very Weak",
	        "weak": "Weak",
	        "normal": "Normal",
	        "medium": "Medium",
	        "strong": "Strong",
	        "veryStrong": "Very Strong"
	    };
	
	    i18n.t = function (key) {
	        var result = '';
	
	        // Try to use i18next.com
	        if (i18next) {
	            result = i18next.t(key);
	        } else {
	            // Fallback to english
	            result = i18n.fallback[key];
	        }
	
	        return result === key ? '' : result;
	    };
	}(i18n, window.i18next));
	
	// Source: src/rules.js
	
	
	
	
	var rulesEngine = {};
	
	try {
	    if (!jQuery && module && module.exports) {
	        var jQuery = __webpack_require__(14),
	            jsdom = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"jsdom\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).jsdom;
	        jQuery = jQuery(jsdom().parentWindow);
	    }
	} catch (ignore) {}
	
	(function ($, rulesEngine) {
	    "use strict";
	    var validation = {};
	
	    rulesEngine.forbiddenSequences = [
	        "0123456789", "abcdefghijklmnopqrstuvwxyz", "qwertyuiop", "asdfghjkl",
	        "zxcvbnm", "!@#$%^&*()_+"
	    ];
	
	    validation.wordNotEmail = function (options, word, score) {
	        if (word.match(/^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/i)) {
	            return score;
	        }
	        return 0;
	    };
	
	    validation.wordLength = function (options, word, score) {
	        var wordlen = word.length,
	            lenScore = Math.pow(wordlen, options.rules.raisePower);
	        if (wordlen < options.common.minChar) {
	            lenScore = (lenScore + score);
	        }
	        return lenScore;
	    };
	
	    validation.wordSimilarToUsername = function (options, word, score) {
	        var username = $(options.common.usernameField).val();
	        if (username && word.toLowerCase().match(username.replace(/[\-\[\]\/\{\}\(\)\*\+\=\?\:\.\\\^\$\|\!\,]/g, "\\$&").toLowerCase())) {
	            return score;
	        }
	        return 0;
	    };
	
	    validation.wordTwoCharacterClasses = function (options, word, score) {
	        if (word.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) ||
	                (word.match(/([a-zA-Z])/) && word.match(/([0-9])/)) ||
	                (word.match(/(.[!,@,#,$,%,\^,&,*,?,_,~])/) && word.match(/[a-zA-Z0-9_]/))) {
	            return score;
	        }
	        return 0;
	    };
	
	    validation.wordRepetitions = function (options, word, score) {
	        if (word.match(/(.)\1\1/)) { return score; }
	        return 0;
	    };
	
	    validation.wordSequences = function (options, word, score) {
	        var found = false,
	            j;
	        if (word.length > 2) {
	            $.each(rulesEngine.forbiddenSequences, function (idx, seq) {
	                if (found) { return; }
	                var sequences = [seq, seq.split('').reverse().join('')];
	                $.each(sequences, function (idx, sequence) {
	                    for (j = 0; j < (word.length - 2); j += 1) { // iterate the word trough a sliding window of size 3:
	                        if (sequence.indexOf(word.toLowerCase().substring(j, j + 3)) > -1) {
	                            found = true;
	                        }
	                    }
	                });
	            });
	            if (found) { return score; }
	        }
	        return 0;
	    };
	
	    validation.wordLowercase = function (options, word, score) {
	        return word.match(/[a-z]/) && score;
	    };
	
	    validation.wordUppercase = function (options, word, score) {
	        return word.match(/[A-Z]/) && score;
	    };
	
	    validation.wordOneNumber = function (options, word, score) {
	        return word.match(/\d+/) && score;
	    };
	
	    validation.wordThreeNumbers = function (options, word, score) {
	        return word.match(/(.*[0-9].*[0-9].*[0-9])/) && score;
	    };
	
	    validation.wordOneSpecialChar = function (options, word, score) {
	        return word.match(/[!,@,#,$,%,\^,&,*,?,_,~]/) && score;
	    };
	
	    validation.wordTwoSpecialChar = function (options, word, score) {
	        return word.match(/(.*[!,@,#,$,%,\^,&,*,?,_,~].*[!,@,#,$,%,\^,&,*,?,_,~])/) && score;
	    };
	
	    validation.wordUpperLowerCombo = function (options, word, score) {
	        return word.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) && score;
	    };
	
	    validation.wordLetterNumberCombo = function (options, word, score) {
	        return word.match(/([a-zA-Z])/) && word.match(/([0-9])/) && score;
	    };
	
	    validation.wordLetterNumberCharCombo = function (options, word, score) {
	        return word.match(/([a-zA-Z0-9].*[!,@,#,$,%,\^,&,*,?,_,~])|([!,@,#,$,%,\^,&,*,?,_,~].*[a-zA-Z0-9])/) && score;
	    };
	
	    rulesEngine.validation = validation;
	
	    rulesEngine.executeRules = function (options, word) {
	        var totalScore = 0;
	
	        $.each(options.rules.activated, function (rule, active) {
	            if (active) {
	                var score = options.rules.scores[rule],
	                    funct = rulesEngine.validation[rule],
	                    result,
	                    errorMessage;
	
	                if (!$.isFunction(funct)) {
	                    funct = options.rules.extra[rule];
	                }
	
	                if ($.isFunction(funct)) {
	                    result = funct(options, word, score);
	                    if (result) {
	                        totalScore += result;
	                    }
	                    if (result < 0 || (!$.isNumeric(result) && !result)) {
	                        errorMessage = options.ui.spanError(options, rule);
	                        if (errorMessage.length > 0) {
	                            options.instances.errors.push(errorMessage);
	                        }
	                    }
	                }
	            }
	        });
	
	        if ($.isFunction(options.common.onScore)) {
	            totalScore = options.common.onScore(options, word, totalScore);
	        }
	
	        return totalScore;
	    };
	}(jQuery, rulesEngine));
	
	try {
	    if (module && module.exports) {
	        module.exports = rulesEngine;
	    }
	} catch (ignore) {}
	
	// Source: src/options.js
	
	
	
	
	var defaultOptions = {};
	
	defaultOptions.common = {};
	defaultOptions.common.minChar = 6;
	defaultOptions.common.usernameField = "#username";
	defaultOptions.common.userInputs = [
	    // Selectors for input fields with user input
	];
	defaultOptions.common.onLoad = undefined;
	defaultOptions.common.onKeyUp = undefined;
	defaultOptions.common.onScore = undefined;
	defaultOptions.common.zxcvbn = false;
	defaultOptions.common.zxcvbnTerms = [
	    // List of disrecommended words
	];
	defaultOptions.common.events = ["keyup", "change", "paste"];
	defaultOptions.common.debug = false;
	
	defaultOptions.rules = {};
	defaultOptions.rules.extra = {};
	defaultOptions.rules.scores = {
	    wordNotEmail: -100,
	    wordLength: -50,
	    wordSimilarToUsername: -100,
	    wordSequences: -20,
	    wordTwoCharacterClasses: 2,
	    wordRepetitions: -25,
	    wordLowercase: 1,
	    wordUppercase: 3,
	    wordOneNumber: 3,
	    wordThreeNumbers: 5,
	    wordOneSpecialChar: 3,
	    wordTwoSpecialChar: 5,
	    wordUpperLowerCombo: 2,
	    wordLetterNumberCombo: 2,
	    wordLetterNumberCharCombo: 2
	};
	defaultOptions.rules.activated = {
	    wordNotEmail: true,
	    wordLength: true,
	    wordSimilarToUsername: true,
	    wordSequences: true,
	    wordTwoCharacterClasses: false,
	    wordRepetitions: false,
	    wordLowercase: true,
	    wordUppercase: true,
	    wordOneNumber: true,
	    wordThreeNumbers: true,
	    wordOneSpecialChar: true,
	    wordTwoSpecialChar: true,
	    wordUpperLowerCombo: true,
	    wordLetterNumberCombo: true,
	    wordLetterNumberCharCombo: true
	};
	defaultOptions.rules.raisePower = 1.4;
	
	defaultOptions.ui = {};
	defaultOptions.ui.bootstrap2 = false;
	defaultOptions.ui.bootstrap4 = false;
	defaultOptions.ui.colorClasses = [
	    "danger", "danger", "danger", "warning", "warning", "success"
	];
	defaultOptions.ui.showProgressBar = true;
	defaultOptions.ui.progressBarEmptyPercentage = 1;
	defaultOptions.ui.progressBarMinPercentage = 1;
	defaultOptions.ui.progressBarExtraCssClasses = '';
	defaultOptions.ui.showPopover = false;
	defaultOptions.ui.popoverPlacement = "bottom";
	defaultOptions.ui.showStatus = false;
	defaultOptions.ui.spanError = function (options, key) {
	    "use strict";
	    var text = options.i18n.t(key);
	    if (!text) { return ''; }
	    return '<span style="color: #d52929">' + text + '</span>';
	};
	defaultOptions.ui.popoverError = function (options) {
	    "use strict";
	    var errors = options.instances.errors,
	        errorsTitle = options.i18n.t("errorList"),
	        message = "<div>" + errorsTitle + "<ul class='error-list' style='margin-bottom: 0;'>";
	
	    jQuery.each(errors, function (idx, err) {
	        message += "<li>" + err + "</li>";
	    });
	    message += "</ul></div>";
	    return message;
	};
	defaultOptions.ui.showVerdicts = true;
	defaultOptions.ui.showVerdictsInsideProgressBar = false;
	defaultOptions.ui.useVerdictCssClass = false;
	defaultOptions.ui.showErrors = false;
	defaultOptions.ui.showScore = false;
	defaultOptions.ui.container = undefined;
	defaultOptions.ui.viewports = {
	    progress: undefined,
	    verdict: undefined,
	    errors: undefined,
	    score: undefined
	};
	defaultOptions.ui.scores = [0, 14, 26, 38, 50];
	
	defaultOptions.i18n = {};
	defaultOptions.i18n.t = i18n.t;
	
	// Source: src/ui.js
	
	
	
	
	var ui = {};
	
	(function ($, ui) {
	    "use strict";
	
	    var statusClasses = ["error", "warning", "success"],
	        verdictKeys = [
	            "veryWeak", "weak", "normal", "medium", "strong", "veryStrong"
	        ];
	
	    ui.getContainer = function (options, $el) {
	        var $container;
	
	        $container = $(options.ui.container);
	        if (!($container && $container.length === 1)) {
	            $container = $el.parent();
	        }
	        return $container;
	    };
	
	    ui.findElement = function ($container, viewport, cssSelector) {
	        if (viewport) {
	            return $container.find(viewport).find(cssSelector);
	        }
	        return $container.find(cssSelector);
	    };
	
	    ui.getUIElements = function (options, $el) {
	        var $container, selector, result;
	
	        if (options.instances.viewports) {
	            return options.instances.viewports;
	        }
	
	        $container = ui.getContainer(options, $el);
	
	        result = {};
	        if (options.ui.bootstrap4) {
	            selector = "progress.progress";
	        } else {
	            selector = "div.progress";
	        }
	        result.$progressbar = ui.findElement($container, options.ui.viewports.progress, selector);
	        if (options.ui.showVerdictsInsideProgressBar) {
	            result.$verdict = result.$progressbar.find("span.password-verdict");
	        }
	
	        if (!options.ui.showPopover) {
	            if (!options.ui.showVerdictsInsideProgressBar) {
	                result.$verdict = ui.findElement($container, options.ui.viewports.verdict, "span.password-verdict");
	            }
	            result.$errors = ui.findElement($container, options.ui.viewports.errors, "ul.error-list");
	        }
	        result.$score = ui.findElement($container, options.ui.viewports.score,
	                                       "span.password-score");
	
	        options.instances.viewports = result;
	        return result;
	    };
	
	    ui.initProgressBar = function (options, $el) {
	        var $container = ui.getContainer(options, $el),
	            progressbar = "<div class='progress ";
	
	        if (options.ui.bootstrap2) {
	            // Boostrap 2
	            progressbar += options.ui.progressBarExtraCssClasses +
	                "'><div class='";
	        } else if (!options.ui.bootstrap2 && !options.ui.bootstrap4) {
	            // Bootstrap 3
	            progressbar += "'><div class='" +
	                options.ui.progressBarExtraCssClasses + " progress-";
	        }
	        progressbar += "bar'>";
	
	        if (options.ui.bootstrap4) {
	            // Boostrap 4
	            progressbar = "<progress class='progress " +
	                options.ui.progressBarExtraCssClasses + "' value='0' max='100'>";
	        }
	
	        if (options.ui.showVerdictsInsideProgressBar) {
	            progressbar += "<span class='password-verdict'></span>";
	        }
	
	        if (options.ui.bootstrap4) {
	            progressbar += "</progress>";
	        } else {
	            progressbar += "</div></div>";
	        }
	
	        if (options.ui.viewports.progress) {
	            $container.find(options.ui.viewports.progress).append(progressbar);
	        } else {
	            $(progressbar).insertAfter($el);
	        }
	    };
	
	    ui.initHelper = function (options, $el, html, viewport) {
	        var $container = ui.getContainer(options, $el);
	        if (viewport) {
	            $container.find(viewport).append(html);
	        } else {
	            $(html).insertAfter($el);
	        }
	    };
	
	    ui.initVerdict = function (options, $el) {
	        ui.initHelper(options, $el, "<span class='password-verdict'></span>",
	                      options.ui.viewports.verdict);
	    };
	
	    ui.initErrorList = function (options, $el) {
	        ui.initHelper(options, $el, "<ul class='error-list'></ul>",
	                      options.ui.viewports.errors);
	    };
	
	    ui.initScore = function (options, $el) {
	        ui.initHelper(options, $el, "<span class='password-score'></span>",
	                      options.ui.viewports.score);
	    };
	
	    ui.initPopover = function (options, $el) {
	        $el.popover("destroy");
	        $el.popover({
	            html: true,
	            placement: options.ui.popoverPlacement,
	            trigger: "manual",
	            content: " "
	        });
	    };
	
	    ui.initUI = function (options, $el) {
	        if (options.ui.showPopover) {
	            ui.initPopover(options, $el);
	        } else {
	            if (options.ui.showErrors) { ui.initErrorList(options, $el); }
	            if (options.ui.showVerdicts && !options.ui.showVerdictsInsideProgressBar) {
	                ui.initVerdict(options, $el);
	            }
	        }
	        if (options.ui.showProgressBar) {
	            ui.initProgressBar(options, $el);
	        }
	        if (options.ui.showScore) {
	            ui.initScore(options, $el);
	        }
	    };
	
	    ui.updateProgressBar = function (options, $el, cssClass, percentage) {
	        var $progressbar = ui.getUIElements(options, $el).$progressbar,
	            $bar = $progressbar.find(".progress-bar"),
	            cssPrefix = "progress-";
	
	        if (options.ui.bootstrap2) {
	            $bar = $progressbar.find(".bar");
	            cssPrefix = "";
	        }
	
	        $.each(options.ui.colorClasses, function (idx, value) {
	            if (options.ui.bootstrap4) {
	                $progressbar.removeClass(cssPrefix + value);
	            } else {
	                $bar.removeClass(cssPrefix + "bar-" + value);
	            }
	        });
	        if (options.ui.bootstrap4) {
	            $progressbar.addClass(cssPrefix + options.ui.colorClasses[cssClass]);
	            $progressbar.val(percentage);
	        } else {
	            $bar.addClass(cssPrefix + "bar-" + options.ui.colorClasses[cssClass]);
	            $bar.css("width", percentage + '%');
	        }
	    };
	
	    ui.updateVerdict = function (options, $el, cssClass, text) {
	        var $verdict = ui.getUIElements(options, $el).$verdict;
	        $verdict.removeClass(options.ui.colorClasses.join(' '));
	        if (cssClass > -1) {
	            $verdict.addClass(options.ui.colorClasses[cssClass]);
	        }
	        $verdict.html(text);
	    };
	
	    ui.updateErrors = function (options, $el, remove) {
	        var $errors = ui.getUIElements(options, $el).$errors,
	            html = "";
	
	        if (!remove) {
	            $.each(options.instances.errors, function (idx, err) {
	                html += "<li>" + err + "</li>";
	            });
	        }
	        $errors.html(html);
	    };
	
	    ui.updateScore = function (options, $el, score, remove) {
	        var $score = ui.getUIElements(options, $el).$score,
	            html = "";
	
	        if (!remove) { html = score.toFixed(2); }
	        $score.html(html);
	    };
	
	    ui.updatePopover = function (options, $el, verdictText, remove) {
	        var popover = $el.data("bs.popover"),
	            html = "",
	            hide = true;
	
	        if (options.ui.showVerdicts &&
	                !options.ui.showVerdictsInsideProgressBar &&
	                verdictText.length > 0) {
	            html = "<h5><span class='password-verdict'>" + verdictText +
	                "</span></h5>";
	            hide = false;
	        }
	        if (options.ui.showErrors) {
	            if (options.instances.errors.length > 0) {
	                hide = false;
	            }
	            html += options.ui.popoverError(options);
	        }
	
	        if (hide || remove) {
	            $el.popover("hide");
	            return;
	        }
	
	        if (options.ui.bootstrap2) { popover = $el.data("popover"); }
	
	        if (popover.$arrow && popover.$arrow.parents("body").length > 0) {
	            $el.find("+ .popover .popover-content").html(html);
	        } else {
	            // It's hidden
	            popover.options.content = html;
	            $el.popover("show");
	        }
	    };
	
	    ui.updateFieldStatus = function (options, $el, cssClass, remove) {
	        var targetClass = options.ui.bootstrap2 ? ".control-group" : ".form-group",
	            $container = $el.parents(targetClass).first();
	
	        $.each(statusClasses, function (idx, css) {
	            if (!options.ui.bootstrap2) { css = "has-" + css; }
	            $container.removeClass(css);
	        });
	
	        if (remove) { return; }
	
	        cssClass = statusClasses[cssClass];
	        if (!options.ui.bootstrap2) { cssClass = "has-" + cssClass; }
	        $container.addClass(cssClass);
	    };
	
	    ui.percentage = function (options, score, maximun) {
	        var result = Math.floor(100 * score / maximun),
	            min = options.ui.progressBarMinPercentage;
	
	        result = result <= min ? min : result;
	        result = result > 100 ? 100 : result;
	        return result;
	    };
	
	    ui.getVerdictAndCssClass = function (options, score) {
	        var level, verdict;
	
	        if (score === undefined) { return ['', 0]; }
	
	        if (score <= options.ui.scores[0]) {
	            level = 0;
	        } else if (score < options.ui.scores[1]) {
	            level = 1;
	        } else if (score < options.ui.scores[2]) {
	            level = 2;
	        } else if (score < options.ui.scores[3]) {
	            level = 3;
	        } else if (score < options.ui.scores[4]) {
	            level = 4;
	        } else {
	            level = 5;
	        }
	
	        verdict = verdictKeys[level];
	
	        return [options.i18n.t(verdict), level];
	    };
	
	    ui.updateUI = function (options, $el, score) {
	        var cssClass, barPercentage, verdictText, verdictCssClass;
	
	        cssClass = ui.getVerdictAndCssClass(options, score);
	        verdictText = score === 0 ? '' : cssClass[0];
	        cssClass = cssClass[1];
	        verdictCssClass = options.ui.useVerdictCssClass ? cssClass : -1;
	
	        if (options.ui.showProgressBar) {
	            if (score === undefined) {
	                barPercentage = options.ui.progressBarEmptyPercentage;
	            } else {
	                barPercentage = ui.percentage(options, score, options.ui.scores[4]);
	            }
	            ui.updateProgressBar(options, $el, cssClass, barPercentage);
	            if (options.ui.showVerdictsInsideProgressBar) {
	                ui.updateVerdict(options, $el, verdictCssClass, verdictText);
	            }
	        }
	
	        if (options.ui.showStatus) {
	            ui.updateFieldStatus(options, $el, cssClass, score === undefined);
	        }
	
	        if (options.ui.showPopover) {
	            ui.updatePopover(options, $el, verdictText, score === undefined);
	        } else {
	            if (options.ui.showVerdicts && !options.ui.showVerdictsInsideProgressBar) {
	                ui.updateVerdict(options, $el, verdictCssClass, verdictText);
	            }
	            if (options.ui.showErrors) {
	                ui.updateErrors(options, $el, score === undefined);
	            }
	        }
	
	        if (options.ui.showScore) {
	            ui.updateScore(options, $el, score, score === undefined);
	        }
	    };
	}(jQuery, ui));
	
	// Source: src/methods.js
	
	
	
	
	var methods = {};
	
	(function ($, methods) {
	    "use strict";
	    var onKeyUp, onPaste, applyToAll;
	
	    onKeyUp = function (event) {
	        var $el = $(event.target),
	            options = $el.data("pwstrength-bootstrap"),
	            word = $el.val(),
	            userInputs,
	            verdictText,
	            verdictLevel,
	            score;
	
	        if (options === undefined) { return; }
	
	        options.instances.errors = [];
	        if (word.length === 0) {
	            score = undefined;
	        } else {
	            if (options.common.zxcvbn) {
	                userInputs = [];
	                $.each(options.common.userInputs.concat([options.common.usernameField]), function (idx, selector) {
	                    var value = $(selector).val();
	                    if (value) { userInputs.push(value); }
	                });
	                userInputs = userInputs.concat(options.common.zxcvbnTerms);
	                score = Math.log2(zxcvbn(word, userInputs).guesses);
	            } else {
	                score = rulesEngine.executeRules(options, word);
	            }
	        }
	        ui.updateUI(options, $el, score);
	        verdictText = ui.getVerdictAndCssClass(options, score);
	        verdictLevel = verdictText[1];
	        verdictText = verdictText[0];
	
	        if (options.common.debug) { console.log(score + ' - ' + verdictText); }
	
	        if ($.isFunction(options.common.onKeyUp)) {
	            options.common.onKeyUp(event, {
	                score: score,
	                verdictText: verdictText,
	                verdictLevel: verdictLevel
	            });
	        }
	    };
	
	    onPaste = function (event) {
	        // This handler is necessary because the paste event fires before the
	        // content is actually in the input, so we cannot read its value right
	        // away. Therefore, the timeouts.
	        var $el = $(event.target),
	            word = $el.val(),
	            tries = 0,
	            callback;
	
	        callback = function () {
	            var newWord =  $el.val();
	
	            if (newWord !== word) {
	                onKeyUp(event);
	            } else if (tries < 3) {
	                tries += 1;
	                setTimeout(callback, 100);
	            }
	        };
	
	        setTimeout(callback, 100);
	    };
	
	    methods.init = function (settings) {
	        this.each(function (idx, el) {
	            // Make it deep extend (first param) so it extends also the
	            // rules and other inside objects
	            var clonedDefaults = $.extend(true, {}, defaultOptions),
	                localOptions = $.extend(true, clonedDefaults, settings),
	                $el = $(el);
	
	            localOptions.instances = {};
	            $el.data("pwstrength-bootstrap", localOptions);
	
	            $.each(localOptions.common.events, function (idx, eventName) {
	                var handler = eventName === "paste" ? onPaste : onKeyUp;
	                $el.on(eventName, handler);
	            });
	
	            ui.initUI(localOptions, $el);
	            $el.trigger("keyup");
	
	            if ($.isFunction(localOptions.common.onLoad)) {
	                localOptions.common.onLoad();
	            }
	        });
	
	        return this;
	    };
	
	    methods.destroy = function () {
	        this.each(function (idx, el) {
	            var $el = $(el),
	                options = $el.data("pwstrength-bootstrap"),
	                elements = ui.getUIElements(options, $el);
	            elements.$progressbar.remove();
	            elements.$verdict.remove();
	            elements.$errors.remove();
	            $el.removeData("pwstrength-bootstrap");
	        });
	    };
	
	    methods.forceUpdate = function () {
	        this.each(function (idx, el) {
	            var event = { target: el };
	            onKeyUp(event);
	        });
	    };
	
	    methods.addRule = function (name, method, score, active) {
	        this.each(function (idx, el) {
	            var options = $(el).data("pwstrength-bootstrap");
	
	            options.rules.activated[name] = active;
	            options.rules.scores[name] = score;
	            options.rules.extra[name] = method;
	        });
	    };
	
	    applyToAll = function (rule, prop, value) {
	        this.each(function (idx, el) {
	            $(el).data("pwstrength-bootstrap").rules[prop][rule] = value;
	        });
	    };
	
	    methods.changeScore = function (rule, score) {
	        applyToAll.call(this, rule, "scores", score);
	    };
	
	    methods.ruleActive = function (rule, active) {
	        applyToAll.call(this, rule, "activated", active);
	    };
	
	    $.fn.pwstrength = function (method) {
	        var result;
	
	        if (methods[method]) {
	            result = methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
	        } else if (typeof method === "object" || !method) {
	            result = methods.init.apply(this, arguments);
	        } else {
	            $.error("Method " +  method + " does not exist on jQuery.pwstrength-bootstrap");
	        }
	
	        return result;
	    };
	}(jQuery, methods));
	}(jQuery));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(59)(module)))

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	/*!
	 * jQuery blockUI plugin
	 * Version 2.70.0-2014.11.23
	 * Requires jQuery v1.7 or later
	 *
	 * Examples at: http://malsup.com/jquery/block/
	 * Copyright (c) 2007-2013 M. Alsup
	 * Dual licensed under the MIT and GPL licenses:
	 * http://www.opensource.org/licenses/mit-license.php
	 * http://www.gnu.org/licenses/gpl.html
	 *
	 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
	 */
	
	;(function () {
		/*jshint eqeqeq:false curly:false latedef:false */
		"use strict";
	
		function setup($) {
			$.fn._fadeIn = $.fn.fadeIn;
	
			var noOp = $.noop || function () {};
	
			// this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
			// confusing userAgent strings on Vista)
			var msie = /MSIE/.test(navigator.userAgent);
			var ie6 = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent);
			var mode = document.documentMode || 0;
			var setExpr = $.isFunction(document.createElement('div').style.setExpression);
	
			// global $ methods for blocking/unblocking the entire page
			$.blockUI = function (opts) {
				install(window, opts);
			};
			$.unblockUI = function (opts) {
				remove(window, opts);
			};
	
			// convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
			$.growlUI = function (title, message, timeout, onClose) {
				var $m = $('<div class="growlUI"></div>');
				if (title) $m.append('<h1>' + title + '</h1>');
				if (message) $m.append('<h2>' + message + '</h2>');
				if (timeout === undefined) timeout = 3000;
	
				// Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
				var callBlock = function callBlock(opts) {
					opts = opts || {};
	
					$.blockUI({
						message: $m,
						fadeIn: typeof opts.fadeIn !== 'undefined' ? opts.fadeIn : 700,
						fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
						timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
						centerY: false,
						showOverlay: false,
						onUnblock: onClose,
						css: $.blockUI.defaults.growlCSS
					});
				};
	
				callBlock();
				var nonmousedOpacity = $m.css('opacity');
				$m.mouseover(function () {
					callBlock({
						fadeIn: 0,
						timeout: 30000
					});
	
					var displayBlock = $('.blockMsg');
					displayBlock.stop(); // cancel fadeout if it has started
					displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
				}).mouseout(function () {
					$('.blockMsg').fadeOut(1000);
				});
				// End konapun additions
			};
	
			// plugin method for blocking element content
			$.fn.block = function (opts) {
				if (this[0] === window) {
					$.blockUI(opts);
					return this;
				}
				var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
				this.each(function () {
					var $el = $(this);
					if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked')) return;
					$el.unblock({ fadeOut: 0 });
				});
	
				return this.each(function () {
					if ($.css(this, 'position') == 'static') {
						this.style.position = 'relative';
						$(this).data('blockUI.static', true);
					}
					this.style.zoom = 1; // force 'hasLayout' in ie
					install(this, opts);
				});
			};
	
			// plugin method for unblocking element content
			$.fn.unblock = function (opts) {
				if (this[0] === window) {
					$.unblockUI(opts);
					return this;
				}
				return this.each(function () {
					remove(this, opts);
				});
			};
	
			$.blockUI.version = 2.70; // 2nd generation blocking at no extra cost!
	
			// override these in your code to change the default behavior and style
			$.blockUI.defaults = {
				// message displayed when blocking (use null for no message)
				message: '<h1>Please wait...</h1>',
	
				title: null, // title string; only used when theme == true
				draggable: true, // only used when theme == true (requires jquery-ui.js to be loaded)
	
				theme: false, // set to true to use with jQuery UI themes
	
				// styles for the message when blocking; if you wish to disable
				// these and use an external stylesheet then do this in your code:
				// $.blockUI.defaults.css = {};
				css: {
					padding: 0,
					margin: 0,
					width: '30%',
					top: '40%',
					left: '35%',
					textAlign: 'center',
					color: '#000',
					border: '3px solid #aaa',
					backgroundColor: '#fff',
					cursor: 'wait'
				},
	
				// minimal style set used when themes are used
				themedCSS: {
					width: '30%',
					top: '40%',
					left: '35%'
				},
	
				// styles for the overlay
				overlayCSS: {
					backgroundColor: '#000',
					opacity: 0.6,
					cursor: 'wait'
				},
	
				// style to replace wait cursor before unblocking to correct issue
				// of lingering wait cursor
				cursorReset: 'default',
	
				// styles applied when using $.growlUI
				growlCSS: {
					width: '350px',
					top: '10px',
					left: '',
					right: '10px',
					border: 'none',
					padding: '5px',
					opacity: 0.6,
					cursor: 'default',
					color: '#fff',
					backgroundColor: '#000',
					'-webkit-border-radius': '10px',
					'-moz-border-radius': '10px',
					'border-radius': '10px'
				},
	
				// IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
				// (hat tip to Jorge H. N. de Vasconcelos)
				/*jshint scripturl:true */
				iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',
	
				// force usage of iframe in non-IE browsers (handy for blocking applets)
				forceIframe: false,
	
				// z-index for the blocking overlay
				baseZ: 1000,
	
				// set these to true to have the message automatically centered
				centerX: true, // <-- only effects element blocking (page block controlled via css above)
				centerY: true,
	
				// allow body element to be stetched in ie6; this makes blocking look better
				// on "short" pages.  disable if you wish to prevent changes to the body height
				allowBodyStretch: true,
	
				// enable if you want key and mouse events to be disabled for content that is blocked
				bindEvents: true,
	
				// be default blockUI will supress tab navigation from leaving blocking content
				// (if bindEvents is true)
				constrainTabKey: true,
	
				// fadeIn time in millis; set to 0 to disable fadeIn on block
				fadeIn: 200,
	
				// fadeOut time in millis; set to 0 to disable fadeOut on unblock
				fadeOut: 400,
	
				// time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
				timeout: 0,
	
				// disable if you don't want to show the overlay
				showOverlay: true,
	
				// if true, focus will be placed in the first available input field when
				// page blocking
				focusInput: true,
	
				// elements that can receive focus
				focusableElements: ':input:enabled:visible',
	
				// suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
				// no longer needed in 2012
				// applyPlatformOpacityRules: true,
	
				// callback method invoked when fadeIn has completed and blocking message is visible
				onBlock: null,
	
				// callback method invoked when unblocking has completed; the callback is
				// passed the element that has been unblocked (which is the window object for page
				// blocks) and the options that were passed to the unblock call:
				//	onUnblock(element, options)
				onUnblock: null,
	
				// callback method invoked when the overlay area is clicked.
				// setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
				onOverlayClick: null,
	
				// don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
				quirksmodeOffsetHack: 4,
	
				// class name of the message block
				blockMsgClass: 'blockMsg',
	
				// if it is already blocked, then ignore it (don't unblock and reblock)
				ignoreIfBlocked: false
			};
	
			// private data and functions follow...
	
			var pageBlock = null;
			var pageBlockEls = [];
	
			function install(el, opts) {
				var css, themedCSS;
				var full = el == window;
				var msg = opts && opts.message !== undefined ? opts.message : undefined;
				opts = $.extend({}, $.blockUI.defaults, opts || {});
	
				if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked')) return;
	
				opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
				css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
				if (opts.onOverlayClick) opts.overlayCSS.cursor = 'pointer';
	
				themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
				msg = msg === undefined ? opts.message : msg;
	
				// remove the current block (if there is one)
				if (full && pageBlock) remove(window, { fadeOut: 0 });
	
				// if an existing element is being used as the blocking content then we capture
				// its current place in the DOM (and current display style) so we can restore
				// it when we unblock
				if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
					var node = msg.jquery ? msg[0] : msg;
					var data = {};
					$(el).data('blockUI.history', data);
					data.el = node;
					data.parent = node.parentNode;
					data.display = node.style.display;
					data.position = node.style.position;
					if (data.parent) data.parent.removeChild(node);
				}
	
				$(el).data('blockUI.onUnblock', opts.onUnblock);
				var z = opts.baseZ;
	
				// blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
				// layer1 is the iframe layer which is used to supress bleed through of underlying content
				// layer2 is the overlay layer which has opacity and a wait cursor (by default)
				// layer3 is the message content that is displayed while blocking
				var lyr1, lyr2, lyr3, s;
				if (msie || opts.forceIframe) lyr1 = $('<iframe class="blockUI" style="z-index:' + z++ + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + opts.iframeSrc + '"></iframe>');else lyr1 = $('<div class="blockUI" style="display:none"></div>');
	
				if (opts.theme) lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + z++ + ';display:none"></div>');else lyr2 = $('<div class="blockUI blockOverlay" style="z-index:' + z++ + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');
	
				if (opts.theme && full) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:fixed">';
					if (opts.title) {
						s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
					}
					s += '<div class="ui-widget-content ui-dialog-content"></div>';
					s += '</div>';
				} else if (opts.theme) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:absolute">';
					if (opts.title) {
						s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
					}
					s += '<div class="ui-widget-content ui-dialog-content"></div>';
					s += '</div>';
				} else if (full) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:' + (z + 10) + ';display:none;position:fixed"></div>';
				} else {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:' + (z + 10) + ';display:none;position:absolute"></div>';
				}
				lyr3 = $(s);
	
				// if we have a message, style it
				if (msg) {
					if (opts.theme) {
						lyr3.css(themedCSS);
						lyr3.addClass('ui-widget-content');
					} else lyr3.css(css);
				}
	
				// style the overlay
				if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/) lyr2.css(opts.overlayCSS);
				lyr2.css('position', full ? 'fixed' : 'absolute');
	
				// make iframe layer transparent in IE
				if (msie || opts.forceIframe) lyr1.css('opacity', 0.0);
	
				//$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
				var layers = [lyr1, lyr2, lyr3],
				    $par = full ? $('body') : $(el);
				$.each(layers, function () {
					this.appendTo($par);
				});
	
				if (opts.theme && opts.draggable && $.fn.draggable) {
					lyr3.draggable({
						handle: '.ui-dialog-titlebar',
						cancel: 'li'
					});
				}
	
				// ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
				var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
				if (ie6 || expr) {
					// give body 100% height
					if (full && opts.allowBodyStretch && $.support.boxModel) $('html,body').css('height', '100%');
	
					// fix ie6 issue when blocked element has a border width
					if ((ie6 || !$.support.boxModel) && !full) {
						var t = sz(el, 'borderTopWidth'),
						    l = sz(el, 'borderLeftWidth');
						var fixT = t ? '(0 - ' + t + ')' : 0;
						var fixL = l ? '(0 - ' + l + ')' : 0;
					}
	
					// simulate fixed position
					$.each(layers, function (i, o) {
						var s = o[0].style;
						s.position = 'absolute';
						if (i < 2) {
							if (full) s.setExpression('height', 'Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:' + opts.quirksmodeOffsetHack + ') + "px"');else s.setExpression('height', 'this.parentNode.offsetHeight + "px"');
							if (full) s.setExpression('width', 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');else s.setExpression('width', 'this.parentNode.offsetWidth + "px"');
							if (fixL) s.setExpression('left', fixL);
							if (fixT) s.setExpression('top', fixT);
						} else if (opts.centerY) {
							if (full) s.setExpression('top', '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
							s.marginTop = 0;
						} else if (!opts.centerY && full) {
							var top = opts.css && opts.css.top ? parseInt(opts.css.top, 10) : 0;
							var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + ' + top + ') + "px"';
							s.setExpression('top', expression);
						}
					});
				}
	
				// show the message
				if (msg) {
					if (opts.theme) lyr3.find('.ui-widget-content').append(msg);else lyr3.append(msg);
					if (msg.jquery || msg.nodeType) $(msg).show();
				}
	
				if ((msie || opts.forceIframe) && opts.showOverlay) lyr1.show(); // opacity is zero
				if (opts.fadeIn) {
					var cb = opts.onBlock ? opts.onBlock : noOp;
					var cb1 = opts.showOverlay && !msg ? cb : noOp;
					var cb2 = msg ? cb : noOp;
					if (opts.showOverlay) lyr2._fadeIn(opts.fadeIn, cb1);
					if (msg) lyr3._fadeIn(opts.fadeIn, cb2);
				} else {
					if (opts.showOverlay) lyr2.show();
					if (msg) lyr3.show();
					if (opts.onBlock) opts.onBlock.bind(lyr3)();
				}
	
				// bind key and mouse events
				bind(1, el, opts);
	
				if (full) {
					pageBlock = lyr3[0];
					pageBlockEls = $(opts.focusableElements, pageBlock);
					if (opts.focusInput) setTimeout(focus, 20);
				} else center(lyr3[0], opts.centerX, opts.centerY);
	
				if (opts.timeout) {
					// auto-unblock
					var to = setTimeout(function () {
						if (full) $.unblockUI(opts);else $(el).unblock(opts);
					}, opts.timeout);
					$(el).data('blockUI.timeout', to);
				}
			}
	
			// remove the block
			function remove(el, opts) {
				var count;
				var full = el == window;
				var $el = $(el);
				var data = $el.data('blockUI.history');
				var to = $el.data('blockUI.timeout');
				if (to) {
					clearTimeout(to);
					$el.removeData('blockUI.timeout');
				}
				opts = $.extend({}, $.blockUI.defaults, opts || {});
				bind(0, el, opts); // unbind events
	
				if (opts.onUnblock === null) {
					opts.onUnblock = $el.data('blockUI.onUnblock');
					$el.removeData('blockUI.onUnblock');
				}
	
				var els;
				if (full) // crazy selector to handle odd field errors in ie6/7
					els = $('body').children().filter('.blockUI').add('body > .blockUI');else els = $el.find('>.blockUI');
	
				// fix cursor issue
				if (opts.cursorReset) {
					if (els.length > 1) els[1].style.cursor = opts.cursorReset;
					if (els.length > 2) els[2].style.cursor = opts.cursorReset;
				}
	
				if (full) pageBlock = pageBlockEls = null;
	
				if (opts.fadeOut) {
					count = els.length;
					els.stop().fadeOut(opts.fadeOut, function () {
						if (--count === 0) reset(els, data, opts, el);
					});
				} else reset(els, data, opts, el);
			}
	
			// move blocking element back into the DOM where it started
			function reset(els, data, opts, el) {
				var $el = $(el);
				if ($el.data('blockUI.isBlocked')) return;
	
				els.each(function (i, o) {
					// remove via DOM calls so we don't lose event handlers
					if (this.parentNode) this.parentNode.removeChild(this);
				});
	
				if (data && data.el) {
					data.el.style.display = data.display;
					data.el.style.position = data.position;
					data.el.style.cursor = 'default'; // #59
					if (data.parent) data.parent.appendChild(data.el);
					$el.removeData('blockUI.history');
				}
	
				if ($el.data('blockUI.static')) {
					$el.css('position', 'static'); // #22
				}
	
				if (typeof opts.onUnblock == 'function') opts.onUnblock(el, opts);
	
				// fix issue in Safari 6 where block artifacts remain until reflow
				var body = $(document.body),
				    w = body.width(),
				    cssW = body[0].style.width;
				body.width(w - 1).width(w);
				body[0].style.width = cssW;
			}
	
			// bind/unbind the handler
			function bind(b, el, opts) {
				var full = el == window,
				    $el = $(el);
	
				// don't bother unbinding if there is nothing to unbind
				if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked'))) return;
	
				$el.data('blockUI.isBlocked', b);
	
				// don't bind events when overlay is not in use or if bindEvents is false
				if (!full || !opts.bindEvents || b && !opts.showOverlay) return;
	
				// bind anchors and inputs for mouse and key events
				var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
				if (b) $(document).bind(events, opts, handler);else $(document).unbind(events, handler);
	
				// former impl...
				//		var $e = $('a,:input');
				//		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
			}
	
			// event handler to suppress keyboard/mouse events when blocking
			function handler(e) {
				// allow tab navigation (conditionally)
				if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
					if (pageBlock && e.data.constrainTabKey) {
						var els = pageBlockEls;
						var fwd = !e.shiftKey && e.target === els[els.length - 1];
						var back = e.shiftKey && e.target === els[0];
						if (fwd || back) {
							setTimeout(function () {
								focus(back);
							}, 10);
							return false;
						}
					}
				}
				var opts = e.data;
				var target = $(e.target);
				if (target.hasClass('blockOverlay') && opts.onOverlayClick) opts.onOverlayClick(e);
	
				// allow events within the message content
				if (target.parents('div.' + opts.blockMsgClass).length > 0) return true;
	
				// allow events for content that is not being blocked
				return target.parents().children().filter('div.blockUI').length === 0;
			}
	
			function focus(back) {
				if (!pageBlockEls) return;
				var e = pageBlockEls[back === true ? pageBlockEls.length - 1 : 0];
				if (e) e.focus();
			}
	
			function center(el, x, y) {
				var p = el.parentNode,
				    s = el.style;
				var l = (p.offsetWidth - el.offsetWidth) / 2 - sz(p, 'borderLeftWidth');
				var t = (p.offsetHeight - el.offsetHeight) / 2 - sz(p, 'borderTopWidth');
				if (x) s.left = l > 0 ? l + 'px' : '0';
				if (y) s.top = t > 0 ? t + 'px' : '0';
			}
	
			function sz(el, p) {
				return parseInt($.css(el, p), 10) || 0;
			}
		}
	
		/*global define:true */
		if ("function" === 'function' && __webpack_require__(1054) && __webpack_require__(1054).jQuery) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (setup), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			setup(jQuery);
		}
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/*
	 *
	 *   INSPINIA - Responsive Admin Theme
	 *   version 2.2
	 *
	 */
	
	$(document).ready(function () {
	
	    // Add body-small class if window less than 768px
	    if ($(this).width() < 769) {
	        $('body').addClass('body-small');
	    } else {
	        $('body').removeClass('body-small');
	    }
	
	    // MetsiMenu
	    $('#side-menu').metisMenu();
	
	    // Collapse ibox function
	    $('body').on('click', '.collapse-link', function () {
	        var ibox = $(this).closest('div.ibox');
	        var button = $(this).find('i');
	        var content = ibox.find('div.ibox-content');
	        content.slideToggle(200);
	        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
	        ibox.toggleClass('').toggleClass('border-bottom');
	        setTimeout(function () {
	            ibox.resize();
	            ibox.find('[id^=map-]').resize();
	        }, 50);
	    });
	
	    // Close ibox function
	    $('.close-link').click(function () {
	        var content = $(this).closest('div.ibox');
	        content.remove();
	    });
	
	    // Close menu in canvas mode
	    $('.close-canvas-menu').click(function () {
	        $("body").toggleClass("mini-navbar");
	        SmoothlyMenu();
	    });
	
	    // Open close right sidebar
	    $('.right-sidebar-toggle').click(function () {
	        $('#right-sidebar').toggleClass('sidebar-open');
	    });
	
	    // Initialize slimscroll for right sidebar
	    $('.sidebar-container').slimScroll({
	        height: '100%',
	        railOpacity: 0.4,
	        wheelStep: 10
	    });
	
	    // Open close small chat
	    $('.open-small-chat').click(function () {
	        $(this).children().toggleClass('fa-comments').toggleClass('fa-remove');
	        $('.small-chat-box').toggleClass('active');
	    });
	
	    // Initialize slimscroll for small chat
	    $('.small-chat-box .content').slimScroll({
	        height: '234px',
	        railOpacity: 0.4
	    });
	
	    // Small todo handler
	    $('.check-link').click(function () {
	        var button = $(this).find('i');
	        var label = $(this).next('span');
	        button.toggleClass('fa-check-square').toggleClass('fa-square-o');
	        label.toggleClass('todo-completed');
	        return false;
	    });
	
	    // Minimalize menu
	    $('.navbar-minimalize').click(function () {
	        $("body").toggleClass("mini-navbar");
	        SmoothlyMenu();
	    });
	
	    // Tooltips demo
	    $('.tooltip-demo').tooltip({
	        selector: "[data-toggle=tooltip]",
	        container: "body"
	    });
	
	    // Move modal to body
	    // Fix Bootstrap backdrop issu with animation.css
	    $('.modal').appendTo("body");
	
	    // Full height of sidebar
	    function fix_height() {
	        var heightWithoutNavbar = $("body > #wrapper").height() - 61;
	        $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");
	
	        var navbarHeigh = $('nav.navbar-default').height();
	        var wrapperHeigh = $('#page-wrapper').height();
	
	        if (navbarHeigh > wrapperHeigh) {
	            $('#page-wrapper').css("min-height", navbarHeigh + "px");
	        }
	
	        if (navbarHeigh < wrapperHeigh) {
	            $('#page-wrapper').css("min-height", $(window).height() + "px");
	        }
	
	        if ($('body').hasClass('fixed-nav')) {
	            $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
	        }
	    }
	    fix_height();
	
	    // Fixed Sidebar
	    $(window).bind("load", function () {
	        if ($("body").hasClass('fixed-sidebar')) {
	            $('.sidebar-collapse').slimScroll({
	                height: '100%',
	                railOpacity: 0.9
	            });
	        }
	    });
	
	    // Move right sidebar top after scroll
	    $(window).scroll(function () {
	        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
	            $('#right-sidebar').addClass('sidebar-top');
	        } else {
	            $('#right-sidebar').removeClass('sidebar-top');
	        }
	    });
	
	    $(window).bind("load resize scroll", function () {
	        if (!$("body").hasClass('body-small')) {
	            fix_height();
	        }
	    });
	
	    $("[data-toggle=popover]").popover();
	
	    // Add slimscroll to element
	    $('.full-height-scroll').slimscroll({
	        height: '100%'
	    });
	});
	
	// Minimalize menu when screen is less than 768px
	$(window).bind("resize", function () {
	    if ($(this).width() < 769) {
	        $('body').addClass('body-small');
	    } else {
	        $('body').removeClass('body-small');
	    }
	});
	
	// For demo purpose - animation css script
	function animationHover(element, animation) {
	    element = $(element);
	    element.hover(function () {
	        element.addClass('animated ' + animation);
	    }, function () {
	        //wait for animation to finish before removing classes
	        window.setTimeout(function () {
	            element.removeClass('animated ' + animation);
	        }, 2000);
	    });
	}
	
	function SmoothlyMenu() {
	    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
	        // Hide menu in order to smoothly turn on when maximize menu
	        $('#side-menu').hide();
	        // For smoothly turn on menu
	        setTimeout(function () {
	            $('#side-menu').fadeIn(500);
	        }, 100);
	    } else if ($('body').hasClass('fixed-sidebar')) {
	        $('#side-menu').hide();
	        setTimeout(function () {
	            $('#side-menu').fadeIn(500);
	        }, 300);
	    } else {
	        // Remove all inline style from jquery fadeIn function to reset menu state
	        $('#side-menu').removeAttr('style');
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./Addempl-2x.png": 1106,
		"./Addempl.png": 1107,
		"./chargebee-icon.svg": 153,
		"./comodo-secure-seal.png": 1108,
		"./day-2x.png": 1109,
		"./day.png": 1110,
		"./favicon.candidate.ico": 1111,
		"./favicon.development.ico": 1112,
		"./favicon.ico": 1113,
		"./favicon.production.ico": 1114,
		"./favicon.staging.ico": 1115,
		"./icon-clock-in.png": 1116,
		"./icon-clock-out.png": 1117,
		"./large_panda.jpg": 1118,
		"./lhdn.gif": 1119,
		"./logo-xero.svg": 1120,
		"./panda_jump.png": 1121,
		"./payrollpanda-logo-lg.png": 1122,
		"./payrollpanda-logo-md.png": 1123,
		"./payrollpanda-logo-sm.png": 1124,
		"./payrollpanda-logo.png": 1125,
		"./processed-2x.png": 1126,
		"./processed.png": 1127,
		"./quickbooks.png": 1128,
		"./refer-icon.png": 1129,
		"./signup-panda-2x.png": 1130,
		"./signup-panda.png": 1131,
		"./start-2x.png": 1132,
		"./start.png": 1133,
		"./xero.png": 1134
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1105;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/Addempl-2x.png";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/Addempl.png";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/comodo-secure-seal.png";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/day-2x.png";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/day.png";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/favicon.candidate.ico";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/favicon.development.ico";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/favicon.ico";

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/favicon.production.ico";

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/favicon.staging.ico";

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/icon-clock-in.png";

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/icon-clock-out.png";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/large_panda.jpg";

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/lhdn.gif";

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/logo-xero.svg";

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/panda_jump.png";

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/payrollpanda-logo-lg.png";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/payrollpanda-logo-md.png";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/payrollpanda-logo-sm.png";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/payrollpanda-logo.png";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/processed-2x.png";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/processed.png";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/quickbooks.png";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/refer-icon.png";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/signup-panda-2x.png";

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/signup-panda.png";

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/start-2x.png";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/start.png";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/xero.png";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./Borang_KWSP_17A_(Khas_2021).xlsx": 1136,
		"./bulk-employees-payslips-template.xlsx": 1137
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1135;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/Borang_KWSP_17A_(Khas_2021).xlsx";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/bulk-employees-payslips-template.xlsx";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// payrollpanda.8910a130398e70a6738e.js